import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: any; output: any; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: any; output: any; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /** A calendar date in YYYY-MM-DD format. */
  Date: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: any; output: any; }
  /** Represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any; }
};

export type Account = Node & {
  __typename?: 'Account';
  /** Reads and enables pagination through a set of `AccountCapitalEntry`. */
  accountCapitalEntries: AccountCapitalEntryConnection;
  accountLabels?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `AccountLiveCallUp` that is related to this `Account`. */
  accountLiveCallUp?: Maybe<AccountLiveCallUp>;
  accountName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `AccountPassedBinder`. */
  accountPassedBinders: AccountPassedBinderConnection;
  /** Reads a single `AccountPlatformDatum` that is related to this `Account`. */
  accountPlatformDatum?: Maybe<AccountPlatformDatum>;
  /** Reads and enables pagination through a set of `AccountStat`. */
  accountStats: AccountStatConnection;
  accountTemplate?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `AccountTemplate` that is related to this `Account`. */
  accountTemplateRelation?: Maybe<AccountTemplate>;
  active?: Maybe<Scalars['Boolean']['output']>;
  bestTradingDay?: Maybe<BestTradingDay>;
  closeReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  complimentary?: Maybe<Scalars['Boolean']['output']>;
  complimentaryExpirationDate?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Stamped once when allWinningDays first reaches the daily-payout unlock threshold (30). Non-null IS the full payout tier — never re-derived, never cleared, never re-stamped. Backfilled at GTM by build step C4 for accounts already past the threshold. */
  dailyPayoutsUnlockedAt?: Maybe<Scalars['Datetime']['output']>;
  dllDailyMetrics?: Maybe<DllDailyMetrics>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignments: ImpactGroupAssignmentConnection;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignmentsList: Array<ImpactGroupAssignment>;
  /** Reads a single `NmiSubscription` that is related to this `Account`. */
  nmiSubscription?: Maybe<NmiSubscription>;
  nmiSubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `OrderFulfillment` that is related to this `Account`. */
  orderFulfillment?: Maybe<OrderFulfillment>;
  pathToFunding?: Maybe<PathToFunding>;
  payoutEnabledByAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Platform` that is related to this `Account`. */
  platform?: Maybe<Platform>;
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ProductCategory` that is related to this `Account`. */
  productCategory?: Maybe<ProductCategory>;
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  projectXAccountStatus?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  skuAccountDetails?: Maybe<SkuAccountDetails>;
  skuId?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Datetime']['output']>;
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** Reads a single `UserSubscription` that is related to this `Account`. */
  subscription?: Maybe<UserSubscription>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `TraderPublicProfile`. */
  traderPublicProfilesByFeaturedAccountId: TraderPublicProfileConnection;
  tradingHabits?: Maybe<TradingHabits>;
  tradingOverview?: Maybe<TradingOverview>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Account`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  viewedReflections: Array<Maybe<Scalars['String']['output']>>;
  worstTradingDay?: Maybe<WorstTradingDay>;
  xfaConsistencyMetrics?: Maybe<XfaConsistencyMetrics>;
  /** Reads and enables pagination through a set of `XfaResetTracking`. */
  xfaResetTrackingsByParentAccountId: XfaResetTrackingConnection;
  /** Reads and enables pagination through a set of `XfaResetTracking`. */
  xfaResetTrackingsByResetAccountId: XfaResetTrackingConnection;
};


export type AccountAccountCapitalEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCapitalEntryCondition>;
  filter?: InputMaybe<AccountCapitalEntryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCapitalEntryOrderBy>>;
};


export type AccountAccountPassedBindersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountPassedBinderCondition>;
  filter?: InputMaybe<AccountPassedBinderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountPassedBinderOrderBy>>;
};


export type AccountAccountStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatCondition>;
  filter?: InputMaybe<AccountStatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatOrderBy>>;
};


export type AccountImpactGroupAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type AccountImpactGroupAssignmentsListArgs = {
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type AccountTraderPublicProfilesByFeaturedAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderPublicProfileCondition>;
  filter?: InputMaybe<TraderPublicProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderPublicProfileOrderBy>>;
};


export type AccountXfaConsistencyMetricsArgs = {
  includeCommissions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountXfaResetTrackingsByParentAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<XfaResetTrackingCondition>;
  filter?: InputMaybe<XfaResetTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<XfaResetTrackingOrderBy>>;
};


export type AccountXfaResetTrackingsByResetAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<XfaResetTrackingCondition>;
  filter?: InputMaybe<XfaResetTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<XfaResetTrackingOrderBy>>;
};

export type AccountAdjustment = Node & {
  __typename?: 'AccountAdjustment';
  accountId: Scalars['Int']['output'];
  adminUserId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type AccountAggregates = {
  __typename?: 'AccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Account` object types. */
export type AccountAggregatesFilter = {
  /** Mean average aggregate over matching `Account` objects. */
  average?: InputMaybe<AccountAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Account` objects. */
  distinctCount?: InputMaybe<AccountDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Account` object to be included within the aggregate. */
  filter?: InputMaybe<AccountFilter>;
  /** Maximum aggregate over matching `Account` objects. */
  max?: InputMaybe<AccountMaxAggregateFilter>;
  /** Minimum aggregate over matching `Account` objects. */
  min?: InputMaybe<AccountMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Account` objects. */
  stddevPopulation?: InputMaybe<AccountStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Account` objects. */
  stddevSample?: InputMaybe<AccountStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Account` objects. */
  sum?: InputMaybe<AccountSumAggregateFilter>;
  /** Population variance aggregate over matching `Account` objects. */
  variancePopulation?: InputMaybe<AccountVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Account` objects. */
  varianceSample?: InputMaybe<AccountVarianceSampleAggregateFilter>;
};

export type AccountAudit = Node & {
  __typename?: 'AccountAudit';
  accountId: Scalars['Int']['output'];
  action: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `UserContactInfo` that is related to this `AccountAudit`. */
  user?: Maybe<UserContactInfo>;
  userId: Scalars['Int']['output'];
};

export type AccountAverageAggregateFilter = {
  accountTemplate?: InputMaybe<BigFloatFilter>;
  nmiSubscriptionId?: InputMaybe<BigFloatFilter>;
  platformId?: InputMaybe<BigFloatFilter>;
  projectXAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountAverageAggregates = {
  __typename?: 'AccountAverageAggregates';
  /** Mean average of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** One LIVE call-up preparation batch per row; AccountLiveCallUp.uuid points here. Access through authorized REST endpoints. */
export type AccountCallUpDecision = Node & {
  __typename?: 'AccountCallUpDecision';
  /** Reads a single `AccountCallUpDecisionCalculation` that is related to this `AccountCallUpDecision`. */
  accountCallUpDecisionCalculationByCalculationIdAndRowIdAndUserId?: Maybe<AccountCallUpDecisionCalculation>;
  /** Reads and enables pagination through a set of `AccountCallUpDecisionCalculation`. */
  accountCallUpDecisionCalculationsByDecisionIdAndUserId: AccountCallUpDecisionCalculationConnection;
  /** Deprecated: superseded by AccountCallUpPayoutOffer; dropped once the API fleet has rolled. */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Deprecated: superseded by AccountCallUpPayoutOffer; dropped once the API fleet has rolled. */
  brokerageUnavailableReason?: Maybe<AccountCallUpDecisionBrokerageUnavailableReasonEnum>;
  calculationId?: Maybe<Scalars['UUID']['output']>;
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  decidedAt?: Maybe<Scalars['Datetime']['output']>;
  decisionEmailQueuedAt?: Maybe<Scalars['Datetime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payoutChoice?: Maybe<AccountCallUpDecisionPayoutChoiceEnum>;
  propEmailQueuedAt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['UUID']['output'];
  status: AccountCallUpDecisionStatusEnum;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `AccountCallUpDecision`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};


/** One LIVE call-up preparation batch per row; AccountLiveCallUp.uuid points here. Access through authorized REST endpoints. */
export type AccountCallUpDecisionAccountCallUpDecisionCalculationsByDecisionIdAndUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCallUpDecisionCalculationCondition>;
  filter?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCallUpDecisionCalculationOrderBy>>;
};

export type AccountCallUpDecisionAggregates = {
  __typename?: 'AccountCallUpDecisionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountCallUpDecisionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountCallUpDecisionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountCallUpDecisionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountCallUpDecisionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountCallUpDecisionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountCallUpDecisionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountCallUpDecisionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountCallUpDecisionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountCallUpDecisionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountCallUpDecision` object types. */
export type AccountCallUpDecisionAggregatesFilter = {
  /** Mean average aggregate over matching `AccountCallUpDecision` objects. */
  average?: InputMaybe<AccountCallUpDecisionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountCallUpDecision` objects. */
  distinctCount?: InputMaybe<AccountCallUpDecisionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountCallUpDecision` object to be included within the aggregate. */
  filter?: InputMaybe<AccountCallUpDecisionFilter>;
  /** Maximum aggregate over matching `AccountCallUpDecision` objects. */
  max?: InputMaybe<AccountCallUpDecisionMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountCallUpDecision` objects. */
  min?: InputMaybe<AccountCallUpDecisionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountCallUpDecision` objects. */
  stddevPopulation?: InputMaybe<AccountCallUpDecisionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountCallUpDecision` objects. */
  stddevSample?: InputMaybe<AccountCallUpDecisionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountCallUpDecision` objects. */
  sum?: InputMaybe<AccountCallUpDecisionSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountCallUpDecision` objects. */
  variancePopulation?: InputMaybe<AccountCallUpDecisionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountCallUpDecision` objects. */
  varianceSample?: InputMaybe<AccountCallUpDecisionVarianceSampleAggregateFilter>;
};

export type AccountCallUpDecisionAverageAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionAverageAggregates = {
  __typename?: 'AccountCallUpDecisionAverageAggregates';
  /** Mean average of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export enum AccountCallUpDecisionBrokerageUnavailableReasonEnum {
  AllocationShortfall = 'allocation_shortfall',
  InsufficientBalance = 'insufficient_balance'
}

/** Immutable LIVE-460 result (account size, transfer balance, starting balance, reserve). A potential calculation, not a spendable balance. */
export type AccountCallUpDecisionCalculation = Node & {
  __typename?: 'AccountCallUpDecisionCalculation';
  accountSize: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  decisionId: Scalars['UUID']['output'];
  /** Reads a single `AccountCallUpDecision` that is related to this `AccountCallUpDecisionCalculation`. */
  decisionUser?: Maybe<AccountCallUpDecision>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Version of the LIVE_CALL_UP_PAYOUT_POLICY row this calculation's offers were priced from. */
  payoutPolicyVersion: Scalars['String']['output'];
  policyVersion: Scalars['String']['output'];
  reserveBalance: Scalars['BigFloat']['output'];
  rowId: Scalars['UUID']['output'];
  sizingAccountIds: Array<Maybe<Scalars['Int']['output']>>;
  startingBalance: Scalars['BigFloat']['output'];
  transferBalance: Scalars['BigFloat']['output'];
  /** Reads a single `User` that is related to this `AccountCallUpDecisionCalculation`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type AccountCallUpDecisionCalculationAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountCallUpDecisionCalculationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountCallUpDecisionCalculationDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountCallUpDecisionCalculationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountCallUpDecisionCalculationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountCallUpDecisionCalculationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountCallUpDecisionCalculationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountCallUpDecisionCalculationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountCallUpDecisionCalculationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountCallUpDecisionCalculationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountCallUpDecisionCalculation` object types. */
export type AccountCallUpDecisionCalculationAggregatesFilter = {
  /** Mean average aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  average?: InputMaybe<AccountCallUpDecisionCalculationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  distinctCount?: InputMaybe<AccountCallUpDecisionCalculationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountCallUpDecisionCalculation` object to be included within the aggregate. */
  filter?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** Maximum aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  max?: InputMaybe<AccountCallUpDecisionCalculationMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  min?: InputMaybe<AccountCallUpDecisionCalculationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  stddevPopulation?: InputMaybe<AccountCallUpDecisionCalculationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  stddevSample?: InputMaybe<AccountCallUpDecisionCalculationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  sum?: InputMaybe<AccountCallUpDecisionCalculationSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  variancePopulation?: InputMaybe<AccountCallUpDecisionCalculationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountCallUpDecisionCalculation` objects. */
  varianceSample?: InputMaybe<AccountCallUpDecisionCalculationVarianceSampleAggregateFilter>;
};

export type AccountCallUpDecisionCalculationAverageAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionCalculationAverageAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationAverageAggregates';
  /** Mean average of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountCallUpDecisionCalculation` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type AccountCallUpDecisionCalculationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `decisionId` field. */
  decisionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountCallUpDecisionCalculation` values. */
export type AccountCallUpDecisionCalculationConnection = {
  __typename?: 'AccountCallUpDecisionCalculationConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountCallUpDecisionCalculationAggregates>;
  /** A list of edges which contains the `AccountCallUpDecisionCalculation` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountCallUpDecisionCalculationEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountCallUpDecisionCalculationAggregates>>;
  /** A list of `AccountCallUpDecisionCalculation` objects. */
  nodes: Array<Maybe<AccountCallUpDecisionCalculation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountCallUpDecisionCalculation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountCallUpDecisionCalculation` values. */
export type AccountCallUpDecisionCalculationConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountCallUpDecisionCalculationGroupBy>;
  having?: InputMaybe<AccountCallUpDecisionCalculationHavingInput>;
};

export type AccountCallUpDecisionCalculationDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  decisionId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountCallUpDecisionCalculationDistinctCountAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationDistinctCountAggregates';
  /** Distinct count of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of decisionId across the matching connection */
  decisionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutPolicyVersion across the matching connection */
  payoutPolicyVersion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of policyVersion across the matching connection */
  policyVersion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sizingAccountIds across the matching connection */
  sizingAccountIds?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountCallUpDecisionCalculation` edge in the connection. */
export type AccountCallUpDecisionCalculationEdge = {
  __typename?: 'AccountCallUpDecisionCalculationEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountCallUpDecisionCalculation` at the end of the edge. */
  node?: Maybe<AccountCallUpDecisionCalculation>;
};

/** A filter to be used against `AccountCallUpDecisionCalculation` object types. All fields are combined with a logical ‘and.’ */
export type AccountCallUpDecisionCalculationFilter = {
  /** Filter by the object’s `accountCallUpDecisionByCalculationIdAndRowIdAndUserId` relation. */
  accountCallUpDecisionByCalculationIdAndRowIdAndUserId?: InputMaybe<AccountCallUpDecisionFilter>;
  /** A related `accountCallUpDecisionByCalculationIdAndRowIdAndUserId` exists. */
  accountCallUpDecisionByCalculationIdAndRowIdAndUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountCallUpDecisionCalculationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `decisionId` field. */
  decisionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `decisionUser` relation. */
  decisionUser?: InputMaybe<AccountCallUpDecisionFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountCallUpDecisionCalculationFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountCallUpDecisionCalculation` for usage during aggregation. */
export enum AccountCallUpDecisionCalculationGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  DecisionId = 'DECISION_ID',
  UserId = 'USER_ID'
}

export type AccountCallUpDecisionCalculationHavingAverageInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingDistinctCountInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountCallUpDecisionCalculation` aggregates. */
export type AccountCallUpDecisionCalculationHavingInput = {
  AND?: InputMaybe<Array<AccountCallUpDecisionCalculationHavingInput>>;
  OR?: InputMaybe<Array<AccountCallUpDecisionCalculationHavingInput>>;
  average?: InputMaybe<AccountCallUpDecisionCalculationHavingAverageInput>;
  distinctCount?: InputMaybe<AccountCallUpDecisionCalculationHavingDistinctCountInput>;
  max?: InputMaybe<AccountCallUpDecisionCalculationHavingMaxInput>;
  min?: InputMaybe<AccountCallUpDecisionCalculationHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountCallUpDecisionCalculationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountCallUpDecisionCalculationHavingStddevSampleInput>;
  sum?: InputMaybe<AccountCallUpDecisionCalculationHavingSumInput>;
  variancePopulation?: InputMaybe<AccountCallUpDecisionCalculationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountCallUpDecisionCalculationHavingVarianceSampleInput>;
};

export type AccountCallUpDecisionCalculationHavingMaxInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingMinInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingStddevPopulationInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingStddevSampleInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingSumInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingVariancePopulationInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationHavingVarianceSampleInput = {
  accountSize?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reserveBalance?: InputMaybe<HavingBigfloatFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  transferBalance?: InputMaybe<HavingBigfloatFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionCalculationMaxAggregateFilter = {
  userId?: InputMaybe<IntFilter>;
};

export type AccountCallUpDecisionCalculationMaxAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationMaxAggregates';
  /** Maximum of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountCallUpDecisionCalculationMinAggregateFilter = {
  userId?: InputMaybe<IntFilter>;
};

export type AccountCallUpDecisionCalculationMinAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationMinAggregates';
  /** Minimum of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountCallUpDecisionCalculation`. */
export enum AccountCallUpDecisionCalculationOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DecisionIdAsc = 'DECISION_ID_ASC',
  DecisionIdDesc = 'DECISION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type AccountCallUpDecisionCalculationStddevPopulationAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionCalculationStddevPopulationAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationStddevPopulationAggregates';
  /** Population standard deviation of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCallUpDecisionCalculationStddevSampleAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionCalculationStddevSampleAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationStddevSampleAggregates';
  /** Sample standard deviation of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCallUpDecisionCalculationSumAggregateFilter = {
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountCallUpDecisionCalculationSumAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationSumAggregates';
  /** Sum of accountSize across the matching connection */
  accountSize: Scalars['BigFloat']['output'];
  /** Sum of reserveBalance across the matching connection */
  reserveBalance: Scalars['BigFloat']['output'];
  /** Sum of startingBalance across the matching connection */
  startingBalance: Scalars['BigFloat']['output'];
  /** Sum of transferBalance across the matching connection */
  transferBalance: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type AccountCallUpDecisionCalculationVariancePopulationAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionCalculationVariancePopulationAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationVariancePopulationAggregates';
  /** Population variance of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCallUpDecisionCalculationVarianceSampleAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionCalculationVarianceSampleAggregates = {
  __typename?: 'AccountCallUpDecisionCalculationVarianceSampleAggregates';
  /** Sample variance of accountSize across the matching connection */
  accountSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reserveBalance across the matching connection */
  reserveBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of transferBalance across the matching connection */
  transferBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountCallUpDecision` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountCallUpDecisionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountCallUpDecision` values. */
export type AccountCallUpDecisionConnection = {
  __typename?: 'AccountCallUpDecisionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountCallUpDecisionAggregates>;
  /** A list of edges which contains the `AccountCallUpDecision` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountCallUpDecisionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountCallUpDecisionAggregates>>;
  /** A list of `AccountCallUpDecision` objects. */
  nodes: Array<Maybe<AccountCallUpDecision>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountCallUpDecision` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountCallUpDecision` values. */
export type AccountCallUpDecisionConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountCallUpDecisionGroupBy>;
  having?: InputMaybe<AccountCallUpDecisionHavingInput>;
};

export type AccountCallUpDecisionDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountCallUpDecisionDistinctCountAggregates = {
  __typename?: 'AccountCallUpDecisionDistinctCountAggregates';
  /** Distinct count of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerageUnavailableReason across the matching connection */
  brokerageUnavailableReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of calculationId across the matching connection */
  calculationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of decidedAt across the matching connection */
  decidedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of decisionEmailQueuedAt across the matching connection */
  decisionEmailQueuedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of failureReason across the matching connection */
  failureReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutChoice across the matching connection */
  payoutChoice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of propEmailQueuedAt across the matching connection */
  propEmailQueuedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of version across the matching connection */
  version?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountCallUpDecision` edge in the connection. */
export type AccountCallUpDecisionEdge = {
  __typename?: 'AccountCallUpDecisionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountCallUpDecision` at the end of the edge. */
  node?: Maybe<AccountCallUpDecision>;
};

/** A filter to be used against `AccountCallUpDecision` object types. All fields are combined with a logical ‘and.’ */
export type AccountCallUpDecisionFilter = {
  /** Filter by the object’s `accountCallUpDecisionCalculationByCalculationIdAndRowIdAndUserId` relation. */
  accountCallUpDecisionCalculationByCalculationIdAndRowIdAndUserId?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** A related `accountCallUpDecisionCalculationByCalculationIdAndRowIdAndUserId` exists. */
  accountCallUpDecisionCalculationByCalculationIdAndRowIdAndUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCallUpDecisionCalculationsByDecisionIdAndUserId` relation. */
  accountCallUpDecisionCalculationsByDecisionIdAndUserId?: InputMaybe<AccountCallUpDecisionToManyAccountCallUpDecisionCalculationFilter>;
  /** Some related `accountCallUpDecisionCalculationsByDecisionIdAndUserId` exist. */
  accountCallUpDecisionCalculationsByDecisionIdAndUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountCallUpDecisionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountCallUpDecisionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountCallUpDecisionFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountCallUpDecision` for usage during aggregation. */
export enum AccountCallUpDecisionGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type AccountCallUpDecisionHavingAverageInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingDistinctCountInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountCallUpDecision` aggregates. */
export type AccountCallUpDecisionHavingInput = {
  AND?: InputMaybe<Array<AccountCallUpDecisionHavingInput>>;
  OR?: InputMaybe<Array<AccountCallUpDecisionHavingInput>>;
  average?: InputMaybe<AccountCallUpDecisionHavingAverageInput>;
  distinctCount?: InputMaybe<AccountCallUpDecisionHavingDistinctCountInput>;
  max?: InputMaybe<AccountCallUpDecisionHavingMaxInput>;
  min?: InputMaybe<AccountCallUpDecisionHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountCallUpDecisionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountCallUpDecisionHavingStddevSampleInput>;
  sum?: InputMaybe<AccountCallUpDecisionHavingSumInput>;
  variancePopulation?: InputMaybe<AccountCallUpDecisionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountCallUpDecisionHavingVarianceSampleInput>;
};

export type AccountCallUpDecisionHavingMaxInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingMinInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingStddevPopulationInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingStddevSampleInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingSumInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingVariancePopulationInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionHavingVarianceSampleInput = {
  brokerageAmount?: InputMaybe<HavingBigfloatFilter>;
  callUpPayoutAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  decidedAt?: InputMaybe<HavingDatetimeFilter>;
  decisionEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  propEmailQueuedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type AccountCallUpDecisionMaxAggregateFilter = {
  userId?: InputMaybe<IntFilter>;
};

export type AccountCallUpDecisionMaxAggregates = {
  __typename?: 'AccountCallUpDecisionMaxAggregates';
  /** Maximum of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of version across the matching connection */
  version?: Maybe<Scalars['Int']['output']>;
};

export type AccountCallUpDecisionMinAggregateFilter = {
  userId?: InputMaybe<IntFilter>;
};

export type AccountCallUpDecisionMinAggregates = {
  __typename?: 'AccountCallUpDecisionMinAggregates';
  /** Minimum of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of version across the matching connection */
  version?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountCallUpDecision`. */
export enum AccountCallUpDecisionOrderBy {
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdAverageUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_AVERAGE_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdAverageUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_AVERAGE_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdCountAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_COUNT_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdCountDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_COUNT_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountCreatedAtAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountCreatedAtDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountDecisionIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_DECISION_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountDecisionIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_DECISION_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountRowIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_ROW_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountRowIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_ROW_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdDistinctCountUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_DISTINCT_COUNT_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdMaxUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_MAX_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdMaxUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_MAX_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdMinUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_MIN_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdMinUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_MIN_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdStddevPopulationUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_STDDEV_POPULATION_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdStddevPopulationUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_STDDEV_POPULATION_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdStddevSampleUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_STDDEV_SAMPLE_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdStddevSampleUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_STDDEV_SAMPLE_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdSumUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_SUM_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdSumUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_SUM_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdVariancePopulationUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_VARIANCE_POPULATION_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdVariancePopulationUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_VARIANCE_POPULATION_USER_ID_DESC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdVarianceSampleUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountCallUpDecisionCalculationsByDecisionIdAndUserIdVarianceSampleUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_BY_DECISION_ID_AND_USER_ID_VARIANCE_SAMPLE_USER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum AccountCallUpDecisionPayoutChoiceEnum {
  Bank = 'bank',
  Brokerage = 'brokerage'
}

export enum AccountCallUpDecisionStatusEnum {
  CallUpPayoutCompleted = 'call_up_payout_completed',
  CallUpPayoutSubmitted = 'call_up_payout_submitted',
  NotOffered = 'not_offered',
  Pending = 'pending',
  PropConfirmed = 'prop_confirmed'
}

export type AccountCallUpDecisionStddevPopulationAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionStddevPopulationAggregates = {
  __typename?: 'AccountCallUpDecisionStddevPopulationAggregates';
  /** Population standard deviation of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCallUpDecisionStddevSampleAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionStddevSampleAggregates = {
  __typename?: 'AccountCallUpDecisionStddevSampleAggregates';
  /** Sample standard deviation of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCallUpDecisionSumAggregateFilter = {
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountCallUpDecisionSumAggregates = {
  __typename?: 'AccountCallUpDecisionSumAggregates';
  /** Sum of brokerageAmount across the matching connection */
  brokerageAmount: Scalars['BigFloat']['output'];
  /** Sum of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
  /** Sum of version across the matching connection */
  version: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AccountCallUpDecisionCalculation` object types. All fields are combined with a logical ‘and.’ */
export type AccountCallUpDecisionToManyAccountCallUpDecisionCalculationFilter = {
  /** Aggregates across related `AccountCallUpDecisionCalculation` match the filter criteria. */
  aggregates?: InputMaybe<AccountCallUpDecisionCalculationAggregatesFilter>;
  /** Every related `AccountCallUpDecisionCalculation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** No related `AccountCallUpDecisionCalculation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** Some related `AccountCallUpDecisionCalculation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
};

export type AccountCallUpDecisionVariancePopulationAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionVariancePopulationAggregates = {
  __typename?: 'AccountCallUpDecisionVariancePopulationAggregates';
  /** Population variance of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCallUpDecisionVarianceSampleAggregateFilter = {
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountCallUpDecisionVarianceSampleAggregates = {
  __typename?: 'AccountCallUpDecisionVarianceSampleAggregates';
  /** Sample variance of brokerageAmount across the matching connection */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of callUpPayoutAmount across the matching connection */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

/** One call-up payout as quoted by a calculation: the share of the starting balance as applied and the base, bonus and total in whole dollars. Immutable; a new calculation quotes afresh. */
export type AccountCallUpPayoutOffer = Node & {
  __typename?: 'AccountCallUpPayoutOffer';
  amount: Scalars['BigFloat']['output'];
  baseAmount: Scalars['BigFloat']['output'];
  /** What the bonus added over the base percent alone: amount - baseAmount. */
  bonusAmount: Scalars['BigFloat']['output'];
  bonusPercent?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `AccountCallUpDecisionCalculation` that is related to this `AccountCallUpPayoutOffer`. */
  calculationDecisionUser?: Maybe<AccountCallUpDecisionCalculation>;
  calculationId: Scalars['UUID']['output'];
  choice: AccountCallUpDecisionPayoutChoiceEnum;
  createdAt: Scalars['Datetime']['output'];
  decisionId: Scalars['UUID']['output'];
  /** The policy's flat brokerage bonus in whole dollars; exclusive with bonusPercent. */
  flatBonus?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  percent: Scalars['Int']['output'];
  rowId: Scalars['UUID']['output'];
  unavailableReason?: Maybe<AccountCallUpPayoutOfferUnavailableReasonEnum>;
  /** Reads a single `User` that is related to this `AccountCallUpPayoutOffer`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export enum AccountCallUpPayoutOfferUnavailableReasonEnum {
  InsufficientBalance = 'insufficient_balance'
}

/** Append-only capital ledger. Credits only: grants and their reversals. Payout debits live on PayoutRequest. Rows are immutable — correct by posting an offsetting entry, never by UPDATE or DELETE. */
export type AccountCapitalEntry = Node & {
  __typename?: 'AccountCapitalEntry';
  /** Reads a single `Account` that is related to this `AccountCapitalEntry`. */
  account?: Maybe<Account>;
  accountId: Scalars['Int']['output'];
  /** Signed. Positive = grant, negative = reversal. Aggregates over this table MUST filter by bucket: an unfiltered SUM adds Octagon bonuses to seed capital and inflates the withdrawal gate. */
  amount: Scalars['BigFloat']['output'];
  bucket: AccountCapitalEntryBucketEnum;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `AccountCapitalEntry`. */
  createdByAdmin?: Maybe<User>;
  createdByAdminId: Scalars['Int']['output'];
  /** When this entry starts counting toward granted/octagonGranted. Stamped at write time from ACCOUNT_CAPITAL_EFFECTIVE_TIME, never recomputed at read time: a config change moves future uploads only. Uploaded SISU and Octagon grants defer identically to 23:00 CT on the upload day, which is also when the clearing platform credits the funds. initial_funding, opening_position, voids and corrections are effective immediately. */
  effectiveAt: Scalars['Datetime']['output'];
  entryType: AccountCapitalEntryTypeEnum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
  /** Reads a single `AccountCapitalEntry` that is related to this `AccountCapitalEntry`. */
  reversesEntry?: Maybe<AccountCapitalEntry>;
  /** Lineage only — does not affect any SUM. Exists so the UI can say "this reverses #14" rather than showing an unexplained negative row. */
  reversesEntryId?: Maybe<Scalars['Int']['output']>;
  /** sha256 over a canonical serialization of the row (entryType, accountId, sisuLevel, integer cents, ISO-8601 UTC effectiveAt, 0x1f-separated) for CSV import idempotency. NULL for rows written outside the importer — the per-account dialog and the backfill script do not hash. Deliberately excludes the admin-typed batch label, so dedup is a property of the data rather than the paperwork. */
  rowHash?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  sisuLevel?: Maybe<Scalars['Int']['output']>;
};

export type AccountCapitalEntryAggregates = {
  __typename?: 'AccountCapitalEntryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountCapitalEntryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountCapitalEntryDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountCapitalEntryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountCapitalEntryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountCapitalEntryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountCapitalEntryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountCapitalEntrySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountCapitalEntryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountCapitalEntryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountCapitalEntry` object types. */
export type AccountCapitalEntryAggregatesFilter = {
  /** Mean average aggregate over matching `AccountCapitalEntry` objects. */
  average?: InputMaybe<AccountCapitalEntryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountCapitalEntry` objects. */
  distinctCount?: InputMaybe<AccountCapitalEntryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountCapitalEntry` object to be included within the aggregate. */
  filter?: InputMaybe<AccountCapitalEntryFilter>;
  /** Maximum aggregate over matching `AccountCapitalEntry` objects. */
  max?: InputMaybe<AccountCapitalEntryMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountCapitalEntry` objects. */
  min?: InputMaybe<AccountCapitalEntryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountCapitalEntry` objects. */
  stddevPopulation?: InputMaybe<AccountCapitalEntryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountCapitalEntry` objects. */
  stddevSample?: InputMaybe<AccountCapitalEntryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountCapitalEntry` objects. */
  sum?: InputMaybe<AccountCapitalEntrySumAggregateFilter>;
  /** Population variance aggregate over matching `AccountCapitalEntry` objects. */
  variancePopulation?: InputMaybe<AccountCapitalEntryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountCapitalEntry` objects. */
  varianceSample?: InputMaybe<AccountCapitalEntryVarianceSampleAggregateFilter>;
};

export type AccountCapitalEntryAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  createdByAdminId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountCapitalEntryAverageAggregates = {
  __typename?: 'AccountCapitalEntryAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['BigFloat']['output']>;
};

export enum AccountCapitalEntryBucketEnum {
  Dpop = 'dpop',
  SeedCapital = 'seed_capital'
}

/**
 * A condition to be used against `AccountCapitalEntry` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountCapitalEntryCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdByAdminId` field. */
  createdByAdminId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `requestId` field. */
  requestId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountCapitalEntry` values. */
export type AccountCapitalEntryConnection = {
  __typename?: 'AccountCapitalEntryConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountCapitalEntryAggregates>;
  /** A list of edges which contains the `AccountCapitalEntry` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountCapitalEntryEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountCapitalEntryAggregates>>;
  /** A list of `AccountCapitalEntry` objects. */
  nodes: Array<Maybe<AccountCapitalEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountCapitalEntry` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountCapitalEntry` values. */
export type AccountCapitalEntryConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountCapitalEntryGroupBy>;
  having?: InputMaybe<AccountCapitalEntryHavingInput>;
};

export type AccountCapitalEntryDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  createdByAdminId?: InputMaybe<BigIntFilter>;
  requestId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AccountCapitalEntryDistinctCountAggregates = {
  __typename?: 'AccountCapitalEntryDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bucket across the matching connection */
  bucket?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of effectiveAt across the matching connection */
  effectiveAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of entryType across the matching connection */
  entryType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of requestId across the matching connection */
  requestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowHash across the matching connection */
  rowHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountCapitalEntry` edge in the connection. */
export type AccountCapitalEntryEdge = {
  __typename?: 'AccountCapitalEntryEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountCapitalEntry` at the end of the edge. */
  node?: Maybe<AccountCapitalEntry>;
};

/** A filter to be used against `AccountCapitalEntry` object types. All fields are combined with a logical ‘and.’ */
export type AccountCapitalEntryFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountCapitalEntryFilter>>;
  /** Filter by the object’s `createdByAdmin` relation. */
  createdByAdmin?: InputMaybe<UserFilter>;
  /** Filter by the object’s `createdByAdminId` field. */
  createdByAdminId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountCapitalEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountCapitalEntryFilter>>;
  /** Filter by the object’s `requestId` field. */
  requestId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reversesEntry` relation. */
  reversesEntry?: InputMaybe<AccountCapitalEntryFilter>;
  /** A related `reversesEntry` exists. */
  reversesEntryExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountCapitalEntry` for usage during aggregation. */
export enum AccountCapitalEntryGroupBy {
  AccountId = 'ACCOUNT_ID',
  CreatedByAdminId = 'CREATED_BY_ADMIN_ID'
}

export type AccountCapitalEntryHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountCapitalEntry` aggregates. */
export type AccountCapitalEntryHavingInput = {
  AND?: InputMaybe<Array<AccountCapitalEntryHavingInput>>;
  OR?: InputMaybe<Array<AccountCapitalEntryHavingInput>>;
  average?: InputMaybe<AccountCapitalEntryHavingAverageInput>;
  distinctCount?: InputMaybe<AccountCapitalEntryHavingDistinctCountInput>;
  max?: InputMaybe<AccountCapitalEntryHavingMaxInput>;
  min?: InputMaybe<AccountCapitalEntryHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountCapitalEntryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountCapitalEntryHavingStddevSampleInput>;
  sum?: InputMaybe<AccountCapitalEntryHavingSumInput>;
  variancePopulation?: InputMaybe<AccountCapitalEntryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountCapitalEntryHavingVarianceSampleInput>;
};

export type AccountCapitalEntryHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdByAdminId?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  reversesEntryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sisuLevel?: InputMaybe<HavingIntFilter>;
};

export type AccountCapitalEntryMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  createdByAdminId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type AccountCapitalEntryMaxAggregates = {
  __typename?: 'AccountCapitalEntryMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['Int']['output']>;
};

export type AccountCapitalEntryMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  createdByAdminId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type AccountCapitalEntryMinAggregates = {
  __typename?: 'AccountCapitalEntryMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountCapitalEntry`. */
export enum AccountCapitalEntryOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedByAdminIdAsc = 'CREATED_BY_ADMIN_ID_ASC',
  CreatedByAdminIdDesc = 'CREATED_BY_ADMIN_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequestIdAsc = 'REQUEST_ID_ASC',
  RequestIdDesc = 'REQUEST_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

/**
 * A single row of the append-only capital ledger. Rows are immutable; a
 * correction is a reversal plus a replacement, and a void is an offsetting row.
 */
export type AccountCapitalEntryResult = {
  __typename?: 'AccountCapitalEntryResult';
  accountId: Scalars['Int']['output'];
  /** Signed. Positive is a grant, negative is a reversal. */
  amount: Scalars['Float']['output'];
  /** Derived from entryType, never supplied by a caller. 'seed_capital' or 'dpop'. */
  bucket: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** Stamped from the JWT. Not settable by a caller. */
  createdByAdminId: Scalars['Int']['output'];
  /** When this entry starts counting toward granted/octagonGranted. */
  effectiveAt: Scalars['String']['output'];
  entryType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  notes: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  /** Lineage only — set on a reversal, pointing at the entry it reverses. */
  reversesEntryId?: Maybe<Scalars['Int']['output']>;
  rowHash?: Maybe<Scalars['String']['output']>;
  sisuLevel?: Maybe<Scalars['Int']['output']>;
};

export type AccountCapitalEntryStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  createdByAdminId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountCapitalEntryStddevPopulationAggregates = {
  __typename?: 'AccountCapitalEntryStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCapitalEntryStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  createdByAdminId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountCapitalEntryStddevSampleAggregates = {
  __typename?: 'AccountCapitalEntryStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCapitalEntrySumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  createdByAdminId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AccountCapitalEntrySumAggregates = {
  __typename?: 'AccountCapitalEntrySumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of createdByAdminId across the matching connection */
  createdByAdminId: Scalars['BigInt']['output'];
  /** Sum of reversesEntryId across the matching connection */
  reversesEntryId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of sisuLevel across the matching connection */
  sisuLevel: Scalars['BigInt']['output'];
};

export enum AccountCapitalEntryTypeEnum {
  Adjustment = 'adjustment',
  InitialFunding = 'initial_funding',
  OctagonBonus = 'octagon_bonus',
  OpeningPosition = 'opening_position',
  SisuLevelUnlock = 'sisu_level_unlock'
}

export type AccountCapitalEntryVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  createdByAdminId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountCapitalEntryVariancePopulationAggregates = {
  __typename?: 'AccountCapitalEntryVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCapitalEntryVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  createdByAdminId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountCapitalEntryVarianceSampleAggregates = {
  __typename?: 'AccountCapitalEntryVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdByAdminId across the matching connection */
  createdByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reversesEntryId across the matching connection */
  reversesEntryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sisuLevel across the matching connection */
  sisuLevel?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCapitalMutationPayload = {
  __typename?: 'AccountCapitalMutationPayload';
  /** The grant, the offsetting void row, or a correction's replacement. */
  entry: AccountCapitalEntryResult;
  /** True when this requestId had already been applied and nothing new was written. */
  idempotentReplay: Scalars['Boolean']['output'];
  /** A correction's reversal row. Null for create, and for void where entry is itself the reversal. */
  reversalEntry?: Maybe<AccountCapitalEntryResult>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `accountName` field. */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountTemplate` field. */
  accountTemplate?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `complimentary` field. */
  complimentary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `nmiSubscriptionId` field. */
  nmiSubscriptionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `platformId` field. */
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectXAccountId` field. */
  projectXAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `skuId` field. */
  skuId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Account` values. */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountAggregates>;
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountAggregates>>;
  /** A list of `Account` objects. */
  nodes: Array<Maybe<Account>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Account` values. */
export type AccountConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountGroupBy>;
  having?: InputMaybe<AccountHavingInput>;
};

export type AccountDistinctCountAggregateFilter = {
  accountName?: InputMaybe<BigIntFilter>;
  accountTemplate?: InputMaybe<BigIntFilter>;
  active?: InputMaybe<BigIntFilter>;
  complimentary?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  nmiSubscriptionId?: InputMaybe<BigIntFilter>;
  platformId?: InputMaybe<BigIntFilter>;
  projectXAccountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
  stage?: InputMaybe<BigIntFilter>;
  startDate?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountDistinctCountAggregates = {
  __typename?: 'AccountDistinctCountAggregates';
  /** Distinct count of accountLabels across the matching connection */
  accountLabels?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountName across the matching connection */
  accountName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closeReason across the matching connection */
  closeReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closedAt across the matching connection */
  closedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of complimentary across the matching connection */
  complimentary?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of complimentaryExpirationDate across the matching connection */
  complimentaryExpirationDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dailyPayoutsUnlockedAt across the matching connection */
  dailyPayoutsUnlockedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idempotencyKey across the matching connection */
  idempotencyKey?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutEnabledByAdmin across the matching connection */
  payoutEnabledByAdmin?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stage across the matching connection */
  stage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startDate across the matching connection */
  startDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of viewedReflections across the matching connection */
  viewedReflections?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Account` edge in the connection. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Account` at the end of the edge. */
  node?: Maybe<Account>;
};

/** A filter to be used against `Account` object types. All fields are combined with a logical ‘and.’ */
export type AccountFilter = {
  /** Filter by the object’s `accountCapitalEntries` relation. */
  accountCapitalEntries?: InputMaybe<AccountToManyAccountCapitalEntryFilter>;
  /** Some related `accountCapitalEntries` exist. */
  accountCapitalEntriesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountLiveCallUp` relation. */
  accountLiveCallUp?: InputMaybe<AccountLiveCallUpFilter>;
  /** A related `accountLiveCallUp` exists. */
  accountLiveCallUpExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountName` field. */
  accountName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountPassedBinders` relation. */
  accountPassedBinders?: InputMaybe<AccountToManyAccountPassedBinderFilter>;
  /** Some related `accountPassedBinders` exist. */
  accountPassedBindersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountPlatformDatum` relation. */
  accountPlatformDatum?: InputMaybe<AccountPlatformDatumFilter>;
  /** A related `accountPlatformDatum` exists. */
  accountPlatformDatumExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountStats` relation. */
  accountStats?: InputMaybe<AccountToManyAccountStatFilter>;
  /** Some related `accountStats` exist. */
  accountStatsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountTemplate` field. */
  accountTemplate?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountTemplateRelation` relation. */
  accountTemplateRelation?: InputMaybe<AccountTemplateFilter>;
  /** A related `accountTemplateRelation` exists. */
  accountTemplateRelationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `complimentary` field. */
  complimentary?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `impactGroupAssignments` relation. */
  impactGroupAssignments?: InputMaybe<AccountToManyImpactGroupAssignmentFilter>;
  /** Some related `impactGroupAssignments` exist. */
  impactGroupAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `nmiSubscription` relation. */
  nmiSubscription?: InputMaybe<NmiSubscriptionFilter>;
  /** A related `nmiSubscription` exists. */
  nmiSubscriptionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `nmiSubscriptionId` field. */
  nmiSubscriptionId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `orderFulfillment` relation. */
  orderFulfillment?: InputMaybe<OrderFulfillmentFilter>;
  /** A related `orderFulfillment` exists. */
  orderFulfillmentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `platform` relation. */
  platform?: InputMaybe<PlatformFilter>;
  /** A related `platform` exists. */
  platformExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `platformId` field. */
  platformId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `productCategory` relation. */
  productCategory?: InputMaybe<ProductCategoryFilter>;
  /** A related `productCategory` exists. */
  productCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectXAccountId` field. */
  projectXAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `skuId` field. */
  skuId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subscription` relation. */
  subscription?: InputMaybe<UserSubscriptionFilter>;
  /** A related `subscription` exists. */
  subscriptionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderPublicProfilesByFeaturedAccountId` relation. */
  traderPublicProfilesByFeaturedAccountId?: InputMaybe<AccountToManyTraderPublicProfileFilter>;
  /** Some related `traderPublicProfilesByFeaturedAccountId` exist. */
  traderPublicProfilesByFeaturedAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `xfaResetTrackingsByParentAccountId` relation. */
  xfaResetTrackingsByParentAccountId?: InputMaybe<AccountToManyXfaResetTrackingFilter>;
  /** Some related `xfaResetTrackingsByParentAccountId` exist. */
  xfaResetTrackingsByParentAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `xfaResetTrackingsByResetAccountId` relation. */
  xfaResetTrackingsByResetAccountId?: InputMaybe<AccountToManyXfaResetTrackingFilter>;
  /** Some related `xfaResetTrackingsByResetAccountId` exist. */
  xfaResetTrackingsByResetAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Account` for usage during aggregation. */
export enum AccountGroupBy {
  AccountName = 'ACCOUNT_NAME',
  AccountTemplate = 'ACCOUNT_TEMPLATE',
  Active = 'ACTIVE',
  Complimentary = 'COMPLIMENTARY',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  NmiSubscriptionId = 'NMI_SUBSCRIPTION_ID',
  PlatformId = 'PLATFORM_ID',
  SkuId = 'SKU_ID',
  Stage = 'STAGE',
  StartDate = 'START_DATE',
  StartDateTruncatedToDay = 'START_DATE_TRUNCATED_TO_DAY',
  StartDateTruncatedToHour = 'START_DATE_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  SubscriptionId = 'SUBSCRIPTION_ID',
  UserId = 'USER_ID'
}

export type AccountHavingAverageInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingDistinctCountInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Account` aggregates. */
export type AccountHavingInput = {
  AND?: InputMaybe<Array<AccountHavingInput>>;
  OR?: InputMaybe<Array<AccountHavingInput>>;
  average?: InputMaybe<AccountHavingAverageInput>;
  distinctCount?: InputMaybe<AccountHavingDistinctCountInput>;
  max?: InputMaybe<AccountHavingMaxInput>;
  min?: InputMaybe<AccountHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountHavingStddevSampleInput>;
  sum?: InputMaybe<AccountHavingSumInput>;
  variancePopulation?: InputMaybe<AccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountHavingVarianceSampleInput>;
};

export type AccountHavingMaxInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingMinInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingStddevPopulationInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingStddevSampleInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingSumInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingVariancePopulationInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingVarianceSampleInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  complimentaryExpirationDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyPayoutsUnlockedAt?: InputMaybe<HavingDatetimeFilter>;
  nmiSubscriptionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  projectXAccountStatus?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  startingBalance?: InputMaybe<HavingBigfloatFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountLiveCallUp = Node & {
  __typename?: 'AccountLiveCallUp';
  /** Reads a single `Account` that is related to this `AccountLiveCallUp`. */
  account?: Maybe<Account>;
  /** Reads a single `AccountCallUpDecision` that is related to this `AccountLiveCallUp`. */
  accountCallUpDecisionByUuidAndUserId?: Maybe<AccountCallUpDecision>;
  accountId: Scalars['Int']['output'];
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Deprecated: superseded by callUpPayoutAmount. Kept for API instances on the previous entity during the deploy; a later migration drops it. */
  brokerageAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** This XFA's share of the call-up payout the trader chose, whole dollars. Frozen once the batch leaves pending. */
  callUpPayoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  callUpPayoutBonusAmount?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Durable claim written before the platform cash-adjustment call. Set with payoutId null = interrupted debit; never replayed automatically. */
  debitStartedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `PayoutRequest` that is related to this `AccountLiveCallUp`. */
  payout?: Maybe<PayoutRequest>;
  payoutAmount?: Maybe<Scalars['BigFloat']['output']>;
  payoutId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `AccountLiveCallUp`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** A filter to be used against `AccountLiveCallUp` object types. All fields are combined with a logical ‘and.’ */
export type AccountLiveCallUpFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountCallUpDecisionByUuidAndUserId` relation. */
  accountCallUpDecisionByUuidAndUserId?: InputMaybe<AccountCallUpDecisionFilter>;
  /** A related `accountCallUpDecisionByUuidAndUserId` exists. */
  accountCallUpDecisionByUuidAndUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountLiveCallUpFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AccountLiveCallUpFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountLiveCallUpFilter>>;
  /** Filter by the object’s `payout` relation. */
  payout?: InputMaybe<PayoutRequestFilter>;
  /** A related `payout` exists. */
  payoutExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutId` field. */
  payoutId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `uuid` field. */
  uuid?: InputMaybe<UuidFilter>;
};

export type AccountMaxAggregateFilter = {
  accountTemplate?: InputMaybe<IntFilter>;
  nmiSubscriptionId?: InputMaybe<IntFilter>;
  platformId?: InputMaybe<IntFilter>;
  projectXAccountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountMaxAggregates = {
  __typename?: 'AccountMaxAggregates';
  /** Maximum of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountMinAggregateFilter = {
  accountTemplate?: InputMaybe<IntFilter>;
  nmiSubscriptionId?: InputMaybe<IntFilter>;
  platformId?: InputMaybe<IntFilter>;
  projectXAccountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountMinAggregates = {
  __typename?: 'AccountMinAggregates';
  /** Minimum of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountNote = Node & {
  __typename?: 'AccountNote';
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  issuedBy?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/** Methods to use when ordering `Account`. */
export enum AccountOrderBy {
  AccountCapitalEntriesAverageAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_AVERAGE_ACCOUNT_ID_ASC',
  AccountCapitalEntriesAverageAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_AVERAGE_ACCOUNT_ID_DESC',
  AccountCapitalEntriesAverageCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_AVERAGE_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesAverageCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_AVERAGE_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesAverageRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_AVERAGE_ROW_ID_ASC',
  AccountCapitalEntriesAverageRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_AVERAGE_ROW_ID_DESC',
  AccountCapitalEntriesCountAsc = 'ACCOUNT_CAPITAL_ENTRIES_COUNT_ASC',
  AccountCapitalEntriesCountDesc = 'ACCOUNT_CAPITAL_ENTRIES_COUNT_DESC',
  AccountCapitalEntriesDistinctCountAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_ACCOUNT_ID_ASC',
  AccountCapitalEntriesDistinctCountAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_ACCOUNT_ID_DESC',
  AccountCapitalEntriesDistinctCountCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesDistinctCountCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesDistinctCountRequestIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_REQUEST_ID_ASC',
  AccountCapitalEntriesDistinctCountRequestIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_REQUEST_ID_DESC',
  AccountCapitalEntriesDistinctCountRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_ROW_ID_ASC',
  AccountCapitalEntriesDistinctCountRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_DISTINCT_COUNT_ROW_ID_DESC',
  AccountCapitalEntriesMaxAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_MAX_ACCOUNT_ID_ASC',
  AccountCapitalEntriesMaxAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_MAX_ACCOUNT_ID_DESC',
  AccountCapitalEntriesMaxCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_MAX_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesMaxCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_MAX_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesMaxRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_MAX_ROW_ID_ASC',
  AccountCapitalEntriesMaxRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_MAX_ROW_ID_DESC',
  AccountCapitalEntriesMinAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_MIN_ACCOUNT_ID_ASC',
  AccountCapitalEntriesMinAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_MIN_ACCOUNT_ID_DESC',
  AccountCapitalEntriesMinCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_MIN_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesMinCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_MIN_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesMinRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_MIN_ROW_ID_ASC',
  AccountCapitalEntriesMinRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_MIN_ROW_ID_DESC',
  AccountCapitalEntriesStddevPopulationAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_POPULATION_ACCOUNT_ID_ASC',
  AccountCapitalEntriesStddevPopulationAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_POPULATION_ACCOUNT_ID_DESC',
  AccountCapitalEntriesStddevPopulationCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_POPULATION_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesStddevPopulationCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_POPULATION_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesStddevPopulationRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_POPULATION_ROW_ID_ASC',
  AccountCapitalEntriesStddevPopulationRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_POPULATION_ROW_ID_DESC',
  AccountCapitalEntriesStddevSampleAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_SAMPLE_ACCOUNT_ID_ASC',
  AccountCapitalEntriesStddevSampleAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_SAMPLE_ACCOUNT_ID_DESC',
  AccountCapitalEntriesStddevSampleCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_SAMPLE_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesStddevSampleCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_SAMPLE_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesStddevSampleRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountCapitalEntriesStddevSampleRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountCapitalEntriesSumAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_SUM_ACCOUNT_ID_ASC',
  AccountCapitalEntriesSumAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_SUM_ACCOUNT_ID_DESC',
  AccountCapitalEntriesSumCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_SUM_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesSumCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_SUM_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesSumRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_SUM_ROW_ID_ASC',
  AccountCapitalEntriesSumRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_SUM_ROW_ID_DESC',
  AccountCapitalEntriesVariancePopulationAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_POPULATION_ACCOUNT_ID_ASC',
  AccountCapitalEntriesVariancePopulationAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_POPULATION_ACCOUNT_ID_DESC',
  AccountCapitalEntriesVariancePopulationCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_POPULATION_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesVariancePopulationCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_POPULATION_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesVariancePopulationRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountCapitalEntriesVariancePopulationRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountCapitalEntriesVarianceSampleAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_SAMPLE_ACCOUNT_ID_ASC',
  AccountCapitalEntriesVarianceSampleAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_SAMPLE_ACCOUNT_ID_DESC',
  AccountCapitalEntriesVarianceSampleCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_SAMPLE_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesVarianceSampleCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_SAMPLE_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesVarianceSampleRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountCapitalEntriesVarianceSampleRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountNameAsc = 'ACCOUNT_NAME_ASC',
  AccountNameDesc = 'ACCOUNT_NAME_DESC',
  AccountPassedBindersAverageAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_AVERAGE_ACCOUNT_ID_ASC',
  AccountPassedBindersAverageAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_AVERAGE_ACCOUNT_ID_DESC',
  AccountPassedBindersAverageRowIdAsc = 'ACCOUNT_PASSED_BINDERS_AVERAGE_ROW_ID_ASC',
  AccountPassedBindersAverageRowIdDesc = 'ACCOUNT_PASSED_BINDERS_AVERAGE_ROW_ID_DESC',
  AccountPassedBindersAverageUserIdAsc = 'ACCOUNT_PASSED_BINDERS_AVERAGE_USER_ID_ASC',
  AccountPassedBindersAverageUserIdDesc = 'ACCOUNT_PASSED_BINDERS_AVERAGE_USER_ID_DESC',
  AccountPassedBindersCountAsc = 'ACCOUNT_PASSED_BINDERS_COUNT_ASC',
  AccountPassedBindersCountDesc = 'ACCOUNT_PASSED_BINDERS_COUNT_DESC',
  AccountPassedBindersDistinctCountAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_DISTINCT_COUNT_ACCOUNT_ID_ASC',
  AccountPassedBindersDistinctCountAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_DISTINCT_COUNT_ACCOUNT_ID_DESC',
  AccountPassedBindersDistinctCountRowIdAsc = 'ACCOUNT_PASSED_BINDERS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountPassedBindersDistinctCountRowIdDesc = 'ACCOUNT_PASSED_BINDERS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountPassedBindersDistinctCountUserIdAsc = 'ACCOUNT_PASSED_BINDERS_DISTINCT_COUNT_USER_ID_ASC',
  AccountPassedBindersDistinctCountUserIdDesc = 'ACCOUNT_PASSED_BINDERS_DISTINCT_COUNT_USER_ID_DESC',
  AccountPassedBindersMaxAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_MAX_ACCOUNT_ID_ASC',
  AccountPassedBindersMaxAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_MAX_ACCOUNT_ID_DESC',
  AccountPassedBindersMaxRowIdAsc = 'ACCOUNT_PASSED_BINDERS_MAX_ROW_ID_ASC',
  AccountPassedBindersMaxRowIdDesc = 'ACCOUNT_PASSED_BINDERS_MAX_ROW_ID_DESC',
  AccountPassedBindersMaxUserIdAsc = 'ACCOUNT_PASSED_BINDERS_MAX_USER_ID_ASC',
  AccountPassedBindersMaxUserIdDesc = 'ACCOUNT_PASSED_BINDERS_MAX_USER_ID_DESC',
  AccountPassedBindersMinAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_MIN_ACCOUNT_ID_ASC',
  AccountPassedBindersMinAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_MIN_ACCOUNT_ID_DESC',
  AccountPassedBindersMinRowIdAsc = 'ACCOUNT_PASSED_BINDERS_MIN_ROW_ID_ASC',
  AccountPassedBindersMinRowIdDesc = 'ACCOUNT_PASSED_BINDERS_MIN_ROW_ID_DESC',
  AccountPassedBindersMinUserIdAsc = 'ACCOUNT_PASSED_BINDERS_MIN_USER_ID_ASC',
  AccountPassedBindersMinUserIdDesc = 'ACCOUNT_PASSED_BINDERS_MIN_USER_ID_DESC',
  AccountPassedBindersStddevPopulationAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_STDDEV_POPULATION_ACCOUNT_ID_ASC',
  AccountPassedBindersStddevPopulationAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_STDDEV_POPULATION_ACCOUNT_ID_DESC',
  AccountPassedBindersStddevPopulationRowIdAsc = 'ACCOUNT_PASSED_BINDERS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountPassedBindersStddevPopulationRowIdDesc = 'ACCOUNT_PASSED_BINDERS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountPassedBindersStddevPopulationUserIdAsc = 'ACCOUNT_PASSED_BINDERS_STDDEV_POPULATION_USER_ID_ASC',
  AccountPassedBindersStddevPopulationUserIdDesc = 'ACCOUNT_PASSED_BINDERS_STDDEV_POPULATION_USER_ID_DESC',
  AccountPassedBindersStddevSampleAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_STDDEV_SAMPLE_ACCOUNT_ID_ASC',
  AccountPassedBindersStddevSampleAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_STDDEV_SAMPLE_ACCOUNT_ID_DESC',
  AccountPassedBindersStddevSampleRowIdAsc = 'ACCOUNT_PASSED_BINDERS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountPassedBindersStddevSampleRowIdDesc = 'ACCOUNT_PASSED_BINDERS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountPassedBindersStddevSampleUserIdAsc = 'ACCOUNT_PASSED_BINDERS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountPassedBindersStddevSampleUserIdDesc = 'ACCOUNT_PASSED_BINDERS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountPassedBindersSumAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_SUM_ACCOUNT_ID_ASC',
  AccountPassedBindersSumAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_SUM_ACCOUNT_ID_DESC',
  AccountPassedBindersSumRowIdAsc = 'ACCOUNT_PASSED_BINDERS_SUM_ROW_ID_ASC',
  AccountPassedBindersSumRowIdDesc = 'ACCOUNT_PASSED_BINDERS_SUM_ROW_ID_DESC',
  AccountPassedBindersSumUserIdAsc = 'ACCOUNT_PASSED_BINDERS_SUM_USER_ID_ASC',
  AccountPassedBindersSumUserIdDesc = 'ACCOUNT_PASSED_BINDERS_SUM_USER_ID_DESC',
  AccountPassedBindersVariancePopulationAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_POPULATION_ACCOUNT_ID_ASC',
  AccountPassedBindersVariancePopulationAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_POPULATION_ACCOUNT_ID_DESC',
  AccountPassedBindersVariancePopulationRowIdAsc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountPassedBindersVariancePopulationRowIdDesc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountPassedBindersVariancePopulationUserIdAsc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountPassedBindersVariancePopulationUserIdDesc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountPassedBindersVarianceSampleAccountIdAsc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_SAMPLE_ACCOUNT_ID_ASC',
  AccountPassedBindersVarianceSampleAccountIdDesc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_SAMPLE_ACCOUNT_ID_DESC',
  AccountPassedBindersVarianceSampleRowIdAsc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountPassedBindersVarianceSampleRowIdDesc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountPassedBindersVarianceSampleUserIdAsc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountPassedBindersVarianceSampleUserIdDesc = 'ACCOUNT_PASSED_BINDERS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountStatsAverageAccountIdAsc = 'ACCOUNT_STATS_AVERAGE_ACCOUNT_ID_ASC',
  AccountStatsAverageAccountIdDesc = 'ACCOUNT_STATS_AVERAGE_ACCOUNT_ID_DESC',
  AccountStatsAverageRowIdAsc = 'ACCOUNT_STATS_AVERAGE_ROW_ID_ASC',
  AccountStatsAverageRowIdDesc = 'ACCOUNT_STATS_AVERAGE_ROW_ID_DESC',
  AccountStatsCountAsc = 'ACCOUNT_STATS_COUNT_ASC',
  AccountStatsCountDesc = 'ACCOUNT_STATS_COUNT_DESC',
  AccountStatsDistinctCountAccountIdAsc = 'ACCOUNT_STATS_DISTINCT_COUNT_ACCOUNT_ID_ASC',
  AccountStatsDistinctCountAccountIdDesc = 'ACCOUNT_STATS_DISTINCT_COUNT_ACCOUNT_ID_DESC',
  AccountStatsDistinctCountRowIdAsc = 'ACCOUNT_STATS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountStatsDistinctCountRowIdDesc = 'ACCOUNT_STATS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountStatsMaxAccountIdAsc = 'ACCOUNT_STATS_MAX_ACCOUNT_ID_ASC',
  AccountStatsMaxAccountIdDesc = 'ACCOUNT_STATS_MAX_ACCOUNT_ID_DESC',
  AccountStatsMaxRowIdAsc = 'ACCOUNT_STATS_MAX_ROW_ID_ASC',
  AccountStatsMaxRowIdDesc = 'ACCOUNT_STATS_MAX_ROW_ID_DESC',
  AccountStatsMinAccountIdAsc = 'ACCOUNT_STATS_MIN_ACCOUNT_ID_ASC',
  AccountStatsMinAccountIdDesc = 'ACCOUNT_STATS_MIN_ACCOUNT_ID_DESC',
  AccountStatsMinRowIdAsc = 'ACCOUNT_STATS_MIN_ROW_ID_ASC',
  AccountStatsMinRowIdDesc = 'ACCOUNT_STATS_MIN_ROW_ID_DESC',
  AccountStatsStddevPopulationAccountIdAsc = 'ACCOUNT_STATS_STDDEV_POPULATION_ACCOUNT_ID_ASC',
  AccountStatsStddevPopulationAccountIdDesc = 'ACCOUNT_STATS_STDDEV_POPULATION_ACCOUNT_ID_DESC',
  AccountStatsStddevPopulationRowIdAsc = 'ACCOUNT_STATS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountStatsStddevPopulationRowIdDesc = 'ACCOUNT_STATS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountStatsStddevSampleAccountIdAsc = 'ACCOUNT_STATS_STDDEV_SAMPLE_ACCOUNT_ID_ASC',
  AccountStatsStddevSampleAccountIdDesc = 'ACCOUNT_STATS_STDDEV_SAMPLE_ACCOUNT_ID_DESC',
  AccountStatsStddevSampleRowIdAsc = 'ACCOUNT_STATS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountStatsStddevSampleRowIdDesc = 'ACCOUNT_STATS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountStatsSumAccountIdAsc = 'ACCOUNT_STATS_SUM_ACCOUNT_ID_ASC',
  AccountStatsSumAccountIdDesc = 'ACCOUNT_STATS_SUM_ACCOUNT_ID_DESC',
  AccountStatsSumRowIdAsc = 'ACCOUNT_STATS_SUM_ROW_ID_ASC',
  AccountStatsSumRowIdDesc = 'ACCOUNT_STATS_SUM_ROW_ID_DESC',
  AccountStatsVariancePopulationAccountIdAsc = 'ACCOUNT_STATS_VARIANCE_POPULATION_ACCOUNT_ID_ASC',
  AccountStatsVariancePopulationAccountIdDesc = 'ACCOUNT_STATS_VARIANCE_POPULATION_ACCOUNT_ID_DESC',
  AccountStatsVariancePopulationRowIdAsc = 'ACCOUNT_STATS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountStatsVariancePopulationRowIdDesc = 'ACCOUNT_STATS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountStatsVarianceSampleAccountIdAsc = 'ACCOUNT_STATS_VARIANCE_SAMPLE_ACCOUNT_ID_ASC',
  AccountStatsVarianceSampleAccountIdDesc = 'ACCOUNT_STATS_VARIANCE_SAMPLE_ACCOUNT_ID_DESC',
  AccountStatsVarianceSampleRowIdAsc = 'ACCOUNT_STATS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountStatsVarianceSampleRowIdDesc = 'ACCOUNT_STATS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountTemplateAsc = 'ACCOUNT_TEMPLATE_ASC',
  AccountTemplateDesc = 'ACCOUNT_TEMPLATE_DESC',
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ComplimentaryAsc = 'COMPLIMENTARY_ASC',
  ComplimentaryDesc = 'COMPLIMENTARY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ImpactGroupAssignmentsAverageImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsAverageImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsAverageRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_ROW_ID_ASC',
  ImpactGroupAssignmentsAverageRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_ROW_ID_DESC',
  ImpactGroupAssignmentsCountAsc = 'IMPACT_GROUP_ASSIGNMENTS_COUNT_ASC',
  ImpactGroupAssignmentsCountDesc = 'IMPACT_GROUP_ASSIGNMENTS_COUNT_DESC',
  ImpactGroupAssignmentsDistinctCountImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsDistinctCountImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsDistinctCountRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_ASC',
  ImpactGroupAssignmentsDistinctCountRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_DESC',
  ImpactGroupAssignmentsMaxImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsMaxImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsMaxRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_ROW_ID_ASC',
  ImpactGroupAssignmentsMaxRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_ROW_ID_DESC',
  ImpactGroupAssignmentsMinImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsMinImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsMinRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_ROW_ID_ASC',
  ImpactGroupAssignmentsMinRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_ROW_ID_DESC',
  ImpactGroupAssignmentsStddevPopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsStddevPopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsStddevPopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsStddevPopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsStddevSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsStddevSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsStddevSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsStddevSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  ImpactGroupAssignmentsSumImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsSumImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsSumRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_ROW_ID_ASC',
  ImpactGroupAssignmentsSumRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_ROW_ID_DESC',
  ImpactGroupAssignmentsVariancePopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsVariancePopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsVariancePopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsVariancePopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsVarianceSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsVarianceSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsVarianceSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsVarianceSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  Natural = 'NATURAL',
  NmiSubscriptionIdAsc = 'NMI_SUBSCRIPTION_ID_ASC',
  NmiSubscriptionIdDesc = 'NMI_SUBSCRIPTION_ID_DESC',
  PlatformIdAsc = 'PLATFORM_ID_ASC',
  PlatformIdDesc = 'PLATFORM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectXaccountIdAsc = 'PROJECT_XACCOUNT_ID_ASC',
  ProjectXaccountIdDesc = 'PROJECT_XACCOUNT_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SkuIdAsc = 'SKU_ID_ASC',
  SkuIdDesc = 'SKU_ID_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdAverageRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_AVERAGE_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdAverageRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_AVERAGE_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdCountAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_COUNT_ASC',
  TraderPublicProfilesByFeaturedAccountIdCountDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_COUNT_DESC',
  TraderPublicProfilesByFeaturedAccountIdDistinctCountPublicTraderIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_DISTINCT_COUNT_PUBLIC_TRADER_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdDistinctCountPublicTraderIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_DISTINCT_COUNT_PUBLIC_TRADER_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdDistinctCountRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdDistinctCountRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdMaxRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_MAX_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdMaxRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_MAX_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdMinRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_MIN_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdMinRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_MIN_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdStddevPopulationRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdStddevPopulationRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdStddevSampleRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdStddevSampleRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdSumRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_SUM_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdSumRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_SUM_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdVariancePopulationRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdVariancePopulationRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  TraderPublicProfilesByFeaturedAccountIdVarianceSampleRowIdAsc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  TraderPublicProfilesByFeaturedAccountIdVarianceSampleRowIdDesc = 'TRADER_PUBLIC_PROFILES_BY_FEATURED_ACCOUNT_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  XfaResetTrackingsByParentAccountIdAverageParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_AVERAGE_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdAverageParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_AVERAGE_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdAverageResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_AVERAGE_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdAverageResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_AVERAGE_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdAverageRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_AVERAGE_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdAverageRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_AVERAGE_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdCountAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_COUNT_ASC',
  XfaResetTrackingsByParentAccountIdCountDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_COUNT_DESC',
  XfaResetTrackingsByParentAccountIdDistinctCountActivationScheduledAtAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_SCHEDULED_AT_ASC',
  XfaResetTrackingsByParentAccountIdDistinctCountActivationScheduledAtDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_SCHEDULED_AT_DESC',
  XfaResetTrackingsByParentAccountIdDistinctCountActivationStatusAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_STATUS_ASC',
  XfaResetTrackingsByParentAccountIdDistinctCountActivationStatusDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_STATUS_DESC',
  XfaResetTrackingsByParentAccountIdDistinctCountBranchIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_BRANCH_ID_ASC',
  XfaResetTrackingsByParentAccountIdDistinctCountBranchIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_BRANCH_ID_DESC',
  XfaResetTrackingsByParentAccountIdDistinctCountParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdDistinctCountParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdDistinctCountResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdDistinctCountResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdDistinctCountRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdDistinctCountRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdMaxParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MAX_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdMaxParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MAX_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdMaxResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MAX_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdMaxResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MAX_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdMaxRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MAX_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdMaxRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MAX_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdMinParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MIN_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdMinParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MIN_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdMinResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MIN_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdMinResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MIN_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdMinRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MIN_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdMinRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_MIN_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdStddevPopulationParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_POPULATION_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdStddevPopulationParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_POPULATION_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdStddevPopulationResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_POPULATION_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdStddevPopulationResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_POPULATION_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdStddevPopulationRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdStddevPopulationRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdStddevSampleParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_SAMPLE_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdStddevSampleParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_SAMPLE_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdStddevSampleResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_SAMPLE_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdStddevSampleResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_SAMPLE_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdStddevSampleRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdStddevSampleRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdSumParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_SUM_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdSumParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_SUM_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdSumResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_SUM_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdSumResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_SUM_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdSumRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_SUM_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdSumRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_SUM_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdVariancePopulationParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_POPULATION_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdVariancePopulationParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_POPULATION_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdVariancePopulationResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_POPULATION_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdVariancePopulationResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_POPULATION_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdVariancePopulationRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdVariancePopulationRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  XfaResetTrackingsByParentAccountIdVarianceSampleParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_SAMPLE_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdVarianceSampleParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_SAMPLE_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdVarianceSampleResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_SAMPLE_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByParentAccountIdVarianceSampleResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_SAMPLE_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByParentAccountIdVarianceSampleRowIdAsc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  XfaResetTrackingsByParentAccountIdVarianceSampleRowIdDesc = 'XFA_RESET_TRACKINGS_BY_PARENT_ACCOUNT_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdAverageParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_AVERAGE_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdAverageParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_AVERAGE_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdAverageResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_AVERAGE_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdAverageResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_AVERAGE_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdAverageRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_AVERAGE_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdAverageRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_AVERAGE_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdCountAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_COUNT_ASC',
  XfaResetTrackingsByResetAccountIdCountDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_COUNT_DESC',
  XfaResetTrackingsByResetAccountIdDistinctCountActivationScheduledAtAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_SCHEDULED_AT_ASC',
  XfaResetTrackingsByResetAccountIdDistinctCountActivationScheduledAtDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_SCHEDULED_AT_DESC',
  XfaResetTrackingsByResetAccountIdDistinctCountActivationStatusAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_STATUS_ASC',
  XfaResetTrackingsByResetAccountIdDistinctCountActivationStatusDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_ACTIVATION_STATUS_DESC',
  XfaResetTrackingsByResetAccountIdDistinctCountBranchIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_BRANCH_ID_ASC',
  XfaResetTrackingsByResetAccountIdDistinctCountBranchIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_BRANCH_ID_DESC',
  XfaResetTrackingsByResetAccountIdDistinctCountParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdDistinctCountParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdDistinctCountResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdDistinctCountResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdDistinctCountRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdDistinctCountRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdMaxParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MAX_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdMaxParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MAX_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdMaxResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MAX_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdMaxResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MAX_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdMaxRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MAX_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdMaxRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MAX_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdMinParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MIN_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdMinParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MIN_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdMinResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MIN_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdMinResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MIN_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdMinRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MIN_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdMinRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_MIN_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdStddevPopulationParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_POPULATION_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdStddevPopulationParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_POPULATION_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdStddevPopulationResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_POPULATION_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdStddevPopulationResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_POPULATION_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdStddevPopulationRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdStddevPopulationRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdStddevSampleParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_SAMPLE_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdStddevSampleParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_SAMPLE_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdStddevSampleResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_SAMPLE_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdStddevSampleResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_SAMPLE_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdStddevSampleRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdStddevSampleRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdSumParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_SUM_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdSumParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_SUM_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdSumResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_SUM_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdSumResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_SUM_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdSumRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_SUM_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdSumRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_SUM_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdVariancePopulationParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_POPULATION_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdVariancePopulationParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_POPULATION_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdVariancePopulationResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_POPULATION_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdVariancePopulationResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_POPULATION_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdVariancePopulationRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdVariancePopulationRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  XfaResetTrackingsByResetAccountIdVarianceSampleParentAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_SAMPLE_PARENT_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdVarianceSampleParentAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_SAMPLE_PARENT_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdVarianceSampleResetAccountIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_SAMPLE_RESET_ACCOUNT_ID_ASC',
  XfaResetTrackingsByResetAccountIdVarianceSampleResetAccountIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_SAMPLE_RESET_ACCOUNT_ID_DESC',
  XfaResetTrackingsByResetAccountIdVarianceSampleRowIdAsc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  XfaResetTrackingsByResetAccountIdVarianceSampleRowIdDesc = 'XFA_RESET_TRACKINGS_BY_RESET_ACCOUNT_ID_VARIANCE_SAMPLE_ROW_ID_DESC'
}

export type AccountPassedBinder = Node & {
  __typename?: 'AccountPassedBinder';
  /** Reads a single `Account` that is related to this `AccountPassedBinder`. */
  account?: Maybe<Account>;
  accountId: Scalars['Int']['output'];
  activationInvoiceReference?: Maybe<Scalars['String']['output']>;
  activationInvoiceSentDate?: Maybe<Scalars['Datetime']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  contractReference?: Maybe<Scalars['String']['output']>;
  contractSentDate?: Maybe<Scalars['Datetime']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  inQueue?: Maybe<Scalars['Boolean']['output']>;
  kycComplete: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['Int']['output'];
  skipActivationFee?: Maybe<Scalars['Boolean']['output']>;
  stage: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
  xfaAccountId?: Maybe<Scalars['Int']['output']>;
};

export type AccountPassedBinderAggregates = {
  __typename?: 'AccountPassedBinderAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountPassedBinderAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountPassedBinderDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountPassedBinderMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountPassedBinderMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountPassedBinderStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountPassedBinderStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountPassedBinderSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountPassedBinderVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountPassedBinderVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountPassedBinder` object types. */
export type AccountPassedBinderAggregatesFilter = {
  /** Mean average aggregate over matching `AccountPassedBinder` objects. */
  average?: InputMaybe<AccountPassedBinderAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountPassedBinder` objects. */
  distinctCount?: InputMaybe<AccountPassedBinderDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountPassedBinder` object to be included within the aggregate. */
  filter?: InputMaybe<AccountPassedBinderFilter>;
  /** Maximum aggregate over matching `AccountPassedBinder` objects. */
  max?: InputMaybe<AccountPassedBinderMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountPassedBinder` objects. */
  min?: InputMaybe<AccountPassedBinderMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountPassedBinder` objects. */
  stddevPopulation?: InputMaybe<AccountPassedBinderStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountPassedBinder` objects. */
  stddevSample?: InputMaybe<AccountPassedBinderStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountPassedBinder` objects. */
  sum?: InputMaybe<AccountPassedBinderSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountPassedBinder` objects. */
  variancePopulation?: InputMaybe<AccountPassedBinderVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountPassedBinder` objects. */
  varianceSample?: InputMaybe<AccountPassedBinderVarianceSampleAggregateFilter>;
};

export type AccountPassedBinderAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountPassedBinderAverageAggregates = {
  __typename?: 'AccountPassedBinderAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountPassedBinder` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountPassedBinderCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountPassedBinder` values. */
export type AccountPassedBinderConnection = {
  __typename?: 'AccountPassedBinderConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountPassedBinderAggregates>;
  /** A list of edges which contains the `AccountPassedBinder` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountPassedBinderEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountPassedBinderAggregates>>;
  /** A list of `AccountPassedBinder` objects. */
  nodes: Array<Maybe<AccountPassedBinder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountPassedBinder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountPassedBinder` values. */
export type AccountPassedBinderConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountPassedBinderGroupBy>;
  having?: InputMaybe<AccountPassedBinderHavingInput>;
};

export type AccountPassedBinderDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountPassedBinderDistinctCountAggregates = {
  __typename?: 'AccountPassedBinderDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of activationInvoiceReference across the matching connection */
  activationInvoiceReference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of activationInvoiceSentDate across the matching connection */
  activationInvoiceSentDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of activationStatus across the matching connection */
  activationStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of contractReference across the matching connection */
  contractReference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of contractSentDate across the matching connection */
  contractSentDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of contractStatus across the matching connection */
  contractStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of inQueue across the matching connection */
  inQueue?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of kycComplete across the matching connection */
  kycComplete?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadata across the matching connection */
  metadata?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of skipActivationFee across the matching connection */
  skipActivationFee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stage across the matching connection */
  stage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountPassedBinder` edge in the connection. */
export type AccountPassedBinderEdge = {
  __typename?: 'AccountPassedBinderEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountPassedBinder` at the end of the edge. */
  node?: Maybe<AccountPassedBinder>;
};

/** A filter to be used against `AccountPassedBinder` object types. All fields are combined with a logical ‘and.’ */
export type AccountPassedBinderFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountPassedBinderFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AccountPassedBinderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountPassedBinderFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountPassedBinder` for usage during aggregation. */
export enum AccountPassedBinderGroupBy {
  AccountId = 'ACCOUNT_ID',
  UserId = 'USER_ID'
}

export type AccountPassedBinderHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountPassedBinder` aggregates. */
export type AccountPassedBinderHavingInput = {
  AND?: InputMaybe<Array<AccountPassedBinderHavingInput>>;
  OR?: InputMaybe<Array<AccountPassedBinderHavingInput>>;
  average?: InputMaybe<AccountPassedBinderHavingAverageInput>;
  distinctCount?: InputMaybe<AccountPassedBinderHavingDistinctCountInput>;
  max?: InputMaybe<AccountPassedBinderHavingMaxInput>;
  min?: InputMaybe<AccountPassedBinderHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountPassedBinderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountPassedBinderHavingStddevSampleInput>;
  sum?: InputMaybe<AccountPassedBinderHavingSumInput>;
  variancePopulation?: InputMaybe<AccountPassedBinderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountPassedBinderHavingVarianceSampleInput>;
};

export type AccountPassedBinderHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activationInvoiceSentDate?: InputMaybe<HavingDatetimeFilter>;
  contractSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  xfaAccountId?: InputMaybe<HavingIntFilter>;
};

export type AccountPassedBinderMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountPassedBinderMaxAggregates = {
  __typename?: 'AccountPassedBinderMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['Int']['output']>;
};

export type AccountPassedBinderMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountPassedBinderMinAggregates = {
  __typename?: 'AccountPassedBinderMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountPassedBinder`. */
export enum AccountPassedBinderOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type AccountPassedBinderStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountPassedBinderStddevPopulationAggregates = {
  __typename?: 'AccountPassedBinderStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountPassedBinderStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountPassedBinderStddevSampleAggregates = {
  __typename?: 'AccountPassedBinderStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountPassedBinderSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountPassedBinderSumAggregates = {
  __typename?: 'AccountPassedBinderSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
  /** Sum of xfaAccountId across the matching connection */
  xfaAccountId: Scalars['BigInt']['output'];
};

export type AccountPassedBinderVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountPassedBinderVariancePopulationAggregates = {
  __typename?: 'AccountPassedBinderVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountPassedBinderVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountPassedBinderVarianceSampleAggregates = {
  __typename?: 'AccountPassedBinderVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of xfaAccountId across the matching connection */
  xfaAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountPlatformDatum = Node & {
  __typename?: 'AccountPlatformDatum';
  /** Reads a single `Account` that is related to this `AccountPlatformDatum`. */
  account?: Maybe<Account>;
  accountId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** A filter to be used against `AccountPlatformDatum` object types. All fields are combined with a logical ‘and.’ */
export type AccountPlatformDatumFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountPlatformDatumFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AccountPlatformDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountPlatformDatumFilter>>;
};

export type AccountResetLimit = Node & {
  __typename?: 'AccountResetLimit';
  createdAt: Scalars['Datetime']['output'];
  dateStr: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastResetDate?: Maybe<Scalars['Datetime']['output']>;
  resetCount: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  subscriptionId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `AccountResetLimit`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type AccountResetLimitAggregates = {
  __typename?: 'AccountResetLimitAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountResetLimitAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountResetLimitDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountResetLimitMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountResetLimitMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountResetLimitStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountResetLimitStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountResetLimitSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountResetLimitVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountResetLimitVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountResetLimit` object types. */
export type AccountResetLimitAggregatesFilter = {
  /** Mean average aggregate over matching `AccountResetLimit` objects. */
  average?: InputMaybe<AccountResetLimitAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountResetLimit` objects. */
  distinctCount?: InputMaybe<AccountResetLimitDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountResetLimit` object to be included within the aggregate. */
  filter?: InputMaybe<AccountResetLimitFilter>;
  /** Maximum aggregate over matching `AccountResetLimit` objects. */
  max?: InputMaybe<AccountResetLimitMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountResetLimit` objects. */
  min?: InputMaybe<AccountResetLimitMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountResetLimit` objects. */
  stddevPopulation?: InputMaybe<AccountResetLimitStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountResetLimit` objects. */
  stddevSample?: InputMaybe<AccountResetLimitStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountResetLimit` objects. */
  sum?: InputMaybe<AccountResetLimitSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountResetLimit` objects. */
  variancePopulation?: InputMaybe<AccountResetLimitVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountResetLimit` objects. */
  varianceSample?: InputMaybe<AccountResetLimitVarianceSampleAggregateFilter>;
};

export type AccountResetLimitAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetLimitAverageAggregates = {
  __typename?: 'AccountResetLimitAverageAggregates';
  /** Mean average of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountResetLimit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountResetLimitCondition = {
  /** Checks for equality with the object’s `dateStr` field. */
  dateStr?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountResetLimit` values. */
export type AccountResetLimitConnection = {
  __typename?: 'AccountResetLimitConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountResetLimitAggregates>;
  /** A list of edges which contains the `AccountResetLimit` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountResetLimitEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountResetLimitAggregates>>;
  /** A list of `AccountResetLimit` objects. */
  nodes: Array<Maybe<AccountResetLimit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountResetLimit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountResetLimit` values. */
export type AccountResetLimitConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountResetLimitGroupBy>;
  having?: InputMaybe<AccountResetLimitHavingInput>;
};

export type AccountResetLimitDistinctCountAggregateFilter = {
  dateStr?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountResetLimitDistinctCountAggregates = {
  __typename?: 'AccountResetLimitDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dateStr across the matching connection */
  dateStr?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastResetDate across the matching connection */
  lastResetDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountResetLimit` edge in the connection. */
export type AccountResetLimitEdge = {
  __typename?: 'AccountResetLimitEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountResetLimit` at the end of the edge. */
  node?: Maybe<AccountResetLimit>;
};

/** A filter to be used against `AccountResetLimit` object types. All fields are combined with a logical ‘and.’ */
export type AccountResetLimitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountResetLimitFilter>>;
  /** Filter by the object’s `dateStr` field. */
  dateStr?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountResetLimitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountResetLimitFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountResetLimit` for usage during aggregation. */
export enum AccountResetLimitGroupBy {
  DateStr = 'DATE_STR',
  SubscriptionId = 'SUBSCRIPTION_ID',
  UserId = 'USER_ID'
}

export type AccountResetLimitHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountResetLimit` aggregates. */
export type AccountResetLimitHavingInput = {
  AND?: InputMaybe<Array<AccountResetLimitHavingInput>>;
  OR?: InputMaybe<Array<AccountResetLimitHavingInput>>;
  average?: InputMaybe<AccountResetLimitHavingAverageInput>;
  distinctCount?: InputMaybe<AccountResetLimitHavingDistinctCountInput>;
  max?: InputMaybe<AccountResetLimitHavingMaxInput>;
  min?: InputMaybe<AccountResetLimitHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountResetLimitHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountResetLimitHavingStddevSampleInput>;
  sum?: InputMaybe<AccountResetLimitHavingSumInput>;
  variancePopulation?: InputMaybe<AccountResetLimitHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountResetLimitHavingVarianceSampleInput>;
};

export type AccountResetLimitHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastResetDate?: InputMaybe<HavingDatetimeFilter>;
  resetCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetLimitMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountResetLimitMaxAggregates = {
  __typename?: 'AccountResetLimitMaxAggregates';
  /** Maximum of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountResetLimitMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountResetLimitMinAggregates = {
  __typename?: 'AccountResetLimitMinAggregates';
  /** Minimum of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountResetLimit`. */
export enum AccountResetLimitOrderBy {
  DateStrAsc = 'DATE_STR_ASC',
  DateStrDesc = 'DATE_STR_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type AccountResetLimitStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetLimitStddevPopulationAggregates = {
  __typename?: 'AccountResetLimitStddevPopulationAggregates';
  /** Population standard deviation of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetLimitStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetLimitStddevSampleAggregates = {
  __typename?: 'AccountResetLimitStddevSampleAggregates';
  /** Sample standard deviation of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetLimitSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountResetLimitSumAggregates = {
  __typename?: 'AccountResetLimitSumAggregates';
  /** Sum of resetCount across the matching connection */
  resetCount: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type AccountResetLimitVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetLimitVariancePopulationAggregates = {
  __typename?: 'AccountResetLimitVariancePopulationAggregates';
  /** Population variance of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetLimitVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetLimitVarianceSampleAggregates = {
  __typename?: 'AccountResetLimitVarianceSampleAggregates';
  /** Sample variance of resetCount across the matching connection */
  resetCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetTracking = Node & {
  __typename?: 'AccountResetTracking';
  accountType: Scalars['String']['output'];
  branchId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `Account` that is related to this `AccountResetTracking`. */
  parentAccount?: Maybe<Account>;
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Account` that is related to this `AccountResetTracking`. */
  resetAccount?: Maybe<Account>;
  resetAccountId: Scalars['Int']['output'];
  resetNumber: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `NmiSubscription` that is related to this `AccountResetTracking`. */
  subscription?: Maybe<NmiSubscription>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `AccountResetTracking`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type AccountResetTrackingAggregates = {
  __typename?: 'AccountResetTrackingAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountResetTrackingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountResetTrackingDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountResetTrackingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountResetTrackingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountResetTrackingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountResetTrackingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountResetTrackingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountResetTrackingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountResetTrackingVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountResetTracking` object types. */
export type AccountResetTrackingAggregatesFilter = {
  /** Mean average aggregate over matching `AccountResetTracking` objects. */
  average?: InputMaybe<AccountResetTrackingAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountResetTracking` objects. */
  distinctCount?: InputMaybe<AccountResetTrackingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountResetTracking` object to be included within the aggregate. */
  filter?: InputMaybe<AccountResetTrackingFilter>;
  /** Maximum aggregate over matching `AccountResetTracking` objects. */
  max?: InputMaybe<AccountResetTrackingMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountResetTracking` objects. */
  min?: InputMaybe<AccountResetTrackingMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountResetTracking` objects. */
  stddevPopulation?: InputMaybe<AccountResetTrackingStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountResetTracking` objects. */
  stddevSample?: InputMaybe<AccountResetTrackingStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountResetTracking` objects. */
  sum?: InputMaybe<AccountResetTrackingSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountResetTracking` objects. */
  variancePopulation?: InputMaybe<AccountResetTrackingVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountResetTracking` objects. */
  varianceSample?: InputMaybe<AccountResetTrackingVarianceSampleAggregateFilter>;
};

export type AccountResetTrackingAverageAggregateFilter = {
  branchId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetTrackingAverageAggregates = {
  __typename?: 'AccountResetTrackingAverageAggregates';
  /** Mean average of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountResetTracking` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountResetTrackingCondition = {
  /** Checks for equality with the object’s `accountType` field. */
  accountType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `branchId` field. */
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountResetTracking` values. */
export type AccountResetTrackingConnection = {
  __typename?: 'AccountResetTrackingConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountResetTrackingAggregates>;
  /** A list of edges which contains the `AccountResetTracking` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountResetTrackingEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountResetTrackingAggregates>>;
  /** A list of `AccountResetTracking` objects. */
  nodes: Array<Maybe<AccountResetTracking>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountResetTracking` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountResetTracking` values. */
export type AccountResetTrackingConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountResetTrackingGroupBy>;
  having?: InputMaybe<AccountResetTrackingHavingInput>;
};

export type AccountResetTrackingDistinctCountAggregateFilter = {
  accountType?: InputMaybe<BigIntFilter>;
  branchId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountResetTrackingDistinctCountAggregates = {
  __typename?: 'AccountResetTrackingDistinctCountAggregates';
  /** Distinct count of accountType across the matching connection */
  accountType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountResetTracking` edge in the connection. */
export type AccountResetTrackingEdge = {
  __typename?: 'AccountResetTrackingEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountResetTracking` at the end of the edge. */
  node?: Maybe<AccountResetTracking>;
};

/** A filter to be used against `AccountResetTracking` object types. All fields are combined with a logical ‘and.’ */
export type AccountResetTrackingFilter = {
  /** Filter by the object’s `accountType` field. */
  accountType?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountResetTrackingFilter>>;
  /** Filter by the object’s `branchId` field. */
  branchId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountResetTrackingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountResetTrackingFilter>>;
  /** Filter by the object’s `parentAccount` relation. */
  parentAccount?: InputMaybe<AccountFilter>;
  /** A related `parentAccount` exists. */
  parentAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `resetAccount` relation. */
  resetAccount?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscription` relation. */
  subscription?: InputMaybe<NmiSubscriptionFilter>;
  /** A related `subscription` exists. */
  subscriptionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountResetTracking` for usage during aggregation. */
export enum AccountResetTrackingGroupBy {
  AccountType = 'ACCOUNT_TYPE',
  BranchId = 'BRANCH_ID',
  SubscriptionId = 'SUBSCRIPTION_ID',
  UserId = 'USER_ID'
}

export type AccountResetTrackingHavingAverageInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingDistinctCountInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountResetTracking` aggregates. */
export type AccountResetTrackingHavingInput = {
  AND?: InputMaybe<Array<AccountResetTrackingHavingInput>>;
  OR?: InputMaybe<Array<AccountResetTrackingHavingInput>>;
  average?: InputMaybe<AccountResetTrackingHavingAverageInput>;
  distinctCount?: InputMaybe<AccountResetTrackingHavingDistinctCountInput>;
  max?: InputMaybe<AccountResetTrackingHavingMaxInput>;
  min?: InputMaybe<AccountResetTrackingHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountResetTrackingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountResetTrackingHavingStddevSampleInput>;
  sum?: InputMaybe<AccountResetTrackingHavingSumInput>;
  variancePopulation?: InputMaybe<AccountResetTrackingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountResetTrackingHavingVarianceSampleInput>;
};

export type AccountResetTrackingHavingMaxInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingMinInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingStddevPopulationInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingStddevSampleInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingSumInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingVariancePopulationInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingHavingVarianceSampleInput = {
  branchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  resetNumber?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AccountResetTrackingMaxAggregateFilter = {
  branchId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountResetTrackingMaxAggregates = {
  __typename?: 'AccountResetTrackingMaxAggregates';
  /** Maximum of branchId across the matching connection */
  branchId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountResetTrackingMinAggregateFilter = {
  branchId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountResetTrackingMinAggregates = {
  __typename?: 'AccountResetTrackingMinAggregates';
  /** Minimum of branchId across the matching connection */
  branchId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountResetTracking`. */
export enum AccountResetTrackingOrderBy {
  AccountTypeAsc = 'ACCOUNT_TYPE_ASC',
  AccountTypeDesc = 'ACCOUNT_TYPE_DESC',
  BranchIdAsc = 'BRANCH_ID_ASC',
  BranchIdDesc = 'BRANCH_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type AccountResetTrackingStddevPopulationAggregateFilter = {
  branchId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetTrackingStddevPopulationAggregates = {
  __typename?: 'AccountResetTrackingStddevPopulationAggregates';
  /** Population standard deviation of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetTrackingStddevSampleAggregateFilter = {
  branchId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetTrackingStddevSampleAggregates = {
  __typename?: 'AccountResetTrackingStddevSampleAggregates';
  /** Sample standard deviation of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetTrackingSumAggregateFilter = {
  branchId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountResetTrackingSumAggregates = {
  __typename?: 'AccountResetTrackingSumAggregates';
  /** Sum of branchId across the matching connection */
  branchId: Scalars['BigInt']['output'];
  /** Sum of parentAccountId across the matching connection */
  parentAccountId: Scalars['BigInt']['output'];
  /** Sum of resetAccountId across the matching connection */
  resetAccountId: Scalars['BigInt']['output'];
  /** Sum of resetNumber across the matching connection */
  resetNumber: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type AccountResetTrackingVariancePopulationAggregateFilter = {
  branchId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetTrackingVariancePopulationAggregates = {
  __typename?: 'AccountResetTrackingVariancePopulationAggregates';
  /** Population variance of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountResetTrackingVarianceSampleAggregateFilter = {
  branchId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountResetTrackingVarianceSampleAggregates = {
  __typename?: 'AccountResetTrackingVarianceSampleAggregates';
  /** Sample variance of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of resetNumber across the matching connection */
  resetNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStat = Node & {
  __typename?: 'AccountStat';
  /** Reads a single `Account` that is related to this `AccountStat`. */
  account?: Maybe<Account>;
  accountId: Scalars['Int']['output'];
  balance?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  ineligible?: Maybe<Scalars['Boolean']['output']>;
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  mll?: Maybe<Scalars['BigFloat']['output']>;
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  topstepxUpdatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type AccountStatAggregates = {
  __typename?: 'AccountStatAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountStatAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountStatDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountStatMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountStatMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountStatStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountStatStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountStatSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountStatVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountStatVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountStat` object types. */
export type AccountStatAggregatesFilter = {
  /** Mean average aggregate over matching `AccountStat` objects. */
  average?: InputMaybe<AccountStatAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountStat` objects. */
  distinctCount?: InputMaybe<AccountStatDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountStat` object to be included within the aggregate. */
  filter?: InputMaybe<AccountStatFilter>;
  /** Maximum aggregate over matching `AccountStat` objects. */
  max?: InputMaybe<AccountStatMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountStat` objects. */
  min?: InputMaybe<AccountStatMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountStat` objects. */
  stddevPopulation?: InputMaybe<AccountStatStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountStat` objects. */
  stddevSample?: InputMaybe<AccountStatStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountStat` objects. */
  sum?: InputMaybe<AccountStatSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountStat` objects. */
  variancePopulation?: InputMaybe<AccountStatVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountStat` objects. */
  varianceSample?: InputMaybe<AccountStatVarianceSampleAggregateFilter>;
};

export type AccountStatAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountStatAverageAggregates = {
  __typename?: 'AccountStatAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of status across the matching connection */
  status?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountStat` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AccountStatCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountStat` values. */
export type AccountStatConnection = {
  __typename?: 'AccountStatConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountStatAggregates>;
  /** A list of edges which contains the `AccountStat` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountStatEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountStatAggregates>>;
  /** A list of `AccountStat` objects. */
  nodes: Array<Maybe<AccountStat>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStat` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountStat` values. */
export type AccountStatConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountStatGroupBy>;
  having?: InputMaybe<AccountStatHavingInput>;
};

export type AccountStatDay = Node & {
  __typename?: 'AccountStatDay';
  accountId: Scalars['Int']['output'];
  balance?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  rowId: Scalars['Int']['output'];
  totalContractsTraded?: Maybe<Scalars['Int']['output']>;
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  totalTrades?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type AccountStatDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AccountStatDistinctCountAggregates = {
  __typename?: 'AccountStatDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of balance across the matching connection */
  balance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ineligible across the matching connection */
  ineligible?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of mll across the matching connection */
  mll?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of topstepxUpdatedAt across the matching connection */
  topstepxUpdatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountStat` edge in the connection. */
export type AccountStatEdge = {
  __typename?: 'AccountStatEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountStat` at the end of the edge. */
  node?: Maybe<AccountStat>;
};

/** A filter to be used against `AccountStat` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountStat` for usage during aggregation. */
export enum AccountStatGroupBy {
  AccountId = 'ACCOUNT_ID'
}

export type AccountStatHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AccountStat` aggregates. */
export type AccountStatHavingInput = {
  AND?: InputMaybe<Array<AccountStatHavingInput>>;
  OR?: InputMaybe<Array<AccountStatHavingInput>>;
  average?: InputMaybe<AccountStatHavingAverageInput>;
  distinctCount?: InputMaybe<AccountStatHavingDistinctCountInput>;
  max?: InputMaybe<AccountStatHavingMaxInput>;
  min?: InputMaybe<AccountStatHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountStatHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountStatHavingStddevSampleInput>;
  sum?: InputMaybe<AccountStatHavingSumInput>;
  variancePopulation?: InputMaybe<AccountStatHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountStatHavingVarianceSampleInput>;
};

export type AccountStatHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  balance?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  minPayoutBalance?: InputMaybe<HavingBigfloatFilter>;
  mll?: InputMaybe<HavingBigfloatFilter>;
  realizedDayPnl?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  status?: InputMaybe<HavingIntFilter>;
  topstepxUpdatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountStatMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type AccountStatMaxAggregates = {
  __typename?: 'AccountStatMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of status across the matching connection */
  status?: Maybe<Scalars['Int']['output']>;
};

export type AccountStatMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type AccountStatMinAggregates = {
  __typename?: 'AccountStatMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of status across the matching connection */
  status?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountStat`. */
export enum AccountStatOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

/** Represents an update to a `AccountStat`. Fields that are set will be updated. */
export type AccountStatPatch = {
  minPayoutBalance?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type AccountStatStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountStatStddevPopulationAggregates = {
  __typename?: 'AccountStatStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of status across the matching connection */
  status?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStatStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountStatStddevSampleAggregates = {
  __typename?: 'AccountStatStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of status across the matching connection */
  status?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStatSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AccountStatSumAggregates = {
  __typename?: 'AccountStatSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of balance across the matching connection */
  balance: Scalars['BigFloat']['output'];
  /** Sum of minPayoutBalance across the matching connection */
  minPayoutBalance: Scalars['BigFloat']['output'];
  /** Sum of mll across the matching connection */
  mll: Scalars['BigFloat']['output'];
  /** Sum of realizedDayPnl across the matching connection */
  realizedDayPnl: Scalars['BigFloat']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of status across the matching connection */
  status: Scalars['BigInt']['output'];
};

export type AccountStatVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountStatVariancePopulationAggregates = {
  __typename?: 'AccountStatVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of status across the matching connection */
  status?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStatVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type AccountStatVarianceSampleAggregates = {
  __typename?: 'AccountStatVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minPayoutBalance across the matching connection */
  minPayoutBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of mll across the matching connection */
  mll?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of realizedDayPnl across the matching connection */
  realizedDayPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of status across the matching connection */
  status?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStddevPopulationAggregateFilter = {
  accountTemplate?: InputMaybe<BigFloatFilter>;
  nmiSubscriptionId?: InputMaybe<BigFloatFilter>;
  platformId?: InputMaybe<BigFloatFilter>;
  projectXAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountStddevPopulationAggregates = {
  __typename?: 'AccountStddevPopulationAggregates';
  /** Population standard deviation of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStddevSampleAggregateFilter = {
  accountTemplate?: InputMaybe<BigFloatFilter>;
  nmiSubscriptionId?: InputMaybe<BigFloatFilter>;
  platformId?: InputMaybe<BigFloatFilter>;
  projectXAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountStddevSampleAggregates = {
  __typename?: 'AccountStddevSampleAggregates';
  /** Sample standard deviation of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountSumAggregateFilter = {
  accountTemplate?: InputMaybe<BigIntFilter>;
  nmiSubscriptionId?: InputMaybe<BigIntFilter>;
  platformId?: InputMaybe<BigIntFilter>;
  projectXAccountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AccountSumAggregates = {
  __typename?: 'AccountSumAggregates';
  /** Sum of accountTemplate across the matching connection */
  accountTemplate: Scalars['BigInt']['output'];
  /** Sum of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId: Scalars['BigInt']['output'];
  /** Sum of platformId across the matching connection */
  platformId: Scalars['BigInt']['output'];
  /** Sum of productCategoryId across the matching connection */
  productCategoryId: Scalars['BigInt']['output'];
  /** Sum of projectXAccountId across the matching connection */
  projectXAccountId: Scalars['BigInt']['output'];
  /** Sum of projectXAccountStatus across the matching connection */
  projectXAccountStatus: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of skuId across the matching connection */
  skuId: Scalars['BigInt']['output'];
  /** Sum of startingBalance across the matching connection */
  startingBalance: Scalars['BigFloat']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type AccountTemplate = Node & {
  __typename?: 'AccountTemplate';
  accountName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Account`. */
  accounts: AccountConnection;
  active?: Maybe<Scalars['Boolean']['output']>;
  avaTaxTaxCode?: Maybe<Scalars['String']['output']>;
  consistencyRule?: Maybe<Scalars['Boolean']['output']>;
  consistencyTargetPercent?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  dailyDrawdown?: Maybe<Scalars['Int']['output']>;
  dailyDrawdownType?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  maxDays?: Maybe<Scalars['Int']['output']>;
  maxDrawdown?: Maybe<Scalars['Int']['output']>;
  maxDrawdownType?: Maybe<Scalars['String']['output']>;
  maxPositionSize?: Maybe<Scalars['Int']['output']>;
  minDays?: Maybe<Scalars['Int']['output']>;
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['BigFloat']['output']>;
  profitTarget?: Maybe<Scalars['Int']['output']>;
  projectXCombineTemplateId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `ResetCredit`. */
  resetCredits: ResetCreditConnection;
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  rowId: Scalars['Int']['output'];
  startingBalance: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type AccountTemplateAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
};


export type AccountTemplateResetCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ResetCreditCondition>;
  filter?: InputMaybe<ResetCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ResetCreditOrderBy>>;
};

export type AccountTemplateAggregates = {
  __typename?: 'AccountTemplateAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountTemplateAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountTemplateDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountTemplateMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountTemplateMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountTemplateStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountTemplateStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountTemplateSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountTemplateVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountTemplateVarianceSampleAggregates>;
};

export type AccountTemplateAverageAggregates = {
  __typename?: 'AccountTemplateAverageAggregates';
  /** Mean average of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minDays across the matching connection */
  minDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountTemplateCondition = {
  /** Checks for equality with the object’s `accountName` field. */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AccountTemplate` values. */
export type AccountTemplateConnection = {
  __typename?: 'AccountTemplateConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountTemplateAggregates>;
  /** A list of edges which contains the `AccountTemplate` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountTemplateEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountTemplateAggregates>>;
  /** A list of `AccountTemplate` objects. */
  nodes: Array<Maybe<AccountTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountTemplate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountTemplate` values. */
export type AccountTemplateConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountTemplateGroupBy>;
  having?: InputMaybe<AccountTemplateHavingInput>;
};

export type AccountTemplateDistinctCountAggregates = {
  __typename?: 'AccountTemplateDistinctCountAggregates';
  /** Distinct count of accountName across the matching connection */
  accountName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avaTaxTaxCode across the matching connection */
  avaTaxTaxCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of consistencyRule across the matching connection */
  consistencyRule?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dailyDrawdownType across the matching connection */
  dailyDrawdownType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxDrawdownType across the matching connection */
  maxDrawdownType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minDays across the matching connection */
  minDays?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountTemplate` edge in the connection. */
export type AccountTemplateEdge = {
  __typename?: 'AccountTemplateEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountTemplate` at the end of the edge. */
  node?: Maybe<AccountTemplate>;
};

/** A filter to be used against `AccountTemplate` object types. All fields are combined with a logical ‘and.’ */
export type AccountTemplateFilter = {
  /** Filter by the object’s `accountName` field. */
  accountName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accounts` relation. */
  accounts?: InputMaybe<AccountTemplateToManyAccountFilter>;
  /** Some related `accounts` exist. */
  accountsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountTemplateFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AccountTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountTemplateFilter>>;
  /** Filter by the object’s `resetCredits` relation. */
  resetCredits?: InputMaybe<AccountTemplateToManyResetCreditFilter>;
  /** Some related `resetCredits` exist. */
  resetCreditsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AccountTemplate` for usage during aggregation. */
export enum AccountTemplateGroupBy {
  AccountName = 'ACCOUNT_NAME',
  Active = 'ACTIVE'
}

export type AccountTemplateHavingAverageInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingDistinctCountInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AccountTemplate` aggregates. */
export type AccountTemplateHavingInput = {
  AND?: InputMaybe<Array<AccountTemplateHavingInput>>;
  OR?: InputMaybe<Array<AccountTemplateHavingInput>>;
  average?: InputMaybe<AccountTemplateHavingAverageInput>;
  distinctCount?: InputMaybe<AccountTemplateHavingDistinctCountInput>;
  max?: InputMaybe<AccountTemplateHavingMaxInput>;
  min?: InputMaybe<AccountTemplateHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountTemplateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountTemplateHavingStddevSampleInput>;
  sum?: InputMaybe<AccountTemplateHavingSumInput>;
  variancePopulation?: InputMaybe<AccountTemplateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountTemplateHavingVarianceSampleInput>;
};

export type AccountTemplateHavingMaxInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingMinInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingStddevPopulationInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingStddevSampleInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingSumInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingVariancePopulationInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateHavingVarianceSampleInput = {
  consistencyTargetPercent?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dailyDrawdown?: InputMaybe<HavingIntFilter>;
  maxDays?: InputMaybe<HavingIntFilter>;
  maxDrawdown?: InputMaybe<HavingIntFilter>;
  maxPositionSize?: InputMaybe<HavingIntFilter>;
  minDays?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  profitTarget?: InputMaybe<HavingIntFilter>;
  projectXCombineTemplateId?: InputMaybe<HavingIntFilter>;
  resetPrice?: InputMaybe<HavingBigfloatFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  startingBalance?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AccountTemplateMaxAggregates = {
  __typename?: 'AccountTemplateMaxAggregates';
  /** Maximum of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['Int']['output']>;
  /** Maximum of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minDays across the matching connection */
  minDays?: Maybe<Scalars['Int']['output']>;
  /** Maximum of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['Int']['output']>;
  /** Maximum of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['Int']['output']>;
};

export type AccountTemplateMinAggregates = {
  __typename?: 'AccountTemplateMinAggregates';
  /** Minimum of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['Int']['output']>;
  /** Minimum of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minDays across the matching connection */
  minDays?: Maybe<Scalars['Int']['output']>;
  /** Minimum of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['Int']['output']>;
  /** Minimum of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AccountTemplate`. */
export enum AccountTemplateOrderBy {
  AccountsAverageAccountTemplateAsc = 'ACCOUNTS_AVERAGE_ACCOUNT_TEMPLATE_ASC',
  AccountsAverageAccountTemplateDesc = 'ACCOUNTS_AVERAGE_ACCOUNT_TEMPLATE_DESC',
  AccountsAverageNmiSubscriptionIdAsc = 'ACCOUNTS_AVERAGE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsAverageNmiSubscriptionIdDesc = 'ACCOUNTS_AVERAGE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsAveragePlatformIdAsc = 'ACCOUNTS_AVERAGE_PLATFORM_ID_ASC',
  AccountsAveragePlatformIdDesc = 'ACCOUNTS_AVERAGE_PLATFORM_ID_DESC',
  AccountsAverageProjectXaccountIdAsc = 'ACCOUNTS_AVERAGE_PROJECT_XACCOUNT_ID_ASC',
  AccountsAverageProjectXaccountIdDesc = 'ACCOUNTS_AVERAGE_PROJECT_XACCOUNT_ID_DESC',
  AccountsAverageRowIdAsc = 'ACCOUNTS_AVERAGE_ROW_ID_ASC',
  AccountsAverageRowIdDesc = 'ACCOUNTS_AVERAGE_ROW_ID_DESC',
  AccountsAverageSkuIdAsc = 'ACCOUNTS_AVERAGE_SKU_ID_ASC',
  AccountsAverageSkuIdDesc = 'ACCOUNTS_AVERAGE_SKU_ID_DESC',
  AccountsAverageSubscriptionIdAsc = 'ACCOUNTS_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountsAverageSubscriptionIdDesc = 'ACCOUNTS_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountsAverageUserIdAsc = 'ACCOUNTS_AVERAGE_USER_ID_ASC',
  AccountsAverageUserIdDesc = 'ACCOUNTS_AVERAGE_USER_ID_DESC',
  AccountsCountAsc = 'ACCOUNTS_COUNT_ASC',
  AccountsCountDesc = 'ACCOUNTS_COUNT_DESC',
  AccountsDistinctCountAccountNameAsc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_NAME_ASC',
  AccountsDistinctCountAccountNameDesc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_NAME_DESC',
  AccountsDistinctCountAccountTemplateAsc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ASC',
  AccountsDistinctCountAccountTemplateDesc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_DESC',
  AccountsDistinctCountActiveAsc = 'ACCOUNTS_DISTINCT_COUNT_ACTIVE_ASC',
  AccountsDistinctCountActiveDesc = 'ACCOUNTS_DISTINCT_COUNT_ACTIVE_DESC',
  AccountsDistinctCountComplimentaryAsc = 'ACCOUNTS_DISTINCT_COUNT_COMPLIMENTARY_ASC',
  AccountsDistinctCountComplimentaryDesc = 'ACCOUNTS_DISTINCT_COUNT_COMPLIMENTARY_DESC',
  AccountsDistinctCountCreatedAtAsc = 'ACCOUNTS_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountsDistinctCountCreatedAtDesc = 'ACCOUNTS_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountsDistinctCountNmiSubscriptionIdAsc = 'ACCOUNTS_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_ASC',
  AccountsDistinctCountNmiSubscriptionIdDesc = 'ACCOUNTS_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_DESC',
  AccountsDistinctCountPlatformIdAsc = 'ACCOUNTS_DISTINCT_COUNT_PLATFORM_ID_ASC',
  AccountsDistinctCountPlatformIdDesc = 'ACCOUNTS_DISTINCT_COUNT_PLATFORM_ID_DESC',
  AccountsDistinctCountProjectXaccountIdAsc = 'ACCOUNTS_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_ASC',
  AccountsDistinctCountProjectXaccountIdDesc = 'ACCOUNTS_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_DESC',
  AccountsDistinctCountRowIdAsc = 'ACCOUNTS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountsDistinctCountRowIdDesc = 'ACCOUNTS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountsDistinctCountSkuIdAsc = 'ACCOUNTS_DISTINCT_COUNT_SKU_ID_ASC',
  AccountsDistinctCountSkuIdDesc = 'ACCOUNTS_DISTINCT_COUNT_SKU_ID_DESC',
  AccountsDistinctCountStageAsc = 'ACCOUNTS_DISTINCT_COUNT_STAGE_ASC',
  AccountsDistinctCountStageDesc = 'ACCOUNTS_DISTINCT_COUNT_STAGE_DESC',
  AccountsDistinctCountStartDateAsc = 'ACCOUNTS_DISTINCT_COUNT_START_DATE_ASC',
  AccountsDistinctCountStartDateDesc = 'ACCOUNTS_DISTINCT_COUNT_START_DATE_DESC',
  AccountsDistinctCountStatusAsc = 'ACCOUNTS_DISTINCT_COUNT_STATUS_ASC',
  AccountsDistinctCountStatusDesc = 'ACCOUNTS_DISTINCT_COUNT_STATUS_DESC',
  AccountsDistinctCountSubscriptionIdAsc = 'ACCOUNTS_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountsDistinctCountSubscriptionIdDesc = 'ACCOUNTS_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountsDistinctCountUserIdAsc = 'ACCOUNTS_DISTINCT_COUNT_USER_ID_ASC',
  AccountsDistinctCountUserIdDesc = 'ACCOUNTS_DISTINCT_COUNT_USER_ID_DESC',
  AccountsMaxAccountTemplateAsc = 'ACCOUNTS_MAX_ACCOUNT_TEMPLATE_ASC',
  AccountsMaxAccountTemplateDesc = 'ACCOUNTS_MAX_ACCOUNT_TEMPLATE_DESC',
  AccountsMaxNmiSubscriptionIdAsc = 'ACCOUNTS_MAX_NMI_SUBSCRIPTION_ID_ASC',
  AccountsMaxNmiSubscriptionIdDesc = 'ACCOUNTS_MAX_NMI_SUBSCRIPTION_ID_DESC',
  AccountsMaxPlatformIdAsc = 'ACCOUNTS_MAX_PLATFORM_ID_ASC',
  AccountsMaxPlatformIdDesc = 'ACCOUNTS_MAX_PLATFORM_ID_DESC',
  AccountsMaxProjectXaccountIdAsc = 'ACCOUNTS_MAX_PROJECT_XACCOUNT_ID_ASC',
  AccountsMaxProjectXaccountIdDesc = 'ACCOUNTS_MAX_PROJECT_XACCOUNT_ID_DESC',
  AccountsMaxRowIdAsc = 'ACCOUNTS_MAX_ROW_ID_ASC',
  AccountsMaxRowIdDesc = 'ACCOUNTS_MAX_ROW_ID_DESC',
  AccountsMaxSkuIdAsc = 'ACCOUNTS_MAX_SKU_ID_ASC',
  AccountsMaxSkuIdDesc = 'ACCOUNTS_MAX_SKU_ID_DESC',
  AccountsMaxSubscriptionIdAsc = 'ACCOUNTS_MAX_SUBSCRIPTION_ID_ASC',
  AccountsMaxSubscriptionIdDesc = 'ACCOUNTS_MAX_SUBSCRIPTION_ID_DESC',
  AccountsMaxUserIdAsc = 'ACCOUNTS_MAX_USER_ID_ASC',
  AccountsMaxUserIdDesc = 'ACCOUNTS_MAX_USER_ID_DESC',
  AccountsMinAccountTemplateAsc = 'ACCOUNTS_MIN_ACCOUNT_TEMPLATE_ASC',
  AccountsMinAccountTemplateDesc = 'ACCOUNTS_MIN_ACCOUNT_TEMPLATE_DESC',
  AccountsMinNmiSubscriptionIdAsc = 'ACCOUNTS_MIN_NMI_SUBSCRIPTION_ID_ASC',
  AccountsMinNmiSubscriptionIdDesc = 'ACCOUNTS_MIN_NMI_SUBSCRIPTION_ID_DESC',
  AccountsMinPlatformIdAsc = 'ACCOUNTS_MIN_PLATFORM_ID_ASC',
  AccountsMinPlatformIdDesc = 'ACCOUNTS_MIN_PLATFORM_ID_DESC',
  AccountsMinProjectXaccountIdAsc = 'ACCOUNTS_MIN_PROJECT_XACCOUNT_ID_ASC',
  AccountsMinProjectXaccountIdDesc = 'ACCOUNTS_MIN_PROJECT_XACCOUNT_ID_DESC',
  AccountsMinRowIdAsc = 'ACCOUNTS_MIN_ROW_ID_ASC',
  AccountsMinRowIdDesc = 'ACCOUNTS_MIN_ROW_ID_DESC',
  AccountsMinSkuIdAsc = 'ACCOUNTS_MIN_SKU_ID_ASC',
  AccountsMinSkuIdDesc = 'ACCOUNTS_MIN_SKU_ID_DESC',
  AccountsMinSubscriptionIdAsc = 'ACCOUNTS_MIN_SUBSCRIPTION_ID_ASC',
  AccountsMinSubscriptionIdDesc = 'ACCOUNTS_MIN_SUBSCRIPTION_ID_DESC',
  AccountsMinUserIdAsc = 'ACCOUNTS_MIN_USER_ID_ASC',
  AccountsMinUserIdDesc = 'ACCOUNTS_MIN_USER_ID_DESC',
  AccountsStddevPopulationAccountTemplateAsc = 'ACCOUNTS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsStddevPopulationAccountTemplateDesc = 'ACCOUNTS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsStddevPopulationNmiSubscriptionIdAsc = 'ACCOUNTS_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsStddevPopulationNmiSubscriptionIdDesc = 'ACCOUNTS_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsStddevPopulationPlatformIdAsc = 'ACCOUNTS_STDDEV_POPULATION_PLATFORM_ID_ASC',
  AccountsStddevPopulationPlatformIdDesc = 'ACCOUNTS_STDDEV_POPULATION_PLATFORM_ID_DESC',
  AccountsStddevPopulationProjectXaccountIdAsc = 'ACCOUNTS_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsStddevPopulationProjectXaccountIdDesc = 'ACCOUNTS_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsStddevPopulationRowIdAsc = 'ACCOUNTS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountsStddevPopulationRowIdDesc = 'ACCOUNTS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountsStddevPopulationSkuIdAsc = 'ACCOUNTS_STDDEV_POPULATION_SKU_ID_ASC',
  AccountsStddevPopulationSkuIdDesc = 'ACCOUNTS_STDDEV_POPULATION_SKU_ID_DESC',
  AccountsStddevPopulationSubscriptionIdAsc = 'ACCOUNTS_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsStddevPopulationSubscriptionIdDesc = 'ACCOUNTS_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsStddevPopulationUserIdAsc = 'ACCOUNTS_STDDEV_POPULATION_USER_ID_ASC',
  AccountsStddevPopulationUserIdDesc = 'ACCOUNTS_STDDEV_POPULATION_USER_ID_DESC',
  AccountsStddevSampleAccountTemplateAsc = 'ACCOUNTS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsStddevSampleAccountTemplateDesc = 'ACCOUNTS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsStddevSampleNmiSubscriptionIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsStddevSampleNmiSubscriptionIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsStddevSamplePlatformIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_PLATFORM_ID_ASC',
  AccountsStddevSamplePlatformIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_PLATFORM_ID_DESC',
  AccountsStddevSampleProjectXaccountIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsStddevSampleProjectXaccountIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsStddevSampleRowIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountsStddevSampleRowIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountsStddevSampleSkuIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_SKU_ID_ASC',
  AccountsStddevSampleSkuIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_SKU_ID_DESC',
  AccountsStddevSampleSubscriptionIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsStddevSampleSubscriptionIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsStddevSampleUserIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountsStddevSampleUserIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountsSumAccountTemplateAsc = 'ACCOUNTS_SUM_ACCOUNT_TEMPLATE_ASC',
  AccountsSumAccountTemplateDesc = 'ACCOUNTS_SUM_ACCOUNT_TEMPLATE_DESC',
  AccountsSumNmiSubscriptionIdAsc = 'ACCOUNTS_SUM_NMI_SUBSCRIPTION_ID_ASC',
  AccountsSumNmiSubscriptionIdDesc = 'ACCOUNTS_SUM_NMI_SUBSCRIPTION_ID_DESC',
  AccountsSumPlatformIdAsc = 'ACCOUNTS_SUM_PLATFORM_ID_ASC',
  AccountsSumPlatformIdDesc = 'ACCOUNTS_SUM_PLATFORM_ID_DESC',
  AccountsSumProjectXaccountIdAsc = 'ACCOUNTS_SUM_PROJECT_XACCOUNT_ID_ASC',
  AccountsSumProjectXaccountIdDesc = 'ACCOUNTS_SUM_PROJECT_XACCOUNT_ID_DESC',
  AccountsSumRowIdAsc = 'ACCOUNTS_SUM_ROW_ID_ASC',
  AccountsSumRowIdDesc = 'ACCOUNTS_SUM_ROW_ID_DESC',
  AccountsSumSkuIdAsc = 'ACCOUNTS_SUM_SKU_ID_ASC',
  AccountsSumSkuIdDesc = 'ACCOUNTS_SUM_SKU_ID_DESC',
  AccountsSumSubscriptionIdAsc = 'ACCOUNTS_SUM_SUBSCRIPTION_ID_ASC',
  AccountsSumSubscriptionIdDesc = 'ACCOUNTS_SUM_SUBSCRIPTION_ID_DESC',
  AccountsSumUserIdAsc = 'ACCOUNTS_SUM_USER_ID_ASC',
  AccountsSumUserIdDesc = 'ACCOUNTS_SUM_USER_ID_DESC',
  AccountsVariancePopulationAccountTemplateAsc = 'ACCOUNTS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsVariancePopulationAccountTemplateDesc = 'ACCOUNTS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsVariancePopulationNmiSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsVariancePopulationNmiSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsVariancePopulationPlatformIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_PLATFORM_ID_ASC',
  AccountsVariancePopulationPlatformIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_PLATFORM_ID_DESC',
  AccountsVariancePopulationProjectXaccountIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsVariancePopulationProjectXaccountIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsVariancePopulationRowIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountsVariancePopulationRowIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountsVariancePopulationSkuIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_SKU_ID_ASC',
  AccountsVariancePopulationSkuIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_SKU_ID_DESC',
  AccountsVariancePopulationSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsVariancePopulationSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsVariancePopulationUserIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountsVariancePopulationUserIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountsVarianceSampleAccountTemplateAsc = 'ACCOUNTS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsVarianceSampleAccountTemplateDesc = 'ACCOUNTS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsVarianceSampleNmiSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsVarianceSampleNmiSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsVarianceSamplePlatformIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_PLATFORM_ID_ASC',
  AccountsVarianceSamplePlatformIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_PLATFORM_ID_DESC',
  AccountsVarianceSampleProjectXaccountIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsVarianceSampleProjectXaccountIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsVarianceSampleRowIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountsVarianceSampleRowIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountsVarianceSampleSkuIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_SKU_ID_ASC',
  AccountsVarianceSampleSkuIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_SKU_ID_DESC',
  AccountsVarianceSampleSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsVarianceSampleSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsVarianceSampleUserIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountsVarianceSampleUserIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountNameAsc = 'ACCOUNT_NAME_ASC',
  AccountNameDesc = 'ACCOUNT_NAME_DESC',
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResetCreditsAverageAccountTemplateIdAsc = 'RESET_CREDITS_AVERAGE_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsAverageAccountTemplateIdDesc = 'RESET_CREDITS_AVERAGE_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsAverageRowIdAsc = 'RESET_CREDITS_AVERAGE_ROW_ID_ASC',
  ResetCreditsAverageRowIdDesc = 'RESET_CREDITS_AVERAGE_ROW_ID_DESC',
  ResetCreditsAverageUserIdAsc = 'RESET_CREDITS_AVERAGE_USER_ID_ASC',
  ResetCreditsAverageUserIdDesc = 'RESET_CREDITS_AVERAGE_USER_ID_DESC',
  ResetCreditsCountAsc = 'RESET_CREDITS_COUNT_ASC',
  ResetCreditsCountDesc = 'RESET_CREDITS_COUNT_DESC',
  ResetCreditsDistinctCountAccountTemplateIdAsc = 'RESET_CREDITS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsDistinctCountAccountTemplateIdDesc = 'RESET_CREDITS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsDistinctCountDeletedAtAsc = 'RESET_CREDITS_DISTINCT_COUNT_DELETED_AT_ASC',
  ResetCreditsDistinctCountDeletedAtDesc = 'RESET_CREDITS_DISTINCT_COUNT_DELETED_AT_DESC',
  ResetCreditsDistinctCountIsComplimentaryAsc = 'RESET_CREDITS_DISTINCT_COUNT_IS_COMPLIMENTARY_ASC',
  ResetCreditsDistinctCountIsComplimentaryDesc = 'RESET_CREDITS_DISTINCT_COUNT_IS_COMPLIMENTARY_DESC',
  ResetCreditsDistinctCountRowIdAsc = 'RESET_CREDITS_DISTINCT_COUNT_ROW_ID_ASC',
  ResetCreditsDistinctCountRowIdDesc = 'RESET_CREDITS_DISTINCT_COUNT_ROW_ID_DESC',
  ResetCreditsDistinctCountStatusAsc = 'RESET_CREDITS_DISTINCT_COUNT_STATUS_ASC',
  ResetCreditsDistinctCountStatusDesc = 'RESET_CREDITS_DISTINCT_COUNT_STATUS_DESC',
  ResetCreditsDistinctCountUserIdAsc = 'RESET_CREDITS_DISTINCT_COUNT_USER_ID_ASC',
  ResetCreditsDistinctCountUserIdDesc = 'RESET_CREDITS_DISTINCT_COUNT_USER_ID_DESC',
  ResetCreditsMaxAccountTemplateIdAsc = 'RESET_CREDITS_MAX_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsMaxAccountTemplateIdDesc = 'RESET_CREDITS_MAX_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsMaxRowIdAsc = 'RESET_CREDITS_MAX_ROW_ID_ASC',
  ResetCreditsMaxRowIdDesc = 'RESET_CREDITS_MAX_ROW_ID_DESC',
  ResetCreditsMaxUserIdAsc = 'RESET_CREDITS_MAX_USER_ID_ASC',
  ResetCreditsMaxUserIdDesc = 'RESET_CREDITS_MAX_USER_ID_DESC',
  ResetCreditsMinAccountTemplateIdAsc = 'RESET_CREDITS_MIN_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsMinAccountTemplateIdDesc = 'RESET_CREDITS_MIN_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsMinRowIdAsc = 'RESET_CREDITS_MIN_ROW_ID_ASC',
  ResetCreditsMinRowIdDesc = 'RESET_CREDITS_MIN_ROW_ID_DESC',
  ResetCreditsMinUserIdAsc = 'RESET_CREDITS_MIN_USER_ID_ASC',
  ResetCreditsMinUserIdDesc = 'RESET_CREDITS_MIN_USER_ID_DESC',
  ResetCreditsStddevPopulationAccountTemplateIdAsc = 'RESET_CREDITS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsStddevPopulationAccountTemplateIdDesc = 'RESET_CREDITS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsStddevPopulationRowIdAsc = 'RESET_CREDITS_STDDEV_POPULATION_ROW_ID_ASC',
  ResetCreditsStddevPopulationRowIdDesc = 'RESET_CREDITS_STDDEV_POPULATION_ROW_ID_DESC',
  ResetCreditsStddevPopulationUserIdAsc = 'RESET_CREDITS_STDDEV_POPULATION_USER_ID_ASC',
  ResetCreditsStddevPopulationUserIdDesc = 'RESET_CREDITS_STDDEV_POPULATION_USER_ID_DESC',
  ResetCreditsStddevSampleAccountTemplateIdAsc = 'RESET_CREDITS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsStddevSampleAccountTemplateIdDesc = 'RESET_CREDITS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsStddevSampleRowIdAsc = 'RESET_CREDITS_STDDEV_SAMPLE_ROW_ID_ASC',
  ResetCreditsStddevSampleRowIdDesc = 'RESET_CREDITS_STDDEV_SAMPLE_ROW_ID_DESC',
  ResetCreditsStddevSampleUserIdAsc = 'RESET_CREDITS_STDDEV_SAMPLE_USER_ID_ASC',
  ResetCreditsStddevSampleUserIdDesc = 'RESET_CREDITS_STDDEV_SAMPLE_USER_ID_DESC',
  ResetCreditsSumAccountTemplateIdAsc = 'RESET_CREDITS_SUM_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsSumAccountTemplateIdDesc = 'RESET_CREDITS_SUM_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsSumRowIdAsc = 'RESET_CREDITS_SUM_ROW_ID_ASC',
  ResetCreditsSumRowIdDesc = 'RESET_CREDITS_SUM_ROW_ID_DESC',
  ResetCreditsSumUserIdAsc = 'RESET_CREDITS_SUM_USER_ID_ASC',
  ResetCreditsSumUserIdDesc = 'RESET_CREDITS_SUM_USER_ID_DESC',
  ResetCreditsVariancePopulationAccountTemplateIdAsc = 'RESET_CREDITS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsVariancePopulationAccountTemplateIdDesc = 'RESET_CREDITS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsVariancePopulationRowIdAsc = 'RESET_CREDITS_VARIANCE_POPULATION_ROW_ID_ASC',
  ResetCreditsVariancePopulationRowIdDesc = 'RESET_CREDITS_VARIANCE_POPULATION_ROW_ID_DESC',
  ResetCreditsVariancePopulationUserIdAsc = 'RESET_CREDITS_VARIANCE_POPULATION_USER_ID_ASC',
  ResetCreditsVariancePopulationUserIdDesc = 'RESET_CREDITS_VARIANCE_POPULATION_USER_ID_DESC',
  ResetCreditsVarianceSampleAccountTemplateIdAsc = 'RESET_CREDITS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsVarianceSampleAccountTemplateIdDesc = 'RESET_CREDITS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsVarianceSampleRowIdAsc = 'RESET_CREDITS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ResetCreditsVarianceSampleRowIdDesc = 'RESET_CREDITS_VARIANCE_SAMPLE_ROW_ID_DESC',
  ResetCreditsVarianceSampleUserIdAsc = 'RESET_CREDITS_VARIANCE_SAMPLE_USER_ID_ASC',
  ResetCreditsVarianceSampleUserIdDesc = 'RESET_CREDITS_VARIANCE_SAMPLE_USER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AccountTemplateStddevPopulationAggregates = {
  __typename?: 'AccountTemplateStddevPopulationAggregates';
  /** Population standard deviation of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minDays across the matching connection */
  minDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountTemplateStddevSampleAggregates = {
  __typename?: 'AccountTemplateStddevSampleAggregates';
  /** Sample standard deviation of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minDays across the matching connection */
  minDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountTemplateSumAggregates = {
  __typename?: 'AccountTemplateSumAggregates';
  /** Sum of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent: Scalars['BigInt']['output'];
  /** Sum of dailyDrawdown across the matching connection */
  dailyDrawdown: Scalars['BigInt']['output'];
  /** Sum of maxDays across the matching connection */
  maxDays: Scalars['BigInt']['output'];
  /** Sum of maxDrawdown across the matching connection */
  maxDrawdown: Scalars['BigInt']['output'];
  /** Sum of maxPositionSize across the matching connection */
  maxPositionSize: Scalars['BigInt']['output'];
  /** Sum of minDays across the matching connection */
  minDays: Scalars['BigInt']['output'];
  /** Sum of netSuiteItemId across the matching connection */
  netSuiteItemId: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['BigFloat']['output'];
  /** Sum of profitTarget across the matching connection */
  profitTarget: Scalars['BigInt']['output'];
  /** Sum of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId: Scalars['BigInt']['output'];
  /** Sum of resetPrice across the matching connection */
  resetPrice: Scalars['BigFloat']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of startingBalance across the matching connection */
  startingBalance: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Account` object types. All fields are combined with a logical ‘and.’ */
export type AccountTemplateToManyAccountFilter = {
  /** Aggregates across related `Account` match the filter criteria. */
  aggregates?: InputMaybe<AccountAggregatesFilter>;
  /** Every related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFilter>;
  /** No related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFilter>;
  /** Some related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFilter>;
};

/** A filter to be used against many `ResetCredit` object types. All fields are combined with a logical ‘and.’ */
export type AccountTemplateToManyResetCreditFilter = {
  /** Aggregates across related `ResetCredit` match the filter criteria. */
  aggregates?: InputMaybe<ResetCreditAggregatesFilter>;
  /** Every related `ResetCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ResetCreditFilter>;
  /** No related `ResetCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ResetCreditFilter>;
  /** Some related `ResetCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ResetCreditFilter>;
};

export type AccountTemplateVariancePopulationAggregates = {
  __typename?: 'AccountTemplateVariancePopulationAggregates';
  /** Population variance of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minDays across the matching connection */
  minDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountTemplateVarianceSampleAggregates = {
  __typename?: 'AccountTemplateVarianceSampleAggregates';
  /** Sample variance of consistencyTargetPercent across the matching connection */
  consistencyTargetPercent?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dailyDrawdown across the matching connection */
  dailyDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxDays across the matching connection */
  maxDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxDrawdown across the matching connection */
  maxDrawdown?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxPositionSize across the matching connection */
  maxPositionSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minDays across the matching connection */
  minDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of profitTarget across the matching connection */
  profitTarget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectXCombineTemplateId across the matching connection */
  projectXCombineTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of resetPrice across the matching connection */
  resetPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against many `AccountCapitalEntry` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyAccountCapitalEntryFilter = {
  /** Aggregates across related `AccountCapitalEntry` match the filter criteria. */
  aggregates?: InputMaybe<AccountCapitalEntryAggregatesFilter>;
  /** Every related `AccountCapitalEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCapitalEntryFilter>;
  /** No related `AccountCapitalEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCapitalEntryFilter>;
  /** Some related `AccountCapitalEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCapitalEntryFilter>;
};

/** A filter to be used against many `AccountPassedBinder` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyAccountPassedBinderFilter = {
  /** Aggregates across related `AccountPassedBinder` match the filter criteria. */
  aggregates?: InputMaybe<AccountPassedBinderAggregatesFilter>;
  /** Every related `AccountPassedBinder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountPassedBinderFilter>;
  /** No related `AccountPassedBinder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountPassedBinderFilter>;
  /** Some related `AccountPassedBinder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountPassedBinderFilter>;
};

/** A filter to be used against many `AccountStat` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyAccountStatFilter = {
  /** Aggregates across related `AccountStat` match the filter criteria. */
  aggregates?: InputMaybe<AccountStatAggregatesFilter>;
  /** Every related `AccountStat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountStatFilter>;
  /** No related `AccountStat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountStatFilter>;
  /** Some related `AccountStat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountStatFilter>;
};

/** A filter to be used against many `ImpactGroupAssignment` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyImpactGroupAssignmentFilter = {
  /** Aggregates across related `ImpactGroupAssignment` match the filter criteria. */
  aggregates?: InputMaybe<ImpactGroupAssignmentAggregatesFilter>;
  /** Every related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** No related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** Some related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ImpactGroupAssignmentFilter>;
};

/** A filter to be used against many `TraderPublicProfile` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyTraderPublicProfileFilter = {
  /** Aggregates across related `TraderPublicProfile` match the filter criteria. */
  aggregates?: InputMaybe<TraderPublicProfileAggregatesFilter>;
  /** Every related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TraderPublicProfileFilter>;
  /** No related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TraderPublicProfileFilter>;
  /** Some related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TraderPublicProfileFilter>;
};

/** A filter to be used against many `XfaResetTracking` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyXfaResetTrackingFilter = {
  /** Aggregates across related `XfaResetTracking` match the filter criteria. */
  aggregates?: InputMaybe<XfaResetTrackingAggregatesFilter>;
  /** Every related `XfaResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<XfaResetTrackingFilter>;
  /** No related `XfaResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<XfaResetTrackingFilter>;
  /** Some related `XfaResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<XfaResetTrackingFilter>;
};

export type AccountTradeArchiveNewId = Node & {
  __typename?: 'AccountTradeArchiveNewId';
  accountId?: Maybe<Scalars['BigInt']['output']>;
  action?: Maybe<Scalars['Int']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  fees?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lots?: Maybe<Scalars['BigFloat']['output']>;
  pairedTradeId?: Maybe<Scalars['BigInt']['output']>;
  pairedTradeIdOld?: Maybe<Scalars['Int']['output']>;
  pnl?: Maybe<Scalars['BigFloat']['output']>;
  price?: Maybe<Scalars['BigFloat']['output']>;
  priceOld?: Maybe<Scalars['BigFloat']['output']>;
  rowId: Scalars['BigInt']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  timeStamp?: Maybe<Scalars['Datetime']['output']>;
  tradeDay?: Maybe<Scalars['String']['output']>;
  tradeId: Scalars['BigInt']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountTradeNat = Node & {
  __typename?: 'AccountTradeNat';
  accountId?: Maybe<Scalars['BigInt']['output']>;
  action?: Maybe<Scalars['Int']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  fees?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lots?: Maybe<Scalars['BigFloat']['output']>;
  pairedTradeId?: Maybe<Scalars['BigInt']['output']>;
  pairedTradeIdOld?: Maybe<Scalars['Int']['output']>;
  pnl?: Maybe<Scalars['BigFloat']['output']>;
  price?: Maybe<Scalars['BigFloat']['output']>;
  priceOld?: Maybe<Scalars['BigFloat']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  timeStamp?: Maybe<Scalars['Datetime']['output']>;
  tradeDay?: Maybe<Scalars['String']['output']>;
  tradeId: Scalars['BigInt']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountTradeStatByDay = Node & {
  __typename?: 'AccountTradeStatByDay';
  avgLosingDuration: Scalars['String']['output'];
  avgLosingTrade: Scalars['BigFloat']['output'];
  avgWinningDuration: Scalars['String']['output'];
  avgWinningTrade: Scalars['BigFloat']['output'];
  contractName: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  losingTrades: Scalars['Int']['output'];
  losingTradesCount: Scalars['Int']['output'];
  maxConsecutiveLosses: Scalars['Int']['output'];
  maxConsecutiveWins: Scalars['Int']['output'];
  netPnl: Scalars['BigFloat']['output'];
  neutralTrades: Scalars['Int']['output'];
  pnlHigh: Scalars['BigFloat']['output'];
  pnlLow: Scalars['BigFloat']['output'];
  projectXAccountId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  totalCommissions: Scalars['BigFloat']['output'];
  totalCompletedTrades: Scalars['Int']['output'];
  totalContracts: Scalars['Int']['output'];
  totalFees: Scalars['BigFloat']['output'];
  totalPnl: Scalars['BigFloat']['output'];
  totalTrades: Scalars['Int']['output'];
  tradingDay: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `AccountTradeStatByDay`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  winRate: Scalars['BigFloat']['output'];
  winningTradePercentage: Scalars['BigFloat']['output'];
  winningTrades: Scalars['Int']['output'];
  winningTradesCount: Scalars['Int']['output'];
};

export type AccountTradeStatByDayAggregates = {
  __typename?: 'AccountTradeStatByDayAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountTradeStatByDayAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountTradeStatByDayDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountTradeStatByDayMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountTradeStatByDayMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountTradeStatByDayStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountTradeStatByDayStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountTradeStatByDaySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountTradeStatByDayVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountTradeStatByDayVarianceSampleAggregates>;
};

export type AccountTradeStatByDayAverageAggregates = {
  __typename?: 'AccountTradeStatByDayAverageAggregates';
  /** Mean average of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountTradeStatByDay` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountTradeStatByDayCondition = {
  /** Checks for equality with the object’s `contractName` field. */
  contractName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectXAccountId` field. */
  projectXAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tradingDay` field. */
  tradingDay?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `AccountTradeStatByDay` values. */
export type AccountTradeStatByDayConnection = {
  __typename?: 'AccountTradeStatByDayConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountTradeStatByDayAggregates>;
  /** A list of edges which contains the `AccountTradeStatByDay` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountTradeStatByDayEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountTradeStatByDayAggregates>>;
  /** A list of `AccountTradeStatByDay` objects. */
  nodes: Array<Maybe<AccountTradeStatByDay>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountTradeStatByDay` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountTradeStatByDay` values. */
export type AccountTradeStatByDayConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountTradeStatByDayGroupBy>;
  having?: InputMaybe<AccountTradeStatByDayHavingInput>;
};

export type AccountTradeStatByDayDistinctCountAggregates = {
  __typename?: 'AccountTradeStatByDayDistinctCountAggregates';
  /** Distinct count of avgLosingDuration across the matching connection */
  avgLosingDuration?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgWinningDuration across the matching connection */
  avgWinningDuration?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of contractName across the matching connection */
  contractName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingDay across the matching connection */
  tradingDay?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AccountTradeStatByDay` edge in the connection. */
export type AccountTradeStatByDayEdge = {
  __typename?: 'AccountTradeStatByDayEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountTradeStatByDay` at the end of the edge. */
  node?: Maybe<AccountTradeStatByDay>;
};

/** A filter to be used against `AccountTradeStatByDay` object types. All fields are combined with a logical ‘and.’ */
export type AccountTradeStatByDayFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountTradeStatByDayFilter>>;
  /** Filter by the object’s `contractName` field. */
  contractName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountTradeStatByDayFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountTradeStatByDayFilter>>;
  /** Filter by the object’s `projectXAccountId` field. */
  projectXAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tradingDay` field. */
  tradingDay?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `AccountTradeStatByDay` for usage during aggregation. */
export enum AccountTradeStatByDayGroupBy {
  ContractName = 'CONTRACT_NAME',
  ProjectXaccountId = 'PROJECT_XACCOUNT_ID',
  TradingDay = 'TRADING_DAY',
  TradingDayTruncatedToDay = 'TRADING_DAY_TRUNCATED_TO_DAY',
  TradingDayTruncatedToHour = 'TRADING_DAY_TRUNCATED_TO_HOUR'
}

export type AccountTradeStatByDayHavingAverageInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingDistinctCountInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountTradeStatByDay` aggregates. */
export type AccountTradeStatByDayHavingInput = {
  AND?: InputMaybe<Array<AccountTradeStatByDayHavingInput>>;
  OR?: InputMaybe<Array<AccountTradeStatByDayHavingInput>>;
  average?: InputMaybe<AccountTradeStatByDayHavingAverageInput>;
  distinctCount?: InputMaybe<AccountTradeStatByDayHavingDistinctCountInput>;
  max?: InputMaybe<AccountTradeStatByDayHavingMaxInput>;
  min?: InputMaybe<AccountTradeStatByDayHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountTradeStatByDayHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountTradeStatByDayHavingStddevSampleInput>;
  sum?: InputMaybe<AccountTradeStatByDayHavingSumInput>;
  variancePopulation?: InputMaybe<AccountTradeStatByDayHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountTradeStatByDayHavingVarianceSampleInput>;
};

export type AccountTradeStatByDayHavingMaxInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingMinInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingStddevPopulationInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingStddevSampleInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingSumInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingVariancePopulationInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayHavingVarianceSampleInput = {
  avgLosingTrade?: InputMaybe<HavingBigfloatFilter>;
  avgWinningTrade?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  losingTrades?: InputMaybe<HavingIntFilter>;
  losingTradesCount?: InputMaybe<HavingIntFilter>;
  maxConsecutiveLosses?: InputMaybe<HavingIntFilter>;
  maxConsecutiveWins?: InputMaybe<HavingIntFilter>;
  netPnl?: InputMaybe<HavingBigfloatFilter>;
  neutralTrades?: InputMaybe<HavingIntFilter>;
  pnlHigh?: InputMaybe<HavingBigfloatFilter>;
  pnlLow?: InputMaybe<HavingBigfloatFilter>;
  projectXAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  totalCommissions?: InputMaybe<HavingBigfloatFilter>;
  totalCompletedTrades?: InputMaybe<HavingIntFilter>;
  totalContracts?: InputMaybe<HavingIntFilter>;
  totalFees?: InputMaybe<HavingBigfloatFilter>;
  totalPnl?: InputMaybe<HavingBigfloatFilter>;
  totalTrades?: InputMaybe<HavingIntFilter>;
  tradingDay?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
  winRate?: InputMaybe<HavingBigfloatFilter>;
  winningTradePercentage?: InputMaybe<HavingBigfloatFilter>;
  winningTrades?: InputMaybe<HavingIntFilter>;
  winningTradesCount?: InputMaybe<HavingIntFilter>;
};

export type AccountTradeStatByDayMaxAggregates = {
  __typename?: 'AccountTradeStatByDayMaxAggregates';
  /** Maximum of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['Int']['output']>;
  /** Maximum of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['Int']['output']>;
  /** Maximum of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['Int']['output']>;
  /** Maximum of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['Int']['output']>;
  /** Maximum of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountTradeStatByDayMinAggregates = {
  __typename?: 'AccountTradeStatByDayMinAggregates';
  /** Minimum of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['Int']['output']>;
  /** Minimum of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['Int']['output']>;
  /** Minimum of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['Int']['output']>;
  /** Minimum of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['Int']['output']>;
  /** Minimum of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountTradeStatByDayNat = Node & {
  __typename?: 'AccountTradeStatByDayNat';
  avgLosingDuration: Scalars['String']['output'];
  avgLosingTrade: Scalars['BigFloat']['output'];
  avgWinningDuration: Scalars['String']['output'];
  avgWinningTrade: Scalars['BigFloat']['output'];
  contractName: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  losingTrades: Scalars['Int']['output'];
  losingTradesCount: Scalars['Int']['output'];
  maxConsecutiveLosses: Scalars['Int']['output'];
  maxConsecutiveWins: Scalars['Int']['output'];
  netPnl: Scalars['BigFloat']['output'];
  neutralTrades: Scalars['Int']['output'];
  pnlHigh: Scalars['BigFloat']['output'];
  pnlLow: Scalars['BigFloat']['output'];
  projectXAccountId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  totalCompletedTrades: Scalars['Int']['output'];
  totalContracts: Scalars['Int']['output'];
  totalFees: Scalars['BigFloat']['output'];
  totalPnl: Scalars['BigFloat']['output'];
  totalTrades: Scalars['Int']['output'];
  tradingDay: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
  winRate: Scalars['BigFloat']['output'];
  winningTradePercentage: Scalars['BigFloat']['output'];
  winningTrades: Scalars['Int']['output'];
  winningTradesCount: Scalars['Int']['output'];
};

/** Methods to use when ordering `AccountTradeStatByDay`. */
export enum AccountTradeStatByDayOrderBy {
  ContractNameAsc = 'CONTRACT_NAME_ASC',
  ContractNameDesc = 'CONTRACT_NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectXaccountIdAsc = 'PROJECT_XACCOUNT_ID_ASC',
  ProjectXaccountIdDesc = 'PROJECT_XACCOUNT_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TradingDayAsc = 'TRADING_DAY_ASC',
  TradingDayDesc = 'TRADING_DAY_DESC'
}

export type AccountTradeStatByDayStddevPopulationAggregates = {
  __typename?: 'AccountTradeStatByDayStddevPopulationAggregates';
  /** Population standard deviation of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountTradeStatByDayStddevSampleAggregates = {
  __typename?: 'AccountTradeStatByDayStddevSampleAggregates';
  /** Sample standard deviation of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountTradeStatByDaySumAggregates = {
  __typename?: 'AccountTradeStatByDaySumAggregates';
  /** Sum of avgLosingTrade across the matching connection */
  avgLosingTrade: Scalars['BigFloat']['output'];
  /** Sum of avgWinningTrade across the matching connection */
  avgWinningTrade: Scalars['BigFloat']['output'];
  /** Sum of losingTrades across the matching connection */
  losingTrades: Scalars['BigInt']['output'];
  /** Sum of losingTradesCount across the matching connection */
  losingTradesCount: Scalars['BigInt']['output'];
  /** Sum of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses: Scalars['BigInt']['output'];
  /** Sum of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins: Scalars['BigInt']['output'];
  /** Sum of netPnl across the matching connection */
  netPnl: Scalars['BigFloat']['output'];
  /** Sum of neutralTrades across the matching connection */
  neutralTrades: Scalars['BigInt']['output'];
  /** Sum of pnlHigh across the matching connection */
  pnlHigh: Scalars['BigFloat']['output'];
  /** Sum of pnlLow across the matching connection */
  pnlLow: Scalars['BigFloat']['output'];
  /** Sum of projectXAccountId across the matching connection */
  projectXAccountId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of totalCommissions across the matching connection */
  totalCommissions: Scalars['BigFloat']['output'];
  /** Sum of totalCompletedTrades across the matching connection */
  totalCompletedTrades: Scalars['BigInt']['output'];
  /** Sum of totalContracts across the matching connection */
  totalContracts: Scalars['BigInt']['output'];
  /** Sum of totalFees across the matching connection */
  totalFees: Scalars['BigFloat']['output'];
  /** Sum of totalPnl across the matching connection */
  totalPnl: Scalars['BigFloat']['output'];
  /** Sum of totalTrades across the matching connection */
  totalTrades: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
  /** Sum of winRate across the matching connection */
  winRate: Scalars['BigFloat']['output'];
  /** Sum of winningTradePercentage across the matching connection */
  winningTradePercentage: Scalars['BigFloat']['output'];
  /** Sum of winningTrades across the matching connection */
  winningTrades: Scalars['BigInt']['output'];
  /** Sum of winningTradesCount across the matching connection */
  winningTradesCount: Scalars['BigInt']['output'];
};

export type AccountTradeStatByDayVariancePopulationAggregates = {
  __typename?: 'AccountTradeStatByDayVariancePopulationAggregates';
  /** Population variance of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountTradeStatByDayVarianceSampleAggregates = {
  __typename?: 'AccountTradeStatByDayVarianceSampleAggregates';
  /** Sample variance of avgLosingTrade across the matching connection */
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgWinningTrade across the matching connection */
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losingTrades across the matching connection */
  losingTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losingTradesCount across the matching connection */
  losingTradesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxConsecutiveLosses across the matching connection */
  maxConsecutiveLosses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxConsecutiveWins across the matching connection */
  maxConsecutiveWins?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of netPnl across the matching connection */
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of neutralTrades across the matching connection */
  neutralTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of pnlHigh across the matching connection */
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of pnlLow across the matching connection */
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalCommissions across the matching connection */
  totalCommissions?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalCompletedTrades across the matching connection */
  totalCompletedTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalContracts across the matching connection */
  totalContracts?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalFees across the matching connection */
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalPnl across the matching connection */
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalTrades across the matching connection */
  totalTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of winRate across the matching connection */
  winRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of winningTradePercentage across the matching connection */
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of winningTrades across the matching connection */
  winningTrades?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of winningTradesCount across the matching connection */
  winningTradesCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountVariancePopulationAggregateFilter = {
  accountTemplate?: InputMaybe<BigFloatFilter>;
  nmiSubscriptionId?: InputMaybe<BigFloatFilter>;
  platformId?: InputMaybe<BigFloatFilter>;
  projectXAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountVariancePopulationAggregates = {
  __typename?: 'AccountVariancePopulationAggregates';
  /** Population variance of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountVarianceSampleAggregateFilter = {
  accountTemplate?: InputMaybe<BigFloatFilter>;
  nmiSubscriptionId?: InputMaybe<BigFloatFilter>;
  platformId?: InputMaybe<BigFloatFilter>;
  projectXAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AccountVarianceSampleAggregates = {
  __typename?: 'AccountVarianceSampleAggregates';
  /** Sample variance of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nmiSubscriptionId across the matching connection */
  nmiSubscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectXAccountId across the matching connection */
  projectXAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectXAccountStatus across the matching connection */
  projectXAccountStatus?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startingBalance across the matching connection */
  startingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AddCaseBanNoteInput = {
  banId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};

export type AddCaseInvestigationNoteInput = {
  investigationId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};

export type Addon = Node & {
  __typename?: 'Addon';
  active?: Maybe<Scalars['Boolean']['output']>;
  avaTaxTaxCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  humanName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['Int']['output']>;
  platformCode?: Maybe<Scalars['String']['output']>;
  price: Scalars['BigFloat']['output'];
  recurring?: Maybe<Scalars['Boolean']['output']>;
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type AdminAudit = Node & {
  __typename?: 'AdminAudit';
  action: Scalars['String']['output'];
  /** Reads a single `UserContactInfo` that is related to this `AdminAudit`. */
  admin?: Maybe<UserContactInfo>;
  adminId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  details: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AdminAuditAggregates = {
  __typename?: 'AdminAuditAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AdminAuditAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AdminAuditDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AdminAuditMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AdminAuditMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AdminAuditStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AdminAuditStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AdminAuditSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AdminAuditVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AdminAuditVarianceSampleAggregates>;
};

export type AdminAuditAverageAggregates = {
  __typename?: 'AdminAuditAverageAggregates';
  /** Mean average of adminId across the matching connection */
  adminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AdminAudit` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AdminAuditCondition = {
  /** Checks for equality with the object’s `action` field. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `entityType` field. */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AdminAudit` values. */
export type AdminAuditConnection = {
  __typename?: 'AdminAuditConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AdminAuditAggregates>;
  /** A list of edges which contains the `AdminAudit` and cursor to aid in pagination. */
  edges: Array<Maybe<AdminAuditEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AdminAuditAggregates>>;
  /** A list of `AdminAudit` objects. */
  nodes: Array<Maybe<AdminAudit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdminAudit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AdminAudit` values. */
export type AdminAuditConnectionGroupedAggregatesArgs = {
  groupBy: Array<AdminAuditGroupBy>;
  having?: InputMaybe<AdminAuditHavingInput>;
};

export type AdminAuditDistinctCountAggregates = {
  __typename?: 'AdminAuditDistinctCountAggregates';
  /** Distinct count of action across the matching connection */
  action?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of adminId across the matching connection */
  adminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of details across the matching connection */
  details?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of entityType across the matching connection */
  entityType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ipAddress across the matching connection */
  ipAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of message across the matching connection */
  message?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userAgent across the matching connection */
  userAgent?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AdminAudit` edge in the connection. */
export type AdminAuditEdge = {
  __typename?: 'AdminAuditEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AdminAudit` at the end of the edge. */
  node?: Maybe<AdminAudit>;
};

/** A filter to be used against `AdminAudit` object types. All fields are combined with a logical ‘and.’ */
export type AdminAuditFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<StringFilter>;
  /** Filter by the object’s `admin` relation. */
  admin?: InputMaybe<UserContactInfoFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AdminAuditFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `entityType` field. */
  entityType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AdminAuditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AdminAuditFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AdminAudit` for usage during aggregation. */
export enum AdminAuditGroupBy {
  Action = 'ACTION',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  EntityType = 'ENTITY_TYPE'
}

export type AdminAuditHavingAverageInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingDistinctCountInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AdminAudit` aggregates. */
export type AdminAuditHavingInput = {
  AND?: InputMaybe<Array<AdminAuditHavingInput>>;
  OR?: InputMaybe<Array<AdminAuditHavingInput>>;
  average?: InputMaybe<AdminAuditHavingAverageInput>;
  distinctCount?: InputMaybe<AdminAuditHavingDistinctCountInput>;
  max?: InputMaybe<AdminAuditHavingMaxInput>;
  min?: InputMaybe<AdminAuditHavingMinInput>;
  stddevPopulation?: InputMaybe<AdminAuditHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AdminAuditHavingStddevSampleInput>;
  sum?: InputMaybe<AdminAuditHavingSumInput>;
  variancePopulation?: InputMaybe<AdminAuditHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AdminAuditHavingVarianceSampleInput>;
};

export type AdminAuditHavingMaxInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingMinInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingStddevPopulationInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingStddevSampleInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingSumInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingVariancePopulationInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditHavingVarianceSampleInput = {
  adminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type AdminAuditMaxAggregates = {
  __typename?: 'AdminAuditMaxAggregates';
  /** Maximum of adminId across the matching connection */
  adminId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type AdminAuditMinAggregates = {
  __typename?: 'AdminAuditMinAggregates';
  /** Minimum of adminId across the matching connection */
  adminId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AdminAudit`. */
export enum AdminAuditOrderBy {
  ActionAsc = 'ACTION_ASC',
  ActionDesc = 'ACTION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EntityTypeAsc = 'ENTITY_TYPE_ASC',
  EntityTypeDesc = 'ENTITY_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AdminAuditStddevPopulationAggregates = {
  __typename?: 'AdminAuditStddevPopulationAggregates';
  /** Population standard deviation of adminId across the matching connection */
  adminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminAuditStddevSampleAggregates = {
  __typename?: 'AdminAuditStddevSampleAggregates';
  /** Sample standard deviation of adminId across the matching connection */
  adminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminAuditSumAggregates = {
  __typename?: 'AdminAuditSumAggregates';
  /** Sum of adminId across the matching connection */
  adminId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type AdminAuditVariancePopulationAggregates = {
  __typename?: 'AdminAuditVariancePopulationAggregates';
  /** Population variance of adminId across the matching connection */
  adminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminAuditVarianceSampleAggregates = {
  __typename?: 'AdminAuditVarianceSampleAggregates';
  /** Sample variance of adminId across the matching connection */
  adminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminConfig = Node & {
  __typename?: 'AdminConfig';
  /** Unique identifier for the configuration (e.g., TRADE_DATA_BACKFILL) */
  configKey: Scalars['String']['output'];
  /** Key-value pairs for configuration settings that override defaults */
  configurations?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Human-readable description of what this configuration controls */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  /** Status of the configuration - only ACTIVE configs are used */
  status: AdminConfigStatusEnum;
  updatedAt: Scalars['Datetime']['output'];
};

/** A `AdminConfig` edge in the connection. */
export type AdminConfigEdge = {
  __typename?: 'AdminConfigEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AdminConfig` at the end of the edge. */
  node?: Maybe<AdminConfig>;
};

/** Methods to use when ordering `AdminConfig`. */
export enum AdminConfigOrderBy {
  ConfigKeyAsc = 'CONFIG_KEY_ASC',
  ConfigKeyDesc = 'CONFIG_KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

/** Represents an update to a `AdminConfig`. Fields that are set will be updated. */
export type AdminConfigPatch = {
  /** Key-value pairs for configuration settings that override defaults */
  configurations?: InputMaybe<Scalars['JSON']['input']>;
};

export enum AdminConfigStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type AdminRole = Node & {
  __typename?: 'AdminRole';
  /** Reads and enables pagination through a set of `AdminRoleUsersUser`. */
  adminRoleUsersUsers: AdminRoleUsersUserConnection;
  createdAt: Scalars['Datetime']['output'];
  createdById?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UserAdminRole`. */
  userAdminRolesByRoleId: UserAdminRoleConnection;
  /** Reads and enables pagination through a set of `UserRolesAdminRole`. */
  userRolesAdminRoles: UserRolesAdminRoleConnection;
};


export type AdminRoleAdminRoleUsersUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AdminRoleUsersUserCondition>;
  filter?: InputMaybe<AdminRoleUsersUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdminRoleUsersUserOrderBy>>;
};


export type AdminRoleUserAdminRolesByRoleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserAdminRoleCondition>;
  filter?: InputMaybe<UserAdminRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserAdminRoleOrderBy>>;
};


export type AdminRoleUserRolesAdminRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRolesAdminRoleCondition>;
  filter?: InputMaybe<UserRolesAdminRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolesAdminRoleOrderBy>>;
};

export type AdminRoleAggregates = {
  __typename?: 'AdminRoleAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AdminRoleAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AdminRoleDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AdminRoleMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AdminRoleMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AdminRoleStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AdminRoleStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AdminRoleSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AdminRoleVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AdminRoleVarianceSampleAggregates>;
};

export type AdminRoleAverageAggregates = {
  __typename?: 'AdminRoleAverageAggregates';
  /** Mean average of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AdminRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AdminRoleCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AdminRole` values. */
export type AdminRoleConnection = {
  __typename?: 'AdminRoleConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AdminRoleAggregates>;
  /** A list of edges which contains the `AdminRole` and cursor to aid in pagination. */
  edges: Array<Maybe<AdminRoleEdge>>;
  /** A list of `AdminRole` objects. */
  nodes: Array<Maybe<AdminRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdminRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type AdminRoleDistinctCountAggregates = {
  __typename?: 'AdminRoleDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of permissions across the matching connection */
  permissions?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AdminRole` edge in the connection. */
export type AdminRoleEdge = {
  __typename?: 'AdminRoleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AdminRole` at the end of the edge. */
  node?: Maybe<AdminRole>;
};

/** A filter to be used against `AdminRole` object types. All fields are combined with a logical ‘and.’ */
export type AdminRoleFilter = {
  /** Filter by the object’s `adminRoleUsersUsers` relation. */
  adminRoleUsersUsers?: InputMaybe<AdminRoleToManyAdminRoleUsersUserFilter>;
  /** Some related `adminRoleUsersUsers` exist. */
  adminRoleUsersUsersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AdminRoleFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AdminRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AdminRoleFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userAdminRolesByRoleId` relation. */
  userAdminRolesByRoleId?: InputMaybe<AdminRoleToManyUserAdminRoleFilter>;
  /** Some related `userAdminRolesByRoleId` exist. */
  userAdminRolesByRoleIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userRolesAdminRoles` relation. */
  userRolesAdminRoles?: InputMaybe<AdminRoleToManyUserRolesAdminRoleFilter>;
  /** Some related `userRolesAdminRoles` exist. */
  userRolesAdminRolesExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminRoleMaxAggregates = {
  __typename?: 'AdminRoleMaxAggregates';
  /** Maximum of createdById across the matching connection */
  createdById?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type AdminRoleMinAggregates = {
  __typename?: 'AdminRoleMinAggregates';
  /** Minimum of createdById across the matching connection */
  createdById?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AdminRole`. */
export enum AdminRoleOrderBy {
  AdminRoleUsersUsersAverageAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersAverageAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersAverageUserIdAsc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_USER_ID_ASC',
  AdminRoleUsersUsersAverageUserIdDesc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_USER_ID_DESC',
  AdminRoleUsersUsersCountAsc = 'ADMIN_ROLE_USERS_USERS_COUNT_ASC',
  AdminRoleUsersUsersCountDesc = 'ADMIN_ROLE_USERS_USERS_COUNT_DESC',
  AdminRoleUsersUsersDistinctCountAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersDistinctCountAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersDistinctCountUserIdAsc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_USER_ID_ASC',
  AdminRoleUsersUsersDistinctCountUserIdDesc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_USER_ID_DESC',
  AdminRoleUsersUsersMaxAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_MAX_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersMaxAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_MAX_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersMaxUserIdAsc = 'ADMIN_ROLE_USERS_USERS_MAX_USER_ID_ASC',
  AdminRoleUsersUsersMaxUserIdDesc = 'ADMIN_ROLE_USERS_USERS_MAX_USER_ID_DESC',
  AdminRoleUsersUsersMinAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_MIN_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersMinAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_MIN_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersMinUserIdAsc = 'ADMIN_ROLE_USERS_USERS_MIN_USER_ID_ASC',
  AdminRoleUsersUsersMinUserIdDesc = 'ADMIN_ROLE_USERS_USERS_MIN_USER_ID_DESC',
  AdminRoleUsersUsersStddevPopulationAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersStddevPopulationAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersStddevPopulationUserIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_USER_ID_ASC',
  AdminRoleUsersUsersStddevPopulationUserIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_USER_ID_DESC',
  AdminRoleUsersUsersStddevSampleAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersStddevSampleAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersStddevSampleUserIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_USER_ID_ASC',
  AdminRoleUsersUsersStddevSampleUserIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_USER_ID_DESC',
  AdminRoleUsersUsersSumAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_SUM_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersSumAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_SUM_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersSumUserIdAsc = 'ADMIN_ROLE_USERS_USERS_SUM_USER_ID_ASC',
  AdminRoleUsersUsersSumUserIdDesc = 'ADMIN_ROLE_USERS_USERS_SUM_USER_ID_DESC',
  AdminRoleUsersUsersVariancePopulationAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersVariancePopulationAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersVariancePopulationUserIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_USER_ID_ASC',
  AdminRoleUsersUsersVariancePopulationUserIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_USER_ID_DESC',
  AdminRoleUsersUsersVarianceSampleAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersVarianceSampleAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersVarianceSampleUserIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_USER_ID_ASC',
  AdminRoleUsersUsersVarianceSampleUserIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_USER_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserAdminRolesByRoleIdAverageRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_AVERAGE_ROLE_ID_ASC',
  UserAdminRolesByRoleIdAverageRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_AVERAGE_ROLE_ID_DESC',
  UserAdminRolesByRoleIdAverageUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_AVERAGE_USER_ID_ASC',
  UserAdminRolesByRoleIdAverageUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_AVERAGE_USER_ID_DESC',
  UserAdminRolesByRoleIdCountAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_COUNT_ASC',
  UserAdminRolesByRoleIdCountDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_COUNT_DESC',
  UserAdminRolesByRoleIdDistinctCountRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_DISTINCT_COUNT_ROLE_ID_ASC',
  UserAdminRolesByRoleIdDistinctCountRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_DISTINCT_COUNT_ROLE_ID_DESC',
  UserAdminRolesByRoleIdDistinctCountUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_DISTINCT_COUNT_USER_ID_ASC',
  UserAdminRolesByRoleIdDistinctCountUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_DISTINCT_COUNT_USER_ID_DESC',
  UserAdminRolesByRoleIdMaxRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MAX_ROLE_ID_ASC',
  UserAdminRolesByRoleIdMaxRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MAX_ROLE_ID_DESC',
  UserAdminRolesByRoleIdMaxUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MAX_USER_ID_ASC',
  UserAdminRolesByRoleIdMaxUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MAX_USER_ID_DESC',
  UserAdminRolesByRoleIdMinRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MIN_ROLE_ID_ASC',
  UserAdminRolesByRoleIdMinRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MIN_ROLE_ID_DESC',
  UserAdminRolesByRoleIdMinUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MIN_USER_ID_ASC',
  UserAdminRolesByRoleIdMinUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_MIN_USER_ID_DESC',
  UserAdminRolesByRoleIdStddevPopulationRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_POPULATION_ROLE_ID_ASC',
  UserAdminRolesByRoleIdStddevPopulationRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_POPULATION_ROLE_ID_DESC',
  UserAdminRolesByRoleIdStddevPopulationUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_POPULATION_USER_ID_ASC',
  UserAdminRolesByRoleIdStddevPopulationUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_POPULATION_USER_ID_DESC',
  UserAdminRolesByRoleIdStddevSampleRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_SAMPLE_ROLE_ID_ASC',
  UserAdminRolesByRoleIdStddevSampleRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_SAMPLE_ROLE_ID_DESC',
  UserAdminRolesByRoleIdStddevSampleUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_SAMPLE_USER_ID_ASC',
  UserAdminRolesByRoleIdStddevSampleUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_STDDEV_SAMPLE_USER_ID_DESC',
  UserAdminRolesByRoleIdSumRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_SUM_ROLE_ID_ASC',
  UserAdminRolesByRoleIdSumRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_SUM_ROLE_ID_DESC',
  UserAdminRolesByRoleIdSumUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_SUM_USER_ID_ASC',
  UserAdminRolesByRoleIdSumUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_SUM_USER_ID_DESC',
  UserAdminRolesByRoleIdVariancePopulationRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_POPULATION_ROLE_ID_ASC',
  UserAdminRolesByRoleIdVariancePopulationRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_POPULATION_ROLE_ID_DESC',
  UserAdminRolesByRoleIdVariancePopulationUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_POPULATION_USER_ID_ASC',
  UserAdminRolesByRoleIdVariancePopulationUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_POPULATION_USER_ID_DESC',
  UserAdminRolesByRoleIdVarianceSampleRoleIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_SAMPLE_ROLE_ID_ASC',
  UserAdminRolesByRoleIdVarianceSampleRoleIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_SAMPLE_ROLE_ID_DESC',
  UserAdminRolesByRoleIdVarianceSampleUserIdAsc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_SAMPLE_USER_ID_ASC',
  UserAdminRolesByRoleIdVarianceSampleUserIdDesc = 'USER_ADMIN_ROLES_BY_ROLE_ID_VARIANCE_SAMPLE_USER_ID_DESC',
  UserRolesAdminRolesAverageAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesAverageAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesAverageUserIdAsc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_USER_ID_ASC',
  UserRolesAdminRolesAverageUserIdDesc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_USER_ID_DESC',
  UserRolesAdminRolesCountAsc = 'USER_ROLES_ADMIN_ROLES_COUNT_ASC',
  UserRolesAdminRolesCountDesc = 'USER_ROLES_ADMIN_ROLES_COUNT_DESC',
  UserRolesAdminRolesDistinctCountAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesDistinctCountAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesDistinctCountUserIdAsc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_USER_ID_ASC',
  UserRolesAdminRolesDistinctCountUserIdDesc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_USER_ID_DESC',
  UserRolesAdminRolesMaxAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_MAX_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesMaxAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_MAX_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesMaxUserIdAsc = 'USER_ROLES_ADMIN_ROLES_MAX_USER_ID_ASC',
  UserRolesAdminRolesMaxUserIdDesc = 'USER_ROLES_ADMIN_ROLES_MAX_USER_ID_DESC',
  UserRolesAdminRolesMinAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_MIN_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesMinAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_MIN_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesMinUserIdAsc = 'USER_ROLES_ADMIN_ROLES_MIN_USER_ID_ASC',
  UserRolesAdminRolesMinUserIdDesc = 'USER_ROLES_ADMIN_ROLES_MIN_USER_ID_DESC',
  UserRolesAdminRolesStddevPopulationAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesStddevPopulationAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesStddevPopulationUserIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_USER_ID_ASC',
  UserRolesAdminRolesStddevPopulationUserIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_USER_ID_DESC',
  UserRolesAdminRolesStddevSampleAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesStddevSampleAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesStddevSampleUserIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_USER_ID_ASC',
  UserRolesAdminRolesStddevSampleUserIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_USER_ID_DESC',
  UserRolesAdminRolesSumAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_SUM_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesSumAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_SUM_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesSumUserIdAsc = 'USER_ROLES_ADMIN_ROLES_SUM_USER_ID_ASC',
  UserRolesAdminRolesSumUserIdDesc = 'USER_ROLES_ADMIN_ROLES_SUM_USER_ID_DESC',
  UserRolesAdminRolesVariancePopulationAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesVariancePopulationAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesVariancePopulationUserIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_USER_ID_ASC',
  UserRolesAdminRolesVariancePopulationUserIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_USER_ID_DESC',
  UserRolesAdminRolesVarianceSampleAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesVarianceSampleAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesVarianceSampleUserIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_USER_ID_ASC',
  UserRolesAdminRolesVarianceSampleUserIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_USER_ID_DESC'
}

export type AdminRoleStddevPopulationAggregates = {
  __typename?: 'AdminRoleStddevPopulationAggregates';
  /** Population standard deviation of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleStddevSampleAggregates = {
  __typename?: 'AdminRoleStddevSampleAggregates';
  /** Sample standard deviation of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleSumAggregates = {
  __typename?: 'AdminRoleSumAggregates';
  /** Sum of createdById across the matching connection */
  createdById: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AdminRoleUsersUser` object types. All fields are combined with a logical ‘and.’ */
export type AdminRoleToManyAdminRoleUsersUserFilter = {
  /** Aggregates across related `AdminRoleUsersUser` match the filter criteria. */
  aggregates?: InputMaybe<AdminRoleUsersUserAggregatesFilter>;
  /** Every related `AdminRoleUsersUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AdminRoleUsersUserFilter>;
  /** No related `AdminRoleUsersUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AdminRoleUsersUserFilter>;
  /** Some related `AdminRoleUsersUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AdminRoleUsersUserFilter>;
};

/** A filter to be used against many `UserAdminRole` object types. All fields are combined with a logical ‘and.’ */
export type AdminRoleToManyUserAdminRoleFilter = {
  /** Aggregates across related `UserAdminRole` match the filter criteria. */
  aggregates?: InputMaybe<UserAdminRoleAggregatesFilter>;
  /** Every related `UserAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAdminRoleFilter>;
  /** No related `UserAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAdminRoleFilter>;
  /** Some related `UserAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAdminRoleFilter>;
};

/** A filter to be used against many `UserRolesAdminRole` object types. All fields are combined with a logical ‘and.’ */
export type AdminRoleToManyUserRolesAdminRoleFilter = {
  /** Aggregates across related `UserRolesAdminRole` match the filter criteria. */
  aggregates?: InputMaybe<UserRolesAdminRoleAggregatesFilter>;
  /** Every related `UserRolesAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRolesAdminRoleFilter>;
  /** No related `UserRolesAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRolesAdminRoleFilter>;
  /** Some related `UserRolesAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRolesAdminRoleFilter>;
};

export type AdminRoleUsersUser = Node & {
  __typename?: 'AdminRoleUsersUser';
  /** Reads a single `AdminRole` that is related to this `AdminRoleUsersUser`. */
  adminRole?: Maybe<AdminRole>;
  adminRoleId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `AdminRoleUsersUser`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type AdminRoleUsersUserAggregates = {
  __typename?: 'AdminRoleUsersUserAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AdminRoleUsersUserAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AdminRoleUsersUserDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AdminRoleUsersUserMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AdminRoleUsersUserMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AdminRoleUsersUserStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AdminRoleUsersUserStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AdminRoleUsersUserSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AdminRoleUsersUserVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AdminRoleUsersUserVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AdminRoleUsersUser` object types. */
export type AdminRoleUsersUserAggregatesFilter = {
  /** Mean average aggregate over matching `AdminRoleUsersUser` objects. */
  average?: InputMaybe<AdminRoleUsersUserAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AdminRoleUsersUser` objects. */
  distinctCount?: InputMaybe<AdminRoleUsersUserDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AdminRoleUsersUser` object to be included within the aggregate. */
  filter?: InputMaybe<AdminRoleUsersUserFilter>;
  /** Maximum aggregate over matching `AdminRoleUsersUser` objects. */
  max?: InputMaybe<AdminRoleUsersUserMaxAggregateFilter>;
  /** Minimum aggregate over matching `AdminRoleUsersUser` objects. */
  min?: InputMaybe<AdminRoleUsersUserMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AdminRoleUsersUser` objects. */
  stddevPopulation?: InputMaybe<AdminRoleUsersUserStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AdminRoleUsersUser` objects. */
  stddevSample?: InputMaybe<AdminRoleUsersUserStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AdminRoleUsersUser` objects. */
  sum?: InputMaybe<AdminRoleUsersUserSumAggregateFilter>;
  /** Population variance aggregate over matching `AdminRoleUsersUser` objects. */
  variancePopulation?: InputMaybe<AdminRoleUsersUserVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AdminRoleUsersUser` objects. */
  varianceSample?: InputMaybe<AdminRoleUsersUserVarianceSampleAggregateFilter>;
};

export type AdminRoleUsersUserAverageAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AdminRoleUsersUserAverageAggregates = {
  __typename?: 'AdminRoleUsersUserAverageAggregates';
  /** Mean average of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AdminRoleUsersUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AdminRoleUsersUserCondition = {
  /** Checks for equality with the object’s `adminRoleId` field. */
  adminRoleId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AdminRoleUsersUser` values. */
export type AdminRoleUsersUserConnection = {
  __typename?: 'AdminRoleUsersUserConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AdminRoleUsersUserAggregates>;
  /** A list of edges which contains the `AdminRoleUsersUser` and cursor to aid in pagination. */
  edges: Array<Maybe<AdminRoleUsersUserEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AdminRoleUsersUserAggregates>>;
  /** A list of `AdminRoleUsersUser` objects. */
  nodes: Array<Maybe<AdminRoleUsersUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdminRoleUsersUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AdminRoleUsersUser` values. */
export type AdminRoleUsersUserConnectionGroupedAggregatesArgs = {
  groupBy: Array<AdminRoleUsersUserGroupBy>;
  having?: InputMaybe<AdminRoleUsersUserHavingInput>;
};

export type AdminRoleUsersUserDistinctCountAggregateFilter = {
  adminRoleId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AdminRoleUsersUserDistinctCountAggregates = {
  __typename?: 'AdminRoleUsersUserDistinctCountAggregates';
  /** Distinct count of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AdminRoleUsersUser` edge in the connection. */
export type AdminRoleUsersUserEdge = {
  __typename?: 'AdminRoleUsersUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AdminRoleUsersUser` at the end of the edge. */
  node?: Maybe<AdminRoleUsersUser>;
};

/** A filter to be used against `AdminRoleUsersUser` object types. All fields are combined with a logical ‘and.’ */
export type AdminRoleUsersUserFilter = {
  /** Filter by the object’s `adminRole` relation. */
  adminRole?: InputMaybe<AdminRoleFilter>;
  /** Filter by the object’s `adminRoleId` field. */
  adminRoleId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AdminRoleUsersUserFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AdminRoleUsersUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AdminRoleUsersUserFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AdminRoleUsersUser` for usage during aggregation. */
export enum AdminRoleUsersUserGroupBy {
  AdminRoleId = 'ADMIN_ROLE_ID',
  UserId = 'USER_ID'
}

export type AdminRoleUsersUserHavingAverageInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingDistinctCountInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AdminRoleUsersUser` aggregates. */
export type AdminRoleUsersUserHavingInput = {
  AND?: InputMaybe<Array<AdminRoleUsersUserHavingInput>>;
  OR?: InputMaybe<Array<AdminRoleUsersUserHavingInput>>;
  average?: InputMaybe<AdminRoleUsersUserHavingAverageInput>;
  distinctCount?: InputMaybe<AdminRoleUsersUserHavingDistinctCountInput>;
  max?: InputMaybe<AdminRoleUsersUserHavingMaxInput>;
  min?: InputMaybe<AdminRoleUsersUserHavingMinInput>;
  stddevPopulation?: InputMaybe<AdminRoleUsersUserHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AdminRoleUsersUserHavingStddevSampleInput>;
  sum?: InputMaybe<AdminRoleUsersUserHavingSumInput>;
  variancePopulation?: InputMaybe<AdminRoleUsersUserHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AdminRoleUsersUserHavingVarianceSampleInput>;
};

export type AdminRoleUsersUserHavingMaxInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingMinInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingStddevPopulationInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingStddevSampleInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingSumInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingVariancePopulationInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserHavingVarianceSampleInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type AdminRoleUsersUserMaxAggregateFilter = {
  adminRoleId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AdminRoleUsersUserMaxAggregates = {
  __typename?: 'AdminRoleUsersUserMaxAggregates';
  /** Maximum of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AdminRoleUsersUserMinAggregateFilter = {
  adminRoleId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AdminRoleUsersUserMinAggregates = {
  __typename?: 'AdminRoleUsersUserMinAggregates';
  /** Minimum of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AdminRoleUsersUser`. */
export enum AdminRoleUsersUserOrderBy {
  AdminRoleIdAsc = 'ADMIN_ROLE_ID_ASC',
  AdminRoleIdDesc = 'ADMIN_ROLE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type AdminRoleUsersUserStddevPopulationAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AdminRoleUsersUserStddevPopulationAggregates = {
  __typename?: 'AdminRoleUsersUserStddevPopulationAggregates';
  /** Population standard deviation of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleUsersUserStddevSampleAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AdminRoleUsersUserStddevSampleAggregates = {
  __typename?: 'AdminRoleUsersUserStddevSampleAggregates';
  /** Sample standard deviation of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleUsersUserSumAggregateFilter = {
  adminRoleId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type AdminRoleUsersUserSumAggregates = {
  __typename?: 'AdminRoleUsersUserSumAggregates';
  /** Sum of adminRoleId across the matching connection */
  adminRoleId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type AdminRoleUsersUserVariancePopulationAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AdminRoleUsersUserVariancePopulationAggregates = {
  __typename?: 'AdminRoleUsersUserVariancePopulationAggregates';
  /** Population variance of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleUsersUserVarianceSampleAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type AdminRoleUsersUserVarianceSampleAggregates = {
  __typename?: 'AdminRoleUsersUserVarianceSampleAggregates';
  /** Sample variance of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleVariancePopulationAggregates = {
  __typename?: 'AdminRoleVariancePopulationAggregates';
  /** Population variance of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AdminRoleVarianceSampleAggregates = {
  __typename?: 'AdminRoleVarianceSampleAggregates';
  /** Sample variance of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Affiliate = Node & {
  __typename?: 'Affiliate';
  /** Reads and enables pagination through a set of `AffiliateAudit`. */
  affiliateAudits: AffiliateAuditConnection;
  /** Reads and enables pagination through a set of `AffiliateCommissionRate`. */
  affiliateCommissionRates: AffiliateCommissionRateConnection;
  /** Reads and enables pagination through a set of `AffiliateLedger`. */
  affiliateLedgers: AffiliateLedgerConnection;
  /** Reads and enables pagination through a set of `AffiliatePayoutPeriod`. */
  affiliatePayoutPeriods: AffiliatePayoutPeriodConnection;
  code: Scalars['String']['output'];
  commissionPercentage: Scalars['BigFloat']['output'];
  /** Reads a single `Coupon` that is related to this `Affiliate`. */
  coupon?: Maybe<Coupon>;
  couponId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  deactivatedAt?: Maybe<Scalars['Datetime']['output']>;
  deactivatedBy?: Maybe<Scalars['Int']['output']>;
  designatedAt: Scalars['Datetime']['output'];
  designatedBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payoutEmail?: Maybe<Scalars['String']['output']>;
  payoutLegalName?: Maybe<Scalars['String']['output']>;
  payoutMethod?: Maybe<Scalars['String']['output']>;
  payoutNotes?: Maybe<Scalars['String']['output']>;
  personalMessage?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Affiliate`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type AffiliateAffiliateAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AffiliateAuditCondition>;
  filter?: InputMaybe<AffiliateAuditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AffiliateAuditOrderBy>>;
};


export type AffiliateAffiliateCommissionRatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AffiliateCommissionRateCondition>;
  filter?: InputMaybe<AffiliateCommissionRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AffiliateCommissionRateOrderBy>>;
};


export type AffiliateAffiliateLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AffiliateLedgerCondition>;
  filter?: InputMaybe<AffiliateLedgerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AffiliateLedgerOrderBy>>;
};


export type AffiliateAffiliatePayoutPeriodsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AffiliatePayoutPeriodCondition>;
  filter?: InputMaybe<AffiliatePayoutPeriodFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AffiliatePayoutPeriodOrderBy>>;
};

export type AffiliateAudit = Node & {
  __typename?: 'AffiliateAudit';
  action: Scalars['String']['output'];
  actorAdminId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Affiliate` that is related to this `AffiliateAudit`. */
  affiliate?: Maybe<Affiliate>;
  affiliateId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
};

export type AffiliateAuditAggregates = {
  __typename?: 'AffiliateAuditAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AffiliateAuditAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AffiliateAuditDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AffiliateAuditMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AffiliateAuditMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AffiliateAuditStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AffiliateAuditStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AffiliateAuditSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AffiliateAuditVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AffiliateAuditVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AffiliateAudit` object types. */
export type AffiliateAuditAggregatesFilter = {
  /** Distinct count aggregate over matching `AffiliateAudit` objects. */
  distinctCount?: InputMaybe<AffiliateAuditDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AffiliateAudit` object to be included within the aggregate. */
  filter?: InputMaybe<AffiliateAuditFilter>;
};

export type AffiliateAuditAverageAggregates = {
  __typename?: 'AffiliateAuditAverageAggregates';
  /** Mean average of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AffiliateAudit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AffiliateAuditCondition = {
  /** Checks for equality with the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `AffiliateAudit` values. */
export type AffiliateAuditConnection = {
  __typename?: 'AffiliateAuditConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AffiliateAuditAggregates>;
  /** A list of edges which contains the `AffiliateAudit` and cursor to aid in pagination. */
  edges: Array<Maybe<AffiliateAuditEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AffiliateAuditAggregates>>;
  /** A list of `AffiliateAudit` objects. */
  nodes: Array<Maybe<AffiliateAudit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AffiliateAudit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AffiliateAudit` values. */
export type AffiliateAuditConnectionGroupedAggregatesArgs = {
  groupBy: Array<AffiliateAuditGroupBy>;
  having?: InputMaybe<AffiliateAuditHavingInput>;
};

export type AffiliateAuditDistinctCountAggregateFilter = {
  affiliateId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AffiliateAuditDistinctCountAggregates = {
  __typename?: 'AffiliateAuditDistinctCountAggregates';
  /** Distinct count of action across the matching connection */
  action?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of affiliateId across the matching connection */
  affiliateId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of message across the matching connection */
  message?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadata across the matching connection */
  metadata?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AffiliateAudit` edge in the connection. */
export type AffiliateAuditEdge = {
  __typename?: 'AffiliateAuditEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AffiliateAudit` at the end of the edge. */
  node?: Maybe<AffiliateAudit>;
};

/** A filter to be used against `AffiliateAudit` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateAuditFilter = {
  /** Filter by the object’s `affiliate` relation. */
  affiliate?: InputMaybe<AffiliateFilter>;
  /** Filter by the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AffiliateAuditFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AffiliateAuditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AffiliateAuditFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
};

/** Grouping methods for `AffiliateAudit` for usage during aggregation. */
export enum AffiliateAuditGroupBy {
  AffiliateId = 'AFFILIATE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR'
}

export type AffiliateAuditHavingAverageInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingDistinctCountInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AffiliateAudit` aggregates. */
export type AffiliateAuditHavingInput = {
  AND?: InputMaybe<Array<AffiliateAuditHavingInput>>;
  OR?: InputMaybe<Array<AffiliateAuditHavingInput>>;
  average?: InputMaybe<AffiliateAuditHavingAverageInput>;
  distinctCount?: InputMaybe<AffiliateAuditHavingDistinctCountInput>;
  max?: InputMaybe<AffiliateAuditHavingMaxInput>;
  min?: InputMaybe<AffiliateAuditHavingMinInput>;
  stddevPopulation?: InputMaybe<AffiliateAuditHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AffiliateAuditHavingStddevSampleInput>;
  sum?: InputMaybe<AffiliateAuditHavingSumInput>;
  variancePopulation?: InputMaybe<AffiliateAuditHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AffiliateAuditHavingVarianceSampleInput>;
};

export type AffiliateAuditHavingMaxInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingMinInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingStddevPopulationInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingStddevSampleInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingSumInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingVariancePopulationInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditHavingVarianceSampleInput = {
  actorAdminId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliateAuditMaxAggregates = {
  __typename?: 'AffiliateAuditMaxAggregates';
  /** Maximum of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['Int']['output']>;
};

export type AffiliateAuditMinAggregates = {
  __typename?: 'AffiliateAuditMinAggregates';
  /** Minimum of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AffiliateAudit`. */
export enum AffiliateAuditOrderBy {
  AffiliateIdAsc = 'AFFILIATE_ID_ASC',
  AffiliateIdDesc = 'AFFILIATE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AffiliateAuditStddevPopulationAggregates = {
  __typename?: 'AffiliateAuditStddevPopulationAggregates';
  /** Population standard deviation of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateAuditStddevSampleAggregates = {
  __typename?: 'AffiliateAuditStddevSampleAggregates';
  /** Sample standard deviation of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateAuditSumAggregates = {
  __typename?: 'AffiliateAuditSumAggregates';
  /** Sum of actorAdminId across the matching connection */
  actorAdminId: Scalars['BigInt']['output'];
};

export type AffiliateAuditVariancePopulationAggregates = {
  __typename?: 'AffiliateAuditVariancePopulationAggregates';
  /** Population variance of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateAuditVarianceSampleAggregates = {
  __typename?: 'AffiliateAuditVarianceSampleAggregates';
  /** Sample variance of actorAdminId across the matching connection */
  actorAdminId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateCommissionRate = Node & {
  __typename?: 'AffiliateCommissionRate';
  /** Reads a single `Affiliate` that is related to this `AffiliateCommissionRate`. */
  affiliate?: Maybe<Affiliate>;
  affiliateId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  effectiveAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  percentage: Scalars['BigFloat']['output'];
  rowId: Scalars['UUID']['output'];
};

export type AffiliateCommissionRateAggregates = {
  __typename?: 'AffiliateCommissionRateAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AffiliateCommissionRateAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AffiliateCommissionRateDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AffiliateCommissionRateMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AffiliateCommissionRateMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AffiliateCommissionRateStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AffiliateCommissionRateStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AffiliateCommissionRateSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AffiliateCommissionRateVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AffiliateCommissionRateVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AffiliateCommissionRate` object types. */
export type AffiliateCommissionRateAggregatesFilter = {
  /** Distinct count aggregate over matching `AffiliateCommissionRate` objects. */
  distinctCount?: InputMaybe<AffiliateCommissionRateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AffiliateCommissionRate` object to be included within the aggregate. */
  filter?: InputMaybe<AffiliateCommissionRateFilter>;
};

export type AffiliateCommissionRateAverageAggregates = {
  __typename?: 'AffiliateCommissionRateAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AffiliateCommissionRate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AffiliateCommissionRateCondition = {
  /** Checks for equality with the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `effectiveAt` field. */
  effectiveAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `AffiliateCommissionRate` values. */
export type AffiliateCommissionRateConnection = {
  __typename?: 'AffiliateCommissionRateConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AffiliateCommissionRateAggregates>;
  /** A list of edges which contains the `AffiliateCommissionRate` and cursor to aid in pagination. */
  edges: Array<Maybe<AffiliateCommissionRateEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AffiliateCommissionRateAggregates>>;
  /** A list of `AffiliateCommissionRate` objects. */
  nodes: Array<Maybe<AffiliateCommissionRate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AffiliateCommissionRate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AffiliateCommissionRate` values. */
export type AffiliateCommissionRateConnectionGroupedAggregatesArgs = {
  groupBy: Array<AffiliateCommissionRateGroupBy>;
  having?: InputMaybe<AffiliateCommissionRateHavingInput>;
};

export type AffiliateCommissionRateDistinctCountAggregateFilter = {
  affiliateId?: InputMaybe<BigIntFilter>;
  effectiveAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AffiliateCommissionRateDistinctCountAggregates = {
  __typename?: 'AffiliateCommissionRateDistinctCountAggregates';
  /** Distinct count of affiliateId across the matching connection */
  affiliateId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of effectiveAt across the matching connection */
  effectiveAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AffiliateCommissionRate` edge in the connection. */
export type AffiliateCommissionRateEdge = {
  __typename?: 'AffiliateCommissionRateEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AffiliateCommissionRate` at the end of the edge. */
  node?: Maybe<AffiliateCommissionRate>;
};

/** A filter to be used against `AffiliateCommissionRate` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateCommissionRateFilter = {
  /** Filter by the object’s `affiliate` relation. */
  affiliate?: InputMaybe<AffiliateFilter>;
  /** Filter by the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AffiliateCommissionRateFilter>>;
  /** Filter by the object’s `effectiveAt` field. */
  effectiveAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AffiliateCommissionRateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AffiliateCommissionRateFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
};

/** Grouping methods for `AffiliateCommissionRate` for usage during aggregation. */
export enum AffiliateCommissionRateGroupBy {
  AffiliateId = 'AFFILIATE_ID',
  EffectiveAt = 'EFFECTIVE_AT',
  EffectiveAtTruncatedToDay = 'EFFECTIVE_AT_TRUNCATED_TO_DAY',
  EffectiveAtTruncatedToHour = 'EFFECTIVE_AT_TRUNCATED_TO_HOUR'
}

export type AffiliateCommissionRateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `AffiliateCommissionRate` aggregates. */
export type AffiliateCommissionRateHavingInput = {
  AND?: InputMaybe<Array<AffiliateCommissionRateHavingInput>>;
  OR?: InputMaybe<Array<AffiliateCommissionRateHavingInput>>;
  average?: InputMaybe<AffiliateCommissionRateHavingAverageInput>;
  distinctCount?: InputMaybe<AffiliateCommissionRateHavingDistinctCountInput>;
  max?: InputMaybe<AffiliateCommissionRateHavingMaxInput>;
  min?: InputMaybe<AffiliateCommissionRateHavingMinInput>;
  stddevPopulation?: InputMaybe<AffiliateCommissionRateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AffiliateCommissionRateHavingStddevSampleInput>;
  sum?: InputMaybe<AffiliateCommissionRateHavingSumInput>;
  variancePopulation?: InputMaybe<AffiliateCommissionRateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AffiliateCommissionRateHavingVarianceSampleInput>;
};

export type AffiliateCommissionRateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  percentage?: InputMaybe<HavingBigfloatFilter>;
};

export type AffiliateCommissionRateMaxAggregates = {
  __typename?: 'AffiliateCommissionRateMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateCommissionRateMinAggregates = {
  __typename?: 'AffiliateCommissionRateMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

/** Methods to use when ordering `AffiliateCommissionRate`. */
export enum AffiliateCommissionRateOrderBy {
  AffiliateIdAsc = 'AFFILIATE_ID_ASC',
  AffiliateIdDesc = 'AFFILIATE_ID_DESC',
  EffectiveAtAsc = 'EFFECTIVE_AT_ASC',
  EffectiveAtDesc = 'EFFECTIVE_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AffiliateCommissionRateStddevPopulationAggregates = {
  __typename?: 'AffiliateCommissionRateStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateCommissionRateStddevSampleAggregates = {
  __typename?: 'AffiliateCommissionRateStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateCommissionRateSumAggregates = {
  __typename?: 'AffiliateCommissionRateSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of percentage across the matching connection */
  percentage: Scalars['BigFloat']['output'];
};

export type AffiliateCommissionRateVariancePopulationAggregates = {
  __typename?: 'AffiliateCommissionRateVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateCommissionRateVarianceSampleAggregates = {
  __typename?: 'AffiliateCommissionRateVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of percentage across the matching connection */
  percentage?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against `Affiliate` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateFilter = {
  /** Filter by the object’s `affiliateAudits` relation. */
  affiliateAudits?: InputMaybe<AffiliateToManyAffiliateAuditFilter>;
  /** Some related `affiliateAudits` exist. */
  affiliateAuditsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `affiliateCommissionRates` relation. */
  affiliateCommissionRates?: InputMaybe<AffiliateToManyAffiliateCommissionRateFilter>;
  /** Some related `affiliateCommissionRates` exist. */
  affiliateCommissionRatesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `affiliateLedgers` relation. */
  affiliateLedgers?: InputMaybe<AffiliateToManyAffiliateLedgerFilter>;
  /** Some related `affiliateLedgers` exist. */
  affiliateLedgersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `affiliatePayoutPeriods` relation. */
  affiliatePayoutPeriods?: InputMaybe<AffiliateToManyAffiliatePayoutPeriodFilter>;
  /** Some related `affiliatePayoutPeriods` exist. */
  affiliatePayoutPeriodsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AffiliateFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `coupon` relation. */
  coupon?: InputMaybe<CouponFilter>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AffiliateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AffiliateFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

export type AffiliateLedger = Node & {
  __typename?: 'AffiliateLedger';
  /** Reads a single `Affiliate` that is related to this `AffiliateLedger`. */
  affiliate?: Maybe<Affiliate>;
  affiliateId: Scalars['UUID']['output'];
  amount: Scalars['BigFloat']['output'];
  chargebackIndicatorId?: Maybe<Scalars['Int']['output']>;
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  entryType: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  occurredAt: Scalars['Datetime']['output'];
  purchaseId?: Maybe<Scalars['Int']['output']>;
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  referredUserId?: Maybe<Scalars['Int']['output']>;
  refundId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['UUID']['output'];
};

export type AffiliateLedgerAggregates = {
  __typename?: 'AffiliateLedgerAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AffiliateLedgerAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AffiliateLedgerDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AffiliateLedgerMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AffiliateLedgerMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AffiliateLedgerStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AffiliateLedgerStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AffiliateLedgerSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AffiliateLedgerVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AffiliateLedgerVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AffiliateLedger` object types. */
export type AffiliateLedgerAggregatesFilter = {
  /** Mean average aggregate over matching `AffiliateLedger` objects. */
  average?: InputMaybe<AffiliateLedgerAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AffiliateLedger` objects. */
  distinctCount?: InputMaybe<AffiliateLedgerDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AffiliateLedger` object to be included within the aggregate. */
  filter?: InputMaybe<AffiliateLedgerFilter>;
  /** Maximum aggregate over matching `AffiliateLedger` objects. */
  max?: InputMaybe<AffiliateLedgerMaxAggregateFilter>;
  /** Minimum aggregate over matching `AffiliateLedger` objects. */
  min?: InputMaybe<AffiliateLedgerMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AffiliateLedger` objects. */
  stddevPopulation?: InputMaybe<AffiliateLedgerStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AffiliateLedger` objects. */
  stddevSample?: InputMaybe<AffiliateLedgerStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AffiliateLedger` objects. */
  sum?: InputMaybe<AffiliateLedgerSumAggregateFilter>;
  /** Population variance aggregate over matching `AffiliateLedger` objects. */
  variancePopulation?: InputMaybe<AffiliateLedgerVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AffiliateLedger` objects. */
  varianceSample?: InputMaybe<AffiliateLedgerVarianceSampleAggregateFilter>;
};

export type AffiliateLedgerAverageAggregateFilter = {
  referredUserId?: InputMaybe<BigFloatFilter>;
};

export type AffiliateLedgerAverageAggregates = {
  __typename?: 'AffiliateLedgerAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundId across the matching connection */
  refundId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AffiliateLedger` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AffiliateLedgerCondition = {
  /** Checks for equality with the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `occurredAt` field. */
  occurredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `referredUserId` field. */
  referredUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `AffiliateLedger` values. */
export type AffiliateLedgerConnection = {
  __typename?: 'AffiliateLedgerConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AffiliateLedgerAggregates>;
  /** A list of edges which contains the `AffiliateLedger` and cursor to aid in pagination. */
  edges: Array<Maybe<AffiliateLedgerEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AffiliateLedgerAggregates>>;
  /** A list of `AffiliateLedger` objects. */
  nodes: Array<Maybe<AffiliateLedger>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AffiliateLedger` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AffiliateLedger` values. */
export type AffiliateLedgerConnectionGroupedAggregatesArgs = {
  groupBy: Array<AffiliateLedgerGroupBy>;
  having?: InputMaybe<AffiliateLedgerHavingInput>;
};

export type AffiliateLedgerDistinctCountAggregateFilter = {
  affiliateId?: InputMaybe<BigIntFilter>;
  occurredAt?: InputMaybe<BigIntFilter>;
  referredUserId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AffiliateLedgerDistinctCountAggregates = {
  __typename?: 'AffiliateLedgerDistinctCountAggregates';
  /** Distinct count of affiliateId across the matching connection */
  affiliateId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of entryType across the matching connection */
  entryType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of occurredAt across the matching connection */
  occurredAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundId across the matching connection */
  refundId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AffiliateLedger` edge in the connection. */
export type AffiliateLedgerEdge = {
  __typename?: 'AffiliateLedgerEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AffiliateLedger` at the end of the edge. */
  node?: Maybe<AffiliateLedger>;
};

/** A filter to be used against `AffiliateLedger` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateLedgerFilter = {
  /** Filter by the object’s `affiliate` relation. */
  affiliate?: InputMaybe<AffiliateFilter>;
  /** Filter by the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AffiliateLedgerFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AffiliateLedgerFilter>;
  /** Filter by the object’s `occurredAt` field. */
  occurredAt?: InputMaybe<DatetimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AffiliateLedgerFilter>>;
  /** Filter by the object’s `referredUserId` field. */
  referredUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
};

/** Grouping methods for `AffiliateLedger` for usage during aggregation. */
export enum AffiliateLedgerGroupBy {
  AffiliateId = 'AFFILIATE_ID',
  OccurredAt = 'OCCURRED_AT',
  OccurredAtTruncatedToDay = 'OCCURRED_AT_TRUNCATED_TO_DAY',
  OccurredAtTruncatedToHour = 'OCCURRED_AT_TRUNCATED_TO_HOUR',
  ReferredUserId = 'REFERRED_USER_ID'
}

export type AffiliateLedgerHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AffiliateLedger` aggregates. */
export type AffiliateLedgerHavingInput = {
  AND?: InputMaybe<Array<AffiliateLedgerHavingInput>>;
  OR?: InputMaybe<Array<AffiliateLedgerHavingInput>>;
  average?: InputMaybe<AffiliateLedgerHavingAverageInput>;
  distinctCount?: InputMaybe<AffiliateLedgerHavingDistinctCountInput>;
  max?: InputMaybe<AffiliateLedgerHavingMaxInput>;
  min?: InputMaybe<AffiliateLedgerHavingMinInput>;
  stddevPopulation?: InputMaybe<AffiliateLedgerHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AffiliateLedgerHavingStddevSampleInput>;
  sum?: InputMaybe<AffiliateLedgerHavingSumInput>;
  variancePopulation?: InputMaybe<AffiliateLedgerHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AffiliateLedgerHavingVarianceSampleInput>;
};

export type AffiliateLedgerHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  chargebackIndicatorId?: InputMaybe<HavingIntFilter>;
  commissionPercentage?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  occurredAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  referredUserId?: InputMaybe<HavingIntFilter>;
  refundId?: InputMaybe<HavingIntFilter>;
};

export type AffiliateLedgerMaxAggregateFilter = {
  referredUserId?: InputMaybe<IntFilter>;
};

export type AffiliateLedgerMaxAggregates = {
  __typename?: 'AffiliateLedgerMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of refundId across the matching connection */
  refundId?: Maybe<Scalars['Int']['output']>;
};

export type AffiliateLedgerMinAggregateFilter = {
  referredUserId?: InputMaybe<IntFilter>;
};

export type AffiliateLedgerMinAggregates = {
  __typename?: 'AffiliateLedgerMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of refundId across the matching connection */
  refundId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AffiliateLedger`. */
export enum AffiliateLedgerOrderBy {
  AffiliateIdAsc = 'AFFILIATE_ID_ASC',
  AffiliateIdDesc = 'AFFILIATE_ID_DESC',
  Natural = 'NATURAL',
  OccurredAtAsc = 'OCCURRED_AT_ASC',
  OccurredAtDesc = 'OCCURRED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferredUserIdAsc = 'REFERRED_USER_ID_ASC',
  ReferredUserIdDesc = 'REFERRED_USER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AffiliateLedgerStddevPopulationAggregateFilter = {
  referredUserId?: InputMaybe<BigFloatFilter>;
};

export type AffiliateLedgerStddevPopulationAggregates = {
  __typename?: 'AffiliateLedgerStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundId across the matching connection */
  refundId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateLedgerStddevSampleAggregateFilter = {
  referredUserId?: InputMaybe<BigFloatFilter>;
};

export type AffiliateLedgerStddevSampleAggregates = {
  __typename?: 'AffiliateLedgerStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundId across the matching connection */
  refundId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateLedgerSumAggregateFilter = {
  referredUserId?: InputMaybe<BigIntFilter>;
};

export type AffiliateLedgerSumAggregates = {
  __typename?: 'AffiliateLedgerSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId: Scalars['BigInt']['output'];
  /** Sum of commissionPercentage across the matching connection */
  commissionPercentage: Scalars['BigFloat']['output'];
  /** Sum of purchaseId across the matching connection */
  purchaseId: Scalars['BigInt']['output'];
  /** Sum of purchaseOrderId across the matching connection */
  purchaseOrderId: Scalars['BigInt']['output'];
  /** Sum of referredUserId across the matching connection */
  referredUserId: Scalars['BigInt']['output'];
  /** Sum of refundId across the matching connection */
  refundId: Scalars['BigInt']['output'];
};

export type AffiliateLedgerVariancePopulationAggregateFilter = {
  referredUserId?: InputMaybe<BigFloatFilter>;
};

export type AffiliateLedgerVariancePopulationAggregates = {
  __typename?: 'AffiliateLedgerVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundId across the matching connection */
  refundId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliateLedgerVarianceSampleAggregateFilter = {
  referredUserId?: InputMaybe<BigFloatFilter>;
};

export type AffiliateLedgerVarianceSampleAggregates = {
  __typename?: 'AffiliateLedgerVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of chargebackIndicatorId across the matching connection */
  chargebackIndicatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of commissionPercentage across the matching connection */
  commissionPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of referredUserId across the matching connection */
  referredUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundId across the matching connection */
  refundId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePayment = Node & {
  __typename?: 'AffiliatePayment';
  amount: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  externalReference?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  loggedBy?: Maybe<Scalars['Int']['output']>;
  method: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paidAt: Scalars['Datetime']['output'];
  /** Reads a single `AffiliatePayoutPeriod` that is related to this `AffiliatePayment`. */
  period?: Maybe<AffiliatePayoutPeriod>;
  periodId: Scalars['UUID']['output'];
  rowId: Scalars['UUID']['output'];
};

export type AffiliatePaymentAggregates = {
  __typename?: 'AffiliatePaymentAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AffiliatePaymentAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AffiliatePaymentDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AffiliatePaymentMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AffiliatePaymentMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AffiliatePaymentStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AffiliatePaymentStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AffiliatePaymentSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AffiliatePaymentVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AffiliatePaymentVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AffiliatePayment` object types. */
export type AffiliatePaymentAggregatesFilter = {
  /** Distinct count aggregate over matching `AffiliatePayment` objects. */
  distinctCount?: InputMaybe<AffiliatePaymentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AffiliatePayment` object to be included within the aggregate. */
  filter?: InputMaybe<AffiliatePaymentFilter>;
};

export type AffiliatePaymentAverageAggregates = {
  __typename?: 'AffiliatePaymentAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AffiliatePayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AffiliatePaymentCondition = {
  /** Checks for equality with the object’s `periodId` field. */
  periodId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `AffiliatePayment` values. */
export type AffiliatePaymentConnection = {
  __typename?: 'AffiliatePaymentConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AffiliatePaymentAggregates>;
  /** A list of edges which contains the `AffiliatePayment` and cursor to aid in pagination. */
  edges: Array<Maybe<AffiliatePaymentEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AffiliatePaymentAggregates>>;
  /** A list of `AffiliatePayment` objects. */
  nodes: Array<Maybe<AffiliatePayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AffiliatePayment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AffiliatePayment` values. */
export type AffiliatePaymentConnectionGroupedAggregatesArgs = {
  groupBy: Array<AffiliatePaymentGroupBy>;
  having?: InputMaybe<AffiliatePaymentHavingInput>;
};

export type AffiliatePaymentDistinctCountAggregateFilter = {
  periodId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AffiliatePaymentDistinctCountAggregates = {
  __typename?: 'AffiliatePaymentDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of externalReference across the matching connection */
  externalReference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of method across the matching connection */
  method?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of paidAt across the matching connection */
  paidAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of periodId across the matching connection */
  periodId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AffiliatePayment` edge in the connection. */
export type AffiliatePaymentEdge = {
  __typename?: 'AffiliatePaymentEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AffiliatePayment` at the end of the edge. */
  node?: Maybe<AffiliatePayment>;
};

/** A filter to be used against `AffiliatePayment` object types. All fields are combined with a logical ‘and.’ */
export type AffiliatePaymentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AffiliatePaymentFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AffiliatePaymentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AffiliatePaymentFilter>>;
  /** Filter by the object’s `period` relation. */
  period?: InputMaybe<AffiliatePayoutPeriodFilter>;
  /** Filter by the object’s `periodId` field. */
  periodId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
};

/** Grouping methods for `AffiliatePayment` for usage during aggregation. */
export enum AffiliatePaymentGroupBy {
  PeriodId = 'PERIOD_ID'
}

export type AffiliatePaymentHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AffiliatePayment` aggregates. */
export type AffiliatePaymentHavingInput = {
  AND?: InputMaybe<Array<AffiliatePaymentHavingInput>>;
  OR?: InputMaybe<Array<AffiliatePaymentHavingInput>>;
  average?: InputMaybe<AffiliatePaymentHavingAverageInput>;
  distinctCount?: InputMaybe<AffiliatePaymentHavingDistinctCountInput>;
  max?: InputMaybe<AffiliatePaymentHavingMaxInput>;
  min?: InputMaybe<AffiliatePaymentHavingMinInput>;
  stddevPopulation?: InputMaybe<AffiliatePaymentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AffiliatePaymentHavingStddevSampleInput>;
  sum?: InputMaybe<AffiliatePaymentHavingSumInput>;
  variancePopulation?: InputMaybe<AffiliatePaymentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AffiliatePaymentHavingVarianceSampleInput>;
};

export type AffiliatePaymentHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  loggedBy?: InputMaybe<HavingIntFilter>;
  paidAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePaymentMaxAggregates = {
  __typename?: 'AffiliatePaymentMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['Int']['output']>;
};

export type AffiliatePaymentMinAggregates = {
  __typename?: 'AffiliatePaymentMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `AffiliatePayment`. */
export enum AffiliatePaymentOrderBy {
  Natural = 'NATURAL',
  PeriodIdAsc = 'PERIOD_ID_ASC',
  PeriodIdDesc = 'PERIOD_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AffiliatePaymentStddevPopulationAggregates = {
  __typename?: 'AffiliatePaymentStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePaymentStddevSampleAggregates = {
  __typename?: 'AffiliatePaymentStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePaymentSumAggregates = {
  __typename?: 'AffiliatePaymentSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of loggedBy across the matching connection */
  loggedBy: Scalars['BigInt']['output'];
};

export type AffiliatePaymentVariancePopulationAggregates = {
  __typename?: 'AffiliatePaymentVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePaymentVarianceSampleAggregates = {
  __typename?: 'AffiliatePaymentVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loggedBy across the matching connection */
  loggedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePayoutPeriod = Node & {
  __typename?: 'AffiliatePayoutPeriod';
  /** Reads a single `Affiliate` that is related to this `AffiliatePayoutPeriod`. */
  affiliate?: Maybe<Affiliate>;
  affiliateId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `AffiliatePayment`. */
  affiliatePaymentsByPeriodId: AffiliatePaymentConnection;
  carryInAmount: Scalars['BigFloat']['output'];
  clawedBackAmount: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  creditedAmount: Scalars['BigFloat']['output'];
  dueOn: Scalars['Date']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  netAmount: Scalars['BigFloat']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  rowId: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type AffiliatePayoutPeriodAffiliatePaymentsByPeriodIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AffiliatePaymentCondition>;
  filter?: InputMaybe<AffiliatePaymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AffiliatePaymentOrderBy>>;
};

export type AffiliatePayoutPeriodAggregates = {
  __typename?: 'AffiliatePayoutPeriodAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AffiliatePayoutPeriodAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AffiliatePayoutPeriodDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AffiliatePayoutPeriodMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AffiliatePayoutPeriodMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AffiliatePayoutPeriodStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AffiliatePayoutPeriodStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AffiliatePayoutPeriodSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AffiliatePayoutPeriodVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AffiliatePayoutPeriodVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AffiliatePayoutPeriod` object types. */
export type AffiliatePayoutPeriodAggregatesFilter = {
  /** Distinct count aggregate over matching `AffiliatePayoutPeriod` objects. */
  distinctCount?: InputMaybe<AffiliatePayoutPeriodDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AffiliatePayoutPeriod` object to be included within the aggregate. */
  filter?: InputMaybe<AffiliatePayoutPeriodFilter>;
};

export type AffiliatePayoutPeriodAverageAggregates = {
  __typename?: 'AffiliatePayoutPeriodAverageAggregates';
  /** Mean average of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AffiliatePayoutPeriod` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AffiliatePayoutPeriodCondition = {
  /** Checks for equality with the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `periodStart` field. */
  periodStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `AffiliatePayoutPeriod` values. */
export type AffiliatePayoutPeriodConnection = {
  __typename?: 'AffiliatePayoutPeriodConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AffiliatePayoutPeriodAggregates>;
  /** A list of edges which contains the `AffiliatePayoutPeriod` and cursor to aid in pagination. */
  edges: Array<Maybe<AffiliatePayoutPeriodEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AffiliatePayoutPeriodAggregates>>;
  /** A list of `AffiliatePayoutPeriod` objects. */
  nodes: Array<Maybe<AffiliatePayoutPeriod>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AffiliatePayoutPeriod` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AffiliatePayoutPeriod` values. */
export type AffiliatePayoutPeriodConnectionGroupedAggregatesArgs = {
  groupBy: Array<AffiliatePayoutPeriodGroupBy>;
  having?: InputMaybe<AffiliatePayoutPeriodHavingInput>;
};

export type AffiliatePayoutPeriodDistinctCountAggregateFilter = {
  affiliateId?: InputMaybe<BigIntFilter>;
  periodStart?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type AffiliatePayoutPeriodDistinctCountAggregates = {
  __typename?: 'AffiliatePayoutPeriodDistinctCountAggregates';
  /** Distinct count of affiliateId across the matching connection */
  affiliateId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dueOn across the matching connection */
  dueOn?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of periodEnd across the matching connection */
  periodEnd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of periodStart across the matching connection */
  periodStart?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `AffiliatePayoutPeriod` edge in the connection. */
export type AffiliatePayoutPeriodEdge = {
  __typename?: 'AffiliatePayoutPeriodEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AffiliatePayoutPeriod` at the end of the edge. */
  node?: Maybe<AffiliatePayoutPeriod>;
};

/** A filter to be used against `AffiliatePayoutPeriod` object types. All fields are combined with a logical ‘and.’ */
export type AffiliatePayoutPeriodFilter = {
  /** Filter by the object’s `affiliate` relation. */
  affiliate?: InputMaybe<AffiliateFilter>;
  /** Filter by the object’s `affiliateId` field. */
  affiliateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `affiliatePaymentsByPeriodId` relation. */
  affiliatePaymentsByPeriodId?: InputMaybe<AffiliatePayoutPeriodToManyAffiliatePaymentFilter>;
  /** Some related `affiliatePaymentsByPeriodId` exist. */
  affiliatePaymentsByPeriodIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AffiliatePayoutPeriodFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AffiliatePayoutPeriodFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AffiliatePayoutPeriodFilter>>;
  /** Filter by the object’s `periodStart` field. */
  periodStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
};

/** Grouping methods for `AffiliatePayoutPeriod` for usage during aggregation. */
export enum AffiliatePayoutPeriodGroupBy {
  AffiliateId = 'AFFILIATE_ID',
  PeriodStart = 'PERIOD_START'
}

export type AffiliatePayoutPeriodHavingAverageInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingDistinctCountInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AffiliatePayoutPeriod` aggregates. */
export type AffiliatePayoutPeriodHavingInput = {
  AND?: InputMaybe<Array<AffiliatePayoutPeriodHavingInput>>;
  OR?: InputMaybe<Array<AffiliatePayoutPeriodHavingInput>>;
  average?: InputMaybe<AffiliatePayoutPeriodHavingAverageInput>;
  distinctCount?: InputMaybe<AffiliatePayoutPeriodHavingDistinctCountInput>;
  max?: InputMaybe<AffiliatePayoutPeriodHavingMaxInput>;
  min?: InputMaybe<AffiliatePayoutPeriodHavingMinInput>;
  stddevPopulation?: InputMaybe<AffiliatePayoutPeriodHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AffiliatePayoutPeriodHavingStddevSampleInput>;
  sum?: InputMaybe<AffiliatePayoutPeriodHavingSumInput>;
  variancePopulation?: InputMaybe<AffiliatePayoutPeriodHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AffiliatePayoutPeriodHavingVarianceSampleInput>;
};

export type AffiliatePayoutPeriodHavingMaxInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingMinInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingStddevPopulationInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingStddevSampleInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingSumInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingVariancePopulationInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodHavingVarianceSampleInput = {
  carryInAmount?: InputMaybe<HavingBigfloatFilter>;
  clawedBackAmount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  creditedAmount?: InputMaybe<HavingBigfloatFilter>;
  dueOn?: InputMaybe<HavingDatetimeFilter>;
  netAmount?: InputMaybe<HavingBigfloatFilter>;
  periodEnd?: InputMaybe<HavingDatetimeFilter>;
  periodStart?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AffiliatePayoutPeriodMaxAggregates = {
  __typename?: 'AffiliatePayoutPeriodMaxAggregates';
  /** Maximum of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePayoutPeriodMinAggregates = {
  __typename?: 'AffiliatePayoutPeriodMinAggregates';
  /** Minimum of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** Methods to use when ordering `AffiliatePayoutPeriod`. */
export enum AffiliatePayoutPeriodOrderBy {
  AffiliateIdAsc = 'AFFILIATE_ID_ASC',
  AffiliateIdDesc = 'AFFILIATE_ID_DESC',
  AffiliatePaymentsByPeriodIdCountAsc = 'AFFILIATE_PAYMENTS_BY_PERIOD_ID_COUNT_ASC',
  AffiliatePaymentsByPeriodIdCountDesc = 'AFFILIATE_PAYMENTS_BY_PERIOD_ID_COUNT_DESC',
  AffiliatePaymentsByPeriodIdDistinctCountPeriodIdAsc = 'AFFILIATE_PAYMENTS_BY_PERIOD_ID_DISTINCT_COUNT_PERIOD_ID_ASC',
  AffiliatePaymentsByPeriodIdDistinctCountPeriodIdDesc = 'AFFILIATE_PAYMENTS_BY_PERIOD_ID_DISTINCT_COUNT_PERIOD_ID_DESC',
  AffiliatePaymentsByPeriodIdDistinctCountRowIdAsc = 'AFFILIATE_PAYMENTS_BY_PERIOD_ID_DISTINCT_COUNT_ROW_ID_ASC',
  AffiliatePaymentsByPeriodIdDistinctCountRowIdDesc = 'AFFILIATE_PAYMENTS_BY_PERIOD_ID_DISTINCT_COUNT_ROW_ID_DESC',
  Natural = 'NATURAL',
  PeriodStartAsc = 'PERIOD_START_ASC',
  PeriodStartDesc = 'PERIOD_START_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type AffiliatePayoutPeriodStddevPopulationAggregates = {
  __typename?: 'AffiliatePayoutPeriodStddevPopulationAggregates';
  /** Population standard deviation of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePayoutPeriodStddevSampleAggregates = {
  __typename?: 'AffiliatePayoutPeriodStddevSampleAggregates';
  /** Sample standard deviation of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePayoutPeriodSumAggregates = {
  __typename?: 'AffiliatePayoutPeriodSumAggregates';
  /** Sum of carryInAmount across the matching connection */
  carryInAmount: Scalars['BigFloat']['output'];
  /** Sum of clawedBackAmount across the matching connection */
  clawedBackAmount: Scalars['BigFloat']['output'];
  /** Sum of creditedAmount across the matching connection */
  creditedAmount: Scalars['BigFloat']['output'];
  /** Sum of netAmount across the matching connection */
  netAmount: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `AffiliatePayment` object types. All fields are combined with a logical ‘and.’ */
export type AffiliatePayoutPeriodToManyAffiliatePaymentFilter = {
  /** Aggregates across related `AffiliatePayment` match the filter criteria. */
  aggregates?: InputMaybe<AffiliatePaymentAggregatesFilter>;
  /** Every related `AffiliatePayment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AffiliatePaymentFilter>;
  /** No related `AffiliatePayment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AffiliatePaymentFilter>;
  /** Some related `AffiliatePayment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AffiliatePaymentFilter>;
};

export type AffiliatePayoutPeriodVariancePopulationAggregates = {
  __typename?: 'AffiliatePayoutPeriodVariancePopulationAggregates';
  /** Population variance of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type AffiliatePayoutPeriodVarianceSampleAggregates = {
  __typename?: 'AffiliatePayoutPeriodVarianceSampleAggregates';
  /** Sample variance of carryInAmount across the matching connection */
  carryInAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of clawedBackAmount across the matching connection */
  clawedBackAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of creditedAmount across the matching connection */
  creditedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of netAmount across the matching connection */
  netAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against many `AffiliateAudit` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateToManyAffiliateAuditFilter = {
  /** Aggregates across related `AffiliateAudit` match the filter criteria. */
  aggregates?: InputMaybe<AffiliateAuditAggregatesFilter>;
  /** Every related `AffiliateAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AffiliateAuditFilter>;
  /** No related `AffiliateAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AffiliateAuditFilter>;
  /** Some related `AffiliateAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AffiliateAuditFilter>;
};

/** A filter to be used against many `AffiliateCommissionRate` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateToManyAffiliateCommissionRateFilter = {
  /** Aggregates across related `AffiliateCommissionRate` match the filter criteria. */
  aggregates?: InputMaybe<AffiliateCommissionRateAggregatesFilter>;
  /** Every related `AffiliateCommissionRate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AffiliateCommissionRateFilter>;
  /** No related `AffiliateCommissionRate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AffiliateCommissionRateFilter>;
  /** Some related `AffiliateCommissionRate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AffiliateCommissionRateFilter>;
};

/** A filter to be used against many `AffiliateLedger` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateToManyAffiliateLedgerFilter = {
  /** Aggregates across related `AffiliateLedger` match the filter criteria. */
  aggregates?: InputMaybe<AffiliateLedgerAggregatesFilter>;
  /** Every related `AffiliateLedger` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AffiliateLedgerFilter>;
  /** No related `AffiliateLedger` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AffiliateLedgerFilter>;
  /** Some related `AffiliateLedger` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AffiliateLedgerFilter>;
};

/** A filter to be used against many `AffiliatePayoutPeriod` object types. All fields are combined with a logical ‘and.’ */
export type AffiliateToManyAffiliatePayoutPeriodFilter = {
  /** Aggregates across related `AffiliatePayoutPeriod` match the filter criteria. */
  aggregates?: InputMaybe<AffiliatePayoutPeriodAggregatesFilter>;
  /** Every related `AffiliatePayoutPeriod` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AffiliatePayoutPeriodFilter>;
  /** No related `AffiliatePayoutPeriod` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AffiliatePayoutPeriodFilter>;
  /** Some related `AffiliatePayoutPeriod` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AffiliatePayoutPeriodFilter>;
};

/** A connection to a list of `AggregateAccountTradeStatByDayRecord` values. */
export type AggregateAccountTradeStatByDayConnection = {
  __typename?: 'AggregateAccountTradeStatByDayConnection';
  /** A list of edges which contains the `AggregateAccountTradeStatByDayRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<AggregateAccountTradeStatByDayEdge>>;
  /** A list of `AggregateAccountTradeStatByDayRecord` objects. */
  nodes: Array<Maybe<AggregateAccountTradeStatByDayRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AggregateAccountTradeStatByDayRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AggregateAccountTradeStatByDayRecord` edge in the connection. */
export type AggregateAccountTradeStatByDayEdge = {
  __typename?: 'AggregateAccountTradeStatByDayEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AggregateAccountTradeStatByDayRecord` at the end of the edge. */
  node?: Maybe<AggregateAccountTradeStatByDayRecord>;
};

export type AggregateAccountTradeStatByDayRecord = {
  __typename?: 'AggregateAccountTradeStatByDayRecord';
  avgLosingTrade?: Maybe<Scalars['BigFloat']['output']>;
  avgWinningTrade?: Maybe<Scalars['BigFloat']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  maxAvgLosingDuration?: Maybe<Interval>;
  maxAvgWinningDuration?: Maybe<Interval>;
  maxConsecutiveLosses?: Maybe<Scalars['Int']['output']>;
  maxConsecutiveWins?: Maybe<Scalars['Int']['output']>;
  minAvgLosingDuration?: Maybe<Interval>;
  minAvgWinningDuration?: Maybe<Interval>;
  netPnl?: Maybe<Scalars['BigFloat']['output']>;
  pnlHigh?: Maybe<Scalars['BigFloat']['output']>;
  pnlLow?: Maybe<Scalars['BigFloat']['output']>;
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  totalContracts?: Maybe<Scalars['Int']['output']>;
  totalFees?: Maybe<Scalars['BigFloat']['output']>;
  totalLosingTrades?: Maybe<Scalars['Int']['output']>;
  totalPnl?: Maybe<Scalars['BigFloat']['output']>;
  totalTrades?: Maybe<Scalars['Int']['output']>;
  totalWinningTrades?: Maybe<Scalars['Int']['output']>;
  tradingDay?: Maybe<Scalars['Datetime']['output']>;
  winningTradePercentage?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against `AggregateAccountTradeStatByDayRecord` object types. All fields are combined with a logical ‘and.’ */
export type AggregateAccountTradeStatByDayRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AggregateAccountTradeStatByDayRecordFilter>>;
  /** Filter by the object’s `avgLosingTrade` field. */
  avgLosingTrade?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgWinningTrade` field. */
  avgWinningTrade?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `contractName` field. */
  contractName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `maxAvgLosingDuration` field. */
  maxAvgLosingDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `maxAvgWinningDuration` field. */
  maxAvgWinningDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `maxConsecutiveLosses` field. */
  maxConsecutiveLosses?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxConsecutiveWins` field. */
  maxConsecutiveWins?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minAvgLosingDuration` field. */
  minAvgLosingDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `minAvgWinningDuration` field. */
  minAvgWinningDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `netPnl` field. */
  netPnl?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AggregateAccountTradeStatByDayRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AggregateAccountTradeStatByDayRecordFilter>>;
  /** Filter by the object’s `pnlHigh` field. */
  pnlHigh?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `pnlLow` field. */
  pnlLow?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectXAccountId` field. */
  projectXAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalContracts` field. */
  totalContracts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalFees` field. */
  totalFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalLosingTrades` field. */
  totalLosingTrades?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalPnl` field. */
  totalPnl?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalTrades` field. */
  totalTrades?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalWinningTrades` field. */
  totalWinningTrades?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tradingDay` field. */
  tradingDay?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `winningTradePercentage` field. */
  winningTradePercentage?: InputMaybe<BigFloatFilter>;
};

export type AwsdmsChanges3728E4207De1F2E6 = Node & {
  __typename?: 'AwsdmsChanges3728E4207De1F2E6';
  col1?: Maybe<Scalars['String']['output']>;
  col2?: Maybe<Scalars['String']['output']>;
  col3?: Maybe<Scalars['String']['output']>;
  col4?: Maybe<Scalars['String']['output']>;
  col5?: Maybe<Scalars['String']['output']>;
  col6?: Maybe<Scalars['String']['output']>;
  col7?: Maybe<Scalars['String']['output']>;
  col8?: Maybe<Scalars['String']['output']>;
  col9?: Maybe<Scalars['String']['output']>;
  col10?: Maybe<Scalars['String']['output']>;
  col11?: Maybe<Scalars['String']['output']>;
  col12?: Maybe<Scalars['String']['output']>;
  col13?: Maybe<Scalars['String']['output']>;
  col14?: Maybe<Scalars['String']['output']>;
  col15?: Maybe<Scalars['String']['output']>;
  col16?: Maybe<Scalars['String']['output']>;
  col17?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  seg1?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
};

export type AwsdmsDdlAudit = Node & {
  __typename?: 'AwsdmsDdlAudit';
  cDdlqry?: Maybe<Scalars['String']['output']>;
  cKey: Scalars['BigInt']['output'];
  cName?: Maybe<Scalars['String']['output']>;
  cOid?: Maybe<Scalars['Int']['output']>;
  cSchema?: Maybe<Scalars['String']['output']>;
  cTag?: Maybe<Scalars['String']['output']>;
  cTime?: Maybe<Scalars['Datetime']['output']>;
  cTxn?: Maybe<Scalars['String']['output']>;
  cUser?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
};

export type AwsdmsHeartbeat = Node & {
  __typename?: 'AwsdmsHeartbeat';
  hbCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  hbCreatedBy?: Maybe<Scalars['String']['output']>;
  hbKey: Scalars['Int']['output'];
  hbLastHeartbeatAt?: Maybe<Scalars['Datetime']['output']>;
  hbLastHeartbeatBy?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
};

export type BatchExecution = Node & {
  __typename?: 'BatchExecution';
  batchType: BatchExecutionBatchtypeEnum;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Array of entity IDs that were actually processed (after deduplication) */
  entityIds: Scalars['JSON']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Additional metadata about the batch execution */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Array of entity IDs that were originally found for processing */
  originalEntityIds: Scalars['JSON']['output'];
  rowId: Scalars['Int']['output'];
  startedAt: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export enum BatchExecutionBatchtypeEnum {
  TradeDataBackfill = 'TRADE_DATA_BACKFILL'
}

export type BestTradingDay = {
  __typename?: 'BestTradingDay';
  averageLosingTrade: Scalars['Float']['output'];
  averageTradeDuration?: Maybe<Scalars['String']['output']>;
  averageWinningTrade: Scalars['Float']['output'];
  bestDayDate?: Maybe<Scalars['String']['output']>;
  bestDayProfit: Scalars['Float']['output'];
  consistency: Scalars['Float']['output'];
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  profitFactor: Scalars['Float']['output'];
  tradeWinPercentage: Scalars['Float']['output'];
  tradingSession?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BulkAction = Node & {
  __typename?: 'BulkAction';
  actionType: Scalars['String']['output'];
  actorId: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  configuration?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Datetime']['output'];
  entityIds: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  submittedAt: Scalars['Datetime']['output'];
  workflowId: Scalars['String']['output'];
};

export type BulkCapitalUploadInput = {
  /** Labels the batch for audit, e.g. sisu-2026-W34. Not an idempotency key. */
  batchLabel: Scalars['String']['input'];
  /**
   * The raw Sigma export, verbatim. Parsed server-side so the preview and the
   * apply see identical rows and a column rename is a backend change.
   */
  csv: Scalars['String']['input'];
  /** Validate and report without writing. Defaults to true. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Chosen once for the whole file, never per row: the bucket is derived from
   * it, so a per-row type could move money between buckets unnoticed.
   * One of sisu_level_unlock or octagon_bonus.
   */
  entryType: Scalars['String']['input'];
  /**
   * One UUID for the whole file, kept by the client across retries. Per-row
   * idempotency keys are derived from it, so re-sending the same upload after
   * a timeout replays inertly instead of posting the batch twice. Send a NEW
   * value when the file itself has been edited.
   */
  requestId: Scalars['String']['input'];
};

/**
 * Counts by outcome, then the per-row detail. A preview leads with rowsRead and
 * appliedAmount.
 */
export type BulkCapitalUploadPayload = {
  __typename?: 'BulkCapitalUploadPayload';
  applied: Scalars['Int']['output'];
  /** Total across applied rows. */
  appliedAmount: Scalars['Float']['output'];
  batchLabel: Scalars['String']['output'];
  dryRun: Scalars['Boolean']['output'];
  entryType: Scalars['String']['output'];
  failed: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  rows: Array<BulkCapitalUploadRowResult>;
  rowsRead: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

/**
 * One row's fate in a bulk upload. rowNumber is 1-based into the uploaded
 * file so an admin can find the offending line.
 */
export type BulkCapitalUploadRowResult = {
  __typename?: 'BulkCapitalUploadRowResult';
  accountId?: Maybe<Scalars['Int']['output']>;
  accountName: Scalars['String']['output'];
  /** Normalized from the file's formatted figure; null when unreadable. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** An AccountCapitalError code when the row was rejected. */
  code?: Maybe<Scalars['String']['output']>;
  entryId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** applied, rejected, skipped, or failed. */
  outcome: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  sisuLevel?: Maybe<Scalars['Int']['output']>;
};

/** Input for bypassing TIN validation on a user tax form */
export type BypassUserTaxFormValidationInput = {
  /** Reason for enabling bypass (required) */
  reason: Scalars['String']['input'];
  /** UserTaxForms ID to enable bypass for */
  userTaxFormId: Scalars['Int']['input'];
};

/** Result of bypassing TIN validation */
export type BypassUserTaxFormValidationResult = {
  __typename?: 'BypassUserTaxFormValidationResult';
  /** Status message */
  message: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type CardTransaction = Node & {
  __typename?: 'CardTransaction';
  amount: Scalars['BigFloat']['output'];
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingRegion?: Maybe<Scalars['String']['output']>;
  billingStreet?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  bin?: Maybe<Scalars['String']['output']>;
  ccCardNumber?: Maybe<Scalars['String']['output']>;
  ccExpMonth?: Maybe<Scalars['String']['output']>;
  ccExpYear?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  gateway: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  nuveiPaymentId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  stripePaymentId?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `CardTransaction`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type CardTransactionAggregates = {
  __typename?: 'CardTransactionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CardTransactionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CardTransactionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CardTransactionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CardTransactionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CardTransactionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CardTransactionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CardTransactionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CardTransactionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CardTransactionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CardTransaction` object types. */
export type CardTransactionAggregatesFilter = {
  /** Mean average aggregate over matching `CardTransaction` objects. */
  average?: InputMaybe<CardTransactionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CardTransaction` objects. */
  distinctCount?: InputMaybe<CardTransactionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CardTransaction` object to be included within the aggregate. */
  filter?: InputMaybe<CardTransactionFilter>;
  /** Maximum aggregate over matching `CardTransaction` objects. */
  max?: InputMaybe<CardTransactionMaxAggregateFilter>;
  /** Minimum aggregate over matching `CardTransaction` objects. */
  min?: InputMaybe<CardTransactionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CardTransaction` objects. */
  stddevPopulation?: InputMaybe<CardTransactionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CardTransaction` objects. */
  stddevSample?: InputMaybe<CardTransactionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CardTransaction` objects. */
  sum?: InputMaybe<CardTransactionSumAggregateFilter>;
  /** Population variance aggregate over matching `CardTransaction` objects. */
  variancePopulation?: InputMaybe<CardTransactionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CardTransaction` objects. */
  varianceSample?: InputMaybe<CardTransactionVarianceSampleAggregateFilter>;
};

export type CardTransactionAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CardTransactionAverageAggregates = {
  __typename?: 'CardTransactionAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CardTransaction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CardTransactionCondition = {
  /** Checks for equality with the object’s `ccCardNumber` field. */
  ccCardNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `nuveiPaymentId` field. */
  nuveiPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stripePaymentId` field. */
  stripePaymentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CardTransaction` values. */
export type CardTransactionConnection = {
  __typename?: 'CardTransactionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CardTransactionAggregates>;
  /** A list of edges which contains the `CardTransaction` and cursor to aid in pagination. */
  edges: Array<Maybe<CardTransactionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CardTransactionAggregates>>;
  /** A list of `CardTransaction` objects. */
  nodes: Array<Maybe<CardTransaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardTransaction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CardTransaction` values. */
export type CardTransactionConnectionGroupedAggregatesArgs = {
  groupBy: Array<CardTransactionGroupBy>;
  having?: InputMaybe<CardTransactionHavingInput>;
};

export type CardTransactionDistinctCountAggregateFilter = {
  ccCardNumber?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  nuveiPaymentId?: InputMaybe<BigIntFilter>;
  result?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  stripePaymentId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CardTransactionDistinctCountAggregates = {
  __typename?: 'CardTransactionDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingCity across the matching connection */
  billingCity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingCountry across the matching connection */
  billingCountry?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingRegion across the matching connection */
  billingRegion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingStreet across the matching connection */
  billingStreet?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingZip across the matching connection */
  billingZip?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bin across the matching connection */
  bin?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccCardNumber across the matching connection */
  ccCardNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccExpMonth across the matching connection */
  ccExpMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccExpYear across the matching connection */
  ccExpYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of errorDescription across the matching connection */
  errorDescription?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiPaymentId across the matching connection */
  nuveiPaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of result across the matching connection */
  result?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stripePaymentId across the matching connection */
  stripePaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tax across the matching connection */
  tax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of total across the matching connection */
  total?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CardTransaction` edge in the connection. */
export type CardTransactionEdge = {
  __typename?: 'CardTransactionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardTransaction` at the end of the edge. */
  node?: Maybe<CardTransaction>;
};

/** A filter to be used against `CardTransaction` object types. All fields are combined with a logical ‘and.’ */
export type CardTransactionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardTransactionFilter>>;
  /** Filter by the object’s `ccCardNumber` field. */
  ccCardNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardTransactionFilter>;
  /** Filter by the object’s `nuveiPaymentId` field. */
  nuveiPaymentId?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardTransactionFilter>>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stripePaymentId` field. */
  stripePaymentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CardTransaction` for usage during aggregation. */
export enum CardTransactionGroupBy {
  CcCardNumber = 'CC_CARD_NUMBER',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Result = 'RESULT',
  UserId = 'USER_ID'
}

export type CardTransactionHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CardTransaction` aggregates. */
export type CardTransactionHavingInput = {
  AND?: InputMaybe<Array<CardTransactionHavingInput>>;
  OR?: InputMaybe<Array<CardTransactionHavingInput>>;
  average?: InputMaybe<CardTransactionHavingAverageInput>;
  distinctCount?: InputMaybe<CardTransactionHavingDistinctCountInput>;
  max?: InputMaybe<CardTransactionHavingMaxInput>;
  min?: InputMaybe<CardTransactionHavingMinInput>;
  stddevPopulation?: InputMaybe<CardTransactionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CardTransactionHavingStddevSampleInput>;
  sum?: InputMaybe<CardTransactionHavingSumInput>;
  variancePopulation?: InputMaybe<CardTransactionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CardTransactionHavingVarianceSampleInput>;
};

export type CardTransactionHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CardTransactionMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CardTransactionMaxAggregates = {
  __typename?: 'CardTransactionMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of gateway across the matching connection */
  gateway?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CardTransactionMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CardTransactionMinAggregates = {
  __typename?: 'CardTransactionMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of gateway across the matching connection */
  gateway?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CardTransaction`. */
export enum CardTransactionOrderBy {
  CcCardNumberAsc = 'CC_CARD_NUMBER_ASC',
  CcCardNumberDesc = 'CC_CARD_NUMBER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  NuveiPaymentIdAsc = 'NUVEI_PAYMENT_ID_ASC',
  NuveiPaymentIdDesc = 'NUVEI_PAYMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StripePaymentIdAsc = 'STRIPE_PAYMENT_ID_ASC',
  StripePaymentIdDesc = 'STRIPE_PAYMENT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type CardTransactionStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CardTransactionStddevPopulationAggregates = {
  __typename?: 'CardTransactionStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CardTransactionStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CardTransactionStddevSampleAggregates = {
  __typename?: 'CardTransactionStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CardTransactionSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CardTransactionSumAggregates = {
  __typename?: 'CardTransactionSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of gateway across the matching connection */
  gateway: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of tax across the matching connection */
  tax: Scalars['BigFloat']['output'];
  /** Sum of total across the matching connection */
  total: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type CardTransactionVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CardTransactionVariancePopulationAggregates = {
  __typename?: 'CardTransactionVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CardTransactionVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CardTransactionVarianceSampleAggregates = {
  __typename?: 'CardTransactionVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseAssignableUser = {
  __typename?: 'CaseAssignableUser';
  departments: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CaseBan = Node & {
  __typename?: 'CaseBan';
  assignedTo?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `CaseBanReasonCode`. */
  caseBanReasonCodes: CaseBanReasonCodeConnection;
  /** Reads and enables pagination through a set of `CaseBanTrader`. */
  caseBanTraders: CaseBanTraderConnection;
  /** Reads and enables pagination through a set of `CaseEvent`. */
  caseEvents: CaseEventConnection;
  /** Reads and enables pagination through a set of `CaseLabelAssignment`. */
  caseLabelAssignments: CaseLabelAssignmentConnection;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  departmentGroupId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  severity: CaseSeverity;
  /** Reads a single `CaseInvestigation` that is related to this `CaseBan`. */
  sourceCaseInvestigation?: Maybe<CaseInvestigation>;
  sourceCaseInvestigationId?: Maybe<Scalars['Int']['output']>;
  status: CaseStatus;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


export type CaseBanCaseBanReasonCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseBanReasonCodeCondition>;
  filter?: InputMaybe<CaseBanReasonCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseBanReasonCodeOrderBy>>;
};


export type CaseBanCaseBanTradersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseBanTraderCondition>;
  filter?: InputMaybe<CaseBanTraderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseBanTraderOrderBy>>;
};


export type CaseBanCaseEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseEventCondition>;
  filter?: InputMaybe<CaseEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseEventOrderBy>>;
};


export type CaseBanCaseLabelAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseLabelAssignmentCondition>;
  filter?: InputMaybe<CaseLabelAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseLabelAssignmentOrderBy>>;
};

export type CaseBanAggregates = {
  __typename?: 'CaseBanAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseBanAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseBanDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseBanMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseBanMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseBanStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseBanStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseBanSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseBanVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseBanVarianceSampleAggregates>;
};

export type CaseBanAverageAggregates = {
  __typename?: 'CaseBanAverageAggregates';
  /** Mean average of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `CaseBan` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CaseBanCondition = {
  /** Checks for equality with the object’s `assignedTo` field. */
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `departmentGroupId` field. */
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `severity` field. */
  severity?: InputMaybe<CaseSeverity>;
  /** Checks for equality with the object’s `sourceCaseInvestigationId` field. */
  sourceCaseInvestigationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CaseStatus>;
};

/** A connection to a list of `CaseBan` values. */
export type CaseBanConnection = {
  __typename?: 'CaseBanConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseBanAggregates>;
  /** A list of edges which contains the `CaseBan` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseBanEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseBanAggregates>>;
  /** A list of `CaseBan` objects. */
  nodes: Array<Maybe<CaseBan>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseBan` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseBan` values. */
export type CaseBanConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseBanGroupBy>;
  having?: InputMaybe<CaseBanHavingInput>;
};

export type CaseBanDistinctCountAggregates = {
  __typename?: 'CaseBanDistinctCountAggregates';
  /** Distinct count of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of departmentGroupId across the matching connection */
  departmentGroupId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nickname across the matching connection */
  nickname?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of severity across the matching connection */
  severity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseBan` edge in the connection. */
export type CaseBanEdge = {
  __typename?: 'CaseBanEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseBan` at the end of the edge. */
  node?: Maybe<CaseBan>;
};

export type CaseBanEventResult = {
  __typename?: 'CaseBanEventResult';
  caseBanId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `CaseBan` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseBanFilter>>;
  /** Filter by the object’s `assignedTo` field. */
  assignedTo?: InputMaybe<IntFilter>;
  /** Filter by the object’s `caseBanReasonCodes` relation. */
  caseBanReasonCodes?: InputMaybe<CaseBanToManyCaseBanReasonCodeFilter>;
  /** Some related `caseBanReasonCodes` exist. */
  caseBanReasonCodesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `caseBanTraders` relation. */
  caseBanTraders?: InputMaybe<CaseBanToManyCaseBanTraderFilter>;
  /** Some related `caseBanTraders` exist. */
  caseBanTradersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `caseEvents` relation. */
  caseEvents?: InputMaybe<CaseBanToManyCaseEventFilter>;
  /** Some related `caseEvents` exist. */
  caseEventsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `caseLabelAssignments` relation. */
  caseLabelAssignments?: InputMaybe<CaseBanToManyCaseLabelAssignmentFilter>;
  /** Some related `caseLabelAssignments` exist. */
  caseLabelAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentGroupId` field. */
  departmentGroupId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseBanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseBanFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `severity` field. */
  severity?: InputMaybe<CaseSeverityFilter>;
  /** Filter by the object’s `sourceCaseInvestigationId` field. */
  sourceCaseInvestigationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CaseStatusFilter>;
};

/** Grouping methods for `CaseBan` for usage during aggregation. */
export enum CaseBanGroupBy {
  AssignedTo = 'ASSIGNED_TO',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  DepartmentGroupId = 'DEPARTMENT_GROUP_ID',
  Severity = 'SEVERITY',
  SourceCaseInvestigationId = 'SOURCE_CASE_INVESTIGATION_ID',
  Status = 'STATUS'
}

export type CaseBanHavingAverageInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingDistinctCountInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseBan` aggregates. */
export type CaseBanHavingInput = {
  AND?: InputMaybe<Array<CaseBanHavingInput>>;
  OR?: InputMaybe<Array<CaseBanHavingInput>>;
  average?: InputMaybe<CaseBanHavingAverageInput>;
  distinctCount?: InputMaybe<CaseBanHavingDistinctCountInput>;
  max?: InputMaybe<CaseBanHavingMaxInput>;
  min?: InputMaybe<CaseBanHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseBanHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseBanHavingStddevSampleInput>;
  sum?: InputMaybe<CaseBanHavingSumInput>;
  variancePopulation?: InputMaybe<CaseBanHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseBanHavingVarianceSampleInput>;
};

export type CaseBanHavingMaxInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingMinInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingStddevPopulationInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingStddevSampleInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingSumInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingVariancePopulationInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanHavingVarianceSampleInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceCaseInvestigationId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanMaxAggregates = {
  __typename?: 'CaseBanMaxAggregates';
  /** Maximum of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseBanMinAggregates = {
  __typename?: 'CaseBanMinAggregates';
  /** Minimum of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseBan`. */
export enum CaseBanOrderBy {
  AssignedToAsc = 'ASSIGNED_TO_ASC',
  AssignedToDesc = 'ASSIGNED_TO_DESC',
  CaseBanReasonCodesAverageCaseBanIdAsc = 'CASE_BAN_REASON_CODES_AVERAGE_CASE_BAN_ID_ASC',
  CaseBanReasonCodesAverageCaseBanIdDesc = 'CASE_BAN_REASON_CODES_AVERAGE_CASE_BAN_ID_DESC',
  CaseBanReasonCodesAverageReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC',
  CaseBanReasonCodesAverageReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC',
  CaseBanReasonCodesAverageRowIdAsc = 'CASE_BAN_REASON_CODES_AVERAGE_ROW_ID_ASC',
  CaseBanReasonCodesAverageRowIdDesc = 'CASE_BAN_REASON_CODES_AVERAGE_ROW_ID_DESC',
  CaseBanReasonCodesCountAsc = 'CASE_BAN_REASON_CODES_COUNT_ASC',
  CaseBanReasonCodesCountDesc = 'CASE_BAN_REASON_CODES_COUNT_DESC',
  CaseBanReasonCodesDistinctCountCaseBanIdAsc = 'CASE_BAN_REASON_CODES_DISTINCT_COUNT_CASE_BAN_ID_ASC',
  CaseBanReasonCodesDistinctCountCaseBanIdDesc = 'CASE_BAN_REASON_CODES_DISTINCT_COUNT_CASE_BAN_ID_DESC',
  CaseBanReasonCodesDistinctCountReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC',
  CaseBanReasonCodesDistinctCountReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC',
  CaseBanReasonCodesDistinctCountRowIdAsc = 'CASE_BAN_REASON_CODES_DISTINCT_COUNT_ROW_ID_ASC',
  CaseBanReasonCodesDistinctCountRowIdDesc = 'CASE_BAN_REASON_CODES_DISTINCT_COUNT_ROW_ID_DESC',
  CaseBanReasonCodesMaxCaseBanIdAsc = 'CASE_BAN_REASON_CODES_MAX_CASE_BAN_ID_ASC',
  CaseBanReasonCodesMaxCaseBanIdDesc = 'CASE_BAN_REASON_CODES_MAX_CASE_BAN_ID_DESC',
  CaseBanReasonCodesMaxReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_MAX_REASON_CODE_ID_ASC',
  CaseBanReasonCodesMaxReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_MAX_REASON_CODE_ID_DESC',
  CaseBanReasonCodesMaxRowIdAsc = 'CASE_BAN_REASON_CODES_MAX_ROW_ID_ASC',
  CaseBanReasonCodesMaxRowIdDesc = 'CASE_BAN_REASON_CODES_MAX_ROW_ID_DESC',
  CaseBanReasonCodesMinCaseBanIdAsc = 'CASE_BAN_REASON_CODES_MIN_CASE_BAN_ID_ASC',
  CaseBanReasonCodesMinCaseBanIdDesc = 'CASE_BAN_REASON_CODES_MIN_CASE_BAN_ID_DESC',
  CaseBanReasonCodesMinReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_MIN_REASON_CODE_ID_ASC',
  CaseBanReasonCodesMinReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_MIN_REASON_CODE_ID_DESC',
  CaseBanReasonCodesMinRowIdAsc = 'CASE_BAN_REASON_CODES_MIN_ROW_ID_ASC',
  CaseBanReasonCodesMinRowIdDesc = 'CASE_BAN_REASON_CODES_MIN_ROW_ID_DESC',
  CaseBanReasonCodesStddevPopulationCaseBanIdAsc = 'CASE_BAN_REASON_CODES_STDDEV_POPULATION_CASE_BAN_ID_ASC',
  CaseBanReasonCodesStddevPopulationCaseBanIdDesc = 'CASE_BAN_REASON_CODES_STDDEV_POPULATION_CASE_BAN_ID_DESC',
  CaseBanReasonCodesStddevPopulationReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC',
  CaseBanReasonCodesStddevPopulationReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC',
  CaseBanReasonCodesStddevPopulationRowIdAsc = 'CASE_BAN_REASON_CODES_STDDEV_POPULATION_ROW_ID_ASC',
  CaseBanReasonCodesStddevPopulationRowIdDesc = 'CASE_BAN_REASON_CODES_STDDEV_POPULATION_ROW_ID_DESC',
  CaseBanReasonCodesStddevSampleCaseBanIdAsc = 'CASE_BAN_REASON_CODES_STDDEV_SAMPLE_CASE_BAN_ID_ASC',
  CaseBanReasonCodesStddevSampleCaseBanIdDesc = 'CASE_BAN_REASON_CODES_STDDEV_SAMPLE_CASE_BAN_ID_DESC',
  CaseBanReasonCodesStddevSampleReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC',
  CaseBanReasonCodesStddevSampleReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC',
  CaseBanReasonCodesStddevSampleRowIdAsc = 'CASE_BAN_REASON_CODES_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseBanReasonCodesStddevSampleRowIdDesc = 'CASE_BAN_REASON_CODES_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseBanReasonCodesSumCaseBanIdAsc = 'CASE_BAN_REASON_CODES_SUM_CASE_BAN_ID_ASC',
  CaseBanReasonCodesSumCaseBanIdDesc = 'CASE_BAN_REASON_CODES_SUM_CASE_BAN_ID_DESC',
  CaseBanReasonCodesSumReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_SUM_REASON_CODE_ID_ASC',
  CaseBanReasonCodesSumReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_SUM_REASON_CODE_ID_DESC',
  CaseBanReasonCodesSumRowIdAsc = 'CASE_BAN_REASON_CODES_SUM_ROW_ID_ASC',
  CaseBanReasonCodesSumRowIdDesc = 'CASE_BAN_REASON_CODES_SUM_ROW_ID_DESC',
  CaseBanReasonCodesVariancePopulationCaseBanIdAsc = 'CASE_BAN_REASON_CODES_VARIANCE_POPULATION_CASE_BAN_ID_ASC',
  CaseBanReasonCodesVariancePopulationCaseBanIdDesc = 'CASE_BAN_REASON_CODES_VARIANCE_POPULATION_CASE_BAN_ID_DESC',
  CaseBanReasonCodesVariancePopulationReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC',
  CaseBanReasonCodesVariancePopulationReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC',
  CaseBanReasonCodesVariancePopulationRowIdAsc = 'CASE_BAN_REASON_CODES_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseBanReasonCodesVariancePopulationRowIdDesc = 'CASE_BAN_REASON_CODES_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseBanReasonCodesVarianceSampleCaseBanIdAsc = 'CASE_BAN_REASON_CODES_VARIANCE_SAMPLE_CASE_BAN_ID_ASC',
  CaseBanReasonCodesVarianceSampleCaseBanIdDesc = 'CASE_BAN_REASON_CODES_VARIANCE_SAMPLE_CASE_BAN_ID_DESC',
  CaseBanReasonCodesVarianceSampleReasonCodeIdAsc = 'CASE_BAN_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC',
  CaseBanReasonCodesVarianceSampleReasonCodeIdDesc = 'CASE_BAN_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC',
  CaseBanReasonCodesVarianceSampleRowIdAsc = 'CASE_BAN_REASON_CODES_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseBanReasonCodesVarianceSampleRowIdDesc = 'CASE_BAN_REASON_CODES_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseBanTradersAverageCaseBanIdAsc = 'CASE_BAN_TRADERS_AVERAGE_CASE_BAN_ID_ASC',
  CaseBanTradersAverageCaseBanIdDesc = 'CASE_BAN_TRADERS_AVERAGE_CASE_BAN_ID_DESC',
  CaseBanTradersAverageRowIdAsc = 'CASE_BAN_TRADERS_AVERAGE_ROW_ID_ASC',
  CaseBanTradersAverageRowIdDesc = 'CASE_BAN_TRADERS_AVERAGE_ROW_ID_DESC',
  CaseBanTradersAverageTraderIdAsc = 'CASE_BAN_TRADERS_AVERAGE_TRADER_ID_ASC',
  CaseBanTradersAverageTraderIdDesc = 'CASE_BAN_TRADERS_AVERAGE_TRADER_ID_DESC',
  CaseBanTradersCountAsc = 'CASE_BAN_TRADERS_COUNT_ASC',
  CaseBanTradersCountDesc = 'CASE_BAN_TRADERS_COUNT_DESC',
  CaseBanTradersDistinctCountCaseBanIdAsc = 'CASE_BAN_TRADERS_DISTINCT_COUNT_CASE_BAN_ID_ASC',
  CaseBanTradersDistinctCountCaseBanIdDesc = 'CASE_BAN_TRADERS_DISTINCT_COUNT_CASE_BAN_ID_DESC',
  CaseBanTradersDistinctCountRowIdAsc = 'CASE_BAN_TRADERS_DISTINCT_COUNT_ROW_ID_ASC',
  CaseBanTradersDistinctCountRowIdDesc = 'CASE_BAN_TRADERS_DISTINCT_COUNT_ROW_ID_DESC',
  CaseBanTradersDistinctCountTraderIdAsc = 'CASE_BAN_TRADERS_DISTINCT_COUNT_TRADER_ID_ASC',
  CaseBanTradersDistinctCountTraderIdDesc = 'CASE_BAN_TRADERS_DISTINCT_COUNT_TRADER_ID_DESC',
  CaseBanTradersMaxCaseBanIdAsc = 'CASE_BAN_TRADERS_MAX_CASE_BAN_ID_ASC',
  CaseBanTradersMaxCaseBanIdDesc = 'CASE_BAN_TRADERS_MAX_CASE_BAN_ID_DESC',
  CaseBanTradersMaxRowIdAsc = 'CASE_BAN_TRADERS_MAX_ROW_ID_ASC',
  CaseBanTradersMaxRowIdDesc = 'CASE_BAN_TRADERS_MAX_ROW_ID_DESC',
  CaseBanTradersMaxTraderIdAsc = 'CASE_BAN_TRADERS_MAX_TRADER_ID_ASC',
  CaseBanTradersMaxTraderIdDesc = 'CASE_BAN_TRADERS_MAX_TRADER_ID_DESC',
  CaseBanTradersMinCaseBanIdAsc = 'CASE_BAN_TRADERS_MIN_CASE_BAN_ID_ASC',
  CaseBanTradersMinCaseBanIdDesc = 'CASE_BAN_TRADERS_MIN_CASE_BAN_ID_DESC',
  CaseBanTradersMinRowIdAsc = 'CASE_BAN_TRADERS_MIN_ROW_ID_ASC',
  CaseBanTradersMinRowIdDesc = 'CASE_BAN_TRADERS_MIN_ROW_ID_DESC',
  CaseBanTradersMinTraderIdAsc = 'CASE_BAN_TRADERS_MIN_TRADER_ID_ASC',
  CaseBanTradersMinTraderIdDesc = 'CASE_BAN_TRADERS_MIN_TRADER_ID_DESC',
  CaseBanTradersStddevPopulationCaseBanIdAsc = 'CASE_BAN_TRADERS_STDDEV_POPULATION_CASE_BAN_ID_ASC',
  CaseBanTradersStddevPopulationCaseBanIdDesc = 'CASE_BAN_TRADERS_STDDEV_POPULATION_CASE_BAN_ID_DESC',
  CaseBanTradersStddevPopulationRowIdAsc = 'CASE_BAN_TRADERS_STDDEV_POPULATION_ROW_ID_ASC',
  CaseBanTradersStddevPopulationRowIdDesc = 'CASE_BAN_TRADERS_STDDEV_POPULATION_ROW_ID_DESC',
  CaseBanTradersStddevPopulationTraderIdAsc = 'CASE_BAN_TRADERS_STDDEV_POPULATION_TRADER_ID_ASC',
  CaseBanTradersStddevPopulationTraderIdDesc = 'CASE_BAN_TRADERS_STDDEV_POPULATION_TRADER_ID_DESC',
  CaseBanTradersStddevSampleCaseBanIdAsc = 'CASE_BAN_TRADERS_STDDEV_SAMPLE_CASE_BAN_ID_ASC',
  CaseBanTradersStddevSampleCaseBanIdDesc = 'CASE_BAN_TRADERS_STDDEV_SAMPLE_CASE_BAN_ID_DESC',
  CaseBanTradersStddevSampleRowIdAsc = 'CASE_BAN_TRADERS_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseBanTradersStddevSampleRowIdDesc = 'CASE_BAN_TRADERS_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseBanTradersStddevSampleTraderIdAsc = 'CASE_BAN_TRADERS_STDDEV_SAMPLE_TRADER_ID_ASC',
  CaseBanTradersStddevSampleTraderIdDesc = 'CASE_BAN_TRADERS_STDDEV_SAMPLE_TRADER_ID_DESC',
  CaseBanTradersSumCaseBanIdAsc = 'CASE_BAN_TRADERS_SUM_CASE_BAN_ID_ASC',
  CaseBanTradersSumCaseBanIdDesc = 'CASE_BAN_TRADERS_SUM_CASE_BAN_ID_DESC',
  CaseBanTradersSumRowIdAsc = 'CASE_BAN_TRADERS_SUM_ROW_ID_ASC',
  CaseBanTradersSumRowIdDesc = 'CASE_BAN_TRADERS_SUM_ROW_ID_DESC',
  CaseBanTradersSumTraderIdAsc = 'CASE_BAN_TRADERS_SUM_TRADER_ID_ASC',
  CaseBanTradersSumTraderIdDesc = 'CASE_BAN_TRADERS_SUM_TRADER_ID_DESC',
  CaseBanTradersVariancePopulationCaseBanIdAsc = 'CASE_BAN_TRADERS_VARIANCE_POPULATION_CASE_BAN_ID_ASC',
  CaseBanTradersVariancePopulationCaseBanIdDesc = 'CASE_BAN_TRADERS_VARIANCE_POPULATION_CASE_BAN_ID_DESC',
  CaseBanTradersVariancePopulationRowIdAsc = 'CASE_BAN_TRADERS_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseBanTradersVariancePopulationRowIdDesc = 'CASE_BAN_TRADERS_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseBanTradersVariancePopulationTraderIdAsc = 'CASE_BAN_TRADERS_VARIANCE_POPULATION_TRADER_ID_ASC',
  CaseBanTradersVariancePopulationTraderIdDesc = 'CASE_BAN_TRADERS_VARIANCE_POPULATION_TRADER_ID_DESC',
  CaseBanTradersVarianceSampleCaseBanIdAsc = 'CASE_BAN_TRADERS_VARIANCE_SAMPLE_CASE_BAN_ID_ASC',
  CaseBanTradersVarianceSampleCaseBanIdDesc = 'CASE_BAN_TRADERS_VARIANCE_SAMPLE_CASE_BAN_ID_DESC',
  CaseBanTradersVarianceSampleRowIdAsc = 'CASE_BAN_TRADERS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseBanTradersVarianceSampleRowIdDesc = 'CASE_BAN_TRADERS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseBanTradersVarianceSampleTraderIdAsc = 'CASE_BAN_TRADERS_VARIANCE_SAMPLE_TRADER_ID_ASC',
  CaseBanTradersVarianceSampleTraderIdDesc = 'CASE_BAN_TRADERS_VARIANCE_SAMPLE_TRADER_ID_DESC',
  CaseEventsAverageCaseBanIdAsc = 'CASE_EVENTS_AVERAGE_CASE_BAN_ID_ASC',
  CaseEventsAverageCaseBanIdDesc = 'CASE_EVENTS_AVERAGE_CASE_BAN_ID_DESC',
  CaseEventsAverageCaseInvestigationIdAsc = 'CASE_EVENTS_AVERAGE_CASE_INVESTIGATION_ID_ASC',
  CaseEventsAverageCaseInvestigationIdDesc = 'CASE_EVENTS_AVERAGE_CASE_INVESTIGATION_ID_DESC',
  CaseEventsAverageRowIdAsc = 'CASE_EVENTS_AVERAGE_ROW_ID_ASC',
  CaseEventsAverageRowIdDesc = 'CASE_EVENTS_AVERAGE_ROW_ID_DESC',
  CaseEventsAverageTraderUserIdAsc = 'CASE_EVENTS_AVERAGE_TRADER_USER_ID_ASC',
  CaseEventsAverageTraderUserIdDesc = 'CASE_EVENTS_AVERAGE_TRADER_USER_ID_DESC',
  CaseEventsCountAsc = 'CASE_EVENTS_COUNT_ASC',
  CaseEventsCountDesc = 'CASE_EVENTS_COUNT_DESC',
  CaseEventsDistinctCountCaseBanIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_BAN_ID_ASC',
  CaseEventsDistinctCountCaseBanIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_BAN_ID_DESC',
  CaseEventsDistinctCountCaseInvestigationIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_ASC',
  CaseEventsDistinctCountCaseInvestigationIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_DESC',
  CaseEventsDistinctCountCreatedAtAsc = 'CASE_EVENTS_DISTINCT_COUNT_CREATED_AT_ASC',
  CaseEventsDistinctCountCreatedAtDesc = 'CASE_EVENTS_DISTINCT_COUNT_CREATED_AT_DESC',
  CaseEventsDistinctCountRowIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_ROW_ID_ASC',
  CaseEventsDistinctCountRowIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_ROW_ID_DESC',
  CaseEventsDistinctCountTraderUserIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_TRADER_USER_ID_ASC',
  CaseEventsDistinctCountTraderUserIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_TRADER_USER_ID_DESC',
  CaseEventsMaxCaseBanIdAsc = 'CASE_EVENTS_MAX_CASE_BAN_ID_ASC',
  CaseEventsMaxCaseBanIdDesc = 'CASE_EVENTS_MAX_CASE_BAN_ID_DESC',
  CaseEventsMaxCaseInvestigationIdAsc = 'CASE_EVENTS_MAX_CASE_INVESTIGATION_ID_ASC',
  CaseEventsMaxCaseInvestigationIdDesc = 'CASE_EVENTS_MAX_CASE_INVESTIGATION_ID_DESC',
  CaseEventsMaxRowIdAsc = 'CASE_EVENTS_MAX_ROW_ID_ASC',
  CaseEventsMaxRowIdDesc = 'CASE_EVENTS_MAX_ROW_ID_DESC',
  CaseEventsMaxTraderUserIdAsc = 'CASE_EVENTS_MAX_TRADER_USER_ID_ASC',
  CaseEventsMaxTraderUserIdDesc = 'CASE_EVENTS_MAX_TRADER_USER_ID_DESC',
  CaseEventsMinCaseBanIdAsc = 'CASE_EVENTS_MIN_CASE_BAN_ID_ASC',
  CaseEventsMinCaseBanIdDesc = 'CASE_EVENTS_MIN_CASE_BAN_ID_DESC',
  CaseEventsMinCaseInvestigationIdAsc = 'CASE_EVENTS_MIN_CASE_INVESTIGATION_ID_ASC',
  CaseEventsMinCaseInvestigationIdDesc = 'CASE_EVENTS_MIN_CASE_INVESTIGATION_ID_DESC',
  CaseEventsMinRowIdAsc = 'CASE_EVENTS_MIN_ROW_ID_ASC',
  CaseEventsMinRowIdDesc = 'CASE_EVENTS_MIN_ROW_ID_DESC',
  CaseEventsMinTraderUserIdAsc = 'CASE_EVENTS_MIN_TRADER_USER_ID_ASC',
  CaseEventsMinTraderUserIdDesc = 'CASE_EVENTS_MIN_TRADER_USER_ID_DESC',
  CaseEventsStddevPopulationCaseBanIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_BAN_ID_ASC',
  CaseEventsStddevPopulationCaseBanIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_BAN_ID_DESC',
  CaseEventsStddevPopulationCaseInvestigationIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseEventsStddevPopulationCaseInvestigationIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseEventsStddevPopulationRowIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_ROW_ID_ASC',
  CaseEventsStddevPopulationRowIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_ROW_ID_DESC',
  CaseEventsStddevPopulationTraderUserIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_TRADER_USER_ID_ASC',
  CaseEventsStddevPopulationTraderUserIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_TRADER_USER_ID_DESC',
  CaseEventsStddevSampleCaseBanIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_BAN_ID_ASC',
  CaseEventsStddevSampleCaseBanIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_BAN_ID_DESC',
  CaseEventsStddevSampleCaseInvestigationIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseEventsStddevSampleCaseInvestigationIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseEventsStddevSampleRowIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseEventsStddevSampleRowIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseEventsStddevSampleTraderUserIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_TRADER_USER_ID_ASC',
  CaseEventsStddevSampleTraderUserIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_TRADER_USER_ID_DESC',
  CaseEventsSumCaseBanIdAsc = 'CASE_EVENTS_SUM_CASE_BAN_ID_ASC',
  CaseEventsSumCaseBanIdDesc = 'CASE_EVENTS_SUM_CASE_BAN_ID_DESC',
  CaseEventsSumCaseInvestigationIdAsc = 'CASE_EVENTS_SUM_CASE_INVESTIGATION_ID_ASC',
  CaseEventsSumCaseInvestigationIdDesc = 'CASE_EVENTS_SUM_CASE_INVESTIGATION_ID_DESC',
  CaseEventsSumRowIdAsc = 'CASE_EVENTS_SUM_ROW_ID_ASC',
  CaseEventsSumRowIdDesc = 'CASE_EVENTS_SUM_ROW_ID_DESC',
  CaseEventsSumTraderUserIdAsc = 'CASE_EVENTS_SUM_TRADER_USER_ID_ASC',
  CaseEventsSumTraderUserIdDesc = 'CASE_EVENTS_SUM_TRADER_USER_ID_DESC',
  CaseEventsVariancePopulationCaseBanIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_BAN_ID_ASC',
  CaseEventsVariancePopulationCaseBanIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_BAN_ID_DESC',
  CaseEventsVariancePopulationCaseInvestigationIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseEventsVariancePopulationCaseInvestigationIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseEventsVariancePopulationRowIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseEventsVariancePopulationRowIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseEventsVariancePopulationTraderUserIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_TRADER_USER_ID_ASC',
  CaseEventsVariancePopulationTraderUserIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_TRADER_USER_ID_DESC',
  CaseEventsVarianceSampleCaseBanIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_BAN_ID_ASC',
  CaseEventsVarianceSampleCaseBanIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_BAN_ID_DESC',
  CaseEventsVarianceSampleCaseInvestigationIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseEventsVarianceSampleCaseInvestigationIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseEventsVarianceSampleRowIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseEventsVarianceSampleRowIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseEventsVarianceSampleTraderUserIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_TRADER_USER_ID_ASC',
  CaseEventsVarianceSampleTraderUserIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_TRADER_USER_ID_DESC',
  CaseLabelAssignmentsAverageCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsAverageCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsAverageCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsAverageCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsAverageCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsAverageCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsAverageRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_ROW_ID_ASC',
  CaseLabelAssignmentsAverageRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_ROW_ID_DESC',
  CaseLabelAssignmentsCountAsc = 'CASE_LABEL_ASSIGNMENTS_COUNT_ASC',
  CaseLabelAssignmentsCountDesc = 'CASE_LABEL_ASSIGNMENTS_COUNT_DESC',
  CaseLabelAssignmentsDistinctCountCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsDistinctCountCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsDistinctCountCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsDistinctCountCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsDistinctCountCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsDistinctCountCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsDistinctCountRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_ASC',
  CaseLabelAssignmentsDistinctCountRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_DESC',
  CaseLabelAssignmentsMaxCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsMaxCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsMaxCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsMaxCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsMaxCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsMaxCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsMaxRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_ROW_ID_ASC',
  CaseLabelAssignmentsMaxRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_ROW_ID_DESC',
  CaseLabelAssignmentsMinCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsMinCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsMinCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsMinCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsMinCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsMinCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsMinRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_ROW_ID_ASC',
  CaseLabelAssignmentsMinRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_ROW_ID_DESC',
  CaseLabelAssignmentsStddevPopulationCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsStddevPopulationCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsStddevPopulationCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsStddevPopulationCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsStddevPopulationCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsStddevPopulationCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsStddevPopulationRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_ASC',
  CaseLabelAssignmentsStddevPopulationRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_DESC',
  CaseLabelAssignmentsStddevSampleCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsStddevSampleCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsStddevSampleCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsStddevSampleCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsStddevSampleCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsStddevSampleCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsStddevSampleRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseLabelAssignmentsStddevSampleRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseLabelAssignmentsSumCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsSumCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsSumCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsSumCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsSumCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsSumCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsSumRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_ROW_ID_ASC',
  CaseLabelAssignmentsSumRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_ROW_ID_DESC',
  CaseLabelAssignmentsVariancePopulationCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsVariancePopulationCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsVariancePopulationCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsVariancePopulationCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsVariancePopulationCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsVariancePopulationCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsVariancePopulationRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseLabelAssignmentsVariancePopulationRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseLabelAssignmentsVarianceSampleCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsVarianceSampleCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsVarianceSampleCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsVarianceSampleCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsVarianceSampleCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsVarianceSampleCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsVarianceSampleRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseLabelAssignmentsVarianceSampleRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DepartmentGroupIdAsc = 'DEPARTMENT_GROUP_ID_ASC',
  DepartmentGroupIdDesc = 'DEPARTMENT_GROUP_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SeverityAsc = 'SEVERITY_ASC',
  SeverityDesc = 'SEVERITY_DESC',
  SourceCaseInvestigationIdAsc = 'SOURCE_CASE_INVESTIGATION_ID_ASC',
  SourceCaseInvestigationIdDesc = 'SOURCE_CASE_INVESTIGATION_ID_DESC'
}

export enum CaseBanPayoutHold {
  Keep = 'keep',
  Reject = 'reject',
  Resume = 'resume'
}

export enum CaseBanPendingAction {
  Cleared = 'cleared',
  MarkBan = 'mark_ban',
  SubmittedForBan = 'submitted_for_ban',
  Warning = 'warning'
}

export type CaseBanReasonCode = Node & {
  __typename?: 'CaseBanReasonCode';
  /** Reads a single `CaseBan` that is related to this `CaseBanReasonCode`. */
  caseBan?: Maybe<CaseBan>;
  caseBanId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `ReasonCode` that is related to this `CaseBanReasonCode`. */
  reasonCode?: Maybe<ReasonCode>;
  reasonCodeId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
};

export type CaseBanReasonCodeAggregates = {
  __typename?: 'CaseBanReasonCodeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseBanReasonCodeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseBanReasonCodeDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseBanReasonCodeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseBanReasonCodeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseBanReasonCodeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseBanReasonCodeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseBanReasonCodeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseBanReasonCodeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseBanReasonCodeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CaseBanReasonCode` object types. */
export type CaseBanReasonCodeAggregatesFilter = {
  /** Mean average aggregate over matching `CaseBanReasonCode` objects. */
  average?: InputMaybe<CaseBanReasonCodeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CaseBanReasonCode` objects. */
  distinctCount?: InputMaybe<CaseBanReasonCodeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CaseBanReasonCode` object to be included within the aggregate. */
  filter?: InputMaybe<CaseBanReasonCodeFilter>;
  /** Maximum aggregate over matching `CaseBanReasonCode` objects. */
  max?: InputMaybe<CaseBanReasonCodeMaxAggregateFilter>;
  /** Minimum aggregate over matching `CaseBanReasonCode` objects. */
  min?: InputMaybe<CaseBanReasonCodeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CaseBanReasonCode` objects. */
  stddevPopulation?: InputMaybe<CaseBanReasonCodeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CaseBanReasonCode` objects. */
  stddevSample?: InputMaybe<CaseBanReasonCodeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CaseBanReasonCode` objects. */
  sum?: InputMaybe<CaseBanReasonCodeSumAggregateFilter>;
  /** Population variance aggregate over matching `CaseBanReasonCode` objects. */
  variancePopulation?: InputMaybe<CaseBanReasonCodeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CaseBanReasonCode` objects. */
  varianceSample?: InputMaybe<CaseBanReasonCodeVarianceSampleAggregateFilter>;
};

export type CaseBanReasonCodeAverageAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanReasonCodeAverageAggregates = {
  __typename?: 'CaseBanReasonCodeAverageAggregates';
  /** Mean average of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseBanReasonCode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CaseBanReasonCodeCondition = {
  /** Checks for equality with the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reasonCodeId` field. */
  reasonCodeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseBanReasonCode` values. */
export type CaseBanReasonCodeConnection = {
  __typename?: 'CaseBanReasonCodeConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseBanReasonCodeAggregates>;
  /** A list of edges which contains the `CaseBanReasonCode` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseBanReasonCodeEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseBanReasonCodeAggregates>>;
  /** A list of `CaseBanReasonCode` objects. */
  nodes: Array<Maybe<CaseBanReasonCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseBanReasonCode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseBanReasonCode` values. */
export type CaseBanReasonCodeConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseBanReasonCodeGroupBy>;
  having?: InputMaybe<CaseBanReasonCodeHavingInput>;
};

export type CaseBanReasonCodeDistinctCountAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  reasonCodeId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type CaseBanReasonCodeDistinctCountAggregates = {
  __typename?: 'CaseBanReasonCodeDistinctCountAggregates';
  /** Distinct count of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseBanReasonCode` edge in the connection. */
export type CaseBanReasonCodeEdge = {
  __typename?: 'CaseBanReasonCodeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseBanReasonCode` at the end of the edge. */
  node?: Maybe<CaseBanReasonCode>;
};

/** A filter to be used against `CaseBanReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanReasonCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseBanReasonCodeFilter>>;
  /** Filter by the object’s `caseBan` relation. */
  caseBan?: InputMaybe<CaseBanFilter>;
  /** Filter by the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseBanReasonCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseBanReasonCodeFilter>>;
  /** Filter by the object’s `reasonCode` relation. */
  reasonCode?: InputMaybe<ReasonCodeFilter>;
  /** Filter by the object’s `reasonCodeId` field. */
  reasonCodeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CaseBanReasonCode` for usage during aggregation. */
export enum CaseBanReasonCodeGroupBy {
  CaseBanId = 'CASE_BAN_ID',
  ReasonCodeId = 'REASON_CODE_ID'
}

export type CaseBanReasonCodeHavingAverageInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingDistinctCountInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseBanReasonCode` aggregates. */
export type CaseBanReasonCodeHavingInput = {
  AND?: InputMaybe<Array<CaseBanReasonCodeHavingInput>>;
  OR?: InputMaybe<Array<CaseBanReasonCodeHavingInput>>;
  average?: InputMaybe<CaseBanReasonCodeHavingAverageInput>;
  distinctCount?: InputMaybe<CaseBanReasonCodeHavingDistinctCountInput>;
  max?: InputMaybe<CaseBanReasonCodeHavingMaxInput>;
  min?: InputMaybe<CaseBanReasonCodeHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseBanReasonCodeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseBanReasonCodeHavingStddevSampleInput>;
  sum?: InputMaybe<CaseBanReasonCodeHavingSumInput>;
  variancePopulation?: InputMaybe<CaseBanReasonCodeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseBanReasonCodeHavingVarianceSampleInput>;
};

export type CaseBanReasonCodeHavingMaxInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingMinInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingStddevPopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingStddevSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingSumInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingVariancePopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeHavingVarianceSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseBanReasonCodeMaxAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  reasonCodeId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type CaseBanReasonCodeMaxAggregates = {
  __typename?: 'CaseBanReasonCodeMaxAggregates';
  /** Maximum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type CaseBanReasonCodeMinAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  reasonCodeId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type CaseBanReasonCodeMinAggregates = {
  __typename?: 'CaseBanReasonCodeMinAggregates';
  /** Minimum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseBanReasonCode`. */
export enum CaseBanReasonCodeOrderBy {
  CaseBanIdAsc = 'CASE_BAN_ID_ASC',
  CaseBanIdDesc = 'CASE_BAN_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonCodeIdAsc = 'REASON_CODE_ID_ASC',
  ReasonCodeIdDesc = 'REASON_CODE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type CaseBanReasonCodeStddevPopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanReasonCodeStddevPopulationAggregates = {
  __typename?: 'CaseBanReasonCodeStddevPopulationAggregates';
  /** Population standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanReasonCodeStddevSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanReasonCodeStddevSampleAggregates = {
  __typename?: 'CaseBanReasonCodeStddevSampleAggregates';
  /** Sample standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanReasonCodeSumAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  reasonCodeId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type CaseBanReasonCodeSumAggregates = {
  __typename?: 'CaseBanReasonCodeSumAggregates';
  /** Sum of caseBanId across the matching connection */
  caseBanId: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of reasonCodeId across the matching connection */
  reasonCodeId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type CaseBanReasonCodeVariancePopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanReasonCodeVariancePopulationAggregates = {
  __typename?: 'CaseBanReasonCodeVariancePopulationAggregates';
  /** Population variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanReasonCodeVarianceSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanReasonCodeVarianceSampleAggregates = {
  __typename?: 'CaseBanReasonCodeVarianceSampleAggregates';
  /** Sample variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanResult = {
  __typename?: 'CaseBanResult';
  assignedTo?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  departmentGroupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  labels: Array<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  reasonCodeIds: Array<Scalars['Int']['output']>;
  severity: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseBanStddevPopulationAggregates = {
  __typename?: 'CaseBanStddevPopulationAggregates';
  /** Population standard deviation of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanStddevSampleAggregates = {
  __typename?: 'CaseBanStddevSampleAggregates';
  /** Sample standard deviation of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanSumAggregates = {
  __typename?: 'CaseBanSumAggregates';
  /** Sum of assignedTo across the matching connection */
  assignedTo: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CaseBanReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanToManyCaseBanReasonCodeFilter = {
  /** Aggregates across related `CaseBanReasonCode` match the filter criteria. */
  aggregates?: InputMaybe<CaseBanReasonCodeAggregatesFilter>;
  /** Every related `CaseBanReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseBanReasonCodeFilter>;
  /** No related `CaseBanReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseBanReasonCodeFilter>;
  /** Some related `CaseBanReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseBanReasonCodeFilter>;
};

/** A filter to be used against many `CaseBanTrader` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanToManyCaseBanTraderFilter = {
  /** Aggregates across related `CaseBanTrader` match the filter criteria. */
  aggregates?: InputMaybe<CaseBanTraderAggregatesFilter>;
  /** Every related `CaseBanTrader` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseBanTraderFilter>;
  /** No related `CaseBanTrader` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseBanTraderFilter>;
  /** Some related `CaseBanTrader` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseBanTraderFilter>;
};

/** A filter to be used against many `CaseEvent` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanToManyCaseEventFilter = {
  /** Aggregates across related `CaseEvent` match the filter criteria. */
  aggregates?: InputMaybe<CaseEventAggregatesFilter>;
  /** Every related `CaseEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseEventFilter>;
  /** No related `CaseEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseEventFilter>;
  /** Some related `CaseEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseEventFilter>;
};

/** A filter to be used against many `CaseLabelAssignment` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanToManyCaseLabelAssignmentFilter = {
  /** Aggregates across related `CaseLabelAssignment` match the filter criteria. */
  aggregates?: InputMaybe<CaseLabelAssignmentAggregatesFilter>;
  /** Every related `CaseLabelAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseLabelAssignmentFilter>;
  /** No related `CaseLabelAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseLabelAssignmentFilter>;
  /** Some related `CaseLabelAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseLabelAssignmentFilter>;
};

export type CaseBanTrader = Node & {
  __typename?: 'CaseBanTrader';
  /** Reads a single `CaseBan` that is related to this `CaseBanTrader`. */
  caseBan?: Maybe<CaseBan>;
  caseBanId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  idvLink?: Maybe<Scalars['String']['output']>;
  intercomLink?: Maybe<Scalars['String']['output']>;
  pendingAction: CaseBanPendingAction;
  pendingActionDetails?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['Int']['output'];
  traderId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseBanTraderAggregates = {
  __typename?: 'CaseBanTraderAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseBanTraderAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseBanTraderDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseBanTraderMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseBanTraderMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseBanTraderStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseBanTraderStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseBanTraderSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseBanTraderVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseBanTraderVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CaseBanTrader` object types. */
export type CaseBanTraderAggregatesFilter = {
  /** Mean average aggregate over matching `CaseBanTrader` objects. */
  average?: InputMaybe<CaseBanTraderAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CaseBanTrader` objects. */
  distinctCount?: InputMaybe<CaseBanTraderDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CaseBanTrader` object to be included within the aggregate. */
  filter?: InputMaybe<CaseBanTraderFilter>;
  /** Maximum aggregate over matching `CaseBanTrader` objects. */
  max?: InputMaybe<CaseBanTraderMaxAggregateFilter>;
  /** Minimum aggregate over matching `CaseBanTrader` objects. */
  min?: InputMaybe<CaseBanTraderMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CaseBanTrader` objects. */
  stddevPopulation?: InputMaybe<CaseBanTraderStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CaseBanTrader` objects. */
  stddevSample?: InputMaybe<CaseBanTraderStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CaseBanTrader` objects. */
  sum?: InputMaybe<CaseBanTraderSumAggregateFilter>;
  /** Population variance aggregate over matching `CaseBanTrader` objects. */
  variancePopulation?: InputMaybe<CaseBanTraderVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CaseBanTrader` objects. */
  varianceSample?: InputMaybe<CaseBanTraderVarianceSampleAggregateFilter>;
};

export type CaseBanTraderAverageAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanTraderAverageAggregates = {
  __typename?: 'CaseBanTraderAverageAggregates';
  /** Mean average of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseBanTrader` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CaseBanTraderCondition = {
  /** Checks for equality with the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `traderId` field. */
  traderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseBanTrader` values. */
export type CaseBanTraderConnection = {
  __typename?: 'CaseBanTraderConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseBanTraderAggregates>;
  /** A list of edges which contains the `CaseBanTrader` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseBanTraderEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseBanTraderAggregates>>;
  /** A list of `CaseBanTrader` objects. */
  nodes: Array<Maybe<CaseBanTrader>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseBanTrader` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseBanTrader` values. */
export type CaseBanTraderConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseBanTraderGroupBy>;
  having?: InputMaybe<CaseBanTraderHavingInput>;
};

export type CaseBanTraderDistinctCountAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type CaseBanTraderDistinctCountAggregates = {
  __typename?: 'CaseBanTraderDistinctCountAggregates';
  /** Distinct count of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idvLink across the matching connection */
  idvLink?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intercomLink across the matching connection */
  intercomLink?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pendingAction across the matching connection */
  pendingAction?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pendingActionDetails across the matching connection */
  pendingActionDetails?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseBanTrader` edge in the connection. */
export type CaseBanTraderEdge = {
  __typename?: 'CaseBanTraderEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseBanTrader` at the end of the edge. */
  node?: Maybe<CaseBanTrader>;
};

/** A filter to be used against `CaseBanTrader` object types. All fields are combined with a logical ‘and.’ */
export type CaseBanTraderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseBanTraderFilter>>;
  /** Filter by the object’s `caseBan` relation. */
  caseBan?: InputMaybe<CaseBanFilter>;
  /** Filter by the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseBanTraderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseBanTraderFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderId` field. */
  traderId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CaseBanTrader` for usage during aggregation. */
export enum CaseBanTraderGroupBy {
  CaseBanId = 'CASE_BAN_ID',
  TraderId = 'TRADER_ID'
}

export type CaseBanTraderHavingAverageInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingDistinctCountInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseBanTrader` aggregates. */
export type CaseBanTraderHavingInput = {
  AND?: InputMaybe<Array<CaseBanTraderHavingInput>>;
  OR?: InputMaybe<Array<CaseBanTraderHavingInput>>;
  average?: InputMaybe<CaseBanTraderHavingAverageInput>;
  distinctCount?: InputMaybe<CaseBanTraderHavingDistinctCountInput>;
  max?: InputMaybe<CaseBanTraderHavingMaxInput>;
  min?: InputMaybe<CaseBanTraderHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseBanTraderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseBanTraderHavingStddevSampleInput>;
  sum?: InputMaybe<CaseBanTraderHavingSumInput>;
  variancePopulation?: InputMaybe<CaseBanTraderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseBanTraderHavingVarianceSampleInput>;
};

export type CaseBanTraderHavingMaxInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingMinInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingStddevPopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingStddevSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingSumInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingVariancePopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderHavingVarianceSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseBanTraderMaxAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type CaseBanTraderMaxAggregates = {
  __typename?: 'CaseBanTraderMaxAggregates';
  /** Maximum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseBanTraderMinAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type CaseBanTraderMinAggregates = {
  __typename?: 'CaseBanTraderMinAggregates';
  /** Minimum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseBanTrader`. */
export enum CaseBanTraderOrderBy {
  CaseBanIdAsc = 'CASE_BAN_ID_ASC',
  CaseBanIdDesc = 'CASE_BAN_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderIdAsc = 'TRADER_ID_ASC',
  TraderIdDesc = 'TRADER_ID_DESC'
}

export type CaseBanTraderPendingDetailsResult = {
  __typename?: 'CaseBanTraderPendingDetailsResult';
  payoutHold?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<Scalars['Boolean']['output']>;
};

export type CaseBanTraderResult = {
  __typename?: 'CaseBanTraderResult';
  caseBanId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  idvLink?: Maybe<Scalars['String']['output']>;
  intercomLink?: Maybe<Scalars['String']['output']>;
  pendingAction: Scalars['String']['output'];
  pendingActionDetails?: Maybe<CaseBanTraderPendingDetailsResult>;
  traderId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseBanTraderStddevPopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanTraderStddevPopulationAggregates = {
  __typename?: 'CaseBanTraderStddevPopulationAggregates';
  /** Population standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanTraderStddevSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanTraderStddevSampleAggregates = {
  __typename?: 'CaseBanTraderStddevSampleAggregates';
  /** Sample standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanTraderSumAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type CaseBanTraderSumAggregates = {
  __typename?: 'CaseBanTraderSumAggregates';
  /** Sum of caseBanId across the matching connection */
  caseBanId: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of traderId across the matching connection */
  traderId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

export type CaseBanTraderVariancePopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanTraderVariancePopulationAggregates = {
  __typename?: 'CaseBanTraderVariancePopulationAggregates';
  /** Population variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanTraderVarianceSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseBanTraderVarianceSampleAggregates = {
  __typename?: 'CaseBanTraderVarianceSampleAggregates';
  /** Sample variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanTradersInput = {
  banId: Scalars['Int']['input'];
  traderIds: Array<Scalars['Int']['input']>;
};

export type CaseBanTradersRemovedResult = {
  __typename?: 'CaseBanTradersRemovedResult';
  cancelledCase: Scalars['Boolean']['output'];
  traders: Array<CaseBanTraderResult>;
};

export type CaseBanVariancePopulationAggregates = {
  __typename?: 'CaseBanVariancePopulationAggregates';
  /** Population variance of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseBanVarianceSampleAggregates = {
  __typename?: 'CaseBanVarianceSampleAggregates';
  /** Sample variance of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sourceCaseInvestigationId across the matching connection */
  sourceCaseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseDepartment = {
  __typename?: 'CaseDepartment';
  /**
   * Whether the calling admin belongs to this department. Membership only, not an
   * authorization answer: an admin holding manage:caseManagement may act on every
   * department regardless of this flag.
   */
  isCurrentAdminMember: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CaseEvent = Node & {
  __typename?: 'CaseEvent';
  /** Reads a single `CaseBan` that is related to this `CaseEvent`. */
  caseBan?: Maybe<CaseBan>;
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CaseInvestigation` that is related to this `CaseEvent`. */
  caseInvestigation?: Maybe<CaseInvestigation>;
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  eventData: Scalars['JSON']['output'];
  eventType: CaseEventType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

export type CaseEventAggregates = {
  __typename?: 'CaseEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseEventDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CaseEvent` object types. */
export type CaseEventAggregatesFilter = {
  /** Mean average aggregate over matching `CaseEvent` objects. */
  average?: InputMaybe<CaseEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CaseEvent` objects. */
  distinctCount?: InputMaybe<CaseEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CaseEvent` object to be included within the aggregate. */
  filter?: InputMaybe<CaseEventFilter>;
  /** Maximum aggregate over matching `CaseEvent` objects. */
  max?: InputMaybe<CaseEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `CaseEvent` objects. */
  min?: InputMaybe<CaseEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CaseEvent` objects. */
  stddevPopulation?: InputMaybe<CaseEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CaseEvent` objects. */
  stddevSample?: InputMaybe<CaseEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CaseEvent` objects. */
  sum?: InputMaybe<CaseEventSumAggregateFilter>;
  /** Population variance aggregate over matching `CaseEvent` objects. */
  variancePopulation?: InputMaybe<CaseEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CaseEvent` objects. */
  varianceSample?: InputMaybe<CaseEventVarianceSampleAggregateFilter>;
};

export type CaseEventAverageAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type CaseEventAverageAggregates = {
  __typename?: 'CaseEventAverageAggregates';
  /** Mean average of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseEvent` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CaseEventCondition = {
  /** Checks for equality with the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `caseInvestigationId` field. */
  caseInvestigationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `traderUserId` field. */
  traderUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseEvent` values. */
export type CaseEventConnection = {
  __typename?: 'CaseEventConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseEventAggregates>;
  /** A list of edges which contains the `CaseEvent` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseEventEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseEventAggregates>>;
  /** A list of `CaseEvent` objects. */
  nodes: Array<Maybe<CaseEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseEvent` values. */
export type CaseEventConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseEventGroupBy>;
  having?: InputMaybe<CaseEventHavingInput>;
};

export type CaseEventDistinctCountAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  caseInvestigationId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderUserId?: InputMaybe<BigIntFilter>;
};

export type CaseEventDistinctCountAggregates = {
  __typename?: 'CaseEventDistinctCountAggregates';
  /** Distinct count of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventData across the matching connection */
  eventData?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventType across the matching connection */
  eventType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseEvent` edge in the connection. */
export type CaseEventEdge = {
  __typename?: 'CaseEventEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseEvent` at the end of the edge. */
  node?: Maybe<CaseEvent>;
};

/** A filter to be used against `CaseEvent` object types. All fields are combined with a logical ‘and.’ */
export type CaseEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseEventFilter>>;
  /** Filter by the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `caseInvestigationId` field. */
  caseInvestigationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseEventFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderUserId` field. */
  traderUserId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CaseEvent` for usage during aggregation. */
export enum CaseEventGroupBy {
  CaseBanId = 'CASE_BAN_ID',
  CaseInvestigationId = 'CASE_INVESTIGATION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  TraderUserId = 'TRADER_USER_ID'
}

export type CaseEventHavingAverageInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingDistinctCountInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseEvent` aggregates. */
export type CaseEventHavingInput = {
  AND?: InputMaybe<Array<CaseEventHavingInput>>;
  OR?: InputMaybe<Array<CaseEventHavingInput>>;
  average?: InputMaybe<CaseEventHavingAverageInput>;
  distinctCount?: InputMaybe<CaseEventHavingDistinctCountInput>;
  max?: InputMaybe<CaseEventHavingMaxInput>;
  min?: InputMaybe<CaseEventHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseEventHavingStddevSampleInput>;
  sum?: InputMaybe<CaseEventHavingSumInput>;
  variancePopulation?: InputMaybe<CaseEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseEventHavingVarianceSampleInput>;
};

export type CaseEventHavingMaxInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingMinInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingStddevPopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingStddevSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingSumInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingVariancePopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventHavingVarianceSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
};

export type CaseEventMaxAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  caseInvestigationId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  traderUserId?: InputMaybe<IntFilter>;
};

export type CaseEventMaxAggregates = {
  __typename?: 'CaseEventMaxAggregates';
  /** Maximum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

export type CaseEventMinAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  caseInvestigationId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  traderUserId?: InputMaybe<IntFilter>;
};

export type CaseEventMinAggregates = {
  __typename?: 'CaseEventMinAggregates';
  /** Minimum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseEvent`. */
export enum CaseEventOrderBy {
  CaseBanIdAsc = 'CASE_BAN_ID_ASC',
  CaseBanIdDesc = 'CASE_BAN_ID_DESC',
  CaseInvestigationIdAsc = 'CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationIdDesc = 'CASE_INVESTIGATION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderUserIdAsc = 'TRADER_USER_ID_ASC',
  TraderUserIdDesc = 'TRADER_USER_ID_DESC'
}

export type CaseEventStddevPopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type CaseEventStddevPopulationAggregates = {
  __typename?: 'CaseEventStddevPopulationAggregates';
  /** Population standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseEventStddevSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type CaseEventStddevSampleAggregates = {
  __typename?: 'CaseEventStddevSampleAggregates';
  /** Sample standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseEventSumAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  caseInvestigationId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderUserId?: InputMaybe<BigIntFilter>;
};

export type CaseEventSumAggregates = {
  __typename?: 'CaseEventSumAggregates';
  /** Sum of caseBanId across the matching connection */
  caseBanId: Scalars['BigInt']['output'];
  /** Sum of caseInvestigationId across the matching connection */
  caseInvestigationId: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of traderUserId across the matching connection */
  traderUserId: Scalars['BigInt']['output'];
};

export enum CaseEventType {
  CaseBanCreated = 'case_ban_created',
  CaseBanUpdated = 'case_ban_updated',
  CaseCancelled = 'case_cancelled',
  CaseClosed = 'case_closed',
  CaseInvestigationCreated = 'case_investigation_created',
  CaseInvestigationUpdated = 'case_investigation_updated',
  CaseOnHold = 'case_on_hold',
  CaseResumed = 'case_resumed',
  NoteAdded = 'note_added',
  PendingStatusUpdated = 'pending_status_updated',
  TraderAdded = 'trader_added',
  TraderRemoved = 'trader_removed'
}

export type CaseEventVariancePopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type CaseEventVariancePopulationAggregates = {
  __typename?: 'CaseEventVariancePopulationAggregates';
  /** Population variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseEventVarianceSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type CaseEventVarianceSampleAggregates = {
  __typename?: 'CaseEventVarianceSampleAggregates';
  /** Sample variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigation = Node & {
  __typename?: 'CaseInvestigation';
  assignedTo?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `CaseBan`. */
  caseBansBySourceCaseInvestigationId: CaseBanConnection;
  /** Reads and enables pagination through a set of `CaseEvent`. */
  caseEvents: CaseEventConnection;
  /** Reads and enables pagination through a set of `CaseInvestigationTrader`. */
  caseInvestigationTraders: CaseInvestigationTraderConnection;
  /** Reads and enables pagination through a set of `CaseLabelAssignment`. */
  caseLabelAssignments: CaseLabelAssignmentConnection;
  /** Reads a single `CaseType` that is related to this `CaseInvestigation`. */
  caseType?: Maybe<CaseType>;
  caseTypeId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  departmentGroupId?: Maybe<Scalars['String']['output']>;
  fitSheet?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  severity: CaseSeverity;
  status: CaseStatus;
  /** Reads a single `CaseInvestigationSubmittedDepartment` that is related to this `CaseInvestigation`. */
  submittedByDepartment?: Maybe<CaseInvestigationSubmittedDepartment>;
  submittedByDepartmentId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


export type CaseInvestigationCaseBansBySourceCaseInvestigationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseBanCondition>;
  filter?: InputMaybe<CaseBanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseBanOrderBy>>;
};


export type CaseInvestigationCaseEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseEventCondition>;
  filter?: InputMaybe<CaseEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseEventOrderBy>>;
};


export type CaseInvestigationCaseInvestigationTradersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseInvestigationTraderCondition>;
  filter?: InputMaybe<CaseInvestigationTraderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseInvestigationTraderOrderBy>>;
};


export type CaseInvestigationCaseLabelAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseLabelAssignmentCondition>;
  filter?: InputMaybe<CaseLabelAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseLabelAssignmentOrderBy>>;
};

export type CaseInvestigationAggregates = {
  __typename?: 'CaseInvestigationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseInvestigationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseInvestigationDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseInvestigationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseInvestigationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseInvestigationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseInvestigationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseInvestigationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseInvestigationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseInvestigationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CaseInvestigation` object types. */
export type CaseInvestigationAggregatesFilter = {
  /** Mean average aggregate over matching `CaseInvestigation` objects. */
  average?: InputMaybe<CaseInvestigationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CaseInvestigation` objects. */
  distinctCount?: InputMaybe<CaseInvestigationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CaseInvestigation` object to be included within the aggregate. */
  filter?: InputMaybe<CaseInvestigationFilter>;
  /** Maximum aggregate over matching `CaseInvestigation` objects. */
  max?: InputMaybe<CaseInvestigationMaxAggregateFilter>;
  /** Minimum aggregate over matching `CaseInvestigation` objects. */
  min?: InputMaybe<CaseInvestigationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CaseInvestigation` objects. */
  stddevPopulation?: InputMaybe<CaseInvestigationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CaseInvestigation` objects. */
  stddevSample?: InputMaybe<CaseInvestigationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CaseInvestigation` objects. */
  sum?: InputMaybe<CaseInvestigationSumAggregateFilter>;
  /** Population variance aggregate over matching `CaseInvestigation` objects. */
  variancePopulation?: InputMaybe<CaseInvestigationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CaseInvestigation` objects. */
  varianceSample?: InputMaybe<CaseInvestigationVarianceSampleAggregateFilter>;
};

export type CaseInvestigationAverageAggregateFilter = {
  assignedTo?: InputMaybe<BigFloatFilter>;
  caseTypeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  submittedByDepartmentId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationAverageAggregates = {
  __typename?: 'CaseInvestigationAverageAggregates';
  /** Mean average of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseInvestigation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CaseInvestigationCondition = {
  /** Checks for equality with the object’s `assignedTo` field. */
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `caseTypeId` field. */
  caseTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `departmentGroupId` field. */
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `severity` field. */
  severity?: InputMaybe<CaseSeverity>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CaseStatus>;
  /** Checks for equality with the object’s `submittedByDepartmentId` field. */
  submittedByDepartmentId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseInvestigation` values. */
export type CaseInvestigationConnection = {
  __typename?: 'CaseInvestigationConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseInvestigationAggregates>;
  /** A list of edges which contains the `CaseInvestigation` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseInvestigationEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseInvestigationAggregates>>;
  /** A list of `CaseInvestigation` objects. */
  nodes: Array<Maybe<CaseInvestigation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseInvestigation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseInvestigation` values. */
export type CaseInvestigationConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseInvestigationGroupBy>;
  having?: InputMaybe<CaseInvestigationHavingInput>;
};

export type CaseInvestigationDistinctCountAggregateFilter = {
  assignedTo?: InputMaybe<BigIntFilter>;
  caseTypeId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  departmentGroupId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  severity?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  submittedByDepartmentId?: InputMaybe<BigIntFilter>;
};

export type CaseInvestigationDistinctCountAggregates = {
  __typename?: 'CaseInvestigationDistinctCountAggregates';
  /** Distinct count of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of departmentGroupId across the matching connection */
  departmentGroupId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fitSheet across the matching connection */
  fitSheet?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nickname across the matching connection */
  nickname?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of severity across the matching connection */
  severity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseInvestigation` edge in the connection. */
export type CaseInvestigationEdge = {
  __typename?: 'CaseInvestigationEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseInvestigation` at the end of the edge. */
  node?: Maybe<CaseInvestigation>;
};

export type CaseInvestigationEventResult = {
  __typename?: 'CaseInvestigationEventResult';
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `CaseInvestigation` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseInvestigationFilter>>;
  /** Filter by the object’s `assignedTo` field. */
  assignedTo?: InputMaybe<IntFilter>;
  /** Filter by the object’s `caseEvents` relation. */
  caseEvents?: InputMaybe<CaseInvestigationToManyCaseEventFilter>;
  /** Some related `caseEvents` exist. */
  caseEventsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `caseInvestigationTraders` relation. */
  caseInvestigationTraders?: InputMaybe<CaseInvestigationToManyCaseInvestigationTraderFilter>;
  /** Some related `caseInvestigationTraders` exist. */
  caseInvestigationTradersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `caseLabelAssignments` relation. */
  caseLabelAssignments?: InputMaybe<CaseInvestigationToManyCaseLabelAssignmentFilter>;
  /** Some related `caseLabelAssignments` exist. */
  caseLabelAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `caseType` relation. */
  caseType?: InputMaybe<CaseTypeFilter>;
  /** Filter by the object’s `caseTypeId` field. */
  caseTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentGroupId` field. */
  departmentGroupId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseInvestigationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseInvestigationFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `severity` field. */
  severity?: InputMaybe<CaseSeverityFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CaseStatusFilter>;
  /** Filter by the object’s `submittedByDepartment` relation. */
  submittedByDepartment?: InputMaybe<CaseInvestigationSubmittedDepartmentFilter>;
  /** A related `submittedByDepartment` exists. */
  submittedByDepartmentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `submittedByDepartmentId` field. */
  submittedByDepartmentId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CaseInvestigation` for usage during aggregation. */
export enum CaseInvestigationGroupBy {
  AssignedTo = 'ASSIGNED_TO',
  CaseTypeId = 'CASE_TYPE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  DepartmentGroupId = 'DEPARTMENT_GROUP_ID',
  Severity = 'SEVERITY',
  Status = 'STATUS',
  SubmittedByDepartmentId = 'SUBMITTED_BY_DEPARTMENT_ID'
}

export type CaseInvestigationHavingAverageInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingDistinctCountInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseInvestigation` aggregates. */
export type CaseInvestigationHavingInput = {
  AND?: InputMaybe<Array<CaseInvestigationHavingInput>>;
  OR?: InputMaybe<Array<CaseInvestigationHavingInput>>;
  average?: InputMaybe<CaseInvestigationHavingAverageInput>;
  distinctCount?: InputMaybe<CaseInvestigationHavingDistinctCountInput>;
  max?: InputMaybe<CaseInvestigationHavingMaxInput>;
  min?: InputMaybe<CaseInvestigationHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseInvestigationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseInvestigationHavingStddevSampleInput>;
  sum?: InputMaybe<CaseInvestigationHavingSumInput>;
  variancePopulation?: InputMaybe<CaseInvestigationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseInvestigationHavingVarianceSampleInput>;
};

export type CaseInvestigationHavingMaxInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingMinInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingStddevPopulationInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingStddevSampleInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingSumInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingVariancePopulationInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationHavingVarianceSampleInput = {
  assignedTo?: InputMaybe<HavingIntFilter>;
  caseTypeId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedByDepartmentId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationMaxAggregateFilter = {
  assignedTo?: InputMaybe<IntFilter>;
  caseTypeId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  submittedByDepartmentId?: InputMaybe<IntFilter>;
};

export type CaseInvestigationMaxAggregates = {
  __typename?: 'CaseInvestigationMaxAggregates';
  /** Maximum of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['Int']['output']>;
  /** Maximum of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationMinAggregateFilter = {
  assignedTo?: InputMaybe<IntFilter>;
  caseTypeId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  submittedByDepartmentId?: InputMaybe<IntFilter>;
};

export type CaseInvestigationMinAggregates = {
  __typename?: 'CaseInvestigationMinAggregates';
  /** Minimum of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['Int']['output']>;
  /** Minimum of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseInvestigation`. */
export enum CaseInvestigationOrderBy {
  AssignedToAsc = 'ASSIGNED_TO_ASC',
  AssignedToDesc = 'ASSIGNED_TO_DESC',
  CaseEventsAverageCaseBanIdAsc = 'CASE_EVENTS_AVERAGE_CASE_BAN_ID_ASC',
  CaseEventsAverageCaseBanIdDesc = 'CASE_EVENTS_AVERAGE_CASE_BAN_ID_DESC',
  CaseEventsAverageCaseInvestigationIdAsc = 'CASE_EVENTS_AVERAGE_CASE_INVESTIGATION_ID_ASC',
  CaseEventsAverageCaseInvestigationIdDesc = 'CASE_EVENTS_AVERAGE_CASE_INVESTIGATION_ID_DESC',
  CaseEventsAverageRowIdAsc = 'CASE_EVENTS_AVERAGE_ROW_ID_ASC',
  CaseEventsAverageRowIdDesc = 'CASE_EVENTS_AVERAGE_ROW_ID_DESC',
  CaseEventsAverageTraderUserIdAsc = 'CASE_EVENTS_AVERAGE_TRADER_USER_ID_ASC',
  CaseEventsAverageTraderUserIdDesc = 'CASE_EVENTS_AVERAGE_TRADER_USER_ID_DESC',
  CaseEventsCountAsc = 'CASE_EVENTS_COUNT_ASC',
  CaseEventsCountDesc = 'CASE_EVENTS_COUNT_DESC',
  CaseEventsDistinctCountCaseBanIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_BAN_ID_ASC',
  CaseEventsDistinctCountCaseBanIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_BAN_ID_DESC',
  CaseEventsDistinctCountCaseInvestigationIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_ASC',
  CaseEventsDistinctCountCaseInvestigationIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_DESC',
  CaseEventsDistinctCountCreatedAtAsc = 'CASE_EVENTS_DISTINCT_COUNT_CREATED_AT_ASC',
  CaseEventsDistinctCountCreatedAtDesc = 'CASE_EVENTS_DISTINCT_COUNT_CREATED_AT_DESC',
  CaseEventsDistinctCountRowIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_ROW_ID_ASC',
  CaseEventsDistinctCountRowIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_ROW_ID_DESC',
  CaseEventsDistinctCountTraderUserIdAsc = 'CASE_EVENTS_DISTINCT_COUNT_TRADER_USER_ID_ASC',
  CaseEventsDistinctCountTraderUserIdDesc = 'CASE_EVENTS_DISTINCT_COUNT_TRADER_USER_ID_DESC',
  CaseEventsMaxCaseBanIdAsc = 'CASE_EVENTS_MAX_CASE_BAN_ID_ASC',
  CaseEventsMaxCaseBanIdDesc = 'CASE_EVENTS_MAX_CASE_BAN_ID_DESC',
  CaseEventsMaxCaseInvestigationIdAsc = 'CASE_EVENTS_MAX_CASE_INVESTIGATION_ID_ASC',
  CaseEventsMaxCaseInvestigationIdDesc = 'CASE_EVENTS_MAX_CASE_INVESTIGATION_ID_DESC',
  CaseEventsMaxRowIdAsc = 'CASE_EVENTS_MAX_ROW_ID_ASC',
  CaseEventsMaxRowIdDesc = 'CASE_EVENTS_MAX_ROW_ID_DESC',
  CaseEventsMaxTraderUserIdAsc = 'CASE_EVENTS_MAX_TRADER_USER_ID_ASC',
  CaseEventsMaxTraderUserIdDesc = 'CASE_EVENTS_MAX_TRADER_USER_ID_DESC',
  CaseEventsMinCaseBanIdAsc = 'CASE_EVENTS_MIN_CASE_BAN_ID_ASC',
  CaseEventsMinCaseBanIdDesc = 'CASE_EVENTS_MIN_CASE_BAN_ID_DESC',
  CaseEventsMinCaseInvestigationIdAsc = 'CASE_EVENTS_MIN_CASE_INVESTIGATION_ID_ASC',
  CaseEventsMinCaseInvestigationIdDesc = 'CASE_EVENTS_MIN_CASE_INVESTIGATION_ID_DESC',
  CaseEventsMinRowIdAsc = 'CASE_EVENTS_MIN_ROW_ID_ASC',
  CaseEventsMinRowIdDesc = 'CASE_EVENTS_MIN_ROW_ID_DESC',
  CaseEventsMinTraderUserIdAsc = 'CASE_EVENTS_MIN_TRADER_USER_ID_ASC',
  CaseEventsMinTraderUserIdDesc = 'CASE_EVENTS_MIN_TRADER_USER_ID_DESC',
  CaseEventsStddevPopulationCaseBanIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_BAN_ID_ASC',
  CaseEventsStddevPopulationCaseBanIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_BAN_ID_DESC',
  CaseEventsStddevPopulationCaseInvestigationIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseEventsStddevPopulationCaseInvestigationIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseEventsStddevPopulationRowIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_ROW_ID_ASC',
  CaseEventsStddevPopulationRowIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_ROW_ID_DESC',
  CaseEventsStddevPopulationTraderUserIdAsc = 'CASE_EVENTS_STDDEV_POPULATION_TRADER_USER_ID_ASC',
  CaseEventsStddevPopulationTraderUserIdDesc = 'CASE_EVENTS_STDDEV_POPULATION_TRADER_USER_ID_DESC',
  CaseEventsStddevSampleCaseBanIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_BAN_ID_ASC',
  CaseEventsStddevSampleCaseBanIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_BAN_ID_DESC',
  CaseEventsStddevSampleCaseInvestigationIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseEventsStddevSampleCaseInvestigationIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseEventsStddevSampleRowIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseEventsStddevSampleRowIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseEventsStddevSampleTraderUserIdAsc = 'CASE_EVENTS_STDDEV_SAMPLE_TRADER_USER_ID_ASC',
  CaseEventsStddevSampleTraderUserIdDesc = 'CASE_EVENTS_STDDEV_SAMPLE_TRADER_USER_ID_DESC',
  CaseEventsSumCaseBanIdAsc = 'CASE_EVENTS_SUM_CASE_BAN_ID_ASC',
  CaseEventsSumCaseBanIdDesc = 'CASE_EVENTS_SUM_CASE_BAN_ID_DESC',
  CaseEventsSumCaseInvestigationIdAsc = 'CASE_EVENTS_SUM_CASE_INVESTIGATION_ID_ASC',
  CaseEventsSumCaseInvestigationIdDesc = 'CASE_EVENTS_SUM_CASE_INVESTIGATION_ID_DESC',
  CaseEventsSumRowIdAsc = 'CASE_EVENTS_SUM_ROW_ID_ASC',
  CaseEventsSumRowIdDesc = 'CASE_EVENTS_SUM_ROW_ID_DESC',
  CaseEventsSumTraderUserIdAsc = 'CASE_EVENTS_SUM_TRADER_USER_ID_ASC',
  CaseEventsSumTraderUserIdDesc = 'CASE_EVENTS_SUM_TRADER_USER_ID_DESC',
  CaseEventsVariancePopulationCaseBanIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_BAN_ID_ASC',
  CaseEventsVariancePopulationCaseBanIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_BAN_ID_DESC',
  CaseEventsVariancePopulationCaseInvestigationIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseEventsVariancePopulationCaseInvestigationIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseEventsVariancePopulationRowIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseEventsVariancePopulationRowIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseEventsVariancePopulationTraderUserIdAsc = 'CASE_EVENTS_VARIANCE_POPULATION_TRADER_USER_ID_ASC',
  CaseEventsVariancePopulationTraderUserIdDesc = 'CASE_EVENTS_VARIANCE_POPULATION_TRADER_USER_ID_DESC',
  CaseEventsVarianceSampleCaseBanIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_BAN_ID_ASC',
  CaseEventsVarianceSampleCaseBanIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_BAN_ID_DESC',
  CaseEventsVarianceSampleCaseInvestigationIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseEventsVarianceSampleCaseInvestigationIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseEventsVarianceSampleRowIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseEventsVarianceSampleRowIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseEventsVarianceSampleTraderUserIdAsc = 'CASE_EVENTS_VARIANCE_SAMPLE_TRADER_USER_ID_ASC',
  CaseEventsVarianceSampleTraderUserIdDesc = 'CASE_EVENTS_VARIANCE_SAMPLE_TRADER_USER_ID_DESC',
  CaseInvestigationTradersAverageCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersAverageCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersAverageReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_REASON_CODE_ID_ASC',
  CaseInvestigationTradersAverageReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_REASON_CODE_ID_DESC',
  CaseInvestigationTradersAverageRowIdAsc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_ROW_ID_ASC',
  CaseInvestigationTradersAverageRowIdDesc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_ROW_ID_DESC',
  CaseInvestigationTradersAverageTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_TRADER_ID_ASC',
  CaseInvestigationTradersAverageTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_AVERAGE_TRADER_ID_DESC',
  CaseInvestigationTradersCountAsc = 'CASE_INVESTIGATION_TRADERS_COUNT_ASC',
  CaseInvestigationTradersCountDesc = 'CASE_INVESTIGATION_TRADERS_COUNT_DESC',
  CaseInvestigationTradersDistinctCountCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersDistinctCountCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersDistinctCountReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_REASON_CODE_ID_ASC',
  CaseInvestigationTradersDistinctCountReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_REASON_CODE_ID_DESC',
  CaseInvestigationTradersDistinctCountRowIdAsc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_ROW_ID_ASC',
  CaseInvestigationTradersDistinctCountRowIdDesc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_ROW_ID_DESC',
  CaseInvestigationTradersDistinctCountTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_TRADER_ID_ASC',
  CaseInvestigationTradersDistinctCountTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_DISTINCT_COUNT_TRADER_ID_DESC',
  CaseInvestigationTradersMaxCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_MAX_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersMaxCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_MAX_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersMaxReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_MAX_REASON_CODE_ID_ASC',
  CaseInvestigationTradersMaxReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_MAX_REASON_CODE_ID_DESC',
  CaseInvestigationTradersMaxRowIdAsc = 'CASE_INVESTIGATION_TRADERS_MAX_ROW_ID_ASC',
  CaseInvestigationTradersMaxRowIdDesc = 'CASE_INVESTIGATION_TRADERS_MAX_ROW_ID_DESC',
  CaseInvestigationTradersMaxTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_MAX_TRADER_ID_ASC',
  CaseInvestigationTradersMaxTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_MAX_TRADER_ID_DESC',
  CaseInvestigationTradersMinCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_MIN_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersMinCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_MIN_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersMinReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_MIN_REASON_CODE_ID_ASC',
  CaseInvestigationTradersMinReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_MIN_REASON_CODE_ID_DESC',
  CaseInvestigationTradersMinRowIdAsc = 'CASE_INVESTIGATION_TRADERS_MIN_ROW_ID_ASC',
  CaseInvestigationTradersMinRowIdDesc = 'CASE_INVESTIGATION_TRADERS_MIN_ROW_ID_DESC',
  CaseInvestigationTradersMinTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_MIN_TRADER_ID_ASC',
  CaseInvestigationTradersMinTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_MIN_TRADER_ID_DESC',
  CaseInvestigationTradersStddevPopulationCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersStddevPopulationCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersStddevPopulationReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_REASON_CODE_ID_ASC',
  CaseInvestigationTradersStddevPopulationReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_REASON_CODE_ID_DESC',
  CaseInvestigationTradersStddevPopulationRowIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_ROW_ID_ASC',
  CaseInvestigationTradersStddevPopulationRowIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_ROW_ID_DESC',
  CaseInvestigationTradersStddevPopulationTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_TRADER_ID_ASC',
  CaseInvestigationTradersStddevPopulationTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_POPULATION_TRADER_ID_DESC',
  CaseInvestigationTradersStddevSampleCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersStddevSampleCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersStddevSampleReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_REASON_CODE_ID_ASC',
  CaseInvestigationTradersStddevSampleReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_REASON_CODE_ID_DESC',
  CaseInvestigationTradersStddevSampleRowIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseInvestigationTradersStddevSampleRowIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseInvestigationTradersStddevSampleTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_TRADER_ID_ASC',
  CaseInvestigationTradersStddevSampleTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_STDDEV_SAMPLE_TRADER_ID_DESC',
  CaseInvestigationTradersSumCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_SUM_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersSumCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_SUM_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersSumReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_SUM_REASON_CODE_ID_ASC',
  CaseInvestigationTradersSumReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_SUM_REASON_CODE_ID_DESC',
  CaseInvestigationTradersSumRowIdAsc = 'CASE_INVESTIGATION_TRADERS_SUM_ROW_ID_ASC',
  CaseInvestigationTradersSumRowIdDesc = 'CASE_INVESTIGATION_TRADERS_SUM_ROW_ID_DESC',
  CaseInvestigationTradersSumTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_SUM_TRADER_ID_ASC',
  CaseInvestigationTradersSumTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_SUM_TRADER_ID_DESC',
  CaseInvestigationTradersVariancePopulationCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersVariancePopulationCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersVariancePopulationReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_REASON_CODE_ID_ASC',
  CaseInvestigationTradersVariancePopulationReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_REASON_CODE_ID_DESC',
  CaseInvestigationTradersVariancePopulationRowIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseInvestigationTradersVariancePopulationRowIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseInvestigationTradersVariancePopulationTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_TRADER_ID_ASC',
  CaseInvestigationTradersVariancePopulationTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_POPULATION_TRADER_ID_DESC',
  CaseInvestigationTradersVarianceSampleCaseInvestigationIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationTradersVarianceSampleCaseInvestigationIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseInvestigationTradersVarianceSampleReasonCodeIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_REASON_CODE_ID_ASC',
  CaseInvestigationTradersVarianceSampleReasonCodeIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_REASON_CODE_ID_DESC',
  CaseInvestigationTradersVarianceSampleRowIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseInvestigationTradersVarianceSampleRowIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseInvestigationTradersVarianceSampleTraderIdAsc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_TRADER_ID_ASC',
  CaseInvestigationTradersVarianceSampleTraderIdDesc = 'CASE_INVESTIGATION_TRADERS_VARIANCE_SAMPLE_TRADER_ID_DESC',
  CaseLabelAssignmentsAverageCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsAverageCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsAverageCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsAverageCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsAverageCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsAverageCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsAverageRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_ROW_ID_ASC',
  CaseLabelAssignmentsAverageRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_AVERAGE_ROW_ID_DESC',
  CaseLabelAssignmentsCountAsc = 'CASE_LABEL_ASSIGNMENTS_COUNT_ASC',
  CaseLabelAssignmentsCountDesc = 'CASE_LABEL_ASSIGNMENTS_COUNT_DESC',
  CaseLabelAssignmentsDistinctCountCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsDistinctCountCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsDistinctCountCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsDistinctCountCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsDistinctCountCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsDistinctCountCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsDistinctCountRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_ASC',
  CaseLabelAssignmentsDistinctCountRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_DESC',
  CaseLabelAssignmentsMaxCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsMaxCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsMaxCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsMaxCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsMaxCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsMaxCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsMaxRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_MAX_ROW_ID_ASC',
  CaseLabelAssignmentsMaxRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_MAX_ROW_ID_DESC',
  CaseLabelAssignmentsMinCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsMinCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsMinCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsMinCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsMinCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsMinCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsMinRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_MIN_ROW_ID_ASC',
  CaseLabelAssignmentsMinRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_MIN_ROW_ID_DESC',
  CaseLabelAssignmentsStddevPopulationCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsStddevPopulationCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsStddevPopulationCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsStddevPopulationCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsStddevPopulationCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsStddevPopulationCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsStddevPopulationRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_ASC',
  CaseLabelAssignmentsStddevPopulationRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_DESC',
  CaseLabelAssignmentsStddevSampleCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsStddevSampleCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsStddevSampleCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsStddevSampleCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsStddevSampleCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsStddevSampleCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsStddevSampleRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseLabelAssignmentsStddevSampleRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseLabelAssignmentsSumCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsSumCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsSumCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsSumCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsSumCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsSumCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsSumRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_SUM_ROW_ID_ASC',
  CaseLabelAssignmentsSumRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_SUM_ROW_ID_DESC',
  CaseLabelAssignmentsVariancePopulationCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsVariancePopulationCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsVariancePopulationCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsVariancePopulationCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsVariancePopulationCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsVariancePopulationCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsVariancePopulationRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseLabelAssignmentsVariancePopulationRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseLabelAssignmentsVarianceSampleCaseBanIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_BAN_ID_ASC',
  CaseLabelAssignmentsVarianceSampleCaseBanIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_BAN_ID_DESC',
  CaseLabelAssignmentsVarianceSampleCaseInvestigationIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_ASC',
  CaseLabelAssignmentsVarianceSampleCaseInvestigationIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_INVESTIGATION_ID_DESC',
  CaseLabelAssignmentsVarianceSampleCaseLabelIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_LABEL_ID_ASC',
  CaseLabelAssignmentsVarianceSampleCaseLabelIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_CASE_LABEL_ID_DESC',
  CaseLabelAssignmentsVarianceSampleRowIdAsc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseLabelAssignmentsVarianceSampleRowIdDesc = 'CASE_LABEL_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseTypeIdAsc = 'CASE_TYPE_ID_ASC',
  CaseTypeIdDesc = 'CASE_TYPE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DepartmentGroupIdAsc = 'DEPARTMENT_GROUP_ID_ASC',
  DepartmentGroupIdDesc = 'DEPARTMENT_GROUP_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SeverityAsc = 'SEVERITY_ASC',
  SeverityDesc = 'SEVERITY_DESC',
  SubmittedByDepartmentIdAsc = 'SUBMITTED_BY_DEPARTMENT_ID_ASC',
  SubmittedByDepartmentIdDesc = 'SUBMITTED_BY_DEPARTMENT_ID_DESC'
}

export enum CaseInvestigationPayoutHold {
  Keep = 'keep',
  Reject = 'reject',
  Resume = 'resume'
}

export enum CaseInvestigationPendingAction {
  BanReview = 'ban_review',
  Cleared = 'cleared',
  UnderInvestigation = 'under_investigation',
  Warning = 'warning'
}

export type CaseInvestigationResult = {
  __typename?: 'CaseInvestigationResult';
  assignedTo?: Maybe<Scalars['Int']['output']>;
  caseTypeId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  departmentGroupId?: Maybe<Scalars['String']['output']>;
  fitSheet?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  labels: Array<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  status: Scalars['String']['output'];
  submittedByDepartmentId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationStddevPopulationAggregateFilter = {
  assignedTo?: InputMaybe<BigFloatFilter>;
  caseTypeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  submittedByDepartmentId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationStddevPopulationAggregates = {
  __typename?: 'CaseInvestigationStddevPopulationAggregates';
  /** Population standard deviation of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationStddevSampleAggregateFilter = {
  assignedTo?: InputMaybe<BigFloatFilter>;
  caseTypeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  submittedByDepartmentId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationStddevSampleAggregates = {
  __typename?: 'CaseInvestigationStddevSampleAggregates';
  /** Sample standard deviation of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationSubmittedDepartment = Node & {
  __typename?: 'CaseInvestigationSubmittedDepartment';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationSubmittedDepartmentAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseInvestigationSubmittedDepartmentAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseInvestigationSubmittedDepartmentDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseInvestigationSubmittedDepartmentMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseInvestigationSubmittedDepartmentMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseInvestigationSubmittedDepartmentStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseInvestigationSubmittedDepartmentStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseInvestigationSubmittedDepartmentSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseInvestigationSubmittedDepartmentVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseInvestigationSubmittedDepartmentVarianceSampleAggregates>;
};

export type CaseInvestigationSubmittedDepartmentAverageAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseInvestigationSubmittedDepartment` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type CaseInvestigationSubmittedDepartmentCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseInvestigationSubmittedDepartment` values. */
export type CaseInvestigationSubmittedDepartmentConnection = {
  __typename?: 'CaseInvestigationSubmittedDepartmentConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseInvestigationSubmittedDepartmentAggregates>;
  /** A list of edges which contains the `CaseInvestigationSubmittedDepartment` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseInvestigationSubmittedDepartmentEdge>>;
  /** A list of `CaseInvestigationSubmittedDepartment` objects. */
  nodes: Array<Maybe<CaseInvestigationSubmittedDepartment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseInvestigationSubmittedDepartment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type CaseInvestigationSubmittedDepartmentDistinctCountAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of code across the matching connection */
  code?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseInvestigationSubmittedDepartment` edge in the connection. */
export type CaseInvestigationSubmittedDepartmentEdge = {
  __typename?: 'CaseInvestigationSubmittedDepartmentEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseInvestigationSubmittedDepartment` at the end of the edge. */
  node?: Maybe<CaseInvestigationSubmittedDepartment>;
};

/** A filter to be used against `CaseInvestigationSubmittedDepartment` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationSubmittedDepartmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseInvestigationSubmittedDepartmentFilter>>;
  /** Filter by the object’s `caseInvestigationsBySubmittedByDepartmentId` relation. */
  caseInvestigationsBySubmittedByDepartmentId?: InputMaybe<CaseInvestigationSubmittedDepartmentToManyCaseInvestigationFilter>;
  /** Some related `caseInvestigationsBySubmittedByDepartmentId` exist. */
  caseInvestigationsBySubmittedByDepartmentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseInvestigationSubmittedDepartmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseInvestigationSubmittedDepartmentFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type CaseInvestigationSubmittedDepartmentMaxAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationSubmittedDepartmentMinAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseInvestigationSubmittedDepartment`. */
export enum CaseInvestigationSubmittedDepartmentOrderBy {
  CaseInvestigationsBySubmittedByDepartmentIdAverageAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdAverageSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_AVERAGE_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdCountAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_COUNT_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdCountDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_COUNT_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountCreatedAtAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_CREATED_AT_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountCreatedAtDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_CREATED_AT_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountDepartmentGroupIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_DEPARTMENT_GROUP_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountDepartmentGroupIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_DEPARTMENT_GROUP_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountSeverityAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_SEVERITY_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountSeverityDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_SEVERITY_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountStatusAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_STATUS_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountStatusDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_STATUS_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdDistinctCountSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_DISTINCT_COUNT_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMaxSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MAX_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMinAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMinAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMinCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMinCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMinRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMinRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdMinSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdMinSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_MIN_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevPopulationSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_POPULATION_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdStddevSampleSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_STDDEV_SAMPLE_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdSumAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdSumAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdSumCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdSumCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdSumRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdSumRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdSumSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdSumSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_SUM_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVariancePopulationSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_POPULATION_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleAssignedToAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_ASSIGNED_TO_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleAssignedToDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_ASSIGNED_TO_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleCaseTypeIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_CASE_TYPE_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleCaseTypeIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_CASE_TYPE_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleRowIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleRowIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleSubmittedByDepartmentIdAsc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_SUBMITTED_BY_DEPARTMENT_ID_ASC',
  CaseInvestigationsBySubmittedByDepartmentIdVarianceSampleSubmittedByDepartmentIdDesc = 'CASE_INVESTIGATIONS_BY_SUBMITTED_BY_DEPARTMENT_ID_VARIANCE_SAMPLE_SUBMITTED_BY_DEPARTMENT_ID_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type CaseInvestigationSubmittedDepartmentStddevPopulationAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationSubmittedDepartmentStddevSampleAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationSubmittedDepartmentSumAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of sortOrder across the matching connection */
  sortOrder: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CaseInvestigation` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationSubmittedDepartmentToManyCaseInvestigationFilter = {
  /** Aggregates across related `CaseInvestigation` match the filter criteria. */
  aggregates?: InputMaybe<CaseInvestigationAggregatesFilter>;
  /** Every related `CaseInvestigation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseInvestigationFilter>;
  /** No related `CaseInvestigation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseInvestigationFilter>;
  /** Some related `CaseInvestigation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseInvestigationFilter>;
};

export type CaseInvestigationSubmittedDepartmentVariancePopulationAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationSubmittedDepartmentVarianceSampleAggregates = {
  __typename?: 'CaseInvestigationSubmittedDepartmentVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationSumAggregateFilter = {
  assignedTo?: InputMaybe<BigIntFilter>;
  caseTypeId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  submittedByDepartmentId?: InputMaybe<BigIntFilter>;
};

export type CaseInvestigationSumAggregates = {
  __typename?: 'CaseInvestigationSumAggregates';
  /** Sum of assignedTo across the matching connection */
  assignedTo: Scalars['BigInt']['output'];
  /** Sum of caseTypeId across the matching connection */
  caseTypeId: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CaseEvent` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationToManyCaseEventFilter = {
  /** Aggregates across related `CaseEvent` match the filter criteria. */
  aggregates?: InputMaybe<CaseEventAggregatesFilter>;
  /** Every related `CaseEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseEventFilter>;
  /** No related `CaseEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseEventFilter>;
  /** Some related `CaseEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseEventFilter>;
};

/** A filter to be used against many `CaseInvestigationTrader` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationToManyCaseInvestigationTraderFilter = {
  /** Aggregates across related `CaseInvestigationTrader` match the filter criteria. */
  aggregates?: InputMaybe<CaseInvestigationTraderAggregatesFilter>;
  /** Every related `CaseInvestigationTrader` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseInvestigationTraderFilter>;
  /** No related `CaseInvestigationTrader` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseInvestigationTraderFilter>;
  /** Some related `CaseInvestigationTrader` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseInvestigationTraderFilter>;
};

/** A filter to be used against many `CaseLabelAssignment` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationToManyCaseLabelAssignmentFilter = {
  /** Aggregates across related `CaseLabelAssignment` match the filter criteria. */
  aggregates?: InputMaybe<CaseLabelAssignmentAggregatesFilter>;
  /** Every related `CaseLabelAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CaseLabelAssignmentFilter>;
  /** No related `CaseLabelAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CaseLabelAssignmentFilter>;
  /** Some related `CaseLabelAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CaseLabelAssignmentFilter>;
};

export type CaseInvestigationTrader = Node & {
  __typename?: 'CaseInvestigationTrader';
  /** Reads a single `CaseInvestigation` that is related to this `CaseInvestigationTrader`. */
  caseInvestigation?: Maybe<CaseInvestigation>;
  caseInvestigationId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  idvLink?: Maybe<Scalars['String']['output']>;
  intercomLink?: Maybe<Scalars['String']['output']>;
  pendingAction: CaseInvestigationPendingAction;
  pendingActionDetails?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `ReasonCode` that is related to this `CaseInvestigationTrader`. */
  reasonCode?: Maybe<ReasonCode>;
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  traderId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationTraderAggregates = {
  __typename?: 'CaseInvestigationTraderAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseInvestigationTraderAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseInvestigationTraderDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseInvestigationTraderMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseInvestigationTraderMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseInvestigationTraderStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseInvestigationTraderStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseInvestigationTraderSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseInvestigationTraderVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseInvestigationTraderVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CaseInvestigationTrader` object types. */
export type CaseInvestigationTraderAggregatesFilter = {
  /** Mean average aggregate over matching `CaseInvestigationTrader` objects. */
  average?: InputMaybe<CaseInvestigationTraderAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CaseInvestigationTrader` objects. */
  distinctCount?: InputMaybe<CaseInvestigationTraderDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CaseInvestigationTrader` object to be included within the aggregate. */
  filter?: InputMaybe<CaseInvestigationTraderFilter>;
  /** Maximum aggregate over matching `CaseInvestigationTrader` objects. */
  max?: InputMaybe<CaseInvestigationTraderMaxAggregateFilter>;
  /** Minimum aggregate over matching `CaseInvestigationTrader` objects. */
  min?: InputMaybe<CaseInvestigationTraderMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CaseInvestigationTrader` objects. */
  stddevPopulation?: InputMaybe<CaseInvestigationTraderStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CaseInvestigationTrader` objects. */
  stddevSample?: InputMaybe<CaseInvestigationTraderStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CaseInvestigationTrader` objects. */
  sum?: InputMaybe<CaseInvestigationTraderSumAggregateFilter>;
  /** Population variance aggregate over matching `CaseInvestigationTrader` objects. */
  variancePopulation?: InputMaybe<CaseInvestigationTraderVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CaseInvestigationTrader` objects. */
  varianceSample?: InputMaybe<CaseInvestigationTraderVarianceSampleAggregateFilter>;
};

export type CaseInvestigationTraderAverageAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationTraderAverageAggregates = {
  __typename?: 'CaseInvestigationTraderAverageAggregates';
  /** Mean average of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseInvestigationTrader` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CaseInvestigationTraderCondition = {
  /** Checks for equality with the object’s `caseInvestigationId` field. */
  caseInvestigationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reasonCodeId` field. */
  reasonCodeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `traderId` field. */
  traderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseInvestigationTrader` values. */
export type CaseInvestigationTraderConnection = {
  __typename?: 'CaseInvestigationTraderConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseInvestigationTraderAggregates>;
  /** A list of edges which contains the `CaseInvestigationTrader` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseInvestigationTraderEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseInvestigationTraderAggregates>>;
  /** A list of `CaseInvestigationTrader` objects. */
  nodes: Array<Maybe<CaseInvestigationTrader>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseInvestigationTrader` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseInvestigationTrader` values. */
export type CaseInvestigationTraderConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseInvestigationTraderGroupBy>;
  having?: InputMaybe<CaseInvestigationTraderHavingInput>;
};

export type CaseInvestigationTraderDistinctCountAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigIntFilter>;
  reasonCodeId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type CaseInvestigationTraderDistinctCountAggregates = {
  __typename?: 'CaseInvestigationTraderDistinctCountAggregates';
  /** Distinct count of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idvLink across the matching connection */
  idvLink?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intercomLink across the matching connection */
  intercomLink?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pendingAction across the matching connection */
  pendingAction?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pendingActionDetails across the matching connection */
  pendingActionDetails?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseInvestigationTrader` edge in the connection. */
export type CaseInvestigationTraderEdge = {
  __typename?: 'CaseInvestigationTraderEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseInvestigationTrader` at the end of the edge. */
  node?: Maybe<CaseInvestigationTrader>;
};

/** A filter to be used against `CaseInvestigationTrader` object types. All fields are combined with a logical ‘and.’ */
export type CaseInvestigationTraderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseInvestigationTraderFilter>>;
  /** Filter by the object’s `caseInvestigation` relation. */
  caseInvestigation?: InputMaybe<CaseInvestigationFilter>;
  /** Filter by the object’s `caseInvestigationId` field. */
  caseInvestigationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseInvestigationTraderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseInvestigationTraderFilter>>;
  /** Filter by the object’s `reasonCode` relation. */
  reasonCode?: InputMaybe<ReasonCodeFilter>;
  /** A related `reasonCode` exists. */
  reasonCodeExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `reasonCodeId` field. */
  reasonCodeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderId` field. */
  traderId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CaseInvestigationTrader` for usage during aggregation. */
export enum CaseInvestigationTraderGroupBy {
  CaseInvestigationId = 'CASE_INVESTIGATION_ID',
  ReasonCodeId = 'REASON_CODE_ID',
  TraderId = 'TRADER_ID'
}

export type CaseInvestigationTraderHavingAverageInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingDistinctCountInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseInvestigationTrader` aggregates. */
export type CaseInvestigationTraderHavingInput = {
  AND?: InputMaybe<Array<CaseInvestigationTraderHavingInput>>;
  OR?: InputMaybe<Array<CaseInvestigationTraderHavingInput>>;
  average?: InputMaybe<CaseInvestigationTraderHavingAverageInput>;
  distinctCount?: InputMaybe<CaseInvestigationTraderHavingDistinctCountInput>;
  max?: InputMaybe<CaseInvestigationTraderHavingMaxInput>;
  min?: InputMaybe<CaseInvestigationTraderHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseInvestigationTraderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseInvestigationTraderHavingStddevSampleInput>;
  sum?: InputMaybe<CaseInvestigationTraderHavingSumInput>;
  variancePopulation?: InputMaybe<CaseInvestigationTraderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseInvestigationTraderHavingVarianceSampleInput>;
};

export type CaseInvestigationTraderHavingMaxInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingMinInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingStddevPopulationInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingStddevSampleInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingSumInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingVariancePopulationInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderHavingVarianceSampleInput = {
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type CaseInvestigationTraderMaxAggregateFilter = {
  caseInvestigationId?: InputMaybe<IntFilter>;
  reasonCodeId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type CaseInvestigationTraderMaxAggregates = {
  __typename?: 'CaseInvestigationTraderMaxAggregates';
  /** Maximum of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationTraderMinAggregateFilter = {
  caseInvestigationId?: InputMaybe<IntFilter>;
  reasonCodeId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type CaseInvestigationTraderMinAggregates = {
  __typename?: 'CaseInvestigationTraderMinAggregates';
  /** Minimum of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseInvestigationTrader`. */
export enum CaseInvestigationTraderOrderBy {
  CaseInvestigationIdAsc = 'CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationIdDesc = 'CASE_INVESTIGATION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonCodeIdAsc = 'REASON_CODE_ID_ASC',
  ReasonCodeIdDesc = 'REASON_CODE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderIdAsc = 'TRADER_ID_ASC',
  TraderIdDesc = 'TRADER_ID_DESC'
}

export type CaseInvestigationTraderPendingDetailsResult = {
  __typename?: 'CaseInvestigationTraderPendingDetailsResult';
  payoutHold?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<Scalars['Boolean']['output']>;
};

export type CaseInvestigationTraderResult = {
  __typename?: 'CaseInvestigationTraderResult';
  caseInvestigationId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  idvLink?: Maybe<Scalars['String']['output']>;
  intercomLink?: Maybe<Scalars['String']['output']>;
  pendingAction: Scalars['String']['output'];
  pendingActionDetails?: Maybe<CaseInvestigationTraderPendingDetailsResult>;
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  traderId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseInvestigationTraderStddevPopulationAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationTraderStddevPopulationAggregates = {
  __typename?: 'CaseInvestigationTraderStddevPopulationAggregates';
  /** Population standard deviation of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationTraderStddevSampleAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationTraderStddevSampleAggregates = {
  __typename?: 'CaseInvestigationTraderStddevSampleAggregates';
  /** Sample standard deviation of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationTraderSumAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigIntFilter>;
  reasonCodeId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type CaseInvestigationTraderSumAggregates = {
  __typename?: 'CaseInvestigationTraderSumAggregates';
  /** Sum of caseInvestigationId across the matching connection */
  caseInvestigationId: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of reasonCodeId across the matching connection */
  reasonCodeId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of traderId across the matching connection */
  traderId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

export type CaseInvestigationTraderVariancePopulationAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationTraderVariancePopulationAggregates = {
  __typename?: 'CaseInvestigationTraderVariancePopulationAggregates';
  /** Population variance of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationTraderVarianceSampleAggregateFilter = {
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  reasonCodeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationTraderVarianceSampleAggregates = {
  __typename?: 'CaseInvestigationTraderVarianceSampleAggregates';
  /** Sample variance of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationTradersInput = {
  investigationId: Scalars['Int']['input'];
  traderIds: Array<Scalars['Int']['input']>;
};

export type CaseInvestigationTradersRemovedResult = {
  __typename?: 'CaseInvestigationTradersRemovedResult';
  cancelledCase: Scalars['Boolean']['output'];
  traders: Array<CaseInvestigationTraderResult>;
};

export type CaseInvestigationVariancePopulationAggregateFilter = {
  assignedTo?: InputMaybe<BigFloatFilter>;
  caseTypeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  submittedByDepartmentId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationVariancePopulationAggregates = {
  __typename?: 'CaseInvestigationVariancePopulationAggregates';
  /** Population variance of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseInvestigationVarianceSampleAggregateFilter = {
  assignedTo?: InputMaybe<BigFloatFilter>;
  caseTypeId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  submittedByDepartmentId?: InputMaybe<BigFloatFilter>;
};

export type CaseInvestigationVarianceSampleAggregates = {
  __typename?: 'CaseInvestigationVarianceSampleAggregates';
  /** Sample variance of assignedTo across the matching connection */
  assignedTo?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of caseTypeId across the matching connection */
  caseTypeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of submittedByDepartmentId across the matching connection */
  submittedByDepartmentId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabel = Node & {
  __typename?: 'CaseLabel';
  /** Reads and enables pagination through a set of `CaseLabelAssignment`. */
  caseLabelAssignments: CaseLabelAssignmentConnection;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


export type CaseLabelCaseLabelAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseLabelAssignmentCondition>;
  filter?: InputMaybe<CaseLabelAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseLabelAssignmentOrderBy>>;
};

export type CaseLabelAggregates = {
  __typename?: 'CaseLabelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseLabelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseLabelDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseLabelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseLabelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseLabelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseLabelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseLabelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseLabelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseLabelVarianceSampleAggregates>;
};

export type CaseLabelAssignment = Node & {
  __typename?: 'CaseLabelAssignment';
  /** Reads a single `CaseBan` that is related to this `CaseLabelAssignment`. */
  caseBan?: Maybe<CaseBan>;
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CaseInvestigation` that is related to this `CaseLabelAssignment`. */
  caseInvestigation?: Maybe<CaseInvestigation>;
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CaseLabel` that is related to this `CaseLabelAssignment`. */
  caseLabel?: Maybe<CaseLabel>;
  caseLabelId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
};

export type CaseLabelAssignmentAggregates = {
  __typename?: 'CaseLabelAssignmentAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseLabelAssignmentAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseLabelAssignmentDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseLabelAssignmentMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseLabelAssignmentMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseLabelAssignmentStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseLabelAssignmentStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseLabelAssignmentSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseLabelAssignmentVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseLabelAssignmentVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CaseLabelAssignment` object types. */
export type CaseLabelAssignmentAggregatesFilter = {
  /** Mean average aggregate over matching `CaseLabelAssignment` objects. */
  average?: InputMaybe<CaseLabelAssignmentAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CaseLabelAssignment` objects. */
  distinctCount?: InputMaybe<CaseLabelAssignmentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CaseLabelAssignment` object to be included within the aggregate. */
  filter?: InputMaybe<CaseLabelAssignmentFilter>;
  /** Maximum aggregate over matching `CaseLabelAssignment` objects. */
  max?: InputMaybe<CaseLabelAssignmentMaxAggregateFilter>;
  /** Minimum aggregate over matching `CaseLabelAssignment` objects. */
  min?: InputMaybe<CaseLabelAssignmentMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CaseLabelAssignment` objects. */
  stddevPopulation?: InputMaybe<CaseLabelAssignmentStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CaseLabelAssignment` objects. */
  stddevSample?: InputMaybe<CaseLabelAssignmentStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CaseLabelAssignment` objects. */
  sum?: InputMaybe<CaseLabelAssignmentSumAggregateFilter>;
  /** Population variance aggregate over matching `CaseLabelAssignment` objects. */
  variancePopulation?: InputMaybe<CaseLabelAssignmentVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CaseLabelAssignment` objects. */
  varianceSample?: InputMaybe<CaseLabelAssignmentVarianceSampleAggregateFilter>;
};

export type CaseLabelAssignmentAverageAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  caseLabelId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseLabelAssignmentAverageAggregates = {
  __typename?: 'CaseLabelAssignmentAverageAggregates';
  /** Mean average of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseLabelAssignment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CaseLabelAssignmentCondition = {
  /** Checks for equality with the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `caseInvestigationId` field. */
  caseInvestigationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `caseLabelId` field. */
  caseLabelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseLabelAssignment` values. */
export type CaseLabelAssignmentConnection = {
  __typename?: 'CaseLabelAssignmentConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseLabelAssignmentAggregates>;
  /** A list of edges which contains the `CaseLabelAssignment` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseLabelAssignmentEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CaseLabelAssignmentAggregates>>;
  /** A list of `CaseLabelAssignment` objects. */
  nodes: Array<Maybe<CaseLabelAssignment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseLabelAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CaseLabelAssignment` values. */
export type CaseLabelAssignmentConnectionGroupedAggregatesArgs = {
  groupBy: Array<CaseLabelAssignmentGroupBy>;
  having?: InputMaybe<CaseLabelAssignmentHavingInput>;
};

export type CaseLabelAssignmentDistinctCountAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  caseInvestigationId?: InputMaybe<BigIntFilter>;
  caseLabelId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type CaseLabelAssignmentDistinctCountAggregates = {
  __typename?: 'CaseLabelAssignmentDistinctCountAggregates';
  /** Distinct count of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseLabelAssignment` edge in the connection. */
export type CaseLabelAssignmentEdge = {
  __typename?: 'CaseLabelAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseLabelAssignment` at the end of the edge. */
  node?: Maybe<CaseLabelAssignment>;
};

/** A filter to be used against `CaseLabelAssignment` object types. All fields are combined with a logical ‘and.’ */
export type CaseLabelAssignmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseLabelAssignmentFilter>>;
  /** Filter by the object’s `caseBanId` field. */
  caseBanId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `caseInvestigationId` field. */
  caseInvestigationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `caseLabel` relation. */
  caseLabel?: InputMaybe<CaseLabelFilter>;
  /** Filter by the object’s `caseLabelId` field. */
  caseLabelId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseLabelAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseLabelAssignmentFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CaseLabelAssignment` for usage during aggregation. */
export enum CaseLabelAssignmentGroupBy {
  CaseBanId = 'CASE_BAN_ID',
  CaseInvestigationId = 'CASE_INVESTIGATION_ID',
  CaseLabelId = 'CASE_LABEL_ID'
}

export type CaseLabelAssignmentHavingAverageInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingDistinctCountInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CaseLabelAssignment` aggregates. */
export type CaseLabelAssignmentHavingInput = {
  AND?: InputMaybe<Array<CaseLabelAssignmentHavingInput>>;
  OR?: InputMaybe<Array<CaseLabelAssignmentHavingInput>>;
  average?: InputMaybe<CaseLabelAssignmentHavingAverageInput>;
  distinctCount?: InputMaybe<CaseLabelAssignmentHavingDistinctCountInput>;
  max?: InputMaybe<CaseLabelAssignmentHavingMaxInput>;
  min?: InputMaybe<CaseLabelAssignmentHavingMinInput>;
  stddevPopulation?: InputMaybe<CaseLabelAssignmentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CaseLabelAssignmentHavingStddevSampleInput>;
  sum?: InputMaybe<CaseLabelAssignmentHavingSumInput>;
  variancePopulation?: InputMaybe<CaseLabelAssignmentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CaseLabelAssignmentHavingVarianceSampleInput>;
};

export type CaseLabelAssignmentHavingMaxInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingMinInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingStddevPopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingStddevSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingSumInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingVariancePopulationInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentHavingVarianceSampleInput = {
  caseBanId?: InputMaybe<HavingIntFilter>;
  caseInvestigationId?: InputMaybe<HavingIntFilter>;
  caseLabelId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type CaseLabelAssignmentMaxAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  caseInvestigationId?: InputMaybe<IntFilter>;
  caseLabelId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type CaseLabelAssignmentMaxAggregates = {
  __typename?: 'CaseLabelAssignmentMaxAggregates';
  /** Maximum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type CaseLabelAssignmentMinAggregateFilter = {
  caseBanId?: InputMaybe<IntFilter>;
  caseInvestigationId?: InputMaybe<IntFilter>;
  caseLabelId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type CaseLabelAssignmentMinAggregates = {
  __typename?: 'CaseLabelAssignmentMinAggregates';
  /** Minimum of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseLabelAssignment`. */
export enum CaseLabelAssignmentOrderBy {
  CaseBanIdAsc = 'CASE_BAN_ID_ASC',
  CaseBanIdDesc = 'CASE_BAN_ID_DESC',
  CaseInvestigationIdAsc = 'CASE_INVESTIGATION_ID_ASC',
  CaseInvestigationIdDesc = 'CASE_INVESTIGATION_ID_DESC',
  CaseLabelIdAsc = 'CASE_LABEL_ID_ASC',
  CaseLabelIdDesc = 'CASE_LABEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type CaseLabelAssignmentStddevPopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  caseLabelId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseLabelAssignmentStddevPopulationAggregates = {
  __typename?: 'CaseLabelAssignmentStddevPopulationAggregates';
  /** Population standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelAssignmentStddevSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  caseLabelId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseLabelAssignmentStddevSampleAggregates = {
  __typename?: 'CaseLabelAssignmentStddevSampleAggregates';
  /** Sample standard deviation of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelAssignmentSumAggregateFilter = {
  caseBanId?: InputMaybe<BigIntFilter>;
  caseInvestigationId?: InputMaybe<BigIntFilter>;
  caseLabelId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type CaseLabelAssignmentSumAggregates = {
  __typename?: 'CaseLabelAssignmentSumAggregates';
  /** Sum of caseBanId across the matching connection */
  caseBanId: Scalars['BigInt']['output'];
  /** Sum of caseInvestigationId across the matching connection */
  caseInvestigationId: Scalars['BigInt']['output'];
  /** Sum of caseLabelId across the matching connection */
  caseLabelId: Scalars['BigInt']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type CaseLabelAssignmentVariancePopulationAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  caseLabelId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseLabelAssignmentVariancePopulationAggregates = {
  __typename?: 'CaseLabelAssignmentVariancePopulationAggregates';
  /** Population variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelAssignmentVarianceSampleAggregateFilter = {
  caseBanId?: InputMaybe<BigFloatFilter>;
  caseInvestigationId?: InputMaybe<BigFloatFilter>;
  caseLabelId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CaseLabelAssignmentVarianceSampleAggregates = {
  __typename?: 'CaseLabelAssignmentVarianceSampleAggregates';
  /** Sample variance of caseBanId across the matching connection */
  caseBanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of caseInvestigationId across the matching connection */
  caseInvestigationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of caseLabelId across the matching connection */
  caseLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelAverageAggregates = {
  __typename?: 'CaseLabelAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseLabel` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CaseLabelCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseLabel` values. */
export type CaseLabelConnection = {
  __typename?: 'CaseLabelConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseLabelAggregates>;
  /** A list of edges which contains the `CaseLabel` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseLabelEdge>>;
  /** A list of `CaseLabel` objects. */
  nodes: Array<Maybe<CaseLabel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseLabel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type CaseLabelDistinctCountAggregates = {
  __typename?: 'CaseLabelDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseLabel` edge in the connection. */
export type CaseLabelEdge = {
  __typename?: 'CaseLabelEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseLabel` at the end of the edge. */
  node?: Maybe<CaseLabel>;
};

/** A filter to be used against `CaseLabel` object types. All fields are combined with a logical ‘and.’ */
export type CaseLabelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseLabelFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseLabelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseLabelFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type CaseLabelMaxAggregates = {
  __typename?: 'CaseLabelMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseLabelMinAggregates = {
  __typename?: 'CaseLabelMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseLabel`. */
export enum CaseLabelOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type CaseLabelStddevPopulationAggregates = {
  __typename?: 'CaseLabelStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelStddevSampleAggregates = {
  __typename?: 'CaseLabelStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelSumAggregates = {
  __typename?: 'CaseLabelSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

export type CaseLabelVariancePopulationAggregates = {
  __typename?: 'CaseLabelVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseLabelVarianceSampleAggregates = {
  __typename?: 'CaseLabelVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export enum CaseSeverity {
  Normal = 'normal',
  Urgent = 'urgent'
}

/** A filter to be used against CaseSeverity fields. All fields are combined with a logical ‘and.’ */
export type CaseSeverityFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CaseSeverity>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CaseSeverity>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CaseSeverity>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CaseSeverity>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CaseSeverity>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CaseSeverity>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CaseSeverity>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CaseSeverity>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CaseSeverity>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CaseSeverity>>;
};

export enum CaseStatus {
  Cancelled = 'cancelled',
  Closed = 'closed',
  Hold = 'hold',
  New = 'new',
  Open = 'open'
}

/** A filter to be used against CaseStatus fields. All fields are combined with a logical ‘and.’ */
export type CaseStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CaseStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CaseStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CaseStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CaseStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CaseStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CaseStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CaseStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CaseStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CaseStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CaseStatus>>;
};

export type CaseType = Node & {
  __typename?: 'CaseType';
  active: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `CaseInvestigation`. */
  caseInvestigations: CaseInvestigationConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


export type CaseTypeCaseInvestigationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseInvestigationCondition>;
  filter?: InputMaybe<CaseInvestigationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseInvestigationOrderBy>>;
};

export type CaseTypeAggregates = {
  __typename?: 'CaseTypeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CaseTypeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CaseTypeDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CaseTypeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CaseTypeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CaseTypeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CaseTypeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CaseTypeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CaseTypeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CaseTypeVarianceSampleAggregates>;
};

export type CaseTypeAverageAggregates = {
  __typename?: 'CaseTypeAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CaseType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CaseTypeCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CaseType` values. */
export type CaseTypeConnection = {
  __typename?: 'CaseTypeConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CaseTypeAggregates>;
  /** A list of edges which contains the `CaseType` and cursor to aid in pagination. */
  edges: Array<Maybe<CaseTypeEdge>>;
  /** A list of `CaseType` objects. */
  nodes: Array<Maybe<CaseType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type CaseTypeDistinctCountAggregates = {
  __typename?: 'CaseTypeDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of code across the matching connection */
  code?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CaseType` edge in the connection. */
export type CaseTypeEdge = {
  __typename?: 'CaseTypeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaseType` at the end of the edge. */
  node?: Maybe<CaseType>;
};

/** A filter to be used against `CaseType` object types. All fields are combined with a logical ‘and.’ */
export type CaseTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CaseTypeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CaseTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CaseTypeFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type CaseTypeMaxAggregates = {
  __typename?: 'CaseTypeMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CaseTypeMinAggregates = {
  __typename?: 'CaseTypeMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CaseType`. */
export enum CaseTypeOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type CaseTypeStddevPopulationAggregates = {
  __typename?: 'CaseTypeStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseTypeStddevSampleAggregates = {
  __typename?: 'CaseTypeStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseTypeSumAggregates = {
  __typename?: 'CaseTypeSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

export type CaseTypeVariancePopulationAggregates = {
  __typename?: 'CaseTypeVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type CaseTypeVarianceSampleAggregates = {
  __typename?: 'CaseTypeVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type Chargeback = Node & {
  __typename?: 'Chargeback';
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  arn?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Datetime']['output']>;
  challengedAt?: Maybe<Scalars['Datetime']['output']>;
  chargebackDate?: Maybe<Scalars['Date']['output']>;
  chargebackKey: Scalars['String']['output'];
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  decisions: Scalars['JSON']['output'];
  disputeId?: Maybe<Scalars['String']['output']>;
  fields: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  lastChangedAt: Scalars['Datetime']['output'];
  linkStatus: Scalars['String']['output'];
  lostAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Chargeback` that is related to this `Chargeback`. */
  mergedInto?: Maybe<Chargeback>;
  mergedIntoId?: Maybe<Scalars['UUID']['output']>;
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  openedAt: Scalars['Datetime']['output'];
  priority: Scalars['Int']['output'];
  problemCount: Scalars['Int']['output'];
  problems: Scalars['JSON']['output'];
  processor: ChargebackProcessor;
  /** Reads a single `Purchase` that is related to this `Chargeback`. */
  purchase?: Maybe<Purchase>;
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `PurchaseOrder` that is related to this `Chargeback`. */
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  readActionId: Scalars['BigInt']['output'];
  readVersionId: Scalars['BigInt']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  removedAt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['UUID']['output'];
  settledAt?: Maybe<Scalars['Datetime']['output']>;
  source: Scalars['String']['output'];
  sourceIds: Array<Maybe<Scalars['String']['output']>>;
  traderUserId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  withdrawnAt?: Maybe<Scalars['Datetime']['output']>;
  wonAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ChargebackAdminAction = Node & {
  __typename?: 'ChargebackAdminAction';
  action: Scalars['String']['output'];
  actorId?: Maybe<Scalars['Int']['output']>;
  at: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  target: Scalars['JSON']['output'];
  targetChargebackId?: Maybe<Scalars['UUID']['output']>;
  targetPurchaseOrderId?: Maybe<Scalars['Int']['output']>;
  targetSourceId?: Maybe<Scalars['String']['output']>;
};

export type ChargebackAggregates = {
  __typename?: 'ChargebackAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ChargebackAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ChargebackDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ChargebackMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ChargebackMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ChargebackStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ChargebackStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ChargebackSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ChargebackVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ChargebackVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Chargeback` object types. */
export type ChargebackAggregatesFilter = {
  /** Mean average aggregate over matching `Chargeback` objects. */
  average?: InputMaybe<ChargebackAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Chargeback` objects. */
  distinctCount?: InputMaybe<ChargebackDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Chargeback` object to be included within the aggregate. */
  filter?: InputMaybe<ChargebackFilter>;
  /** Maximum aggregate over matching `Chargeback` objects. */
  max?: InputMaybe<ChargebackMaxAggregateFilter>;
  /** Minimum aggregate over matching `Chargeback` objects. */
  min?: InputMaybe<ChargebackMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Chargeback` objects. */
  stddevPopulation?: InputMaybe<ChargebackStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Chargeback` objects. */
  stddevSample?: InputMaybe<ChargebackStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Chargeback` objects. */
  sum?: InputMaybe<ChargebackSumAggregateFilter>;
  /** Population variance aggregate over matching `Chargeback` objects. */
  variancePopulation?: InputMaybe<ChargebackVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Chargeback` objects. */
  varianceSample?: InputMaybe<ChargebackVarianceSampleAggregateFilter>;
};

export type ChargebackAverageAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackAverageAggregates = {
  __typename?: 'ChargebackAverageAggregates';
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of priority across the matching connection */
  priority?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Chargeback` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ChargebackCondition = {
  /** Checks for equality with the object’s `chargebackKey` field. */
  chargebackKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `traderUserId` field. */
  traderUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Chargeback` values. */
export type ChargebackConnection = {
  __typename?: 'ChargebackConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ChargebackAggregates>;
  /** A list of edges which contains the `Chargeback` and cursor to aid in pagination. */
  edges: Array<Maybe<ChargebackEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ChargebackAggregates>>;
  /** A list of `Chargeback` objects. */
  nodes: Array<Maybe<Chargeback>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Chargeback` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Chargeback` values. */
export type ChargebackConnectionGroupedAggregatesArgs = {
  groupBy: Array<ChargebackGroupBy>;
  having?: InputMaybe<ChargebackHavingInput>;
};

export type ChargebackDistinctCountAggregateFilter = {
  chargebackKey?: InputMaybe<BigIntFilter>;
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  traderUserId?: InputMaybe<BigIntFilter>;
};

export type ChargebackDistinctCountAggregates = {
  __typename?: 'ChargebackDistinctCountAggregates';
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of arn across the matching connection */
  arn?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cancelledAt across the matching connection */
  cancelledAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of challengedAt across the matching connection */
  challengedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chargebackDate across the matching connection */
  chargebackDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chargebackKey across the matching connection */
  chargebackKey?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closedAt across the matching connection */
  closedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of decisions across the matching connection */
  decisions?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of disputeId across the matching connection */
  disputeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fields across the matching connection */
  fields?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of kind across the matching connection */
  kind?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastChangedAt across the matching connection */
  lastChangedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of linkStatus across the matching connection */
  linkStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lostAt across the matching connection */
  lostAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of mergedIntoId across the matching connection */
  mergedIntoId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of needsReview across the matching connection */
  needsReview?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openedAt across the matching connection */
  openedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priority across the matching connection */
  priority?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of problems across the matching connection */
  problems?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of processor across the matching connection */
  processor?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reason across the matching connection */
  reason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reasonCode across the matching connection */
  reasonCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of removedAt across the matching connection */
  removedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of settledAt across the matching connection */
  settledAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of source across the matching connection */
  source?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceIds across the matching connection */
  sourceIds?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of withdrawnAt across the matching connection */
  withdrawnAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of wonAt across the matching connection */
  wonAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Chargeback` edge in the connection. */
export type ChargebackEdge = {
  __typename?: 'ChargebackEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Chargeback` at the end of the edge. */
  node?: Maybe<Chargeback>;
};

export type ChargebackFeedRun = Node & {
  __typename?: 'ChargebackFeedRun';
  /** Reads and enables pagination through a set of `ChargebackFeedVersion`. */
  chargebackFeedVersionsByRunId: ChargebackFeedVersionConnection;
  diagnostics?: Maybe<Scalars['JSON']['output']>;
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  missing: Array<Maybe<Scalars['String']['output']>>;
  refreshedAt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['String']['output'];
  source: Scalars['String']['output'];
  startedAt: Scalars['Datetime']['output'];
  status: Scalars['String']['output'];
};


export type ChargebackFeedRunChargebackFeedVersionsByRunIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChargebackFeedVersionCondition>;
  filter?: InputMaybe<ChargebackFeedVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChargebackFeedVersionOrderBy>>;
};

/** A filter to be used against `ChargebackFeedRun` object types. All fields are combined with a logical ‘and.’ */
export type ChargebackFeedRunFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChargebackFeedRunFilter>>;
  /** Filter by the object’s `chargebackFeedVersionsByRunId` relation. */
  chargebackFeedVersionsByRunId?: InputMaybe<ChargebackFeedRunToManyChargebackFeedVersionFilter>;
  /** Some related `chargebackFeedVersionsByRunId` exist. */
  chargebackFeedVersionsByRunIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<ChargebackFeedRunFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChargebackFeedRunFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `ChargebackFeedVersion` object types. All fields are combined with a logical ‘and.’ */
export type ChargebackFeedRunToManyChargebackFeedVersionFilter = {
  /** Aggregates across related `ChargebackFeedVersion` match the filter criteria. */
  aggregates?: InputMaybe<ChargebackFeedVersionAggregatesFilter>;
  /** Every related `ChargebackFeedVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ChargebackFeedVersionFilter>;
  /** No related `ChargebackFeedVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ChargebackFeedVersionFilter>;
  /** Some related `ChargebackFeedVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ChargebackFeedVersionFilter>;
};

export type ChargebackFeedSource = Node & {
  __typename?: 'ChargebackFeedSource';
  contentHash?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['Datetime']['output'];
  sourceId: Scalars['String']['output'];
};

export type ChargebackFeedVersion = Node & {
  __typename?: 'ChargebackFeedVersion';
  contentHash?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  observedAt: Scalars['Datetime']['output'];
  raw?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['BigInt']['output'];
  /** Reads a single `ChargebackFeedRun` that is related to this `ChargebackFeedVersion`. */
  run?: Maybe<ChargebackFeedRun>;
  runId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

export type ChargebackFeedVersionAggregates = {
  __typename?: 'ChargebackFeedVersionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ChargebackFeedVersionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ChargebackFeedVersionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ChargebackFeedVersionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ChargebackFeedVersionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ChargebackFeedVersionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ChargebackFeedVersionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ChargebackFeedVersionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ChargebackFeedVersionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ChargebackFeedVersionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ChargebackFeedVersion` object types. */
export type ChargebackFeedVersionAggregatesFilter = {
  /** Mean average aggregate over matching `ChargebackFeedVersion` objects. */
  average?: InputMaybe<ChargebackFeedVersionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ChargebackFeedVersion` objects. */
  distinctCount?: InputMaybe<ChargebackFeedVersionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ChargebackFeedVersion` object to be included within the aggregate. */
  filter?: InputMaybe<ChargebackFeedVersionFilter>;
  /** Maximum aggregate over matching `ChargebackFeedVersion` objects. */
  max?: InputMaybe<ChargebackFeedVersionMaxAggregateFilter>;
  /** Minimum aggregate over matching `ChargebackFeedVersion` objects. */
  min?: InputMaybe<ChargebackFeedVersionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ChargebackFeedVersion` objects. */
  stddevPopulation?: InputMaybe<ChargebackFeedVersionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ChargebackFeedVersion` objects. */
  stddevSample?: InputMaybe<ChargebackFeedVersionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ChargebackFeedVersion` objects. */
  sum?: InputMaybe<ChargebackFeedVersionSumAggregateFilter>;
  /** Population variance aggregate over matching `ChargebackFeedVersion` objects. */
  variancePopulation?: InputMaybe<ChargebackFeedVersionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ChargebackFeedVersion` objects. */
  varianceSample?: InputMaybe<ChargebackFeedVersionVarianceSampleAggregateFilter>;
};

export type ChargebackFeedVersionAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackFeedVersionAverageAggregates = {
  __typename?: 'ChargebackFeedVersionAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ChargebackFeedVersion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChargebackFeedVersionCondition = {
  /** Checks for equality with the object’s `observedAt` field. */
  observedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `runId` field. */
  runId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ChargebackFeedVersion` values. */
export type ChargebackFeedVersionConnection = {
  __typename?: 'ChargebackFeedVersionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ChargebackFeedVersionAggregates>;
  /** A list of edges which contains the `ChargebackFeedVersion` and cursor to aid in pagination. */
  edges: Array<Maybe<ChargebackFeedVersionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ChargebackFeedVersionAggregates>>;
  /** A list of `ChargebackFeedVersion` objects. */
  nodes: Array<Maybe<ChargebackFeedVersion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChargebackFeedVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ChargebackFeedVersion` values. */
export type ChargebackFeedVersionConnectionGroupedAggregatesArgs = {
  groupBy: Array<ChargebackFeedVersionGroupBy>;
  having?: InputMaybe<ChargebackFeedVersionHavingInput>;
};

export type ChargebackFeedVersionDistinctCountAggregateFilter = {
  observedAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  runId?: InputMaybe<BigIntFilter>;
  sourceId?: InputMaybe<BigIntFilter>;
};

export type ChargebackFeedVersionDistinctCountAggregates = {
  __typename?: 'ChargebackFeedVersionDistinctCountAggregates';
  /** Distinct count of contentHash across the matching connection */
  contentHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of observedAt across the matching connection */
  observedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of raw across the matching connection */
  raw?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of runId across the matching connection */
  runId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceId across the matching connection */
  sourceId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ChargebackFeedVersion` edge in the connection. */
export type ChargebackFeedVersionEdge = {
  __typename?: 'ChargebackFeedVersionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChargebackFeedVersion` at the end of the edge. */
  node?: Maybe<ChargebackFeedVersion>;
};

/** A filter to be used against `ChargebackFeedVersion` object types. All fields are combined with a logical ‘and.’ */
export type ChargebackFeedVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChargebackFeedVersionFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<ChargebackFeedVersionFilter>;
  /** Filter by the object’s `observedAt` field. */
  observedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChargebackFeedVersionFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `run` relation. */
  run?: InputMaybe<ChargebackFeedRunFilter>;
  /** Filter by the object’s `runId` field. */
  runId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
};

/** Grouping methods for `ChargebackFeedVersion` for usage during aggregation. */
export enum ChargebackFeedVersionGroupBy {
  ObservedAt = 'OBSERVED_AT',
  ObservedAtTruncatedToDay = 'OBSERVED_AT_TRUNCATED_TO_DAY',
  ObservedAtTruncatedToHour = 'OBSERVED_AT_TRUNCATED_TO_HOUR',
  RunId = 'RUN_ID',
  SourceId = 'SOURCE_ID'
}

export type ChargebackFeedVersionHavingAverageInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingDistinctCountInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `ChargebackFeedVersion` aggregates. */
export type ChargebackFeedVersionHavingInput = {
  AND?: InputMaybe<Array<ChargebackFeedVersionHavingInput>>;
  OR?: InputMaybe<Array<ChargebackFeedVersionHavingInput>>;
  average?: InputMaybe<ChargebackFeedVersionHavingAverageInput>;
  distinctCount?: InputMaybe<ChargebackFeedVersionHavingDistinctCountInput>;
  max?: InputMaybe<ChargebackFeedVersionHavingMaxInput>;
  min?: InputMaybe<ChargebackFeedVersionHavingMinInput>;
  stddevPopulation?: InputMaybe<ChargebackFeedVersionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ChargebackFeedVersionHavingStddevSampleInput>;
  sum?: InputMaybe<ChargebackFeedVersionHavingSumInput>;
  variancePopulation?: InputMaybe<ChargebackFeedVersionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ChargebackFeedVersionHavingVarianceSampleInput>;
};

export type ChargebackFeedVersionHavingMaxInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingMinInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingStddevPopulationInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingStddevSampleInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingSumInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingVariancePopulationInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionHavingVarianceSampleInput = {
  observedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingBigintFilter>;
};

export type ChargebackFeedVersionMaxAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
};

export type ChargebackFeedVersionMaxAggregates = {
  __typename?: 'ChargebackFeedVersionMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

export type ChargebackFeedVersionMinAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
};

export type ChargebackFeedVersionMinAggregates = {
  __typename?: 'ChargebackFeedVersionMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** Methods to use when ordering `ChargebackFeedVersion`. */
export enum ChargebackFeedVersionOrderBy {
  Natural = 'NATURAL',
  ObservedAtAsc = 'OBSERVED_AT_ASC',
  ObservedAtDesc = 'OBSERVED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  RunIdAsc = 'RUN_ID_ASC',
  RunIdDesc = 'RUN_ID_DESC',
  SourceIdAsc = 'SOURCE_ID_ASC',
  SourceIdDesc = 'SOURCE_ID_DESC'
}

export type ChargebackFeedVersionStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackFeedVersionStddevPopulationAggregates = {
  __typename?: 'ChargebackFeedVersionStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackFeedVersionStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackFeedVersionStddevSampleAggregates = {
  __typename?: 'ChargebackFeedVersionStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackFeedVersionSumAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackFeedVersionSumAggregates = {
  __typename?: 'ChargebackFeedVersionSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigFloat']['output'];
};

export type ChargebackFeedVersionVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackFeedVersionVariancePopulationAggregates = {
  __typename?: 'ChargebackFeedVersionVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackFeedVersionVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackFeedVersionVarianceSampleAggregates = {
  __typename?: 'ChargebackFeedVersionVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against `Chargeback` object types. All fields are combined with a logical ‘and.’ */
export type ChargebackFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChargebackFilter>>;
  /** Filter by the object’s `chargebackKey` field. */
  chargebackKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mergedInto` relation. */
  mergedInto?: InputMaybe<ChargebackFilter>;
  /** A related `mergedInto` exists. */
  mergedIntoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<ChargebackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChargebackFilter>>;
  /** Filter by the object’s `purchase` relation. */
  purchase?: InputMaybe<PurchaseFilter>;
  /** A related `purchase` exists. */
  purchaseExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseOrder` relation. */
  purchaseOrder?: InputMaybe<PurchaseOrderFilter>;
  /** A related `purchaseOrder` exists. */
  purchaseOrderExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `traderUserId` field. */
  traderUserId?: InputMaybe<IntFilter>;
};

export type ChargebackFlag = {
  __typename?: 'ChargebackFlag';
  amountUsd: Scalars['String']['output'];
  arn?: Maybe<Scalars['String']['output']>;
  /** Calendar date formatted as YYYY-MM-DD. No time zone is applied. */
  chargebackDate?: Maybe<Scalars['String']['output']>;
  disputeId?: Maybe<Scalars['String']['output']>;
  lifecycleState: ChargebackLifecycleState;
  processor: ChargebackProcessor;
  purchaseOrderId: Scalars['Int']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
};

/** Grouping methods for `Chargeback` for usage during aggregation. */
export enum ChargebackGroupBy {
  PurchaseOrderId = 'PURCHASE_ORDER_ID',
  TraderUserId = 'TRADER_USER_ID'
}

export type ChargebackHavingAverageInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingDistinctCountInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Chargeback` aggregates. */
export type ChargebackHavingInput = {
  AND?: InputMaybe<Array<ChargebackHavingInput>>;
  OR?: InputMaybe<Array<ChargebackHavingInput>>;
  average?: InputMaybe<ChargebackHavingAverageInput>;
  distinctCount?: InputMaybe<ChargebackHavingDistinctCountInput>;
  max?: InputMaybe<ChargebackHavingMaxInput>;
  min?: InputMaybe<ChargebackHavingMinInput>;
  stddevPopulation?: InputMaybe<ChargebackHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ChargebackHavingStddevSampleInput>;
  sum?: InputMaybe<ChargebackHavingSumInput>;
  variancePopulation?: InputMaybe<ChargebackHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ChargebackHavingVarianceSampleInput>;
};

export type ChargebackHavingMaxInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingMinInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingStddevPopulationInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingStddevSampleInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingSumInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingVariancePopulationInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackHavingVarianceSampleInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  cancelledAt?: InputMaybe<HavingDatetimeFilter>;
  challengedAt?: InputMaybe<HavingDatetimeFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastChangedAt?: InputMaybe<HavingDatetimeFilter>;
  lostAt?: InputMaybe<HavingDatetimeFilter>;
  openedAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  problemCount?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  readActionId?: InputMaybe<HavingBigintFilter>;
  readVersionId?: InputMaybe<HavingBigintFilter>;
  removedAt?: InputMaybe<HavingDatetimeFilter>;
  settledAt?: InputMaybe<HavingDatetimeFilter>;
  traderUserId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  withdrawnAt?: InputMaybe<HavingDatetimeFilter>;
  wonAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChargebackIndicator = Node & {
  __typename?: 'ChargebackIndicator';
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  arn?: Maybe<Scalars['String']['output']>;
  caseAction?: Maybe<Scalars['String']['output']>;
  chargebackDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  disputeId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  linkedByAdminId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  processor: ChargebackProcessor;
  processorStatus?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PurchaseOrder` that is related to this `ChargebackIndicator`. */
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  recoveryOutcome?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  sourceExtractedAt?: Maybe<Scalars['Datetime']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceTraderUserId?: Maybe<Scalars['String']['output']>;
  sourceTransactionId?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ChargebackIndicatorAggregates = {
  __typename?: 'ChargebackIndicatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ChargebackIndicatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ChargebackIndicatorDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ChargebackIndicatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ChargebackIndicatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ChargebackIndicatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ChargebackIndicatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ChargebackIndicatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ChargebackIndicatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ChargebackIndicatorVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ChargebackIndicator` object types. */
export type ChargebackIndicatorAggregatesFilter = {
  /** Mean average aggregate over matching `ChargebackIndicator` objects. */
  average?: InputMaybe<ChargebackIndicatorAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ChargebackIndicator` objects. */
  distinctCount?: InputMaybe<ChargebackIndicatorDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ChargebackIndicator` object to be included within the aggregate. */
  filter?: InputMaybe<ChargebackIndicatorFilter>;
  /** Maximum aggregate over matching `ChargebackIndicator` objects. */
  max?: InputMaybe<ChargebackIndicatorMaxAggregateFilter>;
  /** Minimum aggregate over matching `ChargebackIndicator` objects. */
  min?: InputMaybe<ChargebackIndicatorMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ChargebackIndicator` objects. */
  stddevPopulation?: InputMaybe<ChargebackIndicatorStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ChargebackIndicator` objects. */
  stddevSample?: InputMaybe<ChargebackIndicatorStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ChargebackIndicator` objects. */
  sum?: InputMaybe<ChargebackIndicatorSumAggregateFilter>;
  /** Population variance aggregate over matching `ChargebackIndicator` objects. */
  variancePopulation?: InputMaybe<ChargebackIndicatorVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ChargebackIndicator` objects. */
  varianceSample?: InputMaybe<ChargebackIndicatorVarianceSampleAggregateFilter>;
};

export type ChargebackIndicatorAverageAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackIndicatorAverageAggregates = {
  __typename?: 'ChargebackIndicatorAverageAggregates';
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ChargebackIndicator` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChargebackIndicatorCondition = {
  /** Checks for equality with the object’s `arn` field. */
  arn?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `processor` field. */
  processor?: InputMaybe<ChargebackProcessor>;
  /** Checks for equality with the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `recoveryOutcome` field. */
  recoveryOutcome?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceTransactionId` field. */
  sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ChargebackIndicator` values. */
export type ChargebackIndicatorConnection = {
  __typename?: 'ChargebackIndicatorConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ChargebackIndicatorAggregates>;
  /** A list of edges which contains the `ChargebackIndicator` and cursor to aid in pagination. */
  edges: Array<Maybe<ChargebackIndicatorEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ChargebackIndicatorAggregates>>;
  /** A list of `ChargebackIndicator` objects. */
  nodes: Array<Maybe<ChargebackIndicator>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChargebackIndicator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ChargebackIndicator` values. */
export type ChargebackIndicatorConnectionGroupedAggregatesArgs = {
  groupBy: Array<ChargebackIndicatorGroupBy>;
  having?: InputMaybe<ChargebackIndicatorHavingInput>;
};

export type ChargebackIndicatorDistinctCountAggregateFilter = {
  arn?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  processor?: InputMaybe<BigIntFilter>;
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  recoveryOutcome?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  sourceTransactionId?: InputMaybe<BigIntFilter>;
};

export type ChargebackIndicatorDistinctCountAggregates = {
  __typename?: 'ChargebackIndicatorDistinctCountAggregates';
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of arn across the matching connection */
  arn?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of caseAction across the matching connection */
  caseAction?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chargebackDate across the matching connection */
  chargebackDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of disputeId across the matching connection */
  disputeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of processor across the matching connection */
  processor?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of processorStatus across the matching connection */
  processorStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reasonCode across the matching connection */
  reasonCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reasonDescription across the matching connection */
  reasonDescription?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of recoveryOutcome across the matching connection */
  recoveryOutcome?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceExtractedAt across the matching connection */
  sourceExtractedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceId across the matching connection */
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceTraderUserId across the matching connection */
  sourceTraderUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceTransactionId across the matching connection */
  sourceTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stage across the matching connection */
  stage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ChargebackIndicator` edge in the connection. */
export type ChargebackIndicatorEdge = {
  __typename?: 'ChargebackIndicatorEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChargebackIndicator` at the end of the edge. */
  node?: Maybe<ChargebackIndicator>;
};

/** A filter to be used against `ChargebackIndicator` object types. All fields are combined with a logical ‘and.’ */
export type ChargebackIndicatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChargebackIndicatorFilter>>;
  /** Filter by the object’s `arn` field. */
  arn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChargebackIndicatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChargebackIndicatorFilter>>;
  /** Filter by the object’s `processor` field. */
  processor?: InputMaybe<ChargebackProcessorFilter>;
  /** Filter by the object’s `purchaseOrder` relation. */
  purchaseOrder?: InputMaybe<PurchaseOrderFilter>;
  /** A related `purchaseOrder` exists. */
  purchaseOrderExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `recoveryOutcome` field. */
  recoveryOutcome?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceTransactionId` field. */
  sourceTransactionId?: InputMaybe<StringFilter>;
};

/** Grouping methods for `ChargebackIndicator` for usage during aggregation. */
export enum ChargebackIndicatorGroupBy {
  Arn = 'ARN',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Processor = 'PROCESSOR',
  PurchaseOrderId = 'PURCHASE_ORDER_ID',
  RecoveryOutcome = 'RECOVERY_OUTCOME',
  SourceTransactionId = 'SOURCE_TRANSACTION_ID'
}

export type ChargebackIndicatorHavingAverageInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingDistinctCountInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `ChargebackIndicator` aggregates. */
export type ChargebackIndicatorHavingInput = {
  AND?: InputMaybe<Array<ChargebackIndicatorHavingInput>>;
  OR?: InputMaybe<Array<ChargebackIndicatorHavingInput>>;
  average?: InputMaybe<ChargebackIndicatorHavingAverageInput>;
  distinctCount?: InputMaybe<ChargebackIndicatorHavingDistinctCountInput>;
  max?: InputMaybe<ChargebackIndicatorHavingMaxInput>;
  min?: InputMaybe<ChargebackIndicatorHavingMinInput>;
  stddevPopulation?: InputMaybe<ChargebackIndicatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ChargebackIndicatorHavingStddevSampleInput>;
  sum?: InputMaybe<ChargebackIndicatorHavingSumInput>;
  variancePopulation?: InputMaybe<ChargebackIndicatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ChargebackIndicatorHavingVarianceSampleInput>;
};

export type ChargebackIndicatorHavingMaxInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingMinInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingStddevPopulationInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingStddevSampleInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingSumInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingVariancePopulationInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorHavingVarianceSampleInput = {
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  chargebackDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  linkedByAdminId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  sourceExtractedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ChargebackIndicatorMaxAggregateFilter = {
  purchaseOrderId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type ChargebackIndicatorMaxAggregates = {
  __typename?: 'ChargebackIndicatorMaxAggregates';
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ChargebackIndicatorMinAggregateFilter = {
  purchaseOrderId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type ChargebackIndicatorMinAggregates = {
  __typename?: 'ChargebackIndicatorMinAggregates';
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ChargebackIndicator`. */
export enum ChargebackIndicatorOrderBy {
  ArnAsc = 'ARN_ASC',
  ArnDesc = 'ARN_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaseOrderIdAsc = 'PURCHASE_ORDER_ID_ASC',
  PurchaseOrderIdDesc = 'PURCHASE_ORDER_ID_DESC',
  RecoveryOutcomeAsc = 'RECOVERY_OUTCOME_ASC',
  RecoveryOutcomeDesc = 'RECOVERY_OUTCOME_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SourceTransactionIdAsc = 'SOURCE_TRANSACTION_ID_ASC',
  SourceTransactionIdDesc = 'SOURCE_TRANSACTION_ID_DESC'
}

export type ChargebackIndicatorStddevPopulationAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackIndicatorStddevPopulationAggregates = {
  __typename?: 'ChargebackIndicatorStddevPopulationAggregates';
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackIndicatorStddevSampleAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackIndicatorStddevSampleAggregates = {
  __typename?: 'ChargebackIndicatorStddevSampleAggregates';
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackIndicatorSumAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type ChargebackIndicatorSumAggregates = {
  __typename?: 'ChargebackIndicatorSumAggregates';
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of linkedByAdminId across the matching connection */
  linkedByAdminId: Scalars['BigInt']['output'];
  /** Sum of purchaseOrderId across the matching connection */
  purchaseOrderId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

export type ChargebackIndicatorVariancePopulationAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackIndicatorVariancePopulationAggregates = {
  __typename?: 'ChargebackIndicatorVariancePopulationAggregates';
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackIndicatorVarianceSampleAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackIndicatorVarianceSampleAggregates = {
  __typename?: 'ChargebackIndicatorVarianceSampleAggregates';
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of linkedByAdminId across the matching connection */
  linkedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export enum ChargebackLifecycleState {
  Active = 'ACTIVE',
  Lost = 'LOST',
  ProvisionalWon = 'PROVISIONAL_WON',
  Won = 'WON'
}

export type ChargebackMaxAggregateFilter = {
  purchaseOrderId?: InputMaybe<IntFilter>;
  traderUserId?: InputMaybe<IntFilter>;
};

export type ChargebackMaxAggregates = {
  __typename?: 'ChargebackMaxAggregates';
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of priority across the matching connection */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Maximum of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

export type ChargebackMinAggregateFilter = {
  purchaseOrderId?: InputMaybe<IntFilter>;
  traderUserId?: InputMaybe<IntFilter>;
};

export type ChargebackMinAggregates = {
  __typename?: 'ChargebackMinAggregates';
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of priority across the matching connection */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Minimum of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Chargeback`. */
export enum ChargebackOrderBy {
  ChargebackKeyAsc = 'CHARGEBACK_KEY_ASC',
  ChargebackKeyDesc = 'CHARGEBACK_KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaseOrderIdAsc = 'PURCHASE_ORDER_ID_ASC',
  PurchaseOrderIdDesc = 'PURCHASE_ORDER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderUserIdAsc = 'TRADER_USER_ID_ASC',
  TraderUserIdDesc = 'TRADER_USER_ID_DESC'
}

export enum ChargebackProcessor {
  Amex = 'amex',
  Fts = 'fts',
  Nuvei = 'nuvei',
  Paypal = 'paypal',
  Stripe = 'stripe'
}

/** A filter to be used against ChargebackProcessor fields. All fields are combined with a logical ‘and.’ */
export type ChargebackProcessorFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChargebackProcessor>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChargebackProcessor>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChargebackProcessor>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChargebackProcessor>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChargebackProcessor>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChargebackProcessor>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChargebackProcessor>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChargebackProcessor>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChargebackProcessor>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChargebackProcessor>>;
};

export type ChargebackResult = {
  __typename?: 'ChargebackResult';
  amountUsd: Scalars['String']['output'];
  arn?: Maybe<Scalars['String']['output']>;
  chargebackDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  disputeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  linkedByAdminId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  processor: ChargebackProcessor;
  purchaseOrderId: Scalars['Int']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ChargebackStddevPopulationAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackStddevPopulationAggregates = {
  __typename?: 'ChargebackStddevPopulationAggregates';
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of priority across the matching connection */
  priority?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackStddevSampleAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackStddevSampleAggregates = {
  __typename?: 'ChargebackStddevSampleAggregates';
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of priority across the matching connection */
  priority?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackSumAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  traderUserId?: InputMaybe<BigIntFilter>;
};

export type ChargebackSumAggregates = {
  __typename?: 'ChargebackSumAggregates';
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of priority across the matching connection */
  priority: Scalars['BigInt']['output'];
  /** Sum of problemCount across the matching connection */
  problemCount: Scalars['BigInt']['output'];
  /** Sum of purchaseId across the matching connection */
  purchaseId: Scalars['BigInt']['output'];
  /** Sum of purchaseOrderId across the matching connection */
  purchaseOrderId: Scalars['BigInt']['output'];
  /** Sum of readActionId across the matching connection */
  readActionId: Scalars['BigFloat']['output'];
  /** Sum of readVersionId across the matching connection */
  readVersionId: Scalars['BigFloat']['output'];
  /** Sum of traderUserId across the matching connection */
  traderUserId: Scalars['BigInt']['output'];
};

export type ChargebackTotals = {
  __typename?: 'ChargebackTotals';
  count: Scalars['Int']['output'];
  totalUsd: Scalars['String']['output'];
};

export type ChargebackVariancePopulationAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackVariancePopulationAggregates = {
  __typename?: 'ChargebackVariancePopulationAggregates';
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of priority across the matching connection */
  priority?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChargebackVarianceSampleAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  traderUserId?: InputMaybe<BigFloatFilter>;
};

export type ChargebackVarianceSampleAggregates = {
  __typename?: 'ChargebackVarianceSampleAggregates';
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of priority across the matching connection */
  priority?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of problemCount across the matching connection */
  problemCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of readActionId across the matching connection */
  readActionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of readVersionId across the matching connection */
  readVersionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of traderUserId across the matching connection */
  traderUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutItem = Node & {
  __typename?: 'CheckoutItem';
  /** Reads a single `Account` that is related to this `CheckoutItem`. */
  associatedAccount?: Maybe<Account>;
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CheckoutSession` that is related to this `CheckoutItem`. */
  checkoutSession?: Maybe<CheckoutSession>;
  checkoutSessionId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `Platform` that is related to this `CheckoutItem`. */
  platform?: Maybe<Platform>;
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Product` that is related to this `CheckoutItem`. */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type CheckoutItemAggregates = {
  __typename?: 'CheckoutItemAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CheckoutItemAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CheckoutItemDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CheckoutItemMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CheckoutItemMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CheckoutItemStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CheckoutItemStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CheckoutItemSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CheckoutItemVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CheckoutItemVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CheckoutItem` object types. */
export type CheckoutItemAggregatesFilter = {
  /** Mean average aggregate over matching `CheckoutItem` objects. */
  average?: InputMaybe<CheckoutItemAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CheckoutItem` objects. */
  distinctCount?: InputMaybe<CheckoutItemDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CheckoutItem` object to be included within the aggregate. */
  filter?: InputMaybe<CheckoutItemFilter>;
  /** Maximum aggregate over matching `CheckoutItem` objects. */
  max?: InputMaybe<CheckoutItemMaxAggregateFilter>;
  /** Minimum aggregate over matching `CheckoutItem` objects. */
  min?: InputMaybe<CheckoutItemMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CheckoutItem` objects. */
  stddevPopulation?: InputMaybe<CheckoutItemStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CheckoutItem` objects. */
  stddevSample?: InputMaybe<CheckoutItemStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CheckoutItem` objects. */
  sum?: InputMaybe<CheckoutItemSumAggregateFilter>;
  /** Population variance aggregate over matching `CheckoutItem` objects. */
  variancePopulation?: InputMaybe<CheckoutItemVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CheckoutItem` objects. */
  varianceSample?: InputMaybe<CheckoutItemVarianceSampleAggregateFilter>;
};

export type CheckoutItemAverageAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutItemAverageAggregates = {
  __typename?: 'CheckoutItemAverageAggregates';
  /** Mean average of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CheckoutItem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CheckoutItemCondition = {
  /** Checks for equality with the object’s `checkoutSessionId` field. */
  checkoutSessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CheckoutItem` values. */
export type CheckoutItemConnection = {
  __typename?: 'CheckoutItemConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CheckoutItemAggregates>;
  /** A list of edges which contains the `CheckoutItem` and cursor to aid in pagination. */
  edges: Array<Maybe<CheckoutItemEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CheckoutItemAggregates>>;
  /** A list of `CheckoutItem` objects. */
  nodes: Array<Maybe<CheckoutItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckoutItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CheckoutItem` values. */
export type CheckoutItemConnectionGroupedAggregatesArgs = {
  groupBy: Array<CheckoutItemGroupBy>;
  having?: InputMaybe<CheckoutItemHavingInput>;
};

export type CheckoutItemDistinctCountAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type CheckoutItemDistinctCountAggregates = {
  __typename?: 'CheckoutItemDistinctCountAggregates';
  /** Distinct count of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productId across the matching connection */
  productId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CheckoutItem` edge in the connection. */
export type CheckoutItemEdge = {
  __typename?: 'CheckoutItemEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckoutItem` at the end of the edge. */
  node?: Maybe<CheckoutItem>;
};

/** A filter to be used against `CheckoutItem` object types. All fields are combined with a logical ‘and.’ */
export type CheckoutItemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckoutItemFilter>>;
  /** Filter by the object’s `associatedAccount` relation. */
  associatedAccount?: InputMaybe<AccountFilter>;
  /** A related `associatedAccount` exists. */
  associatedAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkoutSession` relation. */
  checkoutSession?: InputMaybe<CheckoutSessionFilter>;
  /** Filter by the object’s `checkoutSessionId` field. */
  checkoutSessionId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckoutItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckoutItemFilter>>;
  /** Filter by the object’s `platform` relation. */
  platform?: InputMaybe<PlatformFilter>;
  /** A related `platform` exists. */
  platformExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<ProductFilter>;
  /** A related `product` exists. */
  productExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CheckoutItem` for usage during aggregation. */
export enum CheckoutItemGroupBy {
  CheckoutSessionId = 'CHECKOUT_SESSION_ID',
  ProductId = 'PRODUCT_ID'
}

export type CheckoutItemHavingAverageInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingDistinctCountInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CheckoutItem` aggregates. */
export type CheckoutItemHavingInput = {
  AND?: InputMaybe<Array<CheckoutItemHavingInput>>;
  OR?: InputMaybe<Array<CheckoutItemHavingInput>>;
  average?: InputMaybe<CheckoutItemHavingAverageInput>;
  distinctCount?: InputMaybe<CheckoutItemHavingDistinctCountInput>;
  max?: InputMaybe<CheckoutItemHavingMaxInput>;
  min?: InputMaybe<CheckoutItemHavingMinInput>;
  stddevPopulation?: InputMaybe<CheckoutItemHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CheckoutItemHavingStddevSampleInput>;
  sum?: InputMaybe<CheckoutItemHavingSumInput>;
  variancePopulation?: InputMaybe<CheckoutItemHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CheckoutItemHavingVarianceSampleInput>;
};

export type CheckoutItemHavingMaxInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingMinInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingStddevPopulationInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingStddevSampleInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingSumInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingVariancePopulationInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemHavingVarianceSampleInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  checkoutSessionId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutItemMaxAggregateFilter = {
  checkoutSessionId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type CheckoutItemMaxAggregates = {
  __typename?: 'CheckoutItemMaxAggregates';
  /** Maximum of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type CheckoutItemMinAggregateFilter = {
  checkoutSessionId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type CheckoutItemMinAggregates = {
  __typename?: 'CheckoutItemMinAggregates';
  /** Minimum of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CheckoutItem`. */
export enum CheckoutItemOrderBy {
  CheckoutSessionIdAsc = 'CHECKOUT_SESSION_ID_ASC',
  CheckoutSessionIdDesc = 'CHECKOUT_SESSION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type CheckoutItemStddevPopulationAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutItemStddevPopulationAggregates = {
  __typename?: 'CheckoutItemStddevPopulationAggregates';
  /** Population standard deviation of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutItemStddevSampleAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutItemStddevSampleAggregates = {
  __typename?: 'CheckoutItemStddevSampleAggregates';
  /** Sample standard deviation of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutItemSumAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type CheckoutItemSumAggregates = {
  __typename?: 'CheckoutItemSumAggregates';
  /** Sum of associatedAccountId across the matching connection */
  associatedAccountId: Scalars['BigInt']['output'];
  /** Sum of checkoutSessionId across the matching connection */
  checkoutSessionId: Scalars['BigInt']['output'];
  /** Sum of platformId across the matching connection */
  platformId: Scalars['BigInt']['output'];
  /** Sum of productId across the matching connection */
  productId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of skuId across the matching connection */
  skuId: Scalars['BigInt']['output'];
};

export type CheckoutItemVariancePopulationAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutItemVariancePopulationAggregates = {
  __typename?: 'CheckoutItemVariancePopulationAggregates';
  /** Population variance of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutItemVarianceSampleAggregateFilter = {
  checkoutSessionId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutItemVarianceSampleAggregates = {
  __typename?: 'CheckoutItemVarianceSampleAggregates';
  /** Sample variance of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of checkoutSessionId across the matching connection */
  checkoutSessionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutSession = Node & {
  __typename?: 'CheckoutSession';
  /** Reads and enables pagination through a set of `CheckoutItem`. */
  checkoutItems: CheckoutItemConnection;
  /** Reads a single `Coupon` that is related to this `CheckoutSession`. */
  coupon?: Maybe<Coupon>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  eventLog: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  publicId?: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `PurchaseOrder` that is related to this `CheckoutSession`. */
  purchase?: Maybe<PurchaseOrder>;
  purchaseId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  status: CheckoutSessionStatusEnum;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `CheckoutSession`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type CheckoutSessionCheckoutItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckoutItemCondition>;
  filter?: InputMaybe<CheckoutItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckoutItemOrderBy>>;
};

export type CheckoutSessionAggregates = {
  __typename?: 'CheckoutSessionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CheckoutSessionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CheckoutSessionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CheckoutSessionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CheckoutSessionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CheckoutSessionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CheckoutSessionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CheckoutSessionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CheckoutSessionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CheckoutSessionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CheckoutSession` object types. */
export type CheckoutSessionAggregatesFilter = {
  /** Mean average aggregate over matching `CheckoutSession` objects. */
  average?: InputMaybe<CheckoutSessionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CheckoutSession` objects. */
  distinctCount?: InputMaybe<CheckoutSessionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CheckoutSession` object to be included within the aggregate. */
  filter?: InputMaybe<CheckoutSessionFilter>;
  /** Maximum aggregate over matching `CheckoutSession` objects. */
  max?: InputMaybe<CheckoutSessionMaxAggregateFilter>;
  /** Minimum aggregate over matching `CheckoutSession` objects. */
  min?: InputMaybe<CheckoutSessionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CheckoutSession` objects. */
  stddevPopulation?: InputMaybe<CheckoutSessionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CheckoutSession` objects. */
  stddevSample?: InputMaybe<CheckoutSessionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CheckoutSession` objects. */
  sum?: InputMaybe<CheckoutSessionSumAggregateFilter>;
  /** Population variance aggregate over matching `CheckoutSession` objects. */
  variancePopulation?: InputMaybe<CheckoutSessionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CheckoutSession` objects. */
  varianceSample?: InputMaybe<CheckoutSessionVarianceSampleAggregateFilter>;
};

export type CheckoutSessionAverageAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutSessionAverageAggregates = {
  __typename?: 'CheckoutSessionAverageAggregates';
  /** Mean average of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CheckoutSession` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CheckoutSessionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `purchaseId` field. */
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CheckoutSession` values. */
export type CheckoutSessionConnection = {
  __typename?: 'CheckoutSessionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CheckoutSessionAggregates>;
  /** A list of edges which contains the `CheckoutSession` and cursor to aid in pagination. */
  edges: Array<Maybe<CheckoutSessionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CheckoutSessionAggregates>>;
  /** A list of `CheckoutSession` objects. */
  nodes: Array<Maybe<CheckoutSession>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckoutSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CheckoutSession` values. */
export type CheckoutSessionConnectionGroupedAggregatesArgs = {
  groupBy: Array<CheckoutSessionGroupBy>;
  having?: InputMaybe<CheckoutSessionHavingInput>;
};

export type CheckoutSessionDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  purchaseId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CheckoutSessionDistinctCountAggregates = {
  __typename?: 'CheckoutSessionDistinctCountAggregates';
  /** Distinct count of couponCode across the matching connection */
  couponCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of publicId across the matching connection */
  publicId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CheckoutSession` edge in the connection. */
export type CheckoutSessionEdge = {
  __typename?: 'CheckoutSessionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckoutSession` at the end of the edge. */
  node?: Maybe<CheckoutSession>;
};

/** A filter to be used against `CheckoutSession` object types. All fields are combined with a logical ‘and.’ */
export type CheckoutSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckoutSessionFilter>>;
  /** Filter by the object’s `checkoutItems` relation. */
  checkoutItems?: InputMaybe<CheckoutSessionToManyCheckoutItemFilter>;
  /** Some related `checkoutItems` exist. */
  checkoutItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `coupon` relation. */
  coupon?: InputMaybe<CouponFilter>;
  /** A related `coupon` exists. */
  couponExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckoutSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckoutSessionFilter>>;
  /** Filter by the object’s `purchase` relation. */
  purchase?: InputMaybe<PurchaseOrderFilter>;
  /** A related `purchase` exists. */
  purchaseExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseId` field. */
  purchaseId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CheckoutSessionStatusEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CheckoutSession` for usage during aggregation. */
export enum CheckoutSessionGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedAtTruncatedToDay = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UpdatedAtTruncatedToHour = 'UPDATED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type CheckoutSessionHavingAverageInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingDistinctCountInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CheckoutSession` aggregates. */
export type CheckoutSessionHavingInput = {
  AND?: InputMaybe<Array<CheckoutSessionHavingInput>>;
  OR?: InputMaybe<Array<CheckoutSessionHavingInput>>;
  average?: InputMaybe<CheckoutSessionHavingAverageInput>;
  distinctCount?: InputMaybe<CheckoutSessionHavingDistinctCountInput>;
  max?: InputMaybe<CheckoutSessionHavingMaxInput>;
  min?: InputMaybe<CheckoutSessionHavingMinInput>;
  stddevPopulation?: InputMaybe<CheckoutSessionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CheckoutSessionHavingStddevSampleInput>;
  sum?: InputMaybe<CheckoutSessionHavingSumInput>;
  variancePopulation?: InputMaybe<CheckoutSessionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CheckoutSessionHavingVarianceSampleInput>;
};

export type CheckoutSessionHavingMaxInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingMinInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingStddevPopulationInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingStddevSampleInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingSumInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingVariancePopulationInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionHavingVarianceSampleInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CheckoutSessionMaxAggregateFilter = {
  purchaseId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CheckoutSessionMaxAggregates = {
  __typename?: 'CheckoutSessionMaxAggregates';
  /** Maximum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CheckoutSessionMinAggregateFilter = {
  purchaseId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CheckoutSessionMinAggregates = {
  __typename?: 'CheckoutSessionMinAggregates';
  /** Minimum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CheckoutSession`. */
export enum CheckoutSessionOrderBy {
  CheckoutItemsAverageCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_AVERAGE_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsAverageCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_AVERAGE_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsAverageProductIdAsc = 'CHECKOUT_ITEMS_AVERAGE_PRODUCT_ID_ASC',
  CheckoutItemsAverageProductIdDesc = 'CHECKOUT_ITEMS_AVERAGE_PRODUCT_ID_DESC',
  CheckoutItemsAverageRowIdAsc = 'CHECKOUT_ITEMS_AVERAGE_ROW_ID_ASC',
  CheckoutItemsAverageRowIdDesc = 'CHECKOUT_ITEMS_AVERAGE_ROW_ID_DESC',
  CheckoutItemsCountAsc = 'CHECKOUT_ITEMS_COUNT_ASC',
  CheckoutItemsCountDesc = 'CHECKOUT_ITEMS_COUNT_DESC',
  CheckoutItemsDistinctCountCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsDistinctCountCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsDistinctCountProductIdAsc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_PRODUCT_ID_ASC',
  CheckoutItemsDistinctCountProductIdDesc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_PRODUCT_ID_DESC',
  CheckoutItemsDistinctCountRowIdAsc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_ROW_ID_ASC',
  CheckoutItemsDistinctCountRowIdDesc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_ROW_ID_DESC',
  CheckoutItemsMaxCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_MAX_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsMaxCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_MAX_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsMaxProductIdAsc = 'CHECKOUT_ITEMS_MAX_PRODUCT_ID_ASC',
  CheckoutItemsMaxProductIdDesc = 'CHECKOUT_ITEMS_MAX_PRODUCT_ID_DESC',
  CheckoutItemsMaxRowIdAsc = 'CHECKOUT_ITEMS_MAX_ROW_ID_ASC',
  CheckoutItemsMaxRowIdDesc = 'CHECKOUT_ITEMS_MAX_ROW_ID_DESC',
  CheckoutItemsMinCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_MIN_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsMinCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_MIN_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsMinProductIdAsc = 'CHECKOUT_ITEMS_MIN_PRODUCT_ID_ASC',
  CheckoutItemsMinProductIdDesc = 'CHECKOUT_ITEMS_MIN_PRODUCT_ID_DESC',
  CheckoutItemsMinRowIdAsc = 'CHECKOUT_ITEMS_MIN_ROW_ID_ASC',
  CheckoutItemsMinRowIdDesc = 'CHECKOUT_ITEMS_MIN_ROW_ID_DESC',
  CheckoutItemsStddevPopulationCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsStddevPopulationCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsStddevPopulationProductIdAsc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_PRODUCT_ID_ASC',
  CheckoutItemsStddevPopulationProductIdDesc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_PRODUCT_ID_DESC',
  CheckoutItemsStddevPopulationRowIdAsc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_ROW_ID_ASC',
  CheckoutItemsStddevPopulationRowIdDesc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_ROW_ID_DESC',
  CheckoutItemsStddevSampleCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsStddevSampleCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsStddevSampleProductIdAsc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  CheckoutItemsStddevSampleProductIdDesc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  CheckoutItemsStddevSampleRowIdAsc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_ROW_ID_ASC',
  CheckoutItemsStddevSampleRowIdDesc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_ROW_ID_DESC',
  CheckoutItemsSumCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_SUM_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsSumCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_SUM_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsSumProductIdAsc = 'CHECKOUT_ITEMS_SUM_PRODUCT_ID_ASC',
  CheckoutItemsSumProductIdDesc = 'CHECKOUT_ITEMS_SUM_PRODUCT_ID_DESC',
  CheckoutItemsSumRowIdAsc = 'CHECKOUT_ITEMS_SUM_ROW_ID_ASC',
  CheckoutItemsSumRowIdDesc = 'CHECKOUT_ITEMS_SUM_ROW_ID_DESC',
  CheckoutItemsVariancePopulationCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsVariancePopulationCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsVariancePopulationProductIdAsc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  CheckoutItemsVariancePopulationProductIdDesc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  CheckoutItemsVariancePopulationRowIdAsc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_ROW_ID_ASC',
  CheckoutItemsVariancePopulationRowIdDesc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_ROW_ID_DESC',
  CheckoutItemsVarianceSampleCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsVarianceSampleCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsVarianceSampleProductIdAsc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  CheckoutItemsVarianceSampleProductIdDesc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  CheckoutItemsVarianceSampleRowIdAsc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CheckoutItemsVarianceSampleRowIdDesc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaseIdAsc = 'PURCHASE_ID_ASC',
  PurchaseIdDesc = 'PURCHASE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum CheckoutSessionStatusEnum {
  AwaitingPayment = 'awaitingPayment',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Failed = 'failed',
  PaymentFailed = 'paymentFailed',
  PaymentProcessed = 'paymentProcessed',
  Started = 'started'
}

/** A filter to be used against CheckoutSessionStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type CheckoutSessionStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CheckoutSessionStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CheckoutSessionStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CheckoutSessionStatusEnum>>;
};

export type CheckoutSessionStddevPopulationAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutSessionStddevPopulationAggregates = {
  __typename?: 'CheckoutSessionStddevPopulationAggregates';
  /** Population standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutSessionStddevSampleAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutSessionStddevSampleAggregates = {
  __typename?: 'CheckoutSessionStddevSampleAggregates';
  /** Sample standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutSessionSumAggregateFilter = {
  purchaseId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CheckoutSessionSumAggregates = {
  __typename?: 'CheckoutSessionSumAggregates';
  /** Sum of couponId across the matching connection */
  couponId: Scalars['BigInt']['output'];
  /** Sum of purchaseId across the matching connection */
  purchaseId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CheckoutItem` object types. All fields are combined with a logical ‘and.’ */
export type CheckoutSessionToManyCheckoutItemFilter = {
  /** Aggregates across related `CheckoutItem` match the filter criteria. */
  aggregates?: InputMaybe<CheckoutItemAggregatesFilter>;
  /** Every related `CheckoutItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckoutItemFilter>;
  /** No related `CheckoutItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckoutItemFilter>;
  /** Some related `CheckoutItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckoutItemFilter>;
};

export type CheckoutSessionVariancePopulationAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutSessionVariancePopulationAggregates = {
  __typename?: 'CheckoutSessionVariancePopulationAggregates';
  /** Population variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CheckoutSessionVarianceSampleAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CheckoutSessionVarianceSampleAggregates = {
  __typename?: 'CheckoutSessionVarianceSampleAggregates';
  /** Sample variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CorrectAccountCapitalEntryInput = {
  /** The corrected amount. Strictly positive, at most two decimal places. */
  amount: Scalars['Float']['input'];
  confirmOutstandingPayout?: InputMaybe<Scalars['Boolean']['input']>;
  confirmUndrawnShortfall?: InputMaybe<Scalars['Boolean']['input']>;
  entryId: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
  /** Idempotency key covering both rows the correction writes. */
  requestId: Scalars['String']['input'];
  /** Omit to keep the original level. Required to remain valid for the entry's type. */
  sisuLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type Coupon = Node & {
  __typename?: 'Coupon';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Affiliate` that is related to this `Coupon`. */
  affiliate?: Maybe<Affiliate>;
  code: Scalars['String']['output'];
  combineSize?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CouponUser`. */
  couponUsers: CouponUserConnection;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  discountAmount: Scalars['Int']['output'];
  discountType: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  firstPurchaseOnly?: Maybe<Scalars['Boolean']['output']>;
  grantResetCredit?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  maxUseTotal?: Maybe<Scalars['Int']['output']>;
  maxUseUser?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `NmiSubscription`. */
  nmiSubscriptions: NmiSubscriptionConnection;
  /** Reads a single `ProductCategory` that is related to this `Coupon`. */
  productCategory?: Maybe<ProductCategory>;
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  recurringDiscount?: Maybe<Scalars['Boolean']['output']>;
  resetCreditAmount?: Maybe<Scalars['Int']['output']>;
  restrictToUser?: Maybe<Scalars['Boolean']['output']>;
  restrictToUserId?: Maybe<Scalars['Int']['output']>;
  restrictToUserList?: Maybe<Scalars['Boolean']['output']>;
  rowId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TraderPublicProfile`. */
  traderPublicProfiles: TraderPublicProfileConnection;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Coupon`. */
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserSubscription`. */
  userSubscriptions: UserSubscriptionConnection;
};


export type CouponCouponUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CouponUserCondition>;
  filter?: InputMaybe<CouponUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CouponUserOrderBy>>;
};


export type CouponNmiSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NmiSubscriptionCondition>;
  filter?: InputMaybe<NmiSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NmiSubscriptionOrderBy>>;
};


export type CouponTraderPublicProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderPublicProfileCondition>;
  filter?: InputMaybe<TraderPublicProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderPublicProfileOrderBy>>;
};


export type CouponUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserSubscriptionCondition>;
  filter?: InputMaybe<UserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSubscriptionOrderBy>>;
};

export type CouponAggregates = {
  __typename?: 'CouponAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CouponAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CouponDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CouponMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CouponMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CouponStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CouponStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CouponSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CouponVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CouponVarianceSampleAggregates>;
};

export type CouponAverageAggregates = {
  __typename?: 'CouponAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Coupon` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CouponCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Coupon` values. */
export type CouponConnection = {
  __typename?: 'CouponConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CouponAggregates>;
  /** A list of edges which contains the `Coupon` and cursor to aid in pagination. */
  edges: Array<Maybe<CouponEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CouponAggregates>>;
  /** A list of `Coupon` objects. */
  nodes: Array<Maybe<Coupon>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Coupon` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Coupon` values. */
export type CouponConnectionGroupedAggregatesArgs = {
  groupBy: Array<CouponGroupBy>;
  having?: InputMaybe<CouponHavingInput>;
};

export type CouponDistinctCountAggregates = {
  __typename?: 'CouponDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of code across the matching connection */
  code?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of combineSize across the matching connection */
  combineSize?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discountType across the matching connection */
  discountType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expiresAt across the matching connection */
  expiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of firstPurchaseOnly across the matching connection */
  firstPurchaseOnly?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of grantResetCredit across the matching connection */
  grantResetCredit?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of recurringDiscount across the matching connection */
  recurringDiscount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of restrictToUser across the matching connection */
  restrictToUser?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of restrictToUserList across the matching connection */
  restrictToUserList?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Coupon` edge in the connection. */
export type CouponEdge = {
  __typename?: 'CouponEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Coupon` at the end of the edge. */
  node?: Maybe<Coupon>;
};

/** A filter to be used against `Coupon` object types. All fields are combined with a logical ‘and.’ */
export type CouponFilter = {
  /** Filter by the object’s `affiliate` relation. */
  affiliate?: InputMaybe<AffiliateFilter>;
  /** A related `affiliate` exists. */
  affiliateExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CouponFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `couponUsers` relation. */
  couponUsers?: InputMaybe<CouponToManyCouponUserFilter>;
  /** Some related `couponUsers` exist. */
  couponUsersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `nmiSubscriptions` relation. */
  nmiSubscriptions?: InputMaybe<CouponToManyNmiSubscriptionFilter>;
  /** Some related `nmiSubscriptions` exist. */
  nmiSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<CouponFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CouponFilter>>;
  /** Filter by the object’s `productCategory` relation. */
  productCategory?: InputMaybe<ProductCategoryFilter>;
  /** A related `productCategory` exists. */
  productCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderPublicProfiles` relation. */
  traderPublicProfiles?: InputMaybe<CouponToManyTraderPublicProfileFilter>;
  /** Some related `traderPublicProfiles` exist. */
  traderPublicProfilesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userSubscriptions` relation. */
  userSubscriptions?: InputMaybe<CouponToManyUserSubscriptionFilter>;
  /** Some related `userSubscriptions` exist. */
  userSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Coupon` for usage during aggregation. */
export enum CouponGroupBy {
  Code = 'CODE',
  DeletedAt = 'DELETED_AT',
  DeletedAtTruncatedToDay = 'DELETED_AT_TRUNCATED_TO_DAY',
  DeletedAtTruncatedToHour = 'DELETED_AT_TRUNCATED_TO_HOUR'
}

export type CouponHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Coupon` aggregates. */
export type CouponHavingInput = {
  AND?: InputMaybe<Array<CouponHavingInput>>;
  OR?: InputMaybe<Array<CouponHavingInput>>;
  average?: InputMaybe<CouponHavingAverageInput>;
  distinctCount?: InputMaybe<CouponHavingDistinctCountInput>;
  max?: InputMaybe<CouponHavingMaxInput>;
  min?: InputMaybe<CouponHavingMinInput>;
  stddevPopulation?: InputMaybe<CouponHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CouponHavingStddevSampleInput>;
  sum?: InputMaybe<CouponHavingSumInput>;
  variancePopulation?: InputMaybe<CouponHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CouponHavingVarianceSampleInput>;
};

export type CouponHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  discountAmount?: InputMaybe<HavingIntFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  maxUseTotal?: InputMaybe<HavingIntFilter>;
  maxUseUser?: InputMaybe<HavingIntFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  resetCreditAmount?: InputMaybe<HavingIntFilter>;
  restrictToUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CouponMaxAggregates = {
  __typename?: 'CouponMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['Int']['output']>;
  /** Maximum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type CouponMinAggregates = {
  __typename?: 'CouponMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['Int']['output']>;
  /** Minimum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Coupon`. */
export enum CouponOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CouponUsersAverageCouponIdAsc = 'COUPON_USERS_AVERAGE_COUPON_ID_ASC',
  CouponUsersAverageCouponIdDesc = 'COUPON_USERS_AVERAGE_COUPON_ID_DESC',
  CouponUsersAverageRowIdAsc = 'COUPON_USERS_AVERAGE_ROW_ID_ASC',
  CouponUsersAverageRowIdDesc = 'COUPON_USERS_AVERAGE_ROW_ID_DESC',
  CouponUsersAverageUserIdAsc = 'COUPON_USERS_AVERAGE_USER_ID_ASC',
  CouponUsersAverageUserIdDesc = 'COUPON_USERS_AVERAGE_USER_ID_DESC',
  CouponUsersCountAsc = 'COUPON_USERS_COUNT_ASC',
  CouponUsersCountDesc = 'COUPON_USERS_COUNT_DESC',
  CouponUsersDistinctCountCouponIdAsc = 'COUPON_USERS_DISTINCT_COUNT_COUPON_ID_ASC',
  CouponUsersDistinctCountCouponIdDesc = 'COUPON_USERS_DISTINCT_COUNT_COUPON_ID_DESC',
  CouponUsersDistinctCountRowIdAsc = 'COUPON_USERS_DISTINCT_COUNT_ROW_ID_ASC',
  CouponUsersDistinctCountRowIdDesc = 'COUPON_USERS_DISTINCT_COUNT_ROW_ID_DESC',
  CouponUsersDistinctCountUserIdAsc = 'COUPON_USERS_DISTINCT_COUNT_USER_ID_ASC',
  CouponUsersDistinctCountUserIdDesc = 'COUPON_USERS_DISTINCT_COUNT_USER_ID_DESC',
  CouponUsersMaxCouponIdAsc = 'COUPON_USERS_MAX_COUPON_ID_ASC',
  CouponUsersMaxCouponIdDesc = 'COUPON_USERS_MAX_COUPON_ID_DESC',
  CouponUsersMaxRowIdAsc = 'COUPON_USERS_MAX_ROW_ID_ASC',
  CouponUsersMaxRowIdDesc = 'COUPON_USERS_MAX_ROW_ID_DESC',
  CouponUsersMaxUserIdAsc = 'COUPON_USERS_MAX_USER_ID_ASC',
  CouponUsersMaxUserIdDesc = 'COUPON_USERS_MAX_USER_ID_DESC',
  CouponUsersMinCouponIdAsc = 'COUPON_USERS_MIN_COUPON_ID_ASC',
  CouponUsersMinCouponIdDesc = 'COUPON_USERS_MIN_COUPON_ID_DESC',
  CouponUsersMinRowIdAsc = 'COUPON_USERS_MIN_ROW_ID_ASC',
  CouponUsersMinRowIdDesc = 'COUPON_USERS_MIN_ROW_ID_DESC',
  CouponUsersMinUserIdAsc = 'COUPON_USERS_MIN_USER_ID_ASC',
  CouponUsersMinUserIdDesc = 'COUPON_USERS_MIN_USER_ID_DESC',
  CouponUsersStddevPopulationCouponIdAsc = 'COUPON_USERS_STDDEV_POPULATION_COUPON_ID_ASC',
  CouponUsersStddevPopulationCouponIdDesc = 'COUPON_USERS_STDDEV_POPULATION_COUPON_ID_DESC',
  CouponUsersStddevPopulationRowIdAsc = 'COUPON_USERS_STDDEV_POPULATION_ROW_ID_ASC',
  CouponUsersStddevPopulationRowIdDesc = 'COUPON_USERS_STDDEV_POPULATION_ROW_ID_DESC',
  CouponUsersStddevPopulationUserIdAsc = 'COUPON_USERS_STDDEV_POPULATION_USER_ID_ASC',
  CouponUsersStddevPopulationUserIdDesc = 'COUPON_USERS_STDDEV_POPULATION_USER_ID_DESC',
  CouponUsersStddevSampleCouponIdAsc = 'COUPON_USERS_STDDEV_SAMPLE_COUPON_ID_ASC',
  CouponUsersStddevSampleCouponIdDesc = 'COUPON_USERS_STDDEV_SAMPLE_COUPON_ID_DESC',
  CouponUsersStddevSampleRowIdAsc = 'COUPON_USERS_STDDEV_SAMPLE_ROW_ID_ASC',
  CouponUsersStddevSampleRowIdDesc = 'COUPON_USERS_STDDEV_SAMPLE_ROW_ID_DESC',
  CouponUsersStddevSampleUserIdAsc = 'COUPON_USERS_STDDEV_SAMPLE_USER_ID_ASC',
  CouponUsersStddevSampleUserIdDesc = 'COUPON_USERS_STDDEV_SAMPLE_USER_ID_DESC',
  CouponUsersSumCouponIdAsc = 'COUPON_USERS_SUM_COUPON_ID_ASC',
  CouponUsersSumCouponIdDesc = 'COUPON_USERS_SUM_COUPON_ID_DESC',
  CouponUsersSumRowIdAsc = 'COUPON_USERS_SUM_ROW_ID_ASC',
  CouponUsersSumRowIdDesc = 'COUPON_USERS_SUM_ROW_ID_DESC',
  CouponUsersSumUserIdAsc = 'COUPON_USERS_SUM_USER_ID_ASC',
  CouponUsersSumUserIdDesc = 'COUPON_USERS_SUM_USER_ID_DESC',
  CouponUsersVariancePopulationCouponIdAsc = 'COUPON_USERS_VARIANCE_POPULATION_COUPON_ID_ASC',
  CouponUsersVariancePopulationCouponIdDesc = 'COUPON_USERS_VARIANCE_POPULATION_COUPON_ID_DESC',
  CouponUsersVariancePopulationRowIdAsc = 'COUPON_USERS_VARIANCE_POPULATION_ROW_ID_ASC',
  CouponUsersVariancePopulationRowIdDesc = 'COUPON_USERS_VARIANCE_POPULATION_ROW_ID_DESC',
  CouponUsersVariancePopulationUserIdAsc = 'COUPON_USERS_VARIANCE_POPULATION_USER_ID_ASC',
  CouponUsersVariancePopulationUserIdDesc = 'COUPON_USERS_VARIANCE_POPULATION_USER_ID_DESC',
  CouponUsersVarianceSampleCouponIdAsc = 'COUPON_USERS_VARIANCE_SAMPLE_COUPON_ID_ASC',
  CouponUsersVarianceSampleCouponIdDesc = 'COUPON_USERS_VARIANCE_SAMPLE_COUPON_ID_DESC',
  CouponUsersVarianceSampleRowIdAsc = 'COUPON_USERS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CouponUsersVarianceSampleRowIdDesc = 'COUPON_USERS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CouponUsersVarianceSampleUserIdAsc = 'COUPON_USERS_VARIANCE_SAMPLE_USER_ID_ASC',
  CouponUsersVarianceSampleUserIdDesc = 'COUPON_USERS_VARIANCE_SAMPLE_USER_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  Natural = 'NATURAL',
  NmiSubscriptionsAverageCouponIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_COUPON_ID_ASC',
  NmiSubscriptionsAverageCouponIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_COUPON_ID_DESC',
  NmiSubscriptionsAverageMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsAverageMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsAverageNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsAverageNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsAverageProductIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_PRODUCT_ID_ASC',
  NmiSubscriptionsAverageProductIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_PRODUCT_ID_DESC',
  NmiSubscriptionsAverageRowIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_ROW_ID_ASC',
  NmiSubscriptionsAverageRowIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_ROW_ID_DESC',
  NmiSubscriptionsAverageSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsAverageSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsAverageSkuIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_SKU_ID_ASC',
  NmiSubscriptionsAverageSkuIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_SKU_ID_DESC',
  NmiSubscriptionsAverageUserIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_USER_ID_ASC',
  NmiSubscriptionsAverageUserIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_USER_ID_DESC',
  NmiSubscriptionsCountAsc = 'NMI_SUBSCRIPTIONS_COUNT_ASC',
  NmiSubscriptionsCountDesc = 'NMI_SUBSCRIPTIONS_COUNT_DESC',
  NmiSubscriptionsDistinctCountCouponIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_ASC',
  NmiSubscriptionsDistinctCountCouponIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_DESC',
  NmiSubscriptionsDistinctCountMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsDistinctCountMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsDistinctCountNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsDistinctCountNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsDistinctCountProductIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_PRODUCT_ID_ASC',
  NmiSubscriptionsDistinctCountProductIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_PRODUCT_ID_DESC',
  NmiSubscriptionsDistinctCountRebillManagerAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_MANAGER_ASC',
  NmiSubscriptionsDistinctCountRebillManagerDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_MANAGER_DESC',
  NmiSubscriptionsDistinctCountRebillRefIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_REF_ID_ASC',
  NmiSubscriptionsDistinctCountRebillRefIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_REF_ID_DESC',
  NmiSubscriptionsDistinctCountRowIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_ASC',
  NmiSubscriptionsDistinctCountRowIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_DESC',
  NmiSubscriptionsDistinctCountSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SAVED_CARD_ID_ASC',
  NmiSubscriptionsDistinctCountSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SAVED_CARD_ID_DESC',
  NmiSubscriptionsDistinctCountServiceAccessUntilAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_ASC',
  NmiSubscriptionsDistinctCountServiceAccessUntilDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_DESC',
  NmiSubscriptionsDistinctCountServiceCancelledAtAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_CANCELLED_AT_ASC',
  NmiSubscriptionsDistinctCountServiceCancelledAtDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_CANCELLED_AT_DESC',
  NmiSubscriptionsDistinctCountSkuIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SKU_ID_ASC',
  NmiSubscriptionsDistinctCountSkuIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SKU_ID_DESC',
  NmiSubscriptionsDistinctCountSubscriptionCancelledAtAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_ASC',
  NmiSubscriptionsDistinctCountSubscriptionCancelledAtDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_DESC',
  NmiSubscriptionsDistinctCountUserIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_ASC',
  NmiSubscriptionsDistinctCountUserIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_DESC',
  NmiSubscriptionsMaxCouponIdAsc = 'NMI_SUBSCRIPTIONS_MAX_COUPON_ID_ASC',
  NmiSubscriptionsMaxCouponIdDesc = 'NMI_SUBSCRIPTIONS_MAX_COUPON_ID_DESC',
  NmiSubscriptionsMaxMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_MAX_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsMaxMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_MAX_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsMaxNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_MAX_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsMaxNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_MAX_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsMaxProductIdAsc = 'NMI_SUBSCRIPTIONS_MAX_PRODUCT_ID_ASC',
  NmiSubscriptionsMaxProductIdDesc = 'NMI_SUBSCRIPTIONS_MAX_PRODUCT_ID_DESC',
  NmiSubscriptionsMaxRowIdAsc = 'NMI_SUBSCRIPTIONS_MAX_ROW_ID_ASC',
  NmiSubscriptionsMaxRowIdDesc = 'NMI_SUBSCRIPTIONS_MAX_ROW_ID_DESC',
  NmiSubscriptionsMaxSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_MAX_SAVED_CARD_ID_ASC',
  NmiSubscriptionsMaxSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_MAX_SAVED_CARD_ID_DESC',
  NmiSubscriptionsMaxSkuIdAsc = 'NMI_SUBSCRIPTIONS_MAX_SKU_ID_ASC',
  NmiSubscriptionsMaxSkuIdDesc = 'NMI_SUBSCRIPTIONS_MAX_SKU_ID_DESC',
  NmiSubscriptionsMaxUserIdAsc = 'NMI_SUBSCRIPTIONS_MAX_USER_ID_ASC',
  NmiSubscriptionsMaxUserIdDesc = 'NMI_SUBSCRIPTIONS_MAX_USER_ID_DESC',
  NmiSubscriptionsMinCouponIdAsc = 'NMI_SUBSCRIPTIONS_MIN_COUPON_ID_ASC',
  NmiSubscriptionsMinCouponIdDesc = 'NMI_SUBSCRIPTIONS_MIN_COUPON_ID_DESC',
  NmiSubscriptionsMinMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_MIN_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsMinMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_MIN_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsMinNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_MIN_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsMinNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_MIN_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsMinProductIdAsc = 'NMI_SUBSCRIPTIONS_MIN_PRODUCT_ID_ASC',
  NmiSubscriptionsMinProductIdDesc = 'NMI_SUBSCRIPTIONS_MIN_PRODUCT_ID_DESC',
  NmiSubscriptionsMinRowIdAsc = 'NMI_SUBSCRIPTIONS_MIN_ROW_ID_ASC',
  NmiSubscriptionsMinRowIdDesc = 'NMI_SUBSCRIPTIONS_MIN_ROW_ID_DESC',
  NmiSubscriptionsMinSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_MIN_SAVED_CARD_ID_ASC',
  NmiSubscriptionsMinSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_MIN_SAVED_CARD_ID_DESC',
  NmiSubscriptionsMinSkuIdAsc = 'NMI_SUBSCRIPTIONS_MIN_SKU_ID_ASC',
  NmiSubscriptionsMinSkuIdDesc = 'NMI_SUBSCRIPTIONS_MIN_SKU_ID_DESC',
  NmiSubscriptionsMinUserIdAsc = 'NMI_SUBSCRIPTIONS_MIN_USER_ID_ASC',
  NmiSubscriptionsMinUserIdDesc = 'NMI_SUBSCRIPTIONS_MIN_USER_ID_DESC',
  NmiSubscriptionsStddevPopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsStddevPopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsStddevPopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsStddevPopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsStddevPopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsStddevPopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsStddevPopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsStddevPopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsStddevPopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsStddevPopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsStddevPopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsStddevPopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsStddevPopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsStddevPopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsStddevPopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_ASC',
  NmiSubscriptionsStddevPopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_DESC',
  NmiSubscriptionsStddevSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsStddevSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsStddevSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsStddevSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsStddevSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsStddevSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsStddevSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsStddevSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsStddevSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsStddevSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsStddevSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsStddevSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsStddevSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsStddevSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsStddevSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsStddevSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_DESC',
  NmiSubscriptionsSumCouponIdAsc = 'NMI_SUBSCRIPTIONS_SUM_COUPON_ID_ASC',
  NmiSubscriptionsSumCouponIdDesc = 'NMI_SUBSCRIPTIONS_SUM_COUPON_ID_DESC',
  NmiSubscriptionsSumMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_SUM_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsSumMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_SUM_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsSumNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_SUM_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsSumNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_SUM_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsSumProductIdAsc = 'NMI_SUBSCRIPTIONS_SUM_PRODUCT_ID_ASC',
  NmiSubscriptionsSumProductIdDesc = 'NMI_SUBSCRIPTIONS_SUM_PRODUCT_ID_DESC',
  NmiSubscriptionsSumRowIdAsc = 'NMI_SUBSCRIPTIONS_SUM_ROW_ID_ASC',
  NmiSubscriptionsSumRowIdDesc = 'NMI_SUBSCRIPTIONS_SUM_ROW_ID_DESC',
  NmiSubscriptionsSumSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_SUM_SAVED_CARD_ID_ASC',
  NmiSubscriptionsSumSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_SUM_SAVED_CARD_ID_DESC',
  NmiSubscriptionsSumSkuIdAsc = 'NMI_SUBSCRIPTIONS_SUM_SKU_ID_ASC',
  NmiSubscriptionsSumSkuIdDesc = 'NMI_SUBSCRIPTIONS_SUM_SKU_ID_DESC',
  NmiSubscriptionsSumUserIdAsc = 'NMI_SUBSCRIPTIONS_SUM_USER_ID_ASC',
  NmiSubscriptionsSumUserIdDesc = 'NMI_SUBSCRIPTIONS_SUM_USER_ID_DESC',
  NmiSubscriptionsVariancePopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsVariancePopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsVariancePopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsVariancePopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsVariancePopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsVariancePopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsVariancePopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsVariancePopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsVariancePopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsVariancePopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsVariancePopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsVariancePopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsVariancePopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsVariancePopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsVariancePopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_ASC',
  NmiSubscriptionsVariancePopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_DESC',
  NmiSubscriptionsVarianceSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsVarianceSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsVarianceSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsVarianceSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsVarianceSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsVarianceSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsVarianceSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsVarianceSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsVarianceSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsVarianceSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsVarianceSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsVarianceSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsVarianceSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsVarianceSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsVarianceSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsVarianceSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderPublicProfilesAverageRowIdAsc = 'TRADER_PUBLIC_PROFILES_AVERAGE_ROW_ID_ASC',
  TraderPublicProfilesAverageRowIdDesc = 'TRADER_PUBLIC_PROFILES_AVERAGE_ROW_ID_DESC',
  TraderPublicProfilesCountAsc = 'TRADER_PUBLIC_PROFILES_COUNT_ASC',
  TraderPublicProfilesCountDesc = 'TRADER_PUBLIC_PROFILES_COUNT_DESC',
  TraderPublicProfilesDistinctCountPublicTraderIdAsc = 'TRADER_PUBLIC_PROFILES_DISTINCT_COUNT_PUBLIC_TRADER_ID_ASC',
  TraderPublicProfilesDistinctCountPublicTraderIdDesc = 'TRADER_PUBLIC_PROFILES_DISTINCT_COUNT_PUBLIC_TRADER_ID_DESC',
  TraderPublicProfilesDistinctCountRowIdAsc = 'TRADER_PUBLIC_PROFILES_DISTINCT_COUNT_ROW_ID_ASC',
  TraderPublicProfilesDistinctCountRowIdDesc = 'TRADER_PUBLIC_PROFILES_DISTINCT_COUNT_ROW_ID_DESC',
  TraderPublicProfilesMaxRowIdAsc = 'TRADER_PUBLIC_PROFILES_MAX_ROW_ID_ASC',
  TraderPublicProfilesMaxRowIdDesc = 'TRADER_PUBLIC_PROFILES_MAX_ROW_ID_DESC',
  TraderPublicProfilesMinRowIdAsc = 'TRADER_PUBLIC_PROFILES_MIN_ROW_ID_ASC',
  TraderPublicProfilesMinRowIdDesc = 'TRADER_PUBLIC_PROFILES_MIN_ROW_ID_DESC',
  TraderPublicProfilesStddevPopulationRowIdAsc = 'TRADER_PUBLIC_PROFILES_STDDEV_POPULATION_ROW_ID_ASC',
  TraderPublicProfilesStddevPopulationRowIdDesc = 'TRADER_PUBLIC_PROFILES_STDDEV_POPULATION_ROW_ID_DESC',
  TraderPublicProfilesStddevSampleRowIdAsc = 'TRADER_PUBLIC_PROFILES_STDDEV_SAMPLE_ROW_ID_ASC',
  TraderPublicProfilesStddevSampleRowIdDesc = 'TRADER_PUBLIC_PROFILES_STDDEV_SAMPLE_ROW_ID_DESC',
  TraderPublicProfilesSumRowIdAsc = 'TRADER_PUBLIC_PROFILES_SUM_ROW_ID_ASC',
  TraderPublicProfilesSumRowIdDesc = 'TRADER_PUBLIC_PROFILES_SUM_ROW_ID_DESC',
  TraderPublicProfilesVariancePopulationRowIdAsc = 'TRADER_PUBLIC_PROFILES_VARIANCE_POPULATION_ROW_ID_ASC',
  TraderPublicProfilesVariancePopulationRowIdDesc = 'TRADER_PUBLIC_PROFILES_VARIANCE_POPULATION_ROW_ID_DESC',
  TraderPublicProfilesVarianceSampleRowIdAsc = 'TRADER_PUBLIC_PROFILES_VARIANCE_SAMPLE_ROW_ID_ASC',
  TraderPublicProfilesVarianceSampleRowIdDesc = 'TRADER_PUBLIC_PROFILES_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserSubscriptionsAverageCouponIdAsc = 'USER_SUBSCRIPTIONS_AVERAGE_COUPON_ID_ASC',
  UserSubscriptionsAverageCouponIdDesc = 'USER_SUBSCRIPTIONS_AVERAGE_COUPON_ID_DESC',
  UserSubscriptionsAverageRowIdAsc = 'USER_SUBSCRIPTIONS_AVERAGE_ROW_ID_ASC',
  UserSubscriptionsAverageRowIdDesc = 'USER_SUBSCRIPTIONS_AVERAGE_ROW_ID_DESC',
  UserSubscriptionsAverageUserIdAsc = 'USER_SUBSCRIPTIONS_AVERAGE_USER_ID_ASC',
  UserSubscriptionsAverageUserIdDesc = 'USER_SUBSCRIPTIONS_AVERAGE_USER_ID_DESC',
  UserSubscriptionsCountAsc = 'USER_SUBSCRIPTIONS_COUNT_ASC',
  UserSubscriptionsCountDesc = 'USER_SUBSCRIPTIONS_COUNT_DESC',
  UserSubscriptionsDistinctCountCouponIdAsc = 'USER_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_ASC',
  UserSubscriptionsDistinctCountCouponIdDesc = 'USER_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_DESC',
  UserSubscriptionsDistinctCountRowIdAsc = 'USER_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_ASC',
  UserSubscriptionsDistinctCountRowIdDesc = 'USER_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_DESC',
  UserSubscriptionsDistinctCountUserIdAsc = 'USER_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_ASC',
  UserSubscriptionsDistinctCountUserIdDesc = 'USER_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_DESC',
  UserSubscriptionsMaxCouponIdAsc = 'USER_SUBSCRIPTIONS_MAX_COUPON_ID_ASC',
  UserSubscriptionsMaxCouponIdDesc = 'USER_SUBSCRIPTIONS_MAX_COUPON_ID_DESC',
  UserSubscriptionsMaxRowIdAsc = 'USER_SUBSCRIPTIONS_MAX_ROW_ID_ASC',
  UserSubscriptionsMaxRowIdDesc = 'USER_SUBSCRIPTIONS_MAX_ROW_ID_DESC',
  UserSubscriptionsMaxUserIdAsc = 'USER_SUBSCRIPTIONS_MAX_USER_ID_ASC',
  UserSubscriptionsMaxUserIdDesc = 'USER_SUBSCRIPTIONS_MAX_USER_ID_DESC',
  UserSubscriptionsMinCouponIdAsc = 'USER_SUBSCRIPTIONS_MIN_COUPON_ID_ASC',
  UserSubscriptionsMinCouponIdDesc = 'USER_SUBSCRIPTIONS_MIN_COUPON_ID_DESC',
  UserSubscriptionsMinRowIdAsc = 'USER_SUBSCRIPTIONS_MIN_ROW_ID_ASC',
  UserSubscriptionsMinRowIdDesc = 'USER_SUBSCRIPTIONS_MIN_ROW_ID_DESC',
  UserSubscriptionsMinUserIdAsc = 'USER_SUBSCRIPTIONS_MIN_USER_ID_ASC',
  UserSubscriptionsMinUserIdDesc = 'USER_SUBSCRIPTIONS_MIN_USER_ID_DESC',
  UserSubscriptionsStddevPopulationCouponIdAsc = 'USER_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_ASC',
  UserSubscriptionsStddevPopulationCouponIdDesc = 'USER_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_DESC',
  UserSubscriptionsStddevPopulationRowIdAsc = 'USER_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_ASC',
  UserSubscriptionsStddevPopulationRowIdDesc = 'USER_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_DESC',
  UserSubscriptionsStddevPopulationUserIdAsc = 'USER_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_ASC',
  UserSubscriptionsStddevPopulationUserIdDesc = 'USER_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_DESC',
  UserSubscriptionsStddevSampleCouponIdAsc = 'USER_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_ASC',
  UserSubscriptionsStddevSampleCouponIdDesc = 'USER_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_DESC',
  UserSubscriptionsStddevSampleRowIdAsc = 'USER_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  UserSubscriptionsStddevSampleRowIdDesc = 'USER_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  UserSubscriptionsStddevSampleUserIdAsc = 'USER_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_ASC',
  UserSubscriptionsStddevSampleUserIdDesc = 'USER_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_DESC',
  UserSubscriptionsSumCouponIdAsc = 'USER_SUBSCRIPTIONS_SUM_COUPON_ID_ASC',
  UserSubscriptionsSumCouponIdDesc = 'USER_SUBSCRIPTIONS_SUM_COUPON_ID_DESC',
  UserSubscriptionsSumRowIdAsc = 'USER_SUBSCRIPTIONS_SUM_ROW_ID_ASC',
  UserSubscriptionsSumRowIdDesc = 'USER_SUBSCRIPTIONS_SUM_ROW_ID_DESC',
  UserSubscriptionsSumUserIdAsc = 'USER_SUBSCRIPTIONS_SUM_USER_ID_ASC',
  UserSubscriptionsSumUserIdDesc = 'USER_SUBSCRIPTIONS_SUM_USER_ID_DESC',
  UserSubscriptionsVariancePopulationCouponIdAsc = 'USER_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_ASC',
  UserSubscriptionsVariancePopulationCouponIdDesc = 'USER_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_DESC',
  UserSubscriptionsVariancePopulationRowIdAsc = 'USER_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  UserSubscriptionsVariancePopulationRowIdDesc = 'USER_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  UserSubscriptionsVariancePopulationUserIdAsc = 'USER_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_ASC',
  UserSubscriptionsVariancePopulationUserIdDesc = 'USER_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_DESC',
  UserSubscriptionsVarianceSampleCouponIdAsc = 'USER_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_ASC',
  UserSubscriptionsVarianceSampleCouponIdDesc = 'USER_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_DESC',
  UserSubscriptionsVarianceSampleRowIdAsc = 'USER_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserSubscriptionsVarianceSampleRowIdDesc = 'USER_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserSubscriptionsVarianceSampleUserIdAsc = 'USER_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserSubscriptionsVarianceSampleUserIdDesc = 'USER_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_DESC'
}

export type CouponPlatform = Node & {
  __typename?: 'CouponPlatform';
  coupon: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  platformId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type CouponRedemption = Node & {
  __typename?: 'CouponRedemption';
  coupon: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type CouponStddevPopulationAggregates = {
  __typename?: 'CouponStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponStddevSampleAggregates = {
  __typename?: 'CouponStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponSumAggregates = {
  __typename?: 'CouponSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of discountAmount across the matching connection */
  discountAmount: Scalars['BigInt']['output'];
  /** Sum of maxUseTotal across the matching connection */
  maxUseTotal: Scalars['BigInt']['output'];
  /** Sum of maxUseUser across the matching connection */
  maxUseUser: Scalars['BigInt']['output'];
  /** Sum of productCategoryId across the matching connection */
  productCategoryId: Scalars['BigInt']['output'];
  /** Sum of resetCreditAmount across the matching connection */
  resetCreditAmount: Scalars['BigInt']['output'];
  /** Sum of restrictToUserId across the matching connection */
  restrictToUserId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CouponUser` object types. All fields are combined with a logical ‘and.’ */
export type CouponToManyCouponUserFilter = {
  /** Aggregates across related `CouponUser` match the filter criteria. */
  aggregates?: InputMaybe<CouponUserAggregatesFilter>;
  /** Every related `CouponUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CouponUserFilter>;
  /** No related `CouponUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CouponUserFilter>;
  /** Some related `CouponUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CouponUserFilter>;
};

/** A filter to be used against many `NmiSubscription` object types. All fields are combined with a logical ‘and.’ */
export type CouponToManyNmiSubscriptionFilter = {
  /** Aggregates across related `NmiSubscription` match the filter criteria. */
  aggregates?: InputMaybe<NmiSubscriptionAggregatesFilter>;
  /** Every related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NmiSubscriptionFilter>;
  /** No related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NmiSubscriptionFilter>;
  /** Some related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NmiSubscriptionFilter>;
};

/** A filter to be used against many `TraderPublicProfile` object types. All fields are combined with a logical ‘and.’ */
export type CouponToManyTraderPublicProfileFilter = {
  /** Aggregates across related `TraderPublicProfile` match the filter criteria. */
  aggregates?: InputMaybe<TraderPublicProfileAggregatesFilter>;
  /** Every related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TraderPublicProfileFilter>;
  /** No related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TraderPublicProfileFilter>;
  /** Some related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TraderPublicProfileFilter>;
};

/** A filter to be used against many `UserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type CouponToManyUserSubscriptionFilter = {
  /** Aggregates across related `UserSubscription` match the filter criteria. */
  aggregates?: InputMaybe<UserSubscriptionAggregatesFilter>;
  /** Every related `UserSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSubscriptionFilter>;
  /** No related `UserSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSubscriptionFilter>;
  /** Some related `UserSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSubscriptionFilter>;
};

export type CouponUser = Node & {
  __typename?: 'CouponUser';
  /** Reads a single `Coupon` that is related to this `CouponUser`. */
  coupon?: Maybe<Coupon>;
  couponId: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  maxRedemptions: Scalars['Int']['output'];
  redemptions: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `CouponUser`. */
  user?: Maybe<User>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CouponUserAggregates = {
  __typename?: 'CouponUserAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CouponUserAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CouponUserDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CouponUserMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CouponUserMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CouponUserStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CouponUserStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CouponUserSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CouponUserVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CouponUserVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CouponUser` object types. */
export type CouponUserAggregatesFilter = {
  /** Mean average aggregate over matching `CouponUser` objects. */
  average?: InputMaybe<CouponUserAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CouponUser` objects. */
  distinctCount?: InputMaybe<CouponUserDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CouponUser` object to be included within the aggregate. */
  filter?: InputMaybe<CouponUserFilter>;
  /** Maximum aggregate over matching `CouponUser` objects. */
  max?: InputMaybe<CouponUserMaxAggregateFilter>;
  /** Minimum aggregate over matching `CouponUser` objects. */
  min?: InputMaybe<CouponUserMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CouponUser` objects. */
  stddevPopulation?: InputMaybe<CouponUserStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CouponUser` objects. */
  stddevSample?: InputMaybe<CouponUserStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CouponUser` objects. */
  sum?: InputMaybe<CouponUserSumAggregateFilter>;
  /** Population variance aggregate over matching `CouponUser` objects. */
  variancePopulation?: InputMaybe<CouponUserVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CouponUser` objects. */
  varianceSample?: InputMaybe<CouponUserVarianceSampleAggregateFilter>;
};

export type CouponUserAverageAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CouponUserAverageAggregates = {
  __typename?: 'CouponUserAverageAggregates';
  /** Mean average of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CouponUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CouponUserCondition = {
  /** Checks for equality with the object’s `couponId` field. */
  couponId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CouponUser` values. */
export type CouponUserConnection = {
  __typename?: 'CouponUserConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CouponUserAggregates>;
  /** A list of edges which contains the `CouponUser` and cursor to aid in pagination. */
  edges: Array<Maybe<CouponUserEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CouponUserAggregates>>;
  /** A list of `CouponUser` objects. */
  nodes: Array<Maybe<CouponUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CouponUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CouponUser` values. */
export type CouponUserConnectionGroupedAggregatesArgs = {
  groupBy: Array<CouponUserGroupBy>;
  having?: InputMaybe<CouponUserHavingInput>;
};

export type CouponUserDistinctCountAggregateFilter = {
  couponId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CouponUserDistinctCountAggregates = {
  __typename?: 'CouponUserDistinctCountAggregates';
  /** Distinct count of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userEmail across the matching connection */
  userEmail?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `CouponUser` edge in the connection. */
export type CouponUserEdge = {
  __typename?: 'CouponUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CouponUser` at the end of the edge. */
  node?: Maybe<CouponUser>;
};

/** A filter to be used against `CouponUser` object types. All fields are combined with a logical ‘and.’ */
export type CouponUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CouponUserFilter>>;
  /** Filter by the object’s `coupon` relation. */
  coupon?: InputMaybe<CouponFilter>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CouponUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CouponUserFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `CouponUser` for usage during aggregation. */
export enum CouponUserGroupBy {
  CouponId = 'COUPON_ID',
  UserId = 'USER_ID'
}

export type CouponUserHavingAverageInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingDistinctCountInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `CouponUser` aggregates. */
export type CouponUserHavingInput = {
  AND?: InputMaybe<Array<CouponUserHavingInput>>;
  OR?: InputMaybe<Array<CouponUserHavingInput>>;
  average?: InputMaybe<CouponUserHavingAverageInput>;
  distinctCount?: InputMaybe<CouponUserHavingDistinctCountInput>;
  max?: InputMaybe<CouponUserHavingMaxInput>;
  min?: InputMaybe<CouponUserHavingMinInput>;
  stddevPopulation?: InputMaybe<CouponUserHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CouponUserHavingStddevSampleInput>;
  sum?: InputMaybe<CouponUserHavingSumInput>;
  variancePopulation?: InputMaybe<CouponUserHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CouponUserHavingVarianceSampleInput>;
};

export type CouponUserHavingMaxInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingMinInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingStddevPopulationInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingStddevSampleInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingSumInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingVariancePopulationInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserHavingVarianceSampleInput = {
  couponId?: InputMaybe<HavingIntFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  maxRedemptions?: InputMaybe<HavingIntFilter>;
  redemptions?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type CouponUserMaxAggregateFilter = {
  couponId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CouponUserMaxAggregates = {
  __typename?: 'CouponUserMaxAggregates';
  /** Maximum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  /** Maximum of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CouponUserMinAggregateFilter = {
  couponId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CouponUserMinAggregates = {
  __typename?: 'CouponUserMinAggregates';
  /** Minimum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  /** Minimum of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `CouponUser`. */
export enum CouponUserOrderBy {
  CouponIdAsc = 'COUPON_ID_ASC',
  CouponIdDesc = 'COUPON_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type CouponUserStddevPopulationAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CouponUserStddevPopulationAggregates = {
  __typename?: 'CouponUserStddevPopulationAggregates';
  /** Population standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponUserStddevSampleAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CouponUserStddevSampleAggregates = {
  __typename?: 'CouponUserStddevSampleAggregates';
  /** Sample standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponUserSumAggregateFilter = {
  couponId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CouponUserSumAggregates = {
  __typename?: 'CouponUserSumAggregates';
  /** Sum of couponId across the matching connection */
  couponId: Scalars['BigInt']['output'];
  /** Sum of maxRedemptions across the matching connection */
  maxRedemptions: Scalars['BigInt']['output'];
  /** Sum of redemptions across the matching connection */
  redemptions: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type CouponUserVariancePopulationAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CouponUserVariancePopulationAggregates = {
  __typename?: 'CouponUserVariancePopulationAggregates';
  /** Population variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponUserVarianceSampleAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type CouponUserVarianceSampleAggregates = {
  __typename?: 'CouponUserVarianceSampleAggregates';
  /** Sample variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxRedemptions across the matching connection */
  maxRedemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of redemptions across the matching connection */
  redemptions?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponVariancePopulationAggregates = {
  __typename?: 'CouponVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CouponVarianceSampleAggregates = {
  __typename?: 'CouponVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of discountAmount across the matching connection */
  discountAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxUseTotal across the matching connection */
  maxUseTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxUseUser across the matching connection */
  maxUseUser?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of resetCreditAmount across the matching connection */
  resetCreditAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of restrictToUserId across the matching connection */
  restrictToUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type CreateAccountCapitalEntryInput = {
  accountId: Scalars['Int']['input'];
  /** Strictly positive, at most two decimal places. */
  amount: Scalars['Float']['input'];
  /** One of sisu_level_unlock, octagon_bonus, adjustment. Baselines are written by the transfer path and the GTM backfill. */
  entryType: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  /** Idempotency key. Generate one per user action; resend the same value on retry. */
  requestId: Scalars['String']['input'];
  /** Required for sisu_level_unlock (1, 2, 3, 4), forbidden otherwise. */
  sisuLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCaseBanInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  reasonCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  severity: CaseSeverity;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCaseInvestigationInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  caseTypeId: Scalars['Int']['input'];
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  fitSheet?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  severity?: InputMaybe<CaseSeverity>;
  submittedByDepartmentId: Scalars['Int']['input'];
  submittedByDepartmentOther?: InputMaybe<Scalars['String']['input']>;
  traderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateCaseTypeInput = {
  code: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** All input for the create `ImpactGroupAssignment` mutation. */
export type CreateImpactGroupAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ImpactGroupAssignment` to be created by this mutation. */
  impactGroupAssignment: ImpactGroupAssignmentInput;
};

/** The output of our create `ImpactGroupAssignment` mutation. */
export type CreateImpactGroupAssignmentPayload = {
  __typename?: 'CreateImpactGroupAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ImpactGroupAssignment` that was created by this mutation. */
  impactGroupAssignment?: Maybe<ImpactGroupAssignment>;
  /** An edge for our `ImpactGroupAssignment`. May be used by Relay 1. */
  impactGroupAssignmentEdge?: Maybe<ImpactGroupAssignmentEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ImpactGroupAssignment` mutation. */
export type CreateImpactGroupAssignmentPayloadImpactGroupAssignmentEdgeArgs = {
  orderBy?: Array<ImpactGroupAssignmentOrderBy>;
};

/** All input for the create `ImpactGroupTemplate` mutation. */
export type CreateImpactGroupTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ImpactGroupTemplate` to be created by this mutation. */
  impactGroupTemplate: ImpactGroupTemplateInput;
};

/** The output of our create `ImpactGroupTemplate` mutation. */
export type CreateImpactGroupTemplatePayload = {
  __typename?: 'CreateImpactGroupTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ImpactGroupTemplate` that was created by this mutation. */
  impactGroupTemplate?: Maybe<ImpactGroupTemplate>;
  /** An edge for our `ImpactGroupTemplate`. May be used by Relay 1. */
  impactGroupTemplateEdge?: Maybe<ImpactGroupTemplateEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ImpactGroupTemplate` mutation. */
export type CreateImpactGroupTemplatePayloadImpactGroupTemplateEdgeArgs = {
  orderBy?: Array<ImpactGroupTemplateOrderBy>;
};

/** All input for the create `KycPriorityLabel` mutation. */
export type CreateKycPriorityLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `KycPriorityLabel` to be created by this mutation. */
  kycPriorityLabel: KycPriorityLabelInput;
};

/** The output of our create `KycPriorityLabel` mutation. */
export type CreateKycPriorityLabelPayload = {
  __typename?: 'CreateKycPriorityLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `KycPriorityLabel` that was created by this mutation. */
  kycPriorityLabel?: Maybe<KycPriorityLabel>;
  /** An edge for our `KycPriorityLabel`. May be used by Relay 1. */
  kycPriorityLabelEdge?: Maybe<KycPriorityLabelEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `KycPriorityLabel` mutation. */
export type CreateKycPriorityLabelPayloadKycPriorityLabelEdgeArgs = {
  orderBy?: Array<KycPriorityLabelOrderBy>;
};

export type CreateKycPriorityReviewConfigInput = {
  activeLabels: Array<Scalars['String']['input']>;
  type: KycPriorityTypeEnum;
};

export type CreateKycPriorityReviewConfigPayload = {
  __typename?: 'CreateKycPriorityReviewConfigPayload';
  activeLabels: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  savedByUserId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type CreateReasonCodeInput = {
  code: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** All input for the create `TraderRiskIndicator` mutation. */
export type CreateTraderRiskIndicatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TraderRiskIndicator` to be created by this mutation. */
  traderRiskIndicator: TraderRiskIndicatorInput;
};

/** The output of our create `TraderRiskIndicator` mutation. */
export type CreateTraderRiskIndicatorPayload = {
  __typename?: 'CreateTraderRiskIndicatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TraderRiskIndicator` that was created by this mutation. */
  traderRiskIndicator?: Maybe<TraderRiskIndicator>;
  /** An edge for our `TraderRiskIndicator`. May be used by Relay 1. */
  traderRiskIndicatorEdge?: Maybe<TraderRiskIndicatorEdge>;
};


/** The output of our create `TraderRiskIndicator` mutation. */
export type CreateTraderRiskIndicatorPayloadTraderRiskIndicatorEdgeArgs = {
  orderBy?: Array<TraderRiskIndicatorOrderBy>;
};

/** All input for the create `TradingProductFee` mutation. */
export type CreateTradingProductFeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TradingProductFee` to be created by this mutation. */
  tradingProductFee: TradingProductFeeInput;
};

/** The output of our create `TradingProductFee` mutation. */
export type CreateTradingProductFeePayload = {
  __typename?: 'CreateTradingProductFeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TradingProductFee` that was created by this mutation. */
  tradingProductFee?: Maybe<TradingProductFee>;
  /** An edge for our `TradingProductFee`. May be used by Relay 1. */
  tradingProductFeeEdge?: Maybe<TradingProductFeeEdge>;
};


/** The output of our create `TradingProductFee` mutation. */
export type CreateTradingProductFeePayloadTradingProductFeeEdgeArgs = {
  orderBy?: Array<TradingProductFeeOrderBy>;
};

/** All input for the create `UserAddress` mutation. */
export type CreateUserAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserAddress` to be created by this mutation. */
  userAddress: UserAddressInput;
};

/** The output of our create `UserAddress` mutation. */
export type CreateUserAddressPayload = {
  __typename?: 'CreateUserAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserAddress` that was created by this mutation. */
  userAddress?: Maybe<UserAddress>;
  /** An edge for our `UserAddress`. May be used by Relay 1. */
  userAddressEdge?: Maybe<UserAddressEdge>;
};


/** The output of our create `UserAddress` mutation. */
export type CreateUserAddressPayloadUserAddressEdgeArgs = {
  orderBy?: Array<UserAddressOrderBy>;
};

/** All input for the create `UserTaxForm` mutation. */
export type CreateUserTaxFormInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserTaxForm` to be created by this mutation. */
  userTaxForm: UserTaxFormInput;
};

/** The output of our create `UserTaxForm` mutation. */
export type CreateUserTaxFormPayload = {
  __typename?: 'CreateUserTaxFormPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTaxForm` that was created by this mutation. */
  userTaxForm?: Maybe<UserTaxForm>;
  /** An edge for our `UserTaxForm`. May be used by Relay 1. */
  userTaxFormEdge?: Maybe<UserTaxFormEdge>;
};


/** The output of our create `UserTaxForm` mutation. */
export type CreateUserTaxFormPayloadUserTaxFormEdgeArgs = {
  orderBy?: Array<UserTaxFormOrderBy>;
};

/** All input for the create `XfaActivationCredit` mutation. */
export type CreateXfaActivationCreditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `XfaActivationCredit` to be created by this mutation. */
  xfaActivationCredit: XfaActivationCreditInput;
};

/** The output of our create `XfaActivationCredit` mutation. */
export type CreateXfaActivationCreditPayload = {
  __typename?: 'CreateXfaActivationCreditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `XfaActivationCredit` that was created by this mutation. */
  xfaActivationCredit?: Maybe<XfaActivationCredit>;
  /** An edge for our `XfaActivationCredit`. May be used by Relay 1. */
  xfaActivationCreditEdge?: Maybe<XfaActivationCreditEdge>;
};


/** The output of our create `XfaActivationCredit` mutation. */
export type CreateXfaActivationCreditPayloadXfaActivationCreditEdgeArgs = {
  orderBy?: Array<XfaActivationCreditOrderBy>;
};

export type CurrentAdminRole = {
  __typename?: 'CurrentAdminRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteImpactGroupAssignmentById` mutation. */
export type DeleteImpactGroupAssignmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ImpactGroupAssignment` to be deleted. */
  id: Scalars['ID']['input'];
};

/** All input for the `deleteImpactGroupAssignment` mutation. */
export type DeleteImpactGroupAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rowId: Scalars['Int']['input'];
};

/** The output of our delete `ImpactGroupAssignment` mutation. */
export type DeleteImpactGroupAssignmentPayload = {
  __typename?: 'DeleteImpactGroupAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedImpactGroupAssignmentId?: Maybe<Scalars['ID']['output']>;
  /** The `ImpactGroupAssignment` that was deleted by this mutation. */
  impactGroupAssignment?: Maybe<ImpactGroupAssignment>;
  /** An edge for our `ImpactGroupAssignment`. May be used by Relay 1. */
  impactGroupAssignmentEdge?: Maybe<ImpactGroupAssignmentEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ImpactGroupAssignment` mutation. */
export type DeleteImpactGroupAssignmentPayloadImpactGroupAssignmentEdgeArgs = {
  orderBy?: Array<ImpactGroupAssignmentOrderBy>;
};

/** All input for the `deleteKycPriorityLabelById` mutation. */
export type DeleteKycPriorityLabelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `KycPriorityLabel` to be deleted. */
  id: Scalars['ID']['input'];
};

/** All input for the `deleteKycPriorityLabel` mutation. */
export type DeleteKycPriorityLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rowId: Scalars['Int']['input'];
};

/** The output of our delete `KycPriorityLabel` mutation. */
export type DeleteKycPriorityLabelPayload = {
  __typename?: 'DeleteKycPriorityLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedKycPriorityLabelId?: Maybe<Scalars['ID']['output']>;
  /** The `KycPriorityLabel` that was deleted by this mutation. */
  kycPriorityLabel?: Maybe<KycPriorityLabel>;
  /** An edge for our `KycPriorityLabel`. May be used by Relay 1. */
  kycPriorityLabelEdge?: Maybe<KycPriorityLabelEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `KycPriorityLabel` mutation. */
export type DeleteKycPriorityLabelPayloadKycPriorityLabelEdgeArgs = {
  orderBy?: Array<KycPriorityLabelOrderBy>;
};

/** All input for the `deleteUserAddressById` mutation. */
export type DeleteUserAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserAddress` to be deleted. */
  id: Scalars['ID']['input'];
};

/** All input for the `deleteUserAddress` mutation. */
export type DeleteUserAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rowId: Scalars['Int']['input'];
};

/** The output of our delete `UserAddress` mutation. */
export type DeleteUserAddressPayload = {
  __typename?: 'DeleteUserAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserAddressId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserAddress` that was deleted by this mutation. */
  userAddress?: Maybe<UserAddress>;
  /** An edge for our `UserAddress`. May be used by Relay 1. */
  userAddressEdge?: Maybe<UserAddressEdge>;
};


/** The output of our delete `UserAddress` mutation. */
export type DeleteUserAddressPayloadUserAddressEdgeArgs = {
  orderBy?: Array<UserAddressOrderBy>;
};

/** All input for the `deleteXfaActivationCreditById` mutation. */
export type DeleteXfaActivationCreditByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `XfaActivationCredit` to be deleted. */
  id: Scalars['ID']['input'];
};

/** All input for the `deleteXfaActivationCredit` mutation. */
export type DeleteXfaActivationCreditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rowId: Scalars['Int']['input'];
};

/** The output of our delete `XfaActivationCredit` mutation. */
export type DeleteXfaActivationCreditPayload = {
  __typename?: 'DeleteXfaActivationCreditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedXfaActivationCreditId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `XfaActivationCredit` that was deleted by this mutation. */
  xfaActivationCredit?: Maybe<XfaActivationCredit>;
  /** An edge for our `XfaActivationCredit`. May be used by Relay 1. */
  xfaActivationCreditEdge?: Maybe<XfaActivationCreditEdge>;
};


/** The output of our delete `XfaActivationCredit` mutation. */
export type DeleteXfaActivationCreditPayloadXfaActivationCreditEdgeArgs = {
  orderBy?: Array<XfaActivationCreditOrderBy>;
};

/** Result of requesting the Discord OAuth link URL for the current user. */
export type DiscordLinkUrlPayload = {
  __typename?: 'DiscordLinkUrlPayload';
  /** Human-readable message (e.g. error reason when url is null). */
  message: Scalars['String']['output'];
  /** Discord OAuth2 authorize URL to redirect the user to. Null if not configured or error. */
  url?: Maybe<Scalars['String']['output']>;
};

export type DllDailyMetrics = {
  __typename?: 'DllDailyMetrics';
  dailyDrawdownLimit: Scalars['Float']['output'];
  lossToday: Scalars['Float']['output'];
  percentageUsed: Scalars['Float']['output'];
  remainingToday: Scalars['Float']['output'];
};

/** DocuSign authentication test response */
export type DocuSignAuthResult = {
  __typename?: 'DocuSignAuthResult';
  /** Whether authentication was successful */
  success: Scalars['Boolean']['output'];
};

/**
 * Result from checking DocuSign envelope status.
 * Contains the real-time status from DocuSign API.
 */
export type DocuSignEnvelopeStatusResult = {
  __typename?: 'DocuSignEnvelopeStatusResult';
  /** The envelope status from DocuSign (e.g., sent, delivered, completed, declined, voided) */
  status: Scalars['String']['output'];
  /** ISO timestamp of when the status last changed */
  statusDateTime: Scalars['String']['output'];
};

export type Email = Node & {
  __typename?: 'Email';
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `EmailAction`. */
  emailActions: EmailActionConnection;
  emailJsonBody?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  lastClicked?: Maybe<Scalars['Datetime']['output']>;
  lastOpened?: Maybe<Scalars['Datetime']['output']>;
  mailGunStorageKey?: Maybe<Scalars['String']['output']>;
  mailgunId?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Email`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type EmailEmailActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailActionCondition>;
  filter?: InputMaybe<EmailActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailActionOrderBy>>;
};

export type EmailAction = Node & {
  __typename?: 'EmailAction';
  actionTime?: Maybe<Scalars['Datetime']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Email` that is related to this `EmailAction`. */
  email?: Maybe<Email>;
  emailId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userBrowser?: Maybe<Scalars['String']['output']>;
  userIp?: Maybe<Scalars['String']['output']>;
  userLocation?: Maybe<Scalars['String']['output']>;
};

export type EmailActionAggregates = {
  __typename?: 'EmailActionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EmailActionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EmailActionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EmailActionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EmailActionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EmailActionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EmailActionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EmailActionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EmailActionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EmailActionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `EmailAction` object types. */
export type EmailActionAggregatesFilter = {
  /** Mean average aggregate over matching `EmailAction` objects. */
  average?: InputMaybe<EmailActionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `EmailAction` objects. */
  distinctCount?: InputMaybe<EmailActionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `EmailAction` object to be included within the aggregate. */
  filter?: InputMaybe<EmailActionFilter>;
  /** Maximum aggregate over matching `EmailAction` objects. */
  max?: InputMaybe<EmailActionMaxAggregateFilter>;
  /** Minimum aggregate over matching `EmailAction` objects. */
  min?: InputMaybe<EmailActionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `EmailAction` objects. */
  stddevPopulation?: InputMaybe<EmailActionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `EmailAction` objects. */
  stddevSample?: InputMaybe<EmailActionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `EmailAction` objects. */
  sum?: InputMaybe<EmailActionSumAggregateFilter>;
  /** Population variance aggregate over matching `EmailAction` objects. */
  variancePopulation?: InputMaybe<EmailActionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `EmailAction` objects. */
  varianceSample?: InputMaybe<EmailActionVarianceSampleAggregateFilter>;
};

export type EmailActionAverageAggregateFilter = {
  emailId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type EmailActionAverageAggregates = {
  __typename?: 'EmailActionAverageAggregates';
  /** Mean average of emailId across the matching connection */
  emailId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `EmailAction` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EmailActionCondition = {
  /** Checks for equality with the object’s `emailId` field. */
  emailId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `EmailAction` values. */
export type EmailActionConnection = {
  __typename?: 'EmailActionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EmailActionAggregates>;
  /** A list of edges which contains the `EmailAction` and cursor to aid in pagination. */
  edges: Array<Maybe<EmailActionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EmailActionAggregates>>;
  /** A list of `EmailAction` objects. */
  nodes: Array<Maybe<EmailAction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailAction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `EmailAction` values. */
export type EmailActionConnectionGroupedAggregatesArgs = {
  groupBy: Array<EmailActionGroupBy>;
  having?: InputMaybe<EmailActionHavingInput>;
};

export type EmailActionDistinctCountAggregateFilter = {
  emailId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type EmailActionDistinctCountAggregates = {
  __typename?: 'EmailActionDistinctCountAggregates';
  /** Distinct count of actionTime across the matching connection */
  actionTime?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of actionType across the matching connection */
  actionType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of emailId across the matching connection */
  emailId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userBrowser across the matching connection */
  userBrowser?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userIp across the matching connection */
  userIp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userLocation across the matching connection */
  userLocation?: Maybe<Scalars['BigInt']['output']>;
};

/** A `EmailAction` edge in the connection. */
export type EmailActionEdge = {
  __typename?: 'EmailActionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailAction` at the end of the edge. */
  node?: Maybe<EmailAction>;
};

/** A filter to be used against `EmailAction` object types. All fields are combined with a logical ‘and.’ */
export type EmailActionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailActionFilter>>;
  /** Filter by the object’s `email` relation. */
  email?: InputMaybe<EmailFilter>;
  /** Filter by the object’s `emailId` field. */
  emailId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailActionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailActionFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `EmailAction` for usage during aggregation. */
export enum EmailActionGroupBy {
  EmailId = 'EMAIL_ID'
}

export type EmailActionHavingAverageInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingDistinctCountInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `EmailAction` aggregates. */
export type EmailActionHavingInput = {
  AND?: InputMaybe<Array<EmailActionHavingInput>>;
  OR?: InputMaybe<Array<EmailActionHavingInput>>;
  average?: InputMaybe<EmailActionHavingAverageInput>;
  distinctCount?: InputMaybe<EmailActionHavingDistinctCountInput>;
  max?: InputMaybe<EmailActionHavingMaxInput>;
  min?: InputMaybe<EmailActionHavingMinInput>;
  stddevPopulation?: InputMaybe<EmailActionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EmailActionHavingStddevSampleInput>;
  sum?: InputMaybe<EmailActionHavingSumInput>;
  variancePopulation?: InputMaybe<EmailActionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EmailActionHavingVarianceSampleInput>;
};

export type EmailActionHavingMaxInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingMinInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingStddevPopulationInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingStddevSampleInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingSumInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingVariancePopulationInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionHavingVarianceSampleInput = {
  actionTime?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  emailId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type EmailActionMaxAggregateFilter = {
  emailId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type EmailActionMaxAggregates = {
  __typename?: 'EmailActionMaxAggregates';
  /** Maximum of emailId across the matching connection */
  emailId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type EmailActionMinAggregateFilter = {
  emailId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type EmailActionMinAggregates = {
  __typename?: 'EmailActionMinAggregates';
  /** Minimum of emailId across the matching connection */
  emailId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `EmailAction`. */
export enum EmailActionOrderBy {
  EmailIdAsc = 'EMAIL_ID_ASC',
  EmailIdDesc = 'EMAIL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type EmailActionStddevPopulationAggregateFilter = {
  emailId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type EmailActionStddevPopulationAggregates = {
  __typename?: 'EmailActionStddevPopulationAggregates';
  /** Population standard deviation of emailId across the matching connection */
  emailId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailActionStddevSampleAggregateFilter = {
  emailId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type EmailActionStddevSampleAggregates = {
  __typename?: 'EmailActionStddevSampleAggregates';
  /** Sample standard deviation of emailId across the matching connection */
  emailId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailActionSumAggregateFilter = {
  emailId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type EmailActionSumAggregates = {
  __typename?: 'EmailActionSumAggregates';
  /** Sum of emailId across the matching connection */
  emailId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type EmailActionVariancePopulationAggregateFilter = {
  emailId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type EmailActionVariancePopulationAggregates = {
  __typename?: 'EmailActionVariancePopulationAggregates';
  /** Population variance of emailId across the matching connection */
  emailId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailActionVarianceSampleAggregateFilter = {
  emailId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type EmailActionVarianceSampleAggregates = {
  __typename?: 'EmailActionVarianceSampleAggregates';
  /** Sample variance of emailId across the matching connection */
  emailId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailAggregates = {
  __typename?: 'EmailAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EmailAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EmailDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EmailMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EmailMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EmailStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EmailStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EmailSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EmailVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EmailVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Email` object types. */
export type EmailAggregatesFilter = {
  /** Mean average aggregate over matching `Email` objects. */
  average?: InputMaybe<EmailAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Email` objects. */
  distinctCount?: InputMaybe<EmailDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Email` object to be included within the aggregate. */
  filter?: InputMaybe<EmailFilter>;
  /** Maximum aggregate over matching `Email` objects. */
  max?: InputMaybe<EmailMaxAggregateFilter>;
  /** Minimum aggregate over matching `Email` objects. */
  min?: InputMaybe<EmailMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Email` objects. */
  stddevPopulation?: InputMaybe<EmailStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Email` objects. */
  stddevSample?: InputMaybe<EmailStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Email` objects. */
  sum?: InputMaybe<EmailSumAggregateFilter>;
  /** Population variance aggregate over matching `Email` objects. */
  variancePopulation?: InputMaybe<EmailVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Email` objects. */
  varianceSample?: InputMaybe<EmailVarianceSampleAggregateFilter>;
};

export type EmailAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type EmailAverageAggregates = {
  __typename?: 'EmailAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Email` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EmailCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `idempotencyKey` field. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastOpened` field. */
  lastOpened?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `mailgunId` field. */
  mailgunId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Email` values. */
export type EmailConnection = {
  __typename?: 'EmailConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EmailAggregates>;
  /** A list of edges which contains the `Email` and cursor to aid in pagination. */
  edges: Array<Maybe<EmailEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EmailAggregates>>;
  /** A list of `Email` objects. */
  nodes: Array<Maybe<Email>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Email` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Email` values. */
export type EmailConnectionGroupedAggregatesArgs = {
  groupBy: Array<EmailGroupBy>;
  having?: InputMaybe<EmailHavingInput>;
};

export type EmailDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  idempotencyKey?: InputMaybe<BigIntFilter>;
  lastOpened?: InputMaybe<BigIntFilter>;
  mailgunId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  subject?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type EmailDistinctCountAggregates = {
  __typename?: 'EmailDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of emailJsonBody across the matching connection */
  emailJsonBody?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idempotencyKey across the matching connection */
  idempotencyKey?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastClicked across the matching connection */
  lastClicked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastOpened across the matching connection */
  lastOpened?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of mailGunStorageKey across the matching connection */
  mailGunStorageKey?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of mailgunId across the matching connection */
  mailgunId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subject across the matching connection */
  subject?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Email` edge in the connection. */
export type EmailEdge = {
  __typename?: 'EmailEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Email` at the end of the edge. */
  node?: Maybe<Email>;
};

/** A filter to be used against `Email` object types. All fields are combined with a logical ‘and.’ */
export type EmailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailActions` relation. */
  emailActions?: InputMaybe<EmailToManyEmailActionFilter>;
  /** Some related `emailActions` exist. */
  emailActionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `idempotencyKey` field. */
  idempotencyKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastOpened` field. */
  lastOpened?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `mailgunId` field. */
  mailgunId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Email` for usage during aggregation. */
export enum EmailGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  IdempotencyKey = 'IDEMPOTENCY_KEY',
  LastOpened = 'LAST_OPENED',
  LastOpenedTruncatedToDay = 'LAST_OPENED_TRUNCATED_TO_DAY',
  LastOpenedTruncatedToHour = 'LAST_OPENED_TRUNCATED_TO_HOUR',
  MailgunId = 'MAILGUN_ID',
  Status = 'STATUS',
  Subject = 'SUBJECT',
  UserId = 'USER_ID'
}

export type EmailHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Email` aggregates. */
export type EmailHavingInput = {
  AND?: InputMaybe<Array<EmailHavingInput>>;
  OR?: InputMaybe<Array<EmailHavingInput>>;
  average?: InputMaybe<EmailHavingAverageInput>;
  distinctCount?: InputMaybe<EmailHavingDistinctCountInput>;
  max?: InputMaybe<EmailHavingMaxInput>;
  min?: InputMaybe<EmailHavingMinInput>;
  stddevPopulation?: InputMaybe<EmailHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EmailHavingStddevSampleInput>;
  sum?: InputMaybe<EmailHavingSumInput>;
  variancePopulation?: InputMaybe<EmailHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EmailHavingVarianceSampleInput>;
};

export type EmailHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastClicked?: InputMaybe<HavingDatetimeFilter>;
  lastOpened?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type EmailMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type EmailMaxAggregates = {
  __typename?: 'EmailMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type EmailMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type EmailMinAggregates = {
  __typename?: 'EmailMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Email`. */
export enum EmailOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailActionsAverageEmailIdAsc = 'EMAIL_ACTIONS_AVERAGE_EMAIL_ID_ASC',
  EmailActionsAverageEmailIdDesc = 'EMAIL_ACTIONS_AVERAGE_EMAIL_ID_DESC',
  EmailActionsAverageRowIdAsc = 'EMAIL_ACTIONS_AVERAGE_ROW_ID_ASC',
  EmailActionsAverageRowIdDesc = 'EMAIL_ACTIONS_AVERAGE_ROW_ID_DESC',
  EmailActionsCountAsc = 'EMAIL_ACTIONS_COUNT_ASC',
  EmailActionsCountDesc = 'EMAIL_ACTIONS_COUNT_DESC',
  EmailActionsDistinctCountEmailIdAsc = 'EMAIL_ACTIONS_DISTINCT_COUNT_EMAIL_ID_ASC',
  EmailActionsDistinctCountEmailIdDesc = 'EMAIL_ACTIONS_DISTINCT_COUNT_EMAIL_ID_DESC',
  EmailActionsDistinctCountRowIdAsc = 'EMAIL_ACTIONS_DISTINCT_COUNT_ROW_ID_ASC',
  EmailActionsDistinctCountRowIdDesc = 'EMAIL_ACTIONS_DISTINCT_COUNT_ROW_ID_DESC',
  EmailActionsMaxEmailIdAsc = 'EMAIL_ACTIONS_MAX_EMAIL_ID_ASC',
  EmailActionsMaxEmailIdDesc = 'EMAIL_ACTIONS_MAX_EMAIL_ID_DESC',
  EmailActionsMaxRowIdAsc = 'EMAIL_ACTIONS_MAX_ROW_ID_ASC',
  EmailActionsMaxRowIdDesc = 'EMAIL_ACTIONS_MAX_ROW_ID_DESC',
  EmailActionsMinEmailIdAsc = 'EMAIL_ACTIONS_MIN_EMAIL_ID_ASC',
  EmailActionsMinEmailIdDesc = 'EMAIL_ACTIONS_MIN_EMAIL_ID_DESC',
  EmailActionsMinRowIdAsc = 'EMAIL_ACTIONS_MIN_ROW_ID_ASC',
  EmailActionsMinRowIdDesc = 'EMAIL_ACTIONS_MIN_ROW_ID_DESC',
  EmailActionsStddevPopulationEmailIdAsc = 'EMAIL_ACTIONS_STDDEV_POPULATION_EMAIL_ID_ASC',
  EmailActionsStddevPopulationEmailIdDesc = 'EMAIL_ACTIONS_STDDEV_POPULATION_EMAIL_ID_DESC',
  EmailActionsStddevPopulationRowIdAsc = 'EMAIL_ACTIONS_STDDEV_POPULATION_ROW_ID_ASC',
  EmailActionsStddevPopulationRowIdDesc = 'EMAIL_ACTIONS_STDDEV_POPULATION_ROW_ID_DESC',
  EmailActionsStddevSampleEmailIdAsc = 'EMAIL_ACTIONS_STDDEV_SAMPLE_EMAIL_ID_ASC',
  EmailActionsStddevSampleEmailIdDesc = 'EMAIL_ACTIONS_STDDEV_SAMPLE_EMAIL_ID_DESC',
  EmailActionsStddevSampleRowIdAsc = 'EMAIL_ACTIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  EmailActionsStddevSampleRowIdDesc = 'EMAIL_ACTIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  EmailActionsSumEmailIdAsc = 'EMAIL_ACTIONS_SUM_EMAIL_ID_ASC',
  EmailActionsSumEmailIdDesc = 'EMAIL_ACTIONS_SUM_EMAIL_ID_DESC',
  EmailActionsSumRowIdAsc = 'EMAIL_ACTIONS_SUM_ROW_ID_ASC',
  EmailActionsSumRowIdDesc = 'EMAIL_ACTIONS_SUM_ROW_ID_DESC',
  EmailActionsVariancePopulationEmailIdAsc = 'EMAIL_ACTIONS_VARIANCE_POPULATION_EMAIL_ID_ASC',
  EmailActionsVariancePopulationEmailIdDesc = 'EMAIL_ACTIONS_VARIANCE_POPULATION_EMAIL_ID_DESC',
  EmailActionsVariancePopulationRowIdAsc = 'EMAIL_ACTIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  EmailActionsVariancePopulationRowIdDesc = 'EMAIL_ACTIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  EmailActionsVarianceSampleEmailIdAsc = 'EMAIL_ACTIONS_VARIANCE_SAMPLE_EMAIL_ID_ASC',
  EmailActionsVarianceSampleEmailIdDesc = 'EMAIL_ACTIONS_VARIANCE_SAMPLE_EMAIL_ID_DESC',
  EmailActionsVarianceSampleRowIdAsc = 'EMAIL_ACTIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  EmailActionsVarianceSampleRowIdDesc = 'EMAIL_ACTIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  IdempotencyKeyAsc = 'IDEMPOTENCY_KEY_ASC',
  IdempotencyKeyDesc = 'IDEMPOTENCY_KEY_DESC',
  LastOpenedAsc = 'LAST_OPENED_ASC',
  LastOpenedDesc = 'LAST_OPENED_DESC',
  MailgunIdAsc = 'MAILGUN_ID_ASC',
  MailgunIdDesc = 'MAILGUN_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type EmailStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type EmailStddevPopulationAggregates = {
  __typename?: 'EmailStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type EmailStddevSampleAggregates = {
  __typename?: 'EmailStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type EmailSumAggregates = {
  __typename?: 'EmailSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `EmailAction` object types. All fields are combined with a logical ‘and.’ */
export type EmailToManyEmailActionFilter = {
  /** Aggregates across related `EmailAction` match the filter criteria. */
  aggregates?: InputMaybe<EmailActionAggregatesFilter>;
  /** Every related `EmailAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmailActionFilter>;
  /** No related `EmailAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmailActionFilter>;
  /** Some related `EmailAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmailActionFilter>;
};

export type EmailVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type EmailVariancePopulationAggregates = {
  __typename?: 'EmailVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EmailVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type EmailVarianceSampleAggregates = {
  __typename?: 'EmailVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** Entity type for W-9 form */
export enum EntityType {
  Business = 'Business',
  Individual = 'Individual'
}

export type GetOrCreateUserTaxFormInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  entityType: EntityType;
  formType: TaxFormTypeEnum;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type GetOrCreateUserTaxFormResult = {
  __typename?: 'GetOrCreateUserTaxFormResult';
  businessName?: Maybe<Scalars['String']['output']>;
  docusignEnvelopeId?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  reused: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
};

export type Group = Node & {
  __typename?: 'Group';
  /** Reads and enables pagination through a set of `GroupAdmin`. */
  groupAdmins: GroupAdminConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
};


export type GroupGroupAdminsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupAdminCondition>;
  filter?: InputMaybe<GroupAdminFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupAdminOrderBy>>;
};

export type GroupAdmin = Node & {
  __typename?: 'GroupAdmin';
  /** Reads a single `Group` that is related to this `GroupAdmin`. */
  group?: Maybe<Group>;
  groupId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `GroupAdmin`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type GroupAdminAggregates = {
  __typename?: 'GroupAdminAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<GroupAdminAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<GroupAdminDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<GroupAdminMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<GroupAdminMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<GroupAdminStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<GroupAdminStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<GroupAdminSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<GroupAdminVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<GroupAdminVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `GroupAdmin` object types. */
export type GroupAdminAggregatesFilter = {
  /** Mean average aggregate over matching `GroupAdmin` objects. */
  average?: InputMaybe<GroupAdminAverageAggregateFilter>;
  /** Distinct count aggregate over matching `GroupAdmin` objects. */
  distinctCount?: InputMaybe<GroupAdminDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `GroupAdmin` object to be included within the aggregate. */
  filter?: InputMaybe<GroupAdminFilter>;
  /** Maximum aggregate over matching `GroupAdmin` objects. */
  max?: InputMaybe<GroupAdminMaxAggregateFilter>;
  /** Minimum aggregate over matching `GroupAdmin` objects. */
  min?: InputMaybe<GroupAdminMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `GroupAdmin` objects. */
  stddevPopulation?: InputMaybe<GroupAdminStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `GroupAdmin` objects. */
  stddevSample?: InputMaybe<GroupAdminStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `GroupAdmin` objects. */
  sum?: InputMaybe<GroupAdminSumAggregateFilter>;
  /** Population variance aggregate over matching `GroupAdmin` objects. */
  variancePopulation?: InputMaybe<GroupAdminVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `GroupAdmin` objects. */
  varianceSample?: InputMaybe<GroupAdminVarianceSampleAggregateFilter>;
};

export type GroupAdminAverageAggregateFilter = {
  groupId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type GroupAdminAverageAggregates = {
  __typename?: 'GroupAdminAverageAggregates';
  /** Mean average of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `GroupAdmin` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GroupAdminCondition = {
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `GroupAdmin` values. */
export type GroupAdminConnection = {
  __typename?: 'GroupAdminConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<GroupAdminAggregates>;
  /** A list of edges which contains the `GroupAdmin` and cursor to aid in pagination. */
  edges: Array<Maybe<GroupAdminEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<GroupAdminAggregates>>;
  /** A list of `GroupAdmin` objects. */
  nodes: Array<Maybe<GroupAdmin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupAdmin` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `GroupAdmin` values. */
export type GroupAdminConnectionGroupedAggregatesArgs = {
  groupBy: Array<GroupAdminGroupBy>;
  having?: InputMaybe<GroupAdminHavingInput>;
};

export type GroupAdminDistinctCountAggregateFilter = {
  groupId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type GroupAdminDistinctCountAggregates = {
  __typename?: 'GroupAdminDistinctCountAggregates';
  /** Distinct count of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `GroupAdmin` edge in the connection. */
export type GroupAdminEdge = {
  __typename?: 'GroupAdminEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GroupAdmin` at the end of the edge. */
  node?: Maybe<GroupAdmin>;
};

/** A filter to be used against `GroupAdmin` object types. All fields are combined with a logical ‘and.’ */
export type GroupAdminFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupAdminFilter>>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupAdminFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupAdminFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `GroupAdmin` for usage during aggregation. */
export enum GroupAdminGroupBy {
  GroupId = 'GROUP_ID',
  UserId = 'USER_ID'
}

export type GroupAdminHavingAverageInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingDistinctCountInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `GroupAdmin` aggregates. */
export type GroupAdminHavingInput = {
  AND?: InputMaybe<Array<GroupAdminHavingInput>>;
  OR?: InputMaybe<Array<GroupAdminHavingInput>>;
  average?: InputMaybe<GroupAdminHavingAverageInput>;
  distinctCount?: InputMaybe<GroupAdminHavingDistinctCountInput>;
  max?: InputMaybe<GroupAdminHavingMaxInput>;
  min?: InputMaybe<GroupAdminHavingMinInput>;
  stddevPopulation?: InputMaybe<GroupAdminHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<GroupAdminHavingStddevSampleInput>;
  sum?: InputMaybe<GroupAdminHavingSumInput>;
  variancePopulation?: InputMaybe<GroupAdminHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<GroupAdminHavingVarianceSampleInput>;
};

export type GroupAdminHavingMaxInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingMinInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingStddevPopulationInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingStddevSampleInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingSumInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingVariancePopulationInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminHavingVarianceSampleInput = {
  groupId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type GroupAdminMaxAggregateFilter = {
  groupId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type GroupAdminMaxAggregates = {
  __typename?: 'GroupAdminMaxAggregates';
  /** Maximum of groupId across the matching connection */
  groupId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type GroupAdminMinAggregateFilter = {
  groupId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type GroupAdminMinAggregates = {
  __typename?: 'GroupAdminMinAggregates';
  /** Minimum of groupId across the matching connection */
  groupId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `GroupAdmin`. */
export enum GroupAdminOrderBy {
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GroupAdminStddevPopulationAggregateFilter = {
  groupId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type GroupAdminStddevPopulationAggregates = {
  __typename?: 'GroupAdminStddevPopulationAggregates';
  /** Population standard deviation of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupAdminStddevSampleAggregateFilter = {
  groupId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type GroupAdminStddevSampleAggregates = {
  __typename?: 'GroupAdminStddevSampleAggregates';
  /** Sample standard deviation of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupAdminSumAggregateFilter = {
  groupId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type GroupAdminSumAggregates = {
  __typename?: 'GroupAdminSumAggregates';
  /** Sum of groupId across the matching connection */
  groupId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type GroupAdminVariancePopulationAggregateFilter = {
  groupId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type GroupAdminVariancePopulationAggregates = {
  __typename?: 'GroupAdminVariancePopulationAggregates';
  /** Population variance of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupAdminVarianceSampleAggregateFilter = {
  groupId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type GroupAdminVarianceSampleAggregates = {
  __typename?: 'GroupAdminVarianceSampleAggregates';
  /** Sample variance of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupAggregates = {
  __typename?: 'GroupAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<GroupAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<GroupDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<GroupMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<GroupMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<GroupStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<GroupStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<GroupSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<GroupVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<GroupVarianceSampleAggregates>;
};

export type GroupAverageAggregates = {
  __typename?: 'GroupAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Group` values. */
export type GroupConnection = {
  __typename?: 'GroupConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<GroupAggregates>;
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<Maybe<GroupEdge>>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type GroupDistinctCountAggregates = {
  __typename?: 'GroupDistinctCountAggregates';
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Group` edge in the connection. */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Group` at the end of the edge. */
  node?: Maybe<Group>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `groupAdmins` relation. */
  groupAdmins?: InputMaybe<GroupToManyGroupAdminFilter>;
  /** Some related `groupAdmins` exist. */
  groupAdminsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type GroupMaxAggregates = {
  __typename?: 'GroupMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type GroupMinAggregates = {
  __typename?: 'GroupMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Group`. */
export enum GroupOrderBy {
  GroupAdminsAverageGroupIdAsc = 'GROUP_ADMINS_AVERAGE_GROUP_ID_ASC',
  GroupAdminsAverageGroupIdDesc = 'GROUP_ADMINS_AVERAGE_GROUP_ID_DESC',
  GroupAdminsAverageUserIdAsc = 'GROUP_ADMINS_AVERAGE_USER_ID_ASC',
  GroupAdminsAverageUserIdDesc = 'GROUP_ADMINS_AVERAGE_USER_ID_DESC',
  GroupAdminsCountAsc = 'GROUP_ADMINS_COUNT_ASC',
  GroupAdminsCountDesc = 'GROUP_ADMINS_COUNT_DESC',
  GroupAdminsDistinctCountGroupIdAsc = 'GROUP_ADMINS_DISTINCT_COUNT_GROUP_ID_ASC',
  GroupAdminsDistinctCountGroupIdDesc = 'GROUP_ADMINS_DISTINCT_COUNT_GROUP_ID_DESC',
  GroupAdminsDistinctCountUserIdAsc = 'GROUP_ADMINS_DISTINCT_COUNT_USER_ID_ASC',
  GroupAdminsDistinctCountUserIdDesc = 'GROUP_ADMINS_DISTINCT_COUNT_USER_ID_DESC',
  GroupAdminsMaxGroupIdAsc = 'GROUP_ADMINS_MAX_GROUP_ID_ASC',
  GroupAdminsMaxGroupIdDesc = 'GROUP_ADMINS_MAX_GROUP_ID_DESC',
  GroupAdminsMaxUserIdAsc = 'GROUP_ADMINS_MAX_USER_ID_ASC',
  GroupAdminsMaxUserIdDesc = 'GROUP_ADMINS_MAX_USER_ID_DESC',
  GroupAdminsMinGroupIdAsc = 'GROUP_ADMINS_MIN_GROUP_ID_ASC',
  GroupAdminsMinGroupIdDesc = 'GROUP_ADMINS_MIN_GROUP_ID_DESC',
  GroupAdminsMinUserIdAsc = 'GROUP_ADMINS_MIN_USER_ID_ASC',
  GroupAdminsMinUserIdDesc = 'GROUP_ADMINS_MIN_USER_ID_DESC',
  GroupAdminsStddevPopulationGroupIdAsc = 'GROUP_ADMINS_STDDEV_POPULATION_GROUP_ID_ASC',
  GroupAdminsStddevPopulationGroupIdDesc = 'GROUP_ADMINS_STDDEV_POPULATION_GROUP_ID_DESC',
  GroupAdminsStddevPopulationUserIdAsc = 'GROUP_ADMINS_STDDEV_POPULATION_USER_ID_ASC',
  GroupAdminsStddevPopulationUserIdDesc = 'GROUP_ADMINS_STDDEV_POPULATION_USER_ID_DESC',
  GroupAdminsStddevSampleGroupIdAsc = 'GROUP_ADMINS_STDDEV_SAMPLE_GROUP_ID_ASC',
  GroupAdminsStddevSampleGroupIdDesc = 'GROUP_ADMINS_STDDEV_SAMPLE_GROUP_ID_DESC',
  GroupAdminsStddevSampleUserIdAsc = 'GROUP_ADMINS_STDDEV_SAMPLE_USER_ID_ASC',
  GroupAdminsStddevSampleUserIdDesc = 'GROUP_ADMINS_STDDEV_SAMPLE_USER_ID_DESC',
  GroupAdminsSumGroupIdAsc = 'GROUP_ADMINS_SUM_GROUP_ID_ASC',
  GroupAdminsSumGroupIdDesc = 'GROUP_ADMINS_SUM_GROUP_ID_DESC',
  GroupAdminsSumUserIdAsc = 'GROUP_ADMINS_SUM_USER_ID_ASC',
  GroupAdminsSumUserIdDesc = 'GROUP_ADMINS_SUM_USER_ID_DESC',
  GroupAdminsVariancePopulationGroupIdAsc = 'GROUP_ADMINS_VARIANCE_POPULATION_GROUP_ID_ASC',
  GroupAdminsVariancePopulationGroupIdDesc = 'GROUP_ADMINS_VARIANCE_POPULATION_GROUP_ID_DESC',
  GroupAdminsVariancePopulationUserIdAsc = 'GROUP_ADMINS_VARIANCE_POPULATION_USER_ID_ASC',
  GroupAdminsVariancePopulationUserIdDesc = 'GROUP_ADMINS_VARIANCE_POPULATION_USER_ID_DESC',
  GroupAdminsVarianceSampleGroupIdAsc = 'GROUP_ADMINS_VARIANCE_SAMPLE_GROUP_ID_ASC',
  GroupAdminsVarianceSampleGroupIdDesc = 'GROUP_ADMINS_VARIANCE_SAMPLE_GROUP_ID_DESC',
  GroupAdminsVarianceSampleUserIdAsc = 'GROUP_ADMINS_VARIANCE_SAMPLE_USER_ID_ASC',
  GroupAdminsVarianceSampleUserIdDesc = 'GROUP_ADMINS_VARIANCE_SAMPLE_USER_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type GroupStddevPopulationAggregates = {
  __typename?: 'GroupStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupStddevSampleAggregates = {
  __typename?: 'GroupStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupSumAggregates = {
  __typename?: 'GroupSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `GroupAdmin` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyGroupAdminFilter = {
  /** Aggregates across related `GroupAdmin` match the filter criteria. */
  aggregates?: InputMaybe<GroupAdminAggregatesFilter>;
  /** Every related `GroupAdmin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupAdminFilter>;
  /** No related `GroupAdmin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupAdminFilter>;
  /** Some related `GroupAdmin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupAdminFilter>;
};

export type GroupVariancePopulationAggregates = {
  __typename?: 'GroupVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type GroupVarianceSampleAggregates = {
  __typename?: 'GroupVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

export type ImpactGroupAssignment = Node & {
  __typename?: 'ImpactGroupAssignment';
  /** Reads a single `Account` that is related to this `ImpactGroupAssignment`. */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  assignedAt: Scalars['Datetime']['output'];
  assignedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `User` that is related to this `ImpactGroupAssignment`. */
  assignedByUser?: Maybe<User>;
  assignmentExpiresAt: Scalars['Datetime']['output'];
  createdAt: Scalars['Datetime']['output'];
  dismissedAt?: Maybe<Scalars['Datetime']['output']>;
  dynamicMessageContent?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `ImpactGroupTemplate` that is related to this `ImpactGroupAssignment`. */
  impactGroup?: Maybe<ImpactGroupTemplate>;
  impactGroupId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `ImpactGroupAssignment`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ImpactGroupAssignmentAggregates = {
  __typename?: 'ImpactGroupAssignmentAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ImpactGroupAssignmentAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ImpactGroupAssignmentDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ImpactGroupAssignmentMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ImpactGroupAssignmentMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ImpactGroupAssignmentStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ImpactGroupAssignmentStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ImpactGroupAssignmentSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ImpactGroupAssignmentVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ImpactGroupAssignmentVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ImpactGroupAssignment` object types. */
export type ImpactGroupAssignmentAggregatesFilter = {
  /** Mean average aggregate over matching `ImpactGroupAssignment` objects. */
  average?: InputMaybe<ImpactGroupAssignmentAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ImpactGroupAssignment` objects. */
  distinctCount?: InputMaybe<ImpactGroupAssignmentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ImpactGroupAssignment` object to be included within the aggregate. */
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** Maximum aggregate over matching `ImpactGroupAssignment` objects. */
  max?: InputMaybe<ImpactGroupAssignmentMaxAggregateFilter>;
  /** Minimum aggregate over matching `ImpactGroupAssignment` objects. */
  min?: InputMaybe<ImpactGroupAssignmentMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ImpactGroupAssignment` objects. */
  stddevPopulation?: InputMaybe<ImpactGroupAssignmentStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ImpactGroupAssignment` objects. */
  stddevSample?: InputMaybe<ImpactGroupAssignmentStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ImpactGroupAssignment` objects. */
  sum?: InputMaybe<ImpactGroupAssignmentSumAggregateFilter>;
  /** Population variance aggregate over matching `ImpactGroupAssignment` objects. */
  variancePopulation?: InputMaybe<ImpactGroupAssignmentVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ImpactGroupAssignment` objects. */
  varianceSample?: InputMaybe<ImpactGroupAssignmentVarianceSampleAggregateFilter>;
};

export type ImpactGroupAssignmentAverageAggregateFilter = {
  impactGroupId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ImpactGroupAssignmentAverageAggregates = {
  __typename?: 'ImpactGroupAssignmentAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ImpactGroupAssignment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ImpactGroupAssignmentCondition = {
  /** Checks for equality with the object’s `impactGroupId` field. */
  impactGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ImpactGroupAssignment` values. */
export type ImpactGroupAssignmentConnection = {
  __typename?: 'ImpactGroupAssignmentConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ImpactGroupAssignmentAggregates>;
  /** A list of edges which contains the `ImpactGroupAssignment` and cursor to aid in pagination. */
  edges: Array<Maybe<ImpactGroupAssignmentEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ImpactGroupAssignmentAggregates>>;
  /** A list of `ImpactGroupAssignment` objects. */
  nodes: Array<Maybe<ImpactGroupAssignment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ImpactGroupAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ImpactGroupAssignment` values. */
export type ImpactGroupAssignmentConnectionGroupedAggregatesArgs = {
  groupBy: Array<ImpactGroupAssignmentGroupBy>;
  having?: InputMaybe<ImpactGroupAssignmentHavingInput>;
};

export type ImpactGroupAssignmentDistinctCountAggregateFilter = {
  impactGroupId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type ImpactGroupAssignmentDistinctCountAggregates = {
  __typename?: 'ImpactGroupAssignmentDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assignedAt across the matching connection */
  assignedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assignmentExpiresAt across the matching connection */
  assignmentExpiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dismissedAt across the matching connection */
  dismissedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dynamicMessageContent across the matching connection */
  dynamicMessageContent?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ImpactGroupAssignment` edge in the connection. */
export type ImpactGroupAssignmentEdge = {
  __typename?: 'ImpactGroupAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ImpactGroupAssignment` at the end of the edge. */
  node?: Maybe<ImpactGroupAssignment>;
};

/** A filter to be used against `ImpactGroupAssignment` object types. All fields are combined with a logical ‘and.’ */
export type ImpactGroupAssignmentFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** A related `account` exists. */
  accountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ImpactGroupAssignmentFilter>>;
  /** Filter by the object’s `assignedByUser` relation. */
  assignedByUser?: InputMaybe<UserFilter>;
  /** A related `assignedByUser` exists. */
  assignedByUserExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `impactGroup` relation. */
  impactGroup?: InputMaybe<ImpactGroupTemplateFilter>;
  /** Filter by the object’s `impactGroupId` field. */
  impactGroupId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ImpactGroupAssignmentFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `ImpactGroupAssignment` for usage during aggregation. */
export enum ImpactGroupAssignmentGroupBy {
  ImpactGroupId = 'IMPACT_GROUP_ID'
}

export type ImpactGroupAssignmentHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `ImpactGroupAssignment` aggregates. */
export type ImpactGroupAssignmentHavingInput = {
  AND?: InputMaybe<Array<ImpactGroupAssignmentHavingInput>>;
  OR?: InputMaybe<Array<ImpactGroupAssignmentHavingInput>>;
  average?: InputMaybe<ImpactGroupAssignmentHavingAverageInput>;
  distinctCount?: InputMaybe<ImpactGroupAssignmentHavingDistinctCountInput>;
  max?: InputMaybe<ImpactGroupAssignmentHavingMaxInput>;
  min?: InputMaybe<ImpactGroupAssignmentHavingMinInput>;
  stddevPopulation?: InputMaybe<ImpactGroupAssignmentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ImpactGroupAssignmentHavingStddevSampleInput>;
  sum?: InputMaybe<ImpactGroupAssignmentHavingSumInput>;
  variancePopulation?: InputMaybe<ImpactGroupAssignmentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ImpactGroupAssignmentHavingVarianceSampleInput>;
};

export type ImpactGroupAssignmentHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupAssignmentHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  assignedAt?: InputMaybe<HavingDatetimeFilter>;
  assignedBy?: InputMaybe<HavingIntFilter>;
  assignmentExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dismissedAt?: InputMaybe<HavingDatetimeFilter>;
  impactGroupId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `ImpactGroupAssignment` */
export type ImpactGroupAssignmentInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  assignedBy?: InputMaybe<Scalars['Int']['input']>;
  assignmentExpiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  dynamicMessageContent?: InputMaybe<Scalars['JSON']['input']>;
  impactGroup: Scalars['ID']['input'];
  impactGroupId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ImpactGroupAssignmentMaxAggregateFilter = {
  impactGroupId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type ImpactGroupAssignmentMaxAggregates = {
  __typename?: 'ImpactGroupAssignmentMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ImpactGroupAssignmentMinAggregateFilter = {
  impactGroupId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type ImpactGroupAssignmentMinAggregates = {
  __typename?: 'ImpactGroupAssignmentMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ImpactGroupAssignment`. */
export enum ImpactGroupAssignmentOrderBy {
  ImpactGroupIdAsc = 'IMPACT_GROUP_ID_ASC',
  ImpactGroupIdDesc = 'IMPACT_GROUP_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

/** Represents an update to a `ImpactGroupAssignment`. Fields that are set will be updated. */
export type ImpactGroupAssignmentPatch = {
  assignmentExpiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  dynamicMessageContent?: InputMaybe<Scalars['JSON']['input']>;
  impactGroup?: InputMaybe<Scalars['ID']['input']>;
};

export type ImpactGroupAssignmentStddevPopulationAggregateFilter = {
  impactGroupId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ImpactGroupAssignmentStddevPopulationAggregates = {
  __typename?: 'ImpactGroupAssignmentStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupAssignmentStddevSampleAggregateFilter = {
  impactGroupId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ImpactGroupAssignmentStddevSampleAggregates = {
  __typename?: 'ImpactGroupAssignmentStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupAssignmentSumAggregateFilter = {
  impactGroupId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type ImpactGroupAssignmentSumAggregates = {
  __typename?: 'ImpactGroupAssignmentSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of assignedBy across the matching connection */
  assignedBy: Scalars['BigInt']['output'];
  /** Sum of impactGroupId across the matching connection */
  impactGroupId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type ImpactGroupAssignmentVariancePopulationAggregateFilter = {
  impactGroupId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ImpactGroupAssignmentVariancePopulationAggregates = {
  __typename?: 'ImpactGroupAssignmentVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupAssignmentVarianceSampleAggregateFilter = {
  impactGroupId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ImpactGroupAssignmentVarianceSampleAggregates = {
  __typename?: 'ImpactGroupAssignmentVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of assignedBy across the matching connection */
  assignedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of impactGroupId across the matching connection */
  impactGroupId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupTemplate = Node & {
  __typename?: 'ImpactGroupTemplate';
  actionUrl?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `User` that is related to this `ImpactGroupTemplate`. */
  createdByUser?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignments: ImpactGroupAssignmentConnection;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignmentsList: Array<ImpactGroupAssignment>;
  label: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notificationMessage?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  scope: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  templateExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `User` that is related to this `ImpactGroupTemplate`. */
  updatedByUser?: Maybe<User>;
};


export type ImpactGroupTemplateImpactGroupAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type ImpactGroupTemplateImpactGroupAssignmentsListArgs = {
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};

export type ImpactGroupTemplateAggregates = {
  __typename?: 'ImpactGroupTemplateAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ImpactGroupTemplateAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ImpactGroupTemplateDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ImpactGroupTemplateMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ImpactGroupTemplateMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ImpactGroupTemplateStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ImpactGroupTemplateStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ImpactGroupTemplateSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ImpactGroupTemplateVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ImpactGroupTemplateVarianceSampleAggregates>;
};

export type ImpactGroupTemplateAverageAggregates = {
  __typename?: 'ImpactGroupTemplateAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ImpactGroupTemplate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ImpactGroupTemplateCondition = {
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `scope` field. */
  scope?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ImpactGroupTemplate` values. */
export type ImpactGroupTemplateConnection = {
  __typename?: 'ImpactGroupTemplateConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ImpactGroupTemplateAggregates>;
  /** A list of edges which contains the `ImpactGroupTemplate` and cursor to aid in pagination. */
  edges: Array<Maybe<ImpactGroupTemplateEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ImpactGroupTemplateAggregates>>;
  /** A list of `ImpactGroupTemplate` objects. */
  nodes: Array<Maybe<ImpactGroupTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ImpactGroupTemplate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ImpactGroupTemplate` values. */
export type ImpactGroupTemplateConnectionGroupedAggregatesArgs = {
  groupBy: Array<ImpactGroupTemplateGroupBy>;
  having?: InputMaybe<ImpactGroupTemplateHavingInput>;
};

export type ImpactGroupTemplateDistinctCountAggregates = {
  __typename?: 'ImpactGroupTemplateDistinctCountAggregates';
  /** Distinct count of actionUrl across the matching connection */
  actionUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of location across the matching connection */
  location?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notificationMessage across the matching connection */
  notificationMessage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of scope across the matching connection */
  scope?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of severity across the matching connection */
  severity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of slug across the matching connection */
  slug?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of templateExpiresAt across the matching connection */
  templateExpiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ImpactGroupTemplate` edge in the connection. */
export type ImpactGroupTemplateEdge = {
  __typename?: 'ImpactGroupTemplateEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ImpactGroupTemplate` at the end of the edge. */
  node?: Maybe<ImpactGroupTemplate>;
};

/** A filter to be used against `ImpactGroupTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ImpactGroupTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ImpactGroupTemplateFilter>>;
  /** Filter by the object’s `createdByUser` relation. */
  createdByUser?: InputMaybe<UserFilter>;
  /** A related `createdByUser` exists. */
  createdByUserExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `impactGroupAssignments` relation. */
  impactGroupAssignments?: InputMaybe<ImpactGroupTemplateToManyImpactGroupAssignmentFilter>;
  /** Some related `impactGroupAssignments` exist. */
  impactGroupAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ImpactGroupTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ImpactGroupTemplateFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scope` field. */
  scope?: InputMaybe<StringFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedByUser` relation. */
  updatedByUser?: InputMaybe<UserFilter>;
  /** A related `updatedByUser` exists. */
  updatedByUserExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `ImpactGroupTemplate` for usage during aggregation. */
export enum ImpactGroupTemplateGroupBy {
  Label = 'LABEL',
  Scope = 'SCOPE'
}

export type ImpactGroupTemplateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `ImpactGroupTemplate` aggregates. */
export type ImpactGroupTemplateHavingInput = {
  AND?: InputMaybe<Array<ImpactGroupTemplateHavingInput>>;
  OR?: InputMaybe<Array<ImpactGroupTemplateHavingInput>>;
  average?: InputMaybe<ImpactGroupTemplateHavingAverageInput>;
  distinctCount?: InputMaybe<ImpactGroupTemplateHavingDistinctCountInput>;
  max?: InputMaybe<ImpactGroupTemplateHavingMaxInput>;
  min?: InputMaybe<ImpactGroupTemplateHavingMinInput>;
  stddevPopulation?: InputMaybe<ImpactGroupTemplateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ImpactGroupTemplateHavingStddevSampleInput>;
  sum?: InputMaybe<ImpactGroupTemplateHavingSumInput>;
  variancePopulation?: InputMaybe<ImpactGroupTemplateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ImpactGroupTemplateHavingVarianceSampleInput>;
};

export type ImpactGroupTemplateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

export type ImpactGroupTemplateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  templateExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedBy?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `ImpactGroupTemplate` */
export type ImpactGroupTemplateInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  notificationMessage?: InputMaybe<Scalars['String']['input']>;
  scope: Scalars['String']['input'];
  severity?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  templateExpiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ImpactGroupTemplateMaxAggregates = {
  __typename?: 'ImpactGroupTemplateMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ImpactGroupTemplateMinAggregates = {
  __typename?: 'ImpactGroupTemplateMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ImpactGroupTemplate`. */
export enum ImpactGroupTemplateOrderBy {
  ImpactGroupAssignmentsAverageImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsAverageImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsAverageRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_ROW_ID_ASC',
  ImpactGroupAssignmentsAverageRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_ROW_ID_DESC',
  ImpactGroupAssignmentsCountAsc = 'IMPACT_GROUP_ASSIGNMENTS_COUNT_ASC',
  ImpactGroupAssignmentsCountDesc = 'IMPACT_GROUP_ASSIGNMENTS_COUNT_DESC',
  ImpactGroupAssignmentsDistinctCountImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsDistinctCountImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsDistinctCountRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_ASC',
  ImpactGroupAssignmentsDistinctCountRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_DESC',
  ImpactGroupAssignmentsMaxImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsMaxImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsMaxRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_ROW_ID_ASC',
  ImpactGroupAssignmentsMaxRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_ROW_ID_DESC',
  ImpactGroupAssignmentsMinImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsMinImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsMinRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_ROW_ID_ASC',
  ImpactGroupAssignmentsMinRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_ROW_ID_DESC',
  ImpactGroupAssignmentsStddevPopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsStddevPopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsStddevPopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsStddevPopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsStddevSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsStddevSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsStddevSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsStddevSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  ImpactGroupAssignmentsSumImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsSumImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsSumRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_ROW_ID_ASC',
  ImpactGroupAssignmentsSumRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_ROW_ID_DESC',
  ImpactGroupAssignmentsVariancePopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsVariancePopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsVariancePopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsVariancePopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsVarianceSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsVarianceSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsVarianceSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsVarianceSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  ScopeAsc = 'SCOPE_ASC',
  ScopeDesc = 'SCOPE_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

/** Represents an update to a `ImpactGroupTemplate`. Fields that are set will be updated. */
export type ImpactGroupTemplatePatch = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notificationMessage?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  templateExpiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ImpactGroupTemplateStddevPopulationAggregates = {
  __typename?: 'ImpactGroupTemplateStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupTemplateStddevSampleAggregates = {
  __typename?: 'ImpactGroupTemplateStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupTemplateSumAggregates = {
  __typename?: 'ImpactGroupTemplateSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

/** A filter to be used against many `ImpactGroupAssignment` object types. All fields are combined with a logical ‘and.’ */
export type ImpactGroupTemplateToManyImpactGroupAssignmentFilter = {
  /** Aggregates across related `ImpactGroupAssignment` match the filter criteria. */
  aggregates?: InputMaybe<ImpactGroupAssignmentAggregatesFilter>;
  /** Every related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** No related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** Some related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ImpactGroupAssignmentFilter>;
};

export type ImpactGroupTemplateVariancePopulationAggregates = {
  __typename?: 'ImpactGroupTemplateVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ImpactGroupTemplateVarianceSampleAggregates = {
  __typename?: 'ImpactGroupTemplateVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type InitiateAdminPayoutRequestInput = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Int']['input'];
};

export type InitiateAdminPayoutRequestPayload = {
  __typename?: 'InitiateAdminPayoutRequestPayload';
  adminInitiated: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  payoutRequestId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']['output']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']['output']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']['output']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']['output']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for invalidating tax forms via event log */
export type InvalidateUserTaxFormEventLogInput = {
  /**
   * Lowers the 50-form ceiling for this call. A larger value is clamped to 50;
   * the ceiling cannot be raised.
   */
  maxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  /** Reason for invalidation (applies to all forms) */
  reason: Scalars['String']['input'];
  /**
   * UserTaxForm IDs to invalidate. Duplicates are ignored, and the ceiling applies to
   * the unique ids: at most 50, or fewer when maxBatchSize lowers it.
   */
  userTaxFormIds: Array<Scalars['Int']['input']>;
};

/** Result of invalidating tax forms via event log */
export type InvalidateUserTaxFormEventLogResult = {
  __typename?: 'InvalidateUserTaxFormEventLogResult';
  /**
   * Voided forms whose active TIN validation bypass was revoked with them. The bypass must
   * be granted again on the trader's next form if it is still needed.
   */
  bypassRevokedIds: Array<Scalars['Int']['output']>;
  /**
   * Number of forms given a new invalidation event. Zero on a pure repair, where every
   * form in the batch already carried one; read voidedCount and repairedIds for that case.
   */
  invalidatedCount: Scalars['Int']['output'];
  /** Status message */
  message: Scalars['String']['output'];
  /** Forms that already carried an invalidation event and were still Pending, now voided */
  repairedIds: Array<Scalars['Int']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Number of Pending forms set to Voided, releasing the tuple for a fresh form */
  voidedCount: Scalars['Int']['output'];
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type KycPriorityLabel = Node & {
  __typename?: 'KycPriorityLabel';
  category: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `KycPriorityReviewConfigLabel`. */
  kycPriorityReviewConfigLabels: KycPriorityReviewConfigLabelConnection;
  label: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  type: KycPriorityTypeEnum;
  updatedAt: Scalars['Datetime']['output'];
};


export type KycPriorityLabelKycPriorityReviewConfigLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<KycPriorityReviewConfigLabelCondition>;
  filter?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KycPriorityReviewConfigLabelOrderBy>>;
};

export type KycPriorityLabelAggregates = {
  __typename?: 'KycPriorityLabelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<KycPriorityLabelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<KycPriorityLabelDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<KycPriorityLabelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<KycPriorityLabelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<KycPriorityLabelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<KycPriorityLabelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<KycPriorityLabelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<KycPriorityLabelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<KycPriorityLabelVarianceSampleAggregates>;
};

export type KycPriorityLabelAverageAggregates = {
  __typename?: 'KycPriorityLabelAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `KycPriorityLabel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type KycPriorityLabelCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<KycPriorityTypeEnum>;
};

/** A connection to a list of `KycPriorityLabel` values. */
export type KycPriorityLabelConnection = {
  __typename?: 'KycPriorityLabelConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<KycPriorityLabelAggregates>;
  /** A list of edges which contains the `KycPriorityLabel` and cursor to aid in pagination. */
  edges: Array<Maybe<KycPriorityLabelEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<KycPriorityLabelAggregates>>;
  /** A list of `KycPriorityLabel` objects. */
  nodes: Array<Maybe<KycPriorityLabel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `KycPriorityLabel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `KycPriorityLabel` values. */
export type KycPriorityLabelConnectionGroupedAggregatesArgs = {
  groupBy: Array<KycPriorityLabelGroupBy>;
  having?: InputMaybe<KycPriorityLabelHavingInput>;
};

export type KycPriorityLabelDistinctCountAggregates = {
  __typename?: 'KycPriorityLabelDistinctCountAggregates';
  /** Distinct count of category across the matching connection */
  category?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of displayName across the matching connection */
  displayName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `KycPriorityLabel` edge in the connection. */
export type KycPriorityLabelEdge = {
  __typename?: 'KycPriorityLabelEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `KycPriorityLabel` at the end of the edge. */
  node?: Maybe<KycPriorityLabel>;
};

/** A filter to be used against `KycPriorityLabel` object types. All fields are combined with a logical ‘and.’ */
export type KycPriorityLabelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<KycPriorityLabelFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `kycPriorityReviewConfigLabels` relation. */
  kycPriorityReviewConfigLabels?: InputMaybe<KycPriorityLabelToManyKycPriorityReviewConfigLabelFilter>;
  /** Some related `kycPriorityReviewConfigLabels` exist. */
  kycPriorityReviewConfigLabelsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<KycPriorityLabelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<KycPriorityLabelFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<KycPriorityTypeEnumFilter>;
};

/** Grouping methods for `KycPriorityLabel` for usage during aggregation. */
export enum KycPriorityLabelGroupBy {
  Category = 'CATEGORY',
  Label = 'LABEL',
  Type = 'TYPE'
}

export type KycPriorityLabelHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `KycPriorityLabel` aggregates. */
export type KycPriorityLabelHavingInput = {
  AND?: InputMaybe<Array<KycPriorityLabelHavingInput>>;
  OR?: InputMaybe<Array<KycPriorityLabelHavingInput>>;
  average?: InputMaybe<KycPriorityLabelHavingAverageInput>;
  distinctCount?: InputMaybe<KycPriorityLabelHavingDistinctCountInput>;
  max?: InputMaybe<KycPriorityLabelHavingMaxInput>;
  min?: InputMaybe<KycPriorityLabelHavingMinInput>;
  stddevPopulation?: InputMaybe<KycPriorityLabelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<KycPriorityLabelHavingStddevSampleInput>;
  sum?: InputMaybe<KycPriorityLabelHavingSumInput>;
  variancePopulation?: InputMaybe<KycPriorityLabelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<KycPriorityLabelHavingVarianceSampleInput>;
};

export type KycPriorityLabelHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type KycPriorityLabelHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `KycPriorityLabel` */
export type KycPriorityLabelInput = {
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  label: Scalars['String']['input'];
  type: KycPriorityTypeEnum;
};

export type KycPriorityLabelMaxAggregates = {
  __typename?: 'KycPriorityLabelMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type KycPriorityLabelMinAggregates = {
  __typename?: 'KycPriorityLabelMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `KycPriorityLabel`. */
export enum KycPriorityLabelOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  KycPriorityReviewConfigLabelsAverageKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsAverageKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsAverageKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsAverageKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsAverageRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsAverageRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsCountAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_COUNT_ASC',
  KycPriorityReviewConfigLabelsCountDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_COUNT_DESC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsDistinctCountRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsDistinctCountRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsMaxKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsMaxKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsMaxKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsMaxKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsMaxRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsMaxRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsMinKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsMinKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsMinKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsMinKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsMinRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsMinRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsStddevPopulationRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsStddevPopulationRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsStddevSampleRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsStddevSampleRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsSumKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsSumKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsSumKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsSumKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsSumRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsSumRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsVariancePopulationRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsVariancePopulationRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsVarianceSampleRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsVarianceSampleRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_ROW_ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

/** Represents an update to a `KycPriorityLabel`. Fields that are set will be updated. */
export type KycPriorityLabelPatch = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type KycPriorityLabelStddevPopulationAggregates = {
  __typename?: 'KycPriorityLabelStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityLabelStddevSampleAggregates = {
  __typename?: 'KycPriorityLabelStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityLabelSumAggregates = {
  __typename?: 'KycPriorityLabelSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `KycPriorityReviewConfigLabel` object types. All fields are combined with a logical ‘and.’ */
export type KycPriorityLabelToManyKycPriorityReviewConfigLabelFilter = {
  /** Aggregates across related `KycPriorityReviewConfigLabel` match the filter criteria. */
  aggregates?: InputMaybe<KycPriorityReviewConfigLabelAggregatesFilter>;
  /** Every related `KycPriorityReviewConfigLabel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  /** No related `KycPriorityReviewConfigLabel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  /** Some related `KycPriorityReviewConfigLabel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
};

export type KycPriorityLabelVariancePopulationAggregates = {
  __typename?: 'KycPriorityLabelVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityLabelVarianceSampleAggregates = {
  __typename?: 'KycPriorityLabelVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfig = Node & {
  __typename?: 'KycPriorityReviewConfig';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `KycPriorityReviewConfigLabel`. */
  kycPriorityReviewConfigLabels: KycPriorityReviewConfigLabelConnection;
  rowId: Scalars['Int']['output'];
  savedByUserId: Scalars['Int']['output'];
  type: KycPriorityTypeEnum;
};


export type KycPriorityReviewConfigKycPriorityReviewConfigLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<KycPriorityReviewConfigLabelCondition>;
  filter?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KycPriorityReviewConfigLabelOrderBy>>;
};

export type KycPriorityReviewConfigAggregates = {
  __typename?: 'KycPriorityReviewConfigAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<KycPriorityReviewConfigAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<KycPriorityReviewConfigDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<KycPriorityReviewConfigMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<KycPriorityReviewConfigMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<KycPriorityReviewConfigStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<KycPriorityReviewConfigStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<KycPriorityReviewConfigSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<KycPriorityReviewConfigVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<KycPriorityReviewConfigVarianceSampleAggregates>;
};

export type KycPriorityReviewConfigAverageAggregates = {
  __typename?: 'KycPriorityReviewConfigAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `KycPriorityReviewConfig` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type KycPriorityReviewConfigCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<KycPriorityTypeEnum>;
};

/** A connection to a list of `KycPriorityReviewConfig` values. */
export type KycPriorityReviewConfigConnection = {
  __typename?: 'KycPriorityReviewConfigConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<KycPriorityReviewConfigAggregates>;
  /** A list of edges which contains the `KycPriorityReviewConfig` and cursor to aid in pagination. */
  edges: Array<Maybe<KycPriorityReviewConfigEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<KycPriorityReviewConfigAggregates>>;
  /** A list of `KycPriorityReviewConfig` objects. */
  nodes: Array<Maybe<KycPriorityReviewConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `KycPriorityReviewConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `KycPriorityReviewConfig` values. */
export type KycPriorityReviewConfigConnectionGroupedAggregatesArgs = {
  groupBy: Array<KycPriorityReviewConfigGroupBy>;
  having?: InputMaybe<KycPriorityReviewConfigHavingInput>;
};

export type KycPriorityReviewConfigDistinctCountAggregates = {
  __typename?: 'KycPriorityReviewConfigDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A `KycPriorityReviewConfig` edge in the connection. */
export type KycPriorityReviewConfigEdge = {
  __typename?: 'KycPriorityReviewConfigEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `KycPriorityReviewConfig` at the end of the edge. */
  node?: Maybe<KycPriorityReviewConfig>;
};

/** A filter to be used against `KycPriorityReviewConfig` object types. All fields are combined with a logical ‘and.’ */
export type KycPriorityReviewConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<KycPriorityReviewConfigFilter>>;
  /** Filter by the object’s `kycPriorityReviewConfigLabels` relation. */
  kycPriorityReviewConfigLabels?: InputMaybe<KycPriorityReviewConfigToManyKycPriorityReviewConfigLabelFilter>;
  /** Some related `kycPriorityReviewConfigLabels` exist. */
  kycPriorityReviewConfigLabelsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<KycPriorityReviewConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<KycPriorityReviewConfigFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<KycPriorityTypeEnumFilter>;
};

/** Grouping methods for `KycPriorityReviewConfig` for usage during aggregation. */
export enum KycPriorityReviewConfigGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR'
}

export type KycPriorityReviewConfigHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `KycPriorityReviewConfig` aggregates. */
export type KycPriorityReviewConfigHavingInput = {
  AND?: InputMaybe<Array<KycPriorityReviewConfigHavingInput>>;
  OR?: InputMaybe<Array<KycPriorityReviewConfigHavingInput>>;
  average?: InputMaybe<KycPriorityReviewConfigHavingAverageInput>;
  distinctCount?: InputMaybe<KycPriorityReviewConfigHavingDistinctCountInput>;
  max?: InputMaybe<KycPriorityReviewConfigHavingMaxInput>;
  min?: InputMaybe<KycPriorityReviewConfigHavingMinInput>;
  stddevPopulation?: InputMaybe<KycPriorityReviewConfigHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<KycPriorityReviewConfigHavingStddevSampleInput>;
  sum?: InputMaybe<KycPriorityReviewConfigHavingSumInput>;
  variancePopulation?: InputMaybe<KycPriorityReviewConfigHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<KycPriorityReviewConfigHavingVarianceSampleInput>;
};

export type KycPriorityReviewConfigHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedByUserId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabel = Node & {
  __typename?: 'KycPriorityReviewConfigLabel';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `KycPriorityLabel` that is related to this `KycPriorityReviewConfigLabel`. */
  kycPriorityLabel?: Maybe<KycPriorityLabel>;
  kycPriorityLabelId: Scalars['Int']['output'];
  /** Reads a single `KycPriorityReviewConfig` that is related to this `KycPriorityReviewConfigLabel`. */
  kycPriorityReviewConfig?: Maybe<KycPriorityReviewConfig>;
  kycPriorityReviewConfigId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
};

export type KycPriorityReviewConfigLabelAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<KycPriorityReviewConfigLabelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<KycPriorityReviewConfigLabelDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<KycPriorityReviewConfigLabelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<KycPriorityReviewConfigLabelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<KycPriorityReviewConfigLabelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<KycPriorityReviewConfigLabelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<KycPriorityReviewConfigLabelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<KycPriorityReviewConfigLabelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<KycPriorityReviewConfigLabelVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `KycPriorityReviewConfigLabel` object types. */
export type KycPriorityReviewConfigLabelAggregatesFilter = {
  /** Mean average aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  average?: InputMaybe<KycPriorityReviewConfigLabelAverageAggregateFilter>;
  /** Distinct count aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  distinctCount?: InputMaybe<KycPriorityReviewConfigLabelDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `KycPriorityReviewConfigLabel` object to be included within the aggregate. */
  filter?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  /** Maximum aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  max?: InputMaybe<KycPriorityReviewConfigLabelMaxAggregateFilter>;
  /** Minimum aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  min?: InputMaybe<KycPriorityReviewConfigLabelMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  stddevPopulation?: InputMaybe<KycPriorityReviewConfigLabelStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  stddevSample?: InputMaybe<KycPriorityReviewConfigLabelStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  sum?: InputMaybe<KycPriorityReviewConfigLabelSumAggregateFilter>;
  /** Population variance aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  variancePopulation?: InputMaybe<KycPriorityReviewConfigLabelVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `KycPriorityReviewConfigLabel` objects. */
  varianceSample?: InputMaybe<KycPriorityReviewConfigLabelVarianceSampleAggregateFilter>;
};

export type KycPriorityReviewConfigLabelAverageAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigFloatFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type KycPriorityReviewConfigLabelAverageAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelAverageAggregates';
  /** Mean average of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `KycPriorityReviewConfigLabel` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type KycPriorityReviewConfigLabelCondition = {
  /** Checks for equality with the object’s `kycPriorityLabelId` field. */
  kycPriorityLabelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `kycPriorityReviewConfigId` field. */
  kycPriorityReviewConfigId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `KycPriorityReviewConfigLabel` values. */
export type KycPriorityReviewConfigLabelConnection = {
  __typename?: 'KycPriorityReviewConfigLabelConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<KycPriorityReviewConfigLabelAggregates>;
  /** A list of edges which contains the `KycPriorityReviewConfigLabel` and cursor to aid in pagination. */
  edges: Array<Maybe<KycPriorityReviewConfigLabelEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<KycPriorityReviewConfigLabelAggregates>>;
  /** A list of `KycPriorityReviewConfigLabel` objects. */
  nodes: Array<Maybe<KycPriorityReviewConfigLabel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `KycPriorityReviewConfigLabel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `KycPriorityReviewConfigLabel` values. */
export type KycPriorityReviewConfigLabelConnectionGroupedAggregatesArgs = {
  groupBy: Array<KycPriorityReviewConfigLabelGroupBy>;
  having?: InputMaybe<KycPriorityReviewConfigLabelHavingInput>;
};

export type KycPriorityReviewConfigLabelDistinctCountAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type KycPriorityReviewConfigLabelDistinctCountAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelDistinctCountAggregates';
  /** Distinct count of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `KycPriorityReviewConfigLabel` edge in the connection. */
export type KycPriorityReviewConfigLabelEdge = {
  __typename?: 'KycPriorityReviewConfigLabelEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `KycPriorityReviewConfigLabel` at the end of the edge. */
  node?: Maybe<KycPriorityReviewConfigLabel>;
};

/** A filter to be used against `KycPriorityReviewConfigLabel` object types. All fields are combined with a logical ‘and.’ */
export type KycPriorityReviewConfigLabelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<KycPriorityReviewConfigLabelFilter>>;
  /** Filter by the object’s `kycPriorityLabel` relation. */
  kycPriorityLabel?: InputMaybe<KycPriorityLabelFilter>;
  /** Filter by the object’s `kycPriorityLabelId` field. */
  kycPriorityLabelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `kycPriorityReviewConfig` relation. */
  kycPriorityReviewConfig?: InputMaybe<KycPriorityReviewConfigFilter>;
  /** Filter by the object’s `kycPriorityReviewConfigId` field. */
  kycPriorityReviewConfigId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<KycPriorityReviewConfigLabelFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `KycPriorityReviewConfigLabel` for usage during aggregation. */
export enum KycPriorityReviewConfigLabelGroupBy {
  KycPriorityLabelId = 'KYC_PRIORITY_LABEL_ID',
  KycPriorityReviewConfigId = 'KYC_PRIORITY_REVIEW_CONFIG_ID'
}

export type KycPriorityReviewConfigLabelHavingAverageInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingDistinctCountInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `KycPriorityReviewConfigLabel` aggregates. */
export type KycPriorityReviewConfigLabelHavingInput = {
  AND?: InputMaybe<Array<KycPriorityReviewConfigLabelHavingInput>>;
  OR?: InputMaybe<Array<KycPriorityReviewConfigLabelHavingInput>>;
  average?: InputMaybe<KycPriorityReviewConfigLabelHavingAverageInput>;
  distinctCount?: InputMaybe<KycPriorityReviewConfigLabelHavingDistinctCountInput>;
  max?: InputMaybe<KycPriorityReviewConfigLabelHavingMaxInput>;
  min?: InputMaybe<KycPriorityReviewConfigLabelHavingMinInput>;
  stddevPopulation?: InputMaybe<KycPriorityReviewConfigLabelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<KycPriorityReviewConfigLabelHavingStddevSampleInput>;
  sum?: InputMaybe<KycPriorityReviewConfigLabelHavingSumInput>;
  variancePopulation?: InputMaybe<KycPriorityReviewConfigLabelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<KycPriorityReviewConfigLabelHavingVarianceSampleInput>;
};

export type KycPriorityReviewConfigLabelHavingMaxInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingMinInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingStddevPopulationInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingStddevSampleInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingSumInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingVariancePopulationInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelHavingVarianceSampleInput = {
  kycPriorityLabelId?: InputMaybe<HavingIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type KycPriorityReviewConfigLabelMaxAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<IntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type KycPriorityReviewConfigLabelMaxAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelMaxAggregates';
  /** Maximum of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type KycPriorityReviewConfigLabelMinAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<IntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type KycPriorityReviewConfigLabelMinAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelMinAggregates';
  /** Minimum of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `KycPriorityReviewConfigLabel`. */
export enum KycPriorityReviewConfigLabelOrderBy {
  KycPriorityLabelIdAsc = 'KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityLabelIdDesc = 'KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type KycPriorityReviewConfigLabelStddevPopulationAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigFloatFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type KycPriorityReviewConfigLabelStddevPopulationAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelStddevPopulationAggregates';
  /** Population standard deviation of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigLabelStddevSampleAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigFloatFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type KycPriorityReviewConfigLabelStddevSampleAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelStddevSampleAggregates';
  /** Sample standard deviation of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigLabelSumAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigIntFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type KycPriorityReviewConfigLabelSumAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelSumAggregates';
  /** Sum of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId: Scalars['BigInt']['output'];
  /** Sum of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type KycPriorityReviewConfigLabelVariancePopulationAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigFloatFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type KycPriorityReviewConfigLabelVariancePopulationAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelVariancePopulationAggregates';
  /** Population variance of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigLabelVarianceSampleAggregateFilter = {
  kycPriorityLabelId?: InputMaybe<BigFloatFilter>;
  kycPriorityReviewConfigId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type KycPriorityReviewConfigLabelVarianceSampleAggregates = {
  __typename?: 'KycPriorityReviewConfigLabelVarianceSampleAggregates';
  /** Sample variance of kycPriorityLabelId across the matching connection */
  kycPriorityLabelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of kycPriorityReviewConfigId across the matching connection */
  kycPriorityReviewConfigId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigMaxAggregates = {
  __typename?: 'KycPriorityReviewConfigMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['Int']['output']>;
};

export type KycPriorityReviewConfigMinAggregates = {
  __typename?: 'KycPriorityReviewConfigMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `KycPriorityReviewConfig`. */
export enum KycPriorityReviewConfigOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  KycPriorityReviewConfigLabelsAverageKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsAverageKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsAverageKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsAverageKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsAverageRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsAverageRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_AVERAGE_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsCountAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_COUNT_ASC',
  KycPriorityReviewConfigLabelsCountDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_COUNT_DESC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsDistinctCountKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsDistinctCountRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsDistinctCountRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_DISTINCT_COUNT_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsMaxKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsMaxKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsMaxKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsMaxKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsMaxRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsMaxRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MAX_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsMinKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsMinKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsMinKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsMinKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsMinRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsMinRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_MIN_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsStddevPopulationKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsStddevPopulationRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsStddevPopulationRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_POPULATION_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsStddevSampleKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsStddevSampleRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsStddevSampleRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_STDDEV_SAMPLE_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsSumKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsSumKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsSumKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsSumKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsSumRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsSumRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_SUM_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsVariancePopulationKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsVariancePopulationRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsVariancePopulationRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_POPULATION_ROW_ID_DESC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityLabelIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_LABEL_ID_ASC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityLabelIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_LABEL_ID_DESC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityReviewConfigIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_ASC',
  KycPriorityReviewConfigLabelsVarianceSampleKycPriorityReviewConfigIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_KYC_PRIORITY_REVIEW_CONFIG_ID_DESC',
  KycPriorityReviewConfigLabelsVarianceSampleRowIdAsc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_ROW_ID_ASC',
  KycPriorityReviewConfigLabelsVarianceSampleRowIdDesc = 'KYC_PRIORITY_REVIEW_CONFIG_LABELS_VARIANCE_SAMPLE_ROW_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type KycPriorityReviewConfigStddevPopulationAggregates = {
  __typename?: 'KycPriorityReviewConfigStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigStddevSampleAggregates = {
  __typename?: 'KycPriorityReviewConfigStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigSumAggregates = {
  __typename?: 'KycPriorityReviewConfigSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of savedByUserId across the matching connection */
  savedByUserId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `KycPriorityReviewConfigLabel` object types. All fields are combined with a logical ‘and.’ */
export type KycPriorityReviewConfigToManyKycPriorityReviewConfigLabelFilter = {
  /** Aggregates across related `KycPriorityReviewConfigLabel` match the filter criteria. */
  aggregates?: InputMaybe<KycPriorityReviewConfigLabelAggregatesFilter>;
  /** Every related `KycPriorityReviewConfigLabel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  /** No related `KycPriorityReviewConfigLabel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
  /** Some related `KycPriorityReviewConfigLabel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<KycPriorityReviewConfigLabelFilter>;
};

export type KycPriorityReviewConfigVariancePopulationAggregates = {
  __typename?: 'KycPriorityReviewConfigVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export type KycPriorityReviewConfigVarianceSampleAggregates = {
  __typename?: 'KycPriorityReviewConfigVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of savedByUserId across the matching connection */
  savedByUserId?: Maybe<Scalars['BigFloat']['output']>;
};

export enum KycPriorityTypeEnum {
  Cs = 'CS',
  Rf = 'RF'
}

/** A filter to be used against KycPriorityTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type KycPriorityTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<KycPriorityTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<KycPriorityTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<KycPriorityTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<KycPriorityTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<KycPriorityTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<KycPriorityTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<KycPriorityTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<KycPriorityTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<KycPriorityTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<KycPriorityTypeEnum>>;
};

export type LfaSplashStatus = {
  __typename?: 'LfaSplashStatus';
  lfaSplashSeenAt?: Maybe<Scalars['String']['output']>;
  shouldShow: Scalars['Boolean']['output'];
};

export type LiteLlmBlockedTermCandidate = Node & {
  __typename?: 'LiteLlmBlockedTermCandidate';
  createdAt: Scalars['Datetime']['output'];
  firstSeenAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['Datetime']['output'];
  normalizedHandle: Scalars['String']['output'];
  occurrenceCount: Scalars['Int']['output'];
  proposedPrUrl?: Maybe<Scalars['String']['output']>;
  rawHandle: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  status: LitellmBlockedTermCandidateStatus;
  updatedAt: Scalars['Datetime']['output'];
};

export enum LitellmBlockedTermCandidateStatus {
  Pending = 'pending',
  Promoted = 'promoted',
  Proposed = 'proposed',
  Rejected = 'rejected'
}

/** YouTube live streaming status for TopStepX channel */
export type LiveStreamStatus = {
  __typename?: 'LiveStreamStatus';
  /** Whether the channel is currently live streaming */
  isLive: Scalars['Boolean']['output'];
  /** URL to the YouTube channel. Returns /live URL when streaming, otherwise returns channel homepage */
  url: Scalars['String']['output'];
};

export type LiveTradePairing = Node & {
  __typename?: 'LiveTradePairing';
  accountId: Scalars['BigInt']['output'];
  closeAction: Scalars['Int']['output'];
  closePrice?: Maybe<Scalars['BigFloat']['output']>;
  closePriceOld?: Maybe<Scalars['BigFloat']['output']>;
  closeTimeStamp: Scalars['Datetime']['output'];
  closeTradeId: Scalars['BigInt']['output'];
  contractName: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  fees: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  openAction: Scalars['Int']['output'];
  openPrice?: Maybe<Scalars['BigFloat']['output']>;
  openPriceOld?: Maybe<Scalars['BigFloat']['output']>;
  openTimeStamp: Scalars['Datetime']['output'];
  openTradeId: Scalars['BigInt']['output'];
  pairedLots: Scalars['BigFloat']['output'];
  pnl: Scalars['BigFloat']['output'];
  rowId: Scalars['Int']['output'];
  tickSize?: Maybe<Scalars['BigFloat']['output']>;
  tickSizeOld?: Maybe<Scalars['BigFloat']['output']>;
  tickValue?: Maybe<Scalars['BigFloat']['output']>;
  tradeDay?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type MarkAsChargebackInput = {
  amountUsd: Scalars['String']['input'];
  chargebackDate?: InputMaybe<Scalars['String']['input']>;
  disputeId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  processor: ChargebackProcessor;
  purchaseOrderId: Scalars['Int']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type Migration = Node & {
  __typename?: 'Migration';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  timestamp: Scalars['BigInt']['output'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Append a note to a case ban. Admin only. */
  addCaseBanNote: CaseBanEventResult;
  /** Add traders to an open case ban. Admin only. */
  addCaseBanTraders: Array<CaseBanTraderResult>;
  /** Append a note to a case investigation. Admin only. */
  addCaseInvestigationNote: CaseInvestigationEventResult;
  /** Add traders to an open case investigation. Admin only. */
  addCaseInvestigationTraders: Array<CaseInvestigationTraderResult>;
  /**
   * Bulk CSV import of SISU level unlocks and Octagon bonuses (LIVE-386).
   * Runs the same guards as createAccountCapitalEntry, one transaction per row.
   */
  bulkUploadAccountCapitalEntries?: Maybe<BulkCapitalUploadPayload>;
  /**
   * Enable TIN validation bypass for a user tax form.
   * Admin-only. Appends a bypass event to the form's eventLog.
   * The form will use a template without TIN validation on next signing.
   */
  bypassUserTaxFormValidation: BypassUserTaxFormValidationResult;
  /** Cancel an open case ban. Admin only. */
  cancelCaseBan: CaseBanResult;
  /** Cancel an open case investigation. Admin only. */
  cancelCaseInvestigation: CaseInvestigationResult;
  /** Close an open case ban. Admin only. */
  closeCaseBan: CaseBanResult;
  /** Close an open case investigation. Admin only. */
  closeCaseInvestigation: CaseInvestigationResult;
  correctAccountCapitalEntry?: Maybe<AccountCapitalMutationPayload>;
  createAccountCapitalEntry?: Maybe<AccountCapitalMutationPayload>;
  /** Open a new case ban. Admin only. */
  createCaseBan: CaseBanResult;
  /** Open a new case investigation. Admin only. */
  createCaseInvestigation: CaseInvestigationResult;
  /** Create a case type (admin-managed master data). Admin only. */
  createCaseType: CaseType;
  /** Creates a single `ImpactGroupAssignment`. */
  createImpactGroupAssignment?: Maybe<CreateImpactGroupAssignmentPayload>;
  /** Creates a single `ImpactGroupTemplate`. */
  createImpactGroupTemplate?: Maybe<CreateImpactGroupTemplatePayload>;
  /** Creates a single `KycPriorityLabel`. */
  createKycPriorityLabel?: Maybe<CreateKycPriorityLabelPayload>;
  createKycPriorityReviewConfig?: Maybe<CreateKycPriorityReviewConfigPayload>;
  /** Create a reason code (admin-managed master data). Admin only. */
  createReasonCode: ReasonCode;
  /** Creates a single `TraderRiskIndicator`. */
  createTraderRiskIndicator?: Maybe<CreateTraderRiskIndicatorPayload>;
  /** Creates a single `TradingProductFee`. */
  createTradingProductFee?: Maybe<CreateTradingProductFeePayload>;
  /** Creates a single `UserAddress`. */
  createUserAddress?: Maybe<CreateUserAddressPayload>;
  /** Creates a single `UserTaxForm`. */
  createUserTaxForm?: Maybe<CreateUserTaxFormPayload>;
  /** Creates a single `XfaActivationCredit`. */
  createXfaActivationCredit?: Maybe<CreateXfaActivationCreditPayload>;
  /** Deletes a single `ImpactGroupAssignment` using a unique key. */
  deleteImpactGroupAssignment?: Maybe<DeleteImpactGroupAssignmentPayload>;
  /** Deletes a single `ImpactGroupAssignment` using its globally unique id. */
  deleteImpactGroupAssignmentById?: Maybe<DeleteImpactGroupAssignmentPayload>;
  /** Deletes a single `KycPriorityLabel` using a unique key. */
  deleteKycPriorityLabel?: Maybe<DeleteKycPriorityLabelPayload>;
  /** Deletes a single `KycPriorityLabel` using its globally unique id. */
  deleteKycPriorityLabelById?: Maybe<DeleteKycPriorityLabelPayload>;
  /** Deletes a single `UserAddress` using a unique key. */
  deleteUserAddress?: Maybe<DeleteUserAddressPayload>;
  /** Deletes a single `UserAddress` using its globally unique id. */
  deleteUserAddressById?: Maybe<DeleteUserAddressPayload>;
  /** Deletes a single `XfaActivationCredit` using a unique key. */
  deleteXfaActivationCredit?: Maybe<DeleteXfaActivationCreditPayload>;
  /** Deletes a single `XfaActivationCredit` using its globally unique id. */
  deleteXfaActivationCreditById?: Maybe<DeleteXfaActivationCreditPayload>;
  getOrCreateUserTaxForm: GetOrCreateUserTaxFormResult;
  /** Put an open case ban on hold, pausing trader actions. Admin only. */
  holdCaseBan: CaseBanResult;
  /** Put an open case investigation on hold, pausing trader actions. Admin only. */
  holdCaseInvestigation: CaseInvestigationResult;
  initiateAdminPayoutRequest?: Maybe<InitiateAdminPayoutRequestPayload>;
  /**
   * Invalidate tax forms via event log (admin only).
   * Appends an invalidation event to the eventLog array, and sets status to Voided on the
   * forms that were Pending, which releases them so the trader can start a new form.
   * Completed, Declined and already-Voided forms keep their status. An active TIN
   * validation bypass on a form being voided is revoked in the same transaction.
   * Admin user ID is retrieved from authentication token.
   * All-or-nothing: if any form fails validation, none are invalidated.
   */
  invalidateUserTaxFormEventLog: InvalidateUserTaxFormEventLogResult;
  /**
   * Manually flag a transaction as charged back with the supplied chargeback
   * details. Idempotent per transaction. Admin only.
   */
  markAsChargeback: ChargebackResult;
  publishMyTraderPublicProfile: UpdateMyTraderPublicProfilePayload;
  recordLfaSplashView?: Maybe<RecordLfaSplashViewPayload>;
  recordReflectionView?: Maybe<RecordReflectionViewPayload>;
  /**
   * Remove traders from an open case ban. Cancels the case when no trader
   * remains. Admin only.
   */
  removeCaseBanTraders: CaseBanTradersRemovedResult;
  /**
   * Remove traders from an open case investigation. Cancels the case when no
   * trader remains. Admin only.
   */
  removeCaseInvestigationTraders: CaseInvestigationTradersRemovedResult;
  /** Resume a case ban that is on hold, back to open. Admin only. */
  resumeCaseBan: CaseBanResult;
  /** Resume a case investigation that is on hold, back to open. Admin only. */
  resumeCaseInvestigation: CaseInvestigationResult;
  /**
   * Revoke TIN validation bypass for a user tax form.
   * Admin-only. Voids the form and appends a revoke event to the form's eventLog.
   */
  revokeUserTaxFormValidationBypass: RevokeUserTaxFormValidationBypassResult;
  /** Set a decided pending status on traders in a case ban. Admin only. */
  setCaseBanPendingStatus: Array<CaseBanTraderResult>;
  /** Set or clear the IDV link on a trader in a case ban. Admin only. */
  setCaseBanTraderIdvLink: CaseBanTraderResult;
  /** Set or clear the Intercom link on a trader in a case ban. Admin only. */
  setCaseBanTraderIntercomLink: CaseBanTraderResult;
  /** Set a decided pending status on traders in a case investigation. Admin only. */
  setCaseInvestigationPendingStatus: Array<CaseInvestigationTraderResult>;
  /** Set or clear the IDV link on a trader in a case investigation. Admin only. */
  setCaseInvestigationTraderIdvLink: CaseInvestigationTraderResult;
  /** Set or clear the Intercom link on a trader in a case investigation. Admin only. */
  setCaseInvestigationTraderIntercomLink: CaseInvestigationTraderResult;
  /**
   * Start W-8BEN signing process for foreign persons.
   * Creates an envelope from the W-8BEN template with prefilled data and returns a signing URL.
   */
  startW8BENSigning: W8BenSigningResult;
  /**
   * Start W-9 signing process.
   * Creates an envelope from the W-9 template with prefilled data and returns a signing URL.
   */
  startW9Signing: W9SigningResult;
  /**
   * Atomically open a case ban and place its traders under ban review, in a
   * single transaction. Admin only.
   */
  submitCaseBan: CaseBanResult;
  /**
   * Sync Topstep Discord roles for the current user.
   *
   * - Requires the user to have a linked discordId (User.discordId).
   * - Roles mirror current standing: active accounts and subscription grant
   *   the tier roles, Paid Out is permanent once earned, and a user with no
   *   standing gets the Sidelined Trader role.
   */
  syncDiscordRoles: SyncDiscordRolesPayload;
  /** Unlink the current user's Discord account by clearing their discordId. */
  unlinkDiscord: UnlinkDiscordPayload;
  /** Remove a manual chargeback flag from a transaction. Admin only. */
  unmarkChargeback: ChargebackResult;
  unpublishMyTraderPublicProfile: UpdateMyTraderPublicProfilePayload;
  /** Reset traders in a case ban back to submitted for ban. Admin only. */
  unsetCaseBanPendingStatus: Array<CaseBanTraderResult>;
  /** Reset traders in a case investigation back to under investigation. Admin only. */
  unsetCaseInvestigationPendingStatus: Array<CaseInvestigationTraderResult>;
  /** Updates a single `AccountStat` using a unique key and a patch. */
  updateAccountStat?: Maybe<UpdateAccountStatPayload>;
  /** Updates a single `AccountStat` using its globally unique id and a patch. */
  updateAccountStatById?: Maybe<UpdateAccountStatPayload>;
  /** Updates a single `AdminConfig` using a unique key and a patch. */
  updateAdminConfig?: Maybe<UpdateAdminConfigPayload>;
  /** Updates a single `AdminConfig` using a unique key and a patch. */
  updateAdminConfigByConfigKey?: Maybe<UpdateAdminConfigPayload>;
  /** Updates a single `AdminConfig` using its globally unique id and a patch. */
  updateAdminConfigById?: Maybe<UpdateAdminConfigPayload>;
  /** Update an open case ban's editable fields. Admin only. */
  updateCaseBan: CaseBanResult;
  /** Update an open case investigation's editable fields. Admin only. */
  updateCaseInvestigation: CaseInvestigationResult;
  /** Updates a single `ImpactGroupAssignment` using a unique key and a patch. */
  updateImpactGroupAssignment?: Maybe<UpdateImpactGroupAssignmentPayload>;
  /** Updates a single `ImpactGroupAssignment` using its globally unique id and a patch. */
  updateImpactGroupAssignmentById?: Maybe<UpdateImpactGroupAssignmentPayload>;
  /** Updates a single `ImpactGroupTemplate` using a unique key and a patch. */
  updateImpactGroupTemplate?: Maybe<UpdateImpactGroupTemplatePayload>;
  /** Updates a single `ImpactGroupTemplate` using its globally unique id and a patch. */
  updateImpactGroupTemplateById?: Maybe<UpdateImpactGroupTemplatePayload>;
  /** Updates a single `ImpactGroupTemplate` using a unique key and a patch. */
  updateImpactGroupTemplateByLabelAndScope?: Maybe<UpdateImpactGroupTemplatePayload>;
  /** Updates a single `ImpactGroupTemplate` using a unique key and a patch. */
  updateImpactGroupTemplateBySlug?: Maybe<UpdateImpactGroupTemplatePayload>;
  /** Updates a single `KycPriorityLabel` using a unique key and a patch. */
  updateKycPriorityLabel?: Maybe<UpdateKycPriorityLabelPayload>;
  /** Updates a single `KycPriorityLabel` using its globally unique id and a patch. */
  updateKycPriorityLabelById?: Maybe<UpdateKycPriorityLabelPayload>;
  updateMyTraderPublicProfile: UpdateMyTraderPublicProfilePayload;
  /** Updates a single `TraderPublicProfile` using a unique key and a patch. */
  updateTraderPublicProfile?: Maybe<UpdateTraderPublicProfilePayload>;
  /** Updates a single `TraderPublicProfile` using its globally unique id and a patch. */
  updateTraderPublicProfileById?: Maybe<UpdateTraderPublicProfilePayload>;
  /** Updates a single `TraderRiskIndicator` using a unique key and a patch. */
  updateTraderRiskIndicator?: Maybe<UpdateTraderRiskIndicatorPayload>;
  /** Updates a single `TraderRiskIndicator` using its globally unique id and a patch. */
  updateTraderRiskIndicatorById?: Maybe<UpdateTraderRiskIndicatorPayload>;
  /** Updates a single `TradingProductFee` using a unique key and a patch. */
  updateTradingProductFee?: Maybe<UpdateTradingProductFeePayload>;
  /** Updates a single `TradingProductFee` using its globally unique id and a patch. */
  updateTradingProductFeeById?: Maybe<UpdateTradingProductFeePayload>;
  /** Updates a single `UserAddress` using a unique key and a patch. */
  updateUserAddress?: Maybe<UpdateUserAddressPayload>;
  /** Updates a single `UserAddress` using its globally unique id and a patch. */
  updateUserAddressById?: Maybe<UpdateUserAddressPayload>;
  /** Updates a single `UserTaxForm` using a unique key and a patch. */
  updateUserTaxForm?: Maybe<UpdateUserTaxFormPayload>;
  /** Updates a single `UserTaxForm` using its globally unique id and a patch. */
  updateUserTaxFormById?: Maybe<UpdateUserTaxFormPayload>;
  /** Updates a single `XfaActivationCredit` using a unique key and a patch. */
  updateXfaActivationCredit?: Maybe<UpdateXfaActivationCreditPayload>;
  /** Updates a single `XfaActivationCredit` using its globally unique id and a patch. */
  updateXfaActivationCreditById?: Maybe<UpdateXfaActivationCreditPayload>;
  voidAccountCapitalEntry?: Maybe<AccountCapitalMutationPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCaseBanNoteArgs = {
  input: AddCaseBanNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCaseBanTradersArgs = {
  input: CaseBanTradersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCaseInvestigationNoteArgs = {
  input: AddCaseInvestigationNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCaseInvestigationTradersArgs = {
  input: CaseInvestigationTradersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkUploadAccountCapitalEntriesArgs = {
  input: BulkCapitalUploadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBypassUserTaxFormValidationArgs = {
  input: BypassUserTaxFormValidationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelCaseBanArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelCaseInvestigationArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloseCaseBanArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloseCaseInvestigationArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCorrectAccountCapitalEntryArgs = {
  input: CorrectAccountCapitalEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountCapitalEntryArgs = {
  input: CreateAccountCapitalEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaseBanArgs = {
  input: CreateCaseBanInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaseInvestigationArgs = {
  input: CreateCaseInvestigationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaseTypeArgs = {
  input: CreateCaseTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateImpactGroupAssignmentArgs = {
  input: CreateImpactGroupAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateImpactGroupTemplateArgs = {
  input: CreateImpactGroupTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateKycPriorityLabelArgs = {
  input: CreateKycPriorityLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateKycPriorityReviewConfigArgs = {
  input: CreateKycPriorityReviewConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReasonCodeArgs = {
  input: CreateReasonCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTraderRiskIndicatorArgs = {
  input: CreateTraderRiskIndicatorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTradingProductFeeArgs = {
  input: CreateTradingProductFeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserAddressArgs = {
  input: CreateUserAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserTaxFormArgs = {
  input: CreateUserTaxFormInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateXfaActivationCreditArgs = {
  input: CreateXfaActivationCreditInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteImpactGroupAssignmentArgs = {
  input: DeleteImpactGroupAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteImpactGroupAssignmentByIdArgs = {
  input: DeleteImpactGroupAssignmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKycPriorityLabelArgs = {
  input: DeleteKycPriorityLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKycPriorityLabelByIdArgs = {
  input: DeleteKycPriorityLabelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserAddressArgs = {
  input: DeleteUserAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserAddressByIdArgs = {
  input: DeleteUserAddressByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteXfaActivationCreditArgs = {
  input: DeleteXfaActivationCreditInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteXfaActivationCreditByIdArgs = {
  input: DeleteXfaActivationCreditByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetOrCreateUserTaxFormArgs = {
  input: GetOrCreateUserTaxFormInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationHoldCaseBanArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationHoldCaseInvestigationArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateAdminPayoutRequestArgs = {
  input: InitiateAdminPayoutRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInvalidateUserTaxFormEventLogArgs = {
  input: InvalidateUserTaxFormEventLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkAsChargebackArgs = {
  input: MarkAsChargebackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRecordLfaSplashViewArgs = {
  input: RecordLfaSplashViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRecordReflectionViewArgs = {
  input: RecordReflectionViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveCaseBanTradersArgs = {
  input: CaseBanTradersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveCaseInvestigationTradersArgs = {
  input: CaseInvestigationTradersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResumeCaseBanArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResumeCaseInvestigationArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeUserTaxFormValidationBypassArgs = {
  input: RevokeUserTaxFormValidationBypassInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCaseBanPendingStatusArgs = {
  input: SetCaseBanPendingStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCaseBanTraderIdvLinkArgs = {
  input: SetCaseBanTraderIdvLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCaseBanTraderIntercomLinkArgs = {
  input: SetCaseBanTraderIntercomLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCaseInvestigationPendingStatusArgs = {
  input: SetCaseInvestigationPendingStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCaseInvestigationTraderIdvLinkArgs = {
  input: SetCaseInvestigationTraderIdvLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCaseInvestigationTraderIntercomLinkArgs = {
  input: SetCaseInvestigationTraderIntercomLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartW8BenSigningArgs = {
  input: StartW8BenSigningInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartW9SigningArgs = {
  input: StartW9SigningInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubmitCaseBanArgs = {
  input: SubmitCaseBanInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnmarkChargebackArgs = {
  purchaseOrderId: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnsetCaseBanPendingStatusArgs = {
  input: UnsetCaseBanPendingStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnsetCaseInvestigationPendingStatusArgs = {
  input: UnsetCaseInvestigationPendingStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountStatArgs = {
  input: UpdateAccountStatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountStatByIdArgs = {
  input: UpdateAccountStatByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAdminConfigArgs = {
  input: UpdateAdminConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAdminConfigByConfigKeyArgs = {
  input: UpdateAdminConfigByConfigKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAdminConfigByIdArgs = {
  input: UpdateAdminConfigByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseBanArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCaseBanInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseInvestigationArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCaseInvestigationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImpactGroupAssignmentArgs = {
  input: UpdateImpactGroupAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImpactGroupAssignmentByIdArgs = {
  input: UpdateImpactGroupAssignmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImpactGroupTemplateArgs = {
  input: UpdateImpactGroupTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImpactGroupTemplateByIdArgs = {
  input: UpdateImpactGroupTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImpactGroupTemplateByLabelAndScopeArgs = {
  input: UpdateImpactGroupTemplateByLabelAndScopeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImpactGroupTemplateBySlugArgs = {
  input: UpdateImpactGroupTemplateBySlugInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKycPriorityLabelArgs = {
  input: UpdateKycPriorityLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKycPriorityLabelByIdArgs = {
  input: UpdateKycPriorityLabelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMyTraderPublicProfileArgs = {
  input: UpdateMyTraderPublicProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraderPublicProfileArgs = {
  input: UpdateTraderPublicProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraderPublicProfileByIdArgs = {
  input: UpdateTraderPublicProfileByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraderRiskIndicatorArgs = {
  input: UpdateTraderRiskIndicatorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraderRiskIndicatorByIdArgs = {
  input: UpdateTraderRiskIndicatorByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTradingProductFeeArgs = {
  input: UpdateTradingProductFeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTradingProductFeeByIdArgs = {
  input: UpdateTradingProductFeeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserAddressArgs = {
  input: UpdateUserAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserAddressByIdArgs = {
  input: UpdateUserAddressByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserTaxFormArgs = {
  input: UpdateUserTaxFormInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserTaxFormByIdArgs = {
  input: UpdateUserTaxFormByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateXfaActivationCreditArgs = {
  input: UpdateXfaActivationCreditInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateXfaActivationCreditByIdArgs = {
  input: UpdateXfaActivationCreditByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVoidAccountCapitalEntryArgs = {
  input: VoidAccountCapitalEntryInput;
};

/**
 * Diff between the trader's top-six PoP card selection and their existing
 * PayoutRequestAssets. Each list is exactly what the generation mutation
 * needs as input — no further filtering required on the client.
 */
export type MyMissingPopcards = {
  __typename?: 'MyMissingPopcards';
  /**
   * Total cards needing generation: `payouts.length + rollupGroups.length`.
   * Equals 0 when every top-six entry already has an asset.
   */
  missingCount: Scalars['Int']['output'];
  /**
   * Top-six individual payouts (PoP candidates) that have no
   * PayoutRequestAsset yet. Feed each into the individual-card generation
   * mutation.
   */
  payouts: Array<PopcardPayoutCandidate>;
  /**
   * Top-six rollup groups that have no PayoutRequestAsset yet. Feed each
   * group's payoutIds into the rollup-card generation mutation.
   */
  rollupGroups: Array<PopcardRollupGroup>;
  /**
   * Size of the trader's top-six selection. Smaller than 6 only when the
   * total candidate pool is smaller than 6. Useful for UI copy like "X of N
   * cards need to be generated".
   */
  topSixSize: Scalars['Int']['output'];
};

/**
 * Source data for the Trader Profile "All-Time Payouts" / "Proof of
 * Payouts" editor surface. The frontend selects the top six entries from
 * `payouts` ∪ `rollupGroups` by descending value and triggers card
 * generation for whichever entries do not already have an existingAssetId.
 */
export type MyPopcardCandidates = {
  __typename?: 'MyPopcardCandidates';
  /** Every paid PayoutRequest for the current user, ordered by amount desc. */
  payouts: Array<PopcardPayoutCandidate>;
  /** Every CT-date × type bucket with > 1 payout, ordered by totalAmount desc. */
  rollupGroups: Array<PopcardRollupGroup>;
};

export type MyTraderProfileAsset = {
  __typename?: 'MyTraderProfileAsset';
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type MyTraderPublicProfile = {
  __typename?: 'MyTraderPublicProfile';
  bannerImageAssetId?: Maybe<Scalars['Int']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  content?: Maybe<MyTraderPublicProfileContent>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  featuredAccountId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  profileImageAssetId?: Maybe<Scalars['Int']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  publicTraderId: Scalars['String']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referralCodeExpiresAt?: Maybe<Scalars['String']['output']>;
  showAllTimePayouts: Scalars['Boolean']['output'];
  showBannerOnPublicProfile: Scalars['Boolean']['output'];
  showProfileImageOnPublicProfile: Scalars['Boolean']['output'];
  showProfitCalendarOnPublicProfile: Scalars['Boolean']['output'];
  showProofOfPayouts: Scalars['Boolean']['output'];
  showReferralCode: Scalars['Boolean']['output'];
  showSocialConnections: Scalars['Boolean']['output'];
  showTradingJourney: Scalars['Boolean']['output'];
  showTradingStatsOnPublicProfile: Scalars['Boolean']['output'];
  userHandle?: Maybe<Scalars['String']['output']>;
};

export type MyTraderPublicProfileAllTimePayouts = {
  __typename?: 'MyTraderPublicProfileAllTimePayouts';
  bestPayout: Scalars['Float']['output'];
  numberOfPayouts: Scalars['Int']['output'];
  payoutsTotal: Scalars['Float']['output'];
};

export type MyTraderPublicProfileContent = {
  __typename?: 'MyTraderPublicProfileContent';
  allTimePayouts?: Maybe<MyTraderPublicProfileAllTimePayouts>;
  header?: Maybe<MyTraderPublicProfileHeader>;
  nowTrading?: Maybe<MyTraderPublicProfileNowTrading>;
  proofOfPayoutDisplayName: Scalars['String']['output'];
  proofOfPayouts?: Maybe<Array<MyTraderPublicProfileProofOfPayoutCard>>;
  socialConnections?: Maybe<MyTraderPublicProfileSocialConnections>;
  tradingJourney?: Maybe<MyTraderPublicProfileTradingJourney>;
  tradingStyle?: Maybe<MyTraderPublicProfileTradingStyle>;
};

export type MyTraderPublicProfileHeader = {
  __typename?: 'MyTraderPublicProfileHeader';
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  userHandle?: Maybe<Scalars['String']['output']>;
};

export type MyTraderPublicProfileNowTrading = {
  __typename?: 'MyTraderPublicProfileNowTrading';
  account: MyTraderPublicProfileNowTradingAccount;
  balanceSparkline?: Maybe<Array<MyTraderPublicProfileNowTradingSparklineDay>>;
  pnlSparkline?: Maybe<Array<MyTraderPublicProfileNowTradingSparklineDay>>;
  profitCalendar?: Maybe<MyTraderPublicProfileNowTradingProfitCalendar>;
  stats?: Maybe<MyTraderPublicProfileNowTradingStats>;
};

export type MyTraderPublicProfileNowTradingAccount = {
  __typename?: 'MyTraderPublicProfileNowTradingAccount';
  accountId: Scalars['Int']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  displayLabel: Scalars['String']['output'];
  size: Scalars['String']['output'];
  stage?: Maybe<Scalars['String']['output']>;
  typeLabel: Scalars['String']['output'];
};

export type MyTraderPublicProfileNowTradingCalendarDay = {
  __typename?: 'MyTraderPublicProfileNowTradingCalendarDay';
  day: Scalars['Int']['output'];
  isBestDay: Scalars['Boolean']['output'];
  isWorstDay: Scalars['Boolean']['output'];
  pnl: Scalars['Float']['output'];
  tradeCount: Scalars['Int']['output'];
};

export type MyTraderPublicProfileNowTradingCalendarWeek = {
  __typename?: 'MyTraderPublicProfileNowTradingCalendarWeek';
  pnl: Scalars['Float']['output'];
  tradeCount: Scalars['Int']['output'];
  weekIndex: Scalars['Int']['output'];
};

export type MyTraderPublicProfileNowTradingProfitCalendar = {
  __typename?: 'MyTraderPublicProfileNowTradingProfitCalendar';
  days: Array<MyTraderPublicProfileNowTradingCalendarDay>;
  month: Scalars['Int']['output'];
  weeks: Array<MyTraderPublicProfileNowTradingCalendarWeek>;
  year: Scalars['Int']['output'];
};

export type MyTraderPublicProfileNowTradingSparklineDay = {
  __typename?: 'MyTraderPublicProfileNowTradingSparklineDay';
  date: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MyTraderPublicProfileNowTradingStats = {
  __typename?: 'MyTraderPublicProfileNowTradingStats';
  averageLoss: Scalars['Float']['output'];
  averageWin: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  consistencyPercent?: Maybe<Scalars['Float']['output']>;
  pnl: Scalars['Float']['output'];
  startingBalance: Scalars['Float']['output'];
  tradeWinPercent: Scalars['Float']['output'];
};

export type MyTraderPublicProfileProofOfPayoutCard = {
  __typename?: 'MyTraderPublicProfileProofOfPayoutCard';
  accountType: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  displayImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type MyTraderPublicProfileSocialConnections = {
  __typename?: 'MyTraderPublicProfileSocialConnections';
  discordUsername?: Maybe<Scalars['String']['output']>;
};

export type MyTraderPublicProfileTradingJourney = {
  __typename?: 'MyTraderPublicProfileTradingJourney';
  expressActivations: Scalars['Int']['output'];
  liveCallUps: Scalars['Int']['output'];
  monthJoined?: Maybe<Scalars['Int']['output']>;
  passedCombines: Scalars['Int']['output'];
  yearJoined?: Maybe<Scalars['Int']['output']>;
};

export type MyTraderPublicProfileTradingStyle = {
  __typename?: 'MyTraderPublicProfileTradingStyle';
  drawdownType?: Maybe<Scalars['String']['output']>;
  tradingMarket?: Maybe<Scalars['String']['output']>;
  tradingSession?: Maybe<Scalars['String']['output']>;
  tradingSetup?: Maybe<Scalars['String']['output']>;
};

/** This table will be renamed to "Entitlement" in the near future. */
export type NmiSubscription = Node & {
  __typename?: 'NmiSubscription';
  /** Reads and enables pagination through a set of `AccountResetTracking`. */
  accountResetTrackingsBySubscriptionId: AccountResetTrackingConnection;
  /** Reads and enables pagination through a set of `Account`. */
  accounts: AccountConnection;
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Coupon` that is related to this `NmiSubscription`. */
  coupon?: Maybe<Coupon>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `UserSubscription` that is related to this `NmiSubscription`. */
  migratedSub?: Maybe<UserSubscription>;
  migratedSubId?: Maybe<Scalars['Int']['output']>;
  nmiReferenceId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `OrderFulfillment`. */
  orderFulfillmentsBySubscriptionId: OrderFulfillmentConnection;
  /** Reads a single `Product` that is related to this `NmiSubscription`. */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  rebillManager?: Maybe<NmiSubscriptionRebillManagerEnum>;
  rebillManagerMigratedAt?: Maybe<Scalars['Datetime']['output']>;
  rebillRefId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `RebillSession`. */
  rebillSessionsBySubscriptionId: RebillSessionConnection;
  rowId: Scalars['Int']['output'];
  /** Reads a single `SavedCard` that is related to this `NmiSubscription`. */
  savedCard?: Maybe<SavedCard>;
  savedCardId?: Maybe<Scalars['Int']['output']>;
  serviceAccessUntil?: Maybe<Scalars['Datetime']['output']>;
  serviceCancelledAt?: Maybe<Scalars['Datetime']['output']>;
  skuId?: Maybe<Scalars['Int']['output']>;
  subscriptionCancelledAt?: Maybe<Scalars['Datetime']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  type: NmiSubscriptionTypeEnum;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};


/** This table will be renamed to "Entitlement" in the near future. */
export type NmiSubscriptionAccountResetTrackingsBySubscriptionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountResetTrackingCondition>;
  filter?: InputMaybe<AccountResetTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountResetTrackingOrderBy>>;
};


/** This table will be renamed to "Entitlement" in the near future. */
export type NmiSubscriptionAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
};


/** This table will be renamed to "Entitlement" in the near future. */
export type NmiSubscriptionOrderFulfillmentsBySubscriptionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderFulfillmentCondition>;
  filter?: InputMaybe<OrderFulfillmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderFulfillmentOrderBy>>;
};


/** This table will be renamed to "Entitlement" in the near future. */
export type NmiSubscriptionRebillSessionsBySubscriptionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RebillSessionCondition>;
  filter?: InputMaybe<RebillSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RebillSessionOrderBy>>;
};

export type NmiSubscriptionAggregates = {
  __typename?: 'NmiSubscriptionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<NmiSubscriptionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<NmiSubscriptionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<NmiSubscriptionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<NmiSubscriptionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<NmiSubscriptionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<NmiSubscriptionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<NmiSubscriptionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<NmiSubscriptionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<NmiSubscriptionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `NmiSubscription` object types. */
export type NmiSubscriptionAggregatesFilter = {
  /** Mean average aggregate over matching `NmiSubscription` objects. */
  average?: InputMaybe<NmiSubscriptionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `NmiSubscription` objects. */
  distinctCount?: InputMaybe<NmiSubscriptionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `NmiSubscription` object to be included within the aggregate. */
  filter?: InputMaybe<NmiSubscriptionFilter>;
  /** Maximum aggregate over matching `NmiSubscription` objects. */
  max?: InputMaybe<NmiSubscriptionMaxAggregateFilter>;
  /** Minimum aggregate over matching `NmiSubscription` objects. */
  min?: InputMaybe<NmiSubscriptionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `NmiSubscription` objects. */
  stddevPopulation?: InputMaybe<NmiSubscriptionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `NmiSubscription` objects. */
  stddevSample?: InputMaybe<NmiSubscriptionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `NmiSubscription` objects. */
  sum?: InputMaybe<NmiSubscriptionSumAggregateFilter>;
  /** Population variance aggregate over matching `NmiSubscription` objects. */
  variancePopulation?: InputMaybe<NmiSubscriptionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `NmiSubscription` objects. */
  varianceSample?: InputMaybe<NmiSubscriptionVarianceSampleAggregateFilter>;
};

export type NmiSubscriptionAverageAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  migratedSubId?: InputMaybe<BigFloatFilter>;
  nmiReferenceId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  savedCardId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NmiSubscriptionAverageAggregates = {
  __typename?: 'NmiSubscriptionAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `NmiSubscription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NmiSubscriptionCondition = {
  /** Checks for equality with the object’s `couponId` field. */
  couponId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `migratedSubId` field. */
  migratedSubId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `nmiReferenceId` field. */
  nmiReferenceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rebillManager` field. */
  rebillManager?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Checks for equality with the object’s `rebillRefId` field. */
  rebillRefId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `savedCardId` field. */
  savedCardId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `serviceAccessUntil` field. */
  serviceAccessUntil?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `serviceCancelledAt` field. */
  serviceCancelledAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `skuId` field. */
  skuId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `subscriptionCancelledAt` field. */
  subscriptionCancelledAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `NmiSubscription` values. */
export type NmiSubscriptionConnection = {
  __typename?: 'NmiSubscriptionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<NmiSubscriptionAggregates>;
  /** A list of edges which contains the `NmiSubscription` and cursor to aid in pagination. */
  edges: Array<Maybe<NmiSubscriptionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<NmiSubscriptionAggregates>>;
  /** A list of `NmiSubscription` objects. */
  nodes: Array<Maybe<NmiSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NmiSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `NmiSubscription` values. */
export type NmiSubscriptionConnectionGroupedAggregatesArgs = {
  groupBy: Array<NmiSubscriptionGroupBy>;
  having?: InputMaybe<NmiSubscriptionHavingInput>;
};

export type NmiSubscriptionDistinctCountAggregateFilter = {
  couponId?: InputMaybe<BigIntFilter>;
  migratedSubId?: InputMaybe<BigIntFilter>;
  nmiReferenceId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<BigIntFilter>;
  rebillManager?: InputMaybe<BigIntFilter>;
  rebillRefId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  savedCardId?: InputMaybe<BigIntFilter>;
  serviceAccessUntil?: InputMaybe<BigIntFilter>;
  serviceCancelledAt?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
  subscriptionCancelledAt?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type NmiSubscriptionDistinctCountAggregates = {
  __typename?: 'NmiSubscriptionDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productId across the matching connection */
  productId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rebillManager across the matching connection */
  rebillManager?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rebillManagerMigratedAt across the matching connection */
  rebillManagerMigratedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rebillRefId across the matching connection */
  rebillRefId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of serviceAccessUntil across the matching connection */
  serviceAccessUntil?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of serviceCancelledAt across the matching connection */
  serviceCancelledAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionCancelledAt across the matching connection */
  subscriptionCancelledAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tax across the matching connection */
  tax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of total across the matching connection */
  total?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `NmiSubscription` edge in the connection. */
export type NmiSubscriptionEdge = {
  __typename?: 'NmiSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NmiSubscription` at the end of the edge. */
  node?: Maybe<NmiSubscription>;
};

/** A filter to be used against `NmiSubscription` object types. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionFilter = {
  /** Filter by the object’s `accountResetTrackingsBySubscriptionId` relation. */
  accountResetTrackingsBySubscriptionId?: InputMaybe<NmiSubscriptionToManyAccountResetTrackingFilter>;
  /** Some related `accountResetTrackingsBySubscriptionId` exist. */
  accountResetTrackingsBySubscriptionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accounts` relation. */
  accounts?: InputMaybe<NmiSubscriptionToManyAccountFilter>;
  /** Some related `accounts` exist. */
  accountsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NmiSubscriptionFilter>>;
  /** Filter by the object’s `coupon` relation. */
  coupon?: InputMaybe<CouponFilter>;
  /** A related `coupon` exists. */
  couponExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `migratedSub` relation. */
  migratedSub?: InputMaybe<UserSubscriptionFilter>;
  /** A related `migratedSub` exists. */
  migratedSubExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `migratedSubId` field. */
  migratedSubId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nmiReferenceId` field. */
  nmiReferenceId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NmiSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NmiSubscriptionFilter>>;
  /** Filter by the object’s `orderFulfillmentsBySubscriptionId` relation. */
  orderFulfillmentsBySubscriptionId?: InputMaybe<NmiSubscriptionToManyOrderFulfillmentFilter>;
  /** Some related `orderFulfillmentsBySubscriptionId` exist. */
  orderFulfillmentsBySubscriptionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<ProductFilter>;
  /** A related `product` exists. */
  productExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rebillManager` field. */
  rebillManager?: InputMaybe<NmiSubscriptionRebillManagerEnumFilter>;
  /** Filter by the object’s `rebillRefId` field. */
  rebillRefId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rebillSessionsBySubscriptionId` relation. */
  rebillSessionsBySubscriptionId?: InputMaybe<NmiSubscriptionToManyRebillSessionFilter>;
  /** Some related `rebillSessionsBySubscriptionId` exist. */
  rebillSessionsBySubscriptionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `savedCard` relation. */
  savedCard?: InputMaybe<SavedCardFilter>;
  /** A related `savedCard` exists. */
  savedCardExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `savedCardId` field. */
  savedCardId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `serviceAccessUntil` field. */
  serviceAccessUntil?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `serviceCancelledAt` field. */
  serviceCancelledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `skuId` field. */
  skuId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscriptionCancelledAt` field. */
  subscriptionCancelledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<NmiSubscriptionTypeEnumFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `NmiSubscription` for usage during aggregation. */
export enum NmiSubscriptionGroupBy {
  CouponId = 'COUPON_ID',
  MigratedSubId = 'MIGRATED_SUB_ID',
  ProductId = 'PRODUCT_ID',
  RebillManager = 'REBILL_MANAGER',
  RebillRefId = 'REBILL_REF_ID',
  SavedCardId = 'SAVED_CARD_ID',
  ServiceAccessUntil = 'SERVICE_ACCESS_UNTIL',
  ServiceAccessUntilTruncatedToDay = 'SERVICE_ACCESS_UNTIL_TRUNCATED_TO_DAY',
  ServiceAccessUntilTruncatedToHour = 'SERVICE_ACCESS_UNTIL_TRUNCATED_TO_HOUR',
  ServiceCancelledAt = 'SERVICE_CANCELLED_AT',
  ServiceCancelledAtTruncatedToDay = 'SERVICE_CANCELLED_AT_TRUNCATED_TO_DAY',
  ServiceCancelledAtTruncatedToHour = 'SERVICE_CANCELLED_AT_TRUNCATED_TO_HOUR',
  SkuId = 'SKU_ID',
  SubscriptionCancelledAt = 'SUBSCRIPTION_CANCELLED_AT',
  SubscriptionCancelledAtTruncatedToDay = 'SUBSCRIPTION_CANCELLED_AT_TRUNCATED_TO_DAY',
  SubscriptionCancelledAtTruncatedToHour = 'SUBSCRIPTION_CANCELLED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type NmiSubscriptionHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `NmiSubscription` aggregates. */
export type NmiSubscriptionHavingInput = {
  AND?: InputMaybe<Array<NmiSubscriptionHavingInput>>;
  OR?: InputMaybe<Array<NmiSubscriptionHavingInput>>;
  average?: InputMaybe<NmiSubscriptionHavingAverageInput>;
  distinctCount?: InputMaybe<NmiSubscriptionHavingDistinctCountInput>;
  max?: InputMaybe<NmiSubscriptionHavingMaxInput>;
  min?: InputMaybe<NmiSubscriptionHavingMinInput>;
  stddevPopulation?: InputMaybe<NmiSubscriptionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<NmiSubscriptionHavingStddevSampleInput>;
  sum?: InputMaybe<NmiSubscriptionHavingSumInput>;
  variancePopulation?: InputMaybe<NmiSubscriptionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<NmiSubscriptionHavingVarianceSampleInput>;
};

export type NmiSubscriptionHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedSubId?: InputMaybe<HavingIntFilter>;
  nmiReferenceId?: InputMaybe<HavingBigintFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rebillManagerMigratedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  savedCardId?: InputMaybe<HavingIntFilter>;
  serviceAccessUntil?: InputMaybe<HavingDatetimeFilter>;
  serviceCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  subscriptionCancelledAt?: InputMaybe<HavingDatetimeFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NmiSubscriptionMaxAggregateFilter = {
  couponId?: InputMaybe<IntFilter>;
  migratedSubId?: InputMaybe<IntFilter>;
  nmiReferenceId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  savedCardId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NmiSubscriptionMaxAggregates = {
  __typename?: 'NmiSubscriptionMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type NmiSubscriptionMinAggregateFilter = {
  couponId?: InputMaybe<IntFilter>;
  migratedSubId?: InputMaybe<IntFilter>;
  nmiReferenceId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  savedCardId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NmiSubscriptionMinAggregates = {
  __typename?: 'NmiSubscriptionMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `NmiSubscription`. */
export enum NmiSubscriptionOrderBy {
  AccountsAverageAccountTemplateAsc = 'ACCOUNTS_AVERAGE_ACCOUNT_TEMPLATE_ASC',
  AccountsAverageAccountTemplateDesc = 'ACCOUNTS_AVERAGE_ACCOUNT_TEMPLATE_DESC',
  AccountsAverageNmiSubscriptionIdAsc = 'ACCOUNTS_AVERAGE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsAverageNmiSubscriptionIdDesc = 'ACCOUNTS_AVERAGE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsAveragePlatformIdAsc = 'ACCOUNTS_AVERAGE_PLATFORM_ID_ASC',
  AccountsAveragePlatformIdDesc = 'ACCOUNTS_AVERAGE_PLATFORM_ID_DESC',
  AccountsAverageProjectXaccountIdAsc = 'ACCOUNTS_AVERAGE_PROJECT_XACCOUNT_ID_ASC',
  AccountsAverageProjectXaccountIdDesc = 'ACCOUNTS_AVERAGE_PROJECT_XACCOUNT_ID_DESC',
  AccountsAverageRowIdAsc = 'ACCOUNTS_AVERAGE_ROW_ID_ASC',
  AccountsAverageRowIdDesc = 'ACCOUNTS_AVERAGE_ROW_ID_DESC',
  AccountsAverageSkuIdAsc = 'ACCOUNTS_AVERAGE_SKU_ID_ASC',
  AccountsAverageSkuIdDesc = 'ACCOUNTS_AVERAGE_SKU_ID_DESC',
  AccountsAverageSubscriptionIdAsc = 'ACCOUNTS_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountsAverageSubscriptionIdDesc = 'ACCOUNTS_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountsAverageUserIdAsc = 'ACCOUNTS_AVERAGE_USER_ID_ASC',
  AccountsAverageUserIdDesc = 'ACCOUNTS_AVERAGE_USER_ID_DESC',
  AccountsCountAsc = 'ACCOUNTS_COUNT_ASC',
  AccountsCountDesc = 'ACCOUNTS_COUNT_DESC',
  AccountsDistinctCountAccountNameAsc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_NAME_ASC',
  AccountsDistinctCountAccountNameDesc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_NAME_DESC',
  AccountsDistinctCountAccountTemplateAsc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ASC',
  AccountsDistinctCountAccountTemplateDesc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_DESC',
  AccountsDistinctCountActiveAsc = 'ACCOUNTS_DISTINCT_COUNT_ACTIVE_ASC',
  AccountsDistinctCountActiveDesc = 'ACCOUNTS_DISTINCT_COUNT_ACTIVE_DESC',
  AccountsDistinctCountComplimentaryAsc = 'ACCOUNTS_DISTINCT_COUNT_COMPLIMENTARY_ASC',
  AccountsDistinctCountComplimentaryDesc = 'ACCOUNTS_DISTINCT_COUNT_COMPLIMENTARY_DESC',
  AccountsDistinctCountCreatedAtAsc = 'ACCOUNTS_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountsDistinctCountCreatedAtDesc = 'ACCOUNTS_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountsDistinctCountNmiSubscriptionIdAsc = 'ACCOUNTS_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_ASC',
  AccountsDistinctCountNmiSubscriptionIdDesc = 'ACCOUNTS_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_DESC',
  AccountsDistinctCountPlatformIdAsc = 'ACCOUNTS_DISTINCT_COUNT_PLATFORM_ID_ASC',
  AccountsDistinctCountPlatformIdDesc = 'ACCOUNTS_DISTINCT_COUNT_PLATFORM_ID_DESC',
  AccountsDistinctCountProjectXaccountIdAsc = 'ACCOUNTS_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_ASC',
  AccountsDistinctCountProjectXaccountIdDesc = 'ACCOUNTS_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_DESC',
  AccountsDistinctCountRowIdAsc = 'ACCOUNTS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountsDistinctCountRowIdDesc = 'ACCOUNTS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountsDistinctCountSkuIdAsc = 'ACCOUNTS_DISTINCT_COUNT_SKU_ID_ASC',
  AccountsDistinctCountSkuIdDesc = 'ACCOUNTS_DISTINCT_COUNT_SKU_ID_DESC',
  AccountsDistinctCountStageAsc = 'ACCOUNTS_DISTINCT_COUNT_STAGE_ASC',
  AccountsDistinctCountStageDesc = 'ACCOUNTS_DISTINCT_COUNT_STAGE_DESC',
  AccountsDistinctCountStartDateAsc = 'ACCOUNTS_DISTINCT_COUNT_START_DATE_ASC',
  AccountsDistinctCountStartDateDesc = 'ACCOUNTS_DISTINCT_COUNT_START_DATE_DESC',
  AccountsDistinctCountStatusAsc = 'ACCOUNTS_DISTINCT_COUNT_STATUS_ASC',
  AccountsDistinctCountStatusDesc = 'ACCOUNTS_DISTINCT_COUNT_STATUS_DESC',
  AccountsDistinctCountSubscriptionIdAsc = 'ACCOUNTS_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountsDistinctCountSubscriptionIdDesc = 'ACCOUNTS_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountsDistinctCountUserIdAsc = 'ACCOUNTS_DISTINCT_COUNT_USER_ID_ASC',
  AccountsDistinctCountUserIdDesc = 'ACCOUNTS_DISTINCT_COUNT_USER_ID_DESC',
  AccountsMaxAccountTemplateAsc = 'ACCOUNTS_MAX_ACCOUNT_TEMPLATE_ASC',
  AccountsMaxAccountTemplateDesc = 'ACCOUNTS_MAX_ACCOUNT_TEMPLATE_DESC',
  AccountsMaxNmiSubscriptionIdAsc = 'ACCOUNTS_MAX_NMI_SUBSCRIPTION_ID_ASC',
  AccountsMaxNmiSubscriptionIdDesc = 'ACCOUNTS_MAX_NMI_SUBSCRIPTION_ID_DESC',
  AccountsMaxPlatformIdAsc = 'ACCOUNTS_MAX_PLATFORM_ID_ASC',
  AccountsMaxPlatformIdDesc = 'ACCOUNTS_MAX_PLATFORM_ID_DESC',
  AccountsMaxProjectXaccountIdAsc = 'ACCOUNTS_MAX_PROJECT_XACCOUNT_ID_ASC',
  AccountsMaxProjectXaccountIdDesc = 'ACCOUNTS_MAX_PROJECT_XACCOUNT_ID_DESC',
  AccountsMaxRowIdAsc = 'ACCOUNTS_MAX_ROW_ID_ASC',
  AccountsMaxRowIdDesc = 'ACCOUNTS_MAX_ROW_ID_DESC',
  AccountsMaxSkuIdAsc = 'ACCOUNTS_MAX_SKU_ID_ASC',
  AccountsMaxSkuIdDesc = 'ACCOUNTS_MAX_SKU_ID_DESC',
  AccountsMaxSubscriptionIdAsc = 'ACCOUNTS_MAX_SUBSCRIPTION_ID_ASC',
  AccountsMaxSubscriptionIdDesc = 'ACCOUNTS_MAX_SUBSCRIPTION_ID_DESC',
  AccountsMaxUserIdAsc = 'ACCOUNTS_MAX_USER_ID_ASC',
  AccountsMaxUserIdDesc = 'ACCOUNTS_MAX_USER_ID_DESC',
  AccountsMinAccountTemplateAsc = 'ACCOUNTS_MIN_ACCOUNT_TEMPLATE_ASC',
  AccountsMinAccountTemplateDesc = 'ACCOUNTS_MIN_ACCOUNT_TEMPLATE_DESC',
  AccountsMinNmiSubscriptionIdAsc = 'ACCOUNTS_MIN_NMI_SUBSCRIPTION_ID_ASC',
  AccountsMinNmiSubscriptionIdDesc = 'ACCOUNTS_MIN_NMI_SUBSCRIPTION_ID_DESC',
  AccountsMinPlatformIdAsc = 'ACCOUNTS_MIN_PLATFORM_ID_ASC',
  AccountsMinPlatformIdDesc = 'ACCOUNTS_MIN_PLATFORM_ID_DESC',
  AccountsMinProjectXaccountIdAsc = 'ACCOUNTS_MIN_PROJECT_XACCOUNT_ID_ASC',
  AccountsMinProjectXaccountIdDesc = 'ACCOUNTS_MIN_PROJECT_XACCOUNT_ID_DESC',
  AccountsMinRowIdAsc = 'ACCOUNTS_MIN_ROW_ID_ASC',
  AccountsMinRowIdDesc = 'ACCOUNTS_MIN_ROW_ID_DESC',
  AccountsMinSkuIdAsc = 'ACCOUNTS_MIN_SKU_ID_ASC',
  AccountsMinSkuIdDesc = 'ACCOUNTS_MIN_SKU_ID_DESC',
  AccountsMinSubscriptionIdAsc = 'ACCOUNTS_MIN_SUBSCRIPTION_ID_ASC',
  AccountsMinSubscriptionIdDesc = 'ACCOUNTS_MIN_SUBSCRIPTION_ID_DESC',
  AccountsMinUserIdAsc = 'ACCOUNTS_MIN_USER_ID_ASC',
  AccountsMinUserIdDesc = 'ACCOUNTS_MIN_USER_ID_DESC',
  AccountsStddevPopulationAccountTemplateAsc = 'ACCOUNTS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsStddevPopulationAccountTemplateDesc = 'ACCOUNTS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsStddevPopulationNmiSubscriptionIdAsc = 'ACCOUNTS_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsStddevPopulationNmiSubscriptionIdDesc = 'ACCOUNTS_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsStddevPopulationPlatformIdAsc = 'ACCOUNTS_STDDEV_POPULATION_PLATFORM_ID_ASC',
  AccountsStddevPopulationPlatformIdDesc = 'ACCOUNTS_STDDEV_POPULATION_PLATFORM_ID_DESC',
  AccountsStddevPopulationProjectXaccountIdAsc = 'ACCOUNTS_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsStddevPopulationProjectXaccountIdDesc = 'ACCOUNTS_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsStddevPopulationRowIdAsc = 'ACCOUNTS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountsStddevPopulationRowIdDesc = 'ACCOUNTS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountsStddevPopulationSkuIdAsc = 'ACCOUNTS_STDDEV_POPULATION_SKU_ID_ASC',
  AccountsStddevPopulationSkuIdDesc = 'ACCOUNTS_STDDEV_POPULATION_SKU_ID_DESC',
  AccountsStddevPopulationSubscriptionIdAsc = 'ACCOUNTS_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsStddevPopulationSubscriptionIdDesc = 'ACCOUNTS_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsStddevPopulationUserIdAsc = 'ACCOUNTS_STDDEV_POPULATION_USER_ID_ASC',
  AccountsStddevPopulationUserIdDesc = 'ACCOUNTS_STDDEV_POPULATION_USER_ID_DESC',
  AccountsStddevSampleAccountTemplateAsc = 'ACCOUNTS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsStddevSampleAccountTemplateDesc = 'ACCOUNTS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsStddevSampleNmiSubscriptionIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsStddevSampleNmiSubscriptionIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsStddevSamplePlatformIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_PLATFORM_ID_ASC',
  AccountsStddevSamplePlatformIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_PLATFORM_ID_DESC',
  AccountsStddevSampleProjectXaccountIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsStddevSampleProjectXaccountIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsStddevSampleRowIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountsStddevSampleRowIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountsStddevSampleSkuIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_SKU_ID_ASC',
  AccountsStddevSampleSkuIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_SKU_ID_DESC',
  AccountsStddevSampleSubscriptionIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsStddevSampleSubscriptionIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsStddevSampleUserIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountsStddevSampleUserIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountsSumAccountTemplateAsc = 'ACCOUNTS_SUM_ACCOUNT_TEMPLATE_ASC',
  AccountsSumAccountTemplateDesc = 'ACCOUNTS_SUM_ACCOUNT_TEMPLATE_DESC',
  AccountsSumNmiSubscriptionIdAsc = 'ACCOUNTS_SUM_NMI_SUBSCRIPTION_ID_ASC',
  AccountsSumNmiSubscriptionIdDesc = 'ACCOUNTS_SUM_NMI_SUBSCRIPTION_ID_DESC',
  AccountsSumPlatformIdAsc = 'ACCOUNTS_SUM_PLATFORM_ID_ASC',
  AccountsSumPlatformIdDesc = 'ACCOUNTS_SUM_PLATFORM_ID_DESC',
  AccountsSumProjectXaccountIdAsc = 'ACCOUNTS_SUM_PROJECT_XACCOUNT_ID_ASC',
  AccountsSumProjectXaccountIdDesc = 'ACCOUNTS_SUM_PROJECT_XACCOUNT_ID_DESC',
  AccountsSumRowIdAsc = 'ACCOUNTS_SUM_ROW_ID_ASC',
  AccountsSumRowIdDesc = 'ACCOUNTS_SUM_ROW_ID_DESC',
  AccountsSumSkuIdAsc = 'ACCOUNTS_SUM_SKU_ID_ASC',
  AccountsSumSkuIdDesc = 'ACCOUNTS_SUM_SKU_ID_DESC',
  AccountsSumSubscriptionIdAsc = 'ACCOUNTS_SUM_SUBSCRIPTION_ID_ASC',
  AccountsSumSubscriptionIdDesc = 'ACCOUNTS_SUM_SUBSCRIPTION_ID_DESC',
  AccountsSumUserIdAsc = 'ACCOUNTS_SUM_USER_ID_ASC',
  AccountsSumUserIdDesc = 'ACCOUNTS_SUM_USER_ID_DESC',
  AccountsVariancePopulationAccountTemplateAsc = 'ACCOUNTS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsVariancePopulationAccountTemplateDesc = 'ACCOUNTS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsVariancePopulationNmiSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsVariancePopulationNmiSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsVariancePopulationPlatformIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_PLATFORM_ID_ASC',
  AccountsVariancePopulationPlatformIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_PLATFORM_ID_DESC',
  AccountsVariancePopulationProjectXaccountIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsVariancePopulationProjectXaccountIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsVariancePopulationRowIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountsVariancePopulationRowIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountsVariancePopulationSkuIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_SKU_ID_ASC',
  AccountsVariancePopulationSkuIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_SKU_ID_DESC',
  AccountsVariancePopulationSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsVariancePopulationSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsVariancePopulationUserIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountsVariancePopulationUserIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountsVarianceSampleAccountTemplateAsc = 'ACCOUNTS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsVarianceSampleAccountTemplateDesc = 'ACCOUNTS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsVarianceSampleNmiSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsVarianceSampleNmiSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsVarianceSamplePlatformIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_PLATFORM_ID_ASC',
  AccountsVarianceSamplePlatformIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_PLATFORM_ID_DESC',
  AccountsVarianceSampleProjectXaccountIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsVarianceSampleProjectXaccountIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsVarianceSampleRowIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountsVarianceSampleRowIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountsVarianceSampleSkuIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_SKU_ID_ASC',
  AccountsVarianceSampleSkuIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_SKU_ID_DESC',
  AccountsVarianceSampleSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsVarianceSampleSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsVarianceSampleUserIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountsVarianceSampleUserIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdAverageBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdAverageBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdAverageRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdAverageRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdAverageSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdAverageSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdAverageUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdAverageUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_AVERAGE_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdCountAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_COUNT_ASC',
  AccountResetTrackingsBySubscriptionIdCountDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_COUNT_DESC',
  AccountResetTrackingsBySubscriptionIdDistinctCountAccountTypeAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_TYPE_ASC',
  AccountResetTrackingsBySubscriptionIdDistinctCountAccountTypeDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_TYPE_DESC',
  AccountResetTrackingsBySubscriptionIdDistinctCountBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdDistinctCountBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdDistinctCountRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdDistinctCountRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdDistinctCountSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdDistinctCountSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdDistinctCountUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdDistinctCountUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMaxBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMaxBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMaxRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMaxRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMaxSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMaxSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMaxUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMaxUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MAX_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMinBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMinBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMinRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMinRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMinSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMinSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdMinUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdMinUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_MIN_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevPopulationUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevSampleBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevSampleBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevSampleRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevSampleRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevSampleSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevSampleSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdStddevSampleUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdStddevSampleUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdSumBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdSumBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdSumRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdSumRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdSumSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdSumSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdSumUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdSumUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_SUM_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVariancePopulationUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_USER_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_BRANCH_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_BRANCH_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountResetTrackingsBySubscriptionIdVarianceSampleUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_USER_ID_DESC',
  CouponIdAsc = 'COUPON_ID_ASC',
  CouponIdDesc = 'COUPON_ID_DESC',
  MigratedSubIdAsc = 'MIGRATED_SUB_ID_ASC',
  MigratedSubIdDesc = 'MIGRATED_SUB_ID_DESC',
  Natural = 'NATURAL',
  NmiReferenceIdAsc = 'NMI_REFERENCE_ID_ASC',
  NmiReferenceIdDesc = 'NMI_REFERENCE_ID_DESC',
  OrderFulfillmentsBySubscriptionIdAverageAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdAverageAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdAveragePurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdAveragePurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdAverageRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdAverageRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdAverageSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdAverageSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdCountAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_COUNT_ASC',
  OrderFulfillmentsBySubscriptionIdCountDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_COUNT_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountAccountNameAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_NAME_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountAccountNameDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_NAME_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountErpInvoiceIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ERP_INVOICE_ID_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountErpInvoiceIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ERP_INVOICE_ID_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountFulfillmentStepLockedAtAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_FULFILLMENT_STEP_LOCKED_AT_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountFulfillmentStepLockedAtDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_FULFILLMENT_STEP_LOCKED_AT_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountPurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountPurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountStatusAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STATUS_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountStatusDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STATUS_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountTypeAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_TYPE_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountTypeDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_TYPE_DESC',
  OrderFulfillmentsBySubscriptionIdDistinctCountUpdatedAtAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_UPDATED_AT_ASC',
  OrderFulfillmentsBySubscriptionIdDistinctCountUpdatedAtDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_UPDATED_AT_DESC',
  OrderFulfillmentsBySubscriptionIdMaxAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMaxAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMaxPurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMaxPurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMaxRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMaxRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMaxSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMaxSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMinAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMinAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMinPurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMinPurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMinRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMinRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdMinSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdMinSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationPurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationPurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevPopulationSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevSampleAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevSampleAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevSamplePurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevSamplePurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevSampleRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevSampleRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdStddevSampleSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdStddevSampleSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdSumAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdSumAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdSumPurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdSumPurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdSumRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdSumRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdSumSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdSumSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationPurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationPurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVariancePopulationSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVarianceSampleAccountIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVarianceSampleAccountIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVarianceSamplePurchaseOrderIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVarianceSamplePurchaseOrderIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVarianceSampleRowIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVarianceSampleRowIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  OrderFulfillmentsBySubscriptionIdVarianceSampleSubscriptionIdAsc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  OrderFulfillmentsBySubscriptionIdVarianceSampleSubscriptionIdDesc = 'ORDER_FULFILLMENTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  RebillRefIdAsc = 'REBILL_REF_ID_ASC',
  RebillRefIdDesc = 'REBILL_REF_ID_DESC',
  RebillSessionsBySubscriptionIdAveragePurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdAveragePurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdAverageRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdAverageRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdAverageSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdAverageSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdAverageUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_USER_ID_ASC',
  RebillSessionsBySubscriptionIdAverageUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_AVERAGE_USER_ID_DESC',
  RebillSessionsBySubscriptionIdCountAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_COUNT_ASC',
  RebillSessionsBySubscriptionIdCountDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_COUNT_DESC',
  RebillSessionsBySubscriptionIdDistinctCountExternalSubscriptionReferenceAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_EXTERNAL_SUBSCRIPTION_REFERENCE_ASC',
  RebillSessionsBySubscriptionIdDistinctCountExternalSubscriptionReferenceDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_EXTERNAL_SUBSCRIPTION_REFERENCE_DESC',
  RebillSessionsBySubscriptionIdDistinctCountPurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdDistinctCountPurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdDistinctCountRebillManagerAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_REBILL_MANAGER_ASC',
  RebillSessionsBySubscriptionIdDistinctCountRebillManagerDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_REBILL_MANAGER_DESC',
  RebillSessionsBySubscriptionIdDistinctCountRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdDistinctCountRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdDistinctCountStatusAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STATUS_ASC',
  RebillSessionsBySubscriptionIdDistinctCountStatusDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STATUS_DESC',
  RebillSessionsBySubscriptionIdDistinctCountSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdDistinctCountSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdDistinctCountUpdatedAtAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_UPDATED_AT_ASC',
  RebillSessionsBySubscriptionIdDistinctCountUpdatedAtDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_UPDATED_AT_DESC',
  RebillSessionsBySubscriptionIdDistinctCountUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_USER_ID_ASC',
  RebillSessionsBySubscriptionIdDistinctCountUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_USER_ID_DESC',
  RebillSessionsBySubscriptionIdMaxPurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdMaxPurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdMaxRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdMaxRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdMaxSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdMaxSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdMaxUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_USER_ID_ASC',
  RebillSessionsBySubscriptionIdMaxUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MAX_USER_ID_DESC',
  RebillSessionsBySubscriptionIdMinPurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdMinPurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdMinRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdMinRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdMinSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdMinSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdMinUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_USER_ID_ASC',
  RebillSessionsBySubscriptionIdMinUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_MIN_USER_ID_DESC',
  RebillSessionsBySubscriptionIdStddevPopulationPurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdStddevPopulationPurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdStddevPopulationRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdStddevPopulationRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdStddevPopulationSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdStddevPopulationSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdStddevPopulationUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_USER_ID_ASC',
  RebillSessionsBySubscriptionIdStddevPopulationUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_USER_ID_DESC',
  RebillSessionsBySubscriptionIdStddevSamplePurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdStddevSamplePurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdStddevSampleRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdStddevSampleRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdStddevSampleSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdStddevSampleSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdStddevSampleUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_USER_ID_ASC',
  RebillSessionsBySubscriptionIdStddevSampleUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_USER_ID_DESC',
  RebillSessionsBySubscriptionIdSumPurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdSumPurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdSumRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdSumRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdSumSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdSumSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdSumUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_USER_ID_ASC',
  RebillSessionsBySubscriptionIdSumUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_SUM_USER_ID_DESC',
  RebillSessionsBySubscriptionIdVariancePopulationPurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdVariancePopulationPurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdVariancePopulationRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdVariancePopulationRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdVariancePopulationSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdVariancePopulationSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdVariancePopulationUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_USER_ID_ASC',
  RebillSessionsBySubscriptionIdVariancePopulationUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_USER_ID_DESC',
  RebillSessionsBySubscriptionIdVarianceSamplePurchaseIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PURCHASE_ID_ASC',
  RebillSessionsBySubscriptionIdVarianceSamplePurchaseIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PURCHASE_ID_DESC',
  RebillSessionsBySubscriptionIdVarianceSampleRowIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  RebillSessionsBySubscriptionIdVarianceSampleRowIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  RebillSessionsBySubscriptionIdVarianceSampleSubscriptionIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  RebillSessionsBySubscriptionIdVarianceSampleSubscriptionIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  RebillSessionsBySubscriptionIdVarianceSampleUserIdAsc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_USER_ID_ASC',
  RebillSessionsBySubscriptionIdVarianceSampleUserIdDesc = 'REBILL_SESSIONS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_USER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SavedCardIdAsc = 'SAVED_CARD_ID_ASC',
  SavedCardIdDesc = 'SAVED_CARD_ID_DESC',
  ServiceAccessUntilAsc = 'SERVICE_ACCESS_UNTIL_ASC',
  ServiceAccessUntilDesc = 'SERVICE_ACCESS_UNTIL_DESC',
  ServiceCancelledAtAsc = 'SERVICE_CANCELLED_AT_ASC',
  ServiceCancelledAtDesc = 'SERVICE_CANCELLED_AT_DESC',
  SkuIdAsc = 'SKU_ID_ASC',
  SkuIdDesc = 'SKU_ID_DESC',
  SubscriptionCancelledAtAsc = 'SUBSCRIPTION_CANCELLED_AT_ASC',
  SubscriptionCancelledAtDesc = 'SUBSCRIPTION_CANCELLED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum NmiSubscriptionRebillManagerEnum {
  Nmi = 'nmi',
  TrmBilling = 'trm_billing'
}

/** A filter to be used against NmiSubscriptionRebillManagerEnum fields. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionRebillManagerEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NmiSubscriptionRebillManagerEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NmiSubscriptionRebillManagerEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NmiSubscriptionRebillManagerEnum>>;
};

export type NmiSubscriptionStddevPopulationAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  migratedSubId?: InputMaybe<BigFloatFilter>;
  nmiReferenceId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  savedCardId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NmiSubscriptionStddevPopulationAggregates = {
  __typename?: 'NmiSubscriptionStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NmiSubscriptionStddevSampleAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  migratedSubId?: InputMaybe<BigFloatFilter>;
  nmiReferenceId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  savedCardId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NmiSubscriptionStddevSampleAggregates = {
  __typename?: 'NmiSubscriptionStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NmiSubscriptionSumAggregateFilter = {
  couponId?: InputMaybe<BigIntFilter>;
  migratedSubId?: InputMaybe<BigIntFilter>;
  nmiReferenceId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  savedCardId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type NmiSubscriptionSumAggregates = {
  __typename?: 'NmiSubscriptionSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of couponId across the matching connection */
  couponId: Scalars['BigInt']['output'];
  /** Sum of migratedSubId across the matching connection */
  migratedSubId: Scalars['BigInt']['output'];
  /** Sum of nmiReferenceId across the matching connection */
  nmiReferenceId: Scalars['BigFloat']['output'];
  /** Sum of productId across the matching connection */
  productId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of savedCardId across the matching connection */
  savedCardId: Scalars['BigInt']['output'];
  /** Sum of skuId across the matching connection */
  skuId: Scalars['BigInt']['output'];
  /** Sum of tax across the matching connection */
  tax: Scalars['BigFloat']['output'];
  /** Sum of total across the matching connection */
  total: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Account` object types. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionToManyAccountFilter = {
  /** Aggregates across related `Account` match the filter criteria. */
  aggregates?: InputMaybe<AccountAggregatesFilter>;
  /** Every related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFilter>;
  /** No related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFilter>;
  /** Some related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFilter>;
};

/** A filter to be used against many `AccountResetTracking` object types. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionToManyAccountResetTrackingFilter = {
  /** Aggregates across related `AccountResetTracking` match the filter criteria. */
  aggregates?: InputMaybe<AccountResetTrackingAggregatesFilter>;
  /** Every related `AccountResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountResetTrackingFilter>;
  /** No related `AccountResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountResetTrackingFilter>;
  /** Some related `AccountResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountResetTrackingFilter>;
};

/** A filter to be used against many `OrderFulfillment` object types. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionToManyOrderFulfillmentFilter = {
  /** Aggregates across related `OrderFulfillment` match the filter criteria. */
  aggregates?: InputMaybe<OrderFulfillmentAggregatesFilter>;
  /** Every related `OrderFulfillment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OrderFulfillmentFilter>;
  /** No related `OrderFulfillment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OrderFulfillmentFilter>;
  /** Some related `OrderFulfillment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OrderFulfillmentFilter>;
};

/** A filter to be used against many `RebillSession` object types. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionToManyRebillSessionFilter = {
  /** Aggregates across related `RebillSession` match the filter criteria. */
  aggregates?: InputMaybe<RebillSessionAggregatesFilter>;
  /** Every related `RebillSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RebillSessionFilter>;
  /** No related `RebillSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RebillSessionFilter>;
  /** Some related `RebillSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RebillSessionFilter>;
};

export enum NmiSubscriptionTypeEnum {
  SingleTerm = 'single_term',
  Subscription = 'subscription',
  Termless = 'termless'
}

/** A filter to be used against NmiSubscriptionTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type NmiSubscriptionTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NmiSubscriptionTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NmiSubscriptionTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NmiSubscriptionTypeEnum>>;
};

export type NmiSubscriptionVariancePopulationAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  migratedSubId?: InputMaybe<BigFloatFilter>;
  nmiReferenceId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  savedCardId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NmiSubscriptionVariancePopulationAggregates = {
  __typename?: 'NmiSubscriptionVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NmiSubscriptionVarianceSampleAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  migratedSubId?: InputMaybe<BigFloatFilter>;
  nmiReferenceId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  savedCardId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NmiSubscriptionVarianceSampleAggregates = {
  __typename?: 'NmiSubscriptionVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of migratedSubId across the matching connection */
  migratedSubId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nmiReferenceId across the matching connection */
  nmiReferenceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of savedCardId across the matching connection */
  savedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
};

/** A connection to a list of `NormalizedPurchasesByUserRecord` values. */
export type NormalizedPurchasesByUserConnection = {
  __typename?: 'NormalizedPurchasesByUserConnection';
  /** A list of edges which contains the `NormalizedPurchasesByUserRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<NormalizedPurchasesByUserEdge>>;
  /** A list of `NormalizedPurchasesByUserRecord` objects. */
  nodes: Array<Maybe<NormalizedPurchasesByUserRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NormalizedPurchasesByUserRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NormalizedPurchasesByUserRecord` edge in the connection. */
export type NormalizedPurchasesByUserEdge = {
  __typename?: 'NormalizedPurchasesByUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NormalizedPurchasesByUserRecord` at the end of the edge. */
  node?: Maybe<NormalizedPurchasesByUserRecord>;
};

export type NormalizedPurchasesByUserRecord = {
  __typename?: 'NormalizedPurchasesByUserRecord';
  accountId?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['BigFloat']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingRegion?: Maybe<Scalars['String']['output']>;
  billingStreet?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Scalars['BigFloat']['output']>;
  fulfillmentStatus?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  gatewayTransactionId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceTemplate?: Maybe<Scalars['String']['output']>;
  localCurrency?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['Int']['output']>;
  platformName?: Maybe<Scalars['String']['output']>;
  processor?: Maybe<Scalars['String']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  shippingRegion?: Maybe<Scalars['String']['output']>;
  shippingStreet?: Maybe<Scalars['String']['output']>;
  shippingZip?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `NormalizedPurchasesByUserRecord` object types. All fields are combined with a logical ‘and.’ */
export type NormalizedPurchasesByUserRecordFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountName` field. */
  accountName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NormalizedPurchasesByUserRecordFilter>>;
  /** Filter by the object’s `billingCity` field. */
  billingCity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingCountry` field. */
  billingCountry?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingRegion` field. */
  billingRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingStreet` field. */
  billingStreet?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingZip` field. */
  billingZip?: InputMaybe<StringFilter>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `discount` field. */
  discount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fulfillmentStatus` field. */
  fulfillmentStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gateway` field. */
  gateway?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `invoiceTemplate` field. */
  invoiceTemplate?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localCurrency` field. */
  localCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `method` field. */
  method?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NormalizedPurchasesByUserRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NormalizedPurchasesByUserRecordFilter>>;
  /** Filter by the object’s `paymentStatus` field. */
  paymentStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `platform` field. */
  platform?: InputMaybe<IntFilter>;
  /** Filter by the object’s `platformName` field. */
  platformName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `processor` field. */
  processor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `processorTransactionId` field. */
  processorTransactionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shippingCity` field. */
  shippingCity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shippingCountry` field. */
  shippingCountry?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shippingRegion` field. */
  shippingRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shippingStreet` field. */
  shippingStreet?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shippingZip` field. */
  shippingZip?: InputMaybe<StringFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subtotal` field. */
  subtotal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tax` field. */
  tax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `taxDisplayedInLocalCurrency` field. */
  taxDisplayedInLocalCurrency?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `total` field. */
  total?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** A connection to a list of `NormalizedSavedCardsByUserRecord` values. */
export type NormalizedSavedCardsByUserConnection = {
  __typename?: 'NormalizedSavedCardsByUserConnection';
  /** A list of edges which contains the `NormalizedSavedCardsByUserRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<NormalizedSavedCardsByUserEdge>>;
  /** A list of `NormalizedSavedCardsByUserRecord` objects. */
  nodes: Array<Maybe<NormalizedSavedCardsByUserRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NormalizedSavedCardsByUserRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NormalizedSavedCardsByUserRecord` edge in the connection. */
export type NormalizedSavedCardsByUserEdge = {
  __typename?: 'NormalizedSavedCardsByUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NormalizedSavedCardsByUserRecord` at the end of the edge. */
  node?: Maybe<NormalizedSavedCardsByUserRecord>;
};

export type NormalizedSavedCardsByUserRecord = {
  __typename?: 'NormalizedSavedCardsByUserRecord';
  active?: Maybe<Scalars['Boolean']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  defaultCard?: Maybe<Scalars['Boolean']['output']>;
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `NormalizedSavedCardsByUserRecord` object types. All fields are combined with a logical ‘and.’ */
export type NormalizedSavedCardsByUserRecordFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NormalizedSavedCardsByUserRecordFilter>>;
  /** Filter by the object’s `cardNumber` field. */
  cardNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultCard` field. */
  defaultCard?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `expirationMonth` field. */
  expirationMonth?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expirationYear` field. */
  expirationYear?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maskedCardNumber` field. */
  maskedCardNumber?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NormalizedSavedCardsByUserRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NormalizedSavedCardsByUserRecordFilter>>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `NormalizedSubsByUserRecord` values. */
export type NormalizedSubsByUserConnection = {
  __typename?: 'NormalizedSubsByUserConnection';
  /** A list of edges which contains the `NormalizedSubsByUserRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<NormalizedSubsByUserEdge>>;
  /** A list of `NormalizedSubsByUserRecord` objects. */
  nodes: Array<Maybe<NormalizedSubsByUserRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NormalizedSubsByUserRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NormalizedSubsByUserRecord` edge in the connection. */
export type NormalizedSubsByUserEdge = {
  __typename?: 'NormalizedSubsByUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NormalizedSubsByUserRecord` at the end of the edge. */
  node?: Maybe<NormalizedSubsByUserRecord>;
};

export type NormalizedSubsByUserRecord = {
  __typename?: 'NormalizedSubsByUserRecord';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  couponIsRecurring?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  externalProcessor?: Maybe<Scalars['String']['output']>;
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productPrice?: Maybe<Scalars['BigFloat']['output']>;
  selectedPaymentMethod?: Maybe<Scalars['String']['output']>;
  serviceAccessUntil?: Maybe<Scalars['Datetime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subscriptionCancelledAt?: Maybe<Scalars['Datetime']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against `NormalizedSubsByUserRecord` object types. All fields are combined with a logical ‘and.’ */
export type NormalizedSubsByUserRecordFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NormalizedSubsByUserRecordFilter>>;
  /** Filter by the object’s `couponCode` field. */
  couponCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `couponIsRecurring` field. */
  couponIsRecurring?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalProcessor` field. */
  externalProcessor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalReferenceId` field. */
  externalReferenceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NormalizedSubsByUserRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NormalizedSubsByUserRecordFilter>>;
  /** Filter by the object’s `productName` field. */
  productName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `productPrice` field. */
  productPrice?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `selectedPaymentMethod` field. */
  selectedPaymentMethod?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceAccessUntil` field. */
  serviceAccessUntil?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subscriptionCancelledAt` field. */
  subscriptionCancelledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `tax` field. */
  tax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `total` field. */
  total?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `NormalizedSubsDetailedByUserRecord` values. */
export type NormalizedSubsDetailedByUserConnection = {
  __typename?: 'NormalizedSubsDetailedByUserConnection';
  /** A list of edges which contains the `NormalizedSubsDetailedByUserRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<NormalizedSubsDetailedByUserEdge>>;
  /** A list of `NormalizedSubsDetailedByUserRecord` objects. */
  nodes: Array<Maybe<NormalizedSubsDetailedByUserRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NormalizedSubsDetailedByUserRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NormalizedSubsDetailedByUserRecord` edge in the connection. */
export type NormalizedSubsDetailedByUserEdge = {
  __typename?: 'NormalizedSubsDetailedByUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NormalizedSubsDetailedByUserRecord` at the end of the edge. */
  node?: Maybe<NormalizedSubsDetailedByUserRecord>;
};

export type NormalizedSubsDetailedByUserRecord = {
  __typename?: 'NormalizedSubsDetailedByUserRecord';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  associatedAccountName?: Maybe<Scalars['String']['output']>;
  catalogProductName?: Maybe<Scalars['String']['output']>;
  catalogProductPrice?: Maybe<Scalars['Float']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  couponIsRecurring?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  externalProcessor?: Maybe<Scalars['String']['output']>;
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productPrice?: Maybe<Scalars['BigFloat']['output']>;
  recurringCycle?: Maybe<Scalars['String']['output']>;
  serviceAccessUntil?: Maybe<Scalars['Datetime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subscriptionCancelledAt?: Maybe<Scalars['Datetime']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** A filter to be used against `NormalizedSubsDetailedByUserRecord` object types. All fields are combined with a logical ‘and.’ */
export type NormalizedSubsDetailedByUserRecordFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NormalizedSubsDetailedByUserRecordFilter>>;
  /** Filter by the object’s `associatedAccountId` field. */
  associatedAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `associatedAccountName` field. */
  associatedAccountName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `couponCode` field. */
  couponCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `couponIsRecurring` field. */
  couponIsRecurring?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalProcessor` field. */
  externalProcessor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalReferenceId` field. */
  externalReferenceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NormalizedSubsDetailedByUserRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NormalizedSubsDetailedByUserRecordFilter>>;
  /** Filter by the object’s `productName` field. */
  productName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `productPrice` field. */
  productPrice?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `serviceAccessUntil` field. */
  serviceAccessUntil?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subscriptionCancelledAt` field. */
  subscriptionCancelledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `tax` field. */
  tax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `total` field. */
  total?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type NuveiSavedCard = Node & {
  __typename?: 'NuveiSavedCard';
  active?: Maybe<Scalars['Boolean']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  cvv?: Maybe<Scalars['String']['output']>;
  defaultCard?: Maybe<Scalars['Boolean']['output']>;
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `NuveiSavedCard`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  userPaymentOptionId: Scalars['String']['output'];
};

export type NuveiSavedCardAggregates = {
  __typename?: 'NuveiSavedCardAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<NuveiSavedCardAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<NuveiSavedCardDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<NuveiSavedCardMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<NuveiSavedCardMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<NuveiSavedCardStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<NuveiSavedCardStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<NuveiSavedCardSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<NuveiSavedCardVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<NuveiSavedCardVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `NuveiSavedCard` object types. */
export type NuveiSavedCardAggregatesFilter = {
  /** Mean average aggregate over matching `NuveiSavedCard` objects. */
  average?: InputMaybe<NuveiSavedCardAverageAggregateFilter>;
  /** Distinct count aggregate over matching `NuveiSavedCard` objects. */
  distinctCount?: InputMaybe<NuveiSavedCardDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `NuveiSavedCard` object to be included within the aggregate. */
  filter?: InputMaybe<NuveiSavedCardFilter>;
  /** Maximum aggregate over matching `NuveiSavedCard` objects. */
  max?: InputMaybe<NuveiSavedCardMaxAggregateFilter>;
  /** Minimum aggregate over matching `NuveiSavedCard` objects. */
  min?: InputMaybe<NuveiSavedCardMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `NuveiSavedCard` objects. */
  stddevPopulation?: InputMaybe<NuveiSavedCardStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `NuveiSavedCard` objects. */
  stddevSample?: InputMaybe<NuveiSavedCardStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `NuveiSavedCard` objects. */
  sum?: InputMaybe<NuveiSavedCardSumAggregateFilter>;
  /** Population variance aggregate over matching `NuveiSavedCard` objects. */
  variancePopulation?: InputMaybe<NuveiSavedCardVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `NuveiSavedCard` objects. */
  varianceSample?: InputMaybe<NuveiSavedCardVarianceSampleAggregateFilter>;
};

export type NuveiSavedCardAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NuveiSavedCardAverageAggregates = {
  __typename?: 'NuveiSavedCardAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `NuveiSavedCard` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NuveiSavedCardCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `NuveiSavedCard` values. */
export type NuveiSavedCardConnection = {
  __typename?: 'NuveiSavedCardConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<NuveiSavedCardAggregates>;
  /** A list of edges which contains the `NuveiSavedCard` and cursor to aid in pagination. */
  edges: Array<Maybe<NuveiSavedCardEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<NuveiSavedCardAggregates>>;
  /** A list of `NuveiSavedCard` objects. */
  nodes: Array<Maybe<NuveiSavedCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NuveiSavedCard` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `NuveiSavedCard` values. */
export type NuveiSavedCardConnectionGroupedAggregatesArgs = {
  groupBy: Array<NuveiSavedCardGroupBy>;
  having?: InputMaybe<NuveiSavedCardHavingInput>;
};

export type NuveiSavedCardDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type NuveiSavedCardDistinctCountAggregates = {
  __typename?: 'NuveiSavedCardDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cardNumber across the matching connection */
  cardNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cvv across the matching connection */
  cvv?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of defaultCard across the matching connection */
  defaultCard?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expirationMonth across the matching connection */
  expirationMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expirationYear across the matching connection */
  expirationYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fullName across the matching connection */
  fullName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userPaymentOptionId across the matching connection */
  userPaymentOptionId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `NuveiSavedCard` edge in the connection. */
export type NuveiSavedCardEdge = {
  __typename?: 'NuveiSavedCardEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NuveiSavedCard` at the end of the edge. */
  node?: Maybe<NuveiSavedCard>;
};

/** A filter to be used against `NuveiSavedCard` object types. All fields are combined with a logical ‘and.’ */
export type NuveiSavedCardFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NuveiSavedCardFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<NuveiSavedCardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NuveiSavedCardFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `NuveiSavedCard` for usage during aggregation. */
export enum NuveiSavedCardGroupBy {
  UserId = 'USER_ID'
}

export type NuveiSavedCardHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `NuveiSavedCard` aggregates. */
export type NuveiSavedCardHavingInput = {
  AND?: InputMaybe<Array<NuveiSavedCardHavingInput>>;
  OR?: InputMaybe<Array<NuveiSavedCardHavingInput>>;
  average?: InputMaybe<NuveiSavedCardHavingAverageInput>;
  distinctCount?: InputMaybe<NuveiSavedCardHavingDistinctCountInput>;
  max?: InputMaybe<NuveiSavedCardHavingMaxInput>;
  min?: InputMaybe<NuveiSavedCardHavingMinInput>;
  stddevPopulation?: InputMaybe<NuveiSavedCardHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<NuveiSavedCardHavingStddevSampleInput>;
  sum?: InputMaybe<NuveiSavedCardHavingSumInput>;
  variancePopulation?: InputMaybe<NuveiSavedCardHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<NuveiSavedCardHavingVarianceSampleInput>;
};

export type NuveiSavedCardHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type NuveiSavedCardMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NuveiSavedCardMaxAggregates = {
  __typename?: 'NuveiSavedCardMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type NuveiSavedCardMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NuveiSavedCardMinAggregates = {
  __typename?: 'NuveiSavedCardMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `NuveiSavedCard`. */
export enum NuveiSavedCardOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type NuveiSavedCardStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NuveiSavedCardStddevPopulationAggregates = {
  __typename?: 'NuveiSavedCardStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NuveiSavedCardStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NuveiSavedCardStddevSampleAggregates = {
  __typename?: 'NuveiSavedCardStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NuveiSavedCardSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type NuveiSavedCardSumAggregates = {
  __typename?: 'NuveiSavedCardSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type NuveiSavedCardVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NuveiSavedCardVariancePopulationAggregates = {
  __typename?: 'NuveiSavedCardVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NuveiSavedCardVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type NuveiSavedCardVarianceSampleAggregates = {
  __typename?: 'NuveiSavedCardVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type NuveiSavedPaypalArchived = Node & {
  __typename?: 'NuveiSavedPaypalArchived';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
  userPaymentOptionId: Scalars['String']['output'];
};

export type NuveiWebhook = Node & {
  __typename?: 'NuveiWebhook';
  bin?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardProcessorStatus?: Maybe<Scalars['String']['output']>;
  clientUniqueId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  customData?: Maybe<Scalars['JSON']['output']>;
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  merchantUniqueId?: Maybe<Scalars['String']['output']>;
  nameOnCard?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  totalAmount?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
  userPaymentOptionId?: Maybe<Scalars['String']['output']>;
};

export type OfacsdnRecord = Node & {
  __typename?: 'OfacsdnRecord';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  internalStatus?: Maybe<Scalars['String']['output']>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['Int']['output'];
  s3Url?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `OfacsdnRecord`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  veriffReference?: Maybe<Scalars['String']['output']>;
};

export type OfacsdnRecordAggregates = {
  __typename?: 'OfacsdnRecordAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OfacsdnRecordAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OfacsdnRecordDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OfacsdnRecordMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OfacsdnRecordMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OfacsdnRecordStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OfacsdnRecordStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OfacsdnRecordSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OfacsdnRecordVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OfacsdnRecordVarianceSampleAggregates>;
};

export type OfacsdnRecordAverageAggregates = {
  __typename?: 'OfacsdnRecordAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OfacsdnRecord` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OfacsdnRecordCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `internalStatus` field. */
  internalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `matchStatus` field. */
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `OfacsdnRecord` values. */
export type OfacsdnRecordConnection = {
  __typename?: 'OfacsdnRecordConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OfacsdnRecordAggregates>;
  /** A list of edges which contains the `OfacsdnRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<OfacsdnRecordEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OfacsdnRecordAggregates>>;
  /** A list of `OfacsdnRecord` objects. */
  nodes: Array<Maybe<OfacsdnRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OfacsdnRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OfacsdnRecord` values. */
export type OfacsdnRecordConnectionGroupedAggregatesArgs = {
  groupBy: Array<OfacsdnRecordGroupBy>;
  having?: InputMaybe<OfacsdnRecordHavingInput>;
};

export type OfacsdnRecordDistinctCountAggregates = {
  __typename?: 'OfacsdnRecordDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of internalStatus across the matching connection */
  internalStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of matchStatus across the matching connection */
  matchStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadata across the matching connection */
  metadata?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of s3Url across the matching connection */
  s3Url?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of submittedAt across the matching connection */
  submittedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of veriffReference across the matching connection */
  veriffReference?: Maybe<Scalars['BigInt']['output']>;
};

/** A `OfacsdnRecord` edge in the connection. */
export type OfacsdnRecordEdge = {
  __typename?: 'OfacsdnRecordEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OfacsdnRecord` at the end of the edge. */
  node?: Maybe<OfacsdnRecord>;
};

/** A filter to be used against `OfacsdnRecord` object types. All fields are combined with a logical ‘and.’ */
export type OfacsdnRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OfacsdnRecordFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `internalStatus` field. */
  internalStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `matchStatus` field. */
  matchStatus?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OfacsdnRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OfacsdnRecordFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `OfacsdnRecord` for usage during aggregation. */
export enum OfacsdnRecordGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  InternalStatus = 'INTERNAL_STATUS',
  MatchStatus = 'MATCH_STATUS'
}

export type OfacsdnRecordHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `OfacsdnRecord` aggregates. */
export type OfacsdnRecordHavingInput = {
  AND?: InputMaybe<Array<OfacsdnRecordHavingInput>>;
  OR?: InputMaybe<Array<OfacsdnRecordHavingInput>>;
  average?: InputMaybe<OfacsdnRecordHavingAverageInput>;
  distinctCount?: InputMaybe<OfacsdnRecordHavingDistinctCountInput>;
  max?: InputMaybe<OfacsdnRecordHavingMaxInput>;
  min?: InputMaybe<OfacsdnRecordHavingMinInput>;
  stddevPopulation?: InputMaybe<OfacsdnRecordHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OfacsdnRecordHavingStddevSampleInput>;
  sum?: InputMaybe<OfacsdnRecordHavingSumInput>;
  variancePopulation?: InputMaybe<OfacsdnRecordHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OfacsdnRecordHavingVarianceSampleInput>;
};

export type OfacsdnRecordHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type OfacsdnRecordMaxAggregates = {
  __typename?: 'OfacsdnRecordMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OfacsdnRecordMinAggregates = {
  __typename?: 'OfacsdnRecordMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `OfacsdnRecord`. */
export enum OfacsdnRecordOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  InternalStatusAsc = 'INTERNAL_STATUS_ASC',
  InternalStatusDesc = 'INTERNAL_STATUS_DESC',
  MatchStatusAsc = 'MATCH_STATUS_ASC',
  MatchStatusDesc = 'MATCH_STATUS_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type OfacsdnRecordStddevPopulationAggregates = {
  __typename?: 'OfacsdnRecordStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OfacsdnRecordStddevSampleAggregates = {
  __typename?: 'OfacsdnRecordStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OfacsdnRecordSumAggregates = {
  __typename?: 'OfacsdnRecordSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type OfacsdnRecordVariancePopulationAggregates = {
  __typename?: 'OfacsdnRecordVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OfacsdnRecordVarianceSampleAggregates = {
  __typename?: 'OfacsdnRecordVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OrderFulfillment = Node & {
  __typename?: 'OrderFulfillment';
  /** Reads a single `Account` that is related to this `OrderFulfillment`. */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  erpInvoiceId?: Maybe<Scalars['String']['output']>;
  eventLog: Scalars['JSON']['output'];
  fulfillmentStepLockedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `PurchaseOrder` that is related to this `OrderFulfillment`. */
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  status: OrderFulfillmentStatusEnum;
  /** Reads a single `NmiSubscription` that is related to this `OrderFulfillment`. */
  subscription?: Maybe<NmiSubscription>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  type: OrderFulfillmentTypeEnum;
  updatedAt: Scalars['Datetime']['output'];
};

export type OrderFulfillmentAggregates = {
  __typename?: 'OrderFulfillmentAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OrderFulfillmentAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OrderFulfillmentDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OrderFulfillmentMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OrderFulfillmentMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OrderFulfillmentStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OrderFulfillmentStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OrderFulfillmentSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OrderFulfillmentVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OrderFulfillmentVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OrderFulfillment` object types. */
export type OrderFulfillmentAggregatesFilter = {
  /** Mean average aggregate over matching `OrderFulfillment` objects. */
  average?: InputMaybe<OrderFulfillmentAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OrderFulfillment` objects. */
  distinctCount?: InputMaybe<OrderFulfillmentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OrderFulfillment` object to be included within the aggregate. */
  filter?: InputMaybe<OrderFulfillmentFilter>;
  /** Maximum aggregate over matching `OrderFulfillment` objects. */
  max?: InputMaybe<OrderFulfillmentMaxAggregateFilter>;
  /** Minimum aggregate over matching `OrderFulfillment` objects. */
  min?: InputMaybe<OrderFulfillmentMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OrderFulfillment` objects. */
  stddevPopulation?: InputMaybe<OrderFulfillmentStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OrderFulfillment` objects. */
  stddevSample?: InputMaybe<OrderFulfillmentStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OrderFulfillment` objects. */
  sum?: InputMaybe<OrderFulfillmentSumAggregateFilter>;
  /** Population variance aggregate over matching `OrderFulfillment` objects. */
  variancePopulation?: InputMaybe<OrderFulfillmentVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OrderFulfillment` objects. */
  varianceSample?: InputMaybe<OrderFulfillmentVarianceSampleAggregateFilter>;
};

export type OrderFulfillmentAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
};

export type OrderFulfillmentAverageAggregates = {
  __typename?: 'OrderFulfillmentAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OrderFulfillment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrderFulfillmentCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `accountName` field. */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `erpInvoiceId` field. */
  erpInvoiceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fulfillmentStepLockedAt` field. */
  fulfillmentStepLockedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `OrderFulfillment` values. */
export type OrderFulfillmentConnection = {
  __typename?: 'OrderFulfillmentConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OrderFulfillmentAggregates>;
  /** A list of edges which contains the `OrderFulfillment` and cursor to aid in pagination. */
  edges: Array<Maybe<OrderFulfillmentEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OrderFulfillmentAggregates>>;
  /** A list of `OrderFulfillment` objects. */
  nodes: Array<Maybe<OrderFulfillment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderFulfillment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OrderFulfillment` values. */
export type OrderFulfillmentConnectionGroupedAggregatesArgs = {
  groupBy: Array<OrderFulfillmentGroupBy>;
  having?: InputMaybe<OrderFulfillmentHavingInput>;
};

export type OrderFulfillmentDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  accountName?: InputMaybe<BigIntFilter>;
  erpInvoiceId?: InputMaybe<BigIntFilter>;
  fulfillmentStepLockedAt?: InputMaybe<BigIntFilter>;
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type OrderFulfillmentDistinctCountAggregates = {
  __typename?: 'OrderFulfillmentDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountName across the matching connection */
  accountName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of erpInvoiceId across the matching connection */
  erpInvoiceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fulfillmentStepLockedAt across the matching connection */
  fulfillmentStepLockedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `OrderFulfillment` edge in the connection. */
export type OrderFulfillmentEdge = {
  __typename?: 'OrderFulfillmentEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderFulfillment` at the end of the edge. */
  node?: Maybe<OrderFulfillment>;
};

/** A filter to be used against `OrderFulfillment` object types. All fields are combined with a logical ‘and.’ */
export type OrderFulfillmentFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** A related `account` exists. */
  accountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountName` field. */
  accountName?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderFulfillmentFilter>>;
  /** Filter by the object’s `erpInvoiceId` field. */
  erpInvoiceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fulfillmentStepLockedAt` field. */
  fulfillmentStepLockedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderFulfillmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderFulfillmentFilter>>;
  /** Filter by the object’s `purchaseOrder` relation. */
  purchaseOrder?: InputMaybe<PurchaseOrderFilter>;
  /** Filter by the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<OrderFulfillmentStatusEnumFilter>;
  /** Filter by the object’s `subscription` relation. */
  subscription?: InputMaybe<NmiSubscriptionFilter>;
  /** A related `subscription` exists. */
  subscriptionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<OrderFulfillmentTypeEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `OrderFulfillment` for usage during aggregation. */
export enum OrderFulfillmentGroupBy {
  AccountName = 'ACCOUNT_NAME',
  ErpInvoiceId = 'ERP_INVOICE_ID',
  FulfillmentStepLockedAt = 'FULFILLMENT_STEP_LOCKED_AT',
  FulfillmentStepLockedAtTruncatedToDay = 'FULFILLMENT_STEP_LOCKED_AT_TRUNCATED_TO_DAY',
  FulfillmentStepLockedAtTruncatedToHour = 'FULFILLMENT_STEP_LOCKED_AT_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  SubscriptionId = 'SUBSCRIPTION_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedAtTruncatedToDay = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UpdatedAtTruncatedToHour = 'UPDATED_AT_TRUNCATED_TO_HOUR'
}

export type OrderFulfillmentHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `OrderFulfillment` aggregates. */
export type OrderFulfillmentHavingInput = {
  AND?: InputMaybe<Array<OrderFulfillmentHavingInput>>;
  OR?: InputMaybe<Array<OrderFulfillmentHavingInput>>;
  average?: InputMaybe<OrderFulfillmentHavingAverageInput>;
  distinctCount?: InputMaybe<OrderFulfillmentHavingDistinctCountInput>;
  max?: InputMaybe<OrderFulfillmentHavingMaxInput>;
  min?: InputMaybe<OrderFulfillmentHavingMinInput>;
  stddevPopulation?: InputMaybe<OrderFulfillmentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OrderFulfillmentHavingStddevSampleInput>;
  sum?: InputMaybe<OrderFulfillmentHavingSumInput>;
  variancePopulation?: InputMaybe<OrderFulfillmentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OrderFulfillmentHavingVarianceSampleInput>;
};

export type OrderFulfillmentHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  fulfillmentStepLockedAt?: InputMaybe<HavingDatetimeFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OrderFulfillmentMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  purchaseOrderId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
};

export type OrderFulfillmentMaxAggregates = {
  __typename?: 'OrderFulfillmentMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
};

export type OrderFulfillmentMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  purchaseOrderId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
};

export type OrderFulfillmentMinAggregates = {
  __typename?: 'OrderFulfillmentMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `OrderFulfillment`. */
export enum OrderFulfillmentOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountNameAsc = 'ACCOUNT_NAME_ASC',
  AccountNameDesc = 'ACCOUNT_NAME_DESC',
  ErpInvoiceIdAsc = 'ERP_INVOICE_ID_ASC',
  ErpInvoiceIdDesc = 'ERP_INVOICE_ID_DESC',
  FulfillmentStepLockedAtAsc = 'FULFILLMENT_STEP_LOCKED_AT_ASC',
  FulfillmentStepLockedAtDesc = 'FULFILLMENT_STEP_LOCKED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaseOrderIdAsc = 'PURCHASE_ORDER_ID_ASC',
  PurchaseOrderIdDesc = 'PURCHASE_ORDER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum OrderFulfillmentStatusEnum {
  Errored = 'errored',
  Fulfilled = 'fulfilled',
  InProgress = 'in_progress',
  Refunded = 'refunded',
  Skipped = 'skipped'
}

/** A filter to be used against OrderFulfillmentStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type OrderFulfillmentStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrderFulfillmentStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrderFulfillmentStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrderFulfillmentStatusEnum>>;
};

export type OrderFulfillmentStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
};

export type OrderFulfillmentStddevPopulationAggregates = {
  __typename?: 'OrderFulfillmentStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OrderFulfillmentStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
};

export type OrderFulfillmentStddevSampleAggregates = {
  __typename?: 'OrderFulfillmentStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OrderFulfillmentSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
};

export type OrderFulfillmentSumAggregates = {
  __typename?: 'OrderFulfillmentSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of purchaseOrderId across the matching connection */
  purchaseOrderId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
};

export enum OrderFulfillmentTypeEnum {
  Initial = 'initial',
  OneTime = 'one_time',
  Renewal = 'renewal'
}

/** A filter to be used against OrderFulfillmentTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type OrderFulfillmentTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrderFulfillmentTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrderFulfillmentTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrderFulfillmentTypeEnum>>;
};

export type OrderFulfillmentVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
};

export type OrderFulfillmentVariancePopulationAggregates = {
  __typename?: 'OrderFulfillmentVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OrderFulfillmentVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
};

export type OrderFulfillmentVarianceSampleAggregates = {
  __typename?: 'OrderFulfillmentVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Outbox = Node & {
  __typename?: 'Outbox';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  nextAttemptAt: Scalars['Datetime']['output'];
  payload: Scalars['JSON']['output'];
  publishedAt?: Maybe<Scalars['Datetime']['output']>;
  retryCount: Scalars['Int']['output'];
  rowId: Scalars['UUID']['output'];
  subject: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Partner = Node & {
  __typename?: 'Partner';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  partnerCode: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  street: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  zip: Scalars['String']['output'];
};

export type PartnerTransaction = Node & {
  __typename?: 'PartnerTransaction';
  compAmount: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  partnerId: Scalars['Int']['output'];
  purchaseId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type PasswordHistory = Node & {
  __typename?: 'PasswordHistory';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  passwordHash: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PasswordHistory`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type PasswordHistoryAggregates = {
  __typename?: 'PasswordHistoryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PasswordHistoryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PasswordHistoryDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PasswordHistoryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PasswordHistoryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PasswordHistoryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PasswordHistoryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PasswordHistorySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PasswordHistoryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PasswordHistoryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PasswordHistory` object types. */
export type PasswordHistoryAggregatesFilter = {
  /** Mean average aggregate over matching `PasswordHistory` objects. */
  average?: InputMaybe<PasswordHistoryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PasswordHistory` objects. */
  distinctCount?: InputMaybe<PasswordHistoryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PasswordHistory` object to be included within the aggregate. */
  filter?: InputMaybe<PasswordHistoryFilter>;
  /** Maximum aggregate over matching `PasswordHistory` objects. */
  max?: InputMaybe<PasswordHistoryMaxAggregateFilter>;
  /** Minimum aggregate over matching `PasswordHistory` objects. */
  min?: InputMaybe<PasswordHistoryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PasswordHistory` objects. */
  stddevPopulation?: InputMaybe<PasswordHistoryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PasswordHistory` objects. */
  stddevSample?: InputMaybe<PasswordHistoryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PasswordHistory` objects. */
  sum?: InputMaybe<PasswordHistorySumAggregateFilter>;
  /** Population variance aggregate over matching `PasswordHistory` objects. */
  variancePopulation?: InputMaybe<PasswordHistoryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PasswordHistory` objects. */
  varianceSample?: InputMaybe<PasswordHistoryVarianceSampleAggregateFilter>;
};

export type PasswordHistoryAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PasswordHistoryAverageAggregates = {
  __typename?: 'PasswordHistoryAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PasswordHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PasswordHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PasswordHistory` values. */
export type PasswordHistoryConnection = {
  __typename?: 'PasswordHistoryConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PasswordHistoryAggregates>;
  /** A list of edges which contains the `PasswordHistory` and cursor to aid in pagination. */
  edges: Array<Maybe<PasswordHistoryEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PasswordHistoryAggregates>>;
  /** A list of `PasswordHistory` objects. */
  nodes: Array<Maybe<PasswordHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PasswordHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PasswordHistory` values. */
export type PasswordHistoryConnectionGroupedAggregatesArgs = {
  groupBy: Array<PasswordHistoryGroupBy>;
  having?: InputMaybe<PasswordHistoryHavingInput>;
};

export type PasswordHistoryDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PasswordHistoryDistinctCountAggregates = {
  __typename?: 'PasswordHistoryDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of passwordHash across the matching connection */
  passwordHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PasswordHistory` edge in the connection. */
export type PasswordHistoryEdge = {
  __typename?: 'PasswordHistoryEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PasswordHistory` at the end of the edge. */
  node?: Maybe<PasswordHistory>;
};

/** A filter to be used against `PasswordHistory` object types. All fields are combined with a logical ‘and.’ */
export type PasswordHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PasswordHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PasswordHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PasswordHistoryFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PasswordHistory` for usage during aggregation. */
export enum PasswordHistoryGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type PasswordHistoryHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PasswordHistory` aggregates. */
export type PasswordHistoryHavingInput = {
  AND?: InputMaybe<Array<PasswordHistoryHavingInput>>;
  OR?: InputMaybe<Array<PasswordHistoryHavingInput>>;
  average?: InputMaybe<PasswordHistoryHavingAverageInput>;
  distinctCount?: InputMaybe<PasswordHistoryHavingDistinctCountInput>;
  max?: InputMaybe<PasswordHistoryHavingMaxInput>;
  min?: InputMaybe<PasswordHistoryHavingMinInput>;
  stddevPopulation?: InputMaybe<PasswordHistoryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PasswordHistoryHavingStddevSampleInput>;
  sum?: InputMaybe<PasswordHistoryHavingSumInput>;
  variancePopulation?: InputMaybe<PasswordHistoryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PasswordHistoryHavingVarianceSampleInput>;
};

export type PasswordHistoryHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PasswordHistoryMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PasswordHistoryMaxAggregates = {
  __typename?: 'PasswordHistoryMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PasswordHistoryMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PasswordHistoryMinAggregates = {
  __typename?: 'PasswordHistoryMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PasswordHistory`. */
export enum PasswordHistoryOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type PasswordHistoryStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PasswordHistoryStddevPopulationAggregates = {
  __typename?: 'PasswordHistoryStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PasswordHistoryStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PasswordHistoryStddevSampleAggregates = {
  __typename?: 'PasswordHistoryStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PasswordHistorySumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PasswordHistorySumAggregates = {
  __typename?: 'PasswordHistorySumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type PasswordHistoryVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PasswordHistoryVariancePopulationAggregates = {
  __typename?: 'PasswordHistoryVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PasswordHistoryVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PasswordHistoryVarianceSampleAggregates = {
  __typename?: 'PasswordHistoryVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PathToFunding = {
  __typename?: 'PathToFunding';
  balance: Scalars['Float']['output'];
  closedTotalPnL: Scalars['Float']['output'];
  objectives: Array<PathToFundingObjective>;
  rules: Array<PathToFundingRule>;
};

export type PathToFundingObjective = {
  __typename?: 'PathToFundingObjective';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PathToFundingRule = {
  __typename?: 'PathToFundingRule';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PaymentGateway = Node & {
  __typename?: 'PaymentGateway';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/** A filter to be used against `PaymentGateway` object types. All fields are combined with a logical ‘and.’ */
export type PaymentGatewayFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PaymentGatewayFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PaymentGatewayFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PaymentGatewayFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutActivityActor = {
  __typename?: 'PayoutActivityActor';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isSystem: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PayoutActivityEvent = {
  __typename?: 'PayoutActivityEvent';
  actor?: Maybe<PayoutActivityActor>;
  note?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  payoutReturn?: Maybe<PayoutActivityReturn>;
  summary: Scalars['String']['output'];
  type: PayoutActivityType;
};

export type PayoutActivityReturn = {
  __typename?: 'PayoutActivityReturn';
  additionalDetails?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  reasonCode: Scalars['String']['output'];
  reasonLabel: Scalars['String']['output'];
  returnedOn?: Maybe<Scalars['String']['output']>;
};

export enum PayoutActivityType {
  AddedToBatch = 'ADDED_TO_BATCH',
  AdminInitiated = 'ADMIN_INITIATED',
  AutoApprovalRevoked = 'AUTO_APPROVAL_REVOKED',
  BankEntered = 'BANK_ENTERED',
  ComplianceApproved = 'COMPLIANCE_APPROVED',
  FinanceApproved = 'FINANCE_APPROVED',
  InvestigationHold = 'INVESTIGATION_HOLD',
  InvestigationRelease = 'INVESTIGATION_RELEASE',
  PayoutMethodChanged = 'PAYOUT_METHOD_CHANGED',
  RemovedFromBatch = 'REMOVED_FROM_BATCH',
  Reopened = 'REOPENED',
  Resubmitted = 'RESUBMITTED',
  Returned = 'RETURNED',
  ReviewApproved = 'REVIEW_APPROVED',
  ReviewDenied = 'REVIEW_DENIED',
  ReviewNote = 'REVIEW_NOTE',
  RiskApproved = 'RISK_APPROVED',
  Submitted = 'SUBMITTED',
  TraderCompleted = 'TRADER_COMPLETED',
  TradeDeskApproved = 'TRADE_DESK_APPROVED',
  UndoBankEntry = 'UNDO_BANK_ENTRY'
}

export type PayoutCycle = Node & {
  __typename?: 'PayoutCycle';
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payoutDate?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type PayoutDepartmentApproval = Node & {
  __typename?: 'PayoutDepartmentApproval';
  approved?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  department: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `PayoutRequest` that is related to this `PayoutDepartmentApproval`. */
  payout?: Maybe<PayoutRequest>;
  payoutId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PayoutDepartmentApproval`. */
  user?: Maybe<User>;
};

export type PayoutDepartmentApprovalAggregates = {
  __typename?: 'PayoutDepartmentApprovalAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutDepartmentApprovalAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutDepartmentApprovalDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutDepartmentApprovalMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutDepartmentApprovalMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutDepartmentApprovalStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutDepartmentApprovalStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutDepartmentApprovalSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutDepartmentApprovalVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutDepartmentApprovalVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutDepartmentApproval` object types. */
export type PayoutDepartmentApprovalAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutDepartmentApproval` objects. */
  average?: InputMaybe<PayoutDepartmentApprovalAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutDepartmentApproval` objects. */
  distinctCount?: InputMaybe<PayoutDepartmentApprovalDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutDepartmentApproval` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutDepartmentApprovalFilter>;
  /** Maximum aggregate over matching `PayoutDepartmentApproval` objects. */
  max?: InputMaybe<PayoutDepartmentApprovalMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutDepartmentApproval` objects. */
  min?: InputMaybe<PayoutDepartmentApprovalMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutDepartmentApproval` objects. */
  stddevPopulation?: InputMaybe<PayoutDepartmentApprovalStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutDepartmentApproval` objects. */
  stddevSample?: InputMaybe<PayoutDepartmentApprovalStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutDepartmentApproval` objects. */
  sum?: InputMaybe<PayoutDepartmentApprovalSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutDepartmentApproval` objects. */
  variancePopulation?: InputMaybe<PayoutDepartmentApprovalVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutDepartmentApproval` objects. */
  varianceSample?: InputMaybe<PayoutDepartmentApprovalVarianceSampleAggregateFilter>;
};

export type PayoutDepartmentApprovalAverageAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutDepartmentApprovalAverageAggregates = {
  __typename?: 'PayoutDepartmentApprovalAverageAggregates';
  /** Mean average of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutDepartmentApproval` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PayoutDepartmentApprovalCondition = {
  /** Checks for equality with the object’s `department` field. */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutDepartmentApproval` values. */
export type PayoutDepartmentApprovalConnection = {
  __typename?: 'PayoutDepartmentApprovalConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutDepartmentApprovalAggregates>;
  /** A list of edges which contains the `PayoutDepartmentApproval` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutDepartmentApprovalEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutDepartmentApprovalAggregates>>;
  /** A list of `PayoutDepartmentApproval` objects. */
  nodes: Array<Maybe<PayoutDepartmentApproval>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutDepartmentApproval` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutDepartmentApproval` values. */
export type PayoutDepartmentApprovalConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutDepartmentApprovalGroupBy>;
  having?: InputMaybe<PayoutDepartmentApprovalHavingInput>;
};

export type PayoutDepartmentApprovalDistinctCountAggregateFilter = {
  department?: InputMaybe<BigIntFilter>;
  payoutId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutDepartmentApprovalDistinctCountAggregates = {
  __typename?: 'PayoutDepartmentApprovalDistinctCountAggregates';
  /** Distinct count of approved across the matching connection */
  approved?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of department across the matching connection */
  department?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutDepartmentApproval` edge in the connection. */
export type PayoutDepartmentApprovalEdge = {
  __typename?: 'PayoutDepartmentApprovalEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutDepartmentApproval` at the end of the edge. */
  node?: Maybe<PayoutDepartmentApproval>;
};

/** A filter to be used against `PayoutDepartmentApproval` object types. All fields are combined with a logical ‘and.’ */
export type PayoutDepartmentApprovalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutDepartmentApprovalFilter>>;
  /** Filter by the object’s `department` field. */
  department?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutDepartmentApprovalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutDepartmentApprovalFilter>>;
  /** Filter by the object’s `payout` relation. */
  payout?: InputMaybe<PayoutRequestFilter>;
  /** Filter by the object’s `payoutId` field. */
  payoutId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `PayoutDepartmentApproval` for usage during aggregation. */
export enum PayoutDepartmentApprovalGroupBy {
  Department = 'DEPARTMENT',
  PayoutId = 'PAYOUT_ID'
}

export type PayoutDepartmentApprovalHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PayoutDepartmentApproval` aggregates. */
export type PayoutDepartmentApprovalHavingInput = {
  AND?: InputMaybe<Array<PayoutDepartmentApprovalHavingInput>>;
  OR?: InputMaybe<Array<PayoutDepartmentApprovalHavingInput>>;
  average?: InputMaybe<PayoutDepartmentApprovalHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutDepartmentApprovalHavingDistinctCountInput>;
  max?: InputMaybe<PayoutDepartmentApprovalHavingMaxInput>;
  min?: InputMaybe<PayoutDepartmentApprovalHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutDepartmentApprovalHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutDepartmentApprovalHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutDepartmentApprovalHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutDepartmentApprovalHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutDepartmentApprovalHavingVarianceSampleInput>;
};

export type PayoutDepartmentApprovalHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdatedBy?: InputMaybe<HavingIntFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutDepartmentApprovalMaxAggregateFilter = {
  payoutId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutDepartmentApprovalMaxAggregates = {
  __typename?: 'PayoutDepartmentApprovalMaxAggregates';
  /** Maximum of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutDepartmentApprovalMinAggregateFilter = {
  payoutId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutDepartmentApprovalMinAggregates = {
  __typename?: 'PayoutDepartmentApprovalMinAggregates';
  /** Minimum of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutDepartmentApproval`. */
export enum PayoutDepartmentApprovalOrderBy {
  DepartmentAsc = 'DEPARTMENT_ASC',
  DepartmentDesc = 'DEPARTMENT_DESC',
  Natural = 'NATURAL',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type PayoutDepartmentApprovalStddevPopulationAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutDepartmentApprovalStddevPopulationAggregates = {
  __typename?: 'PayoutDepartmentApprovalStddevPopulationAggregates';
  /** Population standard deviation of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutDepartmentApprovalStddevSampleAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutDepartmentApprovalStddevSampleAggregates = {
  __typename?: 'PayoutDepartmentApprovalStddevSampleAggregates';
  /** Sample standard deviation of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutDepartmentApprovalSumAggregateFilter = {
  payoutId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutDepartmentApprovalSumAggregates = {
  __typename?: 'PayoutDepartmentApprovalSumAggregates';
  /** Sum of lastUpdatedBy across the matching connection */
  lastUpdatedBy: Scalars['BigInt']['output'];
  /** Sum of payoutId across the matching connection */
  payoutId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type PayoutDepartmentApprovalVariancePopulationAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutDepartmentApprovalVariancePopulationAggregates = {
  __typename?: 'PayoutDepartmentApprovalVariancePopulationAggregates';
  /** Population variance of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutDepartmentApprovalVarianceSampleAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutDepartmentApprovalVarianceSampleAggregates = {
  __typename?: 'PayoutDepartmentApprovalVarianceSampleAggregates';
  /** Sample variance of lastUpdatedBy across the matching connection */
  lastUpdatedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequest = Node & {
  __typename?: 'PayoutRequest';
  /** Reads a single `Account` that is related to this `PayoutRequest`. */
  account?: Maybe<Account>;
  /** Reads a single `AccountCallUpDecision` that is related to this `PayoutRequest`. */
  accountCallUpDecision?: Maybe<AccountCallUpDecision>;
  /** Reads a single `AccountLiveCallUp` that is related to this `PayoutRequest`. */
  accountCallUpDecisionAccount?: Maybe<AccountLiveCallUp>;
  accountCallUpDecisionId?: Maybe<Scalars['UUID']['output']>;
  accountId: Scalars['Int']['output'];
  /** Reads a single `AccountLiveCallUp` that is related to this `PayoutRequest`. */
  accountLiveCallUp?: Maybe<AccountLiveCallUp>;
  adminInitiated: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  approvingUserId: Scalars['Int']['output'];
  assignedDepartment?: Maybe<Scalars['String']['output']>;
  bankInfoEnteredAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  departmentApprovals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exception?: Maybe<Scalars['Boolean']['output']>;
  exceptionNote?: Maybe<Scalars['String']['output']>;
  finalizedAt?: Maybe<Scalars['Datetime']['output']>;
  financeApprovedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** The unbacked seed-capital gap frozen by this payout. Ratchets permanently: later profit becomes DPOP, never seed capital recovery. */
  impairmentRealized: Scalars['BigFloat']['output'];
  method?: Maybe<Scalars['String']['output']>;
  netSuiteBillId?: Maybe<Scalars['String']['output']>;
  netSuitePaymentId?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  paid?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `PayoutDepartmentApproval`. */
  payoutDepartmentApprovalsByPayoutId: PayoutDepartmentApprovalConnection;
  payoutOptionHandle?: Maybe<Scalars['String']['output']>;
  payoutOptionKind?: Maybe<Scalars['String']['output']>;
  payoutPath?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PayoutRequestAsset`. */
  payoutRequestAssets: PayoutRequestAssetConnection;
  /** Reads a single `PayoutRequestBatchItem` that is related to this `PayoutRequest`. */
  payoutRequestBatchItem?: Maybe<PayoutRequestBatchItem>;
  /** Reads and enables pagination through a set of `PayoutRequestSubscriber`. */
  payoutRequestSubscribers: PayoutRequestSubscriberConnection;
  /** Reads and enables pagination through a set of `PayoutReturn`. */
  payoutReturns: PayoutReturnConnection;
  /** Reads and enables pagination through a set of `PayoutReviewer`. */
  payoutReviewersByPayoutId: PayoutReviewerConnection;
  /** Reads and enables pagination through a set of `PayoutReview`. */
  payoutReviewsByPayoutId: PayoutReviewConnection;
  reference: Scalars['String']['output'];
  reopenedAt?: Maybe<Scalars['Datetime']['output']>;
  requestedAmount?: Maybe<Scalars['Int']['output']>;
  /** Did this payout reset the winning-days counter? Named for the effect, not the cause: "did this draw seed capital" is unanswerable for pre-GTM rows. NULL = pre-GTM (anchors the window, old rules). true = post-GTM seed draw. false = post-GTM DPOP-only. */
  resetsWinningDays?: Maybe<Scalars['Boolean']['output']>;
  rowId: Scalars['Int']['output'];
  /** Portion of the gross request drawn from seed capital. 0 means a pure DPOP draw. Computed server-side at request time on the requestedAmount basis, then frozen. */
  seedCapitalAmount: Scalars['BigFloat']['output'];
  status: Scalars['String']['output'];
  statusNote?: Maybe<Scalars['String']['output']>;
  targetCurrency?: Maybe<Scalars['String']['output']>;
  tradedProducts?: Maybe<Array<TradedProductLots>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PayoutRequest`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type PayoutRequestPayoutDepartmentApprovalsByPayoutIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutDepartmentApprovalCondition>;
  filter?: InputMaybe<PayoutDepartmentApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutDepartmentApprovalOrderBy>>;
};


export type PayoutRequestPayoutRequestAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestAssetCondition>;
  filter?: InputMaybe<PayoutRequestAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestAssetOrderBy>>;
};


export type PayoutRequestPayoutRequestSubscribersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestSubscriberCondition>;
  filter?: InputMaybe<PayoutRequestSubscriberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestSubscriberOrderBy>>;
};


export type PayoutRequestPayoutReturnsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutReturnCondition>;
  filter?: InputMaybe<PayoutReturnFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutReturnOrderBy>>;
};


export type PayoutRequestPayoutReviewersByPayoutIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutReviewerCondition>;
  filter?: InputMaybe<PayoutReviewerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutReviewerOrderBy>>;
};


export type PayoutRequestPayoutReviewsByPayoutIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutReviewCondition>;
  filter?: InputMaybe<PayoutReviewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutReviewOrderBy>>;
};

export type PayoutRequestAggregates = {
  __typename?: 'PayoutRequestAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutRequestAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutRequestDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutRequestMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutRequestMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutRequestStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutRequestStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutRequestSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutRequestVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutRequestVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutRequest` object types. */
export type PayoutRequestAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutRequest` objects. */
  average?: InputMaybe<PayoutRequestAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutRequest` objects. */
  distinctCount?: InputMaybe<PayoutRequestDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutRequest` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutRequestFilter>;
  /** Maximum aggregate over matching `PayoutRequest` objects. */
  max?: InputMaybe<PayoutRequestMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutRequest` objects. */
  min?: InputMaybe<PayoutRequestMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutRequest` objects. */
  stddevPopulation?: InputMaybe<PayoutRequestStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutRequest` objects. */
  stddevSample?: InputMaybe<PayoutRequestStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutRequest` objects. */
  sum?: InputMaybe<PayoutRequestSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutRequest` objects. */
  variancePopulation?: InputMaybe<PayoutRequestVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutRequest` objects. */
  varianceSample?: InputMaybe<PayoutRequestVarianceSampleAggregateFilter>;
};

export type PayoutRequestAsset = Node & {
  __typename?: 'PayoutRequestAsset';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  displayImageUrl?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['Datetime']['output']>;
  generationPayload?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payloadHash?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PayoutRequest` that is related to this `PayoutRequestAsset`. */
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  renderedIdentity?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
  socialUrl?: Maybe<Scalars['String']['output']>;
  status: PayoutRequestAssetStatusEnum;
  templateVersion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  variants?: Maybe<Scalars['JSON']['output']>;
};

export type PayoutRequestAssetAggregates = {
  __typename?: 'PayoutRequestAssetAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutRequestAssetAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutRequestAssetDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutRequestAssetMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutRequestAssetMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutRequestAssetStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutRequestAssetStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutRequestAssetSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutRequestAssetVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutRequestAssetVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutRequestAsset` object types. */
export type PayoutRequestAssetAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutRequestAsset` objects. */
  average?: InputMaybe<PayoutRequestAssetAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutRequestAsset` objects. */
  distinctCount?: InputMaybe<PayoutRequestAssetDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutRequestAsset` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutRequestAssetFilter>;
  /** Maximum aggregate over matching `PayoutRequestAsset` objects. */
  max?: InputMaybe<PayoutRequestAssetMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutRequestAsset` objects. */
  min?: InputMaybe<PayoutRequestAssetMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutRequestAsset` objects. */
  stddevPopulation?: InputMaybe<PayoutRequestAssetStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutRequestAsset` objects. */
  stddevSample?: InputMaybe<PayoutRequestAssetStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutRequestAsset` objects. */
  sum?: InputMaybe<PayoutRequestAssetSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutRequestAsset` objects. */
  variancePopulation?: InputMaybe<PayoutRequestAssetVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutRequestAsset` objects. */
  varianceSample?: InputMaybe<PayoutRequestAssetVarianceSampleAggregateFilter>;
};

export type PayoutRequestAssetAverageAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestAssetAverageAggregates = {
  __typename?: 'PayoutRequestAssetAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutRequestAsset` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PayoutRequestAssetCondition = {
  /** Checks for equality with the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PayoutRequestAssetStatusEnum>;
};

/** A connection to a list of `PayoutRequestAsset` values. */
export type PayoutRequestAssetConnection = {
  __typename?: 'PayoutRequestAssetConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutRequestAssetAggregates>;
  /** A list of edges which contains the `PayoutRequestAsset` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutRequestAssetEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutRequestAssetAggregates>>;
  /** A list of `PayoutRequestAsset` objects. */
  nodes: Array<Maybe<PayoutRequestAsset>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutRequestAsset` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutRequestAsset` values. */
export type PayoutRequestAssetConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutRequestAssetGroupBy>;
  having?: InputMaybe<PayoutRequestAssetHavingInput>;
};

export type PayoutRequestAssetDistinctCountAggregateFilter = {
  payoutRequestId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestAssetDistinctCountAggregates = {
  __typename?: 'PayoutRequestAssetDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of displayImageUrl across the matching connection */
  displayImageUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of generatedAt across the matching connection */
  generatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of generationPayload across the matching connection */
  generationPayload?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payloadHash across the matching connection */
  payloadHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of renderedIdentity across the matching connection */
  renderedIdentity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of socialUrl across the matching connection */
  socialUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of templateVersion across the matching connection */
  templateVersion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of variants across the matching connection */
  variants?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutRequestAsset` edge in the connection. */
export type PayoutRequestAssetEdge = {
  __typename?: 'PayoutRequestAssetEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutRequestAsset` at the end of the edge. */
  node?: Maybe<PayoutRequestAsset>;
};

/** A filter to be used against `PayoutRequestAsset` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestAssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutRequestAssetFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutRequestAssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutRequestAssetFilter>>;
  /** Filter by the object’s `payoutRequest` relation. */
  payoutRequest?: InputMaybe<PayoutRequestFilter>;
  /** A related `payoutRequest` exists. */
  payoutRequestExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<PayoutRequestAssetStatusEnumFilter>;
};

/** Grouping methods for `PayoutRequestAsset` for usage during aggregation. */
export enum PayoutRequestAssetGroupBy {
  PayoutRequestId = 'PAYOUT_REQUEST_ID',
  Status = 'STATUS'
}

export type PayoutRequestAssetHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PayoutRequestAsset` aggregates. */
export type PayoutRequestAssetHavingInput = {
  AND?: InputMaybe<Array<PayoutRequestAssetHavingInput>>;
  OR?: InputMaybe<Array<PayoutRequestAssetHavingInput>>;
  average?: InputMaybe<PayoutRequestAssetHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutRequestAssetHavingDistinctCountInput>;
  max?: InputMaybe<PayoutRequestAssetHavingMaxInput>;
  min?: InputMaybe<PayoutRequestAssetHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutRequestAssetHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutRequestAssetHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutRequestAssetHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutRequestAssetHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutRequestAssetHavingVarianceSampleInput>;
};

export type PayoutRequestAssetHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  generatedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestAssetMaxAggregateFilter = {
  payoutRequestId?: InputMaybe<IntFilter>;
};

export type PayoutRequestAssetMaxAggregates = {
  __typename?: 'PayoutRequestAssetMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutRequestAssetMinAggregateFilter = {
  payoutRequestId?: InputMaybe<IntFilter>;
};

export type PayoutRequestAssetMinAggregates = {
  __typename?: 'PayoutRequestAssetMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutRequestAsset`. */
export enum PayoutRequestAssetOrderBy {
  Natural = 'NATURAL',
  PayoutRequestIdAsc = 'PAYOUT_REQUEST_ID_ASC',
  PayoutRequestIdDesc = 'PAYOUT_REQUEST_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export enum PayoutRequestAssetStatusEnum {
  Failed = 'failed',
  Partial = 'partial',
  Pending = 'pending',
  Success = 'success'
}

/** A filter to be used against PayoutRequestAssetStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type PayoutRequestAssetStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PayoutRequestAssetStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PayoutRequestAssetStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PayoutRequestAssetStatusEnum>>;
};

export type PayoutRequestAssetStddevPopulationAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestAssetStddevPopulationAggregates = {
  __typename?: 'PayoutRequestAssetStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestAssetStddevSampleAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestAssetStddevSampleAggregates = {
  __typename?: 'PayoutRequestAssetStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestAssetSumAggregateFilter = {
  payoutRequestId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestAssetSumAggregates = {
  __typename?: 'PayoutRequestAssetSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of payoutRequestId across the matching connection */
  payoutRequestId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type PayoutRequestAssetVariancePopulationAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestAssetVariancePopulationAggregates = {
  __typename?: 'PayoutRequestAssetVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestAssetVarianceSampleAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestAssetVarianceSampleAggregates = {
  __typename?: 'PayoutRequestAssetVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestAverageAggregates = {
  __typename?: 'PayoutRequestAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatch = Node & {
  __typename?: 'PayoutRequestBatch';
  /** Reads a single `User` that is related to this `PayoutRequestBatch`. */
  assignedToAdmin?: Maybe<User>;
  assignedToAdminId?: Maybe<Scalars['Int']['output']>;
  bankAccountType?: Maybe<PayoutRequestBatchBankAccountTypeEnum>;
  bankInfoEnteredAtCount?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PayoutRequestBatch`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']['output']>;
  eventLog?: Maybe<Scalars['JSON']['output']>;
  financeApprovedAtCount?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payoutMethod: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `PayoutRequestBatchItem`. */
  payoutRequestBatchItemsByBatchId: PayoutRequestBatchItemConnection;
  processedVia?: Maybe<PayoutRequestBatchProcessedViaEnum>;
  publishedAt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['Int']['output'];
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


export type PayoutRequestBatchPayoutRequestBatchItemsByBatchIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestBatchItemCondition>;
  filter?: InputMaybe<PayoutRequestBatchItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestBatchItemOrderBy>>;
};

export type PayoutRequestBatchAggregates = {
  __typename?: 'PayoutRequestBatchAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutRequestBatchAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutRequestBatchDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutRequestBatchMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutRequestBatchMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutRequestBatchStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutRequestBatchStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutRequestBatchSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutRequestBatchVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutRequestBatchVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutRequestBatch` object types. */
export type PayoutRequestBatchAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutRequestBatch` objects. */
  average?: InputMaybe<PayoutRequestBatchAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutRequestBatch` objects. */
  distinctCount?: InputMaybe<PayoutRequestBatchDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutRequestBatch` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutRequestBatchFilter>;
  /** Maximum aggregate over matching `PayoutRequestBatch` objects. */
  max?: InputMaybe<PayoutRequestBatchMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutRequestBatch` objects. */
  min?: InputMaybe<PayoutRequestBatchMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutRequestBatch` objects. */
  stddevPopulation?: InputMaybe<PayoutRequestBatchStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutRequestBatch` objects. */
  stddevSample?: InputMaybe<PayoutRequestBatchStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutRequestBatch` objects. */
  sum?: InputMaybe<PayoutRequestBatchSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutRequestBatch` objects. */
  variancePopulation?: InputMaybe<PayoutRequestBatchVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutRequestBatch` objects. */
  varianceSample?: InputMaybe<PayoutRequestBatchVarianceSampleAggregateFilter>;
};

export type PayoutRequestBatchAverageAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigFloatFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigFloatFilter>;
  createdById?: InputMaybe<BigFloatFilter>;
  financeApprovedAtCount?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchAverageAggregates = {
  __typename?: 'PayoutRequestBatchAverageAggregates';
  /** Mean average of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

export enum PayoutRequestBatchBankAccountTypeEnum {
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

/** A filter to be used against PayoutRequestBatchBankAccountTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type PayoutRequestBatchBankAccountTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PayoutRequestBatchBankAccountTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PayoutRequestBatchBankAccountTypeEnum>>;
};

/**
 * A condition to be used against `PayoutRequestBatch` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PayoutRequestBatchCondition = {
  /** Checks for equality with the object’s `assignedToAdminId` field. */
  assignedToAdminId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `bankAccountType` field. */
  bankAccountType?: InputMaybe<PayoutRequestBatchBankAccountTypeEnum>;
  /** Checks for equality with the object’s `bankInfoEnteredAtCount` field. */
  bankInfoEnteredAtCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `financeApprovedAtCount` field. */
  financeApprovedAtCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `payoutMethod` field. */
  payoutMethod?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalNetSum` field. */
  totalNetSum?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `PayoutRequestBatch` values. */
export type PayoutRequestBatchConnection = {
  __typename?: 'PayoutRequestBatchConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutRequestBatchAggregates>;
  /** A list of edges which contains the `PayoutRequestBatch` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutRequestBatchEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutRequestBatchAggregates>>;
  /** A list of `PayoutRequestBatch` objects. */
  nodes: Array<Maybe<PayoutRequestBatch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutRequestBatch` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutRequestBatch` values. */
export type PayoutRequestBatchConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutRequestBatchGroupBy>;
  having?: InputMaybe<PayoutRequestBatchHavingInput>;
};

export type PayoutRequestBatchDistinctCountAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigIntFilter>;
  bankAccountType?: InputMaybe<BigIntFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigIntFilter>;
  completedAt?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdById?: InputMaybe<BigIntFilter>;
  financeApprovedAtCount?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<BigIntFilter>;
  payoutMethod?: InputMaybe<BigIntFilter>;
  publishedAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  totalNetSum?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestBatchDistinctCountAggregates = {
  __typename?: 'PayoutRequestBatchDistinctCountAggregates';
  /** Distinct count of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bankAccountType across the matching connection */
  bankAccountType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of completedAt across the matching connection */
  completedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutMethod across the matching connection */
  payoutMethod?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of processedVia across the matching connection */
  processedVia?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of publishedAt across the matching connection */
  publishedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutRequestBatch` edge in the connection. */
export type PayoutRequestBatchEdge = {
  __typename?: 'PayoutRequestBatchEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutRequestBatch` at the end of the edge. */
  node?: Maybe<PayoutRequestBatch>;
};

/** A filter to be used against `PayoutRequestBatch` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestBatchFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutRequestBatchFilter>>;
  /** Filter by the object’s `assignedToAdmin` relation. */
  assignedToAdmin?: InputMaybe<UserFilter>;
  /** A related `assignedToAdmin` exists. */
  assignedToAdminExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `assignedToAdminId` field. */
  assignedToAdminId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `bankAccountType` field. */
  bankAccountType?: InputMaybe<PayoutRequestBatchBankAccountTypeEnumFilter>;
  /** Filter by the object’s `bankInfoEnteredAtCount` field. */
  bankInfoEnteredAtCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` relation. */
  createdBy?: InputMaybe<UserFilter>;
  /** A related `createdBy` exists. */
  createdByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `financeApprovedAtCount` field. */
  financeApprovedAtCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutRequestBatchFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutRequestBatchFilter>>;
  /** Filter by the object’s `payoutMethod` field. */
  payoutMethod?: InputMaybe<StringFilter>;
  /** Filter by the object’s `payoutRequestBatchItemsByBatchId` relation. */
  payoutRequestBatchItemsByBatchId?: InputMaybe<PayoutRequestBatchToManyPayoutRequestBatchItemFilter>;
  /** Some related `payoutRequestBatchItemsByBatchId` exist. */
  payoutRequestBatchItemsByBatchIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalNetSum` field. */
  totalNetSum?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** Grouping methods for `PayoutRequestBatch` for usage during aggregation. */
export enum PayoutRequestBatchGroupBy {
  AssignedToAdminId = 'ASSIGNED_TO_ADMIN_ID',
  BankAccountType = 'BANK_ACCOUNT_TYPE',
  CompletedAt = 'COMPLETED_AT',
  CompletedAtTruncatedToDay = 'COMPLETED_AT_TRUNCATED_TO_DAY',
  CompletedAtTruncatedToHour = 'COMPLETED_AT_TRUNCATED_TO_HOUR',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  CreatedById = 'CREATED_BY_ID',
  PayoutMethod = 'PAYOUT_METHOD',
  PublishedAt = 'PUBLISHED_AT',
  PublishedAtTruncatedToDay = 'PUBLISHED_AT_TRUNCATED_TO_DAY',
  PublishedAtTruncatedToHour = 'PUBLISHED_AT_TRUNCATED_TO_HOUR',
  Type = 'TYPE'
}

export type PayoutRequestBatchHavingAverageInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingDistinctCountInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PayoutRequestBatch` aggregates. */
export type PayoutRequestBatchHavingInput = {
  AND?: InputMaybe<Array<PayoutRequestBatchHavingInput>>;
  OR?: InputMaybe<Array<PayoutRequestBatchHavingInput>>;
  average?: InputMaybe<PayoutRequestBatchHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutRequestBatchHavingDistinctCountInput>;
  max?: InputMaybe<PayoutRequestBatchHavingMaxInput>;
  min?: InputMaybe<PayoutRequestBatchHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutRequestBatchHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutRequestBatchHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutRequestBatchHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutRequestBatchHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutRequestBatchHavingVarianceSampleInput>;
};

export type PayoutRequestBatchHavingMaxInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingMinInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingStddevPopulationInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingStddevSampleInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingSumInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingVariancePopulationInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchHavingVarianceSampleInput = {
  assignedToAdminId?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  createdById?: InputMaybe<HavingIntFilter>;
  publishedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItem = Node & {
  __typename?: 'PayoutRequestBatchItem';
  /** Reads a single `PayoutRequestBatch` that is related to this `PayoutRequestBatchItem`. */
  batch?: Maybe<PayoutRequestBatch>;
  batchId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `PayoutRequest` that is related to this `PayoutRequestBatchItem`. */
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequestId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type PayoutRequestBatchItemAggregates = {
  __typename?: 'PayoutRequestBatchItemAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutRequestBatchItemAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutRequestBatchItemDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutRequestBatchItemMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutRequestBatchItemMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutRequestBatchItemStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutRequestBatchItemStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutRequestBatchItemSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutRequestBatchItemVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutRequestBatchItemVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutRequestBatchItem` object types. */
export type PayoutRequestBatchItemAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutRequestBatchItem` objects. */
  average?: InputMaybe<PayoutRequestBatchItemAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutRequestBatchItem` objects. */
  distinctCount?: InputMaybe<PayoutRequestBatchItemDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutRequestBatchItem` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutRequestBatchItemFilter>;
  /** Maximum aggregate over matching `PayoutRequestBatchItem` objects. */
  max?: InputMaybe<PayoutRequestBatchItemMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutRequestBatchItem` objects. */
  min?: InputMaybe<PayoutRequestBatchItemMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutRequestBatchItem` objects. */
  stddevPopulation?: InputMaybe<PayoutRequestBatchItemStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutRequestBatchItem` objects. */
  stddevSample?: InputMaybe<PayoutRequestBatchItemStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutRequestBatchItem` objects. */
  sum?: InputMaybe<PayoutRequestBatchItemSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutRequestBatchItem` objects. */
  variancePopulation?: InputMaybe<PayoutRequestBatchItemVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutRequestBatchItem` objects. */
  varianceSample?: InputMaybe<PayoutRequestBatchItemVarianceSampleAggregateFilter>;
};

export type PayoutRequestBatchItemAverageAggregateFilter = {
  batchId?: InputMaybe<BigFloatFilter>;
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchItemAverageAggregates = {
  __typename?: 'PayoutRequestBatchItemAverageAggregates';
  /** Mean average of batchId across the matching connection */
  batchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutRequestBatchItem` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PayoutRequestBatchItemCondition = {
  /** Checks for equality with the object’s `batchId` field. */
  batchId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutRequestBatchItem` values. */
export type PayoutRequestBatchItemConnection = {
  __typename?: 'PayoutRequestBatchItemConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutRequestBatchItemAggregates>;
  /** A list of edges which contains the `PayoutRequestBatchItem` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutRequestBatchItemEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutRequestBatchItemAggregates>>;
  /** A list of `PayoutRequestBatchItem` objects. */
  nodes: Array<Maybe<PayoutRequestBatchItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutRequestBatchItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutRequestBatchItem` values. */
export type PayoutRequestBatchItemConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutRequestBatchItemGroupBy>;
  having?: InputMaybe<PayoutRequestBatchItemHavingInput>;
};

export type PayoutRequestBatchItemDistinctCountAggregateFilter = {
  batchId?: InputMaybe<BigIntFilter>;
  payoutRequestId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestBatchItemDistinctCountAggregates = {
  __typename?: 'PayoutRequestBatchItemDistinctCountAggregates';
  /** Distinct count of batchId across the matching connection */
  batchId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutRequestBatchItem` edge in the connection. */
export type PayoutRequestBatchItemEdge = {
  __typename?: 'PayoutRequestBatchItemEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutRequestBatchItem` at the end of the edge. */
  node?: Maybe<PayoutRequestBatchItem>;
};

/** A filter to be used against `PayoutRequestBatchItem` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestBatchItemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutRequestBatchItemFilter>>;
  /** Filter by the object’s `batch` relation. */
  batch?: InputMaybe<PayoutRequestBatchFilter>;
  /** Filter by the object’s `batchId` field. */
  batchId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutRequestBatchItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutRequestBatchItemFilter>>;
  /** Filter by the object’s `payoutRequest` relation. */
  payoutRequest?: InputMaybe<PayoutRequestFilter>;
  /** Filter by the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PayoutRequestBatchItem` for usage during aggregation. */
export enum PayoutRequestBatchItemGroupBy {
  BatchId = 'BATCH_ID'
}

export type PayoutRequestBatchItemHavingAverageInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingDistinctCountInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PayoutRequestBatchItem` aggregates. */
export type PayoutRequestBatchItemHavingInput = {
  AND?: InputMaybe<Array<PayoutRequestBatchItemHavingInput>>;
  OR?: InputMaybe<Array<PayoutRequestBatchItemHavingInput>>;
  average?: InputMaybe<PayoutRequestBatchItemHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutRequestBatchItemHavingDistinctCountInput>;
  max?: InputMaybe<PayoutRequestBatchItemHavingMaxInput>;
  min?: InputMaybe<PayoutRequestBatchItemHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutRequestBatchItemHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutRequestBatchItemHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutRequestBatchItemHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutRequestBatchItemHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutRequestBatchItemHavingVarianceSampleInput>;
};

export type PayoutRequestBatchItemHavingMaxInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingMinInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingStddevPopulationInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingStddevSampleInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingSumInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingVariancePopulationInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemHavingVarianceSampleInput = {
  batchId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutRequestBatchItemMaxAggregateFilter = {
  batchId?: InputMaybe<IntFilter>;
  payoutRequestId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutRequestBatchItemMaxAggregates = {
  __typename?: 'PayoutRequestBatchItemMaxAggregates';
  /** Maximum of batchId across the matching connection */
  batchId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutRequestBatchItemMinAggregateFilter = {
  batchId?: InputMaybe<IntFilter>;
  payoutRequestId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutRequestBatchItemMinAggregates = {
  __typename?: 'PayoutRequestBatchItemMinAggregates';
  /** Minimum of batchId across the matching connection */
  batchId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutRequestBatchItem`. */
export enum PayoutRequestBatchItemOrderBy {
  BatchIdAsc = 'BATCH_ID_ASC',
  BatchIdDesc = 'BATCH_ID_DESC',
  Natural = 'NATURAL',
  PayoutRequestIdAsc = 'PAYOUT_REQUEST_ID_ASC',
  PayoutRequestIdDesc = 'PAYOUT_REQUEST_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type PayoutRequestBatchItemStddevPopulationAggregateFilter = {
  batchId?: InputMaybe<BigFloatFilter>;
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchItemStddevPopulationAggregates = {
  __typename?: 'PayoutRequestBatchItemStddevPopulationAggregates';
  /** Population standard deviation of batchId across the matching connection */
  batchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchItemStddevSampleAggregateFilter = {
  batchId?: InputMaybe<BigFloatFilter>;
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchItemStddevSampleAggregates = {
  __typename?: 'PayoutRequestBatchItemStddevSampleAggregates';
  /** Sample standard deviation of batchId across the matching connection */
  batchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchItemSumAggregateFilter = {
  batchId?: InputMaybe<BigIntFilter>;
  payoutRequestId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestBatchItemSumAggregates = {
  __typename?: 'PayoutRequestBatchItemSumAggregates';
  /** Sum of batchId across the matching connection */
  batchId: Scalars['BigInt']['output'];
  /** Sum of payoutRequestId across the matching connection */
  payoutRequestId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type PayoutRequestBatchItemVariancePopulationAggregateFilter = {
  batchId?: InputMaybe<BigFloatFilter>;
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchItemVariancePopulationAggregates = {
  __typename?: 'PayoutRequestBatchItemVariancePopulationAggregates';
  /** Population variance of batchId across the matching connection */
  batchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchItemVarianceSampleAggregateFilter = {
  batchId?: InputMaybe<BigFloatFilter>;
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchItemVarianceSampleAggregates = {
  __typename?: 'PayoutRequestBatchItemVarianceSampleAggregates';
  /** Sample variance of batchId across the matching connection */
  batchId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchMaxAggregateFilter = {
  assignedToAdminId?: InputMaybe<IntFilter>;
  bankInfoEnteredAtCount?: InputMaybe<IntFilter>;
  createdById?: InputMaybe<IntFilter>;
  financeApprovedAtCount?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchMaxAggregates = {
  __typename?: 'PayoutRequestBatchMaxAggregates';
  /** Maximum of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdById across the matching connection */
  createdById?: Maybe<Scalars['Int']['output']>;
  /** Maximum of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchMinAggregateFilter = {
  assignedToAdminId?: InputMaybe<IntFilter>;
  bankInfoEnteredAtCount?: InputMaybe<IntFilter>;
  createdById?: InputMaybe<IntFilter>;
  financeApprovedAtCount?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchMinAggregates = {
  __typename?: 'PayoutRequestBatchMinAggregates';
  /** Minimum of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdById across the matching connection */
  createdById?: Maybe<Scalars['Int']['output']>;
  /** Minimum of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

/** Methods to use when ordering `PayoutRequestBatch`. */
export enum PayoutRequestBatchOrderBy {
  AssignedToAdminIdAsc = 'ASSIGNED_TO_ADMIN_ID_ASC',
  AssignedToAdminIdDesc = 'ASSIGNED_TO_ADMIN_ID_DESC',
  BankInfoEnteredAtCountAsc = 'BANK_INFO_ENTERED_AT_COUNT_ASC',
  BankInfoEnteredAtCountDesc = 'BANK_INFO_ENTERED_AT_COUNT_DESC',
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  FinanceApprovedAtCountAsc = 'FINANCE_APPROVED_AT_COUNT_ASC',
  FinanceApprovedAtCountDesc = 'FINANCE_APPROVED_AT_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PayoutMethodAsc = 'PAYOUT_METHOD_ASC',
  PayoutMethodDesc = 'PAYOUT_METHOD_DESC',
  PayoutRequestBatchItemsByBatchIdAverageBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_AVERAGE_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdAverageBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_AVERAGE_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdAveragePayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_AVERAGE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdAveragePayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_AVERAGE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdAverageRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_AVERAGE_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdAverageRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_AVERAGE_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdCountAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_COUNT_ASC',
  PayoutRequestBatchItemsByBatchIdCountDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_COUNT_DESC',
  PayoutRequestBatchItemsByBatchIdDistinctCountBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_DISTINCT_COUNT_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdDistinctCountBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_DISTINCT_COUNT_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdDistinctCountPayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_DISTINCT_COUNT_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdDistinctCountPayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_DISTINCT_COUNT_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdDistinctCountRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdDistinctCountRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdMaxBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MAX_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdMaxBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MAX_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdMaxPayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MAX_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdMaxPayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MAX_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdMaxRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MAX_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdMaxRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MAX_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdMinBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MIN_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdMinBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MIN_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdMinPayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MIN_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdMinPayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MIN_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdMinRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MIN_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdMinRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_MIN_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdStddevPopulationBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_POPULATION_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdStddevPopulationBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_POPULATION_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdStddevPopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdStddevPopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdStddevPopulationRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdStddevPopulationRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdStddevSampleBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_SAMPLE_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdStddevSampleBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_SAMPLE_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdStddevSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdStddevSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdStddevSampleRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdStddevSampleRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdSumBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_SUM_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdSumBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_SUM_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdSumPayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_SUM_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdSumPayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_SUM_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdSumRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_SUM_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdSumRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_SUM_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdVariancePopulationBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_POPULATION_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdVariancePopulationBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_POPULATION_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdVariancePopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdVariancePopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdVariancePopulationRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdVariancePopulationRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutRequestBatchItemsByBatchIdVarianceSampleBatchIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_SAMPLE_BATCH_ID_ASC',
  PayoutRequestBatchItemsByBatchIdVarianceSampleBatchIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_SAMPLE_BATCH_ID_DESC',
  PayoutRequestBatchItemsByBatchIdVarianceSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestBatchItemsByBatchIdVarianceSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestBatchItemsByBatchIdVarianceSampleRowIdAsc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutRequestBatchItemsByBatchIdVarianceSampleRowIdDesc = 'PAYOUT_REQUEST_BATCH_ITEMS_BY_BATCH_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TotalNetSumAsc = 'TOTAL_NET_SUM_ASC',
  TotalNetSumDesc = 'TOTAL_NET_SUM_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export enum PayoutRequestBatchProcessedViaEnum {
  Bofa = 'BOFA',
  Signature = 'SIGNATURE'
}

export type PayoutRequestBatchStddevPopulationAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigFloatFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigFloatFilter>;
  createdById?: InputMaybe<BigFloatFilter>;
  financeApprovedAtCount?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchStddevPopulationAggregates = {
  __typename?: 'PayoutRequestBatchStddevPopulationAggregates';
  /** Population standard deviation of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchStddevSampleAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigFloatFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigFloatFilter>;
  createdById?: InputMaybe<BigFloatFilter>;
  financeApprovedAtCount?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchStddevSampleAggregates = {
  __typename?: 'PayoutRequestBatchStddevSampleAggregates';
  /** Sample standard deviation of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchSumAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigIntFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigIntFilter>;
  createdById?: InputMaybe<BigIntFilter>;
  financeApprovedAtCount?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchSumAggregates = {
  __typename?: 'PayoutRequestBatchSumAggregates';
  /** Sum of assignedToAdminId across the matching connection */
  assignedToAdminId: Scalars['BigInt']['output'];
  /** Sum of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigInt']['output']>;
  /** Sum of createdById across the matching connection */
  createdById: Scalars['BigInt']['output'];
  /** Sum of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigInt']['output']>;
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against many `PayoutRequestBatchItem` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestBatchToManyPayoutRequestBatchItemFilter = {
  /** Aggregates across related `PayoutRequestBatchItem` match the filter criteria. */
  aggregates?: InputMaybe<PayoutRequestBatchItemAggregatesFilter>;
  /** Every related `PayoutRequestBatchItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutRequestBatchItemFilter>;
  /** No related `PayoutRequestBatchItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutRequestBatchItemFilter>;
  /** Some related `PayoutRequestBatchItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutRequestBatchItemFilter>;
};

export type PayoutRequestBatchVariancePopulationAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigFloatFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigFloatFilter>;
  createdById?: InputMaybe<BigFloatFilter>;
  financeApprovedAtCount?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchVariancePopulationAggregates = {
  __typename?: 'PayoutRequestBatchVariancePopulationAggregates';
  /** Population variance of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestBatchVarianceSampleAggregateFilter = {
  assignedToAdminId?: InputMaybe<BigFloatFilter>;
  bankInfoEnteredAtCount?: InputMaybe<BigFloatFilter>;
  createdById?: InputMaybe<BigFloatFilter>;
  financeApprovedAtCount?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  totalNetSum?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestBatchVarianceSampleAggregates = {
  __typename?: 'PayoutRequestBatchVarianceSampleAggregates';
  /** Sample variance of assignedToAdminId across the matching connection */
  assignedToAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of this field across the matching connection. */
  bankInfoEnteredAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of this field across the matching connection. */
  financeApprovedAtCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of this field across the matching connection. */
  totalNetSum?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutRequest` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PayoutRequestCondition = {
  /** Checks for equality with the object’s `adminInitiated` field. */
  adminInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `bankInfoEnteredAt` field. */
  bankInfoEnteredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `exception` field. */
  exception?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `finalizedAt` field. */
  finalizedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `financeApprovedAt` field. */
  financeApprovedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `method` field. */
  method?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `paid` field. */
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `payoutPath` field. */
  payoutPath?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reopenedAt` field. */
  reopenedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutRequest` values. */
export type PayoutRequestConnection = {
  __typename?: 'PayoutRequestConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutRequestAggregates>;
  /** A list of edges which contains the `PayoutRequest` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutRequestEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutRequestAggregates>>;
  /** A list of `PayoutRequest` objects. */
  nodes: Array<Maybe<PayoutRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutRequest` values. */
export type PayoutRequestConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutRequestGroupBy>;
  having?: InputMaybe<PayoutRequestHavingInput>;
};

export type PayoutRequestDistinctCountAggregateFilter = {
  adminInitiated?: InputMaybe<BigIntFilter>;
  bankInfoEnteredAt?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  departmentApprovals?: InputMaybe<BigIntFilter>;
  exception?: InputMaybe<BigIntFilter>;
  finalizedAt?: InputMaybe<BigIntFilter>;
  financeApprovedAt?: InputMaybe<BigIntFilter>;
  method?: InputMaybe<BigIntFilter>;
  paid?: InputMaybe<BigIntFilter>;
  payoutPath?: InputMaybe<BigIntFilter>;
  reopenedAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestDistinctCountAggregates = {
  __typename?: 'PayoutRequestDistinctCountAggregates';
  /** Distinct count of accountCallUpDecisionId across the matching connection */
  accountCallUpDecisionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of adminInitiated across the matching connection */
  adminInitiated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assignedDepartment across the matching connection */
  assignedDepartment?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bankInfoEnteredAt across the matching connection */
  bankInfoEnteredAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of exception across the matching connection */
  exception?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of exceptionNote across the matching connection */
  exceptionNote?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of finalizedAt across the matching connection */
  finalizedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of financeApprovedAt across the matching connection */
  financeApprovedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of method across the matching connection */
  method?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteBillId across the matching connection */
  netSuiteBillId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuitePaymentId across the matching connection */
  netSuitePaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of paid across the matching connection */
  paid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutOptionHandle across the matching connection */
  payoutOptionHandle?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutOptionKind across the matching connection */
  payoutOptionKind?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutPath across the matching connection */
  payoutPath?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reference across the matching connection */
  reference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reopenedAt across the matching connection */
  reopenedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetsWinningDays across the matching connection */
  resetsWinningDays?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statusNote across the matching connection */
  statusNote?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of targetCurrency across the matching connection */
  targetCurrency?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutRequest` edge in the connection. */
export type PayoutRequestEdge = {
  __typename?: 'PayoutRequestEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutRequest` at the end of the edge. */
  node?: Maybe<PayoutRequest>;
};

/** A filter to be used against `PayoutRequest` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountCallUpDecision` relation. */
  accountCallUpDecision?: InputMaybe<AccountCallUpDecisionFilter>;
  /** Filter by the object’s `accountCallUpDecisionAccount` relation. */
  accountCallUpDecisionAccount?: InputMaybe<AccountLiveCallUpFilter>;
  /** A related `accountCallUpDecisionAccount` exists. */
  accountCallUpDecisionAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** A related `accountCallUpDecision` exists. */
  accountCallUpDecisionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountLiveCallUp` relation. */
  accountLiveCallUp?: InputMaybe<AccountLiveCallUpFilter>;
  /** A related `accountLiveCallUp` exists. */
  accountLiveCallUpExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `adminInitiated` field. */
  adminInitiated?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutRequestFilter>>;
  /** Filter by the object’s `bankInfoEnteredAt` field. */
  bankInfoEnteredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentApprovals` field. */
  departmentApprovals?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `exception` field. */
  exception?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `finalizedAt` field. */
  finalizedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `financeApprovedAt` field. */
  financeApprovedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `method` field. */
  method?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutRequestFilter>>;
  /** Filter by the object’s `paid` field. */
  paid?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `payoutDepartmentApprovalsByPayoutId` relation. */
  payoutDepartmentApprovalsByPayoutId?: InputMaybe<PayoutRequestToManyPayoutDepartmentApprovalFilter>;
  /** Some related `payoutDepartmentApprovalsByPayoutId` exist. */
  payoutDepartmentApprovalsByPayoutIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutPath` field. */
  payoutPath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `payoutRequestAssets` relation. */
  payoutRequestAssets?: InputMaybe<PayoutRequestToManyPayoutRequestAssetFilter>;
  /** Some related `payoutRequestAssets` exist. */
  payoutRequestAssetsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequestBatchItem` relation. */
  payoutRequestBatchItem?: InputMaybe<PayoutRequestBatchItemFilter>;
  /** A related `payoutRequestBatchItem` exists. */
  payoutRequestBatchItemExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequestSubscribers` relation. */
  payoutRequestSubscribers?: InputMaybe<PayoutRequestToManyPayoutRequestSubscriberFilter>;
  /** Some related `payoutRequestSubscribers` exist. */
  payoutRequestSubscribersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutReturns` relation. */
  payoutReturns?: InputMaybe<PayoutRequestToManyPayoutReturnFilter>;
  /** Some related `payoutReturns` exist. */
  payoutReturnsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutReviewersByPayoutId` relation. */
  payoutReviewersByPayoutId?: InputMaybe<PayoutRequestToManyPayoutReviewerFilter>;
  /** Some related `payoutReviewersByPayoutId` exist. */
  payoutReviewersByPayoutIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutReviewsByPayoutId` relation. */
  payoutReviewsByPayoutId?: InputMaybe<PayoutRequestToManyPayoutReviewFilter>;
  /** Some related `payoutReviewsByPayoutId` exist. */
  payoutReviewsByPayoutIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `reopenedAt` field. */
  reopenedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PayoutRequest` for usage during aggregation. */
export enum PayoutRequestGroupBy {
  AdminInitiated = 'ADMIN_INITIATED',
  BankInfoEnteredAt = 'BANK_INFO_ENTERED_AT',
  BankInfoEnteredAtTruncatedToDay = 'BANK_INFO_ENTERED_AT_TRUNCATED_TO_DAY',
  BankInfoEnteredAtTruncatedToHour = 'BANK_INFO_ENTERED_AT_TRUNCATED_TO_HOUR',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Exception = 'EXCEPTION',
  FinalizedAt = 'FINALIZED_AT',
  FinalizedAtTruncatedToDay = 'FINALIZED_AT_TRUNCATED_TO_DAY',
  FinalizedAtTruncatedToHour = 'FINALIZED_AT_TRUNCATED_TO_HOUR',
  FinanceApprovedAt = 'FINANCE_APPROVED_AT',
  FinanceApprovedAtTruncatedToDay = 'FINANCE_APPROVED_AT_TRUNCATED_TO_DAY',
  FinanceApprovedAtTruncatedToHour = 'FINANCE_APPROVED_AT_TRUNCATED_TO_HOUR',
  Method = 'METHOD',
  Paid = 'PAID',
  PayoutPath = 'PAYOUT_PATH',
  ReopenedAt = 'REOPENED_AT',
  ReopenedAtTruncatedToDay = 'REOPENED_AT_TRUNCATED_TO_DAY',
  ReopenedAtTruncatedToHour = 'REOPENED_AT_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  Type = 'TYPE',
  UserId = 'USER_ID'
}

export type PayoutRequestHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PayoutRequest` aggregates. */
export type PayoutRequestHavingInput = {
  AND?: InputMaybe<Array<PayoutRequestHavingInput>>;
  OR?: InputMaybe<Array<PayoutRequestHavingInput>>;
  average?: InputMaybe<PayoutRequestHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutRequestHavingDistinctCountInput>;
  max?: InputMaybe<PayoutRequestHavingMaxInput>;
  min?: InputMaybe<PayoutRequestHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutRequestHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutRequestHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutRequestHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutRequestHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutRequestHavingVarianceSampleInput>;
};

export type PayoutRequestHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingIntFilter>;
  approvingUserId?: InputMaybe<HavingIntFilter>;
  bankInfoEnteredAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  finalizedAt?: InputMaybe<HavingDatetimeFilter>;
  financeApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  impairmentRealized?: InputMaybe<HavingBigfloatFilter>;
  reopenedAt?: InputMaybe<HavingDatetimeFilter>;
  requestedAmount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  seedCapitalAmount?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestHistory = Node & {
  __typename?: 'PayoutRequestHistory';
  accountId: Scalars['Int']['output'];
  action: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `PayoutRequestHistory`. */
  admin?: Maybe<User>;
  adminId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  /** Reads a single `PayoutRequest` that is related to this `PayoutRequestHistory`. */
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequestId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  status: PayoutRequestHistoryStatusEnum;
  updatedAt: Scalars['Datetime']['output'];
};

export enum PayoutRequestHistoryStatusEnum {
  AdminInitiated = 'ADMIN_INITIATED',
  AssignedAdmin = 'ASSIGNED_ADMIN',
  AssignedAdminsClearedOnFinalization = 'ASSIGNED_ADMINS_CLEARED_ON_FINALIZATION',
  AutoApprovalRevoked = 'AUTO_APPROVAL_REVOKED',
  BankEntered = 'BANK_ENTERED',
  ComplianceApproved = 'COMPLIANCE_APPROVED',
  ComplianceAutoApprovalSkipped = 'COMPLIANCE_AUTO_APPROVAL_SKIPPED',
  FinanceApproved = 'FINANCE_APPROVED',
  InvestigationHold = 'INVESTIGATION_HOLD',
  InvestigationRelease = 'INVESTIGATION_RELEASE',
  PayoutMethodChanged = 'PAYOUT_METHOD_CHANGED',
  RemovedFromBatch = 'REMOVED_FROM_BATCH',
  Reopened = 'REOPENED',
  Resubmitted = 'RESUBMITTED',
  Returned = 'RETURNED',
  RiskApproved = 'RISK_APPROVED',
  TraderCompleted = 'TRADER_COMPLETED',
  TradeDeskApproved = 'TRADE_DESK_APPROVED',
  UnassignedAdmin = 'UNASSIGNED_ADMIN',
  UndoBankEntry = 'UNDO_BANK_ENTRY'
}

export type PayoutRequestMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PayoutRequestMaxAggregates = {
  __typename?: 'PayoutRequestMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutRequestMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PayoutRequestMinAggregates = {
  __typename?: 'PayoutRequestMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutRequest`. */
export enum PayoutRequestOrderBy {
  AdminInitiatedAsc = 'ADMIN_INITIATED_ASC',
  AdminInitiatedDesc = 'ADMIN_INITIATED_DESC',
  BankInfoEnteredAtAsc = 'BANK_INFO_ENTERED_AT_ASC',
  BankInfoEnteredAtDesc = 'BANK_INFO_ENTERED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExceptionAsc = 'EXCEPTION_ASC',
  ExceptionDesc = 'EXCEPTION_DESC',
  FinalizedAtAsc = 'FINALIZED_AT_ASC',
  FinalizedAtDesc = 'FINALIZED_AT_DESC',
  FinanceApprovedAtAsc = 'FINANCE_APPROVED_AT_ASC',
  FinanceApprovedAtDesc = 'FINANCE_APPROVED_AT_DESC',
  MethodAsc = 'METHOD_ASC',
  MethodDesc = 'METHOD_DESC',
  Natural = 'NATURAL',
  PaidAsc = 'PAID_ASC',
  PaidDesc = 'PAID_DESC',
  PayoutDepartmentApprovalsByPayoutIdAveragePayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_AVERAGE_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdAveragePayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_AVERAGE_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdAverageRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_AVERAGE_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdAverageRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_AVERAGE_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdCountAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_COUNT_ASC',
  PayoutDepartmentApprovalsByPayoutIdCountDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_COUNT_DESC',
  PayoutDepartmentApprovalsByPayoutIdDistinctCountDepartmentAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_DISTINCT_COUNT_DEPARTMENT_ASC',
  PayoutDepartmentApprovalsByPayoutIdDistinctCountDepartmentDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_DISTINCT_COUNT_DEPARTMENT_DESC',
  PayoutDepartmentApprovalsByPayoutIdDistinctCountPayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_DISTINCT_COUNT_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdDistinctCountPayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_DISTINCT_COUNT_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdDistinctCountRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdDistinctCountRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdMaxPayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MAX_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdMaxPayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MAX_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdMaxRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MAX_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdMaxRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MAX_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdMinPayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MIN_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdMinPayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MIN_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdMinRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MIN_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdMinRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_MIN_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdStddevPopulationPayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_POPULATION_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdStddevPopulationPayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_POPULATION_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdStddevPopulationRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdStddevPopulationRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdStddevSamplePayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_SAMPLE_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdStddevSamplePayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_SAMPLE_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdStddevSampleRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdStddevSampleRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdSumPayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_SUM_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdSumPayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_SUM_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdSumRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_SUM_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdSumRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_SUM_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdVariancePopulationPayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_POPULATION_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdVariancePopulationPayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_POPULATION_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdVariancePopulationRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdVariancePopulationRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdVarianceSamplePayoutIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_SAMPLE_PAYOUT_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdVarianceSamplePayoutIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_SAMPLE_PAYOUT_ID_DESC',
  PayoutDepartmentApprovalsByPayoutIdVarianceSampleRowIdAsc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutDepartmentApprovalsByPayoutIdVarianceSampleRowIdDesc = 'PAYOUT_DEPARTMENT_APPROVALS_BY_PAYOUT_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PayoutPathAsc = 'PAYOUT_PATH_ASC',
  PayoutPathDesc = 'PAYOUT_PATH_DESC',
  PayoutRequestAssetsAveragePayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_AVERAGE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsAveragePayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_AVERAGE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsCountAsc = 'PAYOUT_REQUEST_ASSETS_COUNT_ASC',
  PayoutRequestAssetsCountDesc = 'PAYOUT_REQUEST_ASSETS_COUNT_DESC',
  PayoutRequestAssetsDistinctCountPayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsDistinctCountPayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsDistinctCountRowIdAsc = 'PAYOUT_REQUEST_ASSETS_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutRequestAssetsDistinctCountRowIdDesc = 'PAYOUT_REQUEST_ASSETS_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutRequestAssetsDistinctCountStatusAsc = 'PAYOUT_REQUEST_ASSETS_DISTINCT_COUNT_STATUS_ASC',
  PayoutRequestAssetsDistinctCountStatusDesc = 'PAYOUT_REQUEST_ASSETS_DISTINCT_COUNT_STATUS_DESC',
  PayoutRequestAssetsMaxPayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_MAX_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsMaxPayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_MAX_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsMinPayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_MIN_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsMinPayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_MIN_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsStddevPopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsStddevPopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsStddevSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsStddevSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsSumPayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_SUM_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsSumPayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_SUM_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsVariancePopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsVariancePopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestAssetsVarianceSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_ASSETS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestAssetsVarianceSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_ASSETS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersAveragePayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersAveragePayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersAverageUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_USER_ID_ASC',
  PayoutRequestSubscribersAverageUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_USER_ID_DESC',
  PayoutRequestSubscribersCountAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_COUNT_ASC',
  PayoutRequestSubscribersCountDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_COUNT_DESC',
  PayoutRequestSubscribersDistinctCountPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersDistinctCountPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersDistinctCountUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_USER_ID_ASC',
  PayoutRequestSubscribersDistinctCountUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_USER_ID_DESC',
  PayoutRequestSubscribersMaxPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersMaxPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersMaxUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_USER_ID_ASC',
  PayoutRequestSubscribersMaxUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_USER_ID_DESC',
  PayoutRequestSubscribersMinPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersMinPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersMinUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_USER_ID_ASC',
  PayoutRequestSubscribersMinUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_USER_ID_DESC',
  PayoutRequestSubscribersStddevPopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersStddevPopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersStddevPopulationUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_USER_ID_ASC',
  PayoutRequestSubscribersStddevPopulationUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_USER_ID_DESC',
  PayoutRequestSubscribersStddevSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersStddevSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersStddevSampleUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_USER_ID_ASC',
  PayoutRequestSubscribersStddevSampleUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_USER_ID_DESC',
  PayoutRequestSubscribersSumPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersSumPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersSumUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_USER_ID_ASC',
  PayoutRequestSubscribersSumUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_USER_ID_DESC',
  PayoutRequestSubscribersVariancePopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersVariancePopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersVariancePopulationUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_USER_ID_ASC',
  PayoutRequestSubscribersVariancePopulationUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_USER_ID_DESC',
  PayoutRequestSubscribersVarianceSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersVarianceSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersVarianceSampleUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_USER_ID_ASC',
  PayoutRequestSubscribersVarianceSampleUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_USER_ID_DESC',
  PayoutReturnsAveragePayoutRequestIdAsc = 'PAYOUT_RETURNS_AVERAGE_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsAveragePayoutRequestIdDesc = 'PAYOUT_RETURNS_AVERAGE_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsAverageRowIdAsc = 'PAYOUT_RETURNS_AVERAGE_ROW_ID_ASC',
  PayoutReturnsAverageRowIdDesc = 'PAYOUT_RETURNS_AVERAGE_ROW_ID_DESC',
  PayoutReturnsCountAsc = 'PAYOUT_RETURNS_COUNT_ASC',
  PayoutReturnsCountDesc = 'PAYOUT_RETURNS_COUNT_DESC',
  PayoutReturnsDistinctCountPayoutRequestIdAsc = 'PAYOUT_RETURNS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsDistinctCountPayoutRequestIdDesc = 'PAYOUT_RETURNS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsDistinctCountRowIdAsc = 'PAYOUT_RETURNS_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutReturnsDistinctCountRowIdDesc = 'PAYOUT_RETURNS_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutReturnsMaxPayoutRequestIdAsc = 'PAYOUT_RETURNS_MAX_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsMaxPayoutRequestIdDesc = 'PAYOUT_RETURNS_MAX_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsMaxRowIdAsc = 'PAYOUT_RETURNS_MAX_ROW_ID_ASC',
  PayoutReturnsMaxRowIdDesc = 'PAYOUT_RETURNS_MAX_ROW_ID_DESC',
  PayoutReturnsMinPayoutRequestIdAsc = 'PAYOUT_RETURNS_MIN_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsMinPayoutRequestIdDesc = 'PAYOUT_RETURNS_MIN_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsMinRowIdAsc = 'PAYOUT_RETURNS_MIN_ROW_ID_ASC',
  PayoutReturnsMinRowIdDesc = 'PAYOUT_RETURNS_MIN_ROW_ID_DESC',
  PayoutReturnsStddevPopulationPayoutRequestIdAsc = 'PAYOUT_RETURNS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsStddevPopulationPayoutRequestIdDesc = 'PAYOUT_RETURNS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsStddevPopulationRowIdAsc = 'PAYOUT_RETURNS_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutReturnsStddevPopulationRowIdDesc = 'PAYOUT_RETURNS_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutReturnsStddevSamplePayoutRequestIdAsc = 'PAYOUT_RETURNS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsStddevSamplePayoutRequestIdDesc = 'PAYOUT_RETURNS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsStddevSampleRowIdAsc = 'PAYOUT_RETURNS_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutReturnsStddevSampleRowIdDesc = 'PAYOUT_RETURNS_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutReturnsSumPayoutRequestIdAsc = 'PAYOUT_RETURNS_SUM_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsSumPayoutRequestIdDesc = 'PAYOUT_RETURNS_SUM_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsSumRowIdAsc = 'PAYOUT_RETURNS_SUM_ROW_ID_ASC',
  PayoutReturnsSumRowIdDesc = 'PAYOUT_RETURNS_SUM_ROW_ID_DESC',
  PayoutReturnsVariancePopulationPayoutRequestIdAsc = 'PAYOUT_RETURNS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsVariancePopulationPayoutRequestIdDesc = 'PAYOUT_RETURNS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsVariancePopulationRowIdAsc = 'PAYOUT_RETURNS_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutReturnsVariancePopulationRowIdDesc = 'PAYOUT_RETURNS_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutReturnsVarianceSamplePayoutRequestIdAsc = 'PAYOUT_RETURNS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutReturnsVarianceSamplePayoutRequestIdDesc = 'PAYOUT_RETURNS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutReturnsVarianceSampleRowIdAsc = 'PAYOUT_RETURNS_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutReturnsVarianceSampleRowIdDesc = 'PAYOUT_RETURNS_VARIANCE_SAMPLE_ROW_ID_DESC',
  PayoutReviewersByPayoutIdAveragePayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_AVERAGE_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdAveragePayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_AVERAGE_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdAverageRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_AVERAGE_ROW_ID_ASC',
  PayoutReviewersByPayoutIdAverageRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_AVERAGE_ROW_ID_DESC',
  PayoutReviewersByPayoutIdCountAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_COUNT_ASC',
  PayoutReviewersByPayoutIdCountDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_COUNT_DESC',
  PayoutReviewersByPayoutIdDistinctCountPayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_DISTINCT_COUNT_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdDistinctCountPayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_DISTINCT_COUNT_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdDistinctCountRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutReviewersByPayoutIdDistinctCountRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutReviewersByPayoutIdMaxPayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MAX_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdMaxPayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MAX_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdMaxRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MAX_ROW_ID_ASC',
  PayoutReviewersByPayoutIdMaxRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MAX_ROW_ID_DESC',
  PayoutReviewersByPayoutIdMinPayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MIN_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdMinPayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MIN_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdMinRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MIN_ROW_ID_ASC',
  PayoutReviewersByPayoutIdMinRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_MIN_ROW_ID_DESC',
  PayoutReviewersByPayoutIdStddevPopulationPayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_POPULATION_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdStddevPopulationPayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_POPULATION_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdStddevPopulationRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutReviewersByPayoutIdStddevPopulationRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutReviewersByPayoutIdStddevSamplePayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_SAMPLE_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdStddevSamplePayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_SAMPLE_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdStddevSampleRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutReviewersByPayoutIdStddevSampleRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutReviewersByPayoutIdSumPayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_SUM_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdSumPayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_SUM_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdSumRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_SUM_ROW_ID_ASC',
  PayoutReviewersByPayoutIdSumRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_SUM_ROW_ID_DESC',
  PayoutReviewersByPayoutIdVariancePopulationPayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_POPULATION_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdVariancePopulationPayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_POPULATION_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdVariancePopulationRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutReviewersByPayoutIdVariancePopulationRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutReviewersByPayoutIdVarianceSamplePayoutIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_SAMPLE_PAYOUT_ID_ASC',
  PayoutReviewersByPayoutIdVarianceSamplePayoutIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_SAMPLE_PAYOUT_ID_DESC',
  PayoutReviewersByPayoutIdVarianceSampleRowIdAsc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutReviewersByPayoutIdVarianceSampleRowIdDesc = 'PAYOUT_REVIEWERS_BY_PAYOUT_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PayoutReviewsByPayoutIdAveragePayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_AVERAGE_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdAveragePayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_AVERAGE_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdAverageRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_AVERAGE_ROW_ID_ASC',
  PayoutReviewsByPayoutIdAverageRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_AVERAGE_ROW_ID_DESC',
  PayoutReviewsByPayoutIdCountAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_COUNT_ASC',
  PayoutReviewsByPayoutIdCountDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_COUNT_DESC',
  PayoutReviewsByPayoutIdDistinctCountPayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_DISTINCT_COUNT_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdDistinctCountPayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_DISTINCT_COUNT_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdDistinctCountRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutReviewsByPayoutIdDistinctCountRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutReviewsByPayoutIdMaxPayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MAX_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdMaxPayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MAX_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdMaxRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MAX_ROW_ID_ASC',
  PayoutReviewsByPayoutIdMaxRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MAX_ROW_ID_DESC',
  PayoutReviewsByPayoutIdMinPayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MIN_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdMinPayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MIN_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdMinRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MIN_ROW_ID_ASC',
  PayoutReviewsByPayoutIdMinRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_MIN_ROW_ID_DESC',
  PayoutReviewsByPayoutIdStddevPopulationPayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_POPULATION_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdStddevPopulationPayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_POPULATION_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdStddevPopulationRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutReviewsByPayoutIdStddevPopulationRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutReviewsByPayoutIdStddevSamplePayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_SAMPLE_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdStddevSamplePayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_SAMPLE_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdStddevSampleRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutReviewsByPayoutIdStddevSampleRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutReviewsByPayoutIdSumPayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_SUM_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdSumPayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_SUM_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdSumRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_SUM_ROW_ID_ASC',
  PayoutReviewsByPayoutIdSumRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_SUM_ROW_ID_DESC',
  PayoutReviewsByPayoutIdVariancePopulationPayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_POPULATION_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdVariancePopulationPayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_POPULATION_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdVariancePopulationRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutReviewsByPayoutIdVariancePopulationRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutReviewsByPayoutIdVarianceSamplePayoutIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_SAMPLE_PAYOUT_ID_ASC',
  PayoutReviewsByPayoutIdVarianceSamplePayoutIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_SAMPLE_PAYOUT_ID_DESC',
  PayoutReviewsByPayoutIdVarianceSampleRowIdAsc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutReviewsByPayoutIdVarianceSampleRowIdDesc = 'PAYOUT_REVIEWS_BY_PAYOUT_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReopenedAtAsc = 'REOPENED_AT_ASC',
  ReopenedAtDesc = 'REOPENED_AT_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type PayoutRequestStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestStddevPopulationAggregates = {
  __typename?: 'PayoutRequestStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestStddevSampleAggregates = {
  __typename?: 'PayoutRequestStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestSubscriber = Node & {
  __typename?: 'PayoutRequestSubscriber';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `PayoutRequest` that is related to this `PayoutRequestSubscriber`. */
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequestId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `PayoutRequestSubscriber`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type PayoutRequestSubscriberAggregates = {
  __typename?: 'PayoutRequestSubscriberAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutRequestSubscriberAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutRequestSubscriberDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutRequestSubscriberMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutRequestSubscriberMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutRequestSubscriberStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutRequestSubscriberStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutRequestSubscriberSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutRequestSubscriberVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutRequestSubscriberVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutRequestSubscriber` object types. */
export type PayoutRequestSubscriberAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutRequestSubscriber` objects. */
  average?: InputMaybe<PayoutRequestSubscriberAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutRequestSubscriber` objects. */
  distinctCount?: InputMaybe<PayoutRequestSubscriberDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutRequestSubscriber` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutRequestSubscriberFilter>;
  /** Maximum aggregate over matching `PayoutRequestSubscriber` objects. */
  max?: InputMaybe<PayoutRequestSubscriberMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutRequestSubscriber` objects. */
  min?: InputMaybe<PayoutRequestSubscriberMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutRequestSubscriber` objects. */
  stddevPopulation?: InputMaybe<PayoutRequestSubscriberStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutRequestSubscriber` objects. */
  stddevSample?: InputMaybe<PayoutRequestSubscriberStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutRequestSubscriber` objects. */
  sum?: InputMaybe<PayoutRequestSubscriberSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutRequestSubscriber` objects. */
  variancePopulation?: InputMaybe<PayoutRequestSubscriberVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutRequestSubscriber` objects. */
  varianceSample?: InputMaybe<PayoutRequestSubscriberVarianceSampleAggregateFilter>;
};

export type PayoutRequestSubscriberAverageAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestSubscriberAverageAggregates = {
  __typename?: 'PayoutRequestSubscriberAverageAggregates';
  /** Mean average of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutRequestSubscriber` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PayoutRequestSubscriberCondition = {
  /** Checks for equality with the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutRequestSubscriber` values. */
export type PayoutRequestSubscriberConnection = {
  __typename?: 'PayoutRequestSubscriberConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutRequestSubscriberAggregates>;
  /** A list of edges which contains the `PayoutRequestSubscriber` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutRequestSubscriberEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutRequestSubscriberAggregates>>;
  /** A list of `PayoutRequestSubscriber` objects. */
  nodes: Array<Maybe<PayoutRequestSubscriber>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutRequestSubscriber` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutRequestSubscriber` values. */
export type PayoutRequestSubscriberConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutRequestSubscriberGroupBy>;
  having?: InputMaybe<PayoutRequestSubscriberHavingInput>;
};

export type PayoutRequestSubscriberDistinctCountAggregateFilter = {
  payoutRequestId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestSubscriberDistinctCountAggregates = {
  __typename?: 'PayoutRequestSubscriberDistinctCountAggregates';
  /** Distinct count of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutRequestSubscriber` edge in the connection. */
export type PayoutRequestSubscriberEdge = {
  __typename?: 'PayoutRequestSubscriberEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutRequestSubscriber` at the end of the edge. */
  node?: Maybe<PayoutRequestSubscriber>;
};

/** A filter to be used against `PayoutRequestSubscriber` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestSubscriberFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutRequestSubscriberFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutRequestSubscriberFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutRequestSubscriberFilter>>;
  /** Filter by the object’s `payoutRequest` relation. */
  payoutRequest?: InputMaybe<PayoutRequestFilter>;
  /** Filter by the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PayoutRequestSubscriber` for usage during aggregation. */
export enum PayoutRequestSubscriberGroupBy {
  PayoutRequestId = 'PAYOUT_REQUEST_ID',
  UserId = 'USER_ID'
}

export type PayoutRequestSubscriberHavingAverageInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingDistinctCountInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PayoutRequestSubscriber` aggregates. */
export type PayoutRequestSubscriberHavingInput = {
  AND?: InputMaybe<Array<PayoutRequestSubscriberHavingInput>>;
  OR?: InputMaybe<Array<PayoutRequestSubscriberHavingInput>>;
  average?: InputMaybe<PayoutRequestSubscriberHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutRequestSubscriberHavingDistinctCountInput>;
  max?: InputMaybe<PayoutRequestSubscriberHavingMaxInput>;
  min?: InputMaybe<PayoutRequestSubscriberHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutRequestSubscriberHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutRequestSubscriberHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutRequestSubscriberHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutRequestSubscriberHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutRequestSubscriberHavingVarianceSampleInput>;
};

export type PayoutRequestSubscriberHavingMaxInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingMinInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingStddevPopulationInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingStddevSampleInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingSumInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingVariancePopulationInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberHavingVarianceSampleInput = {
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PayoutRequestSubscriberMaxAggregateFilter = {
  payoutRequestId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PayoutRequestSubscriberMaxAggregates = {
  __typename?: 'PayoutRequestSubscriberMaxAggregates';
  /** Maximum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutRequestSubscriberMinAggregateFilter = {
  payoutRequestId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PayoutRequestSubscriberMinAggregates = {
  __typename?: 'PayoutRequestSubscriberMinAggregates';
  /** Minimum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutRequestSubscriber`. */
export enum PayoutRequestSubscriberOrderBy {
  Natural = 'NATURAL',
  PayoutRequestIdAsc = 'PAYOUT_REQUEST_ID_ASC',
  PayoutRequestIdDesc = 'PAYOUT_REQUEST_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type PayoutRequestSubscriberStddevPopulationAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestSubscriberStddevPopulationAggregates = {
  __typename?: 'PayoutRequestSubscriberStddevPopulationAggregates';
  /** Population standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestSubscriberStddevSampleAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestSubscriberStddevSampleAggregates = {
  __typename?: 'PayoutRequestSubscriberStddevSampleAggregates';
  /** Sample standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestSubscriberSumAggregateFilter = {
  payoutRequestId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestSubscriberSumAggregates = {
  __typename?: 'PayoutRequestSubscriberSumAggregates';
  /** Sum of payoutRequestId across the matching connection */
  payoutRequestId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type PayoutRequestSubscriberVariancePopulationAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestSubscriberVariancePopulationAggregates = {
  __typename?: 'PayoutRequestSubscriberVariancePopulationAggregates';
  /** Population variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestSubscriberVarianceSampleAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestSubscriberVarianceSampleAggregates = {
  __typename?: 'PayoutRequestSubscriberVarianceSampleAggregates';
  /** Sample variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PayoutRequestSumAggregates = {
  __typename?: 'PayoutRequestSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigInt']['output'];
  /** Sum of approvingUserId across the matching connection */
  approvingUserId: Scalars['BigInt']['output'];
  /** Sum of impairmentRealized across the matching connection */
  impairmentRealized: Scalars['BigFloat']['output'];
  /** Sum of requestedAmount across the matching connection */
  requestedAmount: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of seedCapitalAmount across the matching connection */
  seedCapitalAmount: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `PayoutDepartmentApproval` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestToManyPayoutDepartmentApprovalFilter = {
  /** Aggregates across related `PayoutDepartmentApproval` match the filter criteria. */
  aggregates?: InputMaybe<PayoutDepartmentApprovalAggregatesFilter>;
  /** Every related `PayoutDepartmentApproval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutDepartmentApprovalFilter>;
  /** No related `PayoutDepartmentApproval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutDepartmentApprovalFilter>;
  /** Some related `PayoutDepartmentApproval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutDepartmentApprovalFilter>;
};

/** A filter to be used against many `PayoutRequestAsset` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestToManyPayoutRequestAssetFilter = {
  /** Aggregates across related `PayoutRequestAsset` match the filter criteria. */
  aggregates?: InputMaybe<PayoutRequestAssetAggregatesFilter>;
  /** Every related `PayoutRequestAsset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutRequestAssetFilter>;
  /** No related `PayoutRequestAsset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutRequestAssetFilter>;
  /** Some related `PayoutRequestAsset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutRequestAssetFilter>;
};

/** A filter to be used against many `PayoutRequestSubscriber` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestToManyPayoutRequestSubscriberFilter = {
  /** Aggregates across related `PayoutRequestSubscriber` match the filter criteria. */
  aggregates?: InputMaybe<PayoutRequestSubscriberAggregatesFilter>;
  /** Every related `PayoutRequestSubscriber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutRequestSubscriberFilter>;
  /** No related `PayoutRequestSubscriber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutRequestSubscriberFilter>;
  /** Some related `PayoutRequestSubscriber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutRequestSubscriberFilter>;
};

/** A filter to be used against many `PayoutReturn` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestToManyPayoutReturnFilter = {
  /** Aggregates across related `PayoutReturn` match the filter criteria. */
  aggregates?: InputMaybe<PayoutReturnAggregatesFilter>;
  /** Every related `PayoutReturn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutReturnFilter>;
  /** No related `PayoutReturn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutReturnFilter>;
  /** Some related `PayoutReturn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutReturnFilter>;
};

/** A filter to be used against many `PayoutReview` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestToManyPayoutReviewFilter = {
  /** Aggregates across related `PayoutReview` match the filter criteria. */
  aggregates?: InputMaybe<PayoutReviewAggregatesFilter>;
  /** Every related `PayoutReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutReviewFilter>;
  /** No related `PayoutReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutReviewFilter>;
  /** Some related `PayoutReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutReviewFilter>;
};

/** A filter to be used against many `PayoutReviewer` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestToManyPayoutReviewerFilter = {
  /** Aggregates across related `PayoutReviewer` match the filter criteria. */
  aggregates?: InputMaybe<PayoutReviewerAggregatesFilter>;
  /** Every related `PayoutReviewer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutReviewerFilter>;
  /** No related `PayoutReviewer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutReviewerFilter>;
  /** Some related `PayoutReviewer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutReviewerFilter>;
};

export type PayoutRequestVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestVariancePopulationAggregates = {
  __typename?: 'PayoutRequestVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutRequestVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PayoutRequestVarianceSampleAggregates = {
  __typename?: 'PayoutRequestVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of approvingUserId across the matching connection */
  approvingUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of impairmentRealized across the matching connection */
  impairmentRealized?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of requestedAmount across the matching connection */
  requestedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of seedCapitalAmount across the matching connection */
  seedCapitalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `PayoutRequestsStatsRecord` values. */
export type PayoutRequestsStatsConnection = {
  __typename?: 'PayoutRequestsStatsConnection';
  /** A list of edges which contains the `PayoutRequestsStatsRecord` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutRequestsStatsEdge>>;
  /** A list of `PayoutRequestsStatsRecord` objects. */
  nodes: Array<Maybe<PayoutRequestsStatsRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutRequestsStatsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PayoutRequestsStatsRecord` edge in the connection. */
export type PayoutRequestsStatsEdge = {
  __typename?: 'PayoutRequestsStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutRequestsStatsRecord` at the end of the edge. */
  node?: Maybe<PayoutRequestsStatsRecord>;
};

export type PayoutRequestsStatsRecord = {
  __typename?: 'PayoutRequestsStatsRecord';
  complianceCount?: Maybe<Scalars['Int']['output']>;
  financeCount?: Maybe<Scalars['Int']['output']>;
  fundingCount?: Maybe<Scalars['Int']['output']>;
  last24Hours?: Maybe<Scalars['Int']['output']>;
  olderThan24Hours?: Maybe<Scalars['Int']['output']>;
  olderThan30Days?: Maybe<Scalars['Int']['output']>;
  olderThan48Hours?: Maybe<Scalars['Int']['output']>;
  olderThan72Hours?: Maybe<Scalars['Int']['output']>;
  riskCount?: Maybe<Scalars['Int']['output']>;
  totalException?: Maybe<Scalars['Int']['output']>;
  totalOnHold?: Maybe<Scalars['Int']['output']>;
  totalPending?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `PayoutRequestsStatsRecord` object types. All fields are combined with a logical ‘and.’ */
export type PayoutRequestsStatsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutRequestsStatsRecordFilter>>;
  /** Filter by the object’s `complianceCount` field. */
  complianceCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `financeCount` field. */
  financeCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fundingCount` field. */
  fundingCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `last24Hours` field. */
  last24Hours?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutRequestsStatsRecordFilter>;
  /** Filter by the object’s `olderThan24Hours` field. */
  olderThan24Hours?: InputMaybe<IntFilter>;
  /** Filter by the object’s `olderThan30Days` field. */
  olderThan30Days?: InputMaybe<IntFilter>;
  /** Filter by the object’s `olderThan48Hours` field. */
  olderThan48Hours?: InputMaybe<IntFilter>;
  /** Filter by the object’s `olderThan72Hours` field. */
  olderThan72Hours?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutRequestsStatsRecordFilter>>;
  /** Filter by the object’s `riskCount` field. */
  riskCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalException` field. */
  totalException?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalOnHold` field. */
  totalOnHold?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalPending` field. */
  totalPending?: InputMaybe<IntFilter>;
};

export type PayoutReturn = Node & {
  __typename?: 'PayoutReturn';
  additionalDetails?: Maybe<Scalars['String']['output']>;
  bankReference?: Maybe<Scalars['String']['output']>;
  bankReturnedAmount: Scalars['BigFloat']['output'];
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  netSuiteJournalEntryFailedAt?: Maybe<Scalars['Datetime']['output']>;
  netSuiteJournalEntryId?: Maybe<Scalars['String']['output']>;
  netSuitePaymentFailedAt?: Maybe<Scalars['Datetime']['output']>;
  netSuitePaymentId?: Maybe<Scalars['String']['output']>;
  netSuiteReturnBillFailedAt?: Maybe<Scalars['Datetime']['output']>;
  netSuiteReturnBillId?: Maybe<Scalars['String']['output']>;
  notificationDismissedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `PayoutRequest` that is related to this `PayoutReturn`. */
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequestId: Scalars['Int']['output'];
  /** Reads a single `PayoutReturnReasonCode` that is related to this `PayoutReturn`. */
  reasonCode?: Maybe<PayoutReturnReasonCode>;
  reasonCodeId: Scalars['Int']['output'];
  recordedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PayoutReturn`. */
  recordedBy?: Maybe<User>;
  recordedById: Scalars['Int']['output'];
  resubmittedAt?: Maybe<Scalars['Datetime']['output']>;
  resubmittedBankingInfoId?: Maybe<Scalars['Int']['output']>;
  resubmittedMethod?: Maybe<Scalars['String']['output']>;
  returnAmount: Scalars['Int']['output'];
  returnFee: Scalars['Int']['output'];
  returnedBankingInfoId?: Maybe<Scalars['Int']['output']>;
  returnedFinanceApprovedAt: Scalars['Datetime']['output'];
  returnedMethod: Scalars['String']['output'];
  returnedOn?: Maybe<Scalars['Date']['output']>;
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type PayoutReturnAggregates = {
  __typename?: 'PayoutReturnAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutReturnAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutReturnDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutReturnMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutReturnMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutReturnStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutReturnStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutReturnSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutReturnVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutReturnVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutReturn` object types. */
export type PayoutReturnAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutReturn` objects. */
  average?: InputMaybe<PayoutReturnAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutReturn` objects. */
  distinctCount?: InputMaybe<PayoutReturnDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutReturn` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutReturnFilter>;
  /** Maximum aggregate over matching `PayoutReturn` objects. */
  max?: InputMaybe<PayoutReturnMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutReturn` objects. */
  min?: InputMaybe<PayoutReturnMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutReturn` objects. */
  stddevPopulation?: InputMaybe<PayoutReturnStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutReturn` objects. */
  stddevSample?: InputMaybe<PayoutReturnStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutReturn` objects. */
  sum?: InputMaybe<PayoutReturnSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutReturn` objects. */
  variancePopulation?: InputMaybe<PayoutReturnVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutReturn` objects. */
  varianceSample?: InputMaybe<PayoutReturnVarianceSampleAggregateFilter>;
};

export type PayoutReturnAverageAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReturnAverageAggregates = {
  __typename?: 'PayoutReturnAverageAggregates';
  /** Mean average of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutReturn` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PayoutReturnCondition = {
  /** Checks for equality with the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutReturn` values. */
export type PayoutReturnConnection = {
  __typename?: 'PayoutReturnConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutReturnAggregates>;
  /** A list of edges which contains the `PayoutReturn` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutReturnEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutReturnAggregates>>;
  /** A list of `PayoutReturn` objects. */
  nodes: Array<Maybe<PayoutReturn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutReturn` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutReturn` values. */
export type PayoutReturnConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutReturnGroupBy>;
  having?: InputMaybe<PayoutReturnHavingInput>;
};

export type PayoutReturnDistinctCountAggregateFilter = {
  payoutRequestId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutReturnDistinctCountAggregates = {
  __typename?: 'PayoutReturnDistinctCountAggregates';
  /** Distinct count of additionalDetails across the matching connection */
  additionalDetails?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bankReference across the matching connection */
  bankReference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closedAt across the matching connection */
  closedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteJournalEntryFailedAt across the matching connection */
  netSuiteJournalEntryFailedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteJournalEntryId across the matching connection */
  netSuiteJournalEntryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuitePaymentFailedAt across the matching connection */
  netSuitePaymentFailedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuitePaymentId across the matching connection */
  netSuitePaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteReturnBillFailedAt across the matching connection */
  netSuiteReturnBillFailedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteReturnBillId across the matching connection */
  netSuiteReturnBillId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notificationDismissedAt across the matching connection */
  notificationDismissedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of recordedAt across the matching connection */
  recordedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resubmittedAt across the matching connection */
  resubmittedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resubmittedMethod across the matching connection */
  resubmittedMethod?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of returnedFinanceApprovedAt across the matching connection */
  returnedFinanceApprovedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of returnedMethod across the matching connection */
  returnedMethod?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of returnedOn across the matching connection */
  returnedOn?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutReturn` edge in the connection. */
export type PayoutReturnEdge = {
  __typename?: 'PayoutReturnEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutReturn` at the end of the edge. */
  node?: Maybe<PayoutReturn>;
};

/** A filter to be used against `PayoutReturn` object types. All fields are combined with a logical ‘and.’ */
export type PayoutReturnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutReturnFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutReturnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutReturnFilter>>;
  /** Filter by the object’s `payoutRequest` relation. */
  payoutRequest?: InputMaybe<PayoutRequestFilter>;
  /** Filter by the object’s `payoutRequestId` field. */
  payoutRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reasonCode` relation. */
  reasonCode?: InputMaybe<PayoutReturnReasonCodeFilter>;
  /** Filter by the object’s `recordedBy` relation. */
  recordedBy?: InputMaybe<UserFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PayoutReturn` for usage during aggregation. */
export enum PayoutReturnGroupBy {
  PayoutRequestId = 'PAYOUT_REQUEST_ID'
}

export type PayoutReturnHavingAverageInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingDistinctCountInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PayoutReturn` aggregates. */
export type PayoutReturnHavingInput = {
  AND?: InputMaybe<Array<PayoutReturnHavingInput>>;
  OR?: InputMaybe<Array<PayoutReturnHavingInput>>;
  average?: InputMaybe<PayoutReturnHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutReturnHavingDistinctCountInput>;
  max?: InputMaybe<PayoutReturnHavingMaxInput>;
  min?: InputMaybe<PayoutReturnHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutReturnHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutReturnHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutReturnHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutReturnHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutReturnHavingVarianceSampleInput>;
};

export type PayoutReturnHavingMaxInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingMinInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingStddevPopulationInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingStddevSampleInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingSumInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingVariancePopulationInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnHavingVarianceSampleInput = {
  bankReturnedAmount?: InputMaybe<HavingBigfloatFilter>;
  closedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteJournalEntryFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuitePaymentFailedAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteReturnBillFailedAt?: InputMaybe<HavingDatetimeFilter>;
  notificationDismissedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutRequestId?: InputMaybe<HavingIntFilter>;
  reasonCodeId?: InputMaybe<HavingIntFilter>;
  recordedAt?: InputMaybe<HavingDatetimeFilter>;
  recordedById?: InputMaybe<HavingIntFilter>;
  resubmittedAt?: InputMaybe<HavingDatetimeFilter>;
  resubmittedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnAmount?: InputMaybe<HavingIntFilter>;
  returnFee?: InputMaybe<HavingIntFilter>;
  returnedBankingInfoId?: InputMaybe<HavingIntFilter>;
  returnedFinanceApprovedAt?: InputMaybe<HavingDatetimeFilter>;
  returnedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReturnMaxAggregateFilter = {
  payoutRequestId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReturnMaxAggregates = {
  __typename?: 'PayoutReturnMaxAggregates';
  /** Maximum of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['Int']['output']>;
  /** Maximum of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['Int']['output']>;
  /** Maximum of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutReturnMinAggregateFilter = {
  payoutRequestId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReturnMinAggregates = {
  __typename?: 'PayoutReturnMinAggregates';
  /** Minimum of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['Int']['output']>;
  /** Minimum of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['Int']['output']>;
  /** Minimum of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutReturn`. */
export enum PayoutReturnOrderBy {
  Natural = 'NATURAL',
  PayoutRequestIdAsc = 'PAYOUT_REQUEST_ID_ASC',
  PayoutRequestIdDesc = 'PAYOUT_REQUEST_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type PayoutReturnReasonCode = Node & {
  __typename?: 'PayoutReturnReasonCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  payoutMethods: Array<Maybe<Scalars['String']['output']>>;
  rowId: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  traderCategory: Scalars['String']['output'];
  traderMessage: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type PayoutReturnReasonCodeAggregates = {
  __typename?: 'PayoutReturnReasonCodeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutReturnReasonCodeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutReturnReasonCodeDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutReturnReasonCodeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutReturnReasonCodeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutReturnReasonCodeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutReturnReasonCodeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutReturnReasonCodeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutReturnReasonCodeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutReturnReasonCodeVarianceSampleAggregates>;
};

export type PayoutReturnReasonCodeAverageAggregates = {
  __typename?: 'PayoutReturnReasonCodeAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutReturnReasonCode` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PayoutReturnReasonCodeCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutReturnReasonCode` values. */
export type PayoutReturnReasonCodeConnection = {
  __typename?: 'PayoutReturnReasonCodeConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutReturnReasonCodeAggregates>;
  /** A list of edges which contains the `PayoutReturnReasonCode` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutReturnReasonCodeEdge>>;
  /** A list of `PayoutReturnReasonCode` objects. */
  nodes: Array<Maybe<PayoutReturnReasonCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutReturnReasonCode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type PayoutReturnReasonCodeDistinctCountAggregates = {
  __typename?: 'PayoutReturnReasonCodeDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of code across the matching connection */
  code?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutMethods across the matching connection */
  payoutMethods?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderCategory across the matching connection */
  traderCategory?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderMessage across the matching connection */
  traderMessage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutReturnReasonCode` edge in the connection. */
export type PayoutReturnReasonCodeEdge = {
  __typename?: 'PayoutReturnReasonCodeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutReturnReasonCode` at the end of the edge. */
  node?: Maybe<PayoutReturnReasonCode>;
};

/** A filter to be used against `PayoutReturnReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type PayoutReturnReasonCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutReturnReasonCodeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutReturnReasonCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutReturnReasonCodeFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReturnReasonCodeMaxAggregates = {
  __typename?: 'PayoutReturnReasonCodeMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type PayoutReturnReasonCodeMinAggregates = {
  __typename?: 'PayoutReturnReasonCodeMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutReturnReasonCode`. */
export enum PayoutReturnReasonCodeOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type PayoutReturnReasonCodeStddevPopulationAggregates = {
  __typename?: 'PayoutReturnReasonCodeStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnReasonCodeStddevSampleAggregates = {
  __typename?: 'PayoutReturnReasonCodeStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnReasonCodeSumAggregates = {
  __typename?: 'PayoutReturnReasonCodeSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of sortOrder across the matching connection */
  sortOrder: Scalars['BigInt']['output'];
};

export type PayoutReturnReasonCodeVariancePopulationAggregates = {
  __typename?: 'PayoutReturnReasonCodeVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnReasonCodeVarianceSampleAggregates = {
  __typename?: 'PayoutReturnReasonCodeVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnStddevPopulationAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReturnStddevPopulationAggregates = {
  __typename?: 'PayoutReturnStddevPopulationAggregates';
  /** Population standard deviation of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnStddevSampleAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReturnStddevSampleAggregates = {
  __typename?: 'PayoutReturnStddevSampleAggregates';
  /** Sample standard deviation of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnSumAggregateFilter = {
  payoutRequestId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutReturnSumAggregates = {
  __typename?: 'PayoutReturnSumAggregates';
  /** Sum of bankReturnedAmount across the matching connection */
  bankReturnedAmount: Scalars['BigFloat']['output'];
  /** Sum of payoutRequestId across the matching connection */
  payoutRequestId: Scalars['BigInt']['output'];
  /** Sum of reasonCodeId across the matching connection */
  reasonCodeId: Scalars['BigInt']['output'];
  /** Sum of recordedById across the matching connection */
  recordedById: Scalars['BigInt']['output'];
  /** Sum of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId: Scalars['BigInt']['output'];
  /** Sum of returnAmount across the matching connection */
  returnAmount: Scalars['BigInt']['output'];
  /** Sum of returnFee across the matching connection */
  returnFee: Scalars['BigInt']['output'];
  /** Sum of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type PayoutReturnVariancePopulationAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReturnVariancePopulationAggregates = {
  __typename?: 'PayoutReturnVariancePopulationAggregates';
  /** Population variance of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReturnVarianceSampleAggregateFilter = {
  payoutRequestId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReturnVarianceSampleAggregates = {
  __typename?: 'PayoutReturnVarianceSampleAggregates';
  /** Sample variance of bankReturnedAmount across the matching connection */
  bankReturnedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of payoutRequestId across the matching connection */
  payoutRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of recordedById across the matching connection */
  recordedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of resubmittedBankingInfoId across the matching connection */
  resubmittedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of returnAmount across the matching connection */
  returnAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of returnFee across the matching connection */
  returnFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of returnedBankingInfoId across the matching connection */
  returnedBankingInfoId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReview = Node & {
  __typename?: 'PayoutReview';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PayoutRequest` that is related to this `PayoutReview`. */
  payout?: Maybe<PayoutRequest>;
  payoutId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `PayoutReview`. */
  reviewer?: Maybe<User>;
  reviewerId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type PayoutReviewAggregates = {
  __typename?: 'PayoutReviewAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutReviewAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutReviewDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutReviewMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutReviewMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutReviewStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutReviewStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutReviewSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutReviewVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutReviewVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutReview` object types. */
export type PayoutReviewAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutReview` objects. */
  average?: InputMaybe<PayoutReviewAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutReview` objects. */
  distinctCount?: InputMaybe<PayoutReviewDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutReview` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutReviewFilter>;
  /** Maximum aggregate over matching `PayoutReview` objects. */
  max?: InputMaybe<PayoutReviewMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutReview` objects. */
  min?: InputMaybe<PayoutReviewMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutReview` objects. */
  stddevPopulation?: InputMaybe<PayoutReviewStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutReview` objects. */
  stddevSample?: InputMaybe<PayoutReviewStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutReview` objects. */
  sum?: InputMaybe<PayoutReviewSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutReview` objects. */
  variancePopulation?: InputMaybe<PayoutReviewVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutReview` objects. */
  varianceSample?: InputMaybe<PayoutReviewVarianceSampleAggregateFilter>;
};

export type PayoutReviewAverageAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewAverageAggregates = {
  __typename?: 'PayoutReviewAverageAggregates';
  /** Mean average of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutReview` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PayoutReviewCondition = {
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutReview` values. */
export type PayoutReviewConnection = {
  __typename?: 'PayoutReviewConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutReviewAggregates>;
  /** A list of edges which contains the `PayoutReview` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutReviewEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutReviewAggregates>>;
  /** A list of `PayoutReview` objects. */
  nodes: Array<Maybe<PayoutReview>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutReview` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutReview` values. */
export type PayoutReviewConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutReviewGroupBy>;
  having?: InputMaybe<PayoutReviewHavingInput>;
};

export type PayoutReviewDistinctCountAggregateFilter = {
  payoutId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutReviewDistinctCountAggregates = {
  __typename?: 'PayoutReviewDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutReview` edge in the connection. */
export type PayoutReviewEdge = {
  __typename?: 'PayoutReviewEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutReview` at the end of the edge. */
  node?: Maybe<PayoutReview>;
};

/** A filter to be used against `PayoutReview` object types. All fields are combined with a logical ‘and.’ */
export type PayoutReviewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutReviewFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutReviewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutReviewFilter>>;
  /** Filter by the object’s `payout` relation. */
  payout?: InputMaybe<PayoutRequestFilter>;
  /** Filter by the object’s `payoutId` field. */
  payoutId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reviewer` relation. */
  reviewer?: InputMaybe<UserFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PayoutReview` for usage during aggregation. */
export enum PayoutReviewGroupBy {
  PayoutId = 'PAYOUT_ID'
}

export type PayoutReviewHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PayoutReview` aggregates. */
export type PayoutReviewHavingInput = {
  AND?: InputMaybe<Array<PayoutReviewHavingInput>>;
  OR?: InputMaybe<Array<PayoutReviewHavingInput>>;
  average?: InputMaybe<PayoutReviewHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutReviewHavingDistinctCountInput>;
  max?: InputMaybe<PayoutReviewHavingMaxInput>;
  min?: InputMaybe<PayoutReviewHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutReviewHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutReviewHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutReviewHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutReviewHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutReviewHavingVarianceSampleInput>;
};

export type PayoutReviewHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewMaxAggregateFilter = {
  payoutId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReviewMaxAggregates = {
  __typename?: 'PayoutReviewMaxAggregates';
  /** Maximum of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutReviewMinAggregateFilter = {
  payoutId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReviewMinAggregates = {
  __typename?: 'PayoutReviewMinAggregates';
  /** Minimum of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutReview`. */
export enum PayoutReviewOrderBy {
  Natural = 'NATURAL',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type PayoutReviewStddevPopulationAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewStddevPopulationAggregates = {
  __typename?: 'PayoutReviewStddevPopulationAggregates';
  /** Population standard deviation of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewStddevSampleAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewStddevSampleAggregates = {
  __typename?: 'PayoutReviewStddevSampleAggregates';
  /** Sample standard deviation of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewSumAggregateFilter = {
  payoutId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutReviewSumAggregates = {
  __typename?: 'PayoutReviewSumAggregates';
  /** Sum of payoutId across the matching connection */
  payoutId: Scalars['BigInt']['output'];
  /** Sum of reviewerId across the matching connection */
  reviewerId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type PayoutReviewVariancePopulationAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewVariancePopulationAggregates = {
  __typename?: 'PayoutReviewVariancePopulationAggregates';
  /** Population variance of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewVarianceSampleAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewVarianceSampleAggregates = {
  __typename?: 'PayoutReviewVarianceSampleAggregates';
  /** Sample variance of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewer = Node & {
  __typename?: 'PayoutReviewer';
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PayoutRequest` that is related to this `PayoutReviewer`. */
  payout?: Maybe<PayoutRequest>;
  payoutId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `PayoutReviewer`. */
  reviewer?: Maybe<User>;
  reviewerId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type PayoutReviewerAggregates = {
  __typename?: 'PayoutReviewerAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PayoutReviewerAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PayoutReviewerDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PayoutReviewerMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PayoutReviewerMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PayoutReviewerStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PayoutReviewerStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PayoutReviewerSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PayoutReviewerVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PayoutReviewerVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PayoutReviewer` object types. */
export type PayoutReviewerAggregatesFilter = {
  /** Mean average aggregate over matching `PayoutReviewer` objects. */
  average?: InputMaybe<PayoutReviewerAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PayoutReviewer` objects. */
  distinctCount?: InputMaybe<PayoutReviewerDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PayoutReviewer` object to be included within the aggregate. */
  filter?: InputMaybe<PayoutReviewerFilter>;
  /** Maximum aggregate over matching `PayoutReviewer` objects. */
  max?: InputMaybe<PayoutReviewerMaxAggregateFilter>;
  /** Minimum aggregate over matching `PayoutReviewer` objects. */
  min?: InputMaybe<PayoutReviewerMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PayoutReviewer` objects. */
  stddevPopulation?: InputMaybe<PayoutReviewerStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PayoutReviewer` objects. */
  stddevSample?: InputMaybe<PayoutReviewerStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PayoutReviewer` objects. */
  sum?: InputMaybe<PayoutReviewerSumAggregateFilter>;
  /** Population variance aggregate over matching `PayoutReviewer` objects. */
  variancePopulation?: InputMaybe<PayoutReviewerVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PayoutReviewer` objects. */
  varianceSample?: InputMaybe<PayoutReviewerVarianceSampleAggregateFilter>;
};

export type PayoutReviewerAverageAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewerAverageAggregates = {
  __typename?: 'PayoutReviewerAverageAggregates';
  /** Mean average of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PayoutReviewer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PayoutReviewerCondition = {
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PayoutReviewer` values. */
export type PayoutReviewerConnection = {
  __typename?: 'PayoutReviewerConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PayoutReviewerAggregates>;
  /** A list of edges which contains the `PayoutReviewer` and cursor to aid in pagination. */
  edges: Array<Maybe<PayoutReviewerEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PayoutReviewerAggregates>>;
  /** A list of `PayoutReviewer` objects. */
  nodes: Array<Maybe<PayoutReviewer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayoutReviewer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PayoutReviewer` values. */
export type PayoutReviewerConnectionGroupedAggregatesArgs = {
  groupBy: Array<PayoutReviewerGroupBy>;
  having?: InputMaybe<PayoutReviewerHavingInput>;
};

export type PayoutReviewerDistinctCountAggregateFilter = {
  payoutId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutReviewerDistinctCountAggregates = {
  __typename?: 'PayoutReviewerDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PayoutReviewer` edge in the connection. */
export type PayoutReviewerEdge = {
  __typename?: 'PayoutReviewerEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PayoutReviewer` at the end of the edge. */
  node?: Maybe<PayoutReviewer>;
};

/** A filter to be used against `PayoutReviewer` object types. All fields are combined with a logical ‘and.’ */
export type PayoutReviewerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PayoutReviewerFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PayoutReviewerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PayoutReviewerFilter>>;
  /** Filter by the object’s `payout` relation. */
  payout?: InputMaybe<PayoutRequestFilter>;
  /** Filter by the object’s `payoutId` field. */
  payoutId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reviewer` relation. */
  reviewer?: InputMaybe<UserFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PayoutReviewer` for usage during aggregation. */
export enum PayoutReviewerGroupBy {
  PayoutId = 'PAYOUT_ID'
}

export type PayoutReviewerHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PayoutReviewer` aggregates. */
export type PayoutReviewerHavingInput = {
  AND?: InputMaybe<Array<PayoutReviewerHavingInput>>;
  OR?: InputMaybe<Array<PayoutReviewerHavingInput>>;
  average?: InputMaybe<PayoutReviewerHavingAverageInput>;
  distinctCount?: InputMaybe<PayoutReviewerHavingDistinctCountInput>;
  max?: InputMaybe<PayoutReviewerHavingMaxInput>;
  min?: InputMaybe<PayoutReviewerHavingMinInput>;
  stddevPopulation?: InputMaybe<PayoutReviewerHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PayoutReviewerHavingStddevSampleInput>;
  sum?: InputMaybe<PayoutReviewerHavingSumInput>;
  variancePopulation?: InputMaybe<PayoutReviewerHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PayoutReviewerHavingVarianceSampleInput>;
};

export type PayoutReviewerHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  payoutId?: InputMaybe<HavingIntFilter>;
  reviewerId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PayoutReviewerMaxAggregateFilter = {
  payoutId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReviewerMaxAggregates = {
  __typename?: 'PayoutReviewerMaxAggregates';
  /** Maximum of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type PayoutReviewerMinAggregateFilter = {
  payoutId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type PayoutReviewerMinAggregates = {
  __typename?: 'PayoutReviewerMinAggregates';
  /** Minimum of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PayoutReviewer`. */
export enum PayoutReviewerOrderBy {
  Natural = 'NATURAL',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type PayoutReviewerStddevPopulationAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewerStddevPopulationAggregates = {
  __typename?: 'PayoutReviewerStddevPopulationAggregates';
  /** Population standard deviation of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewerStddevSampleAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewerStddevSampleAggregates = {
  __typename?: 'PayoutReviewerStddevSampleAggregates';
  /** Sample standard deviation of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewerSumAggregateFilter = {
  payoutId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type PayoutReviewerSumAggregates = {
  __typename?: 'PayoutReviewerSumAggregates';
  /** Sum of payoutId across the matching connection */
  payoutId: Scalars['BigInt']['output'];
  /** Sum of reviewerId across the matching connection */
  reviewerId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type PayoutReviewerVariancePopulationAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewerVariancePopulationAggregates = {
  __typename?: 'PayoutReviewerVariancePopulationAggregates';
  /** Population variance of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PayoutReviewerVarianceSampleAggregateFilter = {
  payoutId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type PayoutReviewerVarianceSampleAggregates = {
  __typename?: 'PayoutReviewerVarianceSampleAggregates';
  /** Sample variance of payoutId across the matching connection */
  payoutId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reviewerId across the matching connection */
  reviewerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A single finalized payout approved yesterday in America/Chicago time. */
export type PayoutRollupItem = {
  __typename?: 'PayoutRollupItem';
  amount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

/**
 * Yesterday's eligible payouts grouped by type (America/Chicago).
 * Used to determine rollup banner eligibility: banner shows when more than
 * one payout of the same type was approved on the same CT day.
 */
export type PayoutRollupResult = {
  __typename?: 'PayoutRollupResult';
  lfa: Array<PayoutRollupItem>;
  xfa: Array<PayoutRollupItem>;
};

export type PaypalTransaction = Node & {
  __typename?: 'PaypalTransaction';
  amount: Scalars['BigFloat']['output'];
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingRegion?: Maybe<Scalars['String']['output']>;
  billingStreet?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  errorDescription?: Maybe<Scalars['String']['output']>;
  gateway: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  nuveiPaymentId?: Maybe<Scalars['String']['output']>;
  paypalResponse?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PaypalTransaction`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type PersonaInquiryEvent = {
  __typename?: 'PersonaInquiryEvent';
  createdAt: Scalars['Datetime']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  payload: Scalars['JSON']['output'];
  personaCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  personaEventId: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PersonaTransactionEvent = {
  __typename?: 'PersonaTransactionEvent';
  createdAt: Scalars['Datetime']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  payload: Scalars['JSON']['output'];
  personaCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  personaEventId: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PersonaWebhookEvent = Node & {
  __typename?: 'PersonaWebhookEvent';
  createdAt: Scalars['Datetime']['output'];
  eventName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  personaCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  personaEventId: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `PersonaWebhookEvent`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PersonaWebhookEventAggregates = {
  __typename?: 'PersonaWebhookEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PersonaWebhookEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PersonaWebhookEventDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PersonaWebhookEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PersonaWebhookEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PersonaWebhookEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PersonaWebhookEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PersonaWebhookEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PersonaWebhookEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PersonaWebhookEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PersonaWebhookEvent` object types. */
export type PersonaWebhookEventAggregatesFilter = {
  /** Mean average aggregate over matching `PersonaWebhookEvent` objects. */
  average?: InputMaybe<PersonaWebhookEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PersonaWebhookEvent` objects. */
  distinctCount?: InputMaybe<PersonaWebhookEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PersonaWebhookEvent` object to be included within the aggregate. */
  filter?: InputMaybe<PersonaWebhookEventFilter>;
  /** Maximum aggregate over matching `PersonaWebhookEvent` objects. */
  max?: InputMaybe<PersonaWebhookEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `PersonaWebhookEvent` objects. */
  min?: InputMaybe<PersonaWebhookEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PersonaWebhookEvent` objects. */
  stddevPopulation?: InputMaybe<PersonaWebhookEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PersonaWebhookEvent` objects. */
  stddevSample?: InputMaybe<PersonaWebhookEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PersonaWebhookEvent` objects. */
  sum?: InputMaybe<PersonaWebhookEventSumAggregateFilter>;
  /** Population variance aggregate over matching `PersonaWebhookEvent` objects. */
  variancePopulation?: InputMaybe<PersonaWebhookEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PersonaWebhookEvent` objects. */
  varianceSample?: InputMaybe<PersonaWebhookEventVarianceSampleAggregateFilter>;
};

export type PersonaWebhookEventAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PersonaWebhookEventAverageAggregates = {
  __typename?: 'PersonaWebhookEventAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PersonaWebhookEvent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PersonaWebhookEventCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eventName` field. */
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `personaCreatedAt` field. */
  personaCreatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `personaEventId` field. */
  personaEventId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `resourceId` field. */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PersonaWebhookEvent` values. */
export type PersonaWebhookEventConnection = {
  __typename?: 'PersonaWebhookEventConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PersonaWebhookEventAggregates>;
  /** A list of edges which contains the `PersonaWebhookEvent` and cursor to aid in pagination. */
  edges: Array<Maybe<PersonaWebhookEventEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PersonaWebhookEventAggregates>>;
  /** A list of `PersonaWebhookEvent` objects. */
  nodes: Array<Maybe<PersonaWebhookEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PersonaWebhookEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PersonaWebhookEvent` values. */
export type PersonaWebhookEventConnectionGroupedAggregatesArgs = {
  groupBy: Array<PersonaWebhookEventGroupBy>;
  having?: InputMaybe<PersonaWebhookEventHavingInput>;
};

export type PersonaWebhookEventDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  eventName?: InputMaybe<BigIntFilter>;
  personaCreatedAt?: InputMaybe<BigIntFilter>;
  personaEventId?: InputMaybe<BigIntFilter>;
  resourceId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PersonaWebhookEventDistinctCountAggregates = {
  __typename?: 'PersonaWebhookEventDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventName across the matching connection */
  eventName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of integrationId across the matching connection */
  integrationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of payload across the matching connection */
  payload?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of personaCreatedAt across the matching connection */
  personaCreatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of personaEventId across the matching connection */
  personaEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resourceId across the matching connection */
  resourceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PersonaWebhookEvent` edge in the connection. */
export type PersonaWebhookEventEdge = {
  __typename?: 'PersonaWebhookEventEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PersonaWebhookEvent` at the end of the edge. */
  node?: Maybe<PersonaWebhookEvent>;
};

/** A filter to be used against `PersonaWebhookEvent` object types. All fields are combined with a logical ‘and.’ */
export type PersonaWebhookEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PersonaWebhookEventFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventName` field. */
  eventName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PersonaWebhookEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PersonaWebhookEventFilter>>;
  /** Filter by the object’s `personaCreatedAt` field. */
  personaCreatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `personaEventId` field. */
  personaEventId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `resourceId` field. */
  resourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PersonaWebhookEvent` for usage during aggregation. */
export enum PersonaWebhookEventGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  EventName = 'EVENT_NAME',
  PersonaCreatedAt = 'PERSONA_CREATED_AT',
  PersonaCreatedAtTruncatedToDay = 'PERSONA_CREATED_AT_TRUNCATED_TO_DAY',
  PersonaCreatedAtTruncatedToHour = 'PERSONA_CREATED_AT_TRUNCATED_TO_HOUR',
  ResourceId = 'RESOURCE_ID',
  Status = 'STATUS',
  UserId = 'USER_ID'
}

export type PersonaWebhookEventHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PersonaWebhookEvent` aggregates. */
export type PersonaWebhookEventHavingInput = {
  AND?: InputMaybe<Array<PersonaWebhookEventHavingInput>>;
  OR?: InputMaybe<Array<PersonaWebhookEventHavingInput>>;
  average?: InputMaybe<PersonaWebhookEventHavingAverageInput>;
  distinctCount?: InputMaybe<PersonaWebhookEventHavingDistinctCountInput>;
  max?: InputMaybe<PersonaWebhookEventHavingMaxInput>;
  min?: InputMaybe<PersonaWebhookEventHavingMinInput>;
  stddevPopulation?: InputMaybe<PersonaWebhookEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PersonaWebhookEventHavingStddevSampleInput>;
  sum?: InputMaybe<PersonaWebhookEventHavingSumInput>;
  variancePopulation?: InputMaybe<PersonaWebhookEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PersonaWebhookEventHavingVarianceSampleInput>;
};

export type PersonaWebhookEventHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  personaCreatedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PersonaWebhookEventMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PersonaWebhookEventMaxAggregates = {
  __typename?: 'PersonaWebhookEventMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PersonaWebhookEventMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PersonaWebhookEventMinAggregates = {
  __typename?: 'PersonaWebhookEventMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PersonaWebhookEvent`. */
export enum PersonaWebhookEventOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EventNameAsc = 'EVENT_NAME_ASC',
  EventNameDesc = 'EVENT_NAME_DESC',
  Natural = 'NATURAL',
  PersonaCreatedAtAsc = 'PERSONA_CREATED_AT_ASC',
  PersonaCreatedAtDesc = 'PERSONA_CREATED_AT_DESC',
  PersonaEventIdAsc = 'PERSONA_EVENT_ID_ASC',
  PersonaEventIdDesc = 'PERSONA_EVENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResourceIdAsc = 'RESOURCE_ID_ASC',
  ResourceIdDesc = 'RESOURCE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type PersonaWebhookEventStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PersonaWebhookEventStddevPopulationAggregates = {
  __typename?: 'PersonaWebhookEventStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PersonaWebhookEventStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PersonaWebhookEventStddevSampleAggregates = {
  __typename?: 'PersonaWebhookEventStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PersonaWebhookEventSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PersonaWebhookEventSumAggregates = {
  __typename?: 'PersonaWebhookEventSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type PersonaWebhookEventVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PersonaWebhookEventVariancePopulationAggregates = {
  __typename?: 'PersonaWebhookEventVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PersonaWebhookEventVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PersonaWebhookEventVarianceSampleAggregates = {
  __typename?: 'PersonaWebhookEventVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Platform = Node & {
  __typename?: 'Platform';
  /** Reads and enables pagination through a set of `Account`. */
  accounts: AccountConnection;
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  dataFeed?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TradingProductFee`. */
  tradingProductFees: TradingProductFeeConnection;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UserPlatformCredential`. */
  userPlatformCredentials: UserPlatformCredentialConnection;
};


export type PlatformAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
};


export type PlatformTradingProductFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingProductFeeCondition>;
  filter?: InputMaybe<TradingProductFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingProductFeeOrderBy>>;
};


export type PlatformUserPlatformCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserPlatformCredentialCondition>;
  filter?: InputMaybe<UserPlatformCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserPlatformCredentialOrderBy>>;
};

/** A filter to be used against `Platform` object types. All fields are combined with a logical ‘and.’ */
export type PlatformFilter = {
  /** Filter by the object’s `accounts` relation. */
  accounts?: InputMaybe<PlatformToManyAccountFilter>;
  /** Some related `accounts` exist. */
  accountsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlatformFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PlatformFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlatformFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tradingProductFees` relation. */
  tradingProductFees?: InputMaybe<PlatformToManyTradingProductFeeFilter>;
  /** Some related `tradingProductFees` exist. */
  tradingProductFeesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userPlatformCredentials` relation. */
  userPlatformCredentials?: InputMaybe<PlatformToManyUserPlatformCredentialFilter>;
  /** Some related `userPlatformCredentials` exist. */
  userPlatformCredentialsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `Account` object types. All fields are combined with a logical ‘and.’ */
export type PlatformToManyAccountFilter = {
  /** Aggregates across related `Account` match the filter criteria. */
  aggregates?: InputMaybe<AccountAggregatesFilter>;
  /** Every related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFilter>;
  /** No related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFilter>;
  /** Some related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFilter>;
};

/** A filter to be used against many `TradingProductFee` object types. All fields are combined with a logical ‘and.’ */
export type PlatformToManyTradingProductFeeFilter = {
  /** Aggregates across related `TradingProductFee` match the filter criteria. */
  aggregates?: InputMaybe<TradingProductFeeAggregatesFilter>;
  /** Every related `TradingProductFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingProductFeeFilter>;
  /** No related `TradingProductFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingProductFeeFilter>;
  /** Some related `TradingProductFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingProductFeeFilter>;
};

/** A filter to be used against many `UserPlatformCredential` object types. All fields are combined with a logical ‘and.’ */
export type PlatformToManyUserPlatformCredentialFilter = {
  /** Aggregates across related `UserPlatformCredential` match the filter criteria. */
  aggregates?: InputMaybe<UserPlatformCredentialAggregatesFilter>;
  /** Every related `UserPlatformCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPlatformCredentialFilter>;
  /** No related `UserPlatformCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPlatformCredentialFilter>;
  /** Some related `UserPlatformCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPlatformCredentialFilter>;
};

/**
 * A single paid PayoutRequest that is eligible to become an individual
 * Proof-of-Payout card. Returned by myPopcardCandidates.payouts.
 */
export type PopcardPayoutCandidate = {
  __typename?: 'PopcardPayoutCandidate';
  /** PayoutRequest.accountId — the account that earned this payout. */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Payout amount in USD. */
  amount: Scalars['Float']['output'];
  /**
   * UUID of an existing individual PayoutRequestAsset row for this payout,
   * or null if no card has been generated yet. Use this to decide whether
   * to call the popcard generation mutation again.
   */
  existingAssetId?: Maybe<Scalars['String']['output']>;
  /** Raw PayoutRequest.financeApprovedAt timestamp (ISO 8601, UTC); null when not yet finance-approved. */
  financeApprovedAt?: Maybe<Scalars['Datetime']['output']>;
  /**
   * financeApprovedAt converted to a YYYY-MM-DD string in America/Chicago.
   * Null when the payout is not finance-approved or was approved before
   * the rollup cutoff (2026-01-01) and therefore can never participate in
   * a rollup group.
   */
  financeApprovedCtDate?: Maybe<Scalars['String']['output']>;
  /** PayoutRequest.id */
  id: Scalars['Int']['output'];
  /** PayoutRequest.type — typically 'XFA' or 'Live'. */
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * A bucket of payouts that share the same CT-date and account type and can
 * be combined into a single Rollup proof-of-payout card. Buckets with only
 * one payout are omitted (a rollup is only meaningful with > 1 payout).
 */
export type PopcardRollupGroup = {
  __typename?: 'PopcardRollupGroup';
  /**
   * UUID of an existing Rollup PayoutRequestAsset row that already covers
   * this exact (sorted) payoutIds set, or null if the rollup has not been
   * generated yet. Matched the same way as the idempotency lookup in
   * payoutRollupImageService.generatePayoutRollupCard.
   */
  existingAssetId?: Maybe<Scalars['String']['output']>;
  /** Shared financeApprovedAt CT-date (YYYY-MM-DD, America/Chicago). */
  financeApprovedCtDate: Scalars['String']['output'];
  /** Number of payouts in the group; always >= 2. */
  payoutCount: Scalars['Int']['output'];
  /** PayoutRequest.id values that make up the group, sorted ascending. */
  payoutIds: Array<Scalars['Int']['output']>;
  /** Each underlying PayoutRequest, sorted by amount descending. */
  payouts: Array<PopcardPayoutCandidate>;
  /** Sum of every payout amount in the group, in USD. */
  totalAmount: Scalars['Float']['output'];
  /** Account type for every payout in the group ('XFA' or 'Live'). */
  type: Scalars['String']['output'];
};

export type Product = Node & {
  __typename?: 'Product';
  /** Reads and enables pagination through a set of `CheckoutItem`. */
  checkoutItems: CheckoutItemConnection;
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  erpItemId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `NmiSubscription`. */
  nmiSubscriptions: NmiSubscriptionConnection;
  price: Scalars['BigFloat']['output'];
  /** Reads a single `ProductCategory` that is related to this `Product`. */
  productCategory?: Maybe<ProductCategory>;
  productCategoryId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `PurchaseItem`. */
  purchaseItems: PurchaseItemConnection;
  recurringCycle: ProductRecurringcycleEnum;
  rowId: Scalars['Int']['output'];
  skuId?: Maybe<Scalars['Int']['output']>;
  taxCode: Scalars['String']['output'];
  taxItemCode: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type ProductCheckoutItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckoutItemCondition>;
  filter?: InputMaybe<CheckoutItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckoutItemOrderBy>>;
};


export type ProductNmiSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NmiSubscriptionCondition>;
  filter?: InputMaybe<NmiSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NmiSubscriptionOrderBy>>;
};


export type ProductPurchaseItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PurchaseItemCondition>;
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PurchaseItemOrderBy>>;
};

export type ProductAggregates = {
  __typename?: 'ProductAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ProductAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProductDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ProductMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ProductMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ProductStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ProductStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ProductSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ProductVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ProductVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Product` object types. */
export type ProductAggregatesFilter = {
  /** Mean average aggregate over matching `Product` objects. */
  average?: InputMaybe<ProductAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Product` objects. */
  distinctCount?: InputMaybe<ProductDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Product` object to be included within the aggregate. */
  filter?: InputMaybe<ProductFilter>;
  /** Maximum aggregate over matching `Product` objects. */
  max?: InputMaybe<ProductMaxAggregateFilter>;
  /** Minimum aggregate over matching `Product` objects. */
  min?: InputMaybe<ProductMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Product` objects. */
  stddevPopulation?: InputMaybe<ProductStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Product` objects. */
  stddevSample?: InputMaybe<ProductStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Product` objects. */
  sum?: InputMaybe<ProductSumAggregateFilter>;
  /** Population variance aggregate over matching `Product` objects. */
  variancePopulation?: InputMaybe<ProductVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Product` objects. */
  varianceSample?: InputMaybe<ProductVarianceSampleAggregateFilter>;
};

export type ProductAverageAggregateFilter = {
  productCategoryId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type ProductAverageAggregates = {
  __typename?: 'ProductAverageAggregates';
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductCategory = Node & {
  __typename?: 'ProductCategory';
  description?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Product`. */
  products: ProductConnection;
  rowId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};


export type ProductCategoryProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderBy>>;
};

export type ProductCategoryAggregates = {
  __typename?: 'ProductCategoryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ProductCategoryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProductCategoryDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ProductCategoryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ProductCategoryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ProductCategoryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ProductCategoryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ProductCategorySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ProductCategoryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ProductCategoryVarianceSampleAggregates>;
};

export type ProductCategoryAverageAggregates = {
  __typename?: 'ProductCategoryAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ProductCategory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProductCategoryCondition = {
  /** Checks for equality with the object’s `handle` field. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ProductCategory` values. */
export type ProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProductCategoryAggregates>;
  /** A list of edges which contains the `ProductCategory` and cursor to aid in pagination. */
  edges: Array<Maybe<ProductCategoryEdge>>;
  /** A list of `ProductCategory` objects. */
  nodes: Array<Maybe<ProductCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProductCategory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ProductCategoryDistinctCountAggregates = {
  __typename?: 'ProductCategoryDistinctCountAggregates';
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of handle across the matching connection */
  handle?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of title across the matching connection */
  title?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ProductCategory` edge in the connection. */
export type ProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProductCategory` at the end of the edge. */
  node?: Maybe<ProductCategory>;
};

/** A filter to be used against `ProductCategory` object types. All fields are combined with a logical ‘and.’ */
export type ProductCategoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductCategoryFilter>>;
  /** Filter by the object’s `handle` field. */
  handle?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProductCategoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductCategoryFilter>>;
  /** Filter by the object’s `products` relation. */
  products?: InputMaybe<ProductCategoryToManyProductFilter>;
  /** Some related `products` exist. */
  productsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type ProductCategoryMaxAggregates = {
  __typename?: 'ProductCategoryMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type ProductCategoryMinAggregates = {
  __typename?: 'ProductCategoryMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ProductCategory`. */
export enum ProductCategoryOrderBy {
  HandleAsc = 'HANDLE_ASC',
  HandleDesc = 'HANDLE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductsAverageProductCategoryIdAsc = 'PRODUCTS_AVERAGE_PRODUCT_CATEGORY_ID_ASC',
  ProductsAverageProductCategoryIdDesc = 'PRODUCTS_AVERAGE_PRODUCT_CATEGORY_ID_DESC',
  ProductsAverageRowIdAsc = 'PRODUCTS_AVERAGE_ROW_ID_ASC',
  ProductsAverageRowIdDesc = 'PRODUCTS_AVERAGE_ROW_ID_DESC',
  ProductsAverageSkuIdAsc = 'PRODUCTS_AVERAGE_SKU_ID_ASC',
  ProductsAverageSkuIdDesc = 'PRODUCTS_AVERAGE_SKU_ID_DESC',
  ProductsCountAsc = 'PRODUCTS_COUNT_ASC',
  ProductsCountDesc = 'PRODUCTS_COUNT_DESC',
  ProductsDistinctCountDeletedAtAsc = 'PRODUCTS_DISTINCT_COUNT_DELETED_AT_ASC',
  ProductsDistinctCountDeletedAtDesc = 'PRODUCTS_DISTINCT_COUNT_DELETED_AT_DESC',
  ProductsDistinctCountProductCategoryIdAsc = 'PRODUCTS_DISTINCT_COUNT_PRODUCT_CATEGORY_ID_ASC',
  ProductsDistinctCountProductCategoryIdDesc = 'PRODUCTS_DISTINCT_COUNT_PRODUCT_CATEGORY_ID_DESC',
  ProductsDistinctCountRowIdAsc = 'PRODUCTS_DISTINCT_COUNT_ROW_ID_ASC',
  ProductsDistinctCountRowIdDesc = 'PRODUCTS_DISTINCT_COUNT_ROW_ID_DESC',
  ProductsDistinctCountSkuIdAsc = 'PRODUCTS_DISTINCT_COUNT_SKU_ID_ASC',
  ProductsDistinctCountSkuIdDesc = 'PRODUCTS_DISTINCT_COUNT_SKU_ID_DESC',
  ProductsMaxProductCategoryIdAsc = 'PRODUCTS_MAX_PRODUCT_CATEGORY_ID_ASC',
  ProductsMaxProductCategoryIdDesc = 'PRODUCTS_MAX_PRODUCT_CATEGORY_ID_DESC',
  ProductsMaxRowIdAsc = 'PRODUCTS_MAX_ROW_ID_ASC',
  ProductsMaxRowIdDesc = 'PRODUCTS_MAX_ROW_ID_DESC',
  ProductsMaxSkuIdAsc = 'PRODUCTS_MAX_SKU_ID_ASC',
  ProductsMaxSkuIdDesc = 'PRODUCTS_MAX_SKU_ID_DESC',
  ProductsMinProductCategoryIdAsc = 'PRODUCTS_MIN_PRODUCT_CATEGORY_ID_ASC',
  ProductsMinProductCategoryIdDesc = 'PRODUCTS_MIN_PRODUCT_CATEGORY_ID_DESC',
  ProductsMinRowIdAsc = 'PRODUCTS_MIN_ROW_ID_ASC',
  ProductsMinRowIdDesc = 'PRODUCTS_MIN_ROW_ID_DESC',
  ProductsMinSkuIdAsc = 'PRODUCTS_MIN_SKU_ID_ASC',
  ProductsMinSkuIdDesc = 'PRODUCTS_MIN_SKU_ID_DESC',
  ProductsStddevPopulationProductCategoryIdAsc = 'PRODUCTS_STDDEV_POPULATION_PRODUCT_CATEGORY_ID_ASC',
  ProductsStddevPopulationProductCategoryIdDesc = 'PRODUCTS_STDDEV_POPULATION_PRODUCT_CATEGORY_ID_DESC',
  ProductsStddevPopulationRowIdAsc = 'PRODUCTS_STDDEV_POPULATION_ROW_ID_ASC',
  ProductsStddevPopulationRowIdDesc = 'PRODUCTS_STDDEV_POPULATION_ROW_ID_DESC',
  ProductsStddevPopulationSkuIdAsc = 'PRODUCTS_STDDEV_POPULATION_SKU_ID_ASC',
  ProductsStddevPopulationSkuIdDesc = 'PRODUCTS_STDDEV_POPULATION_SKU_ID_DESC',
  ProductsStddevSampleProductCategoryIdAsc = 'PRODUCTS_STDDEV_SAMPLE_PRODUCT_CATEGORY_ID_ASC',
  ProductsStddevSampleProductCategoryIdDesc = 'PRODUCTS_STDDEV_SAMPLE_PRODUCT_CATEGORY_ID_DESC',
  ProductsStddevSampleRowIdAsc = 'PRODUCTS_STDDEV_SAMPLE_ROW_ID_ASC',
  ProductsStddevSampleRowIdDesc = 'PRODUCTS_STDDEV_SAMPLE_ROW_ID_DESC',
  ProductsStddevSampleSkuIdAsc = 'PRODUCTS_STDDEV_SAMPLE_SKU_ID_ASC',
  ProductsStddevSampleSkuIdDesc = 'PRODUCTS_STDDEV_SAMPLE_SKU_ID_DESC',
  ProductsSumProductCategoryIdAsc = 'PRODUCTS_SUM_PRODUCT_CATEGORY_ID_ASC',
  ProductsSumProductCategoryIdDesc = 'PRODUCTS_SUM_PRODUCT_CATEGORY_ID_DESC',
  ProductsSumRowIdAsc = 'PRODUCTS_SUM_ROW_ID_ASC',
  ProductsSumRowIdDesc = 'PRODUCTS_SUM_ROW_ID_DESC',
  ProductsSumSkuIdAsc = 'PRODUCTS_SUM_SKU_ID_ASC',
  ProductsSumSkuIdDesc = 'PRODUCTS_SUM_SKU_ID_DESC',
  ProductsVariancePopulationProductCategoryIdAsc = 'PRODUCTS_VARIANCE_POPULATION_PRODUCT_CATEGORY_ID_ASC',
  ProductsVariancePopulationProductCategoryIdDesc = 'PRODUCTS_VARIANCE_POPULATION_PRODUCT_CATEGORY_ID_DESC',
  ProductsVariancePopulationRowIdAsc = 'PRODUCTS_VARIANCE_POPULATION_ROW_ID_ASC',
  ProductsVariancePopulationRowIdDesc = 'PRODUCTS_VARIANCE_POPULATION_ROW_ID_DESC',
  ProductsVariancePopulationSkuIdAsc = 'PRODUCTS_VARIANCE_POPULATION_SKU_ID_ASC',
  ProductsVariancePopulationSkuIdDesc = 'PRODUCTS_VARIANCE_POPULATION_SKU_ID_DESC',
  ProductsVarianceSampleProductCategoryIdAsc = 'PRODUCTS_VARIANCE_SAMPLE_PRODUCT_CATEGORY_ID_ASC',
  ProductsVarianceSampleProductCategoryIdDesc = 'PRODUCTS_VARIANCE_SAMPLE_PRODUCT_CATEGORY_ID_DESC',
  ProductsVarianceSampleRowIdAsc = 'PRODUCTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ProductsVarianceSampleRowIdDesc = 'PRODUCTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  ProductsVarianceSampleSkuIdAsc = 'PRODUCTS_VARIANCE_SAMPLE_SKU_ID_ASC',
  ProductsVarianceSampleSkuIdDesc = 'PRODUCTS_VARIANCE_SAMPLE_SKU_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type ProductCategoryStddevPopulationAggregates = {
  __typename?: 'ProductCategoryStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductCategoryStddevSampleAggregates = {
  __typename?: 'ProductCategoryStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductCategorySumAggregates = {
  __typename?: 'ProductCategorySumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductCategoryToManyProductFilter = {
  /** Aggregates across related `Product` match the filter criteria. */
  aggregates?: InputMaybe<ProductAggregatesFilter>;
  /** Every related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProductFilter>;
  /** No related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProductFilter>;
  /** Some related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProductFilter>;
};

export type ProductCategoryVariancePopulationAggregates = {
  __typename?: 'ProductCategoryVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductCategoryVarianceSampleAggregates = {
  __typename?: 'ProductCategoryVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Product` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProductCondition = {
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `productCategoryId` field. */
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `skuId` field. */
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Product` values. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProductAggregates>;
  /** A list of edges which contains the `Product` and cursor to aid in pagination. */
  edges: Array<Maybe<ProductEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProductAggregates>>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<Product>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Product` values. */
export type ProductConnectionGroupedAggregatesArgs = {
  groupBy: Array<ProductGroupBy>;
  having?: InputMaybe<ProductHavingInput>;
};

export type ProductDistinctCountAggregateFilter = {
  deletedAt?: InputMaybe<BigIntFilter>;
  productCategoryId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
};

export type ProductDistinctCountAggregates = {
  __typename?: 'ProductDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of erpItemId across the matching connection */
  erpItemId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isProtected across the matching connection */
  isProtected?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadata across the matching connection */
  metadata?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of recurringCycle across the matching connection */
  recurringCycle?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxCode across the matching connection */
  taxCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxItemCode across the matching connection */
  taxItemCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Product` edge in the connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Product` at the end of the edge. */
  node?: Maybe<Product>;
};

/** A filter to be used against `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `checkoutItems` relation. */
  checkoutItems?: InputMaybe<ProductToManyCheckoutItemFilter>;
  /** Some related `checkoutItems` exist. */
  checkoutItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `nmiSubscriptions` relation. */
  nmiSubscriptions?: InputMaybe<ProductToManyNmiSubscriptionFilter>;
  /** Some related `nmiSubscriptions` exist. */
  nmiSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<ProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `productCategory` relation. */
  productCategory?: InputMaybe<ProductCategoryFilter>;
  /** Filter by the object’s `productCategoryId` field. */
  productCategoryId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `purchaseItems` relation. */
  purchaseItems?: InputMaybe<ProductToManyPurchaseItemFilter>;
  /** Some related `purchaseItems` exist. */
  purchaseItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `skuId` field. */
  skuId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Product` for usage during aggregation. */
export enum ProductGroupBy {
  DeletedAt = 'DELETED_AT',
  DeletedAtTruncatedToDay = 'DELETED_AT_TRUNCATED_TO_DAY',
  DeletedAtTruncatedToHour = 'DELETED_AT_TRUNCATED_TO_HOUR',
  ProductCategoryId = 'PRODUCT_CATEGORY_ID',
  SkuId = 'SKU_ID'
}

export type ProductHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Product` aggregates. */
export type ProductHavingInput = {
  AND?: InputMaybe<Array<ProductHavingInput>>;
  OR?: InputMaybe<Array<ProductHavingInput>>;
  average?: InputMaybe<ProductHavingAverageInput>;
  distinctCount?: InputMaybe<ProductHavingDistinctCountInput>;
  max?: InputMaybe<ProductHavingMaxInput>;
  min?: InputMaybe<ProductHavingMinInput>;
  stddevPopulation?: InputMaybe<ProductHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ProductHavingStddevSampleInput>;
  sum?: InputMaybe<ProductHavingSumInput>;
  variancePopulation?: InputMaybe<ProductHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ProductHavingVarianceSampleInput>;
};

export type ProductHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProductMaxAggregateFilter = {
  productCategoryId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
};

export type ProductMaxAggregates = {
  __typename?: 'ProductMaxAggregates';
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type ProductMinAggregateFilter = {
  productCategoryId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
};

export type ProductMinAggregates = {
  __typename?: 'ProductMinAggregates';
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Product`. */
export enum ProductOrderBy {
  CheckoutItemsAverageCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_AVERAGE_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsAverageCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_AVERAGE_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsAverageProductIdAsc = 'CHECKOUT_ITEMS_AVERAGE_PRODUCT_ID_ASC',
  CheckoutItemsAverageProductIdDesc = 'CHECKOUT_ITEMS_AVERAGE_PRODUCT_ID_DESC',
  CheckoutItemsAverageRowIdAsc = 'CHECKOUT_ITEMS_AVERAGE_ROW_ID_ASC',
  CheckoutItemsAverageRowIdDesc = 'CHECKOUT_ITEMS_AVERAGE_ROW_ID_DESC',
  CheckoutItemsCountAsc = 'CHECKOUT_ITEMS_COUNT_ASC',
  CheckoutItemsCountDesc = 'CHECKOUT_ITEMS_COUNT_DESC',
  CheckoutItemsDistinctCountCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsDistinctCountCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsDistinctCountProductIdAsc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_PRODUCT_ID_ASC',
  CheckoutItemsDistinctCountProductIdDesc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_PRODUCT_ID_DESC',
  CheckoutItemsDistinctCountRowIdAsc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_ROW_ID_ASC',
  CheckoutItemsDistinctCountRowIdDesc = 'CHECKOUT_ITEMS_DISTINCT_COUNT_ROW_ID_DESC',
  CheckoutItemsMaxCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_MAX_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsMaxCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_MAX_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsMaxProductIdAsc = 'CHECKOUT_ITEMS_MAX_PRODUCT_ID_ASC',
  CheckoutItemsMaxProductIdDesc = 'CHECKOUT_ITEMS_MAX_PRODUCT_ID_DESC',
  CheckoutItemsMaxRowIdAsc = 'CHECKOUT_ITEMS_MAX_ROW_ID_ASC',
  CheckoutItemsMaxRowIdDesc = 'CHECKOUT_ITEMS_MAX_ROW_ID_DESC',
  CheckoutItemsMinCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_MIN_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsMinCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_MIN_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsMinProductIdAsc = 'CHECKOUT_ITEMS_MIN_PRODUCT_ID_ASC',
  CheckoutItemsMinProductIdDesc = 'CHECKOUT_ITEMS_MIN_PRODUCT_ID_DESC',
  CheckoutItemsMinRowIdAsc = 'CHECKOUT_ITEMS_MIN_ROW_ID_ASC',
  CheckoutItemsMinRowIdDesc = 'CHECKOUT_ITEMS_MIN_ROW_ID_DESC',
  CheckoutItemsStddevPopulationCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsStddevPopulationCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsStddevPopulationProductIdAsc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_PRODUCT_ID_ASC',
  CheckoutItemsStddevPopulationProductIdDesc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_PRODUCT_ID_DESC',
  CheckoutItemsStddevPopulationRowIdAsc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_ROW_ID_ASC',
  CheckoutItemsStddevPopulationRowIdDesc = 'CHECKOUT_ITEMS_STDDEV_POPULATION_ROW_ID_DESC',
  CheckoutItemsStddevSampleCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsStddevSampleCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsStddevSampleProductIdAsc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  CheckoutItemsStddevSampleProductIdDesc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  CheckoutItemsStddevSampleRowIdAsc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_ROW_ID_ASC',
  CheckoutItemsStddevSampleRowIdDesc = 'CHECKOUT_ITEMS_STDDEV_SAMPLE_ROW_ID_DESC',
  CheckoutItemsSumCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_SUM_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsSumCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_SUM_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsSumProductIdAsc = 'CHECKOUT_ITEMS_SUM_PRODUCT_ID_ASC',
  CheckoutItemsSumProductIdDesc = 'CHECKOUT_ITEMS_SUM_PRODUCT_ID_DESC',
  CheckoutItemsSumRowIdAsc = 'CHECKOUT_ITEMS_SUM_ROW_ID_ASC',
  CheckoutItemsSumRowIdDesc = 'CHECKOUT_ITEMS_SUM_ROW_ID_DESC',
  CheckoutItemsVariancePopulationCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsVariancePopulationCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsVariancePopulationProductIdAsc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  CheckoutItemsVariancePopulationProductIdDesc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  CheckoutItemsVariancePopulationRowIdAsc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_ROW_ID_ASC',
  CheckoutItemsVariancePopulationRowIdDesc = 'CHECKOUT_ITEMS_VARIANCE_POPULATION_ROW_ID_DESC',
  CheckoutItemsVarianceSampleCheckoutSessionIdAsc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_CHECKOUT_SESSION_ID_ASC',
  CheckoutItemsVarianceSampleCheckoutSessionIdDesc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_CHECKOUT_SESSION_ID_DESC',
  CheckoutItemsVarianceSampleProductIdAsc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  CheckoutItemsVarianceSampleProductIdDesc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  CheckoutItemsVarianceSampleRowIdAsc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CheckoutItemsVarianceSampleRowIdDesc = 'CHECKOUT_ITEMS_VARIANCE_SAMPLE_ROW_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  Natural = 'NATURAL',
  NmiSubscriptionsAverageCouponIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_COUPON_ID_ASC',
  NmiSubscriptionsAverageCouponIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_COUPON_ID_DESC',
  NmiSubscriptionsAverageMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsAverageMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsAverageNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsAverageNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsAverageProductIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_PRODUCT_ID_ASC',
  NmiSubscriptionsAverageProductIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_PRODUCT_ID_DESC',
  NmiSubscriptionsAverageRowIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_ROW_ID_ASC',
  NmiSubscriptionsAverageRowIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_ROW_ID_DESC',
  NmiSubscriptionsAverageSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsAverageSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsAverageSkuIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_SKU_ID_ASC',
  NmiSubscriptionsAverageSkuIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_SKU_ID_DESC',
  NmiSubscriptionsAverageUserIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_USER_ID_ASC',
  NmiSubscriptionsAverageUserIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_USER_ID_DESC',
  NmiSubscriptionsCountAsc = 'NMI_SUBSCRIPTIONS_COUNT_ASC',
  NmiSubscriptionsCountDesc = 'NMI_SUBSCRIPTIONS_COUNT_DESC',
  NmiSubscriptionsDistinctCountCouponIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_ASC',
  NmiSubscriptionsDistinctCountCouponIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_DESC',
  NmiSubscriptionsDistinctCountMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsDistinctCountMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsDistinctCountNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsDistinctCountNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsDistinctCountProductIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_PRODUCT_ID_ASC',
  NmiSubscriptionsDistinctCountProductIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_PRODUCT_ID_DESC',
  NmiSubscriptionsDistinctCountRebillManagerAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_MANAGER_ASC',
  NmiSubscriptionsDistinctCountRebillManagerDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_MANAGER_DESC',
  NmiSubscriptionsDistinctCountRebillRefIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_REF_ID_ASC',
  NmiSubscriptionsDistinctCountRebillRefIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_REF_ID_DESC',
  NmiSubscriptionsDistinctCountRowIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_ASC',
  NmiSubscriptionsDistinctCountRowIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_DESC',
  NmiSubscriptionsDistinctCountSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SAVED_CARD_ID_ASC',
  NmiSubscriptionsDistinctCountSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SAVED_CARD_ID_DESC',
  NmiSubscriptionsDistinctCountServiceAccessUntilAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_ASC',
  NmiSubscriptionsDistinctCountServiceAccessUntilDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_DESC',
  NmiSubscriptionsDistinctCountServiceCancelledAtAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_CANCELLED_AT_ASC',
  NmiSubscriptionsDistinctCountServiceCancelledAtDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_CANCELLED_AT_DESC',
  NmiSubscriptionsDistinctCountSkuIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SKU_ID_ASC',
  NmiSubscriptionsDistinctCountSkuIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SKU_ID_DESC',
  NmiSubscriptionsDistinctCountSubscriptionCancelledAtAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_ASC',
  NmiSubscriptionsDistinctCountSubscriptionCancelledAtDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_DESC',
  NmiSubscriptionsDistinctCountUserIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_ASC',
  NmiSubscriptionsDistinctCountUserIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_DESC',
  NmiSubscriptionsMaxCouponIdAsc = 'NMI_SUBSCRIPTIONS_MAX_COUPON_ID_ASC',
  NmiSubscriptionsMaxCouponIdDesc = 'NMI_SUBSCRIPTIONS_MAX_COUPON_ID_DESC',
  NmiSubscriptionsMaxMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_MAX_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsMaxMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_MAX_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsMaxNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_MAX_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsMaxNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_MAX_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsMaxProductIdAsc = 'NMI_SUBSCRIPTIONS_MAX_PRODUCT_ID_ASC',
  NmiSubscriptionsMaxProductIdDesc = 'NMI_SUBSCRIPTIONS_MAX_PRODUCT_ID_DESC',
  NmiSubscriptionsMaxRowIdAsc = 'NMI_SUBSCRIPTIONS_MAX_ROW_ID_ASC',
  NmiSubscriptionsMaxRowIdDesc = 'NMI_SUBSCRIPTIONS_MAX_ROW_ID_DESC',
  NmiSubscriptionsMaxSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_MAX_SAVED_CARD_ID_ASC',
  NmiSubscriptionsMaxSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_MAX_SAVED_CARD_ID_DESC',
  NmiSubscriptionsMaxSkuIdAsc = 'NMI_SUBSCRIPTIONS_MAX_SKU_ID_ASC',
  NmiSubscriptionsMaxSkuIdDesc = 'NMI_SUBSCRIPTIONS_MAX_SKU_ID_DESC',
  NmiSubscriptionsMaxUserIdAsc = 'NMI_SUBSCRIPTIONS_MAX_USER_ID_ASC',
  NmiSubscriptionsMaxUserIdDesc = 'NMI_SUBSCRIPTIONS_MAX_USER_ID_DESC',
  NmiSubscriptionsMinCouponIdAsc = 'NMI_SUBSCRIPTIONS_MIN_COUPON_ID_ASC',
  NmiSubscriptionsMinCouponIdDesc = 'NMI_SUBSCRIPTIONS_MIN_COUPON_ID_DESC',
  NmiSubscriptionsMinMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_MIN_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsMinMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_MIN_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsMinNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_MIN_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsMinNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_MIN_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsMinProductIdAsc = 'NMI_SUBSCRIPTIONS_MIN_PRODUCT_ID_ASC',
  NmiSubscriptionsMinProductIdDesc = 'NMI_SUBSCRIPTIONS_MIN_PRODUCT_ID_DESC',
  NmiSubscriptionsMinRowIdAsc = 'NMI_SUBSCRIPTIONS_MIN_ROW_ID_ASC',
  NmiSubscriptionsMinRowIdDesc = 'NMI_SUBSCRIPTIONS_MIN_ROW_ID_DESC',
  NmiSubscriptionsMinSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_MIN_SAVED_CARD_ID_ASC',
  NmiSubscriptionsMinSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_MIN_SAVED_CARD_ID_DESC',
  NmiSubscriptionsMinSkuIdAsc = 'NMI_SUBSCRIPTIONS_MIN_SKU_ID_ASC',
  NmiSubscriptionsMinSkuIdDesc = 'NMI_SUBSCRIPTIONS_MIN_SKU_ID_DESC',
  NmiSubscriptionsMinUserIdAsc = 'NMI_SUBSCRIPTIONS_MIN_USER_ID_ASC',
  NmiSubscriptionsMinUserIdDesc = 'NMI_SUBSCRIPTIONS_MIN_USER_ID_DESC',
  NmiSubscriptionsStddevPopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsStddevPopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsStddevPopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsStddevPopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsStddevPopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsStddevPopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsStddevPopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsStddevPopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsStddevPopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsStddevPopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsStddevPopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsStddevPopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsStddevPopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsStddevPopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsStddevPopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_ASC',
  NmiSubscriptionsStddevPopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_DESC',
  NmiSubscriptionsStddevSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsStddevSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsStddevSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsStddevSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsStddevSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsStddevSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsStddevSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsStddevSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsStddevSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsStddevSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsStddevSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsStddevSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsStddevSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsStddevSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsStddevSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsStddevSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_DESC',
  NmiSubscriptionsSumCouponIdAsc = 'NMI_SUBSCRIPTIONS_SUM_COUPON_ID_ASC',
  NmiSubscriptionsSumCouponIdDesc = 'NMI_SUBSCRIPTIONS_SUM_COUPON_ID_DESC',
  NmiSubscriptionsSumMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_SUM_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsSumMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_SUM_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsSumNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_SUM_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsSumNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_SUM_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsSumProductIdAsc = 'NMI_SUBSCRIPTIONS_SUM_PRODUCT_ID_ASC',
  NmiSubscriptionsSumProductIdDesc = 'NMI_SUBSCRIPTIONS_SUM_PRODUCT_ID_DESC',
  NmiSubscriptionsSumRowIdAsc = 'NMI_SUBSCRIPTIONS_SUM_ROW_ID_ASC',
  NmiSubscriptionsSumRowIdDesc = 'NMI_SUBSCRIPTIONS_SUM_ROW_ID_DESC',
  NmiSubscriptionsSumSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_SUM_SAVED_CARD_ID_ASC',
  NmiSubscriptionsSumSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_SUM_SAVED_CARD_ID_DESC',
  NmiSubscriptionsSumSkuIdAsc = 'NMI_SUBSCRIPTIONS_SUM_SKU_ID_ASC',
  NmiSubscriptionsSumSkuIdDesc = 'NMI_SUBSCRIPTIONS_SUM_SKU_ID_DESC',
  NmiSubscriptionsSumUserIdAsc = 'NMI_SUBSCRIPTIONS_SUM_USER_ID_ASC',
  NmiSubscriptionsSumUserIdDesc = 'NMI_SUBSCRIPTIONS_SUM_USER_ID_DESC',
  NmiSubscriptionsVariancePopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsVariancePopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsVariancePopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsVariancePopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsVariancePopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsVariancePopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsVariancePopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsVariancePopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsVariancePopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsVariancePopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsVariancePopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsVariancePopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsVariancePopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsVariancePopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsVariancePopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_ASC',
  NmiSubscriptionsVariancePopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_DESC',
  NmiSubscriptionsVarianceSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsVarianceSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsVarianceSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsVarianceSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsVarianceSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsVarianceSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsVarianceSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsVarianceSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsVarianceSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsVarianceSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsVarianceSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsVarianceSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsVarianceSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsVarianceSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsVarianceSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsVarianceSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductCategoryIdAsc = 'PRODUCT_CATEGORY_ID_ASC',
  ProductCategoryIdDesc = 'PRODUCT_CATEGORY_ID_DESC',
  PurchaseItemsAverageProductIdAsc = 'PURCHASE_ITEMS_AVERAGE_PRODUCT_ID_ASC',
  PurchaseItemsAverageProductIdDesc = 'PURCHASE_ITEMS_AVERAGE_PRODUCT_ID_DESC',
  PurchaseItemsAveragePurchaseIdAsc = 'PURCHASE_ITEMS_AVERAGE_PURCHASE_ID_ASC',
  PurchaseItemsAveragePurchaseIdDesc = 'PURCHASE_ITEMS_AVERAGE_PURCHASE_ID_DESC',
  PurchaseItemsAverageRowIdAsc = 'PURCHASE_ITEMS_AVERAGE_ROW_ID_ASC',
  PurchaseItemsAverageRowIdDesc = 'PURCHASE_ITEMS_AVERAGE_ROW_ID_DESC',
  PurchaseItemsAverageSkuIdAsc = 'PURCHASE_ITEMS_AVERAGE_SKU_ID_ASC',
  PurchaseItemsAverageSkuIdDesc = 'PURCHASE_ITEMS_AVERAGE_SKU_ID_DESC',
  PurchaseItemsCountAsc = 'PURCHASE_ITEMS_COUNT_ASC',
  PurchaseItemsCountDesc = 'PURCHASE_ITEMS_COUNT_DESC',
  PurchaseItemsDistinctCountProductIdAsc = 'PURCHASE_ITEMS_DISTINCT_COUNT_PRODUCT_ID_ASC',
  PurchaseItemsDistinctCountProductIdDesc = 'PURCHASE_ITEMS_DISTINCT_COUNT_PRODUCT_ID_DESC',
  PurchaseItemsDistinctCountPurchaseIdAsc = 'PURCHASE_ITEMS_DISTINCT_COUNT_PURCHASE_ID_ASC',
  PurchaseItemsDistinctCountPurchaseIdDesc = 'PURCHASE_ITEMS_DISTINCT_COUNT_PURCHASE_ID_DESC',
  PurchaseItemsDistinctCountRowIdAsc = 'PURCHASE_ITEMS_DISTINCT_COUNT_ROW_ID_ASC',
  PurchaseItemsDistinctCountRowIdDesc = 'PURCHASE_ITEMS_DISTINCT_COUNT_ROW_ID_DESC',
  PurchaseItemsDistinctCountSkuIdAsc = 'PURCHASE_ITEMS_DISTINCT_COUNT_SKU_ID_ASC',
  PurchaseItemsDistinctCountSkuIdDesc = 'PURCHASE_ITEMS_DISTINCT_COUNT_SKU_ID_DESC',
  PurchaseItemsMaxProductIdAsc = 'PURCHASE_ITEMS_MAX_PRODUCT_ID_ASC',
  PurchaseItemsMaxProductIdDesc = 'PURCHASE_ITEMS_MAX_PRODUCT_ID_DESC',
  PurchaseItemsMaxPurchaseIdAsc = 'PURCHASE_ITEMS_MAX_PURCHASE_ID_ASC',
  PurchaseItemsMaxPurchaseIdDesc = 'PURCHASE_ITEMS_MAX_PURCHASE_ID_DESC',
  PurchaseItemsMaxRowIdAsc = 'PURCHASE_ITEMS_MAX_ROW_ID_ASC',
  PurchaseItemsMaxRowIdDesc = 'PURCHASE_ITEMS_MAX_ROW_ID_DESC',
  PurchaseItemsMaxSkuIdAsc = 'PURCHASE_ITEMS_MAX_SKU_ID_ASC',
  PurchaseItemsMaxSkuIdDesc = 'PURCHASE_ITEMS_MAX_SKU_ID_DESC',
  PurchaseItemsMinProductIdAsc = 'PURCHASE_ITEMS_MIN_PRODUCT_ID_ASC',
  PurchaseItemsMinProductIdDesc = 'PURCHASE_ITEMS_MIN_PRODUCT_ID_DESC',
  PurchaseItemsMinPurchaseIdAsc = 'PURCHASE_ITEMS_MIN_PURCHASE_ID_ASC',
  PurchaseItemsMinPurchaseIdDesc = 'PURCHASE_ITEMS_MIN_PURCHASE_ID_DESC',
  PurchaseItemsMinRowIdAsc = 'PURCHASE_ITEMS_MIN_ROW_ID_ASC',
  PurchaseItemsMinRowIdDesc = 'PURCHASE_ITEMS_MIN_ROW_ID_DESC',
  PurchaseItemsMinSkuIdAsc = 'PURCHASE_ITEMS_MIN_SKU_ID_ASC',
  PurchaseItemsMinSkuIdDesc = 'PURCHASE_ITEMS_MIN_SKU_ID_DESC',
  PurchaseItemsStddevPopulationProductIdAsc = 'PURCHASE_ITEMS_STDDEV_POPULATION_PRODUCT_ID_ASC',
  PurchaseItemsStddevPopulationProductIdDesc = 'PURCHASE_ITEMS_STDDEV_POPULATION_PRODUCT_ID_DESC',
  PurchaseItemsStddevPopulationPurchaseIdAsc = 'PURCHASE_ITEMS_STDDEV_POPULATION_PURCHASE_ID_ASC',
  PurchaseItemsStddevPopulationPurchaseIdDesc = 'PURCHASE_ITEMS_STDDEV_POPULATION_PURCHASE_ID_DESC',
  PurchaseItemsStddevPopulationRowIdAsc = 'PURCHASE_ITEMS_STDDEV_POPULATION_ROW_ID_ASC',
  PurchaseItemsStddevPopulationRowIdDesc = 'PURCHASE_ITEMS_STDDEV_POPULATION_ROW_ID_DESC',
  PurchaseItemsStddevPopulationSkuIdAsc = 'PURCHASE_ITEMS_STDDEV_POPULATION_SKU_ID_ASC',
  PurchaseItemsStddevPopulationSkuIdDesc = 'PURCHASE_ITEMS_STDDEV_POPULATION_SKU_ID_DESC',
  PurchaseItemsStddevSampleProductIdAsc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  PurchaseItemsStddevSampleProductIdDesc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  PurchaseItemsStddevSamplePurchaseIdAsc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_PURCHASE_ID_ASC',
  PurchaseItemsStddevSamplePurchaseIdDesc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_PURCHASE_ID_DESC',
  PurchaseItemsStddevSampleRowIdAsc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_ROW_ID_ASC',
  PurchaseItemsStddevSampleRowIdDesc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_ROW_ID_DESC',
  PurchaseItemsStddevSampleSkuIdAsc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_SKU_ID_ASC',
  PurchaseItemsStddevSampleSkuIdDesc = 'PURCHASE_ITEMS_STDDEV_SAMPLE_SKU_ID_DESC',
  PurchaseItemsSumProductIdAsc = 'PURCHASE_ITEMS_SUM_PRODUCT_ID_ASC',
  PurchaseItemsSumProductIdDesc = 'PURCHASE_ITEMS_SUM_PRODUCT_ID_DESC',
  PurchaseItemsSumPurchaseIdAsc = 'PURCHASE_ITEMS_SUM_PURCHASE_ID_ASC',
  PurchaseItemsSumPurchaseIdDesc = 'PURCHASE_ITEMS_SUM_PURCHASE_ID_DESC',
  PurchaseItemsSumRowIdAsc = 'PURCHASE_ITEMS_SUM_ROW_ID_ASC',
  PurchaseItemsSumRowIdDesc = 'PURCHASE_ITEMS_SUM_ROW_ID_DESC',
  PurchaseItemsSumSkuIdAsc = 'PURCHASE_ITEMS_SUM_SKU_ID_ASC',
  PurchaseItemsSumSkuIdDesc = 'PURCHASE_ITEMS_SUM_SKU_ID_DESC',
  PurchaseItemsVariancePopulationProductIdAsc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  PurchaseItemsVariancePopulationProductIdDesc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  PurchaseItemsVariancePopulationPurchaseIdAsc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_PURCHASE_ID_ASC',
  PurchaseItemsVariancePopulationPurchaseIdDesc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_PURCHASE_ID_DESC',
  PurchaseItemsVariancePopulationRowIdAsc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_ROW_ID_ASC',
  PurchaseItemsVariancePopulationRowIdDesc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_ROW_ID_DESC',
  PurchaseItemsVariancePopulationSkuIdAsc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_SKU_ID_ASC',
  PurchaseItemsVariancePopulationSkuIdDesc = 'PURCHASE_ITEMS_VARIANCE_POPULATION_SKU_ID_DESC',
  PurchaseItemsVarianceSampleProductIdAsc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  PurchaseItemsVarianceSampleProductIdDesc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  PurchaseItemsVarianceSamplePurchaseIdAsc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_PURCHASE_ID_ASC',
  PurchaseItemsVarianceSamplePurchaseIdDesc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_PURCHASE_ID_DESC',
  PurchaseItemsVarianceSampleRowIdAsc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_ROW_ID_ASC',
  PurchaseItemsVarianceSampleRowIdDesc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_ROW_ID_DESC',
  PurchaseItemsVarianceSampleSkuIdAsc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_SKU_ID_ASC',
  PurchaseItemsVarianceSampleSkuIdDesc = 'PURCHASE_ITEMS_VARIANCE_SAMPLE_SKU_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SkuIdAsc = 'SKU_ID_ASC',
  SkuIdDesc = 'SKU_ID_DESC'
}

export enum ProductRecurringcycleEnum {
  Daily = 'daily',
  Monthly = 'monthly',
  Never = 'never',
  OneTime = 'one_time',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type ProductStddevPopulationAggregateFilter = {
  productCategoryId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type ProductStddevPopulationAggregates = {
  __typename?: 'ProductStddevPopulationAggregates';
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductStddevSampleAggregateFilter = {
  productCategoryId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type ProductStddevSampleAggregates = {
  __typename?: 'ProductStddevSampleAggregates';
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductSumAggregateFilter = {
  productCategoryId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
};

export type ProductSumAggregates = {
  __typename?: 'ProductSumAggregates';
  /** Sum of price across the matching connection */
  price: Scalars['BigFloat']['output'];
  /** Sum of productCategoryId across the matching connection */
  productCategoryId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of skuId across the matching connection */
  skuId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CheckoutItem` object types. All fields are combined with a logical ‘and.’ */
export type ProductToManyCheckoutItemFilter = {
  /** Aggregates across related `CheckoutItem` match the filter criteria. */
  aggregates?: InputMaybe<CheckoutItemAggregatesFilter>;
  /** Every related `CheckoutItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckoutItemFilter>;
  /** No related `CheckoutItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckoutItemFilter>;
  /** Some related `CheckoutItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckoutItemFilter>;
};

/** A filter to be used against many `NmiSubscription` object types. All fields are combined with a logical ‘and.’ */
export type ProductToManyNmiSubscriptionFilter = {
  /** Aggregates across related `NmiSubscription` match the filter criteria. */
  aggregates?: InputMaybe<NmiSubscriptionAggregatesFilter>;
  /** Every related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NmiSubscriptionFilter>;
  /** No related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NmiSubscriptionFilter>;
  /** Some related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NmiSubscriptionFilter>;
};

/** A filter to be used against many `PurchaseItem` object types. All fields are combined with a logical ‘and.’ */
export type ProductToManyPurchaseItemFilter = {
  /** Aggregates across related `PurchaseItem` match the filter criteria. */
  aggregates?: InputMaybe<PurchaseItemAggregatesFilter>;
  /** Every related `PurchaseItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PurchaseItemFilter>;
  /** No related `PurchaseItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PurchaseItemFilter>;
  /** Some related `PurchaseItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PurchaseItemFilter>;
};

export type ProductVariancePopulationAggregateFilter = {
  productCategoryId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type ProductVariancePopulationAggregates = {
  __typename?: 'ProductVariancePopulationAggregates';
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProductVarianceSampleAggregateFilter = {
  productCategoryId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type ProductVarianceSampleAggregates = {
  __typename?: 'ProductVarianceSampleAggregates';
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProfileReport = Node & {
  __typename?: 'ProfileReport';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `TraderPublicProfile` that is related to this `ProfileReport`. */
  reportedProfile?: Maybe<TraderPublicProfile>;
  reportedProfileId: Scalars['Int']['output'];
  reporterIpHash: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  status: ProfileReportStatusEnum;
  updatedAt: Scalars['Datetime']['output'];
  userHandle: Scalars['String']['output'];
};

export type ProfileReportAggregates = {
  __typename?: 'ProfileReportAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ProfileReportAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProfileReportDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ProfileReportMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ProfileReportMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ProfileReportStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ProfileReportStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ProfileReportSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ProfileReportVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ProfileReportVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ProfileReport` object types. */
export type ProfileReportAggregatesFilter = {
  /** Mean average aggregate over matching `ProfileReport` objects. */
  average?: InputMaybe<ProfileReportAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ProfileReport` objects. */
  distinctCount?: InputMaybe<ProfileReportDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ProfileReport` object to be included within the aggregate. */
  filter?: InputMaybe<ProfileReportFilter>;
  /** Maximum aggregate over matching `ProfileReport` objects. */
  max?: InputMaybe<ProfileReportMaxAggregateFilter>;
  /** Minimum aggregate over matching `ProfileReport` objects. */
  min?: InputMaybe<ProfileReportMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ProfileReport` objects. */
  stddevPopulation?: InputMaybe<ProfileReportStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ProfileReport` objects. */
  stddevSample?: InputMaybe<ProfileReportStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ProfileReport` objects. */
  sum?: InputMaybe<ProfileReportSumAggregateFilter>;
  /** Population variance aggregate over matching `ProfileReport` objects. */
  variancePopulation?: InputMaybe<ProfileReportVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ProfileReport` objects. */
  varianceSample?: InputMaybe<ProfileReportVarianceSampleAggregateFilter>;
};

export type ProfileReportAverageAggregateFilter = {
  reportedProfileId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ProfileReportAverageAggregates = {
  __typename?: 'ProfileReportAverageAggregates';
  /** Mean average of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ProfileReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProfileReportCondition = {
  /** Checks for equality with the object’s `reportedProfileId` field. */
  reportedProfileId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ProfileReport` values. */
export type ProfileReportConnection = {
  __typename?: 'ProfileReportConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProfileReportAggregates>;
  /** A list of edges which contains the `ProfileReport` and cursor to aid in pagination. */
  edges: Array<Maybe<ProfileReportEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProfileReportAggregates>>;
  /** A list of `ProfileReport` objects. */
  nodes: Array<Maybe<ProfileReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProfileReport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ProfileReport` values. */
export type ProfileReportConnectionGroupedAggregatesArgs = {
  groupBy: Array<ProfileReportGroupBy>;
  having?: InputMaybe<ProfileReportHavingInput>;
};

export type ProfileReportDistinctCountAggregateFilter = {
  reportedProfileId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type ProfileReportDistinctCountAggregates = {
  __typename?: 'ProfileReportDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reporterIpHash across the matching connection */
  reporterIpHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userHandle across the matching connection */
  userHandle?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ProfileReport` edge in the connection. */
export type ProfileReportEdge = {
  __typename?: 'ProfileReportEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProfileReport` at the end of the edge. */
  node?: Maybe<ProfileReport>;
};

/** A filter to be used against `ProfileReport` object types. All fields are combined with a logical ‘and.’ */
export type ProfileReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProfileReportFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<ProfileReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProfileReportFilter>>;
  /** Filter by the object’s `reportedProfile` relation. */
  reportedProfile?: InputMaybe<TraderPublicProfileFilter>;
  /** Filter by the object’s `reportedProfileId` field. */
  reportedProfileId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `ProfileReport` for usage during aggregation. */
export enum ProfileReportGroupBy {
  ReportedProfileId = 'REPORTED_PROFILE_ID'
}

export type ProfileReportHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ProfileReport` aggregates. */
export type ProfileReportHavingInput = {
  AND?: InputMaybe<Array<ProfileReportHavingInput>>;
  OR?: InputMaybe<Array<ProfileReportHavingInput>>;
  average?: InputMaybe<ProfileReportHavingAverageInput>;
  distinctCount?: InputMaybe<ProfileReportHavingDistinctCountInput>;
  max?: InputMaybe<ProfileReportHavingMaxInput>;
  min?: InputMaybe<ProfileReportHavingMinInput>;
  stddevPopulation?: InputMaybe<ProfileReportHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ProfileReportHavingStddevSampleInput>;
  sum?: InputMaybe<ProfileReportHavingSumInput>;
  variancePopulation?: InputMaybe<ProfileReportHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ProfileReportHavingVarianceSampleInput>;
};

export type ProfileReportHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  reportedProfileId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProfileReportMaxAggregateFilter = {
  reportedProfileId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type ProfileReportMaxAggregates = {
  __typename?: 'ProfileReportMaxAggregates';
  /** Maximum of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type ProfileReportMinAggregateFilter = {
  reportedProfileId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type ProfileReportMinAggregates = {
  __typename?: 'ProfileReportMinAggregates';
  /** Minimum of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ProfileReport`. */
export enum ProfileReportOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReportedProfileIdAsc = 'REPORTED_PROFILE_ID_ASC',
  ReportedProfileIdDesc = 'REPORTED_PROFILE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export enum ProfileReportStatusEnum {
  Dismissed = 'dismissed',
  Open = 'open',
  Reviewed = 'reviewed'
}

export type ProfileReportStddevPopulationAggregateFilter = {
  reportedProfileId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ProfileReportStddevPopulationAggregates = {
  __typename?: 'ProfileReportStddevPopulationAggregates';
  /** Population standard deviation of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProfileReportStddevSampleAggregateFilter = {
  reportedProfileId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ProfileReportStddevSampleAggregates = {
  __typename?: 'ProfileReportStddevSampleAggregates';
  /** Sample standard deviation of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProfileReportSumAggregateFilter = {
  reportedProfileId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type ProfileReportSumAggregates = {
  __typename?: 'ProfileReportSumAggregates';
  /** Sum of reportedProfileId across the matching connection */
  reportedProfileId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type ProfileReportVariancePopulationAggregateFilter = {
  reportedProfileId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ProfileReportVariancePopulationAggregates = {
  __typename?: 'ProfileReportVariancePopulationAggregates';
  /** Population variance of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ProfileReportVarianceSampleAggregateFilter = {
  reportedProfileId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type ProfileReportVarianceSampleAggregates = {
  __typename?: 'ProfileReportVarianceSampleAggregates';
  /** Sample variance of reportedProfileId across the matching connection */
  reportedProfileId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Purchase = Node & {
  __typename?: 'Purchase';
  accountTemplate?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['BigFloat']['output'];
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingRegion?: Maybe<Scalars['String']['output']>;
  billingStreet?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  discount?: Maybe<Scalars['BigFloat']['output']>;
  gateway: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  invoiceTemplate?: Maybe<Scalars['String']['output']>;
  localCurrency?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  netSuiteInvoiceId?: Maybe<Scalars['String']['output']>;
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  nuveiAuthCode?: Maybe<Scalars['String']['output']>;
  nuveiPaymentId?: Maybe<Scalars['String']['output']>;
  nuveiSessionToken?: Maybe<Scalars['String']['output']>;
  nuveiTransactionId?: Maybe<Scalars['String']['output']>;
  nuveiUniqueClientId?: Maybe<Scalars['String']['output']>;
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  platform?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stripePaymentId?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type PurchaseAggregates = {
  __typename?: 'PurchaseAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PurchaseAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PurchaseDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PurchaseMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PurchaseMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PurchaseStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PurchaseStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PurchaseSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PurchaseVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PurchaseVarianceSampleAggregates>;
};

export type PurchaseAverageAggregates = {
  __typename?: 'PurchaseAverageAggregates';
  /** Mean average of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of platform across the matching connection */
  platform?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Purchase` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PurchaseCondition = {
  /** Checks for equality with the object’s `nuveiPaymentId` field. */
  nuveiPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nuveiSessionToken` field. */
  nuveiSessionToken?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stripePaymentId` field. */
  stripePaymentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Purchase` values. */
export type PurchaseConnection = {
  __typename?: 'PurchaseConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PurchaseAggregates>;
  /** A list of edges which contains the `Purchase` and cursor to aid in pagination. */
  edges: Array<Maybe<PurchaseEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PurchaseAggregates>>;
  /** A list of `Purchase` objects. */
  nodes: Array<Maybe<Purchase>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Purchase` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Purchase` values. */
export type PurchaseConnectionGroupedAggregatesArgs = {
  groupBy: Array<PurchaseGroupBy>;
  having?: InputMaybe<PurchaseHavingInput>;
};

export type PurchaseDistinctCountAggregates = {
  __typename?: 'PurchaseDistinctCountAggregates';
  /** Distinct count of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingCity across the matching connection */
  billingCity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingCountry across the matching connection */
  billingCountry?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingRegion across the matching connection */
  billingRegion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingStreet across the matching connection */
  billingStreet?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billingZip across the matching connection */
  billingZip?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discount across the matching connection */
  discount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of invoiceTemplate across the matching connection */
  invoiceTemplate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of localCurrency across the matching connection */
  localCurrency?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of method across the matching connection */
  method?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteInvoiceId across the matching connection */
  netSuiteInvoiceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiAuthCode across the matching connection */
  nuveiAuthCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiPaymentId across the matching connection */
  nuveiPaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiSessionToken across the matching connection */
  nuveiSessionToken?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiTransactionId across the matching connection */
  nuveiTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiUniqueClientId across the matching connection */
  nuveiUniqueClientId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platform across the matching connection */
  platform?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stripePaymentId across the matching connection */
  stripePaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tax across the matching connection */
  tax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of total across the matching connection */
  total?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Purchase` edge in the connection. */
export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Purchase` at the end of the edge. */
  node?: Maybe<Purchase>;
};

/** A filter to be used against `Purchase` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PurchaseFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<PurchaseFilter>;
  /** Filter by the object’s `nuveiPaymentId` field. */
  nuveiPaymentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nuveiSessionToken` field. */
  nuveiSessionToken?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PurchaseFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stripePaymentId` field. */
  stripePaymentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Purchase` for usage during aggregation. */
export enum PurchaseGroupBy {
  NuveiSessionToken = 'NUVEI_SESSION_TOKEN',
  UserId = 'USER_ID'
}

export type PurchaseHavingAverageInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingDistinctCountInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Purchase` aggregates. */
export type PurchaseHavingInput = {
  AND?: InputMaybe<Array<PurchaseHavingInput>>;
  OR?: InputMaybe<Array<PurchaseHavingInput>>;
  average?: InputMaybe<PurchaseHavingAverageInput>;
  distinctCount?: InputMaybe<PurchaseHavingDistinctCountInput>;
  max?: InputMaybe<PurchaseHavingMaxInput>;
  min?: InputMaybe<PurchaseHavingMinInput>;
  stddevPopulation?: InputMaybe<PurchaseHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PurchaseHavingStddevSampleInput>;
  sum?: InputMaybe<PurchaseHavingSumInput>;
  variancePopulation?: InputMaybe<PurchaseHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PurchaseHavingVarianceSampleInput>;
};

export type PurchaseHavingMaxInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingMinInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingStddevPopulationInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingStddevSampleInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingSumInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingVariancePopulationInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseHavingVarianceSampleInput = {
  accountTemplate?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gateway?: InputMaybe<HavingIntFilter>;
  netSuiteItemId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  platform?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  taxRate?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItem = Node & {
  __typename?: 'PurchaseItem';
  /** Reads a single `Account` that is related to this `PurchaseItem`. */
  associatedAccount?: Maybe<Account>;
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Reads a single `Platform` that is related to this `PurchaseItem`. */
  platform?: Maybe<Platform>;
  platformId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigFloat']['output'];
  /** Reads a single `Product` that is related to this `PurchaseItem`. */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  productSnapshot: Scalars['JSON']['output'];
  /** Reads a single `PurchaseOrder` that is related to this `PurchaseItem`. */
  purchase?: Maybe<PurchaseOrder>;
  purchaseId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseItemAggregates = {
  __typename?: 'PurchaseItemAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PurchaseItemAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PurchaseItemDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PurchaseItemMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PurchaseItemMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PurchaseItemStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PurchaseItemStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PurchaseItemSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PurchaseItemVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PurchaseItemVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PurchaseItem` object types. */
export type PurchaseItemAggregatesFilter = {
  /** Mean average aggregate over matching `PurchaseItem` objects. */
  average?: InputMaybe<PurchaseItemAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PurchaseItem` objects. */
  distinctCount?: InputMaybe<PurchaseItemDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PurchaseItem` object to be included within the aggregate. */
  filter?: InputMaybe<PurchaseItemFilter>;
  /** Maximum aggregate over matching `PurchaseItem` objects. */
  max?: InputMaybe<PurchaseItemMaxAggregateFilter>;
  /** Minimum aggregate over matching `PurchaseItem` objects. */
  min?: InputMaybe<PurchaseItemMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PurchaseItem` objects. */
  stddevPopulation?: InputMaybe<PurchaseItemStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PurchaseItem` objects. */
  stddevSample?: InputMaybe<PurchaseItemStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PurchaseItem` objects. */
  sum?: InputMaybe<PurchaseItemSumAggregateFilter>;
  /** Population variance aggregate over matching `PurchaseItem` objects. */
  variancePopulation?: InputMaybe<PurchaseItemVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PurchaseItem` objects. */
  varianceSample?: InputMaybe<PurchaseItemVarianceSampleAggregateFilter>;
};

export type PurchaseItemAverageAggregateFilter = {
  productId?: InputMaybe<BigFloatFilter>;
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseItemAverageAggregates = {
  __typename?: 'PurchaseItemAverageAggregates';
  /** Mean average of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PurchaseItem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PurchaseItemCondition = {
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `purchaseId` field. */
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `skuId` field. */
  skuId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PurchaseItem` values. */
export type PurchaseItemConnection = {
  __typename?: 'PurchaseItemConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PurchaseItemAggregates>;
  /** A list of edges which contains the `PurchaseItem` and cursor to aid in pagination. */
  edges: Array<Maybe<PurchaseItemEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PurchaseItemAggregates>>;
  /** A list of `PurchaseItem` objects. */
  nodes: Array<Maybe<PurchaseItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PurchaseItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PurchaseItem` values. */
export type PurchaseItemConnectionGroupedAggregatesArgs = {
  groupBy: Array<PurchaseItemGroupBy>;
  having?: InputMaybe<PurchaseItemHavingInput>;
};

export type PurchaseItemDistinctCountAggregateFilter = {
  productId?: InputMaybe<BigIntFilter>;
  purchaseId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
};

export type PurchaseItemDistinctCountAggregates = {
  __typename?: 'PurchaseItemDistinctCountAggregates';
  /** Distinct count of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productId across the matching connection */
  productId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productSnapshot across the matching connection */
  productSnapshot?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PurchaseItem` edge in the connection. */
export type PurchaseItemEdge = {
  __typename?: 'PurchaseItemEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PurchaseItem` at the end of the edge. */
  node?: Maybe<PurchaseItem>;
};

/** A filter to be used against `PurchaseItem` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseItemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PurchaseItemFilter>>;
  /** Filter by the object’s `associatedAccount` relation. */
  associatedAccount?: InputMaybe<AccountFilter>;
  /** A related `associatedAccount` exists. */
  associatedAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<PurchaseItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PurchaseItemFilter>>;
  /** Filter by the object’s `platform` relation. */
  platform?: InputMaybe<PlatformFilter>;
  /** A related `platform` exists. */
  platformExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<ProductFilter>;
  /** A related `product` exists. */
  productExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `purchase` relation. */
  purchase?: InputMaybe<PurchaseOrderFilter>;
  /** Filter by the object’s `purchaseId` field. */
  purchaseId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `skuId` field. */
  skuId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PurchaseItem` for usage during aggregation. */
export enum PurchaseItemGroupBy {
  ProductId = 'PRODUCT_ID',
  PurchaseId = 'PURCHASE_ID',
  SkuId = 'SKU_ID'
}

export type PurchaseItemHavingAverageInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingDistinctCountInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PurchaseItem` aggregates. */
export type PurchaseItemHavingInput = {
  AND?: InputMaybe<Array<PurchaseItemHavingInput>>;
  OR?: InputMaybe<Array<PurchaseItemHavingInput>>;
  average?: InputMaybe<PurchaseItemHavingAverageInput>;
  distinctCount?: InputMaybe<PurchaseItemHavingDistinctCountInput>;
  max?: InputMaybe<PurchaseItemHavingMaxInput>;
  min?: InputMaybe<PurchaseItemHavingMinInput>;
  stddevPopulation?: InputMaybe<PurchaseItemHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PurchaseItemHavingStddevSampleInput>;
  sum?: InputMaybe<PurchaseItemHavingSumInput>;
  variancePopulation?: InputMaybe<PurchaseItemHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PurchaseItemHavingVarianceSampleInput>;
};

export type PurchaseItemHavingMaxInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingMinInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingStddevPopulationInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingStddevSampleInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingSumInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingVariancePopulationInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemHavingVarianceSampleInput = {
  associatedAccountId?: InputMaybe<HavingIntFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingBigfloatFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  skuId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseItemMaxAggregateFilter = {
  productId?: InputMaybe<IntFilter>;
  purchaseId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
};

export type PurchaseItemMaxAggregates = {
  __typename?: 'PurchaseItemMaxAggregates';
  /** Maximum of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseItemMinAggregateFilter = {
  productId?: InputMaybe<IntFilter>;
  purchaseId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  skuId?: InputMaybe<IntFilter>;
};

export type PurchaseItemMinAggregates = {
  __typename?: 'PurchaseItemMinAggregates';
  /** Minimum of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of skuId across the matching connection */
  skuId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PurchaseItem`. */
export enum PurchaseItemOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  PurchaseIdAsc = 'PURCHASE_ID_ASC',
  PurchaseIdDesc = 'PURCHASE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SkuIdAsc = 'SKU_ID_ASC',
  SkuIdDesc = 'SKU_ID_DESC'
}

export type PurchaseItemStddevPopulationAggregateFilter = {
  productId?: InputMaybe<BigFloatFilter>;
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseItemStddevPopulationAggregates = {
  __typename?: 'PurchaseItemStddevPopulationAggregates';
  /** Population standard deviation of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseItemStddevSampleAggregateFilter = {
  productId?: InputMaybe<BigFloatFilter>;
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseItemStddevSampleAggregates = {
  __typename?: 'PurchaseItemStddevSampleAggregates';
  /** Sample standard deviation of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseItemSumAggregateFilter = {
  productId?: InputMaybe<BigIntFilter>;
  purchaseId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  skuId?: InputMaybe<BigIntFilter>;
};

export type PurchaseItemSumAggregates = {
  __typename?: 'PurchaseItemSumAggregates';
  /** Sum of associatedAccountId across the matching connection */
  associatedAccountId: Scalars['BigInt']['output'];
  /** Sum of platformId across the matching connection */
  platformId: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['BigFloat']['output'];
  /** Sum of productId across the matching connection */
  productId: Scalars['BigInt']['output'];
  /** Sum of purchaseId across the matching connection */
  purchaseId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of skuId across the matching connection */
  skuId: Scalars['BigInt']['output'];
};

export type PurchaseItemVariancePopulationAggregateFilter = {
  productId?: InputMaybe<BigFloatFilter>;
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseItemVariancePopulationAggregates = {
  __typename?: 'PurchaseItemVariancePopulationAggregates';
  /** Population variance of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseItemVarianceSampleAggregateFilter = {
  productId?: InputMaybe<BigFloatFilter>;
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  skuId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseItemVarianceSampleAggregates = {
  __typename?: 'PurchaseItemVarianceSampleAggregates';
  /** Sample variance of associatedAccountId across the matching connection */
  associatedAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of skuId across the matching connection */
  skuId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseMaxAggregates = {
  __typename?: 'PurchaseMaxAggregates';
  /** Maximum of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of gateway across the matching connection */
  gateway?: Maybe<Scalars['Int']['output']>;
  /** Maximum of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of platform across the matching connection */
  platform?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseMinAggregates = {
  __typename?: 'PurchaseMinAggregates';
  /** Minimum of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of gateway across the matching connection */
  gateway?: Maybe<Scalars['Int']['output']>;
  /** Minimum of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of platform across the matching connection */
  platform?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseOrder = Node & {
  __typename?: 'PurchaseOrder';
  billing: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `ChargebackIndicator`. */
  chargebackIndicators: ChargebackIndicatorConnection;
  /** Reads and enables pagination through a set of `Chargeback`. */
  chargebacks: ChargebackConnection;
  /** Reads a single `CheckoutSession` that is related to this `PurchaseOrder`. */
  checkoutSession?: Maybe<CheckoutSession>;
  couponSnapshot?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Datetime']['output'];
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `PaymentGateway` that is related to this `PurchaseOrder`. */
  gateway?: Maybe<PaymentGateway>;
  gatewayId: Scalars['Int']['output'];
  gatewayTransactionId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  invoiceTemplate?: Maybe<Scalars['String']['output']>;
  localCurrency?: Maybe<Scalars['String']['output']>;
  /** Reads a single `OrderFulfillment` that is related to this `PurchaseOrder`. */
  orderFulfillment?: Maybe<OrderFulfillment>;
  paymentMethod: Scalars['String']['output'];
  paymentSnapshot: Scalars['JSON']['output'];
  processor: Scalars['String']['output'];
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PurchaseItem`. */
  purchaseItemsByPurchaseId: PurchaseItemConnection;
  /** Reads a single `RebillSession` that is related to this `PurchaseOrder`. */
  rebillSession?: Maybe<RebillSession>;
  /** Reads and enables pagination through a set of `Refund`. */
  refunds: RefundConnection;
  rowId: Scalars['Int']['output'];
  shipping?: Maybe<Scalars['JSON']['output']>;
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  taxSnapshot: Scalars['JSON']['output'];
  total?: Maybe<Scalars['BigFloat']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `PurchaseOrder`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type PurchaseOrderChargebackIndicatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChargebackIndicatorCondition>;
  filter?: InputMaybe<ChargebackIndicatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChargebackIndicatorOrderBy>>;
};


export type PurchaseOrderChargebacksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChargebackCondition>;
  filter?: InputMaybe<ChargebackFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChargebackOrderBy>>;
};


export type PurchaseOrderPurchaseItemsByPurchaseIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PurchaseItemCondition>;
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PurchaseItemOrderBy>>;
};


export type PurchaseOrderRefundsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RefundCondition>;
  filter?: InputMaybe<RefundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RefundOrderBy>>;
};

export type PurchaseOrderAggregates = {
  __typename?: 'PurchaseOrderAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PurchaseOrderAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PurchaseOrderDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PurchaseOrderMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PurchaseOrderMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PurchaseOrderStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PurchaseOrderStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PurchaseOrderSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PurchaseOrderVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PurchaseOrderVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PurchaseOrder` object types. */
export type PurchaseOrderAggregatesFilter = {
  /** Mean average aggregate over matching `PurchaseOrder` objects. */
  average?: InputMaybe<PurchaseOrderAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PurchaseOrder` objects. */
  distinctCount?: InputMaybe<PurchaseOrderDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PurchaseOrder` object to be included within the aggregate. */
  filter?: InputMaybe<PurchaseOrderFilter>;
  /** Maximum aggregate over matching `PurchaseOrder` objects. */
  max?: InputMaybe<PurchaseOrderMaxAggregateFilter>;
  /** Minimum aggregate over matching `PurchaseOrder` objects. */
  min?: InputMaybe<PurchaseOrderMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PurchaseOrder` objects. */
  stddevPopulation?: InputMaybe<PurchaseOrderStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PurchaseOrder` objects. */
  stddevSample?: InputMaybe<PurchaseOrderStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PurchaseOrder` objects. */
  sum?: InputMaybe<PurchaseOrderSumAggregateFilter>;
  /** Population variance aggregate over matching `PurchaseOrder` objects. */
  variancePopulation?: InputMaybe<PurchaseOrderVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PurchaseOrder` objects. */
  varianceSample?: InputMaybe<PurchaseOrderVarianceSampleAggregateFilter>;
};

export type PurchaseOrderAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseOrderAverageAggregates = {
  __typename?: 'PurchaseOrderAverageAggregates';
  /** Mean average of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** Methods to use when ordering `Purchase`. */
export enum PurchaseOrderBy {
  Natural = 'NATURAL',
  NuveiPaymentIdAsc = 'NUVEI_PAYMENT_ID_ASC',
  NuveiPaymentIdDesc = 'NUVEI_PAYMENT_ID_DESC',
  NuveiSessionTokenAsc = 'NUVEI_SESSION_TOKEN_ASC',
  NuveiSessionTokenDesc = 'NUVEI_SESSION_TOKEN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StripePaymentIdAsc = 'STRIPE_PAYMENT_ID_ASC',
  StripePaymentIdDesc = 'STRIPE_PAYMENT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/**
 * A condition to be used against `PurchaseOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PurchaseOrderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `processorTransactionId` field. */
  processorTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `total` field. */
  total?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PurchaseOrder` values. */
export type PurchaseOrderConnection = {
  __typename?: 'PurchaseOrderConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PurchaseOrderAggregates>;
  /** A list of edges which contains the `PurchaseOrder` and cursor to aid in pagination. */
  edges: Array<Maybe<PurchaseOrderEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PurchaseOrderAggregates>>;
  /** A list of `PurchaseOrder` objects. */
  nodes: Array<Maybe<PurchaseOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PurchaseOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PurchaseOrder` values. */
export type PurchaseOrderConnectionGroupedAggregatesArgs = {
  groupBy: Array<PurchaseOrderGroupBy>;
  having?: InputMaybe<PurchaseOrderHavingInput>;
};

export type PurchaseOrderDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  gatewayTransactionId?: InputMaybe<BigIntFilter>;
  processorTransactionId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  total?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PurchaseOrderDistinctCountAggregates = {
  __typename?: 'PurchaseOrderDistinctCountAggregates';
  /** Distinct count of billing across the matching connection */
  billing?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of couponSnapshot across the matching connection */
  couponSnapshot?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discount across the matching connection */
  discount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of gatewayTransactionId across the matching connection */
  gatewayTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of invoiceTemplate across the matching connection */
  invoiceTemplate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of localCurrency across the matching connection */
  localCurrency?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of paymentMethod across the matching connection */
  paymentMethod?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of paymentSnapshot across the matching connection */
  paymentSnapshot?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of processor across the matching connection */
  processor?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of processorTransactionId across the matching connection */
  processorTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of shipping across the matching connection */
  shipping?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tax across the matching connection */
  tax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxSnapshot across the matching connection */
  taxSnapshot?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of total across the matching connection */
  total?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `PurchaseOrder` edge in the connection. */
export type PurchaseOrderEdge = {
  __typename?: 'PurchaseOrderEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PurchaseOrder` at the end of the edge. */
  node?: Maybe<PurchaseOrder>;
};

/** A filter to be used against `PurchaseOrder` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PurchaseOrderFilter>>;
  /** Filter by the object’s `chargebackIndicators` relation. */
  chargebackIndicators?: InputMaybe<PurchaseOrderToManyChargebackIndicatorFilter>;
  /** Some related `chargebackIndicators` exist. */
  chargebackIndicatorsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `chargebacks` relation. */
  chargebacks?: InputMaybe<PurchaseOrderToManyChargebackFilter>;
  /** Some related `chargebacks` exist. */
  chargebacksExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkoutSession` relation. */
  checkoutSession?: InputMaybe<CheckoutSessionFilter>;
  /** A related `checkoutSession` exists. */
  checkoutSessionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `gateway` relation. */
  gateway?: InputMaybe<PaymentGatewayFilter>;
  /** Filter by the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PurchaseOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PurchaseOrderFilter>>;
  /** Filter by the object’s `orderFulfillment` relation. */
  orderFulfillment?: InputMaybe<OrderFulfillmentFilter>;
  /** A related `orderFulfillment` exists. */
  orderFulfillmentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `processorTransactionId` field. */
  processorTransactionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `purchaseItemsByPurchaseId` relation. */
  purchaseItemsByPurchaseId?: InputMaybe<PurchaseOrderToManyPurchaseItemFilter>;
  /** Some related `purchaseItemsByPurchaseId` exist. */
  purchaseItemsByPurchaseIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rebillSession` relation. */
  rebillSession?: InputMaybe<RebillSessionFilter>;
  /** A related `rebillSession` exists. */
  rebillSessionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `refunds` relation. */
  refunds?: InputMaybe<PurchaseOrderToManyRefundFilter>;
  /** Some related `refunds` exist. */
  refundsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `total` field. */
  total?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `PurchaseOrder` for usage during aggregation. */
export enum PurchaseOrderGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Total = 'TOTAL',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedAtTruncatedToDay = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UpdatedAtTruncatedToHour = 'UPDATED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type PurchaseOrderHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `PurchaseOrder` aggregates. */
export type PurchaseOrderHavingInput = {
  AND?: InputMaybe<Array<PurchaseOrderHavingInput>>;
  OR?: InputMaybe<Array<PurchaseOrderHavingInput>>;
  average?: InputMaybe<PurchaseOrderHavingAverageInput>;
  distinctCount?: InputMaybe<PurchaseOrderHavingDistinctCountInput>;
  max?: InputMaybe<PurchaseOrderHavingMaxInput>;
  min?: InputMaybe<PurchaseOrderHavingMinInput>;
  stddevPopulation?: InputMaybe<PurchaseOrderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PurchaseOrderHavingStddevSampleInput>;
  sum?: InputMaybe<PurchaseOrderHavingSumInput>;
  variancePopulation?: InputMaybe<PurchaseOrderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PurchaseOrderHavingVarianceSampleInput>;
};

export type PurchaseOrderHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  discount?: InputMaybe<HavingBigfloatFilter>;
  gatewayId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subtotal?: InputMaybe<HavingBigfloatFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  taxDisplayedInLocalCurrency?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type PurchaseOrderMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PurchaseOrderMaxAggregates = {
  __typename?: 'PurchaseOrderMaxAggregates';
  /** Maximum of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseOrderMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PurchaseOrderMinAggregates = {
  __typename?: 'PurchaseOrderMinAggregates';
  /** Minimum of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PurchaseOrder`. */
export enum PurchaseOrderOrderBy {
  ChargebacksAveragePurchaseOrderIdAsc = 'CHARGEBACKS_AVERAGE_PURCHASE_ORDER_ID_ASC',
  ChargebacksAveragePurchaseOrderIdDesc = 'CHARGEBACKS_AVERAGE_PURCHASE_ORDER_ID_DESC',
  ChargebacksAverageTraderUserIdAsc = 'CHARGEBACKS_AVERAGE_TRADER_USER_ID_ASC',
  ChargebacksAverageTraderUserIdDesc = 'CHARGEBACKS_AVERAGE_TRADER_USER_ID_DESC',
  ChargebacksCountAsc = 'CHARGEBACKS_COUNT_ASC',
  ChargebacksCountDesc = 'CHARGEBACKS_COUNT_DESC',
  ChargebacksDistinctCountChargebackKeyAsc = 'CHARGEBACKS_DISTINCT_COUNT_CHARGEBACK_KEY_ASC',
  ChargebacksDistinctCountChargebackKeyDesc = 'CHARGEBACKS_DISTINCT_COUNT_CHARGEBACK_KEY_DESC',
  ChargebacksDistinctCountPurchaseOrderIdAsc = 'CHARGEBACKS_DISTINCT_COUNT_PURCHASE_ORDER_ID_ASC',
  ChargebacksDistinctCountPurchaseOrderIdDesc = 'CHARGEBACKS_DISTINCT_COUNT_PURCHASE_ORDER_ID_DESC',
  ChargebacksDistinctCountRowIdAsc = 'CHARGEBACKS_DISTINCT_COUNT_ROW_ID_ASC',
  ChargebacksDistinctCountRowIdDesc = 'CHARGEBACKS_DISTINCT_COUNT_ROW_ID_DESC',
  ChargebacksDistinctCountTraderUserIdAsc = 'CHARGEBACKS_DISTINCT_COUNT_TRADER_USER_ID_ASC',
  ChargebacksDistinctCountTraderUserIdDesc = 'CHARGEBACKS_DISTINCT_COUNT_TRADER_USER_ID_DESC',
  ChargebacksMaxPurchaseOrderIdAsc = 'CHARGEBACKS_MAX_PURCHASE_ORDER_ID_ASC',
  ChargebacksMaxPurchaseOrderIdDesc = 'CHARGEBACKS_MAX_PURCHASE_ORDER_ID_DESC',
  ChargebacksMaxTraderUserIdAsc = 'CHARGEBACKS_MAX_TRADER_USER_ID_ASC',
  ChargebacksMaxTraderUserIdDesc = 'CHARGEBACKS_MAX_TRADER_USER_ID_DESC',
  ChargebacksMinPurchaseOrderIdAsc = 'CHARGEBACKS_MIN_PURCHASE_ORDER_ID_ASC',
  ChargebacksMinPurchaseOrderIdDesc = 'CHARGEBACKS_MIN_PURCHASE_ORDER_ID_DESC',
  ChargebacksMinTraderUserIdAsc = 'CHARGEBACKS_MIN_TRADER_USER_ID_ASC',
  ChargebacksMinTraderUserIdDesc = 'CHARGEBACKS_MIN_TRADER_USER_ID_DESC',
  ChargebacksStddevPopulationPurchaseOrderIdAsc = 'CHARGEBACKS_STDDEV_POPULATION_PURCHASE_ORDER_ID_ASC',
  ChargebacksStddevPopulationPurchaseOrderIdDesc = 'CHARGEBACKS_STDDEV_POPULATION_PURCHASE_ORDER_ID_DESC',
  ChargebacksStddevPopulationTraderUserIdAsc = 'CHARGEBACKS_STDDEV_POPULATION_TRADER_USER_ID_ASC',
  ChargebacksStddevPopulationTraderUserIdDesc = 'CHARGEBACKS_STDDEV_POPULATION_TRADER_USER_ID_DESC',
  ChargebacksStddevSamplePurchaseOrderIdAsc = 'CHARGEBACKS_STDDEV_SAMPLE_PURCHASE_ORDER_ID_ASC',
  ChargebacksStddevSamplePurchaseOrderIdDesc = 'CHARGEBACKS_STDDEV_SAMPLE_PURCHASE_ORDER_ID_DESC',
  ChargebacksStddevSampleTraderUserIdAsc = 'CHARGEBACKS_STDDEV_SAMPLE_TRADER_USER_ID_ASC',
  ChargebacksStddevSampleTraderUserIdDesc = 'CHARGEBACKS_STDDEV_SAMPLE_TRADER_USER_ID_DESC',
  ChargebacksSumPurchaseOrderIdAsc = 'CHARGEBACKS_SUM_PURCHASE_ORDER_ID_ASC',
  ChargebacksSumPurchaseOrderIdDesc = 'CHARGEBACKS_SUM_PURCHASE_ORDER_ID_DESC',
  ChargebacksSumTraderUserIdAsc = 'CHARGEBACKS_SUM_TRADER_USER_ID_ASC',
  ChargebacksSumTraderUserIdDesc = 'CHARGEBACKS_SUM_TRADER_USER_ID_DESC',
  ChargebacksVariancePopulationPurchaseOrderIdAsc = 'CHARGEBACKS_VARIANCE_POPULATION_PURCHASE_ORDER_ID_ASC',
  ChargebacksVariancePopulationPurchaseOrderIdDesc = 'CHARGEBACKS_VARIANCE_POPULATION_PURCHASE_ORDER_ID_DESC',
  ChargebacksVariancePopulationTraderUserIdAsc = 'CHARGEBACKS_VARIANCE_POPULATION_TRADER_USER_ID_ASC',
  ChargebacksVariancePopulationTraderUserIdDesc = 'CHARGEBACKS_VARIANCE_POPULATION_TRADER_USER_ID_DESC',
  ChargebacksVarianceSamplePurchaseOrderIdAsc = 'CHARGEBACKS_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_ASC',
  ChargebacksVarianceSamplePurchaseOrderIdDesc = 'CHARGEBACKS_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_DESC',
  ChargebacksVarianceSampleTraderUserIdAsc = 'CHARGEBACKS_VARIANCE_SAMPLE_TRADER_USER_ID_ASC',
  ChargebacksVarianceSampleTraderUserIdDesc = 'CHARGEBACKS_VARIANCE_SAMPLE_TRADER_USER_ID_DESC',
  ChargebackIndicatorsAveragePurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_AVERAGE_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsAveragePurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_AVERAGE_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsAverageRowIdAsc = 'CHARGEBACK_INDICATORS_AVERAGE_ROW_ID_ASC',
  ChargebackIndicatorsAverageRowIdDesc = 'CHARGEBACK_INDICATORS_AVERAGE_ROW_ID_DESC',
  ChargebackIndicatorsCountAsc = 'CHARGEBACK_INDICATORS_COUNT_ASC',
  ChargebackIndicatorsCountDesc = 'CHARGEBACK_INDICATORS_COUNT_DESC',
  ChargebackIndicatorsDistinctCountArnAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_ARN_ASC',
  ChargebackIndicatorsDistinctCountArnDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_ARN_DESC',
  ChargebackIndicatorsDistinctCountCreatedAtAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_CREATED_AT_ASC',
  ChargebackIndicatorsDistinctCountCreatedAtDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_CREATED_AT_DESC',
  ChargebackIndicatorsDistinctCountProcessorAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_PROCESSOR_ASC',
  ChargebackIndicatorsDistinctCountProcessorDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_PROCESSOR_DESC',
  ChargebackIndicatorsDistinctCountPurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsDistinctCountPurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsDistinctCountRecoveryOutcomeAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_RECOVERY_OUTCOME_ASC',
  ChargebackIndicatorsDistinctCountRecoveryOutcomeDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_RECOVERY_OUTCOME_DESC',
  ChargebackIndicatorsDistinctCountRowIdAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_ROW_ID_ASC',
  ChargebackIndicatorsDistinctCountRowIdDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_ROW_ID_DESC',
  ChargebackIndicatorsDistinctCountSourceTransactionIdAsc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_SOURCE_TRANSACTION_ID_ASC',
  ChargebackIndicatorsDistinctCountSourceTransactionIdDesc = 'CHARGEBACK_INDICATORS_DISTINCT_COUNT_SOURCE_TRANSACTION_ID_DESC',
  ChargebackIndicatorsMaxPurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_MAX_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsMaxPurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_MAX_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsMaxRowIdAsc = 'CHARGEBACK_INDICATORS_MAX_ROW_ID_ASC',
  ChargebackIndicatorsMaxRowIdDesc = 'CHARGEBACK_INDICATORS_MAX_ROW_ID_DESC',
  ChargebackIndicatorsMinPurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_MIN_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsMinPurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_MIN_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsMinRowIdAsc = 'CHARGEBACK_INDICATORS_MIN_ROW_ID_ASC',
  ChargebackIndicatorsMinRowIdDesc = 'CHARGEBACK_INDICATORS_MIN_ROW_ID_DESC',
  ChargebackIndicatorsStddevPopulationPurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_STDDEV_POPULATION_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsStddevPopulationPurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_STDDEV_POPULATION_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsStddevPopulationRowIdAsc = 'CHARGEBACK_INDICATORS_STDDEV_POPULATION_ROW_ID_ASC',
  ChargebackIndicatorsStddevPopulationRowIdDesc = 'CHARGEBACK_INDICATORS_STDDEV_POPULATION_ROW_ID_DESC',
  ChargebackIndicatorsStddevSamplePurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_STDDEV_SAMPLE_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsStddevSamplePurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_STDDEV_SAMPLE_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsStddevSampleRowIdAsc = 'CHARGEBACK_INDICATORS_STDDEV_SAMPLE_ROW_ID_ASC',
  ChargebackIndicatorsStddevSampleRowIdDesc = 'CHARGEBACK_INDICATORS_STDDEV_SAMPLE_ROW_ID_DESC',
  ChargebackIndicatorsSumPurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_SUM_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsSumPurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_SUM_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsSumRowIdAsc = 'CHARGEBACK_INDICATORS_SUM_ROW_ID_ASC',
  ChargebackIndicatorsSumRowIdDesc = 'CHARGEBACK_INDICATORS_SUM_ROW_ID_DESC',
  ChargebackIndicatorsVariancePopulationPurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_VARIANCE_POPULATION_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsVariancePopulationPurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_VARIANCE_POPULATION_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsVariancePopulationRowIdAsc = 'CHARGEBACK_INDICATORS_VARIANCE_POPULATION_ROW_ID_ASC',
  ChargebackIndicatorsVariancePopulationRowIdDesc = 'CHARGEBACK_INDICATORS_VARIANCE_POPULATION_ROW_ID_DESC',
  ChargebackIndicatorsVarianceSamplePurchaseOrderIdAsc = 'CHARGEBACK_INDICATORS_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_ASC',
  ChargebackIndicatorsVarianceSamplePurchaseOrderIdDesc = 'CHARGEBACK_INDICATORS_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_DESC',
  ChargebackIndicatorsVarianceSampleRowIdAsc = 'CHARGEBACK_INDICATORS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ChargebackIndicatorsVarianceSampleRowIdDesc = 'CHARGEBACK_INDICATORS_VARIANCE_SAMPLE_ROW_ID_DESC',
  /** Optimized with index */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Optimized with index */
  CreatedAtDesc = 'CREATED_AT_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessorTransactionIdAsc = 'PROCESSOR_TRANSACTION_ID_ASC',
  ProcessorTransactionIdDesc = 'PROCESSOR_TRANSACTION_ID_DESC',
  PurchaseItemsByPurchaseIdAverageProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdAverageProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdAveragePurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdAveragePurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdAverageRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdAverageRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdAverageSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdAverageSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_AVERAGE_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdCountAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_COUNT_ASC',
  PurchaseItemsByPurchaseIdCountDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_COUNT_DESC',
  PurchaseItemsByPurchaseIdDistinctCountProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdDistinctCountProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdDistinctCountPurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdDistinctCountPurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdDistinctCountRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdDistinctCountRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdDistinctCountSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdDistinctCountSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_DISTINCT_COUNT_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdMaxProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdMaxProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdMaxPurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdMaxPurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdMaxRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdMaxRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdMaxSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdMaxSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MAX_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdMinProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdMinProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdMinPurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdMinPurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdMinRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdMinRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdMinSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdMinSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_MIN_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdStddevPopulationProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdStddevPopulationProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdStddevPopulationPurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdStddevPopulationPurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdStddevPopulationRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdStddevPopulationRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdStddevPopulationSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdStddevPopulationSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_POPULATION_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdStddevSampleProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdStddevSampleProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdStddevSamplePurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdStddevSamplePurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdStddevSampleRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdStddevSampleRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdStddevSampleSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdStddevSampleSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_STDDEV_SAMPLE_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdSumProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdSumProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdSumPurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdSumPurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdSumRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdSumRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdSumSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdSumSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_SUM_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdVariancePopulationProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdVariancePopulationProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdVariancePopulationPurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdVariancePopulationPurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdVariancePopulationRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdVariancePopulationRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdVariancePopulationSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdVariancePopulationSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_POPULATION_SKU_ID_DESC',
  PurchaseItemsByPurchaseIdVarianceSampleProductIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  PurchaseItemsByPurchaseIdVarianceSampleProductIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  PurchaseItemsByPurchaseIdVarianceSamplePurchaseIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_PURCHASE_ID_ASC',
  PurchaseItemsByPurchaseIdVarianceSamplePurchaseIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_PURCHASE_ID_DESC',
  PurchaseItemsByPurchaseIdVarianceSampleRowIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PurchaseItemsByPurchaseIdVarianceSampleRowIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PurchaseItemsByPurchaseIdVarianceSampleSkuIdAsc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_SKU_ID_ASC',
  PurchaseItemsByPurchaseIdVarianceSampleSkuIdDesc = 'PURCHASE_ITEMS_BY_PURCHASE_ID_VARIANCE_SAMPLE_SKU_ID_DESC',
  RefundsAveragePurchaseOrderIdAsc = 'REFUNDS_AVERAGE_PURCHASE_ORDER_ID_ASC',
  RefundsAveragePurchaseOrderIdDesc = 'REFUNDS_AVERAGE_PURCHASE_ORDER_ID_DESC',
  RefundsAverageRowIdAsc = 'REFUNDS_AVERAGE_ROW_ID_ASC',
  RefundsAverageRowIdDesc = 'REFUNDS_AVERAGE_ROW_ID_DESC',
  RefundsAverageUserIdAsc = 'REFUNDS_AVERAGE_USER_ID_ASC',
  RefundsAverageUserIdDesc = 'REFUNDS_AVERAGE_USER_ID_DESC',
  RefundsCountAsc = 'REFUNDS_COUNT_ASC',
  RefundsCountDesc = 'REFUNDS_COUNT_DESC',
  RefundsDistinctCountPurchaseOrderIdAsc = 'REFUNDS_DISTINCT_COUNT_PURCHASE_ORDER_ID_ASC',
  RefundsDistinctCountPurchaseOrderIdDesc = 'REFUNDS_DISTINCT_COUNT_PURCHASE_ORDER_ID_DESC',
  RefundsDistinctCountRowIdAsc = 'REFUNDS_DISTINCT_COUNT_ROW_ID_ASC',
  RefundsDistinctCountRowIdDesc = 'REFUNDS_DISTINCT_COUNT_ROW_ID_DESC',
  RefundsDistinctCountUserIdAsc = 'REFUNDS_DISTINCT_COUNT_USER_ID_ASC',
  RefundsDistinctCountUserIdDesc = 'REFUNDS_DISTINCT_COUNT_USER_ID_DESC',
  RefundsMaxPurchaseOrderIdAsc = 'REFUNDS_MAX_PURCHASE_ORDER_ID_ASC',
  RefundsMaxPurchaseOrderIdDesc = 'REFUNDS_MAX_PURCHASE_ORDER_ID_DESC',
  RefundsMaxRowIdAsc = 'REFUNDS_MAX_ROW_ID_ASC',
  RefundsMaxRowIdDesc = 'REFUNDS_MAX_ROW_ID_DESC',
  RefundsMaxUserIdAsc = 'REFUNDS_MAX_USER_ID_ASC',
  RefundsMaxUserIdDesc = 'REFUNDS_MAX_USER_ID_DESC',
  RefundsMinPurchaseOrderIdAsc = 'REFUNDS_MIN_PURCHASE_ORDER_ID_ASC',
  RefundsMinPurchaseOrderIdDesc = 'REFUNDS_MIN_PURCHASE_ORDER_ID_DESC',
  RefundsMinRowIdAsc = 'REFUNDS_MIN_ROW_ID_ASC',
  RefundsMinRowIdDesc = 'REFUNDS_MIN_ROW_ID_DESC',
  RefundsMinUserIdAsc = 'REFUNDS_MIN_USER_ID_ASC',
  RefundsMinUserIdDesc = 'REFUNDS_MIN_USER_ID_DESC',
  RefundsStddevPopulationPurchaseOrderIdAsc = 'REFUNDS_STDDEV_POPULATION_PURCHASE_ORDER_ID_ASC',
  RefundsStddevPopulationPurchaseOrderIdDesc = 'REFUNDS_STDDEV_POPULATION_PURCHASE_ORDER_ID_DESC',
  RefundsStddevPopulationRowIdAsc = 'REFUNDS_STDDEV_POPULATION_ROW_ID_ASC',
  RefundsStddevPopulationRowIdDesc = 'REFUNDS_STDDEV_POPULATION_ROW_ID_DESC',
  RefundsStddevPopulationUserIdAsc = 'REFUNDS_STDDEV_POPULATION_USER_ID_ASC',
  RefundsStddevPopulationUserIdDesc = 'REFUNDS_STDDEV_POPULATION_USER_ID_DESC',
  RefundsStddevSamplePurchaseOrderIdAsc = 'REFUNDS_STDDEV_SAMPLE_PURCHASE_ORDER_ID_ASC',
  RefundsStddevSamplePurchaseOrderIdDesc = 'REFUNDS_STDDEV_SAMPLE_PURCHASE_ORDER_ID_DESC',
  RefundsStddevSampleRowIdAsc = 'REFUNDS_STDDEV_SAMPLE_ROW_ID_ASC',
  RefundsStddevSampleRowIdDesc = 'REFUNDS_STDDEV_SAMPLE_ROW_ID_DESC',
  RefundsStddevSampleUserIdAsc = 'REFUNDS_STDDEV_SAMPLE_USER_ID_ASC',
  RefundsStddevSampleUserIdDesc = 'REFUNDS_STDDEV_SAMPLE_USER_ID_DESC',
  RefundsSumPurchaseOrderIdAsc = 'REFUNDS_SUM_PURCHASE_ORDER_ID_ASC',
  RefundsSumPurchaseOrderIdDesc = 'REFUNDS_SUM_PURCHASE_ORDER_ID_DESC',
  RefundsSumRowIdAsc = 'REFUNDS_SUM_ROW_ID_ASC',
  RefundsSumRowIdDesc = 'REFUNDS_SUM_ROW_ID_DESC',
  RefundsSumUserIdAsc = 'REFUNDS_SUM_USER_ID_ASC',
  RefundsSumUserIdDesc = 'REFUNDS_SUM_USER_ID_DESC',
  RefundsVariancePopulationPurchaseOrderIdAsc = 'REFUNDS_VARIANCE_POPULATION_PURCHASE_ORDER_ID_ASC',
  RefundsVariancePopulationPurchaseOrderIdDesc = 'REFUNDS_VARIANCE_POPULATION_PURCHASE_ORDER_ID_DESC',
  RefundsVariancePopulationRowIdAsc = 'REFUNDS_VARIANCE_POPULATION_ROW_ID_ASC',
  RefundsVariancePopulationRowIdDesc = 'REFUNDS_VARIANCE_POPULATION_ROW_ID_DESC',
  RefundsVariancePopulationUserIdAsc = 'REFUNDS_VARIANCE_POPULATION_USER_ID_ASC',
  RefundsVariancePopulationUserIdDesc = 'REFUNDS_VARIANCE_POPULATION_USER_ID_DESC',
  RefundsVarianceSamplePurchaseOrderIdAsc = 'REFUNDS_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_ASC',
  RefundsVarianceSamplePurchaseOrderIdDesc = 'REFUNDS_VARIANCE_SAMPLE_PURCHASE_ORDER_ID_DESC',
  RefundsVarianceSampleRowIdAsc = 'REFUNDS_VARIANCE_SAMPLE_ROW_ID_ASC',
  RefundsVarianceSampleRowIdDesc = 'REFUNDS_VARIANCE_SAMPLE_ROW_ID_DESC',
  RefundsVarianceSampleUserIdAsc = 'REFUNDS_VARIANCE_SAMPLE_USER_ID_ASC',
  RefundsVarianceSampleUserIdDesc = 'REFUNDS_VARIANCE_SAMPLE_USER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  /** Optimized with index */
  TotalAsc = 'TOTAL_ASC',
  /** Optimized with index */
  TotalDesc = 'TOTAL_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  /** Optimized with index */
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  /** Optimized with index */
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  /** Optimized with index */
  UserIdAsc = 'USER_ID_ASC',
  /** Optimized with index */
  UserIdDesc = 'USER_ID_DESC'
}

/**
 * A V2 purchase order exactly as the trader's Billing page and the admin Transactions tab
 * receive it from normalizedPurchasesByUser, so its receipt PDF matches theirs.
 */
export type PurchaseOrderReceipt = {
  __typename?: 'PurchaseOrderReceipt';
  accountId?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['BigFloat']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingRegion?: Maybe<Scalars['String']['output']>;
  billingStreet?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  discount?: Maybe<Scalars['BigFloat']['output']>;
  fulfillmentStatus?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  gatewayTransactionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceTemplate?: Maybe<Scalars['String']['output']>;
  localCurrency?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['Int']['output']>;
  platformName?: Maybe<Scalars['String']['output']>;
  processor?: Maybe<Scalars['String']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  shippingRegion?: Maybe<Scalars['String']['output']>;
  shippingStreet?: Maybe<Scalars['String']['output']>;
  shippingZip?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseOrderStddevPopulationAggregates = {
  __typename?: 'PurchaseOrderStddevPopulationAggregates';
  /** Population standard deviation of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseOrderStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseOrderStddevSampleAggregates = {
  __typename?: 'PurchaseOrderStddevSampleAggregates';
  /** Sample standard deviation of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseOrderSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type PurchaseOrderSumAggregates = {
  __typename?: 'PurchaseOrderSumAggregates';
  /** Sum of discount across the matching connection */
  discount: Scalars['BigFloat']['output'];
  /** Sum of gatewayId across the matching connection */
  gatewayId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subtotal across the matching connection */
  subtotal: Scalars['BigFloat']['output'];
  /** Sum of tax across the matching connection */
  tax: Scalars['BigFloat']['output'];
  /** Sum of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency: Scalars['BigFloat']['output'];
  /** Sum of total across the matching connection */
  total: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Chargeback` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseOrderToManyChargebackFilter = {
  /** Aggregates across related `Chargeback` match the filter criteria. */
  aggregates?: InputMaybe<ChargebackAggregatesFilter>;
  /** Every related `Chargeback` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ChargebackFilter>;
  /** No related `Chargeback` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ChargebackFilter>;
  /** Some related `Chargeback` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ChargebackFilter>;
};

/** A filter to be used against many `ChargebackIndicator` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseOrderToManyChargebackIndicatorFilter = {
  /** Aggregates across related `ChargebackIndicator` match the filter criteria. */
  aggregates?: InputMaybe<ChargebackIndicatorAggregatesFilter>;
  /** Every related `ChargebackIndicator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ChargebackIndicatorFilter>;
  /** No related `ChargebackIndicator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ChargebackIndicatorFilter>;
  /** Some related `ChargebackIndicator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ChargebackIndicatorFilter>;
};

/** A filter to be used against many `PurchaseItem` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseOrderToManyPurchaseItemFilter = {
  /** Aggregates across related `PurchaseItem` match the filter criteria. */
  aggregates?: InputMaybe<PurchaseItemAggregatesFilter>;
  /** Every related `PurchaseItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PurchaseItemFilter>;
  /** No related `PurchaseItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PurchaseItemFilter>;
  /** Some related `PurchaseItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PurchaseItemFilter>;
};

/** A filter to be used against many `Refund` object types. All fields are combined with a logical ‘and.’ */
export type PurchaseOrderToManyRefundFilter = {
  /** Aggregates across related `Refund` match the filter criteria. */
  aggregates?: InputMaybe<RefundAggregatesFilter>;
  /** Every related `Refund` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RefundFilter>;
  /** No related `Refund` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RefundFilter>;
  /** Some related `Refund` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RefundFilter>;
};

export type PurchaseOrderVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseOrderVariancePopulationAggregates = {
  __typename?: 'PurchaseOrderVariancePopulationAggregates';
  /** Population variance of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseOrderVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  total?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type PurchaseOrderVarianceSampleAggregates = {
  __typename?: 'PurchaseOrderVarianceSampleAggregates';
  /** Sample variance of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of gatewayId across the matching connection */
  gatewayId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subtotal across the matching connection */
  subtotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseStddevPopulationAggregates = {
  __typename?: 'PurchaseStddevPopulationAggregates';
  /** Population standard deviation of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of platform across the matching connection */
  platform?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseStddevSampleAggregates = {
  __typename?: 'PurchaseStddevSampleAggregates';
  /** Sample standard deviation of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of platform across the matching connection */
  platform?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseSumAggregates = {
  __typename?: 'PurchaseSumAggregates';
  /** Sum of accountTemplate across the matching connection */
  accountTemplate: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of couponId across the matching connection */
  couponId: Scalars['BigInt']['output'];
  /** Sum of discount across the matching connection */
  discount: Scalars['BigFloat']['output'];
  /** Sum of gateway across the matching connection */
  gateway: Scalars['BigInt']['output'];
  /** Sum of netSuiteItemId across the matching connection */
  netSuiteItemId: Scalars['BigInt']['output'];
  /** Sum of originalProductPrice across the matching connection */
  originalProductPrice: Scalars['BigFloat']['output'];
  /** Sum of platform across the matching connection */
  platform: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of tax across the matching connection */
  tax: Scalars['BigFloat']['output'];
  /** Sum of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency: Scalars['BigFloat']['output'];
  /** Sum of taxRate across the matching connection */
  taxRate: Scalars['BigFloat']['output'];
  /** Sum of total across the matching connection */
  total: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type PurchaseVariancePopulationAggregates = {
  __typename?: 'PurchaseVariancePopulationAggregates';
  /** Population variance of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of platform across the matching connection */
  platform?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PurchaseVarianceSampleAggregates = {
  __typename?: 'PurchaseVarianceSampleAggregates';
  /** Sample variance of accountTemplate across the matching connection */
  accountTemplate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of discount across the matching connection */
  discount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of netSuiteItemId across the matching connection */
  netSuiteItemId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of platform across the matching connection */
  platform?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of taxDisplayedInLocalCurrency across the matching connection */
  taxDisplayedInLocalCurrency?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of taxRate across the matching connection */
  taxRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Get a single `Account`. */
  account?: Maybe<Account>;
  /** Reads and enables pagination through a set of `AccountCapitalEntry`. */
  accountCapitalEntries?: Maybe<AccountCapitalEntryConnection>;
  /** Get a single `AccountCapitalEntry`. */
  accountCapitalEntry?: Maybe<AccountCapitalEntry>;
  /** Reads and enables pagination through a set of `AccountTemplate`. */
  accountTemplates?: Maybe<AccountTemplateConnection>;
  /** Reads and enables pagination through a set of `AccountTradeStatByDay`. */
  accountTradeStatByDays?: Maybe<AccountTradeStatByDayConnection>;
  /** Reads and enables pagination through a set of `Account`. */
  accounts?: Maybe<AccountConnection>;
  /** Reads and enables pagination through a set of `AdminAudit`. */
  adminAudits?: Maybe<AdminAuditConnection>;
  /** Get a single `AdminConfig`. */
  adminConfigByConfigKey?: Maybe<AdminConfig>;
  /** Get a single `AdminRole`. */
  adminRole?: Maybe<AdminRole>;
  /** Reads and enables pagination through a set of `AdminRole`. */
  adminRoles?: Maybe<AdminRoleConnection>;
  /**
   * Whether the trader has been designated an affiliate, for the label on their admin
   * profile. Null when they never were. Status only: codes, commission and payouts
   * stay behind read:affiliates.
   */
  affiliateStatusByUser?: Maybe<TraderAffiliateStatus>;
  /** Reads and enables pagination through a set of `AggregateAccountTradeStatByDayRecord`. */
  aggregateAccountTradeStatByDay?: Maybe<AggregateAccountTradeStatByDayConnection>;
  /** Get a single `CardTransaction`. */
  cardTransaction?: Maybe<CardTransaction>;
  /** Get a single `CardTransaction`. */
  cardTransactionByNuveiPaymentId?: Maybe<CardTransaction>;
  /** Get a single `CardTransaction`. */
  cardTransactionByStripePaymentId?: Maybe<CardTransaction>;
  /** Reads and enables pagination through a set of `CardTransaction`. */
  cardTransactions?: Maybe<CardTransactionConnection>;
  /**
   * List admin users eligible to be assigned a case investigation
   * (those whose roles grant update:caseInvestigations). Admin only.
   */
  caseAssignableUsers: Array<CaseAssignableUser>;
  /** Get a single `CaseBan`. */
  caseBan?: Maybe<CaseBan>;
  /** Reads and enables pagination through a set of `CaseBan`. */
  caseBans?: Maybe<CaseBanConnection>;
  caseDepartments: Array<CaseDepartment>;
  /** Get a single `CaseInvestigation`. */
  caseInvestigation?: Maybe<CaseInvestigation>;
  /** Reads and enables pagination through a set of `CaseInvestigationSubmittedDepartment`. */
  caseInvestigationSubmittedDepartments?: Maybe<CaseInvestigationSubmittedDepartmentConnection>;
  /** Reads and enables pagination through a set of `CaseInvestigation`. */
  caseInvestigations?: Maybe<CaseInvestigationConnection>;
  /** Reads and enables pagination through a set of `CaseLabel`. */
  caseLabels?: Maybe<CaseLabelConnection>;
  /** Reads and enables pagination through a set of `CaseType`. */
  caseTypes?: Maybe<CaseTypeConnection>;
  /**
   * Per-trader aggregate of current chargebacks and their net dollar total.
   * Admin only.
   */
  chargebackTotalsByUser: ChargebackTotals;
  /**
   * Current chargeback flags for the given transactions (linked PurchaseOrder
   * ids). Drives the per-row chargeback indicator on the transactions and
   * purchases tables. Returns only transactions that have a chargeback. Admin only.
   */
  chargebacksByPurchaseOrderIds: Array<ChargebackFlag>;
  /** Reads and enables pagination through a set of `CheckoutSession`. */
  checkoutSessions?: Maybe<CheckoutSessionConnection>;
  /** Get a single `Coupon`. */
  coupon?: Maybe<Coupon>;
  /** Reads and enables pagination through a set of `Coupon`. */
  coupons?: Maybe<CouponConnection>;
  currentAdminRoles: Array<CurrentAdminRole>;
  /**
   * Returns the Discord OAuth2 authorize URL for linking the current user's Discord account.
   *
   * Redirect the user to the returned url; after they authorize, Discord redirects to the
   * API callback which updates User.discordId and redirects back to the app.
   *
   * Pass `returnTo` (e.g. "trader-profile") to control which profile tab the callback
   * returns the user to after linking. Omitted/unrecognized values default to "settings".
   */
  discordLinkUrl: DiscordLinkUrlPayload;
  /**
   * Check the real-time status of a DocuSign envelope.
   * Queries the DocuSign API directly for current envelope state.
   * Requires authentication.
   */
  docusignEnvelopeStatus: DocuSignEnvelopeStatusResult;
  /**
   * Download a signed tax form document.
   * Returns the PDF as a Base64 encoded string.
   * Requires authentication.
   */
  downloadTaxFormDocument: TaxFormDocumentResult;
  /** Reads and enables pagination through a set of `EmailAction`. */
  emailActions?: Maybe<EmailActionConnection>;
  /** Reads and enables pagination through a set of `Email`. */
  emails?: Maybe<EmailConnection>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupConnection>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  id: Scalars['ID']['output'];
  /** Get a single `ImpactGroupAssignment`. */
  impactGroupAssignment?: Maybe<ImpactGroupAssignment>;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignments?: Maybe<ImpactGroupAssignmentConnection>;
  /** Get a single `ImpactGroupTemplate`. */
  impactGroupTemplate?: Maybe<ImpactGroupTemplate>;
  /** Reads a single `ImpactGroupTemplate` using its globally unique `ID`. */
  impactGroupTemplateById?: Maybe<ImpactGroupTemplate>;
  /** Get a single `ImpactGroupTemplate`. */
  impactGroupTemplateBySlug?: Maybe<ImpactGroupTemplate>;
  /** Reads and enables pagination through a set of `ImpactGroupTemplate`. */
  impactGroupTemplates?: Maybe<ImpactGroupTemplateConnection>;
  /** Reads a single `KycPriorityLabel` using its globally unique `ID`. */
  kycPriorityLabelById?: Maybe<KycPriorityLabel>;
  /** Reads and enables pagination through a set of `KycPriorityLabel`. */
  kycPriorityLabels?: Maybe<KycPriorityLabelConnection>;
  /** Reads a single `KycPriorityReviewConfig` using its globally unique `ID`. */
  kycPriorityReviewConfigById?: Maybe<KycPriorityReviewConfig>;
  /** Reads and enables pagination through a set of `KycPriorityReviewConfig`. */
  kycPriorityReviewConfigs?: Maybe<KycPriorityReviewConfigConnection>;
  latestPersonaInquiryEvent?: Maybe<PersonaInquiryEvent>;
  latestPersonaTransactionEvent?: Maybe<PersonaTransactionEvent>;
  lfaSplashStatus?: Maybe<LfaSplashStatus>;
  /**
   * Returns the trader's top-six PoP card selection narrowed to entries
   * that do not yet have a backing PayoutRequestAsset — the "what's left to
   * generate" diff.
   *
   * Selection rule:
   * - Combines individual payouts and rollup groups into one pool with no
   *   deduplication (matches the public-side aggregator behavior).
   * - Sorts by value descending; ties favor rollups, then most recent
   *   `financeApprovedAt`.
   * - Slices to the top six, then filters out entries that already have an
   *   asset.
   *
   * The returned `payouts` and `rollupGroups` lists are ready to be fed
   * directly into the popcard generation mutation.
   *
   * Returns an empty diff when the user is unauthenticated.
   */
  myMissingPopcards: MyMissingPopcards;
  /**
   * Returns Proof-of-Payout card candidates for the current user.
   *
   * The response combines two pools — individual paid payouts and
   * rollup-eligible groups — and includes the UUID of any
   * PayoutRequestAsset row that already exists for each candidate so the
   * client can dedupe before invoking the generation mutation.
   *
   * Returns empty arrays when the user is unauthenticated.
   */
  myPopcardCandidates: MyPopcardCandidates;
  myTraderProfileAssets: Array<MyTraderProfileAsset>;
  myTraderPublicProfile?: Maybe<MyTraderPublicProfile>;
  /** Reads and enables pagination through a set of `NmiSubscription`. */
  nmiSubscriptions?: Maybe<NmiSubscriptionConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** Reads and enables pagination through a set of `NormalizedPurchasesByUserRecord`. */
  normalizedPurchasesByUser?: Maybe<NormalizedPurchasesByUserConnection>;
  normalizedPurchasesByUserTotalCount?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `NormalizedSavedCardsByUserRecord`. */
  normalizedSavedCardsByUser?: Maybe<NormalizedSavedCardsByUserConnection>;
  normalizedSavedCardsByUserTotalCount?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `NormalizedSubsByUserRecord`. */
  normalizedSubsByUser?: Maybe<NormalizedSubsByUserConnection>;
  normalizedSubsByUserTotalCount?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `NormalizedSubsDetailedByUserRecord`. */
  normalizedSubsDetailedByUser?: Maybe<NormalizedSubsDetailedByUserConnection>;
  /** Reads and enables pagination through a set of `OfacsdnRecord`. */
  ofacsdnRecords?: Maybe<OfacsdnRecordConnection>;
  payoutActivity: Array<PayoutActivityEvent>;
  /** Get a single `PayoutRequest`. */
  payoutRequest?: Maybe<PayoutRequest>;
  /** Get a single `PayoutRequestBatch`. */
  payoutRequestBatch?: Maybe<PayoutRequestBatch>;
  /** Reads and enables pagination through a set of `PayoutRequestBatch`. */
  payoutRequestBatches?: Maybe<PayoutRequestBatchConnection>;
  /** Reads and enables pagination through a set of `PayoutRequest`. */
  payoutRequests?: Maybe<PayoutRequestConnection>;
  /** Reads and enables pagination through a set of `PayoutRequestsStatsRecord`. */
  payoutRequestsStats?: Maybe<PayoutRequestsStatsConnection>;
  /** Reads and enables pagination through a set of `PayoutReturnReasonCode`. */
  payoutReturnReasonCodes?: Maybe<PayoutReturnReasonCodeConnection>;
  /** Reads and enables pagination through a set of `PayoutReviewer`. */
  payoutReviewers?: Maybe<PayoutReviewerConnection>;
  /** Reads and enables pagination through a set of `PayoutReview`. */
  payoutReviews?: Maybe<PayoutReviewConnection>;
  /**
   * Returns yesterday's eligible payout records (America/Chicago) grouped by
   * type for the current user. Returns empty arrays when no eligible records
   * exist or the user is unauthenticated.
   */
  payoutRollup: PayoutRollupResult;
  /** Reads and enables pagination through a set of `PersonaWebhookEvent`. */
  personaWebhookEvents?: Maybe<PersonaWebhookEventConnection>;
  /** Reads and enables pagination through a set of `ProductCategory`. */
  productCategories?: Maybe<ProductCategoryConnection>;
  /** Get a single `ProductCategory`. */
  productCategory?: Maybe<ProductCategory>;
  /** Get a single `ProductCategory`. */
  productCategoryByHandle?: Maybe<ProductCategory>;
  /** Get a single `PurchaseOrder`. */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /**
   * The trader-copy receipt row for one V2 purchase order. Null when the order does not
   * exist. Admin only.
   */
  purchaseOrderReceipt?: Maybe<PurchaseOrderReceipt>;
  /** Reads and enables pagination through a set of `PurchaseOrder`. */
  purchaseOrders?: Maybe<PurchaseOrderConnection>;
  /** Reads and enables pagination through a set of `Purchase`. */
  purchases?: Maybe<PurchaseConnection>;
  /** Reads and enables pagination through a set of `ReasonCode`. */
  reasonCodes?: Maybe<ReasonCodeConnection>;
  /** Reads and enables pagination through a set of `RebillSession`. */
  rebillSessions?: Maybe<RebillSessionConnection>;
  /** Reads and enables pagination through a set of `ResetCredit`. */
  resetCredits?: Maybe<ResetCreditConnection>;
  /** Reads and enables pagination through a set of `RiskyProduct`. */
  riskyProducts?: Maybe<RiskyProductConnection>;
  /** Reads and enables pagination through a set of `SavedCard`. */
  savedCards?: Maybe<SavedCardConnection>;
  /**
   * Test DocuSign authentication.
   * Returns success: true if authentication works.
   */
  testDocuSignAuth: DocuSignAuthResult;
  /**
   * Check if the configured YouTube channel is currently live streaming.
   * Results are cached for 5 minutes. Backend schedule gating helps manage quota.
   * Returns offline status when outside scheduled streaming hours.
   */
  topstepTVYoutube: LiveStreamStatus;
  traderNowTradingPreview?: Maybe<MyTraderPublicProfileNowTrading>;
  /**
   * Coarse open-case membership for the given traders: whether each is in an open
   * investigation or ban case, which case, and when they were added. Returns no case
   * contents, so it is readable by any admin rather than by case-read holders only.
   */
  traderOpenCases: Array<TraderOpenCase>;
  traderPayoutNotes: Array<TraderPayoutNote>;
  /** Reads and enables pagination through a set of `TraderPublicProfile`. */
  traderPublicProfiles?: Maybe<TraderPublicProfileConnection>;
  /** Get a single `TraderRiskIndicator`. */
  traderRiskIndicator?: Maybe<TraderRiskIndicator>;
  /** Reads and enables pagination through a set of `TraderRiskIndicator`. */
  traderRiskIndicators?: Maybe<TraderRiskIndicatorConnection>;
  /** Get a single `TradingProductFee`. */
  tradingProductFee?: Maybe<TradingProductFee>;
  /** Reads and enables pagination through a set of `TradingProductFee`. */
  tradingProductFees?: Maybe<TradingProductFeeConnection>;
  /** Get a single `User`. */
  user?: Maybe<User>;
  /** Get a single `UserAddress`. */
  userAddress?: Maybe<UserAddress>;
  /** Reads and enables pagination through a set of `UserAddress`. */
  userAddresses?: Maybe<UserAddressConnection>;
  /** Reads and enables pagination through a set of `UserCertificate`. */
  userCertificates?: Maybe<UserCertificateConnection>;
  /** Reads and enables pagination through a set of `UserContactInfo`. */
  userContactInfos?: Maybe<UserContactInfoConnection>;
  /** Reads and enables pagination through a set of `UserNote`. */
  userNotes?: Maybe<UserNoteConnection>;
  /** Reads and enables pagination through a set of `UserSubscription`. */
  userSubscriptions?: Maybe<UserSubscriptionConnection>;
  /** Reads and enables pagination through a set of `UserTaxForm`. */
  userTaxForms?: Maybe<UserTaxFormConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UserConnection>;
  /** Reads and enables pagination through a set of `Verification`. */
  verifications?: Maybe<VerificationConnection>;
  /** Reads and enables pagination through a set of `XfaActivationCredit`. */
  xfaActivationCredits?: Maybe<XfaActivationCreditConnection>;
  /** Get a single `XfaResetTracking`. */
  xfaResetTracking?: Maybe<XfaResetTracking>;
  /** Reads and enables pagination through a set of `XfaResetTracking`. */
  xfaResetTrackings?: Maybe<XfaResetTrackingConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountCapitalEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCapitalEntryCondition>;
  filter?: InputMaybe<AccountCapitalEntryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCapitalEntryOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountCapitalEntryArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountTemplateCondition>;
  filter?: InputMaybe<AccountTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTemplateOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountTradeStatByDaysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountTradeStatByDayCondition>;
  filter?: InputMaybe<AccountTradeStatByDayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTradeStatByDayOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AdminAuditCondition>;
  filter?: InputMaybe<AdminAuditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdminAuditOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminConfigByConfigKeyArgs = {
  configKey: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminRoleArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AdminRoleCondition>;
  filter?: InputMaybe<AdminRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdminRoleOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAffiliateStatusByUserArgs = {
  userId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAggregateAccountTradeStatByDayArgs = {
  accountIdFilter?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  contractNameFilter?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AggregateAccountTradeStatByDayRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTransactionArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTransactionByNuveiPaymentIdArgs = {
  nuveiPaymentId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTransactionByStripePaymentIdArgs = {
  stripePaymentId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTransactionCondition>;
  filter?: InputMaybe<CardTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTransactionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseBanArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseBansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseBanCondition>;
  filter?: InputMaybe<CaseBanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseBanOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseInvestigationArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseInvestigationSubmittedDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseInvestigationSubmittedDepartmentCondition>;
  filter?: InputMaybe<CaseInvestigationSubmittedDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseInvestigationSubmittedDepartmentOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseInvestigationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseInvestigationCondition>;
  filter?: InputMaybe<CaseInvestigationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseInvestigationOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseLabelCondition>;
  filter?: InputMaybe<CaseLabelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseLabelOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseTypeCondition>;
  filter?: InputMaybe<CaseTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseTypeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChargebackTotalsByUserArgs = {
  userId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChargebacksByPurchaseOrderIdsArgs = {
  purchaseOrderIds: Array<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckoutSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckoutSessionCondition>;
  filter?: InputMaybe<CheckoutSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckoutSessionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCouponArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCouponsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CouponCondition>;
  filter?: InputMaybe<CouponFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CouponOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDiscordLinkUrlArgs = {
  returnTo?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeStatusArgs = {
  envelopeId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDownloadTaxFormDocumentArgs = {
  envelopeId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailActionCondition>;
  filter?: InputMaybe<EmailActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailActionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailCondition>;
  filter?: InputMaybe<EmailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryImpactGroupAssignmentArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryImpactGroupAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryImpactGroupTemplateArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryImpactGroupTemplateByIdArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryImpactGroupTemplateBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryImpactGroupTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImpactGroupTemplateCondition>;
  filter?: InputMaybe<ImpactGroupTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupTemplateOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryKycPriorityLabelByIdArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryKycPriorityLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<KycPriorityLabelCondition>;
  filter?: InputMaybe<KycPriorityLabelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KycPriorityLabelOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryKycPriorityReviewConfigByIdArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryKycPriorityReviewConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<KycPriorityReviewConfigCondition>;
  filter?: InputMaybe<KycPriorityReviewConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KycPriorityReviewConfigOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestPersonaInquiryEventArgs = {
  userId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestPersonaTransactionEventArgs = {
  userId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLfaSplashStatusArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTraderProfileAssetsArgs = {
  kind: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNmiSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NmiSubscriptionCondition>;
  filter?: InputMaybe<NmiSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NmiSubscriptionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedPurchasesByUserArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NormalizedPurchasesByUserRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedPurchasesByUserTotalCountArgs = {
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedSavedCardsByUserArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NormalizedSavedCardsByUserRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedSavedCardsByUserTotalCountArgs = {
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedSubsByUserArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NormalizedSubsByUserRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedSubsByUserTotalCountArgs = {
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizedSubsDetailedByUserArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NormalizedSubsDetailedByUserRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userid?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOfacsdnRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OfacsdnRecordCondition>;
  filter?: InputMaybe<OfacsdnRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfacsdnRecordOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutActivityArgs = {
  payoutRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutRequestArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutRequestBatchArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutRequestBatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestBatchCondition>;
  filter?: InputMaybe<PayoutRequestBatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestBatchOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestCondition>;
  filter?: InputMaybe<PayoutRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutRequestsStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PayoutRequestsStatsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutReturnReasonCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutReturnReasonCodeCondition>;
  filter?: InputMaybe<PayoutReturnReasonCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutReturnReasonCodeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutReviewersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutReviewerCondition>;
  filter?: InputMaybe<PayoutReviewerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutReviewerOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPayoutReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutReviewCondition>;
  filter?: InputMaybe<PayoutReviewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutReviewOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonaWebhookEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PersonaWebhookEventCondition>;
  filter?: InputMaybe<PersonaWebhookEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaWebhookEventOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProductCategoryCondition>;
  filter?: InputMaybe<ProductCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProductCategoryArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProductCategoryByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPurchaseOrderArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPurchaseOrderReceiptArgs = {
  purchaseOrderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPurchaseOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PurchaseOrderCondition>;
  filter?: InputMaybe<PurchaseOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PurchaseOrderOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPurchasesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PurchaseCondition>;
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PurchaseOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReasonCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReasonCodeCondition>;
  filter?: InputMaybe<ReasonCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReasonCodeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRebillSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RebillSessionCondition>;
  filter?: InputMaybe<RebillSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RebillSessionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResetCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ResetCreditCondition>;
  filter?: InputMaybe<ResetCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ResetCreditOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRiskyProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RiskyProductCondition>;
  filter?: InputMaybe<RiskyProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskyProductOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SavedCardCondition>;
  filter?: InputMaybe<SavedCardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavedCardOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTraderNowTradingPreviewArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraderOpenCasesArgs = {
  traderIds: Array<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTraderPayoutNotesArgs = {
  traderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraderPublicProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderPublicProfileCondition>;
  filter?: InputMaybe<TraderPublicProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderPublicProfileOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTraderRiskIndicatorArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraderRiskIndicatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderRiskIndicatorCondition>;
  filter?: InputMaybe<TraderRiskIndicatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderRiskIndicatorOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingProductFeeArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingProductFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingProductFeeCondition>;
  filter?: InputMaybe<TradingProductFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingProductFeeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserAddressArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserAddressCondition>;
  filter?: InputMaybe<UserAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserAddressOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCertificatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCertificateCondition>;
  filter?: InputMaybe<UserCertificateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserCertificateOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContactInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContactInfoCondition>;
  filter?: InputMaybe<UserContactInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContactInfoOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserNoteCondition>;
  filter?: InputMaybe<UserNoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNoteOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserSubscriptionCondition>;
  filter?: InputMaybe<UserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSubscriptionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserTaxFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserTaxFormCondition>;
  filter?: InputMaybe<UserTaxFormFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTaxFormOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVerificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VerificationCondition>;
  filter?: InputMaybe<VerificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryXfaActivationCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<XfaActivationCreditCondition>;
  filter?: InputMaybe<XfaActivationCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<XfaActivationCreditOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryXfaResetTrackingArgs = {
  rowId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXfaResetTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<XfaResetTrackingCondition>;
  filter?: InputMaybe<XfaResetTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<XfaResetTrackingOrderBy>>;
};

export type ReasonCode = Node & {
  __typename?: 'ReasonCode';
  active: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `CaseBanReasonCode`. */
  caseBanReasonCodes: CaseBanReasonCodeConnection;
  /** Reads and enables pagination through a set of `CaseInvestigationTrader`. */
  caseInvestigationTraders: CaseInvestigationTraderConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


export type ReasonCodeCaseBanReasonCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseBanReasonCodeCondition>;
  filter?: InputMaybe<CaseBanReasonCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseBanReasonCodeOrderBy>>;
};


export type ReasonCodeCaseInvestigationTradersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaseInvestigationTraderCondition>;
  filter?: InputMaybe<CaseInvestigationTraderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaseInvestigationTraderOrderBy>>;
};

export type ReasonCodeAggregates = {
  __typename?: 'ReasonCodeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ReasonCodeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ReasonCodeDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ReasonCodeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ReasonCodeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ReasonCodeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ReasonCodeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ReasonCodeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ReasonCodeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ReasonCodeVarianceSampleAggregates>;
};

export type ReasonCodeAverageAggregates = {
  __typename?: 'ReasonCodeAverageAggregates';
  /** Mean average of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ReasonCode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ReasonCodeCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ReasonCode` values. */
export type ReasonCodeConnection = {
  __typename?: 'ReasonCodeConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ReasonCodeAggregates>;
  /** A list of edges which contains the `ReasonCode` and cursor to aid in pagination. */
  edges: Array<Maybe<ReasonCodeEdge>>;
  /** A list of `ReasonCode` objects. */
  nodes: Array<Maybe<ReasonCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReasonCode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ReasonCodeDistinctCountAggregates = {
  __typename?: 'ReasonCodeDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of code across the matching connection */
  code?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ReasonCode` edge in the connection. */
export type ReasonCodeEdge = {
  __typename?: 'ReasonCodeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ReasonCode` at the end of the edge. */
  node?: Maybe<ReasonCode>;
};

/** A filter to be used against `ReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type ReasonCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReasonCodeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReasonCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReasonCodeFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type ReasonCodeMaxAggregates = {
  __typename?: 'ReasonCodeMaxAggregates';
  /** Maximum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ReasonCodeMinAggregates = {
  __typename?: 'ReasonCodeMinAggregates';
  /** Minimum of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ReasonCode`. */
export enum ReasonCodeOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type ReasonCodeStddevPopulationAggregates = {
  __typename?: 'ReasonCodeStddevPopulationAggregates';
  /** Population standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ReasonCodeStddevSampleAggregates = {
  __typename?: 'ReasonCodeStddevSampleAggregates';
  /** Sample standard deviation of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ReasonCodeSumAggregates = {
  __typename?: 'ReasonCodeSumAggregates';
  /** Sum of createdBy across the matching connection */
  createdBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of updatedBy across the matching connection */
  updatedBy: Scalars['BigInt']['output'];
};

export type ReasonCodeVariancePopulationAggregates = {
  __typename?: 'ReasonCodeVariancePopulationAggregates';
  /** Population variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type ReasonCodeVarianceSampleAggregates = {
  __typename?: 'ReasonCodeVarianceSampleAggregates';
  /** Sample variance of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of updatedBy across the matching connection */
  updatedBy?: Maybe<Scalars['BigFloat']['output']>;
};

export type RebillSession = Node & {
  __typename?: 'RebillSession';
  attemptCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  eventLog: Scalars['JSON']['output'];
  externalSubscriptionReference?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  maxRetries: Scalars['Int']['output'];
  /** Reads a single `PurchaseOrder` that is related to this `RebillSession`. */
  purchase?: Maybe<PurchaseOrder>;
  purchaseId?: Maybe<Scalars['Int']['output']>;
  rebillManager: RebillSessionRebillManagerEnum;
  rowId: Scalars['Int']['output'];
  status: RebillSessionStatusEnum;
  /** Reads a single `NmiSubscription` that is related to this `RebillSession`. */
  subscription?: Maybe<NmiSubscription>;
  subscriptionId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `RebillSession`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type RebillSessionAggregates = {
  __typename?: 'RebillSessionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RebillSessionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RebillSessionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RebillSessionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RebillSessionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RebillSessionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RebillSessionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RebillSessionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RebillSessionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RebillSessionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `RebillSession` object types. */
export type RebillSessionAggregatesFilter = {
  /** Mean average aggregate over matching `RebillSession` objects. */
  average?: InputMaybe<RebillSessionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `RebillSession` objects. */
  distinctCount?: InputMaybe<RebillSessionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `RebillSession` object to be included within the aggregate. */
  filter?: InputMaybe<RebillSessionFilter>;
  /** Maximum aggregate over matching `RebillSession` objects. */
  max?: InputMaybe<RebillSessionMaxAggregateFilter>;
  /** Minimum aggregate over matching `RebillSession` objects. */
  min?: InputMaybe<RebillSessionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `RebillSession` objects. */
  stddevPopulation?: InputMaybe<RebillSessionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `RebillSession` objects. */
  stddevSample?: InputMaybe<RebillSessionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `RebillSession` objects. */
  sum?: InputMaybe<RebillSessionSumAggregateFilter>;
  /** Population variance aggregate over matching `RebillSession` objects. */
  variancePopulation?: InputMaybe<RebillSessionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `RebillSession` objects. */
  varianceSample?: InputMaybe<RebillSessionVarianceSampleAggregateFilter>;
};

export type RebillSessionAverageAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RebillSessionAverageAggregates = {
  __typename?: 'RebillSessionAverageAggregates';
  /** Mean average of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `RebillSession` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RebillSessionCondition = {
  /** Checks for equality with the object’s `externalSubscriptionReference` field. */
  externalSubscriptionReference?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `purchaseId` field. */
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rebillManager` field. */
  rebillManager?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<RebillSessionStatusEnum>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `RebillSession` values. */
export type RebillSessionConnection = {
  __typename?: 'RebillSessionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RebillSessionAggregates>;
  /** A list of edges which contains the `RebillSession` and cursor to aid in pagination. */
  edges: Array<Maybe<RebillSessionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RebillSessionAggregates>>;
  /** A list of `RebillSession` objects. */
  nodes: Array<Maybe<RebillSession>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RebillSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `RebillSession` values. */
export type RebillSessionConnectionGroupedAggregatesArgs = {
  groupBy: Array<RebillSessionGroupBy>;
  having?: InputMaybe<RebillSessionHavingInput>;
};

export type RebillSessionDistinctCountAggregateFilter = {
  externalSubscriptionReference?: InputMaybe<BigIntFilter>;
  purchaseId?: InputMaybe<BigIntFilter>;
  rebillManager?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type RebillSessionDistinctCountAggregates = {
  __typename?: 'RebillSessionDistinctCountAggregates';
  /** Distinct count of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of externalSubscriptionReference across the matching connection */
  externalSubscriptionReference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rebillManager across the matching connection */
  rebillManager?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `RebillSession` edge in the connection. */
export type RebillSessionEdge = {
  __typename?: 'RebillSessionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RebillSession` at the end of the edge. */
  node?: Maybe<RebillSession>;
};

/** A filter to be used against `RebillSession` object types. All fields are combined with a logical ‘and.’ */
export type RebillSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RebillSessionFilter>>;
  /** Filter by the object’s `externalSubscriptionReference` field. */
  externalSubscriptionReference?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RebillSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RebillSessionFilter>>;
  /** Filter by the object’s `purchase` relation. */
  purchase?: InputMaybe<PurchaseOrderFilter>;
  /** A related `purchase` exists. */
  purchaseExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseId` field. */
  purchaseId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rebillManager` field. */
  rebillManager?: InputMaybe<RebillSessionRebillManagerEnumFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<RebillSessionStatusEnumFilter>;
  /** Filter by the object’s `subscription` relation. */
  subscription?: InputMaybe<NmiSubscriptionFilter>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `RebillSession` for usage during aggregation. */
export enum RebillSessionGroupBy {
  ExternalSubscriptionReference = 'EXTERNAL_SUBSCRIPTION_REFERENCE',
  RebillManager = 'REBILL_MANAGER',
  Status = 'STATUS',
  SubscriptionId = 'SUBSCRIPTION_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedAtTruncatedToDay = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UpdatedAtTruncatedToHour = 'UPDATED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type RebillSessionHavingAverageInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingDistinctCountInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `RebillSession` aggregates. */
export type RebillSessionHavingInput = {
  AND?: InputMaybe<Array<RebillSessionHavingInput>>;
  OR?: InputMaybe<Array<RebillSessionHavingInput>>;
  average?: InputMaybe<RebillSessionHavingAverageInput>;
  distinctCount?: InputMaybe<RebillSessionHavingDistinctCountInput>;
  max?: InputMaybe<RebillSessionHavingMaxInput>;
  min?: InputMaybe<RebillSessionHavingMinInput>;
  stddevPopulation?: InputMaybe<RebillSessionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RebillSessionHavingStddevSampleInput>;
  sum?: InputMaybe<RebillSessionHavingSumInput>;
  variancePopulation?: InputMaybe<RebillSessionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RebillSessionHavingVarianceSampleInput>;
};

export type RebillSessionHavingMaxInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingMinInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingStddevPopulationInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingStddevSampleInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingSumInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingVariancePopulationInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionHavingVarianceSampleInput = {
  attemptCount?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  maxRetries?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RebillSessionMaxAggregateFilter = {
  purchaseId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type RebillSessionMaxAggregates = {
  __typename?: 'RebillSessionMaxAggregates';
  /** Maximum of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RebillSessionMinAggregateFilter = {
  purchaseId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type RebillSessionMinAggregates = {
  __typename?: 'RebillSessionMinAggregates';
  /** Minimum of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `RebillSession`. */
export enum RebillSessionOrderBy {
  ExternalSubscriptionReferenceAsc = 'EXTERNAL_SUBSCRIPTION_REFERENCE_ASC',
  ExternalSubscriptionReferenceDesc = 'EXTERNAL_SUBSCRIPTION_REFERENCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaseIdAsc = 'PURCHASE_ID_ASC',
  PurchaseIdDesc = 'PURCHASE_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum RebillSessionRebillManagerEnum {
  Nmi = 'nmi',
  TrmBilling = 'trm_billing'
}

/** A filter to be used against RebillSessionRebillManagerEnum fields. All fields are combined with a logical ‘and.’ */
export type RebillSessionRebillManagerEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RebillSessionRebillManagerEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RebillSessionRebillManagerEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RebillSessionRebillManagerEnum>>;
};

export enum RebillSessionStatusEnum {
  Cancelled = 'cancelled',
  CompleteRebilled = 'completeRebilled',
  CompleteTerminated = 'completeTerminated',
  Dunning = 'dunning',
  Failed = 'failed',
  Started = 'started'
}

/** A filter to be used against RebillSessionStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type RebillSessionStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RebillSessionStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RebillSessionStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RebillSessionStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RebillSessionStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RebillSessionStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RebillSessionStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RebillSessionStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RebillSessionStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RebillSessionStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RebillSessionStatusEnum>>;
};

export type RebillSessionStddevPopulationAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RebillSessionStddevPopulationAggregates = {
  __typename?: 'RebillSessionStddevPopulationAggregates';
  /** Population standard deviation of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RebillSessionStddevSampleAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RebillSessionStddevSampleAggregates = {
  __typename?: 'RebillSessionStddevSampleAggregates';
  /** Sample standard deviation of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RebillSessionSumAggregateFilter = {
  purchaseId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  subscriptionId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type RebillSessionSumAggregates = {
  __typename?: 'RebillSessionSumAggregates';
  /** Sum of attemptCount across the matching connection */
  attemptCount: Scalars['BigInt']['output'];
  /** Sum of maxRetries across the matching connection */
  maxRetries: Scalars['BigInt']['output'];
  /** Sum of purchaseId across the matching connection */
  purchaseId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type RebillSessionVariancePopulationAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RebillSessionVariancePopulationAggregates = {
  __typename?: 'RebillSessionVariancePopulationAggregates';
  /** Population variance of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RebillSessionVarianceSampleAggregateFilter = {
  purchaseId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  subscriptionId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RebillSessionVarianceSampleAggregates = {
  __typename?: 'RebillSessionVarianceSampleAggregates';
  /** Sample variance of attemptCount across the matching connection */
  attemptCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxRetries across the matching connection */
  maxRetries?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RecordLfaSplashViewInput = {
  accountId: Scalars['Int']['input'];
};

export type RecordLfaSplashViewPayload = {
  __typename?: 'RecordLfaSplashViewPayload';
  lfaSplashSeenAt?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RecordReflectionViewInput = {
  accountId: Scalars['Int']['input'];
  reflectionId: Scalars['String']['input'];
};

export type RecordReflectionViewPayload = {
  __typename?: 'RecordReflectionViewPayload';
  success: Scalars['Boolean']['output'];
  viewedReflections: Array<Scalars['String']['output']>;
};

export type ReferralPurchase = Node & {
  __typename?: 'ReferralPurchase';
  cappedPurchaseAt?: Maybe<Scalars['Datetime']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['Datetime']['output'];
  rewardClaimedAt?: Maybe<Scalars['Datetime']['output']>;
  rewardIssued: Scalars['Boolean']['output'];
  rowId: Scalars['UUID']['output'];
  trader1Id?: Maybe<Scalars['Int']['output']>;
  trader2Id?: Maybe<Scalars['Int']['output']>;
};

export type ReferralReward = Node & {
  __typename?: 'ReferralReward';
  couponCode: Scalars['String']['output'];
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  emailSent: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rewardedAt: Scalars['Datetime']['output'];
  rowId: Scalars['UUID']['output'];
  trader1Id?: Maybe<Scalars['Int']['output']>;
};

export type Refund = Node & {
  __typename?: 'Refund';
  amount: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  issuedBy?: Maybe<Scalars['Int']['output']>;
  netSuiteRefundId?: Maybe<Scalars['String']['output']>;
  nmiTransactionId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  nuveiTransactionId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Purchase` that is related to this `Refund`. */
  purchase?: Maybe<Purchase>;
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `PurchaseOrder` that is related to this `Refund`. */
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stripeTransactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type RefundAggregates = {
  __typename?: 'RefundAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RefundAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RefundDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RefundMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RefundMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RefundStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RefundStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RefundSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RefundVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RefundVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Refund` object types. */
export type RefundAggregatesFilter = {
  /** Mean average aggregate over matching `Refund` objects. */
  average?: InputMaybe<RefundAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Refund` objects. */
  distinctCount?: InputMaybe<RefundDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Refund` object to be included within the aggregate. */
  filter?: InputMaybe<RefundFilter>;
  /** Maximum aggregate over matching `Refund` objects. */
  max?: InputMaybe<RefundMaxAggregateFilter>;
  /** Minimum aggregate over matching `Refund` objects. */
  min?: InputMaybe<RefundMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Refund` objects. */
  stddevPopulation?: InputMaybe<RefundStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Refund` objects. */
  stddevSample?: InputMaybe<RefundStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Refund` objects. */
  sum?: InputMaybe<RefundSumAggregateFilter>;
  /** Population variance aggregate over matching `Refund` objects. */
  variancePopulation?: InputMaybe<RefundVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Refund` objects. */
  varianceSample?: InputMaybe<RefundVarianceSampleAggregateFilter>;
};

export type RefundAverageAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RefundAverageAggregates = {
  __typename?: 'RefundAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Refund` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RefundCondition = {
  /** Checks for equality with the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Refund` values. */
export type RefundConnection = {
  __typename?: 'RefundConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RefundAggregates>;
  /** A list of edges which contains the `Refund` and cursor to aid in pagination. */
  edges: Array<Maybe<RefundEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RefundAggregates>>;
  /** A list of `Refund` objects. */
  nodes: Array<Maybe<Refund>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Refund` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Refund` values. */
export type RefundConnectionGroupedAggregatesArgs = {
  groupBy: Array<RefundGroupBy>;
  having?: InputMaybe<RefundHavingInput>;
};

export type RefundDistinctCountAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type RefundDistinctCountAggregates = {
  __typename?: 'RefundDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of gateway across the matching connection */
  gateway?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteRefundId across the matching connection */
  netSuiteRefundId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nmiTransactionId across the matching connection */
  nmiTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiTransactionId across the matching connection */
  nuveiTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stripeTransactionId across the matching connection */
  stripeTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Refund` edge in the connection. */
export type RefundEdge = {
  __typename?: 'RefundEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Refund` at the end of the edge. */
  node?: Maybe<Refund>;
};

/** A filter to be used against `Refund` object types. All fields are combined with a logical ‘and.’ */
export type RefundFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RefundFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<RefundFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RefundFilter>>;
  /** Filter by the object’s `purchase` relation. */
  purchase?: InputMaybe<PurchaseFilter>;
  /** A related `purchase` exists. */
  purchaseExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseOrder` relation. */
  purchaseOrder?: InputMaybe<PurchaseOrderFilter>;
  /** A related `purchaseOrder` exists. */
  purchaseOrderExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseOrderId` field. */
  purchaseOrderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Refund` for usage during aggregation. */
export enum RefundGroupBy {
  PurchaseOrderId = 'PURCHASE_ORDER_ID',
  UserId = 'USER_ID'
}

export type RefundHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Refund` aggregates. */
export type RefundHavingInput = {
  AND?: InputMaybe<Array<RefundHavingInput>>;
  OR?: InputMaybe<Array<RefundHavingInput>>;
  average?: InputMaybe<RefundHavingAverageInput>;
  distinctCount?: InputMaybe<RefundHavingDistinctCountInput>;
  max?: InputMaybe<RefundHavingMaxInput>;
  min?: InputMaybe<RefundHavingMinInput>;
  stddevPopulation?: InputMaybe<RefundHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RefundHavingStddevSampleInput>;
  sum?: InputMaybe<RefundHavingSumInput>;
  variancePopulation?: InputMaybe<RefundHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RefundHavingVarianceSampleInput>;
};

export type RefundHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  purchaseId?: InputMaybe<HavingIntFilter>;
  purchaseOrderId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type RefundMaxAggregateFilter = {
  purchaseOrderId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type RefundMaxAggregates = {
  __typename?: 'RefundMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RefundMinAggregateFilter = {
  purchaseOrderId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type RefundMinAggregates = {
  __typename?: 'RefundMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Refund`. */
export enum RefundOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaseOrderIdAsc = 'PURCHASE_ORDER_ID_ASC',
  PurchaseOrderIdDesc = 'PURCHASE_ORDER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type RefundStddevPopulationAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RefundStddevPopulationAggregates = {
  __typename?: 'RefundStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RefundStddevSampleAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RefundStddevSampleAggregates = {
  __typename?: 'RefundStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RefundSumAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type RefundSumAggregates = {
  __typename?: 'RefundSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of issuedBy across the matching connection */
  issuedBy: Scalars['BigInt']['output'];
  /** Sum of purchaseId across the matching connection */
  purchaseId: Scalars['BigInt']['output'];
  /** Sum of purchaseOrderId across the matching connection */
  purchaseOrderId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type RefundVariancePopulationAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RefundVariancePopulationAggregates = {
  __typename?: 'RefundVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RefundVarianceSampleAggregateFilter = {
  purchaseOrderId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type RefundVarianceSampleAggregates = {
  __typename?: 'RefundVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseId across the matching connection */
  purchaseId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of purchaseOrderId across the matching connection */
  purchaseOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RegistrationRiskAssessment = Node & {
  __typename?: 'RegistrationRiskAssessment';
  addressCountryCode?: Maybe<Scalars['String']['output']>;
  checks: Scalars['JSON']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  ipCountryCode?: Maybe<Scalars['String']['output']>;
  ipIsProxy?: Maybe<Scalars['Boolean']['output']>;
  reasons: Array<Maybe<Scalars['String']['output']>>;
  requiresIdv: Scalars['Boolean']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `RegistrationRiskAssessment`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/** A filter to be used against `RegistrationRiskAssessment` object types. All fields are combined with a logical ‘and.’ */
export type RegistrationRiskAssessmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RegistrationRiskAssessmentFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<RegistrationRiskAssessmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RegistrationRiskAssessmentFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

export type ResetCredit = Node & {
  __typename?: 'ResetCredit';
  /** Reads a single `AccountTemplate` that is related to this `ResetCredit`. */
  accountTemplate?: Maybe<AccountTemplate>;
  accountTemplateId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  eventLog: Scalars['JSON']['output'];
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isComplimentary: Scalars['Boolean']['output'];
  issuedOn: Scalars['Datetime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ProductCategory` that is related to this `ResetCredit`. */
  productCategory?: Maybe<ProductCategory>;
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `ResetCredit`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type ResetCreditAggregates = {
  __typename?: 'ResetCreditAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ResetCreditAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ResetCreditDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ResetCreditMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ResetCreditMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ResetCreditStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ResetCreditStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ResetCreditSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ResetCreditVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ResetCreditVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ResetCredit` object types. */
export type ResetCreditAggregatesFilter = {
  /** Mean average aggregate over matching `ResetCredit` objects. */
  average?: InputMaybe<ResetCreditAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ResetCredit` objects. */
  distinctCount?: InputMaybe<ResetCreditDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ResetCredit` object to be included within the aggregate. */
  filter?: InputMaybe<ResetCreditFilter>;
  /** Maximum aggregate over matching `ResetCredit` objects. */
  max?: InputMaybe<ResetCreditMaxAggregateFilter>;
  /** Minimum aggregate over matching `ResetCredit` objects. */
  min?: InputMaybe<ResetCreditMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ResetCredit` objects. */
  stddevPopulation?: InputMaybe<ResetCreditStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ResetCredit` objects. */
  stddevSample?: InputMaybe<ResetCreditStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ResetCredit` objects. */
  sum?: InputMaybe<ResetCreditSumAggregateFilter>;
  /** Population variance aggregate over matching `ResetCredit` objects. */
  variancePopulation?: InputMaybe<ResetCreditVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ResetCredit` objects. */
  varianceSample?: InputMaybe<ResetCreditVarianceSampleAggregateFilter>;
};

export type ResetCreditAverageAggregateFilter = {
  accountTemplateId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type ResetCreditAverageAggregates = {
  __typename?: 'ResetCreditAverageAggregates';
  /** Mean average of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ResetCredit` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ResetCreditCondition = {
  /** Checks for equality with the object’s `accountTemplateId` field. */
  accountTemplateId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `isComplimentary` field. */
  isComplimentary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ResetCredit` values. */
export type ResetCreditConnection = {
  __typename?: 'ResetCreditConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ResetCreditAggregates>;
  /** A list of edges which contains the `ResetCredit` and cursor to aid in pagination. */
  edges: Array<Maybe<ResetCreditEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ResetCreditAggregates>>;
  /** A list of `ResetCredit` objects. */
  nodes: Array<Maybe<ResetCredit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResetCredit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ResetCredit` values. */
export type ResetCreditConnectionGroupedAggregatesArgs = {
  groupBy: Array<ResetCreditGroupBy>;
  having?: InputMaybe<ResetCreditHavingInput>;
};

export type ResetCreditDistinctCountAggregateFilter = {
  accountTemplateId?: InputMaybe<BigIntFilter>;
  deletedAt?: InputMaybe<BigIntFilter>;
  isComplimentary?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ResetCreditDistinctCountAggregates = {
  __typename?: 'ResetCreditDistinctCountAggregates';
  /** Distinct count of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expiresAt across the matching connection */
  expiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isComplimentary across the matching connection */
  isComplimentary?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedOn across the matching connection */
  issuedOn?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reason across the matching connection */
  reason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `ResetCredit` edge in the connection. */
export type ResetCreditEdge = {
  __typename?: 'ResetCreditEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ResetCredit` at the end of the edge. */
  node?: Maybe<ResetCredit>;
};

/** A filter to be used against `ResetCredit` object types. All fields are combined with a logical ‘and.’ */
export type ResetCreditFilter = {
  /** Filter by the object’s `accountTemplate` relation. */
  accountTemplate?: InputMaybe<AccountTemplateFilter>;
  /** A related `accountTemplate` exists. */
  accountTemplateExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountTemplateId` field. */
  accountTemplateId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ResetCreditFilter>>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `isComplimentary` field. */
  isComplimentary?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ResetCreditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ResetCreditFilter>>;
  /** Filter by the object’s `productCategory` relation. */
  productCategory?: InputMaybe<ProductCategoryFilter>;
  /** A related `productCategory` exists. */
  productCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

export type ResetCreditGrant = Node & {
  __typename?: 'ResetCreditGrant';
  createdAt: Scalars['Datetime']['output'];
  grantKey: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `ResetCredit` that is related to this `ResetCreditGrant`. */
  resetCredit?: Maybe<ResetCredit>;
  resetCreditId: Scalars['Int']['output'];
};

/** Grouping methods for `ResetCredit` for usage during aggregation. */
export enum ResetCreditGroupBy {
  AccountTemplateId = 'ACCOUNT_TEMPLATE_ID',
  DeletedAt = 'DELETED_AT',
  DeletedAtTruncatedToDay = 'DELETED_AT_TRUNCATED_TO_DAY',
  DeletedAtTruncatedToHour = 'DELETED_AT_TRUNCATED_TO_HOUR',
  IsComplimentary = 'IS_COMPLIMENTARY',
  Status = 'STATUS',
  UserId = 'USER_ID'
}

export type ResetCreditHavingAverageInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingDistinctCountInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `ResetCredit` aggregates. */
export type ResetCreditHavingInput = {
  AND?: InputMaybe<Array<ResetCreditHavingInput>>;
  OR?: InputMaybe<Array<ResetCreditHavingInput>>;
  average?: InputMaybe<ResetCreditHavingAverageInput>;
  distinctCount?: InputMaybe<ResetCreditHavingDistinctCountInput>;
  max?: InputMaybe<ResetCreditHavingMaxInput>;
  min?: InputMaybe<ResetCreditHavingMinInput>;
  stddevPopulation?: InputMaybe<ResetCreditHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ResetCreditHavingStddevSampleInput>;
  sum?: InputMaybe<ResetCreditHavingSumInput>;
  variancePopulation?: InputMaybe<ResetCreditHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ResetCreditHavingVarianceSampleInput>;
};

export type ResetCreditHavingMaxInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingMinInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingStddevPopulationInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingStddevSampleInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingSumInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingVariancePopulationInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditHavingVarianceSampleInput = {
  accountTemplateId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  productCategoryId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type ResetCreditMaxAggregateFilter = {
  accountTemplateId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ResetCreditMaxAggregates = {
  __typename?: 'ResetCreditMaxAggregates';
  /** Maximum of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ResetCreditMinAggregateFilter = {
  accountTemplateId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ResetCreditMinAggregates = {
  __typename?: 'ResetCreditMinAggregates';
  /** Minimum of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `ResetCredit`. */
export enum ResetCreditOrderBy {
  AccountTemplateIdAsc = 'ACCOUNT_TEMPLATE_ID_ASC',
  AccountTemplateIdDesc = 'ACCOUNT_TEMPLATE_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  IsComplimentaryAsc = 'IS_COMPLIMENTARY_ASC',
  IsComplimentaryDesc = 'IS_COMPLIMENTARY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type ResetCreditStddevPopulationAggregateFilter = {
  accountTemplateId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type ResetCreditStddevPopulationAggregates = {
  __typename?: 'ResetCreditStddevPopulationAggregates';
  /** Population standard deviation of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ResetCreditStddevSampleAggregateFilter = {
  accountTemplateId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type ResetCreditStddevSampleAggregates = {
  __typename?: 'ResetCreditStddevSampleAggregates';
  /** Sample standard deviation of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ResetCreditSumAggregateFilter = {
  accountTemplateId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ResetCreditSumAggregates = {
  __typename?: 'ResetCreditSumAggregates';
  /** Sum of accountTemplateId across the matching connection */
  accountTemplateId: Scalars['BigInt']['output'];
  /** Sum of productCategoryId across the matching connection */
  productCategoryId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type ResetCreditVariancePopulationAggregateFilter = {
  accountTemplateId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type ResetCreditVariancePopulationAggregates = {
  __typename?: 'ResetCreditVariancePopulationAggregates';
  /** Population variance of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ResetCreditVarianceSampleAggregateFilter = {
  accountTemplateId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type ResetCreditVarianceSampleAggregates = {
  __typename?: 'ResetCreditVarianceSampleAggregates';
  /** Sample variance of accountTemplateId across the matching connection */
  accountTemplateId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productCategoryId across the matching connection */
  productCategoryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** Input for revoking TIN validation bypass on a user tax form */
export type RevokeUserTaxFormValidationBypassInput = {
  /** UserTaxForms ID to revoke bypass for */
  userTaxFormId: Scalars['Int']['input'];
};

/** Result of revoking TIN validation bypass */
export type RevokeUserTaxFormValidationBypassResult = {
  __typename?: 'RevokeUserTaxFormValidationBypassResult';
  /** Status message */
  message: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type RiskyProduct = Node & {
  __typename?: 'RiskyProduct';
  /** Reads a single `User` that is related to this `RiskyProduct`. */
  addedByAdmin?: Maybe<User>;
  addedByAdminId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Reads a single `User` that is related to this `RiskyProduct`. */
  lastModifiedByAdmin?: Maybe<User>;
  lastModifiedByAdminId?: Maybe<Scalars['Int']['output']>;
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type RiskyProductAggregates = {
  __typename?: 'RiskyProductAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RiskyProductAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RiskyProductDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RiskyProductMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RiskyProductMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RiskyProductStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RiskyProductStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RiskyProductSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RiskyProductVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RiskyProductVarianceSampleAggregates>;
};

export type RiskyProductAverageAggregates = {
  __typename?: 'RiskyProductAverageAggregates';
  /** Mean average of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `RiskyProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RiskyProductCondition = {
  /** Checks for equality with the object’s `productCode` field. */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `RiskyProduct` values. */
export type RiskyProductConnection = {
  __typename?: 'RiskyProductConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RiskyProductAggregates>;
  /** A list of edges which contains the `RiskyProduct` and cursor to aid in pagination. */
  edges: Array<Maybe<RiskyProductEdge>>;
  /** A list of `RiskyProduct` objects. */
  nodes: Array<Maybe<RiskyProduct>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RiskyProduct` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type RiskyProductDistinctCountAggregates = {
  __typename?: 'RiskyProductDistinctCountAggregates';
  /** Distinct count of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isActive across the matching connection */
  isActive?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productCode across the matching connection */
  productCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productName across the matching connection */
  productName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `RiskyProduct` edge in the connection. */
export type RiskyProductEdge = {
  __typename?: 'RiskyProductEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RiskyProduct` at the end of the edge. */
  node?: Maybe<RiskyProduct>;
};

/** A filter to be used against `RiskyProduct` object types. All fields are combined with a logical ‘and.’ */
export type RiskyProductFilter = {
  /** Filter by the object’s `addedByAdmin` relation. */
  addedByAdmin?: InputMaybe<UserFilter>;
  /** A related `addedByAdmin` exists. */
  addedByAdminExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RiskyProductFilter>>;
  /** Filter by the object’s `lastModifiedByAdmin` relation. */
  lastModifiedByAdmin?: InputMaybe<UserFilter>;
  /** A related `lastModifiedByAdmin` exists. */
  lastModifiedByAdminExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<RiskyProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RiskyProductFilter>>;
  /** Filter by the object’s `productCode` field. */
  productCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

export type RiskyProductMaxAggregates = {
  __typename?: 'RiskyProductMaxAggregates';
  /** Maximum of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type RiskyProductMinAggregates = {
  __typename?: 'RiskyProductMinAggregates';
  /** Minimum of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `RiskyProduct`. */
export enum RiskyProductOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type RiskyProductStddevPopulationAggregates = {
  __typename?: 'RiskyProductStddevPopulationAggregates';
  /** Population standard deviation of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RiskyProductStddevSampleAggregates = {
  __typename?: 'RiskyProductStddevSampleAggregates';
  /** Sample standard deviation of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RiskyProductSumAggregates = {
  __typename?: 'RiskyProductSumAggregates';
  /** Sum of addedByAdminId across the matching connection */
  addedByAdminId: Scalars['BigInt']['output'];
  /** Sum of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type RiskyProductVariancePopulationAggregates = {
  __typename?: 'RiskyProductVariancePopulationAggregates';
  /** Population variance of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type RiskyProductVarianceSampleAggregates = {
  __typename?: 'RiskyProductVarianceSampleAggregates';
  /** Sample variance of addedByAdminId across the matching connection */
  addedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lastModifiedByAdminId across the matching connection */
  lastModifiedByAdminId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SavedCard = Node & {
  __typename?: 'SavedCard';
  active?: Maybe<Scalars['Boolean']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  cvvBypassEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultCard?: Maybe<Scalars['Boolean']['output']>;
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  fullNameOnCard?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** NMI initial transaction ID for COF (Credential-on-File) compliance */
  initialTransactionId?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `NmiSubscription`. */
  nmiSubscriptions: NmiSubscriptionConnection;
  rowId: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `SavedCard`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  vaultName: Scalars['String']['output'];
  vaultPaymentId: Scalars['String']['output'];
  vaultUserId: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};


export type SavedCardNmiSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NmiSubscriptionCondition>;
  filter?: InputMaybe<NmiSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NmiSubscriptionOrderBy>>;
};

export type SavedCardAggregates = {
  __typename?: 'SavedCardAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SavedCardAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SavedCardDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SavedCardMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SavedCardMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SavedCardStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SavedCardStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SavedCardSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SavedCardVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SavedCardVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SavedCard` object types. */
export type SavedCardAggregatesFilter = {
  /** Mean average aggregate over matching `SavedCard` objects. */
  average?: InputMaybe<SavedCardAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SavedCard` objects. */
  distinctCount?: InputMaybe<SavedCardDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SavedCard` object to be included within the aggregate. */
  filter?: InputMaybe<SavedCardFilter>;
  /** Maximum aggregate over matching `SavedCard` objects. */
  max?: InputMaybe<SavedCardMaxAggregateFilter>;
  /** Minimum aggregate over matching `SavedCard` objects. */
  min?: InputMaybe<SavedCardMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SavedCard` objects. */
  stddevPopulation?: InputMaybe<SavedCardStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SavedCard` objects. */
  stddevSample?: InputMaybe<SavedCardStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SavedCard` objects. */
  sum?: InputMaybe<SavedCardSumAggregateFilter>;
  /** Population variance aggregate over matching `SavedCard` objects. */
  variancePopulation?: InputMaybe<SavedCardVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SavedCard` objects. */
  varianceSample?: InputMaybe<SavedCardVarianceSampleAggregateFilter>;
};

export type SavedCardAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type SavedCardAverageAggregates = {
  __typename?: 'SavedCardAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `SavedCard` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SavedCardCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SavedCard` values. */
export type SavedCardConnection = {
  __typename?: 'SavedCardConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SavedCardAggregates>;
  /** A list of edges which contains the `SavedCard` and cursor to aid in pagination. */
  edges: Array<Maybe<SavedCardEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SavedCardAggregates>>;
  /** A list of `SavedCard` objects. */
  nodes: Array<Maybe<SavedCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SavedCard` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SavedCard` values. */
export type SavedCardConnectionGroupedAggregatesArgs = {
  groupBy: Array<SavedCardGroupBy>;
  having?: InputMaybe<SavedCardHavingInput>;
};

export type SavedCardDistinctCountAggregateFilter = {
  active?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type SavedCardDistinctCountAggregates = {
  __typename?: 'SavedCardDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cardBrand across the matching connection */
  cardBrand?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of city across the matching connection */
  city?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of country across the matching connection */
  country?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cvvBypassEnabled across the matching connection */
  cvvBypassEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of defaultCard across the matching connection */
  defaultCard?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expirationMonth across the matching connection */
  expirationMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expirationYear across the matching connection */
  expirationYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fullNameOnCard across the matching connection */
  fullNameOnCard?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of initialTransactionId across the matching connection */
  initialTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maskedCardNumber across the matching connection */
  maskedCardNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of state across the matching connection */
  state?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of street across the matching connection */
  street?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of vaultName across the matching connection */
  vaultName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of vaultPaymentId across the matching connection */
  vaultPaymentId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of vaultUserId across the matching connection */
  vaultUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of zip across the matching connection */
  zip?: Maybe<Scalars['BigInt']['output']>;
};

/** A `SavedCard` edge in the connection. */
export type SavedCardEdge = {
  __typename?: 'SavedCardEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SavedCard` at the end of the edge. */
  node?: Maybe<SavedCard>;
};

/** A filter to be used against `SavedCard` object types. All fields are combined with a logical ‘and.’ */
export type SavedCardFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SavedCardFilter>>;
  /** Filter by the object’s `nmiSubscriptions` relation. */
  nmiSubscriptions?: InputMaybe<SavedCardToManyNmiSubscriptionFilter>;
  /** Some related `nmiSubscriptions` exist. */
  nmiSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<SavedCardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SavedCardFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `SavedCard` for usage during aggregation. */
export enum SavedCardGroupBy {
  Active = 'ACTIVE',
  UserId = 'USER_ID'
}

export type SavedCardHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `SavedCard` aggregates. */
export type SavedCardHavingInput = {
  AND?: InputMaybe<Array<SavedCardHavingInput>>;
  OR?: InputMaybe<Array<SavedCardHavingInput>>;
  average?: InputMaybe<SavedCardHavingAverageInput>;
  distinctCount?: InputMaybe<SavedCardHavingDistinctCountInput>;
  max?: InputMaybe<SavedCardHavingMaxInput>;
  min?: InputMaybe<SavedCardHavingMinInput>;
  stddevPopulation?: InputMaybe<SavedCardHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SavedCardHavingStddevSampleInput>;
  sum?: InputMaybe<SavedCardHavingSumInput>;
  variancePopulation?: InputMaybe<SavedCardHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SavedCardHavingVarianceSampleInput>;
};

export type SavedCardHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type SavedCardMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type SavedCardMaxAggregates = {
  __typename?: 'SavedCardMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type SavedCardMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type SavedCardMinAggregates = {
  __typename?: 'SavedCardMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `SavedCard`. */
export enum SavedCardOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  Natural = 'NATURAL',
  NmiSubscriptionsAverageCouponIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_COUPON_ID_ASC',
  NmiSubscriptionsAverageCouponIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_COUPON_ID_DESC',
  NmiSubscriptionsAverageMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsAverageMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsAverageNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsAverageNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsAverageProductIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_PRODUCT_ID_ASC',
  NmiSubscriptionsAverageProductIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_PRODUCT_ID_DESC',
  NmiSubscriptionsAverageRowIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_ROW_ID_ASC',
  NmiSubscriptionsAverageRowIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_ROW_ID_DESC',
  NmiSubscriptionsAverageSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsAverageSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsAverageSkuIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_SKU_ID_ASC',
  NmiSubscriptionsAverageSkuIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_SKU_ID_DESC',
  NmiSubscriptionsAverageUserIdAsc = 'NMI_SUBSCRIPTIONS_AVERAGE_USER_ID_ASC',
  NmiSubscriptionsAverageUserIdDesc = 'NMI_SUBSCRIPTIONS_AVERAGE_USER_ID_DESC',
  NmiSubscriptionsCountAsc = 'NMI_SUBSCRIPTIONS_COUNT_ASC',
  NmiSubscriptionsCountDesc = 'NMI_SUBSCRIPTIONS_COUNT_DESC',
  NmiSubscriptionsDistinctCountCouponIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_ASC',
  NmiSubscriptionsDistinctCountCouponIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_COUPON_ID_DESC',
  NmiSubscriptionsDistinctCountMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsDistinctCountMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsDistinctCountNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsDistinctCountNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsDistinctCountProductIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_PRODUCT_ID_ASC',
  NmiSubscriptionsDistinctCountProductIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_PRODUCT_ID_DESC',
  NmiSubscriptionsDistinctCountRebillManagerAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_MANAGER_ASC',
  NmiSubscriptionsDistinctCountRebillManagerDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_MANAGER_DESC',
  NmiSubscriptionsDistinctCountRebillRefIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_REF_ID_ASC',
  NmiSubscriptionsDistinctCountRebillRefIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_REBILL_REF_ID_DESC',
  NmiSubscriptionsDistinctCountRowIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_ASC',
  NmiSubscriptionsDistinctCountRowIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_ROW_ID_DESC',
  NmiSubscriptionsDistinctCountSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SAVED_CARD_ID_ASC',
  NmiSubscriptionsDistinctCountSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SAVED_CARD_ID_DESC',
  NmiSubscriptionsDistinctCountServiceAccessUntilAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_ASC',
  NmiSubscriptionsDistinctCountServiceAccessUntilDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_DESC',
  NmiSubscriptionsDistinctCountServiceCancelledAtAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_CANCELLED_AT_ASC',
  NmiSubscriptionsDistinctCountServiceCancelledAtDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SERVICE_CANCELLED_AT_DESC',
  NmiSubscriptionsDistinctCountSkuIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SKU_ID_ASC',
  NmiSubscriptionsDistinctCountSkuIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SKU_ID_DESC',
  NmiSubscriptionsDistinctCountSubscriptionCancelledAtAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_ASC',
  NmiSubscriptionsDistinctCountSubscriptionCancelledAtDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_DESC',
  NmiSubscriptionsDistinctCountUserIdAsc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_ASC',
  NmiSubscriptionsDistinctCountUserIdDesc = 'NMI_SUBSCRIPTIONS_DISTINCT_COUNT_USER_ID_DESC',
  NmiSubscriptionsMaxCouponIdAsc = 'NMI_SUBSCRIPTIONS_MAX_COUPON_ID_ASC',
  NmiSubscriptionsMaxCouponIdDesc = 'NMI_SUBSCRIPTIONS_MAX_COUPON_ID_DESC',
  NmiSubscriptionsMaxMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_MAX_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsMaxMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_MAX_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsMaxNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_MAX_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsMaxNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_MAX_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsMaxProductIdAsc = 'NMI_SUBSCRIPTIONS_MAX_PRODUCT_ID_ASC',
  NmiSubscriptionsMaxProductIdDesc = 'NMI_SUBSCRIPTIONS_MAX_PRODUCT_ID_DESC',
  NmiSubscriptionsMaxRowIdAsc = 'NMI_SUBSCRIPTIONS_MAX_ROW_ID_ASC',
  NmiSubscriptionsMaxRowIdDesc = 'NMI_SUBSCRIPTIONS_MAX_ROW_ID_DESC',
  NmiSubscriptionsMaxSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_MAX_SAVED_CARD_ID_ASC',
  NmiSubscriptionsMaxSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_MAX_SAVED_CARD_ID_DESC',
  NmiSubscriptionsMaxSkuIdAsc = 'NMI_SUBSCRIPTIONS_MAX_SKU_ID_ASC',
  NmiSubscriptionsMaxSkuIdDesc = 'NMI_SUBSCRIPTIONS_MAX_SKU_ID_DESC',
  NmiSubscriptionsMaxUserIdAsc = 'NMI_SUBSCRIPTIONS_MAX_USER_ID_ASC',
  NmiSubscriptionsMaxUserIdDesc = 'NMI_SUBSCRIPTIONS_MAX_USER_ID_DESC',
  NmiSubscriptionsMinCouponIdAsc = 'NMI_SUBSCRIPTIONS_MIN_COUPON_ID_ASC',
  NmiSubscriptionsMinCouponIdDesc = 'NMI_SUBSCRIPTIONS_MIN_COUPON_ID_DESC',
  NmiSubscriptionsMinMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_MIN_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsMinMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_MIN_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsMinNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_MIN_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsMinNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_MIN_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsMinProductIdAsc = 'NMI_SUBSCRIPTIONS_MIN_PRODUCT_ID_ASC',
  NmiSubscriptionsMinProductIdDesc = 'NMI_SUBSCRIPTIONS_MIN_PRODUCT_ID_DESC',
  NmiSubscriptionsMinRowIdAsc = 'NMI_SUBSCRIPTIONS_MIN_ROW_ID_ASC',
  NmiSubscriptionsMinRowIdDesc = 'NMI_SUBSCRIPTIONS_MIN_ROW_ID_DESC',
  NmiSubscriptionsMinSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_MIN_SAVED_CARD_ID_ASC',
  NmiSubscriptionsMinSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_MIN_SAVED_CARD_ID_DESC',
  NmiSubscriptionsMinSkuIdAsc = 'NMI_SUBSCRIPTIONS_MIN_SKU_ID_ASC',
  NmiSubscriptionsMinSkuIdDesc = 'NMI_SUBSCRIPTIONS_MIN_SKU_ID_DESC',
  NmiSubscriptionsMinUserIdAsc = 'NMI_SUBSCRIPTIONS_MIN_USER_ID_ASC',
  NmiSubscriptionsMinUserIdDesc = 'NMI_SUBSCRIPTIONS_MIN_USER_ID_DESC',
  NmiSubscriptionsStddevPopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsStddevPopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsStddevPopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsStddevPopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsStddevPopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsStddevPopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsStddevPopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsStddevPopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsStddevPopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsStddevPopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsStddevPopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsStddevPopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsStddevPopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsStddevPopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsStddevPopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_ASC',
  NmiSubscriptionsStddevPopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_POPULATION_USER_ID_DESC',
  NmiSubscriptionsStddevSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsStddevSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsStddevSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsStddevSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsStddevSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsStddevSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsStddevSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsStddevSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsStddevSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsStddevSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsStddevSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsStddevSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsStddevSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsStddevSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsStddevSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsStddevSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_STDDEV_SAMPLE_USER_ID_DESC',
  NmiSubscriptionsSumCouponIdAsc = 'NMI_SUBSCRIPTIONS_SUM_COUPON_ID_ASC',
  NmiSubscriptionsSumCouponIdDesc = 'NMI_SUBSCRIPTIONS_SUM_COUPON_ID_DESC',
  NmiSubscriptionsSumMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_SUM_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsSumMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_SUM_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsSumNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_SUM_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsSumNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_SUM_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsSumProductIdAsc = 'NMI_SUBSCRIPTIONS_SUM_PRODUCT_ID_ASC',
  NmiSubscriptionsSumProductIdDesc = 'NMI_SUBSCRIPTIONS_SUM_PRODUCT_ID_DESC',
  NmiSubscriptionsSumRowIdAsc = 'NMI_SUBSCRIPTIONS_SUM_ROW_ID_ASC',
  NmiSubscriptionsSumRowIdDesc = 'NMI_SUBSCRIPTIONS_SUM_ROW_ID_DESC',
  NmiSubscriptionsSumSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_SUM_SAVED_CARD_ID_ASC',
  NmiSubscriptionsSumSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_SUM_SAVED_CARD_ID_DESC',
  NmiSubscriptionsSumSkuIdAsc = 'NMI_SUBSCRIPTIONS_SUM_SKU_ID_ASC',
  NmiSubscriptionsSumSkuIdDesc = 'NMI_SUBSCRIPTIONS_SUM_SKU_ID_DESC',
  NmiSubscriptionsSumUserIdAsc = 'NMI_SUBSCRIPTIONS_SUM_USER_ID_ASC',
  NmiSubscriptionsSumUserIdDesc = 'NMI_SUBSCRIPTIONS_SUM_USER_ID_DESC',
  NmiSubscriptionsVariancePopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsVariancePopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsVariancePopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsVariancePopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsVariancePopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsVariancePopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsVariancePopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsVariancePopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsVariancePopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsVariancePopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsVariancePopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsVariancePopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsVariancePopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsVariancePopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsVariancePopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_ASC',
  NmiSubscriptionsVariancePopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_POPULATION_USER_ID_DESC',
  NmiSubscriptionsVarianceSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsVarianceSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsVarianceSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsVarianceSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsVarianceSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsVarianceSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsVarianceSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsVarianceSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsVarianceSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsVarianceSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsVarianceSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsVarianceSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsVarianceSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsVarianceSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsVarianceSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsVarianceSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type SavedCardStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type SavedCardStddevPopulationAggregates = {
  __typename?: 'SavedCardStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SavedCardStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type SavedCardStddevSampleAggregates = {
  __typename?: 'SavedCardStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SavedCardSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type SavedCardSumAggregates = {
  __typename?: 'SavedCardSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `NmiSubscription` object types. All fields are combined with a logical ‘and.’ */
export type SavedCardToManyNmiSubscriptionFilter = {
  /** Aggregates across related `NmiSubscription` match the filter criteria. */
  aggregates?: InputMaybe<NmiSubscriptionAggregatesFilter>;
  /** Every related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NmiSubscriptionFilter>;
  /** No related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NmiSubscriptionFilter>;
  /** Some related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NmiSubscriptionFilter>;
};

export type SavedCardVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type SavedCardVariancePopulationAggregates = {
  __typename?: 'SavedCardVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SavedCardVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type SavedCardVarianceSampleAggregates = {
  __typename?: 'SavedCardVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SetCaseBanPendingStatusInput = {
  banId: Scalars['Int']['input'];
  payoutHold?: InputMaybe<CaseBanPayoutHold>;
  pendingAction: CaseBanPendingAction;
  summary?: InputMaybe<Scalars['String']['input']>;
  traderIds: Array<Scalars['Int']['input']>;
  urgency?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetCaseBanTraderIdvLinkInput = {
  banId: Scalars['Int']['input'];
  idvLink?: InputMaybe<Scalars['String']['input']>;
  traderId: Scalars['Int']['input'];
};

export type SetCaseBanTraderIntercomLinkInput = {
  banId: Scalars['Int']['input'];
  intercomLink?: InputMaybe<Scalars['String']['input']>;
  traderId: Scalars['Int']['input'];
};

export type SetCaseInvestigationPendingStatusInput = {
  investigationId: Scalars['Int']['input'];
  payoutHold?: InputMaybe<CaseInvestigationPayoutHold>;
  pendingAction: CaseInvestigationPendingAction;
  reasonCodeId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  traderIds: Array<Scalars['Int']['input']>;
  urgency?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetCaseInvestigationTraderIdvLinkInput = {
  idvLink?: InputMaybe<Scalars['String']['input']>;
  investigationId: Scalars['Int']['input'];
  traderId: Scalars['Int']['input'];
};

export type SetCaseInvestigationTraderIntercomLinkInput = {
  intercomLink?: InputMaybe<Scalars['String']['input']>;
  investigationId: Scalars['Int']['input'];
  traderId: Scalars['Int']['input'];
};

export type SkuAccountDetails = {
  __typename?: 'SkuAccountDetails';
  accountName: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  buyingPower: Scalars['String']['output'];
  dailyDrawdown: Scalars['Float']['output'];
  displayStage?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  hasDll: Scalars['Boolean']['output'];
  isChallenge: Scalars['Boolean']['output'];
  isConsistency: Scalars['Boolean']['output'];
  maxDrawdown: Scalars['Float']['output'];
  maxPositionSize: Scalars['Float']['output'];
  minTradingDays: Scalars['Int']['output'];
  profitTarget: Scalars['Float']['output'];
  resetPrice: Scalars['Float']['output'];
  startingBalance: Scalars['Float']['output'];
};

export type SkuAccountProvisioningClaim = Node & {
  __typename?: 'SkuAccountProvisioningClaim';
  accountId?: Maybe<Scalars['Int']['output']>;
  accountPassedBinderId?: Maybe<Scalars['Int']['output']>;
  accountType: Scalars['String']['output'];
  allocationStartedAt?: Maybe<Scalars['Datetime']['output']>;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  failedAt?: Maybe<Scalars['Datetime']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  leaseExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  nmiSubscriptionId?: Maybe<Scalars['Int']['output']>;
  ownerToken?: Maybe<Scalars['UUID']['output']>;
  projectXAccountId?: Maybe<Scalars['Int']['output']>;
  provisioningKey: Scalars['String']['output'];
  reservedAccountName?: Maybe<Scalars['String']['output']>;
  retryable?: Maybe<Scalars['Boolean']['output']>;
  rowId: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type SkuInventory = Node & {
  __typename?: 'SkuInventory';
  createdAt: Scalars['Datetime']['output'];
  displayLimit?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  skuId: Scalars['Int']['output'];
  unitLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** Input for starting W-8BEN signing process */
export type StartW8BenSigningInput = {
  /** Permanent residence address */
  address: Scalars['String']['input'];
  /** Address line 2 (optional) */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address (if different from permanent) */
  addressMailing?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Mailing city */
  cityMailing?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country: Scalars['String']['input'];
  /** Mailing country */
  countryMailing?: InputMaybe<Scalars['String']['input']>;
  /** Country of citizenship */
  countryOfCitizenship: Scalars['String']['input'];
  /** Date of birth in MM-DD-YYYY format */
  dob: Scalars['String']['input'];
  /** Signer's email address */
  email: Scalars['String']['input'];
  /** Signer's first name */
  firstName: Scalars['String']['input'];
  /** Signer's last name */
  lastName: Scalars['String']['input'];
  /** URL to redirect to after signing */
  returnUrl: Scalars['String']['input'];
  /** State (optional) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Mailing state */
  stateMailing?: InputMaybe<Scalars['String']['input']>;
  /** ZIP code (optional) */
  zipCode?: InputMaybe<Scalars['String']['input']>;
  /** Mailing ZIP code */
  zipCodeMailing?: InputMaybe<Scalars['String']['input']>;
};

/** Input for starting W-9 signing process */
export type StartW9SigningInput = {
  /** Street address line 1 */
  address: Scalars['String']['input'];
  /** Street address line 2 (optional) */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** Business name (required if entityType is Business) */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country (optional) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in MM-DD-YYYY format */
  dob: Scalars['String']['input'];
  /** Signer's email address */
  email: Scalars['String']['input'];
  /** Entity type (Individual or Business) */
  entityType: EntityType;
  /** Signer's first name */
  firstName: Scalars['String']['input'];
  /** Signer's last name */
  lastName: Scalars['String']['input'];
  /** URL to redirect to after signing */
  returnUrl: Scalars['String']['input'];
  /** State (2-letter code) */
  state: Scalars['String']['input'];
  /** ZIP code */
  zipCode: Scalars['String']['input'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubmitCaseBanInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  reasonCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  severity: CaseSeverity;
  summary?: InputMaybe<Scalars['String']['input']>;
  traderIds: Array<Scalars['Int']['input']>;
};

export type SubscriptionDunning = Node & {
  __typename?: 'SubscriptionDunning';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastAttempt?: Maybe<Scalars['Datetime']['output']>;
  nextAttempt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subId: Scalars['Int']['output'];
  totalAttempts?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

/** Result of syncing Discord roles for the current user. */
export type SyncDiscordRolesPayload = {
  __typename?: 'SyncDiscordRolesPayload';
  /** Human-readable message (e.g. success summary or error reason). */
  message: Scalars['String']['output'];
  /** Discord role IDs that were added. */
  rolesAdded: Array<Scalars['String']['output']>;
  /** Whether the sync completed successfully. */
  success: Scalars['Boolean']['output'];
};

export type SyncState = Node & {
  __typename?: 'SyncState';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastProcessedTime: Scalars['Datetime']['output'];
  processName: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/** Result from downloading a signed tax form document */
export type TaxFormDocumentResult = {
  __typename?: 'TaxFormDocumentResult';
  /** MIME type (application/pdf) */
  contentType: Scalars['String']['output'];
  /** Base64 encoded PDF document */
  documentBase64: Scalars['String']['output'];
  /** Suggested filename for download */
  filename: Scalars['String']['output'];
};

export enum TaxFormTypeEnum {
  W8Ben = 'W8BEN',
  W9 = 'W9'
}

export type TaxInfo = Node & {
  __typename?: 'TaxInfo';
  createdAt: Scalars['Datetime']['output'];
  form?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taxYear?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `TaxInfo`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type TaxInfoAggregates = {
  __typename?: 'TaxInfoAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TaxInfoAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TaxInfoDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TaxInfoMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TaxInfoMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TaxInfoStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TaxInfoStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TaxInfoSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TaxInfoVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TaxInfoVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TaxInfo` object types. */
export type TaxInfoAggregatesFilter = {
  /** Mean average aggregate over matching `TaxInfo` objects. */
  average?: InputMaybe<TaxInfoAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TaxInfo` objects. */
  distinctCount?: InputMaybe<TaxInfoDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TaxInfo` object to be included within the aggregate. */
  filter?: InputMaybe<TaxInfoFilter>;
  /** Maximum aggregate over matching `TaxInfo` objects. */
  max?: InputMaybe<TaxInfoMaxAggregateFilter>;
  /** Minimum aggregate over matching `TaxInfo` objects. */
  min?: InputMaybe<TaxInfoMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TaxInfo` objects. */
  stddevPopulation?: InputMaybe<TaxInfoStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TaxInfo` objects. */
  stddevSample?: InputMaybe<TaxInfoStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TaxInfo` objects. */
  sum?: InputMaybe<TaxInfoSumAggregateFilter>;
  /** Population variance aggregate over matching `TaxInfo` objects. */
  variancePopulation?: InputMaybe<TaxInfoVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TaxInfo` objects. */
  varianceSample?: InputMaybe<TaxInfoVarianceSampleAggregateFilter>;
};

export type TaxInfoAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type TaxInfoAverageAggregates = {
  __typename?: 'TaxInfoAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `TaxInfo` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TaxInfoCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `TaxInfo` values. */
export type TaxInfoConnection = {
  __typename?: 'TaxInfoConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TaxInfoAggregates>;
  /** A list of edges which contains the `TaxInfo` and cursor to aid in pagination. */
  edges: Array<Maybe<TaxInfoEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TaxInfoAggregates>>;
  /** A list of `TaxInfo` objects. */
  nodes: Array<Maybe<TaxInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaxInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TaxInfo` values. */
export type TaxInfoConnectionGroupedAggregatesArgs = {
  groupBy: Array<TaxInfoGroupBy>;
  having?: InputMaybe<TaxInfoHavingInput>;
};

export type TaxInfoDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type TaxInfoDistinctCountAggregates = {
  __typename?: 'TaxInfoDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of form across the matching connection */
  form?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of s3Key across the matching connection */
  s3Key?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of s3Url across the matching connection */
  s3Url?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `TaxInfo` edge in the connection. */
export type TaxInfoEdge = {
  __typename?: 'TaxInfoEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TaxInfo` at the end of the edge. */
  node?: Maybe<TaxInfo>;
};

/** A filter to be used against `TaxInfo` object types. All fields are combined with a logical ‘and.’ */
export type TaxInfoFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaxInfoFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TaxInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaxInfoFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `TaxInfo` for usage during aggregation. */
export enum TaxInfoGroupBy {
  Status = 'STATUS',
  UserId = 'USER_ID'
}

export type TaxInfoHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `TaxInfo` aggregates. */
export type TaxInfoHavingInput = {
  AND?: InputMaybe<Array<TaxInfoHavingInput>>;
  OR?: InputMaybe<Array<TaxInfoHavingInput>>;
  average?: InputMaybe<TaxInfoHavingAverageInput>;
  distinctCount?: InputMaybe<TaxInfoHavingDistinctCountInput>;
  max?: InputMaybe<TaxInfoHavingMaxInput>;
  min?: InputMaybe<TaxInfoHavingMinInput>;
  stddevPopulation?: InputMaybe<TaxInfoHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TaxInfoHavingStddevSampleInput>;
  sum?: InputMaybe<TaxInfoHavingSumInput>;
  variancePopulation?: InputMaybe<TaxInfoHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TaxInfoHavingVarianceSampleInput>;
};

export type TaxInfoHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type TaxInfoMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type TaxInfoMaxAggregates = {
  __typename?: 'TaxInfoMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TaxInfoMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type TaxInfoMinAggregates = {
  __typename?: 'TaxInfoMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `TaxInfo`. */
export enum TaxInfoOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type TaxInfoStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type TaxInfoStddevPopulationAggregates = {
  __typename?: 'TaxInfoStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TaxInfoStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type TaxInfoStddevSampleAggregates = {
  __typename?: 'TaxInfoStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TaxInfoSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type TaxInfoSumAggregates = {
  __typename?: 'TaxInfoSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type TaxInfoVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type TaxInfoVariancePopulationAggregates = {
  __typename?: 'TaxInfoVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TaxInfoVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type TaxInfoVarianceSampleAggregates = {
  __typename?: 'TaxInfoVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Trade = Node & {
  __typename?: 'Trade';
  commissions?: Maybe<Scalars['BigFloat']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  executedPrice: Scalars['BigFloat']['output'];
  fees?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  orderId: Scalars['BigInt']['output'];
  pairedTradeId?: Maybe<Scalars['BigInt']['output']>;
  platformId: Scalars['Int']['output'];
  platformTradeId?: Maybe<Scalars['String']['output']>;
  positionSize: Scalars['Int']['output'];
  profitAndLoss?: Maybe<Scalars['BigFloat']['output']>;
  remainingFill: Scalars['Int']['output'];
  rowId: Scalars['BigInt']['output'];
  symbolId: Scalars['String']['output'];
  tradeDay: Scalars['Datetime']['output'];
  tradingAccountId: Scalars['Int']['output'];
  voided: Scalars['Boolean']['output'];
};

export type TradedProductLots = {
  __typename?: 'TradedProductLots';
  name?: Maybe<Scalars['String']['output']>;
  totalLots: Scalars['Float']['output'];
};

export enum TraderAffiliateStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type TraderLockDetail = Node & {
  __typename?: 'TraderLockDetail';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lockNote?: Maybe<Scalars['String']['output']>;
  lockedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `TraderLockDetail`. */
  lockedBy?: Maybe<User>;
  lockedById?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `TraderLockDetail`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/** A filter to be used against `TraderLockDetail` object types. All fields are combined with a logical ‘and.’ */
export type TraderLockDetailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderLockDetailFilter>>;
  /** Filter by the object’s `lockedBy` relation. */
  lockedBy?: InputMaybe<UserFilter>;
  /** A related `lockedBy` exists. */
  lockedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<TraderLockDetailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderLockDetailFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

export type TraderOpenCase = {
  __typename?: 'TraderOpenCase';
  addedAt: Scalars['String']['output'];
  caseId: Scalars['Int']['output'];
  kind: TraderOpenCaseKind;
  traderId: Scalars['Int']['output'];
};

export enum TraderOpenCaseKind {
  Ban = 'ban',
  Investigation = 'investigation'
}

export type TraderPayoutNote = {
  __typename?: 'TraderPayoutNote';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  payoutRequestId: Scalars['Int']['output'];
  reviewerEmail: Scalars['String']['output'];
  reviewerId: Scalars['Int']['output'];
  reviewerName?: Maybe<Scalars['String']['output']>;
};

export type TraderProfileAsset = Node & {
  __typename?: 'TraderProfileAsset';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  kind: TraderProfileAssetKindEnum;
  rowId: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Reads a single `TraderPublicProfile` that is related to this `TraderProfileAsset`. */
  traderPublicProfile?: Maybe<TraderPublicProfile>;
  traderPublicProfileId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TraderPublicProfile`. */
  traderPublicProfilesByBannerImageAssetId: TraderPublicProfileConnection;
  /** Reads and enables pagination through a set of `TraderPublicProfile`. */
  traderPublicProfilesByProfileImageAssetId: TraderPublicProfileConnection;
  updatedAt: Scalars['Datetime']['output'];
  url: Scalars['String']['output'];
};


export type TraderProfileAssetTraderPublicProfilesByBannerImageAssetIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderPublicProfileCondition>;
  filter?: InputMaybe<TraderPublicProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderPublicProfileOrderBy>>;
};


export type TraderProfileAssetTraderPublicProfilesByProfileImageAssetIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderPublicProfileCondition>;
  filter?: InputMaybe<TraderPublicProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderPublicProfileOrderBy>>;
};

/** A filter to be used against `TraderProfileAsset` object types. All fields are combined with a logical ‘and.’ */
export type TraderProfileAssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderProfileAssetFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TraderProfileAssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderProfileAssetFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderPublicProfile` relation. */
  traderPublicProfile?: InputMaybe<TraderPublicProfileFilter>;
  /** Filter by the object’s `traderPublicProfilesByBannerImageAssetId` relation. */
  traderPublicProfilesByBannerImageAssetId?: InputMaybe<TraderProfileAssetToManyTraderPublicProfileFilter>;
  /** Some related `traderPublicProfilesByBannerImageAssetId` exist. */
  traderPublicProfilesByBannerImageAssetIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `traderPublicProfilesByProfileImageAssetId` relation. */
  traderPublicProfilesByProfileImageAssetId?: InputMaybe<TraderProfileAssetToManyTraderPublicProfileFilter>;
  /** Some related `traderPublicProfilesByProfileImageAssetId` exist. */
  traderPublicProfilesByProfileImageAssetIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TraderProfileAssetKindEnum {
  Avatar = 'avatar',
  Banner = 'banner'
}

/** A filter to be used against many `TraderPublicProfile` object types. All fields are combined with a logical ‘and.’ */
export type TraderProfileAssetToManyTraderPublicProfileFilter = {
  /** Aggregates across related `TraderPublicProfile` match the filter criteria. */
  aggregates?: InputMaybe<TraderPublicProfileAggregatesFilter>;
  /** Every related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TraderPublicProfileFilter>;
  /** No related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TraderPublicProfileFilter>;
  /** Some related `TraderPublicProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TraderPublicProfileFilter>;
};

export type TraderProfileModerationBlockedWord = Node & {
  __typename?: 'TraderProfileModerationBlockedWord';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
  value: Scalars['String']['output'];
};

export type TraderProfileModerationCase = Node & {
  __typename?: 'TraderProfileModerationCase';
  allowedAt?: Maybe<Scalars['Datetime']['output']>;
  details: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['Int']['output'];
  solvedAt?: Maybe<Scalars['Datetime']['output']>;
  source: Scalars['String']['output'];
  submittedAt: Scalars['Datetime']['output'];
  submittedBy: Scalars['JSON']['output'];
  /** Reads a single `User` that is related to this `TraderProfileModerationCase`. */
  trader?: Maybe<User>;
  traderId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TraderProfileModerationCaseHistory`. */
  traderProfileModerationCaseHistoriesByCaseId: TraderProfileModerationCaseHistoryConnection;
};


export type TraderProfileModerationCaseTraderProfileModerationCaseHistoriesByCaseIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderProfileModerationCaseHistoryCondition>;
  filter?: InputMaybe<TraderProfileModerationCaseHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderProfileModerationCaseHistoryOrderBy>>;
};

export type TraderProfileModerationCaseAggregates = {
  __typename?: 'TraderProfileModerationCaseAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TraderProfileModerationCaseAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TraderProfileModerationCaseDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TraderProfileModerationCaseMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TraderProfileModerationCaseMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TraderProfileModerationCaseStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TraderProfileModerationCaseStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TraderProfileModerationCaseSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TraderProfileModerationCaseVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TraderProfileModerationCaseVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TraderProfileModerationCase` object types. */
export type TraderProfileModerationCaseAggregatesFilter = {
  /** Mean average aggregate over matching `TraderProfileModerationCase` objects. */
  average?: InputMaybe<TraderProfileModerationCaseAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TraderProfileModerationCase` objects. */
  distinctCount?: InputMaybe<TraderProfileModerationCaseDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TraderProfileModerationCase` object to be included within the aggregate. */
  filter?: InputMaybe<TraderProfileModerationCaseFilter>;
  /** Maximum aggregate over matching `TraderProfileModerationCase` objects. */
  max?: InputMaybe<TraderProfileModerationCaseMaxAggregateFilter>;
  /** Minimum aggregate over matching `TraderProfileModerationCase` objects. */
  min?: InputMaybe<TraderProfileModerationCaseMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TraderProfileModerationCase` objects. */
  stddevPopulation?: InputMaybe<TraderProfileModerationCaseStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TraderProfileModerationCase` objects. */
  stddevSample?: InputMaybe<TraderProfileModerationCaseStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TraderProfileModerationCase` objects. */
  sum?: InputMaybe<TraderProfileModerationCaseSumAggregateFilter>;
  /** Population variance aggregate over matching `TraderProfileModerationCase` objects. */
  variancePopulation?: InputMaybe<TraderProfileModerationCaseVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TraderProfileModerationCase` objects. */
  varianceSample?: InputMaybe<TraderProfileModerationCaseVarianceSampleAggregateFilter>;
};

export type TraderProfileModerationCaseAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseAverageAggregates = {
  __typename?: 'TraderProfileModerationCaseAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TraderProfileModerationCase` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TraderProfileModerationCaseCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `submittedAt` field. */
  submittedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `traderId` field. */
  traderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `TraderProfileModerationCase` values. */
export type TraderProfileModerationCaseConnection = {
  __typename?: 'TraderProfileModerationCaseConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TraderProfileModerationCaseAggregates>;
  /** A list of edges which contains the `TraderProfileModerationCase` and cursor to aid in pagination. */
  edges: Array<Maybe<TraderProfileModerationCaseEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TraderProfileModerationCaseAggregates>>;
  /** A list of `TraderProfileModerationCase` objects. */
  nodes: Array<Maybe<TraderProfileModerationCase>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TraderProfileModerationCase` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TraderProfileModerationCase` values. */
export type TraderProfileModerationCaseConnectionGroupedAggregatesArgs = {
  groupBy: Array<TraderProfileModerationCaseGroupBy>;
  having?: InputMaybe<TraderProfileModerationCaseHavingInput>;
};

export type TraderProfileModerationCaseDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  submittedAt?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type TraderProfileModerationCaseDistinctCountAggregates = {
  __typename?: 'TraderProfileModerationCaseDistinctCountAggregates';
  /** Distinct count of allowedAt across the matching connection */
  allowedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of details across the matching connection */
  details?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rejectedAt across the matching connection */
  rejectedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of solvedAt across the matching connection */
  solvedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of source across the matching connection */
  source?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of submittedAt across the matching connection */
  submittedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of submittedBy across the matching connection */
  submittedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `TraderProfileModerationCase` edge in the connection. */
export type TraderProfileModerationCaseEdge = {
  __typename?: 'TraderProfileModerationCaseEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TraderProfileModerationCase` at the end of the edge. */
  node?: Maybe<TraderProfileModerationCase>;
};

/** A filter to be used against `TraderProfileModerationCase` object types. All fields are combined with a logical ‘and.’ */
export type TraderProfileModerationCaseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderProfileModerationCaseFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TraderProfileModerationCaseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderProfileModerationCaseFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `submittedAt` field. */
  submittedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trader` relation. */
  trader?: InputMaybe<UserFilter>;
  /** Filter by the object’s `traderId` field. */
  traderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderProfileModerationCaseHistoriesByCaseId` relation. */
  traderProfileModerationCaseHistoriesByCaseId?: InputMaybe<TraderProfileModerationCaseToManyTraderProfileModerationCaseHistoryFilter>;
  /** Some related `traderProfileModerationCaseHistoriesByCaseId` exist. */
  traderProfileModerationCaseHistoriesByCaseIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `TraderProfileModerationCase` for usage during aggregation. */
export enum TraderProfileModerationCaseGroupBy {
  SubmittedAt = 'SUBMITTED_AT',
  SubmittedAtTruncatedToDay = 'SUBMITTED_AT_TRUNCATED_TO_DAY',
  SubmittedAtTruncatedToHour = 'SUBMITTED_AT_TRUNCATED_TO_HOUR',
  TraderId = 'TRADER_ID'
}

export type TraderProfileModerationCaseHavingAverageInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingDistinctCountInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `TraderProfileModerationCase` aggregates. */
export type TraderProfileModerationCaseHavingInput = {
  AND?: InputMaybe<Array<TraderProfileModerationCaseHavingInput>>;
  OR?: InputMaybe<Array<TraderProfileModerationCaseHavingInput>>;
  average?: InputMaybe<TraderProfileModerationCaseHavingAverageInput>;
  distinctCount?: InputMaybe<TraderProfileModerationCaseHavingDistinctCountInput>;
  max?: InputMaybe<TraderProfileModerationCaseHavingMaxInput>;
  min?: InputMaybe<TraderProfileModerationCaseHavingMinInput>;
  stddevPopulation?: InputMaybe<TraderProfileModerationCaseHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TraderProfileModerationCaseHavingStddevSampleInput>;
  sum?: InputMaybe<TraderProfileModerationCaseHavingSumInput>;
  variancePopulation?: InputMaybe<TraderProfileModerationCaseHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TraderProfileModerationCaseHavingVarianceSampleInput>;
};

export type TraderProfileModerationCaseHavingMaxInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingMinInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingStddevPopulationInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingStddevSampleInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingSumInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingVariancePopulationInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHavingVarianceSampleInput = {
  allowedAt?: InputMaybe<HavingDatetimeFilter>;
  rejectedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  solvedAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
};

export type TraderProfileModerationCaseHistory = Node & {
  __typename?: 'TraderProfileModerationCaseHistory';
  /** Reads a single `TraderProfileModerationCase` that is related to this `TraderProfileModerationCaseHistory`. */
  case?: Maybe<TraderProfileModerationCase>;
  caseId: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['JSON']['output'];
  event: Scalars['String']['output'];
  eventDetail?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['UUID']['output'];
};

export type TraderProfileModerationCaseHistoryAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TraderProfileModerationCaseHistoryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TraderProfileModerationCaseHistoryDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TraderProfileModerationCaseHistoryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TraderProfileModerationCaseHistoryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TraderProfileModerationCaseHistoryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TraderProfileModerationCaseHistoryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TraderProfileModerationCaseHistorySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TraderProfileModerationCaseHistoryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TraderProfileModerationCaseHistoryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TraderProfileModerationCaseHistory` object types. */
export type TraderProfileModerationCaseHistoryAggregatesFilter = {
  /** Mean average aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  average?: InputMaybe<TraderProfileModerationCaseHistoryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  distinctCount?: InputMaybe<TraderProfileModerationCaseHistoryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TraderProfileModerationCaseHistory` object to be included within the aggregate. */
  filter?: InputMaybe<TraderProfileModerationCaseHistoryFilter>;
  /** Maximum aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  max?: InputMaybe<TraderProfileModerationCaseHistoryMaxAggregateFilter>;
  /** Minimum aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  min?: InputMaybe<TraderProfileModerationCaseHistoryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  stddevPopulation?: InputMaybe<TraderProfileModerationCaseHistoryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  stddevSample?: InputMaybe<TraderProfileModerationCaseHistoryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  sum?: InputMaybe<TraderProfileModerationCaseHistorySumAggregateFilter>;
  /** Population variance aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  variancePopulation?: InputMaybe<TraderProfileModerationCaseHistoryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TraderProfileModerationCaseHistory` objects. */
  varianceSample?: InputMaybe<TraderProfileModerationCaseHistoryVarianceSampleAggregateFilter>;
};

export type TraderProfileModerationCaseHistoryAverageAggregateFilter = {
  caseId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseHistoryAverageAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryAverageAggregates';
  /** Mean average of caseId across the matching connection */
  caseId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TraderProfileModerationCaseHistory` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type TraderProfileModerationCaseHistoryCondition = {
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `TraderProfileModerationCaseHistory` values. */
export type TraderProfileModerationCaseHistoryConnection = {
  __typename?: 'TraderProfileModerationCaseHistoryConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TraderProfileModerationCaseHistoryAggregates>;
  /** A list of edges which contains the `TraderProfileModerationCaseHistory` and cursor to aid in pagination. */
  edges: Array<Maybe<TraderProfileModerationCaseHistoryEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TraderProfileModerationCaseHistoryAggregates>>;
  /** A list of `TraderProfileModerationCaseHistory` objects. */
  nodes: Array<Maybe<TraderProfileModerationCaseHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TraderProfileModerationCaseHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TraderProfileModerationCaseHistory` values. */
export type TraderProfileModerationCaseHistoryConnectionGroupedAggregatesArgs = {
  groupBy: Array<TraderProfileModerationCaseHistoryGroupBy>;
  having?: InputMaybe<TraderProfileModerationCaseHistoryHavingInput>;
};

export type TraderProfileModerationCaseHistoryDistinctCountAggregateFilter = {
  caseId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type TraderProfileModerationCaseHistoryDistinctCountAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryDistinctCountAggregates';
  /** Distinct count of caseId across the matching connection */
  caseId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of event across the matching connection */
  event?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventDetail across the matching connection */
  eventDetail?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `TraderProfileModerationCaseHistory` edge in the connection. */
export type TraderProfileModerationCaseHistoryEdge = {
  __typename?: 'TraderProfileModerationCaseHistoryEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TraderProfileModerationCaseHistory` at the end of the edge. */
  node?: Maybe<TraderProfileModerationCaseHistory>;
};

/** A filter to be used against `TraderProfileModerationCaseHistory` object types. All fields are combined with a logical ‘and.’ */
export type TraderProfileModerationCaseHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderProfileModerationCaseHistoryFilter>>;
  /** Filter by the object’s `case` relation. */
  case?: InputMaybe<TraderProfileModerationCaseFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TraderProfileModerationCaseHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderProfileModerationCaseHistoryFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
};

/** Grouping methods for `TraderProfileModerationCaseHistory` for usage during aggregation. */
export enum TraderProfileModerationCaseHistoryGroupBy {
  CaseId = 'CASE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR'
}

export type TraderProfileModerationCaseHistoryHavingAverageInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingDistinctCountInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `TraderProfileModerationCaseHistory` aggregates. */
export type TraderProfileModerationCaseHistoryHavingInput = {
  AND?: InputMaybe<Array<TraderProfileModerationCaseHistoryHavingInput>>;
  OR?: InputMaybe<Array<TraderProfileModerationCaseHistoryHavingInput>>;
  average?: InputMaybe<TraderProfileModerationCaseHistoryHavingAverageInput>;
  distinctCount?: InputMaybe<TraderProfileModerationCaseHistoryHavingDistinctCountInput>;
  max?: InputMaybe<TraderProfileModerationCaseHistoryHavingMaxInput>;
  min?: InputMaybe<TraderProfileModerationCaseHistoryHavingMinInput>;
  stddevPopulation?: InputMaybe<TraderProfileModerationCaseHistoryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TraderProfileModerationCaseHistoryHavingStddevSampleInput>;
  sum?: InputMaybe<TraderProfileModerationCaseHistoryHavingSumInput>;
  variancePopulation?: InputMaybe<TraderProfileModerationCaseHistoryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TraderProfileModerationCaseHistoryHavingVarianceSampleInput>;
};

export type TraderProfileModerationCaseHistoryHavingMaxInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingMinInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingStddevPopulationInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingStddevSampleInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingSumInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingVariancePopulationInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryHavingVarianceSampleInput = {
  caseId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderProfileModerationCaseHistoryMaxAggregateFilter = {
  caseId?: InputMaybe<IntFilter>;
};

export type TraderProfileModerationCaseHistoryMaxAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryMaxAggregates';
  /** Maximum of caseId across the matching connection */
  caseId?: Maybe<Scalars['Int']['output']>;
};

export type TraderProfileModerationCaseHistoryMinAggregateFilter = {
  caseId?: InputMaybe<IntFilter>;
};

export type TraderProfileModerationCaseHistoryMinAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryMinAggregates';
  /** Minimum of caseId across the matching connection */
  caseId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `TraderProfileModerationCaseHistory`. */
export enum TraderProfileModerationCaseHistoryOrderBy {
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type TraderProfileModerationCaseHistoryStddevPopulationAggregateFilter = {
  caseId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseHistoryStddevPopulationAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryStddevPopulationAggregates';
  /** Population standard deviation of caseId across the matching connection */
  caseId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseHistoryStddevSampleAggregateFilter = {
  caseId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseHistoryStddevSampleAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryStddevSampleAggregates';
  /** Sample standard deviation of caseId across the matching connection */
  caseId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseHistorySumAggregateFilter = {
  caseId?: InputMaybe<BigIntFilter>;
};

export type TraderProfileModerationCaseHistorySumAggregates = {
  __typename?: 'TraderProfileModerationCaseHistorySumAggregates';
  /** Sum of caseId across the matching connection */
  caseId: Scalars['BigInt']['output'];
};

export type TraderProfileModerationCaseHistoryVariancePopulationAggregateFilter = {
  caseId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseHistoryVariancePopulationAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryVariancePopulationAggregates';
  /** Population variance of caseId across the matching connection */
  caseId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseHistoryVarianceSampleAggregateFilter = {
  caseId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseHistoryVarianceSampleAggregates = {
  __typename?: 'TraderProfileModerationCaseHistoryVarianceSampleAggregates';
  /** Sample variance of caseId across the matching connection */
  caseId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type TraderProfileModerationCaseMaxAggregates = {
  __typename?: 'TraderProfileModerationCaseMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
};

export type TraderProfileModerationCaseMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type TraderProfileModerationCaseMinAggregates = {
  __typename?: 'TraderProfileModerationCaseMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `TraderProfileModerationCase`. */
export enum TraderProfileModerationCaseOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SubmittedAtAsc = 'SUBMITTED_AT_ASC',
  SubmittedAtDesc = 'SUBMITTED_AT_DESC',
  TraderIdAsc = 'TRADER_ID_ASC',
  TraderIdDesc = 'TRADER_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdAverageCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_AVERAGE_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdAverageCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_AVERAGE_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdCountAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_COUNT_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdCountDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_COUNT_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdDistinctCountCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_DISTINCT_COUNT_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdDistinctCountCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_DISTINCT_COUNT_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdDistinctCountCreatedAtAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_DISTINCT_COUNT_CREATED_AT_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdDistinctCountCreatedAtDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_DISTINCT_COUNT_CREATED_AT_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdDistinctCountRowIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_DISTINCT_COUNT_ROW_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdDistinctCountRowIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_DISTINCT_COUNT_ROW_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdMaxCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_MAX_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdMaxCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_MAX_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdMinCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_MIN_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdMinCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_MIN_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdStddevPopulationCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_STDDEV_POPULATION_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdStddevPopulationCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_STDDEV_POPULATION_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdStddevSampleCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_STDDEV_SAMPLE_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdStddevSampleCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_STDDEV_SAMPLE_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdSumCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_SUM_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdSumCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_SUM_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdVariancePopulationCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_VARIANCE_POPULATION_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdVariancePopulationCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_VARIANCE_POPULATION_CASE_ID_DESC',
  TraderProfileModerationCaseHistoriesByCaseIdVarianceSampleCaseIdAsc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_VARIANCE_SAMPLE_CASE_ID_ASC',
  TraderProfileModerationCaseHistoriesByCaseIdVarianceSampleCaseIdDesc = 'TRADER_PROFILE_MODERATION_CASE_HISTORIES_BY_CASE_ID_VARIANCE_SAMPLE_CASE_ID_DESC'
}

export type TraderProfileModerationCaseStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseStddevPopulationAggregates = {
  __typename?: 'TraderProfileModerationCaseStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseStddevSampleAggregates = {
  __typename?: 'TraderProfileModerationCaseStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type TraderProfileModerationCaseSumAggregates = {
  __typename?: 'TraderProfileModerationCaseSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of traderId across the matching connection */
  traderId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `TraderProfileModerationCaseHistory` object types. All fields are combined with a logical ‘and.’ */
export type TraderProfileModerationCaseToManyTraderProfileModerationCaseHistoryFilter = {
  /** Aggregates across related `TraderProfileModerationCaseHistory` match the filter criteria. */
  aggregates?: InputMaybe<TraderProfileModerationCaseHistoryAggregatesFilter>;
  /** Every related `TraderProfileModerationCaseHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TraderProfileModerationCaseHistoryFilter>;
  /** No related `TraderProfileModerationCaseHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TraderProfileModerationCaseHistoryFilter>;
  /** Some related `TraderProfileModerationCaseHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TraderProfileModerationCaseHistoryFilter>;
};

export type TraderProfileModerationCaseVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseVariancePopulationAggregates = {
  __typename?: 'TraderProfileModerationCaseVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderProfileModerationCaseVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderProfileModerationCaseVarianceSampleAggregates = {
  __typename?: 'TraderProfileModerationCaseVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderPublicProfile = Node & {
  __typename?: 'TraderPublicProfile';
  /** Reads a single `TraderProfileAsset` that is related to this `TraderPublicProfile`. */
  bannerImageAsset?: Maybe<TraderProfileAsset>;
  bannerImageAssetId?: Maybe<Scalars['Int']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Coupon` that is related to this `TraderPublicProfile`. */
  coupon?: Maybe<Coupon>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Account` that is related to this `TraderPublicProfile`. */
  featuredAccount?: Maybe<Account>;
  featuredAccountId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isModerationBlocked: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  /** Reads a single `TraderProfileAsset` that is related to this `TraderPublicProfile`. */
  profileImageAsset?: Maybe<TraderProfileAsset>;
  profileImageAssetId?: Maybe<Scalars['Int']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProfileReport`. */
  profileReportsByReportedProfileId: ProfileReportConnection;
  publicDisplayName?: Maybe<Scalars['String']['output']>;
  publicTraderId: Scalars['UUID']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referralCodeExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  rowId: Scalars['Int']['output'];
  showAllTimePayouts: Scalars['Boolean']['output'];
  showBannerOnPublicProfile: Scalars['Boolean']['output'];
  showProfileImageOnPublicProfile: Scalars['Boolean']['output'];
  showProfitCalendarOnPublicProfile: Scalars['Boolean']['output'];
  showProofOfPayouts: Scalars['Boolean']['output'];
  showReferralCode: Scalars['Boolean']['output'];
  showSocialConnections: Scalars['Boolean']['output'];
  showTradingJourney: Scalars['Boolean']['output'];
  showTradingStatsOnPublicProfile: Scalars['Boolean']['output'];
  tradingMarket?: Maybe<Scalars['String']['output']>;
  tradingSession?: Maybe<Scalars['String']['output']>;
  tradingSetup?: Maybe<Scalars['String']['output']>;
  tradingWindow?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userHandle?: Maybe<Scalars['String']['output']>;
};


export type TraderPublicProfileProfileReportsByReportedProfileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProfileReportCondition>;
  filter?: InputMaybe<ProfileReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileReportOrderBy>>;
};

export type TraderPublicProfileAggregates = {
  __typename?: 'TraderPublicProfileAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TraderPublicProfileAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TraderPublicProfileDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TraderPublicProfileMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TraderPublicProfileMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TraderPublicProfileStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TraderPublicProfileStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TraderPublicProfileSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TraderPublicProfileVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TraderPublicProfileVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TraderPublicProfile` object types. */
export type TraderPublicProfileAggregatesFilter = {
  /** Mean average aggregate over matching `TraderPublicProfile` objects. */
  average?: InputMaybe<TraderPublicProfileAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TraderPublicProfile` objects. */
  distinctCount?: InputMaybe<TraderPublicProfileDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TraderPublicProfile` object to be included within the aggregate. */
  filter?: InputMaybe<TraderPublicProfileFilter>;
  /** Maximum aggregate over matching `TraderPublicProfile` objects. */
  max?: InputMaybe<TraderPublicProfileMaxAggregateFilter>;
  /** Minimum aggregate over matching `TraderPublicProfile` objects. */
  min?: InputMaybe<TraderPublicProfileMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TraderPublicProfile` objects. */
  stddevPopulation?: InputMaybe<TraderPublicProfileStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TraderPublicProfile` objects. */
  stddevSample?: InputMaybe<TraderPublicProfileStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TraderPublicProfile` objects. */
  sum?: InputMaybe<TraderPublicProfileSumAggregateFilter>;
  /** Population variance aggregate over matching `TraderPublicProfile` objects. */
  variancePopulation?: InputMaybe<TraderPublicProfileVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TraderPublicProfile` objects. */
  varianceSample?: InputMaybe<TraderPublicProfileVarianceSampleAggregateFilter>;
};

export type TraderPublicProfileAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TraderPublicProfileAverageAggregates = {
  __typename?: 'TraderPublicProfileAverageAggregates';
  /** Mean average of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TraderPublicProfile` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TraderPublicProfileCondition = {
  /** Checks for equality with the object’s `isPublished` field. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `publicTraderId` field. */
  publicTraderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userHandle` field. */
  userHandle?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `TraderPublicProfile` values. */
export type TraderPublicProfileConnection = {
  __typename?: 'TraderPublicProfileConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TraderPublicProfileAggregates>;
  /** A list of edges which contains the `TraderPublicProfile` and cursor to aid in pagination. */
  edges: Array<Maybe<TraderPublicProfileEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TraderPublicProfileAggregates>>;
  /** A list of `TraderPublicProfile` objects. */
  nodes: Array<Maybe<TraderPublicProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TraderPublicProfile` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TraderPublicProfile` values. */
export type TraderPublicProfileConnectionGroupedAggregatesArgs = {
  groupBy: Array<TraderPublicProfileGroupBy>;
  having?: InputMaybe<TraderPublicProfileHavingInput>;
};

export type TraderPublicProfileDistinctCountAggregateFilter = {
  isPublished?: InputMaybe<BigIntFilter>;
  publicTraderId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userHandle?: InputMaybe<BigIntFilter>;
};

export type TraderPublicProfileDistinctCountAggregates = {
  __typename?: 'TraderPublicProfileDistinctCountAggregates';
  /** Distinct count of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bannerImageUrl across the matching connection */
  bannerImageUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isModerationBlocked across the matching connection */
  isModerationBlocked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isPublished across the matching connection */
  isPublished?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of profileImageUrl across the matching connection */
  profileImageUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of publicDisplayName across the matching connection */
  publicDisplayName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of publicTraderId across the matching connection */
  publicTraderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of referralCode across the matching connection */
  referralCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of referralCodeExpiresAt across the matching connection */
  referralCodeExpiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showAllTimePayouts across the matching connection */
  showAllTimePayouts?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showBannerOnPublicProfile across the matching connection */
  showBannerOnPublicProfile?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showProfileImageOnPublicProfile across the matching connection */
  showProfileImageOnPublicProfile?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showProfitCalendarOnPublicProfile across the matching connection */
  showProfitCalendarOnPublicProfile?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showProofOfPayouts across the matching connection */
  showProofOfPayouts?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showReferralCode across the matching connection */
  showReferralCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showSocialConnections across the matching connection */
  showSocialConnections?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showTradingJourney across the matching connection */
  showTradingJourney?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of showTradingStatsOnPublicProfile across the matching connection */
  showTradingStatsOnPublicProfile?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingMarket across the matching connection */
  tradingMarket?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingSession across the matching connection */
  tradingSession?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingSetup across the matching connection */
  tradingSetup?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingWindow across the matching connection */
  tradingWindow?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userHandle across the matching connection */
  userHandle?: Maybe<Scalars['BigInt']['output']>;
};

/** A `TraderPublicProfile` edge in the connection. */
export type TraderPublicProfileEdge = {
  __typename?: 'TraderPublicProfileEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TraderPublicProfile` at the end of the edge. */
  node?: Maybe<TraderPublicProfile>;
};

/** A filter to be used against `TraderPublicProfile` object types. All fields are combined with a logical ‘and.’ */
export type TraderPublicProfileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderPublicProfileFilter>>;
  /** Filter by the object’s `bannerImageAsset` relation. */
  bannerImageAsset?: InputMaybe<TraderProfileAssetFilter>;
  /** A related `bannerImageAsset` exists. */
  bannerImageAssetExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `coupon` relation. */
  coupon?: InputMaybe<CouponFilter>;
  /** A related `coupon` exists. */
  couponExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `featuredAccount` relation. */
  featuredAccount?: InputMaybe<AccountFilter>;
  /** A related `featuredAccount` exists. */
  featuredAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `isPublished` field. */
  isPublished?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TraderPublicProfileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderPublicProfileFilter>>;
  /** Filter by the object’s `profileImageAsset` relation. */
  profileImageAsset?: InputMaybe<TraderProfileAssetFilter>;
  /** A related `profileImageAsset` exists. */
  profileImageAssetExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `profileReportsByReportedProfileId` relation. */
  profileReportsByReportedProfileId?: InputMaybe<TraderPublicProfileToManyProfileReportFilter>;
  /** Some related `profileReportsByReportedProfileId` exist. */
  profileReportsByReportedProfileIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `publicTraderId` field. */
  publicTraderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userHandle` field. */
  userHandle?: InputMaybe<StringFilter>;
};

/** Grouping methods for `TraderPublicProfile` for usage during aggregation. */
export enum TraderPublicProfileGroupBy {
  PublicTraderId = 'PUBLIC_TRADER_ID'
}

export type TraderPublicProfileHavingAverageInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingDistinctCountInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `TraderPublicProfile` aggregates. */
export type TraderPublicProfileHavingInput = {
  AND?: InputMaybe<Array<TraderPublicProfileHavingInput>>;
  OR?: InputMaybe<Array<TraderPublicProfileHavingInput>>;
  average?: InputMaybe<TraderPublicProfileHavingAverageInput>;
  distinctCount?: InputMaybe<TraderPublicProfileHavingDistinctCountInput>;
  max?: InputMaybe<TraderPublicProfileHavingMaxInput>;
  min?: InputMaybe<TraderPublicProfileHavingMinInput>;
  stddevPopulation?: InputMaybe<TraderPublicProfileHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TraderPublicProfileHavingStddevSampleInput>;
  sum?: InputMaybe<TraderPublicProfileHavingSumInput>;
  variancePopulation?: InputMaybe<TraderPublicProfileHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TraderPublicProfileHavingVarianceSampleInput>;
};

export type TraderPublicProfileHavingMaxInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingMinInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingStddevPopulationInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingStddevSampleInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingSumInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingVariancePopulationInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileHavingVarianceSampleInput = {
  bannerImageAssetId?: InputMaybe<HavingIntFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  featuredAccountId?: InputMaybe<HavingIntFilter>;
  profileImageAssetId?: InputMaybe<HavingIntFilter>;
  referralCodeExpiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderPublicProfileMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
};

export type TraderPublicProfileMaxAggregates = {
  __typename?: 'TraderPublicProfileMaxAggregates';
  /** Maximum of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type TraderPublicProfileMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
};

export type TraderPublicProfileMinAggregates = {
  __typename?: 'TraderPublicProfileMinAggregates';
  /** Minimum of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `TraderPublicProfile`. */
export enum TraderPublicProfileOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfileReportsByReportedProfileIdAverageReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_AVERAGE_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdAverageReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_AVERAGE_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdAverageRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_AVERAGE_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdAverageRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_AVERAGE_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdCountAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_COUNT_ASC',
  ProfileReportsByReportedProfileIdCountDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_COUNT_DESC',
  ProfileReportsByReportedProfileIdDistinctCountReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_DISTINCT_COUNT_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdDistinctCountReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_DISTINCT_COUNT_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdDistinctCountRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_DISTINCT_COUNT_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdDistinctCountRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_DISTINCT_COUNT_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdMaxReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MAX_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdMaxReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MAX_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdMaxRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MAX_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdMaxRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MAX_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdMinReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MIN_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdMinReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MIN_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdMinRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MIN_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdMinRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_MIN_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdStddevPopulationReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_POPULATION_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdStddevPopulationReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_POPULATION_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdStddevPopulationRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_POPULATION_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdStddevPopulationRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_POPULATION_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdStddevSampleReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_SAMPLE_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdStddevSampleReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_SAMPLE_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdStddevSampleRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdStddevSampleRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdSumReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_SUM_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdSumReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_SUM_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdSumRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_SUM_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdSumRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_SUM_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdVariancePopulationReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_POPULATION_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdVariancePopulationReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_POPULATION_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdVariancePopulationRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdVariancePopulationRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  ProfileReportsByReportedProfileIdVarianceSampleReportedProfileIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_SAMPLE_REPORTED_PROFILE_ID_ASC',
  ProfileReportsByReportedProfileIdVarianceSampleReportedProfileIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_SAMPLE_REPORTED_PROFILE_ID_DESC',
  ProfileReportsByReportedProfileIdVarianceSampleRowIdAsc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  ProfileReportsByReportedProfileIdVarianceSampleRowIdDesc = 'PROFILE_REPORTS_BY_REPORTED_PROFILE_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PublicTraderIdAsc = 'PUBLIC_TRADER_ID_ASC',
  PublicTraderIdDesc = 'PUBLIC_TRADER_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderProfileAssetsAverageRowIdAsc = 'TRADER_PROFILE_ASSETS_AVERAGE_ROW_ID_ASC',
  TraderProfileAssetsAverageRowIdDesc = 'TRADER_PROFILE_ASSETS_AVERAGE_ROW_ID_DESC',
  TraderProfileAssetsCountAsc = 'TRADER_PROFILE_ASSETS_COUNT_ASC',
  TraderProfileAssetsCountDesc = 'TRADER_PROFILE_ASSETS_COUNT_DESC',
  TraderProfileAssetsDistinctCountRowIdAsc = 'TRADER_PROFILE_ASSETS_DISTINCT_COUNT_ROW_ID_ASC',
  TraderProfileAssetsDistinctCountRowIdDesc = 'TRADER_PROFILE_ASSETS_DISTINCT_COUNT_ROW_ID_DESC',
  TraderProfileAssetsMaxRowIdAsc = 'TRADER_PROFILE_ASSETS_MAX_ROW_ID_ASC',
  TraderProfileAssetsMaxRowIdDesc = 'TRADER_PROFILE_ASSETS_MAX_ROW_ID_DESC',
  TraderProfileAssetsMinRowIdAsc = 'TRADER_PROFILE_ASSETS_MIN_ROW_ID_ASC',
  TraderProfileAssetsMinRowIdDesc = 'TRADER_PROFILE_ASSETS_MIN_ROW_ID_DESC',
  TraderProfileAssetsStddevPopulationRowIdAsc = 'TRADER_PROFILE_ASSETS_STDDEV_POPULATION_ROW_ID_ASC',
  TraderProfileAssetsStddevPopulationRowIdDesc = 'TRADER_PROFILE_ASSETS_STDDEV_POPULATION_ROW_ID_DESC',
  TraderProfileAssetsStddevSampleRowIdAsc = 'TRADER_PROFILE_ASSETS_STDDEV_SAMPLE_ROW_ID_ASC',
  TraderProfileAssetsStddevSampleRowIdDesc = 'TRADER_PROFILE_ASSETS_STDDEV_SAMPLE_ROW_ID_DESC',
  TraderProfileAssetsSumRowIdAsc = 'TRADER_PROFILE_ASSETS_SUM_ROW_ID_ASC',
  TraderProfileAssetsSumRowIdDesc = 'TRADER_PROFILE_ASSETS_SUM_ROW_ID_DESC',
  TraderProfileAssetsVariancePopulationRowIdAsc = 'TRADER_PROFILE_ASSETS_VARIANCE_POPULATION_ROW_ID_ASC',
  TraderProfileAssetsVariancePopulationRowIdDesc = 'TRADER_PROFILE_ASSETS_VARIANCE_POPULATION_ROW_ID_DESC',
  TraderProfileAssetsVarianceSampleRowIdAsc = 'TRADER_PROFILE_ASSETS_VARIANCE_SAMPLE_ROW_ID_ASC',
  TraderProfileAssetsVarianceSampleRowIdDesc = 'TRADER_PROFILE_ASSETS_VARIANCE_SAMPLE_ROW_ID_DESC'
}

/** Represents an update to a `TraderPublicProfile`. Fields that are set will be updated. */
export type TraderPublicProfilePatch = {
  bannerImageAssetId?: InputMaybe<Scalars['Int']['input']>;
  featuredAccountId?: InputMaybe<Scalars['Int']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  profileImageAssetId?: InputMaybe<Scalars['Int']['input']>;
  publicDisplayName?: InputMaybe<Scalars['String']['input']>;
  showAllTimePayouts?: InputMaybe<Scalars['Boolean']['input']>;
  showBannerOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showProfileImageOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showProfitCalendarOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showProofOfPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  showSocialConnections?: InputMaybe<Scalars['Boolean']['input']>;
  showTradingJourney?: InputMaybe<Scalars['Boolean']['input']>;
  showTradingStatsOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TraderPublicProfileStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TraderPublicProfileStddevPopulationAggregates = {
  __typename?: 'TraderPublicProfileStddevPopulationAggregates';
  /** Population standard deviation of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderPublicProfileStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TraderPublicProfileStddevSampleAggregates = {
  __typename?: 'TraderPublicProfileStddevSampleAggregates';
  /** Sample standard deviation of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderPublicProfileSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
};

export type TraderPublicProfileSumAggregates = {
  __typename?: 'TraderPublicProfileSumAggregates';
  /** Sum of bannerImageAssetId across the matching connection */
  bannerImageAssetId: Scalars['BigInt']['output'];
  /** Sum of couponId across the matching connection */
  couponId: Scalars['BigInt']['output'];
  /** Sum of featuredAccountId across the matching connection */
  featuredAccountId: Scalars['BigInt']['output'];
  /** Sum of profileImageAssetId across the matching connection */
  profileImageAssetId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `ProfileReport` object types. All fields are combined with a logical ‘and.’ */
export type TraderPublicProfileToManyProfileReportFilter = {
  /** Aggregates across related `ProfileReport` match the filter criteria. */
  aggregates?: InputMaybe<ProfileReportAggregatesFilter>;
  /** Every related `ProfileReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProfileReportFilter>;
  /** No related `ProfileReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProfileReportFilter>;
  /** Some related `ProfileReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProfileReportFilter>;
};

export type TraderPublicProfileVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TraderPublicProfileVariancePopulationAggregates = {
  __typename?: 'TraderPublicProfileVariancePopulationAggregates';
  /** Population variance of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderPublicProfileVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TraderPublicProfileVarianceSampleAggregates = {
  __typename?: 'TraderPublicProfileVarianceSampleAggregates';
  /** Sample variance of bannerImageAssetId across the matching connection */
  bannerImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of featuredAccountId across the matching connection */
  featuredAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of profileImageAssetId across the matching connection */
  profileImageAssetId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderRiskIndicator = Node & {
  __typename?: 'TraderRiskIndicator';
  createdAt: Scalars['Datetime']['output'];
  eventLog: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  resolvedAt?: Maybe<Scalars['Datetime']['output']>;
  resolvedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `User` that is related to this `TraderRiskIndicator`. */
  resolver?: Maybe<User>;
  rowId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `TraderRiskIndicator`. */
  trader?: Maybe<User>;
  traderId: Scalars['Int']['output'];
  /** Reads a single `TraderRiskIndicatorOwner` that is related to this `TraderRiskIndicator`. */
  traderRiskIndicatorOwner?: Maybe<TraderRiskIndicatorOwner>;
  updatedAt: Scalars['Datetime']['output'];
};

export type TraderRiskIndicatorAggregates = {
  __typename?: 'TraderRiskIndicatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TraderRiskIndicatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TraderRiskIndicatorDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TraderRiskIndicatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TraderRiskIndicatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TraderRiskIndicatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TraderRiskIndicatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TraderRiskIndicatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TraderRiskIndicatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TraderRiskIndicatorVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TraderRiskIndicator` object types. */
export type TraderRiskIndicatorAggregatesFilter = {
  /** Mean average aggregate over matching `TraderRiskIndicator` objects. */
  average?: InputMaybe<TraderRiskIndicatorAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TraderRiskIndicator` objects. */
  distinctCount?: InputMaybe<TraderRiskIndicatorDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TraderRiskIndicator` object to be included within the aggregate. */
  filter?: InputMaybe<TraderRiskIndicatorFilter>;
  /** Maximum aggregate over matching `TraderRiskIndicator` objects. */
  max?: InputMaybe<TraderRiskIndicatorMaxAggregateFilter>;
  /** Minimum aggregate over matching `TraderRiskIndicator` objects. */
  min?: InputMaybe<TraderRiskIndicatorMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TraderRiskIndicator` objects. */
  stddevPopulation?: InputMaybe<TraderRiskIndicatorStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TraderRiskIndicator` objects. */
  stddevSample?: InputMaybe<TraderRiskIndicatorStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TraderRiskIndicator` objects. */
  sum?: InputMaybe<TraderRiskIndicatorSumAggregateFilter>;
  /** Population variance aggregate over matching `TraderRiskIndicator` objects. */
  variancePopulation?: InputMaybe<TraderRiskIndicatorVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TraderRiskIndicator` objects. */
  varianceSample?: InputMaybe<TraderRiskIndicatorVarianceSampleAggregateFilter>;
};

export type TraderRiskIndicatorAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderRiskIndicatorAverageAggregates = {
  __typename?: 'TraderRiskIndicatorAverageAggregates';
  /** Mean average of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TraderRiskIndicator` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TraderRiskIndicatorCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `traderId` field. */
  traderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `TraderRiskIndicator` values. */
export type TraderRiskIndicatorConnection = {
  __typename?: 'TraderRiskIndicatorConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TraderRiskIndicatorAggregates>;
  /** A list of edges which contains the `TraderRiskIndicator` and cursor to aid in pagination. */
  edges: Array<Maybe<TraderRiskIndicatorEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TraderRiskIndicatorAggregates>>;
  /** A list of `TraderRiskIndicator` objects. */
  nodes: Array<Maybe<TraderRiskIndicator>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TraderRiskIndicator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TraderRiskIndicator` values. */
export type TraderRiskIndicatorConnectionGroupedAggregatesArgs = {
  groupBy: Array<TraderRiskIndicatorGroupBy>;
  having?: InputMaybe<TraderRiskIndicatorHavingInput>;
};

export type TraderRiskIndicatorDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type TraderRiskIndicatorDistinctCountAggregates = {
  __typename?: 'TraderRiskIndicatorDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resolvedAt across the matching connection */
  resolvedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `TraderRiskIndicator` edge in the connection. */
export type TraderRiskIndicatorEdge = {
  __typename?: 'TraderRiskIndicatorEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TraderRiskIndicator` at the end of the edge. */
  node?: Maybe<TraderRiskIndicator>;
};

/** A filter to be used against `TraderRiskIndicator` object types. All fields are combined with a logical ‘and.’ */
export type TraderRiskIndicatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderRiskIndicatorFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TraderRiskIndicatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderRiskIndicatorFilter>>;
  /** Filter by the object’s `resolver` relation. */
  resolver?: InputMaybe<UserFilter>;
  /** A related `resolver` exists. */
  resolverExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `trader` relation. */
  trader?: InputMaybe<UserFilter>;
  /** Filter by the object’s `traderId` field. */
  traderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderRiskIndicatorOwner` relation. */
  traderRiskIndicatorOwner?: InputMaybe<TraderRiskIndicatorOwnerFilter>;
  /** A related `traderRiskIndicatorOwner` exists. */
  traderRiskIndicatorOwnerExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `TraderRiskIndicator` for usage during aggregation. */
export enum TraderRiskIndicatorGroupBy {
  TraderId = 'TRADER_ID'
}

export type TraderRiskIndicatorHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `TraderRiskIndicator` aggregates. */
export type TraderRiskIndicatorHavingInput = {
  AND?: InputMaybe<Array<TraderRiskIndicatorHavingInput>>;
  OR?: InputMaybe<Array<TraderRiskIndicatorHavingInput>>;
  average?: InputMaybe<TraderRiskIndicatorHavingAverageInput>;
  distinctCount?: InputMaybe<TraderRiskIndicatorHavingDistinctCountInput>;
  max?: InputMaybe<TraderRiskIndicatorHavingMaxInput>;
  min?: InputMaybe<TraderRiskIndicatorHavingMinInput>;
  stddevPopulation?: InputMaybe<TraderRiskIndicatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TraderRiskIndicatorHavingStddevSampleInput>;
  sum?: InputMaybe<TraderRiskIndicatorHavingSumInput>;
  variancePopulation?: InputMaybe<TraderRiskIndicatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TraderRiskIndicatorHavingVarianceSampleInput>;
};

export type TraderRiskIndicatorHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TraderRiskIndicatorHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedAt?: InputMaybe<HavingDatetimeFilter>;
  resolvedBy?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  traderId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `TraderRiskIndicator` */
export type TraderRiskIndicatorInput = {
  eventLog?: InputMaybe<Scalars['JSON']['input']>;
  traderId: Scalars['Int']['input'];
};

export type TraderRiskIndicatorMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type TraderRiskIndicatorMaxAggregates = {
  __typename?: 'TraderRiskIndicatorMaxAggregates';
  /** Maximum of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
};

export type TraderRiskIndicatorMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  traderId?: InputMaybe<IntFilter>;
};

export type TraderRiskIndicatorMinAggregates = {
  __typename?: 'TraderRiskIndicatorMinAggregates';
  /** Minimum of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of traderId across the matching connection */
  traderId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `TraderRiskIndicator`. */
export enum TraderRiskIndicatorOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  TraderIdAsc = 'TRADER_ID_ASC',
  TraderIdDesc = 'TRADER_ID_DESC'
}

export type TraderRiskIndicatorOwner = Node & {
  __typename?: 'TraderRiskIndicatorOwner';
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  ownerId?: Maybe<Scalars['Int']['output']>;
  ownerType: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `TraderRiskIndicator` that is related to this `TraderRiskIndicatorOwner`. */
  traderRiskIndicator?: Maybe<TraderRiskIndicator>;
  traderRiskIndicatorId: Scalars['Int']['output'];
};

/** A filter to be used against `TraderRiskIndicatorOwner` object types. All fields are combined with a logical ‘and.’ */
export type TraderRiskIndicatorOwnerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TraderRiskIndicatorOwnerFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TraderRiskIndicatorOwnerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TraderRiskIndicatorOwnerFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ownerType` field. */
  ownerType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `traderRiskIndicator` relation. */
  traderRiskIndicator?: InputMaybe<TraderRiskIndicatorFilter>;
  /** Filter by the object’s `traderRiskIndicatorId` field. */
  traderRiskIndicatorId?: InputMaybe<IntFilter>;
};

/** Represents an update to a `TraderRiskIndicator`. Fields that are set will be updated. */
export type TraderRiskIndicatorPatch = {
  eventLog?: InputMaybe<Scalars['JSON']['input']>;
  resolvedAt?: InputMaybe<Scalars['Datetime']['input']>;
  resolvedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type TraderRiskIndicatorStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderRiskIndicatorStddevPopulationAggregates = {
  __typename?: 'TraderRiskIndicatorStddevPopulationAggregates';
  /** Population standard deviation of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderRiskIndicatorStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderRiskIndicatorStddevSampleAggregates = {
  __typename?: 'TraderRiskIndicatorStddevSampleAggregates';
  /** Sample standard deviation of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderRiskIndicatorSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  traderId?: InputMaybe<BigIntFilter>;
};

export type TraderRiskIndicatorSumAggregates = {
  __typename?: 'TraderRiskIndicatorSumAggregates';
  /** Sum of resolvedBy across the matching connection */
  resolvedBy: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of traderId across the matching connection */
  traderId: Scalars['BigInt']['output'];
};

export type TraderRiskIndicatorVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderRiskIndicatorVariancePopulationAggregates = {
  __typename?: 'TraderRiskIndicatorVariancePopulationAggregates';
  /** Population variance of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TraderRiskIndicatorVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  traderId?: InputMaybe<BigFloatFilter>;
};

export type TraderRiskIndicatorVarianceSampleAggregates = {
  __typename?: 'TraderRiskIndicatorVarianceSampleAggregates';
  /** Sample variance of resolvedBy across the matching connection */
  resolvedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of traderId across the matching connection */
  traderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingHabits = {
  __typename?: 'TradingHabits';
  accountName: Scalars['String']['output'];
  bestDayDate?: Maybe<Scalars['String']['output']>;
  bestDayProfit: Scalars['Float']['output'];
  consistencyTargetPercentage: Scalars['Float']['output'];
  profitFactor: Scalars['Float']['output'];
  tradeWinPercentage: Scalars['Float']['output'];
};

export type TradingOverview = {
  __typename?: 'TradingOverview';
  averageLosingTrade: Scalars['Float']['output'];
  averageTradeDuration?: Maybe<Scalars['String']['output']>;
  averageWinningTrade: Scalars['Float']['output'];
  consistency: Scalars['Float']['output'];
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  totalPnL: Scalars['Float']['output'];
  tradeWinPercentage: Scalars['Float']['output'];
  tradingDate?: Maybe<Scalars['String']['output']>;
  tradingDayCount: Scalars['Int']['output'];
  tradingSession?: Maybe<Scalars['String']['output']>;
};

export type TradingProduct = Node & {
  __typename?: 'TradingProduct';
  createdAt: Scalars['Datetime']['output'];
  exchange: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `TradingProductFee`. */
  tradingProductFees: TradingProductFeeConnection;
  updatedAt: Scalars['Datetime']['output'];
};


export type TradingProductTradingProductFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingProductFeeCondition>;
  filter?: InputMaybe<TradingProductFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingProductFeeOrderBy>>;
};

export type TradingProductFee = Node & {
  __typename?: 'TradingProductFee';
  commission: Scalars['Float']['output'];
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  effectiveAt: Scalars['Datetime']['output'];
  exchangeFee: Scalars['Float']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  isMicros: Scalars['Boolean']['output'];
  /** Reads a single `Platform` that is related to this `TradingProductFee`. */
  platform?: Maybe<Platform>;
  platformId: Scalars['Int']['output'];
  /** Reads a single `TradingProduct` that is related to this `TradingProductFee`. */
  product?: Maybe<TradingProduct>;
  productId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  tickSize: Scalars['Float']['output'];
  tickValue: Scalars['Float']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type TradingProductFeeAggregates = {
  __typename?: 'TradingProductFeeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingProductFeeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingProductFeeDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingProductFeeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingProductFeeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingProductFeeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingProductFeeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingProductFeeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingProductFeeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingProductFeeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TradingProductFee` object types. */
export type TradingProductFeeAggregatesFilter = {
  /** Mean average aggregate over matching `TradingProductFee` objects. */
  average?: InputMaybe<TradingProductFeeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TradingProductFee` objects. */
  distinctCount?: InputMaybe<TradingProductFeeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TradingProductFee` object to be included within the aggregate. */
  filter?: InputMaybe<TradingProductFeeFilter>;
  /** Maximum aggregate over matching `TradingProductFee` objects. */
  max?: InputMaybe<TradingProductFeeMaxAggregateFilter>;
  /** Minimum aggregate over matching `TradingProductFee` objects. */
  min?: InputMaybe<TradingProductFeeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TradingProductFee` objects. */
  stddevPopulation?: InputMaybe<TradingProductFeeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TradingProductFee` objects. */
  stddevSample?: InputMaybe<TradingProductFeeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TradingProductFee` objects. */
  sum?: InputMaybe<TradingProductFeeSumAggregateFilter>;
  /** Population variance aggregate over matching `TradingProductFee` objects. */
  variancePopulation?: InputMaybe<TradingProductFeeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TradingProductFee` objects. */
  varianceSample?: InputMaybe<TradingProductFeeVarianceSampleAggregateFilter>;
};

export type TradingProductFeeAverageAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TradingProductFeeAverageAggregates = {
  __typename?: 'TradingProductFeeAverageAggregates';
  /** Mean average of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Mean average of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Mean average of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Mean average of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

/**
 * A condition to be used against `TradingProductFee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TradingProductFeeCondition = {
  /** Checks for equality with the object’s `effectiveAt` field. */
  effectiveAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `platformId` field. */
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `TradingProductFee` values. */
export type TradingProductFeeConnection = {
  __typename?: 'TradingProductFeeConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingProductFeeAggregates>;
  /** A list of edges which contains the `TradingProductFee` and cursor to aid in pagination. */
  edges: Array<Maybe<TradingProductFeeEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingProductFeeAggregates>>;
  /** A list of `TradingProductFee` objects. */
  nodes: Array<Maybe<TradingProductFee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingProductFee` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingProductFee` values. */
export type TradingProductFeeConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingProductFeeGroupBy>;
  having?: InputMaybe<TradingProductFeeHavingInput>;
};

export type TradingProductFeeDistinctCountAggregateFilter = {
  effectiveAt?: InputMaybe<BigIntFilter>;
  platformId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type TradingProductFeeDistinctCountAggregates = {
  __typename?: 'TradingProductFeeDistinctCountAggregates';
  /** Distinct count of commission across the matching connection */
  commission?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of effectiveAt across the matching connection */
  effectiveAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isMicros across the matching connection */
  isMicros?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of productId across the matching connection */
  productId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `TradingProductFee` edge in the connection. */
export type TradingProductFeeEdge = {
  __typename?: 'TradingProductFeeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingProductFee` at the end of the edge. */
  node?: Maybe<TradingProductFee>;
};

/** A filter to be used against `TradingProductFee` object types. All fields are combined with a logical ‘and.’ */
export type TradingProductFeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingProductFeeFilter>>;
  /** Filter by the object’s `effectiveAt` field. */
  effectiveAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingProductFeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingProductFeeFilter>>;
  /** Filter by the object’s `platform` relation. */
  platform?: InputMaybe<PlatformFilter>;
  /** Filter by the object’s `platformId` field. */
  platformId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<TradingProductFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `TradingProductFee` for usage during aggregation. */
export enum TradingProductFeeGroupBy {
  EffectiveAt = 'EFFECTIVE_AT',
  EffectiveAtTruncatedToDay = 'EFFECTIVE_AT_TRUNCATED_TO_DAY',
  EffectiveAtTruncatedToHour = 'EFFECTIVE_AT_TRUNCATED_TO_HOUR',
  PlatformId = 'PLATFORM_ID',
  ProductId = 'PRODUCT_ID'
}

export type TradingProductFeeHavingAverageInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingDistinctCountInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `TradingProductFee` aggregates. */
export type TradingProductFeeHavingInput = {
  AND?: InputMaybe<Array<TradingProductFeeHavingInput>>;
  OR?: InputMaybe<Array<TradingProductFeeHavingInput>>;
  average?: InputMaybe<TradingProductFeeHavingAverageInput>;
  distinctCount?: InputMaybe<TradingProductFeeHavingDistinctCountInput>;
  max?: InputMaybe<TradingProductFeeHavingMaxInput>;
  min?: InputMaybe<TradingProductFeeHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingProductFeeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingProductFeeHavingStddevSampleInput>;
  sum?: InputMaybe<TradingProductFeeHavingSumInput>;
  variancePopulation?: InputMaybe<TradingProductFeeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingProductFeeHavingVarianceSampleInput>;
};

export type TradingProductFeeHavingMaxInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingMinInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingStddevPopulationInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingStddevSampleInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingSumInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingVariancePopulationInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TradingProductFeeHavingVarianceSampleInput = {
  commission?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  effectiveAt?: InputMaybe<HavingDatetimeFilter>;
  exchangeFee?: InputMaybe<HavingFloatFilter>;
  platformId?: InputMaybe<HavingIntFilter>;
  productId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tickSize?: InputMaybe<HavingFloatFilter>;
  tickValue?: InputMaybe<HavingFloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `TradingProductFee` */
export type TradingProductFeeInput = {
  commission: Scalars['Float']['input'];
  effectiveAt: Scalars['Datetime']['input'];
  exchangeFee: Scalars['Float']['input'];
  isMicros?: InputMaybe<Scalars['Boolean']['input']>;
  platformId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  tickSize: Scalars['Float']['input'];
  tickValue: Scalars['Float']['input'];
};

export type TradingProductFeeMaxAggregateFilter = {
  platformId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type TradingProductFeeMaxAggregates = {
  __typename?: 'TradingProductFeeMaxAggregates';
  /** Maximum of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Maximum of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Maximum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Maximum of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

export type TradingProductFeeMinAggregateFilter = {
  platformId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type TradingProductFeeMinAggregates = {
  __typename?: 'TradingProductFeeMinAggregates';
  /** Minimum of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Minimum of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Minimum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of productId across the matching connection */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Minimum of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

/** Methods to use when ordering `TradingProductFee`. */
export enum TradingProductFeeOrderBy {
  EffectiveAtAsc = 'EFFECTIVE_AT_ASC',
  EffectiveAtDesc = 'EFFECTIVE_AT_DESC',
  Natural = 'NATURAL',
  PlatformIdAsc = 'PLATFORM_ID_ASC',
  PlatformIdDesc = 'PLATFORM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

/** Represents an update to a `TradingProductFee`. Fields that are set will be updated. */
export type TradingProductFeePatch = {
  commission?: InputMaybe<Scalars['Float']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  effectiveAt?: InputMaybe<Scalars['Datetime']['input']>;
  exchangeFee?: InputMaybe<Scalars['Float']['input']>;
  isMicros?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  tickSize?: InputMaybe<Scalars['Float']['input']>;
  tickValue?: InputMaybe<Scalars['Float']['input']>;
};

export type TradingProductFeeStddevPopulationAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TradingProductFeeStddevPopulationAggregates = {
  __typename?: 'TradingProductFeeStddevPopulationAggregates';
  /** Population standard deviation of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

export type TradingProductFeeStddevSampleAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TradingProductFeeStddevSampleAggregates = {
  __typename?: 'TradingProductFeeStddevSampleAggregates';
  /** Sample standard deviation of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

export type TradingProductFeeSumAggregateFilter = {
  platformId?: InputMaybe<BigIntFilter>;
  productId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type TradingProductFeeSumAggregates = {
  __typename?: 'TradingProductFeeSumAggregates';
  /** Sum of commission across the matching connection */
  commission: Scalars['Float']['output'];
  /** Sum of exchangeFee across the matching connection */
  exchangeFee: Scalars['Float']['output'];
  /** Sum of platformId across the matching connection */
  platformId: Scalars['BigInt']['output'];
  /** Sum of productId across the matching connection */
  productId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of tickSize across the matching connection */
  tickSize: Scalars['Float']['output'];
  /** Sum of tickValue across the matching connection */
  tickValue: Scalars['Float']['output'];
};

export type TradingProductFeeVariancePopulationAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TradingProductFeeVariancePopulationAggregates = {
  __typename?: 'TradingProductFeeVariancePopulationAggregates';
  /** Population variance of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Population variance of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Population variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Population variance of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

export type TradingProductFeeVarianceSampleAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  productId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type TradingProductFeeVarianceSampleAggregates = {
  __typename?: 'TradingProductFeeVarianceSampleAggregates';
  /** Sample variance of commission across the matching connection */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of exchangeFee across the matching connection */
  exchangeFee?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of productId across the matching connection */
  productId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tickSize across the matching connection */
  tickSize?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of tickValue across the matching connection */
  tickValue?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `TradingProduct` object types. All fields are combined with a logical ‘and.’ */
export type TradingProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingProductFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TradingProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingProductFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tradingProductFees` relation. */
  tradingProductFees?: InputMaybe<TradingProductToManyTradingProductFeeFilter>;
  /** Some related `tradingProductFees` exist. */
  tradingProductFeesExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `TradingProductFee` object types. All fields are combined with a logical ‘and.’ */
export type TradingProductToManyTradingProductFeeFilter = {
  /** Aggregates across related `TradingProductFee` match the filter criteria. */
  aggregates?: InputMaybe<TradingProductFeeAggregatesFilter>;
  /** Every related `TradingProductFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingProductFeeFilter>;
  /** No related `TradingProductFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingProductFeeFilter>;
  /** Some related `TradingProductFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingProductFeeFilter>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UnifiedSubscription = Node & {
  __typename?: 'UnifiedSubscription';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  associatedAccountId?: Maybe<Scalars['Int']['output']>;
  associatedAccountName?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  couponIsRecurring?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  externalProcessor?: Maybe<Scalars['String']['output']>;
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Subscription ID from source table. NOT unique alone - use with source column. */
  rowId: Scalars['Int']['output'];
  serviceAccessUntil?: Maybe<Scalars['Datetime']['output']>;
  /** v1 = Nuvei (legacy Subscription table), v2 = NMI (NMISubscription table) */
  source: Scalars['String']['output'];
  subscriptionCancelledAt?: Maybe<Scalars['Datetime']['output']>;
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Result of unlinking the current user's Discord account. */
export type UnlinkDiscordPayload = {
  __typename?: 'UnlinkDiscordPayload';
  /** Human-readable message (e.g. confirmation or error reason). */
  message: Scalars['String']['output'];
  /** Whether the unlink completed successfully. */
  success: Scalars['Boolean']['output'];
};

export type UnsetCaseBanPendingStatusInput = {
  banId: Scalars['Int']['input'];
  traderIds: Array<Scalars['Int']['input']>;
};

export type UnsetCaseInvestigationPendingStatusInput = {
  investigationId: Scalars['Int']['input'];
  traderIds: Array<Scalars['Int']['input']>;
};

/** All input for the `updateAccountStatById` mutation. */
export type UpdateAccountStatByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AccountStat` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `AccountStat` being updated. */
  patch: AccountStatPatch;
};

/** All input for the `updateAccountStat` mutation. */
export type UpdateAccountStatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `AccountStat` being updated. */
  patch: AccountStatPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `AccountStat` mutation. */
export type UpdateAccountStatPayload = {
  __typename?: 'UpdateAccountStatPayload';
  /** The `AccountStat` that was updated by this mutation. */
  accountStat?: Maybe<AccountStat>;
  /** An edge for our `AccountStat`. May be used by Relay 1. */
  accountStatEdge?: Maybe<AccountStatEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AccountStat` mutation. */
export type UpdateAccountStatPayloadAccountStatEdgeArgs = {
  orderBy?: Array<AccountStatOrderBy>;
};

/** All input for the `updateAdminConfigByConfigKey` mutation. */
export type UpdateAdminConfigByConfigKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the configuration (e.g., TRADE_DATA_BACKFILL) */
  configKey: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `AdminConfig` being updated. */
  patch: AdminConfigPatch;
};

/** All input for the `updateAdminConfigById` mutation. */
export type UpdateAdminConfigByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AdminConfig` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `AdminConfig` being updated. */
  patch: AdminConfigPatch;
};

/** All input for the `updateAdminConfig` mutation. */
export type UpdateAdminConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `AdminConfig` being updated. */
  patch: AdminConfigPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `AdminConfig` mutation. */
export type UpdateAdminConfigPayload = {
  __typename?: 'UpdateAdminConfigPayload';
  /** The `AdminConfig` that was updated by this mutation. */
  adminConfig?: Maybe<AdminConfig>;
  /** An edge for our `AdminConfig`. May be used by Relay 1. */
  adminConfigEdge?: Maybe<AdminConfigEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AdminConfig` mutation. */
export type UpdateAdminConfigPayloadAdminConfigEdgeArgs = {
  orderBy?: Array<AdminConfigOrderBy>;
};

export type UpdateCaseBanInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  reasonCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  severity?: InputMaybe<CaseSeverity>;
};

export type UpdateCaseInvestigationInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  caseTypeId?: InputMaybe<Scalars['Int']['input']>;
  departmentGroupId?: InputMaybe<Scalars['String']['input']>;
  fitSheet?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<CaseSeverity>;
};

/** All input for the `updateImpactGroupAssignmentById` mutation. */
export type UpdateImpactGroupAssignmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ImpactGroupAssignment` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ImpactGroupAssignment` being updated. */
  patch: ImpactGroupAssignmentPatch;
};

/** All input for the `updateImpactGroupAssignment` mutation. */
export type UpdateImpactGroupAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ImpactGroupAssignment` being updated. */
  patch: ImpactGroupAssignmentPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `ImpactGroupAssignment` mutation. */
export type UpdateImpactGroupAssignmentPayload = {
  __typename?: 'UpdateImpactGroupAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ImpactGroupAssignment` that was updated by this mutation. */
  impactGroupAssignment?: Maybe<ImpactGroupAssignment>;
  /** An edge for our `ImpactGroupAssignment`. May be used by Relay 1. */
  impactGroupAssignmentEdge?: Maybe<ImpactGroupAssignmentEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ImpactGroupAssignment` mutation. */
export type UpdateImpactGroupAssignmentPayloadImpactGroupAssignmentEdgeArgs = {
  orderBy?: Array<ImpactGroupAssignmentOrderBy>;
};

/** All input for the `updateImpactGroupTemplateById` mutation. */
export type UpdateImpactGroupTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ImpactGroupTemplate` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ImpactGroupTemplate` being updated. */
  patch: ImpactGroupTemplatePatch;
};

/** All input for the `updateImpactGroupTemplateByLabelAndScope` mutation. */
export type UpdateImpactGroupTemplateByLabelAndScopeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ImpactGroupTemplate` being updated. */
  patch: ImpactGroupTemplatePatch;
  scope: Scalars['String']['input'];
};

/** All input for the `updateImpactGroupTemplateBySlug` mutation. */
export type UpdateImpactGroupTemplateBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ImpactGroupTemplate` being updated. */
  patch: ImpactGroupTemplatePatch;
  slug: Scalars['String']['input'];
};

/** All input for the `updateImpactGroupTemplate` mutation. */
export type UpdateImpactGroupTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ImpactGroupTemplate` being updated. */
  patch: ImpactGroupTemplatePatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `ImpactGroupTemplate` mutation. */
export type UpdateImpactGroupTemplatePayload = {
  __typename?: 'UpdateImpactGroupTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ImpactGroupTemplate` that was updated by this mutation. */
  impactGroupTemplate?: Maybe<ImpactGroupTemplate>;
  /** An edge for our `ImpactGroupTemplate`. May be used by Relay 1. */
  impactGroupTemplateEdge?: Maybe<ImpactGroupTemplateEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ImpactGroupTemplate` mutation. */
export type UpdateImpactGroupTemplatePayloadImpactGroupTemplateEdgeArgs = {
  orderBy?: Array<ImpactGroupTemplateOrderBy>;
};

/** All input for the `updateKycPriorityLabelById` mutation. */
export type UpdateKycPriorityLabelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `KycPriorityLabel` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `KycPriorityLabel` being updated. */
  patch: KycPriorityLabelPatch;
};

/** All input for the `updateKycPriorityLabel` mutation. */
export type UpdateKycPriorityLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `KycPriorityLabel` being updated. */
  patch: KycPriorityLabelPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `KycPriorityLabel` mutation. */
export type UpdateKycPriorityLabelPayload = {
  __typename?: 'UpdateKycPriorityLabelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `KycPriorityLabel` that was updated by this mutation. */
  kycPriorityLabel?: Maybe<KycPriorityLabel>;
  /** An edge for our `KycPriorityLabel`. May be used by Relay 1. */
  kycPriorityLabelEdge?: Maybe<KycPriorityLabelEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `KycPriorityLabel` mutation. */
export type UpdateKycPriorityLabelPayloadKycPriorityLabelEdgeArgs = {
  orderBy?: Array<KycPriorityLabelOrderBy>;
};

export type UpdateMyTraderPublicProfileInput = {
  bannerImageAssetId?: InputMaybe<Scalars['Int']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  drawdownType?: InputMaybe<Scalars['String']['input']>;
  featuredAccountId?: InputMaybe<Scalars['Int']['input']>;
  profileImageAssetId?: InputMaybe<Scalars['Int']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  showAllTimePayouts?: InputMaybe<Scalars['Boolean']['input']>;
  showBannerOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showProfileImageOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showProfitCalendarOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showProofOfPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  showReferralCode?: InputMaybe<Scalars['Boolean']['input']>;
  showSocialConnections?: InputMaybe<Scalars['Boolean']['input']>;
  showTradingJourney?: InputMaybe<Scalars['Boolean']['input']>;
  showTradingStatsOnPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  tradingMarket?: InputMaybe<Scalars['String']['input']>;
  tradingSession?: InputMaybe<Scalars['String']['input']>;
  tradingSetup?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyTraderPublicProfilePayload = {
  __typename?: 'UpdateMyTraderPublicProfilePayload';
  traderPublicProfile?: Maybe<MyTraderPublicProfile>;
};

/** All input for the `updateTraderPublicProfileById` mutation. */
export type UpdateTraderPublicProfileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TraderPublicProfile` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `TraderPublicProfile` being updated. */
  patch: TraderPublicProfilePatch;
};

/** All input for the `updateTraderPublicProfile` mutation. */
export type UpdateTraderPublicProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `TraderPublicProfile` being updated. */
  patch: TraderPublicProfilePatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `TraderPublicProfile` mutation. */
export type UpdateTraderPublicProfilePayload = {
  __typename?: 'UpdateTraderPublicProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TraderPublicProfile` that was updated by this mutation. */
  traderPublicProfile?: Maybe<TraderPublicProfile>;
  /** An edge for our `TraderPublicProfile`. May be used by Relay 1. */
  traderPublicProfileEdge?: Maybe<TraderPublicProfileEdge>;
};


/** The output of our update `TraderPublicProfile` mutation. */
export type UpdateTraderPublicProfilePayloadTraderPublicProfileEdgeArgs = {
  orderBy?: Array<TraderPublicProfileOrderBy>;
};

/** All input for the `updateTraderRiskIndicatorById` mutation. */
export type UpdateTraderRiskIndicatorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TraderRiskIndicator` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `TraderRiskIndicator` being updated. */
  patch: TraderRiskIndicatorPatch;
};

/** All input for the `updateTraderRiskIndicator` mutation. */
export type UpdateTraderRiskIndicatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `TraderRiskIndicator` being updated. */
  patch: TraderRiskIndicatorPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `TraderRiskIndicator` mutation. */
export type UpdateTraderRiskIndicatorPayload = {
  __typename?: 'UpdateTraderRiskIndicatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TraderRiskIndicator` that was updated by this mutation. */
  traderRiskIndicator?: Maybe<TraderRiskIndicator>;
  /** An edge for our `TraderRiskIndicator`. May be used by Relay 1. */
  traderRiskIndicatorEdge?: Maybe<TraderRiskIndicatorEdge>;
};


/** The output of our update `TraderRiskIndicator` mutation. */
export type UpdateTraderRiskIndicatorPayloadTraderRiskIndicatorEdgeArgs = {
  orderBy?: Array<TraderRiskIndicatorOrderBy>;
};

/** All input for the `updateTradingProductFeeById` mutation. */
export type UpdateTradingProductFeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TradingProductFee` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `TradingProductFee` being updated. */
  patch: TradingProductFeePatch;
};

/** All input for the `updateTradingProductFee` mutation. */
export type UpdateTradingProductFeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `TradingProductFee` being updated. */
  patch: TradingProductFeePatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `TradingProductFee` mutation. */
export type UpdateTradingProductFeePayload = {
  __typename?: 'UpdateTradingProductFeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TradingProductFee` that was updated by this mutation. */
  tradingProductFee?: Maybe<TradingProductFee>;
  /** An edge for our `TradingProductFee`. May be used by Relay 1. */
  tradingProductFeeEdge?: Maybe<TradingProductFeeEdge>;
};


/** The output of our update `TradingProductFee` mutation. */
export type UpdateTradingProductFeePayloadTradingProductFeeEdgeArgs = {
  orderBy?: Array<TradingProductFeeOrderBy>;
};

/** All input for the `updateUserAddressById` mutation. */
export type UpdateUserAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserAddress` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserAddress` being updated. */
  patch: UserAddressPatch;
};

/** All input for the `updateUserAddress` mutation. */
export type UpdateUserAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UserAddress` being updated. */
  patch: UserAddressPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `UserAddress` mutation. */
export type UpdateUserAddressPayload = {
  __typename?: 'UpdateUserAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserAddress` that was updated by this mutation. */
  userAddress?: Maybe<UserAddress>;
  /** An edge for our `UserAddress`. May be used by Relay 1. */
  userAddressEdge?: Maybe<UserAddressEdge>;
};


/** The output of our update `UserAddress` mutation. */
export type UpdateUserAddressPayloadUserAddressEdgeArgs = {
  orderBy?: Array<UserAddressOrderBy>;
};

/** All input for the `updateUserTaxFormById` mutation. */
export type UpdateUserTaxFormByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserTaxForm` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserTaxForm` being updated. */
  patch: UserTaxFormPatch;
};

/** All input for the `updateUserTaxForm` mutation. */
export type UpdateUserTaxFormInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UserTaxForm` being updated. */
  patch: UserTaxFormPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `UserTaxForm` mutation. */
export type UpdateUserTaxFormPayload = {
  __typename?: 'UpdateUserTaxFormPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserTaxForm` that was updated by this mutation. */
  userTaxForm?: Maybe<UserTaxForm>;
  /** An edge for our `UserTaxForm`. May be used by Relay 1. */
  userTaxFormEdge?: Maybe<UserTaxFormEdge>;
};


/** The output of our update `UserTaxForm` mutation. */
export type UpdateUserTaxFormPayloadUserTaxFormEdgeArgs = {
  orderBy?: Array<UserTaxFormOrderBy>;
};

/** All input for the `updateXfaActivationCreditById` mutation. */
export type UpdateXfaActivationCreditByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `XfaActivationCredit` to be updated. */
  id: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `XfaActivationCredit` being updated. */
  patch: XfaActivationCreditPatch;
};

/** All input for the `updateXfaActivationCredit` mutation. */
export type UpdateXfaActivationCreditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `XfaActivationCredit` being updated. */
  patch: XfaActivationCreditPatch;
  rowId: Scalars['Int']['input'];
};

/** The output of our update `XfaActivationCredit` mutation. */
export type UpdateXfaActivationCreditPayload = {
  __typename?: 'UpdateXfaActivationCreditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `XfaActivationCredit` that was updated by this mutation. */
  xfaActivationCredit?: Maybe<XfaActivationCredit>;
  /** An edge for our `XfaActivationCredit`. May be used by Relay 1. */
  xfaActivationCreditEdge?: Maybe<XfaActivationCreditEdge>;
};


/** The output of our update `XfaActivationCredit` mutation. */
export type UpdateXfaActivationCreditPayloadXfaActivationCreditEdgeArgs = {
  orderBy?: Array<XfaActivationCreditOrderBy>;
};

export type User = Node & {
  __typename?: 'User';
  /** Reads and enables pagination through a set of `AccountCallUpDecisionCalculation`. */
  accountCallUpDecisionCalculations: AccountCallUpDecisionCalculationConnection;
  /** Reads and enables pagination through a set of `AccountCallUpDecision`. */
  accountCallUpDecisions: AccountCallUpDecisionConnection;
  /** Reads and enables pagination through a set of `AccountCapitalEntry`. */
  accountCapitalEntriesCreated: AccountCapitalEntryConnection;
  /** Reads and enables pagination through a set of `AccountResetLimit`. */
  accountResetLimits: AccountResetLimitConnection;
  /** Reads and enables pagination through a set of `AccountResetTracking`. */
  accountResetTrackings: AccountResetTrackingConnection;
  accountTotal?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Account`. */
  accounts: AccountConnection;
  activeCooldown?: Maybe<UserCooldown>;
  /** Reads and enables pagination through a set of `AdminRoleUsersUser`. */
  adminRoleUsersUsers: AdminRoleUsersUserConnection;
  /** Reads a single `Affiliate` that is related to this `User`. */
  affiliate?: Maybe<Affiliate>;
  /** Reads and enables pagination through a set of `CardTransaction`. */
  cardTransactions: CardTransactionConnection;
  /** Reads and enables pagination through a set of `CheckoutSession`. */
  checkoutSessions: CheckoutSessionConnection;
  cognitoSub?: Maybe<Scalars['String']['output']>;
  confirmationCode?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CouponUser`. */
  couponUsers: CouponUserConnection;
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  discordAccessToken?: Maybe<Scalars['String']['output']>;
  discordId?: Maybe<Scalars['String']['output']>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `Email`. */
  emails: EmailConnection;
  forcedLogoutAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `GroupAdmin`. */
  groupAdmins: GroupAdminConnection;
  hasCompletedLegacyPasswordUpdate?: Maybe<Scalars['Boolean']['output']>;
  hasMobileAccess: Scalars['Boolean']['output'];
  heldLockTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  heldLocks?: Maybe<Scalars['JSON']['output']>;
  hubspotId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignments: ImpactGroupAssignmentConnection;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignmentsByAssignedBy: ImpactGroupAssignmentConnection;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignmentsByAssignedByList: Array<ImpactGroupAssignment>;
  /** Reads and enables pagination through a set of `ImpactGroupAssignment`. */
  impactGroupAssignmentsList: Array<ImpactGroupAssignment>;
  isBot?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  kycStatus?: Maybe<Scalars['String']['output']>;
  lastIp?: Maybe<Scalars['String']['output']>;
  latestVerificationStatus?: Maybe<Scalars['String']['output']>;
  legacyAppId?: Maybe<Scalars['Int']['output']>;
  lockReason?: Maybe<Scalars['String']['output']>;
  lockType?: Maybe<Scalars['String']['output']>;
  mobileForcedLogoutAt?: Maybe<Scalars['Datetime']['output']>;
  needsVerification?: Maybe<Scalars['Boolean']['output']>;
  netSuiteId?: Maybe<Scalars['Int']['output']>;
  netSuiteVendorId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `NuveiSavedCard`. */
  nuveiSavedCards: NuveiSavedCardConnection;
  password?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PasswordHistory`. */
  passwordHistories: PasswordHistoryConnection;
  passwordSetupRequired: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `PayoutRequestBatch`. */
  payoutRequestBatchesByAssignedToAdminId: PayoutRequestBatchConnection;
  /** Reads and enables pagination through a set of `PayoutRequestBatch`. */
  payoutRequestBatchesByCreatedById: PayoutRequestBatchConnection;
  /** Reads and enables pagination through a set of `PayoutRequestSubscriber`. */
  payoutRequestSubscribers: PayoutRequestSubscriberConnection;
  /** Reads and enables pagination through a set of `PayoutRequest`. */
  payoutRequests: PayoutRequestConnection;
  /** Reads and enables pagination through a set of `PersonaWebhookEvent`. */
  personaWebhookEvents: PersonaWebhookEventConnection;
  projectXPassword?: Maybe<Scalars['String']['output']>;
  projectXUserId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `TraderPublicProfile` that is related to this `User`. */
  publicTrader?: Maybe<TraderPublicProfile>;
  publicTraderId?: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `PurchaseOrder`. */
  purchaseOrders: PurchaseOrderConnection;
  /** Reads and enables pagination through a set of `RebillSession`. */
  rebillSessions: RebillSessionConnection;
  /** Reads a single `RegistrationRiskAssessment` that is related to this `User`. */
  registrationRiskAssessment?: Maybe<RegistrationRiskAssessment>;
  /** Reads and enables pagination through a set of `ResetCredit`. */
  resetCredits: ResetCreditConnection;
  role: Scalars['String']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `SavedCard`. */
  savedCards: SavedCardConnection;
  /** Reads and enables pagination through a set of `UserTaxForm`. */
  taxForms: UserTaxFormConnection;
  /** Reads and enables pagination through a set of `TaxInfo`. */
  taxInfos: TaxInfoConnection;
  /** Reads a single `TraderLockDetail` that is related to this `User`. */
  traderLockDetail?: Maybe<TraderLockDetail>;
  /** Reads and enables pagination through a set of `TraderProfileModerationCase`. */
  traderProfileModerationCasesByTraderId: TraderProfileModerationCaseConnection;
  /** Reads and enables pagination through a set of `TraderRiskIndicator`. */
  traderRiskIndicators: TraderRiskIndicatorConnection;
  twoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
  twoFactorSecret?: Maybe<Scalars['String']['output']>;
  twoFactorType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UserAddress`. */
  userAddresses: UserAddressConnection;
  /** Reads and enables pagination through a set of `UserAdminRole`. */
  userAdminRoles: UserAdminRoleConnection;
  /** Reads and enables pagination through a set of `UserAgreement`. */
  userAgreements: UserAgreementConnection;
  /** Reads and enables pagination through a set of `UserCertificate`. */
  userCertificates: UserCertificateConnection;
  /** Reads a single `UserContactInfo` that is related to this `User`. */
  userContactInfo?: Maybe<UserContactInfo>;
  /** Reads and enables pagination through a set of `UserCooldown`. */
  userCooldowns: UserCooldownConnection;
  /** Reads a single `UserIntegration` that is related to this `User`. */
  userIntegration?: Maybe<UserIntegration>;
  /** Reads and enables pagination through a set of `UserMeteredEvent`. */
  userMeteredEvents: UserMeteredEventConnection;
  /** Reads and enables pagination through a set of `UserNote`. */
  userNotes: UserNoteConnection;
  /** Reads and enables pagination through a set of `UserNote`. */
  userNotesIssued: UserNoteConnection;
  /** Reads and enables pagination through a set of `UserPlatformCredential`. */
  userPlatformCredentials: UserPlatformCredentialConnection;
  /** Reads and enables pagination through a set of `UserRolesAdminRole`. */
  userRolesAdminRoles: UserRolesAdminRoleConnection;
  /** Reads and enables pagination through a set of `UserTcPurchaseLimit`. */
  userTcPurchaseLimits: UserTcPurchaseLimitConnection;
  userType?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `UserXfaCooldown`. */
  userXfaCooldowns: UserXfaCooldownConnection;
  usingTempPassword?: Maybe<Scalars['Boolean']['output']>;
  verificationLastRequestedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `Verification`. */
  verifications: VerificationConnection;
};


export type UserAccountCallUpDecisionCalculationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCallUpDecisionCalculationCondition>;
  filter?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCallUpDecisionCalculationOrderBy>>;
};


export type UserAccountCallUpDecisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCallUpDecisionCondition>;
  filter?: InputMaybe<AccountCallUpDecisionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCallUpDecisionOrderBy>>;
};


export type UserAccountCapitalEntriesCreatedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCapitalEntryCondition>;
  filter?: InputMaybe<AccountCapitalEntryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCapitalEntryOrderBy>>;
};


export type UserAccountResetLimitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountResetLimitCondition>;
  filter?: InputMaybe<AccountResetLimitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountResetLimitOrderBy>>;
};


export type UserAccountResetTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountResetTrackingCondition>;
  filter?: InputMaybe<AccountResetTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountResetTrackingOrderBy>>;
};


export type UserAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
};


export type UserAdminRoleUsersUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AdminRoleUsersUserCondition>;
  filter?: InputMaybe<AdminRoleUsersUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdminRoleUsersUserOrderBy>>;
};


export type UserCardTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTransactionCondition>;
  filter?: InputMaybe<CardTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTransactionOrderBy>>;
};


export type UserCheckoutSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckoutSessionCondition>;
  filter?: InputMaybe<CheckoutSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckoutSessionOrderBy>>;
};


export type UserCouponUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CouponUserCondition>;
  filter?: InputMaybe<CouponUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CouponUserOrderBy>>;
};


export type UserEmailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailCondition>;
  filter?: InputMaybe<EmailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailOrderBy>>;
};


export type UserGroupAdminsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupAdminCondition>;
  filter?: InputMaybe<GroupAdminFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupAdminOrderBy>>;
};


export type UserImpactGroupAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type UserImpactGroupAssignmentsByAssignedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type UserImpactGroupAssignmentsByAssignedByListArgs = {
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type UserImpactGroupAssignmentsListArgs = {
  condition?: InputMaybe<ImpactGroupAssignmentCondition>;
  filter?: InputMaybe<ImpactGroupAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImpactGroupAssignmentOrderBy>>;
};


export type UserNuveiSavedCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NuveiSavedCardCondition>;
  filter?: InputMaybe<NuveiSavedCardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NuveiSavedCardOrderBy>>;
};


export type UserPasswordHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PasswordHistoryCondition>;
  filter?: InputMaybe<PasswordHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PasswordHistoryOrderBy>>;
};


export type UserPayoutRequestBatchesByAssignedToAdminIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestBatchCondition>;
  filter?: InputMaybe<PayoutRequestBatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestBatchOrderBy>>;
};


export type UserPayoutRequestBatchesByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestBatchCondition>;
  filter?: InputMaybe<PayoutRequestBatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestBatchOrderBy>>;
};


export type UserPayoutRequestSubscribersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestSubscriberCondition>;
  filter?: InputMaybe<PayoutRequestSubscriberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestSubscriberOrderBy>>;
};


export type UserPayoutRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PayoutRequestCondition>;
  filter?: InputMaybe<PayoutRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PayoutRequestOrderBy>>;
};


export type UserPersonaWebhookEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PersonaWebhookEventCondition>;
  filter?: InputMaybe<PersonaWebhookEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonaWebhookEventOrderBy>>;
};


export type UserPurchaseOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PurchaseOrderCondition>;
  filter?: InputMaybe<PurchaseOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PurchaseOrderOrderBy>>;
};


export type UserRebillSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RebillSessionCondition>;
  filter?: InputMaybe<RebillSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RebillSessionOrderBy>>;
};


export type UserResetCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ResetCreditCondition>;
  filter?: InputMaybe<ResetCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ResetCreditOrderBy>>;
};


export type UserSavedCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SavedCardCondition>;
  filter?: InputMaybe<SavedCardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavedCardOrderBy>>;
};


export type UserTaxFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserTaxFormCondition>;
  filter?: InputMaybe<UserTaxFormFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTaxFormOrderBy>>;
};


export type UserTaxInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaxInfoCondition>;
  filter?: InputMaybe<TaxInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaxInfoOrderBy>>;
};


export type UserTraderProfileModerationCasesByTraderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderProfileModerationCaseCondition>;
  filter?: InputMaybe<TraderProfileModerationCaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderProfileModerationCaseOrderBy>>;
};


export type UserTraderRiskIndicatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TraderRiskIndicatorCondition>;
  filter?: InputMaybe<TraderRiskIndicatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraderRiskIndicatorOrderBy>>;
};


export type UserUserAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserAddressCondition>;
  filter?: InputMaybe<UserAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserAddressOrderBy>>;
};


export type UserUserAdminRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserAdminRoleCondition>;
  filter?: InputMaybe<UserAdminRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserAdminRoleOrderBy>>;
};


export type UserUserAgreementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserAgreementCondition>;
  filter?: InputMaybe<UserAgreementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserAgreementOrderBy>>;
};


export type UserUserCertificatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCertificateCondition>;
  filter?: InputMaybe<UserCertificateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserCertificateOrderBy>>;
};


export type UserUserCooldownsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCooldownCondition>;
  filter?: InputMaybe<UserCooldownFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserCooldownOrderBy>>;
};


export type UserUserMeteredEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserMeteredEventCondition>;
  filter?: InputMaybe<UserMeteredEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserMeteredEventOrderBy>>;
};


export type UserUserNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserNoteCondition>;
  filter?: InputMaybe<UserNoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNoteOrderBy>>;
};


export type UserUserNotesIssuedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserNoteCondition>;
  filter?: InputMaybe<UserNoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNoteOrderBy>>;
};


export type UserUserPlatformCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserPlatformCredentialCondition>;
  filter?: InputMaybe<UserPlatformCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserPlatformCredentialOrderBy>>;
};


export type UserUserRolesAdminRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRolesAdminRoleCondition>;
  filter?: InputMaybe<UserRolesAdminRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolesAdminRoleOrderBy>>;
};


export type UserUserTcPurchaseLimitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserTcPurchaseLimitCondition>;
  filter?: InputMaybe<UserTcPurchaseLimitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTcPurchaseLimitOrderBy>>;
};


export type UserUserXfaCooldownsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserXfaCooldownCondition>;
  filter?: InputMaybe<UserXfaCooldownFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserXfaCooldownOrderBy>>;
};


export type UserVerificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VerificationCondition>;
  filter?: InputMaybe<VerificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationOrderBy>>;
};

export type UserAddon = Node & {
  __typename?: 'UserAddon';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Addon` that is related to this `UserAddon`. */
  addOn?: Maybe<Addon>;
  addOnId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `Product` that is related to this `UserAddon`. */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  skuId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserAddon`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserAddress = Node & {
  __typename?: 'UserAddress';
  addressType: UserAddressAddressTypeEnum;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserAddress`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  zip: Scalars['String']['output'];
};

export enum UserAddressAddressTypeEnum {
  Mailing = 'Mailing',
  Shipping = 'Shipping'
}

export type UserAddressAggregates = {
  __typename?: 'UserAddressAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserAddressAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserAddressDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserAddressMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserAddressMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserAddressStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserAddressStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserAddressSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserAddressVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserAddressVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserAddress` object types. */
export type UserAddressAggregatesFilter = {
  /** Mean average aggregate over matching `UserAddress` objects. */
  average?: InputMaybe<UserAddressAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserAddress` objects. */
  distinctCount?: InputMaybe<UserAddressDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserAddress` object to be included within the aggregate. */
  filter?: InputMaybe<UserAddressFilter>;
  /** Maximum aggregate over matching `UserAddress` objects. */
  max?: InputMaybe<UserAddressMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserAddress` objects. */
  min?: InputMaybe<UserAddressMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserAddress` objects. */
  stddevPopulation?: InputMaybe<UserAddressStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserAddress` objects. */
  stddevSample?: InputMaybe<UserAddressStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserAddress` objects. */
  sum?: InputMaybe<UserAddressSumAggregateFilter>;
  /** Population variance aggregate over matching `UserAddress` objects. */
  variancePopulation?: InputMaybe<UserAddressVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserAddress` objects. */
  varianceSample?: InputMaybe<UserAddressVarianceSampleAggregateFilter>;
};

export type UserAddressAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAddressAverageAggregates = {
  __typename?: 'UserAddressAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserAddress` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserAddressCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserAddress` values. */
export type UserAddressConnection = {
  __typename?: 'UserAddressConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserAddressAggregates>;
  /** A list of edges which contains the `UserAddress` and cursor to aid in pagination. */
  edges: Array<Maybe<UserAddressEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserAddressAggregates>>;
  /** A list of `UserAddress` objects. */
  nodes: Array<Maybe<UserAddress>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserAddress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserAddress` values. */
export type UserAddressConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserAddressGroupBy>;
  having?: InputMaybe<UserAddressHavingInput>;
};

export type UserAddressDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserAddressDistinctCountAggregates = {
  __typename?: 'UserAddressDistinctCountAggregates';
  /** Distinct count of addressType across the matching connection */
  addressType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of city across the matching connection */
  city?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of country across the matching connection */
  country?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of state across the matching connection */
  state?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of street across the matching connection */
  street?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of street2 across the matching connection */
  street2?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of zip across the matching connection */
  zip?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserAddress` edge in the connection. */
export type UserAddressEdge = {
  __typename?: 'UserAddressEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserAddress` at the end of the edge. */
  node?: Maybe<UserAddress>;
};

/** A filter to be used against `UserAddress` object types. All fields are combined with a logical ‘and.’ */
export type UserAddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAddressFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAddressFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserAddress` for usage during aggregation. */
export enum UserAddressGroupBy {
  UserId = 'USER_ID'
}

export type UserAddressHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserAddress` aggregates. */
export type UserAddressHavingInput = {
  AND?: InputMaybe<Array<UserAddressHavingInput>>;
  OR?: InputMaybe<Array<UserAddressHavingInput>>;
  average?: InputMaybe<UserAddressHavingAverageInput>;
  distinctCount?: InputMaybe<UserAddressHavingDistinctCountInput>;
  max?: InputMaybe<UserAddressHavingMaxInput>;
  min?: InputMaybe<UserAddressHavingMinInput>;
  stddevPopulation?: InputMaybe<UserAddressHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserAddressHavingStddevSampleInput>;
  sum?: InputMaybe<UserAddressHavingSumInput>;
  variancePopulation?: InputMaybe<UserAddressHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserAddressHavingVarianceSampleInput>;
};

export type UserAddressHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAddressHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `UserAddress` */
export type UserAddressInput = {
  addressType: UserAddressAddressTypeEnum;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type UserAddressMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserAddressMaxAggregates = {
  __typename?: 'UserAddressMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserAddressMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserAddressMinAggregates = {
  __typename?: 'UserAddressMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserAddress`. */
export enum UserAddressOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Represents an update to a `UserAddress`. Fields that are set will be updated. */
export type UserAddressPatch = {
  addressType?: InputMaybe<UserAddressAddressTypeEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserAddressStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAddressStddevPopulationAggregates = {
  __typename?: 'UserAddressStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAddressStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAddressStddevSampleAggregates = {
  __typename?: 'UserAddressStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAddressSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserAddressSumAggregates = {
  __typename?: 'UserAddressSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserAddressVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAddressVariancePopulationAggregates = {
  __typename?: 'UserAddressVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAddressVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAddressVarianceSampleAggregates = {
  __typename?: 'UserAddressVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAdminRole = Node & {
  __typename?: 'UserAdminRole';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `AdminRole` that is related to this `UserAdminRole`. */
  role?: Maybe<AdminRole>;
  roleId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `UserAdminRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserAdminRoleAggregates = {
  __typename?: 'UserAdminRoleAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserAdminRoleAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserAdminRoleDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserAdminRoleMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserAdminRoleMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserAdminRoleStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserAdminRoleStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserAdminRoleSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserAdminRoleVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserAdminRoleVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserAdminRole` object types. */
export type UserAdminRoleAggregatesFilter = {
  /** Mean average aggregate over matching `UserAdminRole` objects. */
  average?: InputMaybe<UserAdminRoleAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserAdminRole` objects. */
  distinctCount?: InputMaybe<UserAdminRoleDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserAdminRole` object to be included within the aggregate. */
  filter?: InputMaybe<UserAdminRoleFilter>;
  /** Maximum aggregate over matching `UserAdminRole` objects. */
  max?: InputMaybe<UserAdminRoleMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserAdminRole` objects. */
  min?: InputMaybe<UserAdminRoleMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserAdminRole` objects. */
  stddevPopulation?: InputMaybe<UserAdminRoleStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserAdminRole` objects. */
  stddevSample?: InputMaybe<UserAdminRoleStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserAdminRole` objects. */
  sum?: InputMaybe<UserAdminRoleSumAggregateFilter>;
  /** Population variance aggregate over matching `UserAdminRole` objects. */
  variancePopulation?: InputMaybe<UserAdminRoleVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserAdminRole` objects. */
  varianceSample?: InputMaybe<UserAdminRoleVarianceSampleAggregateFilter>;
};

export type UserAdminRoleAverageAggregateFilter = {
  roleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAdminRoleAverageAggregates = {
  __typename?: 'UserAdminRoleAverageAggregates';
  /** Mean average of roleId across the matching connection */
  roleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserAdminRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserAdminRoleCondition = {
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserAdminRole` values. */
export type UserAdminRoleConnection = {
  __typename?: 'UserAdminRoleConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserAdminRoleAggregates>;
  /** A list of edges which contains the `UserAdminRole` and cursor to aid in pagination. */
  edges: Array<Maybe<UserAdminRoleEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserAdminRoleAggregates>>;
  /** A list of `UserAdminRole` objects. */
  nodes: Array<Maybe<UserAdminRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserAdminRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserAdminRole` values. */
export type UserAdminRoleConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserAdminRoleGroupBy>;
  having?: InputMaybe<UserAdminRoleHavingInput>;
};

export type UserAdminRoleDistinctCountAggregateFilter = {
  roleId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserAdminRoleDistinctCountAggregates = {
  __typename?: 'UserAdminRoleDistinctCountAggregates';
  /** Distinct count of roleId across the matching connection */
  roleId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserAdminRole` edge in the connection. */
export type UserAdminRoleEdge = {
  __typename?: 'UserAdminRoleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserAdminRole` at the end of the edge. */
  node?: Maybe<UserAdminRole>;
};

/** A filter to be used against `UserAdminRole` object types. All fields are combined with a logical ‘and.’ */
export type UserAdminRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAdminRoleFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserAdminRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAdminRoleFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<AdminRoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserAdminRole` for usage during aggregation. */
export enum UserAdminRoleGroupBy {
  RoleId = 'ROLE_ID',
  UserId = 'USER_ID'
}

export type UserAdminRoleHavingAverageInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingDistinctCountInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserAdminRole` aggregates. */
export type UserAdminRoleHavingInput = {
  AND?: InputMaybe<Array<UserAdminRoleHavingInput>>;
  OR?: InputMaybe<Array<UserAdminRoleHavingInput>>;
  average?: InputMaybe<UserAdminRoleHavingAverageInput>;
  distinctCount?: InputMaybe<UserAdminRoleHavingDistinctCountInput>;
  max?: InputMaybe<UserAdminRoleHavingMaxInput>;
  min?: InputMaybe<UserAdminRoleHavingMinInput>;
  stddevPopulation?: InputMaybe<UserAdminRoleHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserAdminRoleHavingStddevSampleInput>;
  sum?: InputMaybe<UserAdminRoleHavingSumInput>;
  variancePopulation?: InputMaybe<UserAdminRoleHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserAdminRoleHavingVarianceSampleInput>;
};

export type UserAdminRoleHavingMaxInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingMinInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingStddevPopulationInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingStddevSampleInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingSumInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingVariancePopulationInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleHavingVarianceSampleInput = {
  roleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAdminRoleMaxAggregateFilter = {
  roleId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserAdminRoleMaxAggregates = {
  __typename?: 'UserAdminRoleMaxAggregates';
  /** Maximum of roleId across the matching connection */
  roleId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserAdminRoleMinAggregateFilter = {
  roleId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserAdminRoleMinAggregates = {
  __typename?: 'UserAdminRoleMinAggregates';
  /** Minimum of roleId across the matching connection */
  roleId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserAdminRole`. */
export enum UserAdminRoleOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleIdAsc = 'ROLE_ID_ASC',
  RoleIdDesc = 'ROLE_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserAdminRoleStddevPopulationAggregateFilter = {
  roleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAdminRoleStddevPopulationAggregates = {
  __typename?: 'UserAdminRoleStddevPopulationAggregates';
  /** Population standard deviation of roleId across the matching connection */
  roleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAdminRoleStddevSampleAggregateFilter = {
  roleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAdminRoleStddevSampleAggregates = {
  __typename?: 'UserAdminRoleStddevSampleAggregates';
  /** Sample standard deviation of roleId across the matching connection */
  roleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAdminRoleSumAggregateFilter = {
  roleId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserAdminRoleSumAggregates = {
  __typename?: 'UserAdminRoleSumAggregates';
  /** Sum of roleId across the matching connection */
  roleId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserAdminRoleVariancePopulationAggregateFilter = {
  roleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAdminRoleVariancePopulationAggregates = {
  __typename?: 'UserAdminRoleVariancePopulationAggregates';
  /** Population variance of roleId across the matching connection */
  roleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAdminRoleVarianceSampleAggregateFilter = {
  roleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAdminRoleVarianceSampleAggregates = {
  __typename?: 'UserAdminRoleVarianceSampleAggregates';
  /** Sample variance of roleId across the matching connection */
  roleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAggregates = {
  __typename?: 'UserAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserVarianceSampleAggregates>;
};

export type UserAgreement = Node & {
  __typename?: 'UserAgreement';
  agreementName: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  signedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserAgreement`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserAgreementAggregates = {
  __typename?: 'UserAgreementAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserAgreementAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserAgreementDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserAgreementMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserAgreementMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserAgreementStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserAgreementStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserAgreementSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserAgreementVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserAgreementVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserAgreement` object types. */
export type UserAgreementAggregatesFilter = {
  /** Mean average aggregate over matching `UserAgreement` objects. */
  average?: InputMaybe<UserAgreementAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserAgreement` objects. */
  distinctCount?: InputMaybe<UserAgreementDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserAgreement` object to be included within the aggregate. */
  filter?: InputMaybe<UserAgreementFilter>;
  /** Maximum aggregate over matching `UserAgreement` objects. */
  max?: InputMaybe<UserAgreementMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserAgreement` objects. */
  min?: InputMaybe<UserAgreementMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserAgreement` objects. */
  stddevPopulation?: InputMaybe<UserAgreementStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserAgreement` objects. */
  stddevSample?: InputMaybe<UserAgreementStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserAgreement` objects. */
  sum?: InputMaybe<UserAgreementSumAggregateFilter>;
  /** Population variance aggregate over matching `UserAgreement` objects. */
  variancePopulation?: InputMaybe<UserAgreementVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserAgreement` objects. */
  varianceSample?: InputMaybe<UserAgreementVarianceSampleAggregateFilter>;
};

export type UserAgreementAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAgreementAverageAggregates = {
  __typename?: 'UserAgreementAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserAgreement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserAgreementCondition = {
  /** Checks for equality with the object’s `agreementName` field. */
  agreementName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserAgreement` values. */
export type UserAgreementConnection = {
  __typename?: 'UserAgreementConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserAgreementAggregates>;
  /** A list of edges which contains the `UserAgreement` and cursor to aid in pagination. */
  edges: Array<Maybe<UserAgreementEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserAgreementAggregates>>;
  /** A list of `UserAgreement` objects. */
  nodes: Array<Maybe<UserAgreement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserAgreement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserAgreement` values. */
export type UserAgreementConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserAgreementGroupBy>;
  having?: InputMaybe<UserAgreementHavingInput>;
};

export type UserAgreementDistinctCountAggregateFilter = {
  agreementName?: InputMaybe<BigIntFilter>;
  deletedAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserAgreementDistinctCountAggregates = {
  __typename?: 'UserAgreementDistinctCountAggregates';
  /** Distinct count of agreementName across the matching connection */
  agreementName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of signedAt across the matching connection */
  signedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserAgreement` edge in the connection. */
export type UserAgreementEdge = {
  __typename?: 'UserAgreementEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserAgreement` at the end of the edge. */
  node?: Maybe<UserAgreement>;
};

/** A filter to be used against `UserAgreement` object types. All fields are combined with a logical ‘and.’ */
export type UserAgreementFilter = {
  /** Filter by the object’s `agreementName` field. */
  agreementName?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAgreementFilter>>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserAgreementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAgreementFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserAgreement` for usage during aggregation. */
export enum UserAgreementGroupBy {
  AgreementName = 'AGREEMENT_NAME',
  DeletedAt = 'DELETED_AT',
  DeletedAtTruncatedToDay = 'DELETED_AT_TRUNCATED_TO_DAY',
  DeletedAtTruncatedToHour = 'DELETED_AT_TRUNCATED_TO_HOUR',
  UserId = 'USER_ID'
}

export type UserAgreementHavingAverageInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingDistinctCountInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserAgreement` aggregates. */
export type UserAgreementHavingInput = {
  AND?: InputMaybe<Array<UserAgreementHavingInput>>;
  OR?: InputMaybe<Array<UserAgreementHavingInput>>;
  average?: InputMaybe<UserAgreementHavingAverageInput>;
  distinctCount?: InputMaybe<UserAgreementHavingDistinctCountInput>;
  max?: InputMaybe<UserAgreementHavingMaxInput>;
  min?: InputMaybe<UserAgreementHavingMinInput>;
  stddevPopulation?: InputMaybe<UserAgreementHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserAgreementHavingStddevSampleInput>;
  sum?: InputMaybe<UserAgreementHavingSumInput>;
  variancePopulation?: InputMaybe<UserAgreementHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserAgreementHavingVarianceSampleInput>;
};

export type UserAgreementHavingMaxInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingMinInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingStddevPopulationInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingStddevSampleInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingSumInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingVariancePopulationInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementHavingVarianceSampleInput = {
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  signedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserAgreementMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserAgreementMaxAggregates = {
  __typename?: 'UserAgreementMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserAgreementMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserAgreementMinAggregates = {
  __typename?: 'UserAgreementMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserAgreement`. */
export enum UserAgreementOrderBy {
  AgreementNameAsc = 'AGREEMENT_NAME_ASC',
  AgreementNameDesc = 'AGREEMENT_NAME_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserAgreementStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAgreementStddevPopulationAggregates = {
  __typename?: 'UserAgreementStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAgreementStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAgreementStddevSampleAggregates = {
  __typename?: 'UserAgreementStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAgreementSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserAgreementSumAggregates = {
  __typename?: 'UserAgreementSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserAgreementVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAgreementVariancePopulationAggregates = {
  __typename?: 'UserAgreementVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAgreementVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserAgreementVarianceSampleAggregates = {
  __typename?: 'UserAgreementVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserAverageAggregates = {
  __typename?: 'UserAverageAggregates';
  /** Mean average of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserBankingInfo = Node & {
  __typename?: 'UserBankingInfo';
  collection: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  deletedAt: Scalars['Datetime']['output'];
  hash: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  payoutRequestId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type UserCertificate = Node & {
  __typename?: 'UserCertificate';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pdfId?: Maybe<Scalars['Int']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  previewGenerated?: Maybe<Scalars['Boolean']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserCertificate`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserCertificateAggregates = {
  __typename?: 'UserCertificateAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserCertificateAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserCertificateDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserCertificateMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserCertificateMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserCertificateStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserCertificateStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserCertificateSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserCertificateVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserCertificateVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserCertificate` object types. */
export type UserCertificateAggregatesFilter = {
  /** Mean average aggregate over matching `UserCertificate` objects. */
  average?: InputMaybe<UserCertificateAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserCertificate` objects. */
  distinctCount?: InputMaybe<UserCertificateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserCertificate` object to be included within the aggregate. */
  filter?: InputMaybe<UserCertificateFilter>;
  /** Maximum aggregate over matching `UserCertificate` objects. */
  max?: InputMaybe<UserCertificateMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserCertificate` objects. */
  min?: InputMaybe<UserCertificateMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserCertificate` objects. */
  stddevPopulation?: InputMaybe<UserCertificateStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserCertificate` objects. */
  stddevSample?: InputMaybe<UserCertificateStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserCertificate` objects. */
  sum?: InputMaybe<UserCertificateSumAggregateFilter>;
  /** Population variance aggregate over matching `UserCertificate` objects. */
  variancePopulation?: InputMaybe<UserCertificateVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserCertificate` objects. */
  varianceSample?: InputMaybe<UserCertificateVarianceSampleAggregateFilter>;
};

export type UserCertificateAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCertificateAverageAggregates = {
  __typename?: 'UserCertificateAverageAggregates';
  /** Mean average of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserCertificate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCertificateCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserCertificate` values. */
export type UserCertificateConnection = {
  __typename?: 'UserCertificateConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserCertificateAggregates>;
  /** A list of edges which contains the `UserCertificate` and cursor to aid in pagination. */
  edges: Array<Maybe<UserCertificateEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserCertificateAggregates>>;
  /** A list of `UserCertificate` objects. */
  nodes: Array<Maybe<UserCertificate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCertificate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserCertificate` values. */
export type UserCertificateConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserCertificateGroupBy>;
  having?: InputMaybe<UserCertificateHavingInput>;
};

export type UserCertificateDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserCertificateDistinctCountAggregates = {
  __typename?: 'UserCertificateDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pdfUrl across the matching connection */
  pdfUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of previewGenerated across the matching connection */
  previewGenerated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of previewUrl across the matching connection */
  previewUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserCertificate` edge in the connection. */
export type UserCertificateEdge = {
  __typename?: 'UserCertificateEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserCertificate` at the end of the edge. */
  node?: Maybe<UserCertificate>;
};

/** A filter to be used against `UserCertificate` object types. All fields are combined with a logical ‘and.’ */
export type UserCertificateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCertificateFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCertificateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCertificateFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserCertificate` for usage during aggregation. */
export enum UserCertificateGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  UserId = 'USER_ID'
}

export type UserCertificateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserCertificate` aggregates. */
export type UserCertificateHavingInput = {
  AND?: InputMaybe<Array<UserCertificateHavingInput>>;
  OR?: InputMaybe<Array<UserCertificateHavingInput>>;
  average?: InputMaybe<UserCertificateHavingAverageInput>;
  distinctCount?: InputMaybe<UserCertificateHavingDistinctCountInput>;
  max?: InputMaybe<UserCertificateHavingMaxInput>;
  min?: InputMaybe<UserCertificateHavingMinInput>;
  stddevPopulation?: InputMaybe<UserCertificateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserCertificateHavingStddevSampleInput>;
  sum?: InputMaybe<UserCertificateHavingSumInput>;
  variancePopulation?: InputMaybe<UserCertificateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserCertificateHavingVarianceSampleInput>;
};

export type UserCertificateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  pdfId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCertificateMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserCertificateMaxAggregates = {
  __typename?: 'UserCertificateMaxAggregates';
  /** Maximum of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserCertificateMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserCertificateMinAggregates = {
  __typename?: 'UserCertificateMinAggregates';
  /** Minimum of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserCertificate`. */
export enum UserCertificateOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserCertificateStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCertificateStddevPopulationAggregates = {
  __typename?: 'UserCertificateStddevPopulationAggregates';
  /** Population standard deviation of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCertificateStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCertificateStddevSampleAggregates = {
  __typename?: 'UserCertificateStddevSampleAggregates';
  /** Sample standard deviation of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCertificateSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserCertificateSumAggregates = {
  __typename?: 'UserCertificateSumAggregates';
  /** Sum of pdfId across the matching connection */
  pdfId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserCertificateVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCertificateVariancePopulationAggregates = {
  __typename?: 'UserCertificateVariancePopulationAggregates';
  /** Population variance of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCertificateVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCertificateVarianceSampleAggregates = {
  __typename?: 'UserCertificateVarianceSampleAggregates';
  /** Sample variance of pdfId across the matching connection */
  pdfId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `accountTotal` field. */
  accountTotal?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `discordId` field. */
  discordId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `discordUsername` field. */
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heldLocks` field. */
  heldLocks?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `isLocked` field. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `kycStatus` field. */
  kycStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `latestVerificationStatus` field. */
  latestVerificationStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lockType` field. */
  lockType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `needsVerification` field. */
  needsVerification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `projectXUserId` field. */
  projectXUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `User` values. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserAggregates>;
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<Maybe<UserEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserAggregates>>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `User` values. */
export type UserConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserGroupBy>;
  having?: InputMaybe<UserHavingInput>;
};

export type UserContactInfo = Node & {
  __typename?: 'UserContactInfo';
  addressVerification?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  screenName: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserContactInfo`. */
  user?: Maybe<User>;
  userFullName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  zip: Scalars['String']['output'];
};

export type UserContactInfoAggregates = {
  __typename?: 'UserContactInfoAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserContactInfoAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserContactInfoDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserContactInfoMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserContactInfoMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserContactInfoStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserContactInfoStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserContactInfoSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserContactInfoVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserContactInfoVarianceSampleAggregates>;
};

export type UserContactInfoAverageAggregates = {
  __typename?: 'UserContactInfoAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserContactInfo` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserContactInfoCondition = {
  /** Checks for equality with the object’s `addressVerification` field. */
  addressVerification?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `screenName` field. */
  screenName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userFullName` field. */
  userFullName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserContactInfo` values. */
export type UserContactInfoConnection = {
  __typename?: 'UserContactInfoConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserContactInfoAggregates>;
  /** A list of edges which contains the `UserContactInfo` and cursor to aid in pagination. */
  edges: Array<Maybe<UserContactInfoEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserContactInfoAggregates>>;
  /** A list of `UserContactInfo` objects. */
  nodes: Array<Maybe<UserContactInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserContactInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserContactInfo` values. */
export type UserContactInfoConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserContactInfoGroupBy>;
  having?: InputMaybe<UserContactInfoHavingInput>;
};

export type UserContactInfoDistinctCountAggregates = {
  __typename?: 'UserContactInfoDistinctCountAggregates';
  /** Distinct count of addressVerification across the matching connection */
  addressVerification?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of city across the matching connection */
  city?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of country across the matching connection */
  country?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of firstName across the matching connection */
  firstName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastName across the matching connection */
  lastName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of phone across the matching connection */
  phone?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of screenName across the matching connection */
  screenName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of state across the matching connection */
  state?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of street across the matching connection */
  street?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of street2 across the matching connection */
  street2?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  userFullName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of zip across the matching connection */
  zip?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserContactInfo` edge in the connection. */
export type UserContactInfoEdge = {
  __typename?: 'UserContactInfoEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserContactInfo` at the end of the edge. */
  node?: Maybe<UserContactInfo>;
};

/** A filter to be used against `UserContactInfo` object types. All fields are combined with a logical ‘and.’ */
export type UserContactInfoFilter = {
  /** Filter by the object’s `addressVerification` field. */
  addressVerification?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserContactInfoFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserContactInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserContactInfoFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `screenName` field. */
  screenName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userFullName` field. */
  userFullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserContactInfo` for usage during aggregation. */
export enum UserContactInfoGroupBy {
  AddressVerification = 'ADDRESS_VERIFICATION',
  UpdatedAt = 'UPDATED_AT',
  UpdatedAtTruncatedToDay = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UpdatedAtTruncatedToHour = 'UPDATED_AT_TRUNCATED_TO_HOUR'
}

export type UserContactInfoHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserContactInfo` aggregates. */
export type UserContactInfoHavingInput = {
  AND?: InputMaybe<Array<UserContactInfoHavingInput>>;
  OR?: InputMaybe<Array<UserContactInfoHavingInput>>;
  average?: InputMaybe<UserContactInfoHavingAverageInput>;
  distinctCount?: InputMaybe<UserContactInfoHavingDistinctCountInput>;
  max?: InputMaybe<UserContactInfoHavingMaxInput>;
  min?: InputMaybe<UserContactInfoHavingMinInput>;
  stddevPopulation?: InputMaybe<UserContactInfoHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserContactInfoHavingStddevSampleInput>;
  sum?: InputMaybe<UserContactInfoHavingSumInput>;
  variancePopulation?: InputMaybe<UserContactInfoHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserContactInfoHavingVarianceSampleInput>;
};

export type UserContactInfoHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserContactInfoMaxAggregates = {
  __typename?: 'UserContactInfoMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserContactInfoMinAggregates = {
  __typename?: 'UserContactInfoMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserContactInfo`. */
export enum UserContactInfoOrderBy {
  AddressVerificationAsc = 'ADDRESS_VERIFICATION_ASC',
  AddressVerificationDesc = 'ADDRESS_VERIFICATION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  ScreenNameAsc = 'SCREEN_NAME_ASC',
  ScreenNameDesc = 'SCREEN_NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserContactInfoStddevPopulationAggregates = {
  __typename?: 'UserContactInfoStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserContactInfoStddevSampleAggregates = {
  __typename?: 'UserContactInfoStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserContactInfoSumAggregates = {
  __typename?: 'UserContactInfoSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserContactInfoVariancePopulationAggregates = {
  __typename?: 'UserContactInfoVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserContactInfoVarianceSampleAggregates = {
  __typename?: 'UserContactInfoVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCooldown = Node & {
  __typename?: 'UserCooldown';
  createdAt: Scalars['Datetime']['output'];
  endsAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserCooldown`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserCooldownAggregates = {
  __typename?: 'UserCooldownAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserCooldownAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserCooldownDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserCooldownMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserCooldownMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserCooldownStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserCooldownStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserCooldownSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserCooldownVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserCooldownVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserCooldown` object types. */
export type UserCooldownAggregatesFilter = {
  /** Mean average aggregate over matching `UserCooldown` objects. */
  average?: InputMaybe<UserCooldownAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserCooldown` objects. */
  distinctCount?: InputMaybe<UserCooldownDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserCooldown` object to be included within the aggregate. */
  filter?: InputMaybe<UserCooldownFilter>;
  /** Maximum aggregate over matching `UserCooldown` objects. */
  max?: InputMaybe<UserCooldownMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserCooldown` objects. */
  min?: InputMaybe<UserCooldownMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserCooldown` objects. */
  stddevPopulation?: InputMaybe<UserCooldownStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserCooldown` objects. */
  stddevSample?: InputMaybe<UserCooldownStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserCooldown` objects. */
  sum?: InputMaybe<UserCooldownSumAggregateFilter>;
  /** Population variance aggregate over matching `UserCooldown` objects. */
  variancePopulation?: InputMaybe<UserCooldownVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserCooldown` objects. */
  varianceSample?: InputMaybe<UserCooldownVarianceSampleAggregateFilter>;
};

export type UserCooldownAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCooldownAverageAggregates = {
  __typename?: 'UserCooldownAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserCooldown` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCooldownCondition = {
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceType` field. */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserCooldown` values. */
export type UserCooldownConnection = {
  __typename?: 'UserCooldownConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserCooldownAggregates>;
  /** A list of edges which contains the `UserCooldown` and cursor to aid in pagination. */
  edges: Array<Maybe<UserCooldownEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserCooldownAggregates>>;
  /** A list of `UserCooldown` objects. */
  nodes: Array<Maybe<UserCooldown>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCooldown` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserCooldown` values. */
export type UserCooldownConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserCooldownGroupBy>;
  having?: InputMaybe<UserCooldownHavingInput>;
};

export type UserCooldownDistinctCountAggregateFilter = {
  endsAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  sourceId?: InputMaybe<BigIntFilter>;
  sourceType?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserCooldownDistinctCountAggregates = {
  __typename?: 'UserCooldownDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endsAt across the matching connection */
  endsAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceId across the matching connection */
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceType across the matching connection */
  sourceType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserCooldown` edge in the connection. */
export type UserCooldownEdge = {
  __typename?: 'UserCooldownEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserCooldown` at the end of the edge. */
  node?: Maybe<UserCooldown>;
};

/** A filter to be used against `UserCooldown` object types. All fields are combined with a logical ‘and.’ */
export type UserCooldownFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCooldownFilter>>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCooldownFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCooldownFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceType` field. */
  sourceType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserCooldown` for usage during aggregation. */
export enum UserCooldownGroupBy {
  EndsAt = 'ENDS_AT',
  EndsAtTruncatedToDay = 'ENDS_AT_TRUNCATED_TO_DAY',
  EndsAtTruncatedToHour = 'ENDS_AT_TRUNCATED_TO_HOUR',
  SourceId = 'SOURCE_ID',
  SourceType = 'SOURCE_TYPE',
  UserId = 'USER_ID'
}

export type UserCooldownHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserCooldown` aggregates. */
export type UserCooldownHavingInput = {
  AND?: InputMaybe<Array<UserCooldownHavingInput>>;
  OR?: InputMaybe<Array<UserCooldownHavingInput>>;
  average?: InputMaybe<UserCooldownHavingAverageInput>;
  distinctCount?: InputMaybe<UserCooldownHavingDistinctCountInput>;
  max?: InputMaybe<UserCooldownHavingMaxInput>;
  min?: InputMaybe<UserCooldownHavingMinInput>;
  stddevPopulation?: InputMaybe<UserCooldownHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserCooldownHavingStddevSampleInput>;
  sum?: InputMaybe<UserCooldownHavingSumInput>;
  variancePopulation?: InputMaybe<UserCooldownHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserCooldownHavingVarianceSampleInput>;
};

export type UserCooldownHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  endsAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserCooldownMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserCooldownMaxAggregates = {
  __typename?: 'UserCooldownMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserCooldownMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserCooldownMinAggregates = {
  __typename?: 'UserCooldownMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserCooldown`. */
export enum UserCooldownOrderBy {
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SourceIdAsc = 'SOURCE_ID_ASC',
  SourceIdDesc = 'SOURCE_ID_DESC',
  SourceTypeAsc = 'SOURCE_TYPE_ASC',
  SourceTypeDesc = 'SOURCE_TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserCooldownStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCooldownStddevPopulationAggregates = {
  __typename?: 'UserCooldownStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCooldownStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCooldownStddevSampleAggregates = {
  __typename?: 'UserCooldownStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCooldownSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserCooldownSumAggregates = {
  __typename?: 'UserCooldownSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserCooldownVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCooldownVariancePopulationAggregates = {
  __typename?: 'UserCooldownVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserCooldownVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserCooldownVarianceSampleAggregates = {
  __typename?: 'UserCooldownVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserDistinctCountAggregates = {
  __typename?: 'UserDistinctCountAggregates';
  /** Distinct count of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cognitoSub across the matching connection */
  cognitoSub?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of confirmationCode across the matching connection */
  confirmationCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discordAccessToken across the matching connection */
  discordAccessToken?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discordId across the matching connection */
  discordId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of discordUsername across the matching connection */
  discordUsername?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of email across the matching connection */
  email?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of emailConfirmed across the matching connection */
  emailConfirmed?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of forcedLogoutAt across the matching connection */
  forcedLogoutAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of hasCompletedLegacyPasswordUpdate across the matching connection */
  hasCompletedLegacyPasswordUpdate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of hasMobileAccess across the matching connection */
  hasMobileAccess?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  heldLocks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of hubspotId across the matching connection */
  hubspotId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isBot across the matching connection */
  isBot?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isLocked across the matching connection */
  isLocked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of kycStatus across the matching connection */
  kycStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastIp across the matching connection */
  lastIp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  latestVerificationStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lockReason across the matching connection */
  lockReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lockType across the matching connection */
  lockType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of mobileForcedLogoutAt across the matching connection */
  mobileForcedLogoutAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of needsVerification across the matching connection */
  needsVerification?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteVendorId across the matching connection */
  netSuiteVendorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of password across the matching connection */
  password?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of passwordSetupRequired across the matching connection */
  passwordSetupRequired?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectXPassword across the matching connection */
  projectXPassword?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of publicTraderId across the matching connection */
  publicTraderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of twoFactorEnabled across the matching connection */
  twoFactorEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of twoFactorSecret across the matching connection */
  twoFactorSecret?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of twoFactorType across the matching connection */
  twoFactorType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userType across the matching connection */
  userType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of usingTempPassword across the matching connection */
  usingTempPassword?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of verificationLastRequestedAt across the matching connection */
  verificationLastRequestedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A `User` edge in the connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Filter by the object’s `accountCallUpDecisionCalculations` relation. */
  accountCallUpDecisionCalculations?: InputMaybe<UserToManyAccountCallUpDecisionCalculationFilter>;
  /** Some related `accountCallUpDecisionCalculations` exist. */
  accountCallUpDecisionCalculationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCallUpDecisions` relation. */
  accountCallUpDecisions?: InputMaybe<UserToManyAccountCallUpDecisionFilter>;
  /** Some related `accountCallUpDecisions` exist. */
  accountCallUpDecisionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCapitalEntriesCreated` relation. */
  accountCapitalEntriesCreated?: InputMaybe<UserToManyAccountCapitalEntryFilter>;
  /** Some related `accountCapitalEntriesCreated` exist. */
  accountCapitalEntriesCreatedExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountResetLimits` relation. */
  accountResetLimits?: InputMaybe<UserToManyAccountResetLimitFilter>;
  /** Some related `accountResetLimits` exist. */
  accountResetLimitsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountResetTrackings` relation. */
  accountResetTrackings?: InputMaybe<UserToManyAccountResetTrackingFilter>;
  /** Some related `accountResetTrackings` exist. */
  accountResetTrackingsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountTotal` field. */
  accountTotal?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accounts` relation. */
  accounts?: InputMaybe<UserToManyAccountFilter>;
  /** Some related `accounts` exist. */
  accountsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `adminRoleUsersUsers` relation. */
  adminRoleUsersUsers?: InputMaybe<UserToManyAdminRoleUsersUserFilter>;
  /** Some related `adminRoleUsersUsers` exist. */
  adminRoleUsersUsersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `affiliate` relation. */
  affiliate?: InputMaybe<AffiliateFilter>;
  /** A related `affiliate` exists. */
  affiliateExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `cardTransactions` relation. */
  cardTransactions?: InputMaybe<UserToManyCardTransactionFilter>;
  /** Some related `cardTransactions` exist. */
  cardTransactionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkoutSessions` relation. */
  checkoutSessions?: InputMaybe<UserToManyCheckoutSessionFilter>;
  /** Some related `checkoutSessions` exist. */
  checkoutSessionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `couponUsers` relation. */
  couponUsers?: InputMaybe<UserToManyCouponUserFilter>;
  /** Some related `couponUsers` exist. */
  couponUsersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `discordId` field. */
  discordId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `discordUsername` field. */
  discordUsername?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emails` relation. */
  emails?: InputMaybe<UserToManyEmailFilter>;
  /** Some related `emails` exist. */
  emailsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `groupAdmins` relation. */
  groupAdmins?: InputMaybe<UserToManyGroupAdminFilter>;
  /** Some related `groupAdmins` exist. */
  groupAdminsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `heldLockTypes` field. */
  heldLockTypes?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `heldLocks` field. */
  heldLocks?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `impactGroupAssignments` relation. */
  impactGroupAssignments?: InputMaybe<UserToManyImpactGroupAssignmentFilter>;
  /** Filter by the object’s `impactGroupAssignmentsByAssignedBy` relation. */
  impactGroupAssignmentsByAssignedBy?: InputMaybe<UserToManyImpactGroupAssignmentFilter>;
  /** Some related `impactGroupAssignmentsByAssignedBy` exist. */
  impactGroupAssignmentsByAssignedByExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `impactGroupAssignments` exist. */
  impactGroupAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `isLocked` field. */
  isLocked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `kycStatus` field. */
  kycStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `latestVerificationStatus` field. */
  latestVerificationStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lockType` field. */
  lockType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `needsVerification` field. */
  needsVerification?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Filter by the object’s `nuveiSavedCards` relation. */
  nuveiSavedCards?: InputMaybe<UserToManyNuveiSavedCardFilter>;
  /** Some related `nuveiSavedCards` exist. */
  nuveiSavedCardsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `passwordHistories` relation. */
  passwordHistories?: InputMaybe<UserToManyPasswordHistoryFilter>;
  /** Some related `passwordHistories` exist. */
  passwordHistoriesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequestBatchesByAssignedToAdminId` relation. */
  payoutRequestBatchesByAssignedToAdminId?: InputMaybe<UserToManyPayoutRequestBatchFilter>;
  /** Some related `payoutRequestBatchesByAssignedToAdminId` exist. */
  payoutRequestBatchesByAssignedToAdminIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequestBatchesByCreatedById` relation. */
  payoutRequestBatchesByCreatedById?: InputMaybe<UserToManyPayoutRequestBatchFilter>;
  /** Some related `payoutRequestBatchesByCreatedById` exist. */
  payoutRequestBatchesByCreatedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequestSubscribers` relation. */
  payoutRequestSubscribers?: InputMaybe<UserToManyPayoutRequestSubscriberFilter>;
  /** Some related `payoutRequestSubscribers` exist. */
  payoutRequestSubscribersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `payoutRequests` relation. */
  payoutRequests?: InputMaybe<UserToManyPayoutRequestFilter>;
  /** Some related `payoutRequests` exist. */
  payoutRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `personaWebhookEvents` relation. */
  personaWebhookEvents?: InputMaybe<UserToManyPersonaWebhookEventFilter>;
  /** Some related `personaWebhookEvents` exist. */
  personaWebhookEventsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectXUserId` field. */
  projectXUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `publicTrader` relation. */
  publicTrader?: InputMaybe<TraderPublicProfileFilter>;
  /** A related `publicTrader` exists. */
  publicTraderExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `purchaseOrders` relation. */
  purchaseOrders?: InputMaybe<UserToManyPurchaseOrderFilter>;
  /** Some related `purchaseOrders` exist. */
  purchaseOrdersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rebillSessions` relation. */
  rebillSessions?: InputMaybe<UserToManyRebillSessionFilter>;
  /** Some related `rebillSessions` exist. */
  rebillSessionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `registrationRiskAssessment` relation. */
  registrationRiskAssessment?: InputMaybe<RegistrationRiskAssessmentFilter>;
  /** A related `registrationRiskAssessment` exists. */
  registrationRiskAssessmentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `resetCredits` relation. */
  resetCredits?: InputMaybe<UserToManyResetCreditFilter>;
  /** Some related `resetCredits` exist. */
  resetCreditsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `savedCards` relation. */
  savedCards?: InputMaybe<UserToManySavedCardFilter>;
  /** Some related `savedCards` exist. */
  savedCardsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taxForms` relation. */
  taxForms?: InputMaybe<UserToManyUserTaxFormFilter>;
  /** Some related `taxForms` exist. */
  taxFormsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taxInfos` relation. */
  taxInfos?: InputMaybe<UserToManyTaxInfoFilter>;
  /** Some related `taxInfos` exist. */
  taxInfosExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `traderLockDetail` relation. */
  traderLockDetail?: InputMaybe<TraderLockDetailFilter>;
  /** A related `traderLockDetail` exists. */
  traderLockDetailExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `traderProfileModerationCasesByTraderId` relation. */
  traderProfileModerationCasesByTraderId?: InputMaybe<UserToManyTraderProfileModerationCaseFilter>;
  /** Some related `traderProfileModerationCasesByTraderId` exist. */
  traderProfileModerationCasesByTraderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `traderRiskIndicators` relation. */
  traderRiskIndicators?: InputMaybe<UserToManyTraderRiskIndicatorFilter>;
  /** Some related `traderRiskIndicators` exist. */
  traderRiskIndicatorsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userAddresses` relation. */
  userAddresses?: InputMaybe<UserToManyUserAddressFilter>;
  /** Some related `userAddresses` exist. */
  userAddressesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userAdminRoles` relation. */
  userAdminRoles?: InputMaybe<UserToManyUserAdminRoleFilter>;
  /** Some related `userAdminRoles` exist. */
  userAdminRolesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userAgreements` relation. */
  userAgreements?: InputMaybe<UserToManyUserAgreementFilter>;
  /** Some related `userAgreements` exist. */
  userAgreementsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userCertificates` relation. */
  userCertificates?: InputMaybe<UserToManyUserCertificateFilter>;
  /** Some related `userCertificates` exist. */
  userCertificatesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userContactInfo` relation. */
  userContactInfo?: InputMaybe<UserContactInfoFilter>;
  /** A related `userContactInfo` exists. */
  userContactInfoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userCooldowns` relation. */
  userCooldowns?: InputMaybe<UserToManyUserCooldownFilter>;
  /** Some related `userCooldowns` exist. */
  userCooldownsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userIntegration` relation. */
  userIntegration?: InputMaybe<UserIntegrationFilter>;
  /** A related `userIntegration` exists. */
  userIntegrationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userMeteredEvents` relation. */
  userMeteredEvents?: InputMaybe<UserToManyUserMeteredEventFilter>;
  /** Some related `userMeteredEvents` exist. */
  userMeteredEventsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userNotes` relation. */
  userNotes?: InputMaybe<UserToManyUserNoteFilter>;
  /** Some related `userNotes` exist. */
  userNotesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userNotesIssued` relation. */
  userNotesIssued?: InputMaybe<UserToManyUserNoteFilter>;
  /** Some related `userNotesIssued` exist. */
  userNotesIssuedExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userPlatformCredentials` relation. */
  userPlatformCredentials?: InputMaybe<UserToManyUserPlatformCredentialFilter>;
  /** Some related `userPlatformCredentials` exist. */
  userPlatformCredentialsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userRolesAdminRoles` relation. */
  userRolesAdminRoles?: InputMaybe<UserToManyUserRolesAdminRoleFilter>;
  /** Some related `userRolesAdminRoles` exist. */
  userRolesAdminRolesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userTcPurchaseLimits` relation. */
  userTcPurchaseLimits?: InputMaybe<UserToManyUserTcPurchaseLimitFilter>;
  /** Some related `userTcPurchaseLimits` exist. */
  userTcPurchaseLimitsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userXfaCooldowns` relation. */
  userXfaCooldowns?: InputMaybe<UserToManyUserXfaCooldownFilter>;
  /** Some related `userXfaCooldowns` exist. */
  userXfaCooldownsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `verifications` relation. */
  verifications?: InputMaybe<UserToManyVerificationFilter>;
  /** Some related `verifications` exist. */
  verificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `User` for usage during aggregation. */
export enum UserGroupBy {
  IsLocked = 'IS_LOCKED',
  KycStatus = 'KYC_STATUS',
  LockType = 'LOCK_TYPE',
  NeedsVerification = 'NEEDS_VERIFICATION',
  ProjectXuserId = 'PROJECT_XUSER_ID',
  Role = 'ROLE'
}

export type UserHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `User` aggregates. */
export type UserHavingInput = {
  AND?: InputMaybe<Array<UserHavingInput>>;
  OR?: InputMaybe<Array<UserHavingInput>>;
  average?: InputMaybe<UserHavingAverageInput>;
  distinctCount?: InputMaybe<UserHavingDistinctCountInput>;
  max?: InputMaybe<UserHavingMaxInput>;
  min?: InputMaybe<UserHavingMinInput>;
  stddevPopulation?: InputMaybe<UserHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserHavingStddevSampleInput>;
  sum?: InputMaybe<UserHavingSumInput>;
  variancePopulation?: InputMaybe<UserHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserHavingVarianceSampleInput>;
};

export type UserHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  forcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  legacyAppId?: InputMaybe<HavingIntFilter>;
  mobileForcedLogoutAt?: InputMaybe<HavingDatetimeFilter>;
  netSuiteId?: InputMaybe<HavingIntFilter>;
  projectXUserId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  verificationLastRequestedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserIntegration = Node & {
  __typename?: 'UserIntegration';
  discordAccessToken?: Maybe<Scalars['String']['output']>;
  discordId?: Maybe<Scalars['String']['output']>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `UserIntegration`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/** A filter to be used against `UserIntegration` object types. All fields are combined with a logical ‘and.’ */
export type UserIntegrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserIntegrationFilter>>;
  /** Filter by the object’s `discordId` field. */
  discordId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserIntegrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserIntegrationFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

export type UserMarketDatum = Node & {
  __typename?: 'UserMarketDatum';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  marketDataLevel?: Maybe<Scalars['String']['output']>;
  platformId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type UserMaxAggregates = {
  __typename?: 'UserMaxAggregates';
  /** Maximum of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['Int']['output']>;
  /** Maximum of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type UserMeteredEvent = Node & {
  __typename?: 'UserMeteredEvent';
  createdAt: Scalars['Datetime']['output'];
  eventType: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `User` that is related to this `UserMeteredEvent`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserMeteredEventAggregates = {
  __typename?: 'UserMeteredEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserMeteredEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserMeteredEventDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserMeteredEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserMeteredEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserMeteredEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserMeteredEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserMeteredEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserMeteredEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserMeteredEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserMeteredEvent` object types. */
export type UserMeteredEventAggregatesFilter = {
  /** Mean average aggregate over matching `UserMeteredEvent` objects. */
  average?: InputMaybe<UserMeteredEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserMeteredEvent` objects. */
  distinctCount?: InputMaybe<UserMeteredEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserMeteredEvent` object to be included within the aggregate. */
  filter?: InputMaybe<UserMeteredEventFilter>;
  /** Maximum aggregate over matching `UserMeteredEvent` objects. */
  max?: InputMaybe<UserMeteredEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserMeteredEvent` objects. */
  min?: InputMaybe<UserMeteredEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserMeteredEvent` objects. */
  stddevPopulation?: InputMaybe<UserMeteredEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserMeteredEvent` objects. */
  stddevSample?: InputMaybe<UserMeteredEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserMeteredEvent` objects. */
  sum?: InputMaybe<UserMeteredEventSumAggregateFilter>;
  /** Population variance aggregate over matching `UserMeteredEvent` objects. */
  variancePopulation?: InputMaybe<UserMeteredEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserMeteredEvent` objects. */
  varianceSample?: InputMaybe<UserMeteredEventVarianceSampleAggregateFilter>;
};

export type UserMeteredEventAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserMeteredEventAverageAggregates = {
  __typename?: 'UserMeteredEventAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserMeteredEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserMeteredEventCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserMeteredEvent` values. */
export type UserMeteredEventConnection = {
  __typename?: 'UserMeteredEventConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserMeteredEventAggregates>;
  /** A list of edges which contains the `UserMeteredEvent` and cursor to aid in pagination. */
  edges: Array<Maybe<UserMeteredEventEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserMeteredEventAggregates>>;
  /** A list of `UserMeteredEvent` objects. */
  nodes: Array<Maybe<UserMeteredEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserMeteredEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserMeteredEvent` values. */
export type UserMeteredEventConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserMeteredEventGroupBy>;
  having?: InputMaybe<UserMeteredEventHavingInput>;
};

export type UserMeteredEventDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  eventType?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserMeteredEventDistinctCountAggregates = {
  __typename?: 'UserMeteredEventDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventType across the matching connection */
  eventType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserMeteredEvent` edge in the connection. */
export type UserMeteredEventEdge = {
  __typename?: 'UserMeteredEventEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserMeteredEvent` at the end of the edge. */
  node?: Maybe<UserMeteredEvent>;
};

/** A filter to be used against `UserMeteredEvent` object types. All fields are combined with a logical ‘and.’ */
export type UserMeteredEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserMeteredEventFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserMeteredEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserMeteredEventFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserMeteredEvent` for usage during aggregation. */
export enum UserMeteredEventGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  EventType = 'EVENT_TYPE',
  UserId = 'USER_ID'
}

export type UserMeteredEventHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserMeteredEvent` aggregates. */
export type UserMeteredEventHavingInput = {
  AND?: InputMaybe<Array<UserMeteredEventHavingInput>>;
  OR?: InputMaybe<Array<UserMeteredEventHavingInput>>;
  average?: InputMaybe<UserMeteredEventHavingAverageInput>;
  distinctCount?: InputMaybe<UserMeteredEventHavingDistinctCountInput>;
  max?: InputMaybe<UserMeteredEventHavingMaxInput>;
  min?: InputMaybe<UserMeteredEventHavingMinInput>;
  stddevPopulation?: InputMaybe<UserMeteredEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserMeteredEventHavingStddevSampleInput>;
  sum?: InputMaybe<UserMeteredEventHavingSumInput>;
  variancePopulation?: InputMaybe<UserMeteredEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserMeteredEventHavingVarianceSampleInput>;
};

export type UserMeteredEventHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserMeteredEventMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserMeteredEventMaxAggregates = {
  __typename?: 'UserMeteredEventMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserMeteredEventMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserMeteredEventMinAggregates = {
  __typename?: 'UserMeteredEventMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserMeteredEvent`. */
export enum UserMeteredEventOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EventTypeAsc = 'EVENT_TYPE_ASC',
  EventTypeDesc = 'EVENT_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserMeteredEventStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserMeteredEventStddevPopulationAggregates = {
  __typename?: 'UserMeteredEventStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserMeteredEventStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserMeteredEventStddevSampleAggregates = {
  __typename?: 'UserMeteredEventStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserMeteredEventSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserMeteredEventSumAggregates = {
  __typename?: 'UserMeteredEventSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserMeteredEventVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserMeteredEventVariancePopulationAggregates = {
  __typename?: 'UserMeteredEventVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserMeteredEventVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserMeteredEventVarianceSampleAggregates = {
  __typename?: 'UserMeteredEventVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserMinAggregates = {
  __typename?: 'UserMinAggregates';
  /** Minimum of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['Int']['output']>;
  /** Minimum of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type UserNote = Node & {
  __typename?: 'UserNote';
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  issuedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `User` that is related to this `UserNote`. */
  issuedByUser?: Maybe<User>;
  legacyAuthorName?: Maybe<Scalars['String']['output']>;
  legacyNoteId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserNote`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserNoteAggregates = {
  __typename?: 'UserNoteAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserNoteAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserNoteDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserNoteMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserNoteMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserNoteStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserNoteStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserNoteSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserNoteVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserNoteVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserNote` object types. */
export type UserNoteAggregatesFilter = {
  /** Mean average aggregate over matching `UserNote` objects. */
  average?: InputMaybe<UserNoteAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserNote` objects. */
  distinctCount?: InputMaybe<UserNoteDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserNote` object to be included within the aggregate. */
  filter?: InputMaybe<UserNoteFilter>;
  /** Maximum aggregate over matching `UserNote` objects. */
  max?: InputMaybe<UserNoteMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserNote` objects. */
  min?: InputMaybe<UserNoteMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserNote` objects. */
  stddevPopulation?: InputMaybe<UserNoteStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserNote` objects. */
  stddevSample?: InputMaybe<UserNoteStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserNote` objects. */
  sum?: InputMaybe<UserNoteSumAggregateFilter>;
  /** Population variance aggregate over matching `UserNote` objects. */
  variancePopulation?: InputMaybe<UserNoteVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserNote` objects. */
  varianceSample?: InputMaybe<UserNoteVarianceSampleAggregateFilter>;
};

export type UserNoteAverageAggregateFilter = {
  issuedBy?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserNoteAverageAggregates = {
  __typename?: 'UserNoteAverageAggregates';
  /** Mean average of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserNote` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserNoteCondition = {
  /** Checks for equality with the object’s `issuedBy` field. */
  issuedBy?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserNote` values. */
export type UserNoteConnection = {
  __typename?: 'UserNoteConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserNoteAggregates>;
  /** A list of edges which contains the `UserNote` and cursor to aid in pagination. */
  edges: Array<Maybe<UserNoteEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserNoteAggregates>>;
  /** A list of `UserNote` objects. */
  nodes: Array<Maybe<UserNote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserNote` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserNote` values. */
export type UserNoteConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserNoteGroupBy>;
  having?: InputMaybe<UserNoteHavingInput>;
};

export type UserNoteDistinctCountAggregateFilter = {
  issuedBy?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserNoteDistinctCountAggregates = {
  __typename?: 'UserNoteDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of legacyAuthorName across the matching connection */
  legacyAuthorName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of source across the matching connection */
  source?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserNote` edge in the connection. */
export type UserNoteEdge = {
  __typename?: 'UserNoteEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserNote` at the end of the edge. */
  node?: Maybe<UserNote>;
};

/** A filter to be used against `UserNote` object types. All fields are combined with a logical ‘and.’ */
export type UserNoteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserNoteFilter>>;
  /** Filter by the object’s `issuedBy` field. */
  issuedBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `issuedByUser` relation. */
  issuedByUser?: InputMaybe<UserFilter>;
  /** A related `issuedByUser` exists. */
  issuedByUserExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<UserNoteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserNoteFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserNote` for usage during aggregation. */
export enum UserNoteGroupBy {
  IssuedBy = 'ISSUED_BY',
  UserId = 'USER_ID'
}

export type UserNoteHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserNote` aggregates. */
export type UserNoteHavingInput = {
  AND?: InputMaybe<Array<UserNoteHavingInput>>;
  OR?: InputMaybe<Array<UserNoteHavingInput>>;
  average?: InputMaybe<UserNoteHavingAverageInput>;
  distinctCount?: InputMaybe<UserNoteHavingDistinctCountInput>;
  max?: InputMaybe<UserNoteHavingMaxInput>;
  min?: InputMaybe<UserNoteHavingMinInput>;
  stddevPopulation?: InputMaybe<UserNoteHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserNoteHavingStddevSampleInput>;
  sum?: InputMaybe<UserNoteHavingSumInput>;
  variancePopulation?: InputMaybe<UserNoteHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserNoteHavingVarianceSampleInput>;
};

export type UserNoteHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  issuedBy?: InputMaybe<HavingIntFilter>;
  legacyNoteId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserNoteMaxAggregateFilter = {
  issuedBy?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserNoteMaxAggregates = {
  __typename?: 'UserNoteMaxAggregates';
  /** Maximum of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['Int']['output']>;
  /** Maximum of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserNoteMinAggregateFilter = {
  issuedBy?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserNoteMinAggregates = {
  __typename?: 'UserNoteMinAggregates';
  /** Minimum of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['Int']['output']>;
  /** Minimum of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserNote`. */
export enum UserNoteOrderBy {
  IssuedByAsc = 'ISSUED_BY_ASC',
  IssuedByDesc = 'ISSUED_BY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserNoteStddevPopulationAggregateFilter = {
  issuedBy?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserNoteStddevPopulationAggregates = {
  __typename?: 'UserNoteStddevPopulationAggregates';
  /** Population standard deviation of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserNoteStddevSampleAggregateFilter = {
  issuedBy?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserNoteStddevSampleAggregates = {
  __typename?: 'UserNoteStddevSampleAggregates';
  /** Sample standard deviation of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserNoteSumAggregateFilter = {
  issuedBy?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserNoteSumAggregates = {
  __typename?: 'UserNoteSumAggregates';
  /** Sum of issuedBy across the matching connection */
  issuedBy: Scalars['BigInt']['output'];
  /** Sum of legacyNoteId across the matching connection */
  legacyNoteId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserNoteVariancePopulationAggregateFilter = {
  issuedBy?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserNoteVariancePopulationAggregates = {
  __typename?: 'UserNoteVariancePopulationAggregates';
  /** Population variance of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserNoteVarianceSampleAggregateFilter = {
  issuedBy?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserNoteVarianceSampleAggregates = {
  __typename?: 'UserNoteVarianceSampleAggregates';
  /** Sample variance of issuedBy across the matching connection */
  issuedBy?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of legacyNoteId across the matching connection */
  legacyNoteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** Methods to use when ordering `User`. */
export enum UserOrderBy {
  AccountsAverageAccountTemplateAsc = 'ACCOUNTS_AVERAGE_ACCOUNT_TEMPLATE_ASC',
  AccountsAverageAccountTemplateDesc = 'ACCOUNTS_AVERAGE_ACCOUNT_TEMPLATE_DESC',
  AccountsAverageNmiSubscriptionIdAsc = 'ACCOUNTS_AVERAGE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsAverageNmiSubscriptionIdDesc = 'ACCOUNTS_AVERAGE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsAveragePlatformIdAsc = 'ACCOUNTS_AVERAGE_PLATFORM_ID_ASC',
  AccountsAveragePlatformIdDesc = 'ACCOUNTS_AVERAGE_PLATFORM_ID_DESC',
  AccountsAverageProjectXaccountIdAsc = 'ACCOUNTS_AVERAGE_PROJECT_XACCOUNT_ID_ASC',
  AccountsAverageProjectXaccountIdDesc = 'ACCOUNTS_AVERAGE_PROJECT_XACCOUNT_ID_DESC',
  AccountsAverageRowIdAsc = 'ACCOUNTS_AVERAGE_ROW_ID_ASC',
  AccountsAverageRowIdDesc = 'ACCOUNTS_AVERAGE_ROW_ID_DESC',
  AccountsAverageSkuIdAsc = 'ACCOUNTS_AVERAGE_SKU_ID_ASC',
  AccountsAverageSkuIdDesc = 'ACCOUNTS_AVERAGE_SKU_ID_DESC',
  AccountsAverageSubscriptionIdAsc = 'ACCOUNTS_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountsAverageSubscriptionIdDesc = 'ACCOUNTS_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountsAverageUserIdAsc = 'ACCOUNTS_AVERAGE_USER_ID_ASC',
  AccountsAverageUserIdDesc = 'ACCOUNTS_AVERAGE_USER_ID_DESC',
  AccountsCountAsc = 'ACCOUNTS_COUNT_ASC',
  AccountsCountDesc = 'ACCOUNTS_COUNT_DESC',
  AccountsDistinctCountAccountNameAsc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_NAME_ASC',
  AccountsDistinctCountAccountNameDesc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_NAME_DESC',
  AccountsDistinctCountAccountTemplateAsc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ASC',
  AccountsDistinctCountAccountTemplateDesc = 'ACCOUNTS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_DESC',
  AccountsDistinctCountActiveAsc = 'ACCOUNTS_DISTINCT_COUNT_ACTIVE_ASC',
  AccountsDistinctCountActiveDesc = 'ACCOUNTS_DISTINCT_COUNT_ACTIVE_DESC',
  AccountsDistinctCountComplimentaryAsc = 'ACCOUNTS_DISTINCT_COUNT_COMPLIMENTARY_ASC',
  AccountsDistinctCountComplimentaryDesc = 'ACCOUNTS_DISTINCT_COUNT_COMPLIMENTARY_DESC',
  AccountsDistinctCountCreatedAtAsc = 'ACCOUNTS_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountsDistinctCountCreatedAtDesc = 'ACCOUNTS_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountsDistinctCountNmiSubscriptionIdAsc = 'ACCOUNTS_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_ASC',
  AccountsDistinctCountNmiSubscriptionIdDesc = 'ACCOUNTS_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_DESC',
  AccountsDistinctCountPlatformIdAsc = 'ACCOUNTS_DISTINCT_COUNT_PLATFORM_ID_ASC',
  AccountsDistinctCountPlatformIdDesc = 'ACCOUNTS_DISTINCT_COUNT_PLATFORM_ID_DESC',
  AccountsDistinctCountProjectXaccountIdAsc = 'ACCOUNTS_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_ASC',
  AccountsDistinctCountProjectXaccountIdDesc = 'ACCOUNTS_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_DESC',
  AccountsDistinctCountRowIdAsc = 'ACCOUNTS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountsDistinctCountRowIdDesc = 'ACCOUNTS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountsDistinctCountSkuIdAsc = 'ACCOUNTS_DISTINCT_COUNT_SKU_ID_ASC',
  AccountsDistinctCountSkuIdDesc = 'ACCOUNTS_DISTINCT_COUNT_SKU_ID_DESC',
  AccountsDistinctCountStageAsc = 'ACCOUNTS_DISTINCT_COUNT_STAGE_ASC',
  AccountsDistinctCountStageDesc = 'ACCOUNTS_DISTINCT_COUNT_STAGE_DESC',
  AccountsDistinctCountStartDateAsc = 'ACCOUNTS_DISTINCT_COUNT_START_DATE_ASC',
  AccountsDistinctCountStartDateDesc = 'ACCOUNTS_DISTINCT_COUNT_START_DATE_DESC',
  AccountsDistinctCountStatusAsc = 'ACCOUNTS_DISTINCT_COUNT_STATUS_ASC',
  AccountsDistinctCountStatusDesc = 'ACCOUNTS_DISTINCT_COUNT_STATUS_DESC',
  AccountsDistinctCountSubscriptionIdAsc = 'ACCOUNTS_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountsDistinctCountSubscriptionIdDesc = 'ACCOUNTS_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountsDistinctCountUserIdAsc = 'ACCOUNTS_DISTINCT_COUNT_USER_ID_ASC',
  AccountsDistinctCountUserIdDesc = 'ACCOUNTS_DISTINCT_COUNT_USER_ID_DESC',
  AccountsMaxAccountTemplateAsc = 'ACCOUNTS_MAX_ACCOUNT_TEMPLATE_ASC',
  AccountsMaxAccountTemplateDesc = 'ACCOUNTS_MAX_ACCOUNT_TEMPLATE_DESC',
  AccountsMaxNmiSubscriptionIdAsc = 'ACCOUNTS_MAX_NMI_SUBSCRIPTION_ID_ASC',
  AccountsMaxNmiSubscriptionIdDesc = 'ACCOUNTS_MAX_NMI_SUBSCRIPTION_ID_DESC',
  AccountsMaxPlatformIdAsc = 'ACCOUNTS_MAX_PLATFORM_ID_ASC',
  AccountsMaxPlatformIdDesc = 'ACCOUNTS_MAX_PLATFORM_ID_DESC',
  AccountsMaxProjectXaccountIdAsc = 'ACCOUNTS_MAX_PROJECT_XACCOUNT_ID_ASC',
  AccountsMaxProjectXaccountIdDesc = 'ACCOUNTS_MAX_PROJECT_XACCOUNT_ID_DESC',
  AccountsMaxRowIdAsc = 'ACCOUNTS_MAX_ROW_ID_ASC',
  AccountsMaxRowIdDesc = 'ACCOUNTS_MAX_ROW_ID_DESC',
  AccountsMaxSkuIdAsc = 'ACCOUNTS_MAX_SKU_ID_ASC',
  AccountsMaxSkuIdDesc = 'ACCOUNTS_MAX_SKU_ID_DESC',
  AccountsMaxSubscriptionIdAsc = 'ACCOUNTS_MAX_SUBSCRIPTION_ID_ASC',
  AccountsMaxSubscriptionIdDesc = 'ACCOUNTS_MAX_SUBSCRIPTION_ID_DESC',
  AccountsMaxUserIdAsc = 'ACCOUNTS_MAX_USER_ID_ASC',
  AccountsMaxUserIdDesc = 'ACCOUNTS_MAX_USER_ID_DESC',
  AccountsMinAccountTemplateAsc = 'ACCOUNTS_MIN_ACCOUNT_TEMPLATE_ASC',
  AccountsMinAccountTemplateDesc = 'ACCOUNTS_MIN_ACCOUNT_TEMPLATE_DESC',
  AccountsMinNmiSubscriptionIdAsc = 'ACCOUNTS_MIN_NMI_SUBSCRIPTION_ID_ASC',
  AccountsMinNmiSubscriptionIdDesc = 'ACCOUNTS_MIN_NMI_SUBSCRIPTION_ID_DESC',
  AccountsMinPlatformIdAsc = 'ACCOUNTS_MIN_PLATFORM_ID_ASC',
  AccountsMinPlatformIdDesc = 'ACCOUNTS_MIN_PLATFORM_ID_DESC',
  AccountsMinProjectXaccountIdAsc = 'ACCOUNTS_MIN_PROJECT_XACCOUNT_ID_ASC',
  AccountsMinProjectXaccountIdDesc = 'ACCOUNTS_MIN_PROJECT_XACCOUNT_ID_DESC',
  AccountsMinRowIdAsc = 'ACCOUNTS_MIN_ROW_ID_ASC',
  AccountsMinRowIdDesc = 'ACCOUNTS_MIN_ROW_ID_DESC',
  AccountsMinSkuIdAsc = 'ACCOUNTS_MIN_SKU_ID_ASC',
  AccountsMinSkuIdDesc = 'ACCOUNTS_MIN_SKU_ID_DESC',
  AccountsMinSubscriptionIdAsc = 'ACCOUNTS_MIN_SUBSCRIPTION_ID_ASC',
  AccountsMinSubscriptionIdDesc = 'ACCOUNTS_MIN_SUBSCRIPTION_ID_DESC',
  AccountsMinUserIdAsc = 'ACCOUNTS_MIN_USER_ID_ASC',
  AccountsMinUserIdDesc = 'ACCOUNTS_MIN_USER_ID_DESC',
  AccountsStddevPopulationAccountTemplateAsc = 'ACCOUNTS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsStddevPopulationAccountTemplateDesc = 'ACCOUNTS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsStddevPopulationNmiSubscriptionIdAsc = 'ACCOUNTS_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsStddevPopulationNmiSubscriptionIdDesc = 'ACCOUNTS_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsStddevPopulationPlatformIdAsc = 'ACCOUNTS_STDDEV_POPULATION_PLATFORM_ID_ASC',
  AccountsStddevPopulationPlatformIdDesc = 'ACCOUNTS_STDDEV_POPULATION_PLATFORM_ID_DESC',
  AccountsStddevPopulationProjectXaccountIdAsc = 'ACCOUNTS_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsStddevPopulationProjectXaccountIdDesc = 'ACCOUNTS_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsStddevPopulationRowIdAsc = 'ACCOUNTS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountsStddevPopulationRowIdDesc = 'ACCOUNTS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountsStddevPopulationSkuIdAsc = 'ACCOUNTS_STDDEV_POPULATION_SKU_ID_ASC',
  AccountsStddevPopulationSkuIdDesc = 'ACCOUNTS_STDDEV_POPULATION_SKU_ID_DESC',
  AccountsStddevPopulationSubscriptionIdAsc = 'ACCOUNTS_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsStddevPopulationSubscriptionIdDesc = 'ACCOUNTS_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsStddevPopulationUserIdAsc = 'ACCOUNTS_STDDEV_POPULATION_USER_ID_ASC',
  AccountsStddevPopulationUserIdDesc = 'ACCOUNTS_STDDEV_POPULATION_USER_ID_DESC',
  AccountsStddevSampleAccountTemplateAsc = 'ACCOUNTS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsStddevSampleAccountTemplateDesc = 'ACCOUNTS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsStddevSampleNmiSubscriptionIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsStddevSampleNmiSubscriptionIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsStddevSamplePlatformIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_PLATFORM_ID_ASC',
  AccountsStddevSamplePlatformIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_PLATFORM_ID_DESC',
  AccountsStddevSampleProjectXaccountIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsStddevSampleProjectXaccountIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsStddevSampleRowIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountsStddevSampleRowIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountsStddevSampleSkuIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_SKU_ID_ASC',
  AccountsStddevSampleSkuIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_SKU_ID_DESC',
  AccountsStddevSampleSubscriptionIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsStddevSampleSubscriptionIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsStddevSampleUserIdAsc = 'ACCOUNTS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountsStddevSampleUserIdDesc = 'ACCOUNTS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountsSumAccountTemplateAsc = 'ACCOUNTS_SUM_ACCOUNT_TEMPLATE_ASC',
  AccountsSumAccountTemplateDesc = 'ACCOUNTS_SUM_ACCOUNT_TEMPLATE_DESC',
  AccountsSumNmiSubscriptionIdAsc = 'ACCOUNTS_SUM_NMI_SUBSCRIPTION_ID_ASC',
  AccountsSumNmiSubscriptionIdDesc = 'ACCOUNTS_SUM_NMI_SUBSCRIPTION_ID_DESC',
  AccountsSumPlatformIdAsc = 'ACCOUNTS_SUM_PLATFORM_ID_ASC',
  AccountsSumPlatformIdDesc = 'ACCOUNTS_SUM_PLATFORM_ID_DESC',
  AccountsSumProjectXaccountIdAsc = 'ACCOUNTS_SUM_PROJECT_XACCOUNT_ID_ASC',
  AccountsSumProjectXaccountIdDesc = 'ACCOUNTS_SUM_PROJECT_XACCOUNT_ID_DESC',
  AccountsSumRowIdAsc = 'ACCOUNTS_SUM_ROW_ID_ASC',
  AccountsSumRowIdDesc = 'ACCOUNTS_SUM_ROW_ID_DESC',
  AccountsSumSkuIdAsc = 'ACCOUNTS_SUM_SKU_ID_ASC',
  AccountsSumSkuIdDesc = 'ACCOUNTS_SUM_SKU_ID_DESC',
  AccountsSumSubscriptionIdAsc = 'ACCOUNTS_SUM_SUBSCRIPTION_ID_ASC',
  AccountsSumSubscriptionIdDesc = 'ACCOUNTS_SUM_SUBSCRIPTION_ID_DESC',
  AccountsSumUserIdAsc = 'ACCOUNTS_SUM_USER_ID_ASC',
  AccountsSumUserIdDesc = 'ACCOUNTS_SUM_USER_ID_DESC',
  AccountsVariancePopulationAccountTemplateAsc = 'ACCOUNTS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsVariancePopulationAccountTemplateDesc = 'ACCOUNTS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsVariancePopulationNmiSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsVariancePopulationNmiSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsVariancePopulationPlatformIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_PLATFORM_ID_ASC',
  AccountsVariancePopulationPlatformIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_PLATFORM_ID_DESC',
  AccountsVariancePopulationProjectXaccountIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsVariancePopulationProjectXaccountIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsVariancePopulationRowIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountsVariancePopulationRowIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountsVariancePopulationSkuIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_SKU_ID_ASC',
  AccountsVariancePopulationSkuIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_SKU_ID_DESC',
  AccountsVariancePopulationSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsVariancePopulationSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsVariancePopulationUserIdAsc = 'ACCOUNTS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountsVariancePopulationUserIdDesc = 'ACCOUNTS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountsVarianceSampleAccountTemplateAsc = 'ACCOUNTS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsVarianceSampleAccountTemplateDesc = 'ACCOUNTS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsVarianceSampleNmiSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsVarianceSampleNmiSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsVarianceSamplePlatformIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_PLATFORM_ID_ASC',
  AccountsVarianceSamplePlatformIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_PLATFORM_ID_DESC',
  AccountsVarianceSampleProjectXaccountIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsVarianceSampleProjectXaccountIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsVarianceSampleRowIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountsVarianceSampleRowIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountsVarianceSampleSkuIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_SKU_ID_ASC',
  AccountsVarianceSampleSkuIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_SKU_ID_DESC',
  AccountsVarianceSampleSubscriptionIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsVarianceSampleSubscriptionIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsVarianceSampleUserIdAsc = 'ACCOUNTS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountsVarianceSampleUserIdDesc = 'ACCOUNTS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountCallUpDecisionsAverageUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_AVERAGE_USER_ID_ASC',
  AccountCallUpDecisionsAverageUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_AVERAGE_USER_ID_DESC',
  AccountCallUpDecisionsCountAsc = 'ACCOUNT_CALL_UP_DECISIONS_COUNT_ASC',
  AccountCallUpDecisionsCountDesc = 'ACCOUNT_CALL_UP_DECISIONS_COUNT_DESC',
  AccountCallUpDecisionsDistinctCountCreatedAtAsc = 'ACCOUNT_CALL_UP_DECISIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountCallUpDecisionsDistinctCountCreatedAtDesc = 'ACCOUNT_CALL_UP_DECISIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountCallUpDecisionsDistinctCountRowIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountCallUpDecisionsDistinctCountRowIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountCallUpDecisionsDistinctCountUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_DISTINCT_COUNT_USER_ID_ASC',
  AccountCallUpDecisionsDistinctCountUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_DISTINCT_COUNT_USER_ID_DESC',
  AccountCallUpDecisionsMaxUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_MAX_USER_ID_ASC',
  AccountCallUpDecisionsMaxUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_MAX_USER_ID_DESC',
  AccountCallUpDecisionsMinUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_MIN_USER_ID_ASC',
  AccountCallUpDecisionsMinUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_MIN_USER_ID_DESC',
  AccountCallUpDecisionsStddevPopulationUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_STDDEV_POPULATION_USER_ID_ASC',
  AccountCallUpDecisionsStddevPopulationUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_STDDEV_POPULATION_USER_ID_DESC',
  AccountCallUpDecisionsStddevSampleUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountCallUpDecisionsStddevSampleUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountCallUpDecisionsSumUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_SUM_USER_ID_ASC',
  AccountCallUpDecisionsSumUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_SUM_USER_ID_DESC',
  AccountCallUpDecisionsVariancePopulationUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountCallUpDecisionsVariancePopulationUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountCallUpDecisionsVarianceSampleUserIdAsc = 'ACCOUNT_CALL_UP_DECISIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountCallUpDecisionsVarianceSampleUserIdDesc = 'ACCOUNT_CALL_UP_DECISIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountCallUpDecisionCalculationsAverageUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_AVERAGE_USER_ID_ASC',
  AccountCallUpDecisionCalculationsAverageUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_AVERAGE_USER_ID_DESC',
  AccountCallUpDecisionCalculationsCountAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_COUNT_ASC',
  AccountCallUpDecisionCalculationsCountDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_COUNT_DESC',
  AccountCallUpDecisionCalculationsDistinctCountCreatedAtAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountCallUpDecisionCalculationsDistinctCountCreatedAtDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountCallUpDecisionCalculationsDistinctCountDecisionIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_DECISION_ID_ASC',
  AccountCallUpDecisionCalculationsDistinctCountDecisionIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_DECISION_ID_DESC',
  AccountCallUpDecisionCalculationsDistinctCountRowIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountCallUpDecisionCalculationsDistinctCountRowIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountCallUpDecisionCalculationsDistinctCountUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_USER_ID_ASC',
  AccountCallUpDecisionCalculationsDistinctCountUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_DISTINCT_COUNT_USER_ID_DESC',
  AccountCallUpDecisionCalculationsMaxUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_MAX_USER_ID_ASC',
  AccountCallUpDecisionCalculationsMaxUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_MAX_USER_ID_DESC',
  AccountCallUpDecisionCalculationsMinUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_MIN_USER_ID_ASC',
  AccountCallUpDecisionCalculationsMinUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_MIN_USER_ID_DESC',
  AccountCallUpDecisionCalculationsStddevPopulationUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_STDDEV_POPULATION_USER_ID_ASC',
  AccountCallUpDecisionCalculationsStddevPopulationUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_STDDEV_POPULATION_USER_ID_DESC',
  AccountCallUpDecisionCalculationsStddevSampleUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountCallUpDecisionCalculationsStddevSampleUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountCallUpDecisionCalculationsSumUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_SUM_USER_ID_ASC',
  AccountCallUpDecisionCalculationsSumUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_SUM_USER_ID_DESC',
  AccountCallUpDecisionCalculationsVariancePopulationUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountCallUpDecisionCalculationsVariancePopulationUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountCallUpDecisionCalculationsVarianceSampleUserIdAsc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountCallUpDecisionCalculationsVarianceSampleUserIdDesc = 'ACCOUNT_CALL_UP_DECISION_CALCULATIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountCapitalEntriesCreatedAverageAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_AVERAGE_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedAverageAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_AVERAGE_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedAverageCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_AVERAGE_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedAverageCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_AVERAGE_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedAverageRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_AVERAGE_ROW_ID_ASC',
  AccountCapitalEntriesCreatedAverageRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_AVERAGE_ROW_ID_DESC',
  AccountCapitalEntriesCreatedCountAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_COUNT_ASC',
  AccountCapitalEntriesCreatedCountDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_COUNT_DESC',
  AccountCapitalEntriesCreatedDistinctCountAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedDistinctCountAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedDistinctCountCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedDistinctCountCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedDistinctCountRequestIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_REQUEST_ID_ASC',
  AccountCapitalEntriesCreatedDistinctCountRequestIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_REQUEST_ID_DESC',
  AccountCapitalEntriesCreatedDistinctCountRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_ROW_ID_ASC',
  AccountCapitalEntriesCreatedDistinctCountRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_DISTINCT_COUNT_ROW_ID_DESC',
  AccountCapitalEntriesCreatedMaxAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MAX_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedMaxAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MAX_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedMaxCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MAX_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedMaxCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MAX_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedMaxRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MAX_ROW_ID_ASC',
  AccountCapitalEntriesCreatedMaxRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MAX_ROW_ID_DESC',
  AccountCapitalEntriesCreatedMinAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MIN_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedMinAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MIN_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedMinCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MIN_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedMinCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MIN_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedMinRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MIN_ROW_ID_ASC',
  AccountCapitalEntriesCreatedMinRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_MIN_ROW_ID_DESC',
  AccountCapitalEntriesCreatedStddevPopulationAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_POPULATION_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedStddevPopulationAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_POPULATION_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedStddevPopulationCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_POPULATION_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedStddevPopulationCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_POPULATION_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedStddevPopulationRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_POPULATION_ROW_ID_ASC',
  AccountCapitalEntriesCreatedStddevPopulationRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_POPULATION_ROW_ID_DESC',
  AccountCapitalEntriesCreatedStddevSampleAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_SAMPLE_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedStddevSampleAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_SAMPLE_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedStddevSampleCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_SAMPLE_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedStddevSampleCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_SAMPLE_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedStddevSampleRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountCapitalEntriesCreatedStddevSampleRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountCapitalEntriesCreatedSumAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_SUM_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedSumAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_SUM_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedSumCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_SUM_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedSumCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_SUM_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedSumRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_SUM_ROW_ID_ASC',
  AccountCapitalEntriesCreatedSumRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_SUM_ROW_ID_DESC',
  AccountCapitalEntriesCreatedVariancePopulationAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_POPULATION_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedVariancePopulationAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_POPULATION_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedVariancePopulationCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_POPULATION_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedVariancePopulationCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_POPULATION_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedVariancePopulationRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountCapitalEntriesCreatedVariancePopulationRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountCapitalEntriesCreatedVarianceSampleAccountIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_SAMPLE_ACCOUNT_ID_ASC',
  AccountCapitalEntriesCreatedVarianceSampleAccountIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_SAMPLE_ACCOUNT_ID_DESC',
  AccountCapitalEntriesCreatedVarianceSampleCreatedByAdminIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_SAMPLE_CREATED_BY_ADMIN_ID_ASC',
  AccountCapitalEntriesCreatedVarianceSampleCreatedByAdminIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_SAMPLE_CREATED_BY_ADMIN_ID_DESC',
  AccountCapitalEntriesCreatedVarianceSampleRowIdAsc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountCapitalEntriesCreatedVarianceSampleRowIdDesc = 'ACCOUNT_CAPITAL_ENTRIES_CREATED_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountResetLimitsAverageRowIdAsc = 'ACCOUNT_RESET_LIMITS_AVERAGE_ROW_ID_ASC',
  AccountResetLimitsAverageRowIdDesc = 'ACCOUNT_RESET_LIMITS_AVERAGE_ROW_ID_DESC',
  AccountResetLimitsAverageSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsAverageSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsAverageUserIdAsc = 'ACCOUNT_RESET_LIMITS_AVERAGE_USER_ID_ASC',
  AccountResetLimitsAverageUserIdDesc = 'ACCOUNT_RESET_LIMITS_AVERAGE_USER_ID_DESC',
  AccountResetLimitsCountAsc = 'ACCOUNT_RESET_LIMITS_COUNT_ASC',
  AccountResetLimitsCountDesc = 'ACCOUNT_RESET_LIMITS_COUNT_DESC',
  AccountResetLimitsDistinctCountDateStrAsc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_DATE_STR_ASC',
  AccountResetLimitsDistinctCountDateStrDesc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_DATE_STR_DESC',
  AccountResetLimitsDistinctCountRowIdAsc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountResetLimitsDistinctCountRowIdDesc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountResetLimitsDistinctCountSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsDistinctCountSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsDistinctCountUserIdAsc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_USER_ID_ASC',
  AccountResetLimitsDistinctCountUserIdDesc = 'ACCOUNT_RESET_LIMITS_DISTINCT_COUNT_USER_ID_DESC',
  AccountResetLimitsMaxRowIdAsc = 'ACCOUNT_RESET_LIMITS_MAX_ROW_ID_ASC',
  AccountResetLimitsMaxRowIdDesc = 'ACCOUNT_RESET_LIMITS_MAX_ROW_ID_DESC',
  AccountResetLimitsMaxSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_MAX_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsMaxSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_MAX_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsMaxUserIdAsc = 'ACCOUNT_RESET_LIMITS_MAX_USER_ID_ASC',
  AccountResetLimitsMaxUserIdDesc = 'ACCOUNT_RESET_LIMITS_MAX_USER_ID_DESC',
  AccountResetLimitsMinRowIdAsc = 'ACCOUNT_RESET_LIMITS_MIN_ROW_ID_ASC',
  AccountResetLimitsMinRowIdDesc = 'ACCOUNT_RESET_LIMITS_MIN_ROW_ID_DESC',
  AccountResetLimitsMinSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_MIN_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsMinSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_MIN_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsMinUserIdAsc = 'ACCOUNT_RESET_LIMITS_MIN_USER_ID_ASC',
  AccountResetLimitsMinUserIdDesc = 'ACCOUNT_RESET_LIMITS_MIN_USER_ID_DESC',
  AccountResetLimitsStddevPopulationRowIdAsc = 'ACCOUNT_RESET_LIMITS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountResetLimitsStddevPopulationRowIdDesc = 'ACCOUNT_RESET_LIMITS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountResetLimitsStddevPopulationSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsStddevPopulationSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsStddevPopulationUserIdAsc = 'ACCOUNT_RESET_LIMITS_STDDEV_POPULATION_USER_ID_ASC',
  AccountResetLimitsStddevPopulationUserIdDesc = 'ACCOUNT_RESET_LIMITS_STDDEV_POPULATION_USER_ID_DESC',
  AccountResetLimitsStddevSampleRowIdAsc = 'ACCOUNT_RESET_LIMITS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountResetLimitsStddevSampleRowIdDesc = 'ACCOUNT_RESET_LIMITS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountResetLimitsStddevSampleSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsStddevSampleSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsStddevSampleUserIdAsc = 'ACCOUNT_RESET_LIMITS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountResetLimitsStddevSampleUserIdDesc = 'ACCOUNT_RESET_LIMITS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountResetLimitsSumRowIdAsc = 'ACCOUNT_RESET_LIMITS_SUM_ROW_ID_ASC',
  AccountResetLimitsSumRowIdDesc = 'ACCOUNT_RESET_LIMITS_SUM_ROW_ID_DESC',
  AccountResetLimitsSumSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_SUM_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsSumSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_SUM_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsSumUserIdAsc = 'ACCOUNT_RESET_LIMITS_SUM_USER_ID_ASC',
  AccountResetLimitsSumUserIdDesc = 'ACCOUNT_RESET_LIMITS_SUM_USER_ID_DESC',
  AccountResetLimitsVariancePopulationRowIdAsc = 'ACCOUNT_RESET_LIMITS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountResetLimitsVariancePopulationRowIdDesc = 'ACCOUNT_RESET_LIMITS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountResetLimitsVariancePopulationSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsVariancePopulationSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsVariancePopulationUserIdAsc = 'ACCOUNT_RESET_LIMITS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountResetLimitsVariancePopulationUserIdDesc = 'ACCOUNT_RESET_LIMITS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountResetLimitsVarianceSampleRowIdAsc = 'ACCOUNT_RESET_LIMITS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountResetLimitsVarianceSampleRowIdDesc = 'ACCOUNT_RESET_LIMITS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountResetLimitsVarianceSampleSubscriptionIdAsc = 'ACCOUNT_RESET_LIMITS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountResetLimitsVarianceSampleSubscriptionIdDesc = 'ACCOUNT_RESET_LIMITS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountResetLimitsVarianceSampleUserIdAsc = 'ACCOUNT_RESET_LIMITS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountResetLimitsVarianceSampleUserIdDesc = 'ACCOUNT_RESET_LIMITS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountResetTrackingsAverageBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_BRANCH_ID_ASC',
  AccountResetTrackingsAverageBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_BRANCH_ID_DESC',
  AccountResetTrackingsAverageRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_ROW_ID_ASC',
  AccountResetTrackingsAverageRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_ROW_ID_DESC',
  AccountResetTrackingsAverageSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsAverageSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsAverageUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_USER_ID_ASC',
  AccountResetTrackingsAverageUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_AVERAGE_USER_ID_DESC',
  AccountResetTrackingsCountAsc = 'ACCOUNT_RESET_TRACKINGS_COUNT_ASC',
  AccountResetTrackingsCountDesc = 'ACCOUNT_RESET_TRACKINGS_COUNT_DESC',
  AccountResetTrackingsDistinctCountAccountTypeAsc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_ACCOUNT_TYPE_ASC',
  AccountResetTrackingsDistinctCountAccountTypeDesc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_ACCOUNT_TYPE_DESC',
  AccountResetTrackingsDistinctCountBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_BRANCH_ID_ASC',
  AccountResetTrackingsDistinctCountBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_BRANCH_ID_DESC',
  AccountResetTrackingsDistinctCountRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_ROW_ID_ASC',
  AccountResetTrackingsDistinctCountRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_ROW_ID_DESC',
  AccountResetTrackingsDistinctCountSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsDistinctCountSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsDistinctCountUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_USER_ID_ASC',
  AccountResetTrackingsDistinctCountUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_DISTINCT_COUNT_USER_ID_DESC',
  AccountResetTrackingsMaxBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_MAX_BRANCH_ID_ASC',
  AccountResetTrackingsMaxBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_MAX_BRANCH_ID_DESC',
  AccountResetTrackingsMaxRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_MAX_ROW_ID_ASC',
  AccountResetTrackingsMaxRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_MAX_ROW_ID_DESC',
  AccountResetTrackingsMaxSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_MAX_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsMaxSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_MAX_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsMaxUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_MAX_USER_ID_ASC',
  AccountResetTrackingsMaxUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_MAX_USER_ID_DESC',
  AccountResetTrackingsMinBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_MIN_BRANCH_ID_ASC',
  AccountResetTrackingsMinBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_MIN_BRANCH_ID_DESC',
  AccountResetTrackingsMinRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_MIN_ROW_ID_ASC',
  AccountResetTrackingsMinRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_MIN_ROW_ID_DESC',
  AccountResetTrackingsMinSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_MIN_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsMinSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_MIN_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsMinUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_MIN_USER_ID_ASC',
  AccountResetTrackingsMinUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_MIN_USER_ID_DESC',
  AccountResetTrackingsStddevPopulationBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_BRANCH_ID_ASC',
  AccountResetTrackingsStddevPopulationBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_BRANCH_ID_DESC',
  AccountResetTrackingsStddevPopulationRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_ROW_ID_ASC',
  AccountResetTrackingsStddevPopulationRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_ROW_ID_DESC',
  AccountResetTrackingsStddevPopulationSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsStddevPopulationSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsStddevPopulationUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_USER_ID_ASC',
  AccountResetTrackingsStddevPopulationUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_POPULATION_USER_ID_DESC',
  AccountResetTrackingsStddevSampleBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_BRANCH_ID_ASC',
  AccountResetTrackingsStddevSampleBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_BRANCH_ID_DESC',
  AccountResetTrackingsStddevSampleRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountResetTrackingsStddevSampleRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountResetTrackingsStddevSampleSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsStddevSampleSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsStddevSampleUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_USER_ID_ASC',
  AccountResetTrackingsStddevSampleUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_STDDEV_SAMPLE_USER_ID_DESC',
  AccountResetTrackingsSumBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_SUM_BRANCH_ID_ASC',
  AccountResetTrackingsSumBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_SUM_BRANCH_ID_DESC',
  AccountResetTrackingsSumRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_SUM_ROW_ID_ASC',
  AccountResetTrackingsSumRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_SUM_ROW_ID_DESC',
  AccountResetTrackingsSumSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_SUM_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsSumSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_SUM_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsSumUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_SUM_USER_ID_ASC',
  AccountResetTrackingsSumUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_SUM_USER_ID_DESC',
  AccountResetTrackingsVariancePopulationBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_BRANCH_ID_ASC',
  AccountResetTrackingsVariancePopulationBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_BRANCH_ID_DESC',
  AccountResetTrackingsVariancePopulationRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountResetTrackingsVariancePopulationRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountResetTrackingsVariancePopulationSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsVariancePopulationSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsVariancePopulationUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_USER_ID_ASC',
  AccountResetTrackingsVariancePopulationUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_POPULATION_USER_ID_DESC',
  AccountResetTrackingsVarianceSampleBranchIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_BRANCH_ID_ASC',
  AccountResetTrackingsVarianceSampleBranchIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_BRANCH_ID_DESC',
  AccountResetTrackingsVarianceSampleRowIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountResetTrackingsVarianceSampleRowIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountResetTrackingsVarianceSampleSubscriptionIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountResetTrackingsVarianceSampleSubscriptionIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountResetTrackingsVarianceSampleUserIdAsc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountResetTrackingsVarianceSampleUserIdDesc = 'ACCOUNT_RESET_TRACKINGS_VARIANCE_SAMPLE_USER_ID_DESC',
  AccountTotalAsc = 'ACCOUNT_TOTAL_ASC',
  AccountTotalDesc = 'ACCOUNT_TOTAL_DESC',
  AdminRoleUsersUsersAverageAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersAverageAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersAverageUserIdAsc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_USER_ID_ASC',
  AdminRoleUsersUsersAverageUserIdDesc = 'ADMIN_ROLE_USERS_USERS_AVERAGE_USER_ID_DESC',
  AdminRoleUsersUsersCountAsc = 'ADMIN_ROLE_USERS_USERS_COUNT_ASC',
  AdminRoleUsersUsersCountDesc = 'ADMIN_ROLE_USERS_USERS_COUNT_DESC',
  AdminRoleUsersUsersDistinctCountAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersDistinctCountAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersDistinctCountUserIdAsc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_USER_ID_ASC',
  AdminRoleUsersUsersDistinctCountUserIdDesc = 'ADMIN_ROLE_USERS_USERS_DISTINCT_COUNT_USER_ID_DESC',
  AdminRoleUsersUsersMaxAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_MAX_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersMaxAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_MAX_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersMaxUserIdAsc = 'ADMIN_ROLE_USERS_USERS_MAX_USER_ID_ASC',
  AdminRoleUsersUsersMaxUserIdDesc = 'ADMIN_ROLE_USERS_USERS_MAX_USER_ID_DESC',
  AdminRoleUsersUsersMinAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_MIN_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersMinAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_MIN_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersMinUserIdAsc = 'ADMIN_ROLE_USERS_USERS_MIN_USER_ID_ASC',
  AdminRoleUsersUsersMinUserIdDesc = 'ADMIN_ROLE_USERS_USERS_MIN_USER_ID_DESC',
  AdminRoleUsersUsersStddevPopulationAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersStddevPopulationAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersStddevPopulationUserIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_USER_ID_ASC',
  AdminRoleUsersUsersStddevPopulationUserIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_POPULATION_USER_ID_DESC',
  AdminRoleUsersUsersStddevSampleAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersStddevSampleAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersStddevSampleUserIdAsc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_USER_ID_ASC',
  AdminRoleUsersUsersStddevSampleUserIdDesc = 'ADMIN_ROLE_USERS_USERS_STDDEV_SAMPLE_USER_ID_DESC',
  AdminRoleUsersUsersSumAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_SUM_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersSumAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_SUM_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersSumUserIdAsc = 'ADMIN_ROLE_USERS_USERS_SUM_USER_ID_ASC',
  AdminRoleUsersUsersSumUserIdDesc = 'ADMIN_ROLE_USERS_USERS_SUM_USER_ID_DESC',
  AdminRoleUsersUsersVariancePopulationAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersVariancePopulationAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersVariancePopulationUserIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_USER_ID_ASC',
  AdminRoleUsersUsersVariancePopulationUserIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_POPULATION_USER_ID_DESC',
  AdminRoleUsersUsersVarianceSampleAdminRoleIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_ADMIN_ROLE_ID_ASC',
  AdminRoleUsersUsersVarianceSampleAdminRoleIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_ADMIN_ROLE_ID_DESC',
  AdminRoleUsersUsersVarianceSampleUserIdAsc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_USER_ID_ASC',
  AdminRoleUsersUsersVarianceSampleUserIdDesc = 'ADMIN_ROLE_USERS_USERS_VARIANCE_SAMPLE_USER_ID_DESC',
  CardTransactionsAverageRowIdAsc = 'CARD_TRANSACTIONS_AVERAGE_ROW_ID_ASC',
  CardTransactionsAverageRowIdDesc = 'CARD_TRANSACTIONS_AVERAGE_ROW_ID_DESC',
  CardTransactionsAverageUserIdAsc = 'CARD_TRANSACTIONS_AVERAGE_USER_ID_ASC',
  CardTransactionsAverageUserIdDesc = 'CARD_TRANSACTIONS_AVERAGE_USER_ID_DESC',
  CardTransactionsCountAsc = 'CARD_TRANSACTIONS_COUNT_ASC',
  CardTransactionsCountDesc = 'CARD_TRANSACTIONS_COUNT_DESC',
  CardTransactionsDistinctCountCcCardNumberAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_CC_CARD_NUMBER_ASC',
  CardTransactionsDistinctCountCcCardNumberDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_CC_CARD_NUMBER_DESC',
  CardTransactionsDistinctCountCreatedAtAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  CardTransactionsDistinctCountCreatedAtDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  CardTransactionsDistinctCountNuveiPaymentIdAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_NUVEI_PAYMENT_ID_ASC',
  CardTransactionsDistinctCountNuveiPaymentIdDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_NUVEI_PAYMENT_ID_DESC',
  CardTransactionsDistinctCountResultAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_RESULT_ASC',
  CardTransactionsDistinctCountResultDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_RESULT_DESC',
  CardTransactionsDistinctCountRowIdAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_ROW_ID_ASC',
  CardTransactionsDistinctCountRowIdDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_ROW_ID_DESC',
  CardTransactionsDistinctCountStripePaymentIdAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_STRIPE_PAYMENT_ID_ASC',
  CardTransactionsDistinctCountStripePaymentIdDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_STRIPE_PAYMENT_ID_DESC',
  CardTransactionsDistinctCountUserIdAsc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_USER_ID_ASC',
  CardTransactionsDistinctCountUserIdDesc = 'CARD_TRANSACTIONS_DISTINCT_COUNT_USER_ID_DESC',
  CardTransactionsMaxRowIdAsc = 'CARD_TRANSACTIONS_MAX_ROW_ID_ASC',
  CardTransactionsMaxRowIdDesc = 'CARD_TRANSACTIONS_MAX_ROW_ID_DESC',
  CardTransactionsMaxUserIdAsc = 'CARD_TRANSACTIONS_MAX_USER_ID_ASC',
  CardTransactionsMaxUserIdDesc = 'CARD_TRANSACTIONS_MAX_USER_ID_DESC',
  CardTransactionsMinRowIdAsc = 'CARD_TRANSACTIONS_MIN_ROW_ID_ASC',
  CardTransactionsMinRowIdDesc = 'CARD_TRANSACTIONS_MIN_ROW_ID_DESC',
  CardTransactionsMinUserIdAsc = 'CARD_TRANSACTIONS_MIN_USER_ID_ASC',
  CardTransactionsMinUserIdDesc = 'CARD_TRANSACTIONS_MIN_USER_ID_DESC',
  CardTransactionsStddevPopulationRowIdAsc = 'CARD_TRANSACTIONS_STDDEV_POPULATION_ROW_ID_ASC',
  CardTransactionsStddevPopulationRowIdDesc = 'CARD_TRANSACTIONS_STDDEV_POPULATION_ROW_ID_DESC',
  CardTransactionsStddevPopulationUserIdAsc = 'CARD_TRANSACTIONS_STDDEV_POPULATION_USER_ID_ASC',
  CardTransactionsStddevPopulationUserIdDesc = 'CARD_TRANSACTIONS_STDDEV_POPULATION_USER_ID_DESC',
  CardTransactionsStddevSampleRowIdAsc = 'CARD_TRANSACTIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  CardTransactionsStddevSampleRowIdDesc = 'CARD_TRANSACTIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  CardTransactionsStddevSampleUserIdAsc = 'CARD_TRANSACTIONS_STDDEV_SAMPLE_USER_ID_ASC',
  CardTransactionsStddevSampleUserIdDesc = 'CARD_TRANSACTIONS_STDDEV_SAMPLE_USER_ID_DESC',
  CardTransactionsSumRowIdAsc = 'CARD_TRANSACTIONS_SUM_ROW_ID_ASC',
  CardTransactionsSumRowIdDesc = 'CARD_TRANSACTIONS_SUM_ROW_ID_DESC',
  CardTransactionsSumUserIdAsc = 'CARD_TRANSACTIONS_SUM_USER_ID_ASC',
  CardTransactionsSumUserIdDesc = 'CARD_TRANSACTIONS_SUM_USER_ID_DESC',
  CardTransactionsVariancePopulationRowIdAsc = 'CARD_TRANSACTIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  CardTransactionsVariancePopulationRowIdDesc = 'CARD_TRANSACTIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  CardTransactionsVariancePopulationUserIdAsc = 'CARD_TRANSACTIONS_VARIANCE_POPULATION_USER_ID_ASC',
  CardTransactionsVariancePopulationUserIdDesc = 'CARD_TRANSACTIONS_VARIANCE_POPULATION_USER_ID_DESC',
  CardTransactionsVarianceSampleRowIdAsc = 'CARD_TRANSACTIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CardTransactionsVarianceSampleRowIdDesc = 'CARD_TRANSACTIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CardTransactionsVarianceSampleUserIdAsc = 'CARD_TRANSACTIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  CardTransactionsVarianceSampleUserIdDesc = 'CARD_TRANSACTIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  CheckoutSessionsAveragePurchaseIdAsc = 'CHECKOUT_SESSIONS_AVERAGE_PURCHASE_ID_ASC',
  CheckoutSessionsAveragePurchaseIdDesc = 'CHECKOUT_SESSIONS_AVERAGE_PURCHASE_ID_DESC',
  CheckoutSessionsAverageRowIdAsc = 'CHECKOUT_SESSIONS_AVERAGE_ROW_ID_ASC',
  CheckoutSessionsAverageRowIdDesc = 'CHECKOUT_SESSIONS_AVERAGE_ROW_ID_DESC',
  CheckoutSessionsAverageUserIdAsc = 'CHECKOUT_SESSIONS_AVERAGE_USER_ID_ASC',
  CheckoutSessionsAverageUserIdDesc = 'CHECKOUT_SESSIONS_AVERAGE_USER_ID_DESC',
  CheckoutSessionsCountAsc = 'CHECKOUT_SESSIONS_COUNT_ASC',
  CheckoutSessionsCountDesc = 'CHECKOUT_SESSIONS_COUNT_DESC',
  CheckoutSessionsDistinctCountCreatedAtAsc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  CheckoutSessionsDistinctCountCreatedAtDesc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  CheckoutSessionsDistinctCountPurchaseIdAsc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_PURCHASE_ID_ASC',
  CheckoutSessionsDistinctCountPurchaseIdDesc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_PURCHASE_ID_DESC',
  CheckoutSessionsDistinctCountRowIdAsc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_ROW_ID_ASC',
  CheckoutSessionsDistinctCountRowIdDesc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_ROW_ID_DESC',
  CheckoutSessionsDistinctCountStatusAsc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_STATUS_ASC',
  CheckoutSessionsDistinctCountStatusDesc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_STATUS_DESC',
  CheckoutSessionsDistinctCountUpdatedAtAsc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_UPDATED_AT_ASC',
  CheckoutSessionsDistinctCountUpdatedAtDesc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_UPDATED_AT_DESC',
  CheckoutSessionsDistinctCountUserIdAsc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_USER_ID_ASC',
  CheckoutSessionsDistinctCountUserIdDesc = 'CHECKOUT_SESSIONS_DISTINCT_COUNT_USER_ID_DESC',
  CheckoutSessionsMaxPurchaseIdAsc = 'CHECKOUT_SESSIONS_MAX_PURCHASE_ID_ASC',
  CheckoutSessionsMaxPurchaseIdDesc = 'CHECKOUT_SESSIONS_MAX_PURCHASE_ID_DESC',
  CheckoutSessionsMaxRowIdAsc = 'CHECKOUT_SESSIONS_MAX_ROW_ID_ASC',
  CheckoutSessionsMaxRowIdDesc = 'CHECKOUT_SESSIONS_MAX_ROW_ID_DESC',
  CheckoutSessionsMaxUserIdAsc = 'CHECKOUT_SESSIONS_MAX_USER_ID_ASC',
  CheckoutSessionsMaxUserIdDesc = 'CHECKOUT_SESSIONS_MAX_USER_ID_DESC',
  CheckoutSessionsMinPurchaseIdAsc = 'CHECKOUT_SESSIONS_MIN_PURCHASE_ID_ASC',
  CheckoutSessionsMinPurchaseIdDesc = 'CHECKOUT_SESSIONS_MIN_PURCHASE_ID_DESC',
  CheckoutSessionsMinRowIdAsc = 'CHECKOUT_SESSIONS_MIN_ROW_ID_ASC',
  CheckoutSessionsMinRowIdDesc = 'CHECKOUT_SESSIONS_MIN_ROW_ID_DESC',
  CheckoutSessionsMinUserIdAsc = 'CHECKOUT_SESSIONS_MIN_USER_ID_ASC',
  CheckoutSessionsMinUserIdDesc = 'CHECKOUT_SESSIONS_MIN_USER_ID_DESC',
  CheckoutSessionsStddevPopulationPurchaseIdAsc = 'CHECKOUT_SESSIONS_STDDEV_POPULATION_PURCHASE_ID_ASC',
  CheckoutSessionsStddevPopulationPurchaseIdDesc = 'CHECKOUT_SESSIONS_STDDEV_POPULATION_PURCHASE_ID_DESC',
  CheckoutSessionsStddevPopulationRowIdAsc = 'CHECKOUT_SESSIONS_STDDEV_POPULATION_ROW_ID_ASC',
  CheckoutSessionsStddevPopulationRowIdDesc = 'CHECKOUT_SESSIONS_STDDEV_POPULATION_ROW_ID_DESC',
  CheckoutSessionsStddevPopulationUserIdAsc = 'CHECKOUT_SESSIONS_STDDEV_POPULATION_USER_ID_ASC',
  CheckoutSessionsStddevPopulationUserIdDesc = 'CHECKOUT_SESSIONS_STDDEV_POPULATION_USER_ID_DESC',
  CheckoutSessionsStddevSamplePurchaseIdAsc = 'CHECKOUT_SESSIONS_STDDEV_SAMPLE_PURCHASE_ID_ASC',
  CheckoutSessionsStddevSamplePurchaseIdDesc = 'CHECKOUT_SESSIONS_STDDEV_SAMPLE_PURCHASE_ID_DESC',
  CheckoutSessionsStddevSampleRowIdAsc = 'CHECKOUT_SESSIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  CheckoutSessionsStddevSampleRowIdDesc = 'CHECKOUT_SESSIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  CheckoutSessionsStddevSampleUserIdAsc = 'CHECKOUT_SESSIONS_STDDEV_SAMPLE_USER_ID_ASC',
  CheckoutSessionsStddevSampleUserIdDesc = 'CHECKOUT_SESSIONS_STDDEV_SAMPLE_USER_ID_DESC',
  CheckoutSessionsSumPurchaseIdAsc = 'CHECKOUT_SESSIONS_SUM_PURCHASE_ID_ASC',
  CheckoutSessionsSumPurchaseIdDesc = 'CHECKOUT_SESSIONS_SUM_PURCHASE_ID_DESC',
  CheckoutSessionsSumRowIdAsc = 'CHECKOUT_SESSIONS_SUM_ROW_ID_ASC',
  CheckoutSessionsSumRowIdDesc = 'CHECKOUT_SESSIONS_SUM_ROW_ID_DESC',
  CheckoutSessionsSumUserIdAsc = 'CHECKOUT_SESSIONS_SUM_USER_ID_ASC',
  CheckoutSessionsSumUserIdDesc = 'CHECKOUT_SESSIONS_SUM_USER_ID_DESC',
  CheckoutSessionsVariancePopulationPurchaseIdAsc = 'CHECKOUT_SESSIONS_VARIANCE_POPULATION_PURCHASE_ID_ASC',
  CheckoutSessionsVariancePopulationPurchaseIdDesc = 'CHECKOUT_SESSIONS_VARIANCE_POPULATION_PURCHASE_ID_DESC',
  CheckoutSessionsVariancePopulationRowIdAsc = 'CHECKOUT_SESSIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  CheckoutSessionsVariancePopulationRowIdDesc = 'CHECKOUT_SESSIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  CheckoutSessionsVariancePopulationUserIdAsc = 'CHECKOUT_SESSIONS_VARIANCE_POPULATION_USER_ID_ASC',
  CheckoutSessionsVariancePopulationUserIdDesc = 'CHECKOUT_SESSIONS_VARIANCE_POPULATION_USER_ID_DESC',
  CheckoutSessionsVarianceSamplePurchaseIdAsc = 'CHECKOUT_SESSIONS_VARIANCE_SAMPLE_PURCHASE_ID_ASC',
  CheckoutSessionsVarianceSamplePurchaseIdDesc = 'CHECKOUT_SESSIONS_VARIANCE_SAMPLE_PURCHASE_ID_DESC',
  CheckoutSessionsVarianceSampleRowIdAsc = 'CHECKOUT_SESSIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CheckoutSessionsVarianceSampleRowIdDesc = 'CHECKOUT_SESSIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CheckoutSessionsVarianceSampleUserIdAsc = 'CHECKOUT_SESSIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  CheckoutSessionsVarianceSampleUserIdDesc = 'CHECKOUT_SESSIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  CouponUsersAverageCouponIdAsc = 'COUPON_USERS_AVERAGE_COUPON_ID_ASC',
  CouponUsersAverageCouponIdDesc = 'COUPON_USERS_AVERAGE_COUPON_ID_DESC',
  CouponUsersAverageRowIdAsc = 'COUPON_USERS_AVERAGE_ROW_ID_ASC',
  CouponUsersAverageRowIdDesc = 'COUPON_USERS_AVERAGE_ROW_ID_DESC',
  CouponUsersAverageUserIdAsc = 'COUPON_USERS_AVERAGE_USER_ID_ASC',
  CouponUsersAverageUserIdDesc = 'COUPON_USERS_AVERAGE_USER_ID_DESC',
  CouponUsersCountAsc = 'COUPON_USERS_COUNT_ASC',
  CouponUsersCountDesc = 'COUPON_USERS_COUNT_DESC',
  CouponUsersDistinctCountCouponIdAsc = 'COUPON_USERS_DISTINCT_COUNT_COUPON_ID_ASC',
  CouponUsersDistinctCountCouponIdDesc = 'COUPON_USERS_DISTINCT_COUNT_COUPON_ID_DESC',
  CouponUsersDistinctCountRowIdAsc = 'COUPON_USERS_DISTINCT_COUNT_ROW_ID_ASC',
  CouponUsersDistinctCountRowIdDesc = 'COUPON_USERS_DISTINCT_COUNT_ROW_ID_DESC',
  CouponUsersDistinctCountUserIdAsc = 'COUPON_USERS_DISTINCT_COUNT_USER_ID_ASC',
  CouponUsersDistinctCountUserIdDesc = 'COUPON_USERS_DISTINCT_COUNT_USER_ID_DESC',
  CouponUsersMaxCouponIdAsc = 'COUPON_USERS_MAX_COUPON_ID_ASC',
  CouponUsersMaxCouponIdDesc = 'COUPON_USERS_MAX_COUPON_ID_DESC',
  CouponUsersMaxRowIdAsc = 'COUPON_USERS_MAX_ROW_ID_ASC',
  CouponUsersMaxRowIdDesc = 'COUPON_USERS_MAX_ROW_ID_DESC',
  CouponUsersMaxUserIdAsc = 'COUPON_USERS_MAX_USER_ID_ASC',
  CouponUsersMaxUserIdDesc = 'COUPON_USERS_MAX_USER_ID_DESC',
  CouponUsersMinCouponIdAsc = 'COUPON_USERS_MIN_COUPON_ID_ASC',
  CouponUsersMinCouponIdDesc = 'COUPON_USERS_MIN_COUPON_ID_DESC',
  CouponUsersMinRowIdAsc = 'COUPON_USERS_MIN_ROW_ID_ASC',
  CouponUsersMinRowIdDesc = 'COUPON_USERS_MIN_ROW_ID_DESC',
  CouponUsersMinUserIdAsc = 'COUPON_USERS_MIN_USER_ID_ASC',
  CouponUsersMinUserIdDesc = 'COUPON_USERS_MIN_USER_ID_DESC',
  CouponUsersStddevPopulationCouponIdAsc = 'COUPON_USERS_STDDEV_POPULATION_COUPON_ID_ASC',
  CouponUsersStddevPopulationCouponIdDesc = 'COUPON_USERS_STDDEV_POPULATION_COUPON_ID_DESC',
  CouponUsersStddevPopulationRowIdAsc = 'COUPON_USERS_STDDEV_POPULATION_ROW_ID_ASC',
  CouponUsersStddevPopulationRowIdDesc = 'COUPON_USERS_STDDEV_POPULATION_ROW_ID_DESC',
  CouponUsersStddevPopulationUserIdAsc = 'COUPON_USERS_STDDEV_POPULATION_USER_ID_ASC',
  CouponUsersStddevPopulationUserIdDesc = 'COUPON_USERS_STDDEV_POPULATION_USER_ID_DESC',
  CouponUsersStddevSampleCouponIdAsc = 'COUPON_USERS_STDDEV_SAMPLE_COUPON_ID_ASC',
  CouponUsersStddevSampleCouponIdDesc = 'COUPON_USERS_STDDEV_SAMPLE_COUPON_ID_DESC',
  CouponUsersStddevSampleRowIdAsc = 'COUPON_USERS_STDDEV_SAMPLE_ROW_ID_ASC',
  CouponUsersStddevSampleRowIdDesc = 'COUPON_USERS_STDDEV_SAMPLE_ROW_ID_DESC',
  CouponUsersStddevSampleUserIdAsc = 'COUPON_USERS_STDDEV_SAMPLE_USER_ID_ASC',
  CouponUsersStddevSampleUserIdDesc = 'COUPON_USERS_STDDEV_SAMPLE_USER_ID_DESC',
  CouponUsersSumCouponIdAsc = 'COUPON_USERS_SUM_COUPON_ID_ASC',
  CouponUsersSumCouponIdDesc = 'COUPON_USERS_SUM_COUPON_ID_DESC',
  CouponUsersSumRowIdAsc = 'COUPON_USERS_SUM_ROW_ID_ASC',
  CouponUsersSumRowIdDesc = 'COUPON_USERS_SUM_ROW_ID_DESC',
  CouponUsersSumUserIdAsc = 'COUPON_USERS_SUM_USER_ID_ASC',
  CouponUsersSumUserIdDesc = 'COUPON_USERS_SUM_USER_ID_DESC',
  CouponUsersVariancePopulationCouponIdAsc = 'COUPON_USERS_VARIANCE_POPULATION_COUPON_ID_ASC',
  CouponUsersVariancePopulationCouponIdDesc = 'COUPON_USERS_VARIANCE_POPULATION_COUPON_ID_DESC',
  CouponUsersVariancePopulationRowIdAsc = 'COUPON_USERS_VARIANCE_POPULATION_ROW_ID_ASC',
  CouponUsersVariancePopulationRowIdDesc = 'COUPON_USERS_VARIANCE_POPULATION_ROW_ID_DESC',
  CouponUsersVariancePopulationUserIdAsc = 'COUPON_USERS_VARIANCE_POPULATION_USER_ID_ASC',
  CouponUsersVariancePopulationUserIdDesc = 'COUPON_USERS_VARIANCE_POPULATION_USER_ID_DESC',
  CouponUsersVarianceSampleCouponIdAsc = 'COUPON_USERS_VARIANCE_SAMPLE_COUPON_ID_ASC',
  CouponUsersVarianceSampleCouponIdDesc = 'COUPON_USERS_VARIANCE_SAMPLE_COUPON_ID_DESC',
  CouponUsersVarianceSampleRowIdAsc = 'COUPON_USERS_VARIANCE_SAMPLE_ROW_ID_ASC',
  CouponUsersVarianceSampleRowIdDesc = 'COUPON_USERS_VARIANCE_SAMPLE_ROW_ID_DESC',
  CouponUsersVarianceSampleUserIdAsc = 'COUPON_USERS_VARIANCE_SAMPLE_USER_ID_ASC',
  CouponUsersVarianceSampleUserIdDesc = 'COUPON_USERS_VARIANCE_SAMPLE_USER_ID_DESC',
  DiscordIdAsc = 'DISCORD_ID_ASC',
  DiscordIdDesc = 'DISCORD_ID_DESC',
  EmailsAverageRowIdAsc = 'EMAILS_AVERAGE_ROW_ID_ASC',
  EmailsAverageRowIdDesc = 'EMAILS_AVERAGE_ROW_ID_DESC',
  EmailsAverageUserIdAsc = 'EMAILS_AVERAGE_USER_ID_ASC',
  EmailsAverageUserIdDesc = 'EMAILS_AVERAGE_USER_ID_DESC',
  EmailsCountAsc = 'EMAILS_COUNT_ASC',
  EmailsCountDesc = 'EMAILS_COUNT_DESC',
  EmailsDistinctCountCreatedAtAsc = 'EMAILS_DISTINCT_COUNT_CREATED_AT_ASC',
  EmailsDistinctCountCreatedAtDesc = 'EMAILS_DISTINCT_COUNT_CREATED_AT_DESC',
  EmailsDistinctCountIdempotencyKeyAsc = 'EMAILS_DISTINCT_COUNT_IDEMPOTENCY_KEY_ASC',
  EmailsDistinctCountIdempotencyKeyDesc = 'EMAILS_DISTINCT_COUNT_IDEMPOTENCY_KEY_DESC',
  EmailsDistinctCountLastOpenedAsc = 'EMAILS_DISTINCT_COUNT_LAST_OPENED_ASC',
  EmailsDistinctCountLastOpenedDesc = 'EMAILS_DISTINCT_COUNT_LAST_OPENED_DESC',
  EmailsDistinctCountMailgunIdAsc = 'EMAILS_DISTINCT_COUNT_MAILGUN_ID_ASC',
  EmailsDistinctCountMailgunIdDesc = 'EMAILS_DISTINCT_COUNT_MAILGUN_ID_DESC',
  EmailsDistinctCountRowIdAsc = 'EMAILS_DISTINCT_COUNT_ROW_ID_ASC',
  EmailsDistinctCountRowIdDesc = 'EMAILS_DISTINCT_COUNT_ROW_ID_DESC',
  EmailsDistinctCountStatusAsc = 'EMAILS_DISTINCT_COUNT_STATUS_ASC',
  EmailsDistinctCountStatusDesc = 'EMAILS_DISTINCT_COUNT_STATUS_DESC',
  EmailsDistinctCountSubjectAsc = 'EMAILS_DISTINCT_COUNT_SUBJECT_ASC',
  EmailsDistinctCountSubjectDesc = 'EMAILS_DISTINCT_COUNT_SUBJECT_DESC',
  EmailsDistinctCountUserIdAsc = 'EMAILS_DISTINCT_COUNT_USER_ID_ASC',
  EmailsDistinctCountUserIdDesc = 'EMAILS_DISTINCT_COUNT_USER_ID_DESC',
  EmailsMaxRowIdAsc = 'EMAILS_MAX_ROW_ID_ASC',
  EmailsMaxRowIdDesc = 'EMAILS_MAX_ROW_ID_DESC',
  EmailsMaxUserIdAsc = 'EMAILS_MAX_USER_ID_ASC',
  EmailsMaxUserIdDesc = 'EMAILS_MAX_USER_ID_DESC',
  EmailsMinRowIdAsc = 'EMAILS_MIN_ROW_ID_ASC',
  EmailsMinRowIdDesc = 'EMAILS_MIN_ROW_ID_DESC',
  EmailsMinUserIdAsc = 'EMAILS_MIN_USER_ID_ASC',
  EmailsMinUserIdDesc = 'EMAILS_MIN_USER_ID_DESC',
  EmailsStddevPopulationRowIdAsc = 'EMAILS_STDDEV_POPULATION_ROW_ID_ASC',
  EmailsStddevPopulationRowIdDesc = 'EMAILS_STDDEV_POPULATION_ROW_ID_DESC',
  EmailsStddevPopulationUserIdAsc = 'EMAILS_STDDEV_POPULATION_USER_ID_ASC',
  EmailsStddevPopulationUserIdDesc = 'EMAILS_STDDEV_POPULATION_USER_ID_DESC',
  EmailsStddevSampleRowIdAsc = 'EMAILS_STDDEV_SAMPLE_ROW_ID_ASC',
  EmailsStddevSampleRowIdDesc = 'EMAILS_STDDEV_SAMPLE_ROW_ID_DESC',
  EmailsStddevSampleUserIdAsc = 'EMAILS_STDDEV_SAMPLE_USER_ID_ASC',
  EmailsStddevSampleUserIdDesc = 'EMAILS_STDDEV_SAMPLE_USER_ID_DESC',
  EmailsSumRowIdAsc = 'EMAILS_SUM_ROW_ID_ASC',
  EmailsSumRowIdDesc = 'EMAILS_SUM_ROW_ID_DESC',
  EmailsSumUserIdAsc = 'EMAILS_SUM_USER_ID_ASC',
  EmailsSumUserIdDesc = 'EMAILS_SUM_USER_ID_DESC',
  EmailsVariancePopulationRowIdAsc = 'EMAILS_VARIANCE_POPULATION_ROW_ID_ASC',
  EmailsVariancePopulationRowIdDesc = 'EMAILS_VARIANCE_POPULATION_ROW_ID_DESC',
  EmailsVariancePopulationUserIdAsc = 'EMAILS_VARIANCE_POPULATION_USER_ID_ASC',
  EmailsVariancePopulationUserIdDesc = 'EMAILS_VARIANCE_POPULATION_USER_ID_DESC',
  EmailsVarianceSampleRowIdAsc = 'EMAILS_VARIANCE_SAMPLE_ROW_ID_ASC',
  EmailsVarianceSampleRowIdDesc = 'EMAILS_VARIANCE_SAMPLE_ROW_ID_DESC',
  EmailsVarianceSampleUserIdAsc = 'EMAILS_VARIANCE_SAMPLE_USER_ID_ASC',
  EmailsVarianceSampleUserIdDesc = 'EMAILS_VARIANCE_SAMPLE_USER_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  GroupAdminsAverageGroupIdAsc = 'GROUP_ADMINS_AVERAGE_GROUP_ID_ASC',
  GroupAdminsAverageGroupIdDesc = 'GROUP_ADMINS_AVERAGE_GROUP_ID_DESC',
  GroupAdminsAverageUserIdAsc = 'GROUP_ADMINS_AVERAGE_USER_ID_ASC',
  GroupAdminsAverageUserIdDesc = 'GROUP_ADMINS_AVERAGE_USER_ID_DESC',
  GroupAdminsCountAsc = 'GROUP_ADMINS_COUNT_ASC',
  GroupAdminsCountDesc = 'GROUP_ADMINS_COUNT_DESC',
  GroupAdminsDistinctCountGroupIdAsc = 'GROUP_ADMINS_DISTINCT_COUNT_GROUP_ID_ASC',
  GroupAdminsDistinctCountGroupIdDesc = 'GROUP_ADMINS_DISTINCT_COUNT_GROUP_ID_DESC',
  GroupAdminsDistinctCountUserIdAsc = 'GROUP_ADMINS_DISTINCT_COUNT_USER_ID_ASC',
  GroupAdminsDistinctCountUserIdDesc = 'GROUP_ADMINS_DISTINCT_COUNT_USER_ID_DESC',
  GroupAdminsMaxGroupIdAsc = 'GROUP_ADMINS_MAX_GROUP_ID_ASC',
  GroupAdminsMaxGroupIdDesc = 'GROUP_ADMINS_MAX_GROUP_ID_DESC',
  GroupAdminsMaxUserIdAsc = 'GROUP_ADMINS_MAX_USER_ID_ASC',
  GroupAdminsMaxUserIdDesc = 'GROUP_ADMINS_MAX_USER_ID_DESC',
  GroupAdminsMinGroupIdAsc = 'GROUP_ADMINS_MIN_GROUP_ID_ASC',
  GroupAdminsMinGroupIdDesc = 'GROUP_ADMINS_MIN_GROUP_ID_DESC',
  GroupAdminsMinUserIdAsc = 'GROUP_ADMINS_MIN_USER_ID_ASC',
  GroupAdminsMinUserIdDesc = 'GROUP_ADMINS_MIN_USER_ID_DESC',
  GroupAdminsStddevPopulationGroupIdAsc = 'GROUP_ADMINS_STDDEV_POPULATION_GROUP_ID_ASC',
  GroupAdminsStddevPopulationGroupIdDesc = 'GROUP_ADMINS_STDDEV_POPULATION_GROUP_ID_DESC',
  GroupAdminsStddevPopulationUserIdAsc = 'GROUP_ADMINS_STDDEV_POPULATION_USER_ID_ASC',
  GroupAdminsStddevPopulationUserIdDesc = 'GROUP_ADMINS_STDDEV_POPULATION_USER_ID_DESC',
  GroupAdminsStddevSampleGroupIdAsc = 'GROUP_ADMINS_STDDEV_SAMPLE_GROUP_ID_ASC',
  GroupAdminsStddevSampleGroupIdDesc = 'GROUP_ADMINS_STDDEV_SAMPLE_GROUP_ID_DESC',
  GroupAdminsStddevSampleUserIdAsc = 'GROUP_ADMINS_STDDEV_SAMPLE_USER_ID_ASC',
  GroupAdminsStddevSampleUserIdDesc = 'GROUP_ADMINS_STDDEV_SAMPLE_USER_ID_DESC',
  GroupAdminsSumGroupIdAsc = 'GROUP_ADMINS_SUM_GROUP_ID_ASC',
  GroupAdminsSumGroupIdDesc = 'GROUP_ADMINS_SUM_GROUP_ID_DESC',
  GroupAdminsSumUserIdAsc = 'GROUP_ADMINS_SUM_USER_ID_ASC',
  GroupAdminsSumUserIdDesc = 'GROUP_ADMINS_SUM_USER_ID_DESC',
  GroupAdminsVariancePopulationGroupIdAsc = 'GROUP_ADMINS_VARIANCE_POPULATION_GROUP_ID_ASC',
  GroupAdminsVariancePopulationGroupIdDesc = 'GROUP_ADMINS_VARIANCE_POPULATION_GROUP_ID_DESC',
  GroupAdminsVariancePopulationUserIdAsc = 'GROUP_ADMINS_VARIANCE_POPULATION_USER_ID_ASC',
  GroupAdminsVariancePopulationUserIdDesc = 'GROUP_ADMINS_VARIANCE_POPULATION_USER_ID_DESC',
  GroupAdminsVarianceSampleGroupIdAsc = 'GROUP_ADMINS_VARIANCE_SAMPLE_GROUP_ID_ASC',
  GroupAdminsVarianceSampleGroupIdDesc = 'GROUP_ADMINS_VARIANCE_SAMPLE_GROUP_ID_DESC',
  GroupAdminsVarianceSampleUserIdAsc = 'GROUP_ADMINS_VARIANCE_SAMPLE_USER_ID_ASC',
  GroupAdminsVarianceSampleUserIdDesc = 'GROUP_ADMINS_VARIANCE_SAMPLE_USER_ID_DESC',
  ImpactGroupAssignmentsAverageImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsAverageImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsAverageRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_ROW_ID_ASC',
  ImpactGroupAssignmentsAverageRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_AVERAGE_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByAverageImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_AVERAGE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByAverageImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_AVERAGE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByAverageRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_AVERAGE_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByAverageRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_AVERAGE_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByCountAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_COUNT_ASC',
  ImpactGroupAssignmentsByAssignedByCountDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_COUNT_DESC',
  ImpactGroupAssignmentsByAssignedByDistinctCountImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_DISTINCT_COUNT_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByDistinctCountImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_DISTINCT_COUNT_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByDistinctCountRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_DISTINCT_COUNT_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByDistinctCountRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_DISTINCT_COUNT_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByMaxImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MAX_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByMaxImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MAX_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByMaxRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MAX_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByMaxRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MAX_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByMinImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MIN_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByMinImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MIN_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByMinRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MIN_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByMinRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_MIN_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByStddevPopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByStddevPopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByStddevPopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByStddevPopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByStddevSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByStddevSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByStddevSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByStddevSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_STDDEV_SAMPLE_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedBySumImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_SUM_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedBySumImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_SUM_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedBySumRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_SUM_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedBySumRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_SUM_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByVariancePopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByVariancePopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByVariancePopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByVariancePopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsByAssignedByVarianceSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsByAssignedByVarianceSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsByAssignedByVarianceSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsByAssignedByVarianceSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_BY_ASSIGNED_BY_VARIANCE_SAMPLE_ROW_ID_DESC',
  ImpactGroupAssignmentsCountAsc = 'IMPACT_GROUP_ASSIGNMENTS_COUNT_ASC',
  ImpactGroupAssignmentsCountDesc = 'IMPACT_GROUP_ASSIGNMENTS_COUNT_DESC',
  ImpactGroupAssignmentsDistinctCountImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsDistinctCountImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsDistinctCountRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_ASC',
  ImpactGroupAssignmentsDistinctCountRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_DISTINCT_COUNT_ROW_ID_DESC',
  ImpactGroupAssignmentsMaxImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsMaxImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsMaxRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_ROW_ID_ASC',
  ImpactGroupAssignmentsMaxRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MAX_ROW_ID_DESC',
  ImpactGroupAssignmentsMinImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsMinImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsMinRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_ROW_ID_ASC',
  ImpactGroupAssignmentsMinRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_MIN_ROW_ID_DESC',
  ImpactGroupAssignmentsStddevPopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsStddevPopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsStddevPopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsStddevPopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsStddevSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsStddevSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsStddevSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsStddevSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  ImpactGroupAssignmentsSumImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsSumImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsSumRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_ROW_ID_ASC',
  ImpactGroupAssignmentsSumRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_SUM_ROW_ID_DESC',
  ImpactGroupAssignmentsVariancePopulationImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsVariancePopulationImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsVariancePopulationRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  ImpactGroupAssignmentsVariancePopulationRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  ImpactGroupAssignmentsVarianceSampleImpactGroupIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_IMPACT_GROUP_ID_ASC',
  ImpactGroupAssignmentsVarianceSampleImpactGroupIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_IMPACT_GROUP_ID_DESC',
  ImpactGroupAssignmentsVarianceSampleRowIdAsc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ImpactGroupAssignmentsVarianceSampleRowIdDesc = 'IMPACT_GROUP_ASSIGNMENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByAverageRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_AVERAGE_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByAverageRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_AVERAGE_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByCountAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_COUNT_ASC',
  ImpactGroupTemplatesByCreatedByCountDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_COUNT_DESC',
  ImpactGroupTemplatesByCreatedByDistinctCountLabelAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_LABEL_ASC',
  ImpactGroupTemplatesByCreatedByDistinctCountLabelDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_LABEL_DESC',
  ImpactGroupTemplatesByCreatedByDistinctCountRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByDistinctCountRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByDistinctCountScopeAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_SCOPE_ASC',
  ImpactGroupTemplatesByCreatedByDistinctCountScopeDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_SCOPE_DESC',
  ImpactGroupTemplatesByCreatedByDistinctCountSlugAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_SLUG_ASC',
  ImpactGroupTemplatesByCreatedByDistinctCountSlugDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_DISTINCT_COUNT_SLUG_DESC',
  ImpactGroupTemplatesByCreatedByMaxRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_MAX_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByMaxRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_MAX_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByMinRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_MIN_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByMinRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_MIN_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByStddevPopulationRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_STDDEV_POPULATION_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByStddevPopulationRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_STDDEV_POPULATION_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByStddevSampleRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_STDDEV_SAMPLE_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByStddevSampleRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_STDDEV_SAMPLE_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedBySumRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_SUM_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedBySumRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_SUM_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByVariancePopulationRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_VARIANCE_POPULATION_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByVariancePopulationRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_VARIANCE_POPULATION_ROW_ID_DESC',
  ImpactGroupTemplatesByCreatedByVarianceSampleRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_VARIANCE_SAMPLE_ROW_ID_ASC',
  ImpactGroupTemplatesByCreatedByVarianceSampleRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_CREATED_BY_VARIANCE_SAMPLE_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByAverageRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_AVERAGE_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByAverageRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_AVERAGE_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByCountAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_COUNT_ASC',
  ImpactGroupTemplatesByUpdatedByCountDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_COUNT_DESC',
  ImpactGroupTemplatesByUpdatedByDistinctCountLabelAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_LABEL_ASC',
  ImpactGroupTemplatesByUpdatedByDistinctCountLabelDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_LABEL_DESC',
  ImpactGroupTemplatesByUpdatedByDistinctCountRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByDistinctCountRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByDistinctCountScopeAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_SCOPE_ASC',
  ImpactGroupTemplatesByUpdatedByDistinctCountScopeDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_SCOPE_DESC',
  ImpactGroupTemplatesByUpdatedByDistinctCountSlugAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_SLUG_ASC',
  ImpactGroupTemplatesByUpdatedByDistinctCountSlugDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_DISTINCT_COUNT_SLUG_DESC',
  ImpactGroupTemplatesByUpdatedByMaxRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_MAX_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByMaxRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_MAX_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByMinRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_MIN_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByMinRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_MIN_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByStddevPopulationRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_STDDEV_POPULATION_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByStddevPopulationRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_STDDEV_POPULATION_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByStddevSampleRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_STDDEV_SAMPLE_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByStddevSampleRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_STDDEV_SAMPLE_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedBySumRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_SUM_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedBySumRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_SUM_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByVariancePopulationRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_VARIANCE_POPULATION_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByVariancePopulationRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_VARIANCE_POPULATION_ROW_ID_DESC',
  ImpactGroupTemplatesByUpdatedByVarianceSampleRowIdAsc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_VARIANCE_SAMPLE_ROW_ID_ASC',
  ImpactGroupTemplatesByUpdatedByVarianceSampleRowIdDesc = 'IMPACT_GROUP_TEMPLATES_BY_UPDATED_BY_VARIANCE_SAMPLE_ROW_ID_DESC',
  IsLockedAsc = 'IS_LOCKED_ASC',
  IsLockedDesc = 'IS_LOCKED_DESC',
  KycStatusAsc = 'KYC_STATUS_ASC',
  KycStatusDesc = 'KYC_STATUS_DESC',
  LockTypeAsc = 'LOCK_TYPE_ASC',
  LockTypeDesc = 'LOCK_TYPE_DESC',
  Natural = 'NATURAL',
  NeedsVerificationAsc = 'NEEDS_VERIFICATION_ASC',
  NeedsVerificationDesc = 'NEEDS_VERIFICATION_DESC',
  NuveiSavedCardsAverageRowIdAsc = 'NUVEI_SAVED_CARDS_AVERAGE_ROW_ID_ASC',
  NuveiSavedCardsAverageRowIdDesc = 'NUVEI_SAVED_CARDS_AVERAGE_ROW_ID_DESC',
  NuveiSavedCardsAverageUserIdAsc = 'NUVEI_SAVED_CARDS_AVERAGE_USER_ID_ASC',
  NuveiSavedCardsAverageUserIdDesc = 'NUVEI_SAVED_CARDS_AVERAGE_USER_ID_DESC',
  NuveiSavedCardsCountAsc = 'NUVEI_SAVED_CARDS_COUNT_ASC',
  NuveiSavedCardsCountDesc = 'NUVEI_SAVED_CARDS_COUNT_DESC',
  NuveiSavedCardsDistinctCountRowIdAsc = 'NUVEI_SAVED_CARDS_DISTINCT_COUNT_ROW_ID_ASC',
  NuveiSavedCardsDistinctCountRowIdDesc = 'NUVEI_SAVED_CARDS_DISTINCT_COUNT_ROW_ID_DESC',
  NuveiSavedCardsDistinctCountUserIdAsc = 'NUVEI_SAVED_CARDS_DISTINCT_COUNT_USER_ID_ASC',
  NuveiSavedCardsDistinctCountUserIdDesc = 'NUVEI_SAVED_CARDS_DISTINCT_COUNT_USER_ID_DESC',
  NuveiSavedCardsMaxRowIdAsc = 'NUVEI_SAVED_CARDS_MAX_ROW_ID_ASC',
  NuveiSavedCardsMaxRowIdDesc = 'NUVEI_SAVED_CARDS_MAX_ROW_ID_DESC',
  NuveiSavedCardsMaxUserIdAsc = 'NUVEI_SAVED_CARDS_MAX_USER_ID_ASC',
  NuveiSavedCardsMaxUserIdDesc = 'NUVEI_SAVED_CARDS_MAX_USER_ID_DESC',
  NuveiSavedCardsMinRowIdAsc = 'NUVEI_SAVED_CARDS_MIN_ROW_ID_ASC',
  NuveiSavedCardsMinRowIdDesc = 'NUVEI_SAVED_CARDS_MIN_ROW_ID_DESC',
  NuveiSavedCardsMinUserIdAsc = 'NUVEI_SAVED_CARDS_MIN_USER_ID_ASC',
  NuveiSavedCardsMinUserIdDesc = 'NUVEI_SAVED_CARDS_MIN_USER_ID_DESC',
  NuveiSavedCardsStddevPopulationRowIdAsc = 'NUVEI_SAVED_CARDS_STDDEV_POPULATION_ROW_ID_ASC',
  NuveiSavedCardsStddevPopulationRowIdDesc = 'NUVEI_SAVED_CARDS_STDDEV_POPULATION_ROW_ID_DESC',
  NuveiSavedCardsStddevPopulationUserIdAsc = 'NUVEI_SAVED_CARDS_STDDEV_POPULATION_USER_ID_ASC',
  NuveiSavedCardsStddevPopulationUserIdDesc = 'NUVEI_SAVED_CARDS_STDDEV_POPULATION_USER_ID_DESC',
  NuveiSavedCardsStddevSampleRowIdAsc = 'NUVEI_SAVED_CARDS_STDDEV_SAMPLE_ROW_ID_ASC',
  NuveiSavedCardsStddevSampleRowIdDesc = 'NUVEI_SAVED_CARDS_STDDEV_SAMPLE_ROW_ID_DESC',
  NuveiSavedCardsStddevSampleUserIdAsc = 'NUVEI_SAVED_CARDS_STDDEV_SAMPLE_USER_ID_ASC',
  NuveiSavedCardsStddevSampleUserIdDesc = 'NUVEI_SAVED_CARDS_STDDEV_SAMPLE_USER_ID_DESC',
  NuveiSavedCardsSumRowIdAsc = 'NUVEI_SAVED_CARDS_SUM_ROW_ID_ASC',
  NuveiSavedCardsSumRowIdDesc = 'NUVEI_SAVED_CARDS_SUM_ROW_ID_DESC',
  NuveiSavedCardsSumUserIdAsc = 'NUVEI_SAVED_CARDS_SUM_USER_ID_ASC',
  NuveiSavedCardsSumUserIdDesc = 'NUVEI_SAVED_CARDS_SUM_USER_ID_DESC',
  NuveiSavedCardsVariancePopulationRowIdAsc = 'NUVEI_SAVED_CARDS_VARIANCE_POPULATION_ROW_ID_ASC',
  NuveiSavedCardsVariancePopulationRowIdDesc = 'NUVEI_SAVED_CARDS_VARIANCE_POPULATION_ROW_ID_DESC',
  NuveiSavedCardsVariancePopulationUserIdAsc = 'NUVEI_SAVED_CARDS_VARIANCE_POPULATION_USER_ID_ASC',
  NuveiSavedCardsVariancePopulationUserIdDesc = 'NUVEI_SAVED_CARDS_VARIANCE_POPULATION_USER_ID_DESC',
  NuveiSavedCardsVarianceSampleRowIdAsc = 'NUVEI_SAVED_CARDS_VARIANCE_SAMPLE_ROW_ID_ASC',
  NuveiSavedCardsVarianceSampleRowIdDesc = 'NUVEI_SAVED_CARDS_VARIANCE_SAMPLE_ROW_ID_DESC',
  NuveiSavedCardsVarianceSampleUserIdAsc = 'NUVEI_SAVED_CARDS_VARIANCE_SAMPLE_USER_ID_ASC',
  NuveiSavedCardsVarianceSampleUserIdDesc = 'NUVEI_SAVED_CARDS_VARIANCE_SAMPLE_USER_ID_DESC',
  PasswordHistoriesAverageRowIdAsc = 'PASSWORD_HISTORIES_AVERAGE_ROW_ID_ASC',
  PasswordHistoriesAverageRowIdDesc = 'PASSWORD_HISTORIES_AVERAGE_ROW_ID_DESC',
  PasswordHistoriesAverageUserIdAsc = 'PASSWORD_HISTORIES_AVERAGE_USER_ID_ASC',
  PasswordHistoriesAverageUserIdDesc = 'PASSWORD_HISTORIES_AVERAGE_USER_ID_DESC',
  PasswordHistoriesCountAsc = 'PASSWORD_HISTORIES_COUNT_ASC',
  PasswordHistoriesCountDesc = 'PASSWORD_HISTORIES_COUNT_DESC',
  PasswordHistoriesDistinctCountCreatedAtAsc = 'PASSWORD_HISTORIES_DISTINCT_COUNT_CREATED_AT_ASC',
  PasswordHistoriesDistinctCountCreatedAtDesc = 'PASSWORD_HISTORIES_DISTINCT_COUNT_CREATED_AT_DESC',
  PasswordHistoriesDistinctCountRowIdAsc = 'PASSWORD_HISTORIES_DISTINCT_COUNT_ROW_ID_ASC',
  PasswordHistoriesDistinctCountRowIdDesc = 'PASSWORD_HISTORIES_DISTINCT_COUNT_ROW_ID_DESC',
  PasswordHistoriesDistinctCountUserIdAsc = 'PASSWORD_HISTORIES_DISTINCT_COUNT_USER_ID_ASC',
  PasswordHistoriesDistinctCountUserIdDesc = 'PASSWORD_HISTORIES_DISTINCT_COUNT_USER_ID_DESC',
  PasswordHistoriesMaxRowIdAsc = 'PASSWORD_HISTORIES_MAX_ROW_ID_ASC',
  PasswordHistoriesMaxRowIdDesc = 'PASSWORD_HISTORIES_MAX_ROW_ID_DESC',
  PasswordHistoriesMaxUserIdAsc = 'PASSWORD_HISTORIES_MAX_USER_ID_ASC',
  PasswordHistoriesMaxUserIdDesc = 'PASSWORD_HISTORIES_MAX_USER_ID_DESC',
  PasswordHistoriesMinRowIdAsc = 'PASSWORD_HISTORIES_MIN_ROW_ID_ASC',
  PasswordHistoriesMinRowIdDesc = 'PASSWORD_HISTORIES_MIN_ROW_ID_DESC',
  PasswordHistoriesMinUserIdAsc = 'PASSWORD_HISTORIES_MIN_USER_ID_ASC',
  PasswordHistoriesMinUserIdDesc = 'PASSWORD_HISTORIES_MIN_USER_ID_DESC',
  PasswordHistoriesStddevPopulationRowIdAsc = 'PASSWORD_HISTORIES_STDDEV_POPULATION_ROW_ID_ASC',
  PasswordHistoriesStddevPopulationRowIdDesc = 'PASSWORD_HISTORIES_STDDEV_POPULATION_ROW_ID_DESC',
  PasswordHistoriesStddevPopulationUserIdAsc = 'PASSWORD_HISTORIES_STDDEV_POPULATION_USER_ID_ASC',
  PasswordHistoriesStddevPopulationUserIdDesc = 'PASSWORD_HISTORIES_STDDEV_POPULATION_USER_ID_DESC',
  PasswordHistoriesStddevSampleRowIdAsc = 'PASSWORD_HISTORIES_STDDEV_SAMPLE_ROW_ID_ASC',
  PasswordHistoriesStddevSampleRowIdDesc = 'PASSWORD_HISTORIES_STDDEV_SAMPLE_ROW_ID_DESC',
  PasswordHistoriesStddevSampleUserIdAsc = 'PASSWORD_HISTORIES_STDDEV_SAMPLE_USER_ID_ASC',
  PasswordHistoriesStddevSampleUserIdDesc = 'PASSWORD_HISTORIES_STDDEV_SAMPLE_USER_ID_DESC',
  PasswordHistoriesSumRowIdAsc = 'PASSWORD_HISTORIES_SUM_ROW_ID_ASC',
  PasswordHistoriesSumRowIdDesc = 'PASSWORD_HISTORIES_SUM_ROW_ID_DESC',
  PasswordHistoriesSumUserIdAsc = 'PASSWORD_HISTORIES_SUM_USER_ID_ASC',
  PasswordHistoriesSumUserIdDesc = 'PASSWORD_HISTORIES_SUM_USER_ID_DESC',
  PasswordHistoriesVariancePopulationRowIdAsc = 'PASSWORD_HISTORIES_VARIANCE_POPULATION_ROW_ID_ASC',
  PasswordHistoriesVariancePopulationRowIdDesc = 'PASSWORD_HISTORIES_VARIANCE_POPULATION_ROW_ID_DESC',
  PasswordHistoriesVariancePopulationUserIdAsc = 'PASSWORD_HISTORIES_VARIANCE_POPULATION_USER_ID_ASC',
  PasswordHistoriesVariancePopulationUserIdDesc = 'PASSWORD_HISTORIES_VARIANCE_POPULATION_USER_ID_DESC',
  PasswordHistoriesVarianceSampleRowIdAsc = 'PASSWORD_HISTORIES_VARIANCE_SAMPLE_ROW_ID_ASC',
  PasswordHistoriesVarianceSampleRowIdDesc = 'PASSWORD_HISTORIES_VARIANCE_SAMPLE_ROW_ID_DESC',
  PasswordHistoriesVarianceSampleUserIdAsc = 'PASSWORD_HISTORIES_VARIANCE_SAMPLE_USER_ID_ASC',
  PasswordHistoriesVarianceSampleUserIdDesc = 'PASSWORD_HISTORIES_VARIANCE_SAMPLE_USER_ID_DESC',
  PayoutRequestsAverageRowIdAsc = 'PAYOUT_REQUESTS_AVERAGE_ROW_ID_ASC',
  PayoutRequestsAverageRowIdDesc = 'PAYOUT_REQUESTS_AVERAGE_ROW_ID_DESC',
  PayoutRequestsAverageUserIdAsc = 'PAYOUT_REQUESTS_AVERAGE_USER_ID_ASC',
  PayoutRequestsAverageUserIdDesc = 'PAYOUT_REQUESTS_AVERAGE_USER_ID_DESC',
  PayoutRequestsCountAsc = 'PAYOUT_REQUESTS_COUNT_ASC',
  PayoutRequestsCountDesc = 'PAYOUT_REQUESTS_COUNT_DESC',
  PayoutRequestsDistinctCountAdminInitiatedAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_ADMIN_INITIATED_ASC',
  PayoutRequestsDistinctCountAdminInitiatedDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_ADMIN_INITIATED_DESC',
  PayoutRequestsDistinctCountBankInfoEnteredAtAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_BANK_INFO_ENTERED_AT_ASC',
  PayoutRequestsDistinctCountBankInfoEnteredAtDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_BANK_INFO_ENTERED_AT_DESC',
  PayoutRequestsDistinctCountCreatedAtAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_CREATED_AT_ASC',
  PayoutRequestsDistinctCountCreatedAtDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_CREATED_AT_DESC',
  PayoutRequestsDistinctCountExceptionAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_EXCEPTION_ASC',
  PayoutRequestsDistinctCountExceptionDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_EXCEPTION_DESC',
  PayoutRequestsDistinctCountFinalizedAtAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_FINALIZED_AT_ASC',
  PayoutRequestsDistinctCountFinalizedAtDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_FINALIZED_AT_DESC',
  PayoutRequestsDistinctCountFinanceApprovedAtAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_FINANCE_APPROVED_AT_ASC',
  PayoutRequestsDistinctCountFinanceApprovedAtDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_FINANCE_APPROVED_AT_DESC',
  PayoutRequestsDistinctCountMethodAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_METHOD_ASC',
  PayoutRequestsDistinctCountMethodDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_METHOD_DESC',
  PayoutRequestsDistinctCountPaidAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_PAID_ASC',
  PayoutRequestsDistinctCountPaidDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_PAID_DESC',
  PayoutRequestsDistinctCountPayoutPathAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_PAYOUT_PATH_ASC',
  PayoutRequestsDistinctCountPayoutPathDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_PAYOUT_PATH_DESC',
  PayoutRequestsDistinctCountReopenedAtAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_REOPENED_AT_ASC',
  PayoutRequestsDistinctCountReopenedAtDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_REOPENED_AT_DESC',
  PayoutRequestsDistinctCountRowIdAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutRequestsDistinctCountRowIdDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutRequestsDistinctCountStatusAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_STATUS_ASC',
  PayoutRequestsDistinctCountStatusDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_STATUS_DESC',
  PayoutRequestsDistinctCountTypeAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_TYPE_ASC',
  PayoutRequestsDistinctCountTypeDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_TYPE_DESC',
  PayoutRequestsDistinctCountUserIdAsc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_USER_ID_ASC',
  PayoutRequestsDistinctCountUserIdDesc = 'PAYOUT_REQUESTS_DISTINCT_COUNT_USER_ID_DESC',
  PayoutRequestsMaxRowIdAsc = 'PAYOUT_REQUESTS_MAX_ROW_ID_ASC',
  PayoutRequestsMaxRowIdDesc = 'PAYOUT_REQUESTS_MAX_ROW_ID_DESC',
  PayoutRequestsMaxUserIdAsc = 'PAYOUT_REQUESTS_MAX_USER_ID_ASC',
  PayoutRequestsMaxUserIdDesc = 'PAYOUT_REQUESTS_MAX_USER_ID_DESC',
  PayoutRequestsMinRowIdAsc = 'PAYOUT_REQUESTS_MIN_ROW_ID_ASC',
  PayoutRequestsMinRowIdDesc = 'PAYOUT_REQUESTS_MIN_ROW_ID_DESC',
  PayoutRequestsMinUserIdAsc = 'PAYOUT_REQUESTS_MIN_USER_ID_ASC',
  PayoutRequestsMinUserIdDesc = 'PAYOUT_REQUESTS_MIN_USER_ID_DESC',
  PayoutRequestsStddevPopulationRowIdAsc = 'PAYOUT_REQUESTS_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutRequestsStddevPopulationRowIdDesc = 'PAYOUT_REQUESTS_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutRequestsStddevPopulationUserIdAsc = 'PAYOUT_REQUESTS_STDDEV_POPULATION_USER_ID_ASC',
  PayoutRequestsStddevPopulationUserIdDesc = 'PAYOUT_REQUESTS_STDDEV_POPULATION_USER_ID_DESC',
  PayoutRequestsStddevSampleRowIdAsc = 'PAYOUT_REQUESTS_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutRequestsStddevSampleRowIdDesc = 'PAYOUT_REQUESTS_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutRequestsStddevSampleUserIdAsc = 'PAYOUT_REQUESTS_STDDEV_SAMPLE_USER_ID_ASC',
  PayoutRequestsStddevSampleUserIdDesc = 'PAYOUT_REQUESTS_STDDEV_SAMPLE_USER_ID_DESC',
  PayoutRequestsSumRowIdAsc = 'PAYOUT_REQUESTS_SUM_ROW_ID_ASC',
  PayoutRequestsSumRowIdDesc = 'PAYOUT_REQUESTS_SUM_ROW_ID_DESC',
  PayoutRequestsSumUserIdAsc = 'PAYOUT_REQUESTS_SUM_USER_ID_ASC',
  PayoutRequestsSumUserIdDesc = 'PAYOUT_REQUESTS_SUM_USER_ID_DESC',
  PayoutRequestsVariancePopulationRowIdAsc = 'PAYOUT_REQUESTS_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutRequestsVariancePopulationRowIdDesc = 'PAYOUT_REQUESTS_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutRequestsVariancePopulationUserIdAsc = 'PAYOUT_REQUESTS_VARIANCE_POPULATION_USER_ID_ASC',
  PayoutRequestsVariancePopulationUserIdDesc = 'PAYOUT_REQUESTS_VARIANCE_POPULATION_USER_ID_DESC',
  PayoutRequestsVarianceSampleRowIdAsc = 'PAYOUT_REQUESTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutRequestsVarianceSampleRowIdDesc = 'PAYOUT_REQUESTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  PayoutRequestsVarianceSampleUserIdAsc = 'PAYOUT_REQUESTS_VARIANCE_SAMPLE_USER_ID_ASC',
  PayoutRequestsVarianceSampleUserIdDesc = 'PAYOUT_REQUESTS_VARIANCE_SAMPLE_USER_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdAverageAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_AVERAGE_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdAverageAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_AVERAGE_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdAverageCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_AVERAGE_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdAverageCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_AVERAGE_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdAverageRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_AVERAGE_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdAverageRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_AVERAGE_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdCountAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_COUNT_ASC',
  PayoutRequestBatchesByAssignedToAdminIdCountDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_COUNT_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountBankAccountTypeAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_BANK_ACCOUNT_TYPE_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountBankAccountTypeDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_BANK_ACCOUNT_TYPE_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountCompletedAtAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_COMPLETED_AT_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountCompletedAtDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_COMPLETED_AT_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountCreatedAtAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_CREATED_AT_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountCreatedAtDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_CREATED_AT_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountNameAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_NAME_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountNameDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_NAME_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountPayoutMethodAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_PAYOUT_METHOD_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountPayoutMethodDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_PAYOUT_METHOD_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountPublishedAtAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_PUBLISHED_AT_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountPublishedAtDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_PUBLISHED_AT_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountTypeAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_TYPE_ASC',
  PayoutRequestBatchesByAssignedToAdminIdDistinctCountTypeDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_DISTINCT_COUNT_TYPE_DESC',
  PayoutRequestBatchesByAssignedToAdminIdMaxAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MAX_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdMaxAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MAX_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdMaxCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MAX_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdMaxCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MAX_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdMaxRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MAX_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdMaxRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MAX_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdMinAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MIN_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdMinAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MIN_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdMinCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MIN_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdMinCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MIN_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdMinRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MIN_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdMinRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_MIN_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdStddevPopulationAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_POPULATION_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdStddevPopulationAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_POPULATION_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdStddevPopulationCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdStddevPopulationCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdStddevPopulationRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdStddevPopulationRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdStddevSampleAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_SAMPLE_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdStddevSampleAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_SAMPLE_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdStddevSampleCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdStddevSampleCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdStddevSampleRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdStddevSampleRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdSumAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_SUM_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdSumAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_SUM_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdSumCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_SUM_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdSumCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_SUM_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdSumRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_SUM_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdSumRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_SUM_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdVariancePopulationAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_POPULATION_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdVariancePopulationAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_POPULATION_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdVariancePopulationCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdVariancePopulationCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdVariancePopulationRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdVariancePopulationRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdVarianceSampleAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_SAMPLE_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdVarianceSampleAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_SAMPLE_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdVarianceSampleCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdVarianceSampleCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByAssignedToAdminIdVarianceSampleRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutRequestBatchesByAssignedToAdminIdVarianceSampleRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_ASSIGNED_TO_ADMIN_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdAverageAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_AVERAGE_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdAverageAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_AVERAGE_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdAverageCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_AVERAGE_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdAverageCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_AVERAGE_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdAverageRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_AVERAGE_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdAverageRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_AVERAGE_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdCountAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_COUNT_ASC',
  PayoutRequestBatchesByCreatedByIdCountDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_COUNT_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountBankAccountTypeAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_BANK_ACCOUNT_TYPE_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountBankAccountTypeDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_BANK_ACCOUNT_TYPE_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountCompletedAtAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_COMPLETED_AT_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountCompletedAtDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_COMPLETED_AT_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountCreatedAtAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_AT_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountCreatedAtDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_AT_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountNameAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_NAME_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountNameDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_NAME_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountPayoutMethodAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_PAYOUT_METHOD_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountPayoutMethodDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_PAYOUT_METHOD_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountPublishedAtAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_PUBLISHED_AT_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountPublishedAtDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_PUBLISHED_AT_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdDistinctCountTypeAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_TYPE_ASC',
  PayoutRequestBatchesByCreatedByIdDistinctCountTypeDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_DISTINCT_COUNT_TYPE_DESC',
  PayoutRequestBatchesByCreatedByIdMaxAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MAX_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdMaxAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MAX_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdMaxCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MAX_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdMaxCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MAX_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdMaxRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MAX_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdMaxRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MAX_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdMinAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MIN_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdMinAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MIN_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdMinCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MIN_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdMinCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MIN_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdMinRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MIN_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdMinRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_MIN_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdStddevPopulationAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_POPULATION_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdStddevPopulationAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_POPULATION_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdStddevPopulationCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdStddevPopulationCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdStddevPopulationRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_POPULATION_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdStddevPopulationRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_POPULATION_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdStddevSampleAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_SAMPLE_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdStddevSampleAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_SAMPLE_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdStddevSampleCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdStddevSampleCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdStddevSampleRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdStddevSampleRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdSumAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_SUM_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdSumAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_SUM_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdSumCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_SUM_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdSumCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_SUM_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdSumRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_SUM_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdSumRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_SUM_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdVariancePopulationAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_POPULATION_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdVariancePopulationAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_POPULATION_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdVariancePopulationCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdVariancePopulationCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdVariancePopulationRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdVariancePopulationRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  PayoutRequestBatchesByCreatedByIdVarianceSampleAssignedToAdminIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_SAMPLE_ASSIGNED_TO_ADMIN_ID_ASC',
  PayoutRequestBatchesByCreatedByIdVarianceSampleAssignedToAdminIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_SAMPLE_ASSIGNED_TO_ADMIN_ID_DESC',
  PayoutRequestBatchesByCreatedByIdVarianceSampleCreatedByIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC',
  PayoutRequestBatchesByCreatedByIdVarianceSampleCreatedByIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC',
  PayoutRequestBatchesByCreatedByIdVarianceSampleRowIdAsc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  PayoutRequestBatchesByCreatedByIdVarianceSampleRowIdDesc = 'PAYOUT_REQUEST_BATCHES_BY_CREATED_BY_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  PayoutRequestSubscribersAveragePayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersAveragePayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersAverageUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_USER_ID_ASC',
  PayoutRequestSubscribersAverageUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_AVERAGE_USER_ID_DESC',
  PayoutRequestSubscribersCountAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_COUNT_ASC',
  PayoutRequestSubscribersCountDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_COUNT_DESC',
  PayoutRequestSubscribersDistinctCountPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersDistinctCountPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersDistinctCountUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_USER_ID_ASC',
  PayoutRequestSubscribersDistinctCountUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_DISTINCT_COUNT_USER_ID_DESC',
  PayoutRequestSubscribersMaxPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersMaxPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersMaxUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_USER_ID_ASC',
  PayoutRequestSubscribersMaxUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MAX_USER_ID_DESC',
  PayoutRequestSubscribersMinPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersMinPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersMinUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_USER_ID_ASC',
  PayoutRequestSubscribersMinUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_MIN_USER_ID_DESC',
  PayoutRequestSubscribersStddevPopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersStddevPopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersStddevPopulationUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_USER_ID_ASC',
  PayoutRequestSubscribersStddevPopulationUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_POPULATION_USER_ID_DESC',
  PayoutRequestSubscribersStddevSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersStddevSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersStddevSampleUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_USER_ID_ASC',
  PayoutRequestSubscribersStddevSampleUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_STDDEV_SAMPLE_USER_ID_DESC',
  PayoutRequestSubscribersSumPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersSumPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersSumUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_USER_ID_ASC',
  PayoutRequestSubscribersSumUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_SUM_USER_ID_DESC',
  PayoutRequestSubscribersVariancePopulationPayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersVariancePopulationPayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersVariancePopulationUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_USER_ID_ASC',
  PayoutRequestSubscribersVariancePopulationUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_POPULATION_USER_ID_DESC',
  PayoutRequestSubscribersVarianceSamplePayoutRequestIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_ASC',
  PayoutRequestSubscribersVarianceSamplePayoutRequestIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_PAYOUT_REQUEST_ID_DESC',
  PayoutRequestSubscribersVarianceSampleUserIdAsc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_USER_ID_ASC',
  PayoutRequestSubscribersVarianceSampleUserIdDesc = 'PAYOUT_REQUEST_SUBSCRIBERS_VARIANCE_SAMPLE_USER_ID_DESC',
  PersonaWebhookEventsAverageRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_AVERAGE_ROW_ID_ASC',
  PersonaWebhookEventsAverageRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_AVERAGE_ROW_ID_DESC',
  PersonaWebhookEventsAverageUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_AVERAGE_USER_ID_ASC',
  PersonaWebhookEventsAverageUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_AVERAGE_USER_ID_DESC',
  PersonaWebhookEventsCountAsc = 'PERSONA_WEBHOOK_EVENTS_COUNT_ASC',
  PersonaWebhookEventsCountDesc = 'PERSONA_WEBHOOK_EVENTS_COUNT_DESC',
  PersonaWebhookEventsDistinctCountCreatedAtAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_CREATED_AT_ASC',
  PersonaWebhookEventsDistinctCountCreatedAtDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_CREATED_AT_DESC',
  PersonaWebhookEventsDistinctCountEventNameAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_EVENT_NAME_ASC',
  PersonaWebhookEventsDistinctCountEventNameDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_EVENT_NAME_DESC',
  PersonaWebhookEventsDistinctCountPersonaCreatedAtAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_PERSONA_CREATED_AT_ASC',
  PersonaWebhookEventsDistinctCountPersonaCreatedAtDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_PERSONA_CREATED_AT_DESC',
  PersonaWebhookEventsDistinctCountPersonaEventIdAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_PERSONA_EVENT_ID_ASC',
  PersonaWebhookEventsDistinctCountPersonaEventIdDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_PERSONA_EVENT_ID_DESC',
  PersonaWebhookEventsDistinctCountResourceIdAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_RESOURCE_ID_ASC',
  PersonaWebhookEventsDistinctCountResourceIdDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_RESOURCE_ID_DESC',
  PersonaWebhookEventsDistinctCountRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_ROW_ID_ASC',
  PersonaWebhookEventsDistinctCountRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_ROW_ID_DESC',
  PersonaWebhookEventsDistinctCountStatusAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_STATUS_ASC',
  PersonaWebhookEventsDistinctCountStatusDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_STATUS_DESC',
  PersonaWebhookEventsDistinctCountUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_USER_ID_ASC',
  PersonaWebhookEventsDistinctCountUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_DISTINCT_COUNT_USER_ID_DESC',
  PersonaWebhookEventsMaxRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_MAX_ROW_ID_ASC',
  PersonaWebhookEventsMaxRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_MAX_ROW_ID_DESC',
  PersonaWebhookEventsMaxUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_MAX_USER_ID_ASC',
  PersonaWebhookEventsMaxUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_MAX_USER_ID_DESC',
  PersonaWebhookEventsMinRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_MIN_ROW_ID_ASC',
  PersonaWebhookEventsMinRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_MIN_ROW_ID_DESC',
  PersonaWebhookEventsMinUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_MIN_USER_ID_ASC',
  PersonaWebhookEventsMinUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_MIN_USER_ID_DESC',
  PersonaWebhookEventsStddevPopulationRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_POPULATION_ROW_ID_ASC',
  PersonaWebhookEventsStddevPopulationRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_POPULATION_ROW_ID_DESC',
  PersonaWebhookEventsStddevPopulationUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_POPULATION_USER_ID_ASC',
  PersonaWebhookEventsStddevPopulationUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_POPULATION_USER_ID_DESC',
  PersonaWebhookEventsStddevSampleRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  PersonaWebhookEventsStddevSampleRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  PersonaWebhookEventsStddevSampleUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_SAMPLE_USER_ID_ASC',
  PersonaWebhookEventsStddevSampleUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_STDDEV_SAMPLE_USER_ID_DESC',
  PersonaWebhookEventsSumRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_SUM_ROW_ID_ASC',
  PersonaWebhookEventsSumRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_SUM_ROW_ID_DESC',
  PersonaWebhookEventsSumUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_SUM_USER_ID_ASC',
  PersonaWebhookEventsSumUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_SUM_USER_ID_DESC',
  PersonaWebhookEventsVariancePopulationRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  PersonaWebhookEventsVariancePopulationRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  PersonaWebhookEventsVariancePopulationUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_POPULATION_USER_ID_ASC',
  PersonaWebhookEventsVariancePopulationUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_POPULATION_USER_ID_DESC',
  PersonaWebhookEventsVarianceSampleRowIdAsc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  PersonaWebhookEventsVarianceSampleRowIdDesc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  PersonaWebhookEventsVarianceSampleUserIdAsc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_SAMPLE_USER_ID_ASC',
  PersonaWebhookEventsVarianceSampleUserIdDesc = 'PERSONA_WEBHOOK_EVENTS_VARIANCE_SAMPLE_USER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectXuserIdAsc = 'PROJECT_XUSER_ID_ASC',
  ProjectXuserIdDesc = 'PROJECT_XUSER_ID_DESC',
  PurchaseOrdersAverageRowIdAsc = 'PURCHASE_ORDERS_AVERAGE_ROW_ID_ASC',
  PurchaseOrdersAverageRowIdDesc = 'PURCHASE_ORDERS_AVERAGE_ROW_ID_DESC',
  PurchaseOrdersAverageTotalAsc = 'PURCHASE_ORDERS_AVERAGE_TOTAL_ASC',
  PurchaseOrdersAverageTotalDesc = 'PURCHASE_ORDERS_AVERAGE_TOTAL_DESC',
  PurchaseOrdersAverageUserIdAsc = 'PURCHASE_ORDERS_AVERAGE_USER_ID_ASC',
  PurchaseOrdersAverageUserIdDesc = 'PURCHASE_ORDERS_AVERAGE_USER_ID_DESC',
  PurchaseOrdersCountAsc = 'PURCHASE_ORDERS_COUNT_ASC',
  PurchaseOrdersCountDesc = 'PURCHASE_ORDERS_COUNT_DESC',
  PurchaseOrdersDistinctCountCreatedAtAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_CREATED_AT_ASC',
  PurchaseOrdersDistinctCountCreatedAtDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_CREATED_AT_DESC',
  PurchaseOrdersDistinctCountGatewayTransactionIdAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_GATEWAY_TRANSACTION_ID_ASC',
  PurchaseOrdersDistinctCountGatewayTransactionIdDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_GATEWAY_TRANSACTION_ID_DESC',
  PurchaseOrdersDistinctCountProcessorTransactionIdAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_PROCESSOR_TRANSACTION_ID_ASC',
  PurchaseOrdersDistinctCountProcessorTransactionIdDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_PROCESSOR_TRANSACTION_ID_DESC',
  PurchaseOrdersDistinctCountRowIdAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_ROW_ID_ASC',
  PurchaseOrdersDistinctCountRowIdDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_ROW_ID_DESC',
  PurchaseOrdersDistinctCountTotalAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_TOTAL_ASC',
  PurchaseOrdersDistinctCountTotalDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_TOTAL_DESC',
  PurchaseOrdersDistinctCountTypeAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_TYPE_ASC',
  PurchaseOrdersDistinctCountTypeDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_TYPE_DESC',
  PurchaseOrdersDistinctCountUpdatedAtAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_UPDATED_AT_ASC',
  PurchaseOrdersDistinctCountUpdatedAtDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_UPDATED_AT_DESC',
  PurchaseOrdersDistinctCountUserIdAsc = 'PURCHASE_ORDERS_DISTINCT_COUNT_USER_ID_ASC',
  PurchaseOrdersDistinctCountUserIdDesc = 'PURCHASE_ORDERS_DISTINCT_COUNT_USER_ID_DESC',
  PurchaseOrdersMaxRowIdAsc = 'PURCHASE_ORDERS_MAX_ROW_ID_ASC',
  PurchaseOrdersMaxRowIdDesc = 'PURCHASE_ORDERS_MAX_ROW_ID_DESC',
  PurchaseOrdersMaxTotalAsc = 'PURCHASE_ORDERS_MAX_TOTAL_ASC',
  PurchaseOrdersMaxTotalDesc = 'PURCHASE_ORDERS_MAX_TOTAL_DESC',
  PurchaseOrdersMaxUserIdAsc = 'PURCHASE_ORDERS_MAX_USER_ID_ASC',
  PurchaseOrdersMaxUserIdDesc = 'PURCHASE_ORDERS_MAX_USER_ID_DESC',
  PurchaseOrdersMinRowIdAsc = 'PURCHASE_ORDERS_MIN_ROW_ID_ASC',
  PurchaseOrdersMinRowIdDesc = 'PURCHASE_ORDERS_MIN_ROW_ID_DESC',
  PurchaseOrdersMinTotalAsc = 'PURCHASE_ORDERS_MIN_TOTAL_ASC',
  PurchaseOrdersMinTotalDesc = 'PURCHASE_ORDERS_MIN_TOTAL_DESC',
  PurchaseOrdersMinUserIdAsc = 'PURCHASE_ORDERS_MIN_USER_ID_ASC',
  PurchaseOrdersMinUserIdDesc = 'PURCHASE_ORDERS_MIN_USER_ID_DESC',
  PurchaseOrdersStddevPopulationRowIdAsc = 'PURCHASE_ORDERS_STDDEV_POPULATION_ROW_ID_ASC',
  PurchaseOrdersStddevPopulationRowIdDesc = 'PURCHASE_ORDERS_STDDEV_POPULATION_ROW_ID_DESC',
  PurchaseOrdersStddevPopulationTotalAsc = 'PURCHASE_ORDERS_STDDEV_POPULATION_TOTAL_ASC',
  PurchaseOrdersStddevPopulationTotalDesc = 'PURCHASE_ORDERS_STDDEV_POPULATION_TOTAL_DESC',
  PurchaseOrdersStddevPopulationUserIdAsc = 'PURCHASE_ORDERS_STDDEV_POPULATION_USER_ID_ASC',
  PurchaseOrdersStddevPopulationUserIdDesc = 'PURCHASE_ORDERS_STDDEV_POPULATION_USER_ID_DESC',
  PurchaseOrdersStddevSampleRowIdAsc = 'PURCHASE_ORDERS_STDDEV_SAMPLE_ROW_ID_ASC',
  PurchaseOrdersStddevSampleRowIdDesc = 'PURCHASE_ORDERS_STDDEV_SAMPLE_ROW_ID_DESC',
  PurchaseOrdersStddevSampleTotalAsc = 'PURCHASE_ORDERS_STDDEV_SAMPLE_TOTAL_ASC',
  PurchaseOrdersStddevSampleTotalDesc = 'PURCHASE_ORDERS_STDDEV_SAMPLE_TOTAL_DESC',
  PurchaseOrdersStddevSampleUserIdAsc = 'PURCHASE_ORDERS_STDDEV_SAMPLE_USER_ID_ASC',
  PurchaseOrdersStddevSampleUserIdDesc = 'PURCHASE_ORDERS_STDDEV_SAMPLE_USER_ID_DESC',
  PurchaseOrdersSumRowIdAsc = 'PURCHASE_ORDERS_SUM_ROW_ID_ASC',
  PurchaseOrdersSumRowIdDesc = 'PURCHASE_ORDERS_SUM_ROW_ID_DESC',
  PurchaseOrdersSumTotalAsc = 'PURCHASE_ORDERS_SUM_TOTAL_ASC',
  PurchaseOrdersSumTotalDesc = 'PURCHASE_ORDERS_SUM_TOTAL_DESC',
  PurchaseOrdersSumUserIdAsc = 'PURCHASE_ORDERS_SUM_USER_ID_ASC',
  PurchaseOrdersSumUserIdDesc = 'PURCHASE_ORDERS_SUM_USER_ID_DESC',
  PurchaseOrdersVariancePopulationRowIdAsc = 'PURCHASE_ORDERS_VARIANCE_POPULATION_ROW_ID_ASC',
  PurchaseOrdersVariancePopulationRowIdDesc = 'PURCHASE_ORDERS_VARIANCE_POPULATION_ROW_ID_DESC',
  PurchaseOrdersVariancePopulationTotalAsc = 'PURCHASE_ORDERS_VARIANCE_POPULATION_TOTAL_ASC',
  PurchaseOrdersVariancePopulationTotalDesc = 'PURCHASE_ORDERS_VARIANCE_POPULATION_TOTAL_DESC',
  PurchaseOrdersVariancePopulationUserIdAsc = 'PURCHASE_ORDERS_VARIANCE_POPULATION_USER_ID_ASC',
  PurchaseOrdersVariancePopulationUserIdDesc = 'PURCHASE_ORDERS_VARIANCE_POPULATION_USER_ID_DESC',
  PurchaseOrdersVarianceSampleRowIdAsc = 'PURCHASE_ORDERS_VARIANCE_SAMPLE_ROW_ID_ASC',
  PurchaseOrdersVarianceSampleRowIdDesc = 'PURCHASE_ORDERS_VARIANCE_SAMPLE_ROW_ID_DESC',
  PurchaseOrdersVarianceSampleTotalAsc = 'PURCHASE_ORDERS_VARIANCE_SAMPLE_TOTAL_ASC',
  PurchaseOrdersVarianceSampleTotalDesc = 'PURCHASE_ORDERS_VARIANCE_SAMPLE_TOTAL_DESC',
  PurchaseOrdersVarianceSampleUserIdAsc = 'PURCHASE_ORDERS_VARIANCE_SAMPLE_USER_ID_ASC',
  PurchaseOrdersVarianceSampleUserIdDesc = 'PURCHASE_ORDERS_VARIANCE_SAMPLE_USER_ID_DESC',
  RebillSessionsAveragePurchaseIdAsc = 'REBILL_SESSIONS_AVERAGE_PURCHASE_ID_ASC',
  RebillSessionsAveragePurchaseIdDesc = 'REBILL_SESSIONS_AVERAGE_PURCHASE_ID_DESC',
  RebillSessionsAverageRowIdAsc = 'REBILL_SESSIONS_AVERAGE_ROW_ID_ASC',
  RebillSessionsAverageRowIdDesc = 'REBILL_SESSIONS_AVERAGE_ROW_ID_DESC',
  RebillSessionsAverageSubscriptionIdAsc = 'REBILL_SESSIONS_AVERAGE_SUBSCRIPTION_ID_ASC',
  RebillSessionsAverageSubscriptionIdDesc = 'REBILL_SESSIONS_AVERAGE_SUBSCRIPTION_ID_DESC',
  RebillSessionsAverageUserIdAsc = 'REBILL_SESSIONS_AVERAGE_USER_ID_ASC',
  RebillSessionsAverageUserIdDesc = 'REBILL_SESSIONS_AVERAGE_USER_ID_DESC',
  RebillSessionsCountAsc = 'REBILL_SESSIONS_COUNT_ASC',
  RebillSessionsCountDesc = 'REBILL_SESSIONS_COUNT_DESC',
  RebillSessionsDistinctCountExternalSubscriptionReferenceAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_EXTERNAL_SUBSCRIPTION_REFERENCE_ASC',
  RebillSessionsDistinctCountExternalSubscriptionReferenceDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_EXTERNAL_SUBSCRIPTION_REFERENCE_DESC',
  RebillSessionsDistinctCountPurchaseIdAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_PURCHASE_ID_ASC',
  RebillSessionsDistinctCountPurchaseIdDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_PURCHASE_ID_DESC',
  RebillSessionsDistinctCountRebillManagerAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_REBILL_MANAGER_ASC',
  RebillSessionsDistinctCountRebillManagerDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_REBILL_MANAGER_DESC',
  RebillSessionsDistinctCountRowIdAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_ROW_ID_ASC',
  RebillSessionsDistinctCountRowIdDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_ROW_ID_DESC',
  RebillSessionsDistinctCountStatusAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_STATUS_ASC',
  RebillSessionsDistinctCountStatusDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_STATUS_DESC',
  RebillSessionsDistinctCountSubscriptionIdAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  RebillSessionsDistinctCountSubscriptionIdDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  RebillSessionsDistinctCountUpdatedAtAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_UPDATED_AT_ASC',
  RebillSessionsDistinctCountUpdatedAtDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_UPDATED_AT_DESC',
  RebillSessionsDistinctCountUserIdAsc = 'REBILL_SESSIONS_DISTINCT_COUNT_USER_ID_ASC',
  RebillSessionsDistinctCountUserIdDesc = 'REBILL_SESSIONS_DISTINCT_COUNT_USER_ID_DESC',
  RebillSessionsMaxPurchaseIdAsc = 'REBILL_SESSIONS_MAX_PURCHASE_ID_ASC',
  RebillSessionsMaxPurchaseIdDesc = 'REBILL_SESSIONS_MAX_PURCHASE_ID_DESC',
  RebillSessionsMaxRowIdAsc = 'REBILL_SESSIONS_MAX_ROW_ID_ASC',
  RebillSessionsMaxRowIdDesc = 'REBILL_SESSIONS_MAX_ROW_ID_DESC',
  RebillSessionsMaxSubscriptionIdAsc = 'REBILL_SESSIONS_MAX_SUBSCRIPTION_ID_ASC',
  RebillSessionsMaxSubscriptionIdDesc = 'REBILL_SESSIONS_MAX_SUBSCRIPTION_ID_DESC',
  RebillSessionsMaxUserIdAsc = 'REBILL_SESSIONS_MAX_USER_ID_ASC',
  RebillSessionsMaxUserIdDesc = 'REBILL_SESSIONS_MAX_USER_ID_DESC',
  RebillSessionsMinPurchaseIdAsc = 'REBILL_SESSIONS_MIN_PURCHASE_ID_ASC',
  RebillSessionsMinPurchaseIdDesc = 'REBILL_SESSIONS_MIN_PURCHASE_ID_DESC',
  RebillSessionsMinRowIdAsc = 'REBILL_SESSIONS_MIN_ROW_ID_ASC',
  RebillSessionsMinRowIdDesc = 'REBILL_SESSIONS_MIN_ROW_ID_DESC',
  RebillSessionsMinSubscriptionIdAsc = 'REBILL_SESSIONS_MIN_SUBSCRIPTION_ID_ASC',
  RebillSessionsMinSubscriptionIdDesc = 'REBILL_SESSIONS_MIN_SUBSCRIPTION_ID_DESC',
  RebillSessionsMinUserIdAsc = 'REBILL_SESSIONS_MIN_USER_ID_ASC',
  RebillSessionsMinUserIdDesc = 'REBILL_SESSIONS_MIN_USER_ID_DESC',
  RebillSessionsStddevPopulationPurchaseIdAsc = 'REBILL_SESSIONS_STDDEV_POPULATION_PURCHASE_ID_ASC',
  RebillSessionsStddevPopulationPurchaseIdDesc = 'REBILL_SESSIONS_STDDEV_POPULATION_PURCHASE_ID_DESC',
  RebillSessionsStddevPopulationRowIdAsc = 'REBILL_SESSIONS_STDDEV_POPULATION_ROW_ID_ASC',
  RebillSessionsStddevPopulationRowIdDesc = 'REBILL_SESSIONS_STDDEV_POPULATION_ROW_ID_DESC',
  RebillSessionsStddevPopulationSubscriptionIdAsc = 'REBILL_SESSIONS_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  RebillSessionsStddevPopulationSubscriptionIdDesc = 'REBILL_SESSIONS_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  RebillSessionsStddevPopulationUserIdAsc = 'REBILL_SESSIONS_STDDEV_POPULATION_USER_ID_ASC',
  RebillSessionsStddevPopulationUserIdDesc = 'REBILL_SESSIONS_STDDEV_POPULATION_USER_ID_DESC',
  RebillSessionsStddevSamplePurchaseIdAsc = 'REBILL_SESSIONS_STDDEV_SAMPLE_PURCHASE_ID_ASC',
  RebillSessionsStddevSamplePurchaseIdDesc = 'REBILL_SESSIONS_STDDEV_SAMPLE_PURCHASE_ID_DESC',
  RebillSessionsStddevSampleRowIdAsc = 'REBILL_SESSIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  RebillSessionsStddevSampleRowIdDesc = 'REBILL_SESSIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  RebillSessionsStddevSampleSubscriptionIdAsc = 'REBILL_SESSIONS_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  RebillSessionsStddevSampleSubscriptionIdDesc = 'REBILL_SESSIONS_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  RebillSessionsStddevSampleUserIdAsc = 'REBILL_SESSIONS_STDDEV_SAMPLE_USER_ID_ASC',
  RebillSessionsStddevSampleUserIdDesc = 'REBILL_SESSIONS_STDDEV_SAMPLE_USER_ID_DESC',
  RebillSessionsSumPurchaseIdAsc = 'REBILL_SESSIONS_SUM_PURCHASE_ID_ASC',
  RebillSessionsSumPurchaseIdDesc = 'REBILL_SESSIONS_SUM_PURCHASE_ID_DESC',
  RebillSessionsSumRowIdAsc = 'REBILL_SESSIONS_SUM_ROW_ID_ASC',
  RebillSessionsSumRowIdDesc = 'REBILL_SESSIONS_SUM_ROW_ID_DESC',
  RebillSessionsSumSubscriptionIdAsc = 'REBILL_SESSIONS_SUM_SUBSCRIPTION_ID_ASC',
  RebillSessionsSumSubscriptionIdDesc = 'REBILL_SESSIONS_SUM_SUBSCRIPTION_ID_DESC',
  RebillSessionsSumUserIdAsc = 'REBILL_SESSIONS_SUM_USER_ID_ASC',
  RebillSessionsSumUserIdDesc = 'REBILL_SESSIONS_SUM_USER_ID_DESC',
  RebillSessionsVariancePopulationPurchaseIdAsc = 'REBILL_SESSIONS_VARIANCE_POPULATION_PURCHASE_ID_ASC',
  RebillSessionsVariancePopulationPurchaseIdDesc = 'REBILL_SESSIONS_VARIANCE_POPULATION_PURCHASE_ID_DESC',
  RebillSessionsVariancePopulationRowIdAsc = 'REBILL_SESSIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  RebillSessionsVariancePopulationRowIdDesc = 'REBILL_SESSIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  RebillSessionsVariancePopulationSubscriptionIdAsc = 'REBILL_SESSIONS_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  RebillSessionsVariancePopulationSubscriptionIdDesc = 'REBILL_SESSIONS_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  RebillSessionsVariancePopulationUserIdAsc = 'REBILL_SESSIONS_VARIANCE_POPULATION_USER_ID_ASC',
  RebillSessionsVariancePopulationUserIdDesc = 'REBILL_SESSIONS_VARIANCE_POPULATION_USER_ID_DESC',
  RebillSessionsVarianceSamplePurchaseIdAsc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_PURCHASE_ID_ASC',
  RebillSessionsVarianceSamplePurchaseIdDesc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_PURCHASE_ID_DESC',
  RebillSessionsVarianceSampleRowIdAsc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  RebillSessionsVarianceSampleRowIdDesc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  RebillSessionsVarianceSampleSubscriptionIdAsc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  RebillSessionsVarianceSampleSubscriptionIdDesc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  RebillSessionsVarianceSampleUserIdAsc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  RebillSessionsVarianceSampleUserIdDesc = 'REBILL_SESSIONS_VARIANCE_SAMPLE_USER_ID_DESC',
  ResetCreditsAverageAccountTemplateIdAsc = 'RESET_CREDITS_AVERAGE_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsAverageAccountTemplateIdDesc = 'RESET_CREDITS_AVERAGE_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsAverageRowIdAsc = 'RESET_CREDITS_AVERAGE_ROW_ID_ASC',
  ResetCreditsAverageRowIdDesc = 'RESET_CREDITS_AVERAGE_ROW_ID_DESC',
  ResetCreditsAverageUserIdAsc = 'RESET_CREDITS_AVERAGE_USER_ID_ASC',
  ResetCreditsAverageUserIdDesc = 'RESET_CREDITS_AVERAGE_USER_ID_DESC',
  ResetCreditsCountAsc = 'RESET_CREDITS_COUNT_ASC',
  ResetCreditsCountDesc = 'RESET_CREDITS_COUNT_DESC',
  ResetCreditsDistinctCountAccountTemplateIdAsc = 'RESET_CREDITS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsDistinctCountAccountTemplateIdDesc = 'RESET_CREDITS_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsDistinctCountDeletedAtAsc = 'RESET_CREDITS_DISTINCT_COUNT_DELETED_AT_ASC',
  ResetCreditsDistinctCountDeletedAtDesc = 'RESET_CREDITS_DISTINCT_COUNT_DELETED_AT_DESC',
  ResetCreditsDistinctCountIsComplimentaryAsc = 'RESET_CREDITS_DISTINCT_COUNT_IS_COMPLIMENTARY_ASC',
  ResetCreditsDistinctCountIsComplimentaryDesc = 'RESET_CREDITS_DISTINCT_COUNT_IS_COMPLIMENTARY_DESC',
  ResetCreditsDistinctCountRowIdAsc = 'RESET_CREDITS_DISTINCT_COUNT_ROW_ID_ASC',
  ResetCreditsDistinctCountRowIdDesc = 'RESET_CREDITS_DISTINCT_COUNT_ROW_ID_DESC',
  ResetCreditsDistinctCountStatusAsc = 'RESET_CREDITS_DISTINCT_COUNT_STATUS_ASC',
  ResetCreditsDistinctCountStatusDesc = 'RESET_CREDITS_DISTINCT_COUNT_STATUS_DESC',
  ResetCreditsDistinctCountUserIdAsc = 'RESET_CREDITS_DISTINCT_COUNT_USER_ID_ASC',
  ResetCreditsDistinctCountUserIdDesc = 'RESET_CREDITS_DISTINCT_COUNT_USER_ID_DESC',
  ResetCreditsMaxAccountTemplateIdAsc = 'RESET_CREDITS_MAX_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsMaxAccountTemplateIdDesc = 'RESET_CREDITS_MAX_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsMaxRowIdAsc = 'RESET_CREDITS_MAX_ROW_ID_ASC',
  ResetCreditsMaxRowIdDesc = 'RESET_CREDITS_MAX_ROW_ID_DESC',
  ResetCreditsMaxUserIdAsc = 'RESET_CREDITS_MAX_USER_ID_ASC',
  ResetCreditsMaxUserIdDesc = 'RESET_CREDITS_MAX_USER_ID_DESC',
  ResetCreditsMinAccountTemplateIdAsc = 'RESET_CREDITS_MIN_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsMinAccountTemplateIdDesc = 'RESET_CREDITS_MIN_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsMinRowIdAsc = 'RESET_CREDITS_MIN_ROW_ID_ASC',
  ResetCreditsMinRowIdDesc = 'RESET_CREDITS_MIN_ROW_ID_DESC',
  ResetCreditsMinUserIdAsc = 'RESET_CREDITS_MIN_USER_ID_ASC',
  ResetCreditsMinUserIdDesc = 'RESET_CREDITS_MIN_USER_ID_DESC',
  ResetCreditsStddevPopulationAccountTemplateIdAsc = 'RESET_CREDITS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsStddevPopulationAccountTemplateIdDesc = 'RESET_CREDITS_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsStddevPopulationRowIdAsc = 'RESET_CREDITS_STDDEV_POPULATION_ROW_ID_ASC',
  ResetCreditsStddevPopulationRowIdDesc = 'RESET_CREDITS_STDDEV_POPULATION_ROW_ID_DESC',
  ResetCreditsStddevPopulationUserIdAsc = 'RESET_CREDITS_STDDEV_POPULATION_USER_ID_ASC',
  ResetCreditsStddevPopulationUserIdDesc = 'RESET_CREDITS_STDDEV_POPULATION_USER_ID_DESC',
  ResetCreditsStddevSampleAccountTemplateIdAsc = 'RESET_CREDITS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsStddevSampleAccountTemplateIdDesc = 'RESET_CREDITS_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsStddevSampleRowIdAsc = 'RESET_CREDITS_STDDEV_SAMPLE_ROW_ID_ASC',
  ResetCreditsStddevSampleRowIdDesc = 'RESET_CREDITS_STDDEV_SAMPLE_ROW_ID_DESC',
  ResetCreditsStddevSampleUserIdAsc = 'RESET_CREDITS_STDDEV_SAMPLE_USER_ID_ASC',
  ResetCreditsStddevSampleUserIdDesc = 'RESET_CREDITS_STDDEV_SAMPLE_USER_ID_DESC',
  ResetCreditsSumAccountTemplateIdAsc = 'RESET_CREDITS_SUM_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsSumAccountTemplateIdDesc = 'RESET_CREDITS_SUM_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsSumRowIdAsc = 'RESET_CREDITS_SUM_ROW_ID_ASC',
  ResetCreditsSumRowIdDesc = 'RESET_CREDITS_SUM_ROW_ID_DESC',
  ResetCreditsSumUserIdAsc = 'RESET_CREDITS_SUM_USER_ID_ASC',
  ResetCreditsSumUserIdDesc = 'RESET_CREDITS_SUM_USER_ID_DESC',
  ResetCreditsVariancePopulationAccountTemplateIdAsc = 'RESET_CREDITS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsVariancePopulationAccountTemplateIdDesc = 'RESET_CREDITS_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsVariancePopulationRowIdAsc = 'RESET_CREDITS_VARIANCE_POPULATION_ROW_ID_ASC',
  ResetCreditsVariancePopulationRowIdDesc = 'RESET_CREDITS_VARIANCE_POPULATION_ROW_ID_DESC',
  ResetCreditsVariancePopulationUserIdAsc = 'RESET_CREDITS_VARIANCE_POPULATION_USER_ID_ASC',
  ResetCreditsVariancePopulationUserIdDesc = 'RESET_CREDITS_VARIANCE_POPULATION_USER_ID_DESC',
  ResetCreditsVarianceSampleAccountTemplateIdAsc = 'RESET_CREDITS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ID_ASC',
  ResetCreditsVarianceSampleAccountTemplateIdDesc = 'RESET_CREDITS_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ID_DESC',
  ResetCreditsVarianceSampleRowIdAsc = 'RESET_CREDITS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ResetCreditsVarianceSampleRowIdDesc = 'RESET_CREDITS_VARIANCE_SAMPLE_ROW_ID_DESC',
  ResetCreditsVarianceSampleUserIdAsc = 'RESET_CREDITS_VARIANCE_SAMPLE_USER_ID_ASC',
  ResetCreditsVarianceSampleUserIdDesc = 'RESET_CREDITS_VARIANCE_SAMPLE_USER_ID_DESC',
  ResolvedRiskIndicatorsAverageRowIdAsc = 'RESOLVED_RISK_INDICATORS_AVERAGE_ROW_ID_ASC',
  ResolvedRiskIndicatorsAverageRowIdDesc = 'RESOLVED_RISK_INDICATORS_AVERAGE_ROW_ID_DESC',
  ResolvedRiskIndicatorsAverageTraderIdAsc = 'RESOLVED_RISK_INDICATORS_AVERAGE_TRADER_ID_ASC',
  ResolvedRiskIndicatorsAverageTraderIdDesc = 'RESOLVED_RISK_INDICATORS_AVERAGE_TRADER_ID_DESC',
  ResolvedRiskIndicatorsCountAsc = 'RESOLVED_RISK_INDICATORS_COUNT_ASC',
  ResolvedRiskIndicatorsCountDesc = 'RESOLVED_RISK_INDICATORS_COUNT_DESC',
  ResolvedRiskIndicatorsDistinctCountRowIdAsc = 'RESOLVED_RISK_INDICATORS_DISTINCT_COUNT_ROW_ID_ASC',
  ResolvedRiskIndicatorsDistinctCountRowIdDesc = 'RESOLVED_RISK_INDICATORS_DISTINCT_COUNT_ROW_ID_DESC',
  ResolvedRiskIndicatorsDistinctCountTraderIdAsc = 'RESOLVED_RISK_INDICATORS_DISTINCT_COUNT_TRADER_ID_ASC',
  ResolvedRiskIndicatorsDistinctCountTraderIdDesc = 'RESOLVED_RISK_INDICATORS_DISTINCT_COUNT_TRADER_ID_DESC',
  ResolvedRiskIndicatorsMaxRowIdAsc = 'RESOLVED_RISK_INDICATORS_MAX_ROW_ID_ASC',
  ResolvedRiskIndicatorsMaxRowIdDesc = 'RESOLVED_RISK_INDICATORS_MAX_ROW_ID_DESC',
  ResolvedRiskIndicatorsMaxTraderIdAsc = 'RESOLVED_RISK_INDICATORS_MAX_TRADER_ID_ASC',
  ResolvedRiskIndicatorsMaxTraderIdDesc = 'RESOLVED_RISK_INDICATORS_MAX_TRADER_ID_DESC',
  ResolvedRiskIndicatorsMinRowIdAsc = 'RESOLVED_RISK_INDICATORS_MIN_ROW_ID_ASC',
  ResolvedRiskIndicatorsMinRowIdDesc = 'RESOLVED_RISK_INDICATORS_MIN_ROW_ID_DESC',
  ResolvedRiskIndicatorsMinTraderIdAsc = 'RESOLVED_RISK_INDICATORS_MIN_TRADER_ID_ASC',
  ResolvedRiskIndicatorsMinTraderIdDesc = 'RESOLVED_RISK_INDICATORS_MIN_TRADER_ID_DESC',
  ResolvedRiskIndicatorsStddevPopulationRowIdAsc = 'RESOLVED_RISK_INDICATORS_STDDEV_POPULATION_ROW_ID_ASC',
  ResolvedRiskIndicatorsStddevPopulationRowIdDesc = 'RESOLVED_RISK_INDICATORS_STDDEV_POPULATION_ROW_ID_DESC',
  ResolvedRiskIndicatorsStddevPopulationTraderIdAsc = 'RESOLVED_RISK_INDICATORS_STDDEV_POPULATION_TRADER_ID_ASC',
  ResolvedRiskIndicatorsStddevPopulationTraderIdDesc = 'RESOLVED_RISK_INDICATORS_STDDEV_POPULATION_TRADER_ID_DESC',
  ResolvedRiskIndicatorsStddevSampleRowIdAsc = 'RESOLVED_RISK_INDICATORS_STDDEV_SAMPLE_ROW_ID_ASC',
  ResolvedRiskIndicatorsStddevSampleRowIdDesc = 'RESOLVED_RISK_INDICATORS_STDDEV_SAMPLE_ROW_ID_DESC',
  ResolvedRiskIndicatorsStddevSampleTraderIdAsc = 'RESOLVED_RISK_INDICATORS_STDDEV_SAMPLE_TRADER_ID_ASC',
  ResolvedRiskIndicatorsStddevSampleTraderIdDesc = 'RESOLVED_RISK_INDICATORS_STDDEV_SAMPLE_TRADER_ID_DESC',
  ResolvedRiskIndicatorsSumRowIdAsc = 'RESOLVED_RISK_INDICATORS_SUM_ROW_ID_ASC',
  ResolvedRiskIndicatorsSumRowIdDesc = 'RESOLVED_RISK_INDICATORS_SUM_ROW_ID_DESC',
  ResolvedRiskIndicatorsSumTraderIdAsc = 'RESOLVED_RISK_INDICATORS_SUM_TRADER_ID_ASC',
  ResolvedRiskIndicatorsSumTraderIdDesc = 'RESOLVED_RISK_INDICATORS_SUM_TRADER_ID_DESC',
  ResolvedRiskIndicatorsVariancePopulationRowIdAsc = 'RESOLVED_RISK_INDICATORS_VARIANCE_POPULATION_ROW_ID_ASC',
  ResolvedRiskIndicatorsVariancePopulationRowIdDesc = 'RESOLVED_RISK_INDICATORS_VARIANCE_POPULATION_ROW_ID_DESC',
  ResolvedRiskIndicatorsVariancePopulationTraderIdAsc = 'RESOLVED_RISK_INDICATORS_VARIANCE_POPULATION_TRADER_ID_ASC',
  ResolvedRiskIndicatorsVariancePopulationTraderIdDesc = 'RESOLVED_RISK_INDICATORS_VARIANCE_POPULATION_TRADER_ID_DESC',
  ResolvedRiskIndicatorsVarianceSampleRowIdAsc = 'RESOLVED_RISK_INDICATORS_VARIANCE_SAMPLE_ROW_ID_ASC',
  ResolvedRiskIndicatorsVarianceSampleRowIdDesc = 'RESOLVED_RISK_INDICATORS_VARIANCE_SAMPLE_ROW_ID_DESC',
  ResolvedRiskIndicatorsVarianceSampleTraderIdAsc = 'RESOLVED_RISK_INDICATORS_VARIANCE_SAMPLE_TRADER_ID_ASC',
  ResolvedRiskIndicatorsVarianceSampleTraderIdDesc = 'RESOLVED_RISK_INDICATORS_VARIANCE_SAMPLE_TRADER_ID_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  SavedCardsAverageRowIdAsc = 'SAVED_CARDS_AVERAGE_ROW_ID_ASC',
  SavedCardsAverageRowIdDesc = 'SAVED_CARDS_AVERAGE_ROW_ID_DESC',
  SavedCardsAverageUserIdAsc = 'SAVED_CARDS_AVERAGE_USER_ID_ASC',
  SavedCardsAverageUserIdDesc = 'SAVED_CARDS_AVERAGE_USER_ID_DESC',
  SavedCardsCountAsc = 'SAVED_CARDS_COUNT_ASC',
  SavedCardsCountDesc = 'SAVED_CARDS_COUNT_DESC',
  SavedCardsDistinctCountActiveAsc = 'SAVED_CARDS_DISTINCT_COUNT_ACTIVE_ASC',
  SavedCardsDistinctCountActiveDesc = 'SAVED_CARDS_DISTINCT_COUNT_ACTIVE_DESC',
  SavedCardsDistinctCountRowIdAsc = 'SAVED_CARDS_DISTINCT_COUNT_ROW_ID_ASC',
  SavedCardsDistinctCountRowIdDesc = 'SAVED_CARDS_DISTINCT_COUNT_ROW_ID_DESC',
  SavedCardsDistinctCountUserIdAsc = 'SAVED_CARDS_DISTINCT_COUNT_USER_ID_ASC',
  SavedCardsDistinctCountUserIdDesc = 'SAVED_CARDS_DISTINCT_COUNT_USER_ID_DESC',
  SavedCardsMaxRowIdAsc = 'SAVED_CARDS_MAX_ROW_ID_ASC',
  SavedCardsMaxRowIdDesc = 'SAVED_CARDS_MAX_ROW_ID_DESC',
  SavedCardsMaxUserIdAsc = 'SAVED_CARDS_MAX_USER_ID_ASC',
  SavedCardsMaxUserIdDesc = 'SAVED_CARDS_MAX_USER_ID_DESC',
  SavedCardsMinRowIdAsc = 'SAVED_CARDS_MIN_ROW_ID_ASC',
  SavedCardsMinRowIdDesc = 'SAVED_CARDS_MIN_ROW_ID_DESC',
  SavedCardsMinUserIdAsc = 'SAVED_CARDS_MIN_USER_ID_ASC',
  SavedCardsMinUserIdDesc = 'SAVED_CARDS_MIN_USER_ID_DESC',
  SavedCardsStddevPopulationRowIdAsc = 'SAVED_CARDS_STDDEV_POPULATION_ROW_ID_ASC',
  SavedCardsStddevPopulationRowIdDesc = 'SAVED_CARDS_STDDEV_POPULATION_ROW_ID_DESC',
  SavedCardsStddevPopulationUserIdAsc = 'SAVED_CARDS_STDDEV_POPULATION_USER_ID_ASC',
  SavedCardsStddevPopulationUserIdDesc = 'SAVED_CARDS_STDDEV_POPULATION_USER_ID_DESC',
  SavedCardsStddevSampleRowIdAsc = 'SAVED_CARDS_STDDEV_SAMPLE_ROW_ID_ASC',
  SavedCardsStddevSampleRowIdDesc = 'SAVED_CARDS_STDDEV_SAMPLE_ROW_ID_DESC',
  SavedCardsStddevSampleUserIdAsc = 'SAVED_CARDS_STDDEV_SAMPLE_USER_ID_ASC',
  SavedCardsStddevSampleUserIdDesc = 'SAVED_CARDS_STDDEV_SAMPLE_USER_ID_DESC',
  SavedCardsSumRowIdAsc = 'SAVED_CARDS_SUM_ROW_ID_ASC',
  SavedCardsSumRowIdDesc = 'SAVED_CARDS_SUM_ROW_ID_DESC',
  SavedCardsSumUserIdAsc = 'SAVED_CARDS_SUM_USER_ID_ASC',
  SavedCardsSumUserIdDesc = 'SAVED_CARDS_SUM_USER_ID_DESC',
  SavedCardsVariancePopulationRowIdAsc = 'SAVED_CARDS_VARIANCE_POPULATION_ROW_ID_ASC',
  SavedCardsVariancePopulationRowIdDesc = 'SAVED_CARDS_VARIANCE_POPULATION_ROW_ID_DESC',
  SavedCardsVariancePopulationUserIdAsc = 'SAVED_CARDS_VARIANCE_POPULATION_USER_ID_ASC',
  SavedCardsVariancePopulationUserIdDesc = 'SAVED_CARDS_VARIANCE_POPULATION_USER_ID_DESC',
  SavedCardsVarianceSampleRowIdAsc = 'SAVED_CARDS_VARIANCE_SAMPLE_ROW_ID_ASC',
  SavedCardsVarianceSampleRowIdDesc = 'SAVED_CARDS_VARIANCE_SAMPLE_ROW_ID_DESC',
  SavedCardsVarianceSampleUserIdAsc = 'SAVED_CARDS_VARIANCE_SAMPLE_USER_ID_ASC',
  SavedCardsVarianceSampleUserIdDesc = 'SAVED_CARDS_VARIANCE_SAMPLE_USER_ID_DESC',
  TaxFormsAverageRowIdAsc = 'TAX_FORMS_AVERAGE_ROW_ID_ASC',
  TaxFormsAverageRowIdDesc = 'TAX_FORMS_AVERAGE_ROW_ID_DESC',
  TaxFormsAverageUserIdAsc = 'TAX_FORMS_AVERAGE_USER_ID_ASC',
  TaxFormsAverageUserIdDesc = 'TAX_FORMS_AVERAGE_USER_ID_DESC',
  TaxFormsCountAsc = 'TAX_FORMS_COUNT_ASC',
  TaxFormsCountDesc = 'TAX_FORMS_COUNT_DESC',
  TaxFormsDistinctCountDocusignEnvelopeIdAsc = 'TAX_FORMS_DISTINCT_COUNT_DOCUSIGN_ENVELOPE_ID_ASC',
  TaxFormsDistinctCountDocusignEnvelopeIdDesc = 'TAX_FORMS_DISTINCT_COUNT_DOCUSIGN_ENVELOPE_ID_DESC',
  TaxFormsDistinctCountRowIdAsc = 'TAX_FORMS_DISTINCT_COUNT_ROW_ID_ASC',
  TaxFormsDistinctCountRowIdDesc = 'TAX_FORMS_DISTINCT_COUNT_ROW_ID_DESC',
  TaxFormsDistinctCountUserIdAsc = 'TAX_FORMS_DISTINCT_COUNT_USER_ID_ASC',
  TaxFormsDistinctCountUserIdDesc = 'TAX_FORMS_DISTINCT_COUNT_USER_ID_DESC',
  TaxFormsMaxRowIdAsc = 'TAX_FORMS_MAX_ROW_ID_ASC',
  TaxFormsMaxRowIdDesc = 'TAX_FORMS_MAX_ROW_ID_DESC',
  TaxFormsMaxUserIdAsc = 'TAX_FORMS_MAX_USER_ID_ASC',
  TaxFormsMaxUserIdDesc = 'TAX_FORMS_MAX_USER_ID_DESC',
  TaxFormsMinRowIdAsc = 'TAX_FORMS_MIN_ROW_ID_ASC',
  TaxFormsMinRowIdDesc = 'TAX_FORMS_MIN_ROW_ID_DESC',
  TaxFormsMinUserIdAsc = 'TAX_FORMS_MIN_USER_ID_ASC',
  TaxFormsMinUserIdDesc = 'TAX_FORMS_MIN_USER_ID_DESC',
  TaxFormsStddevPopulationRowIdAsc = 'TAX_FORMS_STDDEV_POPULATION_ROW_ID_ASC',
  TaxFormsStddevPopulationRowIdDesc = 'TAX_FORMS_STDDEV_POPULATION_ROW_ID_DESC',
  TaxFormsStddevPopulationUserIdAsc = 'TAX_FORMS_STDDEV_POPULATION_USER_ID_ASC',
  TaxFormsStddevPopulationUserIdDesc = 'TAX_FORMS_STDDEV_POPULATION_USER_ID_DESC',
  TaxFormsStddevSampleRowIdAsc = 'TAX_FORMS_STDDEV_SAMPLE_ROW_ID_ASC',
  TaxFormsStddevSampleRowIdDesc = 'TAX_FORMS_STDDEV_SAMPLE_ROW_ID_DESC',
  TaxFormsStddevSampleUserIdAsc = 'TAX_FORMS_STDDEV_SAMPLE_USER_ID_ASC',
  TaxFormsStddevSampleUserIdDesc = 'TAX_FORMS_STDDEV_SAMPLE_USER_ID_DESC',
  TaxFormsSumRowIdAsc = 'TAX_FORMS_SUM_ROW_ID_ASC',
  TaxFormsSumRowIdDesc = 'TAX_FORMS_SUM_ROW_ID_DESC',
  TaxFormsSumUserIdAsc = 'TAX_FORMS_SUM_USER_ID_ASC',
  TaxFormsSumUserIdDesc = 'TAX_FORMS_SUM_USER_ID_DESC',
  TaxFormsVariancePopulationRowIdAsc = 'TAX_FORMS_VARIANCE_POPULATION_ROW_ID_ASC',
  TaxFormsVariancePopulationRowIdDesc = 'TAX_FORMS_VARIANCE_POPULATION_ROW_ID_DESC',
  TaxFormsVariancePopulationUserIdAsc = 'TAX_FORMS_VARIANCE_POPULATION_USER_ID_ASC',
  TaxFormsVariancePopulationUserIdDesc = 'TAX_FORMS_VARIANCE_POPULATION_USER_ID_DESC',
  TaxFormsVarianceSampleRowIdAsc = 'TAX_FORMS_VARIANCE_SAMPLE_ROW_ID_ASC',
  TaxFormsVarianceSampleRowIdDesc = 'TAX_FORMS_VARIANCE_SAMPLE_ROW_ID_DESC',
  TaxFormsVarianceSampleUserIdAsc = 'TAX_FORMS_VARIANCE_SAMPLE_USER_ID_ASC',
  TaxFormsVarianceSampleUserIdDesc = 'TAX_FORMS_VARIANCE_SAMPLE_USER_ID_DESC',
  TaxInfosAverageRowIdAsc = 'TAX_INFOS_AVERAGE_ROW_ID_ASC',
  TaxInfosAverageRowIdDesc = 'TAX_INFOS_AVERAGE_ROW_ID_DESC',
  TaxInfosAverageUserIdAsc = 'TAX_INFOS_AVERAGE_USER_ID_ASC',
  TaxInfosAverageUserIdDesc = 'TAX_INFOS_AVERAGE_USER_ID_DESC',
  TaxInfosCountAsc = 'TAX_INFOS_COUNT_ASC',
  TaxInfosCountDesc = 'TAX_INFOS_COUNT_DESC',
  TaxInfosDistinctCountRowIdAsc = 'TAX_INFOS_DISTINCT_COUNT_ROW_ID_ASC',
  TaxInfosDistinctCountRowIdDesc = 'TAX_INFOS_DISTINCT_COUNT_ROW_ID_DESC',
  TaxInfosDistinctCountStatusAsc = 'TAX_INFOS_DISTINCT_COUNT_STATUS_ASC',
  TaxInfosDistinctCountStatusDesc = 'TAX_INFOS_DISTINCT_COUNT_STATUS_DESC',
  TaxInfosDistinctCountUserIdAsc = 'TAX_INFOS_DISTINCT_COUNT_USER_ID_ASC',
  TaxInfosDistinctCountUserIdDesc = 'TAX_INFOS_DISTINCT_COUNT_USER_ID_DESC',
  TaxInfosMaxRowIdAsc = 'TAX_INFOS_MAX_ROW_ID_ASC',
  TaxInfosMaxRowIdDesc = 'TAX_INFOS_MAX_ROW_ID_DESC',
  TaxInfosMaxUserIdAsc = 'TAX_INFOS_MAX_USER_ID_ASC',
  TaxInfosMaxUserIdDesc = 'TAX_INFOS_MAX_USER_ID_DESC',
  TaxInfosMinRowIdAsc = 'TAX_INFOS_MIN_ROW_ID_ASC',
  TaxInfosMinRowIdDesc = 'TAX_INFOS_MIN_ROW_ID_DESC',
  TaxInfosMinUserIdAsc = 'TAX_INFOS_MIN_USER_ID_ASC',
  TaxInfosMinUserIdDesc = 'TAX_INFOS_MIN_USER_ID_DESC',
  TaxInfosStddevPopulationRowIdAsc = 'TAX_INFOS_STDDEV_POPULATION_ROW_ID_ASC',
  TaxInfosStddevPopulationRowIdDesc = 'TAX_INFOS_STDDEV_POPULATION_ROW_ID_DESC',
  TaxInfosStddevPopulationUserIdAsc = 'TAX_INFOS_STDDEV_POPULATION_USER_ID_ASC',
  TaxInfosStddevPopulationUserIdDesc = 'TAX_INFOS_STDDEV_POPULATION_USER_ID_DESC',
  TaxInfosStddevSampleRowIdAsc = 'TAX_INFOS_STDDEV_SAMPLE_ROW_ID_ASC',
  TaxInfosStddevSampleRowIdDesc = 'TAX_INFOS_STDDEV_SAMPLE_ROW_ID_DESC',
  TaxInfosStddevSampleUserIdAsc = 'TAX_INFOS_STDDEV_SAMPLE_USER_ID_ASC',
  TaxInfosStddevSampleUserIdDesc = 'TAX_INFOS_STDDEV_SAMPLE_USER_ID_DESC',
  TaxInfosSumRowIdAsc = 'TAX_INFOS_SUM_ROW_ID_ASC',
  TaxInfosSumRowIdDesc = 'TAX_INFOS_SUM_ROW_ID_DESC',
  TaxInfosSumUserIdAsc = 'TAX_INFOS_SUM_USER_ID_ASC',
  TaxInfosSumUserIdDesc = 'TAX_INFOS_SUM_USER_ID_DESC',
  TaxInfosVariancePopulationRowIdAsc = 'TAX_INFOS_VARIANCE_POPULATION_ROW_ID_ASC',
  TaxInfosVariancePopulationRowIdDesc = 'TAX_INFOS_VARIANCE_POPULATION_ROW_ID_DESC',
  TaxInfosVariancePopulationUserIdAsc = 'TAX_INFOS_VARIANCE_POPULATION_USER_ID_ASC',
  TaxInfosVariancePopulationUserIdDesc = 'TAX_INFOS_VARIANCE_POPULATION_USER_ID_DESC',
  TaxInfosVarianceSampleRowIdAsc = 'TAX_INFOS_VARIANCE_SAMPLE_ROW_ID_ASC',
  TaxInfosVarianceSampleRowIdDesc = 'TAX_INFOS_VARIANCE_SAMPLE_ROW_ID_DESC',
  TaxInfosVarianceSampleUserIdAsc = 'TAX_INFOS_VARIANCE_SAMPLE_USER_ID_ASC',
  TaxInfosVarianceSampleUserIdDesc = 'TAX_INFOS_VARIANCE_SAMPLE_USER_ID_DESC',
  TraderProfileModerationCasesByTraderIdAverageRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_AVERAGE_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdAverageRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_AVERAGE_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdAverageTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_AVERAGE_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdAverageTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_AVERAGE_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdCountAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_COUNT_ASC',
  TraderProfileModerationCasesByTraderIdCountDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_COUNT_DESC',
  TraderProfileModerationCasesByTraderIdDistinctCountRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_DISTINCT_COUNT_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdDistinctCountRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_DISTINCT_COUNT_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdDistinctCountSubmittedAtAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_DISTINCT_COUNT_SUBMITTED_AT_ASC',
  TraderProfileModerationCasesByTraderIdDistinctCountSubmittedAtDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_DISTINCT_COUNT_SUBMITTED_AT_DESC',
  TraderProfileModerationCasesByTraderIdDistinctCountTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_DISTINCT_COUNT_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdDistinctCountTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_DISTINCT_COUNT_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdMaxRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MAX_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdMaxRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MAX_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdMaxTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MAX_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdMaxTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MAX_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdMinRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MIN_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdMinRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MIN_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdMinTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MIN_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdMinTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_MIN_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdStddevPopulationRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_POPULATION_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdStddevPopulationRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_POPULATION_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdStddevPopulationTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_POPULATION_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdStddevPopulationTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_POPULATION_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdStddevSampleRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdStddevSampleRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdStddevSampleTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_SAMPLE_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdStddevSampleTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_STDDEV_SAMPLE_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdSumRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_SUM_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdSumRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_SUM_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdSumTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_SUM_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdSumTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_SUM_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdVariancePopulationRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdVariancePopulationRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdVariancePopulationTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_POPULATION_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdVariancePopulationTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_POPULATION_TRADER_ID_DESC',
  TraderProfileModerationCasesByTraderIdVarianceSampleRowIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  TraderProfileModerationCasesByTraderIdVarianceSampleRowIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  TraderProfileModerationCasesByTraderIdVarianceSampleTraderIdAsc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_SAMPLE_TRADER_ID_ASC',
  TraderProfileModerationCasesByTraderIdVarianceSampleTraderIdDesc = 'TRADER_PROFILE_MODERATION_CASES_BY_TRADER_ID_VARIANCE_SAMPLE_TRADER_ID_DESC',
  TraderRiskIndicatorsAverageRowIdAsc = 'TRADER_RISK_INDICATORS_AVERAGE_ROW_ID_ASC',
  TraderRiskIndicatorsAverageRowIdDesc = 'TRADER_RISK_INDICATORS_AVERAGE_ROW_ID_DESC',
  TraderRiskIndicatorsAverageTraderIdAsc = 'TRADER_RISK_INDICATORS_AVERAGE_TRADER_ID_ASC',
  TraderRiskIndicatorsAverageTraderIdDesc = 'TRADER_RISK_INDICATORS_AVERAGE_TRADER_ID_DESC',
  TraderRiskIndicatorsCountAsc = 'TRADER_RISK_INDICATORS_COUNT_ASC',
  TraderRiskIndicatorsCountDesc = 'TRADER_RISK_INDICATORS_COUNT_DESC',
  TraderRiskIndicatorsDistinctCountRowIdAsc = 'TRADER_RISK_INDICATORS_DISTINCT_COUNT_ROW_ID_ASC',
  TraderRiskIndicatorsDistinctCountRowIdDesc = 'TRADER_RISK_INDICATORS_DISTINCT_COUNT_ROW_ID_DESC',
  TraderRiskIndicatorsDistinctCountTraderIdAsc = 'TRADER_RISK_INDICATORS_DISTINCT_COUNT_TRADER_ID_ASC',
  TraderRiskIndicatorsDistinctCountTraderIdDesc = 'TRADER_RISK_INDICATORS_DISTINCT_COUNT_TRADER_ID_DESC',
  TraderRiskIndicatorsMaxRowIdAsc = 'TRADER_RISK_INDICATORS_MAX_ROW_ID_ASC',
  TraderRiskIndicatorsMaxRowIdDesc = 'TRADER_RISK_INDICATORS_MAX_ROW_ID_DESC',
  TraderRiskIndicatorsMaxTraderIdAsc = 'TRADER_RISK_INDICATORS_MAX_TRADER_ID_ASC',
  TraderRiskIndicatorsMaxTraderIdDesc = 'TRADER_RISK_INDICATORS_MAX_TRADER_ID_DESC',
  TraderRiskIndicatorsMinRowIdAsc = 'TRADER_RISK_INDICATORS_MIN_ROW_ID_ASC',
  TraderRiskIndicatorsMinRowIdDesc = 'TRADER_RISK_INDICATORS_MIN_ROW_ID_DESC',
  TraderRiskIndicatorsMinTraderIdAsc = 'TRADER_RISK_INDICATORS_MIN_TRADER_ID_ASC',
  TraderRiskIndicatorsMinTraderIdDesc = 'TRADER_RISK_INDICATORS_MIN_TRADER_ID_DESC',
  TraderRiskIndicatorsStddevPopulationRowIdAsc = 'TRADER_RISK_INDICATORS_STDDEV_POPULATION_ROW_ID_ASC',
  TraderRiskIndicatorsStddevPopulationRowIdDesc = 'TRADER_RISK_INDICATORS_STDDEV_POPULATION_ROW_ID_DESC',
  TraderRiskIndicatorsStddevPopulationTraderIdAsc = 'TRADER_RISK_INDICATORS_STDDEV_POPULATION_TRADER_ID_ASC',
  TraderRiskIndicatorsStddevPopulationTraderIdDesc = 'TRADER_RISK_INDICATORS_STDDEV_POPULATION_TRADER_ID_DESC',
  TraderRiskIndicatorsStddevSampleRowIdAsc = 'TRADER_RISK_INDICATORS_STDDEV_SAMPLE_ROW_ID_ASC',
  TraderRiskIndicatorsStddevSampleRowIdDesc = 'TRADER_RISK_INDICATORS_STDDEV_SAMPLE_ROW_ID_DESC',
  TraderRiskIndicatorsStddevSampleTraderIdAsc = 'TRADER_RISK_INDICATORS_STDDEV_SAMPLE_TRADER_ID_ASC',
  TraderRiskIndicatorsStddevSampleTraderIdDesc = 'TRADER_RISK_INDICATORS_STDDEV_SAMPLE_TRADER_ID_DESC',
  TraderRiskIndicatorsSumRowIdAsc = 'TRADER_RISK_INDICATORS_SUM_ROW_ID_ASC',
  TraderRiskIndicatorsSumRowIdDesc = 'TRADER_RISK_INDICATORS_SUM_ROW_ID_DESC',
  TraderRiskIndicatorsSumTraderIdAsc = 'TRADER_RISK_INDICATORS_SUM_TRADER_ID_ASC',
  TraderRiskIndicatorsSumTraderIdDesc = 'TRADER_RISK_INDICATORS_SUM_TRADER_ID_DESC',
  TraderRiskIndicatorsVariancePopulationRowIdAsc = 'TRADER_RISK_INDICATORS_VARIANCE_POPULATION_ROW_ID_ASC',
  TraderRiskIndicatorsVariancePopulationRowIdDesc = 'TRADER_RISK_INDICATORS_VARIANCE_POPULATION_ROW_ID_DESC',
  TraderRiskIndicatorsVariancePopulationTraderIdAsc = 'TRADER_RISK_INDICATORS_VARIANCE_POPULATION_TRADER_ID_ASC',
  TraderRiskIndicatorsVariancePopulationTraderIdDesc = 'TRADER_RISK_INDICATORS_VARIANCE_POPULATION_TRADER_ID_DESC',
  TraderRiskIndicatorsVarianceSampleRowIdAsc = 'TRADER_RISK_INDICATORS_VARIANCE_SAMPLE_ROW_ID_ASC',
  TraderRiskIndicatorsVarianceSampleRowIdDesc = 'TRADER_RISK_INDICATORS_VARIANCE_SAMPLE_ROW_ID_DESC',
  TraderRiskIndicatorsVarianceSampleTraderIdAsc = 'TRADER_RISK_INDICATORS_VARIANCE_SAMPLE_TRADER_ID_ASC',
  TraderRiskIndicatorsVarianceSampleTraderIdDesc = 'TRADER_RISK_INDICATORS_VARIANCE_SAMPLE_TRADER_ID_DESC',
  UserAddressesAverageRowIdAsc = 'USER_ADDRESSES_AVERAGE_ROW_ID_ASC',
  UserAddressesAverageRowIdDesc = 'USER_ADDRESSES_AVERAGE_ROW_ID_DESC',
  UserAddressesAverageUserIdAsc = 'USER_ADDRESSES_AVERAGE_USER_ID_ASC',
  UserAddressesAverageUserIdDesc = 'USER_ADDRESSES_AVERAGE_USER_ID_DESC',
  UserAddressesCountAsc = 'USER_ADDRESSES_COUNT_ASC',
  UserAddressesCountDesc = 'USER_ADDRESSES_COUNT_DESC',
  UserAddressesDistinctCountRowIdAsc = 'USER_ADDRESSES_DISTINCT_COUNT_ROW_ID_ASC',
  UserAddressesDistinctCountRowIdDesc = 'USER_ADDRESSES_DISTINCT_COUNT_ROW_ID_DESC',
  UserAddressesDistinctCountUserIdAsc = 'USER_ADDRESSES_DISTINCT_COUNT_USER_ID_ASC',
  UserAddressesDistinctCountUserIdDesc = 'USER_ADDRESSES_DISTINCT_COUNT_USER_ID_DESC',
  UserAddressesMaxRowIdAsc = 'USER_ADDRESSES_MAX_ROW_ID_ASC',
  UserAddressesMaxRowIdDesc = 'USER_ADDRESSES_MAX_ROW_ID_DESC',
  UserAddressesMaxUserIdAsc = 'USER_ADDRESSES_MAX_USER_ID_ASC',
  UserAddressesMaxUserIdDesc = 'USER_ADDRESSES_MAX_USER_ID_DESC',
  UserAddressesMinRowIdAsc = 'USER_ADDRESSES_MIN_ROW_ID_ASC',
  UserAddressesMinRowIdDesc = 'USER_ADDRESSES_MIN_ROW_ID_DESC',
  UserAddressesMinUserIdAsc = 'USER_ADDRESSES_MIN_USER_ID_ASC',
  UserAddressesMinUserIdDesc = 'USER_ADDRESSES_MIN_USER_ID_DESC',
  UserAddressesStddevPopulationRowIdAsc = 'USER_ADDRESSES_STDDEV_POPULATION_ROW_ID_ASC',
  UserAddressesStddevPopulationRowIdDesc = 'USER_ADDRESSES_STDDEV_POPULATION_ROW_ID_DESC',
  UserAddressesStddevPopulationUserIdAsc = 'USER_ADDRESSES_STDDEV_POPULATION_USER_ID_ASC',
  UserAddressesStddevPopulationUserIdDesc = 'USER_ADDRESSES_STDDEV_POPULATION_USER_ID_DESC',
  UserAddressesStddevSampleRowIdAsc = 'USER_ADDRESSES_STDDEV_SAMPLE_ROW_ID_ASC',
  UserAddressesStddevSampleRowIdDesc = 'USER_ADDRESSES_STDDEV_SAMPLE_ROW_ID_DESC',
  UserAddressesStddevSampleUserIdAsc = 'USER_ADDRESSES_STDDEV_SAMPLE_USER_ID_ASC',
  UserAddressesStddevSampleUserIdDesc = 'USER_ADDRESSES_STDDEV_SAMPLE_USER_ID_DESC',
  UserAddressesSumRowIdAsc = 'USER_ADDRESSES_SUM_ROW_ID_ASC',
  UserAddressesSumRowIdDesc = 'USER_ADDRESSES_SUM_ROW_ID_DESC',
  UserAddressesSumUserIdAsc = 'USER_ADDRESSES_SUM_USER_ID_ASC',
  UserAddressesSumUserIdDesc = 'USER_ADDRESSES_SUM_USER_ID_DESC',
  UserAddressesVariancePopulationRowIdAsc = 'USER_ADDRESSES_VARIANCE_POPULATION_ROW_ID_ASC',
  UserAddressesVariancePopulationRowIdDesc = 'USER_ADDRESSES_VARIANCE_POPULATION_ROW_ID_DESC',
  UserAddressesVariancePopulationUserIdAsc = 'USER_ADDRESSES_VARIANCE_POPULATION_USER_ID_ASC',
  UserAddressesVariancePopulationUserIdDesc = 'USER_ADDRESSES_VARIANCE_POPULATION_USER_ID_DESC',
  UserAddressesVarianceSampleRowIdAsc = 'USER_ADDRESSES_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserAddressesVarianceSampleRowIdDesc = 'USER_ADDRESSES_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserAddressesVarianceSampleUserIdAsc = 'USER_ADDRESSES_VARIANCE_SAMPLE_USER_ID_ASC',
  UserAddressesVarianceSampleUserIdDesc = 'USER_ADDRESSES_VARIANCE_SAMPLE_USER_ID_DESC',
  UserAdminRolesAverageRoleIdAsc = 'USER_ADMIN_ROLES_AVERAGE_ROLE_ID_ASC',
  UserAdminRolesAverageRoleIdDesc = 'USER_ADMIN_ROLES_AVERAGE_ROLE_ID_DESC',
  UserAdminRolesAverageUserIdAsc = 'USER_ADMIN_ROLES_AVERAGE_USER_ID_ASC',
  UserAdminRolesAverageUserIdDesc = 'USER_ADMIN_ROLES_AVERAGE_USER_ID_DESC',
  UserAdminRolesCountAsc = 'USER_ADMIN_ROLES_COUNT_ASC',
  UserAdminRolesCountDesc = 'USER_ADMIN_ROLES_COUNT_DESC',
  UserAdminRolesDistinctCountRoleIdAsc = 'USER_ADMIN_ROLES_DISTINCT_COUNT_ROLE_ID_ASC',
  UserAdminRolesDistinctCountRoleIdDesc = 'USER_ADMIN_ROLES_DISTINCT_COUNT_ROLE_ID_DESC',
  UserAdminRolesDistinctCountUserIdAsc = 'USER_ADMIN_ROLES_DISTINCT_COUNT_USER_ID_ASC',
  UserAdminRolesDistinctCountUserIdDesc = 'USER_ADMIN_ROLES_DISTINCT_COUNT_USER_ID_DESC',
  UserAdminRolesMaxRoleIdAsc = 'USER_ADMIN_ROLES_MAX_ROLE_ID_ASC',
  UserAdminRolesMaxRoleIdDesc = 'USER_ADMIN_ROLES_MAX_ROLE_ID_DESC',
  UserAdminRolesMaxUserIdAsc = 'USER_ADMIN_ROLES_MAX_USER_ID_ASC',
  UserAdminRolesMaxUserIdDesc = 'USER_ADMIN_ROLES_MAX_USER_ID_DESC',
  UserAdminRolesMinRoleIdAsc = 'USER_ADMIN_ROLES_MIN_ROLE_ID_ASC',
  UserAdminRolesMinRoleIdDesc = 'USER_ADMIN_ROLES_MIN_ROLE_ID_DESC',
  UserAdminRolesMinUserIdAsc = 'USER_ADMIN_ROLES_MIN_USER_ID_ASC',
  UserAdminRolesMinUserIdDesc = 'USER_ADMIN_ROLES_MIN_USER_ID_DESC',
  UserAdminRolesStddevPopulationRoleIdAsc = 'USER_ADMIN_ROLES_STDDEV_POPULATION_ROLE_ID_ASC',
  UserAdminRolesStddevPopulationRoleIdDesc = 'USER_ADMIN_ROLES_STDDEV_POPULATION_ROLE_ID_DESC',
  UserAdminRolesStddevPopulationUserIdAsc = 'USER_ADMIN_ROLES_STDDEV_POPULATION_USER_ID_ASC',
  UserAdminRolesStddevPopulationUserIdDesc = 'USER_ADMIN_ROLES_STDDEV_POPULATION_USER_ID_DESC',
  UserAdminRolesStddevSampleRoleIdAsc = 'USER_ADMIN_ROLES_STDDEV_SAMPLE_ROLE_ID_ASC',
  UserAdminRolesStddevSampleRoleIdDesc = 'USER_ADMIN_ROLES_STDDEV_SAMPLE_ROLE_ID_DESC',
  UserAdminRolesStddevSampleUserIdAsc = 'USER_ADMIN_ROLES_STDDEV_SAMPLE_USER_ID_ASC',
  UserAdminRolesStddevSampleUserIdDesc = 'USER_ADMIN_ROLES_STDDEV_SAMPLE_USER_ID_DESC',
  UserAdminRolesSumRoleIdAsc = 'USER_ADMIN_ROLES_SUM_ROLE_ID_ASC',
  UserAdminRolesSumRoleIdDesc = 'USER_ADMIN_ROLES_SUM_ROLE_ID_DESC',
  UserAdminRolesSumUserIdAsc = 'USER_ADMIN_ROLES_SUM_USER_ID_ASC',
  UserAdminRolesSumUserIdDesc = 'USER_ADMIN_ROLES_SUM_USER_ID_DESC',
  UserAdminRolesVariancePopulationRoleIdAsc = 'USER_ADMIN_ROLES_VARIANCE_POPULATION_ROLE_ID_ASC',
  UserAdminRolesVariancePopulationRoleIdDesc = 'USER_ADMIN_ROLES_VARIANCE_POPULATION_ROLE_ID_DESC',
  UserAdminRolesVariancePopulationUserIdAsc = 'USER_ADMIN_ROLES_VARIANCE_POPULATION_USER_ID_ASC',
  UserAdminRolesVariancePopulationUserIdDesc = 'USER_ADMIN_ROLES_VARIANCE_POPULATION_USER_ID_DESC',
  UserAdminRolesVarianceSampleRoleIdAsc = 'USER_ADMIN_ROLES_VARIANCE_SAMPLE_ROLE_ID_ASC',
  UserAdminRolesVarianceSampleRoleIdDesc = 'USER_ADMIN_ROLES_VARIANCE_SAMPLE_ROLE_ID_DESC',
  UserAdminRolesVarianceSampleUserIdAsc = 'USER_ADMIN_ROLES_VARIANCE_SAMPLE_USER_ID_ASC',
  UserAdminRolesVarianceSampleUserIdDesc = 'USER_ADMIN_ROLES_VARIANCE_SAMPLE_USER_ID_DESC',
  UserAgreementsAverageRowIdAsc = 'USER_AGREEMENTS_AVERAGE_ROW_ID_ASC',
  UserAgreementsAverageRowIdDesc = 'USER_AGREEMENTS_AVERAGE_ROW_ID_DESC',
  UserAgreementsAverageUserIdAsc = 'USER_AGREEMENTS_AVERAGE_USER_ID_ASC',
  UserAgreementsAverageUserIdDesc = 'USER_AGREEMENTS_AVERAGE_USER_ID_DESC',
  UserAgreementsCountAsc = 'USER_AGREEMENTS_COUNT_ASC',
  UserAgreementsCountDesc = 'USER_AGREEMENTS_COUNT_DESC',
  UserAgreementsDistinctCountAgreementNameAsc = 'USER_AGREEMENTS_DISTINCT_COUNT_AGREEMENT_NAME_ASC',
  UserAgreementsDistinctCountAgreementNameDesc = 'USER_AGREEMENTS_DISTINCT_COUNT_AGREEMENT_NAME_DESC',
  UserAgreementsDistinctCountDeletedAtAsc = 'USER_AGREEMENTS_DISTINCT_COUNT_DELETED_AT_ASC',
  UserAgreementsDistinctCountDeletedAtDesc = 'USER_AGREEMENTS_DISTINCT_COUNT_DELETED_AT_DESC',
  UserAgreementsDistinctCountRowIdAsc = 'USER_AGREEMENTS_DISTINCT_COUNT_ROW_ID_ASC',
  UserAgreementsDistinctCountRowIdDesc = 'USER_AGREEMENTS_DISTINCT_COUNT_ROW_ID_DESC',
  UserAgreementsDistinctCountUserIdAsc = 'USER_AGREEMENTS_DISTINCT_COUNT_USER_ID_ASC',
  UserAgreementsDistinctCountUserIdDesc = 'USER_AGREEMENTS_DISTINCT_COUNT_USER_ID_DESC',
  UserAgreementsMaxRowIdAsc = 'USER_AGREEMENTS_MAX_ROW_ID_ASC',
  UserAgreementsMaxRowIdDesc = 'USER_AGREEMENTS_MAX_ROW_ID_DESC',
  UserAgreementsMaxUserIdAsc = 'USER_AGREEMENTS_MAX_USER_ID_ASC',
  UserAgreementsMaxUserIdDesc = 'USER_AGREEMENTS_MAX_USER_ID_DESC',
  UserAgreementsMinRowIdAsc = 'USER_AGREEMENTS_MIN_ROW_ID_ASC',
  UserAgreementsMinRowIdDesc = 'USER_AGREEMENTS_MIN_ROW_ID_DESC',
  UserAgreementsMinUserIdAsc = 'USER_AGREEMENTS_MIN_USER_ID_ASC',
  UserAgreementsMinUserIdDesc = 'USER_AGREEMENTS_MIN_USER_ID_DESC',
  UserAgreementsStddevPopulationRowIdAsc = 'USER_AGREEMENTS_STDDEV_POPULATION_ROW_ID_ASC',
  UserAgreementsStddevPopulationRowIdDesc = 'USER_AGREEMENTS_STDDEV_POPULATION_ROW_ID_DESC',
  UserAgreementsStddevPopulationUserIdAsc = 'USER_AGREEMENTS_STDDEV_POPULATION_USER_ID_ASC',
  UserAgreementsStddevPopulationUserIdDesc = 'USER_AGREEMENTS_STDDEV_POPULATION_USER_ID_DESC',
  UserAgreementsStddevSampleRowIdAsc = 'USER_AGREEMENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  UserAgreementsStddevSampleRowIdDesc = 'USER_AGREEMENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  UserAgreementsStddevSampleUserIdAsc = 'USER_AGREEMENTS_STDDEV_SAMPLE_USER_ID_ASC',
  UserAgreementsStddevSampleUserIdDesc = 'USER_AGREEMENTS_STDDEV_SAMPLE_USER_ID_DESC',
  UserAgreementsSumRowIdAsc = 'USER_AGREEMENTS_SUM_ROW_ID_ASC',
  UserAgreementsSumRowIdDesc = 'USER_AGREEMENTS_SUM_ROW_ID_DESC',
  UserAgreementsSumUserIdAsc = 'USER_AGREEMENTS_SUM_USER_ID_ASC',
  UserAgreementsSumUserIdDesc = 'USER_AGREEMENTS_SUM_USER_ID_DESC',
  UserAgreementsVariancePopulationRowIdAsc = 'USER_AGREEMENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  UserAgreementsVariancePopulationRowIdDesc = 'USER_AGREEMENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  UserAgreementsVariancePopulationUserIdAsc = 'USER_AGREEMENTS_VARIANCE_POPULATION_USER_ID_ASC',
  UserAgreementsVariancePopulationUserIdDesc = 'USER_AGREEMENTS_VARIANCE_POPULATION_USER_ID_DESC',
  UserAgreementsVarianceSampleRowIdAsc = 'USER_AGREEMENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserAgreementsVarianceSampleRowIdDesc = 'USER_AGREEMENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserAgreementsVarianceSampleUserIdAsc = 'USER_AGREEMENTS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserAgreementsVarianceSampleUserIdDesc = 'USER_AGREEMENTS_VARIANCE_SAMPLE_USER_ID_DESC',
  UserCertificatesAverageRowIdAsc = 'USER_CERTIFICATES_AVERAGE_ROW_ID_ASC',
  UserCertificatesAverageRowIdDesc = 'USER_CERTIFICATES_AVERAGE_ROW_ID_DESC',
  UserCertificatesAverageUserIdAsc = 'USER_CERTIFICATES_AVERAGE_USER_ID_ASC',
  UserCertificatesAverageUserIdDesc = 'USER_CERTIFICATES_AVERAGE_USER_ID_DESC',
  UserCertificatesCountAsc = 'USER_CERTIFICATES_COUNT_ASC',
  UserCertificatesCountDesc = 'USER_CERTIFICATES_COUNT_DESC',
  UserCertificatesDistinctCountCreatedAtAsc = 'USER_CERTIFICATES_DISTINCT_COUNT_CREATED_AT_ASC',
  UserCertificatesDistinctCountCreatedAtDesc = 'USER_CERTIFICATES_DISTINCT_COUNT_CREATED_AT_DESC',
  UserCertificatesDistinctCountRowIdAsc = 'USER_CERTIFICATES_DISTINCT_COUNT_ROW_ID_ASC',
  UserCertificatesDistinctCountRowIdDesc = 'USER_CERTIFICATES_DISTINCT_COUNT_ROW_ID_DESC',
  UserCertificatesDistinctCountStatusAsc = 'USER_CERTIFICATES_DISTINCT_COUNT_STATUS_ASC',
  UserCertificatesDistinctCountStatusDesc = 'USER_CERTIFICATES_DISTINCT_COUNT_STATUS_DESC',
  UserCertificatesDistinctCountUserIdAsc = 'USER_CERTIFICATES_DISTINCT_COUNT_USER_ID_ASC',
  UserCertificatesDistinctCountUserIdDesc = 'USER_CERTIFICATES_DISTINCT_COUNT_USER_ID_DESC',
  UserCertificatesMaxRowIdAsc = 'USER_CERTIFICATES_MAX_ROW_ID_ASC',
  UserCertificatesMaxRowIdDesc = 'USER_CERTIFICATES_MAX_ROW_ID_DESC',
  UserCertificatesMaxUserIdAsc = 'USER_CERTIFICATES_MAX_USER_ID_ASC',
  UserCertificatesMaxUserIdDesc = 'USER_CERTIFICATES_MAX_USER_ID_DESC',
  UserCertificatesMinRowIdAsc = 'USER_CERTIFICATES_MIN_ROW_ID_ASC',
  UserCertificatesMinRowIdDesc = 'USER_CERTIFICATES_MIN_ROW_ID_DESC',
  UserCertificatesMinUserIdAsc = 'USER_CERTIFICATES_MIN_USER_ID_ASC',
  UserCertificatesMinUserIdDesc = 'USER_CERTIFICATES_MIN_USER_ID_DESC',
  UserCertificatesStddevPopulationRowIdAsc = 'USER_CERTIFICATES_STDDEV_POPULATION_ROW_ID_ASC',
  UserCertificatesStddevPopulationRowIdDesc = 'USER_CERTIFICATES_STDDEV_POPULATION_ROW_ID_DESC',
  UserCertificatesStddevPopulationUserIdAsc = 'USER_CERTIFICATES_STDDEV_POPULATION_USER_ID_ASC',
  UserCertificatesStddevPopulationUserIdDesc = 'USER_CERTIFICATES_STDDEV_POPULATION_USER_ID_DESC',
  UserCertificatesStddevSampleRowIdAsc = 'USER_CERTIFICATES_STDDEV_SAMPLE_ROW_ID_ASC',
  UserCertificatesStddevSampleRowIdDesc = 'USER_CERTIFICATES_STDDEV_SAMPLE_ROW_ID_DESC',
  UserCertificatesStddevSampleUserIdAsc = 'USER_CERTIFICATES_STDDEV_SAMPLE_USER_ID_ASC',
  UserCertificatesStddevSampleUserIdDesc = 'USER_CERTIFICATES_STDDEV_SAMPLE_USER_ID_DESC',
  UserCertificatesSumRowIdAsc = 'USER_CERTIFICATES_SUM_ROW_ID_ASC',
  UserCertificatesSumRowIdDesc = 'USER_CERTIFICATES_SUM_ROW_ID_DESC',
  UserCertificatesSumUserIdAsc = 'USER_CERTIFICATES_SUM_USER_ID_ASC',
  UserCertificatesSumUserIdDesc = 'USER_CERTIFICATES_SUM_USER_ID_DESC',
  UserCertificatesVariancePopulationRowIdAsc = 'USER_CERTIFICATES_VARIANCE_POPULATION_ROW_ID_ASC',
  UserCertificatesVariancePopulationRowIdDesc = 'USER_CERTIFICATES_VARIANCE_POPULATION_ROW_ID_DESC',
  UserCertificatesVariancePopulationUserIdAsc = 'USER_CERTIFICATES_VARIANCE_POPULATION_USER_ID_ASC',
  UserCertificatesVariancePopulationUserIdDesc = 'USER_CERTIFICATES_VARIANCE_POPULATION_USER_ID_DESC',
  UserCertificatesVarianceSampleRowIdAsc = 'USER_CERTIFICATES_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserCertificatesVarianceSampleRowIdDesc = 'USER_CERTIFICATES_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserCertificatesVarianceSampleUserIdAsc = 'USER_CERTIFICATES_VARIANCE_SAMPLE_USER_ID_ASC',
  UserCertificatesVarianceSampleUserIdDesc = 'USER_CERTIFICATES_VARIANCE_SAMPLE_USER_ID_DESC',
  UserCooldownsAverageRowIdAsc = 'USER_COOLDOWNS_AVERAGE_ROW_ID_ASC',
  UserCooldownsAverageRowIdDesc = 'USER_COOLDOWNS_AVERAGE_ROW_ID_DESC',
  UserCooldownsAverageUserIdAsc = 'USER_COOLDOWNS_AVERAGE_USER_ID_ASC',
  UserCooldownsAverageUserIdDesc = 'USER_COOLDOWNS_AVERAGE_USER_ID_DESC',
  UserCooldownsCountAsc = 'USER_COOLDOWNS_COUNT_ASC',
  UserCooldownsCountDesc = 'USER_COOLDOWNS_COUNT_DESC',
  UserCooldownsDistinctCountEndsAtAsc = 'USER_COOLDOWNS_DISTINCT_COUNT_ENDS_AT_ASC',
  UserCooldownsDistinctCountEndsAtDesc = 'USER_COOLDOWNS_DISTINCT_COUNT_ENDS_AT_DESC',
  UserCooldownsDistinctCountRowIdAsc = 'USER_COOLDOWNS_DISTINCT_COUNT_ROW_ID_ASC',
  UserCooldownsDistinctCountRowIdDesc = 'USER_COOLDOWNS_DISTINCT_COUNT_ROW_ID_DESC',
  UserCooldownsDistinctCountSourceIdAsc = 'USER_COOLDOWNS_DISTINCT_COUNT_SOURCE_ID_ASC',
  UserCooldownsDistinctCountSourceIdDesc = 'USER_COOLDOWNS_DISTINCT_COUNT_SOURCE_ID_DESC',
  UserCooldownsDistinctCountSourceTypeAsc = 'USER_COOLDOWNS_DISTINCT_COUNT_SOURCE_TYPE_ASC',
  UserCooldownsDistinctCountSourceTypeDesc = 'USER_COOLDOWNS_DISTINCT_COUNT_SOURCE_TYPE_DESC',
  UserCooldownsDistinctCountUserIdAsc = 'USER_COOLDOWNS_DISTINCT_COUNT_USER_ID_ASC',
  UserCooldownsDistinctCountUserIdDesc = 'USER_COOLDOWNS_DISTINCT_COUNT_USER_ID_DESC',
  UserCooldownsMaxRowIdAsc = 'USER_COOLDOWNS_MAX_ROW_ID_ASC',
  UserCooldownsMaxRowIdDesc = 'USER_COOLDOWNS_MAX_ROW_ID_DESC',
  UserCooldownsMaxUserIdAsc = 'USER_COOLDOWNS_MAX_USER_ID_ASC',
  UserCooldownsMaxUserIdDesc = 'USER_COOLDOWNS_MAX_USER_ID_DESC',
  UserCooldownsMinRowIdAsc = 'USER_COOLDOWNS_MIN_ROW_ID_ASC',
  UserCooldownsMinRowIdDesc = 'USER_COOLDOWNS_MIN_ROW_ID_DESC',
  UserCooldownsMinUserIdAsc = 'USER_COOLDOWNS_MIN_USER_ID_ASC',
  UserCooldownsMinUserIdDesc = 'USER_COOLDOWNS_MIN_USER_ID_DESC',
  UserCooldownsStddevPopulationRowIdAsc = 'USER_COOLDOWNS_STDDEV_POPULATION_ROW_ID_ASC',
  UserCooldownsStddevPopulationRowIdDesc = 'USER_COOLDOWNS_STDDEV_POPULATION_ROW_ID_DESC',
  UserCooldownsStddevPopulationUserIdAsc = 'USER_COOLDOWNS_STDDEV_POPULATION_USER_ID_ASC',
  UserCooldownsStddevPopulationUserIdDesc = 'USER_COOLDOWNS_STDDEV_POPULATION_USER_ID_DESC',
  UserCooldownsStddevSampleRowIdAsc = 'USER_COOLDOWNS_STDDEV_SAMPLE_ROW_ID_ASC',
  UserCooldownsStddevSampleRowIdDesc = 'USER_COOLDOWNS_STDDEV_SAMPLE_ROW_ID_DESC',
  UserCooldownsStddevSampleUserIdAsc = 'USER_COOLDOWNS_STDDEV_SAMPLE_USER_ID_ASC',
  UserCooldownsStddevSampleUserIdDesc = 'USER_COOLDOWNS_STDDEV_SAMPLE_USER_ID_DESC',
  UserCooldownsSumRowIdAsc = 'USER_COOLDOWNS_SUM_ROW_ID_ASC',
  UserCooldownsSumRowIdDesc = 'USER_COOLDOWNS_SUM_ROW_ID_DESC',
  UserCooldownsSumUserIdAsc = 'USER_COOLDOWNS_SUM_USER_ID_ASC',
  UserCooldownsSumUserIdDesc = 'USER_COOLDOWNS_SUM_USER_ID_DESC',
  UserCooldownsVariancePopulationRowIdAsc = 'USER_COOLDOWNS_VARIANCE_POPULATION_ROW_ID_ASC',
  UserCooldownsVariancePopulationRowIdDesc = 'USER_COOLDOWNS_VARIANCE_POPULATION_ROW_ID_DESC',
  UserCooldownsVariancePopulationUserIdAsc = 'USER_COOLDOWNS_VARIANCE_POPULATION_USER_ID_ASC',
  UserCooldownsVariancePopulationUserIdDesc = 'USER_COOLDOWNS_VARIANCE_POPULATION_USER_ID_DESC',
  UserCooldownsVarianceSampleRowIdAsc = 'USER_COOLDOWNS_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserCooldownsVarianceSampleRowIdDesc = 'USER_COOLDOWNS_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserCooldownsVarianceSampleUserIdAsc = 'USER_COOLDOWNS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserCooldownsVarianceSampleUserIdDesc = 'USER_COOLDOWNS_VARIANCE_SAMPLE_USER_ID_DESC',
  UserMeteredEventsAverageRowIdAsc = 'USER_METERED_EVENTS_AVERAGE_ROW_ID_ASC',
  UserMeteredEventsAverageRowIdDesc = 'USER_METERED_EVENTS_AVERAGE_ROW_ID_DESC',
  UserMeteredEventsAverageUserIdAsc = 'USER_METERED_EVENTS_AVERAGE_USER_ID_ASC',
  UserMeteredEventsAverageUserIdDesc = 'USER_METERED_EVENTS_AVERAGE_USER_ID_DESC',
  UserMeteredEventsCountAsc = 'USER_METERED_EVENTS_COUNT_ASC',
  UserMeteredEventsCountDesc = 'USER_METERED_EVENTS_COUNT_DESC',
  UserMeteredEventsDistinctCountCreatedAtAsc = 'USER_METERED_EVENTS_DISTINCT_COUNT_CREATED_AT_ASC',
  UserMeteredEventsDistinctCountCreatedAtDesc = 'USER_METERED_EVENTS_DISTINCT_COUNT_CREATED_AT_DESC',
  UserMeteredEventsDistinctCountEventTypeAsc = 'USER_METERED_EVENTS_DISTINCT_COUNT_EVENT_TYPE_ASC',
  UserMeteredEventsDistinctCountEventTypeDesc = 'USER_METERED_EVENTS_DISTINCT_COUNT_EVENT_TYPE_DESC',
  UserMeteredEventsDistinctCountRowIdAsc = 'USER_METERED_EVENTS_DISTINCT_COUNT_ROW_ID_ASC',
  UserMeteredEventsDistinctCountRowIdDesc = 'USER_METERED_EVENTS_DISTINCT_COUNT_ROW_ID_DESC',
  UserMeteredEventsDistinctCountUserIdAsc = 'USER_METERED_EVENTS_DISTINCT_COUNT_USER_ID_ASC',
  UserMeteredEventsDistinctCountUserIdDesc = 'USER_METERED_EVENTS_DISTINCT_COUNT_USER_ID_DESC',
  UserMeteredEventsMaxRowIdAsc = 'USER_METERED_EVENTS_MAX_ROW_ID_ASC',
  UserMeteredEventsMaxRowIdDesc = 'USER_METERED_EVENTS_MAX_ROW_ID_DESC',
  UserMeteredEventsMaxUserIdAsc = 'USER_METERED_EVENTS_MAX_USER_ID_ASC',
  UserMeteredEventsMaxUserIdDesc = 'USER_METERED_EVENTS_MAX_USER_ID_DESC',
  UserMeteredEventsMinRowIdAsc = 'USER_METERED_EVENTS_MIN_ROW_ID_ASC',
  UserMeteredEventsMinRowIdDesc = 'USER_METERED_EVENTS_MIN_ROW_ID_DESC',
  UserMeteredEventsMinUserIdAsc = 'USER_METERED_EVENTS_MIN_USER_ID_ASC',
  UserMeteredEventsMinUserIdDesc = 'USER_METERED_EVENTS_MIN_USER_ID_DESC',
  UserMeteredEventsStddevPopulationRowIdAsc = 'USER_METERED_EVENTS_STDDEV_POPULATION_ROW_ID_ASC',
  UserMeteredEventsStddevPopulationRowIdDesc = 'USER_METERED_EVENTS_STDDEV_POPULATION_ROW_ID_DESC',
  UserMeteredEventsStddevPopulationUserIdAsc = 'USER_METERED_EVENTS_STDDEV_POPULATION_USER_ID_ASC',
  UserMeteredEventsStddevPopulationUserIdDesc = 'USER_METERED_EVENTS_STDDEV_POPULATION_USER_ID_DESC',
  UserMeteredEventsStddevSampleRowIdAsc = 'USER_METERED_EVENTS_STDDEV_SAMPLE_ROW_ID_ASC',
  UserMeteredEventsStddevSampleRowIdDesc = 'USER_METERED_EVENTS_STDDEV_SAMPLE_ROW_ID_DESC',
  UserMeteredEventsStddevSampleUserIdAsc = 'USER_METERED_EVENTS_STDDEV_SAMPLE_USER_ID_ASC',
  UserMeteredEventsStddevSampleUserIdDesc = 'USER_METERED_EVENTS_STDDEV_SAMPLE_USER_ID_DESC',
  UserMeteredEventsSumRowIdAsc = 'USER_METERED_EVENTS_SUM_ROW_ID_ASC',
  UserMeteredEventsSumRowIdDesc = 'USER_METERED_EVENTS_SUM_ROW_ID_DESC',
  UserMeteredEventsSumUserIdAsc = 'USER_METERED_EVENTS_SUM_USER_ID_ASC',
  UserMeteredEventsSumUserIdDesc = 'USER_METERED_EVENTS_SUM_USER_ID_DESC',
  UserMeteredEventsVariancePopulationRowIdAsc = 'USER_METERED_EVENTS_VARIANCE_POPULATION_ROW_ID_ASC',
  UserMeteredEventsVariancePopulationRowIdDesc = 'USER_METERED_EVENTS_VARIANCE_POPULATION_ROW_ID_DESC',
  UserMeteredEventsVariancePopulationUserIdAsc = 'USER_METERED_EVENTS_VARIANCE_POPULATION_USER_ID_ASC',
  UserMeteredEventsVariancePopulationUserIdDesc = 'USER_METERED_EVENTS_VARIANCE_POPULATION_USER_ID_DESC',
  UserMeteredEventsVarianceSampleRowIdAsc = 'USER_METERED_EVENTS_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserMeteredEventsVarianceSampleRowIdDesc = 'USER_METERED_EVENTS_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserMeteredEventsVarianceSampleUserIdAsc = 'USER_METERED_EVENTS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserMeteredEventsVarianceSampleUserIdDesc = 'USER_METERED_EVENTS_VARIANCE_SAMPLE_USER_ID_DESC',
  UserNotesAverageIssuedByAsc = 'USER_NOTES_AVERAGE_ISSUED_BY_ASC',
  UserNotesAverageIssuedByDesc = 'USER_NOTES_AVERAGE_ISSUED_BY_DESC',
  UserNotesAverageRowIdAsc = 'USER_NOTES_AVERAGE_ROW_ID_ASC',
  UserNotesAverageRowIdDesc = 'USER_NOTES_AVERAGE_ROW_ID_DESC',
  UserNotesAverageUserIdAsc = 'USER_NOTES_AVERAGE_USER_ID_ASC',
  UserNotesAverageUserIdDesc = 'USER_NOTES_AVERAGE_USER_ID_DESC',
  UserNotesCountAsc = 'USER_NOTES_COUNT_ASC',
  UserNotesCountDesc = 'USER_NOTES_COUNT_DESC',
  UserNotesDistinctCountIssuedByAsc = 'USER_NOTES_DISTINCT_COUNT_ISSUED_BY_ASC',
  UserNotesDistinctCountIssuedByDesc = 'USER_NOTES_DISTINCT_COUNT_ISSUED_BY_DESC',
  UserNotesDistinctCountRowIdAsc = 'USER_NOTES_DISTINCT_COUNT_ROW_ID_ASC',
  UserNotesDistinctCountRowIdDesc = 'USER_NOTES_DISTINCT_COUNT_ROW_ID_DESC',
  UserNotesDistinctCountUserIdAsc = 'USER_NOTES_DISTINCT_COUNT_USER_ID_ASC',
  UserNotesDistinctCountUserIdDesc = 'USER_NOTES_DISTINCT_COUNT_USER_ID_DESC',
  UserNotesIssuedAverageIssuedByAsc = 'USER_NOTES_ISSUED_AVERAGE_ISSUED_BY_ASC',
  UserNotesIssuedAverageIssuedByDesc = 'USER_NOTES_ISSUED_AVERAGE_ISSUED_BY_DESC',
  UserNotesIssuedAverageRowIdAsc = 'USER_NOTES_ISSUED_AVERAGE_ROW_ID_ASC',
  UserNotesIssuedAverageRowIdDesc = 'USER_NOTES_ISSUED_AVERAGE_ROW_ID_DESC',
  UserNotesIssuedAverageUserIdAsc = 'USER_NOTES_ISSUED_AVERAGE_USER_ID_ASC',
  UserNotesIssuedAverageUserIdDesc = 'USER_NOTES_ISSUED_AVERAGE_USER_ID_DESC',
  UserNotesIssuedCountAsc = 'USER_NOTES_ISSUED_COUNT_ASC',
  UserNotesIssuedCountDesc = 'USER_NOTES_ISSUED_COUNT_DESC',
  UserNotesIssuedDistinctCountIssuedByAsc = 'USER_NOTES_ISSUED_DISTINCT_COUNT_ISSUED_BY_ASC',
  UserNotesIssuedDistinctCountIssuedByDesc = 'USER_NOTES_ISSUED_DISTINCT_COUNT_ISSUED_BY_DESC',
  UserNotesIssuedDistinctCountRowIdAsc = 'USER_NOTES_ISSUED_DISTINCT_COUNT_ROW_ID_ASC',
  UserNotesIssuedDistinctCountRowIdDesc = 'USER_NOTES_ISSUED_DISTINCT_COUNT_ROW_ID_DESC',
  UserNotesIssuedDistinctCountUserIdAsc = 'USER_NOTES_ISSUED_DISTINCT_COUNT_USER_ID_ASC',
  UserNotesIssuedDistinctCountUserIdDesc = 'USER_NOTES_ISSUED_DISTINCT_COUNT_USER_ID_DESC',
  UserNotesIssuedMaxIssuedByAsc = 'USER_NOTES_ISSUED_MAX_ISSUED_BY_ASC',
  UserNotesIssuedMaxIssuedByDesc = 'USER_NOTES_ISSUED_MAX_ISSUED_BY_DESC',
  UserNotesIssuedMaxRowIdAsc = 'USER_NOTES_ISSUED_MAX_ROW_ID_ASC',
  UserNotesIssuedMaxRowIdDesc = 'USER_NOTES_ISSUED_MAX_ROW_ID_DESC',
  UserNotesIssuedMaxUserIdAsc = 'USER_NOTES_ISSUED_MAX_USER_ID_ASC',
  UserNotesIssuedMaxUserIdDesc = 'USER_NOTES_ISSUED_MAX_USER_ID_DESC',
  UserNotesIssuedMinIssuedByAsc = 'USER_NOTES_ISSUED_MIN_ISSUED_BY_ASC',
  UserNotesIssuedMinIssuedByDesc = 'USER_NOTES_ISSUED_MIN_ISSUED_BY_DESC',
  UserNotesIssuedMinRowIdAsc = 'USER_NOTES_ISSUED_MIN_ROW_ID_ASC',
  UserNotesIssuedMinRowIdDesc = 'USER_NOTES_ISSUED_MIN_ROW_ID_DESC',
  UserNotesIssuedMinUserIdAsc = 'USER_NOTES_ISSUED_MIN_USER_ID_ASC',
  UserNotesIssuedMinUserIdDesc = 'USER_NOTES_ISSUED_MIN_USER_ID_DESC',
  UserNotesIssuedStddevPopulationIssuedByAsc = 'USER_NOTES_ISSUED_STDDEV_POPULATION_ISSUED_BY_ASC',
  UserNotesIssuedStddevPopulationIssuedByDesc = 'USER_NOTES_ISSUED_STDDEV_POPULATION_ISSUED_BY_DESC',
  UserNotesIssuedStddevPopulationRowIdAsc = 'USER_NOTES_ISSUED_STDDEV_POPULATION_ROW_ID_ASC',
  UserNotesIssuedStddevPopulationRowIdDesc = 'USER_NOTES_ISSUED_STDDEV_POPULATION_ROW_ID_DESC',
  UserNotesIssuedStddevPopulationUserIdAsc = 'USER_NOTES_ISSUED_STDDEV_POPULATION_USER_ID_ASC',
  UserNotesIssuedStddevPopulationUserIdDesc = 'USER_NOTES_ISSUED_STDDEV_POPULATION_USER_ID_DESC',
  UserNotesIssuedStddevSampleIssuedByAsc = 'USER_NOTES_ISSUED_STDDEV_SAMPLE_ISSUED_BY_ASC',
  UserNotesIssuedStddevSampleIssuedByDesc = 'USER_NOTES_ISSUED_STDDEV_SAMPLE_ISSUED_BY_DESC',
  UserNotesIssuedStddevSampleRowIdAsc = 'USER_NOTES_ISSUED_STDDEV_SAMPLE_ROW_ID_ASC',
  UserNotesIssuedStddevSampleRowIdDesc = 'USER_NOTES_ISSUED_STDDEV_SAMPLE_ROW_ID_DESC',
  UserNotesIssuedStddevSampleUserIdAsc = 'USER_NOTES_ISSUED_STDDEV_SAMPLE_USER_ID_ASC',
  UserNotesIssuedStddevSampleUserIdDesc = 'USER_NOTES_ISSUED_STDDEV_SAMPLE_USER_ID_DESC',
  UserNotesIssuedSumIssuedByAsc = 'USER_NOTES_ISSUED_SUM_ISSUED_BY_ASC',
  UserNotesIssuedSumIssuedByDesc = 'USER_NOTES_ISSUED_SUM_ISSUED_BY_DESC',
  UserNotesIssuedSumRowIdAsc = 'USER_NOTES_ISSUED_SUM_ROW_ID_ASC',
  UserNotesIssuedSumRowIdDesc = 'USER_NOTES_ISSUED_SUM_ROW_ID_DESC',
  UserNotesIssuedSumUserIdAsc = 'USER_NOTES_ISSUED_SUM_USER_ID_ASC',
  UserNotesIssuedSumUserIdDesc = 'USER_NOTES_ISSUED_SUM_USER_ID_DESC',
  UserNotesIssuedVariancePopulationIssuedByAsc = 'USER_NOTES_ISSUED_VARIANCE_POPULATION_ISSUED_BY_ASC',
  UserNotesIssuedVariancePopulationIssuedByDesc = 'USER_NOTES_ISSUED_VARIANCE_POPULATION_ISSUED_BY_DESC',
  UserNotesIssuedVariancePopulationRowIdAsc = 'USER_NOTES_ISSUED_VARIANCE_POPULATION_ROW_ID_ASC',
  UserNotesIssuedVariancePopulationRowIdDesc = 'USER_NOTES_ISSUED_VARIANCE_POPULATION_ROW_ID_DESC',
  UserNotesIssuedVariancePopulationUserIdAsc = 'USER_NOTES_ISSUED_VARIANCE_POPULATION_USER_ID_ASC',
  UserNotesIssuedVariancePopulationUserIdDesc = 'USER_NOTES_ISSUED_VARIANCE_POPULATION_USER_ID_DESC',
  UserNotesIssuedVarianceSampleIssuedByAsc = 'USER_NOTES_ISSUED_VARIANCE_SAMPLE_ISSUED_BY_ASC',
  UserNotesIssuedVarianceSampleIssuedByDesc = 'USER_NOTES_ISSUED_VARIANCE_SAMPLE_ISSUED_BY_DESC',
  UserNotesIssuedVarianceSampleRowIdAsc = 'USER_NOTES_ISSUED_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserNotesIssuedVarianceSampleRowIdDesc = 'USER_NOTES_ISSUED_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserNotesIssuedVarianceSampleUserIdAsc = 'USER_NOTES_ISSUED_VARIANCE_SAMPLE_USER_ID_ASC',
  UserNotesIssuedVarianceSampleUserIdDesc = 'USER_NOTES_ISSUED_VARIANCE_SAMPLE_USER_ID_DESC',
  UserNotesMaxIssuedByAsc = 'USER_NOTES_MAX_ISSUED_BY_ASC',
  UserNotesMaxIssuedByDesc = 'USER_NOTES_MAX_ISSUED_BY_DESC',
  UserNotesMaxRowIdAsc = 'USER_NOTES_MAX_ROW_ID_ASC',
  UserNotesMaxRowIdDesc = 'USER_NOTES_MAX_ROW_ID_DESC',
  UserNotesMaxUserIdAsc = 'USER_NOTES_MAX_USER_ID_ASC',
  UserNotesMaxUserIdDesc = 'USER_NOTES_MAX_USER_ID_DESC',
  UserNotesMinIssuedByAsc = 'USER_NOTES_MIN_ISSUED_BY_ASC',
  UserNotesMinIssuedByDesc = 'USER_NOTES_MIN_ISSUED_BY_DESC',
  UserNotesMinRowIdAsc = 'USER_NOTES_MIN_ROW_ID_ASC',
  UserNotesMinRowIdDesc = 'USER_NOTES_MIN_ROW_ID_DESC',
  UserNotesMinUserIdAsc = 'USER_NOTES_MIN_USER_ID_ASC',
  UserNotesMinUserIdDesc = 'USER_NOTES_MIN_USER_ID_DESC',
  UserNotesStddevPopulationIssuedByAsc = 'USER_NOTES_STDDEV_POPULATION_ISSUED_BY_ASC',
  UserNotesStddevPopulationIssuedByDesc = 'USER_NOTES_STDDEV_POPULATION_ISSUED_BY_DESC',
  UserNotesStddevPopulationRowIdAsc = 'USER_NOTES_STDDEV_POPULATION_ROW_ID_ASC',
  UserNotesStddevPopulationRowIdDesc = 'USER_NOTES_STDDEV_POPULATION_ROW_ID_DESC',
  UserNotesStddevPopulationUserIdAsc = 'USER_NOTES_STDDEV_POPULATION_USER_ID_ASC',
  UserNotesStddevPopulationUserIdDesc = 'USER_NOTES_STDDEV_POPULATION_USER_ID_DESC',
  UserNotesStddevSampleIssuedByAsc = 'USER_NOTES_STDDEV_SAMPLE_ISSUED_BY_ASC',
  UserNotesStddevSampleIssuedByDesc = 'USER_NOTES_STDDEV_SAMPLE_ISSUED_BY_DESC',
  UserNotesStddevSampleRowIdAsc = 'USER_NOTES_STDDEV_SAMPLE_ROW_ID_ASC',
  UserNotesStddevSampleRowIdDesc = 'USER_NOTES_STDDEV_SAMPLE_ROW_ID_DESC',
  UserNotesStddevSampleUserIdAsc = 'USER_NOTES_STDDEV_SAMPLE_USER_ID_ASC',
  UserNotesStddevSampleUserIdDesc = 'USER_NOTES_STDDEV_SAMPLE_USER_ID_DESC',
  UserNotesSumIssuedByAsc = 'USER_NOTES_SUM_ISSUED_BY_ASC',
  UserNotesSumIssuedByDesc = 'USER_NOTES_SUM_ISSUED_BY_DESC',
  UserNotesSumRowIdAsc = 'USER_NOTES_SUM_ROW_ID_ASC',
  UserNotesSumRowIdDesc = 'USER_NOTES_SUM_ROW_ID_DESC',
  UserNotesSumUserIdAsc = 'USER_NOTES_SUM_USER_ID_ASC',
  UserNotesSumUserIdDesc = 'USER_NOTES_SUM_USER_ID_DESC',
  UserNotesVariancePopulationIssuedByAsc = 'USER_NOTES_VARIANCE_POPULATION_ISSUED_BY_ASC',
  UserNotesVariancePopulationIssuedByDesc = 'USER_NOTES_VARIANCE_POPULATION_ISSUED_BY_DESC',
  UserNotesVariancePopulationRowIdAsc = 'USER_NOTES_VARIANCE_POPULATION_ROW_ID_ASC',
  UserNotesVariancePopulationRowIdDesc = 'USER_NOTES_VARIANCE_POPULATION_ROW_ID_DESC',
  UserNotesVariancePopulationUserIdAsc = 'USER_NOTES_VARIANCE_POPULATION_USER_ID_ASC',
  UserNotesVariancePopulationUserIdDesc = 'USER_NOTES_VARIANCE_POPULATION_USER_ID_DESC',
  UserNotesVarianceSampleIssuedByAsc = 'USER_NOTES_VARIANCE_SAMPLE_ISSUED_BY_ASC',
  UserNotesVarianceSampleIssuedByDesc = 'USER_NOTES_VARIANCE_SAMPLE_ISSUED_BY_DESC',
  UserNotesVarianceSampleRowIdAsc = 'USER_NOTES_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserNotesVarianceSampleRowIdDesc = 'USER_NOTES_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserNotesVarianceSampleUserIdAsc = 'USER_NOTES_VARIANCE_SAMPLE_USER_ID_ASC',
  UserNotesVarianceSampleUserIdDesc = 'USER_NOTES_VARIANCE_SAMPLE_USER_ID_DESC',
  UserPlatformCredentialsAveragePlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_AVERAGE_PLATFORM_ID_ASC',
  UserPlatformCredentialsAveragePlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_AVERAGE_PLATFORM_ID_DESC',
  UserPlatformCredentialsAverageUserIdAsc = 'USER_PLATFORM_CREDENTIALS_AVERAGE_USER_ID_ASC',
  UserPlatformCredentialsAverageUserIdDesc = 'USER_PLATFORM_CREDENTIALS_AVERAGE_USER_ID_DESC',
  UserPlatformCredentialsCountAsc = 'USER_PLATFORM_CREDENTIALS_COUNT_ASC',
  UserPlatformCredentialsCountDesc = 'USER_PLATFORM_CREDENTIALS_COUNT_DESC',
  UserPlatformCredentialsDistinctCountPlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_DISTINCT_COUNT_PLATFORM_ID_ASC',
  UserPlatformCredentialsDistinctCountPlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_DISTINCT_COUNT_PLATFORM_ID_DESC',
  UserPlatformCredentialsDistinctCountUserIdAsc = 'USER_PLATFORM_CREDENTIALS_DISTINCT_COUNT_USER_ID_ASC',
  UserPlatformCredentialsDistinctCountUserIdDesc = 'USER_PLATFORM_CREDENTIALS_DISTINCT_COUNT_USER_ID_DESC',
  UserPlatformCredentialsMaxPlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_MAX_PLATFORM_ID_ASC',
  UserPlatformCredentialsMaxPlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_MAX_PLATFORM_ID_DESC',
  UserPlatformCredentialsMaxUserIdAsc = 'USER_PLATFORM_CREDENTIALS_MAX_USER_ID_ASC',
  UserPlatformCredentialsMaxUserIdDesc = 'USER_PLATFORM_CREDENTIALS_MAX_USER_ID_DESC',
  UserPlatformCredentialsMinPlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_MIN_PLATFORM_ID_ASC',
  UserPlatformCredentialsMinPlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_MIN_PLATFORM_ID_DESC',
  UserPlatformCredentialsMinUserIdAsc = 'USER_PLATFORM_CREDENTIALS_MIN_USER_ID_ASC',
  UserPlatformCredentialsMinUserIdDesc = 'USER_PLATFORM_CREDENTIALS_MIN_USER_ID_DESC',
  UserPlatformCredentialsStddevPopulationPlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_STDDEV_POPULATION_PLATFORM_ID_ASC',
  UserPlatformCredentialsStddevPopulationPlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_STDDEV_POPULATION_PLATFORM_ID_DESC',
  UserPlatformCredentialsStddevPopulationUserIdAsc = 'USER_PLATFORM_CREDENTIALS_STDDEV_POPULATION_USER_ID_ASC',
  UserPlatformCredentialsStddevPopulationUserIdDesc = 'USER_PLATFORM_CREDENTIALS_STDDEV_POPULATION_USER_ID_DESC',
  UserPlatformCredentialsStddevSamplePlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_STDDEV_SAMPLE_PLATFORM_ID_ASC',
  UserPlatformCredentialsStddevSamplePlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_STDDEV_SAMPLE_PLATFORM_ID_DESC',
  UserPlatformCredentialsStddevSampleUserIdAsc = 'USER_PLATFORM_CREDENTIALS_STDDEV_SAMPLE_USER_ID_ASC',
  UserPlatformCredentialsStddevSampleUserIdDesc = 'USER_PLATFORM_CREDENTIALS_STDDEV_SAMPLE_USER_ID_DESC',
  UserPlatformCredentialsSumPlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_SUM_PLATFORM_ID_ASC',
  UserPlatformCredentialsSumPlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_SUM_PLATFORM_ID_DESC',
  UserPlatformCredentialsSumUserIdAsc = 'USER_PLATFORM_CREDENTIALS_SUM_USER_ID_ASC',
  UserPlatformCredentialsSumUserIdDesc = 'USER_PLATFORM_CREDENTIALS_SUM_USER_ID_DESC',
  UserPlatformCredentialsVariancePopulationPlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_POPULATION_PLATFORM_ID_ASC',
  UserPlatformCredentialsVariancePopulationPlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_POPULATION_PLATFORM_ID_DESC',
  UserPlatformCredentialsVariancePopulationUserIdAsc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_POPULATION_USER_ID_ASC',
  UserPlatformCredentialsVariancePopulationUserIdDesc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_POPULATION_USER_ID_DESC',
  UserPlatformCredentialsVarianceSamplePlatformIdAsc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_SAMPLE_PLATFORM_ID_ASC',
  UserPlatformCredentialsVarianceSamplePlatformIdDesc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_SAMPLE_PLATFORM_ID_DESC',
  UserPlatformCredentialsVarianceSampleUserIdAsc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserPlatformCredentialsVarianceSampleUserIdDesc = 'USER_PLATFORM_CREDENTIALS_VARIANCE_SAMPLE_USER_ID_DESC',
  UserRolesAdminRolesAverageAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesAverageAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesAverageUserIdAsc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_USER_ID_ASC',
  UserRolesAdminRolesAverageUserIdDesc = 'USER_ROLES_ADMIN_ROLES_AVERAGE_USER_ID_DESC',
  UserRolesAdminRolesCountAsc = 'USER_ROLES_ADMIN_ROLES_COUNT_ASC',
  UserRolesAdminRolesCountDesc = 'USER_ROLES_ADMIN_ROLES_COUNT_DESC',
  UserRolesAdminRolesDistinctCountAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesDistinctCountAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesDistinctCountUserIdAsc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_USER_ID_ASC',
  UserRolesAdminRolesDistinctCountUserIdDesc = 'USER_ROLES_ADMIN_ROLES_DISTINCT_COUNT_USER_ID_DESC',
  UserRolesAdminRolesMaxAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_MAX_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesMaxAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_MAX_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesMaxUserIdAsc = 'USER_ROLES_ADMIN_ROLES_MAX_USER_ID_ASC',
  UserRolesAdminRolesMaxUserIdDesc = 'USER_ROLES_ADMIN_ROLES_MAX_USER_ID_DESC',
  UserRolesAdminRolesMinAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_MIN_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesMinAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_MIN_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesMinUserIdAsc = 'USER_ROLES_ADMIN_ROLES_MIN_USER_ID_ASC',
  UserRolesAdminRolesMinUserIdDesc = 'USER_ROLES_ADMIN_ROLES_MIN_USER_ID_DESC',
  UserRolesAdminRolesStddevPopulationAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesStddevPopulationAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesStddevPopulationUserIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_USER_ID_ASC',
  UserRolesAdminRolesStddevPopulationUserIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_POPULATION_USER_ID_DESC',
  UserRolesAdminRolesStddevSampleAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesStddevSampleAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesStddevSampleUserIdAsc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_USER_ID_ASC',
  UserRolesAdminRolesStddevSampleUserIdDesc = 'USER_ROLES_ADMIN_ROLES_STDDEV_SAMPLE_USER_ID_DESC',
  UserRolesAdminRolesSumAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_SUM_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesSumAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_SUM_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesSumUserIdAsc = 'USER_ROLES_ADMIN_ROLES_SUM_USER_ID_ASC',
  UserRolesAdminRolesSumUserIdDesc = 'USER_ROLES_ADMIN_ROLES_SUM_USER_ID_DESC',
  UserRolesAdminRolesVariancePopulationAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesVariancePopulationAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesVariancePopulationUserIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_USER_ID_ASC',
  UserRolesAdminRolesVariancePopulationUserIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_POPULATION_USER_ID_DESC',
  UserRolesAdminRolesVarianceSampleAdminRoleIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_ADMIN_ROLE_ID_ASC',
  UserRolesAdminRolesVarianceSampleAdminRoleIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_ADMIN_ROLE_ID_DESC',
  UserRolesAdminRolesVarianceSampleUserIdAsc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_USER_ID_ASC',
  UserRolesAdminRolesVarianceSampleUserIdDesc = 'USER_ROLES_ADMIN_ROLES_VARIANCE_SAMPLE_USER_ID_DESC',
  UserTcPurchaseLimitsAverageRowIdAsc = 'USER_TC_PURCHASE_LIMITS_AVERAGE_ROW_ID_ASC',
  UserTcPurchaseLimitsAverageRowIdDesc = 'USER_TC_PURCHASE_LIMITS_AVERAGE_ROW_ID_DESC',
  UserTcPurchaseLimitsAverageUserIdAsc = 'USER_TC_PURCHASE_LIMITS_AVERAGE_USER_ID_ASC',
  UserTcPurchaseLimitsAverageUserIdDesc = 'USER_TC_PURCHASE_LIMITS_AVERAGE_USER_ID_DESC',
  UserTcPurchaseLimitsCountAsc = 'USER_TC_PURCHASE_LIMITS_COUNT_ASC',
  UserTcPurchaseLimitsCountDesc = 'USER_TC_PURCHASE_LIMITS_COUNT_DESC',
  UserTcPurchaseLimitsDistinctCountRowIdAsc = 'USER_TC_PURCHASE_LIMITS_DISTINCT_COUNT_ROW_ID_ASC',
  UserTcPurchaseLimitsDistinctCountRowIdDesc = 'USER_TC_PURCHASE_LIMITS_DISTINCT_COUNT_ROW_ID_DESC',
  UserTcPurchaseLimitsDistinctCountUserIdAsc = 'USER_TC_PURCHASE_LIMITS_DISTINCT_COUNT_USER_ID_ASC',
  UserTcPurchaseLimitsDistinctCountUserIdDesc = 'USER_TC_PURCHASE_LIMITS_DISTINCT_COUNT_USER_ID_DESC',
  UserTcPurchaseLimitsDistinctCountYearMonthAsc = 'USER_TC_PURCHASE_LIMITS_DISTINCT_COUNT_YEAR_MONTH_ASC',
  UserTcPurchaseLimitsDistinctCountYearMonthDesc = 'USER_TC_PURCHASE_LIMITS_DISTINCT_COUNT_YEAR_MONTH_DESC',
  UserTcPurchaseLimitsMaxRowIdAsc = 'USER_TC_PURCHASE_LIMITS_MAX_ROW_ID_ASC',
  UserTcPurchaseLimitsMaxRowIdDesc = 'USER_TC_PURCHASE_LIMITS_MAX_ROW_ID_DESC',
  UserTcPurchaseLimitsMaxUserIdAsc = 'USER_TC_PURCHASE_LIMITS_MAX_USER_ID_ASC',
  UserTcPurchaseLimitsMaxUserIdDesc = 'USER_TC_PURCHASE_LIMITS_MAX_USER_ID_DESC',
  UserTcPurchaseLimitsMinRowIdAsc = 'USER_TC_PURCHASE_LIMITS_MIN_ROW_ID_ASC',
  UserTcPurchaseLimitsMinRowIdDesc = 'USER_TC_PURCHASE_LIMITS_MIN_ROW_ID_DESC',
  UserTcPurchaseLimitsMinUserIdAsc = 'USER_TC_PURCHASE_LIMITS_MIN_USER_ID_ASC',
  UserTcPurchaseLimitsMinUserIdDesc = 'USER_TC_PURCHASE_LIMITS_MIN_USER_ID_DESC',
  UserTcPurchaseLimitsStddevPopulationRowIdAsc = 'USER_TC_PURCHASE_LIMITS_STDDEV_POPULATION_ROW_ID_ASC',
  UserTcPurchaseLimitsStddevPopulationRowIdDesc = 'USER_TC_PURCHASE_LIMITS_STDDEV_POPULATION_ROW_ID_DESC',
  UserTcPurchaseLimitsStddevPopulationUserIdAsc = 'USER_TC_PURCHASE_LIMITS_STDDEV_POPULATION_USER_ID_ASC',
  UserTcPurchaseLimitsStddevPopulationUserIdDesc = 'USER_TC_PURCHASE_LIMITS_STDDEV_POPULATION_USER_ID_DESC',
  UserTcPurchaseLimitsStddevSampleRowIdAsc = 'USER_TC_PURCHASE_LIMITS_STDDEV_SAMPLE_ROW_ID_ASC',
  UserTcPurchaseLimitsStddevSampleRowIdDesc = 'USER_TC_PURCHASE_LIMITS_STDDEV_SAMPLE_ROW_ID_DESC',
  UserTcPurchaseLimitsStddevSampleUserIdAsc = 'USER_TC_PURCHASE_LIMITS_STDDEV_SAMPLE_USER_ID_ASC',
  UserTcPurchaseLimitsStddevSampleUserIdDesc = 'USER_TC_PURCHASE_LIMITS_STDDEV_SAMPLE_USER_ID_DESC',
  UserTcPurchaseLimitsSumRowIdAsc = 'USER_TC_PURCHASE_LIMITS_SUM_ROW_ID_ASC',
  UserTcPurchaseLimitsSumRowIdDesc = 'USER_TC_PURCHASE_LIMITS_SUM_ROW_ID_DESC',
  UserTcPurchaseLimitsSumUserIdAsc = 'USER_TC_PURCHASE_LIMITS_SUM_USER_ID_ASC',
  UserTcPurchaseLimitsSumUserIdDesc = 'USER_TC_PURCHASE_LIMITS_SUM_USER_ID_DESC',
  UserTcPurchaseLimitsVariancePopulationRowIdAsc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_POPULATION_ROW_ID_ASC',
  UserTcPurchaseLimitsVariancePopulationRowIdDesc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_POPULATION_ROW_ID_DESC',
  UserTcPurchaseLimitsVariancePopulationUserIdAsc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_POPULATION_USER_ID_ASC',
  UserTcPurchaseLimitsVariancePopulationUserIdDesc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_POPULATION_USER_ID_DESC',
  UserTcPurchaseLimitsVarianceSampleRowIdAsc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserTcPurchaseLimitsVarianceSampleRowIdDesc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserTcPurchaseLimitsVarianceSampleUserIdAsc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserTcPurchaseLimitsVarianceSampleUserIdDesc = 'USER_TC_PURCHASE_LIMITS_VARIANCE_SAMPLE_USER_ID_DESC',
  UserXfaCooldownsAverageRowIdAsc = 'USER_XFA_COOLDOWNS_AVERAGE_ROW_ID_ASC',
  UserXfaCooldownsAverageRowIdDesc = 'USER_XFA_COOLDOWNS_AVERAGE_ROW_ID_DESC',
  UserXfaCooldownsAverageUserIdAsc = 'USER_XFA_COOLDOWNS_AVERAGE_USER_ID_ASC',
  UserXfaCooldownsAverageUserIdDesc = 'USER_XFA_COOLDOWNS_AVERAGE_USER_ID_DESC',
  UserXfaCooldownsCountAsc = 'USER_XFA_COOLDOWNS_COUNT_ASC',
  UserXfaCooldownsCountDesc = 'USER_XFA_COOLDOWNS_COUNT_DESC',
  UserXfaCooldownsDistinctCountRowIdAsc = 'USER_XFA_COOLDOWNS_DISTINCT_COUNT_ROW_ID_ASC',
  UserXfaCooldownsDistinctCountRowIdDesc = 'USER_XFA_COOLDOWNS_DISTINCT_COUNT_ROW_ID_DESC',
  UserXfaCooldownsDistinctCountUserIdAsc = 'USER_XFA_COOLDOWNS_DISTINCT_COUNT_USER_ID_ASC',
  UserXfaCooldownsDistinctCountUserIdDesc = 'USER_XFA_COOLDOWNS_DISTINCT_COUNT_USER_ID_DESC',
  UserXfaCooldownsMaxRowIdAsc = 'USER_XFA_COOLDOWNS_MAX_ROW_ID_ASC',
  UserXfaCooldownsMaxRowIdDesc = 'USER_XFA_COOLDOWNS_MAX_ROW_ID_DESC',
  UserXfaCooldownsMaxUserIdAsc = 'USER_XFA_COOLDOWNS_MAX_USER_ID_ASC',
  UserXfaCooldownsMaxUserIdDesc = 'USER_XFA_COOLDOWNS_MAX_USER_ID_DESC',
  UserXfaCooldownsMinRowIdAsc = 'USER_XFA_COOLDOWNS_MIN_ROW_ID_ASC',
  UserXfaCooldownsMinRowIdDesc = 'USER_XFA_COOLDOWNS_MIN_ROW_ID_DESC',
  UserXfaCooldownsMinUserIdAsc = 'USER_XFA_COOLDOWNS_MIN_USER_ID_ASC',
  UserXfaCooldownsMinUserIdDesc = 'USER_XFA_COOLDOWNS_MIN_USER_ID_DESC',
  UserXfaCooldownsStddevPopulationRowIdAsc = 'USER_XFA_COOLDOWNS_STDDEV_POPULATION_ROW_ID_ASC',
  UserXfaCooldownsStddevPopulationRowIdDesc = 'USER_XFA_COOLDOWNS_STDDEV_POPULATION_ROW_ID_DESC',
  UserXfaCooldownsStddevPopulationUserIdAsc = 'USER_XFA_COOLDOWNS_STDDEV_POPULATION_USER_ID_ASC',
  UserXfaCooldownsStddevPopulationUserIdDesc = 'USER_XFA_COOLDOWNS_STDDEV_POPULATION_USER_ID_DESC',
  UserXfaCooldownsStddevSampleRowIdAsc = 'USER_XFA_COOLDOWNS_STDDEV_SAMPLE_ROW_ID_ASC',
  UserXfaCooldownsStddevSampleRowIdDesc = 'USER_XFA_COOLDOWNS_STDDEV_SAMPLE_ROW_ID_DESC',
  UserXfaCooldownsStddevSampleUserIdAsc = 'USER_XFA_COOLDOWNS_STDDEV_SAMPLE_USER_ID_ASC',
  UserXfaCooldownsStddevSampleUserIdDesc = 'USER_XFA_COOLDOWNS_STDDEV_SAMPLE_USER_ID_DESC',
  UserXfaCooldownsSumRowIdAsc = 'USER_XFA_COOLDOWNS_SUM_ROW_ID_ASC',
  UserXfaCooldownsSumRowIdDesc = 'USER_XFA_COOLDOWNS_SUM_ROW_ID_DESC',
  UserXfaCooldownsSumUserIdAsc = 'USER_XFA_COOLDOWNS_SUM_USER_ID_ASC',
  UserXfaCooldownsSumUserIdDesc = 'USER_XFA_COOLDOWNS_SUM_USER_ID_DESC',
  UserXfaCooldownsVariancePopulationRowIdAsc = 'USER_XFA_COOLDOWNS_VARIANCE_POPULATION_ROW_ID_ASC',
  UserXfaCooldownsVariancePopulationRowIdDesc = 'USER_XFA_COOLDOWNS_VARIANCE_POPULATION_ROW_ID_DESC',
  UserXfaCooldownsVariancePopulationUserIdAsc = 'USER_XFA_COOLDOWNS_VARIANCE_POPULATION_USER_ID_ASC',
  UserXfaCooldownsVariancePopulationUserIdDesc = 'USER_XFA_COOLDOWNS_VARIANCE_POPULATION_USER_ID_DESC',
  UserXfaCooldownsVarianceSampleRowIdAsc = 'USER_XFA_COOLDOWNS_VARIANCE_SAMPLE_ROW_ID_ASC',
  UserXfaCooldownsVarianceSampleRowIdDesc = 'USER_XFA_COOLDOWNS_VARIANCE_SAMPLE_ROW_ID_DESC',
  UserXfaCooldownsVarianceSampleUserIdAsc = 'USER_XFA_COOLDOWNS_VARIANCE_SAMPLE_USER_ID_ASC',
  UserXfaCooldownsVarianceSampleUserIdDesc = 'USER_XFA_COOLDOWNS_VARIANCE_SAMPLE_USER_ID_DESC',
  VerificationsAverageRowIdAsc = 'VERIFICATIONS_AVERAGE_ROW_ID_ASC',
  VerificationsAverageRowIdDesc = 'VERIFICATIONS_AVERAGE_ROW_ID_DESC',
  VerificationsAverageUserIdAsc = 'VERIFICATIONS_AVERAGE_USER_ID_ASC',
  VerificationsAverageUserIdDesc = 'VERIFICATIONS_AVERAGE_USER_ID_DESC',
  VerificationsCountAsc = 'VERIFICATIONS_COUNT_ASC',
  VerificationsCountDesc = 'VERIFICATIONS_COUNT_DESC',
  VerificationsDistinctCountCreatedAtAsc = 'VERIFICATIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  VerificationsDistinctCountCreatedAtDesc = 'VERIFICATIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  VerificationsDistinctCountRowIdAsc = 'VERIFICATIONS_DISTINCT_COUNT_ROW_ID_ASC',
  VerificationsDistinctCountRowIdDesc = 'VERIFICATIONS_DISTINCT_COUNT_ROW_ID_DESC',
  VerificationsDistinctCountStatusAsc = 'VERIFICATIONS_DISTINCT_COUNT_STATUS_ASC',
  VerificationsDistinctCountStatusDesc = 'VERIFICATIONS_DISTINCT_COUNT_STATUS_DESC',
  VerificationsDistinctCountUserIdAsc = 'VERIFICATIONS_DISTINCT_COUNT_USER_ID_ASC',
  VerificationsDistinctCountUserIdDesc = 'VERIFICATIONS_DISTINCT_COUNT_USER_ID_DESC',
  VerificationsMaxRowIdAsc = 'VERIFICATIONS_MAX_ROW_ID_ASC',
  VerificationsMaxRowIdDesc = 'VERIFICATIONS_MAX_ROW_ID_DESC',
  VerificationsMaxUserIdAsc = 'VERIFICATIONS_MAX_USER_ID_ASC',
  VerificationsMaxUserIdDesc = 'VERIFICATIONS_MAX_USER_ID_DESC',
  VerificationsMinRowIdAsc = 'VERIFICATIONS_MIN_ROW_ID_ASC',
  VerificationsMinRowIdDesc = 'VERIFICATIONS_MIN_ROW_ID_DESC',
  VerificationsMinUserIdAsc = 'VERIFICATIONS_MIN_USER_ID_ASC',
  VerificationsMinUserIdDesc = 'VERIFICATIONS_MIN_USER_ID_DESC',
  VerificationsStddevPopulationRowIdAsc = 'VERIFICATIONS_STDDEV_POPULATION_ROW_ID_ASC',
  VerificationsStddevPopulationRowIdDesc = 'VERIFICATIONS_STDDEV_POPULATION_ROW_ID_DESC',
  VerificationsStddevPopulationUserIdAsc = 'VERIFICATIONS_STDDEV_POPULATION_USER_ID_ASC',
  VerificationsStddevPopulationUserIdDesc = 'VERIFICATIONS_STDDEV_POPULATION_USER_ID_DESC',
  VerificationsStddevSampleRowIdAsc = 'VERIFICATIONS_STDDEV_SAMPLE_ROW_ID_ASC',
  VerificationsStddevSampleRowIdDesc = 'VERIFICATIONS_STDDEV_SAMPLE_ROW_ID_DESC',
  VerificationsStddevSampleUserIdAsc = 'VERIFICATIONS_STDDEV_SAMPLE_USER_ID_ASC',
  VerificationsStddevSampleUserIdDesc = 'VERIFICATIONS_STDDEV_SAMPLE_USER_ID_DESC',
  VerificationsSumRowIdAsc = 'VERIFICATIONS_SUM_ROW_ID_ASC',
  VerificationsSumRowIdDesc = 'VERIFICATIONS_SUM_ROW_ID_DESC',
  VerificationsSumUserIdAsc = 'VERIFICATIONS_SUM_USER_ID_ASC',
  VerificationsSumUserIdDesc = 'VERIFICATIONS_SUM_USER_ID_DESC',
  VerificationsVariancePopulationRowIdAsc = 'VERIFICATIONS_VARIANCE_POPULATION_ROW_ID_ASC',
  VerificationsVariancePopulationRowIdDesc = 'VERIFICATIONS_VARIANCE_POPULATION_ROW_ID_DESC',
  VerificationsVariancePopulationUserIdAsc = 'VERIFICATIONS_VARIANCE_POPULATION_USER_ID_ASC',
  VerificationsVariancePopulationUserIdDesc = 'VERIFICATIONS_VARIANCE_POPULATION_USER_ID_DESC',
  VerificationsVarianceSampleRowIdAsc = 'VERIFICATIONS_VARIANCE_SAMPLE_ROW_ID_ASC',
  VerificationsVarianceSampleRowIdDesc = 'VERIFICATIONS_VARIANCE_SAMPLE_ROW_ID_DESC',
  VerificationsVarianceSampleUserIdAsc = 'VERIFICATIONS_VARIANCE_SAMPLE_USER_ID_ASC',
  VerificationsVarianceSampleUserIdDesc = 'VERIFICATIONS_VARIANCE_SAMPLE_USER_ID_DESC'
}

export type UserPlatformCredential = Node & {
  __typename?: 'UserPlatformCredential';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `Platform` that is related to this `UserPlatformCredential`. */
  platform?: Maybe<Platform>;
  platformId: Scalars['Int']['output'];
  platformPassword?: Maybe<Scalars['String']['output']>;
  platformUserId: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `UserPlatformCredential`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserPlatformCredentialAggregates = {
  __typename?: 'UserPlatformCredentialAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserPlatformCredentialAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserPlatformCredentialDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserPlatformCredentialMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserPlatformCredentialMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserPlatformCredentialStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserPlatformCredentialStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserPlatformCredentialSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserPlatformCredentialVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserPlatformCredentialVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserPlatformCredential` object types. */
export type UserPlatformCredentialAggregatesFilter = {
  /** Mean average aggregate over matching `UserPlatformCredential` objects. */
  average?: InputMaybe<UserPlatformCredentialAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserPlatformCredential` objects. */
  distinctCount?: InputMaybe<UserPlatformCredentialDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserPlatformCredential` object to be included within the aggregate. */
  filter?: InputMaybe<UserPlatformCredentialFilter>;
  /** Maximum aggregate over matching `UserPlatformCredential` objects. */
  max?: InputMaybe<UserPlatformCredentialMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserPlatformCredential` objects. */
  min?: InputMaybe<UserPlatformCredentialMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserPlatformCredential` objects. */
  stddevPopulation?: InputMaybe<UserPlatformCredentialStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserPlatformCredential` objects. */
  stddevSample?: InputMaybe<UserPlatformCredentialStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserPlatformCredential` objects. */
  sum?: InputMaybe<UserPlatformCredentialSumAggregateFilter>;
  /** Population variance aggregate over matching `UserPlatformCredential` objects. */
  variancePopulation?: InputMaybe<UserPlatformCredentialVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserPlatformCredential` objects. */
  varianceSample?: InputMaybe<UserPlatformCredentialVarianceSampleAggregateFilter>;
};

export type UserPlatformCredentialAverageAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserPlatformCredentialAverageAggregates = {
  __typename?: 'UserPlatformCredentialAverageAggregates';
  /** Mean average of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserPlatformCredential` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserPlatformCredentialCondition = {
  /** Checks for equality with the object’s `platformId` field. */
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserPlatformCredential` values. */
export type UserPlatformCredentialConnection = {
  __typename?: 'UserPlatformCredentialConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserPlatformCredentialAggregates>;
  /** A list of edges which contains the `UserPlatformCredential` and cursor to aid in pagination. */
  edges: Array<Maybe<UserPlatformCredentialEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserPlatformCredentialAggregates>>;
  /** A list of `UserPlatformCredential` objects. */
  nodes: Array<Maybe<UserPlatformCredential>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserPlatformCredential` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserPlatformCredential` values. */
export type UserPlatformCredentialConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserPlatformCredentialGroupBy>;
  having?: InputMaybe<UserPlatformCredentialHavingInput>;
};

export type UserPlatformCredentialDistinctCountAggregateFilter = {
  platformId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserPlatformCredentialDistinctCountAggregates = {
  __typename?: 'UserPlatformCredentialDistinctCountAggregates';
  /** Distinct count of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platformPassword across the matching connection */
  platformPassword?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of platformUserId across the matching connection */
  platformUserId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserPlatformCredential` edge in the connection. */
export type UserPlatformCredentialEdge = {
  __typename?: 'UserPlatformCredentialEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserPlatformCredential` at the end of the edge. */
  node?: Maybe<UserPlatformCredential>;
};

/** A filter to be used against `UserPlatformCredential` object types. All fields are combined with a logical ‘and.’ */
export type UserPlatformCredentialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPlatformCredentialFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserPlatformCredentialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPlatformCredentialFilter>>;
  /** Filter by the object’s `platform` relation. */
  platform?: InputMaybe<PlatformFilter>;
  /** Filter by the object’s `platformId` field. */
  platformId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserPlatformCredential` for usage during aggregation. */
export enum UserPlatformCredentialGroupBy {
  PlatformId = 'PLATFORM_ID',
  UserId = 'USER_ID'
}

export type UserPlatformCredentialHavingAverageInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingDistinctCountInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserPlatformCredential` aggregates. */
export type UserPlatformCredentialHavingInput = {
  AND?: InputMaybe<Array<UserPlatformCredentialHavingInput>>;
  OR?: InputMaybe<Array<UserPlatformCredentialHavingInput>>;
  average?: InputMaybe<UserPlatformCredentialHavingAverageInput>;
  distinctCount?: InputMaybe<UserPlatformCredentialHavingDistinctCountInput>;
  max?: InputMaybe<UserPlatformCredentialHavingMaxInput>;
  min?: InputMaybe<UserPlatformCredentialHavingMinInput>;
  stddevPopulation?: InputMaybe<UserPlatformCredentialHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserPlatformCredentialHavingStddevSampleInput>;
  sum?: InputMaybe<UserPlatformCredentialHavingSumInput>;
  variancePopulation?: InputMaybe<UserPlatformCredentialHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserPlatformCredentialHavingVarianceSampleInput>;
};

export type UserPlatformCredentialHavingMaxInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingMinInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingStddevPopulationInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingStddevSampleInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingSumInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingVariancePopulationInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialHavingVarianceSampleInput = {
  platformId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserPlatformCredentialMaxAggregateFilter = {
  platformId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserPlatformCredentialMaxAggregates = {
  __typename?: 'UserPlatformCredentialMaxAggregates';
  /** Maximum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserPlatformCredentialMinAggregateFilter = {
  platformId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserPlatformCredentialMinAggregates = {
  __typename?: 'UserPlatformCredentialMinAggregates';
  /** Minimum of platformId across the matching connection */
  platformId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserPlatformCredential`. */
export enum UserPlatformCredentialOrderBy {
  Natural = 'NATURAL',
  PlatformIdAsc = 'PLATFORM_ID_ASC',
  PlatformIdDesc = 'PLATFORM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserPlatformCredentialStddevPopulationAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserPlatformCredentialStddevPopulationAggregates = {
  __typename?: 'UserPlatformCredentialStddevPopulationAggregates';
  /** Population standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserPlatformCredentialStddevSampleAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserPlatformCredentialStddevSampleAggregates = {
  __typename?: 'UserPlatformCredentialStddevSampleAggregates';
  /** Sample standard deviation of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserPlatformCredentialSumAggregateFilter = {
  platformId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserPlatformCredentialSumAggregates = {
  __typename?: 'UserPlatformCredentialSumAggregates';
  /** Sum of platformId across the matching connection */
  platformId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserPlatformCredentialVariancePopulationAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserPlatformCredentialVariancePopulationAggregates = {
  __typename?: 'UserPlatformCredentialVariancePopulationAggregates';
  /** Population variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserPlatformCredentialVarianceSampleAggregateFilter = {
  platformId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserPlatformCredentialVarianceSampleAggregates = {
  __typename?: 'UserPlatformCredentialVarianceSampleAggregates';
  /** Sample variance of platformId across the matching connection */
  platformId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserRolesAdminRole = Node & {
  __typename?: 'UserRolesAdminRole';
  /** Reads a single `AdminRole` that is related to this `UserRolesAdminRole`. */
  adminRole?: Maybe<AdminRole>;
  adminRoleId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `UserRolesAdminRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserRolesAdminRoleAggregates = {
  __typename?: 'UserRolesAdminRoleAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserRolesAdminRoleAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserRolesAdminRoleDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserRolesAdminRoleMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserRolesAdminRoleMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserRolesAdminRoleStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserRolesAdminRoleStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserRolesAdminRoleSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserRolesAdminRoleVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserRolesAdminRoleVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserRolesAdminRole` object types. */
export type UserRolesAdminRoleAggregatesFilter = {
  /** Mean average aggregate over matching `UserRolesAdminRole` objects. */
  average?: InputMaybe<UserRolesAdminRoleAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserRolesAdminRole` objects. */
  distinctCount?: InputMaybe<UserRolesAdminRoleDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserRolesAdminRole` object to be included within the aggregate. */
  filter?: InputMaybe<UserRolesAdminRoleFilter>;
  /** Maximum aggregate over matching `UserRolesAdminRole` objects. */
  max?: InputMaybe<UserRolesAdminRoleMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserRolesAdminRole` objects. */
  min?: InputMaybe<UserRolesAdminRoleMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserRolesAdminRole` objects. */
  stddevPopulation?: InputMaybe<UserRolesAdminRoleStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserRolesAdminRole` objects. */
  stddevSample?: InputMaybe<UserRolesAdminRoleStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserRolesAdminRole` objects. */
  sum?: InputMaybe<UserRolesAdminRoleSumAggregateFilter>;
  /** Population variance aggregate over matching `UserRolesAdminRole` objects. */
  variancePopulation?: InputMaybe<UserRolesAdminRoleVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserRolesAdminRole` objects. */
  varianceSample?: InputMaybe<UserRolesAdminRoleVarianceSampleAggregateFilter>;
};

export type UserRolesAdminRoleAverageAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserRolesAdminRoleAverageAggregates = {
  __typename?: 'UserRolesAdminRoleAverageAggregates';
  /** Mean average of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserRolesAdminRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserRolesAdminRoleCondition = {
  /** Checks for equality with the object’s `adminRoleId` field. */
  adminRoleId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserRolesAdminRole` values. */
export type UserRolesAdminRoleConnection = {
  __typename?: 'UserRolesAdminRoleConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserRolesAdminRoleAggregates>;
  /** A list of edges which contains the `UserRolesAdminRole` and cursor to aid in pagination. */
  edges: Array<Maybe<UserRolesAdminRoleEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserRolesAdminRoleAggregates>>;
  /** A list of `UserRolesAdminRole` objects. */
  nodes: Array<Maybe<UserRolesAdminRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRolesAdminRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserRolesAdminRole` values. */
export type UserRolesAdminRoleConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserRolesAdminRoleGroupBy>;
  having?: InputMaybe<UserRolesAdminRoleHavingInput>;
};

export type UserRolesAdminRoleDistinctCountAggregateFilter = {
  adminRoleId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserRolesAdminRoleDistinctCountAggregates = {
  __typename?: 'UserRolesAdminRoleDistinctCountAggregates';
  /** Distinct count of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserRolesAdminRole` edge in the connection. */
export type UserRolesAdminRoleEdge = {
  __typename?: 'UserRolesAdminRoleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRolesAdminRole` at the end of the edge. */
  node?: Maybe<UserRolesAdminRole>;
};

/** A filter to be used against `UserRolesAdminRole` object types. All fields are combined with a logical ‘and.’ */
export type UserRolesAdminRoleFilter = {
  /** Filter by the object’s `adminRole` relation. */
  adminRole?: InputMaybe<AdminRoleFilter>;
  /** Filter by the object’s `adminRoleId` field. */
  adminRoleId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRolesAdminRoleFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserRolesAdminRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRolesAdminRoleFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserRolesAdminRole` for usage during aggregation. */
export enum UserRolesAdminRoleGroupBy {
  AdminRoleId = 'ADMIN_ROLE_ID',
  UserId = 'USER_ID'
}

export type UserRolesAdminRoleHavingAverageInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingDistinctCountInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserRolesAdminRole` aggregates. */
export type UserRolesAdminRoleHavingInput = {
  AND?: InputMaybe<Array<UserRolesAdminRoleHavingInput>>;
  OR?: InputMaybe<Array<UserRolesAdminRoleHavingInput>>;
  average?: InputMaybe<UserRolesAdminRoleHavingAverageInput>;
  distinctCount?: InputMaybe<UserRolesAdminRoleHavingDistinctCountInput>;
  max?: InputMaybe<UserRolesAdminRoleHavingMaxInput>;
  min?: InputMaybe<UserRolesAdminRoleHavingMinInput>;
  stddevPopulation?: InputMaybe<UserRolesAdminRoleHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserRolesAdminRoleHavingStddevSampleInput>;
  sum?: InputMaybe<UserRolesAdminRoleHavingSumInput>;
  variancePopulation?: InputMaybe<UserRolesAdminRoleHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserRolesAdminRoleHavingVarianceSampleInput>;
};

export type UserRolesAdminRoleHavingMaxInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingMinInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingStddevPopulationInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingStddevSampleInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingSumInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingVariancePopulationInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleHavingVarianceSampleInput = {
  adminRoleId?: InputMaybe<HavingIntFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserRolesAdminRoleMaxAggregateFilter = {
  adminRoleId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserRolesAdminRoleMaxAggregates = {
  __typename?: 'UserRolesAdminRoleMaxAggregates';
  /** Maximum of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserRolesAdminRoleMinAggregateFilter = {
  adminRoleId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserRolesAdminRoleMinAggregates = {
  __typename?: 'UserRolesAdminRoleMinAggregates';
  /** Minimum of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserRolesAdminRole`. */
export enum UserRolesAdminRoleOrderBy {
  AdminRoleIdAsc = 'ADMIN_ROLE_ID_ASC',
  AdminRoleIdDesc = 'ADMIN_ROLE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserRolesAdminRoleStddevPopulationAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserRolesAdminRoleStddevPopulationAggregates = {
  __typename?: 'UserRolesAdminRoleStddevPopulationAggregates';
  /** Population standard deviation of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserRolesAdminRoleStddevSampleAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserRolesAdminRoleStddevSampleAggregates = {
  __typename?: 'UserRolesAdminRoleStddevSampleAggregates';
  /** Sample standard deviation of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserRolesAdminRoleSumAggregateFilter = {
  adminRoleId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserRolesAdminRoleSumAggregates = {
  __typename?: 'UserRolesAdminRoleSumAggregates';
  /** Sum of adminRoleId across the matching connection */
  adminRoleId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserRolesAdminRoleVariancePopulationAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserRolesAdminRoleVariancePopulationAggregates = {
  __typename?: 'UserRolesAdminRoleVariancePopulationAggregates';
  /** Population variance of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserRolesAdminRoleVarianceSampleAggregateFilter = {
  adminRoleId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserRolesAdminRoleVarianceSampleAggregates = {
  __typename?: 'UserRolesAdminRoleVarianceSampleAggregates';
  /** Sample variance of adminRoleId across the matching connection */
  adminRoleId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserStddevPopulationAggregates = {
  __typename?: 'UserStddevPopulationAggregates';
  /** Population standard deviation of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserStddevSampleAggregates = {
  __typename?: 'UserStddevSampleAggregates';
  /** Sample standard deviation of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserSubscription = Node & {
  __typename?: 'UserSubscription';
  /** Reads and enables pagination through a set of `Account`. */
  accountsBySubscriptionId: AccountConnection;
  active?: Maybe<Scalars['Boolean']['output']>;
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Coupon` that is related to this `UserSubscription`. */
  coupon?: Maybe<Coupon>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  dunningAttempts?: Maybe<Scalars['Int']['output']>;
  dunningStartDate?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  initialNuveiTransactionId?: Maybe<Scalars['String']['output']>;
  isDunning?: Maybe<Scalars['Boolean']['output']>;
  lastRenewalDate?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `SavedCard` that is related to this `UserSubscription`. */
  nmiSavedCard?: Maybe<SavedCard>;
  nmiSavedCardId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `NmiSubscription`. */
  nmiSubscriptionsByMigratedSubId: NmiSubscriptionConnection;
  nuveiUserPaymentOptionId?: Maybe<Scalars['String']['output']>;
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  rebillDate?: Maybe<Scalars['Datetime']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  tax?: Maybe<Scalars['BigFloat']['output']>;
  total?: Maybe<Scalars['BigFloat']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};


export type UserSubscriptionAccountsBySubscriptionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
};


export type UserSubscriptionNmiSubscriptionsByMigratedSubIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NmiSubscriptionCondition>;
  filter?: InputMaybe<NmiSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NmiSubscriptionOrderBy>>;
};

export type UserSubscriptionAggregates = {
  __typename?: 'UserSubscriptionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserSubscriptionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserSubscriptionDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserSubscriptionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserSubscriptionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserSubscriptionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserSubscriptionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserSubscriptionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserSubscriptionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserSubscriptionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserSubscription` object types. */
export type UserSubscriptionAggregatesFilter = {
  /** Mean average aggregate over matching `UserSubscription` objects. */
  average?: InputMaybe<UserSubscriptionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserSubscription` objects. */
  distinctCount?: InputMaybe<UserSubscriptionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserSubscription` object to be included within the aggregate. */
  filter?: InputMaybe<UserSubscriptionFilter>;
  /** Maximum aggregate over matching `UserSubscription` objects. */
  max?: InputMaybe<UserSubscriptionMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserSubscription` objects. */
  min?: InputMaybe<UserSubscriptionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserSubscription` objects. */
  stddevPopulation?: InputMaybe<UserSubscriptionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserSubscription` objects. */
  stddevSample?: InputMaybe<UserSubscriptionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserSubscription` objects. */
  sum?: InputMaybe<UserSubscriptionSumAggregateFilter>;
  /** Population variance aggregate over matching `UserSubscription` objects. */
  variancePopulation?: InputMaybe<UserSubscriptionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserSubscription` objects. */
  varianceSample?: InputMaybe<UserSubscriptionVarianceSampleAggregateFilter>;
};

export type UserSubscriptionAverageAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserSubscriptionAverageAggregates = {
  __typename?: 'UserSubscriptionAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserSubscription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserSubscriptionCondition = {
  /** Checks for equality with the object’s `couponId` field. */
  couponId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserSubscription` values. */
export type UserSubscriptionConnection = {
  __typename?: 'UserSubscriptionConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserSubscriptionAggregates>;
  /** A list of edges which contains the `UserSubscription` and cursor to aid in pagination. */
  edges: Array<Maybe<UserSubscriptionEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserSubscriptionAggregates>>;
  /** A list of `UserSubscription` objects. */
  nodes: Array<Maybe<UserSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserSubscription` values. */
export type UserSubscriptionConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserSubscriptionGroupBy>;
  having?: InputMaybe<UserSubscriptionHavingInput>;
};

export type UserSubscriptionDistinctCountAggregateFilter = {
  couponId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserSubscriptionDistinctCountAggregates = {
  __typename?: 'UserSubscriptionDistinctCountAggregates';
  /** Distinct count of active across the matching connection */
  active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dunningStartDate across the matching connection */
  dunningStartDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of initialNuveiTransactionId across the matching connection */
  initialNuveiTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isDunning across the matching connection */
  isDunning?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastRenewalDate across the matching connection */
  lastRenewalDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nuveiUserPaymentOptionId across the matching connection */
  nuveiUserPaymentOptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rebillDate across the matching connection */
  rebillDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of referenceId across the matching connection */
  referenceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tax across the matching connection */
  tax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of total across the matching connection */
  total?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserSubscription` edge in the connection. */
export type UserSubscriptionEdge = {
  __typename?: 'UserSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserSubscription` at the end of the edge. */
  node?: Maybe<UserSubscription>;
};

/** A filter to be used against `UserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionFilter = {
  /** Filter by the object’s `accountsBySubscriptionId` relation. */
  accountsBySubscriptionId?: InputMaybe<UserSubscriptionToManyAccountFilter>;
  /** Some related `accountsBySubscriptionId` exist. */
  accountsBySubscriptionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSubscriptionFilter>>;
  /** Filter by the object’s `coupon` relation. */
  coupon?: InputMaybe<CouponFilter>;
  /** A related `coupon` exists. */
  couponExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `couponId` field. */
  couponId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nmiSavedCard` relation. */
  nmiSavedCard?: InputMaybe<SavedCardFilter>;
  /** A related `nmiSavedCard` exists. */
  nmiSavedCardExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `nmiSubscriptionsByMigratedSubId` relation. */
  nmiSubscriptionsByMigratedSubId?: InputMaybe<UserSubscriptionToManyNmiSubscriptionFilter>;
  /** Some related `nmiSubscriptionsByMigratedSubId` exist. */
  nmiSubscriptionsByMigratedSubIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<UserSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSubscriptionFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserSubscription` for usage during aggregation. */
export enum UserSubscriptionGroupBy {
  CouponId = 'COUPON_ID',
  UserId = 'USER_ID'
}

export type UserSubscriptionHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserSubscription` aggregates. */
export type UserSubscriptionHavingInput = {
  AND?: InputMaybe<Array<UserSubscriptionHavingInput>>;
  OR?: InputMaybe<Array<UserSubscriptionHavingInput>>;
  average?: InputMaybe<UserSubscriptionHavingAverageInput>;
  distinctCount?: InputMaybe<UserSubscriptionHavingDistinctCountInput>;
  max?: InputMaybe<UserSubscriptionHavingMaxInput>;
  min?: InputMaybe<UserSubscriptionHavingMinInput>;
  stddevPopulation?: InputMaybe<UserSubscriptionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserSubscriptionHavingStddevSampleInput>;
  sum?: InputMaybe<UserSubscriptionHavingSumInput>;
  variancePopulation?: InputMaybe<UserSubscriptionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserSubscriptionHavingVarianceSampleInput>;
};

export type UserSubscriptionHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  couponId?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dunningAttempts?: InputMaybe<HavingIntFilter>;
  dunningStartDate?: InputMaybe<HavingDatetimeFilter>;
  lastRenewalDate?: InputMaybe<HavingDatetimeFilter>;
  nmiSavedCardId?: InputMaybe<HavingIntFilter>;
  originalProductPrice?: InputMaybe<HavingBigfloatFilter>;
  rebillDate?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  tax?: InputMaybe<HavingBigfloatFilter>;
  total?: InputMaybe<HavingBigfloatFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserSubscriptionMaxAggregateFilter = {
  couponId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserSubscriptionMaxAggregates = {
  __typename?: 'UserSubscriptionMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserSubscriptionMinAggregateFilter = {
  couponId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserSubscriptionMinAggregates = {
  __typename?: 'UserSubscriptionMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of couponId across the matching connection */
  couponId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserSubscription`. */
export enum UserSubscriptionOrderBy {
  AccountsBySubscriptionIdAverageAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdAverageAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdAverageNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdAverageNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdAveragePlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdAveragePlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdAverageProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdAverageProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdAverageRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_ASC',
  AccountsBySubscriptionIdAverageRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_ROW_ID_DESC',
  AccountsBySubscriptionIdAverageSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_SKU_ID_ASC',
  AccountsBySubscriptionIdAverageSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_SKU_ID_DESC',
  AccountsBySubscriptionIdAverageSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdAverageSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdAverageUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_USER_ID_ASC',
  AccountsBySubscriptionIdAverageUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_AVERAGE_USER_ID_DESC',
  AccountsBySubscriptionIdCountAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_COUNT_ASC',
  AccountsBySubscriptionIdCountDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_COUNT_DESC',
  AccountsBySubscriptionIdDistinctCountAccountNameAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_NAME_ASC',
  AccountsBySubscriptionIdDistinctCountAccountNameDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_NAME_DESC',
  AccountsBySubscriptionIdDistinctCountAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdDistinctCountAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdDistinctCountActiveAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACTIVE_ASC',
  AccountsBySubscriptionIdDistinctCountActiveDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ACTIVE_DESC',
  AccountsBySubscriptionIdDistinctCountComplimentaryAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_COMPLIMENTARY_ASC',
  AccountsBySubscriptionIdDistinctCountComplimentaryDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_COMPLIMENTARY_DESC',
  AccountsBySubscriptionIdDistinctCountCreatedAtAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_CREATED_AT_ASC',
  AccountsBySubscriptionIdDistinctCountCreatedAtDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_CREATED_AT_DESC',
  AccountsBySubscriptionIdDistinctCountNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdDistinctCountNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdDistinctCountPlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdDistinctCountPlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdDistinctCountProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdDistinctCountProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdDistinctCountRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_ASC',
  AccountsBySubscriptionIdDistinctCountRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_ROW_ID_DESC',
  AccountsBySubscriptionIdDistinctCountSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SKU_ID_ASC',
  AccountsBySubscriptionIdDistinctCountSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SKU_ID_DESC',
  AccountsBySubscriptionIdDistinctCountStageAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STAGE_ASC',
  AccountsBySubscriptionIdDistinctCountStageDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STAGE_DESC',
  AccountsBySubscriptionIdDistinctCountStartDateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_START_DATE_ASC',
  AccountsBySubscriptionIdDistinctCountStartDateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_START_DATE_DESC',
  AccountsBySubscriptionIdDistinctCountStatusAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STATUS_ASC',
  AccountsBySubscriptionIdDistinctCountStatusDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_STATUS_DESC',
  AccountsBySubscriptionIdDistinctCountSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdDistinctCountSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdDistinctCountUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_USER_ID_ASC',
  AccountsBySubscriptionIdDistinctCountUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_DISTINCT_COUNT_USER_ID_DESC',
  AccountsBySubscriptionIdMaxAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdMaxAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdMaxNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdMaxNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdMaxPlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdMaxPlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdMaxProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdMaxProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdMaxRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_ASC',
  AccountsBySubscriptionIdMaxRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_ROW_ID_DESC',
  AccountsBySubscriptionIdMaxSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_SKU_ID_ASC',
  AccountsBySubscriptionIdMaxSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_SKU_ID_DESC',
  AccountsBySubscriptionIdMaxSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdMaxSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdMaxUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_USER_ID_ASC',
  AccountsBySubscriptionIdMaxUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MAX_USER_ID_DESC',
  AccountsBySubscriptionIdMinAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdMinAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdMinNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdMinNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdMinPlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdMinPlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdMinProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdMinProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdMinRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_ASC',
  AccountsBySubscriptionIdMinRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_ROW_ID_DESC',
  AccountsBySubscriptionIdMinSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_SKU_ID_ASC',
  AccountsBySubscriptionIdMinSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_SKU_ID_DESC',
  AccountsBySubscriptionIdMinSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdMinSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdMinUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_USER_ID_ASC',
  AccountsBySubscriptionIdMinUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_MIN_USER_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdStddevPopulationAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdStddevPopulationNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationPlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationPlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_ROW_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SKU_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SKU_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdStddevPopulationUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_USER_ID_ASC',
  AccountsBySubscriptionIdStddevPopulationUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_POPULATION_USER_ID_DESC',
  AccountsBySubscriptionIdStddevSampleAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdStddevSampleAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdStddevSampleNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdStddevSampleNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdStddevSamplePlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdStddevSamplePlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdStddevSampleProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdStddevSampleProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdStddevSampleRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  AccountsBySubscriptionIdStddevSampleRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  AccountsBySubscriptionIdStddevSampleSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SKU_ID_ASC',
  AccountsBySubscriptionIdStddevSampleSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SKU_ID_DESC',
  AccountsBySubscriptionIdStddevSampleSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdStddevSampleSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdStddevSampleUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_USER_ID_ASC',
  AccountsBySubscriptionIdStddevSampleUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_STDDEV_SAMPLE_USER_ID_DESC',
  AccountsBySubscriptionIdSumAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdSumAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdSumNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdSumNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdSumPlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdSumPlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdSumProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdSumProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdSumRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_ASC',
  AccountsBySubscriptionIdSumRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_ROW_ID_DESC',
  AccountsBySubscriptionIdSumSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_SKU_ID_ASC',
  AccountsBySubscriptionIdSumSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_SKU_ID_DESC',
  AccountsBySubscriptionIdSumSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdSumSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdSumUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_USER_ID_ASC',
  AccountsBySubscriptionIdSumUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_SUM_USER_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdVariancePopulationAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdVariancePopulationNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationPlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationPlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SKU_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SKU_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdVariancePopulationUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_USER_ID_ASC',
  AccountsBySubscriptionIdVariancePopulationUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_POPULATION_USER_ID_DESC',
  AccountsBySubscriptionIdVarianceSampleAccountTemplateAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_ASC',
  AccountsBySubscriptionIdVarianceSampleAccountTemplateDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ACCOUNT_TEMPLATE_DESC',
  AccountsBySubscriptionIdVarianceSampleNmiSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdVarianceSampleNmiSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_NMI_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdVarianceSamplePlatformIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PLATFORM_ID_ASC',
  AccountsBySubscriptionIdVarianceSamplePlatformIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PLATFORM_ID_DESC',
  AccountsBySubscriptionIdVarianceSampleProjectXaccountIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_ASC',
  AccountsBySubscriptionIdVarianceSampleProjectXaccountIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_PROJECT_XACCOUNT_ID_DESC',
  AccountsBySubscriptionIdVarianceSampleRowIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  AccountsBySubscriptionIdVarianceSampleRowIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  AccountsBySubscriptionIdVarianceSampleSkuIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SKU_ID_ASC',
  AccountsBySubscriptionIdVarianceSampleSkuIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SKU_ID_DESC',
  AccountsBySubscriptionIdVarianceSampleSubscriptionIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_ASC',
  AccountsBySubscriptionIdVarianceSampleSubscriptionIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_SUBSCRIPTION_ID_DESC',
  AccountsBySubscriptionIdVarianceSampleUserIdAsc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_USER_ID_ASC',
  AccountsBySubscriptionIdVarianceSampleUserIdDesc = 'ACCOUNTS_BY_SUBSCRIPTION_ID_VARIANCE_SAMPLE_USER_ID_DESC',
  CouponIdAsc = 'COUPON_ID_ASC',
  CouponIdDesc = 'COUPON_ID_DESC',
  Natural = 'NATURAL',
  NmiSubscriptionsByMigratedSubIdAverageCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdAverageUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdAverageUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_AVERAGE_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdCountAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_COUNT_ASC',
  NmiSubscriptionsByMigratedSubIdCountDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_COUNT_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountRebillManagerAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_REBILL_MANAGER_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountRebillManagerDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_REBILL_MANAGER_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountRebillRefIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_REBILL_REF_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountRebillRefIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_REBILL_REF_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountServiceAccessUntilAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountServiceAccessUntilDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SERVICE_ACCESS_UNTIL_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountServiceCancelledAtAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SERVICE_CANCELLED_AT_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountServiceCancelledAtDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SERVICE_CANCELLED_AT_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountSubscriptionCancelledAtAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountSubscriptionCancelledAtDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_SUBSCRIPTION_CANCELLED_AT_DESC',
  NmiSubscriptionsByMigratedSubIdDistinctCountUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdDistinctCountUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_DISTINCT_COUNT_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMaxUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMaxUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MAX_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdMinUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdMinUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_MIN_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevPopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_POPULATION_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdStddevSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdStddevSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_STDDEV_SAMPLE_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdSumUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdSumUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_SUM_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVariancePopulationUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_POPULATION_USER_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleCouponIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_COUPON_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleCouponIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_COUPON_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleMigratedSubIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_MIGRATED_SUB_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleMigratedSubIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_MIGRATED_SUB_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleNmiReferenceIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_NMI_REFERENCE_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleNmiReferenceIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_NMI_REFERENCE_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleProductIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_PRODUCT_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleProductIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_PRODUCT_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleRowIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_ROW_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleRowIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_ROW_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleSavedCardIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_SAVED_CARD_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleSavedCardIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_SAVED_CARD_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleSkuIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_SKU_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleSkuIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_SKU_ID_DESC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleUserIdAsc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_USER_ID_ASC',
  NmiSubscriptionsByMigratedSubIdVarianceSampleUserIdDesc = 'NMI_SUBSCRIPTIONS_BY_MIGRATED_SUB_ID_VARIANCE_SAMPLE_USER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserSubscriptionStddevPopulationAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserSubscriptionStddevPopulationAggregates = {
  __typename?: 'UserSubscriptionStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserSubscriptionStddevSampleAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserSubscriptionStddevSampleAggregates = {
  __typename?: 'UserSubscriptionStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserSubscriptionSumAggregateFilter = {
  couponId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserSubscriptionSumAggregates = {
  __typename?: 'UserSubscriptionSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of couponId across the matching connection */
  couponId: Scalars['BigInt']['output'];
  /** Sum of dunningAttempts across the matching connection */
  dunningAttempts: Scalars['BigInt']['output'];
  /** Sum of nmiSavedCardId across the matching connection */
  nmiSavedCardId: Scalars['BigInt']['output'];
  /** Sum of originalProductPrice across the matching connection */
  originalProductPrice: Scalars['BigFloat']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of tax across the matching connection */
  tax: Scalars['BigFloat']['output'];
  /** Sum of total across the matching connection */
  total: Scalars['BigFloat']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Account` object types. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionToManyAccountFilter = {
  /** Aggregates across related `Account` match the filter criteria. */
  aggregates?: InputMaybe<AccountAggregatesFilter>;
  /** Every related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFilter>;
  /** No related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFilter>;
  /** Some related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFilter>;
};

/** A filter to be used against many `NmiSubscription` object types. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionToManyNmiSubscriptionFilter = {
  /** Aggregates across related `NmiSubscription` match the filter criteria. */
  aggregates?: InputMaybe<NmiSubscriptionAggregatesFilter>;
  /** Every related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NmiSubscriptionFilter>;
  /** No related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NmiSubscriptionFilter>;
  /** Some related `NmiSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NmiSubscriptionFilter>;
};

export type UserSubscriptionVariancePopulationAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserSubscriptionVariancePopulationAggregates = {
  __typename?: 'UserSubscriptionVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserSubscriptionVarianceSampleAggregateFilter = {
  couponId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserSubscriptionVarianceSampleAggregates = {
  __typename?: 'UserSubscriptionVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of couponId across the matching connection */
  couponId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dunningAttempts across the matching connection */
  dunningAttempts?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nmiSavedCardId across the matching connection */
  nmiSavedCardId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of originalProductPrice across the matching connection */
  originalProductPrice?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tax across the matching connection */
  tax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of total across the matching connection */
  total?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserSumAggregates = {
  __typename?: 'UserSumAggregates';
  /** Sum of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigInt']['output']>;
  /** Sum of legacyAppId across the matching connection */
  legacyAppId: Scalars['BigInt']['output'];
  /** Sum of netSuiteId across the matching connection */
  netSuiteId: Scalars['BigInt']['output'];
  /** Sum of projectXUserId across the matching connection */
  projectXUserId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type UserTaxForm = Node & {
  __typename?: 'UserTaxForm';
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  docusignEnvelopeId?: Maybe<Scalars['String']['output']>;
  entityType: UserTaxFormsEntityTypeEnum;
  eventLog: Scalars['JSON']['output'];
  formType: UserTaxFormsFormTypeEnum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  netSuiteFileId?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status: UserTaxFormsStatusEnum;
  taxYear: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  uploadedToNetsuiteAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `UserTaxForm`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserTaxFormAggregates = {
  __typename?: 'UserTaxFormAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserTaxFormAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserTaxFormDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserTaxFormMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserTaxFormMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserTaxFormStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserTaxFormStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserTaxFormSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserTaxFormVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserTaxFormVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserTaxForm` object types. */
export type UserTaxFormAggregatesFilter = {
  /** Mean average aggregate over matching `UserTaxForm` objects. */
  average?: InputMaybe<UserTaxFormAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserTaxForm` objects. */
  distinctCount?: InputMaybe<UserTaxFormDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserTaxForm` object to be included within the aggregate. */
  filter?: InputMaybe<UserTaxFormFilter>;
  /** Maximum aggregate over matching `UserTaxForm` objects. */
  max?: InputMaybe<UserTaxFormMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserTaxForm` objects. */
  min?: InputMaybe<UserTaxFormMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserTaxForm` objects. */
  stddevPopulation?: InputMaybe<UserTaxFormStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserTaxForm` objects. */
  stddevSample?: InputMaybe<UserTaxFormStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserTaxForm` objects. */
  sum?: InputMaybe<UserTaxFormSumAggregateFilter>;
  /** Population variance aggregate over matching `UserTaxForm` objects. */
  variancePopulation?: InputMaybe<UserTaxFormVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserTaxForm` objects. */
  varianceSample?: InputMaybe<UserTaxFormVarianceSampleAggregateFilter>;
};

export type UserTaxFormAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTaxFormAverageAggregates = {
  __typename?: 'UserTaxFormAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserTaxForm` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserTaxFormCondition = {
  /** Checks for equality with the object’s `docusignEnvelopeId` field. */
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserTaxForm` values. */
export type UserTaxFormConnection = {
  __typename?: 'UserTaxFormConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserTaxFormAggregates>;
  /** A list of edges which contains the `UserTaxForm` and cursor to aid in pagination. */
  edges: Array<Maybe<UserTaxFormEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserTaxFormAggregates>>;
  /** A list of `UserTaxForm` objects. */
  nodes: Array<Maybe<UserTaxForm>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserTaxForm` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserTaxForm` values. */
export type UserTaxFormConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserTaxFormGroupBy>;
  having?: InputMaybe<UserTaxFormHavingInput>;
};

export type UserTaxFormDistinctCountAggregateFilter = {
  docusignEnvelopeId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserTaxFormDistinctCountAggregates = {
  __typename?: 'UserTaxFormDistinctCountAggregates';
  /** Distinct count of businessName across the matching connection */
  businessName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of docusignEnvelopeId across the matching connection */
  docusignEnvelopeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of entityType across the matching connection */
  entityType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventLog across the matching connection */
  eventLog?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of formType across the matching connection */
  formType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netSuiteFileId across the matching connection */
  netSuiteFileId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of uploadedToNetsuiteAt across the matching connection */
  uploadedToNetsuiteAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserTaxForm` edge in the connection. */
export type UserTaxFormEdge = {
  __typename?: 'UserTaxFormEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserTaxForm` at the end of the edge. */
  node?: Maybe<UserTaxForm>;
};

/** A filter to be used against `UserTaxForm` object types. All fields are combined with a logical ‘and.’ */
export type UserTaxFormFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserTaxFormFilter>>;
  /** Filter by the object’s `docusignEnvelopeId` field. */
  docusignEnvelopeId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserTaxFormFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserTaxFormFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserTaxForm` for usage during aggregation. */
export enum UserTaxFormGroupBy {
  DocusignEnvelopeId = 'DOCUSIGN_ENVELOPE_ID',
  UserId = 'USER_ID'
}

export type UserTaxFormHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserTaxForm` aggregates. */
export type UserTaxFormHavingInput = {
  AND?: InputMaybe<Array<UserTaxFormHavingInput>>;
  OR?: InputMaybe<Array<UserTaxFormHavingInput>>;
  average?: InputMaybe<UserTaxFormHavingAverageInput>;
  distinctCount?: InputMaybe<UserTaxFormHavingDistinctCountInput>;
  max?: InputMaybe<UserTaxFormHavingMaxInput>;
  min?: InputMaybe<UserTaxFormHavingMinInput>;
  stddevPopulation?: InputMaybe<UserTaxFormHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserTaxFormHavingStddevSampleInput>;
  sum?: InputMaybe<UserTaxFormHavingSumInput>;
  variancePopulation?: InputMaybe<UserTaxFormHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserTaxFormHavingVarianceSampleInput>;
};

export type UserTaxFormHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTaxFormHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  taxYear?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  uploadedToNetsuiteAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `UserTaxForm` */
export type UserTaxFormInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  entityType: UserTaxFormsEntityTypeEnum;
  eventLog?: InputMaybe<Scalars['JSON']['input']>;
  formType: UserTaxFormsFormTypeEnum;
  status?: InputMaybe<UserTaxFormsStatusEnum>;
  taxYear: Scalars['Int']['input'];
};

export type UserTaxFormMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserTaxFormMaxAggregates = {
  __typename?: 'UserTaxFormMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserTaxFormMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserTaxFormMinAggregates = {
  __typename?: 'UserTaxFormMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserTaxForm`. */
export enum UserTaxFormOrderBy {
  DocusignEnvelopeIdAsc = 'DOCUSIGN_ENVELOPE_ID_ASC',
  DocusignEnvelopeIdDesc = 'DOCUSIGN_ENVELOPE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Represents an update to a `UserTaxForm`. Fields that are set will be updated. */
export type UserTaxFormPatch = {
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  eventLog?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<UserTaxFormsStatusEnum>;
};

export type UserTaxFormStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTaxFormStddevPopulationAggregates = {
  __typename?: 'UserTaxFormStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserTaxFormStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTaxFormStddevSampleAggregates = {
  __typename?: 'UserTaxFormStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserTaxFormSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserTaxFormSumAggregates = {
  __typename?: 'UserTaxFormSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of taxYear across the matching connection */
  taxYear: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserTaxFormVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTaxFormVariancePopulationAggregates = {
  __typename?: 'UserTaxFormVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserTaxFormVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTaxFormVarianceSampleAggregates = {
  __typename?: 'UserTaxFormVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of taxYear across the matching connection */
  taxYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export enum UserTaxFormsEntityTypeEnum {
  Business = 'Business',
  Individual = 'Individual'
}

export enum UserTaxFormsFormTypeEnum {
  W8Ben = 'W8BEN',
  W9 = 'W9'
}

export enum UserTaxFormsStatusEnum {
  Completed = 'Completed',
  Declined = 'Declined',
  Pending = 'Pending',
  Voided = 'Voided'
}

export type UserTcPurchaseLimit = Node & {
  __typename?: 'UserTcPurchaseLimit';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastPurchaseDate?: Maybe<Scalars['Datetime']['output']>;
  purchaseCount: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserTcPurchaseLimit`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  yearMonth: Scalars['String']['output'];
};

export type UserTcPurchaseLimitAggregates = {
  __typename?: 'UserTcPurchaseLimitAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserTcPurchaseLimitAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserTcPurchaseLimitDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserTcPurchaseLimitMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserTcPurchaseLimitMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserTcPurchaseLimitStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserTcPurchaseLimitStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserTcPurchaseLimitSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserTcPurchaseLimitVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserTcPurchaseLimitVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserTcPurchaseLimit` object types. */
export type UserTcPurchaseLimitAggregatesFilter = {
  /** Mean average aggregate over matching `UserTcPurchaseLimit` objects. */
  average?: InputMaybe<UserTcPurchaseLimitAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserTcPurchaseLimit` objects. */
  distinctCount?: InputMaybe<UserTcPurchaseLimitDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserTcPurchaseLimit` object to be included within the aggregate. */
  filter?: InputMaybe<UserTcPurchaseLimitFilter>;
  /** Maximum aggregate over matching `UserTcPurchaseLimit` objects. */
  max?: InputMaybe<UserTcPurchaseLimitMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserTcPurchaseLimit` objects. */
  min?: InputMaybe<UserTcPurchaseLimitMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserTcPurchaseLimit` objects. */
  stddevPopulation?: InputMaybe<UserTcPurchaseLimitStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserTcPurchaseLimit` objects. */
  stddevSample?: InputMaybe<UserTcPurchaseLimitStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserTcPurchaseLimit` objects. */
  sum?: InputMaybe<UserTcPurchaseLimitSumAggregateFilter>;
  /** Population variance aggregate over matching `UserTcPurchaseLimit` objects. */
  variancePopulation?: InputMaybe<UserTcPurchaseLimitVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserTcPurchaseLimit` objects. */
  varianceSample?: InputMaybe<UserTcPurchaseLimitVarianceSampleAggregateFilter>;
};

export type UserTcPurchaseLimitAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTcPurchaseLimitAverageAggregates = {
  __typename?: 'UserTcPurchaseLimitAverageAggregates';
  /** Mean average of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserTcPurchaseLimit` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserTcPurchaseLimitCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `yearMonth` field. */
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `UserTcPurchaseLimit` values. */
export type UserTcPurchaseLimitConnection = {
  __typename?: 'UserTcPurchaseLimitConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserTcPurchaseLimitAggregates>;
  /** A list of edges which contains the `UserTcPurchaseLimit` and cursor to aid in pagination. */
  edges: Array<Maybe<UserTcPurchaseLimitEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserTcPurchaseLimitAggregates>>;
  /** A list of `UserTcPurchaseLimit` objects. */
  nodes: Array<Maybe<UserTcPurchaseLimit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserTcPurchaseLimit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserTcPurchaseLimit` values. */
export type UserTcPurchaseLimitConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserTcPurchaseLimitGroupBy>;
  having?: InputMaybe<UserTcPurchaseLimitHavingInput>;
};

export type UserTcPurchaseLimitDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
  yearMonth?: InputMaybe<BigIntFilter>;
};

export type UserTcPurchaseLimitDistinctCountAggregates = {
  __typename?: 'UserTcPurchaseLimitDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastPurchaseDate across the matching connection */
  lastPurchaseDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of yearMonth across the matching connection */
  yearMonth?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserTcPurchaseLimit` edge in the connection. */
export type UserTcPurchaseLimitEdge = {
  __typename?: 'UserTcPurchaseLimitEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserTcPurchaseLimit` at the end of the edge. */
  node?: Maybe<UserTcPurchaseLimit>;
};

/** A filter to be used against `UserTcPurchaseLimit` object types. All fields are combined with a logical ‘and.’ */
export type UserTcPurchaseLimitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserTcPurchaseLimitFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserTcPurchaseLimitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserTcPurchaseLimitFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `yearMonth` field. */
  yearMonth?: InputMaybe<StringFilter>;
};

/** Grouping methods for `UserTcPurchaseLimit` for usage during aggregation. */
export enum UserTcPurchaseLimitGroupBy {
  UserId = 'USER_ID',
  YearMonth = 'YEAR_MONTH'
}

export type UserTcPurchaseLimitHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserTcPurchaseLimit` aggregates. */
export type UserTcPurchaseLimitHavingInput = {
  AND?: InputMaybe<Array<UserTcPurchaseLimitHavingInput>>;
  OR?: InputMaybe<Array<UserTcPurchaseLimitHavingInput>>;
  average?: InputMaybe<UserTcPurchaseLimitHavingAverageInput>;
  distinctCount?: InputMaybe<UserTcPurchaseLimitHavingDistinctCountInput>;
  max?: InputMaybe<UserTcPurchaseLimitHavingMaxInput>;
  min?: InputMaybe<UserTcPurchaseLimitHavingMinInput>;
  stddevPopulation?: InputMaybe<UserTcPurchaseLimitHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserTcPurchaseLimitHavingStddevSampleInput>;
  sum?: InputMaybe<UserTcPurchaseLimitHavingSumInput>;
  variancePopulation?: InputMaybe<UserTcPurchaseLimitHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserTcPurchaseLimitHavingVarianceSampleInput>;
};

export type UserTcPurchaseLimitHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastPurchaseDate?: InputMaybe<HavingDatetimeFilter>;
  purchaseCount?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserTcPurchaseLimitMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserTcPurchaseLimitMaxAggregates = {
  __typename?: 'UserTcPurchaseLimitMaxAggregates';
  /** Maximum of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserTcPurchaseLimitMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserTcPurchaseLimitMinAggregates = {
  __typename?: 'UserTcPurchaseLimitMinAggregates';
  /** Minimum of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserTcPurchaseLimit`. */
export enum UserTcPurchaseLimitOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  YearMonthAsc = 'YEAR_MONTH_ASC',
  YearMonthDesc = 'YEAR_MONTH_DESC'
}

export type UserTcPurchaseLimitStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTcPurchaseLimitStddevPopulationAggregates = {
  __typename?: 'UserTcPurchaseLimitStddevPopulationAggregates';
  /** Population standard deviation of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserTcPurchaseLimitStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTcPurchaseLimitStddevSampleAggregates = {
  __typename?: 'UserTcPurchaseLimitStddevSampleAggregates';
  /** Sample standard deviation of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserTcPurchaseLimitSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserTcPurchaseLimitSumAggregates = {
  __typename?: 'UserTcPurchaseLimitSumAggregates';
  /** Sum of purchaseCount across the matching connection */
  purchaseCount: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserTcPurchaseLimitVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTcPurchaseLimitVariancePopulationAggregates = {
  __typename?: 'UserTcPurchaseLimitVariancePopulationAggregates';
  /** Population variance of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserTcPurchaseLimitVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserTcPurchaseLimitVarianceSampleAggregates = {
  __typename?: 'UserTcPurchaseLimitVarianceSampleAggregates';
  /** Sample variance of purchaseCount across the matching connection */
  purchaseCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against many `AccountCallUpDecisionCalculation` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAccountCallUpDecisionCalculationFilter = {
  /** Aggregates across related `AccountCallUpDecisionCalculation` match the filter criteria. */
  aggregates?: InputMaybe<AccountCallUpDecisionCalculationAggregatesFilter>;
  /** Every related `AccountCallUpDecisionCalculation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** No related `AccountCallUpDecisionCalculation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
  /** Some related `AccountCallUpDecisionCalculation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCallUpDecisionCalculationFilter>;
};

/** A filter to be used against many `AccountCallUpDecision` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAccountCallUpDecisionFilter = {
  /** Aggregates across related `AccountCallUpDecision` match the filter criteria. */
  aggregates?: InputMaybe<AccountCallUpDecisionAggregatesFilter>;
  /** Every related `AccountCallUpDecision` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCallUpDecisionFilter>;
  /** No related `AccountCallUpDecision` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCallUpDecisionFilter>;
  /** Some related `AccountCallUpDecision` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCallUpDecisionFilter>;
};

/** A filter to be used against many `AccountCapitalEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAccountCapitalEntryFilter = {
  /** Aggregates across related `AccountCapitalEntry` match the filter criteria. */
  aggregates?: InputMaybe<AccountCapitalEntryAggregatesFilter>;
  /** Every related `AccountCapitalEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCapitalEntryFilter>;
  /** No related `AccountCapitalEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCapitalEntryFilter>;
  /** Some related `AccountCapitalEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCapitalEntryFilter>;
};

/** A filter to be used against many `Account` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAccountFilter = {
  /** Aggregates across related `Account` match the filter criteria. */
  aggregates?: InputMaybe<AccountAggregatesFilter>;
  /** Every related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFilter>;
  /** No related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFilter>;
  /** Some related `Account` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFilter>;
};

/** A filter to be used against many `AccountResetLimit` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAccountResetLimitFilter = {
  /** Aggregates across related `AccountResetLimit` match the filter criteria. */
  aggregates?: InputMaybe<AccountResetLimitAggregatesFilter>;
  /** Every related `AccountResetLimit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountResetLimitFilter>;
  /** No related `AccountResetLimit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountResetLimitFilter>;
  /** Some related `AccountResetLimit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountResetLimitFilter>;
};

/** A filter to be used against many `AccountResetTracking` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAccountResetTrackingFilter = {
  /** Aggregates across related `AccountResetTracking` match the filter criteria. */
  aggregates?: InputMaybe<AccountResetTrackingAggregatesFilter>;
  /** Every related `AccountResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountResetTrackingFilter>;
  /** No related `AccountResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountResetTrackingFilter>;
  /** Some related `AccountResetTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountResetTrackingFilter>;
};

/** A filter to be used against many `AdminRoleUsersUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAdminRoleUsersUserFilter = {
  /** Aggregates across related `AdminRoleUsersUser` match the filter criteria. */
  aggregates?: InputMaybe<AdminRoleUsersUserAggregatesFilter>;
  /** Every related `AdminRoleUsersUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AdminRoleUsersUserFilter>;
  /** No related `AdminRoleUsersUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AdminRoleUsersUserFilter>;
  /** Some related `AdminRoleUsersUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AdminRoleUsersUserFilter>;
};

/** A filter to be used against many `CardTransaction` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyCardTransactionFilter = {
  /** Aggregates across related `CardTransaction` match the filter criteria. */
  aggregates?: InputMaybe<CardTransactionAggregatesFilter>;
  /** Every related `CardTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CardTransactionFilter>;
  /** No related `CardTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CardTransactionFilter>;
  /** Some related `CardTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CardTransactionFilter>;
};

/** A filter to be used against many `CheckoutSession` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyCheckoutSessionFilter = {
  /** Aggregates across related `CheckoutSession` match the filter criteria. */
  aggregates?: InputMaybe<CheckoutSessionAggregatesFilter>;
  /** Every related `CheckoutSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckoutSessionFilter>;
  /** No related `CheckoutSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckoutSessionFilter>;
  /** Some related `CheckoutSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckoutSessionFilter>;
};

/** A filter to be used against many `CouponUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyCouponUserFilter = {
  /** Aggregates across related `CouponUser` match the filter criteria. */
  aggregates?: InputMaybe<CouponUserAggregatesFilter>;
  /** Every related `CouponUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CouponUserFilter>;
  /** No related `CouponUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CouponUserFilter>;
  /** Some related `CouponUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CouponUserFilter>;
};

/** A filter to be used against many `Email` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEmailFilter = {
  /** Aggregates across related `Email` match the filter criteria. */
  aggregates?: InputMaybe<EmailAggregatesFilter>;
  /** Every related `Email` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmailFilter>;
  /** No related `Email` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmailFilter>;
  /** Some related `Email` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmailFilter>;
};

/** A filter to be used against many `GroupAdmin` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyGroupAdminFilter = {
  /** Aggregates across related `GroupAdmin` match the filter criteria. */
  aggregates?: InputMaybe<GroupAdminAggregatesFilter>;
  /** Every related `GroupAdmin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupAdminFilter>;
  /** No related `GroupAdmin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupAdminFilter>;
  /** Some related `GroupAdmin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupAdminFilter>;
};

/** A filter to be used against many `ImpactGroupAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyImpactGroupAssignmentFilter = {
  /** Aggregates across related `ImpactGroupAssignment` match the filter criteria. */
  aggregates?: InputMaybe<ImpactGroupAssignmentAggregatesFilter>;
  /** Every related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** No related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ImpactGroupAssignmentFilter>;
  /** Some related `ImpactGroupAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ImpactGroupAssignmentFilter>;
};

/** A filter to be used against many `NuveiSavedCard` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyNuveiSavedCardFilter = {
  /** Aggregates across related `NuveiSavedCard` match the filter criteria. */
  aggregates?: InputMaybe<NuveiSavedCardAggregatesFilter>;
  /** Every related `NuveiSavedCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NuveiSavedCardFilter>;
  /** No related `NuveiSavedCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NuveiSavedCardFilter>;
  /** Some related `NuveiSavedCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NuveiSavedCardFilter>;
};

/** A filter to be used against many `PasswordHistory` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPasswordHistoryFilter = {
  /** Aggregates across related `PasswordHistory` match the filter criteria. */
  aggregates?: InputMaybe<PasswordHistoryAggregatesFilter>;
  /** Every related `PasswordHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PasswordHistoryFilter>;
  /** No related `PasswordHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PasswordHistoryFilter>;
  /** Some related `PasswordHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PasswordHistoryFilter>;
};

/** A filter to be used against many `PayoutRequestBatch` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPayoutRequestBatchFilter = {
  /** Aggregates across related `PayoutRequestBatch` match the filter criteria. */
  aggregates?: InputMaybe<PayoutRequestBatchAggregatesFilter>;
  /** Every related `PayoutRequestBatch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutRequestBatchFilter>;
  /** No related `PayoutRequestBatch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutRequestBatchFilter>;
  /** Some related `PayoutRequestBatch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutRequestBatchFilter>;
};

/** A filter to be used against many `PayoutRequest` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPayoutRequestFilter = {
  /** Aggregates across related `PayoutRequest` match the filter criteria. */
  aggregates?: InputMaybe<PayoutRequestAggregatesFilter>;
  /** Every related `PayoutRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutRequestFilter>;
  /** No related `PayoutRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutRequestFilter>;
  /** Some related `PayoutRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutRequestFilter>;
};

/** A filter to be used against many `PayoutRequestSubscriber` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPayoutRequestSubscriberFilter = {
  /** Aggregates across related `PayoutRequestSubscriber` match the filter criteria. */
  aggregates?: InputMaybe<PayoutRequestSubscriberAggregatesFilter>;
  /** Every related `PayoutRequestSubscriber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PayoutRequestSubscriberFilter>;
  /** No related `PayoutRequestSubscriber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PayoutRequestSubscriberFilter>;
  /** Some related `PayoutRequestSubscriber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PayoutRequestSubscriberFilter>;
};

/** A filter to be used against many `PersonaWebhookEvent` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPersonaWebhookEventFilter = {
  /** Aggregates across related `PersonaWebhookEvent` match the filter criteria. */
  aggregates?: InputMaybe<PersonaWebhookEventAggregatesFilter>;
  /** Every related `PersonaWebhookEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PersonaWebhookEventFilter>;
  /** No related `PersonaWebhookEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PersonaWebhookEventFilter>;
  /** Some related `PersonaWebhookEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PersonaWebhookEventFilter>;
};

/** A filter to be used against many `PurchaseOrder` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPurchaseOrderFilter = {
  /** Aggregates across related `PurchaseOrder` match the filter criteria. */
  aggregates?: InputMaybe<PurchaseOrderAggregatesFilter>;
  /** Every related `PurchaseOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PurchaseOrderFilter>;
  /** No related `PurchaseOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PurchaseOrderFilter>;
  /** Some related `PurchaseOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PurchaseOrderFilter>;
};

/** A filter to be used against many `RebillSession` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyRebillSessionFilter = {
  /** Aggregates across related `RebillSession` match the filter criteria. */
  aggregates?: InputMaybe<RebillSessionAggregatesFilter>;
  /** Every related `RebillSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RebillSessionFilter>;
  /** No related `RebillSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RebillSessionFilter>;
  /** Some related `RebillSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RebillSessionFilter>;
};

/** A filter to be used against many `ResetCredit` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyResetCreditFilter = {
  /** Aggregates across related `ResetCredit` match the filter criteria. */
  aggregates?: InputMaybe<ResetCreditAggregatesFilter>;
  /** Every related `ResetCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ResetCreditFilter>;
  /** No related `ResetCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ResetCreditFilter>;
  /** Some related `ResetCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ResetCreditFilter>;
};

/** A filter to be used against many `SavedCard` object types. All fields are combined with a logical ‘and.’ */
export type UserToManySavedCardFilter = {
  /** Aggregates across related `SavedCard` match the filter criteria. */
  aggregates?: InputMaybe<SavedCardAggregatesFilter>;
  /** Every related `SavedCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SavedCardFilter>;
  /** No related `SavedCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SavedCardFilter>;
  /** Some related `SavedCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SavedCardFilter>;
};

/** A filter to be used against many `TaxInfo` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTaxInfoFilter = {
  /** Aggregates across related `TaxInfo` match the filter criteria. */
  aggregates?: InputMaybe<TaxInfoAggregatesFilter>;
  /** Every related `TaxInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaxInfoFilter>;
  /** No related `TaxInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaxInfoFilter>;
  /** Some related `TaxInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaxInfoFilter>;
};

/** A filter to be used against many `TraderProfileModerationCase` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTraderProfileModerationCaseFilter = {
  /** Aggregates across related `TraderProfileModerationCase` match the filter criteria. */
  aggregates?: InputMaybe<TraderProfileModerationCaseAggregatesFilter>;
  /** Every related `TraderProfileModerationCase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TraderProfileModerationCaseFilter>;
  /** No related `TraderProfileModerationCase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TraderProfileModerationCaseFilter>;
  /** Some related `TraderProfileModerationCase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TraderProfileModerationCaseFilter>;
};

/** A filter to be used against many `TraderRiskIndicator` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTraderRiskIndicatorFilter = {
  /** Aggregates across related `TraderRiskIndicator` match the filter criteria. */
  aggregates?: InputMaybe<TraderRiskIndicatorAggregatesFilter>;
  /** Every related `TraderRiskIndicator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TraderRiskIndicatorFilter>;
  /** No related `TraderRiskIndicator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TraderRiskIndicatorFilter>;
  /** Some related `TraderRiskIndicator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TraderRiskIndicatorFilter>;
};

/** A filter to be used against many `UserAddress` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserAddressFilter = {
  /** Aggregates across related `UserAddress` match the filter criteria. */
  aggregates?: InputMaybe<UserAddressAggregatesFilter>;
  /** Every related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAddressFilter>;
  /** No related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAddressFilter>;
  /** Some related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAddressFilter>;
};

/** A filter to be used against many `UserAdminRole` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserAdminRoleFilter = {
  /** Aggregates across related `UserAdminRole` match the filter criteria. */
  aggregates?: InputMaybe<UserAdminRoleAggregatesFilter>;
  /** Every related `UserAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAdminRoleFilter>;
  /** No related `UserAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAdminRoleFilter>;
  /** Some related `UserAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAdminRoleFilter>;
};

/** A filter to be used against many `UserAgreement` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserAgreementFilter = {
  /** Aggregates across related `UserAgreement` match the filter criteria. */
  aggregates?: InputMaybe<UserAgreementAggregatesFilter>;
  /** Every related `UserAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAgreementFilter>;
  /** No related `UserAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAgreementFilter>;
  /** Some related `UserAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAgreementFilter>;
};

/** A filter to be used against many `UserCertificate` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCertificateFilter = {
  /** Aggregates across related `UserCertificate` match the filter criteria. */
  aggregates?: InputMaybe<UserCertificateAggregatesFilter>;
  /** Every related `UserCertificate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCertificateFilter>;
  /** No related `UserCertificate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCertificateFilter>;
  /** Some related `UserCertificate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCertificateFilter>;
};

/** A filter to be used against many `UserCooldown` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCooldownFilter = {
  /** Aggregates across related `UserCooldown` match the filter criteria. */
  aggregates?: InputMaybe<UserCooldownAggregatesFilter>;
  /** Every related `UserCooldown` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCooldownFilter>;
  /** No related `UserCooldown` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCooldownFilter>;
  /** Some related `UserCooldown` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCooldownFilter>;
};

/** A filter to be used against many `UserMeteredEvent` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserMeteredEventFilter = {
  /** Aggregates across related `UserMeteredEvent` match the filter criteria. */
  aggregates?: InputMaybe<UserMeteredEventAggregatesFilter>;
  /** Every related `UserMeteredEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserMeteredEventFilter>;
  /** No related `UserMeteredEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserMeteredEventFilter>;
  /** Some related `UserMeteredEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserMeteredEventFilter>;
};

/** A filter to be used against many `UserNote` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserNoteFilter = {
  /** Aggregates across related `UserNote` match the filter criteria. */
  aggregates?: InputMaybe<UserNoteAggregatesFilter>;
  /** Every related `UserNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserNoteFilter>;
  /** No related `UserNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserNoteFilter>;
  /** Some related `UserNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserNoteFilter>;
};

/** A filter to be used against many `UserPlatformCredential` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserPlatformCredentialFilter = {
  /** Aggregates across related `UserPlatformCredential` match the filter criteria. */
  aggregates?: InputMaybe<UserPlatformCredentialAggregatesFilter>;
  /** Every related `UserPlatformCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPlatformCredentialFilter>;
  /** No related `UserPlatformCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPlatformCredentialFilter>;
  /** Some related `UserPlatformCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPlatformCredentialFilter>;
};

/** A filter to be used against many `UserRolesAdminRole` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserRolesAdminRoleFilter = {
  /** Aggregates across related `UserRolesAdminRole` match the filter criteria. */
  aggregates?: InputMaybe<UserRolesAdminRoleAggregatesFilter>;
  /** Every related `UserRolesAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRolesAdminRoleFilter>;
  /** No related `UserRolesAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRolesAdminRoleFilter>;
  /** Some related `UserRolesAdminRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRolesAdminRoleFilter>;
};

/** A filter to be used against many `UserTaxForm` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserTaxFormFilter = {
  /** Aggregates across related `UserTaxForm` match the filter criteria. */
  aggregates?: InputMaybe<UserTaxFormAggregatesFilter>;
  /** Every related `UserTaxForm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserTaxFormFilter>;
  /** No related `UserTaxForm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserTaxFormFilter>;
  /** Some related `UserTaxForm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserTaxFormFilter>;
};

/** A filter to be used against many `UserTcPurchaseLimit` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserTcPurchaseLimitFilter = {
  /** Aggregates across related `UserTcPurchaseLimit` match the filter criteria. */
  aggregates?: InputMaybe<UserTcPurchaseLimitAggregatesFilter>;
  /** Every related `UserTcPurchaseLimit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserTcPurchaseLimitFilter>;
  /** No related `UserTcPurchaseLimit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserTcPurchaseLimitFilter>;
  /** Some related `UserTcPurchaseLimit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserTcPurchaseLimitFilter>;
};

/** A filter to be used against many `UserXfaCooldown` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserXfaCooldownFilter = {
  /** Aggregates across related `UserXfaCooldown` match the filter criteria. */
  aggregates?: InputMaybe<UserXfaCooldownAggregatesFilter>;
  /** Every related `UserXfaCooldown` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserXfaCooldownFilter>;
  /** No related `UserXfaCooldown` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserXfaCooldownFilter>;
  /** Some related `UserXfaCooldown` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserXfaCooldownFilter>;
};

/** A filter to be used against many `Verification` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyVerificationFilter = {
  /** Aggregates across related `Verification` match the filter criteria. */
  aggregates?: InputMaybe<VerificationAggregatesFilter>;
  /** Every related `Verification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<VerificationFilter>;
  /** No related `Verification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<VerificationFilter>;
  /** Some related `Verification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<VerificationFilter>;
};

export type UserVariancePopulationAggregates = {
  __typename?: 'UserVariancePopulationAggregates';
  /** Population variance of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserVarianceSampleAggregates = {
  __typename?: 'UserVarianceSampleAggregates';
  /** Sample variance of this field across the matching connection. */
  accountTotal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of legacyAppId across the matching connection */
  legacyAppId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of netSuiteId across the matching connection */
  netSuiteId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectXUserId across the matching connection */
  projectXUserId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserXfaCooldown = Node & {
  __typename?: 'UserXfaCooldown';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  lastMllBreachAt: Scalars['Datetime']['output'];
  rowId: Scalars['Int']['output'];
  /** Reads a single `Account` that is related to this `UserXfaCooldown`. */
  triggeredByAccount?: Maybe<Account>;
  triggeredByAccountId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserXfaCooldown`. */
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserXfaCooldownAggregates = {
  __typename?: 'UserXfaCooldownAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UserXfaCooldownAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserXfaCooldownDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UserXfaCooldownMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UserXfaCooldownMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UserXfaCooldownStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UserXfaCooldownStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UserXfaCooldownSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UserXfaCooldownVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UserXfaCooldownVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `UserXfaCooldown` object types. */
export type UserXfaCooldownAggregatesFilter = {
  /** Mean average aggregate over matching `UserXfaCooldown` objects. */
  average?: InputMaybe<UserXfaCooldownAverageAggregateFilter>;
  /** Distinct count aggregate over matching `UserXfaCooldown` objects. */
  distinctCount?: InputMaybe<UserXfaCooldownDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserXfaCooldown` object to be included within the aggregate. */
  filter?: InputMaybe<UserXfaCooldownFilter>;
  /** Maximum aggregate over matching `UserXfaCooldown` objects. */
  max?: InputMaybe<UserXfaCooldownMaxAggregateFilter>;
  /** Minimum aggregate over matching `UserXfaCooldown` objects. */
  min?: InputMaybe<UserXfaCooldownMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `UserXfaCooldown` objects. */
  stddevPopulation?: InputMaybe<UserXfaCooldownStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `UserXfaCooldown` objects. */
  stddevSample?: InputMaybe<UserXfaCooldownStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `UserXfaCooldown` objects. */
  sum?: InputMaybe<UserXfaCooldownSumAggregateFilter>;
  /** Population variance aggregate over matching `UserXfaCooldown` objects. */
  variancePopulation?: InputMaybe<UserXfaCooldownVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `UserXfaCooldown` objects. */
  varianceSample?: InputMaybe<UserXfaCooldownVarianceSampleAggregateFilter>;
};

export type UserXfaCooldownAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserXfaCooldownAverageAggregates = {
  __typename?: 'UserXfaCooldownAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UserXfaCooldown` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserXfaCooldownCondition = {
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UserXfaCooldown` values. */
export type UserXfaCooldownConnection = {
  __typename?: 'UserXfaCooldownConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserXfaCooldownAggregates>;
  /** A list of edges which contains the `UserXfaCooldown` and cursor to aid in pagination. */
  edges: Array<Maybe<UserXfaCooldownEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserXfaCooldownAggregates>>;
  /** A list of `UserXfaCooldown` objects. */
  nodes: Array<Maybe<UserXfaCooldown>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserXfaCooldown` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `UserXfaCooldown` values. */
export type UserXfaCooldownConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserXfaCooldownGroupBy>;
  having?: InputMaybe<UserXfaCooldownHavingInput>;
};

export type UserXfaCooldownDistinctCountAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserXfaCooldownDistinctCountAggregates = {
  __typename?: 'UserXfaCooldownDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastMllBreachAt across the matching connection */
  lastMllBreachAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `UserXfaCooldown` edge in the connection. */
export type UserXfaCooldownEdge = {
  __typename?: 'UserXfaCooldownEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserXfaCooldown` at the end of the edge. */
  node?: Maybe<UserXfaCooldown>;
};

/** A filter to be used against `UserXfaCooldown` object types. All fields are combined with a logical ‘and.’ */
export type UserXfaCooldownFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserXfaCooldownFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserXfaCooldownFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserXfaCooldownFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triggeredByAccount` relation. */
  triggeredByAccount?: InputMaybe<AccountFilter>;
  /** A related `triggeredByAccount` exists. */
  triggeredByAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `UserXfaCooldown` for usage during aggregation. */
export enum UserXfaCooldownGroupBy {
  UserId = 'USER_ID'
}

export type UserXfaCooldownHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UserXfaCooldown` aggregates. */
export type UserXfaCooldownHavingInput = {
  AND?: InputMaybe<Array<UserXfaCooldownHavingInput>>;
  OR?: InputMaybe<Array<UserXfaCooldownHavingInput>>;
  average?: InputMaybe<UserXfaCooldownHavingAverageInput>;
  distinctCount?: InputMaybe<UserXfaCooldownHavingDistinctCountInput>;
  max?: InputMaybe<UserXfaCooldownHavingMaxInput>;
  min?: InputMaybe<UserXfaCooldownHavingMinInput>;
  stddevPopulation?: InputMaybe<UserXfaCooldownHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserXfaCooldownHavingStddevSampleInput>;
  sum?: InputMaybe<UserXfaCooldownHavingSumInput>;
  variancePopulation?: InputMaybe<UserXfaCooldownHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserXfaCooldownHavingVarianceSampleInput>;
};

export type UserXfaCooldownHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastMllBreachAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  triggeredByAccountId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type UserXfaCooldownMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserXfaCooldownMaxAggregates = {
  __typename?: 'UserXfaCooldownMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserXfaCooldownMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserXfaCooldownMinAggregates = {
  __typename?: 'UserXfaCooldownMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `UserXfaCooldown`. */
export enum UserXfaCooldownOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserXfaCooldownStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserXfaCooldownStddevPopulationAggregates = {
  __typename?: 'UserXfaCooldownStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserXfaCooldownStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserXfaCooldownStddevSampleAggregates = {
  __typename?: 'UserXfaCooldownStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserXfaCooldownSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserXfaCooldownSumAggregates = {
  __typename?: 'UserXfaCooldownSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of triggeredByAccountId across the matching connection */
  triggeredByAccountId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type UserXfaCooldownVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserXfaCooldownVariancePopulationAggregates = {
  __typename?: 'UserXfaCooldownVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UserXfaCooldownVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type UserXfaCooldownVarianceSampleAggregates = {
  __typename?: 'UserXfaCooldownVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of triggeredByAccountId across the matching connection */
  triggeredByAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Verification = Node & {
  __typename?: 'Verification';
  adminUrl?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  riskLabels?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Verification`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type VerificationAggregates = {
  __typename?: 'VerificationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<VerificationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<VerificationDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<VerificationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<VerificationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<VerificationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<VerificationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<VerificationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<VerificationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<VerificationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Verification` object types. */
export type VerificationAggregatesFilter = {
  /** Mean average aggregate over matching `Verification` objects. */
  average?: InputMaybe<VerificationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Verification` objects. */
  distinctCount?: InputMaybe<VerificationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Verification` object to be included within the aggregate. */
  filter?: InputMaybe<VerificationFilter>;
  /** Maximum aggregate over matching `Verification` objects. */
  max?: InputMaybe<VerificationMaxAggregateFilter>;
  /** Minimum aggregate over matching `Verification` objects. */
  min?: InputMaybe<VerificationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Verification` objects. */
  stddevPopulation?: InputMaybe<VerificationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Verification` objects. */
  stddevSample?: InputMaybe<VerificationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Verification` objects. */
  sum?: InputMaybe<VerificationSumAggregateFilter>;
  /** Population variance aggregate over matching `Verification` objects. */
  variancePopulation?: InputMaybe<VerificationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Verification` objects. */
  varianceSample?: InputMaybe<VerificationVarianceSampleAggregateFilter>;
};

export type VerificationAverageAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type VerificationAverageAggregates = {
  __typename?: 'VerificationAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Verification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VerificationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Verification` values. */
export type VerificationConnection = {
  __typename?: 'VerificationConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<VerificationAggregates>;
  /** A list of edges which contains the `Verification` and cursor to aid in pagination. */
  edges: Array<Maybe<VerificationEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<VerificationAggregates>>;
  /** A list of `Verification` objects. */
  nodes: Array<Maybe<Verification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Verification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Verification` values. */
export type VerificationConnectionGroupedAggregatesArgs = {
  groupBy: Array<VerificationGroupBy>;
  having?: InputMaybe<VerificationHavingInput>;
};

export type VerificationDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type VerificationDistinctCountAggregates = {
  __typename?: 'VerificationDistinctCountAggregates';
  /** Distinct count of adminUrl across the matching connection */
  adminUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of approvedAt across the matching connection */
  approvedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expiresAt across the matching connection */
  expiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadata across the matching connection */
  metadata?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reference across the matching connection */
  reference?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of riskLabels across the matching connection */
  riskLabels?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of submittedAt across the matching connection */
  submittedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of url across the matching connection */
  url?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `Verification` edge in the connection. */
export type VerificationEdge = {
  __typename?: 'VerificationEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Verification` at the end of the edge. */
  node?: Maybe<Verification>;
};

/** A filter to be used against `Verification` object types. All fields are combined with a logical ‘and.’ */
export type VerificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VerificationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VerificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VerificationFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Verification` for usage during aggregation. */
export enum VerificationGroupBy {
  CreatedAt = 'CREATED_AT',
  CreatedAtTruncatedToDay = 'CREATED_AT_TRUNCATED_TO_DAY',
  CreatedAtTruncatedToHour = 'CREATED_AT_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  UserId = 'USER_ID'
}

export type VerificationHavingAverageInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingDistinctCountInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Verification` aggregates. */
export type VerificationHavingInput = {
  AND?: InputMaybe<Array<VerificationHavingInput>>;
  OR?: InputMaybe<Array<VerificationHavingInput>>;
  average?: InputMaybe<VerificationHavingAverageInput>;
  distinctCount?: InputMaybe<VerificationHavingDistinctCountInput>;
  max?: InputMaybe<VerificationHavingMaxInput>;
  min?: InputMaybe<VerificationHavingMinInput>;
  stddevPopulation?: InputMaybe<VerificationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<VerificationHavingStddevSampleInput>;
  sum?: InputMaybe<VerificationHavingSumInput>;
  variancePopulation?: InputMaybe<VerificationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<VerificationHavingVarianceSampleInput>;
};

export type VerificationHavingMaxInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingMinInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingStddevPopulationInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingStddevSampleInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingSumInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingVariancePopulationInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationHavingVarianceSampleInput = {
  approvedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type VerificationMaxAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type VerificationMaxAggregates = {
  __typename?: 'VerificationMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type VerificationMinAggregateFilter = {
  rowId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type VerificationMinAggregates = {
  __typename?: 'VerificationMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Verification`. */
export enum VerificationOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type VerificationStddevPopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type VerificationStddevPopulationAggregates = {
  __typename?: 'VerificationStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type VerificationStddevSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type VerificationStddevSampleAggregates = {
  __typename?: 'VerificationStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type VerificationSumAggregateFilter = {
  rowId?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type VerificationSumAggregates = {
  __typename?: 'VerificationSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type VerificationVariancePopulationAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type VerificationVariancePopulationAggregates = {
  __typename?: 'VerificationVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type VerificationVarianceSampleAggregateFilter = {
  rowId?: InputMaybe<BigFloatFilter>;
  userId?: InputMaybe<BigFloatFilter>;
};

export type VerificationVarianceSampleAggregates = {
  __typename?: 'VerificationVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type VoidAccountCapitalEntryInput = {
  /** Acknowledge that a payout is still open on the account and its entitlement was computed against these grants. */
  confirmOutstandingPayout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Acknowledge that the reversal exceeds undrawn seed capital, clawing back money already withdrawn. */
  confirmUndrawnShortfall?: InputMaybe<Scalars['Boolean']['input']>;
  entryId: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

/** Result of starting W-8BEN signing process */
export type W8BenSigningResult = {
  __typename?: 'W8BENSigningResult';
  /** DocuSign envelope ID */
  envelopeId?: Maybe<Scalars['String']['output']>;
  /** Error message if request failed */
  error?: Maybe<Scalars['String']['output']>;
  /** URL to redirect user to for signing */
  signingUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the request was successful */
  success: Scalars['Boolean']['output'];
};

/** Result of starting W-9 signing process */
export type W9SigningResult = {
  __typename?: 'W9SigningResult';
  /** DocuSign envelope ID */
  envelopeId?: Maybe<Scalars['String']['output']>;
  /** Error message if request failed */
  error?: Maybe<Scalars['String']['output']>;
  /** URL to redirect user to for signing */
  signingUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the request was successful */
  success: Scalars['Boolean']['output'];
};

export type WorstTradingDay = {
  __typename?: 'WorstTradingDay';
  averageLosingTrade: Scalars['Float']['output'];
  averageTradeDuration?: Maybe<Scalars['String']['output']>;
  averageWinningTrade: Scalars['Float']['output'];
  consistency: Scalars['Float']['output'];
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  profitFactor: Scalars['Float']['output'];
  tradeWinPercentage: Scalars['Float']['output'];
  tradingSession?: Maybe<Scalars['String']['output']>;
  worstDayDate?: Maybe<Scalars['String']['output']>;
  worstDayPnl: Scalars['Float']['output'];
};

export type XfaActivationCredit = Node & {
  __typename?: 'XfaActivationCredit';
  createdAt: Scalars['Datetime']['output'];
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  issuedOn: Scalars['Datetime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status: XfaActivationCreditStatusEnum;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['Int']['output'];
};

export type XfaActivationCreditAggregates = {
  __typename?: 'XfaActivationCreditAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<XfaActivationCreditAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<XfaActivationCreditDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<XfaActivationCreditMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<XfaActivationCreditMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<XfaActivationCreditStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<XfaActivationCreditStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<XfaActivationCreditSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<XfaActivationCreditVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<XfaActivationCreditVarianceSampleAggregates>;
};

export type XfaActivationCreditAverageAggregates = {
  __typename?: 'XfaActivationCreditAverageAggregates';
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `XfaActivationCredit` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type XfaActivationCreditCondition = {
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `XfaActivationCredit` values. */
export type XfaActivationCreditConnection = {
  __typename?: 'XfaActivationCreditConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<XfaActivationCreditAggregates>;
  /** A list of edges which contains the `XfaActivationCredit` and cursor to aid in pagination. */
  edges: Array<Maybe<XfaActivationCreditEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<XfaActivationCreditAggregates>>;
  /** A list of `XfaActivationCredit` objects. */
  nodes: Array<Maybe<XfaActivationCredit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `XfaActivationCredit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `XfaActivationCredit` values. */
export type XfaActivationCreditConnectionGroupedAggregatesArgs = {
  groupBy: Array<XfaActivationCreditGroupBy>;
  having?: InputMaybe<XfaActivationCreditHavingInput>;
};

export type XfaActivationCreditDistinctCountAggregates = {
  __typename?: 'XfaActivationCreditDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of expiresAt across the matching connection */
  expiresAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedOn across the matching connection */
  issuedOn?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `XfaActivationCredit` edge in the connection. */
export type XfaActivationCreditEdge = {
  __typename?: 'XfaActivationCreditEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `XfaActivationCredit` at the end of the edge. */
  node?: Maybe<XfaActivationCredit>;
};

/** A filter to be used against `XfaActivationCredit` object types. All fields are combined with a logical ‘and.’ */
export type XfaActivationCreditFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<XfaActivationCreditFilter>>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<XfaActivationCreditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<XfaActivationCreditFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<XfaActivationCreditStatusEnumFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `XfaActivationCredit` for usage during aggregation. */
export enum XfaActivationCreditGroupBy {
  ExpiresAt = 'EXPIRES_AT',
  ExpiresAtTruncatedToDay = 'EXPIRES_AT_TRUNCATED_TO_DAY',
  ExpiresAtTruncatedToHour = 'EXPIRES_AT_TRUNCATED_TO_HOUR',
  Status = 'STATUS',
  UserId = 'USER_ID'
}

export type XfaActivationCreditHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `XfaActivationCredit` aggregates. */
export type XfaActivationCreditHavingInput = {
  AND?: InputMaybe<Array<XfaActivationCreditHavingInput>>;
  OR?: InputMaybe<Array<XfaActivationCreditHavingInput>>;
  average?: InputMaybe<XfaActivationCreditHavingAverageInput>;
  distinctCount?: InputMaybe<XfaActivationCreditHavingDistinctCountInput>;
  max?: InputMaybe<XfaActivationCreditHavingMaxInput>;
  min?: InputMaybe<XfaActivationCreditHavingMinInput>;
  stddevPopulation?: InputMaybe<XfaActivationCreditHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<XfaActivationCreditHavingStddevSampleInput>;
  sum?: InputMaybe<XfaActivationCreditHavingSumInput>;
  variancePopulation?: InputMaybe<XfaActivationCreditHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<XfaActivationCreditHavingVarianceSampleInput>;
};

export type XfaActivationCreditHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

export type XfaActivationCreditHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expiresAt?: InputMaybe<HavingDatetimeFilter>;
  issuedOn?: InputMaybe<HavingDatetimeFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
  subscriptionId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  userId?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `XfaActivationCredit` */
export type XfaActivationCreditInput = {
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  issuedOn: Scalars['Datetime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<XfaActivationCreditStatusEnum>;
  userId: Scalars['Int']['input'];
};

export type XfaActivationCreditMaxAggregates = {
  __typename?: 'XfaActivationCreditMaxAggregates';
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type XfaActivationCreditMinAggregates = {
  __typename?: 'XfaActivationCreditMinAggregates';
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of userId across the matching connection */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `XfaActivationCredit`. */
export enum XfaActivationCreditOrderBy {
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Represents an update to a `XfaActivationCredit`. Fields that are set will be updated. */
export type XfaActivationCreditPatch = {
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<XfaActivationCreditStatusEnum>;
};

export enum XfaActivationCreditStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

/** A filter to be used against XfaActivationCreditStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type XfaActivationCreditStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<XfaActivationCreditStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<XfaActivationCreditStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<XfaActivationCreditStatusEnum>>;
};

export type XfaActivationCreditStddevPopulationAggregates = {
  __typename?: 'XfaActivationCreditStddevPopulationAggregates';
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaActivationCreditStddevSampleAggregates = {
  __typename?: 'XfaActivationCreditStddevSampleAggregates';
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaActivationCreditSumAggregates = {
  __typename?: 'XfaActivationCreditSumAggregates';
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
  /** Sum of subscriptionId across the matching connection */
  subscriptionId: Scalars['BigInt']['output'];
  /** Sum of userId across the matching connection */
  userId: Scalars['BigInt']['output'];
};

export type XfaActivationCreditVariancePopulationAggregates = {
  __typename?: 'XfaActivationCreditVariancePopulationAggregates';
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaActivationCreditVarianceSampleAggregates = {
  __typename?: 'XfaActivationCreditVarianceSampleAggregates';
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of subscriptionId across the matching connection */
  subscriptionId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of userId across the matching connection */
  userId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaConsistencyMetrics = {
  __typename?: 'XfaConsistencyMetrics';
  consistencyPercentage: Scalars['Int']['output'];
  consistencyRatio: Scalars['Float']['output'];
  daysInWindow: Scalars['Int']['output'];
  eligibilityReason?: Maybe<Scalars['String']['output']>;
  isEligible: Scalars['Boolean']['output'];
  largestDayDate?: Maybe<Scalars['String']['output']>;
  largestDayProfit: Scalars['Float']['output'];
  pendingPayout: Scalars['Boolean']['output'];
  targetPercentage: Scalars['Int']['output'];
  totalProfit: Scalars['Float']['output'];
};

export type XfaResetTracking = Node & {
  __typename?: 'XfaResetTracking';
  activationScheduledAt?: Maybe<Scalars['Datetime']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  branchId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output'];
  /** Reads a single `Account` that is related to this `XfaResetTracking`. */
  parentAccount?: Maybe<Account>;
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Account` that is related to this `XfaResetTracking`. */
  resetAccount?: Maybe<Account>;
  resetAccountId: Scalars['Int']['output'];
  rowId: Scalars['Int']['output'];
};

export type XfaResetTrackingAggregates = {
  __typename?: 'XfaResetTrackingAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<XfaResetTrackingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<XfaResetTrackingDistinctCountAggregates>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<XfaResetTrackingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<XfaResetTrackingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<XfaResetTrackingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<XfaResetTrackingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<XfaResetTrackingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<XfaResetTrackingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<XfaResetTrackingVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `XfaResetTracking` object types. */
export type XfaResetTrackingAggregatesFilter = {
  /** Mean average aggregate over matching `XfaResetTracking` objects. */
  average?: InputMaybe<XfaResetTrackingAverageAggregateFilter>;
  /** Distinct count aggregate over matching `XfaResetTracking` objects. */
  distinctCount?: InputMaybe<XfaResetTrackingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `XfaResetTracking` object to be included within the aggregate. */
  filter?: InputMaybe<XfaResetTrackingFilter>;
  /** Maximum aggregate over matching `XfaResetTracking` objects. */
  max?: InputMaybe<XfaResetTrackingMaxAggregateFilter>;
  /** Minimum aggregate over matching `XfaResetTracking` objects. */
  min?: InputMaybe<XfaResetTrackingMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `XfaResetTracking` objects. */
  stddevPopulation?: InputMaybe<XfaResetTrackingStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `XfaResetTracking` objects. */
  stddevSample?: InputMaybe<XfaResetTrackingStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `XfaResetTracking` objects. */
  sum?: InputMaybe<XfaResetTrackingSumAggregateFilter>;
  /** Population variance aggregate over matching `XfaResetTracking` objects. */
  variancePopulation?: InputMaybe<XfaResetTrackingVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `XfaResetTracking` objects. */
  varianceSample?: InputMaybe<XfaResetTrackingVarianceSampleAggregateFilter>;
};

export type XfaResetTrackingAverageAggregateFilter = {
  parentAccountId?: InputMaybe<BigFloatFilter>;
  resetAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type XfaResetTrackingAverageAggregates = {
  __typename?: 'XfaResetTrackingAverageAggregates';
  /** Mean average of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `XfaResetTracking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type XfaResetTrackingCondition = {
  /** Checks for equality with the object’s `activationScheduledAt` field. */
  activationScheduledAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `activationStatus` field. */
  activationStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `branchId` field. */
  branchId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `parentAccountId` field. */
  parentAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `resetAccountId` field. */
  resetAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `XfaResetTracking` values. */
export type XfaResetTrackingConnection = {
  __typename?: 'XfaResetTrackingConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<XfaResetTrackingAggregates>;
  /** A list of edges which contains the `XfaResetTracking` and cursor to aid in pagination. */
  edges: Array<Maybe<XfaResetTrackingEdge>>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<XfaResetTrackingAggregates>>;
  /** A list of `XfaResetTracking` objects. */
  nodes: Array<Maybe<XfaResetTracking>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `XfaResetTracking` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `XfaResetTracking` values. */
export type XfaResetTrackingConnectionGroupedAggregatesArgs = {
  groupBy: Array<XfaResetTrackingGroupBy>;
  having?: InputMaybe<XfaResetTrackingHavingInput>;
};

export type XfaResetTrackingDistinctCountAggregateFilter = {
  activationScheduledAt?: InputMaybe<BigIntFilter>;
  activationStatus?: InputMaybe<BigIntFilter>;
  branchId?: InputMaybe<BigIntFilter>;
  parentAccountId?: InputMaybe<BigIntFilter>;
  resetAccountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type XfaResetTrackingDistinctCountAggregates = {
  __typename?: 'XfaResetTrackingDistinctCountAggregates';
  /** Distinct count of activationScheduledAt across the matching connection */
  activationScheduledAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of activationStatus across the matching connection */
  activationStatus?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of branchId across the matching connection */
  branchId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigInt']['output']>;
};

/** A `XfaResetTracking` edge in the connection. */
export type XfaResetTrackingEdge = {
  __typename?: 'XfaResetTrackingEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `XfaResetTracking` at the end of the edge. */
  node?: Maybe<XfaResetTracking>;
};

/** A filter to be used against `XfaResetTracking` object types. All fields are combined with a logical ‘and.’ */
export type XfaResetTrackingFilter = {
  /** Filter by the object’s `activationScheduledAt` field. */
  activationScheduledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `activationStatus` field. */
  activationStatus?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<XfaResetTrackingFilter>>;
  /** Filter by the object’s `branchId` field. */
  branchId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<XfaResetTrackingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<XfaResetTrackingFilter>>;
  /** Filter by the object’s `parentAccount` relation. */
  parentAccount?: InputMaybe<AccountFilter>;
  /** A related `parentAccount` exists. */
  parentAccountExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `parentAccountId` field. */
  parentAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `resetAccount` relation. */
  resetAccount?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `resetAccountId` field. */
  resetAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `XfaResetTracking` for usage during aggregation. */
export enum XfaResetTrackingGroupBy {
  ActivationScheduledAt = 'ACTIVATION_SCHEDULED_AT',
  ActivationScheduledAtTruncatedToDay = 'ACTIVATION_SCHEDULED_AT_TRUNCATED_TO_DAY',
  ActivationScheduledAtTruncatedToHour = 'ACTIVATION_SCHEDULED_AT_TRUNCATED_TO_HOUR',
  ActivationStatus = 'ACTIVATION_STATUS',
  BranchId = 'BRANCH_ID',
  ParentAccountId = 'PARENT_ACCOUNT_ID',
  ResetAccountId = 'RESET_ACCOUNT_ID'
}

export type XfaResetTrackingHavingAverageInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingDistinctCountInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `XfaResetTracking` aggregates. */
export type XfaResetTrackingHavingInput = {
  AND?: InputMaybe<Array<XfaResetTrackingHavingInput>>;
  OR?: InputMaybe<Array<XfaResetTrackingHavingInput>>;
  average?: InputMaybe<XfaResetTrackingHavingAverageInput>;
  distinctCount?: InputMaybe<XfaResetTrackingHavingDistinctCountInput>;
  max?: InputMaybe<XfaResetTrackingHavingMaxInput>;
  min?: InputMaybe<XfaResetTrackingHavingMinInput>;
  stddevPopulation?: InputMaybe<XfaResetTrackingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<XfaResetTrackingHavingStddevSampleInput>;
  sum?: InputMaybe<XfaResetTrackingHavingSumInput>;
  variancePopulation?: InputMaybe<XfaResetTrackingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<XfaResetTrackingHavingVarianceSampleInput>;
};

export type XfaResetTrackingHavingMaxInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingMinInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingStddevPopulationInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingStddevSampleInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingSumInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingVariancePopulationInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingHavingVarianceSampleInput = {
  activationScheduledAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  parentAccountId?: InputMaybe<HavingIntFilter>;
  resetAccountId?: InputMaybe<HavingIntFilter>;
  rowId?: InputMaybe<HavingIntFilter>;
};

export type XfaResetTrackingMaxAggregateFilter = {
  parentAccountId?: InputMaybe<IntFilter>;
  resetAccountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type XfaResetTrackingMaxAggregates = {
  __typename?: 'XfaResetTrackingMaxAggregates';
  /** Maximum of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

export type XfaResetTrackingMinAggregateFilter = {
  parentAccountId?: InputMaybe<IntFilter>;
  resetAccountId?: InputMaybe<IntFilter>;
  rowId?: InputMaybe<IntFilter>;
};

export type XfaResetTrackingMinAggregates = {
  __typename?: 'XfaResetTrackingMinAggregates';
  /** Minimum of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rowId across the matching connection */
  rowId?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `XfaResetTracking`. */
export enum XfaResetTrackingOrderBy {
  ActivationScheduledAtAsc = 'ACTIVATION_SCHEDULED_AT_ASC',
  ActivationScheduledAtDesc = 'ACTIVATION_SCHEDULED_AT_DESC',
  ActivationStatusAsc = 'ACTIVATION_STATUS_ASC',
  ActivationStatusDesc = 'ACTIVATION_STATUS_DESC',
  BranchIdAsc = 'BRANCH_ID_ASC',
  BranchIdDesc = 'BRANCH_ID_DESC',
  Natural = 'NATURAL',
  ParentAccountIdAsc = 'PARENT_ACCOUNT_ID_ASC',
  ParentAccountIdDesc = 'PARENT_ACCOUNT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResetAccountIdAsc = 'RESET_ACCOUNT_ID_ASC',
  ResetAccountIdDesc = 'RESET_ACCOUNT_ID_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC'
}

export type XfaResetTrackingStddevPopulationAggregateFilter = {
  parentAccountId?: InputMaybe<BigFloatFilter>;
  resetAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type XfaResetTrackingStddevPopulationAggregates = {
  __typename?: 'XfaResetTrackingStddevPopulationAggregates';
  /** Population standard deviation of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaResetTrackingStddevSampleAggregateFilter = {
  parentAccountId?: InputMaybe<BigFloatFilter>;
  resetAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type XfaResetTrackingStddevSampleAggregates = {
  __typename?: 'XfaResetTrackingStddevSampleAggregates';
  /** Sample standard deviation of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaResetTrackingSumAggregateFilter = {
  parentAccountId?: InputMaybe<BigIntFilter>;
  resetAccountId?: InputMaybe<BigIntFilter>;
  rowId?: InputMaybe<BigIntFilter>;
};

export type XfaResetTrackingSumAggregates = {
  __typename?: 'XfaResetTrackingSumAggregates';
  /** Sum of parentAccountId across the matching connection */
  parentAccountId: Scalars['BigInt']['output'];
  /** Sum of resetAccountId across the matching connection */
  resetAccountId: Scalars['BigInt']['output'];
  /** Sum of rowId across the matching connection */
  rowId: Scalars['BigInt']['output'];
};

export type XfaResetTrackingVariancePopulationAggregateFilter = {
  parentAccountId?: InputMaybe<BigFloatFilter>;
  resetAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type XfaResetTrackingVariancePopulationAggregates = {
  __typename?: 'XfaResetTrackingVariancePopulationAggregates';
  /** Population variance of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};

export type XfaResetTrackingVarianceSampleAggregateFilter = {
  parentAccountId?: InputMaybe<BigFloatFilter>;
  resetAccountId?: InputMaybe<BigFloatFilter>;
  rowId?: InputMaybe<BigFloatFilter>;
};

export type XfaResetTrackingVarianceSampleAggregates = {
  __typename?: 'XfaResetTrackingVarianceSampleAggregates';
  /** Sample variance of parentAccountId across the matching connection */
  parentAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of resetAccountId across the matching connection */
  resetAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rowId across the matching connection */
  rowId?: Maybe<Scalars['BigFloat']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  Node: ( Account ) | ( AccountAdjustment ) | ( AccountAudit ) | ( AccountCallUpDecision ) | ( AccountCallUpDecisionCalculation ) | ( AccountCallUpPayoutOffer ) | ( AccountCapitalEntry ) | ( AccountLiveCallUp ) | ( AccountNote ) | ( AccountPassedBinder ) | ( AccountPlatformDatum ) | ( AccountResetLimit ) | ( AccountResetTracking ) | ( AccountStat ) | ( AccountStatDay ) | ( AccountTemplate ) | ( AccountTradeArchiveNewId ) | ( AccountTradeNat ) | ( AccountTradeStatByDay ) | ( AccountTradeStatByDayNat ) | ( Addon ) | ( AdminAudit ) | ( AdminConfig ) | ( AdminRole ) | ( AdminRoleUsersUser ) | ( Affiliate ) | ( AffiliateAudit ) | ( AffiliateCommissionRate ) | ( AffiliateLedger ) | ( AffiliatePayment ) | ( AffiliatePayoutPeriod ) | ( AwsdmsChanges3728E4207De1F2E6 ) | ( AwsdmsDdlAudit ) | ( AwsdmsHeartbeat ) | ( BatchExecution ) | ( BulkAction ) | ( CardTransaction ) | ( CaseBan ) | ( CaseBanReasonCode ) | ( CaseBanTrader ) | ( CaseEvent ) | ( CaseInvestigation ) | ( CaseInvestigationSubmittedDepartment ) | ( CaseInvestigationTrader ) | ( CaseLabel ) | ( CaseLabelAssignment ) | ( CaseType ) | ( Chargeback ) | ( ChargebackAdminAction ) | ( ChargebackFeedRun ) | ( ChargebackFeedSource ) | ( ChargebackFeedVersion ) | ( ChargebackIndicator ) | ( CheckoutItem ) | ( CheckoutSession ) | ( Coupon ) | ( CouponPlatform ) | ( CouponRedemption ) | ( CouponUser ) | ( Email ) | ( EmailAction ) | ( Group ) | ( GroupAdmin ) | ( ImpactGroupAssignment ) | ( ImpactGroupTemplate ) | ( KycPriorityLabel ) | ( KycPriorityReviewConfig ) | ( KycPriorityReviewConfigLabel ) | ( LiteLlmBlockedTermCandidate ) | ( LiveTradePairing ) | ( Migration ) | ( NmiSubscription ) | ( NuveiSavedCard ) | ( NuveiSavedPaypalArchived ) | ( NuveiWebhook ) | ( OfacsdnRecord ) | ( OrderFulfillment ) | ( Outbox ) | ( Partner ) | ( PartnerTransaction ) | ( PasswordHistory ) | ( PaymentGateway ) | ( PayoutCycle ) | ( PayoutDepartmentApproval ) | ( PayoutRequest ) | ( PayoutRequestAsset ) | ( PayoutRequestBatch ) | ( PayoutRequestBatchItem ) | ( PayoutRequestHistory ) | ( PayoutRequestSubscriber ) | ( PayoutReturn ) | ( PayoutReturnReasonCode ) | ( PayoutReview ) | ( PayoutReviewer ) | ( PaypalTransaction ) | ( PersonaWebhookEvent ) | ( Platform ) | ( Product ) | ( ProductCategory ) | ( ProfileReport ) | ( Purchase ) | ( PurchaseItem ) | ( PurchaseOrder ) | ( Omit<Query, 'accountTemplates' | 'node'> & { accountTemplates?: Maybe<_RefType['AccountTemplateConnection']>, node?: Maybe<_RefType['Node']> } ) | ( ReasonCode ) | ( RebillSession ) | ( ReferralPurchase ) | ( ReferralReward ) | ( Refund ) | ( RegistrationRiskAssessment ) | ( ResetCredit ) | ( ResetCreditGrant ) | ( RiskyProduct ) | ( SavedCard ) | ( SkuAccountProvisioningClaim ) | ( SkuInventory ) | ( SubscriptionDunning ) | ( SyncState ) | ( TaxInfo ) | ( Trade ) | ( TraderLockDetail ) | ( TraderProfileAsset ) | ( TraderProfileModerationBlockedWord ) | ( TraderProfileModerationCase ) | ( TraderProfileModerationCaseHistory ) | ( TraderPublicProfile ) | ( TraderRiskIndicator ) | ( TraderRiskIndicatorOwner ) | ( TradingProduct ) | ( TradingProductFee ) | ( UnifiedSubscription ) | ( User ) | ( UserAddon ) | ( UserAddress ) | ( UserAdminRole ) | ( UserAgreement ) | ( UserBankingInfo ) | ( UserCertificate ) | ( UserContactInfo ) | ( UserCooldown ) | ( UserIntegration ) | ( UserMarketDatum ) | ( UserMeteredEvent ) | ( UserNote ) | ( UserPlatformCredential ) | ( UserRolesAdminRole ) | ( UserSubscription ) | ( UserTaxForm ) | ( UserTcPurchaseLimit ) | ( UserXfaCooldown ) | ( Verification ) | ( XfaActivationCredit ) | ( XfaResetTracking );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Account: ResolverTypeWrapper<Account>;
  AccountAdjustment: ResolverTypeWrapper<AccountAdjustment>;
  AccountAggregates: ResolverTypeWrapper<AccountAggregates>;
  AccountAggregatesFilter: AccountAggregatesFilter;
  AccountAudit: ResolverTypeWrapper<AccountAudit>;
  AccountAverageAggregateFilter: AccountAverageAggregateFilter;
  AccountAverageAggregates: ResolverTypeWrapper<AccountAverageAggregates>;
  AccountCallUpDecision: ResolverTypeWrapper<AccountCallUpDecision>;
  AccountCallUpDecisionAggregates: ResolverTypeWrapper<AccountCallUpDecisionAggregates>;
  AccountCallUpDecisionAggregatesFilter: AccountCallUpDecisionAggregatesFilter;
  AccountCallUpDecisionAverageAggregateFilter: AccountCallUpDecisionAverageAggregateFilter;
  AccountCallUpDecisionAverageAggregates: ResolverTypeWrapper<AccountCallUpDecisionAverageAggregates>;
  AccountCallUpDecisionBrokerageUnavailableReasonEnum: AccountCallUpDecisionBrokerageUnavailableReasonEnum;
  AccountCallUpDecisionCalculation: ResolverTypeWrapper<AccountCallUpDecisionCalculation>;
  AccountCallUpDecisionCalculationAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationAggregates>;
  AccountCallUpDecisionCalculationAggregatesFilter: AccountCallUpDecisionCalculationAggregatesFilter;
  AccountCallUpDecisionCalculationAverageAggregateFilter: AccountCallUpDecisionCalculationAverageAggregateFilter;
  AccountCallUpDecisionCalculationAverageAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationAverageAggregates>;
  AccountCallUpDecisionCalculationCondition: AccountCallUpDecisionCalculationCondition;
  AccountCallUpDecisionCalculationConnection: ResolverTypeWrapper<AccountCallUpDecisionCalculationConnection>;
  AccountCallUpDecisionCalculationDistinctCountAggregateFilter: AccountCallUpDecisionCalculationDistinctCountAggregateFilter;
  AccountCallUpDecisionCalculationDistinctCountAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationDistinctCountAggregates>;
  AccountCallUpDecisionCalculationEdge: ResolverTypeWrapper<AccountCallUpDecisionCalculationEdge>;
  AccountCallUpDecisionCalculationFilter: AccountCallUpDecisionCalculationFilter;
  AccountCallUpDecisionCalculationGroupBy: AccountCallUpDecisionCalculationGroupBy;
  AccountCallUpDecisionCalculationHavingAverageInput: AccountCallUpDecisionCalculationHavingAverageInput;
  AccountCallUpDecisionCalculationHavingDistinctCountInput: AccountCallUpDecisionCalculationHavingDistinctCountInput;
  AccountCallUpDecisionCalculationHavingInput: AccountCallUpDecisionCalculationHavingInput;
  AccountCallUpDecisionCalculationHavingMaxInput: AccountCallUpDecisionCalculationHavingMaxInput;
  AccountCallUpDecisionCalculationHavingMinInput: AccountCallUpDecisionCalculationHavingMinInput;
  AccountCallUpDecisionCalculationHavingStddevPopulationInput: AccountCallUpDecisionCalculationHavingStddevPopulationInput;
  AccountCallUpDecisionCalculationHavingStddevSampleInput: AccountCallUpDecisionCalculationHavingStddevSampleInput;
  AccountCallUpDecisionCalculationHavingSumInput: AccountCallUpDecisionCalculationHavingSumInput;
  AccountCallUpDecisionCalculationHavingVariancePopulationInput: AccountCallUpDecisionCalculationHavingVariancePopulationInput;
  AccountCallUpDecisionCalculationHavingVarianceSampleInput: AccountCallUpDecisionCalculationHavingVarianceSampleInput;
  AccountCallUpDecisionCalculationMaxAggregateFilter: AccountCallUpDecisionCalculationMaxAggregateFilter;
  AccountCallUpDecisionCalculationMaxAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationMaxAggregates>;
  AccountCallUpDecisionCalculationMinAggregateFilter: AccountCallUpDecisionCalculationMinAggregateFilter;
  AccountCallUpDecisionCalculationMinAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationMinAggregates>;
  AccountCallUpDecisionCalculationOrderBy: AccountCallUpDecisionCalculationOrderBy;
  AccountCallUpDecisionCalculationStddevPopulationAggregateFilter: AccountCallUpDecisionCalculationStddevPopulationAggregateFilter;
  AccountCallUpDecisionCalculationStddevPopulationAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationStddevPopulationAggregates>;
  AccountCallUpDecisionCalculationStddevSampleAggregateFilter: AccountCallUpDecisionCalculationStddevSampleAggregateFilter;
  AccountCallUpDecisionCalculationStddevSampleAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationStddevSampleAggregates>;
  AccountCallUpDecisionCalculationSumAggregateFilter: AccountCallUpDecisionCalculationSumAggregateFilter;
  AccountCallUpDecisionCalculationSumAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationSumAggregates>;
  AccountCallUpDecisionCalculationVariancePopulationAggregateFilter: AccountCallUpDecisionCalculationVariancePopulationAggregateFilter;
  AccountCallUpDecisionCalculationVariancePopulationAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationVariancePopulationAggregates>;
  AccountCallUpDecisionCalculationVarianceSampleAggregateFilter: AccountCallUpDecisionCalculationVarianceSampleAggregateFilter;
  AccountCallUpDecisionCalculationVarianceSampleAggregates: ResolverTypeWrapper<AccountCallUpDecisionCalculationVarianceSampleAggregates>;
  AccountCallUpDecisionCondition: AccountCallUpDecisionCondition;
  AccountCallUpDecisionConnection: ResolverTypeWrapper<AccountCallUpDecisionConnection>;
  AccountCallUpDecisionDistinctCountAggregateFilter: AccountCallUpDecisionDistinctCountAggregateFilter;
  AccountCallUpDecisionDistinctCountAggregates: ResolverTypeWrapper<AccountCallUpDecisionDistinctCountAggregates>;
  AccountCallUpDecisionEdge: ResolverTypeWrapper<AccountCallUpDecisionEdge>;
  AccountCallUpDecisionFilter: AccountCallUpDecisionFilter;
  AccountCallUpDecisionGroupBy: AccountCallUpDecisionGroupBy;
  AccountCallUpDecisionHavingAverageInput: AccountCallUpDecisionHavingAverageInput;
  AccountCallUpDecisionHavingDistinctCountInput: AccountCallUpDecisionHavingDistinctCountInput;
  AccountCallUpDecisionHavingInput: AccountCallUpDecisionHavingInput;
  AccountCallUpDecisionHavingMaxInput: AccountCallUpDecisionHavingMaxInput;
  AccountCallUpDecisionHavingMinInput: AccountCallUpDecisionHavingMinInput;
  AccountCallUpDecisionHavingStddevPopulationInput: AccountCallUpDecisionHavingStddevPopulationInput;
  AccountCallUpDecisionHavingStddevSampleInput: AccountCallUpDecisionHavingStddevSampleInput;
  AccountCallUpDecisionHavingSumInput: AccountCallUpDecisionHavingSumInput;
  AccountCallUpDecisionHavingVariancePopulationInput: AccountCallUpDecisionHavingVariancePopulationInput;
  AccountCallUpDecisionHavingVarianceSampleInput: AccountCallUpDecisionHavingVarianceSampleInput;
  AccountCallUpDecisionMaxAggregateFilter: AccountCallUpDecisionMaxAggregateFilter;
  AccountCallUpDecisionMaxAggregates: ResolverTypeWrapper<AccountCallUpDecisionMaxAggregates>;
  AccountCallUpDecisionMinAggregateFilter: AccountCallUpDecisionMinAggregateFilter;
  AccountCallUpDecisionMinAggregates: ResolverTypeWrapper<AccountCallUpDecisionMinAggregates>;
  AccountCallUpDecisionOrderBy: AccountCallUpDecisionOrderBy;
  AccountCallUpDecisionPayoutChoiceEnum: AccountCallUpDecisionPayoutChoiceEnum;
  AccountCallUpDecisionStatusEnum: AccountCallUpDecisionStatusEnum;
  AccountCallUpDecisionStddevPopulationAggregateFilter: AccountCallUpDecisionStddevPopulationAggregateFilter;
  AccountCallUpDecisionStddevPopulationAggregates: ResolverTypeWrapper<AccountCallUpDecisionStddevPopulationAggregates>;
  AccountCallUpDecisionStddevSampleAggregateFilter: AccountCallUpDecisionStddevSampleAggregateFilter;
  AccountCallUpDecisionStddevSampleAggregates: ResolverTypeWrapper<AccountCallUpDecisionStddevSampleAggregates>;
  AccountCallUpDecisionSumAggregateFilter: AccountCallUpDecisionSumAggregateFilter;
  AccountCallUpDecisionSumAggregates: ResolverTypeWrapper<AccountCallUpDecisionSumAggregates>;
  AccountCallUpDecisionToManyAccountCallUpDecisionCalculationFilter: AccountCallUpDecisionToManyAccountCallUpDecisionCalculationFilter;
  AccountCallUpDecisionVariancePopulationAggregateFilter: AccountCallUpDecisionVariancePopulationAggregateFilter;
  AccountCallUpDecisionVariancePopulationAggregates: ResolverTypeWrapper<AccountCallUpDecisionVariancePopulationAggregates>;
  AccountCallUpDecisionVarianceSampleAggregateFilter: AccountCallUpDecisionVarianceSampleAggregateFilter;
  AccountCallUpDecisionVarianceSampleAggregates: ResolverTypeWrapper<AccountCallUpDecisionVarianceSampleAggregates>;
  AccountCallUpPayoutOffer: ResolverTypeWrapper<AccountCallUpPayoutOffer>;
  AccountCallUpPayoutOfferUnavailableReasonEnum: AccountCallUpPayoutOfferUnavailableReasonEnum;
  AccountCapitalEntry: ResolverTypeWrapper<AccountCapitalEntry>;
  AccountCapitalEntryAggregates: ResolverTypeWrapper<AccountCapitalEntryAggregates>;
  AccountCapitalEntryAggregatesFilter: AccountCapitalEntryAggregatesFilter;
  AccountCapitalEntryAverageAggregateFilter: AccountCapitalEntryAverageAggregateFilter;
  AccountCapitalEntryAverageAggregates: ResolverTypeWrapper<AccountCapitalEntryAverageAggregates>;
  AccountCapitalEntryBucketEnum: AccountCapitalEntryBucketEnum;
  AccountCapitalEntryCondition: AccountCapitalEntryCondition;
  AccountCapitalEntryConnection: ResolverTypeWrapper<AccountCapitalEntryConnection>;
  AccountCapitalEntryDistinctCountAggregateFilter: AccountCapitalEntryDistinctCountAggregateFilter;
  AccountCapitalEntryDistinctCountAggregates: ResolverTypeWrapper<AccountCapitalEntryDistinctCountAggregates>;
  AccountCapitalEntryEdge: ResolverTypeWrapper<AccountCapitalEntryEdge>;
  AccountCapitalEntryFilter: AccountCapitalEntryFilter;
  AccountCapitalEntryGroupBy: AccountCapitalEntryGroupBy;
  AccountCapitalEntryHavingAverageInput: AccountCapitalEntryHavingAverageInput;
  AccountCapitalEntryHavingDistinctCountInput: AccountCapitalEntryHavingDistinctCountInput;
  AccountCapitalEntryHavingInput: AccountCapitalEntryHavingInput;
  AccountCapitalEntryHavingMaxInput: AccountCapitalEntryHavingMaxInput;
  AccountCapitalEntryHavingMinInput: AccountCapitalEntryHavingMinInput;
  AccountCapitalEntryHavingStddevPopulationInput: AccountCapitalEntryHavingStddevPopulationInput;
  AccountCapitalEntryHavingStddevSampleInput: AccountCapitalEntryHavingStddevSampleInput;
  AccountCapitalEntryHavingSumInput: AccountCapitalEntryHavingSumInput;
  AccountCapitalEntryHavingVariancePopulationInput: AccountCapitalEntryHavingVariancePopulationInput;
  AccountCapitalEntryHavingVarianceSampleInput: AccountCapitalEntryHavingVarianceSampleInput;
  AccountCapitalEntryMaxAggregateFilter: AccountCapitalEntryMaxAggregateFilter;
  AccountCapitalEntryMaxAggregates: ResolverTypeWrapper<AccountCapitalEntryMaxAggregates>;
  AccountCapitalEntryMinAggregateFilter: AccountCapitalEntryMinAggregateFilter;
  AccountCapitalEntryMinAggregates: ResolverTypeWrapper<AccountCapitalEntryMinAggregates>;
  AccountCapitalEntryOrderBy: AccountCapitalEntryOrderBy;
  AccountCapitalEntryResult: ResolverTypeWrapper<AccountCapitalEntryResult>;
  AccountCapitalEntryStddevPopulationAggregateFilter: AccountCapitalEntryStddevPopulationAggregateFilter;
  AccountCapitalEntryStddevPopulationAggregates: ResolverTypeWrapper<AccountCapitalEntryStddevPopulationAggregates>;
  AccountCapitalEntryStddevSampleAggregateFilter: AccountCapitalEntryStddevSampleAggregateFilter;
  AccountCapitalEntryStddevSampleAggregates: ResolverTypeWrapper<AccountCapitalEntryStddevSampleAggregates>;
  AccountCapitalEntrySumAggregateFilter: AccountCapitalEntrySumAggregateFilter;
  AccountCapitalEntrySumAggregates: ResolverTypeWrapper<AccountCapitalEntrySumAggregates>;
  AccountCapitalEntryTypeEnum: AccountCapitalEntryTypeEnum;
  AccountCapitalEntryVariancePopulationAggregateFilter: AccountCapitalEntryVariancePopulationAggregateFilter;
  AccountCapitalEntryVariancePopulationAggregates: ResolverTypeWrapper<AccountCapitalEntryVariancePopulationAggregates>;
  AccountCapitalEntryVarianceSampleAggregateFilter: AccountCapitalEntryVarianceSampleAggregateFilter;
  AccountCapitalEntryVarianceSampleAggregates: ResolverTypeWrapper<AccountCapitalEntryVarianceSampleAggregates>;
  AccountCapitalMutationPayload: ResolverTypeWrapper<AccountCapitalMutationPayload>;
  AccountCondition: AccountCondition;
  AccountConnection: ResolverTypeWrapper<AccountConnection>;
  AccountDistinctCountAggregateFilter: AccountDistinctCountAggregateFilter;
  AccountDistinctCountAggregates: ResolverTypeWrapper<AccountDistinctCountAggregates>;
  AccountEdge: ResolverTypeWrapper<AccountEdge>;
  AccountFilter: AccountFilter;
  AccountGroupBy: AccountGroupBy;
  AccountHavingAverageInput: AccountHavingAverageInput;
  AccountHavingDistinctCountInput: AccountHavingDistinctCountInput;
  AccountHavingInput: AccountHavingInput;
  AccountHavingMaxInput: AccountHavingMaxInput;
  AccountHavingMinInput: AccountHavingMinInput;
  AccountHavingStddevPopulationInput: AccountHavingStddevPopulationInput;
  AccountHavingStddevSampleInput: AccountHavingStddevSampleInput;
  AccountHavingSumInput: AccountHavingSumInput;
  AccountHavingVariancePopulationInput: AccountHavingVariancePopulationInput;
  AccountHavingVarianceSampleInput: AccountHavingVarianceSampleInput;
  AccountLiveCallUp: ResolverTypeWrapper<AccountLiveCallUp>;
  AccountLiveCallUpFilter: AccountLiveCallUpFilter;
  AccountMaxAggregateFilter: AccountMaxAggregateFilter;
  AccountMaxAggregates: ResolverTypeWrapper<AccountMaxAggregates>;
  AccountMinAggregateFilter: AccountMinAggregateFilter;
  AccountMinAggregates: ResolverTypeWrapper<AccountMinAggregates>;
  AccountNote: ResolverTypeWrapper<AccountNote>;
  AccountOrderBy: AccountOrderBy;
  AccountPassedBinder: ResolverTypeWrapper<AccountPassedBinder>;
  AccountPassedBinderAggregates: ResolverTypeWrapper<AccountPassedBinderAggregates>;
  AccountPassedBinderAggregatesFilter: AccountPassedBinderAggregatesFilter;
  AccountPassedBinderAverageAggregateFilter: AccountPassedBinderAverageAggregateFilter;
  AccountPassedBinderAverageAggregates: ResolverTypeWrapper<AccountPassedBinderAverageAggregates>;
  AccountPassedBinderCondition: AccountPassedBinderCondition;
  AccountPassedBinderConnection: ResolverTypeWrapper<AccountPassedBinderConnection>;
  AccountPassedBinderDistinctCountAggregateFilter: AccountPassedBinderDistinctCountAggregateFilter;
  AccountPassedBinderDistinctCountAggregates: ResolverTypeWrapper<AccountPassedBinderDistinctCountAggregates>;
  AccountPassedBinderEdge: ResolverTypeWrapper<AccountPassedBinderEdge>;
  AccountPassedBinderFilter: AccountPassedBinderFilter;
  AccountPassedBinderGroupBy: AccountPassedBinderGroupBy;
  AccountPassedBinderHavingAverageInput: AccountPassedBinderHavingAverageInput;
  AccountPassedBinderHavingDistinctCountInput: AccountPassedBinderHavingDistinctCountInput;
  AccountPassedBinderHavingInput: AccountPassedBinderHavingInput;
  AccountPassedBinderHavingMaxInput: AccountPassedBinderHavingMaxInput;
  AccountPassedBinderHavingMinInput: AccountPassedBinderHavingMinInput;
  AccountPassedBinderHavingStddevPopulationInput: AccountPassedBinderHavingStddevPopulationInput;
  AccountPassedBinderHavingStddevSampleInput: AccountPassedBinderHavingStddevSampleInput;
  AccountPassedBinderHavingSumInput: AccountPassedBinderHavingSumInput;
  AccountPassedBinderHavingVariancePopulationInput: AccountPassedBinderHavingVariancePopulationInput;
  AccountPassedBinderHavingVarianceSampleInput: AccountPassedBinderHavingVarianceSampleInput;
  AccountPassedBinderMaxAggregateFilter: AccountPassedBinderMaxAggregateFilter;
  AccountPassedBinderMaxAggregates: ResolverTypeWrapper<AccountPassedBinderMaxAggregates>;
  AccountPassedBinderMinAggregateFilter: AccountPassedBinderMinAggregateFilter;
  AccountPassedBinderMinAggregates: ResolverTypeWrapper<AccountPassedBinderMinAggregates>;
  AccountPassedBinderOrderBy: AccountPassedBinderOrderBy;
  AccountPassedBinderStddevPopulationAggregateFilter: AccountPassedBinderStddevPopulationAggregateFilter;
  AccountPassedBinderStddevPopulationAggregates: ResolverTypeWrapper<AccountPassedBinderStddevPopulationAggregates>;
  AccountPassedBinderStddevSampleAggregateFilter: AccountPassedBinderStddevSampleAggregateFilter;
  AccountPassedBinderStddevSampleAggregates: ResolverTypeWrapper<AccountPassedBinderStddevSampleAggregates>;
  AccountPassedBinderSumAggregateFilter: AccountPassedBinderSumAggregateFilter;
  AccountPassedBinderSumAggregates: ResolverTypeWrapper<AccountPassedBinderSumAggregates>;
  AccountPassedBinderVariancePopulationAggregateFilter: AccountPassedBinderVariancePopulationAggregateFilter;
  AccountPassedBinderVariancePopulationAggregates: ResolverTypeWrapper<AccountPassedBinderVariancePopulationAggregates>;
  AccountPassedBinderVarianceSampleAggregateFilter: AccountPassedBinderVarianceSampleAggregateFilter;
  AccountPassedBinderVarianceSampleAggregates: ResolverTypeWrapper<AccountPassedBinderVarianceSampleAggregates>;
  AccountPlatformDatum: ResolverTypeWrapper<AccountPlatformDatum>;
  AccountPlatformDatumFilter: AccountPlatformDatumFilter;
  AccountResetLimit: ResolverTypeWrapper<AccountResetLimit>;
  AccountResetLimitAggregates: ResolverTypeWrapper<AccountResetLimitAggregates>;
  AccountResetLimitAggregatesFilter: AccountResetLimitAggregatesFilter;
  AccountResetLimitAverageAggregateFilter: AccountResetLimitAverageAggregateFilter;
  AccountResetLimitAverageAggregates: ResolverTypeWrapper<AccountResetLimitAverageAggregates>;
  AccountResetLimitCondition: AccountResetLimitCondition;
  AccountResetLimitConnection: ResolverTypeWrapper<AccountResetLimitConnection>;
  AccountResetLimitDistinctCountAggregateFilter: AccountResetLimitDistinctCountAggregateFilter;
  AccountResetLimitDistinctCountAggregates: ResolverTypeWrapper<AccountResetLimitDistinctCountAggregates>;
  AccountResetLimitEdge: ResolverTypeWrapper<AccountResetLimitEdge>;
  AccountResetLimitFilter: AccountResetLimitFilter;
  AccountResetLimitGroupBy: AccountResetLimitGroupBy;
  AccountResetLimitHavingAverageInput: AccountResetLimitHavingAverageInput;
  AccountResetLimitHavingDistinctCountInput: AccountResetLimitHavingDistinctCountInput;
  AccountResetLimitHavingInput: AccountResetLimitHavingInput;
  AccountResetLimitHavingMaxInput: AccountResetLimitHavingMaxInput;
  AccountResetLimitHavingMinInput: AccountResetLimitHavingMinInput;
  AccountResetLimitHavingStddevPopulationInput: AccountResetLimitHavingStddevPopulationInput;
  AccountResetLimitHavingStddevSampleInput: AccountResetLimitHavingStddevSampleInput;
  AccountResetLimitHavingSumInput: AccountResetLimitHavingSumInput;
  AccountResetLimitHavingVariancePopulationInput: AccountResetLimitHavingVariancePopulationInput;
  AccountResetLimitHavingVarianceSampleInput: AccountResetLimitHavingVarianceSampleInput;
  AccountResetLimitMaxAggregateFilter: AccountResetLimitMaxAggregateFilter;
  AccountResetLimitMaxAggregates: ResolverTypeWrapper<AccountResetLimitMaxAggregates>;
  AccountResetLimitMinAggregateFilter: AccountResetLimitMinAggregateFilter;
  AccountResetLimitMinAggregates: ResolverTypeWrapper<AccountResetLimitMinAggregates>;
  AccountResetLimitOrderBy: AccountResetLimitOrderBy;
  AccountResetLimitStddevPopulationAggregateFilter: AccountResetLimitStddevPopulationAggregateFilter;
  AccountResetLimitStddevPopulationAggregates: ResolverTypeWrapper<AccountResetLimitStddevPopulationAggregates>;
  AccountResetLimitStddevSampleAggregateFilter: AccountResetLimitStddevSampleAggregateFilter;
  AccountResetLimitStddevSampleAggregates: ResolverTypeWrapper<AccountResetLimitStddevSampleAggregates>;
  AccountResetLimitSumAggregateFilter: AccountResetLimitSumAggregateFilter;
  AccountResetLimitSumAggregates: ResolverTypeWrapper<AccountResetLimitSumAggregates>;
  AccountResetLimitVariancePopulationAggregateFilter: AccountResetLimitVariancePopulationAggregateFilter;
  AccountResetLimitVariancePopulationAggregates: ResolverTypeWrapper<AccountResetLimitVariancePopulationAggregates>;
  AccountResetLimitVarianceSampleAggregateFilter: AccountResetLimitVarianceSampleAggregateFilter;
  AccountResetLimitVarianceSampleAggregates: ResolverTypeWrapper<AccountResetLimitVarianceSampleAggregates>;
  AccountResetTracking: ResolverTypeWrapper<AccountResetTracking>;
  AccountResetTrackingAggregates: ResolverTypeWrapper<AccountResetTrackingAggregates>;
  AccountResetTrackingAggregatesFilter: AccountResetTrackingAggregatesFilter;
  AccountResetTrackingAverageAggregateFilter: AccountResetTrackingAverageAggregateFilter;
  AccountResetTrackingAverageAggregates: ResolverTypeWrapper<AccountResetTrackingAverageAggregates>;
  AccountResetTrackingCondition: AccountResetTrackingCondition;
  AccountResetTrackingConnection: ResolverTypeWrapper<AccountResetTrackingConnection>;
  AccountResetTrackingDistinctCountAggregateFilter: AccountResetTrackingDistinctCountAggregateFilter;
  AccountResetTrackingDistinctCountAggregates: ResolverTypeWrapper<AccountResetTrackingDistinctCountAggregates>;
  AccountResetTrackingEdge: ResolverTypeWrapper<AccountResetTrackingEdge>;
  AccountResetTrackingFilter: AccountResetTrackingFilter;
  AccountResetTrackingGroupBy: AccountResetTrackingGroupBy;
  AccountResetTrackingHavingAverageInput: AccountResetTrackingHavingAverageInput;
  AccountResetTrackingHavingDistinctCountInput: AccountResetTrackingHavingDistinctCountInput;
  AccountResetTrackingHavingInput: AccountResetTrackingHavingInput;
  AccountResetTrackingHavingMaxInput: AccountResetTrackingHavingMaxInput;
  AccountResetTrackingHavingMinInput: AccountResetTrackingHavingMinInput;
  AccountResetTrackingHavingStddevPopulationInput: AccountResetTrackingHavingStddevPopulationInput;
  AccountResetTrackingHavingStddevSampleInput: AccountResetTrackingHavingStddevSampleInput;
  AccountResetTrackingHavingSumInput: AccountResetTrackingHavingSumInput;
  AccountResetTrackingHavingVariancePopulationInput: AccountResetTrackingHavingVariancePopulationInput;
  AccountResetTrackingHavingVarianceSampleInput: AccountResetTrackingHavingVarianceSampleInput;
  AccountResetTrackingMaxAggregateFilter: AccountResetTrackingMaxAggregateFilter;
  AccountResetTrackingMaxAggregates: ResolverTypeWrapper<AccountResetTrackingMaxAggregates>;
  AccountResetTrackingMinAggregateFilter: AccountResetTrackingMinAggregateFilter;
  AccountResetTrackingMinAggregates: ResolverTypeWrapper<AccountResetTrackingMinAggregates>;
  AccountResetTrackingOrderBy: AccountResetTrackingOrderBy;
  AccountResetTrackingStddevPopulationAggregateFilter: AccountResetTrackingStddevPopulationAggregateFilter;
  AccountResetTrackingStddevPopulationAggregates: ResolverTypeWrapper<AccountResetTrackingStddevPopulationAggregates>;
  AccountResetTrackingStddevSampleAggregateFilter: AccountResetTrackingStddevSampleAggregateFilter;
  AccountResetTrackingStddevSampleAggregates: ResolverTypeWrapper<AccountResetTrackingStddevSampleAggregates>;
  AccountResetTrackingSumAggregateFilter: AccountResetTrackingSumAggregateFilter;
  AccountResetTrackingSumAggregates: ResolverTypeWrapper<AccountResetTrackingSumAggregates>;
  AccountResetTrackingVariancePopulationAggregateFilter: AccountResetTrackingVariancePopulationAggregateFilter;
  AccountResetTrackingVariancePopulationAggregates: ResolverTypeWrapper<AccountResetTrackingVariancePopulationAggregates>;
  AccountResetTrackingVarianceSampleAggregateFilter: AccountResetTrackingVarianceSampleAggregateFilter;
  AccountResetTrackingVarianceSampleAggregates: ResolverTypeWrapper<AccountResetTrackingVarianceSampleAggregates>;
  AccountStat: ResolverTypeWrapper<AccountStat>;
  AccountStatAggregates: ResolverTypeWrapper<AccountStatAggregates>;
  AccountStatAggregatesFilter: AccountStatAggregatesFilter;
  AccountStatAverageAggregateFilter: AccountStatAverageAggregateFilter;
  AccountStatAverageAggregates: ResolverTypeWrapper<AccountStatAverageAggregates>;
  AccountStatCondition: AccountStatCondition;
  AccountStatConnection: ResolverTypeWrapper<AccountStatConnection>;
  AccountStatDay: ResolverTypeWrapper<AccountStatDay>;
  AccountStatDistinctCountAggregateFilter: AccountStatDistinctCountAggregateFilter;
  AccountStatDistinctCountAggregates: ResolverTypeWrapper<AccountStatDistinctCountAggregates>;
  AccountStatEdge: ResolverTypeWrapper<AccountStatEdge>;
  AccountStatFilter: AccountStatFilter;
  AccountStatGroupBy: AccountStatGroupBy;
  AccountStatHavingAverageInput: AccountStatHavingAverageInput;
  AccountStatHavingDistinctCountInput: AccountStatHavingDistinctCountInput;
  AccountStatHavingInput: AccountStatHavingInput;
  AccountStatHavingMaxInput: AccountStatHavingMaxInput;
  AccountStatHavingMinInput: AccountStatHavingMinInput;
  AccountStatHavingStddevPopulationInput: AccountStatHavingStddevPopulationInput;
  AccountStatHavingStddevSampleInput: AccountStatHavingStddevSampleInput;
  AccountStatHavingSumInput: AccountStatHavingSumInput;
  AccountStatHavingVariancePopulationInput: AccountStatHavingVariancePopulationInput;
  AccountStatHavingVarianceSampleInput: AccountStatHavingVarianceSampleInput;
  AccountStatMaxAggregateFilter: AccountStatMaxAggregateFilter;
  AccountStatMaxAggregates: ResolverTypeWrapper<AccountStatMaxAggregates>;
  AccountStatMinAggregateFilter: AccountStatMinAggregateFilter;
  AccountStatMinAggregates: ResolverTypeWrapper<AccountStatMinAggregates>;
  AccountStatOrderBy: AccountStatOrderBy;
  AccountStatPatch: AccountStatPatch;
  AccountStatStddevPopulationAggregateFilter: AccountStatStddevPopulationAggregateFilter;
  AccountStatStddevPopulationAggregates: ResolverTypeWrapper<AccountStatStddevPopulationAggregates>;
  AccountStatStddevSampleAggregateFilter: AccountStatStddevSampleAggregateFilter;
  AccountStatStddevSampleAggregates: ResolverTypeWrapper<AccountStatStddevSampleAggregates>;
  AccountStatSumAggregateFilter: AccountStatSumAggregateFilter;
  AccountStatSumAggregates: ResolverTypeWrapper<AccountStatSumAggregates>;
  AccountStatVariancePopulationAggregateFilter: AccountStatVariancePopulationAggregateFilter;
  AccountStatVariancePopulationAggregates: ResolverTypeWrapper<AccountStatVariancePopulationAggregates>;
  AccountStatVarianceSampleAggregateFilter: AccountStatVarianceSampleAggregateFilter;
  AccountStatVarianceSampleAggregates: ResolverTypeWrapper<AccountStatVarianceSampleAggregates>;
  AccountStddevPopulationAggregateFilter: AccountStddevPopulationAggregateFilter;
  AccountStddevPopulationAggregates: ResolverTypeWrapper<AccountStddevPopulationAggregates>;
  AccountStddevSampleAggregateFilter: AccountStddevSampleAggregateFilter;
  AccountStddevSampleAggregates: ResolverTypeWrapper<AccountStddevSampleAggregates>;
  AccountSumAggregateFilter: AccountSumAggregateFilter;
  AccountSumAggregates: ResolverTypeWrapper<AccountSumAggregates>;
  AccountTemplate: ResolverTypeWrapper<AccountTemplate>;
  AccountTemplateAggregates: ResolverTypeWrapper<AccountTemplateAggregates>;
  AccountTemplateAverageAggregates: ResolverTypeWrapper<AccountTemplateAverageAggregates>;
  AccountTemplateCondition: AccountTemplateCondition;
  AccountTemplateConnection: ResolverTypeWrapper<AccountTemplateConnection>;
  AccountTemplateDistinctCountAggregates: ResolverTypeWrapper<AccountTemplateDistinctCountAggregates>;
  AccountTemplateEdge: ResolverTypeWrapper<AccountTemplateEdge>;
  AccountTemplateFilter: AccountTemplateFilter;
  AccountTemplateGroupBy: AccountTemplateGroupBy;
  AccountTemplateHavingAverageInput: AccountTemplateHavingAverageInput;
  AccountTemplateHavingDistinctCountInput: AccountTemplateHavingDistinctCountInput;
  AccountTemplateHavingInput: AccountTemplateHavingInput;
  AccountTemplateHavingMaxInput: AccountTemplateHavingMaxInput;
  AccountTemplateHavingMinInput: AccountTemplateHavingMinInput;
  AccountTemplateHavingStddevPopulationInput: AccountTemplateHavingStddevPopulationInput;
  AccountTemplateHavingStddevSampleInput: AccountTemplateHavingStddevSampleInput;
  AccountTemplateHavingSumInput: AccountTemplateHavingSumInput;
  AccountTemplateHavingVariancePopulationInput: AccountTemplateHavingVariancePopulationInput;
  AccountTemplateHavingVarianceSampleInput: AccountTemplateHavingVarianceSampleInput;
  AccountTemplateMaxAggregates: ResolverTypeWrapper<AccountTemplateMaxAggregates>;
  AccountTemplateMinAggregates: ResolverTypeWrapper<AccountTemplateMinAggregates>;
  AccountTemplateOrderBy: AccountTemplateOrderBy;
  AccountTemplateStddevPopulationAggregates: ResolverTypeWrapper<AccountTemplateStddevPopulationAggregates>;
  AccountTemplateStddevSampleAggregates: ResolverTypeWrapper<AccountTemplateStddevSampleAggregates>;
  AccountTemplateSumAggregates: ResolverTypeWrapper<AccountTemplateSumAggregates>;
  AccountTemplateToManyAccountFilter: AccountTemplateToManyAccountFilter;
  AccountTemplateToManyResetCreditFilter: AccountTemplateToManyResetCreditFilter;
  AccountTemplateVariancePopulationAggregates: ResolverTypeWrapper<AccountTemplateVariancePopulationAggregates>;
  AccountTemplateVarianceSampleAggregates: ResolverTypeWrapper<AccountTemplateVarianceSampleAggregates>;
  AccountToManyAccountCapitalEntryFilter: AccountToManyAccountCapitalEntryFilter;
  AccountToManyAccountPassedBinderFilter: AccountToManyAccountPassedBinderFilter;
  AccountToManyAccountStatFilter: AccountToManyAccountStatFilter;
  AccountToManyImpactGroupAssignmentFilter: AccountToManyImpactGroupAssignmentFilter;
  AccountToManyTraderPublicProfileFilter: AccountToManyTraderPublicProfileFilter;
  AccountToManyXfaResetTrackingFilter: AccountToManyXfaResetTrackingFilter;
  AccountTradeArchiveNewId: ResolverTypeWrapper<AccountTradeArchiveNewId>;
  AccountTradeNat: ResolverTypeWrapper<AccountTradeNat>;
  AccountTradeStatByDay: ResolverTypeWrapper<AccountTradeStatByDay>;
  AccountTradeStatByDayAggregates: ResolverTypeWrapper<AccountTradeStatByDayAggregates>;
  AccountTradeStatByDayAverageAggregates: ResolverTypeWrapper<AccountTradeStatByDayAverageAggregates>;
  AccountTradeStatByDayCondition: AccountTradeStatByDayCondition;
  AccountTradeStatByDayConnection: ResolverTypeWrapper<AccountTradeStatByDayConnection>;
  AccountTradeStatByDayDistinctCountAggregates: ResolverTypeWrapper<AccountTradeStatByDayDistinctCountAggregates>;
  AccountTradeStatByDayEdge: ResolverTypeWrapper<AccountTradeStatByDayEdge>;
  AccountTradeStatByDayFilter: AccountTradeStatByDayFilter;
  AccountTradeStatByDayGroupBy: AccountTradeStatByDayGroupBy;
  AccountTradeStatByDayHavingAverageInput: AccountTradeStatByDayHavingAverageInput;
  AccountTradeStatByDayHavingDistinctCountInput: AccountTradeStatByDayHavingDistinctCountInput;
  AccountTradeStatByDayHavingInput: AccountTradeStatByDayHavingInput;
  AccountTradeStatByDayHavingMaxInput: AccountTradeStatByDayHavingMaxInput;
  AccountTradeStatByDayHavingMinInput: AccountTradeStatByDayHavingMinInput;
  AccountTradeStatByDayHavingStddevPopulationInput: AccountTradeStatByDayHavingStddevPopulationInput;
  AccountTradeStatByDayHavingStddevSampleInput: AccountTradeStatByDayHavingStddevSampleInput;
  AccountTradeStatByDayHavingSumInput: AccountTradeStatByDayHavingSumInput;
  AccountTradeStatByDayHavingVariancePopulationInput: AccountTradeStatByDayHavingVariancePopulationInput;
  AccountTradeStatByDayHavingVarianceSampleInput: AccountTradeStatByDayHavingVarianceSampleInput;
  AccountTradeStatByDayMaxAggregates: ResolverTypeWrapper<AccountTradeStatByDayMaxAggregates>;
  AccountTradeStatByDayMinAggregates: ResolverTypeWrapper<AccountTradeStatByDayMinAggregates>;
  AccountTradeStatByDayNat: ResolverTypeWrapper<AccountTradeStatByDayNat>;
  AccountTradeStatByDayOrderBy: AccountTradeStatByDayOrderBy;
  AccountTradeStatByDayStddevPopulationAggregates: ResolverTypeWrapper<AccountTradeStatByDayStddevPopulationAggregates>;
  AccountTradeStatByDayStddevSampleAggregates: ResolverTypeWrapper<AccountTradeStatByDayStddevSampleAggregates>;
  AccountTradeStatByDaySumAggregates: ResolverTypeWrapper<AccountTradeStatByDaySumAggregates>;
  AccountTradeStatByDayVariancePopulationAggregates: ResolverTypeWrapper<AccountTradeStatByDayVariancePopulationAggregates>;
  AccountTradeStatByDayVarianceSampleAggregates: ResolverTypeWrapper<AccountTradeStatByDayVarianceSampleAggregates>;
  AccountVariancePopulationAggregateFilter: AccountVariancePopulationAggregateFilter;
  AccountVariancePopulationAggregates: ResolverTypeWrapper<AccountVariancePopulationAggregates>;
  AccountVarianceSampleAggregateFilter: AccountVarianceSampleAggregateFilter;
  AccountVarianceSampleAggregates: ResolverTypeWrapper<AccountVarianceSampleAggregates>;
  AddCaseBanNoteInput: AddCaseBanNoteInput;
  AddCaseInvestigationNoteInput: AddCaseInvestigationNoteInput;
  Addon: ResolverTypeWrapper<Addon>;
  AdminAudit: ResolverTypeWrapper<AdminAudit>;
  AdminAuditAggregates: ResolverTypeWrapper<AdminAuditAggregates>;
  AdminAuditAverageAggregates: ResolverTypeWrapper<AdminAuditAverageAggregates>;
  AdminAuditCondition: AdminAuditCondition;
  AdminAuditConnection: ResolverTypeWrapper<AdminAuditConnection>;
  AdminAuditDistinctCountAggregates: ResolverTypeWrapper<AdminAuditDistinctCountAggregates>;
  AdminAuditEdge: ResolverTypeWrapper<AdminAuditEdge>;
  AdminAuditFilter: AdminAuditFilter;
  AdminAuditGroupBy: AdminAuditGroupBy;
  AdminAuditHavingAverageInput: AdminAuditHavingAverageInput;
  AdminAuditHavingDistinctCountInput: AdminAuditHavingDistinctCountInput;
  AdminAuditHavingInput: AdminAuditHavingInput;
  AdminAuditHavingMaxInput: AdminAuditHavingMaxInput;
  AdminAuditHavingMinInput: AdminAuditHavingMinInput;
  AdminAuditHavingStddevPopulationInput: AdminAuditHavingStddevPopulationInput;
  AdminAuditHavingStddevSampleInput: AdminAuditHavingStddevSampleInput;
  AdminAuditHavingSumInput: AdminAuditHavingSumInput;
  AdminAuditHavingVariancePopulationInput: AdminAuditHavingVariancePopulationInput;
  AdminAuditHavingVarianceSampleInput: AdminAuditHavingVarianceSampleInput;
  AdminAuditMaxAggregates: ResolverTypeWrapper<AdminAuditMaxAggregates>;
  AdminAuditMinAggregates: ResolverTypeWrapper<AdminAuditMinAggregates>;
  AdminAuditOrderBy: AdminAuditOrderBy;
  AdminAuditStddevPopulationAggregates: ResolverTypeWrapper<AdminAuditStddevPopulationAggregates>;
  AdminAuditStddevSampleAggregates: ResolverTypeWrapper<AdminAuditStddevSampleAggregates>;
  AdminAuditSumAggregates: ResolverTypeWrapper<AdminAuditSumAggregates>;
  AdminAuditVariancePopulationAggregates: ResolverTypeWrapper<AdminAuditVariancePopulationAggregates>;
  AdminAuditVarianceSampleAggregates: ResolverTypeWrapper<AdminAuditVarianceSampleAggregates>;
  AdminConfig: ResolverTypeWrapper<AdminConfig>;
  AdminConfigEdge: ResolverTypeWrapper<AdminConfigEdge>;
  AdminConfigOrderBy: AdminConfigOrderBy;
  AdminConfigPatch: AdminConfigPatch;
  AdminConfigStatusEnum: AdminConfigStatusEnum;
  AdminRole: ResolverTypeWrapper<AdminRole>;
  AdminRoleAggregates: ResolverTypeWrapper<AdminRoleAggregates>;
  AdminRoleAverageAggregates: ResolverTypeWrapper<AdminRoleAverageAggregates>;
  AdminRoleCondition: AdminRoleCondition;
  AdminRoleConnection: ResolverTypeWrapper<AdminRoleConnection>;
  AdminRoleDistinctCountAggregates: ResolverTypeWrapper<AdminRoleDistinctCountAggregates>;
  AdminRoleEdge: ResolverTypeWrapper<AdminRoleEdge>;
  AdminRoleFilter: AdminRoleFilter;
  AdminRoleMaxAggregates: ResolverTypeWrapper<AdminRoleMaxAggregates>;
  AdminRoleMinAggregates: ResolverTypeWrapper<AdminRoleMinAggregates>;
  AdminRoleOrderBy: AdminRoleOrderBy;
  AdminRoleStddevPopulationAggregates: ResolverTypeWrapper<AdminRoleStddevPopulationAggregates>;
  AdminRoleStddevSampleAggregates: ResolverTypeWrapper<AdminRoleStddevSampleAggregates>;
  AdminRoleSumAggregates: ResolverTypeWrapper<AdminRoleSumAggregates>;
  AdminRoleToManyAdminRoleUsersUserFilter: AdminRoleToManyAdminRoleUsersUserFilter;
  AdminRoleToManyUserAdminRoleFilter: AdminRoleToManyUserAdminRoleFilter;
  AdminRoleToManyUserRolesAdminRoleFilter: AdminRoleToManyUserRolesAdminRoleFilter;
  AdminRoleUsersUser: ResolverTypeWrapper<AdminRoleUsersUser>;
  AdminRoleUsersUserAggregates: ResolverTypeWrapper<AdminRoleUsersUserAggregates>;
  AdminRoleUsersUserAggregatesFilter: AdminRoleUsersUserAggregatesFilter;
  AdminRoleUsersUserAverageAggregateFilter: AdminRoleUsersUserAverageAggregateFilter;
  AdminRoleUsersUserAverageAggregates: ResolverTypeWrapper<AdminRoleUsersUserAverageAggregates>;
  AdminRoleUsersUserCondition: AdminRoleUsersUserCondition;
  AdminRoleUsersUserConnection: ResolverTypeWrapper<AdminRoleUsersUserConnection>;
  AdminRoleUsersUserDistinctCountAggregateFilter: AdminRoleUsersUserDistinctCountAggregateFilter;
  AdminRoleUsersUserDistinctCountAggregates: ResolverTypeWrapper<AdminRoleUsersUserDistinctCountAggregates>;
  AdminRoleUsersUserEdge: ResolverTypeWrapper<AdminRoleUsersUserEdge>;
  AdminRoleUsersUserFilter: AdminRoleUsersUserFilter;
  AdminRoleUsersUserGroupBy: AdminRoleUsersUserGroupBy;
  AdminRoleUsersUserHavingAverageInput: AdminRoleUsersUserHavingAverageInput;
  AdminRoleUsersUserHavingDistinctCountInput: AdminRoleUsersUserHavingDistinctCountInput;
  AdminRoleUsersUserHavingInput: AdminRoleUsersUserHavingInput;
  AdminRoleUsersUserHavingMaxInput: AdminRoleUsersUserHavingMaxInput;
  AdminRoleUsersUserHavingMinInput: AdminRoleUsersUserHavingMinInput;
  AdminRoleUsersUserHavingStddevPopulationInput: AdminRoleUsersUserHavingStddevPopulationInput;
  AdminRoleUsersUserHavingStddevSampleInput: AdminRoleUsersUserHavingStddevSampleInput;
  AdminRoleUsersUserHavingSumInput: AdminRoleUsersUserHavingSumInput;
  AdminRoleUsersUserHavingVariancePopulationInput: AdminRoleUsersUserHavingVariancePopulationInput;
  AdminRoleUsersUserHavingVarianceSampleInput: AdminRoleUsersUserHavingVarianceSampleInput;
  AdminRoleUsersUserMaxAggregateFilter: AdminRoleUsersUserMaxAggregateFilter;
  AdminRoleUsersUserMaxAggregates: ResolverTypeWrapper<AdminRoleUsersUserMaxAggregates>;
  AdminRoleUsersUserMinAggregateFilter: AdminRoleUsersUserMinAggregateFilter;
  AdminRoleUsersUserMinAggregates: ResolverTypeWrapper<AdminRoleUsersUserMinAggregates>;
  AdminRoleUsersUserOrderBy: AdminRoleUsersUserOrderBy;
  AdminRoleUsersUserStddevPopulationAggregateFilter: AdminRoleUsersUserStddevPopulationAggregateFilter;
  AdminRoleUsersUserStddevPopulationAggregates: ResolverTypeWrapper<AdminRoleUsersUserStddevPopulationAggregates>;
  AdminRoleUsersUserStddevSampleAggregateFilter: AdminRoleUsersUserStddevSampleAggregateFilter;
  AdminRoleUsersUserStddevSampleAggregates: ResolverTypeWrapper<AdminRoleUsersUserStddevSampleAggregates>;
  AdminRoleUsersUserSumAggregateFilter: AdminRoleUsersUserSumAggregateFilter;
  AdminRoleUsersUserSumAggregates: ResolverTypeWrapper<AdminRoleUsersUserSumAggregates>;
  AdminRoleUsersUserVariancePopulationAggregateFilter: AdminRoleUsersUserVariancePopulationAggregateFilter;
  AdminRoleUsersUserVariancePopulationAggregates: ResolverTypeWrapper<AdminRoleUsersUserVariancePopulationAggregates>;
  AdminRoleUsersUserVarianceSampleAggregateFilter: AdminRoleUsersUserVarianceSampleAggregateFilter;
  AdminRoleUsersUserVarianceSampleAggregates: ResolverTypeWrapper<AdminRoleUsersUserVarianceSampleAggregates>;
  AdminRoleVariancePopulationAggregates: ResolverTypeWrapper<AdminRoleVariancePopulationAggregates>;
  AdminRoleVarianceSampleAggregates: ResolverTypeWrapper<AdminRoleVarianceSampleAggregates>;
  Affiliate: ResolverTypeWrapper<Affiliate>;
  AffiliateAudit: ResolverTypeWrapper<AffiliateAudit>;
  AffiliateAuditAggregates: ResolverTypeWrapper<AffiliateAuditAggregates>;
  AffiliateAuditAggregatesFilter: AffiliateAuditAggregatesFilter;
  AffiliateAuditAverageAggregates: ResolverTypeWrapper<AffiliateAuditAverageAggregates>;
  AffiliateAuditCondition: AffiliateAuditCondition;
  AffiliateAuditConnection: ResolverTypeWrapper<AffiliateAuditConnection>;
  AffiliateAuditDistinctCountAggregateFilter: AffiliateAuditDistinctCountAggregateFilter;
  AffiliateAuditDistinctCountAggregates: ResolverTypeWrapper<AffiliateAuditDistinctCountAggregates>;
  AffiliateAuditEdge: ResolverTypeWrapper<AffiliateAuditEdge>;
  AffiliateAuditFilter: AffiliateAuditFilter;
  AffiliateAuditGroupBy: AffiliateAuditGroupBy;
  AffiliateAuditHavingAverageInput: AffiliateAuditHavingAverageInput;
  AffiliateAuditHavingDistinctCountInput: AffiliateAuditHavingDistinctCountInput;
  AffiliateAuditHavingInput: AffiliateAuditHavingInput;
  AffiliateAuditHavingMaxInput: AffiliateAuditHavingMaxInput;
  AffiliateAuditHavingMinInput: AffiliateAuditHavingMinInput;
  AffiliateAuditHavingStddevPopulationInput: AffiliateAuditHavingStddevPopulationInput;
  AffiliateAuditHavingStddevSampleInput: AffiliateAuditHavingStddevSampleInput;
  AffiliateAuditHavingSumInput: AffiliateAuditHavingSumInput;
  AffiliateAuditHavingVariancePopulationInput: AffiliateAuditHavingVariancePopulationInput;
  AffiliateAuditHavingVarianceSampleInput: AffiliateAuditHavingVarianceSampleInput;
  AffiliateAuditMaxAggregates: ResolverTypeWrapper<AffiliateAuditMaxAggregates>;
  AffiliateAuditMinAggregates: ResolverTypeWrapper<AffiliateAuditMinAggregates>;
  AffiliateAuditOrderBy: AffiliateAuditOrderBy;
  AffiliateAuditStddevPopulationAggregates: ResolverTypeWrapper<AffiliateAuditStddevPopulationAggregates>;
  AffiliateAuditStddevSampleAggregates: ResolverTypeWrapper<AffiliateAuditStddevSampleAggregates>;
  AffiliateAuditSumAggregates: ResolverTypeWrapper<AffiliateAuditSumAggregates>;
  AffiliateAuditVariancePopulationAggregates: ResolverTypeWrapper<AffiliateAuditVariancePopulationAggregates>;
  AffiliateAuditVarianceSampleAggregates: ResolverTypeWrapper<AffiliateAuditVarianceSampleAggregates>;
  AffiliateCommissionRate: ResolverTypeWrapper<AffiliateCommissionRate>;
  AffiliateCommissionRateAggregates: ResolverTypeWrapper<AffiliateCommissionRateAggregates>;
  AffiliateCommissionRateAggregatesFilter: AffiliateCommissionRateAggregatesFilter;
  AffiliateCommissionRateAverageAggregates: ResolverTypeWrapper<AffiliateCommissionRateAverageAggregates>;
  AffiliateCommissionRateCondition: AffiliateCommissionRateCondition;
  AffiliateCommissionRateConnection: ResolverTypeWrapper<AffiliateCommissionRateConnection>;
  AffiliateCommissionRateDistinctCountAggregateFilter: AffiliateCommissionRateDistinctCountAggregateFilter;
  AffiliateCommissionRateDistinctCountAggregates: ResolverTypeWrapper<AffiliateCommissionRateDistinctCountAggregates>;
  AffiliateCommissionRateEdge: ResolverTypeWrapper<AffiliateCommissionRateEdge>;
  AffiliateCommissionRateFilter: AffiliateCommissionRateFilter;
  AffiliateCommissionRateGroupBy: AffiliateCommissionRateGroupBy;
  AffiliateCommissionRateHavingAverageInput: AffiliateCommissionRateHavingAverageInput;
  AffiliateCommissionRateHavingDistinctCountInput: AffiliateCommissionRateHavingDistinctCountInput;
  AffiliateCommissionRateHavingInput: AffiliateCommissionRateHavingInput;
  AffiliateCommissionRateHavingMaxInput: AffiliateCommissionRateHavingMaxInput;
  AffiliateCommissionRateHavingMinInput: AffiliateCommissionRateHavingMinInput;
  AffiliateCommissionRateHavingStddevPopulationInput: AffiliateCommissionRateHavingStddevPopulationInput;
  AffiliateCommissionRateHavingStddevSampleInput: AffiliateCommissionRateHavingStddevSampleInput;
  AffiliateCommissionRateHavingSumInput: AffiliateCommissionRateHavingSumInput;
  AffiliateCommissionRateHavingVariancePopulationInput: AffiliateCommissionRateHavingVariancePopulationInput;
  AffiliateCommissionRateHavingVarianceSampleInput: AffiliateCommissionRateHavingVarianceSampleInput;
  AffiliateCommissionRateMaxAggregates: ResolverTypeWrapper<AffiliateCommissionRateMaxAggregates>;
  AffiliateCommissionRateMinAggregates: ResolverTypeWrapper<AffiliateCommissionRateMinAggregates>;
  AffiliateCommissionRateOrderBy: AffiliateCommissionRateOrderBy;
  AffiliateCommissionRateStddevPopulationAggregates: ResolverTypeWrapper<AffiliateCommissionRateStddevPopulationAggregates>;
  AffiliateCommissionRateStddevSampleAggregates: ResolverTypeWrapper<AffiliateCommissionRateStddevSampleAggregates>;
  AffiliateCommissionRateSumAggregates: ResolverTypeWrapper<AffiliateCommissionRateSumAggregates>;
  AffiliateCommissionRateVariancePopulationAggregates: ResolverTypeWrapper<AffiliateCommissionRateVariancePopulationAggregates>;
  AffiliateCommissionRateVarianceSampleAggregates: ResolverTypeWrapper<AffiliateCommissionRateVarianceSampleAggregates>;
  AffiliateFilter: AffiliateFilter;
  AffiliateLedger: ResolverTypeWrapper<AffiliateLedger>;
  AffiliateLedgerAggregates: ResolverTypeWrapper<AffiliateLedgerAggregates>;
  AffiliateLedgerAggregatesFilter: AffiliateLedgerAggregatesFilter;
  AffiliateLedgerAverageAggregateFilter: AffiliateLedgerAverageAggregateFilter;
  AffiliateLedgerAverageAggregates: ResolverTypeWrapper<AffiliateLedgerAverageAggregates>;
  AffiliateLedgerCondition: AffiliateLedgerCondition;
  AffiliateLedgerConnection: ResolverTypeWrapper<AffiliateLedgerConnection>;
  AffiliateLedgerDistinctCountAggregateFilter: AffiliateLedgerDistinctCountAggregateFilter;
  AffiliateLedgerDistinctCountAggregates: ResolverTypeWrapper<AffiliateLedgerDistinctCountAggregates>;
  AffiliateLedgerEdge: ResolverTypeWrapper<AffiliateLedgerEdge>;
  AffiliateLedgerFilter: AffiliateLedgerFilter;
  AffiliateLedgerGroupBy: AffiliateLedgerGroupBy;
  AffiliateLedgerHavingAverageInput: AffiliateLedgerHavingAverageInput;
  AffiliateLedgerHavingDistinctCountInput: AffiliateLedgerHavingDistinctCountInput;
  AffiliateLedgerHavingInput: AffiliateLedgerHavingInput;
  AffiliateLedgerHavingMaxInput: AffiliateLedgerHavingMaxInput;
  AffiliateLedgerHavingMinInput: AffiliateLedgerHavingMinInput;
  AffiliateLedgerHavingStddevPopulationInput: AffiliateLedgerHavingStddevPopulationInput;
  AffiliateLedgerHavingStddevSampleInput: AffiliateLedgerHavingStddevSampleInput;
  AffiliateLedgerHavingSumInput: AffiliateLedgerHavingSumInput;
  AffiliateLedgerHavingVariancePopulationInput: AffiliateLedgerHavingVariancePopulationInput;
  AffiliateLedgerHavingVarianceSampleInput: AffiliateLedgerHavingVarianceSampleInput;
  AffiliateLedgerMaxAggregateFilter: AffiliateLedgerMaxAggregateFilter;
  AffiliateLedgerMaxAggregates: ResolverTypeWrapper<AffiliateLedgerMaxAggregates>;
  AffiliateLedgerMinAggregateFilter: AffiliateLedgerMinAggregateFilter;
  AffiliateLedgerMinAggregates: ResolverTypeWrapper<AffiliateLedgerMinAggregates>;
  AffiliateLedgerOrderBy: AffiliateLedgerOrderBy;
  AffiliateLedgerStddevPopulationAggregateFilter: AffiliateLedgerStddevPopulationAggregateFilter;
  AffiliateLedgerStddevPopulationAggregates: ResolverTypeWrapper<AffiliateLedgerStddevPopulationAggregates>;
  AffiliateLedgerStddevSampleAggregateFilter: AffiliateLedgerStddevSampleAggregateFilter;
  AffiliateLedgerStddevSampleAggregates: ResolverTypeWrapper<AffiliateLedgerStddevSampleAggregates>;
  AffiliateLedgerSumAggregateFilter: AffiliateLedgerSumAggregateFilter;
  AffiliateLedgerSumAggregates: ResolverTypeWrapper<AffiliateLedgerSumAggregates>;
  AffiliateLedgerVariancePopulationAggregateFilter: AffiliateLedgerVariancePopulationAggregateFilter;
  AffiliateLedgerVariancePopulationAggregates: ResolverTypeWrapper<AffiliateLedgerVariancePopulationAggregates>;
  AffiliateLedgerVarianceSampleAggregateFilter: AffiliateLedgerVarianceSampleAggregateFilter;
  AffiliateLedgerVarianceSampleAggregates: ResolverTypeWrapper<AffiliateLedgerVarianceSampleAggregates>;
  AffiliatePayment: ResolverTypeWrapper<AffiliatePayment>;
  AffiliatePaymentAggregates: ResolverTypeWrapper<AffiliatePaymentAggregates>;
  AffiliatePaymentAggregatesFilter: AffiliatePaymentAggregatesFilter;
  AffiliatePaymentAverageAggregates: ResolverTypeWrapper<AffiliatePaymentAverageAggregates>;
  AffiliatePaymentCondition: AffiliatePaymentCondition;
  AffiliatePaymentConnection: ResolverTypeWrapper<AffiliatePaymentConnection>;
  AffiliatePaymentDistinctCountAggregateFilter: AffiliatePaymentDistinctCountAggregateFilter;
  AffiliatePaymentDistinctCountAggregates: ResolverTypeWrapper<AffiliatePaymentDistinctCountAggregates>;
  AffiliatePaymentEdge: ResolverTypeWrapper<AffiliatePaymentEdge>;
  AffiliatePaymentFilter: AffiliatePaymentFilter;
  AffiliatePaymentGroupBy: AffiliatePaymentGroupBy;
  AffiliatePaymentHavingAverageInput: AffiliatePaymentHavingAverageInput;
  AffiliatePaymentHavingDistinctCountInput: AffiliatePaymentHavingDistinctCountInput;
  AffiliatePaymentHavingInput: AffiliatePaymentHavingInput;
  AffiliatePaymentHavingMaxInput: AffiliatePaymentHavingMaxInput;
  AffiliatePaymentHavingMinInput: AffiliatePaymentHavingMinInput;
  AffiliatePaymentHavingStddevPopulationInput: AffiliatePaymentHavingStddevPopulationInput;
  AffiliatePaymentHavingStddevSampleInput: AffiliatePaymentHavingStddevSampleInput;
  AffiliatePaymentHavingSumInput: AffiliatePaymentHavingSumInput;
  AffiliatePaymentHavingVariancePopulationInput: AffiliatePaymentHavingVariancePopulationInput;
  AffiliatePaymentHavingVarianceSampleInput: AffiliatePaymentHavingVarianceSampleInput;
  AffiliatePaymentMaxAggregates: ResolverTypeWrapper<AffiliatePaymentMaxAggregates>;
  AffiliatePaymentMinAggregates: ResolverTypeWrapper<AffiliatePaymentMinAggregates>;
  AffiliatePaymentOrderBy: AffiliatePaymentOrderBy;
  AffiliatePaymentStddevPopulationAggregates: ResolverTypeWrapper<AffiliatePaymentStddevPopulationAggregates>;
  AffiliatePaymentStddevSampleAggregates: ResolverTypeWrapper<AffiliatePaymentStddevSampleAggregates>;
  AffiliatePaymentSumAggregates: ResolverTypeWrapper<AffiliatePaymentSumAggregates>;
  AffiliatePaymentVariancePopulationAggregates: ResolverTypeWrapper<AffiliatePaymentVariancePopulationAggregates>;
  AffiliatePaymentVarianceSampleAggregates: ResolverTypeWrapper<AffiliatePaymentVarianceSampleAggregates>;
  AffiliatePayoutPeriod: ResolverTypeWrapper<AffiliatePayoutPeriod>;
  AffiliatePayoutPeriodAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodAggregates>;
  AffiliatePayoutPeriodAggregatesFilter: AffiliatePayoutPeriodAggregatesFilter;
  AffiliatePayoutPeriodAverageAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodAverageAggregates>;
  AffiliatePayoutPeriodCondition: AffiliatePayoutPeriodCondition;
  AffiliatePayoutPeriodConnection: ResolverTypeWrapper<AffiliatePayoutPeriodConnection>;
  AffiliatePayoutPeriodDistinctCountAggregateFilter: AffiliatePayoutPeriodDistinctCountAggregateFilter;
  AffiliatePayoutPeriodDistinctCountAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodDistinctCountAggregates>;
  AffiliatePayoutPeriodEdge: ResolverTypeWrapper<AffiliatePayoutPeriodEdge>;
  AffiliatePayoutPeriodFilter: AffiliatePayoutPeriodFilter;
  AffiliatePayoutPeriodGroupBy: AffiliatePayoutPeriodGroupBy;
  AffiliatePayoutPeriodHavingAverageInput: AffiliatePayoutPeriodHavingAverageInput;
  AffiliatePayoutPeriodHavingDistinctCountInput: AffiliatePayoutPeriodHavingDistinctCountInput;
  AffiliatePayoutPeriodHavingInput: AffiliatePayoutPeriodHavingInput;
  AffiliatePayoutPeriodHavingMaxInput: AffiliatePayoutPeriodHavingMaxInput;
  AffiliatePayoutPeriodHavingMinInput: AffiliatePayoutPeriodHavingMinInput;
  AffiliatePayoutPeriodHavingStddevPopulationInput: AffiliatePayoutPeriodHavingStddevPopulationInput;
  AffiliatePayoutPeriodHavingStddevSampleInput: AffiliatePayoutPeriodHavingStddevSampleInput;
  AffiliatePayoutPeriodHavingSumInput: AffiliatePayoutPeriodHavingSumInput;
  AffiliatePayoutPeriodHavingVariancePopulationInput: AffiliatePayoutPeriodHavingVariancePopulationInput;
  AffiliatePayoutPeriodHavingVarianceSampleInput: AffiliatePayoutPeriodHavingVarianceSampleInput;
  AffiliatePayoutPeriodMaxAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodMaxAggregates>;
  AffiliatePayoutPeriodMinAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodMinAggregates>;
  AffiliatePayoutPeriodOrderBy: AffiliatePayoutPeriodOrderBy;
  AffiliatePayoutPeriodStddevPopulationAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodStddevPopulationAggregates>;
  AffiliatePayoutPeriodStddevSampleAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodStddevSampleAggregates>;
  AffiliatePayoutPeriodSumAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodSumAggregates>;
  AffiliatePayoutPeriodToManyAffiliatePaymentFilter: AffiliatePayoutPeriodToManyAffiliatePaymentFilter;
  AffiliatePayoutPeriodVariancePopulationAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodVariancePopulationAggregates>;
  AffiliatePayoutPeriodVarianceSampleAggregates: ResolverTypeWrapper<AffiliatePayoutPeriodVarianceSampleAggregates>;
  AffiliateToManyAffiliateAuditFilter: AffiliateToManyAffiliateAuditFilter;
  AffiliateToManyAffiliateCommissionRateFilter: AffiliateToManyAffiliateCommissionRateFilter;
  AffiliateToManyAffiliateLedgerFilter: AffiliateToManyAffiliateLedgerFilter;
  AffiliateToManyAffiliatePayoutPeriodFilter: AffiliateToManyAffiliatePayoutPeriodFilter;
  AggregateAccountTradeStatByDayConnection: ResolverTypeWrapper<AggregateAccountTradeStatByDayConnection>;
  AggregateAccountTradeStatByDayEdge: ResolverTypeWrapper<AggregateAccountTradeStatByDayEdge>;
  AggregateAccountTradeStatByDayRecord: ResolverTypeWrapper<AggregateAccountTradeStatByDayRecord>;
  AggregateAccountTradeStatByDayRecordFilter: AggregateAccountTradeStatByDayRecordFilter;
  AwsdmsChanges3728E4207De1F2E6: ResolverTypeWrapper<AwsdmsChanges3728E4207De1F2E6>;
  AwsdmsDdlAudit: ResolverTypeWrapper<AwsdmsDdlAudit>;
  AwsdmsHeartbeat: ResolverTypeWrapper<AwsdmsHeartbeat>;
  BatchExecution: ResolverTypeWrapper<BatchExecution>;
  BatchExecutionBatchtypeEnum: BatchExecutionBatchtypeEnum;
  BestTradingDay: ResolverTypeWrapper<BestTradingDay>;
  BigFloat: ResolverTypeWrapper<Scalars['BigFloat']['output']>;
  BigFloatFilter: BigFloatFilter;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']['output']>;
  BigIntFilter: BigIntFilter;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BooleanFilter: BooleanFilter;
  BulkAction: ResolverTypeWrapper<BulkAction>;
  BulkCapitalUploadInput: BulkCapitalUploadInput;
  BulkCapitalUploadPayload: ResolverTypeWrapper<BulkCapitalUploadPayload>;
  BulkCapitalUploadRowResult: ResolverTypeWrapper<BulkCapitalUploadRowResult>;
  BypassUserTaxFormValidationInput: BypassUserTaxFormValidationInput;
  BypassUserTaxFormValidationResult: ResolverTypeWrapper<BypassUserTaxFormValidationResult>;
  CardTransaction: ResolverTypeWrapper<CardTransaction>;
  CardTransactionAggregates: ResolverTypeWrapper<CardTransactionAggregates>;
  CardTransactionAggregatesFilter: CardTransactionAggregatesFilter;
  CardTransactionAverageAggregateFilter: CardTransactionAverageAggregateFilter;
  CardTransactionAverageAggregates: ResolverTypeWrapper<CardTransactionAverageAggregates>;
  CardTransactionCondition: CardTransactionCondition;
  CardTransactionConnection: ResolverTypeWrapper<CardTransactionConnection>;
  CardTransactionDistinctCountAggregateFilter: CardTransactionDistinctCountAggregateFilter;
  CardTransactionDistinctCountAggregates: ResolverTypeWrapper<CardTransactionDistinctCountAggregates>;
  CardTransactionEdge: ResolverTypeWrapper<CardTransactionEdge>;
  CardTransactionFilter: CardTransactionFilter;
  CardTransactionGroupBy: CardTransactionGroupBy;
  CardTransactionHavingAverageInput: CardTransactionHavingAverageInput;
  CardTransactionHavingDistinctCountInput: CardTransactionHavingDistinctCountInput;
  CardTransactionHavingInput: CardTransactionHavingInput;
  CardTransactionHavingMaxInput: CardTransactionHavingMaxInput;
  CardTransactionHavingMinInput: CardTransactionHavingMinInput;
  CardTransactionHavingStddevPopulationInput: CardTransactionHavingStddevPopulationInput;
  CardTransactionHavingStddevSampleInput: CardTransactionHavingStddevSampleInput;
  CardTransactionHavingSumInput: CardTransactionHavingSumInput;
  CardTransactionHavingVariancePopulationInput: CardTransactionHavingVariancePopulationInput;
  CardTransactionHavingVarianceSampleInput: CardTransactionHavingVarianceSampleInput;
  CardTransactionMaxAggregateFilter: CardTransactionMaxAggregateFilter;
  CardTransactionMaxAggregates: ResolverTypeWrapper<CardTransactionMaxAggregates>;
  CardTransactionMinAggregateFilter: CardTransactionMinAggregateFilter;
  CardTransactionMinAggregates: ResolverTypeWrapper<CardTransactionMinAggregates>;
  CardTransactionOrderBy: CardTransactionOrderBy;
  CardTransactionStddevPopulationAggregateFilter: CardTransactionStddevPopulationAggregateFilter;
  CardTransactionStddevPopulationAggregates: ResolverTypeWrapper<CardTransactionStddevPopulationAggregates>;
  CardTransactionStddevSampleAggregateFilter: CardTransactionStddevSampleAggregateFilter;
  CardTransactionStddevSampleAggregates: ResolverTypeWrapper<CardTransactionStddevSampleAggregates>;
  CardTransactionSumAggregateFilter: CardTransactionSumAggregateFilter;
  CardTransactionSumAggregates: ResolverTypeWrapper<CardTransactionSumAggregates>;
  CardTransactionVariancePopulationAggregateFilter: CardTransactionVariancePopulationAggregateFilter;
  CardTransactionVariancePopulationAggregates: ResolverTypeWrapper<CardTransactionVariancePopulationAggregates>;
  CardTransactionVarianceSampleAggregateFilter: CardTransactionVarianceSampleAggregateFilter;
  CardTransactionVarianceSampleAggregates: ResolverTypeWrapper<CardTransactionVarianceSampleAggregates>;
  CaseAssignableUser: ResolverTypeWrapper<CaseAssignableUser>;
  CaseBan: ResolverTypeWrapper<CaseBan>;
  CaseBanAggregates: ResolverTypeWrapper<CaseBanAggregates>;
  CaseBanAverageAggregates: ResolverTypeWrapper<CaseBanAverageAggregates>;
  CaseBanCondition: CaseBanCondition;
  CaseBanConnection: ResolverTypeWrapper<CaseBanConnection>;
  CaseBanDistinctCountAggregates: ResolverTypeWrapper<CaseBanDistinctCountAggregates>;
  CaseBanEdge: ResolverTypeWrapper<CaseBanEdge>;
  CaseBanEventResult: ResolverTypeWrapper<CaseBanEventResult>;
  CaseBanFilter: CaseBanFilter;
  CaseBanGroupBy: CaseBanGroupBy;
  CaseBanHavingAverageInput: CaseBanHavingAverageInput;
  CaseBanHavingDistinctCountInput: CaseBanHavingDistinctCountInput;
  CaseBanHavingInput: CaseBanHavingInput;
  CaseBanHavingMaxInput: CaseBanHavingMaxInput;
  CaseBanHavingMinInput: CaseBanHavingMinInput;
  CaseBanHavingStddevPopulationInput: CaseBanHavingStddevPopulationInput;
  CaseBanHavingStddevSampleInput: CaseBanHavingStddevSampleInput;
  CaseBanHavingSumInput: CaseBanHavingSumInput;
  CaseBanHavingVariancePopulationInput: CaseBanHavingVariancePopulationInput;
  CaseBanHavingVarianceSampleInput: CaseBanHavingVarianceSampleInput;
  CaseBanMaxAggregates: ResolverTypeWrapper<CaseBanMaxAggregates>;
  CaseBanMinAggregates: ResolverTypeWrapper<CaseBanMinAggregates>;
  CaseBanOrderBy: CaseBanOrderBy;
  CaseBanPayoutHold: CaseBanPayoutHold;
  CaseBanPendingAction: CaseBanPendingAction;
  CaseBanReasonCode: ResolverTypeWrapper<CaseBanReasonCode>;
  CaseBanReasonCodeAggregates: ResolverTypeWrapper<CaseBanReasonCodeAggregates>;
  CaseBanReasonCodeAggregatesFilter: CaseBanReasonCodeAggregatesFilter;
  CaseBanReasonCodeAverageAggregateFilter: CaseBanReasonCodeAverageAggregateFilter;
  CaseBanReasonCodeAverageAggregates: ResolverTypeWrapper<CaseBanReasonCodeAverageAggregates>;
  CaseBanReasonCodeCondition: CaseBanReasonCodeCondition;
  CaseBanReasonCodeConnection: ResolverTypeWrapper<CaseBanReasonCodeConnection>;
  CaseBanReasonCodeDistinctCountAggregateFilter: CaseBanReasonCodeDistinctCountAggregateFilter;
  CaseBanReasonCodeDistinctCountAggregates: ResolverTypeWrapper<CaseBanReasonCodeDistinctCountAggregates>;
  CaseBanReasonCodeEdge: ResolverTypeWrapper<CaseBanReasonCodeEdge>;
  CaseBanReasonCodeFilter: CaseBanReasonCodeFilter;
  CaseBanReasonCodeGroupBy: CaseBanReasonCodeGroupBy;
  CaseBanReasonCodeHavingAverageInput: CaseBanReasonCodeHavingAverageInput;
  CaseBanReasonCodeHavingDistinctCountInput: CaseBanReasonCodeHavingDistinctCountInput;
  CaseBanReasonCodeHavingInput: CaseBanReasonCodeHavingInput;
  CaseBanReasonCodeHavingMaxInput: CaseBanReasonCodeHavingMaxInput;
  CaseBanReasonCodeHavingMinInput: CaseBanReasonCodeHavingMinInput;
  CaseBanReasonCodeHavingStddevPopulationInput: CaseBanReasonCodeHavingStddevPopulationInput;
  CaseBanReasonCodeHavingStddevSampleInput: CaseBanReasonCodeHavingStddevSampleInput;
  CaseBanReasonCodeHavingSumInput: CaseBanReasonCodeHavingSumInput;
  CaseBanReasonCodeHavingVariancePopulationInput: CaseBanReasonCodeHavingVariancePopulationInput;
  CaseBanReasonCodeHavingVarianceSampleInput: CaseBanReasonCodeHavingVarianceSampleInput;
  CaseBanReasonCodeMaxAggregateFilter: CaseBanReasonCodeMaxAggregateFilter;
  CaseBanReasonCodeMaxAggregates: ResolverTypeWrapper<CaseBanReasonCodeMaxAggregates>;
  CaseBanReasonCodeMinAggregateFilter: CaseBanReasonCodeMinAggregateFilter;
  CaseBanReasonCodeMinAggregates: ResolverTypeWrapper<CaseBanReasonCodeMinAggregates>;
  CaseBanReasonCodeOrderBy: CaseBanReasonCodeOrderBy;
  CaseBanReasonCodeStddevPopulationAggregateFilter: CaseBanReasonCodeStddevPopulationAggregateFilter;
  CaseBanReasonCodeStddevPopulationAggregates: ResolverTypeWrapper<CaseBanReasonCodeStddevPopulationAggregates>;
  CaseBanReasonCodeStddevSampleAggregateFilter: CaseBanReasonCodeStddevSampleAggregateFilter;
  CaseBanReasonCodeStddevSampleAggregates: ResolverTypeWrapper<CaseBanReasonCodeStddevSampleAggregates>;
  CaseBanReasonCodeSumAggregateFilter: CaseBanReasonCodeSumAggregateFilter;
  CaseBanReasonCodeSumAggregates: ResolverTypeWrapper<CaseBanReasonCodeSumAggregates>;
  CaseBanReasonCodeVariancePopulationAggregateFilter: CaseBanReasonCodeVariancePopulationAggregateFilter;
  CaseBanReasonCodeVariancePopulationAggregates: ResolverTypeWrapper<CaseBanReasonCodeVariancePopulationAggregates>;
  CaseBanReasonCodeVarianceSampleAggregateFilter: CaseBanReasonCodeVarianceSampleAggregateFilter;
  CaseBanReasonCodeVarianceSampleAggregates: ResolverTypeWrapper<CaseBanReasonCodeVarianceSampleAggregates>;
  CaseBanResult: ResolverTypeWrapper<CaseBanResult>;
  CaseBanStddevPopulationAggregates: ResolverTypeWrapper<CaseBanStddevPopulationAggregates>;
  CaseBanStddevSampleAggregates: ResolverTypeWrapper<CaseBanStddevSampleAggregates>;
  CaseBanSumAggregates: ResolverTypeWrapper<CaseBanSumAggregates>;
  CaseBanToManyCaseBanReasonCodeFilter: CaseBanToManyCaseBanReasonCodeFilter;
  CaseBanToManyCaseBanTraderFilter: CaseBanToManyCaseBanTraderFilter;
  CaseBanToManyCaseEventFilter: CaseBanToManyCaseEventFilter;
  CaseBanToManyCaseLabelAssignmentFilter: CaseBanToManyCaseLabelAssignmentFilter;
  CaseBanTrader: ResolverTypeWrapper<CaseBanTrader>;
  CaseBanTraderAggregates: ResolverTypeWrapper<CaseBanTraderAggregates>;
  CaseBanTraderAggregatesFilter: CaseBanTraderAggregatesFilter;
  CaseBanTraderAverageAggregateFilter: CaseBanTraderAverageAggregateFilter;
  CaseBanTraderAverageAggregates: ResolverTypeWrapper<CaseBanTraderAverageAggregates>;
  CaseBanTraderCondition: CaseBanTraderCondition;
  CaseBanTraderConnection: ResolverTypeWrapper<CaseBanTraderConnection>;
  CaseBanTraderDistinctCountAggregateFilter: CaseBanTraderDistinctCountAggregateFilter;
  CaseBanTraderDistinctCountAggregates: ResolverTypeWrapper<CaseBanTraderDistinctCountAggregates>;
  CaseBanTraderEdge: ResolverTypeWrapper<CaseBanTraderEdge>;
  CaseBanTraderFilter: CaseBanTraderFilter;
  CaseBanTraderGroupBy: CaseBanTraderGroupBy;
  CaseBanTraderHavingAverageInput: CaseBanTraderHavingAverageInput;
  CaseBanTraderHavingDistinctCountInput: CaseBanTraderHavingDistinctCountInput;
  CaseBanTraderHavingInput: CaseBanTraderHavingInput;
  CaseBanTraderHavingMaxInput: CaseBanTraderHavingMaxInput;
  CaseBanTraderHavingMinInput: CaseBanTraderHavingMinInput;
  CaseBanTraderHavingStddevPopulationInput: CaseBanTraderHavingStddevPopulationInput;
  CaseBanTraderHavingStddevSampleInput: CaseBanTraderHavingStddevSampleInput;
  CaseBanTraderHavingSumInput: CaseBanTraderHavingSumInput;
  CaseBanTraderHavingVariancePopulationInput: CaseBanTraderHavingVariancePopulationInput;
  CaseBanTraderHavingVarianceSampleInput: CaseBanTraderHavingVarianceSampleInput;
  CaseBanTraderMaxAggregateFilter: CaseBanTraderMaxAggregateFilter;
  CaseBanTraderMaxAggregates: ResolverTypeWrapper<CaseBanTraderMaxAggregates>;
  CaseBanTraderMinAggregateFilter: CaseBanTraderMinAggregateFilter;
  CaseBanTraderMinAggregates: ResolverTypeWrapper<CaseBanTraderMinAggregates>;
  CaseBanTraderOrderBy: CaseBanTraderOrderBy;
  CaseBanTraderPendingDetailsResult: ResolverTypeWrapper<CaseBanTraderPendingDetailsResult>;
  CaseBanTraderResult: ResolverTypeWrapper<CaseBanTraderResult>;
  CaseBanTraderStddevPopulationAggregateFilter: CaseBanTraderStddevPopulationAggregateFilter;
  CaseBanTraderStddevPopulationAggregates: ResolverTypeWrapper<CaseBanTraderStddevPopulationAggregates>;
  CaseBanTraderStddevSampleAggregateFilter: CaseBanTraderStddevSampleAggregateFilter;
  CaseBanTraderStddevSampleAggregates: ResolverTypeWrapper<CaseBanTraderStddevSampleAggregates>;
  CaseBanTraderSumAggregateFilter: CaseBanTraderSumAggregateFilter;
  CaseBanTraderSumAggregates: ResolverTypeWrapper<CaseBanTraderSumAggregates>;
  CaseBanTraderVariancePopulationAggregateFilter: CaseBanTraderVariancePopulationAggregateFilter;
  CaseBanTraderVariancePopulationAggregates: ResolverTypeWrapper<CaseBanTraderVariancePopulationAggregates>;
  CaseBanTraderVarianceSampleAggregateFilter: CaseBanTraderVarianceSampleAggregateFilter;
  CaseBanTraderVarianceSampleAggregates: ResolverTypeWrapper<CaseBanTraderVarianceSampleAggregates>;
  CaseBanTradersInput: CaseBanTradersInput;
  CaseBanTradersRemovedResult: ResolverTypeWrapper<CaseBanTradersRemovedResult>;
  CaseBanVariancePopulationAggregates: ResolverTypeWrapper<CaseBanVariancePopulationAggregates>;
  CaseBanVarianceSampleAggregates: ResolverTypeWrapper<CaseBanVarianceSampleAggregates>;
  CaseDepartment: ResolverTypeWrapper<CaseDepartment>;
  CaseEvent: ResolverTypeWrapper<CaseEvent>;
  CaseEventAggregates: ResolverTypeWrapper<CaseEventAggregates>;
  CaseEventAggregatesFilter: CaseEventAggregatesFilter;
  CaseEventAverageAggregateFilter: CaseEventAverageAggregateFilter;
  CaseEventAverageAggregates: ResolverTypeWrapper<CaseEventAverageAggregates>;
  CaseEventCondition: CaseEventCondition;
  CaseEventConnection: ResolverTypeWrapper<CaseEventConnection>;
  CaseEventDistinctCountAggregateFilter: CaseEventDistinctCountAggregateFilter;
  CaseEventDistinctCountAggregates: ResolverTypeWrapper<CaseEventDistinctCountAggregates>;
  CaseEventEdge: ResolverTypeWrapper<CaseEventEdge>;
  CaseEventFilter: CaseEventFilter;
  CaseEventGroupBy: CaseEventGroupBy;
  CaseEventHavingAverageInput: CaseEventHavingAverageInput;
  CaseEventHavingDistinctCountInput: CaseEventHavingDistinctCountInput;
  CaseEventHavingInput: CaseEventHavingInput;
  CaseEventHavingMaxInput: CaseEventHavingMaxInput;
  CaseEventHavingMinInput: CaseEventHavingMinInput;
  CaseEventHavingStddevPopulationInput: CaseEventHavingStddevPopulationInput;
  CaseEventHavingStddevSampleInput: CaseEventHavingStddevSampleInput;
  CaseEventHavingSumInput: CaseEventHavingSumInput;
  CaseEventHavingVariancePopulationInput: CaseEventHavingVariancePopulationInput;
  CaseEventHavingVarianceSampleInput: CaseEventHavingVarianceSampleInput;
  CaseEventMaxAggregateFilter: CaseEventMaxAggregateFilter;
  CaseEventMaxAggregates: ResolverTypeWrapper<CaseEventMaxAggregates>;
  CaseEventMinAggregateFilter: CaseEventMinAggregateFilter;
  CaseEventMinAggregates: ResolverTypeWrapper<CaseEventMinAggregates>;
  CaseEventOrderBy: CaseEventOrderBy;
  CaseEventStddevPopulationAggregateFilter: CaseEventStddevPopulationAggregateFilter;
  CaseEventStddevPopulationAggregates: ResolverTypeWrapper<CaseEventStddevPopulationAggregates>;
  CaseEventStddevSampleAggregateFilter: CaseEventStddevSampleAggregateFilter;
  CaseEventStddevSampleAggregates: ResolverTypeWrapper<CaseEventStddevSampleAggregates>;
  CaseEventSumAggregateFilter: CaseEventSumAggregateFilter;
  CaseEventSumAggregates: ResolverTypeWrapper<CaseEventSumAggregates>;
  CaseEventType: CaseEventType;
  CaseEventVariancePopulationAggregateFilter: CaseEventVariancePopulationAggregateFilter;
  CaseEventVariancePopulationAggregates: ResolverTypeWrapper<CaseEventVariancePopulationAggregates>;
  CaseEventVarianceSampleAggregateFilter: CaseEventVarianceSampleAggregateFilter;
  CaseEventVarianceSampleAggregates: ResolverTypeWrapper<CaseEventVarianceSampleAggregates>;
  CaseInvestigation: ResolverTypeWrapper<CaseInvestigation>;
  CaseInvestigationAggregates: ResolverTypeWrapper<CaseInvestigationAggregates>;
  CaseInvestigationAggregatesFilter: CaseInvestigationAggregatesFilter;
  CaseInvestigationAverageAggregateFilter: CaseInvestigationAverageAggregateFilter;
  CaseInvestigationAverageAggregates: ResolverTypeWrapper<CaseInvestigationAverageAggregates>;
  CaseInvestigationCondition: CaseInvestigationCondition;
  CaseInvestigationConnection: ResolverTypeWrapper<CaseInvestigationConnection>;
  CaseInvestigationDistinctCountAggregateFilter: CaseInvestigationDistinctCountAggregateFilter;
  CaseInvestigationDistinctCountAggregates: ResolverTypeWrapper<CaseInvestigationDistinctCountAggregates>;
  CaseInvestigationEdge: ResolverTypeWrapper<CaseInvestigationEdge>;
  CaseInvestigationEventResult: ResolverTypeWrapper<CaseInvestigationEventResult>;
  CaseInvestigationFilter: CaseInvestigationFilter;
  CaseInvestigationGroupBy: CaseInvestigationGroupBy;
  CaseInvestigationHavingAverageInput: CaseInvestigationHavingAverageInput;
  CaseInvestigationHavingDistinctCountInput: CaseInvestigationHavingDistinctCountInput;
  CaseInvestigationHavingInput: CaseInvestigationHavingInput;
  CaseInvestigationHavingMaxInput: CaseInvestigationHavingMaxInput;
  CaseInvestigationHavingMinInput: CaseInvestigationHavingMinInput;
  CaseInvestigationHavingStddevPopulationInput: CaseInvestigationHavingStddevPopulationInput;
  CaseInvestigationHavingStddevSampleInput: CaseInvestigationHavingStddevSampleInput;
  CaseInvestigationHavingSumInput: CaseInvestigationHavingSumInput;
  CaseInvestigationHavingVariancePopulationInput: CaseInvestigationHavingVariancePopulationInput;
  CaseInvestigationHavingVarianceSampleInput: CaseInvestigationHavingVarianceSampleInput;
  CaseInvestigationMaxAggregateFilter: CaseInvestigationMaxAggregateFilter;
  CaseInvestigationMaxAggregates: ResolverTypeWrapper<CaseInvestigationMaxAggregates>;
  CaseInvestigationMinAggregateFilter: CaseInvestigationMinAggregateFilter;
  CaseInvestigationMinAggregates: ResolverTypeWrapper<CaseInvestigationMinAggregates>;
  CaseInvestigationOrderBy: CaseInvestigationOrderBy;
  CaseInvestigationPayoutHold: CaseInvestigationPayoutHold;
  CaseInvestigationPendingAction: CaseInvestigationPendingAction;
  CaseInvestigationResult: ResolverTypeWrapper<CaseInvestigationResult>;
  CaseInvestigationStddevPopulationAggregateFilter: CaseInvestigationStddevPopulationAggregateFilter;
  CaseInvestigationStddevPopulationAggregates: ResolverTypeWrapper<CaseInvestigationStddevPopulationAggregates>;
  CaseInvestigationStddevSampleAggregateFilter: CaseInvestigationStddevSampleAggregateFilter;
  CaseInvestigationStddevSampleAggregates: ResolverTypeWrapper<CaseInvestigationStddevSampleAggregates>;
  CaseInvestigationSubmittedDepartment: ResolverTypeWrapper<CaseInvestigationSubmittedDepartment>;
  CaseInvestigationSubmittedDepartmentAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentAggregates>;
  CaseInvestigationSubmittedDepartmentAverageAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentAverageAggregates>;
  CaseInvestigationSubmittedDepartmentCondition: CaseInvestigationSubmittedDepartmentCondition;
  CaseInvestigationSubmittedDepartmentConnection: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentConnection>;
  CaseInvestigationSubmittedDepartmentDistinctCountAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentDistinctCountAggregates>;
  CaseInvestigationSubmittedDepartmentEdge: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentEdge>;
  CaseInvestigationSubmittedDepartmentFilter: CaseInvestigationSubmittedDepartmentFilter;
  CaseInvestigationSubmittedDepartmentMaxAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentMaxAggregates>;
  CaseInvestigationSubmittedDepartmentMinAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentMinAggregates>;
  CaseInvestigationSubmittedDepartmentOrderBy: CaseInvestigationSubmittedDepartmentOrderBy;
  CaseInvestigationSubmittedDepartmentStddevPopulationAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentStddevPopulationAggregates>;
  CaseInvestigationSubmittedDepartmentStddevSampleAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentStddevSampleAggregates>;
  CaseInvestigationSubmittedDepartmentSumAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentSumAggregates>;
  CaseInvestigationSubmittedDepartmentToManyCaseInvestigationFilter: CaseInvestigationSubmittedDepartmentToManyCaseInvestigationFilter;
  CaseInvestigationSubmittedDepartmentVariancePopulationAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentVariancePopulationAggregates>;
  CaseInvestigationSubmittedDepartmentVarianceSampleAggregates: ResolverTypeWrapper<CaseInvestigationSubmittedDepartmentVarianceSampleAggregates>;
  CaseInvestigationSumAggregateFilter: CaseInvestigationSumAggregateFilter;
  CaseInvestigationSumAggregates: ResolverTypeWrapper<CaseInvestigationSumAggregates>;
  CaseInvestigationToManyCaseEventFilter: CaseInvestigationToManyCaseEventFilter;
  CaseInvestigationToManyCaseInvestigationTraderFilter: CaseInvestigationToManyCaseInvestigationTraderFilter;
  CaseInvestigationToManyCaseLabelAssignmentFilter: CaseInvestigationToManyCaseLabelAssignmentFilter;
  CaseInvestigationTrader: ResolverTypeWrapper<CaseInvestigationTrader>;
  CaseInvestigationTraderAggregates: ResolverTypeWrapper<CaseInvestigationTraderAggregates>;
  CaseInvestigationTraderAggregatesFilter: CaseInvestigationTraderAggregatesFilter;
  CaseInvestigationTraderAverageAggregateFilter: CaseInvestigationTraderAverageAggregateFilter;
  CaseInvestigationTraderAverageAggregates: ResolverTypeWrapper<CaseInvestigationTraderAverageAggregates>;
  CaseInvestigationTraderCondition: CaseInvestigationTraderCondition;
  CaseInvestigationTraderConnection: ResolverTypeWrapper<CaseInvestigationTraderConnection>;
  CaseInvestigationTraderDistinctCountAggregateFilter: CaseInvestigationTraderDistinctCountAggregateFilter;
  CaseInvestigationTraderDistinctCountAggregates: ResolverTypeWrapper<CaseInvestigationTraderDistinctCountAggregates>;
  CaseInvestigationTraderEdge: ResolverTypeWrapper<CaseInvestigationTraderEdge>;
  CaseInvestigationTraderFilter: CaseInvestigationTraderFilter;
  CaseInvestigationTraderGroupBy: CaseInvestigationTraderGroupBy;
  CaseInvestigationTraderHavingAverageInput: CaseInvestigationTraderHavingAverageInput;
  CaseInvestigationTraderHavingDistinctCountInput: CaseInvestigationTraderHavingDistinctCountInput;
  CaseInvestigationTraderHavingInput: CaseInvestigationTraderHavingInput;
  CaseInvestigationTraderHavingMaxInput: CaseInvestigationTraderHavingMaxInput;
  CaseInvestigationTraderHavingMinInput: CaseInvestigationTraderHavingMinInput;
  CaseInvestigationTraderHavingStddevPopulationInput: CaseInvestigationTraderHavingStddevPopulationInput;
  CaseInvestigationTraderHavingStddevSampleInput: CaseInvestigationTraderHavingStddevSampleInput;
  CaseInvestigationTraderHavingSumInput: CaseInvestigationTraderHavingSumInput;
  CaseInvestigationTraderHavingVariancePopulationInput: CaseInvestigationTraderHavingVariancePopulationInput;
  CaseInvestigationTraderHavingVarianceSampleInput: CaseInvestigationTraderHavingVarianceSampleInput;
  CaseInvestigationTraderMaxAggregateFilter: CaseInvestigationTraderMaxAggregateFilter;
  CaseInvestigationTraderMaxAggregates: ResolverTypeWrapper<CaseInvestigationTraderMaxAggregates>;
  CaseInvestigationTraderMinAggregateFilter: CaseInvestigationTraderMinAggregateFilter;
  CaseInvestigationTraderMinAggregates: ResolverTypeWrapper<CaseInvestigationTraderMinAggregates>;
  CaseInvestigationTraderOrderBy: CaseInvestigationTraderOrderBy;
  CaseInvestigationTraderPendingDetailsResult: ResolverTypeWrapper<CaseInvestigationTraderPendingDetailsResult>;
  CaseInvestigationTraderResult: ResolverTypeWrapper<CaseInvestigationTraderResult>;
  CaseInvestigationTraderStddevPopulationAggregateFilter: CaseInvestigationTraderStddevPopulationAggregateFilter;
  CaseInvestigationTraderStddevPopulationAggregates: ResolverTypeWrapper<CaseInvestigationTraderStddevPopulationAggregates>;
  CaseInvestigationTraderStddevSampleAggregateFilter: CaseInvestigationTraderStddevSampleAggregateFilter;
  CaseInvestigationTraderStddevSampleAggregates: ResolverTypeWrapper<CaseInvestigationTraderStddevSampleAggregates>;
  CaseInvestigationTraderSumAggregateFilter: CaseInvestigationTraderSumAggregateFilter;
  CaseInvestigationTraderSumAggregates: ResolverTypeWrapper<CaseInvestigationTraderSumAggregates>;
  CaseInvestigationTraderVariancePopulationAggregateFilter: CaseInvestigationTraderVariancePopulationAggregateFilter;
  CaseInvestigationTraderVariancePopulationAggregates: ResolverTypeWrapper<CaseInvestigationTraderVariancePopulationAggregates>;
  CaseInvestigationTraderVarianceSampleAggregateFilter: CaseInvestigationTraderVarianceSampleAggregateFilter;
  CaseInvestigationTraderVarianceSampleAggregates: ResolverTypeWrapper<CaseInvestigationTraderVarianceSampleAggregates>;
  CaseInvestigationTradersInput: CaseInvestigationTradersInput;
  CaseInvestigationTradersRemovedResult: ResolverTypeWrapper<CaseInvestigationTradersRemovedResult>;
  CaseInvestigationVariancePopulationAggregateFilter: CaseInvestigationVariancePopulationAggregateFilter;
  CaseInvestigationVariancePopulationAggregates: ResolverTypeWrapper<CaseInvestigationVariancePopulationAggregates>;
  CaseInvestigationVarianceSampleAggregateFilter: CaseInvestigationVarianceSampleAggregateFilter;
  CaseInvestigationVarianceSampleAggregates: ResolverTypeWrapper<CaseInvestigationVarianceSampleAggregates>;
  CaseLabel: ResolverTypeWrapper<CaseLabel>;
  CaseLabelAggregates: ResolverTypeWrapper<CaseLabelAggregates>;
  CaseLabelAssignment: ResolverTypeWrapper<CaseLabelAssignment>;
  CaseLabelAssignmentAggregates: ResolverTypeWrapper<CaseLabelAssignmentAggregates>;
  CaseLabelAssignmentAggregatesFilter: CaseLabelAssignmentAggregatesFilter;
  CaseLabelAssignmentAverageAggregateFilter: CaseLabelAssignmentAverageAggregateFilter;
  CaseLabelAssignmentAverageAggregates: ResolverTypeWrapper<CaseLabelAssignmentAverageAggregates>;
  CaseLabelAssignmentCondition: CaseLabelAssignmentCondition;
  CaseLabelAssignmentConnection: ResolverTypeWrapper<CaseLabelAssignmentConnection>;
  CaseLabelAssignmentDistinctCountAggregateFilter: CaseLabelAssignmentDistinctCountAggregateFilter;
  CaseLabelAssignmentDistinctCountAggregates: ResolverTypeWrapper<CaseLabelAssignmentDistinctCountAggregates>;
  CaseLabelAssignmentEdge: ResolverTypeWrapper<CaseLabelAssignmentEdge>;
  CaseLabelAssignmentFilter: CaseLabelAssignmentFilter;
  CaseLabelAssignmentGroupBy: CaseLabelAssignmentGroupBy;
  CaseLabelAssignmentHavingAverageInput: CaseLabelAssignmentHavingAverageInput;
  CaseLabelAssignmentHavingDistinctCountInput: CaseLabelAssignmentHavingDistinctCountInput;
  CaseLabelAssignmentHavingInput: CaseLabelAssignmentHavingInput;
  CaseLabelAssignmentHavingMaxInput: CaseLabelAssignmentHavingMaxInput;
  CaseLabelAssignmentHavingMinInput: CaseLabelAssignmentHavingMinInput;
  CaseLabelAssignmentHavingStddevPopulationInput: CaseLabelAssignmentHavingStddevPopulationInput;
  CaseLabelAssignmentHavingStddevSampleInput: CaseLabelAssignmentHavingStddevSampleInput;
  CaseLabelAssignmentHavingSumInput: CaseLabelAssignmentHavingSumInput;
  CaseLabelAssignmentHavingVariancePopulationInput: CaseLabelAssignmentHavingVariancePopulationInput;
  CaseLabelAssignmentHavingVarianceSampleInput: CaseLabelAssignmentHavingVarianceSampleInput;
  CaseLabelAssignmentMaxAggregateFilter: CaseLabelAssignmentMaxAggregateFilter;
  CaseLabelAssignmentMaxAggregates: ResolverTypeWrapper<CaseLabelAssignmentMaxAggregates>;
  CaseLabelAssignmentMinAggregateFilter: CaseLabelAssignmentMinAggregateFilter;
  CaseLabelAssignmentMinAggregates: ResolverTypeWrapper<CaseLabelAssignmentMinAggregates>;
  CaseLabelAssignmentOrderBy: CaseLabelAssignmentOrderBy;
  CaseLabelAssignmentStddevPopulationAggregateFilter: CaseLabelAssignmentStddevPopulationAggregateFilter;
  CaseLabelAssignmentStddevPopulationAggregates: ResolverTypeWrapper<CaseLabelAssignmentStddevPopulationAggregates>;
  CaseLabelAssignmentStddevSampleAggregateFilter: CaseLabelAssignmentStddevSampleAggregateFilter;
  CaseLabelAssignmentStddevSampleAggregates: ResolverTypeWrapper<CaseLabelAssignmentStddevSampleAggregates>;
  CaseLabelAssignmentSumAggregateFilter: CaseLabelAssignmentSumAggregateFilter;
  CaseLabelAssignmentSumAggregates: ResolverTypeWrapper<CaseLabelAssignmentSumAggregates>;
  CaseLabelAssignmentVariancePopulationAggregateFilter: CaseLabelAssignmentVariancePopulationAggregateFilter;
  CaseLabelAssignmentVariancePopulationAggregates: ResolverTypeWrapper<CaseLabelAssignmentVariancePopulationAggregates>;
  CaseLabelAssignmentVarianceSampleAggregateFilter: CaseLabelAssignmentVarianceSampleAggregateFilter;
  CaseLabelAssignmentVarianceSampleAggregates: ResolverTypeWrapper<CaseLabelAssignmentVarianceSampleAggregates>;
  CaseLabelAverageAggregates: ResolverTypeWrapper<CaseLabelAverageAggregates>;
  CaseLabelCondition: CaseLabelCondition;
  CaseLabelConnection: ResolverTypeWrapper<CaseLabelConnection>;
  CaseLabelDistinctCountAggregates: ResolverTypeWrapper<CaseLabelDistinctCountAggregates>;
  CaseLabelEdge: ResolverTypeWrapper<CaseLabelEdge>;
  CaseLabelFilter: CaseLabelFilter;
  CaseLabelMaxAggregates: ResolverTypeWrapper<CaseLabelMaxAggregates>;
  CaseLabelMinAggregates: ResolverTypeWrapper<CaseLabelMinAggregates>;
  CaseLabelOrderBy: CaseLabelOrderBy;
  CaseLabelStddevPopulationAggregates: ResolverTypeWrapper<CaseLabelStddevPopulationAggregates>;
  CaseLabelStddevSampleAggregates: ResolverTypeWrapper<CaseLabelStddevSampleAggregates>;
  CaseLabelSumAggregates: ResolverTypeWrapper<CaseLabelSumAggregates>;
  CaseLabelVariancePopulationAggregates: ResolverTypeWrapper<CaseLabelVariancePopulationAggregates>;
  CaseLabelVarianceSampleAggregates: ResolverTypeWrapper<CaseLabelVarianceSampleAggregates>;
  CaseSeverity: CaseSeverity;
  CaseSeverityFilter: CaseSeverityFilter;
  CaseStatus: CaseStatus;
  CaseStatusFilter: CaseStatusFilter;
  CaseType: ResolverTypeWrapper<CaseType>;
  CaseTypeAggregates: ResolverTypeWrapper<CaseTypeAggregates>;
  CaseTypeAverageAggregates: ResolverTypeWrapper<CaseTypeAverageAggregates>;
  CaseTypeCondition: CaseTypeCondition;
  CaseTypeConnection: ResolverTypeWrapper<CaseTypeConnection>;
  CaseTypeDistinctCountAggregates: ResolverTypeWrapper<CaseTypeDistinctCountAggregates>;
  CaseTypeEdge: ResolverTypeWrapper<CaseTypeEdge>;
  CaseTypeFilter: CaseTypeFilter;
  CaseTypeMaxAggregates: ResolverTypeWrapper<CaseTypeMaxAggregates>;
  CaseTypeMinAggregates: ResolverTypeWrapper<CaseTypeMinAggregates>;
  CaseTypeOrderBy: CaseTypeOrderBy;
  CaseTypeStddevPopulationAggregates: ResolverTypeWrapper<CaseTypeStddevPopulationAggregates>;
  CaseTypeStddevSampleAggregates: ResolverTypeWrapper<CaseTypeStddevSampleAggregates>;
  CaseTypeSumAggregates: ResolverTypeWrapper<CaseTypeSumAggregates>;
  CaseTypeVariancePopulationAggregates: ResolverTypeWrapper<CaseTypeVariancePopulationAggregates>;
  CaseTypeVarianceSampleAggregates: ResolverTypeWrapper<CaseTypeVarianceSampleAggregates>;
  Chargeback: ResolverTypeWrapper<Chargeback>;
  ChargebackAdminAction: ResolverTypeWrapper<ChargebackAdminAction>;
  ChargebackAggregates: ResolverTypeWrapper<ChargebackAggregates>;
  ChargebackAggregatesFilter: ChargebackAggregatesFilter;
  ChargebackAverageAggregateFilter: ChargebackAverageAggregateFilter;
  ChargebackAverageAggregates: ResolverTypeWrapper<ChargebackAverageAggregates>;
  ChargebackCondition: ChargebackCondition;
  ChargebackConnection: ResolverTypeWrapper<ChargebackConnection>;
  ChargebackDistinctCountAggregateFilter: ChargebackDistinctCountAggregateFilter;
  ChargebackDistinctCountAggregates: ResolverTypeWrapper<ChargebackDistinctCountAggregates>;
  ChargebackEdge: ResolverTypeWrapper<ChargebackEdge>;
  ChargebackFeedRun: ResolverTypeWrapper<ChargebackFeedRun>;
  ChargebackFeedRunFilter: ChargebackFeedRunFilter;
  ChargebackFeedRunToManyChargebackFeedVersionFilter: ChargebackFeedRunToManyChargebackFeedVersionFilter;
  ChargebackFeedSource: ResolverTypeWrapper<ChargebackFeedSource>;
  ChargebackFeedVersion: ResolverTypeWrapper<ChargebackFeedVersion>;
  ChargebackFeedVersionAggregates: ResolverTypeWrapper<ChargebackFeedVersionAggregates>;
  ChargebackFeedVersionAggregatesFilter: ChargebackFeedVersionAggregatesFilter;
  ChargebackFeedVersionAverageAggregateFilter: ChargebackFeedVersionAverageAggregateFilter;
  ChargebackFeedVersionAverageAggregates: ResolverTypeWrapper<ChargebackFeedVersionAverageAggregates>;
  ChargebackFeedVersionCondition: ChargebackFeedVersionCondition;
  ChargebackFeedVersionConnection: ResolverTypeWrapper<ChargebackFeedVersionConnection>;
  ChargebackFeedVersionDistinctCountAggregateFilter: ChargebackFeedVersionDistinctCountAggregateFilter;
  ChargebackFeedVersionDistinctCountAggregates: ResolverTypeWrapper<ChargebackFeedVersionDistinctCountAggregates>;
  ChargebackFeedVersionEdge: ResolverTypeWrapper<ChargebackFeedVersionEdge>;
  ChargebackFeedVersionFilter: ChargebackFeedVersionFilter;
  ChargebackFeedVersionGroupBy: ChargebackFeedVersionGroupBy;
  ChargebackFeedVersionHavingAverageInput: ChargebackFeedVersionHavingAverageInput;
  ChargebackFeedVersionHavingDistinctCountInput: ChargebackFeedVersionHavingDistinctCountInput;
  ChargebackFeedVersionHavingInput: ChargebackFeedVersionHavingInput;
  ChargebackFeedVersionHavingMaxInput: ChargebackFeedVersionHavingMaxInput;
  ChargebackFeedVersionHavingMinInput: ChargebackFeedVersionHavingMinInput;
  ChargebackFeedVersionHavingStddevPopulationInput: ChargebackFeedVersionHavingStddevPopulationInput;
  ChargebackFeedVersionHavingStddevSampleInput: ChargebackFeedVersionHavingStddevSampleInput;
  ChargebackFeedVersionHavingSumInput: ChargebackFeedVersionHavingSumInput;
  ChargebackFeedVersionHavingVariancePopulationInput: ChargebackFeedVersionHavingVariancePopulationInput;
  ChargebackFeedVersionHavingVarianceSampleInput: ChargebackFeedVersionHavingVarianceSampleInput;
  ChargebackFeedVersionMaxAggregateFilter: ChargebackFeedVersionMaxAggregateFilter;
  ChargebackFeedVersionMaxAggregates: ResolverTypeWrapper<ChargebackFeedVersionMaxAggregates>;
  ChargebackFeedVersionMinAggregateFilter: ChargebackFeedVersionMinAggregateFilter;
  ChargebackFeedVersionMinAggregates: ResolverTypeWrapper<ChargebackFeedVersionMinAggregates>;
  ChargebackFeedVersionOrderBy: ChargebackFeedVersionOrderBy;
  ChargebackFeedVersionStddevPopulationAggregateFilter: ChargebackFeedVersionStddevPopulationAggregateFilter;
  ChargebackFeedVersionStddevPopulationAggregates: ResolverTypeWrapper<ChargebackFeedVersionStddevPopulationAggregates>;
  ChargebackFeedVersionStddevSampleAggregateFilter: ChargebackFeedVersionStddevSampleAggregateFilter;
  ChargebackFeedVersionStddevSampleAggregates: ResolverTypeWrapper<ChargebackFeedVersionStddevSampleAggregates>;
  ChargebackFeedVersionSumAggregateFilter: ChargebackFeedVersionSumAggregateFilter;
  ChargebackFeedVersionSumAggregates: ResolverTypeWrapper<ChargebackFeedVersionSumAggregates>;
  ChargebackFeedVersionVariancePopulationAggregateFilter: ChargebackFeedVersionVariancePopulationAggregateFilter;
  ChargebackFeedVersionVariancePopulationAggregates: ResolverTypeWrapper<ChargebackFeedVersionVariancePopulationAggregates>;
  ChargebackFeedVersionVarianceSampleAggregateFilter: ChargebackFeedVersionVarianceSampleAggregateFilter;
  ChargebackFeedVersionVarianceSampleAggregates: ResolverTypeWrapper<ChargebackFeedVersionVarianceSampleAggregates>;
  ChargebackFilter: ChargebackFilter;
  ChargebackFlag: ResolverTypeWrapper<ChargebackFlag>;
  ChargebackGroupBy: ChargebackGroupBy;
  ChargebackHavingAverageInput: ChargebackHavingAverageInput;
  ChargebackHavingDistinctCountInput: ChargebackHavingDistinctCountInput;
  ChargebackHavingInput: ChargebackHavingInput;
  ChargebackHavingMaxInput: ChargebackHavingMaxInput;
  ChargebackHavingMinInput: ChargebackHavingMinInput;
  ChargebackHavingStddevPopulationInput: ChargebackHavingStddevPopulationInput;
  ChargebackHavingStddevSampleInput: ChargebackHavingStddevSampleInput;
  ChargebackHavingSumInput: ChargebackHavingSumInput;
  ChargebackHavingVariancePopulationInput: ChargebackHavingVariancePopulationInput;
  ChargebackHavingVarianceSampleInput: ChargebackHavingVarianceSampleInput;
  ChargebackIndicator: ResolverTypeWrapper<ChargebackIndicator>;
  ChargebackIndicatorAggregates: ResolverTypeWrapper<ChargebackIndicatorAggregates>;
  ChargebackIndicatorAggregatesFilter: ChargebackIndicatorAggregatesFilter;
  ChargebackIndicatorAverageAggregateFilter: ChargebackIndicatorAverageAggregateFilter;
  ChargebackIndicatorAverageAggregates: ResolverTypeWrapper<ChargebackIndicatorAverageAggregates>;
  ChargebackIndicatorCondition: ChargebackIndicatorCondition;
  ChargebackIndicatorConnection: ResolverTypeWrapper<ChargebackIndicatorConnection>;
  ChargebackIndicatorDistinctCountAggregateFilter: ChargebackIndicatorDistinctCountAggregateFilter;
  ChargebackIndicatorDistinctCountAggregates: ResolverTypeWrapper<ChargebackIndicatorDistinctCountAggregates>;
  ChargebackIndicatorEdge: ResolverTypeWrapper<ChargebackIndicatorEdge>;
  ChargebackIndicatorFilter: ChargebackIndicatorFilter;
  ChargebackIndicatorGroupBy: ChargebackIndicatorGroupBy;
  ChargebackIndicatorHavingAverageInput: ChargebackIndicatorHavingAverageInput;
  ChargebackIndicatorHavingDistinctCountInput: ChargebackIndicatorHavingDistinctCountInput;
  ChargebackIndicatorHavingInput: ChargebackIndicatorHavingInput;
  ChargebackIndicatorHavingMaxInput: ChargebackIndicatorHavingMaxInput;
  ChargebackIndicatorHavingMinInput: ChargebackIndicatorHavingMinInput;
  ChargebackIndicatorHavingStddevPopulationInput: ChargebackIndicatorHavingStddevPopulationInput;
  ChargebackIndicatorHavingStddevSampleInput: ChargebackIndicatorHavingStddevSampleInput;
  ChargebackIndicatorHavingSumInput: ChargebackIndicatorHavingSumInput;
  ChargebackIndicatorHavingVariancePopulationInput: ChargebackIndicatorHavingVariancePopulationInput;
  ChargebackIndicatorHavingVarianceSampleInput: ChargebackIndicatorHavingVarianceSampleInput;
  ChargebackIndicatorMaxAggregateFilter: ChargebackIndicatorMaxAggregateFilter;
  ChargebackIndicatorMaxAggregates: ResolverTypeWrapper<ChargebackIndicatorMaxAggregates>;
  ChargebackIndicatorMinAggregateFilter: ChargebackIndicatorMinAggregateFilter;
  ChargebackIndicatorMinAggregates: ResolverTypeWrapper<ChargebackIndicatorMinAggregates>;
  ChargebackIndicatorOrderBy: ChargebackIndicatorOrderBy;
  ChargebackIndicatorStddevPopulationAggregateFilter: ChargebackIndicatorStddevPopulationAggregateFilter;
  ChargebackIndicatorStddevPopulationAggregates: ResolverTypeWrapper<ChargebackIndicatorStddevPopulationAggregates>;
  ChargebackIndicatorStddevSampleAggregateFilter: ChargebackIndicatorStddevSampleAggregateFilter;
  ChargebackIndicatorStddevSampleAggregates: ResolverTypeWrapper<ChargebackIndicatorStddevSampleAggregates>;
  ChargebackIndicatorSumAggregateFilter: ChargebackIndicatorSumAggregateFilter;
  ChargebackIndicatorSumAggregates: ResolverTypeWrapper<ChargebackIndicatorSumAggregates>;
  ChargebackIndicatorVariancePopulationAggregateFilter: ChargebackIndicatorVariancePopulationAggregateFilter;
  ChargebackIndicatorVariancePopulationAggregates: ResolverTypeWrapper<ChargebackIndicatorVariancePopulationAggregates>;
  ChargebackIndicatorVarianceSampleAggregateFilter: ChargebackIndicatorVarianceSampleAggregateFilter;
  ChargebackIndicatorVarianceSampleAggregates: ResolverTypeWrapper<ChargebackIndicatorVarianceSampleAggregates>;
  ChargebackLifecycleState: ChargebackLifecycleState;
  ChargebackMaxAggregateFilter: ChargebackMaxAggregateFilter;
  ChargebackMaxAggregates: ResolverTypeWrapper<ChargebackMaxAggregates>;
  ChargebackMinAggregateFilter: ChargebackMinAggregateFilter;
  ChargebackMinAggregates: ResolverTypeWrapper<ChargebackMinAggregates>;
  ChargebackOrderBy: ChargebackOrderBy;
  ChargebackProcessor: ChargebackProcessor;
  ChargebackProcessorFilter: ChargebackProcessorFilter;
  ChargebackResult: ResolverTypeWrapper<ChargebackResult>;
  ChargebackStddevPopulationAggregateFilter: ChargebackStddevPopulationAggregateFilter;
  ChargebackStddevPopulationAggregates: ResolverTypeWrapper<ChargebackStddevPopulationAggregates>;
  ChargebackStddevSampleAggregateFilter: ChargebackStddevSampleAggregateFilter;
  ChargebackStddevSampleAggregates: ResolverTypeWrapper<ChargebackStddevSampleAggregates>;
  ChargebackSumAggregateFilter: ChargebackSumAggregateFilter;
  ChargebackSumAggregates: ResolverTypeWrapper<ChargebackSumAggregates>;
  ChargebackTotals: ResolverTypeWrapper<ChargebackTotals>;
  ChargebackVariancePopulationAggregateFilter: ChargebackVariancePopulationAggregateFilter;
  ChargebackVariancePopulationAggregates: ResolverTypeWrapper<ChargebackVariancePopulationAggregates>;
  ChargebackVarianceSampleAggregateFilter: ChargebackVarianceSampleAggregateFilter;
  ChargebackVarianceSampleAggregates: ResolverTypeWrapper<ChargebackVarianceSampleAggregates>;
  CheckoutItem: ResolverTypeWrapper<CheckoutItem>;
  CheckoutItemAggregates: ResolverTypeWrapper<CheckoutItemAggregates>;
  CheckoutItemAggregatesFilter: CheckoutItemAggregatesFilter;
  CheckoutItemAverageAggregateFilter: CheckoutItemAverageAggregateFilter;
  CheckoutItemAverageAggregates: ResolverTypeWrapper<CheckoutItemAverageAggregates>;
  CheckoutItemCondition: CheckoutItemCondition;
  CheckoutItemConnection: ResolverTypeWrapper<CheckoutItemConnection>;
  CheckoutItemDistinctCountAggregateFilter: CheckoutItemDistinctCountAggregateFilter;
  CheckoutItemDistinctCountAggregates: ResolverTypeWrapper<CheckoutItemDistinctCountAggregates>;
  CheckoutItemEdge: ResolverTypeWrapper<CheckoutItemEdge>;
  CheckoutItemFilter: CheckoutItemFilter;
  CheckoutItemGroupBy: CheckoutItemGroupBy;
  CheckoutItemHavingAverageInput: CheckoutItemHavingAverageInput;
  CheckoutItemHavingDistinctCountInput: CheckoutItemHavingDistinctCountInput;
  CheckoutItemHavingInput: CheckoutItemHavingInput;
  CheckoutItemHavingMaxInput: CheckoutItemHavingMaxInput;
  CheckoutItemHavingMinInput: CheckoutItemHavingMinInput;
  CheckoutItemHavingStddevPopulationInput: CheckoutItemHavingStddevPopulationInput;
  CheckoutItemHavingStddevSampleInput: CheckoutItemHavingStddevSampleInput;
  CheckoutItemHavingSumInput: CheckoutItemHavingSumInput;
  CheckoutItemHavingVariancePopulationInput: CheckoutItemHavingVariancePopulationInput;
  CheckoutItemHavingVarianceSampleInput: CheckoutItemHavingVarianceSampleInput;
  CheckoutItemMaxAggregateFilter: CheckoutItemMaxAggregateFilter;
  CheckoutItemMaxAggregates: ResolverTypeWrapper<CheckoutItemMaxAggregates>;
  CheckoutItemMinAggregateFilter: CheckoutItemMinAggregateFilter;
  CheckoutItemMinAggregates: ResolverTypeWrapper<CheckoutItemMinAggregates>;
  CheckoutItemOrderBy: CheckoutItemOrderBy;
  CheckoutItemStddevPopulationAggregateFilter: CheckoutItemStddevPopulationAggregateFilter;
  CheckoutItemStddevPopulationAggregates: ResolverTypeWrapper<CheckoutItemStddevPopulationAggregates>;
  CheckoutItemStddevSampleAggregateFilter: CheckoutItemStddevSampleAggregateFilter;
  CheckoutItemStddevSampleAggregates: ResolverTypeWrapper<CheckoutItemStddevSampleAggregates>;
  CheckoutItemSumAggregateFilter: CheckoutItemSumAggregateFilter;
  CheckoutItemSumAggregates: ResolverTypeWrapper<CheckoutItemSumAggregates>;
  CheckoutItemVariancePopulationAggregateFilter: CheckoutItemVariancePopulationAggregateFilter;
  CheckoutItemVariancePopulationAggregates: ResolverTypeWrapper<CheckoutItemVariancePopulationAggregates>;
  CheckoutItemVarianceSampleAggregateFilter: CheckoutItemVarianceSampleAggregateFilter;
  CheckoutItemVarianceSampleAggregates: ResolverTypeWrapper<CheckoutItemVarianceSampleAggregates>;
  CheckoutSession: ResolverTypeWrapper<CheckoutSession>;
  CheckoutSessionAggregates: ResolverTypeWrapper<CheckoutSessionAggregates>;
  CheckoutSessionAggregatesFilter: CheckoutSessionAggregatesFilter;
  CheckoutSessionAverageAggregateFilter: CheckoutSessionAverageAggregateFilter;
  CheckoutSessionAverageAggregates: ResolverTypeWrapper<CheckoutSessionAverageAggregates>;
  CheckoutSessionCondition: CheckoutSessionCondition;
  CheckoutSessionConnection: ResolverTypeWrapper<CheckoutSessionConnection>;
  CheckoutSessionDistinctCountAggregateFilter: CheckoutSessionDistinctCountAggregateFilter;
  CheckoutSessionDistinctCountAggregates: ResolverTypeWrapper<CheckoutSessionDistinctCountAggregates>;
  CheckoutSessionEdge: ResolverTypeWrapper<CheckoutSessionEdge>;
  CheckoutSessionFilter: CheckoutSessionFilter;
  CheckoutSessionGroupBy: CheckoutSessionGroupBy;
  CheckoutSessionHavingAverageInput: CheckoutSessionHavingAverageInput;
  CheckoutSessionHavingDistinctCountInput: CheckoutSessionHavingDistinctCountInput;
  CheckoutSessionHavingInput: CheckoutSessionHavingInput;
  CheckoutSessionHavingMaxInput: CheckoutSessionHavingMaxInput;
  CheckoutSessionHavingMinInput: CheckoutSessionHavingMinInput;
  CheckoutSessionHavingStddevPopulationInput: CheckoutSessionHavingStddevPopulationInput;
  CheckoutSessionHavingStddevSampleInput: CheckoutSessionHavingStddevSampleInput;
  CheckoutSessionHavingSumInput: CheckoutSessionHavingSumInput;
  CheckoutSessionHavingVariancePopulationInput: CheckoutSessionHavingVariancePopulationInput;
  CheckoutSessionHavingVarianceSampleInput: CheckoutSessionHavingVarianceSampleInput;
  CheckoutSessionMaxAggregateFilter: CheckoutSessionMaxAggregateFilter;
  CheckoutSessionMaxAggregates: ResolverTypeWrapper<CheckoutSessionMaxAggregates>;
  CheckoutSessionMinAggregateFilter: CheckoutSessionMinAggregateFilter;
  CheckoutSessionMinAggregates: ResolverTypeWrapper<CheckoutSessionMinAggregates>;
  CheckoutSessionOrderBy: CheckoutSessionOrderBy;
  CheckoutSessionStatusEnum: CheckoutSessionStatusEnum;
  CheckoutSessionStatusEnumFilter: CheckoutSessionStatusEnumFilter;
  CheckoutSessionStddevPopulationAggregateFilter: CheckoutSessionStddevPopulationAggregateFilter;
  CheckoutSessionStddevPopulationAggregates: ResolverTypeWrapper<CheckoutSessionStddevPopulationAggregates>;
  CheckoutSessionStddevSampleAggregateFilter: CheckoutSessionStddevSampleAggregateFilter;
  CheckoutSessionStddevSampleAggregates: ResolverTypeWrapper<CheckoutSessionStddevSampleAggregates>;
  CheckoutSessionSumAggregateFilter: CheckoutSessionSumAggregateFilter;
  CheckoutSessionSumAggregates: ResolverTypeWrapper<CheckoutSessionSumAggregates>;
  CheckoutSessionToManyCheckoutItemFilter: CheckoutSessionToManyCheckoutItemFilter;
  CheckoutSessionVariancePopulationAggregateFilter: CheckoutSessionVariancePopulationAggregateFilter;
  CheckoutSessionVariancePopulationAggregates: ResolverTypeWrapper<CheckoutSessionVariancePopulationAggregates>;
  CheckoutSessionVarianceSampleAggregateFilter: CheckoutSessionVarianceSampleAggregateFilter;
  CheckoutSessionVarianceSampleAggregates: ResolverTypeWrapper<CheckoutSessionVarianceSampleAggregates>;
  CorrectAccountCapitalEntryInput: CorrectAccountCapitalEntryInput;
  Coupon: ResolverTypeWrapper<Coupon>;
  CouponAggregates: ResolverTypeWrapper<CouponAggregates>;
  CouponAverageAggregates: ResolverTypeWrapper<CouponAverageAggregates>;
  CouponCondition: CouponCondition;
  CouponConnection: ResolverTypeWrapper<CouponConnection>;
  CouponDistinctCountAggregates: ResolverTypeWrapper<CouponDistinctCountAggregates>;
  CouponEdge: ResolverTypeWrapper<CouponEdge>;
  CouponFilter: CouponFilter;
  CouponGroupBy: CouponGroupBy;
  CouponHavingAverageInput: CouponHavingAverageInput;
  CouponHavingDistinctCountInput: CouponHavingDistinctCountInput;
  CouponHavingInput: CouponHavingInput;
  CouponHavingMaxInput: CouponHavingMaxInput;
  CouponHavingMinInput: CouponHavingMinInput;
  CouponHavingStddevPopulationInput: CouponHavingStddevPopulationInput;
  CouponHavingStddevSampleInput: CouponHavingStddevSampleInput;
  CouponHavingSumInput: CouponHavingSumInput;
  CouponHavingVariancePopulationInput: CouponHavingVariancePopulationInput;
  CouponHavingVarianceSampleInput: CouponHavingVarianceSampleInput;
  CouponMaxAggregates: ResolverTypeWrapper<CouponMaxAggregates>;
  CouponMinAggregates: ResolverTypeWrapper<CouponMinAggregates>;
  CouponOrderBy: CouponOrderBy;
  CouponPlatform: ResolverTypeWrapper<CouponPlatform>;
  CouponRedemption: ResolverTypeWrapper<CouponRedemption>;
  CouponStddevPopulationAggregates: ResolverTypeWrapper<CouponStddevPopulationAggregates>;
  CouponStddevSampleAggregates: ResolverTypeWrapper<CouponStddevSampleAggregates>;
  CouponSumAggregates: ResolverTypeWrapper<CouponSumAggregates>;
  CouponToManyCouponUserFilter: CouponToManyCouponUserFilter;
  CouponToManyNmiSubscriptionFilter: CouponToManyNmiSubscriptionFilter;
  CouponToManyTraderPublicProfileFilter: CouponToManyTraderPublicProfileFilter;
  CouponToManyUserSubscriptionFilter: CouponToManyUserSubscriptionFilter;
  CouponUser: ResolverTypeWrapper<CouponUser>;
  CouponUserAggregates: ResolverTypeWrapper<CouponUserAggregates>;
  CouponUserAggregatesFilter: CouponUserAggregatesFilter;
  CouponUserAverageAggregateFilter: CouponUserAverageAggregateFilter;
  CouponUserAverageAggregates: ResolverTypeWrapper<CouponUserAverageAggregates>;
  CouponUserCondition: CouponUserCondition;
  CouponUserConnection: ResolverTypeWrapper<CouponUserConnection>;
  CouponUserDistinctCountAggregateFilter: CouponUserDistinctCountAggregateFilter;
  CouponUserDistinctCountAggregates: ResolverTypeWrapper<CouponUserDistinctCountAggregates>;
  CouponUserEdge: ResolverTypeWrapper<CouponUserEdge>;
  CouponUserFilter: CouponUserFilter;
  CouponUserGroupBy: CouponUserGroupBy;
  CouponUserHavingAverageInput: CouponUserHavingAverageInput;
  CouponUserHavingDistinctCountInput: CouponUserHavingDistinctCountInput;
  CouponUserHavingInput: CouponUserHavingInput;
  CouponUserHavingMaxInput: CouponUserHavingMaxInput;
  CouponUserHavingMinInput: CouponUserHavingMinInput;
  CouponUserHavingStddevPopulationInput: CouponUserHavingStddevPopulationInput;
  CouponUserHavingStddevSampleInput: CouponUserHavingStddevSampleInput;
  CouponUserHavingSumInput: CouponUserHavingSumInput;
  CouponUserHavingVariancePopulationInput: CouponUserHavingVariancePopulationInput;
  CouponUserHavingVarianceSampleInput: CouponUserHavingVarianceSampleInput;
  CouponUserMaxAggregateFilter: CouponUserMaxAggregateFilter;
  CouponUserMaxAggregates: ResolverTypeWrapper<CouponUserMaxAggregates>;
  CouponUserMinAggregateFilter: CouponUserMinAggregateFilter;
  CouponUserMinAggregates: ResolverTypeWrapper<CouponUserMinAggregates>;
  CouponUserOrderBy: CouponUserOrderBy;
  CouponUserStddevPopulationAggregateFilter: CouponUserStddevPopulationAggregateFilter;
  CouponUserStddevPopulationAggregates: ResolverTypeWrapper<CouponUserStddevPopulationAggregates>;
  CouponUserStddevSampleAggregateFilter: CouponUserStddevSampleAggregateFilter;
  CouponUserStddevSampleAggregates: ResolverTypeWrapper<CouponUserStddevSampleAggregates>;
  CouponUserSumAggregateFilter: CouponUserSumAggregateFilter;
  CouponUserSumAggregates: ResolverTypeWrapper<CouponUserSumAggregates>;
  CouponUserVariancePopulationAggregateFilter: CouponUserVariancePopulationAggregateFilter;
  CouponUserVariancePopulationAggregates: ResolverTypeWrapper<CouponUserVariancePopulationAggregates>;
  CouponUserVarianceSampleAggregateFilter: CouponUserVarianceSampleAggregateFilter;
  CouponUserVarianceSampleAggregates: ResolverTypeWrapper<CouponUserVarianceSampleAggregates>;
  CouponVariancePopulationAggregates: ResolverTypeWrapper<CouponVariancePopulationAggregates>;
  CouponVarianceSampleAggregates: ResolverTypeWrapper<CouponVarianceSampleAggregates>;
  CreateAccountCapitalEntryInput: CreateAccountCapitalEntryInput;
  CreateCaseBanInput: CreateCaseBanInput;
  CreateCaseInvestigationInput: CreateCaseInvestigationInput;
  CreateCaseTypeInput: CreateCaseTypeInput;
  CreateImpactGroupAssignmentInput: CreateImpactGroupAssignmentInput;
  CreateImpactGroupAssignmentPayload: ResolverTypeWrapper<Omit<CreateImpactGroupAssignmentPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateImpactGroupTemplateInput: CreateImpactGroupTemplateInput;
  CreateImpactGroupTemplatePayload: ResolverTypeWrapper<Omit<CreateImpactGroupTemplatePayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateKycPriorityLabelInput: CreateKycPriorityLabelInput;
  CreateKycPriorityLabelPayload: ResolverTypeWrapper<Omit<CreateKycPriorityLabelPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateKycPriorityReviewConfigInput: CreateKycPriorityReviewConfigInput;
  CreateKycPriorityReviewConfigPayload: ResolverTypeWrapper<CreateKycPriorityReviewConfigPayload>;
  CreateReasonCodeInput: CreateReasonCodeInput;
  CreateTraderRiskIndicatorInput: CreateTraderRiskIndicatorInput;
  CreateTraderRiskIndicatorPayload: ResolverTypeWrapper<Omit<CreateTraderRiskIndicatorPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateTradingProductFeeInput: CreateTradingProductFeeInput;
  CreateTradingProductFeePayload: ResolverTypeWrapper<Omit<CreateTradingProductFeePayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateUserAddressInput: CreateUserAddressInput;
  CreateUserAddressPayload: ResolverTypeWrapper<Omit<CreateUserAddressPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateUserTaxFormInput: CreateUserTaxFormInput;
  CreateUserTaxFormPayload: ResolverTypeWrapper<Omit<CreateUserTaxFormPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CreateXfaActivationCreditInput: CreateXfaActivationCreditInput;
  CreateXfaActivationCreditPayload: ResolverTypeWrapper<Omit<CreateXfaActivationCreditPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  CurrentAdminRole: ResolverTypeWrapper<CurrentAdminRole>;
  Cursor: ResolverTypeWrapper<Scalars['Cursor']['output']>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateFilter: DateFilter;
  Datetime: ResolverTypeWrapper<Scalars['Datetime']['output']>;
  DatetimeFilter: DatetimeFilter;
  DeleteImpactGroupAssignmentByIdInput: DeleteImpactGroupAssignmentByIdInput;
  DeleteImpactGroupAssignmentInput: DeleteImpactGroupAssignmentInput;
  DeleteImpactGroupAssignmentPayload: ResolverTypeWrapper<Omit<DeleteImpactGroupAssignmentPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  DeleteKycPriorityLabelByIdInput: DeleteKycPriorityLabelByIdInput;
  DeleteKycPriorityLabelInput: DeleteKycPriorityLabelInput;
  DeleteKycPriorityLabelPayload: ResolverTypeWrapper<Omit<DeleteKycPriorityLabelPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  DeleteUserAddressByIdInput: DeleteUserAddressByIdInput;
  DeleteUserAddressInput: DeleteUserAddressInput;
  DeleteUserAddressPayload: ResolverTypeWrapper<Omit<DeleteUserAddressPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  DeleteXfaActivationCreditByIdInput: DeleteXfaActivationCreditByIdInput;
  DeleteXfaActivationCreditInput: DeleteXfaActivationCreditInput;
  DeleteXfaActivationCreditPayload: ResolverTypeWrapper<Omit<DeleteXfaActivationCreditPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  DiscordLinkUrlPayload: ResolverTypeWrapper<DiscordLinkUrlPayload>;
  DllDailyMetrics: ResolverTypeWrapper<DllDailyMetrics>;
  DocuSignAuthResult: ResolverTypeWrapper<DocuSignAuthResult>;
  DocuSignEnvelopeStatusResult: ResolverTypeWrapper<DocuSignEnvelopeStatusResult>;
  Email: ResolverTypeWrapper<Email>;
  EmailAction: ResolverTypeWrapper<EmailAction>;
  EmailActionAggregates: ResolverTypeWrapper<EmailActionAggregates>;
  EmailActionAggregatesFilter: EmailActionAggregatesFilter;
  EmailActionAverageAggregateFilter: EmailActionAverageAggregateFilter;
  EmailActionAverageAggregates: ResolverTypeWrapper<EmailActionAverageAggregates>;
  EmailActionCondition: EmailActionCondition;
  EmailActionConnection: ResolverTypeWrapper<EmailActionConnection>;
  EmailActionDistinctCountAggregateFilter: EmailActionDistinctCountAggregateFilter;
  EmailActionDistinctCountAggregates: ResolverTypeWrapper<EmailActionDistinctCountAggregates>;
  EmailActionEdge: ResolverTypeWrapper<EmailActionEdge>;
  EmailActionFilter: EmailActionFilter;
  EmailActionGroupBy: EmailActionGroupBy;
  EmailActionHavingAverageInput: EmailActionHavingAverageInput;
  EmailActionHavingDistinctCountInput: EmailActionHavingDistinctCountInput;
  EmailActionHavingInput: EmailActionHavingInput;
  EmailActionHavingMaxInput: EmailActionHavingMaxInput;
  EmailActionHavingMinInput: EmailActionHavingMinInput;
  EmailActionHavingStddevPopulationInput: EmailActionHavingStddevPopulationInput;
  EmailActionHavingStddevSampleInput: EmailActionHavingStddevSampleInput;
  EmailActionHavingSumInput: EmailActionHavingSumInput;
  EmailActionHavingVariancePopulationInput: EmailActionHavingVariancePopulationInput;
  EmailActionHavingVarianceSampleInput: EmailActionHavingVarianceSampleInput;
  EmailActionMaxAggregateFilter: EmailActionMaxAggregateFilter;
  EmailActionMaxAggregates: ResolverTypeWrapper<EmailActionMaxAggregates>;
  EmailActionMinAggregateFilter: EmailActionMinAggregateFilter;
  EmailActionMinAggregates: ResolverTypeWrapper<EmailActionMinAggregates>;
  EmailActionOrderBy: EmailActionOrderBy;
  EmailActionStddevPopulationAggregateFilter: EmailActionStddevPopulationAggregateFilter;
  EmailActionStddevPopulationAggregates: ResolverTypeWrapper<EmailActionStddevPopulationAggregates>;
  EmailActionStddevSampleAggregateFilter: EmailActionStddevSampleAggregateFilter;
  EmailActionStddevSampleAggregates: ResolverTypeWrapper<EmailActionStddevSampleAggregates>;
  EmailActionSumAggregateFilter: EmailActionSumAggregateFilter;
  EmailActionSumAggregates: ResolverTypeWrapper<EmailActionSumAggregates>;
  EmailActionVariancePopulationAggregateFilter: EmailActionVariancePopulationAggregateFilter;
  EmailActionVariancePopulationAggregates: ResolverTypeWrapper<EmailActionVariancePopulationAggregates>;
  EmailActionVarianceSampleAggregateFilter: EmailActionVarianceSampleAggregateFilter;
  EmailActionVarianceSampleAggregates: ResolverTypeWrapper<EmailActionVarianceSampleAggregates>;
  EmailAggregates: ResolverTypeWrapper<EmailAggregates>;
  EmailAggregatesFilter: EmailAggregatesFilter;
  EmailAverageAggregateFilter: EmailAverageAggregateFilter;
  EmailAverageAggregates: ResolverTypeWrapper<EmailAverageAggregates>;
  EmailCondition: EmailCondition;
  EmailConnection: ResolverTypeWrapper<EmailConnection>;
  EmailDistinctCountAggregateFilter: EmailDistinctCountAggregateFilter;
  EmailDistinctCountAggregates: ResolverTypeWrapper<EmailDistinctCountAggregates>;
  EmailEdge: ResolverTypeWrapper<EmailEdge>;
  EmailFilter: EmailFilter;
  EmailGroupBy: EmailGroupBy;
  EmailHavingAverageInput: EmailHavingAverageInput;
  EmailHavingDistinctCountInput: EmailHavingDistinctCountInput;
  EmailHavingInput: EmailHavingInput;
  EmailHavingMaxInput: EmailHavingMaxInput;
  EmailHavingMinInput: EmailHavingMinInput;
  EmailHavingStddevPopulationInput: EmailHavingStddevPopulationInput;
  EmailHavingStddevSampleInput: EmailHavingStddevSampleInput;
  EmailHavingSumInput: EmailHavingSumInput;
  EmailHavingVariancePopulationInput: EmailHavingVariancePopulationInput;
  EmailHavingVarianceSampleInput: EmailHavingVarianceSampleInput;
  EmailMaxAggregateFilter: EmailMaxAggregateFilter;
  EmailMaxAggregates: ResolverTypeWrapper<EmailMaxAggregates>;
  EmailMinAggregateFilter: EmailMinAggregateFilter;
  EmailMinAggregates: ResolverTypeWrapper<EmailMinAggregates>;
  EmailOrderBy: EmailOrderBy;
  EmailStddevPopulationAggregateFilter: EmailStddevPopulationAggregateFilter;
  EmailStddevPopulationAggregates: ResolverTypeWrapper<EmailStddevPopulationAggregates>;
  EmailStddevSampleAggregateFilter: EmailStddevSampleAggregateFilter;
  EmailStddevSampleAggregates: ResolverTypeWrapper<EmailStddevSampleAggregates>;
  EmailSumAggregateFilter: EmailSumAggregateFilter;
  EmailSumAggregates: ResolverTypeWrapper<EmailSumAggregates>;
  EmailToManyEmailActionFilter: EmailToManyEmailActionFilter;
  EmailVariancePopulationAggregateFilter: EmailVariancePopulationAggregateFilter;
  EmailVariancePopulationAggregates: ResolverTypeWrapper<EmailVariancePopulationAggregates>;
  EmailVarianceSampleAggregateFilter: EmailVarianceSampleAggregateFilter;
  EmailVarianceSampleAggregates: ResolverTypeWrapper<EmailVarianceSampleAggregates>;
  EntityType: EntityType;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GetOrCreateUserTaxFormInput: GetOrCreateUserTaxFormInput;
  GetOrCreateUserTaxFormResult: ResolverTypeWrapper<GetOrCreateUserTaxFormResult>;
  Group: ResolverTypeWrapper<Group>;
  GroupAdmin: ResolverTypeWrapper<GroupAdmin>;
  GroupAdminAggregates: ResolverTypeWrapper<GroupAdminAggregates>;
  GroupAdminAggregatesFilter: GroupAdminAggregatesFilter;
  GroupAdminAverageAggregateFilter: GroupAdminAverageAggregateFilter;
  GroupAdminAverageAggregates: ResolverTypeWrapper<GroupAdminAverageAggregates>;
  GroupAdminCondition: GroupAdminCondition;
  GroupAdminConnection: ResolverTypeWrapper<GroupAdminConnection>;
  GroupAdminDistinctCountAggregateFilter: GroupAdminDistinctCountAggregateFilter;
  GroupAdminDistinctCountAggregates: ResolverTypeWrapper<GroupAdminDistinctCountAggregates>;
  GroupAdminEdge: ResolverTypeWrapper<GroupAdminEdge>;
  GroupAdminFilter: GroupAdminFilter;
  GroupAdminGroupBy: GroupAdminGroupBy;
  GroupAdminHavingAverageInput: GroupAdminHavingAverageInput;
  GroupAdminHavingDistinctCountInput: GroupAdminHavingDistinctCountInput;
  GroupAdminHavingInput: GroupAdminHavingInput;
  GroupAdminHavingMaxInput: GroupAdminHavingMaxInput;
  GroupAdminHavingMinInput: GroupAdminHavingMinInput;
  GroupAdminHavingStddevPopulationInput: GroupAdminHavingStddevPopulationInput;
  GroupAdminHavingStddevSampleInput: GroupAdminHavingStddevSampleInput;
  GroupAdminHavingSumInput: GroupAdminHavingSumInput;
  GroupAdminHavingVariancePopulationInput: GroupAdminHavingVariancePopulationInput;
  GroupAdminHavingVarianceSampleInput: GroupAdminHavingVarianceSampleInput;
  GroupAdminMaxAggregateFilter: GroupAdminMaxAggregateFilter;
  GroupAdminMaxAggregates: ResolverTypeWrapper<GroupAdminMaxAggregates>;
  GroupAdminMinAggregateFilter: GroupAdminMinAggregateFilter;
  GroupAdminMinAggregates: ResolverTypeWrapper<GroupAdminMinAggregates>;
  GroupAdminOrderBy: GroupAdminOrderBy;
  GroupAdminStddevPopulationAggregateFilter: GroupAdminStddevPopulationAggregateFilter;
  GroupAdminStddevPopulationAggregates: ResolverTypeWrapper<GroupAdminStddevPopulationAggregates>;
  GroupAdminStddevSampleAggregateFilter: GroupAdminStddevSampleAggregateFilter;
  GroupAdminStddevSampleAggregates: ResolverTypeWrapper<GroupAdminStddevSampleAggregates>;
  GroupAdminSumAggregateFilter: GroupAdminSumAggregateFilter;
  GroupAdminSumAggregates: ResolverTypeWrapper<GroupAdminSumAggregates>;
  GroupAdminVariancePopulationAggregateFilter: GroupAdminVariancePopulationAggregateFilter;
  GroupAdminVariancePopulationAggregates: ResolverTypeWrapper<GroupAdminVariancePopulationAggregates>;
  GroupAdminVarianceSampleAggregateFilter: GroupAdminVarianceSampleAggregateFilter;
  GroupAdminVarianceSampleAggregates: ResolverTypeWrapper<GroupAdminVarianceSampleAggregates>;
  GroupAggregates: ResolverTypeWrapper<GroupAggregates>;
  GroupAverageAggregates: ResolverTypeWrapper<GroupAverageAggregates>;
  GroupCondition: GroupCondition;
  GroupConnection: ResolverTypeWrapper<GroupConnection>;
  GroupDistinctCountAggregates: ResolverTypeWrapper<GroupDistinctCountAggregates>;
  GroupEdge: ResolverTypeWrapper<GroupEdge>;
  GroupFilter: GroupFilter;
  GroupMaxAggregates: ResolverTypeWrapper<GroupMaxAggregates>;
  GroupMinAggregates: ResolverTypeWrapper<GroupMinAggregates>;
  GroupOrderBy: GroupOrderBy;
  GroupStddevPopulationAggregates: ResolverTypeWrapper<GroupStddevPopulationAggregates>;
  GroupStddevSampleAggregates: ResolverTypeWrapper<GroupStddevSampleAggregates>;
  GroupSumAggregates: ResolverTypeWrapper<GroupSumAggregates>;
  GroupToManyGroupAdminFilter: GroupToManyGroupAdminFilter;
  GroupVariancePopulationAggregates: ResolverTypeWrapper<GroupVariancePopulationAggregates>;
  GroupVarianceSampleAggregates: ResolverTypeWrapper<GroupVarianceSampleAggregates>;
  HavingBigfloatFilter: HavingBigfloatFilter;
  HavingBigintFilter: HavingBigintFilter;
  HavingDatetimeFilter: HavingDatetimeFilter;
  HavingFloatFilter: HavingFloatFilter;
  HavingIntFilter: HavingIntFilter;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ImpactGroupAssignment: ResolverTypeWrapper<ImpactGroupAssignment>;
  ImpactGroupAssignmentAggregates: ResolverTypeWrapper<ImpactGroupAssignmentAggregates>;
  ImpactGroupAssignmentAggregatesFilter: ImpactGroupAssignmentAggregatesFilter;
  ImpactGroupAssignmentAverageAggregateFilter: ImpactGroupAssignmentAverageAggregateFilter;
  ImpactGroupAssignmentAverageAggregates: ResolverTypeWrapper<ImpactGroupAssignmentAverageAggregates>;
  ImpactGroupAssignmentCondition: ImpactGroupAssignmentCondition;
  ImpactGroupAssignmentConnection: ResolverTypeWrapper<ImpactGroupAssignmentConnection>;
  ImpactGroupAssignmentDistinctCountAggregateFilter: ImpactGroupAssignmentDistinctCountAggregateFilter;
  ImpactGroupAssignmentDistinctCountAggregates: ResolverTypeWrapper<ImpactGroupAssignmentDistinctCountAggregates>;
  ImpactGroupAssignmentEdge: ResolverTypeWrapper<ImpactGroupAssignmentEdge>;
  ImpactGroupAssignmentFilter: ImpactGroupAssignmentFilter;
  ImpactGroupAssignmentGroupBy: ImpactGroupAssignmentGroupBy;
  ImpactGroupAssignmentHavingAverageInput: ImpactGroupAssignmentHavingAverageInput;
  ImpactGroupAssignmentHavingDistinctCountInput: ImpactGroupAssignmentHavingDistinctCountInput;
  ImpactGroupAssignmentHavingInput: ImpactGroupAssignmentHavingInput;
  ImpactGroupAssignmentHavingMaxInput: ImpactGroupAssignmentHavingMaxInput;
  ImpactGroupAssignmentHavingMinInput: ImpactGroupAssignmentHavingMinInput;
  ImpactGroupAssignmentHavingStddevPopulationInput: ImpactGroupAssignmentHavingStddevPopulationInput;
  ImpactGroupAssignmentHavingStddevSampleInput: ImpactGroupAssignmentHavingStddevSampleInput;
  ImpactGroupAssignmentHavingSumInput: ImpactGroupAssignmentHavingSumInput;
  ImpactGroupAssignmentHavingVariancePopulationInput: ImpactGroupAssignmentHavingVariancePopulationInput;
  ImpactGroupAssignmentHavingVarianceSampleInput: ImpactGroupAssignmentHavingVarianceSampleInput;
  ImpactGroupAssignmentInput: ImpactGroupAssignmentInput;
  ImpactGroupAssignmentMaxAggregateFilter: ImpactGroupAssignmentMaxAggregateFilter;
  ImpactGroupAssignmentMaxAggregates: ResolverTypeWrapper<ImpactGroupAssignmentMaxAggregates>;
  ImpactGroupAssignmentMinAggregateFilter: ImpactGroupAssignmentMinAggregateFilter;
  ImpactGroupAssignmentMinAggregates: ResolverTypeWrapper<ImpactGroupAssignmentMinAggregates>;
  ImpactGroupAssignmentOrderBy: ImpactGroupAssignmentOrderBy;
  ImpactGroupAssignmentPatch: ImpactGroupAssignmentPatch;
  ImpactGroupAssignmentStddevPopulationAggregateFilter: ImpactGroupAssignmentStddevPopulationAggregateFilter;
  ImpactGroupAssignmentStddevPopulationAggregates: ResolverTypeWrapper<ImpactGroupAssignmentStddevPopulationAggregates>;
  ImpactGroupAssignmentStddevSampleAggregateFilter: ImpactGroupAssignmentStddevSampleAggregateFilter;
  ImpactGroupAssignmentStddevSampleAggregates: ResolverTypeWrapper<ImpactGroupAssignmentStddevSampleAggregates>;
  ImpactGroupAssignmentSumAggregateFilter: ImpactGroupAssignmentSumAggregateFilter;
  ImpactGroupAssignmentSumAggregates: ResolverTypeWrapper<ImpactGroupAssignmentSumAggregates>;
  ImpactGroupAssignmentVariancePopulationAggregateFilter: ImpactGroupAssignmentVariancePopulationAggregateFilter;
  ImpactGroupAssignmentVariancePopulationAggregates: ResolverTypeWrapper<ImpactGroupAssignmentVariancePopulationAggregates>;
  ImpactGroupAssignmentVarianceSampleAggregateFilter: ImpactGroupAssignmentVarianceSampleAggregateFilter;
  ImpactGroupAssignmentVarianceSampleAggregates: ResolverTypeWrapper<ImpactGroupAssignmentVarianceSampleAggregates>;
  ImpactGroupTemplate: ResolverTypeWrapper<ImpactGroupTemplate>;
  ImpactGroupTemplateAggregates: ResolverTypeWrapper<ImpactGroupTemplateAggregates>;
  ImpactGroupTemplateAverageAggregates: ResolverTypeWrapper<ImpactGroupTemplateAverageAggregates>;
  ImpactGroupTemplateCondition: ImpactGroupTemplateCondition;
  ImpactGroupTemplateConnection: ResolverTypeWrapper<ImpactGroupTemplateConnection>;
  ImpactGroupTemplateDistinctCountAggregates: ResolverTypeWrapper<ImpactGroupTemplateDistinctCountAggregates>;
  ImpactGroupTemplateEdge: ResolverTypeWrapper<ImpactGroupTemplateEdge>;
  ImpactGroupTemplateFilter: ImpactGroupTemplateFilter;
  ImpactGroupTemplateGroupBy: ImpactGroupTemplateGroupBy;
  ImpactGroupTemplateHavingAverageInput: ImpactGroupTemplateHavingAverageInput;
  ImpactGroupTemplateHavingDistinctCountInput: ImpactGroupTemplateHavingDistinctCountInput;
  ImpactGroupTemplateHavingInput: ImpactGroupTemplateHavingInput;
  ImpactGroupTemplateHavingMaxInput: ImpactGroupTemplateHavingMaxInput;
  ImpactGroupTemplateHavingMinInput: ImpactGroupTemplateHavingMinInput;
  ImpactGroupTemplateHavingStddevPopulationInput: ImpactGroupTemplateHavingStddevPopulationInput;
  ImpactGroupTemplateHavingStddevSampleInput: ImpactGroupTemplateHavingStddevSampleInput;
  ImpactGroupTemplateHavingSumInput: ImpactGroupTemplateHavingSumInput;
  ImpactGroupTemplateHavingVariancePopulationInput: ImpactGroupTemplateHavingVariancePopulationInput;
  ImpactGroupTemplateHavingVarianceSampleInput: ImpactGroupTemplateHavingVarianceSampleInput;
  ImpactGroupTemplateInput: ImpactGroupTemplateInput;
  ImpactGroupTemplateMaxAggregates: ResolverTypeWrapper<ImpactGroupTemplateMaxAggregates>;
  ImpactGroupTemplateMinAggregates: ResolverTypeWrapper<ImpactGroupTemplateMinAggregates>;
  ImpactGroupTemplateOrderBy: ImpactGroupTemplateOrderBy;
  ImpactGroupTemplatePatch: ImpactGroupTemplatePatch;
  ImpactGroupTemplateStddevPopulationAggregates: ResolverTypeWrapper<ImpactGroupTemplateStddevPopulationAggregates>;
  ImpactGroupTemplateStddevSampleAggregates: ResolverTypeWrapper<ImpactGroupTemplateStddevSampleAggregates>;
  ImpactGroupTemplateSumAggregates: ResolverTypeWrapper<ImpactGroupTemplateSumAggregates>;
  ImpactGroupTemplateToManyImpactGroupAssignmentFilter: ImpactGroupTemplateToManyImpactGroupAssignmentFilter;
  ImpactGroupTemplateVariancePopulationAggregates: ResolverTypeWrapper<ImpactGroupTemplateVariancePopulationAggregates>;
  ImpactGroupTemplateVarianceSampleAggregates: ResolverTypeWrapper<ImpactGroupTemplateVarianceSampleAggregates>;
  InitiateAdminPayoutRequestInput: InitiateAdminPayoutRequestInput;
  InitiateAdminPayoutRequestPayload: ResolverTypeWrapper<InitiateAdminPayoutRequestPayload>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntFilter: IntFilter;
  Interval: ResolverTypeWrapper<Interval>;
  IntervalFilter: IntervalFilter;
  IntervalInput: IntervalInput;
  InvalidateUserTaxFormEventLogInput: InvalidateUserTaxFormEventLogInput;
  InvalidateUserTaxFormEventLogResult: ResolverTypeWrapper<InvalidateUserTaxFormEventLogResult>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONFilter: JsonFilter;
  KycPriorityLabel: ResolverTypeWrapper<KycPriorityLabel>;
  KycPriorityLabelAggregates: ResolverTypeWrapper<KycPriorityLabelAggregates>;
  KycPriorityLabelAverageAggregates: ResolverTypeWrapper<KycPriorityLabelAverageAggregates>;
  KycPriorityLabelCondition: KycPriorityLabelCondition;
  KycPriorityLabelConnection: ResolverTypeWrapper<KycPriorityLabelConnection>;
  KycPriorityLabelDistinctCountAggregates: ResolverTypeWrapper<KycPriorityLabelDistinctCountAggregates>;
  KycPriorityLabelEdge: ResolverTypeWrapper<KycPriorityLabelEdge>;
  KycPriorityLabelFilter: KycPriorityLabelFilter;
  KycPriorityLabelGroupBy: KycPriorityLabelGroupBy;
  KycPriorityLabelHavingAverageInput: KycPriorityLabelHavingAverageInput;
  KycPriorityLabelHavingDistinctCountInput: KycPriorityLabelHavingDistinctCountInput;
  KycPriorityLabelHavingInput: KycPriorityLabelHavingInput;
  KycPriorityLabelHavingMaxInput: KycPriorityLabelHavingMaxInput;
  KycPriorityLabelHavingMinInput: KycPriorityLabelHavingMinInput;
  KycPriorityLabelHavingStddevPopulationInput: KycPriorityLabelHavingStddevPopulationInput;
  KycPriorityLabelHavingStddevSampleInput: KycPriorityLabelHavingStddevSampleInput;
  KycPriorityLabelHavingSumInput: KycPriorityLabelHavingSumInput;
  KycPriorityLabelHavingVariancePopulationInput: KycPriorityLabelHavingVariancePopulationInput;
  KycPriorityLabelHavingVarianceSampleInput: KycPriorityLabelHavingVarianceSampleInput;
  KycPriorityLabelInput: KycPriorityLabelInput;
  KycPriorityLabelMaxAggregates: ResolverTypeWrapper<KycPriorityLabelMaxAggregates>;
  KycPriorityLabelMinAggregates: ResolverTypeWrapper<KycPriorityLabelMinAggregates>;
  KycPriorityLabelOrderBy: KycPriorityLabelOrderBy;
  KycPriorityLabelPatch: KycPriorityLabelPatch;
  KycPriorityLabelStddevPopulationAggregates: ResolverTypeWrapper<KycPriorityLabelStddevPopulationAggregates>;
  KycPriorityLabelStddevSampleAggregates: ResolverTypeWrapper<KycPriorityLabelStddevSampleAggregates>;
  KycPriorityLabelSumAggregates: ResolverTypeWrapper<KycPriorityLabelSumAggregates>;
  KycPriorityLabelToManyKycPriorityReviewConfigLabelFilter: KycPriorityLabelToManyKycPriorityReviewConfigLabelFilter;
  KycPriorityLabelVariancePopulationAggregates: ResolverTypeWrapper<KycPriorityLabelVariancePopulationAggregates>;
  KycPriorityLabelVarianceSampleAggregates: ResolverTypeWrapper<KycPriorityLabelVarianceSampleAggregates>;
  KycPriorityReviewConfig: ResolverTypeWrapper<KycPriorityReviewConfig>;
  KycPriorityReviewConfigAggregates: ResolverTypeWrapper<KycPriorityReviewConfigAggregates>;
  KycPriorityReviewConfigAverageAggregates: ResolverTypeWrapper<KycPriorityReviewConfigAverageAggregates>;
  KycPriorityReviewConfigCondition: KycPriorityReviewConfigCondition;
  KycPriorityReviewConfigConnection: ResolverTypeWrapper<KycPriorityReviewConfigConnection>;
  KycPriorityReviewConfigDistinctCountAggregates: ResolverTypeWrapper<KycPriorityReviewConfigDistinctCountAggregates>;
  KycPriorityReviewConfigEdge: ResolverTypeWrapper<KycPriorityReviewConfigEdge>;
  KycPriorityReviewConfigFilter: KycPriorityReviewConfigFilter;
  KycPriorityReviewConfigGroupBy: KycPriorityReviewConfigGroupBy;
  KycPriorityReviewConfigHavingAverageInput: KycPriorityReviewConfigHavingAverageInput;
  KycPriorityReviewConfigHavingDistinctCountInput: KycPriorityReviewConfigHavingDistinctCountInput;
  KycPriorityReviewConfigHavingInput: KycPriorityReviewConfigHavingInput;
  KycPriorityReviewConfigHavingMaxInput: KycPriorityReviewConfigHavingMaxInput;
  KycPriorityReviewConfigHavingMinInput: KycPriorityReviewConfigHavingMinInput;
  KycPriorityReviewConfigHavingStddevPopulationInput: KycPriorityReviewConfigHavingStddevPopulationInput;
  KycPriorityReviewConfigHavingStddevSampleInput: KycPriorityReviewConfigHavingStddevSampleInput;
  KycPriorityReviewConfigHavingSumInput: KycPriorityReviewConfigHavingSumInput;
  KycPriorityReviewConfigHavingVariancePopulationInput: KycPriorityReviewConfigHavingVariancePopulationInput;
  KycPriorityReviewConfigHavingVarianceSampleInput: KycPriorityReviewConfigHavingVarianceSampleInput;
  KycPriorityReviewConfigLabel: ResolverTypeWrapper<KycPriorityReviewConfigLabel>;
  KycPriorityReviewConfigLabelAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelAggregates>;
  KycPriorityReviewConfigLabelAggregatesFilter: KycPriorityReviewConfigLabelAggregatesFilter;
  KycPriorityReviewConfigLabelAverageAggregateFilter: KycPriorityReviewConfigLabelAverageAggregateFilter;
  KycPriorityReviewConfigLabelAverageAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelAverageAggregates>;
  KycPriorityReviewConfigLabelCondition: KycPriorityReviewConfigLabelCondition;
  KycPriorityReviewConfigLabelConnection: ResolverTypeWrapper<KycPriorityReviewConfigLabelConnection>;
  KycPriorityReviewConfigLabelDistinctCountAggregateFilter: KycPriorityReviewConfigLabelDistinctCountAggregateFilter;
  KycPriorityReviewConfigLabelDistinctCountAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelDistinctCountAggregates>;
  KycPriorityReviewConfigLabelEdge: ResolverTypeWrapper<KycPriorityReviewConfigLabelEdge>;
  KycPriorityReviewConfigLabelFilter: KycPriorityReviewConfigLabelFilter;
  KycPriorityReviewConfigLabelGroupBy: KycPriorityReviewConfigLabelGroupBy;
  KycPriorityReviewConfigLabelHavingAverageInput: KycPriorityReviewConfigLabelHavingAverageInput;
  KycPriorityReviewConfigLabelHavingDistinctCountInput: KycPriorityReviewConfigLabelHavingDistinctCountInput;
  KycPriorityReviewConfigLabelHavingInput: KycPriorityReviewConfigLabelHavingInput;
  KycPriorityReviewConfigLabelHavingMaxInput: KycPriorityReviewConfigLabelHavingMaxInput;
  KycPriorityReviewConfigLabelHavingMinInput: KycPriorityReviewConfigLabelHavingMinInput;
  KycPriorityReviewConfigLabelHavingStddevPopulationInput: KycPriorityReviewConfigLabelHavingStddevPopulationInput;
  KycPriorityReviewConfigLabelHavingStddevSampleInput: KycPriorityReviewConfigLabelHavingStddevSampleInput;
  KycPriorityReviewConfigLabelHavingSumInput: KycPriorityReviewConfigLabelHavingSumInput;
  KycPriorityReviewConfigLabelHavingVariancePopulationInput: KycPriorityReviewConfigLabelHavingVariancePopulationInput;
  KycPriorityReviewConfigLabelHavingVarianceSampleInput: KycPriorityReviewConfigLabelHavingVarianceSampleInput;
  KycPriorityReviewConfigLabelMaxAggregateFilter: KycPriorityReviewConfigLabelMaxAggregateFilter;
  KycPriorityReviewConfigLabelMaxAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelMaxAggregates>;
  KycPriorityReviewConfigLabelMinAggregateFilter: KycPriorityReviewConfigLabelMinAggregateFilter;
  KycPriorityReviewConfigLabelMinAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelMinAggregates>;
  KycPriorityReviewConfigLabelOrderBy: KycPriorityReviewConfigLabelOrderBy;
  KycPriorityReviewConfigLabelStddevPopulationAggregateFilter: KycPriorityReviewConfigLabelStddevPopulationAggregateFilter;
  KycPriorityReviewConfigLabelStddevPopulationAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelStddevPopulationAggregates>;
  KycPriorityReviewConfigLabelStddevSampleAggregateFilter: KycPriorityReviewConfigLabelStddevSampleAggregateFilter;
  KycPriorityReviewConfigLabelStddevSampleAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelStddevSampleAggregates>;
  KycPriorityReviewConfigLabelSumAggregateFilter: KycPriorityReviewConfigLabelSumAggregateFilter;
  KycPriorityReviewConfigLabelSumAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelSumAggregates>;
  KycPriorityReviewConfigLabelVariancePopulationAggregateFilter: KycPriorityReviewConfigLabelVariancePopulationAggregateFilter;
  KycPriorityReviewConfigLabelVariancePopulationAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelVariancePopulationAggregates>;
  KycPriorityReviewConfigLabelVarianceSampleAggregateFilter: KycPriorityReviewConfigLabelVarianceSampleAggregateFilter;
  KycPriorityReviewConfigLabelVarianceSampleAggregates: ResolverTypeWrapper<KycPriorityReviewConfigLabelVarianceSampleAggregates>;
  KycPriorityReviewConfigMaxAggregates: ResolverTypeWrapper<KycPriorityReviewConfigMaxAggregates>;
  KycPriorityReviewConfigMinAggregates: ResolverTypeWrapper<KycPriorityReviewConfigMinAggregates>;
  KycPriorityReviewConfigOrderBy: KycPriorityReviewConfigOrderBy;
  KycPriorityReviewConfigStddevPopulationAggregates: ResolverTypeWrapper<KycPriorityReviewConfigStddevPopulationAggregates>;
  KycPriorityReviewConfigStddevSampleAggregates: ResolverTypeWrapper<KycPriorityReviewConfigStddevSampleAggregates>;
  KycPriorityReviewConfigSumAggregates: ResolverTypeWrapper<KycPriorityReviewConfigSumAggregates>;
  KycPriorityReviewConfigToManyKycPriorityReviewConfigLabelFilter: KycPriorityReviewConfigToManyKycPriorityReviewConfigLabelFilter;
  KycPriorityReviewConfigVariancePopulationAggregates: ResolverTypeWrapper<KycPriorityReviewConfigVariancePopulationAggregates>;
  KycPriorityReviewConfigVarianceSampleAggregates: ResolverTypeWrapper<KycPriorityReviewConfigVarianceSampleAggregates>;
  KycPriorityTypeEnum: KycPriorityTypeEnum;
  KycPriorityTypeEnumFilter: KycPriorityTypeEnumFilter;
  LfaSplashStatus: ResolverTypeWrapper<LfaSplashStatus>;
  LiteLlmBlockedTermCandidate: ResolverTypeWrapper<LiteLlmBlockedTermCandidate>;
  LitellmBlockedTermCandidateStatus: LitellmBlockedTermCandidateStatus;
  LiveStreamStatus: ResolverTypeWrapper<LiveStreamStatus>;
  LiveTradePairing: ResolverTypeWrapper<LiveTradePairing>;
  MarkAsChargebackInput: MarkAsChargebackInput;
  Migration: ResolverTypeWrapper<Migration>;
  Mutation: ResolverTypeWrapper<{}>;
  MyMissingPopcards: ResolverTypeWrapper<MyMissingPopcards>;
  MyPopcardCandidates: ResolverTypeWrapper<MyPopcardCandidates>;
  MyTraderProfileAsset: ResolverTypeWrapper<MyTraderProfileAsset>;
  MyTraderPublicProfile: ResolverTypeWrapper<MyTraderPublicProfile>;
  MyTraderPublicProfileAllTimePayouts: ResolverTypeWrapper<MyTraderPublicProfileAllTimePayouts>;
  MyTraderPublicProfileContent: ResolverTypeWrapper<MyTraderPublicProfileContent>;
  MyTraderPublicProfileHeader: ResolverTypeWrapper<MyTraderPublicProfileHeader>;
  MyTraderPublicProfileNowTrading: ResolverTypeWrapper<MyTraderPublicProfileNowTrading>;
  MyTraderPublicProfileNowTradingAccount: ResolverTypeWrapper<MyTraderPublicProfileNowTradingAccount>;
  MyTraderPublicProfileNowTradingCalendarDay: ResolverTypeWrapper<MyTraderPublicProfileNowTradingCalendarDay>;
  MyTraderPublicProfileNowTradingCalendarWeek: ResolverTypeWrapper<MyTraderPublicProfileNowTradingCalendarWeek>;
  MyTraderPublicProfileNowTradingProfitCalendar: ResolverTypeWrapper<MyTraderPublicProfileNowTradingProfitCalendar>;
  MyTraderPublicProfileNowTradingSparklineDay: ResolverTypeWrapper<MyTraderPublicProfileNowTradingSparklineDay>;
  MyTraderPublicProfileNowTradingStats: ResolverTypeWrapper<MyTraderPublicProfileNowTradingStats>;
  MyTraderPublicProfileProofOfPayoutCard: ResolverTypeWrapper<MyTraderPublicProfileProofOfPayoutCard>;
  MyTraderPublicProfileSocialConnections: ResolverTypeWrapper<MyTraderPublicProfileSocialConnections>;
  MyTraderPublicProfileTradingJourney: ResolverTypeWrapper<MyTraderPublicProfileTradingJourney>;
  MyTraderPublicProfileTradingStyle: ResolverTypeWrapper<MyTraderPublicProfileTradingStyle>;
  NmiSubscription: ResolverTypeWrapper<NmiSubscription>;
  NmiSubscriptionAggregates: ResolverTypeWrapper<NmiSubscriptionAggregates>;
  NmiSubscriptionAggregatesFilter: NmiSubscriptionAggregatesFilter;
  NmiSubscriptionAverageAggregateFilter: NmiSubscriptionAverageAggregateFilter;
  NmiSubscriptionAverageAggregates: ResolverTypeWrapper<NmiSubscriptionAverageAggregates>;
  NmiSubscriptionCondition: NmiSubscriptionCondition;
  NmiSubscriptionConnection: ResolverTypeWrapper<NmiSubscriptionConnection>;
  NmiSubscriptionDistinctCountAggregateFilter: NmiSubscriptionDistinctCountAggregateFilter;
  NmiSubscriptionDistinctCountAggregates: ResolverTypeWrapper<NmiSubscriptionDistinctCountAggregates>;
  NmiSubscriptionEdge: ResolverTypeWrapper<NmiSubscriptionEdge>;
  NmiSubscriptionFilter: NmiSubscriptionFilter;
  NmiSubscriptionGroupBy: NmiSubscriptionGroupBy;
  NmiSubscriptionHavingAverageInput: NmiSubscriptionHavingAverageInput;
  NmiSubscriptionHavingDistinctCountInput: NmiSubscriptionHavingDistinctCountInput;
  NmiSubscriptionHavingInput: NmiSubscriptionHavingInput;
  NmiSubscriptionHavingMaxInput: NmiSubscriptionHavingMaxInput;
  NmiSubscriptionHavingMinInput: NmiSubscriptionHavingMinInput;
  NmiSubscriptionHavingStddevPopulationInput: NmiSubscriptionHavingStddevPopulationInput;
  NmiSubscriptionHavingStddevSampleInput: NmiSubscriptionHavingStddevSampleInput;
  NmiSubscriptionHavingSumInput: NmiSubscriptionHavingSumInput;
  NmiSubscriptionHavingVariancePopulationInput: NmiSubscriptionHavingVariancePopulationInput;
  NmiSubscriptionHavingVarianceSampleInput: NmiSubscriptionHavingVarianceSampleInput;
  NmiSubscriptionMaxAggregateFilter: NmiSubscriptionMaxAggregateFilter;
  NmiSubscriptionMaxAggregates: ResolverTypeWrapper<NmiSubscriptionMaxAggregates>;
  NmiSubscriptionMinAggregateFilter: NmiSubscriptionMinAggregateFilter;
  NmiSubscriptionMinAggregates: ResolverTypeWrapper<NmiSubscriptionMinAggregates>;
  NmiSubscriptionOrderBy: NmiSubscriptionOrderBy;
  NmiSubscriptionRebillManagerEnum: NmiSubscriptionRebillManagerEnum;
  NmiSubscriptionRebillManagerEnumFilter: NmiSubscriptionRebillManagerEnumFilter;
  NmiSubscriptionStddevPopulationAggregateFilter: NmiSubscriptionStddevPopulationAggregateFilter;
  NmiSubscriptionStddevPopulationAggregates: ResolverTypeWrapper<NmiSubscriptionStddevPopulationAggregates>;
  NmiSubscriptionStddevSampleAggregateFilter: NmiSubscriptionStddevSampleAggregateFilter;
  NmiSubscriptionStddevSampleAggregates: ResolverTypeWrapper<NmiSubscriptionStddevSampleAggregates>;
  NmiSubscriptionSumAggregateFilter: NmiSubscriptionSumAggregateFilter;
  NmiSubscriptionSumAggregates: ResolverTypeWrapper<NmiSubscriptionSumAggregates>;
  NmiSubscriptionToManyAccountFilter: NmiSubscriptionToManyAccountFilter;
  NmiSubscriptionToManyAccountResetTrackingFilter: NmiSubscriptionToManyAccountResetTrackingFilter;
  NmiSubscriptionToManyOrderFulfillmentFilter: NmiSubscriptionToManyOrderFulfillmentFilter;
  NmiSubscriptionToManyRebillSessionFilter: NmiSubscriptionToManyRebillSessionFilter;
  NmiSubscriptionTypeEnum: NmiSubscriptionTypeEnum;
  NmiSubscriptionTypeEnumFilter: NmiSubscriptionTypeEnumFilter;
  NmiSubscriptionVariancePopulationAggregateFilter: NmiSubscriptionVariancePopulationAggregateFilter;
  NmiSubscriptionVariancePopulationAggregates: ResolverTypeWrapper<NmiSubscriptionVariancePopulationAggregates>;
  NmiSubscriptionVarianceSampleAggregateFilter: NmiSubscriptionVarianceSampleAggregateFilter;
  NmiSubscriptionVarianceSampleAggregates: ResolverTypeWrapper<NmiSubscriptionVarianceSampleAggregates>;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  NormalizedPurchasesByUserConnection: ResolverTypeWrapper<NormalizedPurchasesByUserConnection>;
  NormalizedPurchasesByUserEdge: ResolverTypeWrapper<NormalizedPurchasesByUserEdge>;
  NormalizedPurchasesByUserRecord: ResolverTypeWrapper<NormalizedPurchasesByUserRecord>;
  NormalizedPurchasesByUserRecordFilter: NormalizedPurchasesByUserRecordFilter;
  NormalizedSavedCardsByUserConnection: ResolverTypeWrapper<NormalizedSavedCardsByUserConnection>;
  NormalizedSavedCardsByUserEdge: ResolverTypeWrapper<NormalizedSavedCardsByUserEdge>;
  NormalizedSavedCardsByUserRecord: ResolverTypeWrapper<NormalizedSavedCardsByUserRecord>;
  NormalizedSavedCardsByUserRecordFilter: NormalizedSavedCardsByUserRecordFilter;
  NormalizedSubsByUserConnection: ResolverTypeWrapper<NormalizedSubsByUserConnection>;
  NormalizedSubsByUserEdge: ResolverTypeWrapper<NormalizedSubsByUserEdge>;
  NormalizedSubsByUserRecord: ResolverTypeWrapper<NormalizedSubsByUserRecord>;
  NormalizedSubsByUserRecordFilter: NormalizedSubsByUserRecordFilter;
  NormalizedSubsDetailedByUserConnection: ResolverTypeWrapper<NormalizedSubsDetailedByUserConnection>;
  NormalizedSubsDetailedByUserEdge: ResolverTypeWrapper<NormalizedSubsDetailedByUserEdge>;
  NormalizedSubsDetailedByUserRecord: ResolverTypeWrapper<NormalizedSubsDetailedByUserRecord>;
  NormalizedSubsDetailedByUserRecordFilter: NormalizedSubsDetailedByUserRecordFilter;
  NuveiSavedCard: ResolverTypeWrapper<NuveiSavedCard>;
  NuveiSavedCardAggregates: ResolverTypeWrapper<NuveiSavedCardAggregates>;
  NuveiSavedCardAggregatesFilter: NuveiSavedCardAggregatesFilter;
  NuveiSavedCardAverageAggregateFilter: NuveiSavedCardAverageAggregateFilter;
  NuveiSavedCardAverageAggregates: ResolverTypeWrapper<NuveiSavedCardAverageAggregates>;
  NuveiSavedCardCondition: NuveiSavedCardCondition;
  NuveiSavedCardConnection: ResolverTypeWrapper<NuveiSavedCardConnection>;
  NuveiSavedCardDistinctCountAggregateFilter: NuveiSavedCardDistinctCountAggregateFilter;
  NuveiSavedCardDistinctCountAggregates: ResolverTypeWrapper<NuveiSavedCardDistinctCountAggregates>;
  NuveiSavedCardEdge: ResolverTypeWrapper<NuveiSavedCardEdge>;
  NuveiSavedCardFilter: NuveiSavedCardFilter;
  NuveiSavedCardGroupBy: NuveiSavedCardGroupBy;
  NuveiSavedCardHavingAverageInput: NuveiSavedCardHavingAverageInput;
  NuveiSavedCardHavingDistinctCountInput: NuveiSavedCardHavingDistinctCountInput;
  NuveiSavedCardHavingInput: NuveiSavedCardHavingInput;
  NuveiSavedCardHavingMaxInput: NuveiSavedCardHavingMaxInput;
  NuveiSavedCardHavingMinInput: NuveiSavedCardHavingMinInput;
  NuveiSavedCardHavingStddevPopulationInput: NuveiSavedCardHavingStddevPopulationInput;
  NuveiSavedCardHavingStddevSampleInput: NuveiSavedCardHavingStddevSampleInput;
  NuveiSavedCardHavingSumInput: NuveiSavedCardHavingSumInput;
  NuveiSavedCardHavingVariancePopulationInput: NuveiSavedCardHavingVariancePopulationInput;
  NuveiSavedCardHavingVarianceSampleInput: NuveiSavedCardHavingVarianceSampleInput;
  NuveiSavedCardMaxAggregateFilter: NuveiSavedCardMaxAggregateFilter;
  NuveiSavedCardMaxAggregates: ResolverTypeWrapper<NuveiSavedCardMaxAggregates>;
  NuveiSavedCardMinAggregateFilter: NuveiSavedCardMinAggregateFilter;
  NuveiSavedCardMinAggregates: ResolverTypeWrapper<NuveiSavedCardMinAggregates>;
  NuveiSavedCardOrderBy: NuveiSavedCardOrderBy;
  NuveiSavedCardStddevPopulationAggregateFilter: NuveiSavedCardStddevPopulationAggregateFilter;
  NuveiSavedCardStddevPopulationAggregates: ResolverTypeWrapper<NuveiSavedCardStddevPopulationAggregates>;
  NuveiSavedCardStddevSampleAggregateFilter: NuveiSavedCardStddevSampleAggregateFilter;
  NuveiSavedCardStddevSampleAggregates: ResolverTypeWrapper<NuveiSavedCardStddevSampleAggregates>;
  NuveiSavedCardSumAggregateFilter: NuveiSavedCardSumAggregateFilter;
  NuveiSavedCardSumAggregates: ResolverTypeWrapper<NuveiSavedCardSumAggregates>;
  NuveiSavedCardVariancePopulationAggregateFilter: NuveiSavedCardVariancePopulationAggregateFilter;
  NuveiSavedCardVariancePopulationAggregates: ResolverTypeWrapper<NuveiSavedCardVariancePopulationAggregates>;
  NuveiSavedCardVarianceSampleAggregateFilter: NuveiSavedCardVarianceSampleAggregateFilter;
  NuveiSavedCardVarianceSampleAggregates: ResolverTypeWrapper<NuveiSavedCardVarianceSampleAggregates>;
  NuveiSavedPaypalArchived: ResolverTypeWrapper<NuveiSavedPaypalArchived>;
  NuveiWebhook: ResolverTypeWrapper<NuveiWebhook>;
  OfacsdnRecord: ResolverTypeWrapper<OfacsdnRecord>;
  OfacsdnRecordAggregates: ResolverTypeWrapper<OfacsdnRecordAggregates>;
  OfacsdnRecordAverageAggregates: ResolverTypeWrapper<OfacsdnRecordAverageAggregates>;
  OfacsdnRecordCondition: OfacsdnRecordCondition;
  OfacsdnRecordConnection: ResolverTypeWrapper<OfacsdnRecordConnection>;
  OfacsdnRecordDistinctCountAggregates: ResolverTypeWrapper<OfacsdnRecordDistinctCountAggregates>;
  OfacsdnRecordEdge: ResolverTypeWrapper<OfacsdnRecordEdge>;
  OfacsdnRecordFilter: OfacsdnRecordFilter;
  OfacsdnRecordGroupBy: OfacsdnRecordGroupBy;
  OfacsdnRecordHavingAverageInput: OfacsdnRecordHavingAverageInput;
  OfacsdnRecordHavingDistinctCountInput: OfacsdnRecordHavingDistinctCountInput;
  OfacsdnRecordHavingInput: OfacsdnRecordHavingInput;
  OfacsdnRecordHavingMaxInput: OfacsdnRecordHavingMaxInput;
  OfacsdnRecordHavingMinInput: OfacsdnRecordHavingMinInput;
  OfacsdnRecordHavingStddevPopulationInput: OfacsdnRecordHavingStddevPopulationInput;
  OfacsdnRecordHavingStddevSampleInput: OfacsdnRecordHavingStddevSampleInput;
  OfacsdnRecordHavingSumInput: OfacsdnRecordHavingSumInput;
  OfacsdnRecordHavingVariancePopulationInput: OfacsdnRecordHavingVariancePopulationInput;
  OfacsdnRecordHavingVarianceSampleInput: OfacsdnRecordHavingVarianceSampleInput;
  OfacsdnRecordMaxAggregates: ResolverTypeWrapper<OfacsdnRecordMaxAggregates>;
  OfacsdnRecordMinAggregates: ResolverTypeWrapper<OfacsdnRecordMinAggregates>;
  OfacsdnRecordOrderBy: OfacsdnRecordOrderBy;
  OfacsdnRecordStddevPopulationAggregates: ResolverTypeWrapper<OfacsdnRecordStddevPopulationAggregates>;
  OfacsdnRecordStddevSampleAggregates: ResolverTypeWrapper<OfacsdnRecordStddevSampleAggregates>;
  OfacsdnRecordSumAggregates: ResolverTypeWrapper<OfacsdnRecordSumAggregates>;
  OfacsdnRecordVariancePopulationAggregates: ResolverTypeWrapper<OfacsdnRecordVariancePopulationAggregates>;
  OfacsdnRecordVarianceSampleAggregates: ResolverTypeWrapper<OfacsdnRecordVarianceSampleAggregates>;
  OrderFulfillment: ResolverTypeWrapper<OrderFulfillment>;
  OrderFulfillmentAggregates: ResolverTypeWrapper<OrderFulfillmentAggregates>;
  OrderFulfillmentAggregatesFilter: OrderFulfillmentAggregatesFilter;
  OrderFulfillmentAverageAggregateFilter: OrderFulfillmentAverageAggregateFilter;
  OrderFulfillmentAverageAggregates: ResolverTypeWrapper<OrderFulfillmentAverageAggregates>;
  OrderFulfillmentCondition: OrderFulfillmentCondition;
  OrderFulfillmentConnection: ResolverTypeWrapper<OrderFulfillmentConnection>;
  OrderFulfillmentDistinctCountAggregateFilter: OrderFulfillmentDistinctCountAggregateFilter;
  OrderFulfillmentDistinctCountAggregates: ResolverTypeWrapper<OrderFulfillmentDistinctCountAggregates>;
  OrderFulfillmentEdge: ResolverTypeWrapper<OrderFulfillmentEdge>;
  OrderFulfillmentFilter: OrderFulfillmentFilter;
  OrderFulfillmentGroupBy: OrderFulfillmentGroupBy;
  OrderFulfillmentHavingAverageInput: OrderFulfillmentHavingAverageInput;
  OrderFulfillmentHavingDistinctCountInput: OrderFulfillmentHavingDistinctCountInput;
  OrderFulfillmentHavingInput: OrderFulfillmentHavingInput;
  OrderFulfillmentHavingMaxInput: OrderFulfillmentHavingMaxInput;
  OrderFulfillmentHavingMinInput: OrderFulfillmentHavingMinInput;
  OrderFulfillmentHavingStddevPopulationInput: OrderFulfillmentHavingStddevPopulationInput;
  OrderFulfillmentHavingStddevSampleInput: OrderFulfillmentHavingStddevSampleInput;
  OrderFulfillmentHavingSumInput: OrderFulfillmentHavingSumInput;
  OrderFulfillmentHavingVariancePopulationInput: OrderFulfillmentHavingVariancePopulationInput;
  OrderFulfillmentHavingVarianceSampleInput: OrderFulfillmentHavingVarianceSampleInput;
  OrderFulfillmentMaxAggregateFilter: OrderFulfillmentMaxAggregateFilter;
  OrderFulfillmentMaxAggregates: ResolverTypeWrapper<OrderFulfillmentMaxAggregates>;
  OrderFulfillmentMinAggregateFilter: OrderFulfillmentMinAggregateFilter;
  OrderFulfillmentMinAggregates: ResolverTypeWrapper<OrderFulfillmentMinAggregates>;
  OrderFulfillmentOrderBy: OrderFulfillmentOrderBy;
  OrderFulfillmentStatusEnum: OrderFulfillmentStatusEnum;
  OrderFulfillmentStatusEnumFilter: OrderFulfillmentStatusEnumFilter;
  OrderFulfillmentStddevPopulationAggregateFilter: OrderFulfillmentStddevPopulationAggregateFilter;
  OrderFulfillmentStddevPopulationAggregates: ResolverTypeWrapper<OrderFulfillmentStddevPopulationAggregates>;
  OrderFulfillmentStddevSampleAggregateFilter: OrderFulfillmentStddevSampleAggregateFilter;
  OrderFulfillmentStddevSampleAggregates: ResolverTypeWrapper<OrderFulfillmentStddevSampleAggregates>;
  OrderFulfillmentSumAggregateFilter: OrderFulfillmentSumAggregateFilter;
  OrderFulfillmentSumAggregates: ResolverTypeWrapper<OrderFulfillmentSumAggregates>;
  OrderFulfillmentTypeEnum: OrderFulfillmentTypeEnum;
  OrderFulfillmentTypeEnumFilter: OrderFulfillmentTypeEnumFilter;
  OrderFulfillmentVariancePopulationAggregateFilter: OrderFulfillmentVariancePopulationAggregateFilter;
  OrderFulfillmentVariancePopulationAggregates: ResolverTypeWrapper<OrderFulfillmentVariancePopulationAggregates>;
  OrderFulfillmentVarianceSampleAggregateFilter: OrderFulfillmentVarianceSampleAggregateFilter;
  OrderFulfillmentVarianceSampleAggregates: ResolverTypeWrapper<OrderFulfillmentVarianceSampleAggregates>;
  Outbox: ResolverTypeWrapper<Outbox>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Partner: ResolverTypeWrapper<Partner>;
  PartnerTransaction: ResolverTypeWrapper<PartnerTransaction>;
  PasswordHistory: ResolverTypeWrapper<PasswordHistory>;
  PasswordHistoryAggregates: ResolverTypeWrapper<PasswordHistoryAggregates>;
  PasswordHistoryAggregatesFilter: PasswordHistoryAggregatesFilter;
  PasswordHistoryAverageAggregateFilter: PasswordHistoryAverageAggregateFilter;
  PasswordHistoryAverageAggregates: ResolverTypeWrapper<PasswordHistoryAverageAggregates>;
  PasswordHistoryCondition: PasswordHistoryCondition;
  PasswordHistoryConnection: ResolverTypeWrapper<PasswordHistoryConnection>;
  PasswordHistoryDistinctCountAggregateFilter: PasswordHistoryDistinctCountAggregateFilter;
  PasswordHistoryDistinctCountAggregates: ResolverTypeWrapper<PasswordHistoryDistinctCountAggregates>;
  PasswordHistoryEdge: ResolverTypeWrapper<PasswordHistoryEdge>;
  PasswordHistoryFilter: PasswordHistoryFilter;
  PasswordHistoryGroupBy: PasswordHistoryGroupBy;
  PasswordHistoryHavingAverageInput: PasswordHistoryHavingAverageInput;
  PasswordHistoryHavingDistinctCountInput: PasswordHistoryHavingDistinctCountInput;
  PasswordHistoryHavingInput: PasswordHistoryHavingInput;
  PasswordHistoryHavingMaxInput: PasswordHistoryHavingMaxInput;
  PasswordHistoryHavingMinInput: PasswordHistoryHavingMinInput;
  PasswordHistoryHavingStddevPopulationInput: PasswordHistoryHavingStddevPopulationInput;
  PasswordHistoryHavingStddevSampleInput: PasswordHistoryHavingStddevSampleInput;
  PasswordHistoryHavingSumInput: PasswordHistoryHavingSumInput;
  PasswordHistoryHavingVariancePopulationInput: PasswordHistoryHavingVariancePopulationInput;
  PasswordHistoryHavingVarianceSampleInput: PasswordHistoryHavingVarianceSampleInput;
  PasswordHistoryMaxAggregateFilter: PasswordHistoryMaxAggregateFilter;
  PasswordHistoryMaxAggregates: ResolverTypeWrapper<PasswordHistoryMaxAggregates>;
  PasswordHistoryMinAggregateFilter: PasswordHistoryMinAggregateFilter;
  PasswordHistoryMinAggregates: ResolverTypeWrapper<PasswordHistoryMinAggregates>;
  PasswordHistoryOrderBy: PasswordHistoryOrderBy;
  PasswordHistoryStddevPopulationAggregateFilter: PasswordHistoryStddevPopulationAggregateFilter;
  PasswordHistoryStddevPopulationAggregates: ResolverTypeWrapper<PasswordHistoryStddevPopulationAggregates>;
  PasswordHistoryStddevSampleAggregateFilter: PasswordHistoryStddevSampleAggregateFilter;
  PasswordHistoryStddevSampleAggregates: ResolverTypeWrapper<PasswordHistoryStddevSampleAggregates>;
  PasswordHistorySumAggregateFilter: PasswordHistorySumAggregateFilter;
  PasswordHistorySumAggregates: ResolverTypeWrapper<PasswordHistorySumAggregates>;
  PasswordHistoryVariancePopulationAggregateFilter: PasswordHistoryVariancePopulationAggregateFilter;
  PasswordHistoryVariancePopulationAggregates: ResolverTypeWrapper<PasswordHistoryVariancePopulationAggregates>;
  PasswordHistoryVarianceSampleAggregateFilter: PasswordHistoryVarianceSampleAggregateFilter;
  PasswordHistoryVarianceSampleAggregates: ResolverTypeWrapper<PasswordHistoryVarianceSampleAggregates>;
  PathToFunding: ResolverTypeWrapper<PathToFunding>;
  PathToFundingObjective: ResolverTypeWrapper<PathToFundingObjective>;
  PathToFundingRule: ResolverTypeWrapper<PathToFundingRule>;
  PaymentGateway: ResolverTypeWrapper<PaymentGateway>;
  PaymentGatewayFilter: PaymentGatewayFilter;
  PayoutActivityActor: ResolverTypeWrapper<PayoutActivityActor>;
  PayoutActivityEvent: ResolverTypeWrapper<PayoutActivityEvent>;
  PayoutActivityReturn: ResolverTypeWrapper<PayoutActivityReturn>;
  PayoutActivityType: PayoutActivityType;
  PayoutCycle: ResolverTypeWrapper<PayoutCycle>;
  PayoutDepartmentApproval: ResolverTypeWrapper<PayoutDepartmentApproval>;
  PayoutDepartmentApprovalAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalAggregates>;
  PayoutDepartmentApprovalAggregatesFilter: PayoutDepartmentApprovalAggregatesFilter;
  PayoutDepartmentApprovalAverageAggregateFilter: PayoutDepartmentApprovalAverageAggregateFilter;
  PayoutDepartmentApprovalAverageAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalAverageAggregates>;
  PayoutDepartmentApprovalCondition: PayoutDepartmentApprovalCondition;
  PayoutDepartmentApprovalConnection: ResolverTypeWrapper<PayoutDepartmentApprovalConnection>;
  PayoutDepartmentApprovalDistinctCountAggregateFilter: PayoutDepartmentApprovalDistinctCountAggregateFilter;
  PayoutDepartmentApprovalDistinctCountAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalDistinctCountAggregates>;
  PayoutDepartmentApprovalEdge: ResolverTypeWrapper<PayoutDepartmentApprovalEdge>;
  PayoutDepartmentApprovalFilter: PayoutDepartmentApprovalFilter;
  PayoutDepartmentApprovalGroupBy: PayoutDepartmentApprovalGroupBy;
  PayoutDepartmentApprovalHavingAverageInput: PayoutDepartmentApprovalHavingAverageInput;
  PayoutDepartmentApprovalHavingDistinctCountInput: PayoutDepartmentApprovalHavingDistinctCountInput;
  PayoutDepartmentApprovalHavingInput: PayoutDepartmentApprovalHavingInput;
  PayoutDepartmentApprovalHavingMaxInput: PayoutDepartmentApprovalHavingMaxInput;
  PayoutDepartmentApprovalHavingMinInput: PayoutDepartmentApprovalHavingMinInput;
  PayoutDepartmentApprovalHavingStddevPopulationInput: PayoutDepartmentApprovalHavingStddevPopulationInput;
  PayoutDepartmentApprovalHavingStddevSampleInput: PayoutDepartmentApprovalHavingStddevSampleInput;
  PayoutDepartmentApprovalHavingSumInput: PayoutDepartmentApprovalHavingSumInput;
  PayoutDepartmentApprovalHavingVariancePopulationInput: PayoutDepartmentApprovalHavingVariancePopulationInput;
  PayoutDepartmentApprovalHavingVarianceSampleInput: PayoutDepartmentApprovalHavingVarianceSampleInput;
  PayoutDepartmentApprovalMaxAggregateFilter: PayoutDepartmentApprovalMaxAggregateFilter;
  PayoutDepartmentApprovalMaxAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalMaxAggregates>;
  PayoutDepartmentApprovalMinAggregateFilter: PayoutDepartmentApprovalMinAggregateFilter;
  PayoutDepartmentApprovalMinAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalMinAggregates>;
  PayoutDepartmentApprovalOrderBy: PayoutDepartmentApprovalOrderBy;
  PayoutDepartmentApprovalStddevPopulationAggregateFilter: PayoutDepartmentApprovalStddevPopulationAggregateFilter;
  PayoutDepartmentApprovalStddevPopulationAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalStddevPopulationAggregates>;
  PayoutDepartmentApprovalStddevSampleAggregateFilter: PayoutDepartmentApprovalStddevSampleAggregateFilter;
  PayoutDepartmentApprovalStddevSampleAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalStddevSampleAggregates>;
  PayoutDepartmentApprovalSumAggregateFilter: PayoutDepartmentApprovalSumAggregateFilter;
  PayoutDepartmentApprovalSumAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalSumAggregates>;
  PayoutDepartmentApprovalVariancePopulationAggregateFilter: PayoutDepartmentApprovalVariancePopulationAggregateFilter;
  PayoutDepartmentApprovalVariancePopulationAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalVariancePopulationAggregates>;
  PayoutDepartmentApprovalVarianceSampleAggregateFilter: PayoutDepartmentApprovalVarianceSampleAggregateFilter;
  PayoutDepartmentApprovalVarianceSampleAggregates: ResolverTypeWrapper<PayoutDepartmentApprovalVarianceSampleAggregates>;
  PayoutRequest: ResolverTypeWrapper<PayoutRequest>;
  PayoutRequestAggregates: ResolverTypeWrapper<PayoutRequestAggregates>;
  PayoutRequestAggregatesFilter: PayoutRequestAggregatesFilter;
  PayoutRequestAsset: ResolverTypeWrapper<PayoutRequestAsset>;
  PayoutRequestAssetAggregates: ResolverTypeWrapper<PayoutRequestAssetAggregates>;
  PayoutRequestAssetAggregatesFilter: PayoutRequestAssetAggregatesFilter;
  PayoutRequestAssetAverageAggregateFilter: PayoutRequestAssetAverageAggregateFilter;
  PayoutRequestAssetAverageAggregates: ResolverTypeWrapper<PayoutRequestAssetAverageAggregates>;
  PayoutRequestAssetCondition: PayoutRequestAssetCondition;
  PayoutRequestAssetConnection: ResolverTypeWrapper<PayoutRequestAssetConnection>;
  PayoutRequestAssetDistinctCountAggregateFilter: PayoutRequestAssetDistinctCountAggregateFilter;
  PayoutRequestAssetDistinctCountAggregates: ResolverTypeWrapper<PayoutRequestAssetDistinctCountAggregates>;
  PayoutRequestAssetEdge: ResolverTypeWrapper<PayoutRequestAssetEdge>;
  PayoutRequestAssetFilter: PayoutRequestAssetFilter;
  PayoutRequestAssetGroupBy: PayoutRequestAssetGroupBy;
  PayoutRequestAssetHavingAverageInput: PayoutRequestAssetHavingAverageInput;
  PayoutRequestAssetHavingDistinctCountInput: PayoutRequestAssetHavingDistinctCountInput;
  PayoutRequestAssetHavingInput: PayoutRequestAssetHavingInput;
  PayoutRequestAssetHavingMaxInput: PayoutRequestAssetHavingMaxInput;
  PayoutRequestAssetHavingMinInput: PayoutRequestAssetHavingMinInput;
  PayoutRequestAssetHavingStddevPopulationInput: PayoutRequestAssetHavingStddevPopulationInput;
  PayoutRequestAssetHavingStddevSampleInput: PayoutRequestAssetHavingStddevSampleInput;
  PayoutRequestAssetHavingSumInput: PayoutRequestAssetHavingSumInput;
  PayoutRequestAssetHavingVariancePopulationInput: PayoutRequestAssetHavingVariancePopulationInput;
  PayoutRequestAssetHavingVarianceSampleInput: PayoutRequestAssetHavingVarianceSampleInput;
  PayoutRequestAssetMaxAggregateFilter: PayoutRequestAssetMaxAggregateFilter;
  PayoutRequestAssetMaxAggregates: ResolverTypeWrapper<PayoutRequestAssetMaxAggregates>;
  PayoutRequestAssetMinAggregateFilter: PayoutRequestAssetMinAggregateFilter;
  PayoutRequestAssetMinAggregates: ResolverTypeWrapper<PayoutRequestAssetMinAggregates>;
  PayoutRequestAssetOrderBy: PayoutRequestAssetOrderBy;
  PayoutRequestAssetStatusEnum: PayoutRequestAssetStatusEnum;
  PayoutRequestAssetStatusEnumFilter: PayoutRequestAssetStatusEnumFilter;
  PayoutRequestAssetStddevPopulationAggregateFilter: PayoutRequestAssetStddevPopulationAggregateFilter;
  PayoutRequestAssetStddevPopulationAggregates: ResolverTypeWrapper<PayoutRequestAssetStddevPopulationAggregates>;
  PayoutRequestAssetStddevSampleAggregateFilter: PayoutRequestAssetStddevSampleAggregateFilter;
  PayoutRequestAssetStddevSampleAggregates: ResolverTypeWrapper<PayoutRequestAssetStddevSampleAggregates>;
  PayoutRequestAssetSumAggregateFilter: PayoutRequestAssetSumAggregateFilter;
  PayoutRequestAssetSumAggregates: ResolverTypeWrapper<PayoutRequestAssetSumAggregates>;
  PayoutRequestAssetVariancePopulationAggregateFilter: PayoutRequestAssetVariancePopulationAggregateFilter;
  PayoutRequestAssetVariancePopulationAggregates: ResolverTypeWrapper<PayoutRequestAssetVariancePopulationAggregates>;
  PayoutRequestAssetVarianceSampleAggregateFilter: PayoutRequestAssetVarianceSampleAggregateFilter;
  PayoutRequestAssetVarianceSampleAggregates: ResolverTypeWrapper<PayoutRequestAssetVarianceSampleAggregates>;
  PayoutRequestAverageAggregateFilter: PayoutRequestAverageAggregateFilter;
  PayoutRequestAverageAggregates: ResolverTypeWrapper<PayoutRequestAverageAggregates>;
  PayoutRequestBatch: ResolverTypeWrapper<PayoutRequestBatch>;
  PayoutRequestBatchAggregates: ResolverTypeWrapper<PayoutRequestBatchAggregates>;
  PayoutRequestBatchAggregatesFilter: PayoutRequestBatchAggregatesFilter;
  PayoutRequestBatchAverageAggregateFilter: PayoutRequestBatchAverageAggregateFilter;
  PayoutRequestBatchAverageAggregates: ResolverTypeWrapper<PayoutRequestBatchAverageAggregates>;
  PayoutRequestBatchBankAccountTypeEnum: PayoutRequestBatchBankAccountTypeEnum;
  PayoutRequestBatchBankAccountTypeEnumFilter: PayoutRequestBatchBankAccountTypeEnumFilter;
  PayoutRequestBatchCondition: PayoutRequestBatchCondition;
  PayoutRequestBatchConnection: ResolverTypeWrapper<PayoutRequestBatchConnection>;
  PayoutRequestBatchDistinctCountAggregateFilter: PayoutRequestBatchDistinctCountAggregateFilter;
  PayoutRequestBatchDistinctCountAggregates: ResolverTypeWrapper<PayoutRequestBatchDistinctCountAggregates>;
  PayoutRequestBatchEdge: ResolverTypeWrapper<PayoutRequestBatchEdge>;
  PayoutRequestBatchFilter: PayoutRequestBatchFilter;
  PayoutRequestBatchGroupBy: PayoutRequestBatchGroupBy;
  PayoutRequestBatchHavingAverageInput: PayoutRequestBatchHavingAverageInput;
  PayoutRequestBatchHavingDistinctCountInput: PayoutRequestBatchHavingDistinctCountInput;
  PayoutRequestBatchHavingInput: PayoutRequestBatchHavingInput;
  PayoutRequestBatchHavingMaxInput: PayoutRequestBatchHavingMaxInput;
  PayoutRequestBatchHavingMinInput: PayoutRequestBatchHavingMinInput;
  PayoutRequestBatchHavingStddevPopulationInput: PayoutRequestBatchHavingStddevPopulationInput;
  PayoutRequestBatchHavingStddevSampleInput: PayoutRequestBatchHavingStddevSampleInput;
  PayoutRequestBatchHavingSumInput: PayoutRequestBatchHavingSumInput;
  PayoutRequestBatchHavingVariancePopulationInput: PayoutRequestBatchHavingVariancePopulationInput;
  PayoutRequestBatchHavingVarianceSampleInput: PayoutRequestBatchHavingVarianceSampleInput;
  PayoutRequestBatchItem: ResolverTypeWrapper<PayoutRequestBatchItem>;
  PayoutRequestBatchItemAggregates: ResolverTypeWrapper<PayoutRequestBatchItemAggregates>;
  PayoutRequestBatchItemAggregatesFilter: PayoutRequestBatchItemAggregatesFilter;
  PayoutRequestBatchItemAverageAggregateFilter: PayoutRequestBatchItemAverageAggregateFilter;
  PayoutRequestBatchItemAverageAggregates: ResolverTypeWrapper<PayoutRequestBatchItemAverageAggregates>;
  PayoutRequestBatchItemCondition: PayoutRequestBatchItemCondition;
  PayoutRequestBatchItemConnection: ResolverTypeWrapper<PayoutRequestBatchItemConnection>;
  PayoutRequestBatchItemDistinctCountAggregateFilter: PayoutRequestBatchItemDistinctCountAggregateFilter;
  PayoutRequestBatchItemDistinctCountAggregates: ResolverTypeWrapper<PayoutRequestBatchItemDistinctCountAggregates>;
  PayoutRequestBatchItemEdge: ResolverTypeWrapper<PayoutRequestBatchItemEdge>;
  PayoutRequestBatchItemFilter: PayoutRequestBatchItemFilter;
  PayoutRequestBatchItemGroupBy: PayoutRequestBatchItemGroupBy;
  PayoutRequestBatchItemHavingAverageInput: PayoutRequestBatchItemHavingAverageInput;
  PayoutRequestBatchItemHavingDistinctCountInput: PayoutRequestBatchItemHavingDistinctCountInput;
  PayoutRequestBatchItemHavingInput: PayoutRequestBatchItemHavingInput;
  PayoutRequestBatchItemHavingMaxInput: PayoutRequestBatchItemHavingMaxInput;
  PayoutRequestBatchItemHavingMinInput: PayoutRequestBatchItemHavingMinInput;
  PayoutRequestBatchItemHavingStddevPopulationInput: PayoutRequestBatchItemHavingStddevPopulationInput;
  PayoutRequestBatchItemHavingStddevSampleInput: PayoutRequestBatchItemHavingStddevSampleInput;
  PayoutRequestBatchItemHavingSumInput: PayoutRequestBatchItemHavingSumInput;
  PayoutRequestBatchItemHavingVariancePopulationInput: PayoutRequestBatchItemHavingVariancePopulationInput;
  PayoutRequestBatchItemHavingVarianceSampleInput: PayoutRequestBatchItemHavingVarianceSampleInput;
  PayoutRequestBatchItemMaxAggregateFilter: PayoutRequestBatchItemMaxAggregateFilter;
  PayoutRequestBatchItemMaxAggregates: ResolverTypeWrapper<PayoutRequestBatchItemMaxAggregates>;
  PayoutRequestBatchItemMinAggregateFilter: PayoutRequestBatchItemMinAggregateFilter;
  PayoutRequestBatchItemMinAggregates: ResolverTypeWrapper<PayoutRequestBatchItemMinAggregates>;
  PayoutRequestBatchItemOrderBy: PayoutRequestBatchItemOrderBy;
  PayoutRequestBatchItemStddevPopulationAggregateFilter: PayoutRequestBatchItemStddevPopulationAggregateFilter;
  PayoutRequestBatchItemStddevPopulationAggregates: ResolverTypeWrapper<PayoutRequestBatchItemStddevPopulationAggregates>;
  PayoutRequestBatchItemStddevSampleAggregateFilter: PayoutRequestBatchItemStddevSampleAggregateFilter;
  PayoutRequestBatchItemStddevSampleAggregates: ResolverTypeWrapper<PayoutRequestBatchItemStddevSampleAggregates>;
  PayoutRequestBatchItemSumAggregateFilter: PayoutRequestBatchItemSumAggregateFilter;
  PayoutRequestBatchItemSumAggregates: ResolverTypeWrapper<PayoutRequestBatchItemSumAggregates>;
  PayoutRequestBatchItemVariancePopulationAggregateFilter: PayoutRequestBatchItemVariancePopulationAggregateFilter;
  PayoutRequestBatchItemVariancePopulationAggregates: ResolverTypeWrapper<PayoutRequestBatchItemVariancePopulationAggregates>;
  PayoutRequestBatchItemVarianceSampleAggregateFilter: PayoutRequestBatchItemVarianceSampleAggregateFilter;
  PayoutRequestBatchItemVarianceSampleAggregates: ResolverTypeWrapper<PayoutRequestBatchItemVarianceSampleAggregates>;
  PayoutRequestBatchMaxAggregateFilter: PayoutRequestBatchMaxAggregateFilter;
  PayoutRequestBatchMaxAggregates: ResolverTypeWrapper<PayoutRequestBatchMaxAggregates>;
  PayoutRequestBatchMinAggregateFilter: PayoutRequestBatchMinAggregateFilter;
  PayoutRequestBatchMinAggregates: ResolverTypeWrapper<PayoutRequestBatchMinAggregates>;
  PayoutRequestBatchOrderBy: PayoutRequestBatchOrderBy;
  PayoutRequestBatchProcessedViaEnum: PayoutRequestBatchProcessedViaEnum;
  PayoutRequestBatchStddevPopulationAggregateFilter: PayoutRequestBatchStddevPopulationAggregateFilter;
  PayoutRequestBatchStddevPopulationAggregates: ResolverTypeWrapper<PayoutRequestBatchStddevPopulationAggregates>;
  PayoutRequestBatchStddevSampleAggregateFilter: PayoutRequestBatchStddevSampleAggregateFilter;
  PayoutRequestBatchStddevSampleAggregates: ResolverTypeWrapper<PayoutRequestBatchStddevSampleAggregates>;
  PayoutRequestBatchSumAggregateFilter: PayoutRequestBatchSumAggregateFilter;
  PayoutRequestBatchSumAggregates: ResolverTypeWrapper<PayoutRequestBatchSumAggregates>;
  PayoutRequestBatchToManyPayoutRequestBatchItemFilter: PayoutRequestBatchToManyPayoutRequestBatchItemFilter;
  PayoutRequestBatchVariancePopulationAggregateFilter: PayoutRequestBatchVariancePopulationAggregateFilter;
  PayoutRequestBatchVariancePopulationAggregates: ResolverTypeWrapper<PayoutRequestBatchVariancePopulationAggregates>;
  PayoutRequestBatchVarianceSampleAggregateFilter: PayoutRequestBatchVarianceSampleAggregateFilter;
  PayoutRequestBatchVarianceSampleAggregates: ResolverTypeWrapper<PayoutRequestBatchVarianceSampleAggregates>;
  PayoutRequestCondition: PayoutRequestCondition;
  PayoutRequestConnection: ResolverTypeWrapper<PayoutRequestConnection>;
  PayoutRequestDistinctCountAggregateFilter: PayoutRequestDistinctCountAggregateFilter;
  PayoutRequestDistinctCountAggregates: ResolverTypeWrapper<PayoutRequestDistinctCountAggregates>;
  PayoutRequestEdge: ResolverTypeWrapper<PayoutRequestEdge>;
  PayoutRequestFilter: PayoutRequestFilter;
  PayoutRequestGroupBy: PayoutRequestGroupBy;
  PayoutRequestHavingAverageInput: PayoutRequestHavingAverageInput;
  PayoutRequestHavingDistinctCountInput: PayoutRequestHavingDistinctCountInput;
  PayoutRequestHavingInput: PayoutRequestHavingInput;
  PayoutRequestHavingMaxInput: PayoutRequestHavingMaxInput;
  PayoutRequestHavingMinInput: PayoutRequestHavingMinInput;
  PayoutRequestHavingStddevPopulationInput: PayoutRequestHavingStddevPopulationInput;
  PayoutRequestHavingStddevSampleInput: PayoutRequestHavingStddevSampleInput;
  PayoutRequestHavingSumInput: PayoutRequestHavingSumInput;
  PayoutRequestHavingVariancePopulationInput: PayoutRequestHavingVariancePopulationInput;
  PayoutRequestHavingVarianceSampleInput: PayoutRequestHavingVarianceSampleInput;
  PayoutRequestHistory: ResolverTypeWrapper<PayoutRequestHistory>;
  PayoutRequestHistoryStatusEnum: PayoutRequestHistoryStatusEnum;
  PayoutRequestMaxAggregateFilter: PayoutRequestMaxAggregateFilter;
  PayoutRequestMaxAggregates: ResolverTypeWrapper<PayoutRequestMaxAggregates>;
  PayoutRequestMinAggregateFilter: PayoutRequestMinAggregateFilter;
  PayoutRequestMinAggregates: ResolverTypeWrapper<PayoutRequestMinAggregates>;
  PayoutRequestOrderBy: PayoutRequestOrderBy;
  PayoutRequestStddevPopulationAggregateFilter: PayoutRequestStddevPopulationAggregateFilter;
  PayoutRequestStddevPopulationAggregates: ResolverTypeWrapper<PayoutRequestStddevPopulationAggregates>;
  PayoutRequestStddevSampleAggregateFilter: PayoutRequestStddevSampleAggregateFilter;
  PayoutRequestStddevSampleAggregates: ResolverTypeWrapper<PayoutRequestStddevSampleAggregates>;
  PayoutRequestSubscriber: ResolverTypeWrapper<PayoutRequestSubscriber>;
  PayoutRequestSubscriberAggregates: ResolverTypeWrapper<PayoutRequestSubscriberAggregates>;
  PayoutRequestSubscriberAggregatesFilter: PayoutRequestSubscriberAggregatesFilter;
  PayoutRequestSubscriberAverageAggregateFilter: PayoutRequestSubscriberAverageAggregateFilter;
  PayoutRequestSubscriberAverageAggregates: ResolverTypeWrapper<PayoutRequestSubscriberAverageAggregates>;
  PayoutRequestSubscriberCondition: PayoutRequestSubscriberCondition;
  PayoutRequestSubscriberConnection: ResolverTypeWrapper<PayoutRequestSubscriberConnection>;
  PayoutRequestSubscriberDistinctCountAggregateFilter: PayoutRequestSubscriberDistinctCountAggregateFilter;
  PayoutRequestSubscriberDistinctCountAggregates: ResolverTypeWrapper<PayoutRequestSubscriberDistinctCountAggregates>;
  PayoutRequestSubscriberEdge: ResolverTypeWrapper<PayoutRequestSubscriberEdge>;
  PayoutRequestSubscriberFilter: PayoutRequestSubscriberFilter;
  PayoutRequestSubscriberGroupBy: PayoutRequestSubscriberGroupBy;
  PayoutRequestSubscriberHavingAverageInput: PayoutRequestSubscriberHavingAverageInput;
  PayoutRequestSubscriberHavingDistinctCountInput: PayoutRequestSubscriberHavingDistinctCountInput;
  PayoutRequestSubscriberHavingInput: PayoutRequestSubscriberHavingInput;
  PayoutRequestSubscriberHavingMaxInput: PayoutRequestSubscriberHavingMaxInput;
  PayoutRequestSubscriberHavingMinInput: PayoutRequestSubscriberHavingMinInput;
  PayoutRequestSubscriberHavingStddevPopulationInput: PayoutRequestSubscriberHavingStddevPopulationInput;
  PayoutRequestSubscriberHavingStddevSampleInput: PayoutRequestSubscriberHavingStddevSampleInput;
  PayoutRequestSubscriberHavingSumInput: PayoutRequestSubscriberHavingSumInput;
  PayoutRequestSubscriberHavingVariancePopulationInput: PayoutRequestSubscriberHavingVariancePopulationInput;
  PayoutRequestSubscriberHavingVarianceSampleInput: PayoutRequestSubscriberHavingVarianceSampleInput;
  PayoutRequestSubscriberMaxAggregateFilter: PayoutRequestSubscriberMaxAggregateFilter;
  PayoutRequestSubscriberMaxAggregates: ResolverTypeWrapper<PayoutRequestSubscriberMaxAggregates>;
  PayoutRequestSubscriberMinAggregateFilter: PayoutRequestSubscriberMinAggregateFilter;
  PayoutRequestSubscriberMinAggregates: ResolverTypeWrapper<PayoutRequestSubscriberMinAggregates>;
  PayoutRequestSubscriberOrderBy: PayoutRequestSubscriberOrderBy;
  PayoutRequestSubscriberStddevPopulationAggregateFilter: PayoutRequestSubscriberStddevPopulationAggregateFilter;
  PayoutRequestSubscriberStddevPopulationAggregates: ResolverTypeWrapper<PayoutRequestSubscriberStddevPopulationAggregates>;
  PayoutRequestSubscriberStddevSampleAggregateFilter: PayoutRequestSubscriberStddevSampleAggregateFilter;
  PayoutRequestSubscriberStddevSampleAggregates: ResolverTypeWrapper<PayoutRequestSubscriberStddevSampleAggregates>;
  PayoutRequestSubscriberSumAggregateFilter: PayoutRequestSubscriberSumAggregateFilter;
  PayoutRequestSubscriberSumAggregates: ResolverTypeWrapper<PayoutRequestSubscriberSumAggregates>;
  PayoutRequestSubscriberVariancePopulationAggregateFilter: PayoutRequestSubscriberVariancePopulationAggregateFilter;
  PayoutRequestSubscriberVariancePopulationAggregates: ResolverTypeWrapper<PayoutRequestSubscriberVariancePopulationAggregates>;
  PayoutRequestSubscriberVarianceSampleAggregateFilter: PayoutRequestSubscriberVarianceSampleAggregateFilter;
  PayoutRequestSubscriberVarianceSampleAggregates: ResolverTypeWrapper<PayoutRequestSubscriberVarianceSampleAggregates>;
  PayoutRequestSumAggregateFilter: PayoutRequestSumAggregateFilter;
  PayoutRequestSumAggregates: ResolverTypeWrapper<PayoutRequestSumAggregates>;
  PayoutRequestToManyPayoutDepartmentApprovalFilter: PayoutRequestToManyPayoutDepartmentApprovalFilter;
  PayoutRequestToManyPayoutRequestAssetFilter: PayoutRequestToManyPayoutRequestAssetFilter;
  PayoutRequestToManyPayoutRequestSubscriberFilter: PayoutRequestToManyPayoutRequestSubscriberFilter;
  PayoutRequestToManyPayoutReturnFilter: PayoutRequestToManyPayoutReturnFilter;
  PayoutRequestToManyPayoutReviewFilter: PayoutRequestToManyPayoutReviewFilter;
  PayoutRequestToManyPayoutReviewerFilter: PayoutRequestToManyPayoutReviewerFilter;
  PayoutRequestVariancePopulationAggregateFilter: PayoutRequestVariancePopulationAggregateFilter;
  PayoutRequestVariancePopulationAggregates: ResolverTypeWrapper<PayoutRequestVariancePopulationAggregates>;
  PayoutRequestVarianceSampleAggregateFilter: PayoutRequestVarianceSampleAggregateFilter;
  PayoutRequestVarianceSampleAggregates: ResolverTypeWrapper<PayoutRequestVarianceSampleAggregates>;
  PayoutRequestsStatsConnection: ResolverTypeWrapper<PayoutRequestsStatsConnection>;
  PayoutRequestsStatsEdge: ResolverTypeWrapper<PayoutRequestsStatsEdge>;
  PayoutRequestsStatsRecord: ResolverTypeWrapper<PayoutRequestsStatsRecord>;
  PayoutRequestsStatsRecordFilter: PayoutRequestsStatsRecordFilter;
  PayoutReturn: ResolverTypeWrapper<PayoutReturn>;
  PayoutReturnAggregates: ResolverTypeWrapper<PayoutReturnAggregates>;
  PayoutReturnAggregatesFilter: PayoutReturnAggregatesFilter;
  PayoutReturnAverageAggregateFilter: PayoutReturnAverageAggregateFilter;
  PayoutReturnAverageAggregates: ResolverTypeWrapper<PayoutReturnAverageAggregates>;
  PayoutReturnCondition: PayoutReturnCondition;
  PayoutReturnConnection: ResolverTypeWrapper<PayoutReturnConnection>;
  PayoutReturnDistinctCountAggregateFilter: PayoutReturnDistinctCountAggregateFilter;
  PayoutReturnDistinctCountAggregates: ResolverTypeWrapper<PayoutReturnDistinctCountAggregates>;
  PayoutReturnEdge: ResolverTypeWrapper<PayoutReturnEdge>;
  PayoutReturnFilter: PayoutReturnFilter;
  PayoutReturnGroupBy: PayoutReturnGroupBy;
  PayoutReturnHavingAverageInput: PayoutReturnHavingAverageInput;
  PayoutReturnHavingDistinctCountInput: PayoutReturnHavingDistinctCountInput;
  PayoutReturnHavingInput: PayoutReturnHavingInput;
  PayoutReturnHavingMaxInput: PayoutReturnHavingMaxInput;
  PayoutReturnHavingMinInput: PayoutReturnHavingMinInput;
  PayoutReturnHavingStddevPopulationInput: PayoutReturnHavingStddevPopulationInput;
  PayoutReturnHavingStddevSampleInput: PayoutReturnHavingStddevSampleInput;
  PayoutReturnHavingSumInput: PayoutReturnHavingSumInput;
  PayoutReturnHavingVariancePopulationInput: PayoutReturnHavingVariancePopulationInput;
  PayoutReturnHavingVarianceSampleInput: PayoutReturnHavingVarianceSampleInput;
  PayoutReturnMaxAggregateFilter: PayoutReturnMaxAggregateFilter;
  PayoutReturnMaxAggregates: ResolverTypeWrapper<PayoutReturnMaxAggregates>;
  PayoutReturnMinAggregateFilter: PayoutReturnMinAggregateFilter;
  PayoutReturnMinAggregates: ResolverTypeWrapper<PayoutReturnMinAggregates>;
  PayoutReturnOrderBy: PayoutReturnOrderBy;
  PayoutReturnReasonCode: ResolverTypeWrapper<PayoutReturnReasonCode>;
  PayoutReturnReasonCodeAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeAggregates>;
  PayoutReturnReasonCodeAverageAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeAverageAggregates>;
  PayoutReturnReasonCodeCondition: PayoutReturnReasonCodeCondition;
  PayoutReturnReasonCodeConnection: ResolverTypeWrapper<PayoutReturnReasonCodeConnection>;
  PayoutReturnReasonCodeDistinctCountAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeDistinctCountAggregates>;
  PayoutReturnReasonCodeEdge: ResolverTypeWrapper<PayoutReturnReasonCodeEdge>;
  PayoutReturnReasonCodeFilter: PayoutReturnReasonCodeFilter;
  PayoutReturnReasonCodeMaxAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeMaxAggregates>;
  PayoutReturnReasonCodeMinAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeMinAggregates>;
  PayoutReturnReasonCodeOrderBy: PayoutReturnReasonCodeOrderBy;
  PayoutReturnReasonCodeStddevPopulationAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeStddevPopulationAggregates>;
  PayoutReturnReasonCodeStddevSampleAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeStddevSampleAggregates>;
  PayoutReturnReasonCodeSumAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeSumAggregates>;
  PayoutReturnReasonCodeVariancePopulationAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeVariancePopulationAggregates>;
  PayoutReturnReasonCodeVarianceSampleAggregates: ResolverTypeWrapper<PayoutReturnReasonCodeVarianceSampleAggregates>;
  PayoutReturnStddevPopulationAggregateFilter: PayoutReturnStddevPopulationAggregateFilter;
  PayoutReturnStddevPopulationAggregates: ResolverTypeWrapper<PayoutReturnStddevPopulationAggregates>;
  PayoutReturnStddevSampleAggregateFilter: PayoutReturnStddevSampleAggregateFilter;
  PayoutReturnStddevSampleAggregates: ResolverTypeWrapper<PayoutReturnStddevSampleAggregates>;
  PayoutReturnSumAggregateFilter: PayoutReturnSumAggregateFilter;
  PayoutReturnSumAggregates: ResolverTypeWrapper<PayoutReturnSumAggregates>;
  PayoutReturnVariancePopulationAggregateFilter: PayoutReturnVariancePopulationAggregateFilter;
  PayoutReturnVariancePopulationAggregates: ResolverTypeWrapper<PayoutReturnVariancePopulationAggregates>;
  PayoutReturnVarianceSampleAggregateFilter: PayoutReturnVarianceSampleAggregateFilter;
  PayoutReturnVarianceSampleAggregates: ResolverTypeWrapper<PayoutReturnVarianceSampleAggregates>;
  PayoutReview: ResolverTypeWrapper<PayoutReview>;
  PayoutReviewAggregates: ResolverTypeWrapper<PayoutReviewAggregates>;
  PayoutReviewAggregatesFilter: PayoutReviewAggregatesFilter;
  PayoutReviewAverageAggregateFilter: PayoutReviewAverageAggregateFilter;
  PayoutReviewAverageAggregates: ResolverTypeWrapper<PayoutReviewAverageAggregates>;
  PayoutReviewCondition: PayoutReviewCondition;
  PayoutReviewConnection: ResolverTypeWrapper<PayoutReviewConnection>;
  PayoutReviewDistinctCountAggregateFilter: PayoutReviewDistinctCountAggregateFilter;
  PayoutReviewDistinctCountAggregates: ResolverTypeWrapper<PayoutReviewDistinctCountAggregates>;
  PayoutReviewEdge: ResolverTypeWrapper<PayoutReviewEdge>;
  PayoutReviewFilter: PayoutReviewFilter;
  PayoutReviewGroupBy: PayoutReviewGroupBy;
  PayoutReviewHavingAverageInput: PayoutReviewHavingAverageInput;
  PayoutReviewHavingDistinctCountInput: PayoutReviewHavingDistinctCountInput;
  PayoutReviewHavingInput: PayoutReviewHavingInput;
  PayoutReviewHavingMaxInput: PayoutReviewHavingMaxInput;
  PayoutReviewHavingMinInput: PayoutReviewHavingMinInput;
  PayoutReviewHavingStddevPopulationInput: PayoutReviewHavingStddevPopulationInput;
  PayoutReviewHavingStddevSampleInput: PayoutReviewHavingStddevSampleInput;
  PayoutReviewHavingSumInput: PayoutReviewHavingSumInput;
  PayoutReviewHavingVariancePopulationInput: PayoutReviewHavingVariancePopulationInput;
  PayoutReviewHavingVarianceSampleInput: PayoutReviewHavingVarianceSampleInput;
  PayoutReviewMaxAggregateFilter: PayoutReviewMaxAggregateFilter;
  PayoutReviewMaxAggregates: ResolverTypeWrapper<PayoutReviewMaxAggregates>;
  PayoutReviewMinAggregateFilter: PayoutReviewMinAggregateFilter;
  PayoutReviewMinAggregates: ResolverTypeWrapper<PayoutReviewMinAggregates>;
  PayoutReviewOrderBy: PayoutReviewOrderBy;
  PayoutReviewStddevPopulationAggregateFilter: PayoutReviewStddevPopulationAggregateFilter;
  PayoutReviewStddevPopulationAggregates: ResolverTypeWrapper<PayoutReviewStddevPopulationAggregates>;
  PayoutReviewStddevSampleAggregateFilter: PayoutReviewStddevSampleAggregateFilter;
  PayoutReviewStddevSampleAggregates: ResolverTypeWrapper<PayoutReviewStddevSampleAggregates>;
  PayoutReviewSumAggregateFilter: PayoutReviewSumAggregateFilter;
  PayoutReviewSumAggregates: ResolverTypeWrapper<PayoutReviewSumAggregates>;
  PayoutReviewVariancePopulationAggregateFilter: PayoutReviewVariancePopulationAggregateFilter;
  PayoutReviewVariancePopulationAggregates: ResolverTypeWrapper<PayoutReviewVariancePopulationAggregates>;
  PayoutReviewVarianceSampleAggregateFilter: PayoutReviewVarianceSampleAggregateFilter;
  PayoutReviewVarianceSampleAggregates: ResolverTypeWrapper<PayoutReviewVarianceSampleAggregates>;
  PayoutReviewer: ResolverTypeWrapper<PayoutReviewer>;
  PayoutReviewerAggregates: ResolverTypeWrapper<PayoutReviewerAggregates>;
  PayoutReviewerAggregatesFilter: PayoutReviewerAggregatesFilter;
  PayoutReviewerAverageAggregateFilter: PayoutReviewerAverageAggregateFilter;
  PayoutReviewerAverageAggregates: ResolverTypeWrapper<PayoutReviewerAverageAggregates>;
  PayoutReviewerCondition: PayoutReviewerCondition;
  PayoutReviewerConnection: ResolverTypeWrapper<PayoutReviewerConnection>;
  PayoutReviewerDistinctCountAggregateFilter: PayoutReviewerDistinctCountAggregateFilter;
  PayoutReviewerDistinctCountAggregates: ResolverTypeWrapper<PayoutReviewerDistinctCountAggregates>;
  PayoutReviewerEdge: ResolverTypeWrapper<PayoutReviewerEdge>;
  PayoutReviewerFilter: PayoutReviewerFilter;
  PayoutReviewerGroupBy: PayoutReviewerGroupBy;
  PayoutReviewerHavingAverageInput: PayoutReviewerHavingAverageInput;
  PayoutReviewerHavingDistinctCountInput: PayoutReviewerHavingDistinctCountInput;
  PayoutReviewerHavingInput: PayoutReviewerHavingInput;
  PayoutReviewerHavingMaxInput: PayoutReviewerHavingMaxInput;
  PayoutReviewerHavingMinInput: PayoutReviewerHavingMinInput;
  PayoutReviewerHavingStddevPopulationInput: PayoutReviewerHavingStddevPopulationInput;
  PayoutReviewerHavingStddevSampleInput: PayoutReviewerHavingStddevSampleInput;
  PayoutReviewerHavingSumInput: PayoutReviewerHavingSumInput;
  PayoutReviewerHavingVariancePopulationInput: PayoutReviewerHavingVariancePopulationInput;
  PayoutReviewerHavingVarianceSampleInput: PayoutReviewerHavingVarianceSampleInput;
  PayoutReviewerMaxAggregateFilter: PayoutReviewerMaxAggregateFilter;
  PayoutReviewerMaxAggregates: ResolverTypeWrapper<PayoutReviewerMaxAggregates>;
  PayoutReviewerMinAggregateFilter: PayoutReviewerMinAggregateFilter;
  PayoutReviewerMinAggregates: ResolverTypeWrapper<PayoutReviewerMinAggregates>;
  PayoutReviewerOrderBy: PayoutReviewerOrderBy;
  PayoutReviewerStddevPopulationAggregateFilter: PayoutReviewerStddevPopulationAggregateFilter;
  PayoutReviewerStddevPopulationAggregates: ResolverTypeWrapper<PayoutReviewerStddevPopulationAggregates>;
  PayoutReviewerStddevSampleAggregateFilter: PayoutReviewerStddevSampleAggregateFilter;
  PayoutReviewerStddevSampleAggregates: ResolverTypeWrapper<PayoutReviewerStddevSampleAggregates>;
  PayoutReviewerSumAggregateFilter: PayoutReviewerSumAggregateFilter;
  PayoutReviewerSumAggregates: ResolverTypeWrapper<PayoutReviewerSumAggregates>;
  PayoutReviewerVariancePopulationAggregateFilter: PayoutReviewerVariancePopulationAggregateFilter;
  PayoutReviewerVariancePopulationAggregates: ResolverTypeWrapper<PayoutReviewerVariancePopulationAggregates>;
  PayoutReviewerVarianceSampleAggregateFilter: PayoutReviewerVarianceSampleAggregateFilter;
  PayoutReviewerVarianceSampleAggregates: ResolverTypeWrapper<PayoutReviewerVarianceSampleAggregates>;
  PayoutRollupItem: ResolverTypeWrapper<PayoutRollupItem>;
  PayoutRollupResult: ResolverTypeWrapper<PayoutRollupResult>;
  PaypalTransaction: ResolverTypeWrapper<PaypalTransaction>;
  PersonaInquiryEvent: ResolverTypeWrapper<PersonaInquiryEvent>;
  PersonaTransactionEvent: ResolverTypeWrapper<PersonaTransactionEvent>;
  PersonaWebhookEvent: ResolverTypeWrapper<PersonaWebhookEvent>;
  PersonaWebhookEventAggregates: ResolverTypeWrapper<PersonaWebhookEventAggregates>;
  PersonaWebhookEventAggregatesFilter: PersonaWebhookEventAggregatesFilter;
  PersonaWebhookEventAverageAggregateFilter: PersonaWebhookEventAverageAggregateFilter;
  PersonaWebhookEventAverageAggregates: ResolverTypeWrapper<PersonaWebhookEventAverageAggregates>;
  PersonaWebhookEventCondition: PersonaWebhookEventCondition;
  PersonaWebhookEventConnection: ResolverTypeWrapper<PersonaWebhookEventConnection>;
  PersonaWebhookEventDistinctCountAggregateFilter: PersonaWebhookEventDistinctCountAggregateFilter;
  PersonaWebhookEventDistinctCountAggregates: ResolverTypeWrapper<PersonaWebhookEventDistinctCountAggregates>;
  PersonaWebhookEventEdge: ResolverTypeWrapper<PersonaWebhookEventEdge>;
  PersonaWebhookEventFilter: PersonaWebhookEventFilter;
  PersonaWebhookEventGroupBy: PersonaWebhookEventGroupBy;
  PersonaWebhookEventHavingAverageInput: PersonaWebhookEventHavingAverageInput;
  PersonaWebhookEventHavingDistinctCountInput: PersonaWebhookEventHavingDistinctCountInput;
  PersonaWebhookEventHavingInput: PersonaWebhookEventHavingInput;
  PersonaWebhookEventHavingMaxInput: PersonaWebhookEventHavingMaxInput;
  PersonaWebhookEventHavingMinInput: PersonaWebhookEventHavingMinInput;
  PersonaWebhookEventHavingStddevPopulationInput: PersonaWebhookEventHavingStddevPopulationInput;
  PersonaWebhookEventHavingStddevSampleInput: PersonaWebhookEventHavingStddevSampleInput;
  PersonaWebhookEventHavingSumInput: PersonaWebhookEventHavingSumInput;
  PersonaWebhookEventHavingVariancePopulationInput: PersonaWebhookEventHavingVariancePopulationInput;
  PersonaWebhookEventHavingVarianceSampleInput: PersonaWebhookEventHavingVarianceSampleInput;
  PersonaWebhookEventMaxAggregateFilter: PersonaWebhookEventMaxAggregateFilter;
  PersonaWebhookEventMaxAggregates: ResolverTypeWrapper<PersonaWebhookEventMaxAggregates>;
  PersonaWebhookEventMinAggregateFilter: PersonaWebhookEventMinAggregateFilter;
  PersonaWebhookEventMinAggregates: ResolverTypeWrapper<PersonaWebhookEventMinAggregates>;
  PersonaWebhookEventOrderBy: PersonaWebhookEventOrderBy;
  PersonaWebhookEventStddevPopulationAggregateFilter: PersonaWebhookEventStddevPopulationAggregateFilter;
  PersonaWebhookEventStddevPopulationAggregates: ResolverTypeWrapper<PersonaWebhookEventStddevPopulationAggregates>;
  PersonaWebhookEventStddevSampleAggregateFilter: PersonaWebhookEventStddevSampleAggregateFilter;
  PersonaWebhookEventStddevSampleAggregates: ResolverTypeWrapper<PersonaWebhookEventStddevSampleAggregates>;
  PersonaWebhookEventSumAggregateFilter: PersonaWebhookEventSumAggregateFilter;
  PersonaWebhookEventSumAggregates: ResolverTypeWrapper<PersonaWebhookEventSumAggregates>;
  PersonaWebhookEventVariancePopulationAggregateFilter: PersonaWebhookEventVariancePopulationAggregateFilter;
  PersonaWebhookEventVariancePopulationAggregates: ResolverTypeWrapper<PersonaWebhookEventVariancePopulationAggregates>;
  PersonaWebhookEventVarianceSampleAggregateFilter: PersonaWebhookEventVarianceSampleAggregateFilter;
  PersonaWebhookEventVarianceSampleAggregates: ResolverTypeWrapper<PersonaWebhookEventVarianceSampleAggregates>;
  Platform: ResolverTypeWrapper<Platform>;
  PlatformFilter: PlatformFilter;
  PlatformToManyAccountFilter: PlatformToManyAccountFilter;
  PlatformToManyTradingProductFeeFilter: PlatformToManyTradingProductFeeFilter;
  PlatformToManyUserPlatformCredentialFilter: PlatformToManyUserPlatformCredentialFilter;
  PopcardPayoutCandidate: ResolverTypeWrapper<PopcardPayoutCandidate>;
  PopcardRollupGroup: ResolverTypeWrapper<PopcardRollupGroup>;
  Product: ResolverTypeWrapper<Product>;
  ProductAggregates: ResolverTypeWrapper<ProductAggregates>;
  ProductAggregatesFilter: ProductAggregatesFilter;
  ProductAverageAggregateFilter: ProductAverageAggregateFilter;
  ProductAverageAggregates: ResolverTypeWrapper<ProductAverageAggregates>;
  ProductCategory: ResolverTypeWrapper<ProductCategory>;
  ProductCategoryAggregates: ResolverTypeWrapper<ProductCategoryAggregates>;
  ProductCategoryAverageAggregates: ResolverTypeWrapper<ProductCategoryAverageAggregates>;
  ProductCategoryCondition: ProductCategoryCondition;
  ProductCategoryConnection: ResolverTypeWrapper<ProductCategoryConnection>;
  ProductCategoryDistinctCountAggregates: ResolverTypeWrapper<ProductCategoryDistinctCountAggregates>;
  ProductCategoryEdge: ResolverTypeWrapper<ProductCategoryEdge>;
  ProductCategoryFilter: ProductCategoryFilter;
  ProductCategoryMaxAggregates: ResolverTypeWrapper<ProductCategoryMaxAggregates>;
  ProductCategoryMinAggregates: ResolverTypeWrapper<ProductCategoryMinAggregates>;
  ProductCategoryOrderBy: ProductCategoryOrderBy;
  ProductCategoryStddevPopulationAggregates: ResolverTypeWrapper<ProductCategoryStddevPopulationAggregates>;
  ProductCategoryStddevSampleAggregates: ResolverTypeWrapper<ProductCategoryStddevSampleAggregates>;
  ProductCategorySumAggregates: ResolverTypeWrapper<ProductCategorySumAggregates>;
  ProductCategoryToManyProductFilter: ProductCategoryToManyProductFilter;
  ProductCategoryVariancePopulationAggregates: ResolverTypeWrapper<ProductCategoryVariancePopulationAggregates>;
  ProductCategoryVarianceSampleAggregates: ResolverTypeWrapper<ProductCategoryVarianceSampleAggregates>;
  ProductCondition: ProductCondition;
  ProductConnection: ResolverTypeWrapper<ProductConnection>;
  ProductDistinctCountAggregateFilter: ProductDistinctCountAggregateFilter;
  ProductDistinctCountAggregates: ResolverTypeWrapper<ProductDistinctCountAggregates>;
  ProductEdge: ResolverTypeWrapper<ProductEdge>;
  ProductFilter: ProductFilter;
  ProductGroupBy: ProductGroupBy;
  ProductHavingAverageInput: ProductHavingAverageInput;
  ProductHavingDistinctCountInput: ProductHavingDistinctCountInput;
  ProductHavingInput: ProductHavingInput;
  ProductHavingMaxInput: ProductHavingMaxInput;
  ProductHavingMinInput: ProductHavingMinInput;
  ProductHavingStddevPopulationInput: ProductHavingStddevPopulationInput;
  ProductHavingStddevSampleInput: ProductHavingStddevSampleInput;
  ProductHavingSumInput: ProductHavingSumInput;
  ProductHavingVariancePopulationInput: ProductHavingVariancePopulationInput;
  ProductHavingVarianceSampleInput: ProductHavingVarianceSampleInput;
  ProductMaxAggregateFilter: ProductMaxAggregateFilter;
  ProductMaxAggregates: ResolverTypeWrapper<ProductMaxAggregates>;
  ProductMinAggregateFilter: ProductMinAggregateFilter;
  ProductMinAggregates: ResolverTypeWrapper<ProductMinAggregates>;
  ProductOrderBy: ProductOrderBy;
  ProductRecurringcycleEnum: ProductRecurringcycleEnum;
  ProductStddevPopulationAggregateFilter: ProductStddevPopulationAggregateFilter;
  ProductStddevPopulationAggregates: ResolverTypeWrapper<ProductStddevPopulationAggregates>;
  ProductStddevSampleAggregateFilter: ProductStddevSampleAggregateFilter;
  ProductStddevSampleAggregates: ResolverTypeWrapper<ProductStddevSampleAggregates>;
  ProductSumAggregateFilter: ProductSumAggregateFilter;
  ProductSumAggregates: ResolverTypeWrapper<ProductSumAggregates>;
  ProductToManyCheckoutItemFilter: ProductToManyCheckoutItemFilter;
  ProductToManyNmiSubscriptionFilter: ProductToManyNmiSubscriptionFilter;
  ProductToManyPurchaseItemFilter: ProductToManyPurchaseItemFilter;
  ProductVariancePopulationAggregateFilter: ProductVariancePopulationAggregateFilter;
  ProductVariancePopulationAggregates: ResolverTypeWrapper<ProductVariancePopulationAggregates>;
  ProductVarianceSampleAggregateFilter: ProductVarianceSampleAggregateFilter;
  ProductVarianceSampleAggregates: ResolverTypeWrapper<ProductVarianceSampleAggregates>;
  ProfileReport: ResolverTypeWrapper<ProfileReport>;
  ProfileReportAggregates: ResolverTypeWrapper<ProfileReportAggregates>;
  ProfileReportAggregatesFilter: ProfileReportAggregatesFilter;
  ProfileReportAverageAggregateFilter: ProfileReportAverageAggregateFilter;
  ProfileReportAverageAggregates: ResolverTypeWrapper<ProfileReportAverageAggregates>;
  ProfileReportCondition: ProfileReportCondition;
  ProfileReportConnection: ResolverTypeWrapper<ProfileReportConnection>;
  ProfileReportDistinctCountAggregateFilter: ProfileReportDistinctCountAggregateFilter;
  ProfileReportDistinctCountAggregates: ResolverTypeWrapper<ProfileReportDistinctCountAggregates>;
  ProfileReportEdge: ResolverTypeWrapper<ProfileReportEdge>;
  ProfileReportFilter: ProfileReportFilter;
  ProfileReportGroupBy: ProfileReportGroupBy;
  ProfileReportHavingAverageInput: ProfileReportHavingAverageInput;
  ProfileReportHavingDistinctCountInput: ProfileReportHavingDistinctCountInput;
  ProfileReportHavingInput: ProfileReportHavingInput;
  ProfileReportHavingMaxInput: ProfileReportHavingMaxInput;
  ProfileReportHavingMinInput: ProfileReportHavingMinInput;
  ProfileReportHavingStddevPopulationInput: ProfileReportHavingStddevPopulationInput;
  ProfileReportHavingStddevSampleInput: ProfileReportHavingStddevSampleInput;
  ProfileReportHavingSumInput: ProfileReportHavingSumInput;
  ProfileReportHavingVariancePopulationInput: ProfileReportHavingVariancePopulationInput;
  ProfileReportHavingVarianceSampleInput: ProfileReportHavingVarianceSampleInput;
  ProfileReportMaxAggregateFilter: ProfileReportMaxAggregateFilter;
  ProfileReportMaxAggregates: ResolverTypeWrapper<ProfileReportMaxAggregates>;
  ProfileReportMinAggregateFilter: ProfileReportMinAggregateFilter;
  ProfileReportMinAggregates: ResolverTypeWrapper<ProfileReportMinAggregates>;
  ProfileReportOrderBy: ProfileReportOrderBy;
  ProfileReportStatusEnum: ProfileReportStatusEnum;
  ProfileReportStddevPopulationAggregateFilter: ProfileReportStddevPopulationAggregateFilter;
  ProfileReportStddevPopulationAggregates: ResolverTypeWrapper<ProfileReportStddevPopulationAggregates>;
  ProfileReportStddevSampleAggregateFilter: ProfileReportStddevSampleAggregateFilter;
  ProfileReportStddevSampleAggregates: ResolverTypeWrapper<ProfileReportStddevSampleAggregates>;
  ProfileReportSumAggregateFilter: ProfileReportSumAggregateFilter;
  ProfileReportSumAggregates: ResolverTypeWrapper<ProfileReportSumAggregates>;
  ProfileReportVariancePopulationAggregateFilter: ProfileReportVariancePopulationAggregateFilter;
  ProfileReportVariancePopulationAggregates: ResolverTypeWrapper<ProfileReportVariancePopulationAggregates>;
  ProfileReportVarianceSampleAggregateFilter: ProfileReportVarianceSampleAggregateFilter;
  ProfileReportVarianceSampleAggregates: ResolverTypeWrapper<ProfileReportVarianceSampleAggregates>;
  Purchase: ResolverTypeWrapper<Purchase>;
  PurchaseAggregates: ResolverTypeWrapper<PurchaseAggregates>;
  PurchaseAverageAggregates: ResolverTypeWrapper<PurchaseAverageAggregates>;
  PurchaseCondition: PurchaseCondition;
  PurchaseConnection: ResolverTypeWrapper<PurchaseConnection>;
  PurchaseDistinctCountAggregates: ResolverTypeWrapper<PurchaseDistinctCountAggregates>;
  PurchaseEdge: ResolverTypeWrapper<PurchaseEdge>;
  PurchaseFilter: PurchaseFilter;
  PurchaseGroupBy: PurchaseGroupBy;
  PurchaseHavingAverageInput: PurchaseHavingAverageInput;
  PurchaseHavingDistinctCountInput: PurchaseHavingDistinctCountInput;
  PurchaseHavingInput: PurchaseHavingInput;
  PurchaseHavingMaxInput: PurchaseHavingMaxInput;
  PurchaseHavingMinInput: PurchaseHavingMinInput;
  PurchaseHavingStddevPopulationInput: PurchaseHavingStddevPopulationInput;
  PurchaseHavingStddevSampleInput: PurchaseHavingStddevSampleInput;
  PurchaseHavingSumInput: PurchaseHavingSumInput;
  PurchaseHavingVariancePopulationInput: PurchaseHavingVariancePopulationInput;
  PurchaseHavingVarianceSampleInput: PurchaseHavingVarianceSampleInput;
  PurchaseItem: ResolverTypeWrapper<PurchaseItem>;
  PurchaseItemAggregates: ResolverTypeWrapper<PurchaseItemAggregates>;
  PurchaseItemAggregatesFilter: PurchaseItemAggregatesFilter;
  PurchaseItemAverageAggregateFilter: PurchaseItemAverageAggregateFilter;
  PurchaseItemAverageAggregates: ResolverTypeWrapper<PurchaseItemAverageAggregates>;
  PurchaseItemCondition: PurchaseItemCondition;
  PurchaseItemConnection: ResolverTypeWrapper<PurchaseItemConnection>;
  PurchaseItemDistinctCountAggregateFilter: PurchaseItemDistinctCountAggregateFilter;
  PurchaseItemDistinctCountAggregates: ResolverTypeWrapper<PurchaseItemDistinctCountAggregates>;
  PurchaseItemEdge: ResolverTypeWrapper<PurchaseItemEdge>;
  PurchaseItemFilter: PurchaseItemFilter;
  PurchaseItemGroupBy: PurchaseItemGroupBy;
  PurchaseItemHavingAverageInput: PurchaseItemHavingAverageInput;
  PurchaseItemHavingDistinctCountInput: PurchaseItemHavingDistinctCountInput;
  PurchaseItemHavingInput: PurchaseItemHavingInput;
  PurchaseItemHavingMaxInput: PurchaseItemHavingMaxInput;
  PurchaseItemHavingMinInput: PurchaseItemHavingMinInput;
  PurchaseItemHavingStddevPopulationInput: PurchaseItemHavingStddevPopulationInput;
  PurchaseItemHavingStddevSampleInput: PurchaseItemHavingStddevSampleInput;
  PurchaseItemHavingSumInput: PurchaseItemHavingSumInput;
  PurchaseItemHavingVariancePopulationInput: PurchaseItemHavingVariancePopulationInput;
  PurchaseItemHavingVarianceSampleInput: PurchaseItemHavingVarianceSampleInput;
  PurchaseItemMaxAggregateFilter: PurchaseItemMaxAggregateFilter;
  PurchaseItemMaxAggregates: ResolverTypeWrapper<PurchaseItemMaxAggregates>;
  PurchaseItemMinAggregateFilter: PurchaseItemMinAggregateFilter;
  PurchaseItemMinAggregates: ResolverTypeWrapper<PurchaseItemMinAggregates>;
  PurchaseItemOrderBy: PurchaseItemOrderBy;
  PurchaseItemStddevPopulationAggregateFilter: PurchaseItemStddevPopulationAggregateFilter;
  PurchaseItemStddevPopulationAggregates: ResolverTypeWrapper<PurchaseItemStddevPopulationAggregates>;
  PurchaseItemStddevSampleAggregateFilter: PurchaseItemStddevSampleAggregateFilter;
  PurchaseItemStddevSampleAggregates: ResolverTypeWrapper<PurchaseItemStddevSampleAggregates>;
  PurchaseItemSumAggregateFilter: PurchaseItemSumAggregateFilter;
  PurchaseItemSumAggregates: ResolverTypeWrapper<PurchaseItemSumAggregates>;
  PurchaseItemVariancePopulationAggregateFilter: PurchaseItemVariancePopulationAggregateFilter;
  PurchaseItemVariancePopulationAggregates: ResolverTypeWrapper<PurchaseItemVariancePopulationAggregates>;
  PurchaseItemVarianceSampleAggregateFilter: PurchaseItemVarianceSampleAggregateFilter;
  PurchaseItemVarianceSampleAggregates: ResolverTypeWrapper<PurchaseItemVarianceSampleAggregates>;
  PurchaseMaxAggregates: ResolverTypeWrapper<PurchaseMaxAggregates>;
  PurchaseMinAggregates: ResolverTypeWrapper<PurchaseMinAggregates>;
  PurchaseOrder: ResolverTypeWrapper<PurchaseOrder>;
  PurchaseOrderAggregates: ResolverTypeWrapper<PurchaseOrderAggregates>;
  PurchaseOrderAggregatesFilter: PurchaseOrderAggregatesFilter;
  PurchaseOrderAverageAggregateFilter: PurchaseOrderAverageAggregateFilter;
  PurchaseOrderAverageAggregates: ResolverTypeWrapper<PurchaseOrderAverageAggregates>;
  PurchaseOrderBy: PurchaseOrderBy;
  PurchaseOrderCondition: PurchaseOrderCondition;
  PurchaseOrderConnection: ResolverTypeWrapper<PurchaseOrderConnection>;
  PurchaseOrderDistinctCountAggregateFilter: PurchaseOrderDistinctCountAggregateFilter;
  PurchaseOrderDistinctCountAggregates: ResolverTypeWrapper<PurchaseOrderDistinctCountAggregates>;
  PurchaseOrderEdge: ResolverTypeWrapper<PurchaseOrderEdge>;
  PurchaseOrderFilter: PurchaseOrderFilter;
  PurchaseOrderGroupBy: PurchaseOrderGroupBy;
  PurchaseOrderHavingAverageInput: PurchaseOrderHavingAverageInput;
  PurchaseOrderHavingDistinctCountInput: PurchaseOrderHavingDistinctCountInput;
  PurchaseOrderHavingInput: PurchaseOrderHavingInput;
  PurchaseOrderHavingMaxInput: PurchaseOrderHavingMaxInput;
  PurchaseOrderHavingMinInput: PurchaseOrderHavingMinInput;
  PurchaseOrderHavingStddevPopulationInput: PurchaseOrderHavingStddevPopulationInput;
  PurchaseOrderHavingStddevSampleInput: PurchaseOrderHavingStddevSampleInput;
  PurchaseOrderHavingSumInput: PurchaseOrderHavingSumInput;
  PurchaseOrderHavingVariancePopulationInput: PurchaseOrderHavingVariancePopulationInput;
  PurchaseOrderHavingVarianceSampleInput: PurchaseOrderHavingVarianceSampleInput;
  PurchaseOrderMaxAggregateFilter: PurchaseOrderMaxAggregateFilter;
  PurchaseOrderMaxAggregates: ResolverTypeWrapper<PurchaseOrderMaxAggregates>;
  PurchaseOrderMinAggregateFilter: PurchaseOrderMinAggregateFilter;
  PurchaseOrderMinAggregates: ResolverTypeWrapper<PurchaseOrderMinAggregates>;
  PurchaseOrderOrderBy: PurchaseOrderOrderBy;
  PurchaseOrderReceipt: ResolverTypeWrapper<PurchaseOrderReceipt>;
  PurchaseOrderStddevPopulationAggregateFilter: PurchaseOrderStddevPopulationAggregateFilter;
  PurchaseOrderStddevPopulationAggregates: ResolverTypeWrapper<PurchaseOrderStddevPopulationAggregates>;
  PurchaseOrderStddevSampleAggregateFilter: PurchaseOrderStddevSampleAggregateFilter;
  PurchaseOrderStddevSampleAggregates: ResolverTypeWrapper<PurchaseOrderStddevSampleAggregates>;
  PurchaseOrderSumAggregateFilter: PurchaseOrderSumAggregateFilter;
  PurchaseOrderSumAggregates: ResolverTypeWrapper<PurchaseOrderSumAggregates>;
  PurchaseOrderToManyChargebackFilter: PurchaseOrderToManyChargebackFilter;
  PurchaseOrderToManyChargebackIndicatorFilter: PurchaseOrderToManyChargebackIndicatorFilter;
  PurchaseOrderToManyPurchaseItemFilter: PurchaseOrderToManyPurchaseItemFilter;
  PurchaseOrderToManyRefundFilter: PurchaseOrderToManyRefundFilter;
  PurchaseOrderVariancePopulationAggregateFilter: PurchaseOrderVariancePopulationAggregateFilter;
  PurchaseOrderVariancePopulationAggregates: ResolverTypeWrapper<PurchaseOrderVariancePopulationAggregates>;
  PurchaseOrderVarianceSampleAggregateFilter: PurchaseOrderVarianceSampleAggregateFilter;
  PurchaseOrderVarianceSampleAggregates: ResolverTypeWrapper<PurchaseOrderVarianceSampleAggregates>;
  PurchaseStddevPopulationAggregates: ResolverTypeWrapper<PurchaseStddevPopulationAggregates>;
  PurchaseStddevSampleAggregates: ResolverTypeWrapper<PurchaseStddevSampleAggregates>;
  PurchaseSumAggregates: ResolverTypeWrapper<PurchaseSumAggregates>;
  PurchaseVariancePopulationAggregates: ResolverTypeWrapper<PurchaseVariancePopulationAggregates>;
  PurchaseVarianceSampleAggregates: ResolverTypeWrapper<PurchaseVarianceSampleAggregates>;
  Query: ResolverTypeWrapper<{}>;
  ReasonCode: ResolverTypeWrapper<ReasonCode>;
  ReasonCodeAggregates: ResolverTypeWrapper<ReasonCodeAggregates>;
  ReasonCodeAverageAggregates: ResolverTypeWrapper<ReasonCodeAverageAggregates>;
  ReasonCodeCondition: ReasonCodeCondition;
  ReasonCodeConnection: ResolverTypeWrapper<ReasonCodeConnection>;
  ReasonCodeDistinctCountAggregates: ResolverTypeWrapper<ReasonCodeDistinctCountAggregates>;
  ReasonCodeEdge: ResolverTypeWrapper<ReasonCodeEdge>;
  ReasonCodeFilter: ReasonCodeFilter;
  ReasonCodeMaxAggregates: ResolverTypeWrapper<ReasonCodeMaxAggregates>;
  ReasonCodeMinAggregates: ResolverTypeWrapper<ReasonCodeMinAggregates>;
  ReasonCodeOrderBy: ReasonCodeOrderBy;
  ReasonCodeStddevPopulationAggregates: ResolverTypeWrapper<ReasonCodeStddevPopulationAggregates>;
  ReasonCodeStddevSampleAggregates: ResolverTypeWrapper<ReasonCodeStddevSampleAggregates>;
  ReasonCodeSumAggregates: ResolverTypeWrapper<ReasonCodeSumAggregates>;
  ReasonCodeVariancePopulationAggregates: ResolverTypeWrapper<ReasonCodeVariancePopulationAggregates>;
  ReasonCodeVarianceSampleAggregates: ResolverTypeWrapper<ReasonCodeVarianceSampleAggregates>;
  RebillSession: ResolverTypeWrapper<RebillSession>;
  RebillSessionAggregates: ResolverTypeWrapper<RebillSessionAggregates>;
  RebillSessionAggregatesFilter: RebillSessionAggregatesFilter;
  RebillSessionAverageAggregateFilter: RebillSessionAverageAggregateFilter;
  RebillSessionAverageAggregates: ResolverTypeWrapper<RebillSessionAverageAggregates>;
  RebillSessionCondition: RebillSessionCondition;
  RebillSessionConnection: ResolverTypeWrapper<RebillSessionConnection>;
  RebillSessionDistinctCountAggregateFilter: RebillSessionDistinctCountAggregateFilter;
  RebillSessionDistinctCountAggregates: ResolverTypeWrapper<RebillSessionDistinctCountAggregates>;
  RebillSessionEdge: ResolverTypeWrapper<RebillSessionEdge>;
  RebillSessionFilter: RebillSessionFilter;
  RebillSessionGroupBy: RebillSessionGroupBy;
  RebillSessionHavingAverageInput: RebillSessionHavingAverageInput;
  RebillSessionHavingDistinctCountInput: RebillSessionHavingDistinctCountInput;
  RebillSessionHavingInput: RebillSessionHavingInput;
  RebillSessionHavingMaxInput: RebillSessionHavingMaxInput;
  RebillSessionHavingMinInput: RebillSessionHavingMinInput;
  RebillSessionHavingStddevPopulationInput: RebillSessionHavingStddevPopulationInput;
  RebillSessionHavingStddevSampleInput: RebillSessionHavingStddevSampleInput;
  RebillSessionHavingSumInput: RebillSessionHavingSumInput;
  RebillSessionHavingVariancePopulationInput: RebillSessionHavingVariancePopulationInput;
  RebillSessionHavingVarianceSampleInput: RebillSessionHavingVarianceSampleInput;
  RebillSessionMaxAggregateFilter: RebillSessionMaxAggregateFilter;
  RebillSessionMaxAggregates: ResolverTypeWrapper<RebillSessionMaxAggregates>;
  RebillSessionMinAggregateFilter: RebillSessionMinAggregateFilter;
  RebillSessionMinAggregates: ResolverTypeWrapper<RebillSessionMinAggregates>;
  RebillSessionOrderBy: RebillSessionOrderBy;
  RebillSessionRebillManagerEnum: RebillSessionRebillManagerEnum;
  RebillSessionRebillManagerEnumFilter: RebillSessionRebillManagerEnumFilter;
  RebillSessionStatusEnum: RebillSessionStatusEnum;
  RebillSessionStatusEnumFilter: RebillSessionStatusEnumFilter;
  RebillSessionStddevPopulationAggregateFilter: RebillSessionStddevPopulationAggregateFilter;
  RebillSessionStddevPopulationAggregates: ResolverTypeWrapper<RebillSessionStddevPopulationAggregates>;
  RebillSessionStddevSampleAggregateFilter: RebillSessionStddevSampleAggregateFilter;
  RebillSessionStddevSampleAggregates: ResolverTypeWrapper<RebillSessionStddevSampleAggregates>;
  RebillSessionSumAggregateFilter: RebillSessionSumAggregateFilter;
  RebillSessionSumAggregates: ResolverTypeWrapper<RebillSessionSumAggregates>;
  RebillSessionVariancePopulationAggregateFilter: RebillSessionVariancePopulationAggregateFilter;
  RebillSessionVariancePopulationAggregates: ResolverTypeWrapper<RebillSessionVariancePopulationAggregates>;
  RebillSessionVarianceSampleAggregateFilter: RebillSessionVarianceSampleAggregateFilter;
  RebillSessionVarianceSampleAggregates: ResolverTypeWrapper<RebillSessionVarianceSampleAggregates>;
  RecordLfaSplashViewInput: RecordLfaSplashViewInput;
  RecordLfaSplashViewPayload: ResolverTypeWrapper<RecordLfaSplashViewPayload>;
  RecordReflectionViewInput: RecordReflectionViewInput;
  RecordReflectionViewPayload: ResolverTypeWrapper<RecordReflectionViewPayload>;
  ReferralPurchase: ResolverTypeWrapper<ReferralPurchase>;
  ReferralReward: ResolverTypeWrapper<ReferralReward>;
  Refund: ResolverTypeWrapper<Refund>;
  RefundAggregates: ResolverTypeWrapper<RefundAggregates>;
  RefundAggregatesFilter: RefundAggregatesFilter;
  RefundAverageAggregateFilter: RefundAverageAggregateFilter;
  RefundAverageAggregates: ResolverTypeWrapper<RefundAverageAggregates>;
  RefundCondition: RefundCondition;
  RefundConnection: ResolverTypeWrapper<RefundConnection>;
  RefundDistinctCountAggregateFilter: RefundDistinctCountAggregateFilter;
  RefundDistinctCountAggregates: ResolverTypeWrapper<RefundDistinctCountAggregates>;
  RefundEdge: ResolverTypeWrapper<RefundEdge>;
  RefundFilter: RefundFilter;
  RefundGroupBy: RefundGroupBy;
  RefundHavingAverageInput: RefundHavingAverageInput;
  RefundHavingDistinctCountInput: RefundHavingDistinctCountInput;
  RefundHavingInput: RefundHavingInput;
  RefundHavingMaxInput: RefundHavingMaxInput;
  RefundHavingMinInput: RefundHavingMinInput;
  RefundHavingStddevPopulationInput: RefundHavingStddevPopulationInput;
  RefundHavingStddevSampleInput: RefundHavingStddevSampleInput;
  RefundHavingSumInput: RefundHavingSumInput;
  RefundHavingVariancePopulationInput: RefundHavingVariancePopulationInput;
  RefundHavingVarianceSampleInput: RefundHavingVarianceSampleInput;
  RefundMaxAggregateFilter: RefundMaxAggregateFilter;
  RefundMaxAggregates: ResolverTypeWrapper<RefundMaxAggregates>;
  RefundMinAggregateFilter: RefundMinAggregateFilter;
  RefundMinAggregates: ResolverTypeWrapper<RefundMinAggregates>;
  RefundOrderBy: RefundOrderBy;
  RefundStddevPopulationAggregateFilter: RefundStddevPopulationAggregateFilter;
  RefundStddevPopulationAggregates: ResolverTypeWrapper<RefundStddevPopulationAggregates>;
  RefundStddevSampleAggregateFilter: RefundStddevSampleAggregateFilter;
  RefundStddevSampleAggregates: ResolverTypeWrapper<RefundStddevSampleAggregates>;
  RefundSumAggregateFilter: RefundSumAggregateFilter;
  RefundSumAggregates: ResolverTypeWrapper<RefundSumAggregates>;
  RefundVariancePopulationAggregateFilter: RefundVariancePopulationAggregateFilter;
  RefundVariancePopulationAggregates: ResolverTypeWrapper<RefundVariancePopulationAggregates>;
  RefundVarianceSampleAggregateFilter: RefundVarianceSampleAggregateFilter;
  RefundVarianceSampleAggregates: ResolverTypeWrapper<RefundVarianceSampleAggregates>;
  RegistrationRiskAssessment: ResolverTypeWrapper<RegistrationRiskAssessment>;
  RegistrationRiskAssessmentFilter: RegistrationRiskAssessmentFilter;
  ResetCredit: ResolverTypeWrapper<ResetCredit>;
  ResetCreditAggregates: ResolverTypeWrapper<ResetCreditAggregates>;
  ResetCreditAggregatesFilter: ResetCreditAggregatesFilter;
  ResetCreditAverageAggregateFilter: ResetCreditAverageAggregateFilter;
  ResetCreditAverageAggregates: ResolverTypeWrapper<ResetCreditAverageAggregates>;
  ResetCreditCondition: ResetCreditCondition;
  ResetCreditConnection: ResolverTypeWrapper<ResetCreditConnection>;
  ResetCreditDistinctCountAggregateFilter: ResetCreditDistinctCountAggregateFilter;
  ResetCreditDistinctCountAggregates: ResolverTypeWrapper<ResetCreditDistinctCountAggregates>;
  ResetCreditEdge: ResolverTypeWrapper<ResetCreditEdge>;
  ResetCreditFilter: ResetCreditFilter;
  ResetCreditGrant: ResolverTypeWrapper<ResetCreditGrant>;
  ResetCreditGroupBy: ResetCreditGroupBy;
  ResetCreditHavingAverageInput: ResetCreditHavingAverageInput;
  ResetCreditHavingDistinctCountInput: ResetCreditHavingDistinctCountInput;
  ResetCreditHavingInput: ResetCreditHavingInput;
  ResetCreditHavingMaxInput: ResetCreditHavingMaxInput;
  ResetCreditHavingMinInput: ResetCreditHavingMinInput;
  ResetCreditHavingStddevPopulationInput: ResetCreditHavingStddevPopulationInput;
  ResetCreditHavingStddevSampleInput: ResetCreditHavingStddevSampleInput;
  ResetCreditHavingSumInput: ResetCreditHavingSumInput;
  ResetCreditHavingVariancePopulationInput: ResetCreditHavingVariancePopulationInput;
  ResetCreditHavingVarianceSampleInput: ResetCreditHavingVarianceSampleInput;
  ResetCreditMaxAggregateFilter: ResetCreditMaxAggregateFilter;
  ResetCreditMaxAggregates: ResolverTypeWrapper<ResetCreditMaxAggregates>;
  ResetCreditMinAggregateFilter: ResetCreditMinAggregateFilter;
  ResetCreditMinAggregates: ResolverTypeWrapper<ResetCreditMinAggregates>;
  ResetCreditOrderBy: ResetCreditOrderBy;
  ResetCreditStddevPopulationAggregateFilter: ResetCreditStddevPopulationAggregateFilter;
  ResetCreditStddevPopulationAggregates: ResolverTypeWrapper<ResetCreditStddevPopulationAggregates>;
  ResetCreditStddevSampleAggregateFilter: ResetCreditStddevSampleAggregateFilter;
  ResetCreditStddevSampleAggregates: ResolverTypeWrapper<ResetCreditStddevSampleAggregates>;
  ResetCreditSumAggregateFilter: ResetCreditSumAggregateFilter;
  ResetCreditSumAggregates: ResolverTypeWrapper<ResetCreditSumAggregates>;
  ResetCreditVariancePopulationAggregateFilter: ResetCreditVariancePopulationAggregateFilter;
  ResetCreditVariancePopulationAggregates: ResolverTypeWrapper<ResetCreditVariancePopulationAggregates>;
  ResetCreditVarianceSampleAggregateFilter: ResetCreditVarianceSampleAggregateFilter;
  ResetCreditVarianceSampleAggregates: ResolverTypeWrapper<ResetCreditVarianceSampleAggregates>;
  RevokeUserTaxFormValidationBypassInput: RevokeUserTaxFormValidationBypassInput;
  RevokeUserTaxFormValidationBypassResult: ResolverTypeWrapper<RevokeUserTaxFormValidationBypassResult>;
  RiskyProduct: ResolverTypeWrapper<RiskyProduct>;
  RiskyProductAggregates: ResolverTypeWrapper<RiskyProductAggregates>;
  RiskyProductAverageAggregates: ResolverTypeWrapper<RiskyProductAverageAggregates>;
  RiskyProductCondition: RiskyProductCondition;
  RiskyProductConnection: ResolverTypeWrapper<RiskyProductConnection>;
  RiskyProductDistinctCountAggregates: ResolverTypeWrapper<RiskyProductDistinctCountAggregates>;
  RiskyProductEdge: ResolverTypeWrapper<RiskyProductEdge>;
  RiskyProductFilter: RiskyProductFilter;
  RiskyProductMaxAggregates: ResolverTypeWrapper<RiskyProductMaxAggregates>;
  RiskyProductMinAggregates: ResolverTypeWrapper<RiskyProductMinAggregates>;
  RiskyProductOrderBy: RiskyProductOrderBy;
  RiskyProductStddevPopulationAggregates: ResolverTypeWrapper<RiskyProductStddevPopulationAggregates>;
  RiskyProductStddevSampleAggregates: ResolverTypeWrapper<RiskyProductStddevSampleAggregates>;
  RiskyProductSumAggregates: ResolverTypeWrapper<RiskyProductSumAggregates>;
  RiskyProductVariancePopulationAggregates: ResolverTypeWrapper<RiskyProductVariancePopulationAggregates>;
  RiskyProductVarianceSampleAggregates: ResolverTypeWrapper<RiskyProductVarianceSampleAggregates>;
  SavedCard: ResolverTypeWrapper<SavedCard>;
  SavedCardAggregates: ResolverTypeWrapper<SavedCardAggregates>;
  SavedCardAggregatesFilter: SavedCardAggregatesFilter;
  SavedCardAverageAggregateFilter: SavedCardAverageAggregateFilter;
  SavedCardAverageAggregates: ResolverTypeWrapper<SavedCardAverageAggregates>;
  SavedCardCondition: SavedCardCondition;
  SavedCardConnection: ResolverTypeWrapper<SavedCardConnection>;
  SavedCardDistinctCountAggregateFilter: SavedCardDistinctCountAggregateFilter;
  SavedCardDistinctCountAggregates: ResolverTypeWrapper<SavedCardDistinctCountAggregates>;
  SavedCardEdge: ResolverTypeWrapper<SavedCardEdge>;
  SavedCardFilter: SavedCardFilter;
  SavedCardGroupBy: SavedCardGroupBy;
  SavedCardHavingAverageInput: SavedCardHavingAverageInput;
  SavedCardHavingDistinctCountInput: SavedCardHavingDistinctCountInput;
  SavedCardHavingInput: SavedCardHavingInput;
  SavedCardHavingMaxInput: SavedCardHavingMaxInput;
  SavedCardHavingMinInput: SavedCardHavingMinInput;
  SavedCardHavingStddevPopulationInput: SavedCardHavingStddevPopulationInput;
  SavedCardHavingStddevSampleInput: SavedCardHavingStddevSampleInput;
  SavedCardHavingSumInput: SavedCardHavingSumInput;
  SavedCardHavingVariancePopulationInput: SavedCardHavingVariancePopulationInput;
  SavedCardHavingVarianceSampleInput: SavedCardHavingVarianceSampleInput;
  SavedCardMaxAggregateFilter: SavedCardMaxAggregateFilter;
  SavedCardMaxAggregates: ResolverTypeWrapper<SavedCardMaxAggregates>;
  SavedCardMinAggregateFilter: SavedCardMinAggregateFilter;
  SavedCardMinAggregates: ResolverTypeWrapper<SavedCardMinAggregates>;
  SavedCardOrderBy: SavedCardOrderBy;
  SavedCardStddevPopulationAggregateFilter: SavedCardStddevPopulationAggregateFilter;
  SavedCardStddevPopulationAggregates: ResolverTypeWrapper<SavedCardStddevPopulationAggregates>;
  SavedCardStddevSampleAggregateFilter: SavedCardStddevSampleAggregateFilter;
  SavedCardStddevSampleAggregates: ResolverTypeWrapper<SavedCardStddevSampleAggregates>;
  SavedCardSumAggregateFilter: SavedCardSumAggregateFilter;
  SavedCardSumAggregates: ResolverTypeWrapper<SavedCardSumAggregates>;
  SavedCardToManyNmiSubscriptionFilter: SavedCardToManyNmiSubscriptionFilter;
  SavedCardVariancePopulationAggregateFilter: SavedCardVariancePopulationAggregateFilter;
  SavedCardVariancePopulationAggregates: ResolverTypeWrapper<SavedCardVariancePopulationAggregates>;
  SavedCardVarianceSampleAggregateFilter: SavedCardVarianceSampleAggregateFilter;
  SavedCardVarianceSampleAggregates: ResolverTypeWrapper<SavedCardVarianceSampleAggregates>;
  SetCaseBanPendingStatusInput: SetCaseBanPendingStatusInput;
  SetCaseBanTraderIdvLinkInput: SetCaseBanTraderIdvLinkInput;
  SetCaseBanTraderIntercomLinkInput: SetCaseBanTraderIntercomLinkInput;
  SetCaseInvestigationPendingStatusInput: SetCaseInvestigationPendingStatusInput;
  SetCaseInvestigationTraderIdvLinkInput: SetCaseInvestigationTraderIdvLinkInput;
  SetCaseInvestigationTraderIntercomLinkInput: SetCaseInvestigationTraderIntercomLinkInput;
  SkuAccountDetails: ResolverTypeWrapper<SkuAccountDetails>;
  SkuAccountProvisioningClaim: ResolverTypeWrapper<SkuAccountProvisioningClaim>;
  SkuInventory: ResolverTypeWrapper<SkuInventory>;
  StartW8BENSigningInput: StartW8BenSigningInput;
  StartW9SigningInput: StartW9SigningInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StringFilter: StringFilter;
  StringListFilter: StringListFilter;
  SubmitCaseBanInput: SubmitCaseBanInput;
  SubscriptionDunning: ResolverTypeWrapper<SubscriptionDunning>;
  SyncDiscordRolesPayload: ResolverTypeWrapper<SyncDiscordRolesPayload>;
  SyncState: ResolverTypeWrapper<SyncState>;
  TaxFormDocumentResult: ResolverTypeWrapper<TaxFormDocumentResult>;
  TaxFormTypeEnum: TaxFormTypeEnum;
  TaxInfo: ResolverTypeWrapper<TaxInfo>;
  TaxInfoAggregates: ResolverTypeWrapper<TaxInfoAggregates>;
  TaxInfoAggregatesFilter: TaxInfoAggregatesFilter;
  TaxInfoAverageAggregateFilter: TaxInfoAverageAggregateFilter;
  TaxInfoAverageAggregates: ResolverTypeWrapper<TaxInfoAverageAggregates>;
  TaxInfoCondition: TaxInfoCondition;
  TaxInfoConnection: ResolverTypeWrapper<TaxInfoConnection>;
  TaxInfoDistinctCountAggregateFilter: TaxInfoDistinctCountAggregateFilter;
  TaxInfoDistinctCountAggregates: ResolverTypeWrapper<TaxInfoDistinctCountAggregates>;
  TaxInfoEdge: ResolverTypeWrapper<TaxInfoEdge>;
  TaxInfoFilter: TaxInfoFilter;
  TaxInfoGroupBy: TaxInfoGroupBy;
  TaxInfoHavingAverageInput: TaxInfoHavingAverageInput;
  TaxInfoHavingDistinctCountInput: TaxInfoHavingDistinctCountInput;
  TaxInfoHavingInput: TaxInfoHavingInput;
  TaxInfoHavingMaxInput: TaxInfoHavingMaxInput;
  TaxInfoHavingMinInput: TaxInfoHavingMinInput;
  TaxInfoHavingStddevPopulationInput: TaxInfoHavingStddevPopulationInput;
  TaxInfoHavingStddevSampleInput: TaxInfoHavingStddevSampleInput;
  TaxInfoHavingSumInput: TaxInfoHavingSumInput;
  TaxInfoHavingVariancePopulationInput: TaxInfoHavingVariancePopulationInput;
  TaxInfoHavingVarianceSampleInput: TaxInfoHavingVarianceSampleInput;
  TaxInfoMaxAggregateFilter: TaxInfoMaxAggregateFilter;
  TaxInfoMaxAggregates: ResolverTypeWrapper<TaxInfoMaxAggregates>;
  TaxInfoMinAggregateFilter: TaxInfoMinAggregateFilter;
  TaxInfoMinAggregates: ResolverTypeWrapper<TaxInfoMinAggregates>;
  TaxInfoOrderBy: TaxInfoOrderBy;
  TaxInfoStddevPopulationAggregateFilter: TaxInfoStddevPopulationAggregateFilter;
  TaxInfoStddevPopulationAggregates: ResolverTypeWrapper<TaxInfoStddevPopulationAggregates>;
  TaxInfoStddevSampleAggregateFilter: TaxInfoStddevSampleAggregateFilter;
  TaxInfoStddevSampleAggregates: ResolverTypeWrapper<TaxInfoStddevSampleAggregates>;
  TaxInfoSumAggregateFilter: TaxInfoSumAggregateFilter;
  TaxInfoSumAggregates: ResolverTypeWrapper<TaxInfoSumAggregates>;
  TaxInfoVariancePopulationAggregateFilter: TaxInfoVariancePopulationAggregateFilter;
  TaxInfoVariancePopulationAggregates: ResolverTypeWrapper<TaxInfoVariancePopulationAggregates>;
  TaxInfoVarianceSampleAggregateFilter: TaxInfoVarianceSampleAggregateFilter;
  TaxInfoVarianceSampleAggregates: ResolverTypeWrapper<TaxInfoVarianceSampleAggregates>;
  Trade: ResolverTypeWrapper<Trade>;
  TradedProductLots: ResolverTypeWrapper<TradedProductLots>;
  TraderAffiliateStatus: TraderAffiliateStatus;
  TraderLockDetail: ResolverTypeWrapper<TraderLockDetail>;
  TraderLockDetailFilter: TraderLockDetailFilter;
  TraderOpenCase: ResolverTypeWrapper<TraderOpenCase>;
  TraderOpenCaseKind: TraderOpenCaseKind;
  TraderPayoutNote: ResolverTypeWrapper<TraderPayoutNote>;
  TraderProfileAsset: ResolverTypeWrapper<TraderProfileAsset>;
  TraderProfileAssetFilter: TraderProfileAssetFilter;
  TraderProfileAssetKindEnum: TraderProfileAssetKindEnum;
  TraderProfileAssetToManyTraderPublicProfileFilter: TraderProfileAssetToManyTraderPublicProfileFilter;
  TraderProfileModerationBlockedWord: ResolverTypeWrapper<TraderProfileModerationBlockedWord>;
  TraderProfileModerationCase: ResolverTypeWrapper<TraderProfileModerationCase>;
  TraderProfileModerationCaseAggregates: ResolverTypeWrapper<TraderProfileModerationCaseAggregates>;
  TraderProfileModerationCaseAggregatesFilter: TraderProfileModerationCaseAggregatesFilter;
  TraderProfileModerationCaseAverageAggregateFilter: TraderProfileModerationCaseAverageAggregateFilter;
  TraderProfileModerationCaseAverageAggregates: ResolverTypeWrapper<TraderProfileModerationCaseAverageAggregates>;
  TraderProfileModerationCaseCondition: TraderProfileModerationCaseCondition;
  TraderProfileModerationCaseConnection: ResolverTypeWrapper<TraderProfileModerationCaseConnection>;
  TraderProfileModerationCaseDistinctCountAggregateFilter: TraderProfileModerationCaseDistinctCountAggregateFilter;
  TraderProfileModerationCaseDistinctCountAggregates: ResolverTypeWrapper<TraderProfileModerationCaseDistinctCountAggregates>;
  TraderProfileModerationCaseEdge: ResolverTypeWrapper<TraderProfileModerationCaseEdge>;
  TraderProfileModerationCaseFilter: TraderProfileModerationCaseFilter;
  TraderProfileModerationCaseGroupBy: TraderProfileModerationCaseGroupBy;
  TraderProfileModerationCaseHavingAverageInput: TraderProfileModerationCaseHavingAverageInput;
  TraderProfileModerationCaseHavingDistinctCountInput: TraderProfileModerationCaseHavingDistinctCountInput;
  TraderProfileModerationCaseHavingInput: TraderProfileModerationCaseHavingInput;
  TraderProfileModerationCaseHavingMaxInput: TraderProfileModerationCaseHavingMaxInput;
  TraderProfileModerationCaseHavingMinInput: TraderProfileModerationCaseHavingMinInput;
  TraderProfileModerationCaseHavingStddevPopulationInput: TraderProfileModerationCaseHavingStddevPopulationInput;
  TraderProfileModerationCaseHavingStddevSampleInput: TraderProfileModerationCaseHavingStddevSampleInput;
  TraderProfileModerationCaseHavingSumInput: TraderProfileModerationCaseHavingSumInput;
  TraderProfileModerationCaseHavingVariancePopulationInput: TraderProfileModerationCaseHavingVariancePopulationInput;
  TraderProfileModerationCaseHavingVarianceSampleInput: TraderProfileModerationCaseHavingVarianceSampleInput;
  TraderProfileModerationCaseHistory: ResolverTypeWrapper<TraderProfileModerationCaseHistory>;
  TraderProfileModerationCaseHistoryAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryAggregates>;
  TraderProfileModerationCaseHistoryAggregatesFilter: TraderProfileModerationCaseHistoryAggregatesFilter;
  TraderProfileModerationCaseHistoryAverageAggregateFilter: TraderProfileModerationCaseHistoryAverageAggregateFilter;
  TraderProfileModerationCaseHistoryAverageAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryAverageAggregates>;
  TraderProfileModerationCaseHistoryCondition: TraderProfileModerationCaseHistoryCondition;
  TraderProfileModerationCaseHistoryConnection: ResolverTypeWrapper<TraderProfileModerationCaseHistoryConnection>;
  TraderProfileModerationCaseHistoryDistinctCountAggregateFilter: TraderProfileModerationCaseHistoryDistinctCountAggregateFilter;
  TraderProfileModerationCaseHistoryDistinctCountAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryDistinctCountAggregates>;
  TraderProfileModerationCaseHistoryEdge: ResolverTypeWrapper<TraderProfileModerationCaseHistoryEdge>;
  TraderProfileModerationCaseHistoryFilter: TraderProfileModerationCaseHistoryFilter;
  TraderProfileModerationCaseHistoryGroupBy: TraderProfileModerationCaseHistoryGroupBy;
  TraderProfileModerationCaseHistoryHavingAverageInput: TraderProfileModerationCaseHistoryHavingAverageInput;
  TraderProfileModerationCaseHistoryHavingDistinctCountInput: TraderProfileModerationCaseHistoryHavingDistinctCountInput;
  TraderProfileModerationCaseHistoryHavingInput: TraderProfileModerationCaseHistoryHavingInput;
  TraderProfileModerationCaseHistoryHavingMaxInput: TraderProfileModerationCaseHistoryHavingMaxInput;
  TraderProfileModerationCaseHistoryHavingMinInput: TraderProfileModerationCaseHistoryHavingMinInput;
  TraderProfileModerationCaseHistoryHavingStddevPopulationInput: TraderProfileModerationCaseHistoryHavingStddevPopulationInput;
  TraderProfileModerationCaseHistoryHavingStddevSampleInput: TraderProfileModerationCaseHistoryHavingStddevSampleInput;
  TraderProfileModerationCaseHistoryHavingSumInput: TraderProfileModerationCaseHistoryHavingSumInput;
  TraderProfileModerationCaseHistoryHavingVariancePopulationInput: TraderProfileModerationCaseHistoryHavingVariancePopulationInput;
  TraderProfileModerationCaseHistoryHavingVarianceSampleInput: TraderProfileModerationCaseHistoryHavingVarianceSampleInput;
  TraderProfileModerationCaseHistoryMaxAggregateFilter: TraderProfileModerationCaseHistoryMaxAggregateFilter;
  TraderProfileModerationCaseHistoryMaxAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryMaxAggregates>;
  TraderProfileModerationCaseHistoryMinAggregateFilter: TraderProfileModerationCaseHistoryMinAggregateFilter;
  TraderProfileModerationCaseHistoryMinAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryMinAggregates>;
  TraderProfileModerationCaseHistoryOrderBy: TraderProfileModerationCaseHistoryOrderBy;
  TraderProfileModerationCaseHistoryStddevPopulationAggregateFilter: TraderProfileModerationCaseHistoryStddevPopulationAggregateFilter;
  TraderProfileModerationCaseHistoryStddevPopulationAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryStddevPopulationAggregates>;
  TraderProfileModerationCaseHistoryStddevSampleAggregateFilter: TraderProfileModerationCaseHistoryStddevSampleAggregateFilter;
  TraderProfileModerationCaseHistoryStddevSampleAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryStddevSampleAggregates>;
  TraderProfileModerationCaseHistorySumAggregateFilter: TraderProfileModerationCaseHistorySumAggregateFilter;
  TraderProfileModerationCaseHistorySumAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistorySumAggregates>;
  TraderProfileModerationCaseHistoryVariancePopulationAggregateFilter: TraderProfileModerationCaseHistoryVariancePopulationAggregateFilter;
  TraderProfileModerationCaseHistoryVariancePopulationAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryVariancePopulationAggregates>;
  TraderProfileModerationCaseHistoryVarianceSampleAggregateFilter: TraderProfileModerationCaseHistoryVarianceSampleAggregateFilter;
  TraderProfileModerationCaseHistoryVarianceSampleAggregates: ResolverTypeWrapper<TraderProfileModerationCaseHistoryVarianceSampleAggregates>;
  TraderProfileModerationCaseMaxAggregateFilter: TraderProfileModerationCaseMaxAggregateFilter;
  TraderProfileModerationCaseMaxAggregates: ResolverTypeWrapper<TraderProfileModerationCaseMaxAggregates>;
  TraderProfileModerationCaseMinAggregateFilter: TraderProfileModerationCaseMinAggregateFilter;
  TraderProfileModerationCaseMinAggregates: ResolverTypeWrapper<TraderProfileModerationCaseMinAggregates>;
  TraderProfileModerationCaseOrderBy: TraderProfileModerationCaseOrderBy;
  TraderProfileModerationCaseStddevPopulationAggregateFilter: TraderProfileModerationCaseStddevPopulationAggregateFilter;
  TraderProfileModerationCaseStddevPopulationAggregates: ResolverTypeWrapper<TraderProfileModerationCaseStddevPopulationAggregates>;
  TraderProfileModerationCaseStddevSampleAggregateFilter: TraderProfileModerationCaseStddevSampleAggregateFilter;
  TraderProfileModerationCaseStddevSampleAggregates: ResolverTypeWrapper<TraderProfileModerationCaseStddevSampleAggregates>;
  TraderProfileModerationCaseSumAggregateFilter: TraderProfileModerationCaseSumAggregateFilter;
  TraderProfileModerationCaseSumAggregates: ResolverTypeWrapper<TraderProfileModerationCaseSumAggregates>;
  TraderProfileModerationCaseToManyTraderProfileModerationCaseHistoryFilter: TraderProfileModerationCaseToManyTraderProfileModerationCaseHistoryFilter;
  TraderProfileModerationCaseVariancePopulationAggregateFilter: TraderProfileModerationCaseVariancePopulationAggregateFilter;
  TraderProfileModerationCaseVariancePopulationAggregates: ResolverTypeWrapper<TraderProfileModerationCaseVariancePopulationAggregates>;
  TraderProfileModerationCaseVarianceSampleAggregateFilter: TraderProfileModerationCaseVarianceSampleAggregateFilter;
  TraderProfileModerationCaseVarianceSampleAggregates: ResolverTypeWrapper<TraderProfileModerationCaseVarianceSampleAggregates>;
  TraderPublicProfile: ResolverTypeWrapper<TraderPublicProfile>;
  TraderPublicProfileAggregates: ResolverTypeWrapper<TraderPublicProfileAggregates>;
  TraderPublicProfileAggregatesFilter: TraderPublicProfileAggregatesFilter;
  TraderPublicProfileAverageAggregateFilter: TraderPublicProfileAverageAggregateFilter;
  TraderPublicProfileAverageAggregates: ResolverTypeWrapper<TraderPublicProfileAverageAggregates>;
  TraderPublicProfileCondition: TraderPublicProfileCondition;
  TraderPublicProfileConnection: ResolverTypeWrapper<TraderPublicProfileConnection>;
  TraderPublicProfileDistinctCountAggregateFilter: TraderPublicProfileDistinctCountAggregateFilter;
  TraderPublicProfileDistinctCountAggregates: ResolverTypeWrapper<TraderPublicProfileDistinctCountAggregates>;
  TraderPublicProfileEdge: ResolverTypeWrapper<TraderPublicProfileEdge>;
  TraderPublicProfileFilter: TraderPublicProfileFilter;
  TraderPublicProfileGroupBy: TraderPublicProfileGroupBy;
  TraderPublicProfileHavingAverageInput: TraderPublicProfileHavingAverageInput;
  TraderPublicProfileHavingDistinctCountInput: TraderPublicProfileHavingDistinctCountInput;
  TraderPublicProfileHavingInput: TraderPublicProfileHavingInput;
  TraderPublicProfileHavingMaxInput: TraderPublicProfileHavingMaxInput;
  TraderPublicProfileHavingMinInput: TraderPublicProfileHavingMinInput;
  TraderPublicProfileHavingStddevPopulationInput: TraderPublicProfileHavingStddevPopulationInput;
  TraderPublicProfileHavingStddevSampleInput: TraderPublicProfileHavingStddevSampleInput;
  TraderPublicProfileHavingSumInput: TraderPublicProfileHavingSumInput;
  TraderPublicProfileHavingVariancePopulationInput: TraderPublicProfileHavingVariancePopulationInput;
  TraderPublicProfileHavingVarianceSampleInput: TraderPublicProfileHavingVarianceSampleInput;
  TraderPublicProfileMaxAggregateFilter: TraderPublicProfileMaxAggregateFilter;
  TraderPublicProfileMaxAggregates: ResolverTypeWrapper<TraderPublicProfileMaxAggregates>;
  TraderPublicProfileMinAggregateFilter: TraderPublicProfileMinAggregateFilter;
  TraderPublicProfileMinAggregates: ResolverTypeWrapper<TraderPublicProfileMinAggregates>;
  TraderPublicProfileOrderBy: TraderPublicProfileOrderBy;
  TraderPublicProfilePatch: TraderPublicProfilePatch;
  TraderPublicProfileStddevPopulationAggregateFilter: TraderPublicProfileStddevPopulationAggregateFilter;
  TraderPublicProfileStddevPopulationAggregates: ResolverTypeWrapper<TraderPublicProfileStddevPopulationAggregates>;
  TraderPublicProfileStddevSampleAggregateFilter: TraderPublicProfileStddevSampleAggregateFilter;
  TraderPublicProfileStddevSampleAggregates: ResolverTypeWrapper<TraderPublicProfileStddevSampleAggregates>;
  TraderPublicProfileSumAggregateFilter: TraderPublicProfileSumAggregateFilter;
  TraderPublicProfileSumAggregates: ResolverTypeWrapper<TraderPublicProfileSumAggregates>;
  TraderPublicProfileToManyProfileReportFilter: TraderPublicProfileToManyProfileReportFilter;
  TraderPublicProfileVariancePopulationAggregateFilter: TraderPublicProfileVariancePopulationAggregateFilter;
  TraderPublicProfileVariancePopulationAggregates: ResolverTypeWrapper<TraderPublicProfileVariancePopulationAggregates>;
  TraderPublicProfileVarianceSampleAggregateFilter: TraderPublicProfileVarianceSampleAggregateFilter;
  TraderPublicProfileVarianceSampleAggregates: ResolverTypeWrapper<TraderPublicProfileVarianceSampleAggregates>;
  TraderRiskIndicator: ResolverTypeWrapper<TraderRiskIndicator>;
  TraderRiskIndicatorAggregates: ResolverTypeWrapper<TraderRiskIndicatorAggregates>;
  TraderRiskIndicatorAggregatesFilter: TraderRiskIndicatorAggregatesFilter;
  TraderRiskIndicatorAverageAggregateFilter: TraderRiskIndicatorAverageAggregateFilter;
  TraderRiskIndicatorAverageAggregates: ResolverTypeWrapper<TraderRiskIndicatorAverageAggregates>;
  TraderRiskIndicatorCondition: TraderRiskIndicatorCondition;
  TraderRiskIndicatorConnection: ResolverTypeWrapper<TraderRiskIndicatorConnection>;
  TraderRiskIndicatorDistinctCountAggregateFilter: TraderRiskIndicatorDistinctCountAggregateFilter;
  TraderRiskIndicatorDistinctCountAggregates: ResolverTypeWrapper<TraderRiskIndicatorDistinctCountAggregates>;
  TraderRiskIndicatorEdge: ResolverTypeWrapper<TraderRiskIndicatorEdge>;
  TraderRiskIndicatorFilter: TraderRiskIndicatorFilter;
  TraderRiskIndicatorGroupBy: TraderRiskIndicatorGroupBy;
  TraderRiskIndicatorHavingAverageInput: TraderRiskIndicatorHavingAverageInput;
  TraderRiskIndicatorHavingDistinctCountInput: TraderRiskIndicatorHavingDistinctCountInput;
  TraderRiskIndicatorHavingInput: TraderRiskIndicatorHavingInput;
  TraderRiskIndicatorHavingMaxInput: TraderRiskIndicatorHavingMaxInput;
  TraderRiskIndicatorHavingMinInput: TraderRiskIndicatorHavingMinInput;
  TraderRiskIndicatorHavingStddevPopulationInput: TraderRiskIndicatorHavingStddevPopulationInput;
  TraderRiskIndicatorHavingStddevSampleInput: TraderRiskIndicatorHavingStddevSampleInput;
  TraderRiskIndicatorHavingSumInput: TraderRiskIndicatorHavingSumInput;
  TraderRiskIndicatorHavingVariancePopulationInput: TraderRiskIndicatorHavingVariancePopulationInput;
  TraderRiskIndicatorHavingVarianceSampleInput: TraderRiskIndicatorHavingVarianceSampleInput;
  TraderRiskIndicatorInput: TraderRiskIndicatorInput;
  TraderRiskIndicatorMaxAggregateFilter: TraderRiskIndicatorMaxAggregateFilter;
  TraderRiskIndicatorMaxAggregates: ResolverTypeWrapper<TraderRiskIndicatorMaxAggregates>;
  TraderRiskIndicatorMinAggregateFilter: TraderRiskIndicatorMinAggregateFilter;
  TraderRiskIndicatorMinAggregates: ResolverTypeWrapper<TraderRiskIndicatorMinAggregates>;
  TraderRiskIndicatorOrderBy: TraderRiskIndicatorOrderBy;
  TraderRiskIndicatorOwner: ResolverTypeWrapper<TraderRiskIndicatorOwner>;
  TraderRiskIndicatorOwnerFilter: TraderRiskIndicatorOwnerFilter;
  TraderRiskIndicatorPatch: TraderRiskIndicatorPatch;
  TraderRiskIndicatorStddevPopulationAggregateFilter: TraderRiskIndicatorStddevPopulationAggregateFilter;
  TraderRiskIndicatorStddevPopulationAggregates: ResolverTypeWrapper<TraderRiskIndicatorStddevPopulationAggregates>;
  TraderRiskIndicatorStddevSampleAggregateFilter: TraderRiskIndicatorStddevSampleAggregateFilter;
  TraderRiskIndicatorStddevSampleAggregates: ResolverTypeWrapper<TraderRiskIndicatorStddevSampleAggregates>;
  TraderRiskIndicatorSumAggregateFilter: TraderRiskIndicatorSumAggregateFilter;
  TraderRiskIndicatorSumAggregates: ResolverTypeWrapper<TraderRiskIndicatorSumAggregates>;
  TraderRiskIndicatorVariancePopulationAggregateFilter: TraderRiskIndicatorVariancePopulationAggregateFilter;
  TraderRiskIndicatorVariancePopulationAggregates: ResolverTypeWrapper<TraderRiskIndicatorVariancePopulationAggregates>;
  TraderRiskIndicatorVarianceSampleAggregateFilter: TraderRiskIndicatorVarianceSampleAggregateFilter;
  TraderRiskIndicatorVarianceSampleAggregates: ResolverTypeWrapper<TraderRiskIndicatorVarianceSampleAggregates>;
  TradingHabits: ResolverTypeWrapper<TradingHabits>;
  TradingOverview: ResolverTypeWrapper<TradingOverview>;
  TradingProduct: ResolverTypeWrapper<TradingProduct>;
  TradingProductFee: ResolverTypeWrapper<TradingProductFee>;
  TradingProductFeeAggregates: ResolverTypeWrapper<TradingProductFeeAggregates>;
  TradingProductFeeAggregatesFilter: TradingProductFeeAggregatesFilter;
  TradingProductFeeAverageAggregateFilter: TradingProductFeeAverageAggregateFilter;
  TradingProductFeeAverageAggregates: ResolverTypeWrapper<TradingProductFeeAverageAggregates>;
  TradingProductFeeCondition: TradingProductFeeCondition;
  TradingProductFeeConnection: ResolverTypeWrapper<TradingProductFeeConnection>;
  TradingProductFeeDistinctCountAggregateFilter: TradingProductFeeDistinctCountAggregateFilter;
  TradingProductFeeDistinctCountAggregates: ResolverTypeWrapper<TradingProductFeeDistinctCountAggregates>;
  TradingProductFeeEdge: ResolverTypeWrapper<TradingProductFeeEdge>;
  TradingProductFeeFilter: TradingProductFeeFilter;
  TradingProductFeeGroupBy: TradingProductFeeGroupBy;
  TradingProductFeeHavingAverageInput: TradingProductFeeHavingAverageInput;
  TradingProductFeeHavingDistinctCountInput: TradingProductFeeHavingDistinctCountInput;
  TradingProductFeeHavingInput: TradingProductFeeHavingInput;
  TradingProductFeeHavingMaxInput: TradingProductFeeHavingMaxInput;
  TradingProductFeeHavingMinInput: TradingProductFeeHavingMinInput;
  TradingProductFeeHavingStddevPopulationInput: TradingProductFeeHavingStddevPopulationInput;
  TradingProductFeeHavingStddevSampleInput: TradingProductFeeHavingStddevSampleInput;
  TradingProductFeeHavingSumInput: TradingProductFeeHavingSumInput;
  TradingProductFeeHavingVariancePopulationInput: TradingProductFeeHavingVariancePopulationInput;
  TradingProductFeeHavingVarianceSampleInput: TradingProductFeeHavingVarianceSampleInput;
  TradingProductFeeInput: TradingProductFeeInput;
  TradingProductFeeMaxAggregateFilter: TradingProductFeeMaxAggregateFilter;
  TradingProductFeeMaxAggregates: ResolverTypeWrapper<TradingProductFeeMaxAggregates>;
  TradingProductFeeMinAggregateFilter: TradingProductFeeMinAggregateFilter;
  TradingProductFeeMinAggregates: ResolverTypeWrapper<TradingProductFeeMinAggregates>;
  TradingProductFeeOrderBy: TradingProductFeeOrderBy;
  TradingProductFeePatch: TradingProductFeePatch;
  TradingProductFeeStddevPopulationAggregateFilter: TradingProductFeeStddevPopulationAggregateFilter;
  TradingProductFeeStddevPopulationAggregates: ResolverTypeWrapper<TradingProductFeeStddevPopulationAggregates>;
  TradingProductFeeStddevSampleAggregateFilter: TradingProductFeeStddevSampleAggregateFilter;
  TradingProductFeeStddevSampleAggregates: ResolverTypeWrapper<TradingProductFeeStddevSampleAggregates>;
  TradingProductFeeSumAggregateFilter: TradingProductFeeSumAggregateFilter;
  TradingProductFeeSumAggregates: ResolverTypeWrapper<TradingProductFeeSumAggregates>;
  TradingProductFeeVariancePopulationAggregateFilter: TradingProductFeeVariancePopulationAggregateFilter;
  TradingProductFeeVariancePopulationAggregates: ResolverTypeWrapper<TradingProductFeeVariancePopulationAggregates>;
  TradingProductFeeVarianceSampleAggregateFilter: TradingProductFeeVarianceSampleAggregateFilter;
  TradingProductFeeVarianceSampleAggregates: ResolverTypeWrapper<TradingProductFeeVarianceSampleAggregates>;
  TradingProductFilter: TradingProductFilter;
  TradingProductToManyTradingProductFeeFilter: TradingProductToManyTradingProductFeeFilter;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UUIDFilter: UuidFilter;
  UnifiedSubscription: ResolverTypeWrapper<UnifiedSubscription>;
  UnlinkDiscordPayload: ResolverTypeWrapper<UnlinkDiscordPayload>;
  UnsetCaseBanPendingStatusInput: UnsetCaseBanPendingStatusInput;
  UnsetCaseInvestigationPendingStatusInput: UnsetCaseInvestigationPendingStatusInput;
  UpdateAccountStatByIdInput: UpdateAccountStatByIdInput;
  UpdateAccountStatInput: UpdateAccountStatInput;
  UpdateAccountStatPayload: ResolverTypeWrapper<Omit<UpdateAccountStatPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateAdminConfigByConfigKeyInput: UpdateAdminConfigByConfigKeyInput;
  UpdateAdminConfigByIdInput: UpdateAdminConfigByIdInput;
  UpdateAdminConfigInput: UpdateAdminConfigInput;
  UpdateAdminConfigPayload: ResolverTypeWrapper<Omit<UpdateAdminConfigPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateCaseBanInput: UpdateCaseBanInput;
  UpdateCaseInvestigationInput: UpdateCaseInvestigationInput;
  UpdateImpactGroupAssignmentByIdInput: UpdateImpactGroupAssignmentByIdInput;
  UpdateImpactGroupAssignmentInput: UpdateImpactGroupAssignmentInput;
  UpdateImpactGroupAssignmentPayload: ResolverTypeWrapper<Omit<UpdateImpactGroupAssignmentPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateImpactGroupTemplateByIdInput: UpdateImpactGroupTemplateByIdInput;
  UpdateImpactGroupTemplateByLabelAndScopeInput: UpdateImpactGroupTemplateByLabelAndScopeInput;
  UpdateImpactGroupTemplateBySlugInput: UpdateImpactGroupTemplateBySlugInput;
  UpdateImpactGroupTemplateInput: UpdateImpactGroupTemplateInput;
  UpdateImpactGroupTemplatePayload: ResolverTypeWrapper<Omit<UpdateImpactGroupTemplatePayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateKycPriorityLabelByIdInput: UpdateKycPriorityLabelByIdInput;
  UpdateKycPriorityLabelInput: UpdateKycPriorityLabelInput;
  UpdateKycPriorityLabelPayload: ResolverTypeWrapper<Omit<UpdateKycPriorityLabelPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateMyTraderPublicProfileInput: UpdateMyTraderPublicProfileInput;
  UpdateMyTraderPublicProfilePayload: ResolverTypeWrapper<UpdateMyTraderPublicProfilePayload>;
  UpdateTraderPublicProfileByIdInput: UpdateTraderPublicProfileByIdInput;
  UpdateTraderPublicProfileInput: UpdateTraderPublicProfileInput;
  UpdateTraderPublicProfilePayload: ResolverTypeWrapper<Omit<UpdateTraderPublicProfilePayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateTraderRiskIndicatorByIdInput: UpdateTraderRiskIndicatorByIdInput;
  UpdateTraderRiskIndicatorInput: UpdateTraderRiskIndicatorInput;
  UpdateTraderRiskIndicatorPayload: ResolverTypeWrapper<Omit<UpdateTraderRiskIndicatorPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateTradingProductFeeByIdInput: UpdateTradingProductFeeByIdInput;
  UpdateTradingProductFeeInput: UpdateTradingProductFeeInput;
  UpdateTradingProductFeePayload: ResolverTypeWrapper<Omit<UpdateTradingProductFeePayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateUserAddressByIdInput: UpdateUserAddressByIdInput;
  UpdateUserAddressInput: UpdateUserAddressInput;
  UpdateUserAddressPayload: ResolverTypeWrapper<Omit<UpdateUserAddressPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateUserTaxFormByIdInput: UpdateUserTaxFormByIdInput;
  UpdateUserTaxFormInput: UpdateUserTaxFormInput;
  UpdateUserTaxFormPayload: ResolverTypeWrapper<Omit<UpdateUserTaxFormPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  UpdateXfaActivationCreditByIdInput: UpdateXfaActivationCreditByIdInput;
  UpdateXfaActivationCreditInput: UpdateXfaActivationCreditInput;
  UpdateXfaActivationCreditPayload: ResolverTypeWrapper<Omit<UpdateXfaActivationCreditPayload, 'query'> & { query?: Maybe<ResolversTypes['Query']> }>;
  User: ResolverTypeWrapper<User>;
  UserAddon: ResolverTypeWrapper<UserAddon>;
  UserAddress: ResolverTypeWrapper<UserAddress>;
  UserAddressAddressTypeEnum: UserAddressAddressTypeEnum;
  UserAddressAggregates: ResolverTypeWrapper<UserAddressAggregates>;
  UserAddressAggregatesFilter: UserAddressAggregatesFilter;
  UserAddressAverageAggregateFilter: UserAddressAverageAggregateFilter;
  UserAddressAverageAggregates: ResolverTypeWrapper<UserAddressAverageAggregates>;
  UserAddressCondition: UserAddressCondition;
  UserAddressConnection: ResolverTypeWrapper<UserAddressConnection>;
  UserAddressDistinctCountAggregateFilter: UserAddressDistinctCountAggregateFilter;
  UserAddressDistinctCountAggregates: ResolverTypeWrapper<UserAddressDistinctCountAggregates>;
  UserAddressEdge: ResolverTypeWrapper<UserAddressEdge>;
  UserAddressFilter: UserAddressFilter;
  UserAddressGroupBy: UserAddressGroupBy;
  UserAddressHavingAverageInput: UserAddressHavingAverageInput;
  UserAddressHavingDistinctCountInput: UserAddressHavingDistinctCountInput;
  UserAddressHavingInput: UserAddressHavingInput;
  UserAddressHavingMaxInput: UserAddressHavingMaxInput;
  UserAddressHavingMinInput: UserAddressHavingMinInput;
  UserAddressHavingStddevPopulationInput: UserAddressHavingStddevPopulationInput;
  UserAddressHavingStddevSampleInput: UserAddressHavingStddevSampleInput;
  UserAddressHavingSumInput: UserAddressHavingSumInput;
  UserAddressHavingVariancePopulationInput: UserAddressHavingVariancePopulationInput;
  UserAddressHavingVarianceSampleInput: UserAddressHavingVarianceSampleInput;
  UserAddressInput: UserAddressInput;
  UserAddressMaxAggregateFilter: UserAddressMaxAggregateFilter;
  UserAddressMaxAggregates: ResolverTypeWrapper<UserAddressMaxAggregates>;
  UserAddressMinAggregateFilter: UserAddressMinAggregateFilter;
  UserAddressMinAggregates: ResolverTypeWrapper<UserAddressMinAggregates>;
  UserAddressOrderBy: UserAddressOrderBy;
  UserAddressPatch: UserAddressPatch;
  UserAddressStddevPopulationAggregateFilter: UserAddressStddevPopulationAggregateFilter;
  UserAddressStddevPopulationAggregates: ResolverTypeWrapper<UserAddressStddevPopulationAggregates>;
  UserAddressStddevSampleAggregateFilter: UserAddressStddevSampleAggregateFilter;
  UserAddressStddevSampleAggregates: ResolverTypeWrapper<UserAddressStddevSampleAggregates>;
  UserAddressSumAggregateFilter: UserAddressSumAggregateFilter;
  UserAddressSumAggregates: ResolverTypeWrapper<UserAddressSumAggregates>;
  UserAddressVariancePopulationAggregateFilter: UserAddressVariancePopulationAggregateFilter;
  UserAddressVariancePopulationAggregates: ResolverTypeWrapper<UserAddressVariancePopulationAggregates>;
  UserAddressVarianceSampleAggregateFilter: UserAddressVarianceSampleAggregateFilter;
  UserAddressVarianceSampleAggregates: ResolverTypeWrapper<UserAddressVarianceSampleAggregates>;
  UserAdminRole: ResolverTypeWrapper<UserAdminRole>;
  UserAdminRoleAggregates: ResolverTypeWrapper<UserAdminRoleAggregates>;
  UserAdminRoleAggregatesFilter: UserAdminRoleAggregatesFilter;
  UserAdminRoleAverageAggregateFilter: UserAdminRoleAverageAggregateFilter;
  UserAdminRoleAverageAggregates: ResolverTypeWrapper<UserAdminRoleAverageAggregates>;
  UserAdminRoleCondition: UserAdminRoleCondition;
  UserAdminRoleConnection: ResolverTypeWrapper<UserAdminRoleConnection>;
  UserAdminRoleDistinctCountAggregateFilter: UserAdminRoleDistinctCountAggregateFilter;
  UserAdminRoleDistinctCountAggregates: ResolverTypeWrapper<UserAdminRoleDistinctCountAggregates>;
  UserAdminRoleEdge: ResolverTypeWrapper<UserAdminRoleEdge>;
  UserAdminRoleFilter: UserAdminRoleFilter;
  UserAdminRoleGroupBy: UserAdminRoleGroupBy;
  UserAdminRoleHavingAverageInput: UserAdminRoleHavingAverageInput;
  UserAdminRoleHavingDistinctCountInput: UserAdminRoleHavingDistinctCountInput;
  UserAdminRoleHavingInput: UserAdminRoleHavingInput;
  UserAdminRoleHavingMaxInput: UserAdminRoleHavingMaxInput;
  UserAdminRoleHavingMinInput: UserAdminRoleHavingMinInput;
  UserAdminRoleHavingStddevPopulationInput: UserAdminRoleHavingStddevPopulationInput;
  UserAdminRoleHavingStddevSampleInput: UserAdminRoleHavingStddevSampleInput;
  UserAdminRoleHavingSumInput: UserAdminRoleHavingSumInput;
  UserAdminRoleHavingVariancePopulationInput: UserAdminRoleHavingVariancePopulationInput;
  UserAdminRoleHavingVarianceSampleInput: UserAdminRoleHavingVarianceSampleInput;
  UserAdminRoleMaxAggregateFilter: UserAdminRoleMaxAggregateFilter;
  UserAdminRoleMaxAggregates: ResolverTypeWrapper<UserAdminRoleMaxAggregates>;
  UserAdminRoleMinAggregateFilter: UserAdminRoleMinAggregateFilter;
  UserAdminRoleMinAggregates: ResolverTypeWrapper<UserAdminRoleMinAggregates>;
  UserAdminRoleOrderBy: UserAdminRoleOrderBy;
  UserAdminRoleStddevPopulationAggregateFilter: UserAdminRoleStddevPopulationAggregateFilter;
  UserAdminRoleStddevPopulationAggregates: ResolverTypeWrapper<UserAdminRoleStddevPopulationAggregates>;
  UserAdminRoleStddevSampleAggregateFilter: UserAdminRoleStddevSampleAggregateFilter;
  UserAdminRoleStddevSampleAggregates: ResolverTypeWrapper<UserAdminRoleStddevSampleAggregates>;
  UserAdminRoleSumAggregateFilter: UserAdminRoleSumAggregateFilter;
  UserAdminRoleSumAggregates: ResolverTypeWrapper<UserAdminRoleSumAggregates>;
  UserAdminRoleVariancePopulationAggregateFilter: UserAdminRoleVariancePopulationAggregateFilter;
  UserAdminRoleVariancePopulationAggregates: ResolverTypeWrapper<UserAdminRoleVariancePopulationAggregates>;
  UserAdminRoleVarianceSampleAggregateFilter: UserAdminRoleVarianceSampleAggregateFilter;
  UserAdminRoleVarianceSampleAggregates: ResolverTypeWrapper<UserAdminRoleVarianceSampleAggregates>;
  UserAggregates: ResolverTypeWrapper<UserAggregates>;
  UserAgreement: ResolverTypeWrapper<UserAgreement>;
  UserAgreementAggregates: ResolverTypeWrapper<UserAgreementAggregates>;
  UserAgreementAggregatesFilter: UserAgreementAggregatesFilter;
  UserAgreementAverageAggregateFilter: UserAgreementAverageAggregateFilter;
  UserAgreementAverageAggregates: ResolverTypeWrapper<UserAgreementAverageAggregates>;
  UserAgreementCondition: UserAgreementCondition;
  UserAgreementConnection: ResolverTypeWrapper<UserAgreementConnection>;
  UserAgreementDistinctCountAggregateFilter: UserAgreementDistinctCountAggregateFilter;
  UserAgreementDistinctCountAggregates: ResolverTypeWrapper<UserAgreementDistinctCountAggregates>;
  UserAgreementEdge: ResolverTypeWrapper<UserAgreementEdge>;
  UserAgreementFilter: UserAgreementFilter;
  UserAgreementGroupBy: UserAgreementGroupBy;
  UserAgreementHavingAverageInput: UserAgreementHavingAverageInput;
  UserAgreementHavingDistinctCountInput: UserAgreementHavingDistinctCountInput;
  UserAgreementHavingInput: UserAgreementHavingInput;
  UserAgreementHavingMaxInput: UserAgreementHavingMaxInput;
  UserAgreementHavingMinInput: UserAgreementHavingMinInput;
  UserAgreementHavingStddevPopulationInput: UserAgreementHavingStddevPopulationInput;
  UserAgreementHavingStddevSampleInput: UserAgreementHavingStddevSampleInput;
  UserAgreementHavingSumInput: UserAgreementHavingSumInput;
  UserAgreementHavingVariancePopulationInput: UserAgreementHavingVariancePopulationInput;
  UserAgreementHavingVarianceSampleInput: UserAgreementHavingVarianceSampleInput;
  UserAgreementMaxAggregateFilter: UserAgreementMaxAggregateFilter;
  UserAgreementMaxAggregates: ResolverTypeWrapper<UserAgreementMaxAggregates>;
  UserAgreementMinAggregateFilter: UserAgreementMinAggregateFilter;
  UserAgreementMinAggregates: ResolverTypeWrapper<UserAgreementMinAggregates>;
  UserAgreementOrderBy: UserAgreementOrderBy;
  UserAgreementStddevPopulationAggregateFilter: UserAgreementStddevPopulationAggregateFilter;
  UserAgreementStddevPopulationAggregates: ResolverTypeWrapper<UserAgreementStddevPopulationAggregates>;
  UserAgreementStddevSampleAggregateFilter: UserAgreementStddevSampleAggregateFilter;
  UserAgreementStddevSampleAggregates: ResolverTypeWrapper<UserAgreementStddevSampleAggregates>;
  UserAgreementSumAggregateFilter: UserAgreementSumAggregateFilter;
  UserAgreementSumAggregates: ResolverTypeWrapper<UserAgreementSumAggregates>;
  UserAgreementVariancePopulationAggregateFilter: UserAgreementVariancePopulationAggregateFilter;
  UserAgreementVariancePopulationAggregates: ResolverTypeWrapper<UserAgreementVariancePopulationAggregates>;
  UserAgreementVarianceSampleAggregateFilter: UserAgreementVarianceSampleAggregateFilter;
  UserAgreementVarianceSampleAggregates: ResolverTypeWrapper<UserAgreementVarianceSampleAggregates>;
  UserAverageAggregates: ResolverTypeWrapper<UserAverageAggregates>;
  UserBankingInfo: ResolverTypeWrapper<UserBankingInfo>;
  UserCertificate: ResolverTypeWrapper<UserCertificate>;
  UserCertificateAggregates: ResolverTypeWrapper<UserCertificateAggregates>;
  UserCertificateAggregatesFilter: UserCertificateAggregatesFilter;
  UserCertificateAverageAggregateFilter: UserCertificateAverageAggregateFilter;
  UserCertificateAverageAggregates: ResolverTypeWrapper<UserCertificateAverageAggregates>;
  UserCertificateCondition: UserCertificateCondition;
  UserCertificateConnection: ResolverTypeWrapper<UserCertificateConnection>;
  UserCertificateDistinctCountAggregateFilter: UserCertificateDistinctCountAggregateFilter;
  UserCertificateDistinctCountAggregates: ResolverTypeWrapper<UserCertificateDistinctCountAggregates>;
  UserCertificateEdge: ResolverTypeWrapper<UserCertificateEdge>;
  UserCertificateFilter: UserCertificateFilter;
  UserCertificateGroupBy: UserCertificateGroupBy;
  UserCertificateHavingAverageInput: UserCertificateHavingAverageInput;
  UserCertificateHavingDistinctCountInput: UserCertificateHavingDistinctCountInput;
  UserCertificateHavingInput: UserCertificateHavingInput;
  UserCertificateHavingMaxInput: UserCertificateHavingMaxInput;
  UserCertificateHavingMinInput: UserCertificateHavingMinInput;
  UserCertificateHavingStddevPopulationInput: UserCertificateHavingStddevPopulationInput;
  UserCertificateHavingStddevSampleInput: UserCertificateHavingStddevSampleInput;
  UserCertificateHavingSumInput: UserCertificateHavingSumInput;
  UserCertificateHavingVariancePopulationInput: UserCertificateHavingVariancePopulationInput;
  UserCertificateHavingVarianceSampleInput: UserCertificateHavingVarianceSampleInput;
  UserCertificateMaxAggregateFilter: UserCertificateMaxAggregateFilter;
  UserCertificateMaxAggregates: ResolverTypeWrapper<UserCertificateMaxAggregates>;
  UserCertificateMinAggregateFilter: UserCertificateMinAggregateFilter;
  UserCertificateMinAggregates: ResolverTypeWrapper<UserCertificateMinAggregates>;
  UserCertificateOrderBy: UserCertificateOrderBy;
  UserCertificateStddevPopulationAggregateFilter: UserCertificateStddevPopulationAggregateFilter;
  UserCertificateStddevPopulationAggregates: ResolverTypeWrapper<UserCertificateStddevPopulationAggregates>;
  UserCertificateStddevSampleAggregateFilter: UserCertificateStddevSampleAggregateFilter;
  UserCertificateStddevSampleAggregates: ResolverTypeWrapper<UserCertificateStddevSampleAggregates>;
  UserCertificateSumAggregateFilter: UserCertificateSumAggregateFilter;
  UserCertificateSumAggregates: ResolverTypeWrapper<UserCertificateSumAggregates>;
  UserCertificateVariancePopulationAggregateFilter: UserCertificateVariancePopulationAggregateFilter;
  UserCertificateVariancePopulationAggregates: ResolverTypeWrapper<UserCertificateVariancePopulationAggregates>;
  UserCertificateVarianceSampleAggregateFilter: UserCertificateVarianceSampleAggregateFilter;
  UserCertificateVarianceSampleAggregates: ResolverTypeWrapper<UserCertificateVarianceSampleAggregates>;
  UserCondition: UserCondition;
  UserConnection: ResolverTypeWrapper<UserConnection>;
  UserContactInfo: ResolverTypeWrapper<UserContactInfo>;
  UserContactInfoAggregates: ResolverTypeWrapper<UserContactInfoAggregates>;
  UserContactInfoAverageAggregates: ResolverTypeWrapper<UserContactInfoAverageAggregates>;
  UserContactInfoCondition: UserContactInfoCondition;
  UserContactInfoConnection: ResolverTypeWrapper<UserContactInfoConnection>;
  UserContactInfoDistinctCountAggregates: ResolverTypeWrapper<UserContactInfoDistinctCountAggregates>;
  UserContactInfoEdge: ResolverTypeWrapper<UserContactInfoEdge>;
  UserContactInfoFilter: UserContactInfoFilter;
  UserContactInfoGroupBy: UserContactInfoGroupBy;
  UserContactInfoHavingAverageInput: UserContactInfoHavingAverageInput;
  UserContactInfoHavingDistinctCountInput: UserContactInfoHavingDistinctCountInput;
  UserContactInfoHavingInput: UserContactInfoHavingInput;
  UserContactInfoHavingMaxInput: UserContactInfoHavingMaxInput;
  UserContactInfoHavingMinInput: UserContactInfoHavingMinInput;
  UserContactInfoHavingStddevPopulationInput: UserContactInfoHavingStddevPopulationInput;
  UserContactInfoHavingStddevSampleInput: UserContactInfoHavingStddevSampleInput;
  UserContactInfoHavingSumInput: UserContactInfoHavingSumInput;
  UserContactInfoHavingVariancePopulationInput: UserContactInfoHavingVariancePopulationInput;
  UserContactInfoHavingVarianceSampleInput: UserContactInfoHavingVarianceSampleInput;
  UserContactInfoMaxAggregates: ResolverTypeWrapper<UserContactInfoMaxAggregates>;
  UserContactInfoMinAggregates: ResolverTypeWrapper<UserContactInfoMinAggregates>;
  UserContactInfoOrderBy: UserContactInfoOrderBy;
  UserContactInfoStddevPopulationAggregates: ResolverTypeWrapper<UserContactInfoStddevPopulationAggregates>;
  UserContactInfoStddevSampleAggregates: ResolverTypeWrapper<UserContactInfoStddevSampleAggregates>;
  UserContactInfoSumAggregates: ResolverTypeWrapper<UserContactInfoSumAggregates>;
  UserContactInfoVariancePopulationAggregates: ResolverTypeWrapper<UserContactInfoVariancePopulationAggregates>;
  UserContactInfoVarianceSampleAggregates: ResolverTypeWrapper<UserContactInfoVarianceSampleAggregates>;
  UserCooldown: ResolverTypeWrapper<UserCooldown>;
  UserCooldownAggregates: ResolverTypeWrapper<UserCooldownAggregates>;
  UserCooldownAggregatesFilter: UserCooldownAggregatesFilter;
  UserCooldownAverageAggregateFilter: UserCooldownAverageAggregateFilter;
  UserCooldownAverageAggregates: ResolverTypeWrapper<UserCooldownAverageAggregates>;
  UserCooldownCondition: UserCooldownCondition;
  UserCooldownConnection: ResolverTypeWrapper<UserCooldownConnection>;
  UserCooldownDistinctCountAggregateFilter: UserCooldownDistinctCountAggregateFilter;
  UserCooldownDistinctCountAggregates: ResolverTypeWrapper<UserCooldownDistinctCountAggregates>;
  UserCooldownEdge: ResolverTypeWrapper<UserCooldownEdge>;
  UserCooldownFilter: UserCooldownFilter;
  UserCooldownGroupBy: UserCooldownGroupBy;
  UserCooldownHavingAverageInput: UserCooldownHavingAverageInput;
  UserCooldownHavingDistinctCountInput: UserCooldownHavingDistinctCountInput;
  UserCooldownHavingInput: UserCooldownHavingInput;
  UserCooldownHavingMaxInput: UserCooldownHavingMaxInput;
  UserCooldownHavingMinInput: UserCooldownHavingMinInput;
  UserCooldownHavingStddevPopulationInput: UserCooldownHavingStddevPopulationInput;
  UserCooldownHavingStddevSampleInput: UserCooldownHavingStddevSampleInput;
  UserCooldownHavingSumInput: UserCooldownHavingSumInput;
  UserCooldownHavingVariancePopulationInput: UserCooldownHavingVariancePopulationInput;
  UserCooldownHavingVarianceSampleInput: UserCooldownHavingVarianceSampleInput;
  UserCooldownMaxAggregateFilter: UserCooldownMaxAggregateFilter;
  UserCooldownMaxAggregates: ResolverTypeWrapper<UserCooldownMaxAggregates>;
  UserCooldownMinAggregateFilter: UserCooldownMinAggregateFilter;
  UserCooldownMinAggregates: ResolverTypeWrapper<UserCooldownMinAggregates>;
  UserCooldownOrderBy: UserCooldownOrderBy;
  UserCooldownStddevPopulationAggregateFilter: UserCooldownStddevPopulationAggregateFilter;
  UserCooldownStddevPopulationAggregates: ResolverTypeWrapper<UserCooldownStddevPopulationAggregates>;
  UserCooldownStddevSampleAggregateFilter: UserCooldownStddevSampleAggregateFilter;
  UserCooldownStddevSampleAggregates: ResolverTypeWrapper<UserCooldownStddevSampleAggregates>;
  UserCooldownSumAggregateFilter: UserCooldownSumAggregateFilter;
  UserCooldownSumAggregates: ResolverTypeWrapper<UserCooldownSumAggregates>;
  UserCooldownVariancePopulationAggregateFilter: UserCooldownVariancePopulationAggregateFilter;
  UserCooldownVariancePopulationAggregates: ResolverTypeWrapper<UserCooldownVariancePopulationAggregates>;
  UserCooldownVarianceSampleAggregateFilter: UserCooldownVarianceSampleAggregateFilter;
  UserCooldownVarianceSampleAggregates: ResolverTypeWrapper<UserCooldownVarianceSampleAggregates>;
  UserDistinctCountAggregates: ResolverTypeWrapper<UserDistinctCountAggregates>;
  UserEdge: ResolverTypeWrapper<UserEdge>;
  UserFilter: UserFilter;
  UserGroupBy: UserGroupBy;
  UserHavingAverageInput: UserHavingAverageInput;
  UserHavingDistinctCountInput: UserHavingDistinctCountInput;
  UserHavingInput: UserHavingInput;
  UserHavingMaxInput: UserHavingMaxInput;
  UserHavingMinInput: UserHavingMinInput;
  UserHavingStddevPopulationInput: UserHavingStddevPopulationInput;
  UserHavingStddevSampleInput: UserHavingStddevSampleInput;
  UserHavingSumInput: UserHavingSumInput;
  UserHavingVariancePopulationInput: UserHavingVariancePopulationInput;
  UserHavingVarianceSampleInput: UserHavingVarianceSampleInput;
  UserIntegration: ResolverTypeWrapper<UserIntegration>;
  UserIntegrationFilter: UserIntegrationFilter;
  UserMarketDatum: ResolverTypeWrapper<UserMarketDatum>;
  UserMaxAggregates: ResolverTypeWrapper<UserMaxAggregates>;
  UserMeteredEvent: ResolverTypeWrapper<UserMeteredEvent>;
  UserMeteredEventAggregates: ResolverTypeWrapper<UserMeteredEventAggregates>;
  UserMeteredEventAggregatesFilter: UserMeteredEventAggregatesFilter;
  UserMeteredEventAverageAggregateFilter: UserMeteredEventAverageAggregateFilter;
  UserMeteredEventAverageAggregates: ResolverTypeWrapper<UserMeteredEventAverageAggregates>;
  UserMeteredEventCondition: UserMeteredEventCondition;
  UserMeteredEventConnection: ResolverTypeWrapper<UserMeteredEventConnection>;
  UserMeteredEventDistinctCountAggregateFilter: UserMeteredEventDistinctCountAggregateFilter;
  UserMeteredEventDistinctCountAggregates: ResolverTypeWrapper<UserMeteredEventDistinctCountAggregates>;
  UserMeteredEventEdge: ResolverTypeWrapper<UserMeteredEventEdge>;
  UserMeteredEventFilter: UserMeteredEventFilter;
  UserMeteredEventGroupBy: UserMeteredEventGroupBy;
  UserMeteredEventHavingAverageInput: UserMeteredEventHavingAverageInput;
  UserMeteredEventHavingDistinctCountInput: UserMeteredEventHavingDistinctCountInput;
  UserMeteredEventHavingInput: UserMeteredEventHavingInput;
  UserMeteredEventHavingMaxInput: UserMeteredEventHavingMaxInput;
  UserMeteredEventHavingMinInput: UserMeteredEventHavingMinInput;
  UserMeteredEventHavingStddevPopulationInput: UserMeteredEventHavingStddevPopulationInput;
  UserMeteredEventHavingStddevSampleInput: UserMeteredEventHavingStddevSampleInput;
  UserMeteredEventHavingSumInput: UserMeteredEventHavingSumInput;
  UserMeteredEventHavingVariancePopulationInput: UserMeteredEventHavingVariancePopulationInput;
  UserMeteredEventHavingVarianceSampleInput: UserMeteredEventHavingVarianceSampleInput;
  UserMeteredEventMaxAggregateFilter: UserMeteredEventMaxAggregateFilter;
  UserMeteredEventMaxAggregates: ResolverTypeWrapper<UserMeteredEventMaxAggregates>;
  UserMeteredEventMinAggregateFilter: UserMeteredEventMinAggregateFilter;
  UserMeteredEventMinAggregates: ResolverTypeWrapper<UserMeteredEventMinAggregates>;
  UserMeteredEventOrderBy: UserMeteredEventOrderBy;
  UserMeteredEventStddevPopulationAggregateFilter: UserMeteredEventStddevPopulationAggregateFilter;
  UserMeteredEventStddevPopulationAggregates: ResolverTypeWrapper<UserMeteredEventStddevPopulationAggregates>;
  UserMeteredEventStddevSampleAggregateFilter: UserMeteredEventStddevSampleAggregateFilter;
  UserMeteredEventStddevSampleAggregates: ResolverTypeWrapper<UserMeteredEventStddevSampleAggregates>;
  UserMeteredEventSumAggregateFilter: UserMeteredEventSumAggregateFilter;
  UserMeteredEventSumAggregates: ResolverTypeWrapper<UserMeteredEventSumAggregates>;
  UserMeteredEventVariancePopulationAggregateFilter: UserMeteredEventVariancePopulationAggregateFilter;
  UserMeteredEventVariancePopulationAggregates: ResolverTypeWrapper<UserMeteredEventVariancePopulationAggregates>;
  UserMeteredEventVarianceSampleAggregateFilter: UserMeteredEventVarianceSampleAggregateFilter;
  UserMeteredEventVarianceSampleAggregates: ResolverTypeWrapper<UserMeteredEventVarianceSampleAggregates>;
  UserMinAggregates: ResolverTypeWrapper<UserMinAggregates>;
  UserNote: ResolverTypeWrapper<UserNote>;
  UserNoteAggregates: ResolverTypeWrapper<UserNoteAggregates>;
  UserNoteAggregatesFilter: UserNoteAggregatesFilter;
  UserNoteAverageAggregateFilter: UserNoteAverageAggregateFilter;
  UserNoteAverageAggregates: ResolverTypeWrapper<UserNoteAverageAggregates>;
  UserNoteCondition: UserNoteCondition;
  UserNoteConnection: ResolverTypeWrapper<UserNoteConnection>;
  UserNoteDistinctCountAggregateFilter: UserNoteDistinctCountAggregateFilter;
  UserNoteDistinctCountAggregates: ResolverTypeWrapper<UserNoteDistinctCountAggregates>;
  UserNoteEdge: ResolverTypeWrapper<UserNoteEdge>;
  UserNoteFilter: UserNoteFilter;
  UserNoteGroupBy: UserNoteGroupBy;
  UserNoteHavingAverageInput: UserNoteHavingAverageInput;
  UserNoteHavingDistinctCountInput: UserNoteHavingDistinctCountInput;
  UserNoteHavingInput: UserNoteHavingInput;
  UserNoteHavingMaxInput: UserNoteHavingMaxInput;
  UserNoteHavingMinInput: UserNoteHavingMinInput;
  UserNoteHavingStddevPopulationInput: UserNoteHavingStddevPopulationInput;
  UserNoteHavingStddevSampleInput: UserNoteHavingStddevSampleInput;
  UserNoteHavingSumInput: UserNoteHavingSumInput;
  UserNoteHavingVariancePopulationInput: UserNoteHavingVariancePopulationInput;
  UserNoteHavingVarianceSampleInput: UserNoteHavingVarianceSampleInput;
  UserNoteMaxAggregateFilter: UserNoteMaxAggregateFilter;
  UserNoteMaxAggregates: ResolverTypeWrapper<UserNoteMaxAggregates>;
  UserNoteMinAggregateFilter: UserNoteMinAggregateFilter;
  UserNoteMinAggregates: ResolverTypeWrapper<UserNoteMinAggregates>;
  UserNoteOrderBy: UserNoteOrderBy;
  UserNoteStddevPopulationAggregateFilter: UserNoteStddevPopulationAggregateFilter;
  UserNoteStddevPopulationAggregates: ResolverTypeWrapper<UserNoteStddevPopulationAggregates>;
  UserNoteStddevSampleAggregateFilter: UserNoteStddevSampleAggregateFilter;
  UserNoteStddevSampleAggregates: ResolverTypeWrapper<UserNoteStddevSampleAggregates>;
  UserNoteSumAggregateFilter: UserNoteSumAggregateFilter;
  UserNoteSumAggregates: ResolverTypeWrapper<UserNoteSumAggregates>;
  UserNoteVariancePopulationAggregateFilter: UserNoteVariancePopulationAggregateFilter;
  UserNoteVariancePopulationAggregates: ResolverTypeWrapper<UserNoteVariancePopulationAggregates>;
  UserNoteVarianceSampleAggregateFilter: UserNoteVarianceSampleAggregateFilter;
  UserNoteVarianceSampleAggregates: ResolverTypeWrapper<UserNoteVarianceSampleAggregates>;
  UserOrderBy: UserOrderBy;
  UserPlatformCredential: ResolverTypeWrapper<UserPlatformCredential>;
  UserPlatformCredentialAggregates: ResolverTypeWrapper<UserPlatformCredentialAggregates>;
  UserPlatformCredentialAggregatesFilter: UserPlatformCredentialAggregatesFilter;
  UserPlatformCredentialAverageAggregateFilter: UserPlatformCredentialAverageAggregateFilter;
  UserPlatformCredentialAverageAggregates: ResolverTypeWrapper<UserPlatformCredentialAverageAggregates>;
  UserPlatformCredentialCondition: UserPlatformCredentialCondition;
  UserPlatformCredentialConnection: ResolverTypeWrapper<UserPlatformCredentialConnection>;
  UserPlatformCredentialDistinctCountAggregateFilter: UserPlatformCredentialDistinctCountAggregateFilter;
  UserPlatformCredentialDistinctCountAggregates: ResolverTypeWrapper<UserPlatformCredentialDistinctCountAggregates>;
  UserPlatformCredentialEdge: ResolverTypeWrapper<UserPlatformCredentialEdge>;
  UserPlatformCredentialFilter: UserPlatformCredentialFilter;
  UserPlatformCredentialGroupBy: UserPlatformCredentialGroupBy;
  UserPlatformCredentialHavingAverageInput: UserPlatformCredentialHavingAverageInput;
  UserPlatformCredentialHavingDistinctCountInput: UserPlatformCredentialHavingDistinctCountInput;
  UserPlatformCredentialHavingInput: UserPlatformCredentialHavingInput;
  UserPlatformCredentialHavingMaxInput: UserPlatformCredentialHavingMaxInput;
  UserPlatformCredentialHavingMinInput: UserPlatformCredentialHavingMinInput;
  UserPlatformCredentialHavingStddevPopulationInput: UserPlatformCredentialHavingStddevPopulationInput;
  UserPlatformCredentialHavingStddevSampleInput: UserPlatformCredentialHavingStddevSampleInput;
  UserPlatformCredentialHavingSumInput: UserPlatformCredentialHavingSumInput;
  UserPlatformCredentialHavingVariancePopulationInput: UserPlatformCredentialHavingVariancePopulationInput;
  UserPlatformCredentialHavingVarianceSampleInput: UserPlatformCredentialHavingVarianceSampleInput;
  UserPlatformCredentialMaxAggregateFilter: UserPlatformCredentialMaxAggregateFilter;
  UserPlatformCredentialMaxAggregates: ResolverTypeWrapper<UserPlatformCredentialMaxAggregates>;
  UserPlatformCredentialMinAggregateFilter: UserPlatformCredentialMinAggregateFilter;
  UserPlatformCredentialMinAggregates: ResolverTypeWrapper<UserPlatformCredentialMinAggregates>;
  UserPlatformCredentialOrderBy: UserPlatformCredentialOrderBy;
  UserPlatformCredentialStddevPopulationAggregateFilter: UserPlatformCredentialStddevPopulationAggregateFilter;
  UserPlatformCredentialStddevPopulationAggregates: ResolverTypeWrapper<UserPlatformCredentialStddevPopulationAggregates>;
  UserPlatformCredentialStddevSampleAggregateFilter: UserPlatformCredentialStddevSampleAggregateFilter;
  UserPlatformCredentialStddevSampleAggregates: ResolverTypeWrapper<UserPlatformCredentialStddevSampleAggregates>;
  UserPlatformCredentialSumAggregateFilter: UserPlatformCredentialSumAggregateFilter;
  UserPlatformCredentialSumAggregates: ResolverTypeWrapper<UserPlatformCredentialSumAggregates>;
  UserPlatformCredentialVariancePopulationAggregateFilter: UserPlatformCredentialVariancePopulationAggregateFilter;
  UserPlatformCredentialVariancePopulationAggregates: ResolverTypeWrapper<UserPlatformCredentialVariancePopulationAggregates>;
  UserPlatformCredentialVarianceSampleAggregateFilter: UserPlatformCredentialVarianceSampleAggregateFilter;
  UserPlatformCredentialVarianceSampleAggregates: ResolverTypeWrapper<UserPlatformCredentialVarianceSampleAggregates>;
  UserRolesAdminRole: ResolverTypeWrapper<UserRolesAdminRole>;
  UserRolesAdminRoleAggregates: ResolverTypeWrapper<UserRolesAdminRoleAggregates>;
  UserRolesAdminRoleAggregatesFilter: UserRolesAdminRoleAggregatesFilter;
  UserRolesAdminRoleAverageAggregateFilter: UserRolesAdminRoleAverageAggregateFilter;
  UserRolesAdminRoleAverageAggregates: ResolverTypeWrapper<UserRolesAdminRoleAverageAggregates>;
  UserRolesAdminRoleCondition: UserRolesAdminRoleCondition;
  UserRolesAdminRoleConnection: ResolverTypeWrapper<UserRolesAdminRoleConnection>;
  UserRolesAdminRoleDistinctCountAggregateFilter: UserRolesAdminRoleDistinctCountAggregateFilter;
  UserRolesAdminRoleDistinctCountAggregates: ResolverTypeWrapper<UserRolesAdminRoleDistinctCountAggregates>;
  UserRolesAdminRoleEdge: ResolverTypeWrapper<UserRolesAdminRoleEdge>;
  UserRolesAdminRoleFilter: UserRolesAdminRoleFilter;
  UserRolesAdminRoleGroupBy: UserRolesAdminRoleGroupBy;
  UserRolesAdminRoleHavingAverageInput: UserRolesAdminRoleHavingAverageInput;
  UserRolesAdminRoleHavingDistinctCountInput: UserRolesAdminRoleHavingDistinctCountInput;
  UserRolesAdminRoleHavingInput: UserRolesAdminRoleHavingInput;
  UserRolesAdminRoleHavingMaxInput: UserRolesAdminRoleHavingMaxInput;
  UserRolesAdminRoleHavingMinInput: UserRolesAdminRoleHavingMinInput;
  UserRolesAdminRoleHavingStddevPopulationInput: UserRolesAdminRoleHavingStddevPopulationInput;
  UserRolesAdminRoleHavingStddevSampleInput: UserRolesAdminRoleHavingStddevSampleInput;
  UserRolesAdminRoleHavingSumInput: UserRolesAdminRoleHavingSumInput;
  UserRolesAdminRoleHavingVariancePopulationInput: UserRolesAdminRoleHavingVariancePopulationInput;
  UserRolesAdminRoleHavingVarianceSampleInput: UserRolesAdminRoleHavingVarianceSampleInput;
  UserRolesAdminRoleMaxAggregateFilter: UserRolesAdminRoleMaxAggregateFilter;
  UserRolesAdminRoleMaxAggregates: ResolverTypeWrapper<UserRolesAdminRoleMaxAggregates>;
  UserRolesAdminRoleMinAggregateFilter: UserRolesAdminRoleMinAggregateFilter;
  UserRolesAdminRoleMinAggregates: ResolverTypeWrapper<UserRolesAdminRoleMinAggregates>;
  UserRolesAdminRoleOrderBy: UserRolesAdminRoleOrderBy;
  UserRolesAdminRoleStddevPopulationAggregateFilter: UserRolesAdminRoleStddevPopulationAggregateFilter;
  UserRolesAdminRoleStddevPopulationAggregates: ResolverTypeWrapper<UserRolesAdminRoleStddevPopulationAggregates>;
  UserRolesAdminRoleStddevSampleAggregateFilter: UserRolesAdminRoleStddevSampleAggregateFilter;
  UserRolesAdminRoleStddevSampleAggregates: ResolverTypeWrapper<UserRolesAdminRoleStddevSampleAggregates>;
  UserRolesAdminRoleSumAggregateFilter: UserRolesAdminRoleSumAggregateFilter;
  UserRolesAdminRoleSumAggregates: ResolverTypeWrapper<UserRolesAdminRoleSumAggregates>;
  UserRolesAdminRoleVariancePopulationAggregateFilter: UserRolesAdminRoleVariancePopulationAggregateFilter;
  UserRolesAdminRoleVariancePopulationAggregates: ResolverTypeWrapper<UserRolesAdminRoleVariancePopulationAggregates>;
  UserRolesAdminRoleVarianceSampleAggregateFilter: UserRolesAdminRoleVarianceSampleAggregateFilter;
  UserRolesAdminRoleVarianceSampleAggregates: ResolverTypeWrapper<UserRolesAdminRoleVarianceSampleAggregates>;
  UserStddevPopulationAggregates: ResolverTypeWrapper<UserStddevPopulationAggregates>;
  UserStddevSampleAggregates: ResolverTypeWrapper<UserStddevSampleAggregates>;
  UserSubscription: ResolverTypeWrapper<UserSubscription>;
  UserSubscriptionAggregates: ResolverTypeWrapper<UserSubscriptionAggregates>;
  UserSubscriptionAggregatesFilter: UserSubscriptionAggregatesFilter;
  UserSubscriptionAverageAggregateFilter: UserSubscriptionAverageAggregateFilter;
  UserSubscriptionAverageAggregates: ResolverTypeWrapper<UserSubscriptionAverageAggregates>;
  UserSubscriptionCondition: UserSubscriptionCondition;
  UserSubscriptionConnection: ResolverTypeWrapper<UserSubscriptionConnection>;
  UserSubscriptionDistinctCountAggregateFilter: UserSubscriptionDistinctCountAggregateFilter;
  UserSubscriptionDistinctCountAggregates: ResolverTypeWrapper<UserSubscriptionDistinctCountAggregates>;
  UserSubscriptionEdge: ResolverTypeWrapper<UserSubscriptionEdge>;
  UserSubscriptionFilter: UserSubscriptionFilter;
  UserSubscriptionGroupBy: UserSubscriptionGroupBy;
  UserSubscriptionHavingAverageInput: UserSubscriptionHavingAverageInput;
  UserSubscriptionHavingDistinctCountInput: UserSubscriptionHavingDistinctCountInput;
  UserSubscriptionHavingInput: UserSubscriptionHavingInput;
  UserSubscriptionHavingMaxInput: UserSubscriptionHavingMaxInput;
  UserSubscriptionHavingMinInput: UserSubscriptionHavingMinInput;
  UserSubscriptionHavingStddevPopulationInput: UserSubscriptionHavingStddevPopulationInput;
  UserSubscriptionHavingStddevSampleInput: UserSubscriptionHavingStddevSampleInput;
  UserSubscriptionHavingSumInput: UserSubscriptionHavingSumInput;
  UserSubscriptionHavingVariancePopulationInput: UserSubscriptionHavingVariancePopulationInput;
  UserSubscriptionHavingVarianceSampleInput: UserSubscriptionHavingVarianceSampleInput;
  UserSubscriptionMaxAggregateFilter: UserSubscriptionMaxAggregateFilter;
  UserSubscriptionMaxAggregates: ResolverTypeWrapper<UserSubscriptionMaxAggregates>;
  UserSubscriptionMinAggregateFilter: UserSubscriptionMinAggregateFilter;
  UserSubscriptionMinAggregates: ResolverTypeWrapper<UserSubscriptionMinAggregates>;
  UserSubscriptionOrderBy: UserSubscriptionOrderBy;
  UserSubscriptionStddevPopulationAggregateFilter: UserSubscriptionStddevPopulationAggregateFilter;
  UserSubscriptionStddevPopulationAggregates: ResolverTypeWrapper<UserSubscriptionStddevPopulationAggregates>;
  UserSubscriptionStddevSampleAggregateFilter: UserSubscriptionStddevSampleAggregateFilter;
  UserSubscriptionStddevSampleAggregates: ResolverTypeWrapper<UserSubscriptionStddevSampleAggregates>;
  UserSubscriptionSumAggregateFilter: UserSubscriptionSumAggregateFilter;
  UserSubscriptionSumAggregates: ResolverTypeWrapper<UserSubscriptionSumAggregates>;
  UserSubscriptionToManyAccountFilter: UserSubscriptionToManyAccountFilter;
  UserSubscriptionToManyNmiSubscriptionFilter: UserSubscriptionToManyNmiSubscriptionFilter;
  UserSubscriptionVariancePopulationAggregateFilter: UserSubscriptionVariancePopulationAggregateFilter;
  UserSubscriptionVariancePopulationAggregates: ResolverTypeWrapper<UserSubscriptionVariancePopulationAggregates>;
  UserSubscriptionVarianceSampleAggregateFilter: UserSubscriptionVarianceSampleAggregateFilter;
  UserSubscriptionVarianceSampleAggregates: ResolverTypeWrapper<UserSubscriptionVarianceSampleAggregates>;
  UserSumAggregates: ResolverTypeWrapper<UserSumAggregates>;
  UserTaxForm: ResolverTypeWrapper<UserTaxForm>;
  UserTaxFormAggregates: ResolverTypeWrapper<UserTaxFormAggregates>;
  UserTaxFormAggregatesFilter: UserTaxFormAggregatesFilter;
  UserTaxFormAverageAggregateFilter: UserTaxFormAverageAggregateFilter;
  UserTaxFormAverageAggregates: ResolverTypeWrapper<UserTaxFormAverageAggregates>;
  UserTaxFormCondition: UserTaxFormCondition;
  UserTaxFormConnection: ResolverTypeWrapper<UserTaxFormConnection>;
  UserTaxFormDistinctCountAggregateFilter: UserTaxFormDistinctCountAggregateFilter;
  UserTaxFormDistinctCountAggregates: ResolverTypeWrapper<UserTaxFormDistinctCountAggregates>;
  UserTaxFormEdge: ResolverTypeWrapper<UserTaxFormEdge>;
  UserTaxFormFilter: UserTaxFormFilter;
  UserTaxFormGroupBy: UserTaxFormGroupBy;
  UserTaxFormHavingAverageInput: UserTaxFormHavingAverageInput;
  UserTaxFormHavingDistinctCountInput: UserTaxFormHavingDistinctCountInput;
  UserTaxFormHavingInput: UserTaxFormHavingInput;
  UserTaxFormHavingMaxInput: UserTaxFormHavingMaxInput;
  UserTaxFormHavingMinInput: UserTaxFormHavingMinInput;
  UserTaxFormHavingStddevPopulationInput: UserTaxFormHavingStddevPopulationInput;
  UserTaxFormHavingStddevSampleInput: UserTaxFormHavingStddevSampleInput;
  UserTaxFormHavingSumInput: UserTaxFormHavingSumInput;
  UserTaxFormHavingVariancePopulationInput: UserTaxFormHavingVariancePopulationInput;
  UserTaxFormHavingVarianceSampleInput: UserTaxFormHavingVarianceSampleInput;
  UserTaxFormInput: UserTaxFormInput;
  UserTaxFormMaxAggregateFilter: UserTaxFormMaxAggregateFilter;
  UserTaxFormMaxAggregates: ResolverTypeWrapper<UserTaxFormMaxAggregates>;
  UserTaxFormMinAggregateFilter: UserTaxFormMinAggregateFilter;
  UserTaxFormMinAggregates: ResolverTypeWrapper<UserTaxFormMinAggregates>;
  UserTaxFormOrderBy: UserTaxFormOrderBy;
  UserTaxFormPatch: UserTaxFormPatch;
  UserTaxFormStddevPopulationAggregateFilter: UserTaxFormStddevPopulationAggregateFilter;
  UserTaxFormStddevPopulationAggregates: ResolverTypeWrapper<UserTaxFormStddevPopulationAggregates>;
  UserTaxFormStddevSampleAggregateFilter: UserTaxFormStddevSampleAggregateFilter;
  UserTaxFormStddevSampleAggregates: ResolverTypeWrapper<UserTaxFormStddevSampleAggregates>;
  UserTaxFormSumAggregateFilter: UserTaxFormSumAggregateFilter;
  UserTaxFormSumAggregates: ResolverTypeWrapper<UserTaxFormSumAggregates>;
  UserTaxFormVariancePopulationAggregateFilter: UserTaxFormVariancePopulationAggregateFilter;
  UserTaxFormVariancePopulationAggregates: ResolverTypeWrapper<UserTaxFormVariancePopulationAggregates>;
  UserTaxFormVarianceSampleAggregateFilter: UserTaxFormVarianceSampleAggregateFilter;
  UserTaxFormVarianceSampleAggregates: ResolverTypeWrapper<UserTaxFormVarianceSampleAggregates>;
  UserTaxFormsEntityTypeEnum: UserTaxFormsEntityTypeEnum;
  UserTaxFormsFormTypeEnum: UserTaxFormsFormTypeEnum;
  UserTaxFormsStatusEnum: UserTaxFormsStatusEnum;
  UserTcPurchaseLimit: ResolverTypeWrapper<UserTcPurchaseLimit>;
  UserTcPurchaseLimitAggregates: ResolverTypeWrapper<UserTcPurchaseLimitAggregates>;
  UserTcPurchaseLimitAggregatesFilter: UserTcPurchaseLimitAggregatesFilter;
  UserTcPurchaseLimitAverageAggregateFilter: UserTcPurchaseLimitAverageAggregateFilter;
  UserTcPurchaseLimitAverageAggregates: ResolverTypeWrapper<UserTcPurchaseLimitAverageAggregates>;
  UserTcPurchaseLimitCondition: UserTcPurchaseLimitCondition;
  UserTcPurchaseLimitConnection: ResolverTypeWrapper<UserTcPurchaseLimitConnection>;
  UserTcPurchaseLimitDistinctCountAggregateFilter: UserTcPurchaseLimitDistinctCountAggregateFilter;
  UserTcPurchaseLimitDistinctCountAggregates: ResolverTypeWrapper<UserTcPurchaseLimitDistinctCountAggregates>;
  UserTcPurchaseLimitEdge: ResolverTypeWrapper<UserTcPurchaseLimitEdge>;
  UserTcPurchaseLimitFilter: UserTcPurchaseLimitFilter;
  UserTcPurchaseLimitGroupBy: UserTcPurchaseLimitGroupBy;
  UserTcPurchaseLimitHavingAverageInput: UserTcPurchaseLimitHavingAverageInput;
  UserTcPurchaseLimitHavingDistinctCountInput: UserTcPurchaseLimitHavingDistinctCountInput;
  UserTcPurchaseLimitHavingInput: UserTcPurchaseLimitHavingInput;
  UserTcPurchaseLimitHavingMaxInput: UserTcPurchaseLimitHavingMaxInput;
  UserTcPurchaseLimitHavingMinInput: UserTcPurchaseLimitHavingMinInput;
  UserTcPurchaseLimitHavingStddevPopulationInput: UserTcPurchaseLimitHavingStddevPopulationInput;
  UserTcPurchaseLimitHavingStddevSampleInput: UserTcPurchaseLimitHavingStddevSampleInput;
  UserTcPurchaseLimitHavingSumInput: UserTcPurchaseLimitHavingSumInput;
  UserTcPurchaseLimitHavingVariancePopulationInput: UserTcPurchaseLimitHavingVariancePopulationInput;
  UserTcPurchaseLimitHavingVarianceSampleInput: UserTcPurchaseLimitHavingVarianceSampleInput;
  UserTcPurchaseLimitMaxAggregateFilter: UserTcPurchaseLimitMaxAggregateFilter;
  UserTcPurchaseLimitMaxAggregates: ResolverTypeWrapper<UserTcPurchaseLimitMaxAggregates>;
  UserTcPurchaseLimitMinAggregateFilter: UserTcPurchaseLimitMinAggregateFilter;
  UserTcPurchaseLimitMinAggregates: ResolverTypeWrapper<UserTcPurchaseLimitMinAggregates>;
  UserTcPurchaseLimitOrderBy: UserTcPurchaseLimitOrderBy;
  UserTcPurchaseLimitStddevPopulationAggregateFilter: UserTcPurchaseLimitStddevPopulationAggregateFilter;
  UserTcPurchaseLimitStddevPopulationAggregates: ResolverTypeWrapper<UserTcPurchaseLimitStddevPopulationAggregates>;
  UserTcPurchaseLimitStddevSampleAggregateFilter: UserTcPurchaseLimitStddevSampleAggregateFilter;
  UserTcPurchaseLimitStddevSampleAggregates: ResolverTypeWrapper<UserTcPurchaseLimitStddevSampleAggregates>;
  UserTcPurchaseLimitSumAggregateFilter: UserTcPurchaseLimitSumAggregateFilter;
  UserTcPurchaseLimitSumAggregates: ResolverTypeWrapper<UserTcPurchaseLimitSumAggregates>;
  UserTcPurchaseLimitVariancePopulationAggregateFilter: UserTcPurchaseLimitVariancePopulationAggregateFilter;
  UserTcPurchaseLimitVariancePopulationAggregates: ResolverTypeWrapper<UserTcPurchaseLimitVariancePopulationAggregates>;
  UserTcPurchaseLimitVarianceSampleAggregateFilter: UserTcPurchaseLimitVarianceSampleAggregateFilter;
  UserTcPurchaseLimitVarianceSampleAggregates: ResolverTypeWrapper<UserTcPurchaseLimitVarianceSampleAggregates>;
  UserToManyAccountCallUpDecisionCalculationFilter: UserToManyAccountCallUpDecisionCalculationFilter;
  UserToManyAccountCallUpDecisionFilter: UserToManyAccountCallUpDecisionFilter;
  UserToManyAccountCapitalEntryFilter: UserToManyAccountCapitalEntryFilter;
  UserToManyAccountFilter: UserToManyAccountFilter;
  UserToManyAccountResetLimitFilter: UserToManyAccountResetLimitFilter;
  UserToManyAccountResetTrackingFilter: UserToManyAccountResetTrackingFilter;
  UserToManyAdminRoleUsersUserFilter: UserToManyAdminRoleUsersUserFilter;
  UserToManyCardTransactionFilter: UserToManyCardTransactionFilter;
  UserToManyCheckoutSessionFilter: UserToManyCheckoutSessionFilter;
  UserToManyCouponUserFilter: UserToManyCouponUserFilter;
  UserToManyEmailFilter: UserToManyEmailFilter;
  UserToManyGroupAdminFilter: UserToManyGroupAdminFilter;
  UserToManyImpactGroupAssignmentFilter: UserToManyImpactGroupAssignmentFilter;
  UserToManyNuveiSavedCardFilter: UserToManyNuveiSavedCardFilter;
  UserToManyPasswordHistoryFilter: UserToManyPasswordHistoryFilter;
  UserToManyPayoutRequestBatchFilter: UserToManyPayoutRequestBatchFilter;
  UserToManyPayoutRequestFilter: UserToManyPayoutRequestFilter;
  UserToManyPayoutRequestSubscriberFilter: UserToManyPayoutRequestSubscriberFilter;
  UserToManyPersonaWebhookEventFilter: UserToManyPersonaWebhookEventFilter;
  UserToManyPurchaseOrderFilter: UserToManyPurchaseOrderFilter;
  UserToManyRebillSessionFilter: UserToManyRebillSessionFilter;
  UserToManyResetCreditFilter: UserToManyResetCreditFilter;
  UserToManySavedCardFilter: UserToManySavedCardFilter;
  UserToManyTaxInfoFilter: UserToManyTaxInfoFilter;
  UserToManyTraderProfileModerationCaseFilter: UserToManyTraderProfileModerationCaseFilter;
  UserToManyTraderRiskIndicatorFilter: UserToManyTraderRiskIndicatorFilter;
  UserToManyUserAddressFilter: UserToManyUserAddressFilter;
  UserToManyUserAdminRoleFilter: UserToManyUserAdminRoleFilter;
  UserToManyUserAgreementFilter: UserToManyUserAgreementFilter;
  UserToManyUserCertificateFilter: UserToManyUserCertificateFilter;
  UserToManyUserCooldownFilter: UserToManyUserCooldownFilter;
  UserToManyUserMeteredEventFilter: UserToManyUserMeteredEventFilter;
  UserToManyUserNoteFilter: UserToManyUserNoteFilter;
  UserToManyUserPlatformCredentialFilter: UserToManyUserPlatformCredentialFilter;
  UserToManyUserRolesAdminRoleFilter: UserToManyUserRolesAdminRoleFilter;
  UserToManyUserTaxFormFilter: UserToManyUserTaxFormFilter;
  UserToManyUserTcPurchaseLimitFilter: UserToManyUserTcPurchaseLimitFilter;
  UserToManyUserXfaCooldownFilter: UserToManyUserXfaCooldownFilter;
  UserToManyVerificationFilter: UserToManyVerificationFilter;
  UserVariancePopulationAggregates: ResolverTypeWrapper<UserVariancePopulationAggregates>;
  UserVarianceSampleAggregates: ResolverTypeWrapper<UserVarianceSampleAggregates>;
  UserXfaCooldown: ResolverTypeWrapper<UserXfaCooldown>;
  UserXfaCooldownAggregates: ResolverTypeWrapper<UserXfaCooldownAggregates>;
  UserXfaCooldownAggregatesFilter: UserXfaCooldownAggregatesFilter;
  UserXfaCooldownAverageAggregateFilter: UserXfaCooldownAverageAggregateFilter;
  UserXfaCooldownAverageAggregates: ResolverTypeWrapper<UserXfaCooldownAverageAggregates>;
  UserXfaCooldownCondition: UserXfaCooldownCondition;
  UserXfaCooldownConnection: ResolverTypeWrapper<UserXfaCooldownConnection>;
  UserXfaCooldownDistinctCountAggregateFilter: UserXfaCooldownDistinctCountAggregateFilter;
  UserXfaCooldownDistinctCountAggregates: ResolverTypeWrapper<UserXfaCooldownDistinctCountAggregates>;
  UserXfaCooldownEdge: ResolverTypeWrapper<UserXfaCooldownEdge>;
  UserXfaCooldownFilter: UserXfaCooldownFilter;
  UserXfaCooldownGroupBy: UserXfaCooldownGroupBy;
  UserXfaCooldownHavingAverageInput: UserXfaCooldownHavingAverageInput;
  UserXfaCooldownHavingDistinctCountInput: UserXfaCooldownHavingDistinctCountInput;
  UserXfaCooldownHavingInput: UserXfaCooldownHavingInput;
  UserXfaCooldownHavingMaxInput: UserXfaCooldownHavingMaxInput;
  UserXfaCooldownHavingMinInput: UserXfaCooldownHavingMinInput;
  UserXfaCooldownHavingStddevPopulationInput: UserXfaCooldownHavingStddevPopulationInput;
  UserXfaCooldownHavingStddevSampleInput: UserXfaCooldownHavingStddevSampleInput;
  UserXfaCooldownHavingSumInput: UserXfaCooldownHavingSumInput;
  UserXfaCooldownHavingVariancePopulationInput: UserXfaCooldownHavingVariancePopulationInput;
  UserXfaCooldownHavingVarianceSampleInput: UserXfaCooldownHavingVarianceSampleInput;
  UserXfaCooldownMaxAggregateFilter: UserXfaCooldownMaxAggregateFilter;
  UserXfaCooldownMaxAggregates: ResolverTypeWrapper<UserXfaCooldownMaxAggregates>;
  UserXfaCooldownMinAggregateFilter: UserXfaCooldownMinAggregateFilter;
  UserXfaCooldownMinAggregates: ResolverTypeWrapper<UserXfaCooldownMinAggregates>;
  UserXfaCooldownOrderBy: UserXfaCooldownOrderBy;
  UserXfaCooldownStddevPopulationAggregateFilter: UserXfaCooldownStddevPopulationAggregateFilter;
  UserXfaCooldownStddevPopulationAggregates: ResolverTypeWrapper<UserXfaCooldownStddevPopulationAggregates>;
  UserXfaCooldownStddevSampleAggregateFilter: UserXfaCooldownStddevSampleAggregateFilter;
  UserXfaCooldownStddevSampleAggregates: ResolverTypeWrapper<UserXfaCooldownStddevSampleAggregates>;
  UserXfaCooldownSumAggregateFilter: UserXfaCooldownSumAggregateFilter;
  UserXfaCooldownSumAggregates: ResolverTypeWrapper<UserXfaCooldownSumAggregates>;
  UserXfaCooldownVariancePopulationAggregateFilter: UserXfaCooldownVariancePopulationAggregateFilter;
  UserXfaCooldownVariancePopulationAggregates: ResolverTypeWrapper<UserXfaCooldownVariancePopulationAggregates>;
  UserXfaCooldownVarianceSampleAggregateFilter: UserXfaCooldownVarianceSampleAggregateFilter;
  UserXfaCooldownVarianceSampleAggregates: ResolverTypeWrapper<UserXfaCooldownVarianceSampleAggregates>;
  Verification: ResolverTypeWrapper<Verification>;
  VerificationAggregates: ResolverTypeWrapper<VerificationAggregates>;
  VerificationAggregatesFilter: VerificationAggregatesFilter;
  VerificationAverageAggregateFilter: VerificationAverageAggregateFilter;
  VerificationAverageAggregates: ResolverTypeWrapper<VerificationAverageAggregates>;
  VerificationCondition: VerificationCondition;
  VerificationConnection: ResolverTypeWrapper<VerificationConnection>;
  VerificationDistinctCountAggregateFilter: VerificationDistinctCountAggregateFilter;
  VerificationDistinctCountAggregates: ResolverTypeWrapper<VerificationDistinctCountAggregates>;
  VerificationEdge: ResolverTypeWrapper<VerificationEdge>;
  VerificationFilter: VerificationFilter;
  VerificationGroupBy: VerificationGroupBy;
  VerificationHavingAverageInput: VerificationHavingAverageInput;
  VerificationHavingDistinctCountInput: VerificationHavingDistinctCountInput;
  VerificationHavingInput: VerificationHavingInput;
  VerificationHavingMaxInput: VerificationHavingMaxInput;
  VerificationHavingMinInput: VerificationHavingMinInput;
  VerificationHavingStddevPopulationInput: VerificationHavingStddevPopulationInput;
  VerificationHavingStddevSampleInput: VerificationHavingStddevSampleInput;
  VerificationHavingSumInput: VerificationHavingSumInput;
  VerificationHavingVariancePopulationInput: VerificationHavingVariancePopulationInput;
  VerificationHavingVarianceSampleInput: VerificationHavingVarianceSampleInput;
  VerificationMaxAggregateFilter: VerificationMaxAggregateFilter;
  VerificationMaxAggregates: ResolverTypeWrapper<VerificationMaxAggregates>;
  VerificationMinAggregateFilter: VerificationMinAggregateFilter;
  VerificationMinAggregates: ResolverTypeWrapper<VerificationMinAggregates>;
  VerificationOrderBy: VerificationOrderBy;
  VerificationStddevPopulationAggregateFilter: VerificationStddevPopulationAggregateFilter;
  VerificationStddevPopulationAggregates: ResolverTypeWrapper<VerificationStddevPopulationAggregates>;
  VerificationStddevSampleAggregateFilter: VerificationStddevSampleAggregateFilter;
  VerificationStddevSampleAggregates: ResolverTypeWrapper<VerificationStddevSampleAggregates>;
  VerificationSumAggregateFilter: VerificationSumAggregateFilter;
  VerificationSumAggregates: ResolverTypeWrapper<VerificationSumAggregates>;
  VerificationVariancePopulationAggregateFilter: VerificationVariancePopulationAggregateFilter;
  VerificationVariancePopulationAggregates: ResolverTypeWrapper<VerificationVariancePopulationAggregates>;
  VerificationVarianceSampleAggregateFilter: VerificationVarianceSampleAggregateFilter;
  VerificationVarianceSampleAggregates: ResolverTypeWrapper<VerificationVarianceSampleAggregates>;
  VoidAccountCapitalEntryInput: VoidAccountCapitalEntryInput;
  W8BENSigningResult: ResolverTypeWrapper<W8BenSigningResult>;
  W9SigningResult: ResolverTypeWrapper<W9SigningResult>;
  WorstTradingDay: ResolverTypeWrapper<WorstTradingDay>;
  XfaActivationCredit: ResolverTypeWrapper<XfaActivationCredit>;
  XfaActivationCreditAggregates: ResolverTypeWrapper<XfaActivationCreditAggregates>;
  XfaActivationCreditAverageAggregates: ResolverTypeWrapper<XfaActivationCreditAverageAggregates>;
  XfaActivationCreditCondition: XfaActivationCreditCondition;
  XfaActivationCreditConnection: ResolverTypeWrapper<XfaActivationCreditConnection>;
  XfaActivationCreditDistinctCountAggregates: ResolverTypeWrapper<XfaActivationCreditDistinctCountAggregates>;
  XfaActivationCreditEdge: ResolverTypeWrapper<XfaActivationCreditEdge>;
  XfaActivationCreditFilter: XfaActivationCreditFilter;
  XfaActivationCreditGroupBy: XfaActivationCreditGroupBy;
  XfaActivationCreditHavingAverageInput: XfaActivationCreditHavingAverageInput;
  XfaActivationCreditHavingDistinctCountInput: XfaActivationCreditHavingDistinctCountInput;
  XfaActivationCreditHavingInput: XfaActivationCreditHavingInput;
  XfaActivationCreditHavingMaxInput: XfaActivationCreditHavingMaxInput;
  XfaActivationCreditHavingMinInput: XfaActivationCreditHavingMinInput;
  XfaActivationCreditHavingStddevPopulationInput: XfaActivationCreditHavingStddevPopulationInput;
  XfaActivationCreditHavingStddevSampleInput: XfaActivationCreditHavingStddevSampleInput;
  XfaActivationCreditHavingSumInput: XfaActivationCreditHavingSumInput;
  XfaActivationCreditHavingVariancePopulationInput: XfaActivationCreditHavingVariancePopulationInput;
  XfaActivationCreditHavingVarianceSampleInput: XfaActivationCreditHavingVarianceSampleInput;
  XfaActivationCreditInput: XfaActivationCreditInput;
  XfaActivationCreditMaxAggregates: ResolverTypeWrapper<XfaActivationCreditMaxAggregates>;
  XfaActivationCreditMinAggregates: ResolverTypeWrapper<XfaActivationCreditMinAggregates>;
  XfaActivationCreditOrderBy: XfaActivationCreditOrderBy;
  XfaActivationCreditPatch: XfaActivationCreditPatch;
  XfaActivationCreditStatusEnum: XfaActivationCreditStatusEnum;
  XfaActivationCreditStatusEnumFilter: XfaActivationCreditStatusEnumFilter;
  XfaActivationCreditStddevPopulationAggregates: ResolverTypeWrapper<XfaActivationCreditStddevPopulationAggregates>;
  XfaActivationCreditStddevSampleAggregates: ResolverTypeWrapper<XfaActivationCreditStddevSampleAggregates>;
  XfaActivationCreditSumAggregates: ResolverTypeWrapper<XfaActivationCreditSumAggregates>;
  XfaActivationCreditVariancePopulationAggregates: ResolverTypeWrapper<XfaActivationCreditVariancePopulationAggregates>;
  XfaActivationCreditVarianceSampleAggregates: ResolverTypeWrapper<XfaActivationCreditVarianceSampleAggregates>;
  XfaConsistencyMetrics: ResolverTypeWrapper<XfaConsistencyMetrics>;
  XfaResetTracking: ResolverTypeWrapper<XfaResetTracking>;
  XfaResetTrackingAggregates: ResolverTypeWrapper<XfaResetTrackingAggregates>;
  XfaResetTrackingAggregatesFilter: XfaResetTrackingAggregatesFilter;
  XfaResetTrackingAverageAggregateFilter: XfaResetTrackingAverageAggregateFilter;
  XfaResetTrackingAverageAggregates: ResolverTypeWrapper<XfaResetTrackingAverageAggregates>;
  XfaResetTrackingCondition: XfaResetTrackingCondition;
  XfaResetTrackingConnection: ResolverTypeWrapper<XfaResetTrackingConnection>;
  XfaResetTrackingDistinctCountAggregateFilter: XfaResetTrackingDistinctCountAggregateFilter;
  XfaResetTrackingDistinctCountAggregates: ResolverTypeWrapper<XfaResetTrackingDistinctCountAggregates>;
  XfaResetTrackingEdge: ResolverTypeWrapper<XfaResetTrackingEdge>;
  XfaResetTrackingFilter: XfaResetTrackingFilter;
  XfaResetTrackingGroupBy: XfaResetTrackingGroupBy;
  XfaResetTrackingHavingAverageInput: XfaResetTrackingHavingAverageInput;
  XfaResetTrackingHavingDistinctCountInput: XfaResetTrackingHavingDistinctCountInput;
  XfaResetTrackingHavingInput: XfaResetTrackingHavingInput;
  XfaResetTrackingHavingMaxInput: XfaResetTrackingHavingMaxInput;
  XfaResetTrackingHavingMinInput: XfaResetTrackingHavingMinInput;
  XfaResetTrackingHavingStddevPopulationInput: XfaResetTrackingHavingStddevPopulationInput;
  XfaResetTrackingHavingStddevSampleInput: XfaResetTrackingHavingStddevSampleInput;
  XfaResetTrackingHavingSumInput: XfaResetTrackingHavingSumInput;
  XfaResetTrackingHavingVariancePopulationInput: XfaResetTrackingHavingVariancePopulationInput;
  XfaResetTrackingHavingVarianceSampleInput: XfaResetTrackingHavingVarianceSampleInput;
  XfaResetTrackingMaxAggregateFilter: XfaResetTrackingMaxAggregateFilter;
  XfaResetTrackingMaxAggregates: ResolverTypeWrapper<XfaResetTrackingMaxAggregates>;
  XfaResetTrackingMinAggregateFilter: XfaResetTrackingMinAggregateFilter;
  XfaResetTrackingMinAggregates: ResolverTypeWrapper<XfaResetTrackingMinAggregates>;
  XfaResetTrackingOrderBy: XfaResetTrackingOrderBy;
  XfaResetTrackingStddevPopulationAggregateFilter: XfaResetTrackingStddevPopulationAggregateFilter;
  XfaResetTrackingStddevPopulationAggregates: ResolverTypeWrapper<XfaResetTrackingStddevPopulationAggregates>;
  XfaResetTrackingStddevSampleAggregateFilter: XfaResetTrackingStddevSampleAggregateFilter;
  XfaResetTrackingStddevSampleAggregates: ResolverTypeWrapper<XfaResetTrackingStddevSampleAggregates>;
  XfaResetTrackingSumAggregateFilter: XfaResetTrackingSumAggregateFilter;
  XfaResetTrackingSumAggregates: ResolverTypeWrapper<XfaResetTrackingSumAggregates>;
  XfaResetTrackingVariancePopulationAggregateFilter: XfaResetTrackingVariancePopulationAggregateFilter;
  XfaResetTrackingVariancePopulationAggregates: ResolverTypeWrapper<XfaResetTrackingVariancePopulationAggregates>;
  XfaResetTrackingVarianceSampleAggregateFilter: XfaResetTrackingVarianceSampleAggregateFilter;
  XfaResetTrackingVarianceSampleAggregates: ResolverTypeWrapper<XfaResetTrackingVarianceSampleAggregates>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Account: Account;
  AccountAdjustment: AccountAdjustment;
  AccountAggregates: AccountAggregates;
  AccountAggregatesFilter: AccountAggregatesFilter;
  AccountAudit: AccountAudit;
  AccountAverageAggregateFilter: AccountAverageAggregateFilter;
  AccountAverageAggregates: AccountAverageAggregates;
  AccountCallUpDecision: AccountCallUpDecision;
  AccountCallUpDecisionAggregates: AccountCallUpDecisionAggregates;
  AccountCallUpDecisionAggregatesFilter: AccountCallUpDecisionAggregatesFilter;
  AccountCallUpDecisionAverageAggregateFilter: AccountCallUpDecisionAverageAggregateFilter;
  AccountCallUpDecisionAverageAggregates: AccountCallUpDecisionAverageAggregates;
  AccountCallUpDecisionCalculation: AccountCallUpDecisionCalculation;
  AccountCallUpDecisionCalculationAggregates: AccountCallUpDecisionCalculationAggregates;
  AccountCallUpDecisionCalculationAggregatesFilter: AccountCallUpDecisionCalculationAggregatesFilter;
  AccountCallUpDecisionCalculationAverageAggregateFilter: AccountCallUpDecisionCalculationAverageAggregateFilter;
  AccountCallUpDecisionCalculationAverageAggregates: AccountCallUpDecisionCalculationAverageAggregates;
  AccountCallUpDecisionCalculationCondition: AccountCallUpDecisionCalculationCondition;
  AccountCallUpDecisionCalculationConnection: AccountCallUpDecisionCalculationConnection;
  AccountCallUpDecisionCalculationDistinctCountAggregateFilter: AccountCallUpDecisionCalculationDistinctCountAggregateFilter;
  AccountCallUpDecisionCalculationDistinctCountAggregates: AccountCallUpDecisionCalculationDistinctCountAggregates;
  AccountCallUpDecisionCalculationEdge: AccountCallUpDecisionCalculationEdge;
  AccountCallUpDecisionCalculationFilter: AccountCallUpDecisionCalculationFilter;
  AccountCallUpDecisionCalculationHavingAverageInput: AccountCallUpDecisionCalculationHavingAverageInput;
  AccountCallUpDecisionCalculationHavingDistinctCountInput: AccountCallUpDecisionCalculationHavingDistinctCountInput;
  AccountCallUpDecisionCalculationHavingInput: AccountCallUpDecisionCalculationHavingInput;
  AccountCallUpDecisionCalculationHavingMaxInput: AccountCallUpDecisionCalculationHavingMaxInput;
  AccountCallUpDecisionCalculationHavingMinInput: AccountCallUpDecisionCalculationHavingMinInput;
  AccountCallUpDecisionCalculationHavingStddevPopulationInput: AccountCallUpDecisionCalculationHavingStddevPopulationInput;
  AccountCallUpDecisionCalculationHavingStddevSampleInput: AccountCallUpDecisionCalculationHavingStddevSampleInput;
  AccountCallUpDecisionCalculationHavingSumInput: AccountCallUpDecisionCalculationHavingSumInput;
  AccountCallUpDecisionCalculationHavingVariancePopulationInput: AccountCallUpDecisionCalculationHavingVariancePopulationInput;
  AccountCallUpDecisionCalculationHavingVarianceSampleInput: AccountCallUpDecisionCalculationHavingVarianceSampleInput;
  AccountCallUpDecisionCalculationMaxAggregateFilter: AccountCallUpDecisionCalculationMaxAggregateFilter;
  AccountCallUpDecisionCalculationMaxAggregates: AccountCallUpDecisionCalculationMaxAggregates;
  AccountCallUpDecisionCalculationMinAggregateFilter: AccountCallUpDecisionCalculationMinAggregateFilter;
  AccountCallUpDecisionCalculationMinAggregates: AccountCallUpDecisionCalculationMinAggregates;
  AccountCallUpDecisionCalculationStddevPopulationAggregateFilter: AccountCallUpDecisionCalculationStddevPopulationAggregateFilter;
  AccountCallUpDecisionCalculationStddevPopulationAggregates: AccountCallUpDecisionCalculationStddevPopulationAggregates;
  AccountCallUpDecisionCalculationStddevSampleAggregateFilter: AccountCallUpDecisionCalculationStddevSampleAggregateFilter;
  AccountCallUpDecisionCalculationStddevSampleAggregates: AccountCallUpDecisionCalculationStddevSampleAggregates;
  AccountCallUpDecisionCalculationSumAggregateFilter: AccountCallUpDecisionCalculationSumAggregateFilter;
  AccountCallUpDecisionCalculationSumAggregates: AccountCallUpDecisionCalculationSumAggregates;
  AccountCallUpDecisionCalculationVariancePopulationAggregateFilter: AccountCallUpDecisionCalculationVariancePopulationAggregateFilter;
  AccountCallUpDecisionCalculationVariancePopulationAggregates: AccountCallUpDecisionCalculationVariancePopulationAggregates;
  AccountCallUpDecisionCalculationVarianceSampleAggregateFilter: AccountCallUpDecisionCalculationVarianceSampleAggregateFilter;
  AccountCallUpDecisionCalculationVarianceSampleAggregates: AccountCallUpDecisionCalculationVarianceSampleAggregates;
  AccountCallUpDecisionCondition: AccountCallUpDecisionCondition;
  AccountCallUpDecisionConnection: AccountCallUpDecisionConnection;
  AccountCallUpDecisionDistinctCountAggregateFilter: AccountCallUpDecisionDistinctCountAggregateFilter;
  AccountCallUpDecisionDistinctCountAggregates: AccountCallUpDecisionDistinctCountAggregates;
  AccountCallUpDecisionEdge: AccountCallUpDecisionEdge;
  AccountCallUpDecisionFilter: AccountCallUpDecisionFilter;
  AccountCallUpDecisionHavingAverageInput: AccountCallUpDecisionHavingAverageInput;
  AccountCallUpDecisionHavingDistinctCountInput: AccountCallUpDecisionHavingDistinctCountInput;
  AccountCallUpDecisionHavingInput: AccountCallUpDecisionHavingInput;
  AccountCallUpDecisionHavingMaxInput: AccountCallUpDecisionHavingMaxInput;
  AccountCallUpDecisionHavingMinInput: AccountCallUpDecisionHavingMinInput;
  AccountCallUpDecisionHavingStddevPopulationInput: AccountCallUpDecisionHavingStddevPopulationInput;
  AccountCallUpDecisionHavingStddevSampleInput: AccountCallUpDecisionHavingStddevSampleInput;
  AccountCallUpDecisionHavingSumInput: AccountCallUpDecisionHavingSumInput;
  AccountCallUpDecisionHavingVariancePopulationInput: AccountCallUpDecisionHavingVariancePopulationInput;
  AccountCallUpDecisionHavingVarianceSampleInput: AccountCallUpDecisionHavingVarianceSampleInput;
  AccountCallUpDecisionMaxAggregateFilter: AccountCallUpDecisionMaxAggregateFilter;
  AccountCallUpDecisionMaxAggregates: AccountCallUpDecisionMaxAggregates;
  AccountCallUpDecisionMinAggregateFilter: AccountCallUpDecisionMinAggregateFilter;
  AccountCallUpDecisionMinAggregates: AccountCallUpDecisionMinAggregates;
  AccountCallUpDecisionStddevPopulationAggregateFilter: AccountCallUpDecisionStddevPopulationAggregateFilter;
  AccountCallUpDecisionStddevPopulationAggregates: AccountCallUpDecisionStddevPopulationAggregates;
  AccountCallUpDecisionStddevSampleAggregateFilter: AccountCallUpDecisionStddevSampleAggregateFilter;
  AccountCallUpDecisionStddevSampleAggregates: AccountCallUpDecisionStddevSampleAggregates;
  AccountCallUpDecisionSumAggregateFilter: AccountCallUpDecisionSumAggregateFilter;
  AccountCallUpDecisionSumAggregates: AccountCallUpDecisionSumAggregates;
  AccountCallUpDecisionToManyAccountCallUpDecisionCalculationFilter: AccountCallUpDecisionToManyAccountCallUpDecisionCalculationFilter;
  AccountCallUpDecisionVariancePopulationAggregateFilter: AccountCallUpDecisionVariancePopulationAggregateFilter;
  AccountCallUpDecisionVariancePopulationAggregates: AccountCallUpDecisionVariancePopulationAggregates;
  AccountCallUpDecisionVarianceSampleAggregateFilter: AccountCallUpDecisionVarianceSampleAggregateFilter;
  AccountCallUpDecisionVarianceSampleAggregates: AccountCallUpDecisionVarianceSampleAggregates;
  AccountCallUpPayoutOffer: AccountCallUpPayoutOffer;
  AccountCapitalEntry: AccountCapitalEntry;
  AccountCapitalEntryAggregates: AccountCapitalEntryAggregates;
  AccountCapitalEntryAggregatesFilter: AccountCapitalEntryAggregatesFilter;
  AccountCapitalEntryAverageAggregateFilter: AccountCapitalEntryAverageAggregateFilter;
  AccountCapitalEntryAverageAggregates: AccountCapitalEntryAverageAggregates;
  AccountCapitalEntryCondition: AccountCapitalEntryCondition;
  AccountCapitalEntryConnection: AccountCapitalEntryConnection;
  AccountCapitalEntryDistinctCountAggregateFilter: AccountCapitalEntryDistinctCountAggregateFilter;
  AccountCapitalEntryDistinctCountAggregates: AccountCapitalEntryDistinctCountAggregates;
  AccountCapitalEntryEdge: AccountCapitalEntryEdge;
  AccountCapitalEntryFilter: AccountCapitalEntryFilter;
  AccountCapitalEntryHavingAverageInput: AccountCapitalEntryHavingAverageInput;
  AccountCapitalEntryHavingDistinctCountInput: AccountCapitalEntryHavingDistinctCountInput;
  AccountCapitalEntryHavingInput: AccountCapitalEntryHavingInput;
  AccountCapitalEntryHavingMaxInput: AccountCapitalEntryHavingMaxInput;
  AccountCapitalEntryHavingMinInput: AccountCapitalEntryHavingMinInput;
  AccountCapitalEntryHavingStddevPopulationInput: AccountCapitalEntryHavingStddevPopulationInput;
  AccountCapitalEntryHavingStddevSampleInput: AccountCapitalEntryHavingStddevSampleInput;
  AccountCapitalEntryHavingSumInput: AccountCapitalEntryHavingSumInput;
  AccountCapitalEntryHavingVariancePopulationInput: AccountCapitalEntryHavingVariancePopulationInput;
  AccountCapitalEntryHavingVarianceSampleInput: AccountCapitalEntryHavingVarianceSampleInput;
  AccountCapitalEntryMaxAggregateFilter: AccountCapitalEntryMaxAggregateFilter;
  AccountCapitalEntryMaxAggregates: AccountCapitalEntryMaxAggregates;
  AccountCapitalEntryMinAggregateFilter: AccountCapitalEntryMinAggregateFilter;
  AccountCapitalEntryMinAggregates: AccountCapitalEntryMinAggregates;
  AccountCapitalEntryResult: AccountCapitalEntryResult;
  AccountCapitalEntryStddevPopulationAggregateFilter: AccountCapitalEntryStddevPopulationAggregateFilter;
  AccountCapitalEntryStddevPopulationAggregates: AccountCapitalEntryStddevPopulationAggregates;
  AccountCapitalEntryStddevSampleAggregateFilter: AccountCapitalEntryStddevSampleAggregateFilter;
  AccountCapitalEntryStddevSampleAggregates: AccountCapitalEntryStddevSampleAggregates;
  AccountCapitalEntrySumAggregateFilter: AccountCapitalEntrySumAggregateFilter;
  AccountCapitalEntrySumAggregates: AccountCapitalEntrySumAggregates;
  AccountCapitalEntryVariancePopulationAggregateFilter: AccountCapitalEntryVariancePopulationAggregateFilter;
  AccountCapitalEntryVariancePopulationAggregates: AccountCapitalEntryVariancePopulationAggregates;
  AccountCapitalEntryVarianceSampleAggregateFilter: AccountCapitalEntryVarianceSampleAggregateFilter;
  AccountCapitalEntryVarianceSampleAggregates: AccountCapitalEntryVarianceSampleAggregates;
  AccountCapitalMutationPayload: AccountCapitalMutationPayload;
  AccountCondition: AccountCondition;
  AccountConnection: AccountConnection;
  AccountDistinctCountAggregateFilter: AccountDistinctCountAggregateFilter;
  AccountDistinctCountAggregates: AccountDistinctCountAggregates;
  AccountEdge: AccountEdge;
  AccountFilter: AccountFilter;
  AccountHavingAverageInput: AccountHavingAverageInput;
  AccountHavingDistinctCountInput: AccountHavingDistinctCountInput;
  AccountHavingInput: AccountHavingInput;
  AccountHavingMaxInput: AccountHavingMaxInput;
  AccountHavingMinInput: AccountHavingMinInput;
  AccountHavingStddevPopulationInput: AccountHavingStddevPopulationInput;
  AccountHavingStddevSampleInput: AccountHavingStddevSampleInput;
  AccountHavingSumInput: AccountHavingSumInput;
  AccountHavingVariancePopulationInput: AccountHavingVariancePopulationInput;
  AccountHavingVarianceSampleInput: AccountHavingVarianceSampleInput;
  AccountLiveCallUp: AccountLiveCallUp;
  AccountLiveCallUpFilter: AccountLiveCallUpFilter;
  AccountMaxAggregateFilter: AccountMaxAggregateFilter;
  AccountMaxAggregates: AccountMaxAggregates;
  AccountMinAggregateFilter: AccountMinAggregateFilter;
  AccountMinAggregates: AccountMinAggregates;
  AccountNote: AccountNote;
  AccountPassedBinder: AccountPassedBinder;
  AccountPassedBinderAggregates: AccountPassedBinderAggregates;
  AccountPassedBinderAggregatesFilter: AccountPassedBinderAggregatesFilter;
  AccountPassedBinderAverageAggregateFilter: AccountPassedBinderAverageAggregateFilter;
  AccountPassedBinderAverageAggregates: AccountPassedBinderAverageAggregates;
  AccountPassedBinderCondition: AccountPassedBinderCondition;
  AccountPassedBinderConnection: AccountPassedBinderConnection;
  AccountPassedBinderDistinctCountAggregateFilter: AccountPassedBinderDistinctCountAggregateFilter;
  AccountPassedBinderDistinctCountAggregates: AccountPassedBinderDistinctCountAggregates;
  AccountPassedBinderEdge: AccountPassedBinderEdge;
  AccountPassedBinderFilter: AccountPassedBinderFilter;
  AccountPassedBinderHavingAverageInput: AccountPassedBinderHavingAverageInput;
  AccountPassedBinderHavingDistinctCountInput: AccountPassedBinderHavingDistinctCountInput;
  AccountPassedBinderHavingInput: AccountPassedBinderHavingInput;
  AccountPassedBinderHavingMaxInput: AccountPassedBinderHavingMaxInput;
  AccountPassedBinderHavingMinInput: AccountPassedBinderHavingMinInput;
  AccountPassedBinderHavingStddevPopulationInput: AccountPassedBinderHavingStddevPopulationInput;
  AccountPassedBinderHavingStddevSampleInput: AccountPassedBinderHavingStddevSampleInput;
  AccountPassedBinderHavingSumInput: AccountPassedBinderHavingSumInput;
  AccountPassedBinderHavingVariancePopulationInput: AccountPassedBinderHavingVariancePopulationInput;
  AccountPassedBinderHavingVarianceSampleInput: AccountPassedBinderHavingVarianceSampleInput;
  AccountPassedBinderMaxAggregateFilter: AccountPassedBinderMaxAggregateFilter;
  AccountPassedBinderMaxAggregates: AccountPassedBinderMaxAggregates;
  AccountPassedBinderMinAggregateFilter: AccountPassedBinderMinAggregateFilter;
  AccountPassedBinderMinAggregates: AccountPassedBinderMinAggregates;
  AccountPassedBinderStddevPopulationAggregateFilter: AccountPassedBinderStddevPopulationAggregateFilter;
  AccountPassedBinderStddevPopulationAggregates: AccountPassedBinderStddevPopulationAggregates;
  AccountPassedBinderStddevSampleAggregateFilter: AccountPassedBinderStddevSampleAggregateFilter;
  AccountPassedBinderStddevSampleAggregates: AccountPassedBinderStddevSampleAggregates;
  AccountPassedBinderSumAggregateFilter: AccountPassedBinderSumAggregateFilter;
  AccountPassedBinderSumAggregates: AccountPassedBinderSumAggregates;
  AccountPassedBinderVariancePopulationAggregateFilter: AccountPassedBinderVariancePopulationAggregateFilter;
  AccountPassedBinderVariancePopulationAggregates: AccountPassedBinderVariancePopulationAggregates;
  AccountPassedBinderVarianceSampleAggregateFilter: AccountPassedBinderVarianceSampleAggregateFilter;
  AccountPassedBinderVarianceSampleAggregates: AccountPassedBinderVarianceSampleAggregates;
  AccountPlatformDatum: AccountPlatformDatum;
  AccountPlatformDatumFilter: AccountPlatformDatumFilter;
  AccountResetLimit: AccountResetLimit;
  AccountResetLimitAggregates: AccountResetLimitAggregates;
  AccountResetLimitAggregatesFilter: AccountResetLimitAggregatesFilter;
  AccountResetLimitAverageAggregateFilter: AccountResetLimitAverageAggregateFilter;
  AccountResetLimitAverageAggregates: AccountResetLimitAverageAggregates;
  AccountResetLimitCondition: AccountResetLimitCondition;
  AccountResetLimitConnection: AccountResetLimitConnection;
  AccountResetLimitDistinctCountAggregateFilter: AccountResetLimitDistinctCountAggregateFilter;
  AccountResetLimitDistinctCountAggregates: AccountResetLimitDistinctCountAggregates;
  AccountResetLimitEdge: AccountResetLimitEdge;
  AccountResetLimitFilter: AccountResetLimitFilter;
  AccountResetLimitHavingAverageInput: AccountResetLimitHavingAverageInput;
  AccountResetLimitHavingDistinctCountInput: AccountResetLimitHavingDistinctCountInput;
  AccountResetLimitHavingInput: AccountResetLimitHavingInput;
  AccountResetLimitHavingMaxInput: AccountResetLimitHavingMaxInput;
  AccountResetLimitHavingMinInput: AccountResetLimitHavingMinInput;
  AccountResetLimitHavingStddevPopulationInput: AccountResetLimitHavingStddevPopulationInput;
  AccountResetLimitHavingStddevSampleInput: AccountResetLimitHavingStddevSampleInput;
  AccountResetLimitHavingSumInput: AccountResetLimitHavingSumInput;
  AccountResetLimitHavingVariancePopulationInput: AccountResetLimitHavingVariancePopulationInput;
  AccountResetLimitHavingVarianceSampleInput: AccountResetLimitHavingVarianceSampleInput;
  AccountResetLimitMaxAggregateFilter: AccountResetLimitMaxAggregateFilter;
  AccountResetLimitMaxAggregates: AccountResetLimitMaxAggregates;
  AccountResetLimitMinAggregateFilter: AccountResetLimitMinAggregateFilter;
  AccountResetLimitMinAggregates: AccountResetLimitMinAggregates;
  AccountResetLimitStddevPopulationAggregateFilter: AccountResetLimitStddevPopulationAggregateFilter;
  AccountResetLimitStddevPopulationAggregates: AccountResetLimitStddevPopulationAggregates;
  AccountResetLimitStddevSampleAggregateFilter: AccountResetLimitStddevSampleAggregateFilter;
  AccountResetLimitStddevSampleAggregates: AccountResetLimitStddevSampleAggregates;
  AccountResetLimitSumAggregateFilter: AccountResetLimitSumAggregateFilter;
  AccountResetLimitSumAggregates: AccountResetLimitSumAggregates;
  AccountResetLimitVariancePopulationAggregateFilter: AccountResetLimitVariancePopulationAggregateFilter;
  AccountResetLimitVariancePopulationAggregates: AccountResetLimitVariancePopulationAggregates;
  AccountResetLimitVarianceSampleAggregateFilter: AccountResetLimitVarianceSampleAggregateFilter;
  AccountResetLimitVarianceSampleAggregates: AccountResetLimitVarianceSampleAggregates;
  AccountResetTracking: AccountResetTracking;
  AccountResetTrackingAggregates: AccountResetTrackingAggregates;
  AccountResetTrackingAggregatesFilter: AccountResetTrackingAggregatesFilter;
  AccountResetTrackingAverageAggregateFilter: AccountResetTrackingAverageAggregateFilter;
  AccountResetTrackingAverageAggregates: AccountResetTrackingAverageAggregates;
  AccountResetTrackingCondition: AccountResetTrackingCondition;
  AccountResetTrackingConnection: AccountResetTrackingConnection;
  AccountResetTrackingDistinctCountAggregateFilter: AccountResetTrackingDistinctCountAggregateFilter;
  AccountResetTrackingDistinctCountAggregates: AccountResetTrackingDistinctCountAggregates;
  AccountResetTrackingEdge: AccountResetTrackingEdge;
  AccountResetTrackingFilter: AccountResetTrackingFilter;
  AccountResetTrackingHavingAverageInput: AccountResetTrackingHavingAverageInput;
  AccountResetTrackingHavingDistinctCountInput: AccountResetTrackingHavingDistinctCountInput;
  AccountResetTrackingHavingInput: AccountResetTrackingHavingInput;
  AccountResetTrackingHavingMaxInput: AccountResetTrackingHavingMaxInput;
  AccountResetTrackingHavingMinInput: AccountResetTrackingHavingMinInput;
  AccountResetTrackingHavingStddevPopulationInput: AccountResetTrackingHavingStddevPopulationInput;
  AccountResetTrackingHavingStddevSampleInput: AccountResetTrackingHavingStddevSampleInput;
  AccountResetTrackingHavingSumInput: AccountResetTrackingHavingSumInput;
  AccountResetTrackingHavingVariancePopulationInput: AccountResetTrackingHavingVariancePopulationInput;
  AccountResetTrackingHavingVarianceSampleInput: AccountResetTrackingHavingVarianceSampleInput;
  AccountResetTrackingMaxAggregateFilter: AccountResetTrackingMaxAggregateFilter;
  AccountResetTrackingMaxAggregates: AccountResetTrackingMaxAggregates;
  AccountResetTrackingMinAggregateFilter: AccountResetTrackingMinAggregateFilter;
  AccountResetTrackingMinAggregates: AccountResetTrackingMinAggregates;
  AccountResetTrackingStddevPopulationAggregateFilter: AccountResetTrackingStddevPopulationAggregateFilter;
  AccountResetTrackingStddevPopulationAggregates: AccountResetTrackingStddevPopulationAggregates;
  AccountResetTrackingStddevSampleAggregateFilter: AccountResetTrackingStddevSampleAggregateFilter;
  AccountResetTrackingStddevSampleAggregates: AccountResetTrackingStddevSampleAggregates;
  AccountResetTrackingSumAggregateFilter: AccountResetTrackingSumAggregateFilter;
  AccountResetTrackingSumAggregates: AccountResetTrackingSumAggregates;
  AccountResetTrackingVariancePopulationAggregateFilter: AccountResetTrackingVariancePopulationAggregateFilter;
  AccountResetTrackingVariancePopulationAggregates: AccountResetTrackingVariancePopulationAggregates;
  AccountResetTrackingVarianceSampleAggregateFilter: AccountResetTrackingVarianceSampleAggregateFilter;
  AccountResetTrackingVarianceSampleAggregates: AccountResetTrackingVarianceSampleAggregates;
  AccountStat: AccountStat;
  AccountStatAggregates: AccountStatAggregates;
  AccountStatAggregatesFilter: AccountStatAggregatesFilter;
  AccountStatAverageAggregateFilter: AccountStatAverageAggregateFilter;
  AccountStatAverageAggregates: AccountStatAverageAggregates;
  AccountStatCondition: AccountStatCondition;
  AccountStatConnection: AccountStatConnection;
  AccountStatDay: AccountStatDay;
  AccountStatDistinctCountAggregateFilter: AccountStatDistinctCountAggregateFilter;
  AccountStatDistinctCountAggregates: AccountStatDistinctCountAggregates;
  AccountStatEdge: AccountStatEdge;
  AccountStatFilter: AccountStatFilter;
  AccountStatHavingAverageInput: AccountStatHavingAverageInput;
  AccountStatHavingDistinctCountInput: AccountStatHavingDistinctCountInput;
  AccountStatHavingInput: AccountStatHavingInput;
  AccountStatHavingMaxInput: AccountStatHavingMaxInput;
  AccountStatHavingMinInput: AccountStatHavingMinInput;
  AccountStatHavingStddevPopulationInput: AccountStatHavingStddevPopulationInput;
  AccountStatHavingStddevSampleInput: AccountStatHavingStddevSampleInput;
  AccountStatHavingSumInput: AccountStatHavingSumInput;
  AccountStatHavingVariancePopulationInput: AccountStatHavingVariancePopulationInput;
  AccountStatHavingVarianceSampleInput: AccountStatHavingVarianceSampleInput;
  AccountStatMaxAggregateFilter: AccountStatMaxAggregateFilter;
  AccountStatMaxAggregates: AccountStatMaxAggregates;
  AccountStatMinAggregateFilter: AccountStatMinAggregateFilter;
  AccountStatMinAggregates: AccountStatMinAggregates;
  AccountStatPatch: AccountStatPatch;
  AccountStatStddevPopulationAggregateFilter: AccountStatStddevPopulationAggregateFilter;
  AccountStatStddevPopulationAggregates: AccountStatStddevPopulationAggregates;
  AccountStatStddevSampleAggregateFilter: AccountStatStddevSampleAggregateFilter;
  AccountStatStddevSampleAggregates: AccountStatStddevSampleAggregates;
  AccountStatSumAggregateFilter: AccountStatSumAggregateFilter;
  AccountStatSumAggregates: AccountStatSumAggregates;
  AccountStatVariancePopulationAggregateFilter: AccountStatVariancePopulationAggregateFilter;
  AccountStatVariancePopulationAggregates: AccountStatVariancePopulationAggregates;
  AccountStatVarianceSampleAggregateFilter: AccountStatVarianceSampleAggregateFilter;
  AccountStatVarianceSampleAggregates: AccountStatVarianceSampleAggregates;
  AccountStddevPopulationAggregateFilter: AccountStddevPopulationAggregateFilter;
  AccountStddevPopulationAggregates: AccountStddevPopulationAggregates;
  AccountStddevSampleAggregateFilter: AccountStddevSampleAggregateFilter;
  AccountStddevSampleAggregates: AccountStddevSampleAggregates;
  AccountSumAggregateFilter: AccountSumAggregateFilter;
  AccountSumAggregates: AccountSumAggregates;
  AccountTemplate: AccountTemplate;
  AccountTemplateAggregates: AccountTemplateAggregates;
  AccountTemplateAverageAggregates: AccountTemplateAverageAggregates;
  AccountTemplateCondition: AccountTemplateCondition;
  AccountTemplateConnection: AccountTemplateConnection;
  AccountTemplateDistinctCountAggregates: AccountTemplateDistinctCountAggregates;
  AccountTemplateEdge: AccountTemplateEdge;
  AccountTemplateFilter: AccountTemplateFilter;
  AccountTemplateHavingAverageInput: AccountTemplateHavingAverageInput;
  AccountTemplateHavingDistinctCountInput: AccountTemplateHavingDistinctCountInput;
  AccountTemplateHavingInput: AccountTemplateHavingInput;
  AccountTemplateHavingMaxInput: AccountTemplateHavingMaxInput;
  AccountTemplateHavingMinInput: AccountTemplateHavingMinInput;
  AccountTemplateHavingStddevPopulationInput: AccountTemplateHavingStddevPopulationInput;
  AccountTemplateHavingStddevSampleInput: AccountTemplateHavingStddevSampleInput;
  AccountTemplateHavingSumInput: AccountTemplateHavingSumInput;
  AccountTemplateHavingVariancePopulationInput: AccountTemplateHavingVariancePopulationInput;
  AccountTemplateHavingVarianceSampleInput: AccountTemplateHavingVarianceSampleInput;
  AccountTemplateMaxAggregates: AccountTemplateMaxAggregates;
  AccountTemplateMinAggregates: AccountTemplateMinAggregates;
  AccountTemplateStddevPopulationAggregates: AccountTemplateStddevPopulationAggregates;
  AccountTemplateStddevSampleAggregates: AccountTemplateStddevSampleAggregates;
  AccountTemplateSumAggregates: AccountTemplateSumAggregates;
  AccountTemplateToManyAccountFilter: AccountTemplateToManyAccountFilter;
  AccountTemplateToManyResetCreditFilter: AccountTemplateToManyResetCreditFilter;
  AccountTemplateVariancePopulationAggregates: AccountTemplateVariancePopulationAggregates;
  AccountTemplateVarianceSampleAggregates: AccountTemplateVarianceSampleAggregates;
  AccountToManyAccountCapitalEntryFilter: AccountToManyAccountCapitalEntryFilter;
  AccountToManyAccountPassedBinderFilter: AccountToManyAccountPassedBinderFilter;
  AccountToManyAccountStatFilter: AccountToManyAccountStatFilter;
  AccountToManyImpactGroupAssignmentFilter: AccountToManyImpactGroupAssignmentFilter;
  AccountToManyTraderPublicProfileFilter: AccountToManyTraderPublicProfileFilter;
  AccountToManyXfaResetTrackingFilter: AccountToManyXfaResetTrackingFilter;
  AccountTradeArchiveNewId: AccountTradeArchiveNewId;
  AccountTradeNat: AccountTradeNat;
  AccountTradeStatByDay: AccountTradeStatByDay;
  AccountTradeStatByDayAggregates: AccountTradeStatByDayAggregates;
  AccountTradeStatByDayAverageAggregates: AccountTradeStatByDayAverageAggregates;
  AccountTradeStatByDayCondition: AccountTradeStatByDayCondition;
  AccountTradeStatByDayConnection: AccountTradeStatByDayConnection;
  AccountTradeStatByDayDistinctCountAggregates: AccountTradeStatByDayDistinctCountAggregates;
  AccountTradeStatByDayEdge: AccountTradeStatByDayEdge;
  AccountTradeStatByDayFilter: AccountTradeStatByDayFilter;
  AccountTradeStatByDayHavingAverageInput: AccountTradeStatByDayHavingAverageInput;
  AccountTradeStatByDayHavingDistinctCountInput: AccountTradeStatByDayHavingDistinctCountInput;
  AccountTradeStatByDayHavingInput: AccountTradeStatByDayHavingInput;
  AccountTradeStatByDayHavingMaxInput: AccountTradeStatByDayHavingMaxInput;
  AccountTradeStatByDayHavingMinInput: AccountTradeStatByDayHavingMinInput;
  AccountTradeStatByDayHavingStddevPopulationInput: AccountTradeStatByDayHavingStddevPopulationInput;
  AccountTradeStatByDayHavingStddevSampleInput: AccountTradeStatByDayHavingStddevSampleInput;
  AccountTradeStatByDayHavingSumInput: AccountTradeStatByDayHavingSumInput;
  AccountTradeStatByDayHavingVariancePopulationInput: AccountTradeStatByDayHavingVariancePopulationInput;
  AccountTradeStatByDayHavingVarianceSampleInput: AccountTradeStatByDayHavingVarianceSampleInput;
  AccountTradeStatByDayMaxAggregates: AccountTradeStatByDayMaxAggregates;
  AccountTradeStatByDayMinAggregates: AccountTradeStatByDayMinAggregates;
  AccountTradeStatByDayNat: AccountTradeStatByDayNat;
  AccountTradeStatByDayStddevPopulationAggregates: AccountTradeStatByDayStddevPopulationAggregates;
  AccountTradeStatByDayStddevSampleAggregates: AccountTradeStatByDayStddevSampleAggregates;
  AccountTradeStatByDaySumAggregates: AccountTradeStatByDaySumAggregates;
  AccountTradeStatByDayVariancePopulationAggregates: AccountTradeStatByDayVariancePopulationAggregates;
  AccountTradeStatByDayVarianceSampleAggregates: AccountTradeStatByDayVarianceSampleAggregates;
  AccountVariancePopulationAggregateFilter: AccountVariancePopulationAggregateFilter;
  AccountVariancePopulationAggregates: AccountVariancePopulationAggregates;
  AccountVarianceSampleAggregateFilter: AccountVarianceSampleAggregateFilter;
  AccountVarianceSampleAggregates: AccountVarianceSampleAggregates;
  AddCaseBanNoteInput: AddCaseBanNoteInput;
  AddCaseInvestigationNoteInput: AddCaseInvestigationNoteInput;
  Addon: Addon;
  AdminAudit: AdminAudit;
  AdminAuditAggregates: AdminAuditAggregates;
  AdminAuditAverageAggregates: AdminAuditAverageAggregates;
  AdminAuditCondition: AdminAuditCondition;
  AdminAuditConnection: AdminAuditConnection;
  AdminAuditDistinctCountAggregates: AdminAuditDistinctCountAggregates;
  AdminAuditEdge: AdminAuditEdge;
  AdminAuditFilter: AdminAuditFilter;
  AdminAuditHavingAverageInput: AdminAuditHavingAverageInput;
  AdminAuditHavingDistinctCountInput: AdminAuditHavingDistinctCountInput;
  AdminAuditHavingInput: AdminAuditHavingInput;
  AdminAuditHavingMaxInput: AdminAuditHavingMaxInput;
  AdminAuditHavingMinInput: AdminAuditHavingMinInput;
  AdminAuditHavingStddevPopulationInput: AdminAuditHavingStddevPopulationInput;
  AdminAuditHavingStddevSampleInput: AdminAuditHavingStddevSampleInput;
  AdminAuditHavingSumInput: AdminAuditHavingSumInput;
  AdminAuditHavingVariancePopulationInput: AdminAuditHavingVariancePopulationInput;
  AdminAuditHavingVarianceSampleInput: AdminAuditHavingVarianceSampleInput;
  AdminAuditMaxAggregates: AdminAuditMaxAggregates;
  AdminAuditMinAggregates: AdminAuditMinAggregates;
  AdminAuditStddevPopulationAggregates: AdminAuditStddevPopulationAggregates;
  AdminAuditStddevSampleAggregates: AdminAuditStddevSampleAggregates;
  AdminAuditSumAggregates: AdminAuditSumAggregates;
  AdminAuditVariancePopulationAggregates: AdminAuditVariancePopulationAggregates;
  AdminAuditVarianceSampleAggregates: AdminAuditVarianceSampleAggregates;
  AdminConfig: AdminConfig;
  AdminConfigEdge: AdminConfigEdge;
  AdminConfigPatch: AdminConfigPatch;
  AdminRole: AdminRole;
  AdminRoleAggregates: AdminRoleAggregates;
  AdminRoleAverageAggregates: AdminRoleAverageAggregates;
  AdminRoleCondition: AdminRoleCondition;
  AdminRoleConnection: AdminRoleConnection;
  AdminRoleDistinctCountAggregates: AdminRoleDistinctCountAggregates;
  AdminRoleEdge: AdminRoleEdge;
  AdminRoleFilter: AdminRoleFilter;
  AdminRoleMaxAggregates: AdminRoleMaxAggregates;
  AdminRoleMinAggregates: AdminRoleMinAggregates;
  AdminRoleStddevPopulationAggregates: AdminRoleStddevPopulationAggregates;
  AdminRoleStddevSampleAggregates: AdminRoleStddevSampleAggregates;
  AdminRoleSumAggregates: AdminRoleSumAggregates;
  AdminRoleToManyAdminRoleUsersUserFilter: AdminRoleToManyAdminRoleUsersUserFilter;
  AdminRoleToManyUserAdminRoleFilter: AdminRoleToManyUserAdminRoleFilter;
  AdminRoleToManyUserRolesAdminRoleFilter: AdminRoleToManyUserRolesAdminRoleFilter;
  AdminRoleUsersUser: AdminRoleUsersUser;
  AdminRoleUsersUserAggregates: AdminRoleUsersUserAggregates;
  AdminRoleUsersUserAggregatesFilter: AdminRoleUsersUserAggregatesFilter;
  AdminRoleUsersUserAverageAggregateFilter: AdminRoleUsersUserAverageAggregateFilter;
  AdminRoleUsersUserAverageAggregates: AdminRoleUsersUserAverageAggregates;
  AdminRoleUsersUserCondition: AdminRoleUsersUserCondition;
  AdminRoleUsersUserConnection: AdminRoleUsersUserConnection;
  AdminRoleUsersUserDistinctCountAggregateFilter: AdminRoleUsersUserDistinctCountAggregateFilter;
  AdminRoleUsersUserDistinctCountAggregates: AdminRoleUsersUserDistinctCountAggregates;
  AdminRoleUsersUserEdge: AdminRoleUsersUserEdge;
  AdminRoleUsersUserFilter: AdminRoleUsersUserFilter;
  AdminRoleUsersUserHavingAverageInput: AdminRoleUsersUserHavingAverageInput;
  AdminRoleUsersUserHavingDistinctCountInput: AdminRoleUsersUserHavingDistinctCountInput;
  AdminRoleUsersUserHavingInput: AdminRoleUsersUserHavingInput;
  AdminRoleUsersUserHavingMaxInput: AdminRoleUsersUserHavingMaxInput;
  AdminRoleUsersUserHavingMinInput: AdminRoleUsersUserHavingMinInput;
  AdminRoleUsersUserHavingStddevPopulationInput: AdminRoleUsersUserHavingStddevPopulationInput;
  AdminRoleUsersUserHavingStddevSampleInput: AdminRoleUsersUserHavingStddevSampleInput;
  AdminRoleUsersUserHavingSumInput: AdminRoleUsersUserHavingSumInput;
  AdminRoleUsersUserHavingVariancePopulationInput: AdminRoleUsersUserHavingVariancePopulationInput;
  AdminRoleUsersUserHavingVarianceSampleInput: AdminRoleUsersUserHavingVarianceSampleInput;
  AdminRoleUsersUserMaxAggregateFilter: AdminRoleUsersUserMaxAggregateFilter;
  AdminRoleUsersUserMaxAggregates: AdminRoleUsersUserMaxAggregates;
  AdminRoleUsersUserMinAggregateFilter: AdminRoleUsersUserMinAggregateFilter;
  AdminRoleUsersUserMinAggregates: AdminRoleUsersUserMinAggregates;
  AdminRoleUsersUserStddevPopulationAggregateFilter: AdminRoleUsersUserStddevPopulationAggregateFilter;
  AdminRoleUsersUserStddevPopulationAggregates: AdminRoleUsersUserStddevPopulationAggregates;
  AdminRoleUsersUserStddevSampleAggregateFilter: AdminRoleUsersUserStddevSampleAggregateFilter;
  AdminRoleUsersUserStddevSampleAggregates: AdminRoleUsersUserStddevSampleAggregates;
  AdminRoleUsersUserSumAggregateFilter: AdminRoleUsersUserSumAggregateFilter;
  AdminRoleUsersUserSumAggregates: AdminRoleUsersUserSumAggregates;
  AdminRoleUsersUserVariancePopulationAggregateFilter: AdminRoleUsersUserVariancePopulationAggregateFilter;
  AdminRoleUsersUserVariancePopulationAggregates: AdminRoleUsersUserVariancePopulationAggregates;
  AdminRoleUsersUserVarianceSampleAggregateFilter: AdminRoleUsersUserVarianceSampleAggregateFilter;
  AdminRoleUsersUserVarianceSampleAggregates: AdminRoleUsersUserVarianceSampleAggregates;
  AdminRoleVariancePopulationAggregates: AdminRoleVariancePopulationAggregates;
  AdminRoleVarianceSampleAggregates: AdminRoleVarianceSampleAggregates;
  Affiliate: Affiliate;
  AffiliateAudit: AffiliateAudit;
  AffiliateAuditAggregates: AffiliateAuditAggregates;
  AffiliateAuditAggregatesFilter: AffiliateAuditAggregatesFilter;
  AffiliateAuditAverageAggregates: AffiliateAuditAverageAggregates;
  AffiliateAuditCondition: AffiliateAuditCondition;
  AffiliateAuditConnection: AffiliateAuditConnection;
  AffiliateAuditDistinctCountAggregateFilter: AffiliateAuditDistinctCountAggregateFilter;
  AffiliateAuditDistinctCountAggregates: AffiliateAuditDistinctCountAggregates;
  AffiliateAuditEdge: AffiliateAuditEdge;
  AffiliateAuditFilter: AffiliateAuditFilter;
  AffiliateAuditHavingAverageInput: AffiliateAuditHavingAverageInput;
  AffiliateAuditHavingDistinctCountInput: AffiliateAuditHavingDistinctCountInput;
  AffiliateAuditHavingInput: AffiliateAuditHavingInput;
  AffiliateAuditHavingMaxInput: AffiliateAuditHavingMaxInput;
  AffiliateAuditHavingMinInput: AffiliateAuditHavingMinInput;
  AffiliateAuditHavingStddevPopulationInput: AffiliateAuditHavingStddevPopulationInput;
  AffiliateAuditHavingStddevSampleInput: AffiliateAuditHavingStddevSampleInput;
  AffiliateAuditHavingSumInput: AffiliateAuditHavingSumInput;
  AffiliateAuditHavingVariancePopulationInput: AffiliateAuditHavingVariancePopulationInput;
  AffiliateAuditHavingVarianceSampleInput: AffiliateAuditHavingVarianceSampleInput;
  AffiliateAuditMaxAggregates: AffiliateAuditMaxAggregates;
  AffiliateAuditMinAggregates: AffiliateAuditMinAggregates;
  AffiliateAuditStddevPopulationAggregates: AffiliateAuditStddevPopulationAggregates;
  AffiliateAuditStddevSampleAggregates: AffiliateAuditStddevSampleAggregates;
  AffiliateAuditSumAggregates: AffiliateAuditSumAggregates;
  AffiliateAuditVariancePopulationAggregates: AffiliateAuditVariancePopulationAggregates;
  AffiliateAuditVarianceSampleAggregates: AffiliateAuditVarianceSampleAggregates;
  AffiliateCommissionRate: AffiliateCommissionRate;
  AffiliateCommissionRateAggregates: AffiliateCommissionRateAggregates;
  AffiliateCommissionRateAggregatesFilter: AffiliateCommissionRateAggregatesFilter;
  AffiliateCommissionRateAverageAggregates: AffiliateCommissionRateAverageAggregates;
  AffiliateCommissionRateCondition: AffiliateCommissionRateCondition;
  AffiliateCommissionRateConnection: AffiliateCommissionRateConnection;
  AffiliateCommissionRateDistinctCountAggregateFilter: AffiliateCommissionRateDistinctCountAggregateFilter;
  AffiliateCommissionRateDistinctCountAggregates: AffiliateCommissionRateDistinctCountAggregates;
  AffiliateCommissionRateEdge: AffiliateCommissionRateEdge;
  AffiliateCommissionRateFilter: AffiliateCommissionRateFilter;
  AffiliateCommissionRateHavingAverageInput: AffiliateCommissionRateHavingAverageInput;
  AffiliateCommissionRateHavingDistinctCountInput: AffiliateCommissionRateHavingDistinctCountInput;
  AffiliateCommissionRateHavingInput: AffiliateCommissionRateHavingInput;
  AffiliateCommissionRateHavingMaxInput: AffiliateCommissionRateHavingMaxInput;
  AffiliateCommissionRateHavingMinInput: AffiliateCommissionRateHavingMinInput;
  AffiliateCommissionRateHavingStddevPopulationInput: AffiliateCommissionRateHavingStddevPopulationInput;
  AffiliateCommissionRateHavingStddevSampleInput: AffiliateCommissionRateHavingStddevSampleInput;
  AffiliateCommissionRateHavingSumInput: AffiliateCommissionRateHavingSumInput;
  AffiliateCommissionRateHavingVariancePopulationInput: AffiliateCommissionRateHavingVariancePopulationInput;
  AffiliateCommissionRateHavingVarianceSampleInput: AffiliateCommissionRateHavingVarianceSampleInput;
  AffiliateCommissionRateMaxAggregates: AffiliateCommissionRateMaxAggregates;
  AffiliateCommissionRateMinAggregates: AffiliateCommissionRateMinAggregates;
  AffiliateCommissionRateStddevPopulationAggregates: AffiliateCommissionRateStddevPopulationAggregates;
  AffiliateCommissionRateStddevSampleAggregates: AffiliateCommissionRateStddevSampleAggregates;
  AffiliateCommissionRateSumAggregates: AffiliateCommissionRateSumAggregates;
  AffiliateCommissionRateVariancePopulationAggregates: AffiliateCommissionRateVariancePopulationAggregates;
  AffiliateCommissionRateVarianceSampleAggregates: AffiliateCommissionRateVarianceSampleAggregates;
  AffiliateFilter: AffiliateFilter;
  AffiliateLedger: AffiliateLedger;
  AffiliateLedgerAggregates: AffiliateLedgerAggregates;
  AffiliateLedgerAggregatesFilter: AffiliateLedgerAggregatesFilter;
  AffiliateLedgerAverageAggregateFilter: AffiliateLedgerAverageAggregateFilter;
  AffiliateLedgerAverageAggregates: AffiliateLedgerAverageAggregates;
  AffiliateLedgerCondition: AffiliateLedgerCondition;
  AffiliateLedgerConnection: AffiliateLedgerConnection;
  AffiliateLedgerDistinctCountAggregateFilter: AffiliateLedgerDistinctCountAggregateFilter;
  AffiliateLedgerDistinctCountAggregates: AffiliateLedgerDistinctCountAggregates;
  AffiliateLedgerEdge: AffiliateLedgerEdge;
  AffiliateLedgerFilter: AffiliateLedgerFilter;
  AffiliateLedgerHavingAverageInput: AffiliateLedgerHavingAverageInput;
  AffiliateLedgerHavingDistinctCountInput: AffiliateLedgerHavingDistinctCountInput;
  AffiliateLedgerHavingInput: AffiliateLedgerHavingInput;
  AffiliateLedgerHavingMaxInput: AffiliateLedgerHavingMaxInput;
  AffiliateLedgerHavingMinInput: AffiliateLedgerHavingMinInput;
  AffiliateLedgerHavingStddevPopulationInput: AffiliateLedgerHavingStddevPopulationInput;
  AffiliateLedgerHavingStddevSampleInput: AffiliateLedgerHavingStddevSampleInput;
  AffiliateLedgerHavingSumInput: AffiliateLedgerHavingSumInput;
  AffiliateLedgerHavingVariancePopulationInput: AffiliateLedgerHavingVariancePopulationInput;
  AffiliateLedgerHavingVarianceSampleInput: AffiliateLedgerHavingVarianceSampleInput;
  AffiliateLedgerMaxAggregateFilter: AffiliateLedgerMaxAggregateFilter;
  AffiliateLedgerMaxAggregates: AffiliateLedgerMaxAggregates;
  AffiliateLedgerMinAggregateFilter: AffiliateLedgerMinAggregateFilter;
  AffiliateLedgerMinAggregates: AffiliateLedgerMinAggregates;
  AffiliateLedgerStddevPopulationAggregateFilter: AffiliateLedgerStddevPopulationAggregateFilter;
  AffiliateLedgerStddevPopulationAggregates: AffiliateLedgerStddevPopulationAggregates;
  AffiliateLedgerStddevSampleAggregateFilter: AffiliateLedgerStddevSampleAggregateFilter;
  AffiliateLedgerStddevSampleAggregates: AffiliateLedgerStddevSampleAggregates;
  AffiliateLedgerSumAggregateFilter: AffiliateLedgerSumAggregateFilter;
  AffiliateLedgerSumAggregates: AffiliateLedgerSumAggregates;
  AffiliateLedgerVariancePopulationAggregateFilter: AffiliateLedgerVariancePopulationAggregateFilter;
  AffiliateLedgerVariancePopulationAggregates: AffiliateLedgerVariancePopulationAggregates;
  AffiliateLedgerVarianceSampleAggregateFilter: AffiliateLedgerVarianceSampleAggregateFilter;
  AffiliateLedgerVarianceSampleAggregates: AffiliateLedgerVarianceSampleAggregates;
  AffiliatePayment: AffiliatePayment;
  AffiliatePaymentAggregates: AffiliatePaymentAggregates;
  AffiliatePaymentAggregatesFilter: AffiliatePaymentAggregatesFilter;
  AffiliatePaymentAverageAggregates: AffiliatePaymentAverageAggregates;
  AffiliatePaymentCondition: AffiliatePaymentCondition;
  AffiliatePaymentConnection: AffiliatePaymentConnection;
  AffiliatePaymentDistinctCountAggregateFilter: AffiliatePaymentDistinctCountAggregateFilter;
  AffiliatePaymentDistinctCountAggregates: AffiliatePaymentDistinctCountAggregates;
  AffiliatePaymentEdge: AffiliatePaymentEdge;
  AffiliatePaymentFilter: AffiliatePaymentFilter;
  AffiliatePaymentHavingAverageInput: AffiliatePaymentHavingAverageInput;
  AffiliatePaymentHavingDistinctCountInput: AffiliatePaymentHavingDistinctCountInput;
  AffiliatePaymentHavingInput: AffiliatePaymentHavingInput;
  AffiliatePaymentHavingMaxInput: AffiliatePaymentHavingMaxInput;
  AffiliatePaymentHavingMinInput: AffiliatePaymentHavingMinInput;
  AffiliatePaymentHavingStddevPopulationInput: AffiliatePaymentHavingStddevPopulationInput;
  AffiliatePaymentHavingStddevSampleInput: AffiliatePaymentHavingStddevSampleInput;
  AffiliatePaymentHavingSumInput: AffiliatePaymentHavingSumInput;
  AffiliatePaymentHavingVariancePopulationInput: AffiliatePaymentHavingVariancePopulationInput;
  AffiliatePaymentHavingVarianceSampleInput: AffiliatePaymentHavingVarianceSampleInput;
  AffiliatePaymentMaxAggregates: AffiliatePaymentMaxAggregates;
  AffiliatePaymentMinAggregates: AffiliatePaymentMinAggregates;
  AffiliatePaymentStddevPopulationAggregates: AffiliatePaymentStddevPopulationAggregates;
  AffiliatePaymentStddevSampleAggregates: AffiliatePaymentStddevSampleAggregates;
  AffiliatePaymentSumAggregates: AffiliatePaymentSumAggregates;
  AffiliatePaymentVariancePopulationAggregates: AffiliatePaymentVariancePopulationAggregates;
  AffiliatePaymentVarianceSampleAggregates: AffiliatePaymentVarianceSampleAggregates;
  AffiliatePayoutPeriod: AffiliatePayoutPeriod;
  AffiliatePayoutPeriodAggregates: AffiliatePayoutPeriodAggregates;
  AffiliatePayoutPeriodAggregatesFilter: AffiliatePayoutPeriodAggregatesFilter;
  AffiliatePayoutPeriodAverageAggregates: AffiliatePayoutPeriodAverageAggregates;
  AffiliatePayoutPeriodCondition: AffiliatePayoutPeriodCondition;
  AffiliatePayoutPeriodConnection: AffiliatePayoutPeriodConnection;
  AffiliatePayoutPeriodDistinctCountAggregateFilter: AffiliatePayoutPeriodDistinctCountAggregateFilter;
  AffiliatePayoutPeriodDistinctCountAggregates: AffiliatePayoutPeriodDistinctCountAggregates;
  AffiliatePayoutPeriodEdge: AffiliatePayoutPeriodEdge;
  AffiliatePayoutPeriodFilter: AffiliatePayoutPeriodFilter;
  AffiliatePayoutPeriodHavingAverageInput: AffiliatePayoutPeriodHavingAverageInput;
  AffiliatePayoutPeriodHavingDistinctCountInput: AffiliatePayoutPeriodHavingDistinctCountInput;
  AffiliatePayoutPeriodHavingInput: AffiliatePayoutPeriodHavingInput;
  AffiliatePayoutPeriodHavingMaxInput: AffiliatePayoutPeriodHavingMaxInput;
  AffiliatePayoutPeriodHavingMinInput: AffiliatePayoutPeriodHavingMinInput;
  AffiliatePayoutPeriodHavingStddevPopulationInput: AffiliatePayoutPeriodHavingStddevPopulationInput;
  AffiliatePayoutPeriodHavingStddevSampleInput: AffiliatePayoutPeriodHavingStddevSampleInput;
  AffiliatePayoutPeriodHavingSumInput: AffiliatePayoutPeriodHavingSumInput;
  AffiliatePayoutPeriodHavingVariancePopulationInput: AffiliatePayoutPeriodHavingVariancePopulationInput;
  AffiliatePayoutPeriodHavingVarianceSampleInput: AffiliatePayoutPeriodHavingVarianceSampleInput;
  AffiliatePayoutPeriodMaxAggregates: AffiliatePayoutPeriodMaxAggregates;
  AffiliatePayoutPeriodMinAggregates: AffiliatePayoutPeriodMinAggregates;
  AffiliatePayoutPeriodStddevPopulationAggregates: AffiliatePayoutPeriodStddevPopulationAggregates;
  AffiliatePayoutPeriodStddevSampleAggregates: AffiliatePayoutPeriodStddevSampleAggregates;
  AffiliatePayoutPeriodSumAggregates: AffiliatePayoutPeriodSumAggregates;
  AffiliatePayoutPeriodToManyAffiliatePaymentFilter: AffiliatePayoutPeriodToManyAffiliatePaymentFilter;
  AffiliatePayoutPeriodVariancePopulationAggregates: AffiliatePayoutPeriodVariancePopulationAggregates;
  AffiliatePayoutPeriodVarianceSampleAggregates: AffiliatePayoutPeriodVarianceSampleAggregates;
  AffiliateToManyAffiliateAuditFilter: AffiliateToManyAffiliateAuditFilter;
  AffiliateToManyAffiliateCommissionRateFilter: AffiliateToManyAffiliateCommissionRateFilter;
  AffiliateToManyAffiliateLedgerFilter: AffiliateToManyAffiliateLedgerFilter;
  AffiliateToManyAffiliatePayoutPeriodFilter: AffiliateToManyAffiliatePayoutPeriodFilter;
  AggregateAccountTradeStatByDayConnection: AggregateAccountTradeStatByDayConnection;
  AggregateAccountTradeStatByDayEdge: AggregateAccountTradeStatByDayEdge;
  AggregateAccountTradeStatByDayRecord: AggregateAccountTradeStatByDayRecord;
  AggregateAccountTradeStatByDayRecordFilter: AggregateAccountTradeStatByDayRecordFilter;
  AwsdmsChanges3728E4207De1F2E6: AwsdmsChanges3728E4207De1F2E6;
  AwsdmsDdlAudit: AwsdmsDdlAudit;
  AwsdmsHeartbeat: AwsdmsHeartbeat;
  BatchExecution: BatchExecution;
  BestTradingDay: BestTradingDay;
  BigFloat: Scalars['BigFloat']['output'];
  BigFloatFilter: BigFloatFilter;
  BigInt: Scalars['BigInt']['output'];
  BigIntFilter: BigIntFilter;
  Boolean: Scalars['Boolean']['output'];
  BooleanFilter: BooleanFilter;
  BulkAction: BulkAction;
  BulkCapitalUploadInput: BulkCapitalUploadInput;
  BulkCapitalUploadPayload: BulkCapitalUploadPayload;
  BulkCapitalUploadRowResult: BulkCapitalUploadRowResult;
  BypassUserTaxFormValidationInput: BypassUserTaxFormValidationInput;
  BypassUserTaxFormValidationResult: BypassUserTaxFormValidationResult;
  CardTransaction: CardTransaction;
  CardTransactionAggregates: CardTransactionAggregates;
  CardTransactionAggregatesFilter: CardTransactionAggregatesFilter;
  CardTransactionAverageAggregateFilter: CardTransactionAverageAggregateFilter;
  CardTransactionAverageAggregates: CardTransactionAverageAggregates;
  CardTransactionCondition: CardTransactionCondition;
  CardTransactionConnection: CardTransactionConnection;
  CardTransactionDistinctCountAggregateFilter: CardTransactionDistinctCountAggregateFilter;
  CardTransactionDistinctCountAggregates: CardTransactionDistinctCountAggregates;
  CardTransactionEdge: CardTransactionEdge;
  CardTransactionFilter: CardTransactionFilter;
  CardTransactionHavingAverageInput: CardTransactionHavingAverageInput;
  CardTransactionHavingDistinctCountInput: CardTransactionHavingDistinctCountInput;
  CardTransactionHavingInput: CardTransactionHavingInput;
  CardTransactionHavingMaxInput: CardTransactionHavingMaxInput;
  CardTransactionHavingMinInput: CardTransactionHavingMinInput;
  CardTransactionHavingStddevPopulationInput: CardTransactionHavingStddevPopulationInput;
  CardTransactionHavingStddevSampleInput: CardTransactionHavingStddevSampleInput;
  CardTransactionHavingSumInput: CardTransactionHavingSumInput;
  CardTransactionHavingVariancePopulationInput: CardTransactionHavingVariancePopulationInput;
  CardTransactionHavingVarianceSampleInput: CardTransactionHavingVarianceSampleInput;
  CardTransactionMaxAggregateFilter: CardTransactionMaxAggregateFilter;
  CardTransactionMaxAggregates: CardTransactionMaxAggregates;
  CardTransactionMinAggregateFilter: CardTransactionMinAggregateFilter;
  CardTransactionMinAggregates: CardTransactionMinAggregates;
  CardTransactionStddevPopulationAggregateFilter: CardTransactionStddevPopulationAggregateFilter;
  CardTransactionStddevPopulationAggregates: CardTransactionStddevPopulationAggregates;
  CardTransactionStddevSampleAggregateFilter: CardTransactionStddevSampleAggregateFilter;
  CardTransactionStddevSampleAggregates: CardTransactionStddevSampleAggregates;
  CardTransactionSumAggregateFilter: CardTransactionSumAggregateFilter;
  CardTransactionSumAggregates: CardTransactionSumAggregates;
  CardTransactionVariancePopulationAggregateFilter: CardTransactionVariancePopulationAggregateFilter;
  CardTransactionVariancePopulationAggregates: CardTransactionVariancePopulationAggregates;
  CardTransactionVarianceSampleAggregateFilter: CardTransactionVarianceSampleAggregateFilter;
  CardTransactionVarianceSampleAggregates: CardTransactionVarianceSampleAggregates;
  CaseAssignableUser: CaseAssignableUser;
  CaseBan: CaseBan;
  CaseBanAggregates: CaseBanAggregates;
  CaseBanAverageAggregates: CaseBanAverageAggregates;
  CaseBanCondition: CaseBanCondition;
  CaseBanConnection: CaseBanConnection;
  CaseBanDistinctCountAggregates: CaseBanDistinctCountAggregates;
  CaseBanEdge: CaseBanEdge;
  CaseBanEventResult: CaseBanEventResult;
  CaseBanFilter: CaseBanFilter;
  CaseBanHavingAverageInput: CaseBanHavingAverageInput;
  CaseBanHavingDistinctCountInput: CaseBanHavingDistinctCountInput;
  CaseBanHavingInput: CaseBanHavingInput;
  CaseBanHavingMaxInput: CaseBanHavingMaxInput;
  CaseBanHavingMinInput: CaseBanHavingMinInput;
  CaseBanHavingStddevPopulationInput: CaseBanHavingStddevPopulationInput;
  CaseBanHavingStddevSampleInput: CaseBanHavingStddevSampleInput;
  CaseBanHavingSumInput: CaseBanHavingSumInput;
  CaseBanHavingVariancePopulationInput: CaseBanHavingVariancePopulationInput;
  CaseBanHavingVarianceSampleInput: CaseBanHavingVarianceSampleInput;
  CaseBanMaxAggregates: CaseBanMaxAggregates;
  CaseBanMinAggregates: CaseBanMinAggregates;
  CaseBanReasonCode: CaseBanReasonCode;
  CaseBanReasonCodeAggregates: CaseBanReasonCodeAggregates;
  CaseBanReasonCodeAggregatesFilter: CaseBanReasonCodeAggregatesFilter;
  CaseBanReasonCodeAverageAggregateFilter: CaseBanReasonCodeAverageAggregateFilter;
  CaseBanReasonCodeAverageAggregates: CaseBanReasonCodeAverageAggregates;
  CaseBanReasonCodeCondition: CaseBanReasonCodeCondition;
  CaseBanReasonCodeConnection: CaseBanReasonCodeConnection;
  CaseBanReasonCodeDistinctCountAggregateFilter: CaseBanReasonCodeDistinctCountAggregateFilter;
  CaseBanReasonCodeDistinctCountAggregates: CaseBanReasonCodeDistinctCountAggregates;
  CaseBanReasonCodeEdge: CaseBanReasonCodeEdge;
  CaseBanReasonCodeFilter: CaseBanReasonCodeFilter;
  CaseBanReasonCodeHavingAverageInput: CaseBanReasonCodeHavingAverageInput;
  CaseBanReasonCodeHavingDistinctCountInput: CaseBanReasonCodeHavingDistinctCountInput;
  CaseBanReasonCodeHavingInput: CaseBanReasonCodeHavingInput;
  CaseBanReasonCodeHavingMaxInput: CaseBanReasonCodeHavingMaxInput;
  CaseBanReasonCodeHavingMinInput: CaseBanReasonCodeHavingMinInput;
  CaseBanReasonCodeHavingStddevPopulationInput: CaseBanReasonCodeHavingStddevPopulationInput;
  CaseBanReasonCodeHavingStddevSampleInput: CaseBanReasonCodeHavingStddevSampleInput;
  CaseBanReasonCodeHavingSumInput: CaseBanReasonCodeHavingSumInput;
  CaseBanReasonCodeHavingVariancePopulationInput: CaseBanReasonCodeHavingVariancePopulationInput;
  CaseBanReasonCodeHavingVarianceSampleInput: CaseBanReasonCodeHavingVarianceSampleInput;
  CaseBanReasonCodeMaxAggregateFilter: CaseBanReasonCodeMaxAggregateFilter;
  CaseBanReasonCodeMaxAggregates: CaseBanReasonCodeMaxAggregates;
  CaseBanReasonCodeMinAggregateFilter: CaseBanReasonCodeMinAggregateFilter;
  CaseBanReasonCodeMinAggregates: CaseBanReasonCodeMinAggregates;
  CaseBanReasonCodeStddevPopulationAggregateFilter: CaseBanReasonCodeStddevPopulationAggregateFilter;
  CaseBanReasonCodeStddevPopulationAggregates: CaseBanReasonCodeStddevPopulationAggregates;
  CaseBanReasonCodeStddevSampleAggregateFilter: CaseBanReasonCodeStddevSampleAggregateFilter;
  CaseBanReasonCodeStddevSampleAggregates: CaseBanReasonCodeStddevSampleAggregates;
  CaseBanReasonCodeSumAggregateFilter: CaseBanReasonCodeSumAggregateFilter;
  CaseBanReasonCodeSumAggregates: CaseBanReasonCodeSumAggregates;
  CaseBanReasonCodeVariancePopulationAggregateFilter: CaseBanReasonCodeVariancePopulationAggregateFilter;
  CaseBanReasonCodeVariancePopulationAggregates: CaseBanReasonCodeVariancePopulationAggregates;
  CaseBanReasonCodeVarianceSampleAggregateFilter: CaseBanReasonCodeVarianceSampleAggregateFilter;
  CaseBanReasonCodeVarianceSampleAggregates: CaseBanReasonCodeVarianceSampleAggregates;
  CaseBanResult: CaseBanResult;
  CaseBanStddevPopulationAggregates: CaseBanStddevPopulationAggregates;
  CaseBanStddevSampleAggregates: CaseBanStddevSampleAggregates;
  CaseBanSumAggregates: CaseBanSumAggregates;
  CaseBanToManyCaseBanReasonCodeFilter: CaseBanToManyCaseBanReasonCodeFilter;
  CaseBanToManyCaseBanTraderFilter: CaseBanToManyCaseBanTraderFilter;
  CaseBanToManyCaseEventFilter: CaseBanToManyCaseEventFilter;
  CaseBanToManyCaseLabelAssignmentFilter: CaseBanToManyCaseLabelAssignmentFilter;
  CaseBanTrader: CaseBanTrader;
  CaseBanTraderAggregates: CaseBanTraderAggregates;
  CaseBanTraderAggregatesFilter: CaseBanTraderAggregatesFilter;
  CaseBanTraderAverageAggregateFilter: CaseBanTraderAverageAggregateFilter;
  CaseBanTraderAverageAggregates: CaseBanTraderAverageAggregates;
  CaseBanTraderCondition: CaseBanTraderCondition;
  CaseBanTraderConnection: CaseBanTraderConnection;
  CaseBanTraderDistinctCountAggregateFilter: CaseBanTraderDistinctCountAggregateFilter;
  CaseBanTraderDistinctCountAggregates: CaseBanTraderDistinctCountAggregates;
  CaseBanTraderEdge: CaseBanTraderEdge;
  CaseBanTraderFilter: CaseBanTraderFilter;
  CaseBanTraderHavingAverageInput: CaseBanTraderHavingAverageInput;
  CaseBanTraderHavingDistinctCountInput: CaseBanTraderHavingDistinctCountInput;
  CaseBanTraderHavingInput: CaseBanTraderHavingInput;
  CaseBanTraderHavingMaxInput: CaseBanTraderHavingMaxInput;
  CaseBanTraderHavingMinInput: CaseBanTraderHavingMinInput;
  CaseBanTraderHavingStddevPopulationInput: CaseBanTraderHavingStddevPopulationInput;
  CaseBanTraderHavingStddevSampleInput: CaseBanTraderHavingStddevSampleInput;
  CaseBanTraderHavingSumInput: CaseBanTraderHavingSumInput;
  CaseBanTraderHavingVariancePopulationInput: CaseBanTraderHavingVariancePopulationInput;
  CaseBanTraderHavingVarianceSampleInput: CaseBanTraderHavingVarianceSampleInput;
  CaseBanTraderMaxAggregateFilter: CaseBanTraderMaxAggregateFilter;
  CaseBanTraderMaxAggregates: CaseBanTraderMaxAggregates;
  CaseBanTraderMinAggregateFilter: CaseBanTraderMinAggregateFilter;
  CaseBanTraderMinAggregates: CaseBanTraderMinAggregates;
  CaseBanTraderPendingDetailsResult: CaseBanTraderPendingDetailsResult;
  CaseBanTraderResult: CaseBanTraderResult;
  CaseBanTraderStddevPopulationAggregateFilter: CaseBanTraderStddevPopulationAggregateFilter;
  CaseBanTraderStddevPopulationAggregates: CaseBanTraderStddevPopulationAggregates;
  CaseBanTraderStddevSampleAggregateFilter: CaseBanTraderStddevSampleAggregateFilter;
  CaseBanTraderStddevSampleAggregates: CaseBanTraderStddevSampleAggregates;
  CaseBanTraderSumAggregateFilter: CaseBanTraderSumAggregateFilter;
  CaseBanTraderSumAggregates: CaseBanTraderSumAggregates;
  CaseBanTraderVariancePopulationAggregateFilter: CaseBanTraderVariancePopulationAggregateFilter;
  CaseBanTraderVariancePopulationAggregates: CaseBanTraderVariancePopulationAggregates;
  CaseBanTraderVarianceSampleAggregateFilter: CaseBanTraderVarianceSampleAggregateFilter;
  CaseBanTraderVarianceSampleAggregates: CaseBanTraderVarianceSampleAggregates;
  CaseBanTradersInput: CaseBanTradersInput;
  CaseBanTradersRemovedResult: CaseBanTradersRemovedResult;
  CaseBanVariancePopulationAggregates: CaseBanVariancePopulationAggregates;
  CaseBanVarianceSampleAggregates: CaseBanVarianceSampleAggregates;
  CaseDepartment: CaseDepartment;
  CaseEvent: CaseEvent;
  CaseEventAggregates: CaseEventAggregates;
  CaseEventAggregatesFilter: CaseEventAggregatesFilter;
  CaseEventAverageAggregateFilter: CaseEventAverageAggregateFilter;
  CaseEventAverageAggregates: CaseEventAverageAggregates;
  CaseEventCondition: CaseEventCondition;
  CaseEventConnection: CaseEventConnection;
  CaseEventDistinctCountAggregateFilter: CaseEventDistinctCountAggregateFilter;
  CaseEventDistinctCountAggregates: CaseEventDistinctCountAggregates;
  CaseEventEdge: CaseEventEdge;
  CaseEventFilter: CaseEventFilter;
  CaseEventHavingAverageInput: CaseEventHavingAverageInput;
  CaseEventHavingDistinctCountInput: CaseEventHavingDistinctCountInput;
  CaseEventHavingInput: CaseEventHavingInput;
  CaseEventHavingMaxInput: CaseEventHavingMaxInput;
  CaseEventHavingMinInput: CaseEventHavingMinInput;
  CaseEventHavingStddevPopulationInput: CaseEventHavingStddevPopulationInput;
  CaseEventHavingStddevSampleInput: CaseEventHavingStddevSampleInput;
  CaseEventHavingSumInput: CaseEventHavingSumInput;
  CaseEventHavingVariancePopulationInput: CaseEventHavingVariancePopulationInput;
  CaseEventHavingVarianceSampleInput: CaseEventHavingVarianceSampleInput;
  CaseEventMaxAggregateFilter: CaseEventMaxAggregateFilter;
  CaseEventMaxAggregates: CaseEventMaxAggregates;
  CaseEventMinAggregateFilter: CaseEventMinAggregateFilter;
  CaseEventMinAggregates: CaseEventMinAggregates;
  CaseEventStddevPopulationAggregateFilter: CaseEventStddevPopulationAggregateFilter;
  CaseEventStddevPopulationAggregates: CaseEventStddevPopulationAggregates;
  CaseEventStddevSampleAggregateFilter: CaseEventStddevSampleAggregateFilter;
  CaseEventStddevSampleAggregates: CaseEventStddevSampleAggregates;
  CaseEventSumAggregateFilter: CaseEventSumAggregateFilter;
  CaseEventSumAggregates: CaseEventSumAggregates;
  CaseEventVariancePopulationAggregateFilter: CaseEventVariancePopulationAggregateFilter;
  CaseEventVariancePopulationAggregates: CaseEventVariancePopulationAggregates;
  CaseEventVarianceSampleAggregateFilter: CaseEventVarianceSampleAggregateFilter;
  CaseEventVarianceSampleAggregates: CaseEventVarianceSampleAggregates;
  CaseInvestigation: CaseInvestigation;
  CaseInvestigationAggregates: CaseInvestigationAggregates;
  CaseInvestigationAggregatesFilter: CaseInvestigationAggregatesFilter;
  CaseInvestigationAverageAggregateFilter: CaseInvestigationAverageAggregateFilter;
  CaseInvestigationAverageAggregates: CaseInvestigationAverageAggregates;
  CaseInvestigationCondition: CaseInvestigationCondition;
  CaseInvestigationConnection: CaseInvestigationConnection;
  CaseInvestigationDistinctCountAggregateFilter: CaseInvestigationDistinctCountAggregateFilter;
  CaseInvestigationDistinctCountAggregates: CaseInvestigationDistinctCountAggregates;
  CaseInvestigationEdge: CaseInvestigationEdge;
  CaseInvestigationEventResult: CaseInvestigationEventResult;
  CaseInvestigationFilter: CaseInvestigationFilter;
  CaseInvestigationHavingAverageInput: CaseInvestigationHavingAverageInput;
  CaseInvestigationHavingDistinctCountInput: CaseInvestigationHavingDistinctCountInput;
  CaseInvestigationHavingInput: CaseInvestigationHavingInput;
  CaseInvestigationHavingMaxInput: CaseInvestigationHavingMaxInput;
  CaseInvestigationHavingMinInput: CaseInvestigationHavingMinInput;
  CaseInvestigationHavingStddevPopulationInput: CaseInvestigationHavingStddevPopulationInput;
  CaseInvestigationHavingStddevSampleInput: CaseInvestigationHavingStddevSampleInput;
  CaseInvestigationHavingSumInput: CaseInvestigationHavingSumInput;
  CaseInvestigationHavingVariancePopulationInput: CaseInvestigationHavingVariancePopulationInput;
  CaseInvestigationHavingVarianceSampleInput: CaseInvestigationHavingVarianceSampleInput;
  CaseInvestigationMaxAggregateFilter: CaseInvestigationMaxAggregateFilter;
  CaseInvestigationMaxAggregates: CaseInvestigationMaxAggregates;
  CaseInvestigationMinAggregateFilter: CaseInvestigationMinAggregateFilter;
  CaseInvestigationMinAggregates: CaseInvestigationMinAggregates;
  CaseInvestigationResult: CaseInvestigationResult;
  CaseInvestigationStddevPopulationAggregateFilter: CaseInvestigationStddevPopulationAggregateFilter;
  CaseInvestigationStddevPopulationAggregates: CaseInvestigationStddevPopulationAggregates;
  CaseInvestigationStddevSampleAggregateFilter: CaseInvestigationStddevSampleAggregateFilter;
  CaseInvestigationStddevSampleAggregates: CaseInvestigationStddevSampleAggregates;
  CaseInvestigationSubmittedDepartment: CaseInvestigationSubmittedDepartment;
  CaseInvestigationSubmittedDepartmentAggregates: CaseInvestigationSubmittedDepartmentAggregates;
  CaseInvestigationSubmittedDepartmentAverageAggregates: CaseInvestigationSubmittedDepartmentAverageAggregates;
  CaseInvestigationSubmittedDepartmentCondition: CaseInvestigationSubmittedDepartmentCondition;
  CaseInvestigationSubmittedDepartmentConnection: CaseInvestigationSubmittedDepartmentConnection;
  CaseInvestigationSubmittedDepartmentDistinctCountAggregates: CaseInvestigationSubmittedDepartmentDistinctCountAggregates;
  CaseInvestigationSubmittedDepartmentEdge: CaseInvestigationSubmittedDepartmentEdge;
  CaseInvestigationSubmittedDepartmentFilter: CaseInvestigationSubmittedDepartmentFilter;
  CaseInvestigationSubmittedDepartmentMaxAggregates: CaseInvestigationSubmittedDepartmentMaxAggregates;
  CaseInvestigationSubmittedDepartmentMinAggregates: CaseInvestigationSubmittedDepartmentMinAggregates;
  CaseInvestigationSubmittedDepartmentStddevPopulationAggregates: CaseInvestigationSubmittedDepartmentStddevPopulationAggregates;
  CaseInvestigationSubmittedDepartmentStddevSampleAggregates: CaseInvestigationSubmittedDepartmentStddevSampleAggregates;
  CaseInvestigationSubmittedDepartmentSumAggregates: CaseInvestigationSubmittedDepartmentSumAggregates;
  CaseInvestigationSubmittedDepartmentToManyCaseInvestigationFilter: CaseInvestigationSubmittedDepartmentToManyCaseInvestigationFilter;
  CaseInvestigationSubmittedDepartmentVariancePopulationAggregates: CaseInvestigationSubmittedDepartmentVariancePopulationAggregates;
  CaseInvestigationSubmittedDepartmentVarianceSampleAggregates: CaseInvestigationSubmittedDepartmentVarianceSampleAggregates;
  CaseInvestigationSumAggregateFilter: CaseInvestigationSumAggregateFilter;
  CaseInvestigationSumAggregates: CaseInvestigationSumAggregates;
  CaseInvestigationToManyCaseEventFilter: CaseInvestigationToManyCaseEventFilter;
  CaseInvestigationToManyCaseInvestigationTraderFilter: CaseInvestigationToManyCaseInvestigationTraderFilter;
  CaseInvestigationToManyCaseLabelAssignmentFilter: CaseInvestigationToManyCaseLabelAssignmentFilter;
  CaseInvestigationTrader: CaseInvestigationTrader;
  CaseInvestigationTraderAggregates: CaseInvestigationTraderAggregates;
  CaseInvestigationTraderAggregatesFilter: CaseInvestigationTraderAggregatesFilter;
  CaseInvestigationTraderAverageAggregateFilter: CaseInvestigationTraderAverageAggregateFilter;
  CaseInvestigationTraderAverageAggregates: CaseInvestigationTraderAverageAggregates;
  CaseInvestigationTraderCondition: CaseInvestigationTraderCondition;
  CaseInvestigationTraderConnection: CaseInvestigationTraderConnection;
  CaseInvestigationTraderDistinctCountAggregateFilter: CaseInvestigationTraderDistinctCountAggregateFilter;
  CaseInvestigationTraderDistinctCountAggregates: CaseInvestigationTraderDistinctCountAggregates;
  CaseInvestigationTraderEdge: CaseInvestigationTraderEdge;
  CaseInvestigationTraderFilter: CaseInvestigationTraderFilter;
  CaseInvestigationTraderHavingAverageInput: CaseInvestigationTraderHavingAverageInput;
  CaseInvestigationTraderHavingDistinctCountInput: CaseInvestigationTraderHavingDistinctCountInput;
  CaseInvestigationTraderHavingInput: CaseInvestigationTraderHavingInput;
  CaseInvestigationTraderHavingMaxInput: CaseInvestigationTraderHavingMaxInput;
  CaseInvestigationTraderHavingMinInput: CaseInvestigationTraderHavingMinInput;
  CaseInvestigationTraderHavingStddevPopulationInput: CaseInvestigationTraderHavingStddevPopulationInput;
  CaseInvestigationTraderHavingStddevSampleInput: CaseInvestigationTraderHavingStddevSampleInput;
  CaseInvestigationTraderHavingSumInput: CaseInvestigationTraderHavingSumInput;
  CaseInvestigationTraderHavingVariancePopulationInput: CaseInvestigationTraderHavingVariancePopulationInput;
  CaseInvestigationTraderHavingVarianceSampleInput: CaseInvestigationTraderHavingVarianceSampleInput;
  CaseInvestigationTraderMaxAggregateFilter: CaseInvestigationTraderMaxAggregateFilter;
  CaseInvestigationTraderMaxAggregates: CaseInvestigationTraderMaxAggregates;
  CaseInvestigationTraderMinAggregateFilter: CaseInvestigationTraderMinAggregateFilter;
  CaseInvestigationTraderMinAggregates: CaseInvestigationTraderMinAggregates;
  CaseInvestigationTraderPendingDetailsResult: CaseInvestigationTraderPendingDetailsResult;
  CaseInvestigationTraderResult: CaseInvestigationTraderResult;
  CaseInvestigationTraderStddevPopulationAggregateFilter: CaseInvestigationTraderStddevPopulationAggregateFilter;
  CaseInvestigationTraderStddevPopulationAggregates: CaseInvestigationTraderStddevPopulationAggregates;
  CaseInvestigationTraderStddevSampleAggregateFilter: CaseInvestigationTraderStddevSampleAggregateFilter;
  CaseInvestigationTraderStddevSampleAggregates: CaseInvestigationTraderStddevSampleAggregates;
  CaseInvestigationTraderSumAggregateFilter: CaseInvestigationTraderSumAggregateFilter;
  CaseInvestigationTraderSumAggregates: CaseInvestigationTraderSumAggregates;
  CaseInvestigationTraderVariancePopulationAggregateFilter: CaseInvestigationTraderVariancePopulationAggregateFilter;
  CaseInvestigationTraderVariancePopulationAggregates: CaseInvestigationTraderVariancePopulationAggregates;
  CaseInvestigationTraderVarianceSampleAggregateFilter: CaseInvestigationTraderVarianceSampleAggregateFilter;
  CaseInvestigationTraderVarianceSampleAggregates: CaseInvestigationTraderVarianceSampleAggregates;
  CaseInvestigationTradersInput: CaseInvestigationTradersInput;
  CaseInvestigationTradersRemovedResult: CaseInvestigationTradersRemovedResult;
  CaseInvestigationVariancePopulationAggregateFilter: CaseInvestigationVariancePopulationAggregateFilter;
  CaseInvestigationVariancePopulationAggregates: CaseInvestigationVariancePopulationAggregates;
  CaseInvestigationVarianceSampleAggregateFilter: CaseInvestigationVarianceSampleAggregateFilter;
  CaseInvestigationVarianceSampleAggregates: CaseInvestigationVarianceSampleAggregates;
  CaseLabel: CaseLabel;
  CaseLabelAggregates: CaseLabelAggregates;
  CaseLabelAssignment: CaseLabelAssignment;
  CaseLabelAssignmentAggregates: CaseLabelAssignmentAggregates;
  CaseLabelAssignmentAggregatesFilter: CaseLabelAssignmentAggregatesFilter;
  CaseLabelAssignmentAverageAggregateFilter: CaseLabelAssignmentAverageAggregateFilter;
  CaseLabelAssignmentAverageAggregates: CaseLabelAssignmentAverageAggregates;
  CaseLabelAssignmentCondition: CaseLabelAssignmentCondition;
  CaseLabelAssignmentConnection: CaseLabelAssignmentConnection;
  CaseLabelAssignmentDistinctCountAggregateFilter: CaseLabelAssignmentDistinctCountAggregateFilter;
  CaseLabelAssignmentDistinctCountAggregates: CaseLabelAssignmentDistinctCountAggregates;
  CaseLabelAssignmentEdge: CaseLabelAssignmentEdge;
  CaseLabelAssignmentFilter: CaseLabelAssignmentFilter;
  CaseLabelAssignmentHavingAverageInput: CaseLabelAssignmentHavingAverageInput;
  CaseLabelAssignmentHavingDistinctCountInput: CaseLabelAssignmentHavingDistinctCountInput;
  CaseLabelAssignmentHavingInput: CaseLabelAssignmentHavingInput;
  CaseLabelAssignmentHavingMaxInput: CaseLabelAssignmentHavingMaxInput;
  CaseLabelAssignmentHavingMinInput: CaseLabelAssignmentHavingMinInput;
  CaseLabelAssignmentHavingStddevPopulationInput: CaseLabelAssignmentHavingStddevPopulationInput;
  CaseLabelAssignmentHavingStddevSampleInput: CaseLabelAssignmentHavingStddevSampleInput;
  CaseLabelAssignmentHavingSumInput: CaseLabelAssignmentHavingSumInput;
  CaseLabelAssignmentHavingVariancePopulationInput: CaseLabelAssignmentHavingVariancePopulationInput;
  CaseLabelAssignmentHavingVarianceSampleInput: CaseLabelAssignmentHavingVarianceSampleInput;
  CaseLabelAssignmentMaxAggregateFilter: CaseLabelAssignmentMaxAggregateFilter;
  CaseLabelAssignmentMaxAggregates: CaseLabelAssignmentMaxAggregates;
  CaseLabelAssignmentMinAggregateFilter: CaseLabelAssignmentMinAggregateFilter;
  CaseLabelAssignmentMinAggregates: CaseLabelAssignmentMinAggregates;
  CaseLabelAssignmentStddevPopulationAggregateFilter: CaseLabelAssignmentStddevPopulationAggregateFilter;
  CaseLabelAssignmentStddevPopulationAggregates: CaseLabelAssignmentStddevPopulationAggregates;
  CaseLabelAssignmentStddevSampleAggregateFilter: CaseLabelAssignmentStddevSampleAggregateFilter;
  CaseLabelAssignmentStddevSampleAggregates: CaseLabelAssignmentStddevSampleAggregates;
  CaseLabelAssignmentSumAggregateFilter: CaseLabelAssignmentSumAggregateFilter;
  CaseLabelAssignmentSumAggregates: CaseLabelAssignmentSumAggregates;
  CaseLabelAssignmentVariancePopulationAggregateFilter: CaseLabelAssignmentVariancePopulationAggregateFilter;
  CaseLabelAssignmentVariancePopulationAggregates: CaseLabelAssignmentVariancePopulationAggregates;
  CaseLabelAssignmentVarianceSampleAggregateFilter: CaseLabelAssignmentVarianceSampleAggregateFilter;
  CaseLabelAssignmentVarianceSampleAggregates: CaseLabelAssignmentVarianceSampleAggregates;
  CaseLabelAverageAggregates: CaseLabelAverageAggregates;
  CaseLabelCondition: CaseLabelCondition;
  CaseLabelConnection: CaseLabelConnection;
  CaseLabelDistinctCountAggregates: CaseLabelDistinctCountAggregates;
  CaseLabelEdge: CaseLabelEdge;
  CaseLabelFilter: CaseLabelFilter;
  CaseLabelMaxAggregates: CaseLabelMaxAggregates;
  CaseLabelMinAggregates: CaseLabelMinAggregates;
  CaseLabelStddevPopulationAggregates: CaseLabelStddevPopulationAggregates;
  CaseLabelStddevSampleAggregates: CaseLabelStddevSampleAggregates;
  CaseLabelSumAggregates: CaseLabelSumAggregates;
  CaseLabelVariancePopulationAggregates: CaseLabelVariancePopulationAggregates;
  CaseLabelVarianceSampleAggregates: CaseLabelVarianceSampleAggregates;
  CaseSeverityFilter: CaseSeverityFilter;
  CaseStatusFilter: CaseStatusFilter;
  CaseType: CaseType;
  CaseTypeAggregates: CaseTypeAggregates;
  CaseTypeAverageAggregates: CaseTypeAverageAggregates;
  CaseTypeCondition: CaseTypeCondition;
  CaseTypeConnection: CaseTypeConnection;
  CaseTypeDistinctCountAggregates: CaseTypeDistinctCountAggregates;
  CaseTypeEdge: CaseTypeEdge;
  CaseTypeFilter: CaseTypeFilter;
  CaseTypeMaxAggregates: CaseTypeMaxAggregates;
  CaseTypeMinAggregates: CaseTypeMinAggregates;
  CaseTypeStddevPopulationAggregates: CaseTypeStddevPopulationAggregates;
  CaseTypeStddevSampleAggregates: CaseTypeStddevSampleAggregates;
  CaseTypeSumAggregates: CaseTypeSumAggregates;
  CaseTypeVariancePopulationAggregates: CaseTypeVariancePopulationAggregates;
  CaseTypeVarianceSampleAggregates: CaseTypeVarianceSampleAggregates;
  Chargeback: Chargeback;
  ChargebackAdminAction: ChargebackAdminAction;
  ChargebackAggregates: ChargebackAggregates;
  ChargebackAggregatesFilter: ChargebackAggregatesFilter;
  ChargebackAverageAggregateFilter: ChargebackAverageAggregateFilter;
  ChargebackAverageAggregates: ChargebackAverageAggregates;
  ChargebackCondition: ChargebackCondition;
  ChargebackConnection: ChargebackConnection;
  ChargebackDistinctCountAggregateFilter: ChargebackDistinctCountAggregateFilter;
  ChargebackDistinctCountAggregates: ChargebackDistinctCountAggregates;
  ChargebackEdge: ChargebackEdge;
  ChargebackFeedRun: ChargebackFeedRun;
  ChargebackFeedRunFilter: ChargebackFeedRunFilter;
  ChargebackFeedRunToManyChargebackFeedVersionFilter: ChargebackFeedRunToManyChargebackFeedVersionFilter;
  ChargebackFeedSource: ChargebackFeedSource;
  ChargebackFeedVersion: ChargebackFeedVersion;
  ChargebackFeedVersionAggregates: ChargebackFeedVersionAggregates;
  ChargebackFeedVersionAggregatesFilter: ChargebackFeedVersionAggregatesFilter;
  ChargebackFeedVersionAverageAggregateFilter: ChargebackFeedVersionAverageAggregateFilter;
  ChargebackFeedVersionAverageAggregates: ChargebackFeedVersionAverageAggregates;
  ChargebackFeedVersionCondition: ChargebackFeedVersionCondition;
  ChargebackFeedVersionConnection: ChargebackFeedVersionConnection;
  ChargebackFeedVersionDistinctCountAggregateFilter: ChargebackFeedVersionDistinctCountAggregateFilter;
  ChargebackFeedVersionDistinctCountAggregates: ChargebackFeedVersionDistinctCountAggregates;
  ChargebackFeedVersionEdge: ChargebackFeedVersionEdge;
  ChargebackFeedVersionFilter: ChargebackFeedVersionFilter;
  ChargebackFeedVersionHavingAverageInput: ChargebackFeedVersionHavingAverageInput;
  ChargebackFeedVersionHavingDistinctCountInput: ChargebackFeedVersionHavingDistinctCountInput;
  ChargebackFeedVersionHavingInput: ChargebackFeedVersionHavingInput;
  ChargebackFeedVersionHavingMaxInput: ChargebackFeedVersionHavingMaxInput;
  ChargebackFeedVersionHavingMinInput: ChargebackFeedVersionHavingMinInput;
  ChargebackFeedVersionHavingStddevPopulationInput: ChargebackFeedVersionHavingStddevPopulationInput;
  ChargebackFeedVersionHavingStddevSampleInput: ChargebackFeedVersionHavingStddevSampleInput;
  ChargebackFeedVersionHavingSumInput: ChargebackFeedVersionHavingSumInput;
  ChargebackFeedVersionHavingVariancePopulationInput: ChargebackFeedVersionHavingVariancePopulationInput;
  ChargebackFeedVersionHavingVarianceSampleInput: ChargebackFeedVersionHavingVarianceSampleInput;
  ChargebackFeedVersionMaxAggregateFilter: ChargebackFeedVersionMaxAggregateFilter;
  ChargebackFeedVersionMaxAggregates: ChargebackFeedVersionMaxAggregates;
  ChargebackFeedVersionMinAggregateFilter: ChargebackFeedVersionMinAggregateFilter;
  ChargebackFeedVersionMinAggregates: ChargebackFeedVersionMinAggregates;
  ChargebackFeedVersionStddevPopulationAggregateFilter: ChargebackFeedVersionStddevPopulationAggregateFilter;
  ChargebackFeedVersionStddevPopulationAggregates: ChargebackFeedVersionStddevPopulationAggregates;
  ChargebackFeedVersionStddevSampleAggregateFilter: ChargebackFeedVersionStddevSampleAggregateFilter;
  ChargebackFeedVersionStddevSampleAggregates: ChargebackFeedVersionStddevSampleAggregates;
  ChargebackFeedVersionSumAggregateFilter: ChargebackFeedVersionSumAggregateFilter;
  ChargebackFeedVersionSumAggregates: ChargebackFeedVersionSumAggregates;
  ChargebackFeedVersionVariancePopulationAggregateFilter: ChargebackFeedVersionVariancePopulationAggregateFilter;
  ChargebackFeedVersionVariancePopulationAggregates: ChargebackFeedVersionVariancePopulationAggregates;
  ChargebackFeedVersionVarianceSampleAggregateFilter: ChargebackFeedVersionVarianceSampleAggregateFilter;
  ChargebackFeedVersionVarianceSampleAggregates: ChargebackFeedVersionVarianceSampleAggregates;
  ChargebackFilter: ChargebackFilter;
  ChargebackFlag: ChargebackFlag;
  ChargebackHavingAverageInput: ChargebackHavingAverageInput;
  ChargebackHavingDistinctCountInput: ChargebackHavingDistinctCountInput;
  ChargebackHavingInput: ChargebackHavingInput;
  ChargebackHavingMaxInput: ChargebackHavingMaxInput;
  ChargebackHavingMinInput: ChargebackHavingMinInput;
  ChargebackHavingStddevPopulationInput: ChargebackHavingStddevPopulationInput;
  ChargebackHavingStddevSampleInput: ChargebackHavingStddevSampleInput;
  ChargebackHavingSumInput: ChargebackHavingSumInput;
  ChargebackHavingVariancePopulationInput: ChargebackHavingVariancePopulationInput;
  ChargebackHavingVarianceSampleInput: ChargebackHavingVarianceSampleInput;
  ChargebackIndicator: ChargebackIndicator;
  ChargebackIndicatorAggregates: ChargebackIndicatorAggregates;
  ChargebackIndicatorAggregatesFilter: ChargebackIndicatorAggregatesFilter;
  ChargebackIndicatorAverageAggregateFilter: ChargebackIndicatorAverageAggregateFilter;
  ChargebackIndicatorAverageAggregates: ChargebackIndicatorAverageAggregates;
  ChargebackIndicatorCondition: ChargebackIndicatorCondition;
  ChargebackIndicatorConnection: ChargebackIndicatorConnection;
  ChargebackIndicatorDistinctCountAggregateFilter: ChargebackIndicatorDistinctCountAggregateFilter;
  ChargebackIndicatorDistinctCountAggregates: ChargebackIndicatorDistinctCountAggregates;
  ChargebackIndicatorEdge: ChargebackIndicatorEdge;
  ChargebackIndicatorFilter: ChargebackIndicatorFilter;
  ChargebackIndicatorHavingAverageInput: ChargebackIndicatorHavingAverageInput;
  ChargebackIndicatorHavingDistinctCountInput: ChargebackIndicatorHavingDistinctCountInput;
  ChargebackIndicatorHavingInput: ChargebackIndicatorHavingInput;
  ChargebackIndicatorHavingMaxInput: ChargebackIndicatorHavingMaxInput;
  ChargebackIndicatorHavingMinInput: ChargebackIndicatorHavingMinInput;
  ChargebackIndicatorHavingStddevPopulationInput: ChargebackIndicatorHavingStddevPopulationInput;
  ChargebackIndicatorHavingStddevSampleInput: ChargebackIndicatorHavingStddevSampleInput;
  ChargebackIndicatorHavingSumInput: ChargebackIndicatorHavingSumInput;
  ChargebackIndicatorHavingVariancePopulationInput: ChargebackIndicatorHavingVariancePopulationInput;
  ChargebackIndicatorHavingVarianceSampleInput: ChargebackIndicatorHavingVarianceSampleInput;
  ChargebackIndicatorMaxAggregateFilter: ChargebackIndicatorMaxAggregateFilter;
  ChargebackIndicatorMaxAggregates: ChargebackIndicatorMaxAggregates;
  ChargebackIndicatorMinAggregateFilter: ChargebackIndicatorMinAggregateFilter;
  ChargebackIndicatorMinAggregates: ChargebackIndicatorMinAggregates;
  ChargebackIndicatorStddevPopulationAggregateFilter: ChargebackIndicatorStddevPopulationAggregateFilter;
  ChargebackIndicatorStddevPopulationAggregates: ChargebackIndicatorStddevPopulationAggregates;
  ChargebackIndicatorStddevSampleAggregateFilter: ChargebackIndicatorStddevSampleAggregateFilter;
  ChargebackIndicatorStddevSampleAggregates: ChargebackIndicatorStddevSampleAggregates;
  ChargebackIndicatorSumAggregateFilter: ChargebackIndicatorSumAggregateFilter;
  ChargebackIndicatorSumAggregates: ChargebackIndicatorSumAggregates;
  ChargebackIndicatorVariancePopulationAggregateFilter: ChargebackIndicatorVariancePopulationAggregateFilter;
  ChargebackIndicatorVariancePopulationAggregates: ChargebackIndicatorVariancePopulationAggregates;
  ChargebackIndicatorVarianceSampleAggregateFilter: ChargebackIndicatorVarianceSampleAggregateFilter;
  ChargebackIndicatorVarianceSampleAggregates: ChargebackIndicatorVarianceSampleAggregates;
  ChargebackMaxAggregateFilter: ChargebackMaxAggregateFilter;
  ChargebackMaxAggregates: ChargebackMaxAggregates;
  ChargebackMinAggregateFilter: ChargebackMinAggregateFilter;
  ChargebackMinAggregates: ChargebackMinAggregates;
  ChargebackProcessorFilter: ChargebackProcessorFilter;
  ChargebackResult: ChargebackResult;
  ChargebackStddevPopulationAggregateFilter: ChargebackStddevPopulationAggregateFilter;
  ChargebackStddevPopulationAggregates: ChargebackStddevPopulationAggregates;
  ChargebackStddevSampleAggregateFilter: ChargebackStddevSampleAggregateFilter;
  ChargebackStddevSampleAggregates: ChargebackStddevSampleAggregates;
  ChargebackSumAggregateFilter: ChargebackSumAggregateFilter;
  ChargebackSumAggregates: ChargebackSumAggregates;
  ChargebackTotals: ChargebackTotals;
  ChargebackVariancePopulationAggregateFilter: ChargebackVariancePopulationAggregateFilter;
  ChargebackVariancePopulationAggregates: ChargebackVariancePopulationAggregates;
  ChargebackVarianceSampleAggregateFilter: ChargebackVarianceSampleAggregateFilter;
  ChargebackVarianceSampleAggregates: ChargebackVarianceSampleAggregates;
  CheckoutItem: CheckoutItem;
  CheckoutItemAggregates: CheckoutItemAggregates;
  CheckoutItemAggregatesFilter: CheckoutItemAggregatesFilter;
  CheckoutItemAverageAggregateFilter: CheckoutItemAverageAggregateFilter;
  CheckoutItemAverageAggregates: CheckoutItemAverageAggregates;
  CheckoutItemCondition: CheckoutItemCondition;
  CheckoutItemConnection: CheckoutItemConnection;
  CheckoutItemDistinctCountAggregateFilter: CheckoutItemDistinctCountAggregateFilter;
  CheckoutItemDistinctCountAggregates: CheckoutItemDistinctCountAggregates;
  CheckoutItemEdge: CheckoutItemEdge;
  CheckoutItemFilter: CheckoutItemFilter;
  CheckoutItemHavingAverageInput: CheckoutItemHavingAverageInput;
  CheckoutItemHavingDistinctCountInput: CheckoutItemHavingDistinctCountInput;
  CheckoutItemHavingInput: CheckoutItemHavingInput;
  CheckoutItemHavingMaxInput: CheckoutItemHavingMaxInput;
  CheckoutItemHavingMinInput: CheckoutItemHavingMinInput;
  CheckoutItemHavingStddevPopulationInput: CheckoutItemHavingStddevPopulationInput;
  CheckoutItemHavingStddevSampleInput: CheckoutItemHavingStddevSampleInput;
  CheckoutItemHavingSumInput: CheckoutItemHavingSumInput;
  CheckoutItemHavingVariancePopulationInput: CheckoutItemHavingVariancePopulationInput;
  CheckoutItemHavingVarianceSampleInput: CheckoutItemHavingVarianceSampleInput;
  CheckoutItemMaxAggregateFilter: CheckoutItemMaxAggregateFilter;
  CheckoutItemMaxAggregates: CheckoutItemMaxAggregates;
  CheckoutItemMinAggregateFilter: CheckoutItemMinAggregateFilter;
  CheckoutItemMinAggregates: CheckoutItemMinAggregates;
  CheckoutItemStddevPopulationAggregateFilter: CheckoutItemStddevPopulationAggregateFilter;
  CheckoutItemStddevPopulationAggregates: CheckoutItemStddevPopulationAggregates;
  CheckoutItemStddevSampleAggregateFilter: CheckoutItemStddevSampleAggregateFilter;
  CheckoutItemStddevSampleAggregates: CheckoutItemStddevSampleAggregates;
  CheckoutItemSumAggregateFilter: CheckoutItemSumAggregateFilter;
  CheckoutItemSumAggregates: CheckoutItemSumAggregates;
  CheckoutItemVariancePopulationAggregateFilter: CheckoutItemVariancePopulationAggregateFilter;
  CheckoutItemVariancePopulationAggregates: CheckoutItemVariancePopulationAggregates;
  CheckoutItemVarianceSampleAggregateFilter: CheckoutItemVarianceSampleAggregateFilter;
  CheckoutItemVarianceSampleAggregates: CheckoutItemVarianceSampleAggregates;
  CheckoutSession: CheckoutSession;
  CheckoutSessionAggregates: CheckoutSessionAggregates;
  CheckoutSessionAggregatesFilter: CheckoutSessionAggregatesFilter;
  CheckoutSessionAverageAggregateFilter: CheckoutSessionAverageAggregateFilter;
  CheckoutSessionAverageAggregates: CheckoutSessionAverageAggregates;
  CheckoutSessionCondition: CheckoutSessionCondition;
  CheckoutSessionConnection: CheckoutSessionConnection;
  CheckoutSessionDistinctCountAggregateFilter: CheckoutSessionDistinctCountAggregateFilter;
  CheckoutSessionDistinctCountAggregates: CheckoutSessionDistinctCountAggregates;
  CheckoutSessionEdge: CheckoutSessionEdge;
  CheckoutSessionFilter: CheckoutSessionFilter;
  CheckoutSessionHavingAverageInput: CheckoutSessionHavingAverageInput;
  CheckoutSessionHavingDistinctCountInput: CheckoutSessionHavingDistinctCountInput;
  CheckoutSessionHavingInput: CheckoutSessionHavingInput;
  CheckoutSessionHavingMaxInput: CheckoutSessionHavingMaxInput;
  CheckoutSessionHavingMinInput: CheckoutSessionHavingMinInput;
  CheckoutSessionHavingStddevPopulationInput: CheckoutSessionHavingStddevPopulationInput;
  CheckoutSessionHavingStddevSampleInput: CheckoutSessionHavingStddevSampleInput;
  CheckoutSessionHavingSumInput: CheckoutSessionHavingSumInput;
  CheckoutSessionHavingVariancePopulationInput: CheckoutSessionHavingVariancePopulationInput;
  CheckoutSessionHavingVarianceSampleInput: CheckoutSessionHavingVarianceSampleInput;
  CheckoutSessionMaxAggregateFilter: CheckoutSessionMaxAggregateFilter;
  CheckoutSessionMaxAggregates: CheckoutSessionMaxAggregates;
  CheckoutSessionMinAggregateFilter: CheckoutSessionMinAggregateFilter;
  CheckoutSessionMinAggregates: CheckoutSessionMinAggregates;
  CheckoutSessionStatusEnumFilter: CheckoutSessionStatusEnumFilter;
  CheckoutSessionStddevPopulationAggregateFilter: CheckoutSessionStddevPopulationAggregateFilter;
  CheckoutSessionStddevPopulationAggregates: CheckoutSessionStddevPopulationAggregates;
  CheckoutSessionStddevSampleAggregateFilter: CheckoutSessionStddevSampleAggregateFilter;
  CheckoutSessionStddevSampleAggregates: CheckoutSessionStddevSampleAggregates;
  CheckoutSessionSumAggregateFilter: CheckoutSessionSumAggregateFilter;
  CheckoutSessionSumAggregates: CheckoutSessionSumAggregates;
  CheckoutSessionToManyCheckoutItemFilter: CheckoutSessionToManyCheckoutItemFilter;
  CheckoutSessionVariancePopulationAggregateFilter: CheckoutSessionVariancePopulationAggregateFilter;
  CheckoutSessionVariancePopulationAggregates: CheckoutSessionVariancePopulationAggregates;
  CheckoutSessionVarianceSampleAggregateFilter: CheckoutSessionVarianceSampleAggregateFilter;
  CheckoutSessionVarianceSampleAggregates: CheckoutSessionVarianceSampleAggregates;
  CorrectAccountCapitalEntryInput: CorrectAccountCapitalEntryInput;
  Coupon: Coupon;
  CouponAggregates: CouponAggregates;
  CouponAverageAggregates: CouponAverageAggregates;
  CouponCondition: CouponCondition;
  CouponConnection: CouponConnection;
  CouponDistinctCountAggregates: CouponDistinctCountAggregates;
  CouponEdge: CouponEdge;
  CouponFilter: CouponFilter;
  CouponHavingAverageInput: CouponHavingAverageInput;
  CouponHavingDistinctCountInput: CouponHavingDistinctCountInput;
  CouponHavingInput: CouponHavingInput;
  CouponHavingMaxInput: CouponHavingMaxInput;
  CouponHavingMinInput: CouponHavingMinInput;
  CouponHavingStddevPopulationInput: CouponHavingStddevPopulationInput;
  CouponHavingStddevSampleInput: CouponHavingStddevSampleInput;
  CouponHavingSumInput: CouponHavingSumInput;
  CouponHavingVariancePopulationInput: CouponHavingVariancePopulationInput;
  CouponHavingVarianceSampleInput: CouponHavingVarianceSampleInput;
  CouponMaxAggregates: CouponMaxAggregates;
  CouponMinAggregates: CouponMinAggregates;
  CouponPlatform: CouponPlatform;
  CouponRedemption: CouponRedemption;
  CouponStddevPopulationAggregates: CouponStddevPopulationAggregates;
  CouponStddevSampleAggregates: CouponStddevSampleAggregates;
  CouponSumAggregates: CouponSumAggregates;
  CouponToManyCouponUserFilter: CouponToManyCouponUserFilter;
  CouponToManyNmiSubscriptionFilter: CouponToManyNmiSubscriptionFilter;
  CouponToManyTraderPublicProfileFilter: CouponToManyTraderPublicProfileFilter;
  CouponToManyUserSubscriptionFilter: CouponToManyUserSubscriptionFilter;
  CouponUser: CouponUser;
  CouponUserAggregates: CouponUserAggregates;
  CouponUserAggregatesFilter: CouponUserAggregatesFilter;
  CouponUserAverageAggregateFilter: CouponUserAverageAggregateFilter;
  CouponUserAverageAggregates: CouponUserAverageAggregates;
  CouponUserCondition: CouponUserCondition;
  CouponUserConnection: CouponUserConnection;
  CouponUserDistinctCountAggregateFilter: CouponUserDistinctCountAggregateFilter;
  CouponUserDistinctCountAggregates: CouponUserDistinctCountAggregates;
  CouponUserEdge: CouponUserEdge;
  CouponUserFilter: CouponUserFilter;
  CouponUserHavingAverageInput: CouponUserHavingAverageInput;
  CouponUserHavingDistinctCountInput: CouponUserHavingDistinctCountInput;
  CouponUserHavingInput: CouponUserHavingInput;
  CouponUserHavingMaxInput: CouponUserHavingMaxInput;
  CouponUserHavingMinInput: CouponUserHavingMinInput;
  CouponUserHavingStddevPopulationInput: CouponUserHavingStddevPopulationInput;
  CouponUserHavingStddevSampleInput: CouponUserHavingStddevSampleInput;
  CouponUserHavingSumInput: CouponUserHavingSumInput;
  CouponUserHavingVariancePopulationInput: CouponUserHavingVariancePopulationInput;
  CouponUserHavingVarianceSampleInput: CouponUserHavingVarianceSampleInput;
  CouponUserMaxAggregateFilter: CouponUserMaxAggregateFilter;
  CouponUserMaxAggregates: CouponUserMaxAggregates;
  CouponUserMinAggregateFilter: CouponUserMinAggregateFilter;
  CouponUserMinAggregates: CouponUserMinAggregates;
  CouponUserStddevPopulationAggregateFilter: CouponUserStddevPopulationAggregateFilter;
  CouponUserStddevPopulationAggregates: CouponUserStddevPopulationAggregates;
  CouponUserStddevSampleAggregateFilter: CouponUserStddevSampleAggregateFilter;
  CouponUserStddevSampleAggregates: CouponUserStddevSampleAggregates;
  CouponUserSumAggregateFilter: CouponUserSumAggregateFilter;
  CouponUserSumAggregates: CouponUserSumAggregates;
  CouponUserVariancePopulationAggregateFilter: CouponUserVariancePopulationAggregateFilter;
  CouponUserVariancePopulationAggregates: CouponUserVariancePopulationAggregates;
  CouponUserVarianceSampleAggregateFilter: CouponUserVarianceSampleAggregateFilter;
  CouponUserVarianceSampleAggregates: CouponUserVarianceSampleAggregates;
  CouponVariancePopulationAggregates: CouponVariancePopulationAggregates;
  CouponVarianceSampleAggregates: CouponVarianceSampleAggregates;
  CreateAccountCapitalEntryInput: CreateAccountCapitalEntryInput;
  CreateCaseBanInput: CreateCaseBanInput;
  CreateCaseInvestigationInput: CreateCaseInvestigationInput;
  CreateCaseTypeInput: CreateCaseTypeInput;
  CreateImpactGroupAssignmentInput: CreateImpactGroupAssignmentInput;
  CreateImpactGroupAssignmentPayload: Omit<CreateImpactGroupAssignmentPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateImpactGroupTemplateInput: CreateImpactGroupTemplateInput;
  CreateImpactGroupTemplatePayload: Omit<CreateImpactGroupTemplatePayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateKycPriorityLabelInput: CreateKycPriorityLabelInput;
  CreateKycPriorityLabelPayload: Omit<CreateKycPriorityLabelPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateKycPriorityReviewConfigInput: CreateKycPriorityReviewConfigInput;
  CreateKycPriorityReviewConfigPayload: CreateKycPriorityReviewConfigPayload;
  CreateReasonCodeInput: CreateReasonCodeInput;
  CreateTraderRiskIndicatorInput: CreateTraderRiskIndicatorInput;
  CreateTraderRiskIndicatorPayload: Omit<CreateTraderRiskIndicatorPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateTradingProductFeeInput: CreateTradingProductFeeInput;
  CreateTradingProductFeePayload: Omit<CreateTradingProductFeePayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateUserAddressInput: CreateUserAddressInput;
  CreateUserAddressPayload: Omit<CreateUserAddressPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateUserTaxFormInput: CreateUserTaxFormInput;
  CreateUserTaxFormPayload: Omit<CreateUserTaxFormPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CreateXfaActivationCreditInput: CreateXfaActivationCreditInput;
  CreateXfaActivationCreditPayload: Omit<CreateXfaActivationCreditPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  CurrentAdminRole: CurrentAdminRole;
  Cursor: Scalars['Cursor']['output'];
  Date: Scalars['Date']['output'];
  DateFilter: DateFilter;
  Datetime: Scalars['Datetime']['output'];
  DatetimeFilter: DatetimeFilter;
  DeleteImpactGroupAssignmentByIdInput: DeleteImpactGroupAssignmentByIdInput;
  DeleteImpactGroupAssignmentInput: DeleteImpactGroupAssignmentInput;
  DeleteImpactGroupAssignmentPayload: Omit<DeleteImpactGroupAssignmentPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  DeleteKycPriorityLabelByIdInput: DeleteKycPriorityLabelByIdInput;
  DeleteKycPriorityLabelInput: DeleteKycPriorityLabelInput;
  DeleteKycPriorityLabelPayload: Omit<DeleteKycPriorityLabelPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  DeleteUserAddressByIdInput: DeleteUserAddressByIdInput;
  DeleteUserAddressInput: DeleteUserAddressInput;
  DeleteUserAddressPayload: Omit<DeleteUserAddressPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  DeleteXfaActivationCreditByIdInput: DeleteXfaActivationCreditByIdInput;
  DeleteXfaActivationCreditInput: DeleteXfaActivationCreditInput;
  DeleteXfaActivationCreditPayload: Omit<DeleteXfaActivationCreditPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  DiscordLinkUrlPayload: DiscordLinkUrlPayload;
  DllDailyMetrics: DllDailyMetrics;
  DocuSignAuthResult: DocuSignAuthResult;
  DocuSignEnvelopeStatusResult: DocuSignEnvelopeStatusResult;
  Email: Email;
  EmailAction: EmailAction;
  EmailActionAggregates: EmailActionAggregates;
  EmailActionAggregatesFilter: EmailActionAggregatesFilter;
  EmailActionAverageAggregateFilter: EmailActionAverageAggregateFilter;
  EmailActionAverageAggregates: EmailActionAverageAggregates;
  EmailActionCondition: EmailActionCondition;
  EmailActionConnection: EmailActionConnection;
  EmailActionDistinctCountAggregateFilter: EmailActionDistinctCountAggregateFilter;
  EmailActionDistinctCountAggregates: EmailActionDistinctCountAggregates;
  EmailActionEdge: EmailActionEdge;
  EmailActionFilter: EmailActionFilter;
  EmailActionHavingAverageInput: EmailActionHavingAverageInput;
  EmailActionHavingDistinctCountInput: EmailActionHavingDistinctCountInput;
  EmailActionHavingInput: EmailActionHavingInput;
  EmailActionHavingMaxInput: EmailActionHavingMaxInput;
  EmailActionHavingMinInput: EmailActionHavingMinInput;
  EmailActionHavingStddevPopulationInput: EmailActionHavingStddevPopulationInput;
  EmailActionHavingStddevSampleInput: EmailActionHavingStddevSampleInput;
  EmailActionHavingSumInput: EmailActionHavingSumInput;
  EmailActionHavingVariancePopulationInput: EmailActionHavingVariancePopulationInput;
  EmailActionHavingVarianceSampleInput: EmailActionHavingVarianceSampleInput;
  EmailActionMaxAggregateFilter: EmailActionMaxAggregateFilter;
  EmailActionMaxAggregates: EmailActionMaxAggregates;
  EmailActionMinAggregateFilter: EmailActionMinAggregateFilter;
  EmailActionMinAggregates: EmailActionMinAggregates;
  EmailActionStddevPopulationAggregateFilter: EmailActionStddevPopulationAggregateFilter;
  EmailActionStddevPopulationAggregates: EmailActionStddevPopulationAggregates;
  EmailActionStddevSampleAggregateFilter: EmailActionStddevSampleAggregateFilter;
  EmailActionStddevSampleAggregates: EmailActionStddevSampleAggregates;
  EmailActionSumAggregateFilter: EmailActionSumAggregateFilter;
  EmailActionSumAggregates: EmailActionSumAggregates;
  EmailActionVariancePopulationAggregateFilter: EmailActionVariancePopulationAggregateFilter;
  EmailActionVariancePopulationAggregates: EmailActionVariancePopulationAggregates;
  EmailActionVarianceSampleAggregateFilter: EmailActionVarianceSampleAggregateFilter;
  EmailActionVarianceSampleAggregates: EmailActionVarianceSampleAggregates;
  EmailAggregates: EmailAggregates;
  EmailAggregatesFilter: EmailAggregatesFilter;
  EmailAverageAggregateFilter: EmailAverageAggregateFilter;
  EmailAverageAggregates: EmailAverageAggregates;
  EmailCondition: EmailCondition;
  EmailConnection: EmailConnection;
  EmailDistinctCountAggregateFilter: EmailDistinctCountAggregateFilter;
  EmailDistinctCountAggregates: EmailDistinctCountAggregates;
  EmailEdge: EmailEdge;
  EmailFilter: EmailFilter;
  EmailHavingAverageInput: EmailHavingAverageInput;
  EmailHavingDistinctCountInput: EmailHavingDistinctCountInput;
  EmailHavingInput: EmailHavingInput;
  EmailHavingMaxInput: EmailHavingMaxInput;
  EmailHavingMinInput: EmailHavingMinInput;
  EmailHavingStddevPopulationInput: EmailHavingStddevPopulationInput;
  EmailHavingStddevSampleInput: EmailHavingStddevSampleInput;
  EmailHavingSumInput: EmailHavingSumInput;
  EmailHavingVariancePopulationInput: EmailHavingVariancePopulationInput;
  EmailHavingVarianceSampleInput: EmailHavingVarianceSampleInput;
  EmailMaxAggregateFilter: EmailMaxAggregateFilter;
  EmailMaxAggregates: EmailMaxAggregates;
  EmailMinAggregateFilter: EmailMinAggregateFilter;
  EmailMinAggregates: EmailMinAggregates;
  EmailStddevPopulationAggregateFilter: EmailStddevPopulationAggregateFilter;
  EmailStddevPopulationAggregates: EmailStddevPopulationAggregates;
  EmailStddevSampleAggregateFilter: EmailStddevSampleAggregateFilter;
  EmailStddevSampleAggregates: EmailStddevSampleAggregates;
  EmailSumAggregateFilter: EmailSumAggregateFilter;
  EmailSumAggregates: EmailSumAggregates;
  EmailToManyEmailActionFilter: EmailToManyEmailActionFilter;
  EmailVariancePopulationAggregateFilter: EmailVariancePopulationAggregateFilter;
  EmailVariancePopulationAggregates: EmailVariancePopulationAggregates;
  EmailVarianceSampleAggregateFilter: EmailVarianceSampleAggregateFilter;
  EmailVarianceSampleAggregates: EmailVarianceSampleAggregates;
  Float: Scalars['Float']['output'];
  GetOrCreateUserTaxFormInput: GetOrCreateUserTaxFormInput;
  GetOrCreateUserTaxFormResult: GetOrCreateUserTaxFormResult;
  Group: Group;
  GroupAdmin: GroupAdmin;
  GroupAdminAggregates: GroupAdminAggregates;
  GroupAdminAggregatesFilter: GroupAdminAggregatesFilter;
  GroupAdminAverageAggregateFilter: GroupAdminAverageAggregateFilter;
  GroupAdminAverageAggregates: GroupAdminAverageAggregates;
  GroupAdminCondition: GroupAdminCondition;
  GroupAdminConnection: GroupAdminConnection;
  GroupAdminDistinctCountAggregateFilter: GroupAdminDistinctCountAggregateFilter;
  GroupAdminDistinctCountAggregates: GroupAdminDistinctCountAggregates;
  GroupAdminEdge: GroupAdminEdge;
  GroupAdminFilter: GroupAdminFilter;
  GroupAdminHavingAverageInput: GroupAdminHavingAverageInput;
  GroupAdminHavingDistinctCountInput: GroupAdminHavingDistinctCountInput;
  GroupAdminHavingInput: GroupAdminHavingInput;
  GroupAdminHavingMaxInput: GroupAdminHavingMaxInput;
  GroupAdminHavingMinInput: GroupAdminHavingMinInput;
  GroupAdminHavingStddevPopulationInput: GroupAdminHavingStddevPopulationInput;
  GroupAdminHavingStddevSampleInput: GroupAdminHavingStddevSampleInput;
  GroupAdminHavingSumInput: GroupAdminHavingSumInput;
  GroupAdminHavingVariancePopulationInput: GroupAdminHavingVariancePopulationInput;
  GroupAdminHavingVarianceSampleInput: GroupAdminHavingVarianceSampleInput;
  GroupAdminMaxAggregateFilter: GroupAdminMaxAggregateFilter;
  GroupAdminMaxAggregates: GroupAdminMaxAggregates;
  GroupAdminMinAggregateFilter: GroupAdminMinAggregateFilter;
  GroupAdminMinAggregates: GroupAdminMinAggregates;
  GroupAdminStddevPopulationAggregateFilter: GroupAdminStddevPopulationAggregateFilter;
  GroupAdminStddevPopulationAggregates: GroupAdminStddevPopulationAggregates;
  GroupAdminStddevSampleAggregateFilter: GroupAdminStddevSampleAggregateFilter;
  GroupAdminStddevSampleAggregates: GroupAdminStddevSampleAggregates;
  GroupAdminSumAggregateFilter: GroupAdminSumAggregateFilter;
  GroupAdminSumAggregates: GroupAdminSumAggregates;
  GroupAdminVariancePopulationAggregateFilter: GroupAdminVariancePopulationAggregateFilter;
  GroupAdminVariancePopulationAggregates: GroupAdminVariancePopulationAggregates;
  GroupAdminVarianceSampleAggregateFilter: GroupAdminVarianceSampleAggregateFilter;
  GroupAdminVarianceSampleAggregates: GroupAdminVarianceSampleAggregates;
  GroupAggregates: GroupAggregates;
  GroupAverageAggregates: GroupAverageAggregates;
  GroupCondition: GroupCondition;
  GroupConnection: GroupConnection;
  GroupDistinctCountAggregates: GroupDistinctCountAggregates;
  GroupEdge: GroupEdge;
  GroupFilter: GroupFilter;
  GroupMaxAggregates: GroupMaxAggregates;
  GroupMinAggregates: GroupMinAggregates;
  GroupStddevPopulationAggregates: GroupStddevPopulationAggregates;
  GroupStddevSampleAggregates: GroupStddevSampleAggregates;
  GroupSumAggregates: GroupSumAggregates;
  GroupToManyGroupAdminFilter: GroupToManyGroupAdminFilter;
  GroupVariancePopulationAggregates: GroupVariancePopulationAggregates;
  GroupVarianceSampleAggregates: GroupVarianceSampleAggregates;
  HavingBigfloatFilter: HavingBigfloatFilter;
  HavingBigintFilter: HavingBigintFilter;
  HavingDatetimeFilter: HavingDatetimeFilter;
  HavingFloatFilter: HavingFloatFilter;
  HavingIntFilter: HavingIntFilter;
  ID: Scalars['ID']['output'];
  ImpactGroupAssignment: ImpactGroupAssignment;
  ImpactGroupAssignmentAggregates: ImpactGroupAssignmentAggregates;
  ImpactGroupAssignmentAggregatesFilter: ImpactGroupAssignmentAggregatesFilter;
  ImpactGroupAssignmentAverageAggregateFilter: ImpactGroupAssignmentAverageAggregateFilter;
  ImpactGroupAssignmentAverageAggregates: ImpactGroupAssignmentAverageAggregates;
  ImpactGroupAssignmentCondition: ImpactGroupAssignmentCondition;
  ImpactGroupAssignmentConnection: ImpactGroupAssignmentConnection;
  ImpactGroupAssignmentDistinctCountAggregateFilter: ImpactGroupAssignmentDistinctCountAggregateFilter;
  ImpactGroupAssignmentDistinctCountAggregates: ImpactGroupAssignmentDistinctCountAggregates;
  ImpactGroupAssignmentEdge: ImpactGroupAssignmentEdge;
  ImpactGroupAssignmentFilter: ImpactGroupAssignmentFilter;
  ImpactGroupAssignmentHavingAverageInput: ImpactGroupAssignmentHavingAverageInput;
  ImpactGroupAssignmentHavingDistinctCountInput: ImpactGroupAssignmentHavingDistinctCountInput;
  ImpactGroupAssignmentHavingInput: ImpactGroupAssignmentHavingInput;
  ImpactGroupAssignmentHavingMaxInput: ImpactGroupAssignmentHavingMaxInput;
  ImpactGroupAssignmentHavingMinInput: ImpactGroupAssignmentHavingMinInput;
  ImpactGroupAssignmentHavingStddevPopulationInput: ImpactGroupAssignmentHavingStddevPopulationInput;
  ImpactGroupAssignmentHavingStddevSampleInput: ImpactGroupAssignmentHavingStddevSampleInput;
  ImpactGroupAssignmentHavingSumInput: ImpactGroupAssignmentHavingSumInput;
  ImpactGroupAssignmentHavingVariancePopulationInput: ImpactGroupAssignmentHavingVariancePopulationInput;
  ImpactGroupAssignmentHavingVarianceSampleInput: ImpactGroupAssignmentHavingVarianceSampleInput;
  ImpactGroupAssignmentInput: ImpactGroupAssignmentInput;
  ImpactGroupAssignmentMaxAggregateFilter: ImpactGroupAssignmentMaxAggregateFilter;
  ImpactGroupAssignmentMaxAggregates: ImpactGroupAssignmentMaxAggregates;
  ImpactGroupAssignmentMinAggregateFilter: ImpactGroupAssignmentMinAggregateFilter;
  ImpactGroupAssignmentMinAggregates: ImpactGroupAssignmentMinAggregates;
  ImpactGroupAssignmentPatch: ImpactGroupAssignmentPatch;
  ImpactGroupAssignmentStddevPopulationAggregateFilter: ImpactGroupAssignmentStddevPopulationAggregateFilter;
  ImpactGroupAssignmentStddevPopulationAggregates: ImpactGroupAssignmentStddevPopulationAggregates;
  ImpactGroupAssignmentStddevSampleAggregateFilter: ImpactGroupAssignmentStddevSampleAggregateFilter;
  ImpactGroupAssignmentStddevSampleAggregates: ImpactGroupAssignmentStddevSampleAggregates;
  ImpactGroupAssignmentSumAggregateFilter: ImpactGroupAssignmentSumAggregateFilter;
  ImpactGroupAssignmentSumAggregates: ImpactGroupAssignmentSumAggregates;
  ImpactGroupAssignmentVariancePopulationAggregateFilter: ImpactGroupAssignmentVariancePopulationAggregateFilter;
  ImpactGroupAssignmentVariancePopulationAggregates: ImpactGroupAssignmentVariancePopulationAggregates;
  ImpactGroupAssignmentVarianceSampleAggregateFilter: ImpactGroupAssignmentVarianceSampleAggregateFilter;
  ImpactGroupAssignmentVarianceSampleAggregates: ImpactGroupAssignmentVarianceSampleAggregates;
  ImpactGroupTemplate: ImpactGroupTemplate;
  ImpactGroupTemplateAggregates: ImpactGroupTemplateAggregates;
  ImpactGroupTemplateAverageAggregates: ImpactGroupTemplateAverageAggregates;
  ImpactGroupTemplateCondition: ImpactGroupTemplateCondition;
  ImpactGroupTemplateConnection: ImpactGroupTemplateConnection;
  ImpactGroupTemplateDistinctCountAggregates: ImpactGroupTemplateDistinctCountAggregates;
  ImpactGroupTemplateEdge: ImpactGroupTemplateEdge;
  ImpactGroupTemplateFilter: ImpactGroupTemplateFilter;
  ImpactGroupTemplateHavingAverageInput: ImpactGroupTemplateHavingAverageInput;
  ImpactGroupTemplateHavingDistinctCountInput: ImpactGroupTemplateHavingDistinctCountInput;
  ImpactGroupTemplateHavingInput: ImpactGroupTemplateHavingInput;
  ImpactGroupTemplateHavingMaxInput: ImpactGroupTemplateHavingMaxInput;
  ImpactGroupTemplateHavingMinInput: ImpactGroupTemplateHavingMinInput;
  ImpactGroupTemplateHavingStddevPopulationInput: ImpactGroupTemplateHavingStddevPopulationInput;
  ImpactGroupTemplateHavingStddevSampleInput: ImpactGroupTemplateHavingStddevSampleInput;
  ImpactGroupTemplateHavingSumInput: ImpactGroupTemplateHavingSumInput;
  ImpactGroupTemplateHavingVariancePopulationInput: ImpactGroupTemplateHavingVariancePopulationInput;
  ImpactGroupTemplateHavingVarianceSampleInput: ImpactGroupTemplateHavingVarianceSampleInput;
  ImpactGroupTemplateInput: ImpactGroupTemplateInput;
  ImpactGroupTemplateMaxAggregates: ImpactGroupTemplateMaxAggregates;
  ImpactGroupTemplateMinAggregates: ImpactGroupTemplateMinAggregates;
  ImpactGroupTemplatePatch: ImpactGroupTemplatePatch;
  ImpactGroupTemplateStddevPopulationAggregates: ImpactGroupTemplateStddevPopulationAggregates;
  ImpactGroupTemplateStddevSampleAggregates: ImpactGroupTemplateStddevSampleAggregates;
  ImpactGroupTemplateSumAggregates: ImpactGroupTemplateSumAggregates;
  ImpactGroupTemplateToManyImpactGroupAssignmentFilter: ImpactGroupTemplateToManyImpactGroupAssignmentFilter;
  ImpactGroupTemplateVariancePopulationAggregates: ImpactGroupTemplateVariancePopulationAggregates;
  ImpactGroupTemplateVarianceSampleAggregates: ImpactGroupTemplateVarianceSampleAggregates;
  InitiateAdminPayoutRequestInput: InitiateAdminPayoutRequestInput;
  InitiateAdminPayoutRequestPayload: InitiateAdminPayoutRequestPayload;
  Int: Scalars['Int']['output'];
  IntFilter: IntFilter;
  Interval: Interval;
  IntervalFilter: IntervalFilter;
  IntervalInput: IntervalInput;
  InvalidateUserTaxFormEventLogInput: InvalidateUserTaxFormEventLogInput;
  InvalidateUserTaxFormEventLogResult: InvalidateUserTaxFormEventLogResult;
  JSON: Scalars['JSON']['output'];
  JSONFilter: JsonFilter;
  KycPriorityLabel: KycPriorityLabel;
  KycPriorityLabelAggregates: KycPriorityLabelAggregates;
  KycPriorityLabelAverageAggregates: KycPriorityLabelAverageAggregates;
  KycPriorityLabelCondition: KycPriorityLabelCondition;
  KycPriorityLabelConnection: KycPriorityLabelConnection;
  KycPriorityLabelDistinctCountAggregates: KycPriorityLabelDistinctCountAggregates;
  KycPriorityLabelEdge: KycPriorityLabelEdge;
  KycPriorityLabelFilter: KycPriorityLabelFilter;
  KycPriorityLabelHavingAverageInput: KycPriorityLabelHavingAverageInput;
  KycPriorityLabelHavingDistinctCountInput: KycPriorityLabelHavingDistinctCountInput;
  KycPriorityLabelHavingInput: KycPriorityLabelHavingInput;
  KycPriorityLabelHavingMaxInput: KycPriorityLabelHavingMaxInput;
  KycPriorityLabelHavingMinInput: KycPriorityLabelHavingMinInput;
  KycPriorityLabelHavingStddevPopulationInput: KycPriorityLabelHavingStddevPopulationInput;
  KycPriorityLabelHavingStddevSampleInput: KycPriorityLabelHavingStddevSampleInput;
  KycPriorityLabelHavingSumInput: KycPriorityLabelHavingSumInput;
  KycPriorityLabelHavingVariancePopulationInput: KycPriorityLabelHavingVariancePopulationInput;
  KycPriorityLabelHavingVarianceSampleInput: KycPriorityLabelHavingVarianceSampleInput;
  KycPriorityLabelInput: KycPriorityLabelInput;
  KycPriorityLabelMaxAggregates: KycPriorityLabelMaxAggregates;
  KycPriorityLabelMinAggregates: KycPriorityLabelMinAggregates;
  KycPriorityLabelPatch: KycPriorityLabelPatch;
  KycPriorityLabelStddevPopulationAggregates: KycPriorityLabelStddevPopulationAggregates;
  KycPriorityLabelStddevSampleAggregates: KycPriorityLabelStddevSampleAggregates;
  KycPriorityLabelSumAggregates: KycPriorityLabelSumAggregates;
  KycPriorityLabelToManyKycPriorityReviewConfigLabelFilter: KycPriorityLabelToManyKycPriorityReviewConfigLabelFilter;
  KycPriorityLabelVariancePopulationAggregates: KycPriorityLabelVariancePopulationAggregates;
  KycPriorityLabelVarianceSampleAggregates: KycPriorityLabelVarianceSampleAggregates;
  KycPriorityReviewConfig: KycPriorityReviewConfig;
  KycPriorityReviewConfigAggregates: KycPriorityReviewConfigAggregates;
  KycPriorityReviewConfigAverageAggregates: KycPriorityReviewConfigAverageAggregates;
  KycPriorityReviewConfigCondition: KycPriorityReviewConfigCondition;
  KycPriorityReviewConfigConnection: KycPriorityReviewConfigConnection;
  KycPriorityReviewConfigDistinctCountAggregates: KycPriorityReviewConfigDistinctCountAggregates;
  KycPriorityReviewConfigEdge: KycPriorityReviewConfigEdge;
  KycPriorityReviewConfigFilter: KycPriorityReviewConfigFilter;
  KycPriorityReviewConfigHavingAverageInput: KycPriorityReviewConfigHavingAverageInput;
  KycPriorityReviewConfigHavingDistinctCountInput: KycPriorityReviewConfigHavingDistinctCountInput;
  KycPriorityReviewConfigHavingInput: KycPriorityReviewConfigHavingInput;
  KycPriorityReviewConfigHavingMaxInput: KycPriorityReviewConfigHavingMaxInput;
  KycPriorityReviewConfigHavingMinInput: KycPriorityReviewConfigHavingMinInput;
  KycPriorityReviewConfigHavingStddevPopulationInput: KycPriorityReviewConfigHavingStddevPopulationInput;
  KycPriorityReviewConfigHavingStddevSampleInput: KycPriorityReviewConfigHavingStddevSampleInput;
  KycPriorityReviewConfigHavingSumInput: KycPriorityReviewConfigHavingSumInput;
  KycPriorityReviewConfigHavingVariancePopulationInput: KycPriorityReviewConfigHavingVariancePopulationInput;
  KycPriorityReviewConfigHavingVarianceSampleInput: KycPriorityReviewConfigHavingVarianceSampleInput;
  KycPriorityReviewConfigLabel: KycPriorityReviewConfigLabel;
  KycPriorityReviewConfigLabelAggregates: KycPriorityReviewConfigLabelAggregates;
  KycPriorityReviewConfigLabelAggregatesFilter: KycPriorityReviewConfigLabelAggregatesFilter;
  KycPriorityReviewConfigLabelAverageAggregateFilter: KycPriorityReviewConfigLabelAverageAggregateFilter;
  KycPriorityReviewConfigLabelAverageAggregates: KycPriorityReviewConfigLabelAverageAggregates;
  KycPriorityReviewConfigLabelCondition: KycPriorityReviewConfigLabelCondition;
  KycPriorityReviewConfigLabelConnection: KycPriorityReviewConfigLabelConnection;
  KycPriorityReviewConfigLabelDistinctCountAggregateFilter: KycPriorityReviewConfigLabelDistinctCountAggregateFilter;
  KycPriorityReviewConfigLabelDistinctCountAggregates: KycPriorityReviewConfigLabelDistinctCountAggregates;
  KycPriorityReviewConfigLabelEdge: KycPriorityReviewConfigLabelEdge;
  KycPriorityReviewConfigLabelFilter: KycPriorityReviewConfigLabelFilter;
  KycPriorityReviewConfigLabelHavingAverageInput: KycPriorityReviewConfigLabelHavingAverageInput;
  KycPriorityReviewConfigLabelHavingDistinctCountInput: KycPriorityReviewConfigLabelHavingDistinctCountInput;
  KycPriorityReviewConfigLabelHavingInput: KycPriorityReviewConfigLabelHavingInput;
  KycPriorityReviewConfigLabelHavingMaxInput: KycPriorityReviewConfigLabelHavingMaxInput;
  KycPriorityReviewConfigLabelHavingMinInput: KycPriorityReviewConfigLabelHavingMinInput;
  KycPriorityReviewConfigLabelHavingStddevPopulationInput: KycPriorityReviewConfigLabelHavingStddevPopulationInput;
  KycPriorityReviewConfigLabelHavingStddevSampleInput: KycPriorityReviewConfigLabelHavingStddevSampleInput;
  KycPriorityReviewConfigLabelHavingSumInput: KycPriorityReviewConfigLabelHavingSumInput;
  KycPriorityReviewConfigLabelHavingVariancePopulationInput: KycPriorityReviewConfigLabelHavingVariancePopulationInput;
  KycPriorityReviewConfigLabelHavingVarianceSampleInput: KycPriorityReviewConfigLabelHavingVarianceSampleInput;
  KycPriorityReviewConfigLabelMaxAggregateFilter: KycPriorityReviewConfigLabelMaxAggregateFilter;
  KycPriorityReviewConfigLabelMaxAggregates: KycPriorityReviewConfigLabelMaxAggregates;
  KycPriorityReviewConfigLabelMinAggregateFilter: KycPriorityReviewConfigLabelMinAggregateFilter;
  KycPriorityReviewConfigLabelMinAggregates: KycPriorityReviewConfigLabelMinAggregates;
  KycPriorityReviewConfigLabelStddevPopulationAggregateFilter: KycPriorityReviewConfigLabelStddevPopulationAggregateFilter;
  KycPriorityReviewConfigLabelStddevPopulationAggregates: KycPriorityReviewConfigLabelStddevPopulationAggregates;
  KycPriorityReviewConfigLabelStddevSampleAggregateFilter: KycPriorityReviewConfigLabelStddevSampleAggregateFilter;
  KycPriorityReviewConfigLabelStddevSampleAggregates: KycPriorityReviewConfigLabelStddevSampleAggregates;
  KycPriorityReviewConfigLabelSumAggregateFilter: KycPriorityReviewConfigLabelSumAggregateFilter;
  KycPriorityReviewConfigLabelSumAggregates: KycPriorityReviewConfigLabelSumAggregates;
  KycPriorityReviewConfigLabelVariancePopulationAggregateFilter: KycPriorityReviewConfigLabelVariancePopulationAggregateFilter;
  KycPriorityReviewConfigLabelVariancePopulationAggregates: KycPriorityReviewConfigLabelVariancePopulationAggregates;
  KycPriorityReviewConfigLabelVarianceSampleAggregateFilter: KycPriorityReviewConfigLabelVarianceSampleAggregateFilter;
  KycPriorityReviewConfigLabelVarianceSampleAggregates: KycPriorityReviewConfigLabelVarianceSampleAggregates;
  KycPriorityReviewConfigMaxAggregates: KycPriorityReviewConfigMaxAggregates;
  KycPriorityReviewConfigMinAggregates: KycPriorityReviewConfigMinAggregates;
  KycPriorityReviewConfigStddevPopulationAggregates: KycPriorityReviewConfigStddevPopulationAggregates;
  KycPriorityReviewConfigStddevSampleAggregates: KycPriorityReviewConfigStddevSampleAggregates;
  KycPriorityReviewConfigSumAggregates: KycPriorityReviewConfigSumAggregates;
  KycPriorityReviewConfigToManyKycPriorityReviewConfigLabelFilter: KycPriorityReviewConfigToManyKycPriorityReviewConfigLabelFilter;
  KycPriorityReviewConfigVariancePopulationAggregates: KycPriorityReviewConfigVariancePopulationAggregates;
  KycPriorityReviewConfigVarianceSampleAggregates: KycPriorityReviewConfigVarianceSampleAggregates;
  KycPriorityTypeEnumFilter: KycPriorityTypeEnumFilter;
  LfaSplashStatus: LfaSplashStatus;
  LiteLlmBlockedTermCandidate: LiteLlmBlockedTermCandidate;
  LiveStreamStatus: LiveStreamStatus;
  LiveTradePairing: LiveTradePairing;
  MarkAsChargebackInput: MarkAsChargebackInput;
  Migration: Migration;
  Mutation: {};
  MyMissingPopcards: MyMissingPopcards;
  MyPopcardCandidates: MyPopcardCandidates;
  MyTraderProfileAsset: MyTraderProfileAsset;
  MyTraderPublicProfile: MyTraderPublicProfile;
  MyTraderPublicProfileAllTimePayouts: MyTraderPublicProfileAllTimePayouts;
  MyTraderPublicProfileContent: MyTraderPublicProfileContent;
  MyTraderPublicProfileHeader: MyTraderPublicProfileHeader;
  MyTraderPublicProfileNowTrading: MyTraderPublicProfileNowTrading;
  MyTraderPublicProfileNowTradingAccount: MyTraderPublicProfileNowTradingAccount;
  MyTraderPublicProfileNowTradingCalendarDay: MyTraderPublicProfileNowTradingCalendarDay;
  MyTraderPublicProfileNowTradingCalendarWeek: MyTraderPublicProfileNowTradingCalendarWeek;
  MyTraderPublicProfileNowTradingProfitCalendar: MyTraderPublicProfileNowTradingProfitCalendar;
  MyTraderPublicProfileNowTradingSparklineDay: MyTraderPublicProfileNowTradingSparklineDay;
  MyTraderPublicProfileNowTradingStats: MyTraderPublicProfileNowTradingStats;
  MyTraderPublicProfileProofOfPayoutCard: MyTraderPublicProfileProofOfPayoutCard;
  MyTraderPublicProfileSocialConnections: MyTraderPublicProfileSocialConnections;
  MyTraderPublicProfileTradingJourney: MyTraderPublicProfileTradingJourney;
  MyTraderPublicProfileTradingStyle: MyTraderPublicProfileTradingStyle;
  NmiSubscription: NmiSubscription;
  NmiSubscriptionAggregates: NmiSubscriptionAggregates;
  NmiSubscriptionAggregatesFilter: NmiSubscriptionAggregatesFilter;
  NmiSubscriptionAverageAggregateFilter: NmiSubscriptionAverageAggregateFilter;
  NmiSubscriptionAverageAggregates: NmiSubscriptionAverageAggregates;
  NmiSubscriptionCondition: NmiSubscriptionCondition;
  NmiSubscriptionConnection: NmiSubscriptionConnection;
  NmiSubscriptionDistinctCountAggregateFilter: NmiSubscriptionDistinctCountAggregateFilter;
  NmiSubscriptionDistinctCountAggregates: NmiSubscriptionDistinctCountAggregates;
  NmiSubscriptionEdge: NmiSubscriptionEdge;
  NmiSubscriptionFilter: NmiSubscriptionFilter;
  NmiSubscriptionHavingAverageInput: NmiSubscriptionHavingAverageInput;
  NmiSubscriptionHavingDistinctCountInput: NmiSubscriptionHavingDistinctCountInput;
  NmiSubscriptionHavingInput: NmiSubscriptionHavingInput;
  NmiSubscriptionHavingMaxInput: NmiSubscriptionHavingMaxInput;
  NmiSubscriptionHavingMinInput: NmiSubscriptionHavingMinInput;
  NmiSubscriptionHavingStddevPopulationInput: NmiSubscriptionHavingStddevPopulationInput;
  NmiSubscriptionHavingStddevSampleInput: NmiSubscriptionHavingStddevSampleInput;
  NmiSubscriptionHavingSumInput: NmiSubscriptionHavingSumInput;
  NmiSubscriptionHavingVariancePopulationInput: NmiSubscriptionHavingVariancePopulationInput;
  NmiSubscriptionHavingVarianceSampleInput: NmiSubscriptionHavingVarianceSampleInput;
  NmiSubscriptionMaxAggregateFilter: NmiSubscriptionMaxAggregateFilter;
  NmiSubscriptionMaxAggregates: NmiSubscriptionMaxAggregates;
  NmiSubscriptionMinAggregateFilter: NmiSubscriptionMinAggregateFilter;
  NmiSubscriptionMinAggregates: NmiSubscriptionMinAggregates;
  NmiSubscriptionRebillManagerEnumFilter: NmiSubscriptionRebillManagerEnumFilter;
  NmiSubscriptionStddevPopulationAggregateFilter: NmiSubscriptionStddevPopulationAggregateFilter;
  NmiSubscriptionStddevPopulationAggregates: NmiSubscriptionStddevPopulationAggregates;
  NmiSubscriptionStddevSampleAggregateFilter: NmiSubscriptionStddevSampleAggregateFilter;
  NmiSubscriptionStddevSampleAggregates: NmiSubscriptionStddevSampleAggregates;
  NmiSubscriptionSumAggregateFilter: NmiSubscriptionSumAggregateFilter;
  NmiSubscriptionSumAggregates: NmiSubscriptionSumAggregates;
  NmiSubscriptionToManyAccountFilter: NmiSubscriptionToManyAccountFilter;
  NmiSubscriptionToManyAccountResetTrackingFilter: NmiSubscriptionToManyAccountResetTrackingFilter;
  NmiSubscriptionToManyOrderFulfillmentFilter: NmiSubscriptionToManyOrderFulfillmentFilter;
  NmiSubscriptionToManyRebillSessionFilter: NmiSubscriptionToManyRebillSessionFilter;
  NmiSubscriptionTypeEnumFilter: NmiSubscriptionTypeEnumFilter;
  NmiSubscriptionVariancePopulationAggregateFilter: NmiSubscriptionVariancePopulationAggregateFilter;
  NmiSubscriptionVariancePopulationAggregates: NmiSubscriptionVariancePopulationAggregates;
  NmiSubscriptionVarianceSampleAggregateFilter: NmiSubscriptionVarianceSampleAggregateFilter;
  NmiSubscriptionVarianceSampleAggregates: NmiSubscriptionVarianceSampleAggregates;
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  NormalizedPurchasesByUserConnection: NormalizedPurchasesByUserConnection;
  NormalizedPurchasesByUserEdge: NormalizedPurchasesByUserEdge;
  NormalizedPurchasesByUserRecord: NormalizedPurchasesByUserRecord;
  NormalizedPurchasesByUserRecordFilter: NormalizedPurchasesByUserRecordFilter;
  NormalizedSavedCardsByUserConnection: NormalizedSavedCardsByUserConnection;
  NormalizedSavedCardsByUserEdge: NormalizedSavedCardsByUserEdge;
  NormalizedSavedCardsByUserRecord: NormalizedSavedCardsByUserRecord;
  NormalizedSavedCardsByUserRecordFilter: NormalizedSavedCardsByUserRecordFilter;
  NormalizedSubsByUserConnection: NormalizedSubsByUserConnection;
  NormalizedSubsByUserEdge: NormalizedSubsByUserEdge;
  NormalizedSubsByUserRecord: NormalizedSubsByUserRecord;
  NormalizedSubsByUserRecordFilter: NormalizedSubsByUserRecordFilter;
  NormalizedSubsDetailedByUserConnection: NormalizedSubsDetailedByUserConnection;
  NormalizedSubsDetailedByUserEdge: NormalizedSubsDetailedByUserEdge;
  NormalizedSubsDetailedByUserRecord: NormalizedSubsDetailedByUserRecord;
  NormalizedSubsDetailedByUserRecordFilter: NormalizedSubsDetailedByUserRecordFilter;
  NuveiSavedCard: NuveiSavedCard;
  NuveiSavedCardAggregates: NuveiSavedCardAggregates;
  NuveiSavedCardAggregatesFilter: NuveiSavedCardAggregatesFilter;
  NuveiSavedCardAverageAggregateFilter: NuveiSavedCardAverageAggregateFilter;
  NuveiSavedCardAverageAggregates: NuveiSavedCardAverageAggregates;
  NuveiSavedCardCondition: NuveiSavedCardCondition;
  NuveiSavedCardConnection: NuveiSavedCardConnection;
  NuveiSavedCardDistinctCountAggregateFilter: NuveiSavedCardDistinctCountAggregateFilter;
  NuveiSavedCardDistinctCountAggregates: NuveiSavedCardDistinctCountAggregates;
  NuveiSavedCardEdge: NuveiSavedCardEdge;
  NuveiSavedCardFilter: NuveiSavedCardFilter;
  NuveiSavedCardHavingAverageInput: NuveiSavedCardHavingAverageInput;
  NuveiSavedCardHavingDistinctCountInput: NuveiSavedCardHavingDistinctCountInput;
  NuveiSavedCardHavingInput: NuveiSavedCardHavingInput;
  NuveiSavedCardHavingMaxInput: NuveiSavedCardHavingMaxInput;
  NuveiSavedCardHavingMinInput: NuveiSavedCardHavingMinInput;
  NuveiSavedCardHavingStddevPopulationInput: NuveiSavedCardHavingStddevPopulationInput;
  NuveiSavedCardHavingStddevSampleInput: NuveiSavedCardHavingStddevSampleInput;
  NuveiSavedCardHavingSumInput: NuveiSavedCardHavingSumInput;
  NuveiSavedCardHavingVariancePopulationInput: NuveiSavedCardHavingVariancePopulationInput;
  NuveiSavedCardHavingVarianceSampleInput: NuveiSavedCardHavingVarianceSampleInput;
  NuveiSavedCardMaxAggregateFilter: NuveiSavedCardMaxAggregateFilter;
  NuveiSavedCardMaxAggregates: NuveiSavedCardMaxAggregates;
  NuveiSavedCardMinAggregateFilter: NuveiSavedCardMinAggregateFilter;
  NuveiSavedCardMinAggregates: NuveiSavedCardMinAggregates;
  NuveiSavedCardStddevPopulationAggregateFilter: NuveiSavedCardStddevPopulationAggregateFilter;
  NuveiSavedCardStddevPopulationAggregates: NuveiSavedCardStddevPopulationAggregates;
  NuveiSavedCardStddevSampleAggregateFilter: NuveiSavedCardStddevSampleAggregateFilter;
  NuveiSavedCardStddevSampleAggregates: NuveiSavedCardStddevSampleAggregates;
  NuveiSavedCardSumAggregateFilter: NuveiSavedCardSumAggregateFilter;
  NuveiSavedCardSumAggregates: NuveiSavedCardSumAggregates;
  NuveiSavedCardVariancePopulationAggregateFilter: NuveiSavedCardVariancePopulationAggregateFilter;
  NuveiSavedCardVariancePopulationAggregates: NuveiSavedCardVariancePopulationAggregates;
  NuveiSavedCardVarianceSampleAggregateFilter: NuveiSavedCardVarianceSampleAggregateFilter;
  NuveiSavedCardVarianceSampleAggregates: NuveiSavedCardVarianceSampleAggregates;
  NuveiSavedPaypalArchived: NuveiSavedPaypalArchived;
  NuveiWebhook: NuveiWebhook;
  OfacsdnRecord: OfacsdnRecord;
  OfacsdnRecordAggregates: OfacsdnRecordAggregates;
  OfacsdnRecordAverageAggregates: OfacsdnRecordAverageAggregates;
  OfacsdnRecordCondition: OfacsdnRecordCondition;
  OfacsdnRecordConnection: OfacsdnRecordConnection;
  OfacsdnRecordDistinctCountAggregates: OfacsdnRecordDistinctCountAggregates;
  OfacsdnRecordEdge: OfacsdnRecordEdge;
  OfacsdnRecordFilter: OfacsdnRecordFilter;
  OfacsdnRecordHavingAverageInput: OfacsdnRecordHavingAverageInput;
  OfacsdnRecordHavingDistinctCountInput: OfacsdnRecordHavingDistinctCountInput;
  OfacsdnRecordHavingInput: OfacsdnRecordHavingInput;
  OfacsdnRecordHavingMaxInput: OfacsdnRecordHavingMaxInput;
  OfacsdnRecordHavingMinInput: OfacsdnRecordHavingMinInput;
  OfacsdnRecordHavingStddevPopulationInput: OfacsdnRecordHavingStddevPopulationInput;
  OfacsdnRecordHavingStddevSampleInput: OfacsdnRecordHavingStddevSampleInput;
  OfacsdnRecordHavingSumInput: OfacsdnRecordHavingSumInput;
  OfacsdnRecordHavingVariancePopulationInput: OfacsdnRecordHavingVariancePopulationInput;
  OfacsdnRecordHavingVarianceSampleInput: OfacsdnRecordHavingVarianceSampleInput;
  OfacsdnRecordMaxAggregates: OfacsdnRecordMaxAggregates;
  OfacsdnRecordMinAggregates: OfacsdnRecordMinAggregates;
  OfacsdnRecordStddevPopulationAggregates: OfacsdnRecordStddevPopulationAggregates;
  OfacsdnRecordStddevSampleAggregates: OfacsdnRecordStddevSampleAggregates;
  OfacsdnRecordSumAggregates: OfacsdnRecordSumAggregates;
  OfacsdnRecordVariancePopulationAggregates: OfacsdnRecordVariancePopulationAggregates;
  OfacsdnRecordVarianceSampleAggregates: OfacsdnRecordVarianceSampleAggregates;
  OrderFulfillment: OrderFulfillment;
  OrderFulfillmentAggregates: OrderFulfillmentAggregates;
  OrderFulfillmentAggregatesFilter: OrderFulfillmentAggregatesFilter;
  OrderFulfillmentAverageAggregateFilter: OrderFulfillmentAverageAggregateFilter;
  OrderFulfillmentAverageAggregates: OrderFulfillmentAverageAggregates;
  OrderFulfillmentCondition: OrderFulfillmentCondition;
  OrderFulfillmentConnection: OrderFulfillmentConnection;
  OrderFulfillmentDistinctCountAggregateFilter: OrderFulfillmentDistinctCountAggregateFilter;
  OrderFulfillmentDistinctCountAggregates: OrderFulfillmentDistinctCountAggregates;
  OrderFulfillmentEdge: OrderFulfillmentEdge;
  OrderFulfillmentFilter: OrderFulfillmentFilter;
  OrderFulfillmentHavingAverageInput: OrderFulfillmentHavingAverageInput;
  OrderFulfillmentHavingDistinctCountInput: OrderFulfillmentHavingDistinctCountInput;
  OrderFulfillmentHavingInput: OrderFulfillmentHavingInput;
  OrderFulfillmentHavingMaxInput: OrderFulfillmentHavingMaxInput;
  OrderFulfillmentHavingMinInput: OrderFulfillmentHavingMinInput;
  OrderFulfillmentHavingStddevPopulationInput: OrderFulfillmentHavingStddevPopulationInput;
  OrderFulfillmentHavingStddevSampleInput: OrderFulfillmentHavingStddevSampleInput;
  OrderFulfillmentHavingSumInput: OrderFulfillmentHavingSumInput;
  OrderFulfillmentHavingVariancePopulationInput: OrderFulfillmentHavingVariancePopulationInput;
  OrderFulfillmentHavingVarianceSampleInput: OrderFulfillmentHavingVarianceSampleInput;
  OrderFulfillmentMaxAggregateFilter: OrderFulfillmentMaxAggregateFilter;
  OrderFulfillmentMaxAggregates: OrderFulfillmentMaxAggregates;
  OrderFulfillmentMinAggregateFilter: OrderFulfillmentMinAggregateFilter;
  OrderFulfillmentMinAggregates: OrderFulfillmentMinAggregates;
  OrderFulfillmentStatusEnumFilter: OrderFulfillmentStatusEnumFilter;
  OrderFulfillmentStddevPopulationAggregateFilter: OrderFulfillmentStddevPopulationAggregateFilter;
  OrderFulfillmentStddevPopulationAggregates: OrderFulfillmentStddevPopulationAggregates;
  OrderFulfillmentStddevSampleAggregateFilter: OrderFulfillmentStddevSampleAggregateFilter;
  OrderFulfillmentStddevSampleAggregates: OrderFulfillmentStddevSampleAggregates;
  OrderFulfillmentSumAggregateFilter: OrderFulfillmentSumAggregateFilter;
  OrderFulfillmentSumAggregates: OrderFulfillmentSumAggregates;
  OrderFulfillmentTypeEnumFilter: OrderFulfillmentTypeEnumFilter;
  OrderFulfillmentVariancePopulationAggregateFilter: OrderFulfillmentVariancePopulationAggregateFilter;
  OrderFulfillmentVariancePopulationAggregates: OrderFulfillmentVariancePopulationAggregates;
  OrderFulfillmentVarianceSampleAggregateFilter: OrderFulfillmentVarianceSampleAggregateFilter;
  OrderFulfillmentVarianceSampleAggregates: OrderFulfillmentVarianceSampleAggregates;
  Outbox: Outbox;
  PageInfo: PageInfo;
  Partner: Partner;
  PartnerTransaction: PartnerTransaction;
  PasswordHistory: PasswordHistory;
  PasswordHistoryAggregates: PasswordHistoryAggregates;
  PasswordHistoryAggregatesFilter: PasswordHistoryAggregatesFilter;
  PasswordHistoryAverageAggregateFilter: PasswordHistoryAverageAggregateFilter;
  PasswordHistoryAverageAggregates: PasswordHistoryAverageAggregates;
  PasswordHistoryCondition: PasswordHistoryCondition;
  PasswordHistoryConnection: PasswordHistoryConnection;
  PasswordHistoryDistinctCountAggregateFilter: PasswordHistoryDistinctCountAggregateFilter;
  PasswordHistoryDistinctCountAggregates: PasswordHistoryDistinctCountAggregates;
  PasswordHistoryEdge: PasswordHistoryEdge;
  PasswordHistoryFilter: PasswordHistoryFilter;
  PasswordHistoryHavingAverageInput: PasswordHistoryHavingAverageInput;
  PasswordHistoryHavingDistinctCountInput: PasswordHistoryHavingDistinctCountInput;
  PasswordHistoryHavingInput: PasswordHistoryHavingInput;
  PasswordHistoryHavingMaxInput: PasswordHistoryHavingMaxInput;
  PasswordHistoryHavingMinInput: PasswordHistoryHavingMinInput;
  PasswordHistoryHavingStddevPopulationInput: PasswordHistoryHavingStddevPopulationInput;
  PasswordHistoryHavingStddevSampleInput: PasswordHistoryHavingStddevSampleInput;
  PasswordHistoryHavingSumInput: PasswordHistoryHavingSumInput;
  PasswordHistoryHavingVariancePopulationInput: PasswordHistoryHavingVariancePopulationInput;
  PasswordHistoryHavingVarianceSampleInput: PasswordHistoryHavingVarianceSampleInput;
  PasswordHistoryMaxAggregateFilter: PasswordHistoryMaxAggregateFilter;
  PasswordHistoryMaxAggregates: PasswordHistoryMaxAggregates;
  PasswordHistoryMinAggregateFilter: PasswordHistoryMinAggregateFilter;
  PasswordHistoryMinAggregates: PasswordHistoryMinAggregates;
  PasswordHistoryStddevPopulationAggregateFilter: PasswordHistoryStddevPopulationAggregateFilter;
  PasswordHistoryStddevPopulationAggregates: PasswordHistoryStddevPopulationAggregates;
  PasswordHistoryStddevSampleAggregateFilter: PasswordHistoryStddevSampleAggregateFilter;
  PasswordHistoryStddevSampleAggregates: PasswordHistoryStddevSampleAggregates;
  PasswordHistorySumAggregateFilter: PasswordHistorySumAggregateFilter;
  PasswordHistorySumAggregates: PasswordHistorySumAggregates;
  PasswordHistoryVariancePopulationAggregateFilter: PasswordHistoryVariancePopulationAggregateFilter;
  PasswordHistoryVariancePopulationAggregates: PasswordHistoryVariancePopulationAggregates;
  PasswordHistoryVarianceSampleAggregateFilter: PasswordHistoryVarianceSampleAggregateFilter;
  PasswordHistoryVarianceSampleAggregates: PasswordHistoryVarianceSampleAggregates;
  PathToFunding: PathToFunding;
  PathToFundingObjective: PathToFundingObjective;
  PathToFundingRule: PathToFundingRule;
  PaymentGateway: PaymentGateway;
  PaymentGatewayFilter: PaymentGatewayFilter;
  PayoutActivityActor: PayoutActivityActor;
  PayoutActivityEvent: PayoutActivityEvent;
  PayoutActivityReturn: PayoutActivityReturn;
  PayoutCycle: PayoutCycle;
  PayoutDepartmentApproval: PayoutDepartmentApproval;
  PayoutDepartmentApprovalAggregates: PayoutDepartmentApprovalAggregates;
  PayoutDepartmentApprovalAggregatesFilter: PayoutDepartmentApprovalAggregatesFilter;
  PayoutDepartmentApprovalAverageAggregateFilter: PayoutDepartmentApprovalAverageAggregateFilter;
  PayoutDepartmentApprovalAverageAggregates: PayoutDepartmentApprovalAverageAggregates;
  PayoutDepartmentApprovalCondition: PayoutDepartmentApprovalCondition;
  PayoutDepartmentApprovalConnection: PayoutDepartmentApprovalConnection;
  PayoutDepartmentApprovalDistinctCountAggregateFilter: PayoutDepartmentApprovalDistinctCountAggregateFilter;
  PayoutDepartmentApprovalDistinctCountAggregates: PayoutDepartmentApprovalDistinctCountAggregates;
  PayoutDepartmentApprovalEdge: PayoutDepartmentApprovalEdge;
  PayoutDepartmentApprovalFilter: PayoutDepartmentApprovalFilter;
  PayoutDepartmentApprovalHavingAverageInput: PayoutDepartmentApprovalHavingAverageInput;
  PayoutDepartmentApprovalHavingDistinctCountInput: PayoutDepartmentApprovalHavingDistinctCountInput;
  PayoutDepartmentApprovalHavingInput: PayoutDepartmentApprovalHavingInput;
  PayoutDepartmentApprovalHavingMaxInput: PayoutDepartmentApprovalHavingMaxInput;
  PayoutDepartmentApprovalHavingMinInput: PayoutDepartmentApprovalHavingMinInput;
  PayoutDepartmentApprovalHavingStddevPopulationInput: PayoutDepartmentApprovalHavingStddevPopulationInput;
  PayoutDepartmentApprovalHavingStddevSampleInput: PayoutDepartmentApprovalHavingStddevSampleInput;
  PayoutDepartmentApprovalHavingSumInput: PayoutDepartmentApprovalHavingSumInput;
  PayoutDepartmentApprovalHavingVariancePopulationInput: PayoutDepartmentApprovalHavingVariancePopulationInput;
  PayoutDepartmentApprovalHavingVarianceSampleInput: PayoutDepartmentApprovalHavingVarianceSampleInput;
  PayoutDepartmentApprovalMaxAggregateFilter: PayoutDepartmentApprovalMaxAggregateFilter;
  PayoutDepartmentApprovalMaxAggregates: PayoutDepartmentApprovalMaxAggregates;
  PayoutDepartmentApprovalMinAggregateFilter: PayoutDepartmentApprovalMinAggregateFilter;
  PayoutDepartmentApprovalMinAggregates: PayoutDepartmentApprovalMinAggregates;
  PayoutDepartmentApprovalStddevPopulationAggregateFilter: PayoutDepartmentApprovalStddevPopulationAggregateFilter;
  PayoutDepartmentApprovalStddevPopulationAggregates: PayoutDepartmentApprovalStddevPopulationAggregates;
  PayoutDepartmentApprovalStddevSampleAggregateFilter: PayoutDepartmentApprovalStddevSampleAggregateFilter;
  PayoutDepartmentApprovalStddevSampleAggregates: PayoutDepartmentApprovalStddevSampleAggregates;
  PayoutDepartmentApprovalSumAggregateFilter: PayoutDepartmentApprovalSumAggregateFilter;
  PayoutDepartmentApprovalSumAggregates: PayoutDepartmentApprovalSumAggregates;
  PayoutDepartmentApprovalVariancePopulationAggregateFilter: PayoutDepartmentApprovalVariancePopulationAggregateFilter;
  PayoutDepartmentApprovalVariancePopulationAggregates: PayoutDepartmentApprovalVariancePopulationAggregates;
  PayoutDepartmentApprovalVarianceSampleAggregateFilter: PayoutDepartmentApprovalVarianceSampleAggregateFilter;
  PayoutDepartmentApprovalVarianceSampleAggregates: PayoutDepartmentApprovalVarianceSampleAggregates;
  PayoutRequest: PayoutRequest;
  PayoutRequestAggregates: PayoutRequestAggregates;
  PayoutRequestAggregatesFilter: PayoutRequestAggregatesFilter;
  PayoutRequestAsset: PayoutRequestAsset;
  PayoutRequestAssetAggregates: PayoutRequestAssetAggregates;
  PayoutRequestAssetAggregatesFilter: PayoutRequestAssetAggregatesFilter;
  PayoutRequestAssetAverageAggregateFilter: PayoutRequestAssetAverageAggregateFilter;
  PayoutRequestAssetAverageAggregates: PayoutRequestAssetAverageAggregates;
  PayoutRequestAssetCondition: PayoutRequestAssetCondition;
  PayoutRequestAssetConnection: PayoutRequestAssetConnection;
  PayoutRequestAssetDistinctCountAggregateFilter: PayoutRequestAssetDistinctCountAggregateFilter;
  PayoutRequestAssetDistinctCountAggregates: PayoutRequestAssetDistinctCountAggregates;
  PayoutRequestAssetEdge: PayoutRequestAssetEdge;
  PayoutRequestAssetFilter: PayoutRequestAssetFilter;
  PayoutRequestAssetHavingAverageInput: PayoutRequestAssetHavingAverageInput;
  PayoutRequestAssetHavingDistinctCountInput: PayoutRequestAssetHavingDistinctCountInput;
  PayoutRequestAssetHavingInput: PayoutRequestAssetHavingInput;
  PayoutRequestAssetHavingMaxInput: PayoutRequestAssetHavingMaxInput;
  PayoutRequestAssetHavingMinInput: PayoutRequestAssetHavingMinInput;
  PayoutRequestAssetHavingStddevPopulationInput: PayoutRequestAssetHavingStddevPopulationInput;
  PayoutRequestAssetHavingStddevSampleInput: PayoutRequestAssetHavingStddevSampleInput;
  PayoutRequestAssetHavingSumInput: PayoutRequestAssetHavingSumInput;
  PayoutRequestAssetHavingVariancePopulationInput: PayoutRequestAssetHavingVariancePopulationInput;
  PayoutRequestAssetHavingVarianceSampleInput: PayoutRequestAssetHavingVarianceSampleInput;
  PayoutRequestAssetMaxAggregateFilter: PayoutRequestAssetMaxAggregateFilter;
  PayoutRequestAssetMaxAggregates: PayoutRequestAssetMaxAggregates;
  PayoutRequestAssetMinAggregateFilter: PayoutRequestAssetMinAggregateFilter;
  PayoutRequestAssetMinAggregates: PayoutRequestAssetMinAggregates;
  PayoutRequestAssetStatusEnumFilter: PayoutRequestAssetStatusEnumFilter;
  PayoutRequestAssetStddevPopulationAggregateFilter: PayoutRequestAssetStddevPopulationAggregateFilter;
  PayoutRequestAssetStddevPopulationAggregates: PayoutRequestAssetStddevPopulationAggregates;
  PayoutRequestAssetStddevSampleAggregateFilter: PayoutRequestAssetStddevSampleAggregateFilter;
  PayoutRequestAssetStddevSampleAggregates: PayoutRequestAssetStddevSampleAggregates;
  PayoutRequestAssetSumAggregateFilter: PayoutRequestAssetSumAggregateFilter;
  PayoutRequestAssetSumAggregates: PayoutRequestAssetSumAggregates;
  PayoutRequestAssetVariancePopulationAggregateFilter: PayoutRequestAssetVariancePopulationAggregateFilter;
  PayoutRequestAssetVariancePopulationAggregates: PayoutRequestAssetVariancePopulationAggregates;
  PayoutRequestAssetVarianceSampleAggregateFilter: PayoutRequestAssetVarianceSampleAggregateFilter;
  PayoutRequestAssetVarianceSampleAggregates: PayoutRequestAssetVarianceSampleAggregates;
  PayoutRequestAverageAggregateFilter: PayoutRequestAverageAggregateFilter;
  PayoutRequestAverageAggregates: PayoutRequestAverageAggregates;
  PayoutRequestBatch: PayoutRequestBatch;
  PayoutRequestBatchAggregates: PayoutRequestBatchAggregates;
  PayoutRequestBatchAggregatesFilter: PayoutRequestBatchAggregatesFilter;
  PayoutRequestBatchAverageAggregateFilter: PayoutRequestBatchAverageAggregateFilter;
  PayoutRequestBatchAverageAggregates: PayoutRequestBatchAverageAggregates;
  PayoutRequestBatchBankAccountTypeEnumFilter: PayoutRequestBatchBankAccountTypeEnumFilter;
  PayoutRequestBatchCondition: PayoutRequestBatchCondition;
  PayoutRequestBatchConnection: PayoutRequestBatchConnection;
  PayoutRequestBatchDistinctCountAggregateFilter: PayoutRequestBatchDistinctCountAggregateFilter;
  PayoutRequestBatchDistinctCountAggregates: PayoutRequestBatchDistinctCountAggregates;
  PayoutRequestBatchEdge: PayoutRequestBatchEdge;
  PayoutRequestBatchFilter: PayoutRequestBatchFilter;
  PayoutRequestBatchHavingAverageInput: PayoutRequestBatchHavingAverageInput;
  PayoutRequestBatchHavingDistinctCountInput: PayoutRequestBatchHavingDistinctCountInput;
  PayoutRequestBatchHavingInput: PayoutRequestBatchHavingInput;
  PayoutRequestBatchHavingMaxInput: PayoutRequestBatchHavingMaxInput;
  PayoutRequestBatchHavingMinInput: PayoutRequestBatchHavingMinInput;
  PayoutRequestBatchHavingStddevPopulationInput: PayoutRequestBatchHavingStddevPopulationInput;
  PayoutRequestBatchHavingStddevSampleInput: PayoutRequestBatchHavingStddevSampleInput;
  PayoutRequestBatchHavingSumInput: PayoutRequestBatchHavingSumInput;
  PayoutRequestBatchHavingVariancePopulationInput: PayoutRequestBatchHavingVariancePopulationInput;
  PayoutRequestBatchHavingVarianceSampleInput: PayoutRequestBatchHavingVarianceSampleInput;
  PayoutRequestBatchItem: PayoutRequestBatchItem;
  PayoutRequestBatchItemAggregates: PayoutRequestBatchItemAggregates;
  PayoutRequestBatchItemAggregatesFilter: PayoutRequestBatchItemAggregatesFilter;
  PayoutRequestBatchItemAverageAggregateFilter: PayoutRequestBatchItemAverageAggregateFilter;
  PayoutRequestBatchItemAverageAggregates: PayoutRequestBatchItemAverageAggregates;
  PayoutRequestBatchItemCondition: PayoutRequestBatchItemCondition;
  PayoutRequestBatchItemConnection: PayoutRequestBatchItemConnection;
  PayoutRequestBatchItemDistinctCountAggregateFilter: PayoutRequestBatchItemDistinctCountAggregateFilter;
  PayoutRequestBatchItemDistinctCountAggregates: PayoutRequestBatchItemDistinctCountAggregates;
  PayoutRequestBatchItemEdge: PayoutRequestBatchItemEdge;
  PayoutRequestBatchItemFilter: PayoutRequestBatchItemFilter;
  PayoutRequestBatchItemHavingAverageInput: PayoutRequestBatchItemHavingAverageInput;
  PayoutRequestBatchItemHavingDistinctCountInput: PayoutRequestBatchItemHavingDistinctCountInput;
  PayoutRequestBatchItemHavingInput: PayoutRequestBatchItemHavingInput;
  PayoutRequestBatchItemHavingMaxInput: PayoutRequestBatchItemHavingMaxInput;
  PayoutRequestBatchItemHavingMinInput: PayoutRequestBatchItemHavingMinInput;
  PayoutRequestBatchItemHavingStddevPopulationInput: PayoutRequestBatchItemHavingStddevPopulationInput;
  PayoutRequestBatchItemHavingStddevSampleInput: PayoutRequestBatchItemHavingStddevSampleInput;
  PayoutRequestBatchItemHavingSumInput: PayoutRequestBatchItemHavingSumInput;
  PayoutRequestBatchItemHavingVariancePopulationInput: PayoutRequestBatchItemHavingVariancePopulationInput;
  PayoutRequestBatchItemHavingVarianceSampleInput: PayoutRequestBatchItemHavingVarianceSampleInput;
  PayoutRequestBatchItemMaxAggregateFilter: PayoutRequestBatchItemMaxAggregateFilter;
  PayoutRequestBatchItemMaxAggregates: PayoutRequestBatchItemMaxAggregates;
  PayoutRequestBatchItemMinAggregateFilter: PayoutRequestBatchItemMinAggregateFilter;
  PayoutRequestBatchItemMinAggregates: PayoutRequestBatchItemMinAggregates;
  PayoutRequestBatchItemStddevPopulationAggregateFilter: PayoutRequestBatchItemStddevPopulationAggregateFilter;
  PayoutRequestBatchItemStddevPopulationAggregates: PayoutRequestBatchItemStddevPopulationAggregates;
  PayoutRequestBatchItemStddevSampleAggregateFilter: PayoutRequestBatchItemStddevSampleAggregateFilter;
  PayoutRequestBatchItemStddevSampleAggregates: PayoutRequestBatchItemStddevSampleAggregates;
  PayoutRequestBatchItemSumAggregateFilter: PayoutRequestBatchItemSumAggregateFilter;
  PayoutRequestBatchItemSumAggregates: PayoutRequestBatchItemSumAggregates;
  PayoutRequestBatchItemVariancePopulationAggregateFilter: PayoutRequestBatchItemVariancePopulationAggregateFilter;
  PayoutRequestBatchItemVariancePopulationAggregates: PayoutRequestBatchItemVariancePopulationAggregates;
  PayoutRequestBatchItemVarianceSampleAggregateFilter: PayoutRequestBatchItemVarianceSampleAggregateFilter;
  PayoutRequestBatchItemVarianceSampleAggregates: PayoutRequestBatchItemVarianceSampleAggregates;
  PayoutRequestBatchMaxAggregateFilter: PayoutRequestBatchMaxAggregateFilter;
  PayoutRequestBatchMaxAggregates: PayoutRequestBatchMaxAggregates;
  PayoutRequestBatchMinAggregateFilter: PayoutRequestBatchMinAggregateFilter;
  PayoutRequestBatchMinAggregates: PayoutRequestBatchMinAggregates;
  PayoutRequestBatchStddevPopulationAggregateFilter: PayoutRequestBatchStddevPopulationAggregateFilter;
  PayoutRequestBatchStddevPopulationAggregates: PayoutRequestBatchStddevPopulationAggregates;
  PayoutRequestBatchStddevSampleAggregateFilter: PayoutRequestBatchStddevSampleAggregateFilter;
  PayoutRequestBatchStddevSampleAggregates: PayoutRequestBatchStddevSampleAggregates;
  PayoutRequestBatchSumAggregateFilter: PayoutRequestBatchSumAggregateFilter;
  PayoutRequestBatchSumAggregates: PayoutRequestBatchSumAggregates;
  PayoutRequestBatchToManyPayoutRequestBatchItemFilter: PayoutRequestBatchToManyPayoutRequestBatchItemFilter;
  PayoutRequestBatchVariancePopulationAggregateFilter: PayoutRequestBatchVariancePopulationAggregateFilter;
  PayoutRequestBatchVariancePopulationAggregates: PayoutRequestBatchVariancePopulationAggregates;
  PayoutRequestBatchVarianceSampleAggregateFilter: PayoutRequestBatchVarianceSampleAggregateFilter;
  PayoutRequestBatchVarianceSampleAggregates: PayoutRequestBatchVarianceSampleAggregates;
  PayoutRequestCondition: PayoutRequestCondition;
  PayoutRequestConnection: PayoutRequestConnection;
  PayoutRequestDistinctCountAggregateFilter: PayoutRequestDistinctCountAggregateFilter;
  PayoutRequestDistinctCountAggregates: PayoutRequestDistinctCountAggregates;
  PayoutRequestEdge: PayoutRequestEdge;
  PayoutRequestFilter: PayoutRequestFilter;
  PayoutRequestHavingAverageInput: PayoutRequestHavingAverageInput;
  PayoutRequestHavingDistinctCountInput: PayoutRequestHavingDistinctCountInput;
  PayoutRequestHavingInput: PayoutRequestHavingInput;
  PayoutRequestHavingMaxInput: PayoutRequestHavingMaxInput;
  PayoutRequestHavingMinInput: PayoutRequestHavingMinInput;
  PayoutRequestHavingStddevPopulationInput: PayoutRequestHavingStddevPopulationInput;
  PayoutRequestHavingStddevSampleInput: PayoutRequestHavingStddevSampleInput;
  PayoutRequestHavingSumInput: PayoutRequestHavingSumInput;
  PayoutRequestHavingVariancePopulationInput: PayoutRequestHavingVariancePopulationInput;
  PayoutRequestHavingVarianceSampleInput: PayoutRequestHavingVarianceSampleInput;
  PayoutRequestHistory: PayoutRequestHistory;
  PayoutRequestMaxAggregateFilter: PayoutRequestMaxAggregateFilter;
  PayoutRequestMaxAggregates: PayoutRequestMaxAggregates;
  PayoutRequestMinAggregateFilter: PayoutRequestMinAggregateFilter;
  PayoutRequestMinAggregates: PayoutRequestMinAggregates;
  PayoutRequestStddevPopulationAggregateFilter: PayoutRequestStddevPopulationAggregateFilter;
  PayoutRequestStddevPopulationAggregates: PayoutRequestStddevPopulationAggregates;
  PayoutRequestStddevSampleAggregateFilter: PayoutRequestStddevSampleAggregateFilter;
  PayoutRequestStddevSampleAggregates: PayoutRequestStddevSampleAggregates;
  PayoutRequestSubscriber: PayoutRequestSubscriber;
  PayoutRequestSubscriberAggregates: PayoutRequestSubscriberAggregates;
  PayoutRequestSubscriberAggregatesFilter: PayoutRequestSubscriberAggregatesFilter;
  PayoutRequestSubscriberAverageAggregateFilter: PayoutRequestSubscriberAverageAggregateFilter;
  PayoutRequestSubscriberAverageAggregates: PayoutRequestSubscriberAverageAggregates;
  PayoutRequestSubscriberCondition: PayoutRequestSubscriberCondition;
  PayoutRequestSubscriberConnection: PayoutRequestSubscriberConnection;
  PayoutRequestSubscriberDistinctCountAggregateFilter: PayoutRequestSubscriberDistinctCountAggregateFilter;
  PayoutRequestSubscriberDistinctCountAggregates: PayoutRequestSubscriberDistinctCountAggregates;
  PayoutRequestSubscriberEdge: PayoutRequestSubscriberEdge;
  PayoutRequestSubscriberFilter: PayoutRequestSubscriberFilter;
  PayoutRequestSubscriberHavingAverageInput: PayoutRequestSubscriberHavingAverageInput;
  PayoutRequestSubscriberHavingDistinctCountInput: PayoutRequestSubscriberHavingDistinctCountInput;
  PayoutRequestSubscriberHavingInput: PayoutRequestSubscriberHavingInput;
  PayoutRequestSubscriberHavingMaxInput: PayoutRequestSubscriberHavingMaxInput;
  PayoutRequestSubscriberHavingMinInput: PayoutRequestSubscriberHavingMinInput;
  PayoutRequestSubscriberHavingStddevPopulationInput: PayoutRequestSubscriberHavingStddevPopulationInput;
  PayoutRequestSubscriberHavingStddevSampleInput: PayoutRequestSubscriberHavingStddevSampleInput;
  PayoutRequestSubscriberHavingSumInput: PayoutRequestSubscriberHavingSumInput;
  PayoutRequestSubscriberHavingVariancePopulationInput: PayoutRequestSubscriberHavingVariancePopulationInput;
  PayoutRequestSubscriberHavingVarianceSampleInput: PayoutRequestSubscriberHavingVarianceSampleInput;
  PayoutRequestSubscriberMaxAggregateFilter: PayoutRequestSubscriberMaxAggregateFilter;
  PayoutRequestSubscriberMaxAggregates: PayoutRequestSubscriberMaxAggregates;
  PayoutRequestSubscriberMinAggregateFilter: PayoutRequestSubscriberMinAggregateFilter;
  PayoutRequestSubscriberMinAggregates: PayoutRequestSubscriberMinAggregates;
  PayoutRequestSubscriberStddevPopulationAggregateFilter: PayoutRequestSubscriberStddevPopulationAggregateFilter;
  PayoutRequestSubscriberStddevPopulationAggregates: PayoutRequestSubscriberStddevPopulationAggregates;
  PayoutRequestSubscriberStddevSampleAggregateFilter: PayoutRequestSubscriberStddevSampleAggregateFilter;
  PayoutRequestSubscriberStddevSampleAggregates: PayoutRequestSubscriberStddevSampleAggregates;
  PayoutRequestSubscriberSumAggregateFilter: PayoutRequestSubscriberSumAggregateFilter;
  PayoutRequestSubscriberSumAggregates: PayoutRequestSubscriberSumAggregates;
  PayoutRequestSubscriberVariancePopulationAggregateFilter: PayoutRequestSubscriberVariancePopulationAggregateFilter;
  PayoutRequestSubscriberVariancePopulationAggregates: PayoutRequestSubscriberVariancePopulationAggregates;
  PayoutRequestSubscriberVarianceSampleAggregateFilter: PayoutRequestSubscriberVarianceSampleAggregateFilter;
  PayoutRequestSubscriberVarianceSampleAggregates: PayoutRequestSubscriberVarianceSampleAggregates;
  PayoutRequestSumAggregateFilter: PayoutRequestSumAggregateFilter;
  PayoutRequestSumAggregates: PayoutRequestSumAggregates;
  PayoutRequestToManyPayoutDepartmentApprovalFilter: PayoutRequestToManyPayoutDepartmentApprovalFilter;
  PayoutRequestToManyPayoutRequestAssetFilter: PayoutRequestToManyPayoutRequestAssetFilter;
  PayoutRequestToManyPayoutRequestSubscriberFilter: PayoutRequestToManyPayoutRequestSubscriberFilter;
  PayoutRequestToManyPayoutReturnFilter: PayoutRequestToManyPayoutReturnFilter;
  PayoutRequestToManyPayoutReviewFilter: PayoutRequestToManyPayoutReviewFilter;
  PayoutRequestToManyPayoutReviewerFilter: PayoutRequestToManyPayoutReviewerFilter;
  PayoutRequestVariancePopulationAggregateFilter: PayoutRequestVariancePopulationAggregateFilter;
  PayoutRequestVariancePopulationAggregates: PayoutRequestVariancePopulationAggregates;
  PayoutRequestVarianceSampleAggregateFilter: PayoutRequestVarianceSampleAggregateFilter;
  PayoutRequestVarianceSampleAggregates: PayoutRequestVarianceSampleAggregates;
  PayoutRequestsStatsConnection: PayoutRequestsStatsConnection;
  PayoutRequestsStatsEdge: PayoutRequestsStatsEdge;
  PayoutRequestsStatsRecord: PayoutRequestsStatsRecord;
  PayoutRequestsStatsRecordFilter: PayoutRequestsStatsRecordFilter;
  PayoutReturn: PayoutReturn;
  PayoutReturnAggregates: PayoutReturnAggregates;
  PayoutReturnAggregatesFilter: PayoutReturnAggregatesFilter;
  PayoutReturnAverageAggregateFilter: PayoutReturnAverageAggregateFilter;
  PayoutReturnAverageAggregates: PayoutReturnAverageAggregates;
  PayoutReturnCondition: PayoutReturnCondition;
  PayoutReturnConnection: PayoutReturnConnection;
  PayoutReturnDistinctCountAggregateFilter: PayoutReturnDistinctCountAggregateFilter;
  PayoutReturnDistinctCountAggregates: PayoutReturnDistinctCountAggregates;
  PayoutReturnEdge: PayoutReturnEdge;
  PayoutReturnFilter: PayoutReturnFilter;
  PayoutReturnHavingAverageInput: PayoutReturnHavingAverageInput;
  PayoutReturnHavingDistinctCountInput: PayoutReturnHavingDistinctCountInput;
  PayoutReturnHavingInput: PayoutReturnHavingInput;
  PayoutReturnHavingMaxInput: PayoutReturnHavingMaxInput;
  PayoutReturnHavingMinInput: PayoutReturnHavingMinInput;
  PayoutReturnHavingStddevPopulationInput: PayoutReturnHavingStddevPopulationInput;
  PayoutReturnHavingStddevSampleInput: PayoutReturnHavingStddevSampleInput;
  PayoutReturnHavingSumInput: PayoutReturnHavingSumInput;
  PayoutReturnHavingVariancePopulationInput: PayoutReturnHavingVariancePopulationInput;
  PayoutReturnHavingVarianceSampleInput: PayoutReturnHavingVarianceSampleInput;
  PayoutReturnMaxAggregateFilter: PayoutReturnMaxAggregateFilter;
  PayoutReturnMaxAggregates: PayoutReturnMaxAggregates;
  PayoutReturnMinAggregateFilter: PayoutReturnMinAggregateFilter;
  PayoutReturnMinAggregates: PayoutReturnMinAggregates;
  PayoutReturnReasonCode: PayoutReturnReasonCode;
  PayoutReturnReasonCodeAggregates: PayoutReturnReasonCodeAggregates;
  PayoutReturnReasonCodeAverageAggregates: PayoutReturnReasonCodeAverageAggregates;
  PayoutReturnReasonCodeCondition: PayoutReturnReasonCodeCondition;
  PayoutReturnReasonCodeConnection: PayoutReturnReasonCodeConnection;
  PayoutReturnReasonCodeDistinctCountAggregates: PayoutReturnReasonCodeDistinctCountAggregates;
  PayoutReturnReasonCodeEdge: PayoutReturnReasonCodeEdge;
  PayoutReturnReasonCodeFilter: PayoutReturnReasonCodeFilter;
  PayoutReturnReasonCodeMaxAggregates: PayoutReturnReasonCodeMaxAggregates;
  PayoutReturnReasonCodeMinAggregates: PayoutReturnReasonCodeMinAggregates;
  PayoutReturnReasonCodeStddevPopulationAggregates: PayoutReturnReasonCodeStddevPopulationAggregates;
  PayoutReturnReasonCodeStddevSampleAggregates: PayoutReturnReasonCodeStddevSampleAggregates;
  PayoutReturnReasonCodeSumAggregates: PayoutReturnReasonCodeSumAggregates;
  PayoutReturnReasonCodeVariancePopulationAggregates: PayoutReturnReasonCodeVariancePopulationAggregates;
  PayoutReturnReasonCodeVarianceSampleAggregates: PayoutReturnReasonCodeVarianceSampleAggregates;
  PayoutReturnStddevPopulationAggregateFilter: PayoutReturnStddevPopulationAggregateFilter;
  PayoutReturnStddevPopulationAggregates: PayoutReturnStddevPopulationAggregates;
  PayoutReturnStddevSampleAggregateFilter: PayoutReturnStddevSampleAggregateFilter;
  PayoutReturnStddevSampleAggregates: PayoutReturnStddevSampleAggregates;
  PayoutReturnSumAggregateFilter: PayoutReturnSumAggregateFilter;
  PayoutReturnSumAggregates: PayoutReturnSumAggregates;
  PayoutReturnVariancePopulationAggregateFilter: PayoutReturnVariancePopulationAggregateFilter;
  PayoutReturnVariancePopulationAggregates: PayoutReturnVariancePopulationAggregates;
  PayoutReturnVarianceSampleAggregateFilter: PayoutReturnVarianceSampleAggregateFilter;
  PayoutReturnVarianceSampleAggregates: PayoutReturnVarianceSampleAggregates;
  PayoutReview: PayoutReview;
  PayoutReviewAggregates: PayoutReviewAggregates;
  PayoutReviewAggregatesFilter: PayoutReviewAggregatesFilter;
  PayoutReviewAverageAggregateFilter: PayoutReviewAverageAggregateFilter;
  PayoutReviewAverageAggregates: PayoutReviewAverageAggregates;
  PayoutReviewCondition: PayoutReviewCondition;
  PayoutReviewConnection: PayoutReviewConnection;
  PayoutReviewDistinctCountAggregateFilter: PayoutReviewDistinctCountAggregateFilter;
  PayoutReviewDistinctCountAggregates: PayoutReviewDistinctCountAggregates;
  PayoutReviewEdge: PayoutReviewEdge;
  PayoutReviewFilter: PayoutReviewFilter;
  PayoutReviewHavingAverageInput: PayoutReviewHavingAverageInput;
  PayoutReviewHavingDistinctCountInput: PayoutReviewHavingDistinctCountInput;
  PayoutReviewHavingInput: PayoutReviewHavingInput;
  PayoutReviewHavingMaxInput: PayoutReviewHavingMaxInput;
  PayoutReviewHavingMinInput: PayoutReviewHavingMinInput;
  PayoutReviewHavingStddevPopulationInput: PayoutReviewHavingStddevPopulationInput;
  PayoutReviewHavingStddevSampleInput: PayoutReviewHavingStddevSampleInput;
  PayoutReviewHavingSumInput: PayoutReviewHavingSumInput;
  PayoutReviewHavingVariancePopulationInput: PayoutReviewHavingVariancePopulationInput;
  PayoutReviewHavingVarianceSampleInput: PayoutReviewHavingVarianceSampleInput;
  PayoutReviewMaxAggregateFilter: PayoutReviewMaxAggregateFilter;
  PayoutReviewMaxAggregates: PayoutReviewMaxAggregates;
  PayoutReviewMinAggregateFilter: PayoutReviewMinAggregateFilter;
  PayoutReviewMinAggregates: PayoutReviewMinAggregates;
  PayoutReviewStddevPopulationAggregateFilter: PayoutReviewStddevPopulationAggregateFilter;
  PayoutReviewStddevPopulationAggregates: PayoutReviewStddevPopulationAggregates;
  PayoutReviewStddevSampleAggregateFilter: PayoutReviewStddevSampleAggregateFilter;
  PayoutReviewStddevSampleAggregates: PayoutReviewStddevSampleAggregates;
  PayoutReviewSumAggregateFilter: PayoutReviewSumAggregateFilter;
  PayoutReviewSumAggregates: PayoutReviewSumAggregates;
  PayoutReviewVariancePopulationAggregateFilter: PayoutReviewVariancePopulationAggregateFilter;
  PayoutReviewVariancePopulationAggregates: PayoutReviewVariancePopulationAggregates;
  PayoutReviewVarianceSampleAggregateFilter: PayoutReviewVarianceSampleAggregateFilter;
  PayoutReviewVarianceSampleAggregates: PayoutReviewVarianceSampleAggregates;
  PayoutReviewer: PayoutReviewer;
  PayoutReviewerAggregates: PayoutReviewerAggregates;
  PayoutReviewerAggregatesFilter: PayoutReviewerAggregatesFilter;
  PayoutReviewerAverageAggregateFilter: PayoutReviewerAverageAggregateFilter;
  PayoutReviewerAverageAggregates: PayoutReviewerAverageAggregates;
  PayoutReviewerCondition: PayoutReviewerCondition;
  PayoutReviewerConnection: PayoutReviewerConnection;
  PayoutReviewerDistinctCountAggregateFilter: PayoutReviewerDistinctCountAggregateFilter;
  PayoutReviewerDistinctCountAggregates: PayoutReviewerDistinctCountAggregates;
  PayoutReviewerEdge: PayoutReviewerEdge;
  PayoutReviewerFilter: PayoutReviewerFilter;
  PayoutReviewerHavingAverageInput: PayoutReviewerHavingAverageInput;
  PayoutReviewerHavingDistinctCountInput: PayoutReviewerHavingDistinctCountInput;
  PayoutReviewerHavingInput: PayoutReviewerHavingInput;
  PayoutReviewerHavingMaxInput: PayoutReviewerHavingMaxInput;
  PayoutReviewerHavingMinInput: PayoutReviewerHavingMinInput;
  PayoutReviewerHavingStddevPopulationInput: PayoutReviewerHavingStddevPopulationInput;
  PayoutReviewerHavingStddevSampleInput: PayoutReviewerHavingStddevSampleInput;
  PayoutReviewerHavingSumInput: PayoutReviewerHavingSumInput;
  PayoutReviewerHavingVariancePopulationInput: PayoutReviewerHavingVariancePopulationInput;
  PayoutReviewerHavingVarianceSampleInput: PayoutReviewerHavingVarianceSampleInput;
  PayoutReviewerMaxAggregateFilter: PayoutReviewerMaxAggregateFilter;
  PayoutReviewerMaxAggregates: PayoutReviewerMaxAggregates;
  PayoutReviewerMinAggregateFilter: PayoutReviewerMinAggregateFilter;
  PayoutReviewerMinAggregates: PayoutReviewerMinAggregates;
  PayoutReviewerStddevPopulationAggregateFilter: PayoutReviewerStddevPopulationAggregateFilter;
  PayoutReviewerStddevPopulationAggregates: PayoutReviewerStddevPopulationAggregates;
  PayoutReviewerStddevSampleAggregateFilter: PayoutReviewerStddevSampleAggregateFilter;
  PayoutReviewerStddevSampleAggregates: PayoutReviewerStddevSampleAggregates;
  PayoutReviewerSumAggregateFilter: PayoutReviewerSumAggregateFilter;
  PayoutReviewerSumAggregates: PayoutReviewerSumAggregates;
  PayoutReviewerVariancePopulationAggregateFilter: PayoutReviewerVariancePopulationAggregateFilter;
  PayoutReviewerVariancePopulationAggregates: PayoutReviewerVariancePopulationAggregates;
  PayoutReviewerVarianceSampleAggregateFilter: PayoutReviewerVarianceSampleAggregateFilter;
  PayoutReviewerVarianceSampleAggregates: PayoutReviewerVarianceSampleAggregates;
  PayoutRollupItem: PayoutRollupItem;
  PayoutRollupResult: PayoutRollupResult;
  PaypalTransaction: PaypalTransaction;
  PersonaInquiryEvent: PersonaInquiryEvent;
  PersonaTransactionEvent: PersonaTransactionEvent;
  PersonaWebhookEvent: PersonaWebhookEvent;
  PersonaWebhookEventAggregates: PersonaWebhookEventAggregates;
  PersonaWebhookEventAggregatesFilter: PersonaWebhookEventAggregatesFilter;
  PersonaWebhookEventAverageAggregateFilter: PersonaWebhookEventAverageAggregateFilter;
  PersonaWebhookEventAverageAggregates: PersonaWebhookEventAverageAggregates;
  PersonaWebhookEventCondition: PersonaWebhookEventCondition;
  PersonaWebhookEventConnection: PersonaWebhookEventConnection;
  PersonaWebhookEventDistinctCountAggregateFilter: PersonaWebhookEventDistinctCountAggregateFilter;
  PersonaWebhookEventDistinctCountAggregates: PersonaWebhookEventDistinctCountAggregates;
  PersonaWebhookEventEdge: PersonaWebhookEventEdge;
  PersonaWebhookEventFilter: PersonaWebhookEventFilter;
  PersonaWebhookEventHavingAverageInput: PersonaWebhookEventHavingAverageInput;
  PersonaWebhookEventHavingDistinctCountInput: PersonaWebhookEventHavingDistinctCountInput;
  PersonaWebhookEventHavingInput: PersonaWebhookEventHavingInput;
  PersonaWebhookEventHavingMaxInput: PersonaWebhookEventHavingMaxInput;
  PersonaWebhookEventHavingMinInput: PersonaWebhookEventHavingMinInput;
  PersonaWebhookEventHavingStddevPopulationInput: PersonaWebhookEventHavingStddevPopulationInput;
  PersonaWebhookEventHavingStddevSampleInput: PersonaWebhookEventHavingStddevSampleInput;
  PersonaWebhookEventHavingSumInput: PersonaWebhookEventHavingSumInput;
  PersonaWebhookEventHavingVariancePopulationInput: PersonaWebhookEventHavingVariancePopulationInput;
  PersonaWebhookEventHavingVarianceSampleInput: PersonaWebhookEventHavingVarianceSampleInput;
  PersonaWebhookEventMaxAggregateFilter: PersonaWebhookEventMaxAggregateFilter;
  PersonaWebhookEventMaxAggregates: PersonaWebhookEventMaxAggregates;
  PersonaWebhookEventMinAggregateFilter: PersonaWebhookEventMinAggregateFilter;
  PersonaWebhookEventMinAggregates: PersonaWebhookEventMinAggregates;
  PersonaWebhookEventStddevPopulationAggregateFilter: PersonaWebhookEventStddevPopulationAggregateFilter;
  PersonaWebhookEventStddevPopulationAggregates: PersonaWebhookEventStddevPopulationAggregates;
  PersonaWebhookEventStddevSampleAggregateFilter: PersonaWebhookEventStddevSampleAggregateFilter;
  PersonaWebhookEventStddevSampleAggregates: PersonaWebhookEventStddevSampleAggregates;
  PersonaWebhookEventSumAggregateFilter: PersonaWebhookEventSumAggregateFilter;
  PersonaWebhookEventSumAggregates: PersonaWebhookEventSumAggregates;
  PersonaWebhookEventVariancePopulationAggregateFilter: PersonaWebhookEventVariancePopulationAggregateFilter;
  PersonaWebhookEventVariancePopulationAggregates: PersonaWebhookEventVariancePopulationAggregates;
  PersonaWebhookEventVarianceSampleAggregateFilter: PersonaWebhookEventVarianceSampleAggregateFilter;
  PersonaWebhookEventVarianceSampleAggregates: PersonaWebhookEventVarianceSampleAggregates;
  Platform: Platform;
  PlatformFilter: PlatformFilter;
  PlatformToManyAccountFilter: PlatformToManyAccountFilter;
  PlatformToManyTradingProductFeeFilter: PlatformToManyTradingProductFeeFilter;
  PlatformToManyUserPlatformCredentialFilter: PlatformToManyUserPlatformCredentialFilter;
  PopcardPayoutCandidate: PopcardPayoutCandidate;
  PopcardRollupGroup: PopcardRollupGroup;
  Product: Product;
  ProductAggregates: ProductAggregates;
  ProductAggregatesFilter: ProductAggregatesFilter;
  ProductAverageAggregateFilter: ProductAverageAggregateFilter;
  ProductAverageAggregates: ProductAverageAggregates;
  ProductCategory: ProductCategory;
  ProductCategoryAggregates: ProductCategoryAggregates;
  ProductCategoryAverageAggregates: ProductCategoryAverageAggregates;
  ProductCategoryCondition: ProductCategoryCondition;
  ProductCategoryConnection: ProductCategoryConnection;
  ProductCategoryDistinctCountAggregates: ProductCategoryDistinctCountAggregates;
  ProductCategoryEdge: ProductCategoryEdge;
  ProductCategoryFilter: ProductCategoryFilter;
  ProductCategoryMaxAggregates: ProductCategoryMaxAggregates;
  ProductCategoryMinAggregates: ProductCategoryMinAggregates;
  ProductCategoryStddevPopulationAggregates: ProductCategoryStddevPopulationAggregates;
  ProductCategoryStddevSampleAggregates: ProductCategoryStddevSampleAggregates;
  ProductCategorySumAggregates: ProductCategorySumAggregates;
  ProductCategoryToManyProductFilter: ProductCategoryToManyProductFilter;
  ProductCategoryVariancePopulationAggregates: ProductCategoryVariancePopulationAggregates;
  ProductCategoryVarianceSampleAggregates: ProductCategoryVarianceSampleAggregates;
  ProductCondition: ProductCondition;
  ProductConnection: ProductConnection;
  ProductDistinctCountAggregateFilter: ProductDistinctCountAggregateFilter;
  ProductDistinctCountAggregates: ProductDistinctCountAggregates;
  ProductEdge: ProductEdge;
  ProductFilter: ProductFilter;
  ProductHavingAverageInput: ProductHavingAverageInput;
  ProductHavingDistinctCountInput: ProductHavingDistinctCountInput;
  ProductHavingInput: ProductHavingInput;
  ProductHavingMaxInput: ProductHavingMaxInput;
  ProductHavingMinInput: ProductHavingMinInput;
  ProductHavingStddevPopulationInput: ProductHavingStddevPopulationInput;
  ProductHavingStddevSampleInput: ProductHavingStddevSampleInput;
  ProductHavingSumInput: ProductHavingSumInput;
  ProductHavingVariancePopulationInput: ProductHavingVariancePopulationInput;
  ProductHavingVarianceSampleInput: ProductHavingVarianceSampleInput;
  ProductMaxAggregateFilter: ProductMaxAggregateFilter;
  ProductMaxAggregates: ProductMaxAggregates;
  ProductMinAggregateFilter: ProductMinAggregateFilter;
  ProductMinAggregates: ProductMinAggregates;
  ProductStddevPopulationAggregateFilter: ProductStddevPopulationAggregateFilter;
  ProductStddevPopulationAggregates: ProductStddevPopulationAggregates;
  ProductStddevSampleAggregateFilter: ProductStddevSampleAggregateFilter;
  ProductStddevSampleAggregates: ProductStddevSampleAggregates;
  ProductSumAggregateFilter: ProductSumAggregateFilter;
  ProductSumAggregates: ProductSumAggregates;
  ProductToManyCheckoutItemFilter: ProductToManyCheckoutItemFilter;
  ProductToManyNmiSubscriptionFilter: ProductToManyNmiSubscriptionFilter;
  ProductToManyPurchaseItemFilter: ProductToManyPurchaseItemFilter;
  ProductVariancePopulationAggregateFilter: ProductVariancePopulationAggregateFilter;
  ProductVariancePopulationAggregates: ProductVariancePopulationAggregates;
  ProductVarianceSampleAggregateFilter: ProductVarianceSampleAggregateFilter;
  ProductVarianceSampleAggregates: ProductVarianceSampleAggregates;
  ProfileReport: ProfileReport;
  ProfileReportAggregates: ProfileReportAggregates;
  ProfileReportAggregatesFilter: ProfileReportAggregatesFilter;
  ProfileReportAverageAggregateFilter: ProfileReportAverageAggregateFilter;
  ProfileReportAverageAggregates: ProfileReportAverageAggregates;
  ProfileReportCondition: ProfileReportCondition;
  ProfileReportConnection: ProfileReportConnection;
  ProfileReportDistinctCountAggregateFilter: ProfileReportDistinctCountAggregateFilter;
  ProfileReportDistinctCountAggregates: ProfileReportDistinctCountAggregates;
  ProfileReportEdge: ProfileReportEdge;
  ProfileReportFilter: ProfileReportFilter;
  ProfileReportHavingAverageInput: ProfileReportHavingAverageInput;
  ProfileReportHavingDistinctCountInput: ProfileReportHavingDistinctCountInput;
  ProfileReportHavingInput: ProfileReportHavingInput;
  ProfileReportHavingMaxInput: ProfileReportHavingMaxInput;
  ProfileReportHavingMinInput: ProfileReportHavingMinInput;
  ProfileReportHavingStddevPopulationInput: ProfileReportHavingStddevPopulationInput;
  ProfileReportHavingStddevSampleInput: ProfileReportHavingStddevSampleInput;
  ProfileReportHavingSumInput: ProfileReportHavingSumInput;
  ProfileReportHavingVariancePopulationInput: ProfileReportHavingVariancePopulationInput;
  ProfileReportHavingVarianceSampleInput: ProfileReportHavingVarianceSampleInput;
  ProfileReportMaxAggregateFilter: ProfileReportMaxAggregateFilter;
  ProfileReportMaxAggregates: ProfileReportMaxAggregates;
  ProfileReportMinAggregateFilter: ProfileReportMinAggregateFilter;
  ProfileReportMinAggregates: ProfileReportMinAggregates;
  ProfileReportStddevPopulationAggregateFilter: ProfileReportStddevPopulationAggregateFilter;
  ProfileReportStddevPopulationAggregates: ProfileReportStddevPopulationAggregates;
  ProfileReportStddevSampleAggregateFilter: ProfileReportStddevSampleAggregateFilter;
  ProfileReportStddevSampleAggregates: ProfileReportStddevSampleAggregates;
  ProfileReportSumAggregateFilter: ProfileReportSumAggregateFilter;
  ProfileReportSumAggregates: ProfileReportSumAggregates;
  ProfileReportVariancePopulationAggregateFilter: ProfileReportVariancePopulationAggregateFilter;
  ProfileReportVariancePopulationAggregates: ProfileReportVariancePopulationAggregates;
  ProfileReportVarianceSampleAggregateFilter: ProfileReportVarianceSampleAggregateFilter;
  ProfileReportVarianceSampleAggregates: ProfileReportVarianceSampleAggregates;
  Purchase: Purchase;
  PurchaseAggregates: PurchaseAggregates;
  PurchaseAverageAggregates: PurchaseAverageAggregates;
  PurchaseCondition: PurchaseCondition;
  PurchaseConnection: PurchaseConnection;
  PurchaseDistinctCountAggregates: PurchaseDistinctCountAggregates;
  PurchaseEdge: PurchaseEdge;
  PurchaseFilter: PurchaseFilter;
  PurchaseHavingAverageInput: PurchaseHavingAverageInput;
  PurchaseHavingDistinctCountInput: PurchaseHavingDistinctCountInput;
  PurchaseHavingInput: PurchaseHavingInput;
  PurchaseHavingMaxInput: PurchaseHavingMaxInput;
  PurchaseHavingMinInput: PurchaseHavingMinInput;
  PurchaseHavingStddevPopulationInput: PurchaseHavingStddevPopulationInput;
  PurchaseHavingStddevSampleInput: PurchaseHavingStddevSampleInput;
  PurchaseHavingSumInput: PurchaseHavingSumInput;
  PurchaseHavingVariancePopulationInput: PurchaseHavingVariancePopulationInput;
  PurchaseHavingVarianceSampleInput: PurchaseHavingVarianceSampleInput;
  PurchaseItem: PurchaseItem;
  PurchaseItemAggregates: PurchaseItemAggregates;
  PurchaseItemAggregatesFilter: PurchaseItemAggregatesFilter;
  PurchaseItemAverageAggregateFilter: PurchaseItemAverageAggregateFilter;
  PurchaseItemAverageAggregates: PurchaseItemAverageAggregates;
  PurchaseItemCondition: PurchaseItemCondition;
  PurchaseItemConnection: PurchaseItemConnection;
  PurchaseItemDistinctCountAggregateFilter: PurchaseItemDistinctCountAggregateFilter;
  PurchaseItemDistinctCountAggregates: PurchaseItemDistinctCountAggregates;
  PurchaseItemEdge: PurchaseItemEdge;
  PurchaseItemFilter: PurchaseItemFilter;
  PurchaseItemHavingAverageInput: PurchaseItemHavingAverageInput;
  PurchaseItemHavingDistinctCountInput: PurchaseItemHavingDistinctCountInput;
  PurchaseItemHavingInput: PurchaseItemHavingInput;
  PurchaseItemHavingMaxInput: PurchaseItemHavingMaxInput;
  PurchaseItemHavingMinInput: PurchaseItemHavingMinInput;
  PurchaseItemHavingStddevPopulationInput: PurchaseItemHavingStddevPopulationInput;
  PurchaseItemHavingStddevSampleInput: PurchaseItemHavingStddevSampleInput;
  PurchaseItemHavingSumInput: PurchaseItemHavingSumInput;
  PurchaseItemHavingVariancePopulationInput: PurchaseItemHavingVariancePopulationInput;
  PurchaseItemHavingVarianceSampleInput: PurchaseItemHavingVarianceSampleInput;
  PurchaseItemMaxAggregateFilter: PurchaseItemMaxAggregateFilter;
  PurchaseItemMaxAggregates: PurchaseItemMaxAggregates;
  PurchaseItemMinAggregateFilter: PurchaseItemMinAggregateFilter;
  PurchaseItemMinAggregates: PurchaseItemMinAggregates;
  PurchaseItemStddevPopulationAggregateFilter: PurchaseItemStddevPopulationAggregateFilter;
  PurchaseItemStddevPopulationAggregates: PurchaseItemStddevPopulationAggregates;
  PurchaseItemStddevSampleAggregateFilter: PurchaseItemStddevSampleAggregateFilter;
  PurchaseItemStddevSampleAggregates: PurchaseItemStddevSampleAggregates;
  PurchaseItemSumAggregateFilter: PurchaseItemSumAggregateFilter;
  PurchaseItemSumAggregates: PurchaseItemSumAggregates;
  PurchaseItemVariancePopulationAggregateFilter: PurchaseItemVariancePopulationAggregateFilter;
  PurchaseItemVariancePopulationAggregates: PurchaseItemVariancePopulationAggregates;
  PurchaseItemVarianceSampleAggregateFilter: PurchaseItemVarianceSampleAggregateFilter;
  PurchaseItemVarianceSampleAggregates: PurchaseItemVarianceSampleAggregates;
  PurchaseMaxAggregates: PurchaseMaxAggregates;
  PurchaseMinAggregates: PurchaseMinAggregates;
  PurchaseOrder: PurchaseOrder;
  PurchaseOrderAggregates: PurchaseOrderAggregates;
  PurchaseOrderAggregatesFilter: PurchaseOrderAggregatesFilter;
  PurchaseOrderAverageAggregateFilter: PurchaseOrderAverageAggregateFilter;
  PurchaseOrderAverageAggregates: PurchaseOrderAverageAggregates;
  PurchaseOrderCondition: PurchaseOrderCondition;
  PurchaseOrderConnection: PurchaseOrderConnection;
  PurchaseOrderDistinctCountAggregateFilter: PurchaseOrderDistinctCountAggregateFilter;
  PurchaseOrderDistinctCountAggregates: PurchaseOrderDistinctCountAggregates;
  PurchaseOrderEdge: PurchaseOrderEdge;
  PurchaseOrderFilter: PurchaseOrderFilter;
  PurchaseOrderHavingAverageInput: PurchaseOrderHavingAverageInput;
  PurchaseOrderHavingDistinctCountInput: PurchaseOrderHavingDistinctCountInput;
  PurchaseOrderHavingInput: PurchaseOrderHavingInput;
  PurchaseOrderHavingMaxInput: PurchaseOrderHavingMaxInput;
  PurchaseOrderHavingMinInput: PurchaseOrderHavingMinInput;
  PurchaseOrderHavingStddevPopulationInput: PurchaseOrderHavingStddevPopulationInput;
  PurchaseOrderHavingStddevSampleInput: PurchaseOrderHavingStddevSampleInput;
  PurchaseOrderHavingSumInput: PurchaseOrderHavingSumInput;
  PurchaseOrderHavingVariancePopulationInput: PurchaseOrderHavingVariancePopulationInput;
  PurchaseOrderHavingVarianceSampleInput: PurchaseOrderHavingVarianceSampleInput;
  PurchaseOrderMaxAggregateFilter: PurchaseOrderMaxAggregateFilter;
  PurchaseOrderMaxAggregates: PurchaseOrderMaxAggregates;
  PurchaseOrderMinAggregateFilter: PurchaseOrderMinAggregateFilter;
  PurchaseOrderMinAggregates: PurchaseOrderMinAggregates;
  PurchaseOrderReceipt: PurchaseOrderReceipt;
  PurchaseOrderStddevPopulationAggregateFilter: PurchaseOrderStddevPopulationAggregateFilter;
  PurchaseOrderStddevPopulationAggregates: PurchaseOrderStddevPopulationAggregates;
  PurchaseOrderStddevSampleAggregateFilter: PurchaseOrderStddevSampleAggregateFilter;
  PurchaseOrderStddevSampleAggregates: PurchaseOrderStddevSampleAggregates;
  PurchaseOrderSumAggregateFilter: PurchaseOrderSumAggregateFilter;
  PurchaseOrderSumAggregates: PurchaseOrderSumAggregates;
  PurchaseOrderToManyChargebackFilter: PurchaseOrderToManyChargebackFilter;
  PurchaseOrderToManyChargebackIndicatorFilter: PurchaseOrderToManyChargebackIndicatorFilter;
  PurchaseOrderToManyPurchaseItemFilter: PurchaseOrderToManyPurchaseItemFilter;
  PurchaseOrderToManyRefundFilter: PurchaseOrderToManyRefundFilter;
  PurchaseOrderVariancePopulationAggregateFilter: PurchaseOrderVariancePopulationAggregateFilter;
  PurchaseOrderVariancePopulationAggregates: PurchaseOrderVariancePopulationAggregates;
  PurchaseOrderVarianceSampleAggregateFilter: PurchaseOrderVarianceSampleAggregateFilter;
  PurchaseOrderVarianceSampleAggregates: PurchaseOrderVarianceSampleAggregates;
  PurchaseStddevPopulationAggregates: PurchaseStddevPopulationAggregates;
  PurchaseStddevSampleAggregates: PurchaseStddevSampleAggregates;
  PurchaseSumAggregates: PurchaseSumAggregates;
  PurchaseVariancePopulationAggregates: PurchaseVariancePopulationAggregates;
  PurchaseVarianceSampleAggregates: PurchaseVarianceSampleAggregates;
  Query: {};
  ReasonCode: ReasonCode;
  ReasonCodeAggregates: ReasonCodeAggregates;
  ReasonCodeAverageAggregates: ReasonCodeAverageAggregates;
  ReasonCodeCondition: ReasonCodeCondition;
  ReasonCodeConnection: ReasonCodeConnection;
  ReasonCodeDistinctCountAggregates: ReasonCodeDistinctCountAggregates;
  ReasonCodeEdge: ReasonCodeEdge;
  ReasonCodeFilter: ReasonCodeFilter;
  ReasonCodeMaxAggregates: ReasonCodeMaxAggregates;
  ReasonCodeMinAggregates: ReasonCodeMinAggregates;
  ReasonCodeStddevPopulationAggregates: ReasonCodeStddevPopulationAggregates;
  ReasonCodeStddevSampleAggregates: ReasonCodeStddevSampleAggregates;
  ReasonCodeSumAggregates: ReasonCodeSumAggregates;
  ReasonCodeVariancePopulationAggregates: ReasonCodeVariancePopulationAggregates;
  ReasonCodeVarianceSampleAggregates: ReasonCodeVarianceSampleAggregates;
  RebillSession: RebillSession;
  RebillSessionAggregates: RebillSessionAggregates;
  RebillSessionAggregatesFilter: RebillSessionAggregatesFilter;
  RebillSessionAverageAggregateFilter: RebillSessionAverageAggregateFilter;
  RebillSessionAverageAggregates: RebillSessionAverageAggregates;
  RebillSessionCondition: RebillSessionCondition;
  RebillSessionConnection: RebillSessionConnection;
  RebillSessionDistinctCountAggregateFilter: RebillSessionDistinctCountAggregateFilter;
  RebillSessionDistinctCountAggregates: RebillSessionDistinctCountAggregates;
  RebillSessionEdge: RebillSessionEdge;
  RebillSessionFilter: RebillSessionFilter;
  RebillSessionHavingAverageInput: RebillSessionHavingAverageInput;
  RebillSessionHavingDistinctCountInput: RebillSessionHavingDistinctCountInput;
  RebillSessionHavingInput: RebillSessionHavingInput;
  RebillSessionHavingMaxInput: RebillSessionHavingMaxInput;
  RebillSessionHavingMinInput: RebillSessionHavingMinInput;
  RebillSessionHavingStddevPopulationInput: RebillSessionHavingStddevPopulationInput;
  RebillSessionHavingStddevSampleInput: RebillSessionHavingStddevSampleInput;
  RebillSessionHavingSumInput: RebillSessionHavingSumInput;
  RebillSessionHavingVariancePopulationInput: RebillSessionHavingVariancePopulationInput;
  RebillSessionHavingVarianceSampleInput: RebillSessionHavingVarianceSampleInput;
  RebillSessionMaxAggregateFilter: RebillSessionMaxAggregateFilter;
  RebillSessionMaxAggregates: RebillSessionMaxAggregates;
  RebillSessionMinAggregateFilter: RebillSessionMinAggregateFilter;
  RebillSessionMinAggregates: RebillSessionMinAggregates;
  RebillSessionRebillManagerEnumFilter: RebillSessionRebillManagerEnumFilter;
  RebillSessionStatusEnumFilter: RebillSessionStatusEnumFilter;
  RebillSessionStddevPopulationAggregateFilter: RebillSessionStddevPopulationAggregateFilter;
  RebillSessionStddevPopulationAggregates: RebillSessionStddevPopulationAggregates;
  RebillSessionStddevSampleAggregateFilter: RebillSessionStddevSampleAggregateFilter;
  RebillSessionStddevSampleAggregates: RebillSessionStddevSampleAggregates;
  RebillSessionSumAggregateFilter: RebillSessionSumAggregateFilter;
  RebillSessionSumAggregates: RebillSessionSumAggregates;
  RebillSessionVariancePopulationAggregateFilter: RebillSessionVariancePopulationAggregateFilter;
  RebillSessionVariancePopulationAggregates: RebillSessionVariancePopulationAggregates;
  RebillSessionVarianceSampleAggregateFilter: RebillSessionVarianceSampleAggregateFilter;
  RebillSessionVarianceSampleAggregates: RebillSessionVarianceSampleAggregates;
  RecordLfaSplashViewInput: RecordLfaSplashViewInput;
  RecordLfaSplashViewPayload: RecordLfaSplashViewPayload;
  RecordReflectionViewInput: RecordReflectionViewInput;
  RecordReflectionViewPayload: RecordReflectionViewPayload;
  ReferralPurchase: ReferralPurchase;
  ReferralReward: ReferralReward;
  Refund: Refund;
  RefundAggregates: RefundAggregates;
  RefundAggregatesFilter: RefundAggregatesFilter;
  RefundAverageAggregateFilter: RefundAverageAggregateFilter;
  RefundAverageAggregates: RefundAverageAggregates;
  RefundCondition: RefundCondition;
  RefundConnection: RefundConnection;
  RefundDistinctCountAggregateFilter: RefundDistinctCountAggregateFilter;
  RefundDistinctCountAggregates: RefundDistinctCountAggregates;
  RefundEdge: RefundEdge;
  RefundFilter: RefundFilter;
  RefundHavingAverageInput: RefundHavingAverageInput;
  RefundHavingDistinctCountInput: RefundHavingDistinctCountInput;
  RefundHavingInput: RefundHavingInput;
  RefundHavingMaxInput: RefundHavingMaxInput;
  RefundHavingMinInput: RefundHavingMinInput;
  RefundHavingStddevPopulationInput: RefundHavingStddevPopulationInput;
  RefundHavingStddevSampleInput: RefundHavingStddevSampleInput;
  RefundHavingSumInput: RefundHavingSumInput;
  RefundHavingVariancePopulationInput: RefundHavingVariancePopulationInput;
  RefundHavingVarianceSampleInput: RefundHavingVarianceSampleInput;
  RefundMaxAggregateFilter: RefundMaxAggregateFilter;
  RefundMaxAggregates: RefundMaxAggregates;
  RefundMinAggregateFilter: RefundMinAggregateFilter;
  RefundMinAggregates: RefundMinAggregates;
  RefundStddevPopulationAggregateFilter: RefundStddevPopulationAggregateFilter;
  RefundStddevPopulationAggregates: RefundStddevPopulationAggregates;
  RefundStddevSampleAggregateFilter: RefundStddevSampleAggregateFilter;
  RefundStddevSampleAggregates: RefundStddevSampleAggregates;
  RefundSumAggregateFilter: RefundSumAggregateFilter;
  RefundSumAggregates: RefundSumAggregates;
  RefundVariancePopulationAggregateFilter: RefundVariancePopulationAggregateFilter;
  RefundVariancePopulationAggregates: RefundVariancePopulationAggregates;
  RefundVarianceSampleAggregateFilter: RefundVarianceSampleAggregateFilter;
  RefundVarianceSampleAggregates: RefundVarianceSampleAggregates;
  RegistrationRiskAssessment: RegistrationRiskAssessment;
  RegistrationRiskAssessmentFilter: RegistrationRiskAssessmentFilter;
  ResetCredit: ResetCredit;
  ResetCreditAggregates: ResetCreditAggregates;
  ResetCreditAggregatesFilter: ResetCreditAggregatesFilter;
  ResetCreditAverageAggregateFilter: ResetCreditAverageAggregateFilter;
  ResetCreditAverageAggregates: ResetCreditAverageAggregates;
  ResetCreditCondition: ResetCreditCondition;
  ResetCreditConnection: ResetCreditConnection;
  ResetCreditDistinctCountAggregateFilter: ResetCreditDistinctCountAggregateFilter;
  ResetCreditDistinctCountAggregates: ResetCreditDistinctCountAggregates;
  ResetCreditEdge: ResetCreditEdge;
  ResetCreditFilter: ResetCreditFilter;
  ResetCreditGrant: ResetCreditGrant;
  ResetCreditHavingAverageInput: ResetCreditHavingAverageInput;
  ResetCreditHavingDistinctCountInput: ResetCreditHavingDistinctCountInput;
  ResetCreditHavingInput: ResetCreditHavingInput;
  ResetCreditHavingMaxInput: ResetCreditHavingMaxInput;
  ResetCreditHavingMinInput: ResetCreditHavingMinInput;
  ResetCreditHavingStddevPopulationInput: ResetCreditHavingStddevPopulationInput;
  ResetCreditHavingStddevSampleInput: ResetCreditHavingStddevSampleInput;
  ResetCreditHavingSumInput: ResetCreditHavingSumInput;
  ResetCreditHavingVariancePopulationInput: ResetCreditHavingVariancePopulationInput;
  ResetCreditHavingVarianceSampleInput: ResetCreditHavingVarianceSampleInput;
  ResetCreditMaxAggregateFilter: ResetCreditMaxAggregateFilter;
  ResetCreditMaxAggregates: ResetCreditMaxAggregates;
  ResetCreditMinAggregateFilter: ResetCreditMinAggregateFilter;
  ResetCreditMinAggregates: ResetCreditMinAggregates;
  ResetCreditStddevPopulationAggregateFilter: ResetCreditStddevPopulationAggregateFilter;
  ResetCreditStddevPopulationAggregates: ResetCreditStddevPopulationAggregates;
  ResetCreditStddevSampleAggregateFilter: ResetCreditStddevSampleAggregateFilter;
  ResetCreditStddevSampleAggregates: ResetCreditStddevSampleAggregates;
  ResetCreditSumAggregateFilter: ResetCreditSumAggregateFilter;
  ResetCreditSumAggregates: ResetCreditSumAggregates;
  ResetCreditVariancePopulationAggregateFilter: ResetCreditVariancePopulationAggregateFilter;
  ResetCreditVariancePopulationAggregates: ResetCreditVariancePopulationAggregates;
  ResetCreditVarianceSampleAggregateFilter: ResetCreditVarianceSampleAggregateFilter;
  ResetCreditVarianceSampleAggregates: ResetCreditVarianceSampleAggregates;
  RevokeUserTaxFormValidationBypassInput: RevokeUserTaxFormValidationBypassInput;
  RevokeUserTaxFormValidationBypassResult: RevokeUserTaxFormValidationBypassResult;
  RiskyProduct: RiskyProduct;
  RiskyProductAggregates: RiskyProductAggregates;
  RiskyProductAverageAggregates: RiskyProductAverageAggregates;
  RiskyProductCondition: RiskyProductCondition;
  RiskyProductConnection: RiskyProductConnection;
  RiskyProductDistinctCountAggregates: RiskyProductDistinctCountAggregates;
  RiskyProductEdge: RiskyProductEdge;
  RiskyProductFilter: RiskyProductFilter;
  RiskyProductMaxAggregates: RiskyProductMaxAggregates;
  RiskyProductMinAggregates: RiskyProductMinAggregates;
  RiskyProductStddevPopulationAggregates: RiskyProductStddevPopulationAggregates;
  RiskyProductStddevSampleAggregates: RiskyProductStddevSampleAggregates;
  RiskyProductSumAggregates: RiskyProductSumAggregates;
  RiskyProductVariancePopulationAggregates: RiskyProductVariancePopulationAggregates;
  RiskyProductVarianceSampleAggregates: RiskyProductVarianceSampleAggregates;
  SavedCard: SavedCard;
  SavedCardAggregates: SavedCardAggregates;
  SavedCardAggregatesFilter: SavedCardAggregatesFilter;
  SavedCardAverageAggregateFilter: SavedCardAverageAggregateFilter;
  SavedCardAverageAggregates: SavedCardAverageAggregates;
  SavedCardCondition: SavedCardCondition;
  SavedCardConnection: SavedCardConnection;
  SavedCardDistinctCountAggregateFilter: SavedCardDistinctCountAggregateFilter;
  SavedCardDistinctCountAggregates: SavedCardDistinctCountAggregates;
  SavedCardEdge: SavedCardEdge;
  SavedCardFilter: SavedCardFilter;
  SavedCardHavingAverageInput: SavedCardHavingAverageInput;
  SavedCardHavingDistinctCountInput: SavedCardHavingDistinctCountInput;
  SavedCardHavingInput: SavedCardHavingInput;
  SavedCardHavingMaxInput: SavedCardHavingMaxInput;
  SavedCardHavingMinInput: SavedCardHavingMinInput;
  SavedCardHavingStddevPopulationInput: SavedCardHavingStddevPopulationInput;
  SavedCardHavingStddevSampleInput: SavedCardHavingStddevSampleInput;
  SavedCardHavingSumInput: SavedCardHavingSumInput;
  SavedCardHavingVariancePopulationInput: SavedCardHavingVariancePopulationInput;
  SavedCardHavingVarianceSampleInput: SavedCardHavingVarianceSampleInput;
  SavedCardMaxAggregateFilter: SavedCardMaxAggregateFilter;
  SavedCardMaxAggregates: SavedCardMaxAggregates;
  SavedCardMinAggregateFilter: SavedCardMinAggregateFilter;
  SavedCardMinAggregates: SavedCardMinAggregates;
  SavedCardStddevPopulationAggregateFilter: SavedCardStddevPopulationAggregateFilter;
  SavedCardStddevPopulationAggregates: SavedCardStddevPopulationAggregates;
  SavedCardStddevSampleAggregateFilter: SavedCardStddevSampleAggregateFilter;
  SavedCardStddevSampleAggregates: SavedCardStddevSampleAggregates;
  SavedCardSumAggregateFilter: SavedCardSumAggregateFilter;
  SavedCardSumAggregates: SavedCardSumAggregates;
  SavedCardToManyNmiSubscriptionFilter: SavedCardToManyNmiSubscriptionFilter;
  SavedCardVariancePopulationAggregateFilter: SavedCardVariancePopulationAggregateFilter;
  SavedCardVariancePopulationAggregates: SavedCardVariancePopulationAggregates;
  SavedCardVarianceSampleAggregateFilter: SavedCardVarianceSampleAggregateFilter;
  SavedCardVarianceSampleAggregates: SavedCardVarianceSampleAggregates;
  SetCaseBanPendingStatusInput: SetCaseBanPendingStatusInput;
  SetCaseBanTraderIdvLinkInput: SetCaseBanTraderIdvLinkInput;
  SetCaseBanTraderIntercomLinkInput: SetCaseBanTraderIntercomLinkInput;
  SetCaseInvestigationPendingStatusInput: SetCaseInvestigationPendingStatusInput;
  SetCaseInvestigationTraderIdvLinkInput: SetCaseInvestigationTraderIdvLinkInput;
  SetCaseInvestigationTraderIntercomLinkInput: SetCaseInvestigationTraderIntercomLinkInput;
  SkuAccountDetails: SkuAccountDetails;
  SkuAccountProvisioningClaim: SkuAccountProvisioningClaim;
  SkuInventory: SkuInventory;
  StartW8BENSigningInput: StartW8BenSigningInput;
  StartW9SigningInput: StartW9SigningInput;
  String: Scalars['String']['output'];
  StringFilter: StringFilter;
  StringListFilter: StringListFilter;
  SubmitCaseBanInput: SubmitCaseBanInput;
  SubscriptionDunning: SubscriptionDunning;
  SyncDiscordRolesPayload: SyncDiscordRolesPayload;
  SyncState: SyncState;
  TaxFormDocumentResult: TaxFormDocumentResult;
  TaxInfo: TaxInfo;
  TaxInfoAggregates: TaxInfoAggregates;
  TaxInfoAggregatesFilter: TaxInfoAggregatesFilter;
  TaxInfoAverageAggregateFilter: TaxInfoAverageAggregateFilter;
  TaxInfoAverageAggregates: TaxInfoAverageAggregates;
  TaxInfoCondition: TaxInfoCondition;
  TaxInfoConnection: TaxInfoConnection;
  TaxInfoDistinctCountAggregateFilter: TaxInfoDistinctCountAggregateFilter;
  TaxInfoDistinctCountAggregates: TaxInfoDistinctCountAggregates;
  TaxInfoEdge: TaxInfoEdge;
  TaxInfoFilter: TaxInfoFilter;
  TaxInfoHavingAverageInput: TaxInfoHavingAverageInput;
  TaxInfoHavingDistinctCountInput: TaxInfoHavingDistinctCountInput;
  TaxInfoHavingInput: TaxInfoHavingInput;
  TaxInfoHavingMaxInput: TaxInfoHavingMaxInput;
  TaxInfoHavingMinInput: TaxInfoHavingMinInput;
  TaxInfoHavingStddevPopulationInput: TaxInfoHavingStddevPopulationInput;
  TaxInfoHavingStddevSampleInput: TaxInfoHavingStddevSampleInput;
  TaxInfoHavingSumInput: TaxInfoHavingSumInput;
  TaxInfoHavingVariancePopulationInput: TaxInfoHavingVariancePopulationInput;
  TaxInfoHavingVarianceSampleInput: TaxInfoHavingVarianceSampleInput;
  TaxInfoMaxAggregateFilter: TaxInfoMaxAggregateFilter;
  TaxInfoMaxAggregates: TaxInfoMaxAggregates;
  TaxInfoMinAggregateFilter: TaxInfoMinAggregateFilter;
  TaxInfoMinAggregates: TaxInfoMinAggregates;
  TaxInfoStddevPopulationAggregateFilter: TaxInfoStddevPopulationAggregateFilter;
  TaxInfoStddevPopulationAggregates: TaxInfoStddevPopulationAggregates;
  TaxInfoStddevSampleAggregateFilter: TaxInfoStddevSampleAggregateFilter;
  TaxInfoStddevSampleAggregates: TaxInfoStddevSampleAggregates;
  TaxInfoSumAggregateFilter: TaxInfoSumAggregateFilter;
  TaxInfoSumAggregates: TaxInfoSumAggregates;
  TaxInfoVariancePopulationAggregateFilter: TaxInfoVariancePopulationAggregateFilter;
  TaxInfoVariancePopulationAggregates: TaxInfoVariancePopulationAggregates;
  TaxInfoVarianceSampleAggregateFilter: TaxInfoVarianceSampleAggregateFilter;
  TaxInfoVarianceSampleAggregates: TaxInfoVarianceSampleAggregates;
  Trade: Trade;
  TradedProductLots: TradedProductLots;
  TraderLockDetail: TraderLockDetail;
  TraderLockDetailFilter: TraderLockDetailFilter;
  TraderOpenCase: TraderOpenCase;
  TraderPayoutNote: TraderPayoutNote;
  TraderProfileAsset: TraderProfileAsset;
  TraderProfileAssetFilter: TraderProfileAssetFilter;
  TraderProfileAssetToManyTraderPublicProfileFilter: TraderProfileAssetToManyTraderPublicProfileFilter;
  TraderProfileModerationBlockedWord: TraderProfileModerationBlockedWord;
  TraderProfileModerationCase: TraderProfileModerationCase;
  TraderProfileModerationCaseAggregates: TraderProfileModerationCaseAggregates;
  TraderProfileModerationCaseAggregatesFilter: TraderProfileModerationCaseAggregatesFilter;
  TraderProfileModerationCaseAverageAggregateFilter: TraderProfileModerationCaseAverageAggregateFilter;
  TraderProfileModerationCaseAverageAggregates: TraderProfileModerationCaseAverageAggregates;
  TraderProfileModerationCaseCondition: TraderProfileModerationCaseCondition;
  TraderProfileModerationCaseConnection: TraderProfileModerationCaseConnection;
  TraderProfileModerationCaseDistinctCountAggregateFilter: TraderProfileModerationCaseDistinctCountAggregateFilter;
  TraderProfileModerationCaseDistinctCountAggregates: TraderProfileModerationCaseDistinctCountAggregates;
  TraderProfileModerationCaseEdge: TraderProfileModerationCaseEdge;
  TraderProfileModerationCaseFilter: TraderProfileModerationCaseFilter;
  TraderProfileModerationCaseHavingAverageInput: TraderProfileModerationCaseHavingAverageInput;
  TraderProfileModerationCaseHavingDistinctCountInput: TraderProfileModerationCaseHavingDistinctCountInput;
  TraderProfileModerationCaseHavingInput: TraderProfileModerationCaseHavingInput;
  TraderProfileModerationCaseHavingMaxInput: TraderProfileModerationCaseHavingMaxInput;
  TraderProfileModerationCaseHavingMinInput: TraderProfileModerationCaseHavingMinInput;
  TraderProfileModerationCaseHavingStddevPopulationInput: TraderProfileModerationCaseHavingStddevPopulationInput;
  TraderProfileModerationCaseHavingStddevSampleInput: TraderProfileModerationCaseHavingStddevSampleInput;
  TraderProfileModerationCaseHavingSumInput: TraderProfileModerationCaseHavingSumInput;
  TraderProfileModerationCaseHavingVariancePopulationInput: TraderProfileModerationCaseHavingVariancePopulationInput;
  TraderProfileModerationCaseHavingVarianceSampleInput: TraderProfileModerationCaseHavingVarianceSampleInput;
  TraderProfileModerationCaseHistory: TraderProfileModerationCaseHistory;
  TraderProfileModerationCaseHistoryAggregates: TraderProfileModerationCaseHistoryAggregates;
  TraderProfileModerationCaseHistoryAggregatesFilter: TraderProfileModerationCaseHistoryAggregatesFilter;
  TraderProfileModerationCaseHistoryAverageAggregateFilter: TraderProfileModerationCaseHistoryAverageAggregateFilter;
  TraderProfileModerationCaseHistoryAverageAggregates: TraderProfileModerationCaseHistoryAverageAggregates;
  TraderProfileModerationCaseHistoryCondition: TraderProfileModerationCaseHistoryCondition;
  TraderProfileModerationCaseHistoryConnection: TraderProfileModerationCaseHistoryConnection;
  TraderProfileModerationCaseHistoryDistinctCountAggregateFilter: TraderProfileModerationCaseHistoryDistinctCountAggregateFilter;
  TraderProfileModerationCaseHistoryDistinctCountAggregates: TraderProfileModerationCaseHistoryDistinctCountAggregates;
  TraderProfileModerationCaseHistoryEdge: TraderProfileModerationCaseHistoryEdge;
  TraderProfileModerationCaseHistoryFilter: TraderProfileModerationCaseHistoryFilter;
  TraderProfileModerationCaseHistoryHavingAverageInput: TraderProfileModerationCaseHistoryHavingAverageInput;
  TraderProfileModerationCaseHistoryHavingDistinctCountInput: TraderProfileModerationCaseHistoryHavingDistinctCountInput;
  TraderProfileModerationCaseHistoryHavingInput: TraderProfileModerationCaseHistoryHavingInput;
  TraderProfileModerationCaseHistoryHavingMaxInput: TraderProfileModerationCaseHistoryHavingMaxInput;
  TraderProfileModerationCaseHistoryHavingMinInput: TraderProfileModerationCaseHistoryHavingMinInput;
  TraderProfileModerationCaseHistoryHavingStddevPopulationInput: TraderProfileModerationCaseHistoryHavingStddevPopulationInput;
  TraderProfileModerationCaseHistoryHavingStddevSampleInput: TraderProfileModerationCaseHistoryHavingStddevSampleInput;
  TraderProfileModerationCaseHistoryHavingSumInput: TraderProfileModerationCaseHistoryHavingSumInput;
  TraderProfileModerationCaseHistoryHavingVariancePopulationInput: TraderProfileModerationCaseHistoryHavingVariancePopulationInput;
  TraderProfileModerationCaseHistoryHavingVarianceSampleInput: TraderProfileModerationCaseHistoryHavingVarianceSampleInput;
  TraderProfileModerationCaseHistoryMaxAggregateFilter: TraderProfileModerationCaseHistoryMaxAggregateFilter;
  TraderProfileModerationCaseHistoryMaxAggregates: TraderProfileModerationCaseHistoryMaxAggregates;
  TraderProfileModerationCaseHistoryMinAggregateFilter: TraderProfileModerationCaseHistoryMinAggregateFilter;
  TraderProfileModerationCaseHistoryMinAggregates: TraderProfileModerationCaseHistoryMinAggregates;
  TraderProfileModerationCaseHistoryStddevPopulationAggregateFilter: TraderProfileModerationCaseHistoryStddevPopulationAggregateFilter;
  TraderProfileModerationCaseHistoryStddevPopulationAggregates: TraderProfileModerationCaseHistoryStddevPopulationAggregates;
  TraderProfileModerationCaseHistoryStddevSampleAggregateFilter: TraderProfileModerationCaseHistoryStddevSampleAggregateFilter;
  TraderProfileModerationCaseHistoryStddevSampleAggregates: TraderProfileModerationCaseHistoryStddevSampleAggregates;
  TraderProfileModerationCaseHistorySumAggregateFilter: TraderProfileModerationCaseHistorySumAggregateFilter;
  TraderProfileModerationCaseHistorySumAggregates: TraderProfileModerationCaseHistorySumAggregates;
  TraderProfileModerationCaseHistoryVariancePopulationAggregateFilter: TraderProfileModerationCaseHistoryVariancePopulationAggregateFilter;
  TraderProfileModerationCaseHistoryVariancePopulationAggregates: TraderProfileModerationCaseHistoryVariancePopulationAggregates;
  TraderProfileModerationCaseHistoryVarianceSampleAggregateFilter: TraderProfileModerationCaseHistoryVarianceSampleAggregateFilter;
  TraderProfileModerationCaseHistoryVarianceSampleAggregates: TraderProfileModerationCaseHistoryVarianceSampleAggregates;
  TraderProfileModerationCaseMaxAggregateFilter: TraderProfileModerationCaseMaxAggregateFilter;
  TraderProfileModerationCaseMaxAggregates: TraderProfileModerationCaseMaxAggregates;
  TraderProfileModerationCaseMinAggregateFilter: TraderProfileModerationCaseMinAggregateFilter;
  TraderProfileModerationCaseMinAggregates: TraderProfileModerationCaseMinAggregates;
  TraderProfileModerationCaseStddevPopulationAggregateFilter: TraderProfileModerationCaseStddevPopulationAggregateFilter;
  TraderProfileModerationCaseStddevPopulationAggregates: TraderProfileModerationCaseStddevPopulationAggregates;
  TraderProfileModerationCaseStddevSampleAggregateFilter: TraderProfileModerationCaseStddevSampleAggregateFilter;
  TraderProfileModerationCaseStddevSampleAggregates: TraderProfileModerationCaseStddevSampleAggregates;
  TraderProfileModerationCaseSumAggregateFilter: TraderProfileModerationCaseSumAggregateFilter;
  TraderProfileModerationCaseSumAggregates: TraderProfileModerationCaseSumAggregates;
  TraderProfileModerationCaseToManyTraderProfileModerationCaseHistoryFilter: TraderProfileModerationCaseToManyTraderProfileModerationCaseHistoryFilter;
  TraderProfileModerationCaseVariancePopulationAggregateFilter: TraderProfileModerationCaseVariancePopulationAggregateFilter;
  TraderProfileModerationCaseVariancePopulationAggregates: TraderProfileModerationCaseVariancePopulationAggregates;
  TraderProfileModerationCaseVarianceSampleAggregateFilter: TraderProfileModerationCaseVarianceSampleAggregateFilter;
  TraderProfileModerationCaseVarianceSampleAggregates: TraderProfileModerationCaseVarianceSampleAggregates;
  TraderPublicProfile: TraderPublicProfile;
  TraderPublicProfileAggregates: TraderPublicProfileAggregates;
  TraderPublicProfileAggregatesFilter: TraderPublicProfileAggregatesFilter;
  TraderPublicProfileAverageAggregateFilter: TraderPublicProfileAverageAggregateFilter;
  TraderPublicProfileAverageAggregates: TraderPublicProfileAverageAggregates;
  TraderPublicProfileCondition: TraderPublicProfileCondition;
  TraderPublicProfileConnection: TraderPublicProfileConnection;
  TraderPublicProfileDistinctCountAggregateFilter: TraderPublicProfileDistinctCountAggregateFilter;
  TraderPublicProfileDistinctCountAggregates: TraderPublicProfileDistinctCountAggregates;
  TraderPublicProfileEdge: TraderPublicProfileEdge;
  TraderPublicProfileFilter: TraderPublicProfileFilter;
  TraderPublicProfileHavingAverageInput: TraderPublicProfileHavingAverageInput;
  TraderPublicProfileHavingDistinctCountInput: TraderPublicProfileHavingDistinctCountInput;
  TraderPublicProfileHavingInput: TraderPublicProfileHavingInput;
  TraderPublicProfileHavingMaxInput: TraderPublicProfileHavingMaxInput;
  TraderPublicProfileHavingMinInput: TraderPublicProfileHavingMinInput;
  TraderPublicProfileHavingStddevPopulationInput: TraderPublicProfileHavingStddevPopulationInput;
  TraderPublicProfileHavingStddevSampleInput: TraderPublicProfileHavingStddevSampleInput;
  TraderPublicProfileHavingSumInput: TraderPublicProfileHavingSumInput;
  TraderPublicProfileHavingVariancePopulationInput: TraderPublicProfileHavingVariancePopulationInput;
  TraderPublicProfileHavingVarianceSampleInput: TraderPublicProfileHavingVarianceSampleInput;
  TraderPublicProfileMaxAggregateFilter: TraderPublicProfileMaxAggregateFilter;
  TraderPublicProfileMaxAggregates: TraderPublicProfileMaxAggregates;
  TraderPublicProfileMinAggregateFilter: TraderPublicProfileMinAggregateFilter;
  TraderPublicProfileMinAggregates: TraderPublicProfileMinAggregates;
  TraderPublicProfilePatch: TraderPublicProfilePatch;
  TraderPublicProfileStddevPopulationAggregateFilter: TraderPublicProfileStddevPopulationAggregateFilter;
  TraderPublicProfileStddevPopulationAggregates: TraderPublicProfileStddevPopulationAggregates;
  TraderPublicProfileStddevSampleAggregateFilter: TraderPublicProfileStddevSampleAggregateFilter;
  TraderPublicProfileStddevSampleAggregates: TraderPublicProfileStddevSampleAggregates;
  TraderPublicProfileSumAggregateFilter: TraderPublicProfileSumAggregateFilter;
  TraderPublicProfileSumAggregates: TraderPublicProfileSumAggregates;
  TraderPublicProfileToManyProfileReportFilter: TraderPublicProfileToManyProfileReportFilter;
  TraderPublicProfileVariancePopulationAggregateFilter: TraderPublicProfileVariancePopulationAggregateFilter;
  TraderPublicProfileVariancePopulationAggregates: TraderPublicProfileVariancePopulationAggregates;
  TraderPublicProfileVarianceSampleAggregateFilter: TraderPublicProfileVarianceSampleAggregateFilter;
  TraderPublicProfileVarianceSampleAggregates: TraderPublicProfileVarianceSampleAggregates;
  TraderRiskIndicator: TraderRiskIndicator;
  TraderRiskIndicatorAggregates: TraderRiskIndicatorAggregates;
  TraderRiskIndicatorAggregatesFilter: TraderRiskIndicatorAggregatesFilter;
  TraderRiskIndicatorAverageAggregateFilter: TraderRiskIndicatorAverageAggregateFilter;
  TraderRiskIndicatorAverageAggregates: TraderRiskIndicatorAverageAggregates;
  TraderRiskIndicatorCondition: TraderRiskIndicatorCondition;
  TraderRiskIndicatorConnection: TraderRiskIndicatorConnection;
  TraderRiskIndicatorDistinctCountAggregateFilter: TraderRiskIndicatorDistinctCountAggregateFilter;
  TraderRiskIndicatorDistinctCountAggregates: TraderRiskIndicatorDistinctCountAggregates;
  TraderRiskIndicatorEdge: TraderRiskIndicatorEdge;
  TraderRiskIndicatorFilter: TraderRiskIndicatorFilter;
  TraderRiskIndicatorHavingAverageInput: TraderRiskIndicatorHavingAverageInput;
  TraderRiskIndicatorHavingDistinctCountInput: TraderRiskIndicatorHavingDistinctCountInput;
  TraderRiskIndicatorHavingInput: TraderRiskIndicatorHavingInput;
  TraderRiskIndicatorHavingMaxInput: TraderRiskIndicatorHavingMaxInput;
  TraderRiskIndicatorHavingMinInput: TraderRiskIndicatorHavingMinInput;
  TraderRiskIndicatorHavingStddevPopulationInput: TraderRiskIndicatorHavingStddevPopulationInput;
  TraderRiskIndicatorHavingStddevSampleInput: TraderRiskIndicatorHavingStddevSampleInput;
  TraderRiskIndicatorHavingSumInput: TraderRiskIndicatorHavingSumInput;
  TraderRiskIndicatorHavingVariancePopulationInput: TraderRiskIndicatorHavingVariancePopulationInput;
  TraderRiskIndicatorHavingVarianceSampleInput: TraderRiskIndicatorHavingVarianceSampleInput;
  TraderRiskIndicatorInput: TraderRiskIndicatorInput;
  TraderRiskIndicatorMaxAggregateFilter: TraderRiskIndicatorMaxAggregateFilter;
  TraderRiskIndicatorMaxAggregates: TraderRiskIndicatorMaxAggregates;
  TraderRiskIndicatorMinAggregateFilter: TraderRiskIndicatorMinAggregateFilter;
  TraderRiskIndicatorMinAggregates: TraderRiskIndicatorMinAggregates;
  TraderRiskIndicatorOwner: TraderRiskIndicatorOwner;
  TraderRiskIndicatorOwnerFilter: TraderRiskIndicatorOwnerFilter;
  TraderRiskIndicatorPatch: TraderRiskIndicatorPatch;
  TraderRiskIndicatorStddevPopulationAggregateFilter: TraderRiskIndicatorStddevPopulationAggregateFilter;
  TraderRiskIndicatorStddevPopulationAggregates: TraderRiskIndicatorStddevPopulationAggregates;
  TraderRiskIndicatorStddevSampleAggregateFilter: TraderRiskIndicatorStddevSampleAggregateFilter;
  TraderRiskIndicatorStddevSampleAggregates: TraderRiskIndicatorStddevSampleAggregates;
  TraderRiskIndicatorSumAggregateFilter: TraderRiskIndicatorSumAggregateFilter;
  TraderRiskIndicatorSumAggregates: TraderRiskIndicatorSumAggregates;
  TraderRiskIndicatorVariancePopulationAggregateFilter: TraderRiskIndicatorVariancePopulationAggregateFilter;
  TraderRiskIndicatorVariancePopulationAggregates: TraderRiskIndicatorVariancePopulationAggregates;
  TraderRiskIndicatorVarianceSampleAggregateFilter: TraderRiskIndicatorVarianceSampleAggregateFilter;
  TraderRiskIndicatorVarianceSampleAggregates: TraderRiskIndicatorVarianceSampleAggregates;
  TradingHabits: TradingHabits;
  TradingOverview: TradingOverview;
  TradingProduct: TradingProduct;
  TradingProductFee: TradingProductFee;
  TradingProductFeeAggregates: TradingProductFeeAggregates;
  TradingProductFeeAggregatesFilter: TradingProductFeeAggregatesFilter;
  TradingProductFeeAverageAggregateFilter: TradingProductFeeAverageAggregateFilter;
  TradingProductFeeAverageAggregates: TradingProductFeeAverageAggregates;
  TradingProductFeeCondition: TradingProductFeeCondition;
  TradingProductFeeConnection: TradingProductFeeConnection;
  TradingProductFeeDistinctCountAggregateFilter: TradingProductFeeDistinctCountAggregateFilter;
  TradingProductFeeDistinctCountAggregates: TradingProductFeeDistinctCountAggregates;
  TradingProductFeeEdge: TradingProductFeeEdge;
  TradingProductFeeFilter: TradingProductFeeFilter;
  TradingProductFeeHavingAverageInput: TradingProductFeeHavingAverageInput;
  TradingProductFeeHavingDistinctCountInput: TradingProductFeeHavingDistinctCountInput;
  TradingProductFeeHavingInput: TradingProductFeeHavingInput;
  TradingProductFeeHavingMaxInput: TradingProductFeeHavingMaxInput;
  TradingProductFeeHavingMinInput: TradingProductFeeHavingMinInput;
  TradingProductFeeHavingStddevPopulationInput: TradingProductFeeHavingStddevPopulationInput;
  TradingProductFeeHavingStddevSampleInput: TradingProductFeeHavingStddevSampleInput;
  TradingProductFeeHavingSumInput: TradingProductFeeHavingSumInput;
  TradingProductFeeHavingVariancePopulationInput: TradingProductFeeHavingVariancePopulationInput;
  TradingProductFeeHavingVarianceSampleInput: TradingProductFeeHavingVarianceSampleInput;
  TradingProductFeeInput: TradingProductFeeInput;
  TradingProductFeeMaxAggregateFilter: TradingProductFeeMaxAggregateFilter;
  TradingProductFeeMaxAggregates: TradingProductFeeMaxAggregates;
  TradingProductFeeMinAggregateFilter: TradingProductFeeMinAggregateFilter;
  TradingProductFeeMinAggregates: TradingProductFeeMinAggregates;
  TradingProductFeePatch: TradingProductFeePatch;
  TradingProductFeeStddevPopulationAggregateFilter: TradingProductFeeStddevPopulationAggregateFilter;
  TradingProductFeeStddevPopulationAggregates: TradingProductFeeStddevPopulationAggregates;
  TradingProductFeeStddevSampleAggregateFilter: TradingProductFeeStddevSampleAggregateFilter;
  TradingProductFeeStddevSampleAggregates: TradingProductFeeStddevSampleAggregates;
  TradingProductFeeSumAggregateFilter: TradingProductFeeSumAggregateFilter;
  TradingProductFeeSumAggregates: TradingProductFeeSumAggregates;
  TradingProductFeeVariancePopulationAggregateFilter: TradingProductFeeVariancePopulationAggregateFilter;
  TradingProductFeeVariancePopulationAggregates: TradingProductFeeVariancePopulationAggregates;
  TradingProductFeeVarianceSampleAggregateFilter: TradingProductFeeVarianceSampleAggregateFilter;
  TradingProductFeeVarianceSampleAggregates: TradingProductFeeVarianceSampleAggregates;
  TradingProductFilter: TradingProductFilter;
  TradingProductToManyTradingProductFeeFilter: TradingProductToManyTradingProductFeeFilter;
  UUID: Scalars['UUID']['output'];
  UUIDFilter: UuidFilter;
  UnifiedSubscription: UnifiedSubscription;
  UnlinkDiscordPayload: UnlinkDiscordPayload;
  UnsetCaseBanPendingStatusInput: UnsetCaseBanPendingStatusInput;
  UnsetCaseInvestigationPendingStatusInput: UnsetCaseInvestigationPendingStatusInput;
  UpdateAccountStatByIdInput: UpdateAccountStatByIdInput;
  UpdateAccountStatInput: UpdateAccountStatInput;
  UpdateAccountStatPayload: Omit<UpdateAccountStatPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateAdminConfigByConfigKeyInput: UpdateAdminConfigByConfigKeyInput;
  UpdateAdminConfigByIdInput: UpdateAdminConfigByIdInput;
  UpdateAdminConfigInput: UpdateAdminConfigInput;
  UpdateAdminConfigPayload: Omit<UpdateAdminConfigPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateCaseBanInput: UpdateCaseBanInput;
  UpdateCaseInvestigationInput: UpdateCaseInvestigationInput;
  UpdateImpactGroupAssignmentByIdInput: UpdateImpactGroupAssignmentByIdInput;
  UpdateImpactGroupAssignmentInput: UpdateImpactGroupAssignmentInput;
  UpdateImpactGroupAssignmentPayload: Omit<UpdateImpactGroupAssignmentPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateImpactGroupTemplateByIdInput: UpdateImpactGroupTemplateByIdInput;
  UpdateImpactGroupTemplateByLabelAndScopeInput: UpdateImpactGroupTemplateByLabelAndScopeInput;
  UpdateImpactGroupTemplateBySlugInput: UpdateImpactGroupTemplateBySlugInput;
  UpdateImpactGroupTemplateInput: UpdateImpactGroupTemplateInput;
  UpdateImpactGroupTemplatePayload: Omit<UpdateImpactGroupTemplatePayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateKycPriorityLabelByIdInput: UpdateKycPriorityLabelByIdInput;
  UpdateKycPriorityLabelInput: UpdateKycPriorityLabelInput;
  UpdateKycPriorityLabelPayload: Omit<UpdateKycPriorityLabelPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateMyTraderPublicProfileInput: UpdateMyTraderPublicProfileInput;
  UpdateMyTraderPublicProfilePayload: UpdateMyTraderPublicProfilePayload;
  UpdateTraderPublicProfileByIdInput: UpdateTraderPublicProfileByIdInput;
  UpdateTraderPublicProfileInput: UpdateTraderPublicProfileInput;
  UpdateTraderPublicProfilePayload: Omit<UpdateTraderPublicProfilePayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateTraderRiskIndicatorByIdInput: UpdateTraderRiskIndicatorByIdInput;
  UpdateTraderRiskIndicatorInput: UpdateTraderRiskIndicatorInput;
  UpdateTraderRiskIndicatorPayload: Omit<UpdateTraderRiskIndicatorPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateTradingProductFeeByIdInput: UpdateTradingProductFeeByIdInput;
  UpdateTradingProductFeeInput: UpdateTradingProductFeeInput;
  UpdateTradingProductFeePayload: Omit<UpdateTradingProductFeePayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateUserAddressByIdInput: UpdateUserAddressByIdInput;
  UpdateUserAddressInput: UpdateUserAddressInput;
  UpdateUserAddressPayload: Omit<UpdateUserAddressPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateUserTaxFormByIdInput: UpdateUserTaxFormByIdInput;
  UpdateUserTaxFormInput: UpdateUserTaxFormInput;
  UpdateUserTaxFormPayload: Omit<UpdateUserTaxFormPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  UpdateXfaActivationCreditByIdInput: UpdateXfaActivationCreditByIdInput;
  UpdateXfaActivationCreditInput: UpdateXfaActivationCreditInput;
  UpdateXfaActivationCreditPayload: Omit<UpdateXfaActivationCreditPayload, 'query'> & { query?: Maybe<ResolversParentTypes['Query']> };
  User: User;
  UserAddon: UserAddon;
  UserAddress: UserAddress;
  UserAddressAggregates: UserAddressAggregates;
  UserAddressAggregatesFilter: UserAddressAggregatesFilter;
  UserAddressAverageAggregateFilter: UserAddressAverageAggregateFilter;
  UserAddressAverageAggregates: UserAddressAverageAggregates;
  UserAddressCondition: UserAddressCondition;
  UserAddressConnection: UserAddressConnection;
  UserAddressDistinctCountAggregateFilter: UserAddressDistinctCountAggregateFilter;
  UserAddressDistinctCountAggregates: UserAddressDistinctCountAggregates;
  UserAddressEdge: UserAddressEdge;
  UserAddressFilter: UserAddressFilter;
  UserAddressHavingAverageInput: UserAddressHavingAverageInput;
  UserAddressHavingDistinctCountInput: UserAddressHavingDistinctCountInput;
  UserAddressHavingInput: UserAddressHavingInput;
  UserAddressHavingMaxInput: UserAddressHavingMaxInput;
  UserAddressHavingMinInput: UserAddressHavingMinInput;
  UserAddressHavingStddevPopulationInput: UserAddressHavingStddevPopulationInput;
  UserAddressHavingStddevSampleInput: UserAddressHavingStddevSampleInput;
  UserAddressHavingSumInput: UserAddressHavingSumInput;
  UserAddressHavingVariancePopulationInput: UserAddressHavingVariancePopulationInput;
  UserAddressHavingVarianceSampleInput: UserAddressHavingVarianceSampleInput;
  UserAddressInput: UserAddressInput;
  UserAddressMaxAggregateFilter: UserAddressMaxAggregateFilter;
  UserAddressMaxAggregates: UserAddressMaxAggregates;
  UserAddressMinAggregateFilter: UserAddressMinAggregateFilter;
  UserAddressMinAggregates: UserAddressMinAggregates;
  UserAddressPatch: UserAddressPatch;
  UserAddressStddevPopulationAggregateFilter: UserAddressStddevPopulationAggregateFilter;
  UserAddressStddevPopulationAggregates: UserAddressStddevPopulationAggregates;
  UserAddressStddevSampleAggregateFilter: UserAddressStddevSampleAggregateFilter;
  UserAddressStddevSampleAggregates: UserAddressStddevSampleAggregates;
  UserAddressSumAggregateFilter: UserAddressSumAggregateFilter;
  UserAddressSumAggregates: UserAddressSumAggregates;
  UserAddressVariancePopulationAggregateFilter: UserAddressVariancePopulationAggregateFilter;
  UserAddressVariancePopulationAggregates: UserAddressVariancePopulationAggregates;
  UserAddressVarianceSampleAggregateFilter: UserAddressVarianceSampleAggregateFilter;
  UserAddressVarianceSampleAggregates: UserAddressVarianceSampleAggregates;
  UserAdminRole: UserAdminRole;
  UserAdminRoleAggregates: UserAdminRoleAggregates;
  UserAdminRoleAggregatesFilter: UserAdminRoleAggregatesFilter;
  UserAdminRoleAverageAggregateFilter: UserAdminRoleAverageAggregateFilter;
  UserAdminRoleAverageAggregates: UserAdminRoleAverageAggregates;
  UserAdminRoleCondition: UserAdminRoleCondition;
  UserAdminRoleConnection: UserAdminRoleConnection;
  UserAdminRoleDistinctCountAggregateFilter: UserAdminRoleDistinctCountAggregateFilter;
  UserAdminRoleDistinctCountAggregates: UserAdminRoleDistinctCountAggregates;
  UserAdminRoleEdge: UserAdminRoleEdge;
  UserAdminRoleFilter: UserAdminRoleFilter;
  UserAdminRoleHavingAverageInput: UserAdminRoleHavingAverageInput;
  UserAdminRoleHavingDistinctCountInput: UserAdminRoleHavingDistinctCountInput;
  UserAdminRoleHavingInput: UserAdminRoleHavingInput;
  UserAdminRoleHavingMaxInput: UserAdminRoleHavingMaxInput;
  UserAdminRoleHavingMinInput: UserAdminRoleHavingMinInput;
  UserAdminRoleHavingStddevPopulationInput: UserAdminRoleHavingStddevPopulationInput;
  UserAdminRoleHavingStddevSampleInput: UserAdminRoleHavingStddevSampleInput;
  UserAdminRoleHavingSumInput: UserAdminRoleHavingSumInput;
  UserAdminRoleHavingVariancePopulationInput: UserAdminRoleHavingVariancePopulationInput;
  UserAdminRoleHavingVarianceSampleInput: UserAdminRoleHavingVarianceSampleInput;
  UserAdminRoleMaxAggregateFilter: UserAdminRoleMaxAggregateFilter;
  UserAdminRoleMaxAggregates: UserAdminRoleMaxAggregates;
  UserAdminRoleMinAggregateFilter: UserAdminRoleMinAggregateFilter;
  UserAdminRoleMinAggregates: UserAdminRoleMinAggregates;
  UserAdminRoleStddevPopulationAggregateFilter: UserAdminRoleStddevPopulationAggregateFilter;
  UserAdminRoleStddevPopulationAggregates: UserAdminRoleStddevPopulationAggregates;
  UserAdminRoleStddevSampleAggregateFilter: UserAdminRoleStddevSampleAggregateFilter;
  UserAdminRoleStddevSampleAggregates: UserAdminRoleStddevSampleAggregates;
  UserAdminRoleSumAggregateFilter: UserAdminRoleSumAggregateFilter;
  UserAdminRoleSumAggregates: UserAdminRoleSumAggregates;
  UserAdminRoleVariancePopulationAggregateFilter: UserAdminRoleVariancePopulationAggregateFilter;
  UserAdminRoleVariancePopulationAggregates: UserAdminRoleVariancePopulationAggregates;
  UserAdminRoleVarianceSampleAggregateFilter: UserAdminRoleVarianceSampleAggregateFilter;
  UserAdminRoleVarianceSampleAggregates: UserAdminRoleVarianceSampleAggregates;
  UserAggregates: UserAggregates;
  UserAgreement: UserAgreement;
  UserAgreementAggregates: UserAgreementAggregates;
  UserAgreementAggregatesFilter: UserAgreementAggregatesFilter;
  UserAgreementAverageAggregateFilter: UserAgreementAverageAggregateFilter;
  UserAgreementAverageAggregates: UserAgreementAverageAggregates;
  UserAgreementCondition: UserAgreementCondition;
  UserAgreementConnection: UserAgreementConnection;
  UserAgreementDistinctCountAggregateFilter: UserAgreementDistinctCountAggregateFilter;
  UserAgreementDistinctCountAggregates: UserAgreementDistinctCountAggregates;
  UserAgreementEdge: UserAgreementEdge;
  UserAgreementFilter: UserAgreementFilter;
  UserAgreementHavingAverageInput: UserAgreementHavingAverageInput;
  UserAgreementHavingDistinctCountInput: UserAgreementHavingDistinctCountInput;
  UserAgreementHavingInput: UserAgreementHavingInput;
  UserAgreementHavingMaxInput: UserAgreementHavingMaxInput;
  UserAgreementHavingMinInput: UserAgreementHavingMinInput;
  UserAgreementHavingStddevPopulationInput: UserAgreementHavingStddevPopulationInput;
  UserAgreementHavingStddevSampleInput: UserAgreementHavingStddevSampleInput;
  UserAgreementHavingSumInput: UserAgreementHavingSumInput;
  UserAgreementHavingVariancePopulationInput: UserAgreementHavingVariancePopulationInput;
  UserAgreementHavingVarianceSampleInput: UserAgreementHavingVarianceSampleInput;
  UserAgreementMaxAggregateFilter: UserAgreementMaxAggregateFilter;
  UserAgreementMaxAggregates: UserAgreementMaxAggregates;
  UserAgreementMinAggregateFilter: UserAgreementMinAggregateFilter;
  UserAgreementMinAggregates: UserAgreementMinAggregates;
  UserAgreementStddevPopulationAggregateFilter: UserAgreementStddevPopulationAggregateFilter;
  UserAgreementStddevPopulationAggregates: UserAgreementStddevPopulationAggregates;
  UserAgreementStddevSampleAggregateFilter: UserAgreementStddevSampleAggregateFilter;
  UserAgreementStddevSampleAggregates: UserAgreementStddevSampleAggregates;
  UserAgreementSumAggregateFilter: UserAgreementSumAggregateFilter;
  UserAgreementSumAggregates: UserAgreementSumAggregates;
  UserAgreementVariancePopulationAggregateFilter: UserAgreementVariancePopulationAggregateFilter;
  UserAgreementVariancePopulationAggregates: UserAgreementVariancePopulationAggregates;
  UserAgreementVarianceSampleAggregateFilter: UserAgreementVarianceSampleAggregateFilter;
  UserAgreementVarianceSampleAggregates: UserAgreementVarianceSampleAggregates;
  UserAverageAggregates: UserAverageAggregates;
  UserBankingInfo: UserBankingInfo;
  UserCertificate: UserCertificate;
  UserCertificateAggregates: UserCertificateAggregates;
  UserCertificateAggregatesFilter: UserCertificateAggregatesFilter;
  UserCertificateAverageAggregateFilter: UserCertificateAverageAggregateFilter;
  UserCertificateAverageAggregates: UserCertificateAverageAggregates;
  UserCertificateCondition: UserCertificateCondition;
  UserCertificateConnection: UserCertificateConnection;
  UserCertificateDistinctCountAggregateFilter: UserCertificateDistinctCountAggregateFilter;
  UserCertificateDistinctCountAggregates: UserCertificateDistinctCountAggregates;
  UserCertificateEdge: UserCertificateEdge;
  UserCertificateFilter: UserCertificateFilter;
  UserCertificateHavingAverageInput: UserCertificateHavingAverageInput;
  UserCertificateHavingDistinctCountInput: UserCertificateHavingDistinctCountInput;
  UserCertificateHavingInput: UserCertificateHavingInput;
  UserCertificateHavingMaxInput: UserCertificateHavingMaxInput;
  UserCertificateHavingMinInput: UserCertificateHavingMinInput;
  UserCertificateHavingStddevPopulationInput: UserCertificateHavingStddevPopulationInput;
  UserCertificateHavingStddevSampleInput: UserCertificateHavingStddevSampleInput;
  UserCertificateHavingSumInput: UserCertificateHavingSumInput;
  UserCertificateHavingVariancePopulationInput: UserCertificateHavingVariancePopulationInput;
  UserCertificateHavingVarianceSampleInput: UserCertificateHavingVarianceSampleInput;
  UserCertificateMaxAggregateFilter: UserCertificateMaxAggregateFilter;
  UserCertificateMaxAggregates: UserCertificateMaxAggregates;
  UserCertificateMinAggregateFilter: UserCertificateMinAggregateFilter;
  UserCertificateMinAggregates: UserCertificateMinAggregates;
  UserCertificateStddevPopulationAggregateFilter: UserCertificateStddevPopulationAggregateFilter;
  UserCertificateStddevPopulationAggregates: UserCertificateStddevPopulationAggregates;
  UserCertificateStddevSampleAggregateFilter: UserCertificateStddevSampleAggregateFilter;
  UserCertificateStddevSampleAggregates: UserCertificateStddevSampleAggregates;
  UserCertificateSumAggregateFilter: UserCertificateSumAggregateFilter;
  UserCertificateSumAggregates: UserCertificateSumAggregates;
  UserCertificateVariancePopulationAggregateFilter: UserCertificateVariancePopulationAggregateFilter;
  UserCertificateVariancePopulationAggregates: UserCertificateVariancePopulationAggregates;
  UserCertificateVarianceSampleAggregateFilter: UserCertificateVarianceSampleAggregateFilter;
  UserCertificateVarianceSampleAggregates: UserCertificateVarianceSampleAggregates;
  UserCondition: UserCondition;
  UserConnection: UserConnection;
  UserContactInfo: UserContactInfo;
  UserContactInfoAggregates: UserContactInfoAggregates;
  UserContactInfoAverageAggregates: UserContactInfoAverageAggregates;
  UserContactInfoCondition: UserContactInfoCondition;
  UserContactInfoConnection: UserContactInfoConnection;
  UserContactInfoDistinctCountAggregates: UserContactInfoDistinctCountAggregates;
  UserContactInfoEdge: UserContactInfoEdge;
  UserContactInfoFilter: UserContactInfoFilter;
  UserContactInfoHavingAverageInput: UserContactInfoHavingAverageInput;
  UserContactInfoHavingDistinctCountInput: UserContactInfoHavingDistinctCountInput;
  UserContactInfoHavingInput: UserContactInfoHavingInput;
  UserContactInfoHavingMaxInput: UserContactInfoHavingMaxInput;
  UserContactInfoHavingMinInput: UserContactInfoHavingMinInput;
  UserContactInfoHavingStddevPopulationInput: UserContactInfoHavingStddevPopulationInput;
  UserContactInfoHavingStddevSampleInput: UserContactInfoHavingStddevSampleInput;
  UserContactInfoHavingSumInput: UserContactInfoHavingSumInput;
  UserContactInfoHavingVariancePopulationInput: UserContactInfoHavingVariancePopulationInput;
  UserContactInfoHavingVarianceSampleInput: UserContactInfoHavingVarianceSampleInput;
  UserContactInfoMaxAggregates: UserContactInfoMaxAggregates;
  UserContactInfoMinAggregates: UserContactInfoMinAggregates;
  UserContactInfoStddevPopulationAggregates: UserContactInfoStddevPopulationAggregates;
  UserContactInfoStddevSampleAggregates: UserContactInfoStddevSampleAggregates;
  UserContactInfoSumAggregates: UserContactInfoSumAggregates;
  UserContactInfoVariancePopulationAggregates: UserContactInfoVariancePopulationAggregates;
  UserContactInfoVarianceSampleAggregates: UserContactInfoVarianceSampleAggregates;
  UserCooldown: UserCooldown;
  UserCooldownAggregates: UserCooldownAggregates;
  UserCooldownAggregatesFilter: UserCooldownAggregatesFilter;
  UserCooldownAverageAggregateFilter: UserCooldownAverageAggregateFilter;
  UserCooldownAverageAggregates: UserCooldownAverageAggregates;
  UserCooldownCondition: UserCooldownCondition;
  UserCooldownConnection: UserCooldownConnection;
  UserCooldownDistinctCountAggregateFilter: UserCooldownDistinctCountAggregateFilter;
  UserCooldownDistinctCountAggregates: UserCooldownDistinctCountAggregates;
  UserCooldownEdge: UserCooldownEdge;
  UserCooldownFilter: UserCooldownFilter;
  UserCooldownHavingAverageInput: UserCooldownHavingAverageInput;
  UserCooldownHavingDistinctCountInput: UserCooldownHavingDistinctCountInput;
  UserCooldownHavingInput: UserCooldownHavingInput;
  UserCooldownHavingMaxInput: UserCooldownHavingMaxInput;
  UserCooldownHavingMinInput: UserCooldownHavingMinInput;
  UserCooldownHavingStddevPopulationInput: UserCooldownHavingStddevPopulationInput;
  UserCooldownHavingStddevSampleInput: UserCooldownHavingStddevSampleInput;
  UserCooldownHavingSumInput: UserCooldownHavingSumInput;
  UserCooldownHavingVariancePopulationInput: UserCooldownHavingVariancePopulationInput;
  UserCooldownHavingVarianceSampleInput: UserCooldownHavingVarianceSampleInput;
  UserCooldownMaxAggregateFilter: UserCooldownMaxAggregateFilter;
  UserCooldownMaxAggregates: UserCooldownMaxAggregates;
  UserCooldownMinAggregateFilter: UserCooldownMinAggregateFilter;
  UserCooldownMinAggregates: UserCooldownMinAggregates;
  UserCooldownStddevPopulationAggregateFilter: UserCooldownStddevPopulationAggregateFilter;
  UserCooldownStddevPopulationAggregates: UserCooldownStddevPopulationAggregates;
  UserCooldownStddevSampleAggregateFilter: UserCooldownStddevSampleAggregateFilter;
  UserCooldownStddevSampleAggregates: UserCooldownStddevSampleAggregates;
  UserCooldownSumAggregateFilter: UserCooldownSumAggregateFilter;
  UserCooldownSumAggregates: UserCooldownSumAggregates;
  UserCooldownVariancePopulationAggregateFilter: UserCooldownVariancePopulationAggregateFilter;
  UserCooldownVariancePopulationAggregates: UserCooldownVariancePopulationAggregates;
  UserCooldownVarianceSampleAggregateFilter: UserCooldownVarianceSampleAggregateFilter;
  UserCooldownVarianceSampleAggregates: UserCooldownVarianceSampleAggregates;
  UserDistinctCountAggregates: UserDistinctCountAggregates;
  UserEdge: UserEdge;
  UserFilter: UserFilter;
  UserHavingAverageInput: UserHavingAverageInput;
  UserHavingDistinctCountInput: UserHavingDistinctCountInput;
  UserHavingInput: UserHavingInput;
  UserHavingMaxInput: UserHavingMaxInput;
  UserHavingMinInput: UserHavingMinInput;
  UserHavingStddevPopulationInput: UserHavingStddevPopulationInput;
  UserHavingStddevSampleInput: UserHavingStddevSampleInput;
  UserHavingSumInput: UserHavingSumInput;
  UserHavingVariancePopulationInput: UserHavingVariancePopulationInput;
  UserHavingVarianceSampleInput: UserHavingVarianceSampleInput;
  UserIntegration: UserIntegration;
  UserIntegrationFilter: UserIntegrationFilter;
  UserMarketDatum: UserMarketDatum;
  UserMaxAggregates: UserMaxAggregates;
  UserMeteredEvent: UserMeteredEvent;
  UserMeteredEventAggregates: UserMeteredEventAggregates;
  UserMeteredEventAggregatesFilter: UserMeteredEventAggregatesFilter;
  UserMeteredEventAverageAggregateFilter: UserMeteredEventAverageAggregateFilter;
  UserMeteredEventAverageAggregates: UserMeteredEventAverageAggregates;
  UserMeteredEventCondition: UserMeteredEventCondition;
  UserMeteredEventConnection: UserMeteredEventConnection;
  UserMeteredEventDistinctCountAggregateFilter: UserMeteredEventDistinctCountAggregateFilter;
  UserMeteredEventDistinctCountAggregates: UserMeteredEventDistinctCountAggregates;
  UserMeteredEventEdge: UserMeteredEventEdge;
  UserMeteredEventFilter: UserMeteredEventFilter;
  UserMeteredEventHavingAverageInput: UserMeteredEventHavingAverageInput;
  UserMeteredEventHavingDistinctCountInput: UserMeteredEventHavingDistinctCountInput;
  UserMeteredEventHavingInput: UserMeteredEventHavingInput;
  UserMeteredEventHavingMaxInput: UserMeteredEventHavingMaxInput;
  UserMeteredEventHavingMinInput: UserMeteredEventHavingMinInput;
  UserMeteredEventHavingStddevPopulationInput: UserMeteredEventHavingStddevPopulationInput;
  UserMeteredEventHavingStddevSampleInput: UserMeteredEventHavingStddevSampleInput;
  UserMeteredEventHavingSumInput: UserMeteredEventHavingSumInput;
  UserMeteredEventHavingVariancePopulationInput: UserMeteredEventHavingVariancePopulationInput;
  UserMeteredEventHavingVarianceSampleInput: UserMeteredEventHavingVarianceSampleInput;
  UserMeteredEventMaxAggregateFilter: UserMeteredEventMaxAggregateFilter;
  UserMeteredEventMaxAggregates: UserMeteredEventMaxAggregates;
  UserMeteredEventMinAggregateFilter: UserMeteredEventMinAggregateFilter;
  UserMeteredEventMinAggregates: UserMeteredEventMinAggregates;
  UserMeteredEventStddevPopulationAggregateFilter: UserMeteredEventStddevPopulationAggregateFilter;
  UserMeteredEventStddevPopulationAggregates: UserMeteredEventStddevPopulationAggregates;
  UserMeteredEventStddevSampleAggregateFilter: UserMeteredEventStddevSampleAggregateFilter;
  UserMeteredEventStddevSampleAggregates: UserMeteredEventStddevSampleAggregates;
  UserMeteredEventSumAggregateFilter: UserMeteredEventSumAggregateFilter;
  UserMeteredEventSumAggregates: UserMeteredEventSumAggregates;
  UserMeteredEventVariancePopulationAggregateFilter: UserMeteredEventVariancePopulationAggregateFilter;
  UserMeteredEventVariancePopulationAggregates: UserMeteredEventVariancePopulationAggregates;
  UserMeteredEventVarianceSampleAggregateFilter: UserMeteredEventVarianceSampleAggregateFilter;
  UserMeteredEventVarianceSampleAggregates: UserMeteredEventVarianceSampleAggregates;
  UserMinAggregates: UserMinAggregates;
  UserNote: UserNote;
  UserNoteAggregates: UserNoteAggregates;
  UserNoteAggregatesFilter: UserNoteAggregatesFilter;
  UserNoteAverageAggregateFilter: UserNoteAverageAggregateFilter;
  UserNoteAverageAggregates: UserNoteAverageAggregates;
  UserNoteCondition: UserNoteCondition;
  UserNoteConnection: UserNoteConnection;
  UserNoteDistinctCountAggregateFilter: UserNoteDistinctCountAggregateFilter;
  UserNoteDistinctCountAggregates: UserNoteDistinctCountAggregates;
  UserNoteEdge: UserNoteEdge;
  UserNoteFilter: UserNoteFilter;
  UserNoteHavingAverageInput: UserNoteHavingAverageInput;
  UserNoteHavingDistinctCountInput: UserNoteHavingDistinctCountInput;
  UserNoteHavingInput: UserNoteHavingInput;
  UserNoteHavingMaxInput: UserNoteHavingMaxInput;
  UserNoteHavingMinInput: UserNoteHavingMinInput;
  UserNoteHavingStddevPopulationInput: UserNoteHavingStddevPopulationInput;
  UserNoteHavingStddevSampleInput: UserNoteHavingStddevSampleInput;
  UserNoteHavingSumInput: UserNoteHavingSumInput;
  UserNoteHavingVariancePopulationInput: UserNoteHavingVariancePopulationInput;
  UserNoteHavingVarianceSampleInput: UserNoteHavingVarianceSampleInput;
  UserNoteMaxAggregateFilter: UserNoteMaxAggregateFilter;
  UserNoteMaxAggregates: UserNoteMaxAggregates;
  UserNoteMinAggregateFilter: UserNoteMinAggregateFilter;
  UserNoteMinAggregates: UserNoteMinAggregates;
  UserNoteStddevPopulationAggregateFilter: UserNoteStddevPopulationAggregateFilter;
  UserNoteStddevPopulationAggregates: UserNoteStddevPopulationAggregates;
  UserNoteStddevSampleAggregateFilter: UserNoteStddevSampleAggregateFilter;
  UserNoteStddevSampleAggregates: UserNoteStddevSampleAggregates;
  UserNoteSumAggregateFilter: UserNoteSumAggregateFilter;
  UserNoteSumAggregates: UserNoteSumAggregates;
  UserNoteVariancePopulationAggregateFilter: UserNoteVariancePopulationAggregateFilter;
  UserNoteVariancePopulationAggregates: UserNoteVariancePopulationAggregates;
  UserNoteVarianceSampleAggregateFilter: UserNoteVarianceSampleAggregateFilter;
  UserNoteVarianceSampleAggregates: UserNoteVarianceSampleAggregates;
  UserPlatformCredential: UserPlatformCredential;
  UserPlatformCredentialAggregates: UserPlatformCredentialAggregates;
  UserPlatformCredentialAggregatesFilter: UserPlatformCredentialAggregatesFilter;
  UserPlatformCredentialAverageAggregateFilter: UserPlatformCredentialAverageAggregateFilter;
  UserPlatformCredentialAverageAggregates: UserPlatformCredentialAverageAggregates;
  UserPlatformCredentialCondition: UserPlatformCredentialCondition;
  UserPlatformCredentialConnection: UserPlatformCredentialConnection;
  UserPlatformCredentialDistinctCountAggregateFilter: UserPlatformCredentialDistinctCountAggregateFilter;
  UserPlatformCredentialDistinctCountAggregates: UserPlatformCredentialDistinctCountAggregates;
  UserPlatformCredentialEdge: UserPlatformCredentialEdge;
  UserPlatformCredentialFilter: UserPlatformCredentialFilter;
  UserPlatformCredentialHavingAverageInput: UserPlatformCredentialHavingAverageInput;
  UserPlatformCredentialHavingDistinctCountInput: UserPlatformCredentialHavingDistinctCountInput;
  UserPlatformCredentialHavingInput: UserPlatformCredentialHavingInput;
  UserPlatformCredentialHavingMaxInput: UserPlatformCredentialHavingMaxInput;
  UserPlatformCredentialHavingMinInput: UserPlatformCredentialHavingMinInput;
  UserPlatformCredentialHavingStddevPopulationInput: UserPlatformCredentialHavingStddevPopulationInput;
  UserPlatformCredentialHavingStddevSampleInput: UserPlatformCredentialHavingStddevSampleInput;
  UserPlatformCredentialHavingSumInput: UserPlatformCredentialHavingSumInput;
  UserPlatformCredentialHavingVariancePopulationInput: UserPlatformCredentialHavingVariancePopulationInput;
  UserPlatformCredentialHavingVarianceSampleInput: UserPlatformCredentialHavingVarianceSampleInput;
  UserPlatformCredentialMaxAggregateFilter: UserPlatformCredentialMaxAggregateFilter;
  UserPlatformCredentialMaxAggregates: UserPlatformCredentialMaxAggregates;
  UserPlatformCredentialMinAggregateFilter: UserPlatformCredentialMinAggregateFilter;
  UserPlatformCredentialMinAggregates: UserPlatformCredentialMinAggregates;
  UserPlatformCredentialStddevPopulationAggregateFilter: UserPlatformCredentialStddevPopulationAggregateFilter;
  UserPlatformCredentialStddevPopulationAggregates: UserPlatformCredentialStddevPopulationAggregates;
  UserPlatformCredentialStddevSampleAggregateFilter: UserPlatformCredentialStddevSampleAggregateFilter;
  UserPlatformCredentialStddevSampleAggregates: UserPlatformCredentialStddevSampleAggregates;
  UserPlatformCredentialSumAggregateFilter: UserPlatformCredentialSumAggregateFilter;
  UserPlatformCredentialSumAggregates: UserPlatformCredentialSumAggregates;
  UserPlatformCredentialVariancePopulationAggregateFilter: UserPlatformCredentialVariancePopulationAggregateFilter;
  UserPlatformCredentialVariancePopulationAggregates: UserPlatformCredentialVariancePopulationAggregates;
  UserPlatformCredentialVarianceSampleAggregateFilter: UserPlatformCredentialVarianceSampleAggregateFilter;
  UserPlatformCredentialVarianceSampleAggregates: UserPlatformCredentialVarianceSampleAggregates;
  UserRolesAdminRole: UserRolesAdminRole;
  UserRolesAdminRoleAggregates: UserRolesAdminRoleAggregates;
  UserRolesAdminRoleAggregatesFilter: UserRolesAdminRoleAggregatesFilter;
  UserRolesAdminRoleAverageAggregateFilter: UserRolesAdminRoleAverageAggregateFilter;
  UserRolesAdminRoleAverageAggregates: UserRolesAdminRoleAverageAggregates;
  UserRolesAdminRoleCondition: UserRolesAdminRoleCondition;
  UserRolesAdminRoleConnection: UserRolesAdminRoleConnection;
  UserRolesAdminRoleDistinctCountAggregateFilter: UserRolesAdminRoleDistinctCountAggregateFilter;
  UserRolesAdminRoleDistinctCountAggregates: UserRolesAdminRoleDistinctCountAggregates;
  UserRolesAdminRoleEdge: UserRolesAdminRoleEdge;
  UserRolesAdminRoleFilter: UserRolesAdminRoleFilter;
  UserRolesAdminRoleHavingAverageInput: UserRolesAdminRoleHavingAverageInput;
  UserRolesAdminRoleHavingDistinctCountInput: UserRolesAdminRoleHavingDistinctCountInput;
  UserRolesAdminRoleHavingInput: UserRolesAdminRoleHavingInput;
  UserRolesAdminRoleHavingMaxInput: UserRolesAdminRoleHavingMaxInput;
  UserRolesAdminRoleHavingMinInput: UserRolesAdminRoleHavingMinInput;
  UserRolesAdminRoleHavingStddevPopulationInput: UserRolesAdminRoleHavingStddevPopulationInput;
  UserRolesAdminRoleHavingStddevSampleInput: UserRolesAdminRoleHavingStddevSampleInput;
  UserRolesAdminRoleHavingSumInput: UserRolesAdminRoleHavingSumInput;
  UserRolesAdminRoleHavingVariancePopulationInput: UserRolesAdminRoleHavingVariancePopulationInput;
  UserRolesAdminRoleHavingVarianceSampleInput: UserRolesAdminRoleHavingVarianceSampleInput;
  UserRolesAdminRoleMaxAggregateFilter: UserRolesAdminRoleMaxAggregateFilter;
  UserRolesAdminRoleMaxAggregates: UserRolesAdminRoleMaxAggregates;
  UserRolesAdminRoleMinAggregateFilter: UserRolesAdminRoleMinAggregateFilter;
  UserRolesAdminRoleMinAggregates: UserRolesAdminRoleMinAggregates;
  UserRolesAdminRoleStddevPopulationAggregateFilter: UserRolesAdminRoleStddevPopulationAggregateFilter;
  UserRolesAdminRoleStddevPopulationAggregates: UserRolesAdminRoleStddevPopulationAggregates;
  UserRolesAdminRoleStddevSampleAggregateFilter: UserRolesAdminRoleStddevSampleAggregateFilter;
  UserRolesAdminRoleStddevSampleAggregates: UserRolesAdminRoleStddevSampleAggregates;
  UserRolesAdminRoleSumAggregateFilter: UserRolesAdminRoleSumAggregateFilter;
  UserRolesAdminRoleSumAggregates: UserRolesAdminRoleSumAggregates;
  UserRolesAdminRoleVariancePopulationAggregateFilter: UserRolesAdminRoleVariancePopulationAggregateFilter;
  UserRolesAdminRoleVariancePopulationAggregates: UserRolesAdminRoleVariancePopulationAggregates;
  UserRolesAdminRoleVarianceSampleAggregateFilter: UserRolesAdminRoleVarianceSampleAggregateFilter;
  UserRolesAdminRoleVarianceSampleAggregates: UserRolesAdminRoleVarianceSampleAggregates;
  UserStddevPopulationAggregates: UserStddevPopulationAggregates;
  UserStddevSampleAggregates: UserStddevSampleAggregates;
  UserSubscription: UserSubscription;
  UserSubscriptionAggregates: UserSubscriptionAggregates;
  UserSubscriptionAggregatesFilter: UserSubscriptionAggregatesFilter;
  UserSubscriptionAverageAggregateFilter: UserSubscriptionAverageAggregateFilter;
  UserSubscriptionAverageAggregates: UserSubscriptionAverageAggregates;
  UserSubscriptionCondition: UserSubscriptionCondition;
  UserSubscriptionConnection: UserSubscriptionConnection;
  UserSubscriptionDistinctCountAggregateFilter: UserSubscriptionDistinctCountAggregateFilter;
  UserSubscriptionDistinctCountAggregates: UserSubscriptionDistinctCountAggregates;
  UserSubscriptionEdge: UserSubscriptionEdge;
  UserSubscriptionFilter: UserSubscriptionFilter;
  UserSubscriptionHavingAverageInput: UserSubscriptionHavingAverageInput;
  UserSubscriptionHavingDistinctCountInput: UserSubscriptionHavingDistinctCountInput;
  UserSubscriptionHavingInput: UserSubscriptionHavingInput;
  UserSubscriptionHavingMaxInput: UserSubscriptionHavingMaxInput;
  UserSubscriptionHavingMinInput: UserSubscriptionHavingMinInput;
  UserSubscriptionHavingStddevPopulationInput: UserSubscriptionHavingStddevPopulationInput;
  UserSubscriptionHavingStddevSampleInput: UserSubscriptionHavingStddevSampleInput;
  UserSubscriptionHavingSumInput: UserSubscriptionHavingSumInput;
  UserSubscriptionHavingVariancePopulationInput: UserSubscriptionHavingVariancePopulationInput;
  UserSubscriptionHavingVarianceSampleInput: UserSubscriptionHavingVarianceSampleInput;
  UserSubscriptionMaxAggregateFilter: UserSubscriptionMaxAggregateFilter;
  UserSubscriptionMaxAggregates: UserSubscriptionMaxAggregates;
  UserSubscriptionMinAggregateFilter: UserSubscriptionMinAggregateFilter;
  UserSubscriptionMinAggregates: UserSubscriptionMinAggregates;
  UserSubscriptionStddevPopulationAggregateFilter: UserSubscriptionStddevPopulationAggregateFilter;
  UserSubscriptionStddevPopulationAggregates: UserSubscriptionStddevPopulationAggregates;
  UserSubscriptionStddevSampleAggregateFilter: UserSubscriptionStddevSampleAggregateFilter;
  UserSubscriptionStddevSampleAggregates: UserSubscriptionStddevSampleAggregates;
  UserSubscriptionSumAggregateFilter: UserSubscriptionSumAggregateFilter;
  UserSubscriptionSumAggregates: UserSubscriptionSumAggregates;
  UserSubscriptionToManyAccountFilter: UserSubscriptionToManyAccountFilter;
  UserSubscriptionToManyNmiSubscriptionFilter: UserSubscriptionToManyNmiSubscriptionFilter;
  UserSubscriptionVariancePopulationAggregateFilter: UserSubscriptionVariancePopulationAggregateFilter;
  UserSubscriptionVariancePopulationAggregates: UserSubscriptionVariancePopulationAggregates;
  UserSubscriptionVarianceSampleAggregateFilter: UserSubscriptionVarianceSampleAggregateFilter;
  UserSubscriptionVarianceSampleAggregates: UserSubscriptionVarianceSampleAggregates;
  UserSumAggregates: UserSumAggregates;
  UserTaxForm: UserTaxForm;
  UserTaxFormAggregates: UserTaxFormAggregates;
  UserTaxFormAggregatesFilter: UserTaxFormAggregatesFilter;
  UserTaxFormAverageAggregateFilter: UserTaxFormAverageAggregateFilter;
  UserTaxFormAverageAggregates: UserTaxFormAverageAggregates;
  UserTaxFormCondition: UserTaxFormCondition;
  UserTaxFormConnection: UserTaxFormConnection;
  UserTaxFormDistinctCountAggregateFilter: UserTaxFormDistinctCountAggregateFilter;
  UserTaxFormDistinctCountAggregates: UserTaxFormDistinctCountAggregates;
  UserTaxFormEdge: UserTaxFormEdge;
  UserTaxFormFilter: UserTaxFormFilter;
  UserTaxFormHavingAverageInput: UserTaxFormHavingAverageInput;
  UserTaxFormHavingDistinctCountInput: UserTaxFormHavingDistinctCountInput;
  UserTaxFormHavingInput: UserTaxFormHavingInput;
  UserTaxFormHavingMaxInput: UserTaxFormHavingMaxInput;
  UserTaxFormHavingMinInput: UserTaxFormHavingMinInput;
  UserTaxFormHavingStddevPopulationInput: UserTaxFormHavingStddevPopulationInput;
  UserTaxFormHavingStddevSampleInput: UserTaxFormHavingStddevSampleInput;
  UserTaxFormHavingSumInput: UserTaxFormHavingSumInput;
  UserTaxFormHavingVariancePopulationInput: UserTaxFormHavingVariancePopulationInput;
  UserTaxFormHavingVarianceSampleInput: UserTaxFormHavingVarianceSampleInput;
  UserTaxFormInput: UserTaxFormInput;
  UserTaxFormMaxAggregateFilter: UserTaxFormMaxAggregateFilter;
  UserTaxFormMaxAggregates: UserTaxFormMaxAggregates;
  UserTaxFormMinAggregateFilter: UserTaxFormMinAggregateFilter;
  UserTaxFormMinAggregates: UserTaxFormMinAggregates;
  UserTaxFormPatch: UserTaxFormPatch;
  UserTaxFormStddevPopulationAggregateFilter: UserTaxFormStddevPopulationAggregateFilter;
  UserTaxFormStddevPopulationAggregates: UserTaxFormStddevPopulationAggregates;
  UserTaxFormStddevSampleAggregateFilter: UserTaxFormStddevSampleAggregateFilter;
  UserTaxFormStddevSampleAggregates: UserTaxFormStddevSampleAggregates;
  UserTaxFormSumAggregateFilter: UserTaxFormSumAggregateFilter;
  UserTaxFormSumAggregates: UserTaxFormSumAggregates;
  UserTaxFormVariancePopulationAggregateFilter: UserTaxFormVariancePopulationAggregateFilter;
  UserTaxFormVariancePopulationAggregates: UserTaxFormVariancePopulationAggregates;
  UserTaxFormVarianceSampleAggregateFilter: UserTaxFormVarianceSampleAggregateFilter;
  UserTaxFormVarianceSampleAggregates: UserTaxFormVarianceSampleAggregates;
  UserTcPurchaseLimit: UserTcPurchaseLimit;
  UserTcPurchaseLimitAggregates: UserTcPurchaseLimitAggregates;
  UserTcPurchaseLimitAggregatesFilter: UserTcPurchaseLimitAggregatesFilter;
  UserTcPurchaseLimitAverageAggregateFilter: UserTcPurchaseLimitAverageAggregateFilter;
  UserTcPurchaseLimitAverageAggregates: UserTcPurchaseLimitAverageAggregates;
  UserTcPurchaseLimitCondition: UserTcPurchaseLimitCondition;
  UserTcPurchaseLimitConnection: UserTcPurchaseLimitConnection;
  UserTcPurchaseLimitDistinctCountAggregateFilter: UserTcPurchaseLimitDistinctCountAggregateFilter;
  UserTcPurchaseLimitDistinctCountAggregates: UserTcPurchaseLimitDistinctCountAggregates;
  UserTcPurchaseLimitEdge: UserTcPurchaseLimitEdge;
  UserTcPurchaseLimitFilter: UserTcPurchaseLimitFilter;
  UserTcPurchaseLimitHavingAverageInput: UserTcPurchaseLimitHavingAverageInput;
  UserTcPurchaseLimitHavingDistinctCountInput: UserTcPurchaseLimitHavingDistinctCountInput;
  UserTcPurchaseLimitHavingInput: UserTcPurchaseLimitHavingInput;
  UserTcPurchaseLimitHavingMaxInput: UserTcPurchaseLimitHavingMaxInput;
  UserTcPurchaseLimitHavingMinInput: UserTcPurchaseLimitHavingMinInput;
  UserTcPurchaseLimitHavingStddevPopulationInput: UserTcPurchaseLimitHavingStddevPopulationInput;
  UserTcPurchaseLimitHavingStddevSampleInput: UserTcPurchaseLimitHavingStddevSampleInput;
  UserTcPurchaseLimitHavingSumInput: UserTcPurchaseLimitHavingSumInput;
  UserTcPurchaseLimitHavingVariancePopulationInput: UserTcPurchaseLimitHavingVariancePopulationInput;
  UserTcPurchaseLimitHavingVarianceSampleInput: UserTcPurchaseLimitHavingVarianceSampleInput;
  UserTcPurchaseLimitMaxAggregateFilter: UserTcPurchaseLimitMaxAggregateFilter;
  UserTcPurchaseLimitMaxAggregates: UserTcPurchaseLimitMaxAggregates;
  UserTcPurchaseLimitMinAggregateFilter: UserTcPurchaseLimitMinAggregateFilter;
  UserTcPurchaseLimitMinAggregates: UserTcPurchaseLimitMinAggregates;
  UserTcPurchaseLimitStddevPopulationAggregateFilter: UserTcPurchaseLimitStddevPopulationAggregateFilter;
  UserTcPurchaseLimitStddevPopulationAggregates: UserTcPurchaseLimitStddevPopulationAggregates;
  UserTcPurchaseLimitStddevSampleAggregateFilter: UserTcPurchaseLimitStddevSampleAggregateFilter;
  UserTcPurchaseLimitStddevSampleAggregates: UserTcPurchaseLimitStddevSampleAggregates;
  UserTcPurchaseLimitSumAggregateFilter: UserTcPurchaseLimitSumAggregateFilter;
  UserTcPurchaseLimitSumAggregates: UserTcPurchaseLimitSumAggregates;
  UserTcPurchaseLimitVariancePopulationAggregateFilter: UserTcPurchaseLimitVariancePopulationAggregateFilter;
  UserTcPurchaseLimitVariancePopulationAggregates: UserTcPurchaseLimitVariancePopulationAggregates;
  UserTcPurchaseLimitVarianceSampleAggregateFilter: UserTcPurchaseLimitVarianceSampleAggregateFilter;
  UserTcPurchaseLimitVarianceSampleAggregates: UserTcPurchaseLimitVarianceSampleAggregates;
  UserToManyAccountCallUpDecisionCalculationFilter: UserToManyAccountCallUpDecisionCalculationFilter;
  UserToManyAccountCallUpDecisionFilter: UserToManyAccountCallUpDecisionFilter;
  UserToManyAccountCapitalEntryFilter: UserToManyAccountCapitalEntryFilter;
  UserToManyAccountFilter: UserToManyAccountFilter;
  UserToManyAccountResetLimitFilter: UserToManyAccountResetLimitFilter;
  UserToManyAccountResetTrackingFilter: UserToManyAccountResetTrackingFilter;
  UserToManyAdminRoleUsersUserFilter: UserToManyAdminRoleUsersUserFilter;
  UserToManyCardTransactionFilter: UserToManyCardTransactionFilter;
  UserToManyCheckoutSessionFilter: UserToManyCheckoutSessionFilter;
  UserToManyCouponUserFilter: UserToManyCouponUserFilter;
  UserToManyEmailFilter: UserToManyEmailFilter;
  UserToManyGroupAdminFilter: UserToManyGroupAdminFilter;
  UserToManyImpactGroupAssignmentFilter: UserToManyImpactGroupAssignmentFilter;
  UserToManyNuveiSavedCardFilter: UserToManyNuveiSavedCardFilter;
  UserToManyPasswordHistoryFilter: UserToManyPasswordHistoryFilter;
  UserToManyPayoutRequestBatchFilter: UserToManyPayoutRequestBatchFilter;
  UserToManyPayoutRequestFilter: UserToManyPayoutRequestFilter;
  UserToManyPayoutRequestSubscriberFilter: UserToManyPayoutRequestSubscriberFilter;
  UserToManyPersonaWebhookEventFilter: UserToManyPersonaWebhookEventFilter;
  UserToManyPurchaseOrderFilter: UserToManyPurchaseOrderFilter;
  UserToManyRebillSessionFilter: UserToManyRebillSessionFilter;
  UserToManyResetCreditFilter: UserToManyResetCreditFilter;
  UserToManySavedCardFilter: UserToManySavedCardFilter;
  UserToManyTaxInfoFilter: UserToManyTaxInfoFilter;
  UserToManyTraderProfileModerationCaseFilter: UserToManyTraderProfileModerationCaseFilter;
  UserToManyTraderRiskIndicatorFilter: UserToManyTraderRiskIndicatorFilter;
  UserToManyUserAddressFilter: UserToManyUserAddressFilter;
  UserToManyUserAdminRoleFilter: UserToManyUserAdminRoleFilter;
  UserToManyUserAgreementFilter: UserToManyUserAgreementFilter;
  UserToManyUserCertificateFilter: UserToManyUserCertificateFilter;
  UserToManyUserCooldownFilter: UserToManyUserCooldownFilter;
  UserToManyUserMeteredEventFilter: UserToManyUserMeteredEventFilter;
  UserToManyUserNoteFilter: UserToManyUserNoteFilter;
  UserToManyUserPlatformCredentialFilter: UserToManyUserPlatformCredentialFilter;
  UserToManyUserRolesAdminRoleFilter: UserToManyUserRolesAdminRoleFilter;
  UserToManyUserTaxFormFilter: UserToManyUserTaxFormFilter;
  UserToManyUserTcPurchaseLimitFilter: UserToManyUserTcPurchaseLimitFilter;
  UserToManyUserXfaCooldownFilter: UserToManyUserXfaCooldownFilter;
  UserToManyVerificationFilter: UserToManyVerificationFilter;
  UserVariancePopulationAggregates: UserVariancePopulationAggregates;
  UserVarianceSampleAggregates: UserVarianceSampleAggregates;
  UserXfaCooldown: UserXfaCooldown;
  UserXfaCooldownAggregates: UserXfaCooldownAggregates;
  UserXfaCooldownAggregatesFilter: UserXfaCooldownAggregatesFilter;
  UserXfaCooldownAverageAggregateFilter: UserXfaCooldownAverageAggregateFilter;
  UserXfaCooldownAverageAggregates: UserXfaCooldownAverageAggregates;
  UserXfaCooldownCondition: UserXfaCooldownCondition;
  UserXfaCooldownConnection: UserXfaCooldownConnection;
  UserXfaCooldownDistinctCountAggregateFilter: UserXfaCooldownDistinctCountAggregateFilter;
  UserXfaCooldownDistinctCountAggregates: UserXfaCooldownDistinctCountAggregates;
  UserXfaCooldownEdge: UserXfaCooldownEdge;
  UserXfaCooldownFilter: UserXfaCooldownFilter;
  UserXfaCooldownHavingAverageInput: UserXfaCooldownHavingAverageInput;
  UserXfaCooldownHavingDistinctCountInput: UserXfaCooldownHavingDistinctCountInput;
  UserXfaCooldownHavingInput: UserXfaCooldownHavingInput;
  UserXfaCooldownHavingMaxInput: UserXfaCooldownHavingMaxInput;
  UserXfaCooldownHavingMinInput: UserXfaCooldownHavingMinInput;
  UserXfaCooldownHavingStddevPopulationInput: UserXfaCooldownHavingStddevPopulationInput;
  UserXfaCooldownHavingStddevSampleInput: UserXfaCooldownHavingStddevSampleInput;
  UserXfaCooldownHavingSumInput: UserXfaCooldownHavingSumInput;
  UserXfaCooldownHavingVariancePopulationInput: UserXfaCooldownHavingVariancePopulationInput;
  UserXfaCooldownHavingVarianceSampleInput: UserXfaCooldownHavingVarianceSampleInput;
  UserXfaCooldownMaxAggregateFilter: UserXfaCooldownMaxAggregateFilter;
  UserXfaCooldownMaxAggregates: UserXfaCooldownMaxAggregates;
  UserXfaCooldownMinAggregateFilter: UserXfaCooldownMinAggregateFilter;
  UserXfaCooldownMinAggregates: UserXfaCooldownMinAggregates;
  UserXfaCooldownStddevPopulationAggregateFilter: UserXfaCooldownStddevPopulationAggregateFilter;
  UserXfaCooldownStddevPopulationAggregates: UserXfaCooldownStddevPopulationAggregates;
  UserXfaCooldownStddevSampleAggregateFilter: UserXfaCooldownStddevSampleAggregateFilter;
  UserXfaCooldownStddevSampleAggregates: UserXfaCooldownStddevSampleAggregates;
  UserXfaCooldownSumAggregateFilter: UserXfaCooldownSumAggregateFilter;
  UserXfaCooldownSumAggregates: UserXfaCooldownSumAggregates;
  UserXfaCooldownVariancePopulationAggregateFilter: UserXfaCooldownVariancePopulationAggregateFilter;
  UserXfaCooldownVariancePopulationAggregates: UserXfaCooldownVariancePopulationAggregates;
  UserXfaCooldownVarianceSampleAggregateFilter: UserXfaCooldownVarianceSampleAggregateFilter;
  UserXfaCooldownVarianceSampleAggregates: UserXfaCooldownVarianceSampleAggregates;
  Verification: Verification;
  VerificationAggregates: VerificationAggregates;
  VerificationAggregatesFilter: VerificationAggregatesFilter;
  VerificationAverageAggregateFilter: VerificationAverageAggregateFilter;
  VerificationAverageAggregates: VerificationAverageAggregates;
  VerificationCondition: VerificationCondition;
  VerificationConnection: VerificationConnection;
  VerificationDistinctCountAggregateFilter: VerificationDistinctCountAggregateFilter;
  VerificationDistinctCountAggregates: VerificationDistinctCountAggregates;
  VerificationEdge: VerificationEdge;
  VerificationFilter: VerificationFilter;
  VerificationHavingAverageInput: VerificationHavingAverageInput;
  VerificationHavingDistinctCountInput: VerificationHavingDistinctCountInput;
  VerificationHavingInput: VerificationHavingInput;
  VerificationHavingMaxInput: VerificationHavingMaxInput;
  VerificationHavingMinInput: VerificationHavingMinInput;
  VerificationHavingStddevPopulationInput: VerificationHavingStddevPopulationInput;
  VerificationHavingStddevSampleInput: VerificationHavingStddevSampleInput;
  VerificationHavingSumInput: VerificationHavingSumInput;
  VerificationHavingVariancePopulationInput: VerificationHavingVariancePopulationInput;
  VerificationHavingVarianceSampleInput: VerificationHavingVarianceSampleInput;
  VerificationMaxAggregateFilter: VerificationMaxAggregateFilter;
  VerificationMaxAggregates: VerificationMaxAggregates;
  VerificationMinAggregateFilter: VerificationMinAggregateFilter;
  VerificationMinAggregates: VerificationMinAggregates;
  VerificationStddevPopulationAggregateFilter: VerificationStddevPopulationAggregateFilter;
  VerificationStddevPopulationAggregates: VerificationStddevPopulationAggregates;
  VerificationStddevSampleAggregateFilter: VerificationStddevSampleAggregateFilter;
  VerificationStddevSampleAggregates: VerificationStddevSampleAggregates;
  VerificationSumAggregateFilter: VerificationSumAggregateFilter;
  VerificationSumAggregates: VerificationSumAggregates;
  VerificationVariancePopulationAggregateFilter: VerificationVariancePopulationAggregateFilter;
  VerificationVariancePopulationAggregates: VerificationVariancePopulationAggregates;
  VerificationVarianceSampleAggregateFilter: VerificationVarianceSampleAggregateFilter;
  VerificationVarianceSampleAggregates: VerificationVarianceSampleAggregates;
  VoidAccountCapitalEntryInput: VoidAccountCapitalEntryInput;
  W8BENSigningResult: W8BenSigningResult;
  W9SigningResult: W9SigningResult;
  WorstTradingDay: WorstTradingDay;
  XfaActivationCredit: XfaActivationCredit;
  XfaActivationCreditAggregates: XfaActivationCreditAggregates;
  XfaActivationCreditAverageAggregates: XfaActivationCreditAverageAggregates;
  XfaActivationCreditCondition: XfaActivationCreditCondition;
  XfaActivationCreditConnection: XfaActivationCreditConnection;
  XfaActivationCreditDistinctCountAggregates: XfaActivationCreditDistinctCountAggregates;
  XfaActivationCreditEdge: XfaActivationCreditEdge;
  XfaActivationCreditFilter: XfaActivationCreditFilter;
  XfaActivationCreditHavingAverageInput: XfaActivationCreditHavingAverageInput;
  XfaActivationCreditHavingDistinctCountInput: XfaActivationCreditHavingDistinctCountInput;
  XfaActivationCreditHavingInput: XfaActivationCreditHavingInput;
  XfaActivationCreditHavingMaxInput: XfaActivationCreditHavingMaxInput;
  XfaActivationCreditHavingMinInput: XfaActivationCreditHavingMinInput;
  XfaActivationCreditHavingStddevPopulationInput: XfaActivationCreditHavingStddevPopulationInput;
  XfaActivationCreditHavingStddevSampleInput: XfaActivationCreditHavingStddevSampleInput;
  XfaActivationCreditHavingSumInput: XfaActivationCreditHavingSumInput;
  XfaActivationCreditHavingVariancePopulationInput: XfaActivationCreditHavingVariancePopulationInput;
  XfaActivationCreditHavingVarianceSampleInput: XfaActivationCreditHavingVarianceSampleInput;
  XfaActivationCreditInput: XfaActivationCreditInput;
  XfaActivationCreditMaxAggregates: XfaActivationCreditMaxAggregates;
  XfaActivationCreditMinAggregates: XfaActivationCreditMinAggregates;
  XfaActivationCreditPatch: XfaActivationCreditPatch;
  XfaActivationCreditStatusEnumFilter: XfaActivationCreditStatusEnumFilter;
  XfaActivationCreditStddevPopulationAggregates: XfaActivationCreditStddevPopulationAggregates;
  XfaActivationCreditStddevSampleAggregates: XfaActivationCreditStddevSampleAggregates;
  XfaActivationCreditSumAggregates: XfaActivationCreditSumAggregates;
  XfaActivationCreditVariancePopulationAggregates: XfaActivationCreditVariancePopulationAggregates;
  XfaActivationCreditVarianceSampleAggregates: XfaActivationCreditVarianceSampleAggregates;
  XfaConsistencyMetrics: XfaConsistencyMetrics;
  XfaResetTracking: XfaResetTracking;
  XfaResetTrackingAggregates: XfaResetTrackingAggregates;
  XfaResetTrackingAggregatesFilter: XfaResetTrackingAggregatesFilter;
  XfaResetTrackingAverageAggregateFilter: XfaResetTrackingAverageAggregateFilter;
  XfaResetTrackingAverageAggregates: XfaResetTrackingAverageAggregates;
  XfaResetTrackingCondition: XfaResetTrackingCondition;
  XfaResetTrackingConnection: XfaResetTrackingConnection;
  XfaResetTrackingDistinctCountAggregateFilter: XfaResetTrackingDistinctCountAggregateFilter;
  XfaResetTrackingDistinctCountAggregates: XfaResetTrackingDistinctCountAggregates;
  XfaResetTrackingEdge: XfaResetTrackingEdge;
  XfaResetTrackingFilter: XfaResetTrackingFilter;
  XfaResetTrackingHavingAverageInput: XfaResetTrackingHavingAverageInput;
  XfaResetTrackingHavingDistinctCountInput: XfaResetTrackingHavingDistinctCountInput;
  XfaResetTrackingHavingInput: XfaResetTrackingHavingInput;
  XfaResetTrackingHavingMaxInput: XfaResetTrackingHavingMaxInput;
  XfaResetTrackingHavingMinInput: XfaResetTrackingHavingMinInput;
  XfaResetTrackingHavingStddevPopulationInput: XfaResetTrackingHavingStddevPopulationInput;
  XfaResetTrackingHavingStddevSampleInput: XfaResetTrackingHavingStddevSampleInput;
  XfaResetTrackingHavingSumInput: XfaResetTrackingHavingSumInput;
  XfaResetTrackingHavingVariancePopulationInput: XfaResetTrackingHavingVariancePopulationInput;
  XfaResetTrackingHavingVarianceSampleInput: XfaResetTrackingHavingVarianceSampleInput;
  XfaResetTrackingMaxAggregateFilter: XfaResetTrackingMaxAggregateFilter;
  XfaResetTrackingMaxAggregates: XfaResetTrackingMaxAggregates;
  XfaResetTrackingMinAggregateFilter: XfaResetTrackingMinAggregateFilter;
  XfaResetTrackingMinAggregates: XfaResetTrackingMinAggregates;
  XfaResetTrackingStddevPopulationAggregateFilter: XfaResetTrackingStddevPopulationAggregateFilter;
  XfaResetTrackingStddevPopulationAggregates: XfaResetTrackingStddevPopulationAggregates;
  XfaResetTrackingStddevSampleAggregateFilter: XfaResetTrackingStddevSampleAggregateFilter;
  XfaResetTrackingStddevSampleAggregates: XfaResetTrackingStddevSampleAggregates;
  XfaResetTrackingSumAggregateFilter: XfaResetTrackingSumAggregateFilter;
  XfaResetTrackingSumAggregates: XfaResetTrackingSumAggregates;
  XfaResetTrackingVariancePopulationAggregateFilter: XfaResetTrackingVariancePopulationAggregateFilter;
  XfaResetTrackingVariancePopulationAggregates: XfaResetTrackingVariancePopulationAggregates;
  XfaResetTrackingVarianceSampleAggregateFilter: XfaResetTrackingVarianceSampleAggregateFilter;
  XfaResetTrackingVarianceSampleAggregates: XfaResetTrackingVarianceSampleAggregates;
};

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = {
  accountCapitalEntries?: Resolver<ResolversTypes['AccountCapitalEntryConnection'], ParentType, ContextType, RequireFields<AccountAccountCapitalEntriesArgs, 'orderBy'>>;
  accountLabels?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  accountLiveCallUp?: Resolver<Maybe<ResolversTypes['AccountLiveCallUp']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountPassedBinders?: Resolver<ResolversTypes['AccountPassedBinderConnection'], ParentType, ContextType, RequireFields<AccountAccountPassedBindersArgs, 'orderBy'>>;
  accountPlatformDatum?: Resolver<Maybe<ResolversTypes['AccountPlatformDatum']>, ParentType, ContextType>;
  accountStats?: Resolver<ResolversTypes['AccountStatConnection'], ParentType, ContextType, RequireFields<AccountAccountStatsArgs, 'orderBy'>>;
  accountTemplate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountTemplateRelation?: Resolver<Maybe<ResolversTypes['AccountTemplate']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bestTradingDay?: Resolver<Maybe<ResolversTypes['BestTradingDay']>, ParentType, ContextType>;
  closeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  complimentary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  complimentaryExpirationDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dailyPayoutsUnlockedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dllDailyMetrics?: Resolver<Maybe<ResolversTypes['DllDailyMetrics']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idempotencyKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impactGroupAssignments?: Resolver<ResolversTypes['ImpactGroupAssignmentConnection'], ParentType, ContextType, RequireFields<AccountImpactGroupAssignmentsArgs, 'orderBy'>>;
  impactGroupAssignmentsList?: Resolver<Array<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType, Partial<AccountImpactGroupAssignmentsListArgs>>;
  nmiSubscription?: Resolver<Maybe<ResolversTypes['NmiSubscription']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orderFulfillment?: Resolver<Maybe<ResolversTypes['OrderFulfillment']>, ParentType, ContextType>;
  pathToFunding?: Resolver<Maybe<ResolversTypes['PathToFunding']>, ParentType, ContextType>;
  payoutEnabledByAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Platform']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategory?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skuAccountDetails?: Resolver<Maybe<ResolversTypes['SkuAccountDetails']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['UserSubscription']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderPublicProfilesByFeaturedAccountId?: Resolver<ResolversTypes['TraderPublicProfileConnection'], ParentType, ContextType, RequireFields<AccountTraderPublicProfilesByFeaturedAccountIdArgs, 'orderBy'>>;
  tradingHabits?: Resolver<Maybe<ResolversTypes['TradingHabits']>, ParentType, ContextType>;
  tradingOverview?: Resolver<Maybe<ResolversTypes['TradingOverview']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  viewedReflections?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  worstTradingDay?: Resolver<Maybe<ResolversTypes['WorstTradingDay']>, ParentType, ContextType>;
  xfaConsistencyMetrics?: Resolver<Maybe<ResolversTypes['XfaConsistencyMetrics']>, ParentType, ContextType, RequireFields<AccountXfaConsistencyMetricsArgs, 'includeCommissions'>>;
  xfaResetTrackingsByParentAccountId?: Resolver<ResolversTypes['XfaResetTrackingConnection'], ParentType, ContextType, RequireFields<AccountXfaResetTrackingsByParentAccountIdArgs, 'orderBy'>>;
  xfaResetTrackingsByResetAccountId?: Resolver<ResolversTypes['XfaResetTrackingConnection'], ParentType, ContextType, RequireFields<AccountXfaResetTrackingsByResetAccountIdArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountAdjustmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountAdjustment'] = ResolversParentTypes['AccountAdjustment']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  adminUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountAggregates'] = ResolversParentTypes['AccountAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountAuditResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountAudit'] = ResolversParentTypes['AccountAudit']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserContactInfo']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountAverageAggregates'] = ResolversParentTypes['AccountAverageAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecision'] = ResolversParentTypes['AccountCallUpDecision']> = {
  accountCallUpDecisionCalculationByCalculationIdAndRowIdAndUserId?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculation']>, ParentType, ContextType>;
  accountCallUpDecisionCalculationsByDecisionIdAndUserId?: Resolver<ResolversTypes['AccountCallUpDecisionCalculationConnection'], ParentType, ContextType, RequireFields<AccountCallUpDecisionAccountCallUpDecisionCalculationsByDecisionIdAndUserIdArgs, 'orderBy'>>;
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  brokerageUnavailableReason?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionBrokerageUnavailableReasonEnum']>, ParentType, ContextType>;
  calculationId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  decidedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  decisionEmailQueuedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutChoice?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionPayoutChoiceEnum']>, ParentType, ContextType>;
  propEmailQueuedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AccountCallUpDecisionStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionAggregates'] = ResolversParentTypes['AccountCallUpDecisionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionAverageAggregates'] = ResolversParentTypes['AccountCallUpDecisionAverageAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculation'] = ResolversParentTypes['AccountCallUpDecisionCalculation']> = {
  accountSize?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  decisionId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  decisionUser?: Resolver<Maybe<ResolversTypes['AccountCallUpDecision']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutPolicyVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  policyVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reserveBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  sizingAccountIds?: Resolver<Array<Maybe<ResolversTypes['Int']>>, ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  transferBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationAverageAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationAverageAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationConnection'] = ResolversParentTypes['AccountCallUpDecisionCalculationConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculationAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountCallUpDecisionCalculationEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountCallUpDecisionCalculationAggregates']>>, ParentType, ContextType, RequireFields<AccountCallUpDecisionCalculationConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountCallUpDecisionCalculation']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationDistinctCountAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationDistinctCountAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  decisionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutPolicyVersion?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  policyVersion?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sizingAccountIds?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationEdge'] = ResolversParentTypes['AccountCallUpDecisionCalculationEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationMaxAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationMaxAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationMinAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationMinAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationStddevPopulationAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationStddevPopulationAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationStddevSampleAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationStddevSampleAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationSumAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationSumAggregates']> = {
  accountSize?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  reserveBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  transferBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationVariancePopulationAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationVariancePopulationAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionCalculationVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionCalculationVarianceSampleAggregates'] = ResolversParentTypes['AccountCallUpDecisionCalculationVarianceSampleAggregates']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  transferBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionConnection'] = ResolversParentTypes['AccountCallUpDecisionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountCallUpDecisionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountCallUpDecisionAggregates']>>, ParentType, ContextType, RequireFields<AccountCallUpDecisionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountCallUpDecision']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionDistinctCountAggregates'] = ResolversParentTypes['AccountCallUpDecisionDistinctCountAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  brokerageUnavailableReason?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  calculationId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  decidedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  decisionEmailQueuedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutChoice?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  propEmailQueuedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionEdge'] = ResolversParentTypes['AccountCallUpDecisionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountCallUpDecision']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionMaxAggregates'] = ResolversParentTypes['AccountCallUpDecisionMaxAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionMinAggregates'] = ResolversParentTypes['AccountCallUpDecisionMinAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionStddevPopulationAggregates'] = ResolversParentTypes['AccountCallUpDecisionStddevPopulationAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionStddevSampleAggregates'] = ResolversParentTypes['AccountCallUpDecisionStddevSampleAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionSumAggregates'] = ResolversParentTypes['AccountCallUpDecisionSumAggregates']> = {
  brokerageAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionVariancePopulationAggregates'] = ResolversParentTypes['AccountCallUpDecisionVariancePopulationAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpDecisionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpDecisionVarianceSampleAggregates'] = ResolversParentTypes['AccountCallUpDecisionVarianceSampleAggregates']> = {
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCallUpPayoutOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCallUpPayoutOffer'] = ResolversParentTypes['AccountCallUpPayoutOffer']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  baseAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  bonusAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  bonusPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  calculationDecisionUser?: Resolver<Maybe<ResolversTypes['AccountCallUpDecisionCalculation']>, ParentType, ContextType>;
  calculationId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  choice?: Resolver<ResolversTypes['AccountCallUpDecisionPayoutChoiceEnum'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  decisionId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  flatBonus?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  unavailableReason?: Resolver<Maybe<ResolversTypes['AccountCallUpPayoutOfferUnavailableReasonEnum']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntry'] = ResolversParentTypes['AccountCapitalEntry']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  bucket?: Resolver<ResolversTypes['AccountCapitalEntryBucketEnum'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdByAdmin?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  effectiveAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  entryType?: Resolver<ResolversTypes['AccountCapitalEntryTypeEnum'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  reversesEntry?: Resolver<Maybe<ResolversTypes['AccountCapitalEntry']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryAggregates'] = ResolversParentTypes['AccountCapitalEntryAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountCapitalEntrySumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryAverageAggregates'] = ResolversParentTypes['AccountCapitalEntryAverageAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryConnection'] = ResolversParentTypes['AccountCapitalEntryConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountCapitalEntryEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountCapitalEntryAggregates']>>, ParentType, ContextType, RequireFields<AccountCapitalEntryConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountCapitalEntry']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryDistinctCountAggregates'] = ResolversParentTypes['AccountCapitalEntryDistinctCountAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bucket?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  effectiveAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  entryType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowHash?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryEdge'] = ResolversParentTypes['AccountCapitalEntryEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountCapitalEntry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryMaxAggregates'] = ResolversParentTypes['AccountCapitalEntryMaxAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryMinAggregates'] = ResolversParentTypes['AccountCapitalEntryMinAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryResult'] = ResolversParentTypes['AccountCapitalEntryResult']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdByAdminId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  effectiveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryStddevPopulationAggregates'] = ResolversParentTypes['AccountCapitalEntryStddevPopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryStddevSampleAggregates'] = ResolversParentTypes['AccountCapitalEntryStddevSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntrySumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntrySumAggregates'] = ResolversParentTypes['AccountCapitalEntrySumAggregates']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdByAdminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reversesEntryId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  sisuLevel?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryVariancePopulationAggregates'] = ResolversParentTypes['AccountCapitalEntryVariancePopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalEntryVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalEntryVarianceSampleAggregates'] = ResolversParentTypes['AccountCapitalEntryVarianceSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reversesEntryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountCapitalMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountCapitalMutationPayload'] = ResolversParentTypes['AccountCapitalMutationPayload']> = {
  entry?: Resolver<ResolversTypes['AccountCapitalEntryResult'], ParentType, ContextType>;
  idempotentReplay?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reversalEntry?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountConnection'] = ResolversParentTypes['AccountConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountAggregates']>>, ParentType, ContextType, RequireFields<AccountConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Account']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountDistinctCountAggregates'] = ResolversParentTypes['AccountDistinctCountAggregates']> = {
  accountLabels?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  closeReason?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  complimentary?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  complimentaryExpirationDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dailyPayoutsUnlockedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  idempotencyKey?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutEnabledByAdmin?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  viewedReflections?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountEdge'] = ResolversParentTypes['AccountEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountLiveCallUpResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountLiveCallUp'] = ResolversParentTypes['AccountLiveCallUp']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountCallUpDecisionByUuidAndUserId?: Resolver<Maybe<ResolversTypes['AccountCallUpDecision']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  brokerageAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  callUpPayoutBonusAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  debitStartedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountMaxAggregates'] = ResolversParentTypes['AccountMaxAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountMinAggregates'] = ResolversParentTypes['AccountMinAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountNote'] = ResolversParentTypes['AccountNote']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinder'] = ResolversParentTypes['AccountPassedBinder']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activationInvoiceReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activationInvoiceSentDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  activationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractSentDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  contractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inQueue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  kycComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipActivationFee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderAggregates'] = ResolversParentTypes['AccountPassedBinderAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountPassedBinderAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountPassedBinderDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountPassedBinderMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountPassedBinderMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountPassedBinderStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountPassedBinderStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountPassedBinderSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountPassedBinderVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountPassedBinderVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderAverageAggregates'] = ResolversParentTypes['AccountPassedBinderAverageAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderConnection'] = ResolversParentTypes['AccountPassedBinderConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountPassedBinderAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountPassedBinderEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountPassedBinderAggregates']>>, ParentType, ContextType, RequireFields<AccountPassedBinderConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountPassedBinder']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderDistinctCountAggregates'] = ResolversParentTypes['AccountPassedBinderDistinctCountAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  activationInvoiceReference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  activationInvoiceSentDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  activationStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  contractReference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  contractSentDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  contractStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  inQueue?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  kycComplete?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  skipActivationFee?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderEdge'] = ResolversParentTypes['AccountPassedBinderEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountPassedBinder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderMaxAggregates'] = ResolversParentTypes['AccountPassedBinderMaxAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderMinAggregates'] = ResolversParentTypes['AccountPassedBinderMinAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderStddevPopulationAggregates'] = ResolversParentTypes['AccountPassedBinderStddevPopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderStddevSampleAggregates'] = ResolversParentTypes['AccountPassedBinderStddevSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderSumAggregates'] = ResolversParentTypes['AccountPassedBinderSumAggregates']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  xfaAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderVariancePopulationAggregates'] = ResolversParentTypes['AccountPassedBinderVariancePopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPassedBinderVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPassedBinderVarianceSampleAggregates'] = ResolversParentTypes['AccountPassedBinderVarianceSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  xfaAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPlatformDatumResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPlatformDatum'] = ResolversParentTypes['AccountPlatformDatum']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimit'] = ResolversParentTypes['AccountResetLimit']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateStr?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastResetDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  resetCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitAggregates'] = ResolversParentTypes['AccountResetLimitAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountResetLimitAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountResetLimitDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountResetLimitMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountResetLimitMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountResetLimitStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountResetLimitStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountResetLimitSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountResetLimitVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountResetLimitVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitAverageAggregates'] = ResolversParentTypes['AccountResetLimitAverageAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitConnection'] = ResolversParentTypes['AccountResetLimitConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountResetLimitAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountResetLimitEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountResetLimitAggregates']>>, ParentType, ContextType, RequireFields<AccountResetLimitConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountResetLimit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitDistinctCountAggregates'] = ResolversParentTypes['AccountResetLimitDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dateStr?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastResetDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitEdge'] = ResolversParentTypes['AccountResetLimitEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountResetLimit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitMaxAggregates'] = ResolversParentTypes['AccountResetLimitMaxAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitMinAggregates'] = ResolversParentTypes['AccountResetLimitMinAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitStddevPopulationAggregates'] = ResolversParentTypes['AccountResetLimitStddevPopulationAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitStddevSampleAggregates'] = ResolversParentTypes['AccountResetLimitStddevSampleAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitSumAggregates'] = ResolversParentTypes['AccountResetLimitSumAggregates']> = {
  resetCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitVariancePopulationAggregates'] = ResolversParentTypes['AccountResetLimitVariancePopulationAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetLimitVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetLimitVarianceSampleAggregates'] = ResolversParentTypes['AccountResetLimitVarianceSampleAggregates']> = {
  resetCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTracking'] = ResolversParentTypes['AccountResetTracking']> = {
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  resetAccountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  resetNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['NmiSubscription']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingAggregates'] = ResolversParentTypes['AccountResetTrackingAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountResetTrackingAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountResetTrackingDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountResetTrackingMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountResetTrackingMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountResetTrackingStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountResetTrackingStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountResetTrackingSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountResetTrackingVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountResetTrackingVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingAverageAggregates'] = ResolversParentTypes['AccountResetTrackingAverageAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingConnection'] = ResolversParentTypes['AccountResetTrackingConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountResetTrackingAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountResetTrackingEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountResetTrackingAggregates']>>, ParentType, ContextType, RequireFields<AccountResetTrackingConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountResetTracking']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingDistinctCountAggregates'] = ResolversParentTypes['AccountResetTrackingDistinctCountAggregates']> = {
  accountType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  branchId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingEdge'] = ResolversParentTypes['AccountResetTrackingEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountResetTracking']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingMaxAggregates'] = ResolversParentTypes['AccountResetTrackingMaxAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingMinAggregates'] = ResolversParentTypes['AccountResetTrackingMinAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingStddevPopulationAggregates'] = ResolversParentTypes['AccountResetTrackingStddevPopulationAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingStddevSampleAggregates'] = ResolversParentTypes['AccountResetTrackingStddevSampleAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingSumAggregates'] = ResolversParentTypes['AccountResetTrackingSumAggregates']> = {
  branchId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  parentAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  resetAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  resetNumber?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingVariancePopulationAggregates'] = ResolversParentTypes['AccountResetTrackingVariancePopulationAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResetTrackingVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountResetTrackingVarianceSampleAggregates'] = ResolversParentTypes['AccountResetTrackingVarianceSampleAggregates']> = {
  branchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetNumber?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStat'] = ResolversParentTypes['AccountStat']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ineligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  topstepxUpdatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatAggregates'] = ResolversParentTypes['AccountStatAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountStatAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountStatDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountStatMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountStatMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountStatStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountStatStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountStatSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountStatVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountStatVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatAverageAggregates'] = ResolversParentTypes['AccountStatAverageAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatConnection'] = ResolversParentTypes['AccountStatConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountStatAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountStatEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountStatAggregates']>>, ParentType, ContextType, RequireFields<AccountStatConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountStat']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatDay'] = ResolversParentTypes['AccountStatDay']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalContractsTraded?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatDistinctCountAggregates'] = ResolversParentTypes['AccountStatDistinctCountAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  ineligible?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  topstepxUpdatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatEdge'] = ResolversParentTypes['AccountStatEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountStat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatMaxAggregates'] = ResolversParentTypes['AccountStatMaxAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatMinAggregates'] = ResolversParentTypes['AccountStatMinAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatStddevPopulationAggregates'] = ResolversParentTypes['AccountStatStddevPopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatStddevSampleAggregates'] = ResolversParentTypes['AccountStatStddevSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatSumAggregates'] = ResolversParentTypes['AccountStatSumAggregates']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  minPayoutBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  mll?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  realizedDayPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatVariancePopulationAggregates'] = ResolversParentTypes['AccountStatVariancePopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStatVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStatVarianceSampleAggregates'] = ResolversParentTypes['AccountStatVarianceSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minPayoutBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  mll?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  realizedDayPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStddevPopulationAggregates'] = ResolversParentTypes['AccountStddevPopulationAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStddevSampleAggregates'] = ResolversParentTypes['AccountStddevSampleAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountSumAggregates'] = ResolversParentTypes['AccountSumAggregates']> = {
  accountTemplate?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  productCategoryId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  projectXAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  projectXAccountStatus?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  skuId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplate'] = ResolversParentTypes['AccountTemplate']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accounts?: Resolver<ResolversTypes['AccountConnection'], ParentType, ContextType, RequireFields<AccountTemplateAccountsArgs, 'orderBy'>>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  avaTaxTaxCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consistencyRule?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dailyDrawdownType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDrawdownType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetCredits?: Resolver<ResolversTypes['ResetCreditConnection'], ParentType, ContextType, RequireFields<AccountTemplateResetCreditsArgs, 'orderBy'>>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateAggregates'] = ResolversParentTypes['AccountTemplateAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountTemplateAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountTemplateDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountTemplateMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountTemplateMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountTemplateStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountTemplateStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountTemplateSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountTemplateVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountTemplateVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateAverageAggregates'] = ResolversParentTypes['AccountTemplateAverageAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateConnection'] = ResolversParentTypes['AccountTemplateConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountTemplateAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountTemplateEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountTemplateAggregates']>>, ParentType, ContextType, RequireFields<AccountTemplateConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountTemplate']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateDistinctCountAggregates'] = ResolversParentTypes['AccountTemplateDistinctCountAggregates']> = {
  accountName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  avaTaxTaxCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  consistencyRule?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dailyDrawdownType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxDrawdownType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateEdge'] = ResolversParentTypes['AccountTemplateEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateMaxAggregates'] = ResolversParentTypes['AccountTemplateMaxAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateMinAggregates'] = ResolversParentTypes['AccountTemplateMinAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateStddevPopulationAggregates'] = ResolversParentTypes['AccountTemplateStddevPopulationAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateStddevSampleAggregates'] = ResolversParentTypes['AccountTemplateStddevSampleAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateSumAggregates'] = ResolversParentTypes['AccountTemplateSumAggregates']> = {
  consistencyTargetPercent?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dailyDrawdown?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxDays?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxDrawdown?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxPositionSize?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  minDays?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  netSuiteItemId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  profitTarget?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  resetPrice?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateVariancePopulationAggregates'] = ResolversParentTypes['AccountTemplateVariancePopulationAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTemplateVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTemplateVarianceSampleAggregates'] = ResolversParentTypes['AccountTemplateVarianceSampleAggregates']> = {
  consistencyTargetPercent?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dailyDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxDrawdown?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxPositionSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  minDays?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profitTarget?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXCombineTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeArchiveNewIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeArchiveNewId'] = ResolversParentTypes['AccountTradeArchiveNewId']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  action?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lots?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pairedTradeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pairedTradeIdOld?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priceOld?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeStamp?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  tradeDay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeNatResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeNat'] = ResolversParentTypes['AccountTradeNat']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  action?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lots?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pairedTradeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pairedTradeIdOld?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priceOld?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeStamp?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  tradeDay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDay'] = ResolversParentTypes['AccountTradeStatByDay']> = {
  avgLosingDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avgLosingTrade?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  avgWinningDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avgWinningTrade?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  contractName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  losingTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  losingTradesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  netPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  neutralTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pnlHigh?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  pnlLow?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  projectXAccountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCommissions?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalCompletedTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalContracts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalFees?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tradingDay?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winRate?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  winningTradePercentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  winningTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  winningTradesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayAggregates'] = ResolversParentTypes['AccountTradeStatByDayAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDaySumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayAverageAggregates'] = ResolversParentTypes['AccountTradeStatByDayAverageAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayConnection'] = ResolversParentTypes['AccountTradeStatByDayConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AccountTradeStatByDayEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AccountTradeStatByDayAggregates']>>, ParentType, ContextType, RequireFields<AccountTradeStatByDayConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AccountTradeStatByDay']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayDistinctCountAggregates'] = ResolversParentTypes['AccountTradeStatByDayDistinctCountAggregates']> = {
  avgLosingDuration?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  avgWinningDuration?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  contractName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tradingDay?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayEdge'] = ResolversParentTypes['AccountTradeStatByDayEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDay']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayMaxAggregates'] = ResolversParentTypes['AccountTradeStatByDayMaxAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayMinAggregates'] = ResolversParentTypes['AccountTradeStatByDayMinAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayNatResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayNat'] = ResolversParentTypes['AccountTradeStatByDayNat']> = {
  avgLosingDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avgLosingTrade?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  avgWinningDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avgWinningTrade?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  contractName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  losingTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  losingTradesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  netPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  neutralTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pnlHigh?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  pnlLow?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  projectXAccountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCompletedTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalContracts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalFees?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tradingDay?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  winRate?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  winningTradePercentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  winningTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  winningTradesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayStddevPopulationAggregates'] = ResolversParentTypes['AccountTradeStatByDayStddevPopulationAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayStddevSampleAggregates'] = ResolversParentTypes['AccountTradeStatByDayStddevSampleAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDaySumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDaySumAggregates'] = ResolversParentTypes['AccountTradeStatByDaySumAggregates']> = {
  avgLosingTrade?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  avgWinningTrade?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  losingTrades?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  losingTradesCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  netPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  neutralTrades?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  pnlHigh?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  pnlLow?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  projectXAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  totalCommissions?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalCompletedTrades?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  totalContracts?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  totalFees?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalPnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  totalTrades?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  winRate?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  winningTradePercentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  winningTrades?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  winningTradesCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayVariancePopulationAggregates'] = ResolversParentTypes['AccountTradeStatByDayVariancePopulationAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountTradeStatByDayVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTradeStatByDayVarianceSampleAggregates'] = ResolversParentTypes['AccountTradeStatByDayVarianceSampleAggregates']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  losingTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  neutralTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCommissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalCompletedTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTrades?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  winningTradesCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountVariancePopulationAggregates'] = ResolversParentTypes['AccountVariancePopulationAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountVarianceSampleAggregates'] = ResolversParentTypes['AccountVarianceSampleAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountStatus?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  startingBalance?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Addon'] = ResolversParentTypes['Addon']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  avaTaxTaxCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  humanName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  recurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAudit'] = ResolversParentTypes['AdminAudit']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  admin?: Resolver<Maybe<ResolversTypes['UserContactInfo']>, ParentType, ContextType>;
  adminId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditAggregates'] = ResolversParentTypes['AdminAuditAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AdminAuditAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AdminAuditDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AdminAuditMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AdminAuditMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AdminAuditStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AdminAuditStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AdminAuditSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AdminAuditVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AdminAuditVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditAverageAggregates'] = ResolversParentTypes['AdminAuditAverageAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditConnection'] = ResolversParentTypes['AdminAuditConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AdminAuditAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AdminAuditEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AdminAuditAggregates']>>, ParentType, ContextType, RequireFields<AdminAuditConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AdminAudit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditDistinctCountAggregates'] = ResolversParentTypes['AdminAuditDistinctCountAggregates']> = {
  action?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  adminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditEdge'] = ResolversParentTypes['AdminAuditEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AdminAudit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditMaxAggregates'] = ResolversParentTypes['AdminAuditMaxAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditMinAggregates'] = ResolversParentTypes['AdminAuditMinAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditStddevPopulationAggregates'] = ResolversParentTypes['AdminAuditStddevPopulationAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditStddevSampleAggregates'] = ResolversParentTypes['AdminAuditStddevSampleAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditSumAggregates'] = ResolversParentTypes['AdminAuditSumAggregates']> = {
  adminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditVariancePopulationAggregates'] = ResolversParentTypes['AdminAuditVariancePopulationAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAuditVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAuditVarianceSampleAggregates'] = ResolversParentTypes['AdminAuditVarianceSampleAggregates']> = {
  adminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminConfig'] = ResolversParentTypes['AdminConfig']> = {
  configKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  configurations?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AdminConfigStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminConfigEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminConfigEdge'] = ResolversParentTypes['AdminConfigEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AdminConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRole'] = ResolversParentTypes['AdminRole']> = {
  adminRoleUsersUsers?: Resolver<ResolversTypes['AdminRoleUsersUserConnection'], ParentType, ContextType, RequireFields<AdminRoleAdminRoleUsersUsersArgs, 'orderBy'>>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userAdminRolesByRoleId?: Resolver<ResolversTypes['UserAdminRoleConnection'], ParentType, ContextType, RequireFields<AdminRoleUserAdminRolesByRoleIdArgs, 'orderBy'>>;
  userRolesAdminRoles?: Resolver<ResolversTypes['UserRolesAdminRoleConnection'], ParentType, ContextType, RequireFields<AdminRoleUserRolesAdminRolesArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleAggregates'] = ResolversParentTypes['AdminRoleAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AdminRoleAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AdminRoleDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AdminRoleMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AdminRoleMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AdminRoleStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AdminRoleStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AdminRoleSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AdminRoleVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AdminRoleVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleAverageAggregates'] = ResolversParentTypes['AdminRoleAverageAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleConnection'] = ResolversParentTypes['AdminRoleConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AdminRoleAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AdminRoleEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AdminRole']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleDistinctCountAggregates'] = ResolversParentTypes['AdminRoleDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleEdge'] = ResolversParentTypes['AdminRoleEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AdminRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleMaxAggregates'] = ResolversParentTypes['AdminRoleMaxAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleMinAggregates'] = ResolversParentTypes['AdminRoleMinAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleStddevPopulationAggregates'] = ResolversParentTypes['AdminRoleStddevPopulationAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleStddevSampleAggregates'] = ResolversParentTypes['AdminRoleStddevSampleAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleSumAggregates'] = ResolversParentTypes['AdminRoleSumAggregates']> = {
  createdById?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUser'] = ResolversParentTypes['AdminRoleUsersUser']> = {
  adminRole?: Resolver<Maybe<ResolversTypes['AdminRole']>, ParentType, ContextType>;
  adminRoleId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserAggregates'] = ResolversParentTypes['AdminRoleUsersUserAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserAverageAggregates'] = ResolversParentTypes['AdminRoleUsersUserAverageAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserConnection'] = ResolversParentTypes['AdminRoleUsersUserConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUserAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AdminRoleUsersUserEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AdminRoleUsersUserAggregates']>>, ParentType, ContextType, RequireFields<AdminRoleUsersUserConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AdminRoleUsersUser']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserDistinctCountAggregates'] = ResolversParentTypes['AdminRoleUsersUserDistinctCountAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserEdge'] = ResolversParentTypes['AdminRoleUsersUserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AdminRoleUsersUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserMaxAggregates'] = ResolversParentTypes['AdminRoleUsersUserMaxAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserMinAggregates'] = ResolversParentTypes['AdminRoleUsersUserMinAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserStddevPopulationAggregates'] = ResolversParentTypes['AdminRoleUsersUserStddevPopulationAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserStddevSampleAggregates'] = ResolversParentTypes['AdminRoleUsersUserStddevSampleAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserSumAggregates'] = ResolversParentTypes['AdminRoleUsersUserSumAggregates']> = {
  adminRoleId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserVariancePopulationAggregates'] = ResolversParentTypes['AdminRoleUsersUserVariancePopulationAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleUsersUserVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleUsersUserVarianceSampleAggregates'] = ResolversParentTypes['AdminRoleUsersUserVarianceSampleAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleVariancePopulationAggregates'] = ResolversParentTypes['AdminRoleVariancePopulationAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleVarianceSampleAggregates'] = ResolversParentTypes['AdminRoleVarianceSampleAggregates']> = {
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Affiliate'] = ResolversParentTypes['Affiliate']> = {
  affiliateAudits?: Resolver<ResolversTypes['AffiliateAuditConnection'], ParentType, ContextType, RequireFields<AffiliateAffiliateAuditsArgs, 'orderBy'>>;
  affiliateCommissionRates?: Resolver<ResolversTypes['AffiliateCommissionRateConnection'], ParentType, ContextType, RequireFields<AffiliateAffiliateCommissionRatesArgs, 'orderBy'>>;
  affiliateLedgers?: Resolver<ResolversTypes['AffiliateLedgerConnection'], ParentType, ContextType, RequireFields<AffiliateAffiliateLedgersArgs, 'orderBy'>>;
  affiliatePayoutPeriods?: Resolver<ResolversTypes['AffiliatePayoutPeriodConnection'], ParentType, ContextType, RequireFields<AffiliateAffiliatePayoutPeriodsArgs, 'orderBy'>>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commissionPercentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  deactivatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  designatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  designatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutLegalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAudit'] = ResolversParentTypes['AffiliateAudit']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  actorAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  affiliate?: Resolver<Maybe<ResolversTypes['Affiliate']>, ParentType, ContextType>;
  affiliateId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditAggregates'] = ResolversParentTypes['AffiliateAuditAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AffiliateAuditAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AffiliateAuditDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AffiliateAuditMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AffiliateAuditMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AffiliateAuditStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AffiliateAuditStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AffiliateAuditSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AffiliateAuditVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AffiliateAuditVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditAverageAggregates'] = ResolversParentTypes['AffiliateAuditAverageAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditConnection'] = ResolversParentTypes['AffiliateAuditConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AffiliateAuditAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AffiliateAuditEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AffiliateAuditAggregates']>>, ParentType, ContextType, RequireFields<AffiliateAuditConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AffiliateAudit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditDistinctCountAggregates'] = ResolversParentTypes['AffiliateAuditDistinctCountAggregates']> = {
  action?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  actorAdminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  affiliateId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditEdge'] = ResolversParentTypes['AffiliateAuditEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AffiliateAudit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditMaxAggregates'] = ResolversParentTypes['AffiliateAuditMaxAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditMinAggregates'] = ResolversParentTypes['AffiliateAuditMinAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditStddevPopulationAggregates'] = ResolversParentTypes['AffiliateAuditStddevPopulationAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditStddevSampleAggregates'] = ResolversParentTypes['AffiliateAuditStddevSampleAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditSumAggregates'] = ResolversParentTypes['AffiliateAuditSumAggregates']> = {
  actorAdminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditVariancePopulationAggregates'] = ResolversParentTypes['AffiliateAuditVariancePopulationAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateAuditVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateAuditVarianceSampleAggregates'] = ResolversParentTypes['AffiliateAuditVarianceSampleAggregates']> = {
  actorAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRate'] = ResolversParentTypes['AffiliateCommissionRate']> = {
  affiliate?: Resolver<Maybe<ResolversTypes['Affiliate']>, ParentType, ContextType>;
  affiliateId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  effectiveAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateAggregates'] = ResolversParentTypes['AffiliateCommissionRateAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateAverageAggregates'] = ResolversParentTypes['AffiliateCommissionRateAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateConnection'] = ResolversParentTypes['AffiliateCommissionRateConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRateAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AffiliateCommissionRateEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AffiliateCommissionRateAggregates']>>, ParentType, ContextType, RequireFields<AffiliateCommissionRateConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AffiliateCommissionRate']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateDistinctCountAggregates'] = ResolversParentTypes['AffiliateCommissionRateDistinctCountAggregates']> = {
  affiliateId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  effectiveAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateEdge'] = ResolversParentTypes['AffiliateCommissionRateEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AffiliateCommissionRate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateMaxAggregates'] = ResolversParentTypes['AffiliateCommissionRateMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateMinAggregates'] = ResolversParentTypes['AffiliateCommissionRateMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateStddevPopulationAggregates'] = ResolversParentTypes['AffiliateCommissionRateStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateStddevSampleAggregates'] = ResolversParentTypes['AffiliateCommissionRateStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateSumAggregates'] = ResolversParentTypes['AffiliateCommissionRateSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateVariancePopulationAggregates'] = ResolversParentTypes['AffiliateCommissionRateVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateCommissionRateVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateCommissionRateVarianceSampleAggregates'] = ResolversParentTypes['AffiliateCommissionRateVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedger'] = ResolversParentTypes['AffiliateLedger']> = {
  affiliate?: Resolver<Maybe<ResolversTypes['Affiliate']>, ParentType, ContextType>;
  affiliateId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  entryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  occurredAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerAggregates'] = ResolversParentTypes['AffiliateLedgerAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AffiliateLedgerAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AffiliateLedgerDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AffiliateLedgerMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AffiliateLedgerMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AffiliateLedgerStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AffiliateLedgerStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AffiliateLedgerSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AffiliateLedgerVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AffiliateLedgerVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerAverageAggregates'] = ResolversParentTypes['AffiliateLedgerAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerConnection'] = ResolversParentTypes['AffiliateLedgerConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AffiliateLedgerAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AffiliateLedgerEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AffiliateLedgerAggregates']>>, ParentType, ContextType, RequireFields<AffiliateLedgerConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AffiliateLedger']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerDistinctCountAggregates'] = ResolversParentTypes['AffiliateLedgerDistinctCountAggregates']> = {
  affiliateId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  entryType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  occurredAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerEdge'] = ResolversParentTypes['AffiliateLedgerEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AffiliateLedger']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerMaxAggregates'] = ResolversParentTypes['AffiliateLedgerMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerMinAggregates'] = ResolversParentTypes['AffiliateLedgerMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerStddevPopulationAggregates'] = ResolversParentTypes['AffiliateLedgerStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerStddevSampleAggregates'] = ResolversParentTypes['AffiliateLedgerStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerSumAggregates'] = ResolversParentTypes['AffiliateLedgerSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  commissionPercentage?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  referredUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  refundId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerVariancePopulationAggregates'] = ResolversParentTypes['AffiliateLedgerVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliateLedgerVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliateLedgerVarianceSampleAggregates'] = ResolversParentTypes['AffiliateLedgerVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  chargebackIndicatorId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  referredUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayment'] = ResolversParentTypes['AffiliatePayment']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  externalReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paidAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  period?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriod']>, ParentType, ContextType>;
  periodId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentAggregates'] = ResolversParentTypes['AffiliatePaymentAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AffiliatePaymentAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AffiliatePaymentDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AffiliatePaymentMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AffiliatePaymentMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AffiliatePaymentStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AffiliatePaymentStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AffiliatePaymentSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AffiliatePaymentVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AffiliatePaymentVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentAverageAggregates'] = ResolversParentTypes['AffiliatePaymentAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentConnection'] = ResolversParentTypes['AffiliatePaymentConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AffiliatePaymentAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AffiliatePaymentEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AffiliatePaymentAggregates']>>, ParentType, ContextType, RequireFields<AffiliatePaymentConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AffiliatePayment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentDistinctCountAggregates'] = ResolversParentTypes['AffiliatePaymentDistinctCountAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  externalReference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  periodId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentEdge'] = ResolversParentTypes['AffiliatePaymentEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AffiliatePayment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentMaxAggregates'] = ResolversParentTypes['AffiliatePaymentMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentMinAggregates'] = ResolversParentTypes['AffiliatePaymentMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentStddevPopulationAggregates'] = ResolversParentTypes['AffiliatePaymentStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentStddevSampleAggregates'] = ResolversParentTypes['AffiliatePaymentStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentSumAggregates'] = ResolversParentTypes['AffiliatePaymentSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  loggedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentVariancePopulationAggregates'] = ResolversParentTypes['AffiliatePaymentVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePaymentVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePaymentVarianceSampleAggregates'] = ResolversParentTypes['AffiliatePaymentVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  loggedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriod'] = ResolversParentTypes['AffiliatePayoutPeriod']> = {
  affiliate?: Resolver<Maybe<ResolversTypes['Affiliate']>, ParentType, ContextType>;
  affiliateId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  affiliatePaymentsByPeriodId?: Resolver<ResolversTypes['AffiliatePaymentConnection'], ParentType, ContextType, RequireFields<AffiliatePayoutPeriodAffiliatePaymentsByPeriodIdArgs, 'orderBy'>>;
  carryInAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  clawedBackAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  creditedAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  dueOn?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  netAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  periodEnd?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  periodStart?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodAverageAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodAverageAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodConnection'] = ResolversParentTypes['AffiliatePayoutPeriodConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriodAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['AffiliatePayoutPeriodEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['AffiliatePayoutPeriodAggregates']>>, ParentType, ContextType, RequireFields<AffiliatePayoutPeriodConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AffiliatePayoutPeriod']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodDistinctCountAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodDistinctCountAggregates']> = {
  affiliateId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dueOn?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  periodEnd?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  periodStart?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodEdge'] = ResolversParentTypes['AffiliatePayoutPeriodEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AffiliatePayoutPeriod']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodMaxAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodMaxAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodMinAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodMinAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodStddevPopulationAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodStddevPopulationAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodStddevSampleAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodStddevSampleAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodSumAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodSumAggregates']> = {
  carryInAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  clawedBackAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  creditedAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  netAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodVariancePopulationAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodVariancePopulationAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliatePayoutPeriodVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffiliatePayoutPeriodVarianceSampleAggregates'] = ResolversParentTypes['AffiliatePayoutPeriodVarianceSampleAggregates']> = {
  carryInAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  clawedBackAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  creditedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregateAccountTradeStatByDayConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregateAccountTradeStatByDayConnection'] = ResolversParentTypes['AggregateAccountTradeStatByDayConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['AggregateAccountTradeStatByDayEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['AggregateAccountTradeStatByDayRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregateAccountTradeStatByDayEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregateAccountTradeStatByDayEdge'] = ResolversParentTypes['AggregateAccountTradeStatByDayEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AggregateAccountTradeStatByDayRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregateAccountTradeStatByDayRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregateAccountTradeStatByDayRecord'] = ResolversParentTypes['AggregateAccountTradeStatByDayRecord']> = {
  avgLosingTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  avgWinningTrade?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  contractName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxAvgLosingDuration?: Resolver<Maybe<ResolversTypes['Interval']>, ParentType, ContextType>;
  maxAvgWinningDuration?: Resolver<Maybe<ResolversTypes['Interval']>, ParentType, ContextType>;
  maxConsecutiveLosses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxConsecutiveWins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minAvgLosingDuration?: Resolver<Maybe<ResolversTypes['Interval']>, ParentType, ContextType>;
  minAvgWinningDuration?: Resolver<Maybe<ResolversTypes['Interval']>, ParentType, ContextType>;
  netPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlHigh?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  pnlLow?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalContracts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalLosingTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPnl?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalWinningTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tradingDay?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  winningTradePercentage?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsdmsChanges3728E4207De1F2E6Resolvers<ContextType = any, ParentType extends ResolversParentTypes['AwsdmsChanges3728E4207De1F2E6'] = ResolversParentTypes['AwsdmsChanges3728E4207De1F2E6']> = {
  col1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col8?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col9?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col10?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col11?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col12?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col13?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col14?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col15?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col16?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  col17?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  seg1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seq?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsdmsDdlAuditResolvers<ContextType = any, ParentType extends ResolversParentTypes['AwsdmsDdlAudit'] = ResolversParentTypes['AwsdmsDdlAudit']> = {
  cDdlqry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cKey?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  cName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cOid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cSchema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cTime?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  cTxn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsdmsHeartbeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['AwsdmsHeartbeat'] = ResolversParentTypes['AwsdmsHeartbeat']> = {
  hbCreatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  hbCreatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hbKey?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hbLastHeartbeatAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  hbLastHeartbeatBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchExecutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchExecution'] = ResolversParentTypes['BatchExecution']> = {
  batchType?: Resolver<ResolversTypes['BatchExecutionBatchtypeEnum'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  entityIds?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  originalEntityIds?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BestTradingDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['BestTradingDay'] = ResolversParentTypes['BestTradingDay']> = {
  averageLosingTrade?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageTradeDuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  averageWinningTrade?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bestDayDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bestDayProfit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  consistency?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dayOfWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profitFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeWinPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradingSession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigFloatScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigFloat'], any> {
  name: 'BigFloat';
}

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export type BulkActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkAction'] = ResolversParentTypes['BulkAction']> = {
  actionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  actorId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  configuration?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  entityIds?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  submittedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  workflowId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkCapitalUploadPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkCapitalUploadPayload'] = ResolversParentTypes['BulkCapitalUploadPayload']> = {
  applied?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  appliedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  batchLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dryRun?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  entryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rejected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rows?: Resolver<Array<ResolversTypes['BulkCapitalUploadRowResult']>, ParentType, ContextType>;
  rowsRead?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkCapitalUploadRowResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkCapitalUploadRowResult'] = ResolversParentTypes['BulkCapitalUploadRowResult']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outcome?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sisuLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BypassUserTaxFormValidationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BypassUserTaxFormValidationResult'] = ResolversParentTypes['BypassUserTaxFormValidationResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransaction'] = ResolversParentTypes['CardTransaction']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ccCardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ccExpMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ccExpYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gateway?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nuveiPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stripePaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionAggregates'] = ResolversParentTypes['CardTransactionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CardTransactionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CardTransactionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CardTransactionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CardTransactionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CardTransactionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CardTransactionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CardTransactionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CardTransactionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CardTransactionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionAverageAggregates'] = ResolversParentTypes['CardTransactionAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionConnection'] = ResolversParentTypes['CardTransactionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CardTransactionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CardTransactionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CardTransactionAggregates']>>, ParentType, ContextType, RequireFields<CardTransactionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CardTransaction']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionDistinctCountAggregates'] = ResolversParentTypes['CardTransactionDistinctCountAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bin?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  ccCardNumber?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  ccExpMonth?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  ccExpYear?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  errorDescription?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiPaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  stripePaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionEdge'] = ResolversParentTypes['CardTransactionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CardTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionMaxAggregates'] = ResolversParentTypes['CardTransactionMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionMinAggregates'] = ResolversParentTypes['CardTransactionMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionStddevPopulationAggregates'] = ResolversParentTypes['CardTransactionStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionStddevSampleAggregates'] = ResolversParentTypes['CardTransactionStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionSumAggregates'] = ResolversParentTypes['CardTransactionSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  gateway?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tax?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionVariancePopulationAggregates'] = ResolversParentTypes['CardTransactionVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardTransactionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardTransactionVarianceSampleAggregates'] = ResolversParentTypes['CardTransactionVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseAssignableUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseAssignableUser'] = ResolversParentTypes['CaseAssignableUser']> = {
  departments?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBan'] = ResolversParentTypes['CaseBan']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseBanReasonCodes?: Resolver<ResolversTypes['CaseBanReasonCodeConnection'], ParentType, ContextType, RequireFields<CaseBanCaseBanReasonCodesArgs, 'orderBy'>>;
  caseBanTraders?: Resolver<ResolversTypes['CaseBanTraderConnection'], ParentType, ContextType, RequireFields<CaseBanCaseBanTradersArgs, 'orderBy'>>;
  caseEvents?: Resolver<ResolversTypes['CaseEventConnection'], ParentType, ContextType, RequireFields<CaseBanCaseEventsArgs, 'orderBy'>>;
  caseLabelAssignments?: Resolver<ResolversTypes['CaseLabelAssignmentConnection'], ParentType, ContextType, RequireFields<CaseBanCaseLabelAssignmentsArgs, 'orderBy'>>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  departmentGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['CaseSeverity'], ParentType, ContextType>;
  sourceCaseInvestigation?: Resolver<Maybe<ResolversTypes['CaseInvestigation']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CaseStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanAggregates'] = ResolversParentTypes['CaseBanAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseBanAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseBanDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseBanMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseBanMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseBanStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseBanStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseBanSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseBanVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseBanVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanAverageAggregates'] = ResolversParentTypes['CaseBanAverageAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanConnection'] = ResolversParentTypes['CaseBanConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseBanAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseBanEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseBanAggregates']>>, ParentType, ContextType, RequireFields<CaseBanConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseBan']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanDistinctCountAggregates'] = ResolversParentTypes['CaseBanDistinctCountAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  departmentGroupId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanEdge'] = ResolversParentTypes['CaseBanEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseBan']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanEventResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanEventResult'] = ResolversParentTypes['CaseBanEventResult']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanMaxAggregates'] = ResolversParentTypes['CaseBanMaxAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanMinAggregates'] = ResolversParentTypes['CaseBanMinAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCode'] = ResolversParentTypes['CaseBanReasonCode']> = {
  caseBan?: Resolver<Maybe<ResolversTypes['CaseBan']>, ParentType, ContextType>;
  caseBanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['ReasonCode']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeAggregates'] = ResolversParentTypes['CaseBanReasonCodeAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeAverageAggregates'] = ResolversParentTypes['CaseBanReasonCodeAverageAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeConnection'] = ResolversParentTypes['CaseBanReasonCodeConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseBanReasonCodeAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseBanReasonCodeEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseBanReasonCodeAggregates']>>, ParentType, ContextType, RequireFields<CaseBanReasonCodeConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseBanReasonCode']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeDistinctCountAggregates'] = ResolversParentTypes['CaseBanReasonCodeDistinctCountAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeEdge'] = ResolversParentTypes['CaseBanReasonCodeEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseBanReasonCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeMaxAggregates'] = ResolversParentTypes['CaseBanReasonCodeMaxAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeMinAggregates'] = ResolversParentTypes['CaseBanReasonCodeMinAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeStddevPopulationAggregates'] = ResolversParentTypes['CaseBanReasonCodeStddevPopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeStddevSampleAggregates'] = ResolversParentTypes['CaseBanReasonCodeStddevSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeSumAggregates'] = ResolversParentTypes['CaseBanReasonCodeSumAggregates']> = {
  caseBanId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reasonCodeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeVariancePopulationAggregates'] = ResolversParentTypes['CaseBanReasonCodeVariancePopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanReasonCodeVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanReasonCodeVarianceSampleAggregates'] = ResolversParentTypes['CaseBanReasonCodeVarianceSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanResult'] = ResolversParentTypes['CaseBanResult']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  departmentGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  labels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonCodeIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanStddevPopulationAggregates'] = ResolversParentTypes['CaseBanStddevPopulationAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanStddevSampleAggregates'] = ResolversParentTypes['CaseBanStddevSampleAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanSumAggregates'] = ResolversParentTypes['CaseBanSumAggregates']> = {
  assignedTo?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTrader'] = ResolversParentTypes['CaseBanTrader']> = {
  caseBan?: Resolver<Maybe<ResolversTypes['CaseBan']>, ParentType, ContextType>;
  caseBanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idvLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intercomLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingAction?: Resolver<ResolversTypes['CaseBanPendingAction'], ParentType, ContextType>;
  pendingActionDetails?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderAggregates'] = ResolversParentTypes['CaseBanTraderAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseBanTraderAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseBanTraderDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseBanTraderMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseBanTraderMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseBanTraderStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseBanTraderStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseBanTraderSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseBanTraderVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseBanTraderVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderAverageAggregates'] = ResolversParentTypes['CaseBanTraderAverageAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderConnection'] = ResolversParentTypes['CaseBanTraderConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseBanTraderAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseBanTraderEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseBanTraderAggregates']>>, ParentType, ContextType, RequireFields<CaseBanTraderConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseBanTrader']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderDistinctCountAggregates'] = ResolversParentTypes['CaseBanTraderDistinctCountAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  idvLink?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  intercomLink?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pendingAction?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pendingActionDetails?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderEdge'] = ResolversParentTypes['CaseBanTraderEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseBanTrader']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderMaxAggregates'] = ResolversParentTypes['CaseBanTraderMaxAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderMinAggregates'] = ResolversParentTypes['CaseBanTraderMinAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderPendingDetailsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderPendingDetailsResult'] = ResolversParentTypes['CaseBanTraderPendingDetailsResult']> = {
  payoutHold?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urgency?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderResult'] = ResolversParentTypes['CaseBanTraderResult']> = {
  caseBanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  idvLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intercomLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingAction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingActionDetails?: Resolver<Maybe<ResolversTypes['CaseBanTraderPendingDetailsResult']>, ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderStddevPopulationAggregates'] = ResolversParentTypes['CaseBanTraderStddevPopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderStddevSampleAggregates'] = ResolversParentTypes['CaseBanTraderStddevSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderSumAggregates'] = ResolversParentTypes['CaseBanTraderSumAggregates']> = {
  caseBanId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderVariancePopulationAggregates'] = ResolversParentTypes['CaseBanTraderVariancePopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTraderVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTraderVarianceSampleAggregates'] = ResolversParentTypes['CaseBanTraderVarianceSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanTradersRemovedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanTradersRemovedResult'] = ResolversParentTypes['CaseBanTradersRemovedResult']> = {
  cancelledCase?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  traders?: Resolver<Array<ResolversTypes['CaseBanTraderResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanVariancePopulationAggregates'] = ResolversParentTypes['CaseBanVariancePopulationAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBanVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBanVarianceSampleAggregates'] = ResolversParentTypes['CaseBanVarianceSampleAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sourceCaseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseDepartmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseDepartment'] = ResolversParentTypes['CaseDepartment']> = {
  isCurrentAdminMember?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEvent'] = ResolversParentTypes['CaseEvent']> = {
  caseBan?: Resolver<Maybe<ResolversTypes['CaseBan']>, ParentType, ContextType>;
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseInvestigation?: Resolver<Maybe<ResolversTypes['CaseInvestigation']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventData?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['CaseEventType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventAggregates'] = ResolversParentTypes['CaseEventAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseEventAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseEventDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseEventMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseEventMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseEventStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseEventStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseEventSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseEventVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseEventVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventAverageAggregates'] = ResolversParentTypes['CaseEventAverageAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventConnection'] = ResolversParentTypes['CaseEventConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseEventAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseEventEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseEventAggregates']>>, ParentType, ContextType, RequireFields<CaseEventConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseEvent']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventDistinctCountAggregates'] = ResolversParentTypes['CaseEventDistinctCountAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventData?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventEdge'] = ResolversParentTypes['CaseEventEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventMaxAggregates'] = ResolversParentTypes['CaseEventMaxAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventMinAggregates'] = ResolversParentTypes['CaseEventMinAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventStddevPopulationAggregates'] = ResolversParentTypes['CaseEventStddevPopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventStddevSampleAggregates'] = ResolversParentTypes['CaseEventStddevSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventSumAggregates'] = ResolversParentTypes['CaseEventSumAggregates']> = {
  caseBanId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  caseInvestigationId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  traderUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventVariancePopulationAggregates'] = ResolversParentTypes['CaseEventVariancePopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEventVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEventVarianceSampleAggregates'] = ResolversParentTypes['CaseEventVarianceSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigation'] = ResolversParentTypes['CaseInvestigation']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseBansBySourceCaseInvestigationId?: Resolver<ResolversTypes['CaseBanConnection'], ParentType, ContextType, RequireFields<CaseInvestigationCaseBansBySourceCaseInvestigationIdArgs, 'orderBy'>>;
  caseEvents?: Resolver<ResolversTypes['CaseEventConnection'], ParentType, ContextType, RequireFields<CaseInvestigationCaseEventsArgs, 'orderBy'>>;
  caseInvestigationTraders?: Resolver<ResolversTypes['CaseInvestigationTraderConnection'], ParentType, ContextType, RequireFields<CaseInvestigationCaseInvestigationTradersArgs, 'orderBy'>>;
  caseLabelAssignments?: Resolver<ResolversTypes['CaseLabelAssignmentConnection'], ParentType, ContextType, RequireFields<CaseInvestigationCaseLabelAssignmentsArgs, 'orderBy'>>;
  caseType?: Resolver<Maybe<ResolversTypes['CaseType']>, ParentType, ContextType>;
  caseTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  departmentGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitSheet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['CaseSeverity'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CaseStatus'], ParentType, ContextType>;
  submittedByDepartment?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartment']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationAggregates'] = ResolversParentTypes['CaseInvestigationAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseInvestigationAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseInvestigationDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseInvestigationMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseInvestigationMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseInvestigationStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseInvestigationStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseInvestigationSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseInvestigationVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseInvestigationVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationAverageAggregates'] = ResolversParentTypes['CaseInvestigationAverageAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationConnection'] = ResolversParentTypes['CaseInvestigationConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseInvestigationAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseInvestigationEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseInvestigationAggregates']>>, ParentType, ContextType, RequireFields<CaseInvestigationConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseInvestigation']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationDistinctCountAggregates'] = ResolversParentTypes['CaseInvestigationDistinctCountAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  departmentGroupId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  fitSheet?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationEdge'] = ResolversParentTypes['CaseInvestigationEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseInvestigation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationEventResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationEventResult'] = ResolversParentTypes['CaseInvestigationEventResult']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationMaxAggregates'] = ResolversParentTypes['CaseInvestigationMaxAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationMinAggregates'] = ResolversParentTypes['CaseInvestigationMinAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationResult'] = ResolversParentTypes['CaseInvestigationResult']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  departmentGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitSheet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  labels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationStddevPopulationAggregates'] = ResolversParentTypes['CaseInvestigationStddevPopulationAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationStddevSampleAggregates'] = ResolversParentTypes['CaseInvestigationStddevSampleAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartment'] = ResolversParentTypes['CaseInvestigationSubmittedDepartment']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentAverageAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentConnection'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentDistinctCountAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentEdge'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentMaxAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentMinAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentStddevPopulationAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentStddevSampleAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentSumAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentVariancePopulationAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSubmittedDepartmentVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSubmittedDepartmentVarianceSampleAggregates'] = ResolversParentTypes['CaseInvestigationSubmittedDepartmentVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationSumAggregates'] = ResolversParentTypes['CaseInvestigationSumAggregates']> = {
  assignedTo?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  caseTypeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTrader'] = ResolversParentTypes['CaseInvestigationTrader']> = {
  caseInvestigation?: Resolver<Maybe<ResolversTypes['CaseInvestigation']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idvLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intercomLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingAction?: Resolver<ResolversTypes['CaseInvestigationPendingAction'], ParentType, ContextType>;
  pendingActionDetails?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['ReasonCode']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderAggregates'] = ResolversParentTypes['CaseInvestigationTraderAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderAverageAggregates'] = ResolversParentTypes['CaseInvestigationTraderAverageAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderConnection'] = ResolversParentTypes['CaseInvestigationTraderConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseInvestigationTraderEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseInvestigationTraderAggregates']>>, ParentType, ContextType, RequireFields<CaseInvestigationTraderConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseInvestigationTrader']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderDistinctCountAggregates'] = ResolversParentTypes['CaseInvestigationTraderDistinctCountAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  idvLink?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  intercomLink?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pendingAction?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pendingActionDetails?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderEdge'] = ResolversParentTypes['CaseInvestigationTraderEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseInvestigationTrader']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderMaxAggregates'] = ResolversParentTypes['CaseInvestigationTraderMaxAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderMinAggregates'] = ResolversParentTypes['CaseInvestigationTraderMinAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderPendingDetailsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderPendingDetailsResult'] = ResolversParentTypes['CaseInvestigationTraderPendingDetailsResult']> = {
  payoutHold?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urgency?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderResult'] = ResolversParentTypes['CaseInvestigationTraderResult']> = {
  caseInvestigationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  idvLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intercomLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingAction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingActionDetails?: Resolver<Maybe<ResolversTypes['CaseInvestigationTraderPendingDetailsResult']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderStddevPopulationAggregates'] = ResolversParentTypes['CaseInvestigationTraderStddevPopulationAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderStddevSampleAggregates'] = ResolversParentTypes['CaseInvestigationTraderStddevSampleAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderSumAggregates'] = ResolversParentTypes['CaseInvestigationTraderSumAggregates']> = {
  caseInvestigationId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reasonCodeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderVariancePopulationAggregates'] = ResolversParentTypes['CaseInvestigationTraderVariancePopulationAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTraderVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTraderVarianceSampleAggregates'] = ResolversParentTypes['CaseInvestigationTraderVarianceSampleAggregates']> = {
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationTradersRemovedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationTradersRemovedResult'] = ResolversParentTypes['CaseInvestigationTradersRemovedResult']> = {
  cancelledCase?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  traders?: Resolver<Array<ResolversTypes['CaseInvestigationTraderResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationVariancePopulationAggregates'] = ResolversParentTypes['CaseInvestigationVariancePopulationAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInvestigationVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInvestigationVarianceSampleAggregates'] = ResolversParentTypes['CaseInvestigationVarianceSampleAggregates']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseTypeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  submittedByDepartmentId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabel'] = ResolversParentTypes['CaseLabel']> = {
  caseLabelAssignments?: Resolver<ResolversTypes['CaseLabelAssignmentConnection'], ParentType, ContextType, RequireFields<CaseLabelCaseLabelAssignmentsArgs, 'orderBy'>>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAggregates'] = ResolversParentTypes['CaseLabelAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseLabelAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseLabelDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseLabelMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseLabelMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseLabelStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseLabelStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseLabelSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseLabelVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseLabelVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignment'] = ResolversParentTypes['CaseLabelAssignment']> = {
  caseBan?: Resolver<Maybe<ResolversTypes['CaseBan']>, ParentType, ContextType>;
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseInvestigation?: Resolver<Maybe<ResolversTypes['CaseInvestigation']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseLabel?: Resolver<Maybe<ResolversTypes['CaseLabel']>, ParentType, ContextType>;
  caseLabelId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentAggregates'] = ResolversParentTypes['CaseLabelAssignmentAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentAverageAggregates'] = ResolversParentTypes['CaseLabelAssignmentAverageAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentConnection'] = ResolversParentTypes['CaseLabelAssignmentConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseLabelAssignmentAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseLabelAssignmentEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CaseLabelAssignmentAggregates']>>, ParentType, ContextType, RequireFields<CaseLabelAssignmentConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseLabelAssignment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentDistinctCountAggregates'] = ResolversParentTypes['CaseLabelAssignmentDistinctCountAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentEdge'] = ResolversParentTypes['CaseLabelAssignmentEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseLabelAssignment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentMaxAggregates'] = ResolversParentTypes['CaseLabelAssignmentMaxAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentMinAggregates'] = ResolversParentTypes['CaseLabelAssignmentMinAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentStddevPopulationAggregates'] = ResolversParentTypes['CaseLabelAssignmentStddevPopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentStddevSampleAggregates'] = ResolversParentTypes['CaseLabelAssignmentStddevSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentSumAggregates'] = ResolversParentTypes['CaseLabelAssignmentSumAggregates']> = {
  caseBanId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  caseInvestigationId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  caseLabelId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentVariancePopulationAggregates'] = ResolversParentTypes['CaseLabelAssignmentVariancePopulationAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAssignmentVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAssignmentVarianceSampleAggregates'] = ResolversParentTypes['CaseLabelAssignmentVarianceSampleAggregates']> = {
  caseBanId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseInvestigationId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  caseLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelAverageAggregates'] = ResolversParentTypes['CaseLabelAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelConnection'] = ResolversParentTypes['CaseLabelConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseLabelAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseLabelEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseLabel']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelDistinctCountAggregates'] = ResolversParentTypes['CaseLabelDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelEdge'] = ResolversParentTypes['CaseLabelEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseLabel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelMaxAggregates'] = ResolversParentTypes['CaseLabelMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelMinAggregates'] = ResolversParentTypes['CaseLabelMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelStddevPopulationAggregates'] = ResolversParentTypes['CaseLabelStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelStddevSampleAggregates'] = ResolversParentTypes['CaseLabelStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelSumAggregates'] = ResolversParentTypes['CaseLabelSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelVariancePopulationAggregates'] = ResolversParentTypes['CaseLabelVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLabelVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseLabelVarianceSampleAggregates'] = ResolversParentTypes['CaseLabelVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseType'] = ResolversParentTypes['CaseType']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  caseInvestigations?: Resolver<ResolversTypes['CaseInvestigationConnection'], ParentType, ContextType, RequireFields<CaseTypeCaseInvestigationsArgs, 'orderBy'>>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeAggregates'] = ResolversParentTypes['CaseTypeAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CaseTypeAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CaseTypeDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CaseTypeMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CaseTypeMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CaseTypeStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CaseTypeStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CaseTypeSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CaseTypeVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CaseTypeVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeAverageAggregates'] = ResolversParentTypes['CaseTypeAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeConnection'] = ResolversParentTypes['CaseTypeConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CaseTypeAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CaseTypeEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CaseType']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeDistinctCountAggregates'] = ResolversParentTypes['CaseTypeDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeEdge'] = ResolversParentTypes['CaseTypeEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeMaxAggregates'] = ResolversParentTypes['CaseTypeMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeMinAggregates'] = ResolversParentTypes['CaseTypeMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeStddevPopulationAggregates'] = ResolversParentTypes['CaseTypeStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeStddevSampleAggregates'] = ResolversParentTypes['CaseTypeStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeSumAggregates'] = ResolversParentTypes['CaseTypeSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeVariancePopulationAggregates'] = ResolversParentTypes['CaseTypeVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTypeVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseTypeVarianceSampleAggregates'] = ResolversParentTypes['CaseTypeVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chargeback'] = ResolversParentTypes['Chargeback']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  arn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  challengedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  chargebackDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  chargebackKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  decisions?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  disputeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastChangedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  linkStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lostAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  mergedInto?: Resolver<Maybe<ResolversTypes['Chargeback']>, ParentType, ContextType>;
  mergedIntoId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  needsReview?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  openedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  problemCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  problems?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  processor?: Resolver<ResolversTypes['ChargebackProcessor'], ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['Purchase']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrder?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  readActionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  readVersionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  settledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  withdrawnAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  wonAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackAdminActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackAdminAction'] = ResolversParentTypes['ChargebackAdminAction']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  actorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  at?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  targetChargebackId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  targetPurchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  targetSourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackAggregates'] = ResolversParentTypes['ChargebackAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ChargebackAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ChargebackDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ChargebackMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ChargebackMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ChargebackStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ChargebackStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ChargebackSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ChargebackVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ChargebackVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackAverageAggregates'] = ResolversParentTypes['ChargebackAverageAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackConnection'] = ResolversParentTypes['ChargebackConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ChargebackAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ChargebackEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ChargebackAggregates']>>, ParentType, ContextType, RequireFields<ChargebackConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Chargeback']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackDistinctCountAggregates'] = ResolversParentTypes['ChargebackDistinctCountAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  arn?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cancelledAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  challengedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  chargebackDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  chargebackKey?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  decisions?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  disputeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  kind?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastChangedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  linkStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lostAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  mergedIntoId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  needsReview?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  openedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  problems?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  removedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  settledAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceIds?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  withdrawnAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  wonAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackEdge'] = ResolversParentTypes['ChargebackEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Chargeback']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedRunResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedRun'] = ResolversParentTypes['ChargebackFeedRun']> = {
  chargebackFeedVersionsByRunId?: Resolver<ResolversTypes['ChargebackFeedVersionConnection'], ParentType, ContextType, RequireFields<ChargebackFeedRunChargebackFeedVersionsByRunIdArgs, 'orderBy'>>;
  diagnostics?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  missing?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  refreshedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedSource'] = ResolversParentTypes['ChargebackFeedSource']> = {
  contentHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersion'] = ResolversParentTypes['ChargebackFeedVersion']> = {
  contentHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  observedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  raw?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['ChargebackFeedRun']>, ParentType, ContextType>;
  runId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionAggregates'] = ResolversParentTypes['ChargebackFeedVersionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionAverageAggregates'] = ResolversParentTypes['ChargebackFeedVersionAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionConnection'] = ResolversParentTypes['ChargebackFeedVersionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ChargebackFeedVersionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ChargebackFeedVersionAggregates']>>, ParentType, ContextType, RequireFields<ChargebackFeedVersionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ChargebackFeedVersion']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionDistinctCountAggregates'] = ResolversParentTypes['ChargebackFeedVersionDistinctCountAggregates']> = {
  contentHash?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  observedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  raw?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  runId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionEdge'] = ResolversParentTypes['ChargebackFeedVersionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ChargebackFeedVersion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionMaxAggregates'] = ResolversParentTypes['ChargebackFeedVersionMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionMinAggregates'] = ResolversParentTypes['ChargebackFeedVersionMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionStddevPopulationAggregates'] = ResolversParentTypes['ChargebackFeedVersionStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionStddevSampleAggregates'] = ResolversParentTypes['ChargebackFeedVersionStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionSumAggregates'] = ResolversParentTypes['ChargebackFeedVersionSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionVariancePopulationAggregates'] = ResolversParentTypes['ChargebackFeedVersionVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFeedVersionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFeedVersionVarianceSampleAggregates'] = ResolversParentTypes['ChargebackFeedVersionVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackFlagResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackFlag'] = ResolversParentTypes['ChargebackFlag']> = {
  amountUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebackDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lifecycleState?: Resolver<ResolversTypes['ChargebackLifecycleState'], ParentType, ContextType>;
  processor?: Resolver<ResolversTypes['ChargebackProcessor'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicator'] = ResolversParentTypes['ChargebackIndicator']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  arn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  caseAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebackDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  disputeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processor?: Resolver<ResolversTypes['ChargebackProcessor'], ParentType, ContextType>;
  processorStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchaseOrder?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recoveryOutcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sourceExtractedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTraderUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorAggregates'] = ResolversParentTypes['ChargebackIndicatorAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorAverageAggregates'] = ResolversParentTypes['ChargebackIndicatorAverageAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorConnection'] = ResolversParentTypes['ChargebackIndicatorConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ChargebackIndicatorAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ChargebackIndicatorEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ChargebackIndicatorAggregates']>>, ParentType, ContextType, RequireFields<ChargebackIndicatorConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ChargebackIndicator']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorDistinctCountAggregates'] = ResolversParentTypes['ChargebackIndicatorDistinctCountAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  arn?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  caseAction?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  chargebackDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  disputeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  processorStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reasonDescription?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  recoveryOutcome?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceExtractedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceTraderUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorEdge'] = ResolversParentTypes['ChargebackIndicatorEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ChargebackIndicator']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorMaxAggregates'] = ResolversParentTypes['ChargebackIndicatorMaxAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorMinAggregates'] = ResolversParentTypes['ChargebackIndicatorMinAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorStddevPopulationAggregates'] = ResolversParentTypes['ChargebackIndicatorStddevPopulationAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorStddevSampleAggregates'] = ResolversParentTypes['ChargebackIndicatorStddevSampleAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorSumAggregates'] = ResolversParentTypes['ChargebackIndicatorSumAggregates']> = {
  amountUsd?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  linkedByAdminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorVariancePopulationAggregates'] = ResolversParentTypes['ChargebackIndicatorVariancePopulationAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackIndicatorVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackIndicatorVarianceSampleAggregates'] = ResolversParentTypes['ChargebackIndicatorVarianceSampleAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackMaxAggregates'] = ResolversParentTypes['ChargebackMaxAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackMinAggregates'] = ResolversParentTypes['ChargebackMinAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackResult'] = ResolversParentTypes['ChargebackResult']> = {
  amountUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebackDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  linkedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processor?: Resolver<ResolversTypes['ChargebackProcessor'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackStddevPopulationAggregates'] = ResolversParentTypes['ChargebackStddevPopulationAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackStddevSampleAggregates'] = ResolversParentTypes['ChargebackStddevSampleAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackSumAggregates'] = ResolversParentTypes['ChargebackSumAggregates']> = {
  amountUsd?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  problemCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  readActionId?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  readVersionId?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  traderUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackTotals'] = ResolversParentTypes['ChargebackTotals']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackVariancePopulationAggregates'] = ResolversParentTypes['ChargebackVariancePopulationAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackVarianceSampleAggregates'] = ResolversParentTypes['ChargebackVarianceSampleAggregates']> = {
  amountUsd?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  problemCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readActionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  readVersionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItem'] = ResolversParentTypes['CheckoutItem']> = {
  associatedAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkoutSession?: Resolver<Maybe<ResolversTypes['CheckoutSession']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Platform']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemAggregates'] = ResolversParentTypes['CheckoutItemAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CheckoutItemAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CheckoutItemDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CheckoutItemMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CheckoutItemMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CheckoutItemStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CheckoutItemStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CheckoutItemSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CheckoutItemVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CheckoutItemVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemAverageAggregates'] = ResolversParentTypes['CheckoutItemAverageAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemConnection'] = ResolversParentTypes['CheckoutItemConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CheckoutItemAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CheckoutItemEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CheckoutItemAggregates']>>, ParentType, ContextType, RequireFields<CheckoutItemConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CheckoutItem']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemDistinctCountAggregates'] = ResolversParentTypes['CheckoutItemDistinctCountAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemEdge'] = ResolversParentTypes['CheckoutItemEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CheckoutItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemMaxAggregates'] = ResolversParentTypes['CheckoutItemMaxAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemMinAggregates'] = ResolversParentTypes['CheckoutItemMinAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemStddevPopulationAggregates'] = ResolversParentTypes['CheckoutItemStddevPopulationAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemStddevSampleAggregates'] = ResolversParentTypes['CheckoutItemStddevSampleAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemSumAggregates'] = ResolversParentTypes['CheckoutItemSumAggregates']> = {
  associatedAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  checkoutSessionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  skuId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemVariancePopulationAggregates'] = ResolversParentTypes['CheckoutItemVariancePopulationAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutItemVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutItemVarianceSampleAggregates'] = ResolversParentTypes['CheckoutItemVarianceSampleAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSession'] = ResolversParentTypes['CheckoutSession']> = {
  checkoutItems?: Resolver<ResolversTypes['CheckoutItemConnection'], ParentType, ContextType, RequireFields<CheckoutSessionCheckoutItemsArgs, 'orderBy'>>;
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventLog?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  publicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckoutSessionStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionAggregates'] = ResolversParentTypes['CheckoutSessionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CheckoutSessionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CheckoutSessionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CheckoutSessionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CheckoutSessionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CheckoutSessionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CheckoutSessionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CheckoutSessionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CheckoutSessionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CheckoutSessionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionAverageAggregates'] = ResolversParentTypes['CheckoutSessionAverageAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionConnection'] = ResolversParentTypes['CheckoutSessionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CheckoutSessionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CheckoutSessionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CheckoutSessionAggregates']>>, ParentType, ContextType, RequireFields<CheckoutSessionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CheckoutSession']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionDistinctCountAggregates'] = ResolversParentTypes['CheckoutSessionDistinctCountAggregates']> = {
  couponCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  publicId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionEdge'] = ResolversParentTypes['CheckoutSessionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CheckoutSession']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionMaxAggregates'] = ResolversParentTypes['CheckoutSessionMaxAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionMinAggregates'] = ResolversParentTypes['CheckoutSessionMinAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionStddevPopulationAggregates'] = ResolversParentTypes['CheckoutSessionStddevPopulationAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionStddevSampleAggregates'] = ResolversParentTypes['CheckoutSessionStddevSampleAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionSumAggregates'] = ResolversParentTypes['CheckoutSessionSumAggregates']> = {
  couponId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionVariancePopulationAggregates'] = ResolversParentTypes['CheckoutSessionVariancePopulationAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionVarianceSampleAggregates'] = ResolversParentTypes['CheckoutSessionVarianceSampleAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['Coupon'] = ResolversParentTypes['Coupon']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  affiliate?: Resolver<Maybe<ResolversTypes['Affiliate']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  combineSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponUsers?: Resolver<ResolversTypes['CouponUserConnection'], ParentType, ContextType, RequireFields<CouponCouponUsersArgs, 'orderBy'>>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  firstPurchaseOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  grantResetCredit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiSubscriptions?: Resolver<ResolversTypes['NmiSubscriptionConnection'], ParentType, ContextType, RequireFields<CouponNmiSubscriptionsArgs, 'orderBy'>>;
  productCategory?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recurringDiscount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  restrictToUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  restrictToUserList?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderPublicProfiles?: Resolver<ResolversTypes['TraderPublicProfileConnection'], ParentType, ContextType, RequireFields<CouponTraderPublicProfilesArgs, 'orderBy'>>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userSubscriptions?: Resolver<ResolversTypes['UserSubscriptionConnection'], ParentType, ContextType, RequireFields<CouponUserSubscriptionsArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponAggregates'] = ResolversParentTypes['CouponAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CouponAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CouponDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CouponMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CouponMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CouponStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CouponStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CouponSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CouponVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CouponVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponAverageAggregates'] = ResolversParentTypes['CouponAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponConnection'] = ResolversParentTypes['CouponConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CouponAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CouponEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CouponAggregates']>>, ParentType, ContextType, RequireFields<CouponConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Coupon']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDistinctCountAggregates'] = ResolversParentTypes['CouponDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  combineSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discountType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  firstPurchaseOnly?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  grantResetCredit?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  recurringDiscount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  restrictToUser?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  restrictToUserList?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponEdge'] = ResolversParentTypes['CouponEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponMaxAggregates'] = ResolversParentTypes['CouponMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponMinAggregates'] = ResolversParentTypes['CouponMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatform'] = ResolversParentTypes['CouponPlatform']> = {
  coupon?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponRedemptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponRedemption'] = ResolversParentTypes['CouponRedemption']> = {
  coupon?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponStddevPopulationAggregates'] = ResolversParentTypes['CouponStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponStddevSampleAggregates'] = ResolversParentTypes['CouponStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponSumAggregates'] = ResolversParentTypes['CouponSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxUseTotal?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxUseUser?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  productCategoryId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  resetCreditAmount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  restrictToUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUser'] = ResolversParentTypes['CouponUser']> = {
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxRedemptions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  redemptions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserAggregates'] = ResolversParentTypes['CouponUserAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['CouponUserAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['CouponUserDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['CouponUserMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CouponUserMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['CouponUserStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['CouponUserStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['CouponUserSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['CouponUserVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['CouponUserVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserAverageAggregates'] = ResolversParentTypes['CouponUserAverageAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserConnection'] = ResolversParentTypes['CouponUserConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['CouponUserAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['CouponUserEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['CouponUserAggregates']>>, ParentType, ContextType, RequireFields<CouponUserConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['CouponUser']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserDistinctCountAggregates'] = ResolversParentTypes['CouponUserDistinctCountAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserEdge'] = ResolversParentTypes['CouponUserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CouponUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserMaxAggregates'] = ResolversParentTypes['CouponUserMaxAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserMinAggregates'] = ResolversParentTypes['CouponUserMinAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserStddevPopulationAggregates'] = ResolversParentTypes['CouponUserStddevPopulationAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserStddevSampleAggregates'] = ResolversParentTypes['CouponUserStddevSampleAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserSumAggregates'] = ResolversParentTypes['CouponUserSumAggregates']> = {
  couponId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxRedemptions?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  redemptions?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserVariancePopulationAggregates'] = ResolversParentTypes['CouponUserVariancePopulationAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUserVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUserVarianceSampleAggregates'] = ResolversParentTypes['CouponUserVarianceSampleAggregates']> = {
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  redemptions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponVariancePopulationAggregates'] = ResolversParentTypes['CouponVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponVarianceSampleAggregates'] = ResolversParentTypes['CouponVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxUseUser?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetCreditAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  restrictToUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateImpactGroupAssignmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateImpactGroupAssignmentPayload'] = ResolversParentTypes['CreateImpactGroupAssignmentPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impactGroupAssignment?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType>;
  impactGroupAssignmentEdge?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentEdge']>, ParentType, ContextType, RequireFields<CreateImpactGroupAssignmentPayloadImpactGroupAssignmentEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateImpactGroupTemplatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateImpactGroupTemplatePayload'] = ResolversParentTypes['CreateImpactGroupTemplatePayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impactGroupTemplate?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType>;
  impactGroupTemplateEdge?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateEdge']>, ParentType, ContextType, RequireFields<CreateImpactGroupTemplatePayloadImpactGroupTemplateEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateKycPriorityLabelPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateKycPriorityLabelPayload'] = ResolversParentTypes['CreateKycPriorityLabelPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kycPriorityLabel?: Resolver<Maybe<ResolversTypes['KycPriorityLabel']>, ParentType, ContextType>;
  kycPriorityLabelEdge?: Resolver<Maybe<ResolversTypes['KycPriorityLabelEdge']>, ParentType, ContextType, RequireFields<CreateKycPriorityLabelPayloadKycPriorityLabelEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateKycPriorityReviewConfigPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateKycPriorityReviewConfigPayload'] = ResolversParentTypes['CreateKycPriorityReviewConfigPayload']> = {
  activeLabels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  savedByUserId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTraderRiskIndicatorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTraderRiskIndicatorPayload'] = ResolversParentTypes['CreateTraderRiskIndicatorPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  traderRiskIndicator?: Resolver<Maybe<ResolversTypes['TraderRiskIndicator']>, ParentType, ContextType>;
  traderRiskIndicatorEdge?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorEdge']>, ParentType, ContextType, RequireFields<CreateTraderRiskIndicatorPayloadTraderRiskIndicatorEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTradingProductFeePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTradingProductFeePayload'] = ResolversParentTypes['CreateTradingProductFeePayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  tradingProductFee?: Resolver<Maybe<ResolversTypes['TradingProductFee']>, ParentType, ContextType>;
  tradingProductFeeEdge?: Resolver<Maybe<ResolversTypes['TradingProductFeeEdge']>, ParentType, ContextType, RequireFields<CreateTradingProductFeePayloadTradingProductFeeEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserAddressPayload'] = ResolversParentTypes['CreateUserAddressPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  userAddress?: Resolver<Maybe<ResolversTypes['UserAddress']>, ParentType, ContextType>;
  userAddressEdge?: Resolver<Maybe<ResolversTypes['UserAddressEdge']>, ParentType, ContextType, RequireFields<CreateUserAddressPayloadUserAddressEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserTaxFormPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserTaxFormPayload'] = ResolversParentTypes['CreateUserTaxFormPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  userTaxForm?: Resolver<Maybe<ResolversTypes['UserTaxForm']>, ParentType, ContextType>;
  userTaxFormEdge?: Resolver<Maybe<ResolversTypes['UserTaxFormEdge']>, ParentType, ContextType, RequireFields<CreateUserTaxFormPayloadUserTaxFormEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateXfaActivationCreditPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateXfaActivationCreditPayload'] = ResolversParentTypes['CreateXfaActivationCreditPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  xfaActivationCredit?: Resolver<Maybe<ResolversTypes['XfaActivationCredit']>, ParentType, ContextType>;
  xfaActivationCreditEdge?: Resolver<Maybe<ResolversTypes['XfaActivationCreditEdge']>, ParentType, ContextType, RequireFields<CreateXfaActivationCreditPayloadXfaActivationCreditEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentAdminRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentAdminRole'] = ResolversParentTypes['CurrentAdminRole']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CursorScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Cursor'], any> {
  name: 'Cursor';
}

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DatetimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Datetime'], any> {
  name: 'Datetime';
}

export type DeleteImpactGroupAssignmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteImpactGroupAssignmentPayload'] = ResolversParentTypes['DeleteImpactGroupAssignmentPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedImpactGroupAssignmentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  impactGroupAssignment?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType>;
  impactGroupAssignmentEdge?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentEdge']>, ParentType, ContextType, RequireFields<DeleteImpactGroupAssignmentPayloadImpactGroupAssignmentEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteKycPriorityLabelPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteKycPriorityLabelPayload'] = ResolversParentTypes['DeleteKycPriorityLabelPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedKycPriorityLabelId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  kycPriorityLabel?: Resolver<Maybe<ResolversTypes['KycPriorityLabel']>, ParentType, ContextType>;
  kycPriorityLabelEdge?: Resolver<Maybe<ResolversTypes['KycPriorityLabelEdge']>, ParentType, ContextType, RequireFields<DeleteKycPriorityLabelPayloadKycPriorityLabelEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserAddressPayload'] = ResolversParentTypes['DeleteUserAddressPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedUserAddressId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  userAddress?: Resolver<Maybe<ResolversTypes['UserAddress']>, ParentType, ContextType>;
  userAddressEdge?: Resolver<Maybe<ResolversTypes['UserAddressEdge']>, ParentType, ContextType, RequireFields<DeleteUserAddressPayloadUserAddressEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteXfaActivationCreditPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteXfaActivationCreditPayload'] = ResolversParentTypes['DeleteXfaActivationCreditPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedXfaActivationCreditId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  xfaActivationCredit?: Resolver<Maybe<ResolversTypes['XfaActivationCredit']>, ParentType, ContextType>;
  xfaActivationCreditEdge?: Resolver<Maybe<ResolversTypes['XfaActivationCreditEdge']>, ParentType, ContextType, RequireFields<DeleteXfaActivationCreditPayloadXfaActivationCreditEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscordLinkUrlPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscordLinkUrlPayload'] = ResolversParentTypes['DiscordLinkUrlPayload']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DllDailyMetricsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DllDailyMetrics'] = ResolversParentTypes['DllDailyMetrics']> = {
  dailyDrawdownLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lossToday?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  percentageUsed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  remainingToday?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocuSignAuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocuSignAuthResult'] = ResolversParentTypes['DocuSignAuthResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocuSignEnvelopeStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocuSignEnvelopeStatusResult'] = ResolversParentTypes['DocuSignEnvelopeStatusResult']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusDateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Email'] = ResolversParentTypes['Email']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  emailActions?: Resolver<ResolversTypes['EmailActionConnection'], ParentType, ContextType, RequireFields<EmailEmailActionsArgs, 'orderBy'>>;
  emailJsonBody?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idempotencyKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastClicked?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  lastOpened?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  mailGunStorageKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mailgunId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAction'] = ResolversParentTypes['EmailAction']> = {
  actionTime?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  actionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['Email']>, ParentType, ContextType>;
  emailId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userBrowser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionAggregates'] = ResolversParentTypes['EmailActionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['EmailActionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['EmailActionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['EmailActionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailActionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['EmailActionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['EmailActionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['EmailActionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['EmailActionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['EmailActionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionAverageAggregates'] = ResolversParentTypes['EmailActionAverageAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionConnection'] = ResolversParentTypes['EmailActionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['EmailActionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['EmailActionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['EmailActionAggregates']>>, ParentType, ContextType, RequireFields<EmailActionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['EmailAction']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionDistinctCountAggregates'] = ResolversParentTypes['EmailActionDistinctCountAggregates']> = {
  actionTime?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  actionType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userBrowser?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userIp?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userLocation?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionEdge'] = ResolversParentTypes['EmailActionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EmailAction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionMaxAggregates'] = ResolversParentTypes['EmailActionMaxAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionMinAggregates'] = ResolversParentTypes['EmailActionMinAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionStddevPopulationAggregates'] = ResolversParentTypes['EmailActionStddevPopulationAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionStddevSampleAggregates'] = ResolversParentTypes['EmailActionStddevSampleAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionSumAggregates'] = ResolversParentTypes['EmailActionSumAggregates']> = {
  emailId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionVariancePopulationAggregates'] = ResolversParentTypes['EmailActionVariancePopulationAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailActionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailActionVarianceSampleAggregates'] = ResolversParentTypes['EmailActionVarianceSampleAggregates']> = {
  emailId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAggregates'] = ResolversParentTypes['EmailAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['EmailAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['EmailDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['EmailMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['EmailStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['EmailStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['EmailSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['EmailVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['EmailVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAverageAggregates'] = ResolversParentTypes['EmailAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailConnection'] = ResolversParentTypes['EmailConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['EmailAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['EmailEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['EmailAggregates']>>, ParentType, ContextType, RequireFields<EmailConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Email']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailDistinctCountAggregates'] = ResolversParentTypes['EmailDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  emailJsonBody?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  idempotencyKey?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastClicked?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastOpened?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  mailGunStorageKey?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  mailgunId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailEdge'] = ResolversParentTypes['EmailEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Email']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailMaxAggregates'] = ResolversParentTypes['EmailMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailMinAggregates'] = ResolversParentTypes['EmailMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailStddevPopulationAggregates'] = ResolversParentTypes['EmailStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailStddevSampleAggregates'] = ResolversParentTypes['EmailStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailSumAggregates'] = ResolversParentTypes['EmailSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailVariancePopulationAggregates'] = ResolversParentTypes['EmailVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailVarianceSampleAggregates'] = ResolversParentTypes['EmailVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOrCreateUserTaxFormResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOrCreateUserTaxFormResult'] = ResolversParentTypes['GetOrCreateUserTaxFormResult']> = {
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docusignEnvelopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  formType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = {
  groupAdmins?: Resolver<ResolversTypes['GroupAdminConnection'], ParentType, ContextType, RequireFields<GroupGroupAdminsArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdmin'] = ResolversParentTypes['GroupAdmin']> = {
  group?: Resolver<Maybe<ResolversTypes['Group']>, ParentType, ContextType>;
  groupId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminAggregates'] = ResolversParentTypes['GroupAdminAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['GroupAdminAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['GroupAdminDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['GroupAdminMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GroupAdminMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['GroupAdminStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['GroupAdminStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GroupAdminSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['GroupAdminVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['GroupAdminVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminAverageAggregates'] = ResolversParentTypes['GroupAdminAverageAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminConnection'] = ResolversParentTypes['GroupAdminConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['GroupAdminAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['GroupAdminEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['GroupAdminAggregates']>>, ParentType, ContextType, RequireFields<GroupAdminConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['GroupAdmin']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminDistinctCountAggregates'] = ResolversParentTypes['GroupAdminDistinctCountAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminEdge'] = ResolversParentTypes['GroupAdminEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['GroupAdmin']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminMaxAggregates'] = ResolversParentTypes['GroupAdminMaxAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminMinAggregates'] = ResolversParentTypes['GroupAdminMinAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminStddevPopulationAggregates'] = ResolversParentTypes['GroupAdminStddevPopulationAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminStddevSampleAggregates'] = ResolversParentTypes['GroupAdminStddevSampleAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminSumAggregates'] = ResolversParentTypes['GroupAdminSumAggregates']> = {
  groupId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminVariancePopulationAggregates'] = ResolversParentTypes['GroupAdminVariancePopulationAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAdminVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAdminVarianceSampleAggregates'] = ResolversParentTypes['GroupAdminVarianceSampleAggregates']> = {
  groupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAggregates'] = ResolversParentTypes['GroupAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['GroupAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['GroupDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['GroupMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GroupMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['GroupStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['GroupStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GroupSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['GroupVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['GroupVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupAverageAggregates'] = ResolversParentTypes['GroupAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupConnection'] = ResolversParentTypes['GroupConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['GroupAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['GroupEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Group']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupDistinctCountAggregates'] = ResolversParentTypes['GroupDistinctCountAggregates']> = {
  name?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEdge'] = ResolversParentTypes['GroupEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Group']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupMaxAggregates'] = ResolversParentTypes['GroupMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupMinAggregates'] = ResolversParentTypes['GroupMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupStddevPopulationAggregates'] = ResolversParentTypes['GroupStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupStddevSampleAggregates'] = ResolversParentTypes['GroupStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupSumAggregates'] = ResolversParentTypes['GroupSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupVariancePopulationAggregates'] = ResolversParentTypes['GroupVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupVarianceSampleAggregates'] = ResolversParentTypes['GroupVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignment'] = ResolversParentTypes['ImpactGroupAssignment']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  assignedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  assignedByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  assignmentExpiresAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dismissedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dynamicMessageContent?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impactGroup?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType>;
  impactGroupId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentAggregates'] = ResolversParentTypes['ImpactGroupAssignmentAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentAverageAggregates'] = ResolversParentTypes['ImpactGroupAssignmentAverageAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentConnection'] = ResolversParentTypes['ImpactGroupAssignmentConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ImpactGroupAssignmentEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ImpactGroupAssignmentAggregates']>>, ParentType, ContextType, RequireFields<ImpactGroupAssignmentConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ImpactGroupAssignment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentDistinctCountAggregates'] = ResolversParentTypes['ImpactGroupAssignmentDistinctCountAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  assignedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  assignmentExpiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dismissedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dynamicMessageContent?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentEdge'] = ResolversParentTypes['ImpactGroupAssignmentEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentMaxAggregates'] = ResolversParentTypes['ImpactGroupAssignmentMaxAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentMinAggregates'] = ResolversParentTypes['ImpactGroupAssignmentMinAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentStddevPopulationAggregates'] = ResolversParentTypes['ImpactGroupAssignmentStddevPopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentStddevSampleAggregates'] = ResolversParentTypes['ImpactGroupAssignmentStddevSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentSumAggregates'] = ResolversParentTypes['ImpactGroupAssignmentSumAggregates']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  assignedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  impactGroupId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentVariancePopulationAggregates'] = ResolversParentTypes['ImpactGroupAssignmentVariancePopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupAssignmentVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupAssignmentVarianceSampleAggregates'] = ResolversParentTypes['ImpactGroupAssignmentVarianceSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  assignedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impactGroupId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplate'] = ResolversParentTypes['ImpactGroupTemplate']> = {
  actionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impactGroupAssignments?: Resolver<ResolversTypes['ImpactGroupAssignmentConnection'], ParentType, ContextType, RequireFields<ImpactGroupTemplateImpactGroupAssignmentsArgs, 'orderBy'>>;
  impactGroupAssignmentsList?: Resolver<Array<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType, Partial<ImpactGroupTemplateImpactGroupAssignmentsListArgs>>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateExpiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateAggregates'] = ResolversParentTypes['ImpactGroupTemplateAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateAverageAggregates'] = ResolversParentTypes['ImpactGroupTemplateAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateConnection'] = ResolversParentTypes['ImpactGroupTemplateConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ImpactGroupTemplateEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ImpactGroupTemplateAggregates']>>, ParentType, ContextType, RequireFields<ImpactGroupTemplateConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ImpactGroupTemplate']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateDistinctCountAggregates'] = ResolversParentTypes['ImpactGroupTemplateDistinctCountAggregates']> = {
  actionUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notificationMessage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  templateExpiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateEdge'] = ResolversParentTypes['ImpactGroupTemplateEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateMaxAggregates'] = ResolversParentTypes['ImpactGroupTemplateMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateMinAggregates'] = ResolversParentTypes['ImpactGroupTemplateMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateStddevPopulationAggregates'] = ResolversParentTypes['ImpactGroupTemplateStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateStddevSampleAggregates'] = ResolversParentTypes['ImpactGroupTemplateStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateSumAggregates'] = ResolversParentTypes['ImpactGroupTemplateSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateVariancePopulationAggregates'] = ResolversParentTypes['ImpactGroupTemplateVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactGroupTemplateVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactGroupTemplateVarianceSampleAggregates'] = ResolversParentTypes['ImpactGroupTemplateVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateAdminPayoutRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateAdminPayoutRequestPayload'] = ResolversParentTypes['InitiateAdminPayoutRequestPayload']> = {
  adminInitiated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntervalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Interval'] = ResolversParentTypes['Interval']> = {
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  months?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seconds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  years?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidateUserTaxFormEventLogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidateUserTaxFormEventLogResult'] = ResolversParentTypes['InvalidateUserTaxFormEventLogResult']> = {
  bypassRevokedIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  invalidatedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  repairedIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  voidedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type KycPriorityLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabel'] = ResolversParentTypes['KycPriorityLabel']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kycPriorityReviewConfigLabels?: Resolver<ResolversTypes['KycPriorityReviewConfigLabelConnection'], ParentType, ContextType, RequireFields<KycPriorityLabelKycPriorityReviewConfigLabelsArgs, 'orderBy'>>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['KycPriorityTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelAggregates'] = ResolversParentTypes['KycPriorityLabelAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['KycPriorityLabelAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['KycPriorityLabelDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['KycPriorityLabelMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['KycPriorityLabelMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['KycPriorityLabelStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['KycPriorityLabelStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['KycPriorityLabelSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['KycPriorityLabelVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['KycPriorityLabelVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelAverageAggregates'] = ResolversParentTypes['KycPriorityLabelAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelConnection'] = ResolversParentTypes['KycPriorityLabelConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['KycPriorityLabelAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['KycPriorityLabelEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['KycPriorityLabelAggregates']>>, ParentType, ContextType, RequireFields<KycPriorityLabelConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['KycPriorityLabel']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelDistinctCountAggregates'] = ResolversParentTypes['KycPriorityLabelDistinctCountAggregates']> = {
  category?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelEdge'] = ResolversParentTypes['KycPriorityLabelEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['KycPriorityLabel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelMaxAggregates'] = ResolversParentTypes['KycPriorityLabelMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelMinAggregates'] = ResolversParentTypes['KycPriorityLabelMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelStddevPopulationAggregates'] = ResolversParentTypes['KycPriorityLabelStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelStddevSampleAggregates'] = ResolversParentTypes['KycPriorityLabelStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelSumAggregates'] = ResolversParentTypes['KycPriorityLabelSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelVariancePopulationAggregates'] = ResolversParentTypes['KycPriorityLabelVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityLabelVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityLabelVarianceSampleAggregates'] = ResolversParentTypes['KycPriorityLabelVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfig'] = ResolversParentTypes['KycPriorityReviewConfig']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kycPriorityReviewConfigLabels?: Resolver<ResolversTypes['KycPriorityReviewConfigLabelConnection'], ParentType, ContextType, RequireFields<KycPriorityReviewConfigKycPriorityReviewConfigLabelsArgs, 'orderBy'>>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  savedByUserId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['KycPriorityTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigAggregates'] = ResolversParentTypes['KycPriorityReviewConfigAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigAverageAggregates'] = ResolversParentTypes['KycPriorityReviewConfigAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigConnection'] = ResolversParentTypes['KycPriorityReviewConfigConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['KycPriorityReviewConfigEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['KycPriorityReviewConfigAggregates']>>, ParentType, ContextType, RequireFields<KycPriorityReviewConfigConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['KycPriorityReviewConfig']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigDistinctCountAggregates'] = ResolversParentTypes['KycPriorityReviewConfigDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigEdge'] = ResolversParentTypes['KycPriorityReviewConfigEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabel'] = ResolversParentTypes['KycPriorityReviewConfigLabel']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kycPriorityLabel?: Resolver<Maybe<ResolversTypes['KycPriorityLabel']>, ParentType, ContextType>;
  kycPriorityLabelId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kycPriorityReviewConfig?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfig']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelAverageAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelAverageAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelConnection'] = ResolversParentTypes['KycPriorityReviewConfigLabelConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabelAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['KycPriorityReviewConfigLabelEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['KycPriorityReviewConfigLabelAggregates']>>, ParentType, ContextType, RequireFields<KycPriorityReviewConfigLabelConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['KycPriorityReviewConfigLabel']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelDistinctCountAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelDistinctCountAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelEdge'] = ResolversParentTypes['KycPriorityReviewConfigLabelEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigLabel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelMaxAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelMaxAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelMinAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelMinAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelStddevPopulationAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelStddevPopulationAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelStddevSampleAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelStddevSampleAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelSumAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelSumAggregates']> = {
  kycPriorityLabelId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelVariancePopulationAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelVariancePopulationAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigLabelVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigLabelVarianceSampleAggregates'] = ResolversParentTypes['KycPriorityReviewConfigLabelVarianceSampleAggregates']> = {
  kycPriorityLabelId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  kycPriorityReviewConfigId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigMaxAggregates'] = ResolversParentTypes['KycPriorityReviewConfigMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigMinAggregates'] = ResolversParentTypes['KycPriorityReviewConfigMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigStddevPopulationAggregates'] = ResolversParentTypes['KycPriorityReviewConfigStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigStddevSampleAggregates'] = ResolversParentTypes['KycPriorityReviewConfigStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigSumAggregates'] = ResolversParentTypes['KycPriorityReviewConfigSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  savedByUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigVariancePopulationAggregates'] = ResolversParentTypes['KycPriorityReviewConfigVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycPriorityReviewConfigVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycPriorityReviewConfigVarianceSampleAggregates'] = ResolversParentTypes['KycPriorityReviewConfigVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedByUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LfaSplashStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['LfaSplashStatus'] = ResolversParentTypes['LfaSplashStatus']> = {
  lfaSplashSeenAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shouldShow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiteLlmBlockedTermCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiteLlmBlockedTermCandidate'] = ResolversParentTypes['LiteLlmBlockedTermCandidate']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  firstSeenAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  normalizedHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  occurrenceCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  proposedPrUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LitellmBlockedTermCandidateStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveStreamStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveStreamStatus'] = ResolversParentTypes['LiveStreamStatus']> = {
  isLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveTradePairingResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveTradePairing'] = ResolversParentTypes['LiveTradePairing']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  closeAction?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  closePrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  closePriceOld?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  closeTimeStamp?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  closeTradeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  contractName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  openAction?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  openPriceOld?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  openTimeStamp?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  openTradeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  pairedLots?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  pnl?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickSizeOld?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tradeDay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MigrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Migration'] = ResolversParentTypes['Migration']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addCaseBanNote?: Resolver<ResolversTypes['CaseBanEventResult'], ParentType, ContextType, RequireFields<MutationAddCaseBanNoteArgs, 'input'>>;
  addCaseBanTraders?: Resolver<Array<ResolversTypes['CaseBanTraderResult']>, ParentType, ContextType, RequireFields<MutationAddCaseBanTradersArgs, 'input'>>;
  addCaseInvestigationNote?: Resolver<ResolversTypes['CaseInvestigationEventResult'], ParentType, ContextType, RequireFields<MutationAddCaseInvestigationNoteArgs, 'input'>>;
  addCaseInvestigationTraders?: Resolver<Array<ResolversTypes['CaseInvestigationTraderResult']>, ParentType, ContextType, RequireFields<MutationAddCaseInvestigationTradersArgs, 'input'>>;
  bulkUploadAccountCapitalEntries?: Resolver<Maybe<ResolversTypes['BulkCapitalUploadPayload']>, ParentType, ContextType, RequireFields<MutationBulkUploadAccountCapitalEntriesArgs, 'input'>>;
  bypassUserTaxFormValidation?: Resolver<ResolversTypes['BypassUserTaxFormValidationResult'], ParentType, ContextType, RequireFields<MutationBypassUserTaxFormValidationArgs, 'input'>>;
  cancelCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationCancelCaseBanArgs, 'id'>>;
  cancelCaseInvestigation?: Resolver<ResolversTypes['CaseInvestigationResult'], ParentType, ContextType, RequireFields<MutationCancelCaseInvestigationArgs, 'id'>>;
  closeCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationCloseCaseBanArgs, 'id'>>;
  closeCaseInvestigation?: Resolver<ResolversTypes['CaseInvestigationResult'], ParentType, ContextType, RequireFields<MutationCloseCaseInvestigationArgs, 'id'>>;
  correctAccountCapitalEntry?: Resolver<Maybe<ResolversTypes['AccountCapitalMutationPayload']>, ParentType, ContextType, RequireFields<MutationCorrectAccountCapitalEntryArgs, 'input'>>;
  createAccountCapitalEntry?: Resolver<Maybe<ResolversTypes['AccountCapitalMutationPayload']>, ParentType, ContextType, RequireFields<MutationCreateAccountCapitalEntryArgs, 'input'>>;
  createCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationCreateCaseBanArgs, 'input'>>;
  createCaseInvestigation?: Resolver<ResolversTypes['CaseInvestigationResult'], ParentType, ContextType, RequireFields<MutationCreateCaseInvestigationArgs, 'input'>>;
  createCaseType?: Resolver<ResolversTypes['CaseType'], ParentType, ContextType, RequireFields<MutationCreateCaseTypeArgs, 'input'>>;
  createImpactGroupAssignment?: Resolver<Maybe<ResolversTypes['CreateImpactGroupAssignmentPayload']>, ParentType, ContextType, RequireFields<MutationCreateImpactGroupAssignmentArgs, 'input'>>;
  createImpactGroupTemplate?: Resolver<Maybe<ResolversTypes['CreateImpactGroupTemplatePayload']>, ParentType, ContextType, RequireFields<MutationCreateImpactGroupTemplateArgs, 'input'>>;
  createKycPriorityLabel?: Resolver<Maybe<ResolversTypes['CreateKycPriorityLabelPayload']>, ParentType, ContextType, RequireFields<MutationCreateKycPriorityLabelArgs, 'input'>>;
  createKycPriorityReviewConfig?: Resolver<Maybe<ResolversTypes['CreateKycPriorityReviewConfigPayload']>, ParentType, ContextType, RequireFields<MutationCreateKycPriorityReviewConfigArgs, 'input'>>;
  createReasonCode?: Resolver<ResolversTypes['ReasonCode'], ParentType, ContextType, RequireFields<MutationCreateReasonCodeArgs, 'input'>>;
  createTraderRiskIndicator?: Resolver<Maybe<ResolversTypes['CreateTraderRiskIndicatorPayload']>, ParentType, ContextType, RequireFields<MutationCreateTraderRiskIndicatorArgs, 'input'>>;
  createTradingProductFee?: Resolver<Maybe<ResolversTypes['CreateTradingProductFeePayload']>, ParentType, ContextType, RequireFields<MutationCreateTradingProductFeeArgs, 'input'>>;
  createUserAddress?: Resolver<Maybe<ResolversTypes['CreateUserAddressPayload']>, ParentType, ContextType, RequireFields<MutationCreateUserAddressArgs, 'input'>>;
  createUserTaxForm?: Resolver<Maybe<ResolversTypes['CreateUserTaxFormPayload']>, ParentType, ContextType, RequireFields<MutationCreateUserTaxFormArgs, 'input'>>;
  createXfaActivationCredit?: Resolver<Maybe<ResolversTypes['CreateXfaActivationCreditPayload']>, ParentType, ContextType, RequireFields<MutationCreateXfaActivationCreditArgs, 'input'>>;
  deleteImpactGroupAssignment?: Resolver<Maybe<ResolversTypes['DeleteImpactGroupAssignmentPayload']>, ParentType, ContextType, RequireFields<MutationDeleteImpactGroupAssignmentArgs, 'input'>>;
  deleteImpactGroupAssignmentById?: Resolver<Maybe<ResolversTypes['DeleteImpactGroupAssignmentPayload']>, ParentType, ContextType, RequireFields<MutationDeleteImpactGroupAssignmentByIdArgs, 'input'>>;
  deleteKycPriorityLabel?: Resolver<Maybe<ResolversTypes['DeleteKycPriorityLabelPayload']>, ParentType, ContextType, RequireFields<MutationDeleteKycPriorityLabelArgs, 'input'>>;
  deleteKycPriorityLabelById?: Resolver<Maybe<ResolversTypes['DeleteKycPriorityLabelPayload']>, ParentType, ContextType, RequireFields<MutationDeleteKycPriorityLabelByIdArgs, 'input'>>;
  deleteUserAddress?: Resolver<Maybe<ResolversTypes['DeleteUserAddressPayload']>, ParentType, ContextType, RequireFields<MutationDeleteUserAddressArgs, 'input'>>;
  deleteUserAddressById?: Resolver<Maybe<ResolversTypes['DeleteUserAddressPayload']>, ParentType, ContextType, RequireFields<MutationDeleteUserAddressByIdArgs, 'input'>>;
  deleteXfaActivationCredit?: Resolver<Maybe<ResolversTypes['DeleteXfaActivationCreditPayload']>, ParentType, ContextType, RequireFields<MutationDeleteXfaActivationCreditArgs, 'input'>>;
  deleteXfaActivationCreditById?: Resolver<Maybe<ResolversTypes['DeleteXfaActivationCreditPayload']>, ParentType, ContextType, RequireFields<MutationDeleteXfaActivationCreditByIdArgs, 'input'>>;
  getOrCreateUserTaxForm?: Resolver<ResolversTypes['GetOrCreateUserTaxFormResult'], ParentType, ContextType, RequireFields<MutationGetOrCreateUserTaxFormArgs, 'input'>>;
  holdCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationHoldCaseBanArgs, 'id'>>;
  holdCaseInvestigation?: Resolver<ResolversTypes['CaseInvestigationResult'], ParentType, ContextType, RequireFields<MutationHoldCaseInvestigationArgs, 'id'>>;
  initiateAdminPayoutRequest?: Resolver<Maybe<ResolversTypes['InitiateAdminPayoutRequestPayload']>, ParentType, ContextType, RequireFields<MutationInitiateAdminPayoutRequestArgs, 'input'>>;
  invalidateUserTaxFormEventLog?: Resolver<ResolversTypes['InvalidateUserTaxFormEventLogResult'], ParentType, ContextType, RequireFields<MutationInvalidateUserTaxFormEventLogArgs, 'input'>>;
  markAsChargeback?: Resolver<ResolversTypes['ChargebackResult'], ParentType, ContextType, RequireFields<MutationMarkAsChargebackArgs, 'input'>>;
  publishMyTraderPublicProfile?: Resolver<ResolversTypes['UpdateMyTraderPublicProfilePayload'], ParentType, ContextType>;
  recordLfaSplashView?: Resolver<Maybe<ResolversTypes['RecordLfaSplashViewPayload']>, ParentType, ContextType, RequireFields<MutationRecordLfaSplashViewArgs, 'input'>>;
  recordReflectionView?: Resolver<Maybe<ResolversTypes['RecordReflectionViewPayload']>, ParentType, ContextType, RequireFields<MutationRecordReflectionViewArgs, 'input'>>;
  removeCaseBanTraders?: Resolver<ResolversTypes['CaseBanTradersRemovedResult'], ParentType, ContextType, RequireFields<MutationRemoveCaseBanTradersArgs, 'input'>>;
  removeCaseInvestigationTraders?: Resolver<ResolversTypes['CaseInvestigationTradersRemovedResult'], ParentType, ContextType, RequireFields<MutationRemoveCaseInvestigationTradersArgs, 'input'>>;
  resumeCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationResumeCaseBanArgs, 'id'>>;
  resumeCaseInvestigation?: Resolver<ResolversTypes['CaseInvestigationResult'], ParentType, ContextType, RequireFields<MutationResumeCaseInvestigationArgs, 'id'>>;
  revokeUserTaxFormValidationBypass?: Resolver<ResolversTypes['RevokeUserTaxFormValidationBypassResult'], ParentType, ContextType, RequireFields<MutationRevokeUserTaxFormValidationBypassArgs, 'input'>>;
  setCaseBanPendingStatus?: Resolver<Array<ResolversTypes['CaseBanTraderResult']>, ParentType, ContextType, RequireFields<MutationSetCaseBanPendingStatusArgs, 'input'>>;
  setCaseBanTraderIdvLink?: Resolver<ResolversTypes['CaseBanTraderResult'], ParentType, ContextType, RequireFields<MutationSetCaseBanTraderIdvLinkArgs, 'input'>>;
  setCaseBanTraderIntercomLink?: Resolver<ResolversTypes['CaseBanTraderResult'], ParentType, ContextType, RequireFields<MutationSetCaseBanTraderIntercomLinkArgs, 'input'>>;
  setCaseInvestigationPendingStatus?: Resolver<Array<ResolversTypes['CaseInvestigationTraderResult']>, ParentType, ContextType, RequireFields<MutationSetCaseInvestigationPendingStatusArgs, 'input'>>;
  setCaseInvestigationTraderIdvLink?: Resolver<ResolversTypes['CaseInvestigationTraderResult'], ParentType, ContextType, RequireFields<MutationSetCaseInvestigationTraderIdvLinkArgs, 'input'>>;
  setCaseInvestigationTraderIntercomLink?: Resolver<ResolversTypes['CaseInvestigationTraderResult'], ParentType, ContextType, RequireFields<MutationSetCaseInvestigationTraderIntercomLinkArgs, 'input'>>;
  startW8BENSigning?: Resolver<ResolversTypes['W8BENSigningResult'], ParentType, ContextType, RequireFields<MutationStartW8BenSigningArgs, 'input'>>;
  startW9Signing?: Resolver<ResolversTypes['W9SigningResult'], ParentType, ContextType, RequireFields<MutationStartW9SigningArgs, 'input'>>;
  submitCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationSubmitCaseBanArgs, 'input'>>;
  syncDiscordRoles?: Resolver<ResolversTypes['SyncDiscordRolesPayload'], ParentType, ContextType>;
  unlinkDiscord?: Resolver<ResolversTypes['UnlinkDiscordPayload'], ParentType, ContextType>;
  unmarkChargeback?: Resolver<ResolversTypes['ChargebackResult'], ParentType, ContextType, RequireFields<MutationUnmarkChargebackArgs, 'purchaseOrderId'>>;
  unpublishMyTraderPublicProfile?: Resolver<ResolversTypes['UpdateMyTraderPublicProfilePayload'], ParentType, ContextType>;
  unsetCaseBanPendingStatus?: Resolver<Array<ResolversTypes['CaseBanTraderResult']>, ParentType, ContextType, RequireFields<MutationUnsetCaseBanPendingStatusArgs, 'input'>>;
  unsetCaseInvestigationPendingStatus?: Resolver<Array<ResolversTypes['CaseInvestigationTraderResult']>, ParentType, ContextType, RequireFields<MutationUnsetCaseInvestigationPendingStatusArgs, 'input'>>;
  updateAccountStat?: Resolver<Maybe<ResolversTypes['UpdateAccountStatPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAccountStatArgs, 'input'>>;
  updateAccountStatById?: Resolver<Maybe<ResolversTypes['UpdateAccountStatPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAccountStatByIdArgs, 'input'>>;
  updateAdminConfig?: Resolver<Maybe<ResolversTypes['UpdateAdminConfigPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAdminConfigArgs, 'input'>>;
  updateAdminConfigByConfigKey?: Resolver<Maybe<ResolversTypes['UpdateAdminConfigPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAdminConfigByConfigKeyArgs, 'input'>>;
  updateAdminConfigById?: Resolver<Maybe<ResolversTypes['UpdateAdminConfigPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAdminConfigByIdArgs, 'input'>>;
  updateCaseBan?: Resolver<ResolversTypes['CaseBanResult'], ParentType, ContextType, RequireFields<MutationUpdateCaseBanArgs, 'id' | 'input'>>;
  updateCaseInvestigation?: Resolver<ResolversTypes['CaseInvestigationResult'], ParentType, ContextType, RequireFields<MutationUpdateCaseInvestigationArgs, 'id' | 'input'>>;
  updateImpactGroupAssignment?: Resolver<Maybe<ResolversTypes['UpdateImpactGroupAssignmentPayload']>, ParentType, ContextType, RequireFields<MutationUpdateImpactGroupAssignmentArgs, 'input'>>;
  updateImpactGroupAssignmentById?: Resolver<Maybe<ResolversTypes['UpdateImpactGroupAssignmentPayload']>, ParentType, ContextType, RequireFields<MutationUpdateImpactGroupAssignmentByIdArgs, 'input'>>;
  updateImpactGroupTemplate?: Resolver<Maybe<ResolversTypes['UpdateImpactGroupTemplatePayload']>, ParentType, ContextType, RequireFields<MutationUpdateImpactGroupTemplateArgs, 'input'>>;
  updateImpactGroupTemplateById?: Resolver<Maybe<ResolversTypes['UpdateImpactGroupTemplatePayload']>, ParentType, ContextType, RequireFields<MutationUpdateImpactGroupTemplateByIdArgs, 'input'>>;
  updateImpactGroupTemplateByLabelAndScope?: Resolver<Maybe<ResolversTypes['UpdateImpactGroupTemplatePayload']>, ParentType, ContextType, RequireFields<MutationUpdateImpactGroupTemplateByLabelAndScopeArgs, 'input'>>;
  updateImpactGroupTemplateBySlug?: Resolver<Maybe<ResolversTypes['UpdateImpactGroupTemplatePayload']>, ParentType, ContextType, RequireFields<MutationUpdateImpactGroupTemplateBySlugArgs, 'input'>>;
  updateKycPriorityLabel?: Resolver<Maybe<ResolversTypes['UpdateKycPriorityLabelPayload']>, ParentType, ContextType, RequireFields<MutationUpdateKycPriorityLabelArgs, 'input'>>;
  updateKycPriorityLabelById?: Resolver<Maybe<ResolversTypes['UpdateKycPriorityLabelPayload']>, ParentType, ContextType, RequireFields<MutationUpdateKycPriorityLabelByIdArgs, 'input'>>;
  updateMyTraderPublicProfile?: Resolver<ResolversTypes['UpdateMyTraderPublicProfilePayload'], ParentType, ContextType, RequireFields<MutationUpdateMyTraderPublicProfileArgs, 'input'>>;
  updateTraderPublicProfile?: Resolver<Maybe<ResolversTypes['UpdateTraderPublicProfilePayload']>, ParentType, ContextType, RequireFields<MutationUpdateTraderPublicProfileArgs, 'input'>>;
  updateTraderPublicProfileById?: Resolver<Maybe<ResolversTypes['UpdateTraderPublicProfilePayload']>, ParentType, ContextType, RequireFields<MutationUpdateTraderPublicProfileByIdArgs, 'input'>>;
  updateTraderRiskIndicator?: Resolver<Maybe<ResolversTypes['UpdateTraderRiskIndicatorPayload']>, ParentType, ContextType, RequireFields<MutationUpdateTraderRiskIndicatorArgs, 'input'>>;
  updateTraderRiskIndicatorById?: Resolver<Maybe<ResolversTypes['UpdateTraderRiskIndicatorPayload']>, ParentType, ContextType, RequireFields<MutationUpdateTraderRiskIndicatorByIdArgs, 'input'>>;
  updateTradingProductFee?: Resolver<Maybe<ResolversTypes['UpdateTradingProductFeePayload']>, ParentType, ContextType, RequireFields<MutationUpdateTradingProductFeeArgs, 'input'>>;
  updateTradingProductFeeById?: Resolver<Maybe<ResolversTypes['UpdateTradingProductFeePayload']>, ParentType, ContextType, RequireFields<MutationUpdateTradingProductFeeByIdArgs, 'input'>>;
  updateUserAddress?: Resolver<Maybe<ResolversTypes['UpdateUserAddressPayload']>, ParentType, ContextType, RequireFields<MutationUpdateUserAddressArgs, 'input'>>;
  updateUserAddressById?: Resolver<Maybe<ResolversTypes['UpdateUserAddressPayload']>, ParentType, ContextType, RequireFields<MutationUpdateUserAddressByIdArgs, 'input'>>;
  updateUserTaxForm?: Resolver<Maybe<ResolversTypes['UpdateUserTaxFormPayload']>, ParentType, ContextType, RequireFields<MutationUpdateUserTaxFormArgs, 'input'>>;
  updateUserTaxFormById?: Resolver<Maybe<ResolversTypes['UpdateUserTaxFormPayload']>, ParentType, ContextType, RequireFields<MutationUpdateUserTaxFormByIdArgs, 'input'>>;
  updateXfaActivationCredit?: Resolver<Maybe<ResolversTypes['UpdateXfaActivationCreditPayload']>, ParentType, ContextType, RequireFields<MutationUpdateXfaActivationCreditArgs, 'input'>>;
  updateXfaActivationCreditById?: Resolver<Maybe<ResolversTypes['UpdateXfaActivationCreditPayload']>, ParentType, ContextType, RequireFields<MutationUpdateXfaActivationCreditByIdArgs, 'input'>>;
  voidAccountCapitalEntry?: Resolver<Maybe<ResolversTypes['AccountCapitalMutationPayload']>, ParentType, ContextType, RequireFields<MutationVoidAccountCapitalEntryArgs, 'input'>>;
};

export type MyMissingPopcardsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyMissingPopcards'] = ResolversParentTypes['MyMissingPopcards']> = {
  missingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payouts?: Resolver<Array<ResolversTypes['PopcardPayoutCandidate']>, ParentType, ContextType>;
  rollupGroups?: Resolver<Array<ResolversTypes['PopcardRollupGroup']>, ParentType, ContextType>;
  topSixSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyPopcardCandidatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyPopcardCandidates'] = ResolversParentTypes['MyPopcardCandidates']> = {
  payouts?: Resolver<Array<ResolversTypes['PopcardPayoutCandidate']>, ParentType, ContextType>;
  rollupGroups?: Resolver<Array<ResolversTypes['PopcardRollupGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderProfileAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderProfileAsset'] = ResolversParentTypes['MyTraderProfileAsset']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfile'] = ResolversParentTypes['MyTraderPublicProfile']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bannerImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileContent']>, ParentType, ContextType>;
  discordUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isPublished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profileImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicTraderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralCodeExpiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAllTimePayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showBannerOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showProfileImageOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showProfitCalendarOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showProofOfPayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showReferralCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showSocialConnections?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showTradingJourney?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showTradingStatsOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileAllTimePayoutsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileAllTimePayouts'] = ResolversParentTypes['MyTraderPublicProfileAllTimePayouts']> = {
  bestPayout?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  numberOfPayouts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payoutsTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileContent'] = ResolversParentTypes['MyTraderPublicProfileContent']> = {
  allTimePayouts?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileAllTimePayouts']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileHeader']>, ParentType, ContextType>;
  nowTrading?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileNowTrading']>, ParentType, ContextType>;
  proofOfPayoutDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  proofOfPayouts?: Resolver<Maybe<Array<ResolversTypes['MyTraderPublicProfileProofOfPayoutCard']>>, ParentType, ContextType>;
  socialConnections?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileSocialConnections']>, ParentType, ContextType>;
  tradingJourney?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileTradingJourney']>, ParentType, ContextType>;
  tradingStyle?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileTradingStyle']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileHeaderResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileHeader'] = ResolversParentTypes['MyTraderPublicProfileHeader']> = {
  bannerImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTrading'] = ResolversParentTypes['MyTraderPublicProfileNowTrading']> = {
  account?: Resolver<ResolversTypes['MyTraderPublicProfileNowTradingAccount'], ParentType, ContextType>;
  balanceSparkline?: Resolver<Maybe<Array<ResolversTypes['MyTraderPublicProfileNowTradingSparklineDay']>>, ParentType, ContextType>;
  pnlSparkline?: Resolver<Maybe<Array<ResolversTypes['MyTraderPublicProfileNowTradingSparklineDay']>>, ParentType, ContextType>;
  profitCalendar?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileNowTradingProfitCalendar']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileNowTradingStats']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTradingAccount'] = ResolversParentTypes['MyTraderPublicProfileNowTradingAccount']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingCalendarDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTradingCalendarDay'] = ResolversParentTypes['MyTraderPublicProfileNowTradingCalendarDay']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isBestDay?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isWorstDay?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pnl?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingCalendarWeekResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTradingCalendarWeek'] = ResolversParentTypes['MyTraderPublicProfileNowTradingCalendarWeek']> = {
  pnl?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  weekIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingProfitCalendarResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTradingProfitCalendar'] = ResolversParentTypes['MyTraderPublicProfileNowTradingProfitCalendar']> = {
  days?: Resolver<Array<ResolversTypes['MyTraderPublicProfileNowTradingCalendarDay']>, ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  weeks?: Resolver<Array<ResolversTypes['MyTraderPublicProfileNowTradingCalendarWeek']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingSparklineDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTradingSparklineDay'] = ResolversParentTypes['MyTraderPublicProfileNowTradingSparklineDay']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileNowTradingStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileNowTradingStats'] = ResolversParentTypes['MyTraderPublicProfileNowTradingStats']> = {
  averageLoss?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageWin?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  consistencyPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pnl?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeWinPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileProofOfPayoutCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileProofOfPayoutCard'] = ResolversParentTypes['MyTraderPublicProfileProofOfPayoutCard']> = {
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileSocialConnectionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileSocialConnections'] = ResolversParentTypes['MyTraderPublicProfileSocialConnections']> = {
  discordUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileTradingJourneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileTradingJourney'] = ResolversParentTypes['MyTraderPublicProfileTradingJourney']> = {
  expressActivations?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  liveCallUps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  monthJoined?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  passedCombines?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yearJoined?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyTraderPublicProfileTradingStyleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyTraderPublicProfileTradingStyle'] = ResolversParentTypes['MyTraderPublicProfileTradingStyle']> = {
  drawdownType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingMarket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingSession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingSetup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscription'] = ResolversParentTypes['NmiSubscription']> = {
  accountResetTrackingsBySubscriptionId?: Resolver<ResolversTypes['AccountResetTrackingConnection'], ParentType, ContextType, RequireFields<NmiSubscriptionAccountResetTrackingsBySubscriptionIdArgs, 'orderBy'>>;
  accounts?: Resolver<ResolversTypes['AccountConnection'], ParentType, ContextType, RequireFields<NmiSubscriptionAccountsArgs, 'orderBy'>>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  migratedSub?: Resolver<Maybe<ResolversTypes['UserSubscription']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  orderFulfillmentsBySubscriptionId?: Resolver<ResolversTypes['OrderFulfillmentConnection'], ParentType, ContextType, RequireFields<NmiSubscriptionOrderFulfillmentsBySubscriptionIdArgs, 'orderBy'>>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rebillManager?: Resolver<Maybe<ResolversTypes['NmiSubscriptionRebillManagerEnum']>, ParentType, ContextType>;
  rebillManagerMigratedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rebillRefId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rebillSessionsBySubscriptionId?: Resolver<ResolversTypes['RebillSessionConnection'], ParentType, ContextType, RequireFields<NmiSubscriptionRebillSessionsBySubscriptionIdArgs, 'orderBy'>>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  savedCard?: Resolver<Maybe<ResolversTypes['SavedCard']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serviceAccessUntil?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  serviceCancelledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionCancelledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NmiSubscriptionTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionAggregates'] = ResolversParentTypes['NmiSubscriptionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['NmiSubscriptionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['NmiSubscriptionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['NmiSubscriptionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['NmiSubscriptionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['NmiSubscriptionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['NmiSubscriptionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['NmiSubscriptionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['NmiSubscriptionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['NmiSubscriptionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionAverageAggregates'] = ResolversParentTypes['NmiSubscriptionAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionConnection'] = ResolversParentTypes['NmiSubscriptionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['NmiSubscriptionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['NmiSubscriptionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['NmiSubscriptionAggregates']>>, ParentType, ContextType, RequireFields<NmiSubscriptionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['NmiSubscription']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionDistinctCountAggregates'] = ResolversParentTypes['NmiSubscriptionDistinctCountAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rebillManager?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rebillManagerMigratedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rebillRefId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  serviceAccessUntil?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  serviceCancelledAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionCancelledAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionEdge'] = ResolversParentTypes['NmiSubscriptionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NmiSubscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionMaxAggregates'] = ResolversParentTypes['NmiSubscriptionMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionMinAggregates'] = ResolversParentTypes['NmiSubscriptionMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionStddevPopulationAggregates'] = ResolversParentTypes['NmiSubscriptionStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionStddevSampleAggregates'] = ResolversParentTypes['NmiSubscriptionStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionSumAggregates'] = ResolversParentTypes['NmiSubscriptionSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  migratedSubId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  nmiReferenceId?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  savedCardId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  skuId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tax?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionVariancePopulationAggregates'] = ResolversParentTypes['NmiSubscriptionVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NmiSubscriptionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NmiSubscriptionVarianceSampleAggregates'] = ResolversParentTypes['NmiSubscriptionVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  migratedSubId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiReferenceId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  savedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = {
  __resolveType: TypeResolveFn<'Account' | 'AccountAdjustment' | 'AccountAudit' | 'AccountCallUpDecision' | 'AccountCallUpDecisionCalculation' | 'AccountCallUpPayoutOffer' | 'AccountCapitalEntry' | 'AccountLiveCallUp' | 'AccountNote' | 'AccountPassedBinder' | 'AccountPlatformDatum' | 'AccountResetLimit' | 'AccountResetTracking' | 'AccountStat' | 'AccountStatDay' | 'AccountTemplate' | 'AccountTradeArchiveNewId' | 'AccountTradeNat' | 'AccountTradeStatByDay' | 'AccountTradeStatByDayNat' | 'Addon' | 'AdminAudit' | 'AdminConfig' | 'AdminRole' | 'AdminRoleUsersUser' | 'Affiliate' | 'AffiliateAudit' | 'AffiliateCommissionRate' | 'AffiliateLedger' | 'AffiliatePayment' | 'AffiliatePayoutPeriod' | 'AwsdmsChanges3728E4207De1F2E6' | 'AwsdmsDdlAudit' | 'AwsdmsHeartbeat' | 'BatchExecution' | 'BulkAction' | 'CardTransaction' | 'CaseBan' | 'CaseBanReasonCode' | 'CaseBanTrader' | 'CaseEvent' | 'CaseInvestigation' | 'CaseInvestigationSubmittedDepartment' | 'CaseInvestigationTrader' | 'CaseLabel' | 'CaseLabelAssignment' | 'CaseType' | 'Chargeback' | 'ChargebackAdminAction' | 'ChargebackFeedRun' | 'ChargebackFeedSource' | 'ChargebackFeedVersion' | 'ChargebackIndicator' | 'CheckoutItem' | 'CheckoutSession' | 'Coupon' | 'CouponPlatform' | 'CouponRedemption' | 'CouponUser' | 'Email' | 'EmailAction' | 'Group' | 'GroupAdmin' | 'ImpactGroupAssignment' | 'ImpactGroupTemplate' | 'KycPriorityLabel' | 'KycPriorityReviewConfig' | 'KycPriorityReviewConfigLabel' | 'LiteLlmBlockedTermCandidate' | 'LiveTradePairing' | 'Migration' | 'NmiSubscription' | 'NuveiSavedCard' | 'NuveiSavedPaypalArchived' | 'NuveiWebhook' | 'OfacsdnRecord' | 'OrderFulfillment' | 'Outbox' | 'Partner' | 'PartnerTransaction' | 'PasswordHistory' | 'PaymentGateway' | 'PayoutCycle' | 'PayoutDepartmentApproval' | 'PayoutRequest' | 'PayoutRequestAsset' | 'PayoutRequestBatch' | 'PayoutRequestBatchItem' | 'PayoutRequestHistory' | 'PayoutRequestSubscriber' | 'PayoutReturn' | 'PayoutReturnReasonCode' | 'PayoutReview' | 'PayoutReviewer' | 'PaypalTransaction' | 'PersonaWebhookEvent' | 'Platform' | 'Product' | 'ProductCategory' | 'ProfileReport' | 'Purchase' | 'PurchaseItem' | 'PurchaseOrder' | 'Query' | 'ReasonCode' | 'RebillSession' | 'ReferralPurchase' | 'ReferralReward' | 'Refund' | 'RegistrationRiskAssessment' | 'ResetCredit' | 'ResetCreditGrant' | 'RiskyProduct' | 'SavedCard' | 'SkuAccountProvisioningClaim' | 'SkuInventory' | 'SubscriptionDunning' | 'SyncState' | 'TaxInfo' | 'Trade' | 'TraderLockDetail' | 'TraderProfileAsset' | 'TraderProfileModerationBlockedWord' | 'TraderProfileModerationCase' | 'TraderProfileModerationCaseHistory' | 'TraderPublicProfile' | 'TraderRiskIndicator' | 'TraderRiskIndicatorOwner' | 'TradingProduct' | 'TradingProductFee' | 'UnifiedSubscription' | 'User' | 'UserAddon' | 'UserAddress' | 'UserAdminRole' | 'UserAgreement' | 'UserBankingInfo' | 'UserCertificate' | 'UserContactInfo' | 'UserCooldown' | 'UserIntegration' | 'UserMarketDatum' | 'UserMeteredEvent' | 'UserNote' | 'UserPlatformCredential' | 'UserRolesAdminRole' | 'UserSubscription' | 'UserTaxForm' | 'UserTcPurchaseLimit' | 'UserXfaCooldown' | 'Verification' | 'XfaActivationCredit' | 'XfaResetTracking', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type NormalizedPurchasesByUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedPurchasesByUserConnection'] = ResolversParentTypes['NormalizedPurchasesByUserConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['NormalizedPurchasesByUserEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['NormalizedPurchasesByUserRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedPurchasesByUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedPurchasesByUserEdge'] = ResolversParentTypes['NormalizedPurchasesByUserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NormalizedPurchasesByUserRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedPurchasesByUserRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedPurchasesByUserRecord'] = ResolversParentTypes['NormalizedPurchasesByUserRecord']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  fulfillmentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gatewayTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invoiceTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processorTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSavedCardsByUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSavedCardsByUserConnection'] = ResolversParentTypes['NormalizedSavedCardsByUserConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['NormalizedSavedCardsByUserEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['NormalizedSavedCardsByUserRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSavedCardsByUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSavedCardsByUserEdge'] = ResolversParentTypes['NormalizedSavedCardsByUserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NormalizedSavedCardsByUserRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSavedCardsByUserRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSavedCardsByUserRecord'] = ResolversParentTypes['NormalizedSavedCardsByUserRecord']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  defaultCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expirationYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maskedCardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSubsByUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSubsByUserConnection'] = ResolversParentTypes['NormalizedSubsByUserConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['NormalizedSubsByUserEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['NormalizedSubsByUserRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSubsByUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSubsByUserEdge'] = ResolversParentTypes['NormalizedSubsByUserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NormalizedSubsByUserRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSubsByUserRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSubsByUserRecord'] = ResolversParentTypes['NormalizedSubsByUserRecord']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponIsRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  externalProcessor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  selectedPaymentMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceAccessUntil?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionCancelledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSubsDetailedByUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSubsDetailedByUserConnection'] = ResolversParentTypes['NormalizedSubsDetailedByUserConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['NormalizedSubsDetailedByUserEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['NormalizedSubsDetailedByUserRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSubsDetailedByUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSubsDetailedByUserEdge'] = ResolversParentTypes['NormalizedSubsDetailedByUserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NormalizedSubsDetailedByUserRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalizedSubsDetailedByUserRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedSubsDetailedByUserRecord'] = ResolversParentTypes['NormalizedSubsDetailedByUserRecord']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  associatedAccountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  catalogProductName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  catalogProductPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponIsRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  externalProcessor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  recurringCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceAccessUntil?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionCancelledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCard'] = ResolversParentTypes['NuveiSavedCard']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  cvv?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expirationYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userPaymentOptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardAggregates'] = ResolversParentTypes['NuveiSavedCardAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['NuveiSavedCardAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['NuveiSavedCardDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['NuveiSavedCardMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['NuveiSavedCardMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['NuveiSavedCardStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['NuveiSavedCardStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['NuveiSavedCardSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['NuveiSavedCardVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['NuveiSavedCardVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardAverageAggregates'] = ResolversParentTypes['NuveiSavedCardAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardConnection'] = ResolversParentTypes['NuveiSavedCardConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['NuveiSavedCardAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['NuveiSavedCardEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['NuveiSavedCardAggregates']>>, ParentType, ContextType, RequireFields<NuveiSavedCardConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['NuveiSavedCard']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardDistinctCountAggregates'] = ResolversParentTypes['NuveiSavedCardDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cardNumber?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cvv?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  defaultCard?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expirationMonth?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expirationYear?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userPaymentOptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardEdge'] = ResolversParentTypes['NuveiSavedCardEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NuveiSavedCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardMaxAggregates'] = ResolversParentTypes['NuveiSavedCardMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardMinAggregates'] = ResolversParentTypes['NuveiSavedCardMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardStddevPopulationAggregates'] = ResolversParentTypes['NuveiSavedCardStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardStddevSampleAggregates'] = ResolversParentTypes['NuveiSavedCardStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardSumAggregates'] = ResolversParentTypes['NuveiSavedCardSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardVariancePopulationAggregates'] = ResolversParentTypes['NuveiSavedCardVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedCardVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedCardVarianceSampleAggregates'] = ResolversParentTypes['NuveiSavedCardVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiSavedPaypalArchivedResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiSavedPaypalArchived'] = ResolversParentTypes['NuveiSavedPaypalArchived']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userPaymentOptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NuveiWebhookResolvers<ContextType = any, ParentType extends ResolversParentTypes['NuveiWebhook'] = ResolversParentTypes['NuveiWebhook']> = {
  bin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardProcessorStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientUniqueId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  customData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  expMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isReconciled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  merchantUniqueId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameOnCard?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userPaymentOptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecord'] = ResolversParentTypes['OfacsdnRecord']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  s3Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  veriffReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordAggregates'] = ResolversParentTypes['OfacsdnRecordAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['OfacsdnRecordAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['OfacsdnRecordDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['OfacsdnRecordMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OfacsdnRecordMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['OfacsdnRecordStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['OfacsdnRecordStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['OfacsdnRecordSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['OfacsdnRecordVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['OfacsdnRecordVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordAverageAggregates'] = ResolversParentTypes['OfacsdnRecordAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordConnection'] = ResolversParentTypes['OfacsdnRecordConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['OfacsdnRecordAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['OfacsdnRecordEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['OfacsdnRecordAggregates']>>, ParentType, ContextType, RequireFields<OfacsdnRecordConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['OfacsdnRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordDistinctCountAggregates'] = ResolversParentTypes['OfacsdnRecordDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  internalStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  matchStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  s3Url?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  veriffReference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordEdge'] = ResolversParentTypes['OfacsdnRecordEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OfacsdnRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordMaxAggregates'] = ResolversParentTypes['OfacsdnRecordMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordMinAggregates'] = ResolversParentTypes['OfacsdnRecordMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordStddevPopulationAggregates'] = ResolversParentTypes['OfacsdnRecordStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordStddevSampleAggregates'] = ResolversParentTypes['OfacsdnRecordStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordSumAggregates'] = ResolversParentTypes['OfacsdnRecordSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordVariancePopulationAggregates'] = ResolversParentTypes['OfacsdnRecordVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfacsdnRecordVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfacsdnRecordVarianceSampleAggregates'] = ResolversParentTypes['OfacsdnRecordVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillment'] = ResolversParentTypes['OrderFulfillment']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  erpInvoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  fulfillmentStepLockedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  purchaseOrder?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderFulfillmentStatusEnum'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['NmiSubscription']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderFulfillmentTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentAggregates'] = ResolversParentTypes['OrderFulfillmentAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['OrderFulfillmentAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['OrderFulfillmentDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['OrderFulfillmentMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OrderFulfillmentMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['OrderFulfillmentStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['OrderFulfillmentStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['OrderFulfillmentSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['OrderFulfillmentVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['OrderFulfillmentVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentAverageAggregates'] = ResolversParentTypes['OrderFulfillmentAverageAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentConnection'] = ResolversParentTypes['OrderFulfillmentConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['OrderFulfillmentAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['OrderFulfillmentEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['OrderFulfillmentAggregates']>>, ParentType, ContextType, RequireFields<OrderFulfillmentConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['OrderFulfillment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentDistinctCountAggregates'] = ResolversParentTypes['OrderFulfillmentDistinctCountAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  erpInvoiceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  fulfillmentStepLockedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentEdge'] = ResolversParentTypes['OrderFulfillmentEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrderFulfillment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentMaxAggregates'] = ResolversParentTypes['OrderFulfillmentMaxAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentMinAggregates'] = ResolversParentTypes['OrderFulfillmentMinAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentStddevPopulationAggregates'] = ResolversParentTypes['OrderFulfillmentStddevPopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentStddevSampleAggregates'] = ResolversParentTypes['OrderFulfillmentStddevSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentSumAggregates'] = ResolversParentTypes['OrderFulfillmentSumAggregates']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentVariancePopulationAggregates'] = ResolversParentTypes['OrderFulfillmentVariancePopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderFulfillmentVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderFulfillmentVarianceSampleAggregates'] = ResolversParentTypes['OrderFulfillmentVarianceSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutboxResolvers<ContextType = any, ParentType extends ResolversParentTypes['Outbox'] = ResolversParentTypes['Outbox']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nextAttemptAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  retryCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Partner'] = ResolversParentTypes['Partner']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  partnerCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerTransaction'] = ResolversParentTypes['PartnerTransaction']> = {
  compAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  partnerId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistory'] = ResolversParentTypes['PasswordHistory']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  passwordHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryAggregates'] = ResolversParentTypes['PasswordHistoryAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PasswordHistoryAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PasswordHistoryDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PasswordHistoryMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PasswordHistoryMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PasswordHistoryStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PasswordHistoryStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PasswordHistorySumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PasswordHistoryVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PasswordHistoryVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryAverageAggregates'] = ResolversParentTypes['PasswordHistoryAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryConnection'] = ResolversParentTypes['PasswordHistoryConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PasswordHistoryAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PasswordHistoryEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PasswordHistoryAggregates']>>, ParentType, ContextType, RequireFields<PasswordHistoryConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PasswordHistory']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryDistinctCountAggregates'] = ResolversParentTypes['PasswordHistoryDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  passwordHash?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryEdge'] = ResolversParentTypes['PasswordHistoryEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PasswordHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryMaxAggregates'] = ResolversParentTypes['PasswordHistoryMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryMinAggregates'] = ResolversParentTypes['PasswordHistoryMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryStddevPopulationAggregates'] = ResolversParentTypes['PasswordHistoryStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryStddevSampleAggregates'] = ResolversParentTypes['PasswordHistoryStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistorySumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistorySumAggregates'] = ResolversParentTypes['PasswordHistorySumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryVariancePopulationAggregates'] = ResolversParentTypes['PasswordHistoryVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordHistoryVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordHistoryVarianceSampleAggregates'] = ResolversParentTypes['PasswordHistoryVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PathToFundingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PathToFunding'] = ResolversParentTypes['PathToFunding']> = {
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closedTotalPnL?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  objectives?: Resolver<Array<ResolversTypes['PathToFundingObjective']>, ParentType, ContextType>;
  rules?: Resolver<Array<ResolversTypes['PathToFundingRule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PathToFundingObjectiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['PathToFundingObjective'] = ResolversParentTypes['PathToFundingObjective']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PathToFundingRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PathToFundingRule'] = ResolversParentTypes['PathToFundingRule']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentGatewayResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentGateway'] = ResolversParentTypes['PaymentGateway']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutActivityActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutActivityActor'] = ResolversParentTypes['PayoutActivityActor']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isSystem?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutActivityEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutActivityEvent'] = ResolversParentTypes['PayoutActivityEvent']> = {
  actor?: Resolver<Maybe<ResolversTypes['PayoutActivityActor']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  occurredAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutReturn?: Resolver<Maybe<ResolversTypes['PayoutActivityReturn']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PayoutActivityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutActivityReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutActivityReturn'] = ResolversParentTypes['PayoutActivityReturn']> = {
  additionalDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reasonCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reasonLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutCycleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutCycle'] = ResolversParentTypes['PayoutCycle']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApproval'] = ResolversParentTypes['PayoutDepartmentApproval']> = {
  approved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  department?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalAverageAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalAverageAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalConnection'] = ResolversParentTypes['PayoutDepartmentApprovalConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApprovalAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutDepartmentApprovalEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutDepartmentApprovalAggregates']>>, ParentType, ContextType, RequireFields<PayoutDepartmentApprovalConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutDepartmentApproval']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalDistinctCountAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalDistinctCountAggregates']> = {
  approved?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalEdge'] = ResolversParentTypes['PayoutDepartmentApprovalEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutDepartmentApproval']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalMaxAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalMaxAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalMinAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalMinAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalStddevPopulationAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalStddevPopulationAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalStddevSampleAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalStddevSampleAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalSumAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalSumAggregates']> = {
  lastUpdatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  payoutId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalVariancePopulationAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalVariancePopulationAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDepartmentApprovalVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDepartmentApprovalVarianceSampleAggregates'] = ResolversParentTypes['PayoutDepartmentApprovalVarianceSampleAggregates']> = {
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequest'] = ResolversParentTypes['PayoutRequest']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountCallUpDecision?: Resolver<Maybe<ResolversTypes['AccountCallUpDecision']>, ParentType, ContextType>;
  accountCallUpDecisionAccount?: Resolver<Maybe<ResolversTypes['AccountLiveCallUp']>, ParentType, ContextType>;
  accountCallUpDecisionId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accountLiveCallUp?: Resolver<Maybe<ResolversTypes['AccountLiveCallUp']>, ParentType, ContextType>;
  adminInitiated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  approvingUserId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  assignedDepartment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankInfoEnteredAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  departmentApprovals?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  exception?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exceptionNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finalizedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  financeApprovedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impairmentRealized?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netSuiteBillId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netSuitePaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  payoutDepartmentApprovalsByPayoutId?: Resolver<ResolversTypes['PayoutDepartmentApprovalConnection'], ParentType, ContextType, RequireFields<PayoutRequestPayoutDepartmentApprovalsByPayoutIdArgs, 'orderBy'>>;
  payoutOptionHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutOptionKind?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutRequestAssets?: Resolver<ResolversTypes['PayoutRequestAssetConnection'], ParentType, ContextType, RequireFields<PayoutRequestPayoutRequestAssetsArgs, 'orderBy'>>;
  payoutRequestBatchItem?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItem']>, ParentType, ContextType>;
  payoutRequestSubscribers?: Resolver<ResolversTypes['PayoutRequestSubscriberConnection'], ParentType, ContextType, RequireFields<PayoutRequestPayoutRequestSubscribersArgs, 'orderBy'>>;
  payoutReturns?: Resolver<ResolversTypes['PayoutReturnConnection'], ParentType, ContextType, RequireFields<PayoutRequestPayoutReturnsArgs, 'orderBy'>>;
  payoutReviewersByPayoutId?: Resolver<ResolversTypes['PayoutReviewerConnection'], ParentType, ContextType, RequireFields<PayoutRequestPayoutReviewersByPayoutIdArgs, 'orderBy'>>;
  payoutReviewsByPayoutId?: Resolver<ResolversTypes['PayoutReviewConnection'], ParentType, ContextType, RequireFields<PayoutRequestPayoutReviewsByPayoutIdArgs, 'orderBy'>>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reopenedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetsWinningDays?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seedCapitalAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradedProducts?: Resolver<Maybe<Array<ResolversTypes['TradedProductLots']>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAggregates'] = ResolversParentTypes['PayoutRequestAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutRequestAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutRequestDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutRequestMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutRequestMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutRequestStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutRequestSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutRequestVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAsset'] = ResolversParentTypes['PayoutRequestAsset']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  displayImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  generationPayload?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payloadHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutRequest?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  renderedIdentity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  socialUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PayoutRequestAssetStatusEnum'], ParentType, ContextType>;
  templateVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  variants?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetAggregates'] = ResolversParentTypes['PayoutRequestAssetAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetAverageAggregates'] = ResolversParentTypes['PayoutRequestAssetAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetConnection'] = ResolversParentTypes['PayoutRequestAssetConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutRequestAssetAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestAssetEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutRequestAssetAggregates']>>, ParentType, ContextType, RequireFields<PayoutRequestAssetConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestAsset']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetDistinctCountAggregates'] = ResolversParentTypes['PayoutRequestAssetDistinctCountAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  displayImageUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  generatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  generationPayload?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payloadHash?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  renderedIdentity?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  socialUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  templateVersion?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  variants?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetEdge'] = ResolversParentTypes['PayoutRequestAssetEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutRequestAsset']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetMaxAggregates'] = ResolversParentTypes['PayoutRequestAssetMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetMinAggregates'] = ResolversParentTypes['PayoutRequestAssetMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetStddevPopulationAggregates'] = ResolversParentTypes['PayoutRequestAssetStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetStddevSampleAggregates'] = ResolversParentTypes['PayoutRequestAssetStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetSumAggregates'] = ResolversParentTypes['PayoutRequestAssetSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetVariancePopulationAggregates'] = ResolversParentTypes['PayoutRequestAssetVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAssetVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAssetVarianceSampleAggregates'] = ResolversParentTypes['PayoutRequestAssetVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestAverageAggregates'] = ResolversParentTypes['PayoutRequestAverageAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatch'] = ResolversParentTypes['PayoutRequestBatch']> = {
  assignedToAdmin?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bankAccountType?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchBankAccountTypeEnum']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutRequestBatchItemsByBatchId?: Resolver<ResolversTypes['PayoutRequestBatchItemConnection'], ParentType, ContextType, RequireFields<PayoutRequestBatchPayoutRequestBatchItemsByBatchIdArgs, 'orderBy'>>;
  processedVia?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchProcessedViaEnum']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchAggregates'] = ResolversParentTypes['PayoutRequestBatchAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchAverageAggregates'] = ResolversParentTypes['PayoutRequestBatchAverageAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchConnection'] = ResolversParentTypes['PayoutRequestBatchConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestBatchEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutRequestBatchAggregates']>>, ParentType, ContextType, RequireFields<PayoutRequestBatchConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestBatch']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchDistinctCountAggregates'] = ResolversParentTypes['PayoutRequestBatchDistinctCountAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bankAccountType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutMethod?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  processedVia?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchEdge'] = ResolversParentTypes['PayoutRequestBatchEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutRequestBatch']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItem'] = ResolversParentTypes['PayoutRequestBatchItem']> = {
  batch?: Resolver<Maybe<ResolversTypes['PayoutRequestBatch']>, ParentType, ContextType>;
  batchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutRequest?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemAggregates'] = ResolversParentTypes['PayoutRequestBatchItemAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemAverageAggregates'] = ResolversParentTypes['PayoutRequestBatchItemAverageAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemConnection'] = ResolversParentTypes['PayoutRequestBatchItemConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItemAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestBatchItemEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutRequestBatchItemAggregates']>>, ParentType, ContextType, RequireFields<PayoutRequestBatchItemConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestBatchItem']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemDistinctCountAggregates'] = ResolversParentTypes['PayoutRequestBatchItemDistinctCountAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemEdge'] = ResolversParentTypes['PayoutRequestBatchItemEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemMaxAggregates'] = ResolversParentTypes['PayoutRequestBatchItemMaxAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemMinAggregates'] = ResolversParentTypes['PayoutRequestBatchItemMinAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemStddevPopulationAggregates'] = ResolversParentTypes['PayoutRequestBatchItemStddevPopulationAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemStddevSampleAggregates'] = ResolversParentTypes['PayoutRequestBatchItemStddevSampleAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemSumAggregates'] = ResolversParentTypes['PayoutRequestBatchItemSumAggregates']> = {
  batchId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemVariancePopulationAggregates'] = ResolversParentTypes['PayoutRequestBatchItemVariancePopulationAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchItemVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchItemVarianceSampleAggregates'] = ResolversParentTypes['PayoutRequestBatchItemVarianceSampleAggregates']> = {
  batchId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchMaxAggregates'] = ResolversParentTypes['PayoutRequestBatchMaxAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchMinAggregates'] = ResolversParentTypes['PayoutRequestBatchMinAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchStddevPopulationAggregates'] = ResolversParentTypes['PayoutRequestBatchStddevPopulationAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchStddevSampleAggregates'] = ResolversParentTypes['PayoutRequestBatchStddevSampleAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchSumAggregates'] = ResolversParentTypes['PayoutRequestBatchSumAggregates']> = {
  assignedToAdminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdById?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchVariancePopulationAggregates'] = ResolversParentTypes['PayoutRequestBatchVariancePopulationAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestBatchVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestBatchVarianceSampleAggregates'] = ResolversParentTypes['PayoutRequestBatchVarianceSampleAggregates']> = {
  assignedToAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  bankInfoEnteredAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  createdById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  financeApprovedAtCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  totalNetSum?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestConnection'] = ResolversParentTypes['PayoutRequestConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutRequestAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutRequestAggregates']>>, ParentType, ContextType, RequireFields<PayoutRequestConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutRequest']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestDistinctCountAggregates'] = ResolversParentTypes['PayoutRequestDistinctCountAggregates']> = {
  accountCallUpDecisionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  adminInitiated?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  assignedDepartment?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bankInfoEnteredAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  exception?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  exceptionNote?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  finalizedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  financeApprovedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteBillId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuitePaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  paid?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutOptionHandle?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutOptionKind?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutPath?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reopenedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetsWinningDays?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  statusNote?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  targetCurrency?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestEdge'] = ResolversParentTypes['PayoutRequestEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestHistory'] = ResolversParentTypes['PayoutRequestHistory']> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  admin?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  adminId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutRequest?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PayoutRequestHistoryStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestMaxAggregates'] = ResolversParentTypes['PayoutRequestMaxAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestMinAggregates'] = ResolversParentTypes['PayoutRequestMinAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestStddevPopulationAggregates'] = ResolversParentTypes['PayoutRequestStddevPopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestStddevSampleAggregates'] = ResolversParentTypes['PayoutRequestStddevSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriber'] = ResolversParentTypes['PayoutRequestSubscriber']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutRequest?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberAggregates'] = ResolversParentTypes['PayoutRequestSubscriberAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberAverageAggregates'] = ResolversParentTypes['PayoutRequestSubscriberAverageAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberConnection'] = ResolversParentTypes['PayoutRequestSubscriberConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriberAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestSubscriberEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutRequestSubscriberAggregates']>>, ParentType, ContextType, RequireFields<PayoutRequestSubscriberConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestSubscriber']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberDistinctCountAggregates'] = ResolversParentTypes['PayoutRequestSubscriberDistinctCountAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberEdge'] = ResolversParentTypes['PayoutRequestSubscriberEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutRequestSubscriber']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberMaxAggregates'] = ResolversParentTypes['PayoutRequestSubscriberMaxAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberMinAggregates'] = ResolversParentTypes['PayoutRequestSubscriberMinAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberStddevPopulationAggregates'] = ResolversParentTypes['PayoutRequestSubscriberStddevPopulationAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberStddevSampleAggregates'] = ResolversParentTypes['PayoutRequestSubscriberStddevSampleAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberSumAggregates'] = ResolversParentTypes['PayoutRequestSubscriberSumAggregates']> = {
  payoutRequestId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberVariancePopulationAggregates'] = ResolversParentTypes['PayoutRequestSubscriberVariancePopulationAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSubscriberVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSubscriberVarianceSampleAggregates'] = ResolversParentTypes['PayoutRequestSubscriberVarianceSampleAggregates']> = {
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestSumAggregates'] = ResolversParentTypes['PayoutRequestSumAggregates']> = {
  accountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  approvingUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  impairmentRealized?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  requestedAmount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  seedCapitalAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestVariancePopulationAggregates'] = ResolversParentTypes['PayoutRequestVariancePopulationAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestVarianceSampleAggregates'] = ResolversParentTypes['PayoutRequestVarianceSampleAggregates']> = {
  accountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  approvingUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  impairmentRealized?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  requestedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  seedCapitalAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestsStatsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestsStatsConnection'] = ResolversParentTypes['PayoutRequestsStatsConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestsStatsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutRequestsStatsRecord']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestsStatsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestsStatsEdge'] = ResolversParentTypes['PayoutRequestsStatsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutRequestsStatsRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRequestsStatsRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRequestsStatsRecord'] = ResolversParentTypes['PayoutRequestsStatsRecord']> = {
  complianceCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  financeCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fundingCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last24Hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  olderThan24Hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  olderThan30Days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  olderThan48Hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  olderThan72Hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  riskCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalException?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalOnHold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPending?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturn'] = ResolversParentTypes['PayoutReturn']> = {
  additionalDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankReturnedAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  netSuiteJournalEntryFailedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  netSuiteJournalEntryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netSuitePaymentFailedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  netSuitePaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netSuiteReturnBillFailedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  netSuiteReturnBillId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationDismissedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  payoutRequest?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCode']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  recordedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  recordedById?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  resubmittedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resubmittedMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnFee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnedFinanceApprovedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  returnedMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnAggregates'] = ResolversParentTypes['PayoutReturnAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutReturnAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutReturnDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutReturnMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutReturnMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutReturnStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutReturnStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutReturnSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutReturnVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutReturnVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnAverageAggregates'] = ResolversParentTypes['PayoutReturnAverageAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnConnection'] = ResolversParentTypes['PayoutReturnConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutReturnAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutReturnEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutReturnAggregates']>>, ParentType, ContextType, RequireFields<PayoutReturnConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutReturn']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnDistinctCountAggregates'] = ResolversParentTypes['PayoutReturnDistinctCountAggregates']> = {
  additionalDetails?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bankReference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteJournalEntryFailedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteJournalEntryId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuitePaymentFailedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuitePaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteReturnBillFailedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteReturnBillId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notificationDismissedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  recordedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resubmittedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resubmittedMethod?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  returnedFinanceApprovedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  returnedMethod?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  returnedOn?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnEdge'] = ResolversParentTypes['PayoutReturnEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnMaxAggregates'] = ResolversParentTypes['PayoutReturnMaxAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnMinAggregates'] = ResolversParentTypes['PayoutReturnMinAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCode'] = ResolversParentTypes['PayoutReturnReasonCode']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutMethods?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  traderMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeAverageAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeConnection'] = ResolversParentTypes['PayoutReturnReasonCodeConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutReturnReasonCodeEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutReturnReasonCode']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeDistinctCountAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutMethods?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderCategory?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderMessage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeEdge'] = ResolversParentTypes['PayoutReturnReasonCodeEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeMaxAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeMinAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeStddevPopulationAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeStddevSampleAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeSumAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeVariancePopulationAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnReasonCodeVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnReasonCodeVarianceSampleAggregates'] = ResolversParentTypes['PayoutReturnReasonCodeVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnStddevPopulationAggregates'] = ResolversParentTypes['PayoutReturnStddevPopulationAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnStddevSampleAggregates'] = ResolversParentTypes['PayoutReturnStddevSampleAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnSumAggregates'] = ResolversParentTypes['PayoutReturnSumAggregates']> = {
  bankReturnedAmount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reasonCodeId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  recordedById?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  returnAmount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  returnFee?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnVariancePopulationAggregates'] = ResolversParentTypes['PayoutReturnVariancePopulationAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReturnVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReturnVarianceSampleAggregates'] = ResolversParentTypes['PayoutReturnVarianceSampleAggregates']> = {
  bankReturnedAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reasonCodeId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  recordedById?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resubmittedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnAmount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnFee?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  returnedBankingInfoId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReview'] = ResolversParentTypes['PayoutReview']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviewer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  reviewerId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewAggregates'] = ResolversParentTypes['PayoutReviewAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutReviewAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutReviewDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutReviewMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutReviewMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutReviewStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutReviewStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutReviewSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutReviewVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutReviewVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewAverageAggregates'] = ResolversParentTypes['PayoutReviewAverageAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewConnection'] = ResolversParentTypes['PayoutReviewConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutReviewAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutReviewEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutReviewAggregates']>>, ParentType, ContextType, RequireFields<PayoutReviewConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutReview']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewDistinctCountAggregates'] = ResolversParentTypes['PayoutReviewDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewEdge'] = ResolversParentTypes['PayoutReviewEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutReview']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewMaxAggregates'] = ResolversParentTypes['PayoutReviewMaxAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewMinAggregates'] = ResolversParentTypes['PayoutReviewMinAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewStddevPopulationAggregates'] = ResolversParentTypes['PayoutReviewStddevPopulationAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewStddevSampleAggregates'] = ResolversParentTypes['PayoutReviewStddevSampleAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewSumAggregates'] = ResolversParentTypes['PayoutReviewSumAggregates']> = {
  payoutId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reviewerId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewVariancePopulationAggregates'] = ResolversParentTypes['PayoutReviewVariancePopulationAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewVarianceSampleAggregates'] = ResolversParentTypes['PayoutReviewVarianceSampleAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewer'] = ResolversParentTypes['PayoutReviewer']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType>;
  payoutId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviewer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  reviewerId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerAggregates'] = ResolversParentTypes['PayoutReviewerAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PayoutReviewerAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PayoutReviewerDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PayoutReviewerMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PayoutReviewerMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PayoutReviewerStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PayoutReviewerStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PayoutReviewerSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PayoutReviewerVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PayoutReviewerVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerAverageAggregates'] = ResolversParentTypes['PayoutReviewerAverageAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerConnection'] = ResolversParentTypes['PayoutReviewerConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PayoutReviewerAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PayoutReviewerEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PayoutReviewerAggregates']>>, ParentType, ContextType, RequireFields<PayoutReviewerConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PayoutReviewer']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerDistinctCountAggregates'] = ResolversParentTypes['PayoutReviewerDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerEdge'] = ResolversParentTypes['PayoutReviewerEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PayoutReviewer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerMaxAggregates'] = ResolversParentTypes['PayoutReviewerMaxAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerMinAggregates'] = ResolversParentTypes['PayoutReviewerMinAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerStddevPopulationAggregates'] = ResolversParentTypes['PayoutReviewerStddevPopulationAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerStddevSampleAggregates'] = ResolversParentTypes['PayoutReviewerStddevSampleAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerSumAggregates'] = ResolversParentTypes['PayoutReviewerSumAggregates']> = {
  payoutId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reviewerId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerVariancePopulationAggregates'] = ResolversParentTypes['PayoutReviewerVariancePopulationAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutReviewerVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutReviewerVarianceSampleAggregates'] = ResolversParentTypes['PayoutReviewerVarianceSampleAggregates']> = {
  payoutId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRollupItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRollupItem'] = ResolversParentTypes['PayoutRollupItem']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRollupResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRollupResult'] = ResolversParentTypes['PayoutRollupResult']> = {
  lfa?: Resolver<Array<ResolversTypes['PayoutRollupItem']>, ParentType, ContextType>;
  xfa?: Resolver<Array<ResolversTypes['PayoutRollupItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaypalTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaypalTransaction'] = ResolversParentTypes['PaypalTransaction']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  errorDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gateway?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nuveiPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paypalResponse?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaInquiryEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaInquiryEvent'] = ResolversParentTypes['PersonaInquiryEvent']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  personaCreatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  personaEventId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaTransactionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaTransactionEvent'] = ResolversParentTypes['PersonaTransactionEvent']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  personaCreatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  personaEventId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEvent'] = ResolversParentTypes['PersonaWebhookEvent']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  personaCreatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  personaEventId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventAggregates'] = ResolversParentTypes['PersonaWebhookEventAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventAverageAggregates'] = ResolversParentTypes['PersonaWebhookEventAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventConnection'] = ResolversParentTypes['PersonaWebhookEventConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PersonaWebhookEventEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PersonaWebhookEventAggregates']>>, ParentType, ContextType, RequireFields<PersonaWebhookEventConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PersonaWebhookEvent']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventDistinctCountAggregates'] = ResolversParentTypes['PersonaWebhookEventDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  integrationId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  personaCreatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  personaEventId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventEdge'] = ResolversParentTypes['PersonaWebhookEventEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PersonaWebhookEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventMaxAggregates'] = ResolversParentTypes['PersonaWebhookEventMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventMinAggregates'] = ResolversParentTypes['PersonaWebhookEventMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventStddevPopulationAggregates'] = ResolversParentTypes['PersonaWebhookEventStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventStddevSampleAggregates'] = ResolversParentTypes['PersonaWebhookEventStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventSumAggregates'] = ResolversParentTypes['PersonaWebhookEventSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventVariancePopulationAggregates'] = ResolversParentTypes['PersonaWebhookEventVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonaWebhookEventVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonaWebhookEventVarianceSampleAggregates'] = ResolversParentTypes['PersonaWebhookEventVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformResolvers<ContextType = any, ParentType extends ResolversParentTypes['Platform'] = ResolversParentTypes['Platform']> = {
  accounts?: Resolver<ResolversTypes['AccountConnection'], ParentType, ContextType, RequireFields<PlatformAccountsArgs, 'orderBy'>>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dataFeed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tradingProductFees?: Resolver<ResolversTypes['TradingProductFeeConnection'], ParentType, ContextType, RequireFields<PlatformTradingProductFeesArgs, 'orderBy'>>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userPlatformCredentials?: Resolver<ResolversTypes['UserPlatformCredentialConnection'], ParentType, ContextType, RequireFields<PlatformUserPlatformCredentialsArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopcardPayoutCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopcardPayoutCandidate'] = ResolversParentTypes['PopcardPayoutCandidate']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  existingAssetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  financeApprovedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  financeApprovedCtDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopcardRollupGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopcardRollupGroup'] = ResolversParentTypes['PopcardRollupGroup']> = {
  existingAssetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  financeApprovedCtDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payoutIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  payouts?: Resolver<Array<ResolversTypes['PopcardPayoutCandidate']>, ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = {
  checkoutItems?: Resolver<ResolversTypes['CheckoutItemConnection'], ParentType, ContextType, RequireFields<ProductCheckoutItemsArgs, 'orderBy'>>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erpItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nmiSubscriptions?: Resolver<ResolversTypes['NmiSubscriptionConnection'], ParentType, ContextType, RequireFields<ProductNmiSubscriptionsArgs, 'orderBy'>>;
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  productCategory?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  productCategoryId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  purchaseItems?: Resolver<ResolversTypes['PurchaseItemConnection'], ParentType, ContextType, RequireFields<ProductPurchaseItemsArgs, 'orderBy'>>;
  recurringCycle?: Resolver<ResolversTypes['ProductRecurringcycleEnum'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxItemCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductAggregates'] = ResolversParentTypes['ProductAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ProductAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ProductDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ProductMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ProductMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ProductStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ProductStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ProductSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ProductVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ProductVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductAverageAggregates'] = ResolversParentTypes['ProductAverageAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategory'] = ResolversParentTypes['ProductCategory']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  handle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  products?: Resolver<ResolversTypes['ProductConnection'], ParentType, ContextType, RequireFields<ProductCategoryProductsArgs, 'orderBy'>>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryAggregates'] = ResolversParentTypes['ProductCategoryAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ProductCategoryAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ProductCategoryDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ProductCategoryMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ProductCategoryMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ProductCategoryStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ProductCategoryStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ProductCategorySumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ProductCategoryVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ProductCategoryVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryAverageAggregates'] = ResolversParentTypes['ProductCategoryAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryConnection'] = ResolversParentTypes['ProductCategoryConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ProductCategoryAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ProductCategoryEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ProductCategory']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryDistinctCountAggregates'] = ResolversParentTypes['ProductCategoryDistinctCountAggregates']> = {
  description?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  handle?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryEdge'] = ResolversParentTypes['ProductCategoryEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryMaxAggregates'] = ResolversParentTypes['ProductCategoryMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryMinAggregates'] = ResolversParentTypes['ProductCategoryMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryStddevPopulationAggregates'] = ResolversParentTypes['ProductCategoryStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryStddevSampleAggregates'] = ResolversParentTypes['ProductCategoryStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategorySumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategorySumAggregates'] = ResolversParentTypes['ProductCategorySumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryVariancePopulationAggregates'] = ResolversParentTypes['ProductCategoryVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategoryVarianceSampleAggregates'] = ResolversParentTypes['ProductCategoryVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConnection'] = ResolversParentTypes['ProductConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ProductAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ProductEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ProductAggregates']>>, ParentType, ContextType, RequireFields<ProductConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Product']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductDistinctCountAggregates'] = ResolversParentTypes['ProductDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  erpItemId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  recurringCycle?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxItemCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductEdge'] = ResolversParentTypes['ProductEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductMaxAggregates'] = ResolversParentTypes['ProductMaxAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductMinAggregates'] = ResolversParentTypes['ProductMinAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductStddevPopulationAggregates'] = ResolversParentTypes['ProductStddevPopulationAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductStddevSampleAggregates'] = ResolversParentTypes['ProductStddevSampleAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSumAggregates'] = ResolversParentTypes['ProductSumAggregates']> = {
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  productCategoryId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  skuId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariancePopulationAggregates'] = ResolversParentTypes['ProductVariancePopulationAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVarianceSampleAggregates'] = ResolversParentTypes['ProductVarianceSampleAggregates']> = {
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReport'] = ResolversParentTypes['ProfileReport']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reportedProfile?: Resolver<Maybe<ResolversTypes['TraderPublicProfile']>, ParentType, ContextType>;
  reportedProfileId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reporterIpHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProfileReportStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportAggregates'] = ResolversParentTypes['ProfileReportAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ProfileReportAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ProfileReportDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ProfileReportMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ProfileReportMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ProfileReportStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ProfileReportStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ProfileReportSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ProfileReportVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ProfileReportVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportAverageAggregates'] = ResolversParentTypes['ProfileReportAverageAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportConnection'] = ResolversParentTypes['ProfileReportConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ProfileReportAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ProfileReportEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ProfileReportAggregates']>>, ParentType, ContextType, RequireFields<ProfileReportConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ProfileReport']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportDistinctCountAggregates'] = ResolversParentTypes['ProfileReportDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reportedProfileId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reporterIpHash?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userHandle?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportEdge'] = ResolversParentTypes['ProfileReportEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProfileReport']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportMaxAggregates'] = ResolversParentTypes['ProfileReportMaxAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportMinAggregates'] = ResolversParentTypes['ProfileReportMinAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportStddevPopulationAggregates'] = ResolversParentTypes['ProfileReportStddevPopulationAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportStddevSampleAggregates'] = ResolversParentTypes['ProfileReportStddevSampleAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportSumAggregates'] = ResolversParentTypes['ProfileReportSumAggregates']> = {
  reportedProfileId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportVariancePopulationAggregates'] = ResolversParentTypes['ProfileReportVariancePopulationAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileReportVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileReportVarianceSampleAggregates'] = ResolversParentTypes['ProfileReportVarianceSampleAggregates']> = {
  reportedProfileId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Purchase'] = ResolversParentTypes['Purchase']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netSuiteInvoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nuveiAuthCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nuveiPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nuveiSessionToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nuveiTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nuveiUniqueClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripePaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAggregates'] = ResolversParentTypes['PurchaseAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PurchaseAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PurchaseDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PurchaseMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PurchaseMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PurchaseStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PurchaseStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PurchaseSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PurchaseVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PurchaseVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAverageAggregates'] = ResolversParentTypes['PurchaseAverageAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseConnection'] = ResolversParentTypes['PurchaseConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PurchaseAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PurchaseEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PurchaseAggregates']>>, ParentType, ContextType, RequireFields<PurchaseConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Purchase']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseDistinctCountAggregates'] = ResolversParentTypes['PurchaseDistinctCountAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  invoiceTemplate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteInvoiceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiAuthCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiPaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiSessionToken?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiUniqueClientId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  stripePaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseEdge'] = ResolversParentTypes['PurchaseEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Purchase']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItem'] = ResolversParentTypes['PurchaseItem']> = {
  associatedAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Platform']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productSnapshot?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemAggregates'] = ResolversParentTypes['PurchaseItemAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PurchaseItemAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PurchaseItemDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PurchaseItemMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PurchaseItemMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PurchaseItemStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PurchaseItemStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PurchaseItemSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PurchaseItemVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PurchaseItemVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemAverageAggregates'] = ResolversParentTypes['PurchaseItemAverageAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemConnection'] = ResolversParentTypes['PurchaseItemConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PurchaseItemAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PurchaseItemEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PurchaseItemAggregates']>>, ParentType, ContextType, RequireFields<PurchaseItemConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PurchaseItem']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemDistinctCountAggregates'] = ResolversParentTypes['PurchaseItemDistinctCountAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productSnapshot?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemEdge'] = ResolversParentTypes['PurchaseItemEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PurchaseItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemMaxAggregates'] = ResolversParentTypes['PurchaseItemMaxAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemMinAggregates'] = ResolversParentTypes['PurchaseItemMinAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemStddevPopulationAggregates'] = ResolversParentTypes['PurchaseItemStddevPopulationAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemStddevSampleAggregates'] = ResolversParentTypes['PurchaseItemStddevSampleAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemSumAggregates'] = ResolversParentTypes['PurchaseItemSumAggregates']> = {
  associatedAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  skuId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemVariancePopulationAggregates'] = ResolversParentTypes['PurchaseItemVariancePopulationAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseItemVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseItemVarianceSampleAggregates'] = ResolversParentTypes['PurchaseItemVarianceSampleAggregates']> = {
  associatedAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseMaxAggregates'] = ResolversParentTypes['PurchaseMaxAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseMinAggregates'] = ResolversParentTypes['PurchaseMinAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrder'] = ResolversParentTypes['PurchaseOrder']> = {
  billing?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  chargebackIndicators?: Resolver<ResolversTypes['ChargebackIndicatorConnection'], ParentType, ContextType, RequireFields<PurchaseOrderChargebackIndicatorsArgs, 'orderBy'>>;
  chargebacks?: Resolver<ResolversTypes['ChargebackConnection'], ParentType, ContextType, RequireFields<PurchaseOrderChargebacksArgs, 'orderBy'>>;
  checkoutSession?: Resolver<Maybe<ResolversTypes['CheckoutSession']>, ParentType, ContextType>;
  couponSnapshot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['PaymentGateway']>, ParentType, ContextType>;
  gatewayId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gatewayTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderFulfillment?: Resolver<Maybe<ResolversTypes['OrderFulfillment']>, ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentSnapshot?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  processor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processorTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchaseItemsByPurchaseId?: Resolver<ResolversTypes['PurchaseItemConnection'], ParentType, ContextType, RequireFields<PurchaseOrderPurchaseItemsByPurchaseIdArgs, 'orderBy'>>;
  rebillSession?: Resolver<Maybe<ResolversTypes['RebillSession']>, ParentType, ContextType>;
  refunds?: Resolver<ResolversTypes['RefundConnection'], ParentType, ContextType, RequireFields<PurchaseOrderRefundsArgs, 'orderBy'>>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shipping?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxSnapshot?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderAggregates'] = ResolversParentTypes['PurchaseOrderAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['PurchaseOrderAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['PurchaseOrderDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['PurchaseOrderMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PurchaseOrderMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['PurchaseOrderStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['PurchaseOrderStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['PurchaseOrderSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['PurchaseOrderVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['PurchaseOrderVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderAverageAggregates'] = ResolversParentTypes['PurchaseOrderAverageAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderConnection'] = ResolversParentTypes['PurchaseOrderConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['PurchaseOrderAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['PurchaseOrderEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['PurchaseOrderAggregates']>>, ParentType, ContextType, RequireFields<PurchaseOrderConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['PurchaseOrder']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderDistinctCountAggregates'] = ResolversParentTypes['PurchaseOrderDistinctCountAggregates']> = {
  billing?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  couponSnapshot?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  gatewayTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  invoiceTemplate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  paymentSnapshot?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  processorTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  shipping?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxSnapshot?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderEdge'] = ResolversParentTypes['PurchaseOrderEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderMaxAggregates'] = ResolversParentTypes['PurchaseOrderMaxAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderMinAggregates'] = ResolversParentTypes['PurchaseOrderMinAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderReceiptResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderReceipt'] = ResolversParentTypes['PurchaseOrderReceipt']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  fulfillmentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gatewayTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  invoiceTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processorTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderStddevPopulationAggregates'] = ResolversParentTypes['PurchaseOrderStddevPopulationAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderStddevSampleAggregates'] = ResolversParentTypes['PurchaseOrderStddevSampleAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderSumAggregates'] = ResolversParentTypes['PurchaseOrderSumAggregates']> = {
  discount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  gatewayId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  tax?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderVariancePopulationAggregates'] = ResolversParentTypes['PurchaseOrderVariancePopulationAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseOrderVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseOrderVarianceSampleAggregates'] = ResolversParentTypes['PurchaseOrderVarianceSampleAggregates']> = {
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gatewayId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseStddevPopulationAggregates'] = ResolversParentTypes['PurchaseStddevPopulationAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseStddevSampleAggregates'] = ResolversParentTypes['PurchaseStddevSampleAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseSumAggregates'] = ResolversParentTypes['PurchaseSumAggregates']> = {
  accountTemplate?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  discount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  gateway?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  netSuiteItemId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  originalProductPrice?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  platform?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tax?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseVariancePopulationAggregates'] = ResolversParentTypes['PurchaseVariancePopulationAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseVarianceSampleAggregates'] = ResolversParentTypes['PurchaseVarianceSampleAggregates']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteItemId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxDisplayedInLocalCurrency?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxRate?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<QueryAccountArgs, 'rowId'>>;
  accountCapitalEntries?: Resolver<Maybe<ResolversTypes['AccountCapitalEntryConnection']>, ParentType, ContextType, RequireFields<QueryAccountCapitalEntriesArgs, 'orderBy'>>;
  accountCapitalEntry?: Resolver<Maybe<ResolversTypes['AccountCapitalEntry']>, ParentType, ContextType, RequireFields<QueryAccountCapitalEntryArgs, 'rowId'>>;
  accountTemplates?: Resolver<Maybe<ResolversTypes['AccountTemplateConnection']>, ParentType, ContextType, RequireFields<QueryAccountTemplatesArgs, 'orderBy'>>;
  accountTradeStatByDays?: Resolver<Maybe<ResolversTypes['AccountTradeStatByDayConnection']>, ParentType, ContextType, RequireFields<QueryAccountTradeStatByDaysArgs, 'orderBy'>>;
  accounts?: Resolver<Maybe<ResolversTypes['AccountConnection']>, ParentType, ContextType, RequireFields<QueryAccountsArgs, 'orderBy'>>;
  adminAudits?: Resolver<Maybe<ResolversTypes['AdminAuditConnection']>, ParentType, ContextType, RequireFields<QueryAdminAuditsArgs, 'orderBy'>>;
  adminConfigByConfigKey?: Resolver<Maybe<ResolversTypes['AdminConfig']>, ParentType, ContextType, RequireFields<QueryAdminConfigByConfigKeyArgs, 'configKey'>>;
  adminRole?: Resolver<Maybe<ResolversTypes['AdminRole']>, ParentType, ContextType, RequireFields<QueryAdminRoleArgs, 'rowId'>>;
  adminRoles?: Resolver<Maybe<ResolversTypes['AdminRoleConnection']>, ParentType, ContextType, RequireFields<QueryAdminRolesArgs, 'orderBy'>>;
  affiliateStatusByUser?: Resolver<Maybe<ResolversTypes['TraderAffiliateStatus']>, ParentType, ContextType, RequireFields<QueryAffiliateStatusByUserArgs, 'userId'>>;
  aggregateAccountTradeStatByDay?: Resolver<Maybe<ResolversTypes['AggregateAccountTradeStatByDayConnection']>, ParentType, ContextType, Partial<QueryAggregateAccountTradeStatByDayArgs>>;
  cardTransaction?: Resolver<Maybe<ResolversTypes['CardTransaction']>, ParentType, ContextType, RequireFields<QueryCardTransactionArgs, 'rowId'>>;
  cardTransactionByNuveiPaymentId?: Resolver<Maybe<ResolversTypes['CardTransaction']>, ParentType, ContextType, RequireFields<QueryCardTransactionByNuveiPaymentIdArgs, 'nuveiPaymentId'>>;
  cardTransactionByStripePaymentId?: Resolver<Maybe<ResolversTypes['CardTransaction']>, ParentType, ContextType, RequireFields<QueryCardTransactionByStripePaymentIdArgs, 'stripePaymentId'>>;
  cardTransactions?: Resolver<Maybe<ResolversTypes['CardTransactionConnection']>, ParentType, ContextType, RequireFields<QueryCardTransactionsArgs, 'orderBy'>>;
  caseAssignableUsers?: Resolver<Array<ResolversTypes['CaseAssignableUser']>, ParentType, ContextType>;
  caseBan?: Resolver<Maybe<ResolversTypes['CaseBan']>, ParentType, ContextType, RequireFields<QueryCaseBanArgs, 'rowId'>>;
  caseBans?: Resolver<Maybe<ResolversTypes['CaseBanConnection']>, ParentType, ContextType, RequireFields<QueryCaseBansArgs, 'orderBy'>>;
  caseDepartments?: Resolver<Array<ResolversTypes['CaseDepartment']>, ParentType, ContextType>;
  caseInvestigation?: Resolver<Maybe<ResolversTypes['CaseInvestigation']>, ParentType, ContextType, RequireFields<QueryCaseInvestigationArgs, 'rowId'>>;
  caseInvestigationSubmittedDepartments?: Resolver<Maybe<ResolversTypes['CaseInvestigationSubmittedDepartmentConnection']>, ParentType, ContextType, RequireFields<QueryCaseInvestigationSubmittedDepartmentsArgs, 'orderBy'>>;
  caseInvestigations?: Resolver<Maybe<ResolversTypes['CaseInvestigationConnection']>, ParentType, ContextType, RequireFields<QueryCaseInvestigationsArgs, 'orderBy'>>;
  caseLabels?: Resolver<Maybe<ResolversTypes['CaseLabelConnection']>, ParentType, ContextType, RequireFields<QueryCaseLabelsArgs, 'orderBy'>>;
  caseTypes?: Resolver<Maybe<ResolversTypes['CaseTypeConnection']>, ParentType, ContextType, RequireFields<QueryCaseTypesArgs, 'orderBy'>>;
  chargebackTotalsByUser?: Resolver<ResolversTypes['ChargebackTotals'], ParentType, ContextType, RequireFields<QueryChargebackTotalsByUserArgs, 'userId'>>;
  chargebacksByPurchaseOrderIds?: Resolver<Array<ResolversTypes['ChargebackFlag']>, ParentType, ContextType, RequireFields<QueryChargebacksByPurchaseOrderIdsArgs, 'purchaseOrderIds'>>;
  checkoutSessions?: Resolver<Maybe<ResolversTypes['CheckoutSessionConnection']>, ParentType, ContextType, RequireFields<QueryCheckoutSessionsArgs, 'orderBy'>>;
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType, RequireFields<QueryCouponArgs, 'rowId'>>;
  coupons?: Resolver<Maybe<ResolversTypes['CouponConnection']>, ParentType, ContextType, RequireFields<QueryCouponsArgs, 'orderBy'>>;
  currentAdminRoles?: Resolver<Array<ResolversTypes['CurrentAdminRole']>, ParentType, ContextType>;
  discordLinkUrl?: Resolver<ResolversTypes['DiscordLinkUrlPayload'], ParentType, ContextType, Partial<QueryDiscordLinkUrlArgs>>;
  docusignEnvelopeStatus?: Resolver<ResolversTypes['DocuSignEnvelopeStatusResult'], ParentType, ContextType, RequireFields<QueryDocusignEnvelopeStatusArgs, 'envelopeId'>>;
  downloadTaxFormDocument?: Resolver<ResolversTypes['TaxFormDocumentResult'], ParentType, ContextType, RequireFields<QueryDownloadTaxFormDocumentArgs, 'envelopeId'>>;
  emailActions?: Resolver<Maybe<ResolversTypes['EmailActionConnection']>, ParentType, ContextType, RequireFields<QueryEmailActionsArgs, 'orderBy'>>;
  emails?: Resolver<Maybe<ResolversTypes['EmailConnection']>, ParentType, ContextType, RequireFields<QueryEmailsArgs, 'orderBy'>>;
  groups?: Resolver<Maybe<ResolversTypes['GroupConnection']>, ParentType, ContextType, RequireFields<QueryGroupsArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impactGroupAssignment?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType, RequireFields<QueryImpactGroupAssignmentArgs, 'rowId'>>;
  impactGroupAssignments?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentConnection']>, ParentType, ContextType, RequireFields<QueryImpactGroupAssignmentsArgs, 'orderBy'>>;
  impactGroupTemplate?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType, RequireFields<QueryImpactGroupTemplateArgs, 'rowId'>>;
  impactGroupTemplateById?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType, RequireFields<QueryImpactGroupTemplateByIdArgs, 'id'>>;
  impactGroupTemplateBySlug?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType, RequireFields<QueryImpactGroupTemplateBySlugArgs, 'slug'>>;
  impactGroupTemplates?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateConnection']>, ParentType, ContextType, RequireFields<QueryImpactGroupTemplatesArgs, 'orderBy'>>;
  kycPriorityLabelById?: Resolver<Maybe<ResolversTypes['KycPriorityLabel']>, ParentType, ContextType, RequireFields<QueryKycPriorityLabelByIdArgs, 'id'>>;
  kycPriorityLabels?: Resolver<Maybe<ResolversTypes['KycPriorityLabelConnection']>, ParentType, ContextType, RequireFields<QueryKycPriorityLabelsArgs, 'orderBy'>>;
  kycPriorityReviewConfigById?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfig']>, ParentType, ContextType, RequireFields<QueryKycPriorityReviewConfigByIdArgs, 'id'>>;
  kycPriorityReviewConfigs?: Resolver<Maybe<ResolversTypes['KycPriorityReviewConfigConnection']>, ParentType, ContextType, RequireFields<QueryKycPriorityReviewConfigsArgs, 'orderBy'>>;
  latestPersonaInquiryEvent?: Resolver<Maybe<ResolversTypes['PersonaInquiryEvent']>, ParentType, ContextType, RequireFields<QueryLatestPersonaInquiryEventArgs, 'userId'>>;
  latestPersonaTransactionEvent?: Resolver<Maybe<ResolversTypes['PersonaTransactionEvent']>, ParentType, ContextType, RequireFields<QueryLatestPersonaTransactionEventArgs, 'userId'>>;
  lfaSplashStatus?: Resolver<Maybe<ResolversTypes['LfaSplashStatus']>, ParentType, ContextType, RequireFields<QueryLfaSplashStatusArgs, 'accountId'>>;
  myMissingPopcards?: Resolver<ResolversTypes['MyMissingPopcards'], ParentType, ContextType>;
  myPopcardCandidates?: Resolver<ResolversTypes['MyPopcardCandidates'], ParentType, ContextType>;
  myTraderProfileAssets?: Resolver<Array<ResolversTypes['MyTraderProfileAsset']>, ParentType, ContextType, RequireFields<QueryMyTraderProfileAssetsArgs, 'kind'>>;
  myTraderPublicProfile?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfile']>, ParentType, ContextType>;
  nmiSubscriptions?: Resolver<Maybe<ResolversTypes['NmiSubscriptionConnection']>, ParentType, ContextType, RequireFields<QueryNmiSubscriptionsArgs, 'orderBy'>>;
  node?: Resolver<Maybe<ResolversTypes['Node']>, ParentType, ContextType, RequireFields<QueryNodeArgs, 'id'>>;
  normalizedPurchasesByUser?: Resolver<Maybe<ResolversTypes['NormalizedPurchasesByUserConnection']>, ParentType, ContextType, Partial<QueryNormalizedPurchasesByUserArgs>>;
  normalizedPurchasesByUserTotalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryNormalizedPurchasesByUserTotalCountArgs>>;
  normalizedSavedCardsByUser?: Resolver<Maybe<ResolversTypes['NormalizedSavedCardsByUserConnection']>, ParentType, ContextType, Partial<QueryNormalizedSavedCardsByUserArgs>>;
  normalizedSavedCardsByUserTotalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryNormalizedSavedCardsByUserTotalCountArgs>>;
  normalizedSubsByUser?: Resolver<Maybe<ResolversTypes['NormalizedSubsByUserConnection']>, ParentType, ContextType, Partial<QueryNormalizedSubsByUserArgs>>;
  normalizedSubsByUserTotalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryNormalizedSubsByUserTotalCountArgs>>;
  normalizedSubsDetailedByUser?: Resolver<Maybe<ResolversTypes['NormalizedSubsDetailedByUserConnection']>, ParentType, ContextType, Partial<QueryNormalizedSubsDetailedByUserArgs>>;
  ofacsdnRecords?: Resolver<Maybe<ResolversTypes['OfacsdnRecordConnection']>, ParentType, ContextType, RequireFields<QueryOfacsdnRecordsArgs, 'orderBy'>>;
  payoutActivity?: Resolver<Array<ResolversTypes['PayoutActivityEvent']>, ParentType, ContextType, RequireFields<QueryPayoutActivityArgs, 'payoutRequestId'>>;
  payoutRequest?: Resolver<Maybe<ResolversTypes['PayoutRequest']>, ParentType, ContextType, RequireFields<QueryPayoutRequestArgs, 'rowId'>>;
  payoutRequestBatch?: Resolver<Maybe<ResolversTypes['PayoutRequestBatch']>, ParentType, ContextType, RequireFields<QueryPayoutRequestBatchArgs, 'rowId'>>;
  payoutRequestBatches?: Resolver<Maybe<ResolversTypes['PayoutRequestBatchConnection']>, ParentType, ContextType, RequireFields<QueryPayoutRequestBatchesArgs, 'orderBy'>>;
  payoutRequests?: Resolver<Maybe<ResolversTypes['PayoutRequestConnection']>, ParentType, ContextType, RequireFields<QueryPayoutRequestsArgs, 'orderBy'>>;
  payoutRequestsStats?: Resolver<Maybe<ResolversTypes['PayoutRequestsStatsConnection']>, ParentType, ContextType, Partial<QueryPayoutRequestsStatsArgs>>;
  payoutReturnReasonCodes?: Resolver<Maybe<ResolversTypes['PayoutReturnReasonCodeConnection']>, ParentType, ContextType, RequireFields<QueryPayoutReturnReasonCodesArgs, 'orderBy'>>;
  payoutReviewers?: Resolver<Maybe<ResolversTypes['PayoutReviewerConnection']>, ParentType, ContextType, RequireFields<QueryPayoutReviewersArgs, 'orderBy'>>;
  payoutReviews?: Resolver<Maybe<ResolversTypes['PayoutReviewConnection']>, ParentType, ContextType, RequireFields<QueryPayoutReviewsArgs, 'orderBy'>>;
  payoutRollup?: Resolver<ResolversTypes['PayoutRollupResult'], ParentType, ContextType>;
  personaWebhookEvents?: Resolver<Maybe<ResolversTypes['PersonaWebhookEventConnection']>, ParentType, ContextType, RequireFields<QueryPersonaWebhookEventsArgs, 'orderBy'>>;
  productCategories?: Resolver<Maybe<ResolversTypes['ProductCategoryConnection']>, ParentType, ContextType, RequireFields<QueryProductCategoriesArgs, 'orderBy'>>;
  productCategory?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType, RequireFields<QueryProductCategoryArgs, 'rowId'>>;
  productCategoryByHandle?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType, RequireFields<QueryProductCategoryByHandleArgs, 'handle'>>;
  purchaseOrder?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType, RequireFields<QueryPurchaseOrderArgs, 'rowId'>>;
  purchaseOrderReceipt?: Resolver<Maybe<ResolversTypes['PurchaseOrderReceipt']>, ParentType, ContextType, RequireFields<QueryPurchaseOrderReceiptArgs, 'purchaseOrderId'>>;
  purchaseOrders?: Resolver<Maybe<ResolversTypes['PurchaseOrderConnection']>, ParentType, ContextType, RequireFields<QueryPurchaseOrdersArgs, 'orderBy'>>;
  purchases?: Resolver<Maybe<ResolversTypes['PurchaseConnection']>, ParentType, ContextType, RequireFields<QueryPurchasesArgs, 'orderBy'>>;
  reasonCodes?: Resolver<Maybe<ResolversTypes['ReasonCodeConnection']>, ParentType, ContextType, RequireFields<QueryReasonCodesArgs, 'orderBy'>>;
  rebillSessions?: Resolver<Maybe<ResolversTypes['RebillSessionConnection']>, ParentType, ContextType, RequireFields<QueryRebillSessionsArgs, 'orderBy'>>;
  resetCredits?: Resolver<Maybe<ResolversTypes['ResetCreditConnection']>, ParentType, ContextType, RequireFields<QueryResetCreditsArgs, 'orderBy'>>;
  riskyProducts?: Resolver<Maybe<ResolversTypes['RiskyProductConnection']>, ParentType, ContextType, RequireFields<QueryRiskyProductsArgs, 'orderBy'>>;
  savedCards?: Resolver<Maybe<ResolversTypes['SavedCardConnection']>, ParentType, ContextType, RequireFields<QuerySavedCardsArgs, 'orderBy'>>;
  testDocuSignAuth?: Resolver<ResolversTypes['DocuSignAuthResult'], ParentType, ContextType>;
  topstepTVYoutube?: Resolver<ResolversTypes['LiveStreamStatus'], ParentType, ContextType>;
  traderNowTradingPreview?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfileNowTrading']>, ParentType, ContextType, RequireFields<QueryTraderNowTradingPreviewArgs, 'accountId'>>;
  traderOpenCases?: Resolver<Array<ResolversTypes['TraderOpenCase']>, ParentType, ContextType, RequireFields<QueryTraderOpenCasesArgs, 'traderIds'>>;
  traderPayoutNotes?: Resolver<Array<ResolversTypes['TraderPayoutNote']>, ParentType, ContextType, RequireFields<QueryTraderPayoutNotesArgs, 'traderId'>>;
  traderPublicProfiles?: Resolver<Maybe<ResolversTypes['TraderPublicProfileConnection']>, ParentType, ContextType, RequireFields<QueryTraderPublicProfilesArgs, 'orderBy'>>;
  traderRiskIndicator?: Resolver<Maybe<ResolversTypes['TraderRiskIndicator']>, ParentType, ContextType, RequireFields<QueryTraderRiskIndicatorArgs, 'rowId'>>;
  traderRiskIndicators?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorConnection']>, ParentType, ContextType, RequireFields<QueryTraderRiskIndicatorsArgs, 'orderBy'>>;
  tradingProductFee?: Resolver<Maybe<ResolversTypes['TradingProductFee']>, ParentType, ContextType, RequireFields<QueryTradingProductFeeArgs, 'rowId'>>;
  tradingProductFees?: Resolver<Maybe<ResolversTypes['TradingProductFeeConnection']>, ParentType, ContextType, RequireFields<QueryTradingProductFeesArgs, 'orderBy'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'rowId'>>;
  userAddress?: Resolver<Maybe<ResolversTypes['UserAddress']>, ParentType, ContextType, RequireFields<QueryUserAddressArgs, 'rowId'>>;
  userAddresses?: Resolver<Maybe<ResolversTypes['UserAddressConnection']>, ParentType, ContextType, RequireFields<QueryUserAddressesArgs, 'orderBy'>>;
  userCertificates?: Resolver<Maybe<ResolversTypes['UserCertificateConnection']>, ParentType, ContextType, RequireFields<QueryUserCertificatesArgs, 'orderBy'>>;
  userContactInfos?: Resolver<Maybe<ResolversTypes['UserContactInfoConnection']>, ParentType, ContextType, RequireFields<QueryUserContactInfosArgs, 'orderBy'>>;
  userNotes?: Resolver<Maybe<ResolversTypes['UserNoteConnection']>, ParentType, ContextType, RequireFields<QueryUserNotesArgs, 'orderBy'>>;
  userSubscriptions?: Resolver<Maybe<ResolversTypes['UserSubscriptionConnection']>, ParentType, ContextType, RequireFields<QueryUserSubscriptionsArgs, 'orderBy'>>;
  userTaxForms?: Resolver<Maybe<ResolversTypes['UserTaxFormConnection']>, ParentType, ContextType, RequireFields<QueryUserTaxFormsArgs, 'orderBy'>>;
  users?: Resolver<Maybe<ResolversTypes['UserConnection']>, ParentType, ContextType, RequireFields<QueryUsersArgs, 'orderBy'>>;
  verifications?: Resolver<Maybe<ResolversTypes['VerificationConnection']>, ParentType, ContextType, RequireFields<QueryVerificationsArgs, 'orderBy'>>;
  xfaActivationCredits?: Resolver<Maybe<ResolversTypes['XfaActivationCreditConnection']>, ParentType, ContextType, RequireFields<QueryXfaActivationCreditsArgs, 'orderBy'>>;
  xfaResetTracking?: Resolver<Maybe<ResolversTypes['XfaResetTracking']>, ParentType, ContextType, RequireFields<QueryXfaResetTrackingArgs, 'rowId'>>;
  xfaResetTrackings?: Resolver<Maybe<ResolversTypes['XfaResetTrackingConnection']>, ParentType, ContextType, RequireFields<QueryXfaResetTrackingsArgs, 'orderBy'>>;
};

export type ReasonCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCode'] = ResolversParentTypes['ReasonCode']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  caseBanReasonCodes?: Resolver<ResolversTypes['CaseBanReasonCodeConnection'], ParentType, ContextType, RequireFields<ReasonCodeCaseBanReasonCodesArgs, 'orderBy'>>;
  caseInvestigationTraders?: Resolver<ResolversTypes['CaseInvestigationTraderConnection'], ParentType, ContextType, RequireFields<ReasonCodeCaseInvestigationTradersArgs, 'orderBy'>>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeAggregates'] = ResolversParentTypes['ReasonCodeAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ReasonCodeAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ReasonCodeDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ReasonCodeMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ReasonCodeMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ReasonCodeStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ReasonCodeStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ReasonCodeSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ReasonCodeVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ReasonCodeVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeAverageAggregates'] = ResolversParentTypes['ReasonCodeAverageAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeConnection'] = ResolversParentTypes['ReasonCodeConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ReasonCodeAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ReasonCodeEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ReasonCode']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeDistinctCountAggregates'] = ResolversParentTypes['ReasonCodeDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeEdge'] = ResolversParentTypes['ReasonCodeEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ReasonCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeMaxAggregates'] = ResolversParentTypes['ReasonCodeMaxAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeMinAggregates'] = ResolversParentTypes['ReasonCodeMinAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeStddevPopulationAggregates'] = ResolversParentTypes['ReasonCodeStddevPopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeStddevSampleAggregates'] = ResolversParentTypes['ReasonCodeStddevSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeSumAggregates'] = ResolversParentTypes['ReasonCodeSumAggregates']> = {
  createdBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeVariancePopulationAggregates'] = ResolversParentTypes['ReasonCodeVariancePopulationAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonCodeVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReasonCodeVarianceSampleAggregates'] = ResolversParentTypes['ReasonCodeVarianceSampleAggregates']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSession'] = ResolversParentTypes['RebillSession']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventLog?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  externalSubscriptionReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxRetries?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rebillManager?: Resolver<ResolversTypes['RebillSessionRebillManagerEnum'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RebillSessionStatusEnum'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['NmiSubscription']>, ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionAggregates'] = ResolversParentTypes['RebillSessionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['RebillSessionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['RebillSessionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['RebillSessionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RebillSessionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['RebillSessionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['RebillSessionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['RebillSessionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['RebillSessionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['RebillSessionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionAverageAggregates'] = ResolversParentTypes['RebillSessionAverageAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionConnection'] = ResolversParentTypes['RebillSessionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['RebillSessionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['RebillSessionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['RebillSessionAggregates']>>, ParentType, ContextType, RequireFields<RebillSessionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['RebillSession']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionDistinctCountAggregates'] = ResolversParentTypes['RebillSessionDistinctCountAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  externalSubscriptionReference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rebillManager?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionEdge'] = ResolversParentTypes['RebillSessionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RebillSession']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionMaxAggregates'] = ResolversParentTypes['RebillSessionMaxAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionMinAggregates'] = ResolversParentTypes['RebillSessionMinAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionStddevPopulationAggregates'] = ResolversParentTypes['RebillSessionStddevPopulationAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionStddevSampleAggregates'] = ResolversParentTypes['RebillSessionStddevSampleAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionSumAggregates'] = ResolversParentTypes['RebillSessionSumAggregates']> = {
  attemptCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  maxRetries?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionVariancePopulationAggregates'] = ResolversParentTypes['RebillSessionVariancePopulationAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebillSessionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebillSessionVarianceSampleAggregates'] = ResolversParentTypes['RebillSessionVarianceSampleAggregates']> = {
  attemptCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordLfaSplashViewPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordLfaSplashViewPayload'] = ResolversParentTypes['RecordLfaSplashViewPayload']> = {
  lfaSplashSeenAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordReflectionViewPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordReflectionViewPayload'] = ResolversParentTypes['RecordReflectionViewPayload']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  viewedReflections?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPurchase'] = ResolversParentTypes['ReferralPurchase']> = {
  cappedPurchaseAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  purchasedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  rewardClaimedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rewardIssued?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  trader1Id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trader2Id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralReward'] = ResolversParentTypes['ReferralReward']> = {
  couponCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rewardedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  trader1Id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['Refund'] = ResolversParentTypes['Refund']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteRefundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nmiTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nuveiTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['Purchase']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrder?: Resolver<Maybe<ResolversTypes['PurchaseOrder']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripeTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundAggregates'] = ResolversParentTypes['RefundAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['RefundAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['RefundDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['RefundMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RefundMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['RefundStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['RefundStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['RefundSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['RefundVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['RefundVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundAverageAggregates'] = ResolversParentTypes['RefundAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundConnection'] = ResolversParentTypes['RefundConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['RefundAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['RefundEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['RefundAggregates']>>, ParentType, ContextType, RequireFields<RefundConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Refund']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDistinctCountAggregates'] = ResolversParentTypes['RefundDistinctCountAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  gateway?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteRefundId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nmiTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  stripeTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundEdge'] = ResolversParentTypes['RefundEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Refund']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundMaxAggregates'] = ResolversParentTypes['RefundMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundMinAggregates'] = ResolversParentTypes['RefundMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundStddevPopulationAggregates'] = ResolversParentTypes['RefundStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundStddevSampleAggregates'] = ResolversParentTypes['RefundStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundSumAggregates'] = ResolversParentTypes['RefundSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  issuedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  purchaseOrderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundVariancePopulationAggregates'] = ResolversParentTypes['RefundVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundVarianceSampleAggregates'] = ResolversParentTypes['RefundVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  purchaseOrderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationRiskAssessmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationRiskAssessment'] = ResolversParentTypes['RegistrationRiskAssessment']> = {
  addressCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checks?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ipCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ipIsProxy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reasons?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  requiresIdv?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCredit'] = ResolversParentTypes['ResetCredit']> = {
  accountTemplate?: Resolver<Maybe<ResolversTypes['AccountTemplate']>, ParentType, ContextType>;
  accountTemplateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  eventLog?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isComplimentary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuedOn?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCategory?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditAggregates'] = ResolversParentTypes['ResetCreditAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['ResetCreditAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['ResetCreditDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['ResetCreditMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ResetCreditMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['ResetCreditStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['ResetCreditStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ResetCreditSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['ResetCreditVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['ResetCreditVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditAverageAggregates'] = ResolversParentTypes['ResetCreditAverageAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditConnection'] = ResolversParentTypes['ResetCreditConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['ResetCreditAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['ResetCreditEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['ResetCreditAggregates']>>, ParentType, ContextType, RequireFields<ResetCreditConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['ResetCredit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditDistinctCountAggregates'] = ResolversParentTypes['ResetCreditDistinctCountAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isComplimentary?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  issuedOn?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditEdge'] = ResolversParentTypes['ResetCreditEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ResetCredit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditGrant'] = ResolversParentTypes['ResetCreditGrant']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  grantKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  resetCredit?: Resolver<Maybe<ResolversTypes['ResetCredit']>, ParentType, ContextType>;
  resetCreditId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditMaxAggregates'] = ResolversParentTypes['ResetCreditMaxAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditMinAggregates'] = ResolversParentTypes['ResetCreditMinAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditStddevPopulationAggregates'] = ResolversParentTypes['ResetCreditStddevPopulationAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditStddevSampleAggregates'] = ResolversParentTypes['ResetCreditStddevSampleAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditSumAggregates'] = ResolversParentTypes['ResetCreditSumAggregates']> = {
  accountTemplateId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  productCategoryId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditVariancePopulationAggregates'] = ResolversParentTypes['ResetCreditVariancePopulationAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetCreditVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetCreditVarianceSampleAggregates'] = ResolversParentTypes['ResetCreditVarianceSampleAggregates']> = {
  accountTemplateId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productCategoryId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RevokeUserTaxFormValidationBypassResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokeUserTaxFormValidationBypassResult'] = ResolversParentTypes['RevokeUserTaxFormValidationBypassResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProduct'] = ResolversParentTypes['RiskyProduct']> = {
  addedByAdmin?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  addedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedByAdmin?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductAggregates'] = ResolversParentTypes['RiskyProductAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['RiskyProductAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['RiskyProductDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['RiskyProductMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RiskyProductMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['RiskyProductStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['RiskyProductStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['RiskyProductSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['RiskyProductVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['RiskyProductVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductAverageAggregates'] = ResolversParentTypes['RiskyProductAverageAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductConnection'] = ResolversParentTypes['RiskyProductConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['RiskyProductAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['RiskyProductEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['RiskyProduct']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductDistinctCountAggregates'] = ResolversParentTypes['RiskyProductDistinctCountAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductEdge'] = ResolversParentTypes['RiskyProductEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RiskyProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductMaxAggregates'] = ResolversParentTypes['RiskyProductMaxAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductMinAggregates'] = ResolversParentTypes['RiskyProductMinAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductStddevPopulationAggregates'] = ResolversParentTypes['RiskyProductStddevPopulationAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductStddevSampleAggregates'] = ResolversParentTypes['RiskyProductStddevSampleAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductSumAggregates'] = ResolversParentTypes['RiskyProductSumAggregates']> = {
  addedByAdminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductVariancePopulationAggregates'] = ResolversParentTypes['RiskyProductVariancePopulationAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskyProductVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskyProductVarianceSampleAggregates'] = ResolversParentTypes['RiskyProductVarianceSampleAggregates']> = {
  addedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  lastModifiedByAdminId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCard'] = ResolversParentTypes['SavedCard']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cardBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  cvvBypassEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  defaultCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expirationYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullNameOnCard?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maskedCardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nmiSubscriptions?: Resolver<ResolversTypes['NmiSubscriptionConnection'], ParentType, ContextType, RequireFields<SavedCardNmiSubscriptionsArgs, 'orderBy'>>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  vaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vaultPaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vaultUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardAggregates'] = ResolversParentTypes['SavedCardAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['SavedCardAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['SavedCardDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['SavedCardMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['SavedCardMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['SavedCardStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['SavedCardStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['SavedCardSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['SavedCardVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['SavedCardVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardAverageAggregates'] = ResolversParentTypes['SavedCardAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardConnection'] = ResolversParentTypes['SavedCardConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['SavedCardAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['SavedCardEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['SavedCardAggregates']>>, ParentType, ContextType, RequireFields<SavedCardConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['SavedCard']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardDistinctCountAggregates'] = ResolversParentTypes['SavedCardDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cardBrand?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cvvBypassEnabled?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  defaultCard?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expirationMonth?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expirationYear?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  fullNameOnCard?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  initialTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maskedCardNumber?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  vaultName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  vaultPaymentId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  vaultUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardEdge'] = ResolversParentTypes['SavedCardEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SavedCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardMaxAggregates'] = ResolversParentTypes['SavedCardMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardMinAggregates'] = ResolversParentTypes['SavedCardMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardStddevPopulationAggregates'] = ResolversParentTypes['SavedCardStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardStddevSampleAggregates'] = ResolversParentTypes['SavedCardStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardSumAggregates'] = ResolversParentTypes['SavedCardSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardVariancePopulationAggregates'] = ResolversParentTypes['SavedCardVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedCardVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavedCardVarianceSampleAggregates'] = ResolversParentTypes['SavedCardVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SkuAccountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkuAccountDetails'] = ResolversParentTypes['SkuAccountDetails']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  buyingPower?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dailyDrawdown?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  displayStage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasDll?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isChallenge?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isConsistency?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxDrawdown?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxPositionSize?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minTradingDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profitTarget?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  resetPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SkuAccountProvisioningClaimResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkuAccountProvisioningClaim'] = ResolversParentTypes['SkuAccountProvisioningClaim']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountPassedBinderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  allocationStartedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  failedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  failureCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  leaseExpiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  nmiSubscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ownerToken?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  projectXAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  provisioningKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservedAccountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retryable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SkuInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkuInventory'] = ResolversParentTypes['SkuInventory']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  displayLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skuId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unitLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionDunningResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionDunning'] = ResolversParentTypes['SubscriptionDunning']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAttempt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  nextAttempt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAttempts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncDiscordRolesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncDiscordRolesPayload'] = ResolversParentTypes['SyncDiscordRolesPayload']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rolesAdded?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncState'] = ResolversParentTypes['SyncState']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastProcessedTime?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  processName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxFormDocumentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxFormDocumentResult'] = ResolversParentTypes['TaxFormDocumentResult']> = {
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentBase64?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfo'] = ResolversParentTypes['TaxInfo']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  form?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  s3Key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoAggregates'] = ResolversParentTypes['TaxInfoAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['TaxInfoAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['TaxInfoDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['TaxInfoMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaxInfoMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['TaxInfoStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['TaxInfoStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TaxInfoSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['TaxInfoVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['TaxInfoVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoAverageAggregates'] = ResolversParentTypes['TaxInfoAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoConnection'] = ResolversParentTypes['TaxInfoConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['TaxInfoAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['TaxInfoEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['TaxInfoAggregates']>>, ParentType, ContextType, RequireFields<TaxInfoConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['TaxInfo']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoDistinctCountAggregates'] = ResolversParentTypes['TaxInfoDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  form?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  s3Key?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  s3Url?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoEdge'] = ResolversParentTypes['TaxInfoEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TaxInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoMaxAggregates'] = ResolversParentTypes['TaxInfoMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoMinAggregates'] = ResolversParentTypes['TaxInfoMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoStddevPopulationAggregates'] = ResolversParentTypes['TaxInfoStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoStddevSampleAggregates'] = ResolversParentTypes['TaxInfoStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoSumAggregates'] = ResolversParentTypes['TaxInfoSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoVariancePopulationAggregates'] = ResolversParentTypes['TaxInfoVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxInfoVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxInfoVarianceSampleAggregates'] = ResolversParentTypes['TaxInfoVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Trade'] = ResolversParentTypes['Trade']> = {
  commissions?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  executedPrice?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  fees?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  pairedTradeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  platformTradeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  positionSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profitAndLoss?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  remainingFill?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  symbolId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeDay?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  tradingAccountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voided?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradedProductLotsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradedProductLots'] = ResolversParentTypes['TradedProductLots']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalLots?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderLockDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderLockDetail'] = ResolversParentTypes['TraderLockDetail']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lockNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  lockedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  lockedById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderOpenCaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderOpenCase'] = ResolversParentTypes['TraderOpenCase']> = {
  addedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TraderOpenCaseKind'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPayoutNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPayoutNote'] = ResolversParentTypes['TraderPayoutNote']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviewerEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reviewerId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviewerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileAsset'] = ResolversParentTypes['TraderProfileAsset']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TraderProfileAssetKindEnum'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderPublicProfile?: Resolver<Maybe<ResolversTypes['TraderPublicProfile']>, ParentType, ContextType>;
  traderPublicProfileId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderPublicProfilesByBannerImageAssetId?: Resolver<ResolversTypes['TraderPublicProfileConnection'], ParentType, ContextType, RequireFields<TraderProfileAssetTraderPublicProfilesByBannerImageAssetIdArgs, 'orderBy'>>;
  traderPublicProfilesByProfileImageAssetId?: Resolver<ResolversTypes['TraderPublicProfileConnection'], ParentType, ContextType, RequireFields<TraderProfileAssetTraderPublicProfilesByProfileImageAssetIdArgs, 'orderBy'>>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationBlockedWordResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationBlockedWord'] = ResolversParentTypes['TraderProfileModerationBlockedWord']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCase'] = ResolversParentTypes['TraderProfileModerationCase']> = {
  allowedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rejectedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  solvedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  submittedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  submittedBy?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  trader?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderProfileModerationCaseHistoriesByCaseId?: Resolver<ResolversTypes['TraderProfileModerationCaseHistoryConnection'], ParentType, ContextType, RequireFields<TraderProfileModerationCaseTraderProfileModerationCaseHistoriesByCaseIdArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseAggregates'] = ResolversParentTypes['TraderProfileModerationCaseAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseAverageAggregates'] = ResolversParentTypes['TraderProfileModerationCaseAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseConnection'] = ResolversParentTypes['TraderProfileModerationCaseConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['TraderProfileModerationCaseEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['TraderProfileModerationCaseAggregates']>>, ParentType, ContextType, RequireFields<TraderProfileModerationCaseConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['TraderProfileModerationCase']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseDistinctCountAggregates'] = ResolversParentTypes['TraderProfileModerationCaseDistinctCountAggregates']> = {
  allowedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rejectedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  solvedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  submittedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseEdge'] = ResolversParentTypes['TraderProfileModerationCaseEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCase']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistory'] = ResolversParentTypes['TraderProfileModerationCaseHistory']> = {
  case?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCase']>, ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventDetail?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistorySumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryAverageAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryAverageAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryConnection'] = ResolversParentTypes['TraderProfileModerationCaseHistoryConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['TraderProfileModerationCaseHistoryEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['TraderProfileModerationCaseHistoryAggregates']>>, ParentType, ContextType, RequireFields<TraderProfileModerationCaseHistoryConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['TraderProfileModerationCaseHistory']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryDistinctCountAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryDistinctCountAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  event?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventDetail?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryEdge'] = ResolversParentTypes['TraderProfileModerationCaseHistoryEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TraderProfileModerationCaseHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryMaxAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryMaxAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryMinAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryMinAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryStddevPopulationAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryStddevPopulationAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryStddevSampleAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryStddevSampleAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistorySumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistorySumAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistorySumAggregates']> = {
  caseId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryVariancePopulationAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryVariancePopulationAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseHistoryVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseHistoryVarianceSampleAggregates'] = ResolversParentTypes['TraderProfileModerationCaseHistoryVarianceSampleAggregates']> = {
  caseId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseMaxAggregates'] = ResolversParentTypes['TraderProfileModerationCaseMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseMinAggregates'] = ResolversParentTypes['TraderProfileModerationCaseMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseStddevPopulationAggregates'] = ResolversParentTypes['TraderProfileModerationCaseStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseStddevSampleAggregates'] = ResolversParentTypes['TraderProfileModerationCaseStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseSumAggregates'] = ResolversParentTypes['TraderProfileModerationCaseSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseVariancePopulationAggregates'] = ResolversParentTypes['TraderProfileModerationCaseVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderProfileModerationCaseVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderProfileModerationCaseVarianceSampleAggregates'] = ResolversParentTypes['TraderProfileModerationCaseVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfile'] = ResolversParentTypes['TraderPublicProfile']> = {
  bannerImageAsset?: Resolver<Maybe<ResolversTypes['TraderProfileAsset']>, ParentType, ContextType>;
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bannerImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  featuredAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isModerationBlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPublished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profileImageAsset?: Resolver<Maybe<ResolversTypes['TraderProfileAsset']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profileImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileReportsByReportedProfileId?: Resolver<ResolversTypes['ProfileReportConnection'], ParentType, ContextType, RequireFields<TraderPublicProfileProfileReportsByReportedProfileIdArgs, 'orderBy'>>;
  publicDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicTraderId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralCodeExpiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  showAllTimePayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showBannerOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showProfileImageOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showProfitCalendarOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showProofOfPayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showReferralCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showSocialConnections?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showTradingJourney?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showTradingStatsOnPublicProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tradingMarket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingSession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingSetup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingWindow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileAggregates'] = ResolversParentTypes['TraderPublicProfileAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['TraderPublicProfileAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['TraderPublicProfileDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['TraderPublicProfileMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TraderPublicProfileMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['TraderPublicProfileStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['TraderPublicProfileStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TraderPublicProfileSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['TraderPublicProfileVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['TraderPublicProfileVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileAverageAggregates'] = ResolversParentTypes['TraderPublicProfileAverageAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileConnection'] = ResolversParentTypes['TraderPublicProfileConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['TraderPublicProfileAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['TraderPublicProfileEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['TraderPublicProfileAggregates']>>, ParentType, ContextType, RequireFields<TraderPublicProfileConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['TraderPublicProfile']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileDistinctCountAggregates'] = ResolversParentTypes['TraderPublicProfileDistinctCountAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  bannerImageUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isModerationBlocked?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isPublished?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  profileImageUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  publicDisplayName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  publicTraderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  referralCodeExpiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showAllTimePayouts?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showBannerOnPublicProfile?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showProfileImageOnPublicProfile?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showProfitCalendarOnPublicProfile?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showProofOfPayouts?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showReferralCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showSocialConnections?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showTradingJourney?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  showTradingStatsOnPublicProfile?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tradingMarket?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tradingSession?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tradingSetup?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tradingWindow?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userHandle?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileEdge'] = ResolversParentTypes['TraderPublicProfileEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TraderPublicProfile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileMaxAggregates'] = ResolversParentTypes['TraderPublicProfileMaxAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileMinAggregates'] = ResolversParentTypes['TraderPublicProfileMinAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileStddevPopulationAggregates'] = ResolversParentTypes['TraderPublicProfileStddevPopulationAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileStddevSampleAggregates'] = ResolversParentTypes['TraderPublicProfileStddevSampleAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileSumAggregates'] = ResolversParentTypes['TraderPublicProfileSumAggregates']> = {
  bannerImageAssetId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  featuredAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  profileImageAssetId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileVariancePopulationAggregates'] = ResolversParentTypes['TraderPublicProfileVariancePopulationAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderPublicProfileVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderPublicProfileVarianceSampleAggregates'] = ResolversParentTypes['TraderPublicProfileVarianceSampleAggregates']> = {
  bannerImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  featuredAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  profileImageAssetId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicator'] = ResolversParentTypes['TraderRiskIndicator']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventLog?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  resolvedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  resolvedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resolver?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trader?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderRiskIndicatorOwner?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorOwner']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorAggregates'] = ResolversParentTypes['TraderRiskIndicatorAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorAverageAggregates'] = ResolversParentTypes['TraderRiskIndicatorAverageAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorConnection'] = ResolversParentTypes['TraderRiskIndicatorConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['TraderRiskIndicatorEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['TraderRiskIndicatorAggregates']>>, ParentType, ContextType, RequireFields<TraderRiskIndicatorConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['TraderRiskIndicator']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorDistinctCountAggregates'] = ResolversParentTypes['TraderRiskIndicatorDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resolvedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resolvedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorEdge'] = ResolversParentTypes['TraderRiskIndicatorEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TraderRiskIndicator']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorMaxAggregates'] = ResolversParentTypes['TraderRiskIndicatorMaxAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorMinAggregates'] = ResolversParentTypes['TraderRiskIndicatorMinAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorOwner'] = ResolversParentTypes['TraderRiskIndicatorOwner']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ownerType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  traderRiskIndicator?: Resolver<Maybe<ResolversTypes['TraderRiskIndicator']>, ParentType, ContextType>;
  traderRiskIndicatorId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorStddevPopulationAggregates'] = ResolversParentTypes['TraderRiskIndicatorStddevPopulationAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorStddevSampleAggregates'] = ResolversParentTypes['TraderRiskIndicatorStddevSampleAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorSumAggregates'] = ResolversParentTypes['TraderRiskIndicatorSumAggregates']> = {
  resolvedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  traderId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorVariancePopulationAggregates'] = ResolversParentTypes['TraderRiskIndicatorVariancePopulationAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TraderRiskIndicatorVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TraderRiskIndicatorVarianceSampleAggregates'] = ResolversParentTypes['TraderRiskIndicatorVarianceSampleAggregates']> = {
  resolvedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  traderId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingHabitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingHabits'] = ResolversParentTypes['TradingHabits']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bestDayDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bestDayProfit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  consistencyTargetPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  profitFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeWinPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingOverview'] = ResolversParentTypes['TradingOverview']> = {
  averageLosingTrade?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageTradeDuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  averageWinningTrade?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  consistency?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dayOfWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPnL?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeWinPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingDayCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tradingSession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProduct'] = ResolversParentTypes['TradingProduct']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  exchange?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradingProductFees?: Resolver<ResolversTypes['TradingProductFeeConnection'], ParentType, ContextType, RequireFields<TradingProductTradingProductFeesArgs, 'orderBy'>>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFee'] = ResolversParentTypes['TradingProductFee']> = {
  commission?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  effectiveAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  exchangeFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isMicros?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Platform']>, ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['TradingProduct']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tickSize?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tickValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeAggregates'] = ResolversParentTypes['TradingProductFeeAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['TradingProductFeeAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['TradingProductFeeDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['TradingProductFeeMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TradingProductFeeMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['TradingProductFeeStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['TradingProductFeeStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TradingProductFeeSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['TradingProductFeeVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['TradingProductFeeVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeAverageAggregates'] = ResolversParentTypes['TradingProductFeeAverageAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeConnection'] = ResolversParentTypes['TradingProductFeeConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['TradingProductFeeAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['TradingProductFeeEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['TradingProductFeeAggregates']>>, ParentType, ContextType, RequireFields<TradingProductFeeConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['TradingProductFee']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeDistinctCountAggregates'] = ResolversParentTypes['TradingProductFeeDistinctCountAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  effectiveAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isMicros?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeEdge'] = ResolversParentTypes['TradingProductFeeEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TradingProductFee']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeMaxAggregates'] = ResolversParentTypes['TradingProductFeeMaxAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeMinAggregates'] = ResolversParentTypes['TradingProductFeeMinAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeStddevPopulationAggregates'] = ResolversParentTypes['TradingProductFeeStddevPopulationAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeStddevSampleAggregates'] = ResolversParentTypes['TradingProductFeeStddevSampleAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeSumAggregates'] = ResolversParentTypes['TradingProductFeeSumAggregates']> = {
  commission?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  exchangeFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tickSize?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tickValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeVariancePopulationAggregates'] = ResolversParentTypes['TradingProductFeeVariancePopulationAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradingProductFeeVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradingProductFeeVarianceSampleAggregates'] = ResolversParentTypes['TradingProductFeeVarianceSampleAggregates']> = {
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exchangeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tickSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tickValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UnifiedSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnifiedSubscription'] = ResolversParentTypes['UnifiedSubscription']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  associatedAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  associatedAccountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponIsRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  externalProcessor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  serviceAccessUntil?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionCancelledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnlinkDiscordPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnlinkDiscordPayload'] = ResolversParentTypes['UnlinkDiscordPayload']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAccountStatPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAccountStatPayload'] = ResolversParentTypes['UpdateAccountStatPayload']> = {
  accountStat?: Resolver<Maybe<ResolversTypes['AccountStat']>, ParentType, ContextType>;
  accountStatEdge?: Resolver<Maybe<ResolversTypes['AccountStatEdge']>, ParentType, ContextType, RequireFields<UpdateAccountStatPayloadAccountStatEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAdminConfigPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAdminConfigPayload'] = ResolversParentTypes['UpdateAdminConfigPayload']> = {
  adminConfig?: Resolver<Maybe<ResolversTypes['AdminConfig']>, ParentType, ContextType>;
  adminConfigEdge?: Resolver<Maybe<ResolversTypes['AdminConfigEdge']>, ParentType, ContextType, RequireFields<UpdateAdminConfigPayloadAdminConfigEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateImpactGroupAssignmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateImpactGroupAssignmentPayload'] = ResolversParentTypes['UpdateImpactGroupAssignmentPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impactGroupAssignment?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType>;
  impactGroupAssignmentEdge?: Resolver<Maybe<ResolversTypes['ImpactGroupAssignmentEdge']>, ParentType, ContextType, RequireFields<UpdateImpactGroupAssignmentPayloadImpactGroupAssignmentEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateImpactGroupTemplatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateImpactGroupTemplatePayload'] = ResolversParentTypes['UpdateImpactGroupTemplatePayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impactGroupTemplate?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplate']>, ParentType, ContextType>;
  impactGroupTemplateEdge?: Resolver<Maybe<ResolversTypes['ImpactGroupTemplateEdge']>, ParentType, ContextType, RequireFields<UpdateImpactGroupTemplatePayloadImpactGroupTemplateEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateKycPriorityLabelPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateKycPriorityLabelPayload'] = ResolversParentTypes['UpdateKycPriorityLabelPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kycPriorityLabel?: Resolver<Maybe<ResolversTypes['KycPriorityLabel']>, ParentType, ContextType>;
  kycPriorityLabelEdge?: Resolver<Maybe<ResolversTypes['KycPriorityLabelEdge']>, ParentType, ContextType, RequireFields<UpdateKycPriorityLabelPayloadKycPriorityLabelEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMyTraderPublicProfilePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMyTraderPublicProfilePayload'] = ResolversParentTypes['UpdateMyTraderPublicProfilePayload']> = {
  traderPublicProfile?: Resolver<Maybe<ResolversTypes['MyTraderPublicProfile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTraderPublicProfilePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTraderPublicProfilePayload'] = ResolversParentTypes['UpdateTraderPublicProfilePayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  traderPublicProfile?: Resolver<Maybe<ResolversTypes['TraderPublicProfile']>, ParentType, ContextType>;
  traderPublicProfileEdge?: Resolver<Maybe<ResolversTypes['TraderPublicProfileEdge']>, ParentType, ContextType, RequireFields<UpdateTraderPublicProfilePayloadTraderPublicProfileEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTraderRiskIndicatorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTraderRiskIndicatorPayload'] = ResolversParentTypes['UpdateTraderRiskIndicatorPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  traderRiskIndicator?: Resolver<Maybe<ResolversTypes['TraderRiskIndicator']>, ParentType, ContextType>;
  traderRiskIndicatorEdge?: Resolver<Maybe<ResolversTypes['TraderRiskIndicatorEdge']>, ParentType, ContextType, RequireFields<UpdateTraderRiskIndicatorPayloadTraderRiskIndicatorEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTradingProductFeePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTradingProductFeePayload'] = ResolversParentTypes['UpdateTradingProductFeePayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  tradingProductFee?: Resolver<Maybe<ResolversTypes['TradingProductFee']>, ParentType, ContextType>;
  tradingProductFeeEdge?: Resolver<Maybe<ResolversTypes['TradingProductFeeEdge']>, ParentType, ContextType, RequireFields<UpdateTradingProductFeePayloadTradingProductFeeEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserAddressPayload'] = ResolversParentTypes['UpdateUserAddressPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  userAddress?: Resolver<Maybe<ResolversTypes['UserAddress']>, ParentType, ContextType>;
  userAddressEdge?: Resolver<Maybe<ResolversTypes['UserAddressEdge']>, ParentType, ContextType, RequireFields<UpdateUserAddressPayloadUserAddressEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserTaxFormPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserTaxFormPayload'] = ResolversParentTypes['UpdateUserTaxFormPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  userTaxForm?: Resolver<Maybe<ResolversTypes['UserTaxForm']>, ParentType, ContextType>;
  userTaxFormEdge?: Resolver<Maybe<ResolversTypes['UserTaxFormEdge']>, ParentType, ContextType, RequireFields<UpdateUserTaxFormPayloadUserTaxFormEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateXfaActivationCreditPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateXfaActivationCreditPayload'] = ResolversParentTypes['UpdateXfaActivationCreditPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  xfaActivationCredit?: Resolver<Maybe<ResolversTypes['XfaActivationCredit']>, ParentType, ContextType>;
  xfaActivationCreditEdge?: Resolver<Maybe<ResolversTypes['XfaActivationCreditEdge']>, ParentType, ContextType, RequireFields<UpdateXfaActivationCreditPayloadXfaActivationCreditEdgeArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  accountCallUpDecisionCalculations?: Resolver<ResolversTypes['AccountCallUpDecisionCalculationConnection'], ParentType, ContextType, RequireFields<UserAccountCallUpDecisionCalculationsArgs, 'orderBy'>>;
  accountCallUpDecisions?: Resolver<ResolversTypes['AccountCallUpDecisionConnection'], ParentType, ContextType, RequireFields<UserAccountCallUpDecisionsArgs, 'orderBy'>>;
  accountCapitalEntriesCreated?: Resolver<ResolversTypes['AccountCapitalEntryConnection'], ParentType, ContextType, RequireFields<UserAccountCapitalEntriesCreatedArgs, 'orderBy'>>;
  accountResetLimits?: Resolver<ResolversTypes['AccountResetLimitConnection'], ParentType, ContextType, RequireFields<UserAccountResetLimitsArgs, 'orderBy'>>;
  accountResetTrackings?: Resolver<ResolversTypes['AccountResetTrackingConnection'], ParentType, ContextType, RequireFields<UserAccountResetTrackingsArgs, 'orderBy'>>;
  accountTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accounts?: Resolver<ResolversTypes['AccountConnection'], ParentType, ContextType, RequireFields<UserAccountsArgs, 'orderBy'>>;
  activeCooldown?: Resolver<Maybe<ResolversTypes['UserCooldown']>, ParentType, ContextType>;
  adminRoleUsersUsers?: Resolver<ResolversTypes['AdminRoleUsersUserConnection'], ParentType, ContextType, RequireFields<UserAdminRoleUsersUsersArgs, 'orderBy'>>;
  affiliate?: Resolver<Maybe<ResolversTypes['Affiliate']>, ParentType, ContextType>;
  cardTransactions?: Resolver<ResolversTypes['CardTransactionConnection'], ParentType, ContextType, RequireFields<UserCardTransactionsArgs, 'orderBy'>>;
  checkoutSessions?: Resolver<ResolversTypes['CheckoutSessionConnection'], ParentType, ContextType, RequireFields<UserCheckoutSessionsArgs, 'orderBy'>>;
  cognitoSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confirmationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponUsers?: Resolver<ResolversTypes['CouponUserConnection'], ParentType, ContextType, RequireFields<UserCouponUsersArgs, 'orderBy'>>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  discordAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discordId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discordUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emails?: Resolver<ResolversTypes['EmailConnection'], ParentType, ContextType, RequireFields<UserEmailsArgs, 'orderBy'>>;
  forcedLogoutAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  groupAdmins?: Resolver<ResolversTypes['GroupAdminConnection'], ParentType, ContextType, RequireFields<UserGroupAdminsArgs, 'orderBy'>>;
  hasCompletedLegacyPasswordUpdate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasMobileAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  heldLockTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  heldLocks?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  hubspotId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impactGroupAssignments?: Resolver<ResolversTypes['ImpactGroupAssignmentConnection'], ParentType, ContextType, RequireFields<UserImpactGroupAssignmentsArgs, 'orderBy'>>;
  impactGroupAssignmentsByAssignedBy?: Resolver<ResolversTypes['ImpactGroupAssignmentConnection'], ParentType, ContextType, RequireFields<UserImpactGroupAssignmentsByAssignedByArgs, 'orderBy'>>;
  impactGroupAssignmentsByAssignedByList?: Resolver<Array<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType, Partial<UserImpactGroupAssignmentsByAssignedByListArgs>>;
  impactGroupAssignmentsList?: Resolver<Array<ResolversTypes['ImpactGroupAssignment']>, ParentType, ContextType, Partial<UserImpactGroupAssignmentsListArgs>>;
  isBot?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  kycStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestVerificationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lockReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileForcedLogoutAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  needsVerification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteVendorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nuveiSavedCards?: Resolver<ResolversTypes['NuveiSavedCardConnection'], ParentType, ContextType, RequireFields<UserNuveiSavedCardsArgs, 'orderBy'>>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passwordHistories?: Resolver<ResolversTypes['PasswordHistoryConnection'], ParentType, ContextType, RequireFields<UserPasswordHistoriesArgs, 'orderBy'>>;
  passwordSetupRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  payoutRequestBatchesByAssignedToAdminId?: Resolver<ResolversTypes['PayoutRequestBatchConnection'], ParentType, ContextType, RequireFields<UserPayoutRequestBatchesByAssignedToAdminIdArgs, 'orderBy'>>;
  payoutRequestBatchesByCreatedById?: Resolver<ResolversTypes['PayoutRequestBatchConnection'], ParentType, ContextType, RequireFields<UserPayoutRequestBatchesByCreatedByIdArgs, 'orderBy'>>;
  payoutRequestSubscribers?: Resolver<ResolversTypes['PayoutRequestSubscriberConnection'], ParentType, ContextType, RequireFields<UserPayoutRequestSubscribersArgs, 'orderBy'>>;
  payoutRequests?: Resolver<ResolversTypes['PayoutRequestConnection'], ParentType, ContextType, RequireFields<UserPayoutRequestsArgs, 'orderBy'>>;
  personaWebhookEvents?: Resolver<ResolversTypes['PersonaWebhookEventConnection'], ParentType, ContextType, RequireFields<UserPersonaWebhookEventsArgs, 'orderBy'>>;
  projectXPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  publicTrader?: Resolver<Maybe<ResolversTypes['TraderPublicProfile']>, ParentType, ContextType>;
  publicTraderId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  purchaseOrders?: Resolver<ResolversTypes['PurchaseOrderConnection'], ParentType, ContextType, RequireFields<UserPurchaseOrdersArgs, 'orderBy'>>;
  rebillSessions?: Resolver<ResolversTypes['RebillSessionConnection'], ParentType, ContextType, RequireFields<UserRebillSessionsArgs, 'orderBy'>>;
  registrationRiskAssessment?: Resolver<Maybe<ResolversTypes['RegistrationRiskAssessment']>, ParentType, ContextType>;
  resetCredits?: Resolver<ResolversTypes['ResetCreditConnection'], ParentType, ContextType, RequireFields<UserResetCreditsArgs, 'orderBy'>>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  savedCards?: Resolver<ResolversTypes['SavedCardConnection'], ParentType, ContextType, RequireFields<UserSavedCardsArgs, 'orderBy'>>;
  taxForms?: Resolver<ResolversTypes['UserTaxFormConnection'], ParentType, ContextType, RequireFields<UserTaxFormsArgs, 'orderBy'>>;
  taxInfos?: Resolver<ResolversTypes['TaxInfoConnection'], ParentType, ContextType, RequireFields<UserTaxInfosArgs, 'orderBy'>>;
  traderLockDetail?: Resolver<Maybe<ResolversTypes['TraderLockDetail']>, ParentType, ContextType>;
  traderProfileModerationCasesByTraderId?: Resolver<ResolversTypes['TraderProfileModerationCaseConnection'], ParentType, ContextType, RequireFields<UserTraderProfileModerationCasesByTraderIdArgs, 'orderBy'>>;
  traderRiskIndicators?: Resolver<ResolversTypes['TraderRiskIndicatorConnection'], ParentType, ContextType, RequireFields<UserTraderRiskIndicatorsArgs, 'orderBy'>>;
  twoFactorEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  twoFactorSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twoFactorType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userAddresses?: Resolver<ResolversTypes['UserAddressConnection'], ParentType, ContextType, RequireFields<UserUserAddressesArgs, 'orderBy'>>;
  userAdminRoles?: Resolver<ResolversTypes['UserAdminRoleConnection'], ParentType, ContextType, RequireFields<UserUserAdminRolesArgs, 'orderBy'>>;
  userAgreements?: Resolver<ResolversTypes['UserAgreementConnection'], ParentType, ContextType, RequireFields<UserUserAgreementsArgs, 'orderBy'>>;
  userCertificates?: Resolver<ResolversTypes['UserCertificateConnection'], ParentType, ContextType, RequireFields<UserUserCertificatesArgs, 'orderBy'>>;
  userContactInfo?: Resolver<Maybe<ResolversTypes['UserContactInfo']>, ParentType, ContextType>;
  userCooldowns?: Resolver<ResolversTypes['UserCooldownConnection'], ParentType, ContextType, RequireFields<UserUserCooldownsArgs, 'orderBy'>>;
  userIntegration?: Resolver<Maybe<ResolversTypes['UserIntegration']>, ParentType, ContextType>;
  userMeteredEvents?: Resolver<ResolversTypes['UserMeteredEventConnection'], ParentType, ContextType, RequireFields<UserUserMeteredEventsArgs, 'orderBy'>>;
  userNotes?: Resolver<ResolversTypes['UserNoteConnection'], ParentType, ContextType, RequireFields<UserUserNotesArgs, 'orderBy'>>;
  userNotesIssued?: Resolver<ResolversTypes['UserNoteConnection'], ParentType, ContextType, RequireFields<UserUserNotesIssuedArgs, 'orderBy'>>;
  userPlatformCredentials?: Resolver<ResolversTypes['UserPlatformCredentialConnection'], ParentType, ContextType, RequireFields<UserUserPlatformCredentialsArgs, 'orderBy'>>;
  userRolesAdminRoles?: Resolver<ResolversTypes['UserRolesAdminRoleConnection'], ParentType, ContextType, RequireFields<UserUserRolesAdminRolesArgs, 'orderBy'>>;
  userTcPurchaseLimits?: Resolver<ResolversTypes['UserTcPurchaseLimitConnection'], ParentType, ContextType, RequireFields<UserUserTcPurchaseLimitsArgs, 'orderBy'>>;
  userType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userXfaCooldowns?: Resolver<ResolversTypes['UserXfaCooldownConnection'], ParentType, ContextType, RequireFields<UserUserXfaCooldownsArgs, 'orderBy'>>;
  usingTempPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  verificationLastRequestedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  verifications?: Resolver<ResolversTypes['VerificationConnection'], ParentType, ContextType, RequireFields<UserVerificationsArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddonResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddon'] = ResolversParentTypes['UserAddon']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  addOn?: Resolver<Maybe<ResolversTypes['Addon']>, ParentType, ContextType>;
  addOnId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skuId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddress'] = ResolversParentTypes['UserAddress']> = {
  addressType?: Resolver<ResolversTypes['UserAddressAddressTypeEnum'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressAggregates'] = ResolversParentTypes['UserAddressAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserAddressAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserAddressDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserAddressMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserAddressMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserAddressStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserAddressStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserAddressSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserAddressVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserAddressVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressAverageAggregates'] = ResolversParentTypes['UserAddressAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressConnection'] = ResolversParentTypes['UserAddressConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserAddressAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserAddressEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserAddressAggregates']>>, ParentType, ContextType, RequireFields<UserAddressConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserAddress']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressDistinctCountAggregates'] = ResolversParentTypes['UserAddressDistinctCountAggregates']> = {
  addressType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressEdge'] = ResolversParentTypes['UserAddressEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressMaxAggregates'] = ResolversParentTypes['UserAddressMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressMinAggregates'] = ResolversParentTypes['UserAddressMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressStddevPopulationAggregates'] = ResolversParentTypes['UserAddressStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressStddevSampleAggregates'] = ResolversParentTypes['UserAddressStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressSumAggregates'] = ResolversParentTypes['UserAddressSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressVariancePopulationAggregates'] = ResolversParentTypes['UserAddressVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddressVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddressVarianceSampleAggregates'] = ResolversParentTypes['UserAddressVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRole'] = ResolversParentTypes['UserAdminRole']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['AdminRole']>, ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleAggregates'] = ResolversParentTypes['UserAdminRoleAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserAdminRoleAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserAdminRoleDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserAdminRoleMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserAdminRoleMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserAdminRoleStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserAdminRoleStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserAdminRoleSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserAdminRoleVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserAdminRoleVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleAverageAggregates'] = ResolversParentTypes['UserAdminRoleAverageAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleConnection'] = ResolversParentTypes['UserAdminRoleConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserAdminRoleAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserAdminRoleEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserAdminRoleAggregates']>>, ParentType, ContextType, RequireFields<UserAdminRoleConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserAdminRole']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleDistinctCountAggregates'] = ResolversParentTypes['UserAdminRoleDistinctCountAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleEdge'] = ResolversParentTypes['UserAdminRoleEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserAdminRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleMaxAggregates'] = ResolversParentTypes['UserAdminRoleMaxAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleMinAggregates'] = ResolversParentTypes['UserAdminRoleMinAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleStddevPopulationAggregates'] = ResolversParentTypes['UserAdminRoleStddevPopulationAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleStddevSampleAggregates'] = ResolversParentTypes['UserAdminRoleStddevSampleAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleSumAggregates'] = ResolversParentTypes['UserAdminRoleSumAggregates']> = {
  roleId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleVariancePopulationAggregates'] = ResolversParentTypes['UserAdminRoleVariancePopulationAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAdminRoleVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAdminRoleVarianceSampleAggregates'] = ResolversParentTypes['UserAdminRoleVarianceSampleAggregates']> = {
  roleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAggregates'] = ResolversParentTypes['UserAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreement'] = ResolversParentTypes['UserAgreement']> = {
  agreementName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  signedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementAggregates'] = ResolversParentTypes['UserAgreementAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserAgreementAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserAgreementDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserAgreementMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserAgreementMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserAgreementStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserAgreementStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserAgreementSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserAgreementVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserAgreementVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementAverageAggregates'] = ResolversParentTypes['UserAgreementAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementConnection'] = ResolversParentTypes['UserAgreementConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserAgreementAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserAgreementEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserAgreementAggregates']>>, ParentType, ContextType, RequireFields<UserAgreementConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserAgreement']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementDistinctCountAggregates'] = ResolversParentTypes['UserAgreementDistinctCountAggregates']> = {
  agreementName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  signedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementEdge'] = ResolversParentTypes['UserAgreementEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserAgreement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementMaxAggregates'] = ResolversParentTypes['UserAgreementMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementMinAggregates'] = ResolversParentTypes['UserAgreementMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementStddevPopulationAggregates'] = ResolversParentTypes['UserAgreementStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementStddevSampleAggregates'] = ResolversParentTypes['UserAgreementStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementSumAggregates'] = ResolversParentTypes['UserAgreementSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementVariancePopulationAggregates'] = ResolversParentTypes['UserAgreementVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAgreementVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAgreementVarianceSampleAggregates'] = ResolversParentTypes['UserAgreementVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAverageAggregates'] = ResolversParentTypes['UserAverageAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserBankingInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserBankingInfo'] = ResolversParentTypes['UserBankingInfo']> = {
  collection?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutRequestId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificate'] = ResolversParentTypes['UserCertificate']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previewGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  previewUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateAggregates'] = ResolversParentTypes['UserCertificateAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserCertificateAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserCertificateDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserCertificateMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserCertificateMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserCertificateStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserCertificateStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserCertificateSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserCertificateVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserCertificateVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateAverageAggregates'] = ResolversParentTypes['UserCertificateAverageAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateConnection'] = ResolversParentTypes['UserCertificateConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserCertificateAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserCertificateEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserCertificateAggregates']>>, ParentType, ContextType, RequireFields<UserCertificateConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserCertificate']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateDistinctCountAggregates'] = ResolversParentTypes['UserCertificateDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pdfId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  pdfUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  previewGenerated?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  previewUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateEdge'] = ResolversParentTypes['UserCertificateEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserCertificate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateMaxAggregates'] = ResolversParentTypes['UserCertificateMaxAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateMinAggregates'] = ResolversParentTypes['UserCertificateMinAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateStddevPopulationAggregates'] = ResolversParentTypes['UserCertificateStddevPopulationAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateStddevSampleAggregates'] = ResolversParentTypes['UserCertificateStddevSampleAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateSumAggregates'] = ResolversParentTypes['UserCertificateSumAggregates']> = {
  pdfId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateVariancePopulationAggregates'] = ResolversParentTypes['UserCertificateVariancePopulationAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCertificateVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCertificateVarianceSampleAggregates'] = ResolversParentTypes['UserCertificateVarianceSampleAggregates']> = {
  pdfId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserConnection'] = ResolversParentTypes['UserConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserAggregates']>>, ParentType, ContextType, RequireFields<UserConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['User']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfo'] = ResolversParentTypes['UserContactInfo']> = {
  addressVerification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  screenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoAggregates'] = ResolversParentTypes['UserContactInfoAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserContactInfoAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserContactInfoDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserContactInfoMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserContactInfoMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserContactInfoStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserContactInfoStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserContactInfoSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserContactInfoVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserContactInfoVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoAverageAggregates'] = ResolversParentTypes['UserContactInfoAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoConnection'] = ResolversParentTypes['UserContactInfoConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserContactInfoAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserContactInfoEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserContactInfoAggregates']>>, ParentType, ContextType, RequireFields<UserContactInfoConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserContactInfo']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoDistinctCountAggregates'] = ResolversParentTypes['UserContactInfoDistinctCountAggregates']> = {
  addressVerification?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  screenName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userFullName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoEdge'] = ResolversParentTypes['UserContactInfoEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserContactInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoMaxAggregates'] = ResolversParentTypes['UserContactInfoMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoMinAggregates'] = ResolversParentTypes['UserContactInfoMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoStddevPopulationAggregates'] = ResolversParentTypes['UserContactInfoStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoStddevSampleAggregates'] = ResolversParentTypes['UserContactInfoStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoSumAggregates'] = ResolversParentTypes['UserContactInfoSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoVariancePopulationAggregates'] = ResolversParentTypes['UserContactInfoVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactInfoVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContactInfoVarianceSampleAggregates'] = ResolversParentTypes['UserContactInfoVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldown'] = ResolversParentTypes['UserCooldown']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  endsAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownAggregates'] = ResolversParentTypes['UserCooldownAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserCooldownAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserCooldownDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserCooldownMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserCooldownMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserCooldownStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserCooldownStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserCooldownSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserCooldownVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserCooldownVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownAverageAggregates'] = ResolversParentTypes['UserCooldownAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownConnection'] = ResolversParentTypes['UserCooldownConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserCooldownAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserCooldownEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserCooldownAggregates']>>, ParentType, ContextType, RequireFields<UserCooldownConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserCooldown']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownDistinctCountAggregates'] = ResolversParentTypes['UserCooldownDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  endsAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownEdge'] = ResolversParentTypes['UserCooldownEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserCooldown']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownMaxAggregates'] = ResolversParentTypes['UserCooldownMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownMinAggregates'] = ResolversParentTypes['UserCooldownMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownStddevPopulationAggregates'] = ResolversParentTypes['UserCooldownStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownStddevSampleAggregates'] = ResolversParentTypes['UserCooldownStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownSumAggregates'] = ResolversParentTypes['UserCooldownSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownVariancePopulationAggregates'] = ResolversParentTypes['UserCooldownVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCooldownVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCooldownVarianceSampleAggregates'] = ResolversParentTypes['UserCooldownVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDistinctCountAggregates'] = ResolversParentTypes['UserDistinctCountAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cognitoSub?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  confirmationCode?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discordAccessToken?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discordId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  discordUsername?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  emailConfirmed?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  forcedLogoutAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  hasCompletedLegacyPasswordUpdate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  hasMobileAccess?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  heldLocks?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  hubspotId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isBot?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  kycStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastIp?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  latestVerificationStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lockReason?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lockType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  mobileForcedLogoutAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  needsVerification?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteVendorId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  passwordSetupRequired?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  projectXPassword?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  publicTraderId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  twoFactorEnabled?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  twoFactorSecret?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  twoFactorType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  usingTempPassword?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  verificationLastRequestedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserEdge'] = ResolversParentTypes['UserEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserIntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserIntegration'] = ResolversParentTypes['UserIntegration']> = {
  discordAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discordId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discordUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMarketDatumResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMarketDatum'] = ResolversParentTypes['UserMarketDatum']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  marketDataLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMaxAggregates'] = ResolversParentTypes['UserMaxAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEvent'] = ResolversParentTypes['UserMeteredEvent']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventAggregates'] = ResolversParentTypes['UserMeteredEventAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserMeteredEventAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserMeteredEventDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserMeteredEventMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserMeteredEventMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserMeteredEventStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserMeteredEventStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserMeteredEventSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserMeteredEventVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserMeteredEventVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventAverageAggregates'] = ResolversParentTypes['UserMeteredEventAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventConnection'] = ResolversParentTypes['UserMeteredEventConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserMeteredEventAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserMeteredEventEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserMeteredEventAggregates']>>, ParentType, ContextType, RequireFields<UserMeteredEventConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserMeteredEvent']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventDistinctCountAggregates'] = ResolversParentTypes['UserMeteredEventDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventEdge'] = ResolversParentTypes['UserMeteredEventEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserMeteredEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventMaxAggregates'] = ResolversParentTypes['UserMeteredEventMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventMinAggregates'] = ResolversParentTypes['UserMeteredEventMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventStddevPopulationAggregates'] = ResolversParentTypes['UserMeteredEventStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventStddevSampleAggregates'] = ResolversParentTypes['UserMeteredEventStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventSumAggregates'] = ResolversParentTypes['UserMeteredEventSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventVariancePopulationAggregates'] = ResolversParentTypes['UserMeteredEventVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMeteredEventVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMeteredEventVarianceSampleAggregates'] = ResolversParentTypes['UserMeteredEventVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMinAggregates'] = ResolversParentTypes['UserMinAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNote'] = ResolversParentTypes['UserNote']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  issuedByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  legacyAuthorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteAggregates'] = ResolversParentTypes['UserNoteAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserNoteAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserNoteDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserNoteMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserNoteMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserNoteStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserNoteStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserNoteSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserNoteVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserNoteVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteAverageAggregates'] = ResolversParentTypes['UserNoteAverageAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteConnection'] = ResolversParentTypes['UserNoteConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserNoteAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserNoteEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserNoteAggregates']>>, ParentType, ContextType, RequireFields<UserNoteConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserNote']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteDistinctCountAggregates'] = ResolversParentTypes['UserNoteDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  legacyAuthorName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteEdge'] = ResolversParentTypes['UserNoteEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserNote']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteMaxAggregates'] = ResolversParentTypes['UserNoteMaxAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteMinAggregates'] = ResolversParentTypes['UserNoteMinAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteStddevPopulationAggregates'] = ResolversParentTypes['UserNoteStddevPopulationAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteStddevSampleAggregates'] = ResolversParentTypes['UserNoteStddevSampleAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteSumAggregates'] = ResolversParentTypes['UserNoteSumAggregates']> = {
  issuedBy?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  legacyNoteId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteVariancePopulationAggregates'] = ResolversParentTypes['UserNoteVariancePopulationAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNoteVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNoteVarianceSampleAggregates'] = ResolversParentTypes['UserNoteVarianceSampleAggregates']> = {
  issuedBy?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyNoteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredential'] = ResolversParentTypes['UserPlatformCredential']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['Platform']>, ParentType, ContextType>;
  platformId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  platformPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialAggregates'] = ResolversParentTypes['UserPlatformCredentialAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialAverageAggregates'] = ResolversParentTypes['UserPlatformCredentialAverageAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialConnection'] = ResolversParentTypes['UserPlatformCredentialConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserPlatformCredentialAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserPlatformCredentialEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserPlatformCredentialAggregates']>>, ParentType, ContextType, RequireFields<UserPlatformCredentialConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserPlatformCredential']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialDistinctCountAggregates'] = ResolversParentTypes['UserPlatformCredentialDistinctCountAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformPassword?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  platformUserId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialEdge'] = ResolversParentTypes['UserPlatformCredentialEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserPlatformCredential']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialMaxAggregates'] = ResolversParentTypes['UserPlatformCredentialMaxAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialMinAggregates'] = ResolversParentTypes['UserPlatformCredentialMinAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialStddevPopulationAggregates'] = ResolversParentTypes['UserPlatformCredentialStddevPopulationAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialStddevSampleAggregates'] = ResolversParentTypes['UserPlatformCredentialStddevSampleAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialSumAggregates'] = ResolversParentTypes['UserPlatformCredentialSumAggregates']> = {
  platformId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialVariancePopulationAggregates'] = ResolversParentTypes['UserPlatformCredentialVariancePopulationAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPlatformCredentialVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPlatformCredentialVarianceSampleAggregates'] = ResolversParentTypes['UserPlatformCredentialVarianceSampleAggregates']> = {
  platformId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRole'] = ResolversParentTypes['UserRolesAdminRole']> = {
  adminRole?: Resolver<Maybe<ResolversTypes['AdminRole']>, ParentType, ContextType>;
  adminRoleId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleAggregates'] = ResolversParentTypes['UserRolesAdminRoleAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleAverageAggregates'] = ResolversParentTypes['UserRolesAdminRoleAverageAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleConnection'] = ResolversParentTypes['UserRolesAdminRoleConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserRolesAdminRoleAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserRolesAdminRoleEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserRolesAdminRoleAggregates']>>, ParentType, ContextType, RequireFields<UserRolesAdminRoleConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserRolesAdminRole']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleDistinctCountAggregates'] = ResolversParentTypes['UserRolesAdminRoleDistinctCountAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleEdge'] = ResolversParentTypes['UserRolesAdminRoleEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserRolesAdminRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleMaxAggregates'] = ResolversParentTypes['UserRolesAdminRoleMaxAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleMinAggregates'] = ResolversParentTypes['UserRolesAdminRoleMinAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleStddevPopulationAggregates'] = ResolversParentTypes['UserRolesAdminRoleStddevPopulationAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleStddevSampleAggregates'] = ResolversParentTypes['UserRolesAdminRoleStddevSampleAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleSumAggregates'] = ResolversParentTypes['UserRolesAdminRoleSumAggregates']> = {
  adminRoleId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleVariancePopulationAggregates'] = ResolversParentTypes['UserRolesAdminRoleVariancePopulationAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRolesAdminRoleVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRolesAdminRoleVarianceSampleAggregates'] = ResolversParentTypes['UserRolesAdminRoleVarianceSampleAggregates']> = {
  adminRoleId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserStddevPopulationAggregates'] = ResolversParentTypes['UserStddevPopulationAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserStddevSampleAggregates'] = ResolversParentTypes['UserStddevSampleAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscription'] = ResolversParentTypes['UserSubscription']> = {
  accountsBySubscriptionId?: Resolver<ResolversTypes['AccountConnection'], ParentType, ContextType, RequireFields<UserSubscriptionAccountsBySubscriptionIdArgs, 'orderBy'>>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['Coupon']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dunningStartDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialNuveiTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDunning?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastRenewalDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  nmiSavedCard?: Resolver<Maybe<ResolversTypes['SavedCard']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiSubscriptionsByMigratedSubId?: Resolver<ResolversTypes['NmiSubscriptionConnection'], ParentType, ContextType, RequireFields<UserSubscriptionNmiSubscriptionsByMigratedSubIdArgs, 'orderBy'>>;
  nuveiUserPaymentOptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rebillDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionAggregates'] = ResolversParentTypes['UserSubscriptionAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserSubscriptionAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserSubscriptionDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserSubscriptionMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserSubscriptionMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserSubscriptionStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserSubscriptionStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserSubscriptionSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserSubscriptionVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserSubscriptionVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionAverageAggregates'] = ResolversParentTypes['UserSubscriptionAverageAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionConnection'] = ResolversParentTypes['UserSubscriptionConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserSubscriptionAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserSubscriptionEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserSubscriptionAggregates']>>, ParentType, ContextType, RequireFields<UserSubscriptionConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserSubscription']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionDistinctCountAggregates'] = ResolversParentTypes['UserSubscriptionDistinctCountAggregates']> = {
  active?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dunningStartDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  initialNuveiTransactionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  isDunning?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastRenewalDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  nuveiUserPaymentOptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rebillDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionEdge'] = ResolversParentTypes['UserSubscriptionEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserSubscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionMaxAggregates'] = ResolversParentTypes['UserSubscriptionMaxAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionMinAggregates'] = ResolversParentTypes['UserSubscriptionMinAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionStddevPopulationAggregates'] = ResolversParentTypes['UserSubscriptionStddevPopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionStddevSampleAggregates'] = ResolversParentTypes['UserSubscriptionStddevSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionSumAggregates'] = ResolversParentTypes['UserSubscriptionSumAggregates']> = {
  amount?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dunningAttempts?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  nmiSavedCardId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  originalProductPrice?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tax?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionVariancePopulationAggregates'] = ResolversParentTypes['UserSubscriptionVariancePopulationAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionVarianceSampleAggregates'] = ResolversParentTypes['UserSubscriptionVarianceSampleAggregates']> = {
  amount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  couponId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  dunningAttempts?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  nmiSavedCardId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  originalProductPrice?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSumAggregates'] = ResolversParentTypes['UserSumAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  legacyAppId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  netSuiteId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  projectXUserId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxForm'] = ResolversParentTypes['UserTaxForm']> = {
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  docusignEnvelopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['UserTaxFormsEntityTypeEnum'], ParentType, ContextType>;
  eventLog?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  formType?: Resolver<ResolversTypes['UserTaxFormsFormTypeEnum'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  netSuiteFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserTaxFormsStatusEnum'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  uploadedToNetsuiteAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormAggregates'] = ResolversParentTypes['UserTaxFormAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserTaxFormAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserTaxFormDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserTaxFormMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserTaxFormMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserTaxFormStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserTaxFormStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserTaxFormSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserTaxFormVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserTaxFormVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormAverageAggregates'] = ResolversParentTypes['UserTaxFormAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormConnection'] = ResolversParentTypes['UserTaxFormConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserTaxFormAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserTaxFormEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserTaxFormAggregates']>>, ParentType, ContextType, RequireFields<UserTaxFormConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserTaxForm']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormDistinctCountAggregates'] = ResolversParentTypes['UserTaxFormDistinctCountAggregates']> = {
  businessName?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  docusignEnvelopeId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  formType?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  netSuiteFileId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  uploadedToNetsuiteAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormEdge'] = ResolversParentTypes['UserTaxFormEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserTaxForm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormMaxAggregates'] = ResolversParentTypes['UserTaxFormMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormMinAggregates'] = ResolversParentTypes['UserTaxFormMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormStddevPopulationAggregates'] = ResolversParentTypes['UserTaxFormStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormStddevSampleAggregates'] = ResolversParentTypes['UserTaxFormStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormSumAggregates'] = ResolversParentTypes['UserTaxFormSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormVariancePopulationAggregates'] = ResolversParentTypes['UserTaxFormVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaxFormVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTaxFormVarianceSampleAggregates'] = ResolversParentTypes['UserTaxFormVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimit'] = ResolversParentTypes['UserTcPurchaseLimit']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastPurchaseDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  purchaseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitAggregates'] = ResolversParentTypes['UserTcPurchaseLimitAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitAverageAggregates'] = ResolversParentTypes['UserTcPurchaseLimitAverageAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitConnection'] = ResolversParentTypes['UserTcPurchaseLimitConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimitAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserTcPurchaseLimitEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserTcPurchaseLimitAggregates']>>, ParentType, ContextType, RequireFields<UserTcPurchaseLimitConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserTcPurchaseLimit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitDistinctCountAggregates'] = ResolversParentTypes['UserTcPurchaseLimitDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastPurchaseDate?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  purchaseCount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  yearMonth?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitEdge'] = ResolversParentTypes['UserTcPurchaseLimitEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserTcPurchaseLimit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitMaxAggregates'] = ResolversParentTypes['UserTcPurchaseLimitMaxAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitMinAggregates'] = ResolversParentTypes['UserTcPurchaseLimitMinAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitStddevPopulationAggregates'] = ResolversParentTypes['UserTcPurchaseLimitStddevPopulationAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitStddevSampleAggregates'] = ResolversParentTypes['UserTcPurchaseLimitStddevSampleAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitSumAggregates'] = ResolversParentTypes['UserTcPurchaseLimitSumAggregates']> = {
  purchaseCount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitVariancePopulationAggregates'] = ResolversParentTypes['UserTcPurchaseLimitVariancePopulationAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTcPurchaseLimitVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTcPurchaseLimitVarianceSampleAggregates'] = ResolversParentTypes['UserTcPurchaseLimitVarianceSampleAggregates']> = {
  purchaseCount?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserVariancePopulationAggregates'] = ResolversParentTypes['UserVariancePopulationAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserVarianceSampleAggregates'] = ResolversParentTypes['UserVarianceSampleAggregates']> = {
  accountTotal?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  legacyAppId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  netSuiteId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  projectXUserId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldown'] = ResolversParentTypes['UserXfaCooldown']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastMllBreachAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  triggeredByAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownAggregates'] = ResolversParentTypes['UserXfaCooldownAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['UserXfaCooldownAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['UserXfaCooldownDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['UserXfaCooldownMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['UserXfaCooldownMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['UserXfaCooldownStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['UserXfaCooldownStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['UserXfaCooldownSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['UserXfaCooldownVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['UserXfaCooldownVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownAverageAggregates'] = ResolversParentTypes['UserXfaCooldownAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownConnection'] = ResolversParentTypes['UserXfaCooldownConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['UserXfaCooldownAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['UserXfaCooldownEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['UserXfaCooldownAggregates']>>, ParentType, ContextType, RequireFields<UserXfaCooldownConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['UserXfaCooldown']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownDistinctCountAggregates'] = ResolversParentTypes['UserXfaCooldownDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lastMllBreachAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownEdge'] = ResolversParentTypes['UserXfaCooldownEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserXfaCooldown']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownMaxAggregates'] = ResolversParentTypes['UserXfaCooldownMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownMinAggregates'] = ResolversParentTypes['UserXfaCooldownMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownStddevPopulationAggregates'] = ResolversParentTypes['UserXfaCooldownStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownStddevSampleAggregates'] = ResolversParentTypes['UserXfaCooldownStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownSumAggregates'] = ResolversParentTypes['UserXfaCooldownSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  triggeredByAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownVariancePopulationAggregates'] = ResolversParentTypes['UserXfaCooldownVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserXfaCooldownVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserXfaCooldownVarianceSampleAggregates'] = ResolversParentTypes['UserXfaCooldownVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  triggeredByAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Verification'] = ResolversParentTypes['Verification']> = {
  adminUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  riskLabels?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationAggregates'] = ResolversParentTypes['VerificationAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['VerificationAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['VerificationDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['VerificationMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['VerificationMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['VerificationStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['VerificationStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['VerificationSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['VerificationVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['VerificationVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationAverageAggregates'] = ResolversParentTypes['VerificationAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationConnection'] = ResolversParentTypes['VerificationConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['VerificationAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['VerificationEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['VerificationAggregates']>>, ParentType, ContextType, RequireFields<VerificationConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['Verification']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationDistinctCountAggregates'] = ResolversParentTypes['VerificationDistinctCountAggregates']> = {
  adminUrl?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  riskLabels?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationEdge'] = ResolversParentTypes['VerificationEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Verification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationMaxAggregates'] = ResolversParentTypes['VerificationMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationMinAggregates'] = ResolversParentTypes['VerificationMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationStddevPopulationAggregates'] = ResolversParentTypes['VerificationStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationStddevSampleAggregates'] = ResolversParentTypes['VerificationStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationSumAggregates'] = ResolversParentTypes['VerificationSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationVariancePopulationAggregates'] = ResolversParentTypes['VerificationVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationVarianceSampleAggregates'] = ResolversParentTypes['VerificationVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type W8BenSigningResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['W8BENSigningResult'] = ResolversParentTypes['W8BENSigningResult']> = {
  envelopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type W9SigningResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['W9SigningResult'] = ResolversParentTypes['W9SigningResult']> = {
  envelopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorstTradingDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorstTradingDay'] = ResolversParentTypes['WorstTradingDay']> = {
  averageLosingTrade?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageTradeDuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  averageWinningTrade?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  consistency?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dayOfWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfTrades?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profitFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeWinPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradingSession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  worstDayDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  worstDayPnl?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCredit'] = ResolversParentTypes['XfaActivationCredit']> = {
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuedOn?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['XfaActivationCreditStatusEnum'], ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditAggregates'] = ResolversParentTypes['XfaActivationCreditAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['XfaActivationCreditAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['XfaActivationCreditDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['XfaActivationCreditMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['XfaActivationCreditMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['XfaActivationCreditStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['XfaActivationCreditStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['XfaActivationCreditSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['XfaActivationCreditVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['XfaActivationCreditVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditAverageAggregates'] = ResolversParentTypes['XfaActivationCreditAverageAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditConnection'] = ResolversParentTypes['XfaActivationCreditConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['XfaActivationCreditAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['XfaActivationCreditEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['XfaActivationCreditAggregates']>>, ParentType, ContextType, RequireFields<XfaActivationCreditConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['XfaActivationCredit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditDistinctCountAggregates'] = ResolversParentTypes['XfaActivationCreditDistinctCountAggregates']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  issuedOn?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditEdge'] = ResolversParentTypes['XfaActivationCreditEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['XfaActivationCredit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditMaxAggregates'] = ResolversParentTypes['XfaActivationCreditMaxAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditMinAggregates'] = ResolversParentTypes['XfaActivationCreditMinAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditStddevPopulationAggregates'] = ResolversParentTypes['XfaActivationCreditStddevPopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditStddevSampleAggregates'] = ResolversParentTypes['XfaActivationCreditStddevSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditSumAggregates'] = ResolversParentTypes['XfaActivationCreditSumAggregates']> = {
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditVariancePopulationAggregates'] = ResolversParentTypes['XfaActivationCreditVariancePopulationAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaActivationCreditVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaActivationCreditVarianceSampleAggregates'] = ResolversParentTypes['XfaActivationCreditVarianceSampleAggregates']> = {
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaConsistencyMetricsResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaConsistencyMetrics'] = ResolversParentTypes['XfaConsistencyMetrics']> = {
  consistencyPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  consistencyRatio?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  daysInWindow?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eligibilityReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  largestDayDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  largestDayProfit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pendingPayout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  targetPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalProfit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTracking'] = ResolversParentTypes['XfaResetTracking']> = {
  activationScheduledAt?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  activationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  resetAccountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingAggregates'] = ResolversParentTypes['XfaResetTrackingAggregates']> = {
  average?: Resolver<Maybe<ResolversTypes['XfaResetTrackingAverageAggregates']>, ParentType, ContextType>;
  distinctCount?: Resolver<Maybe<ResolversTypes['XfaResetTrackingDistinctCountAggregates']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['XfaResetTrackingMaxAggregates']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['XfaResetTrackingMinAggregates']>, ParentType, ContextType>;
  stddevPopulation?: Resolver<Maybe<ResolversTypes['XfaResetTrackingStddevPopulationAggregates']>, ParentType, ContextType>;
  stddevSample?: Resolver<Maybe<ResolversTypes['XfaResetTrackingStddevSampleAggregates']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['XfaResetTrackingSumAggregates']>, ParentType, ContextType>;
  variancePopulation?: Resolver<Maybe<ResolversTypes['XfaResetTrackingVariancePopulationAggregates']>, ParentType, ContextType>;
  varianceSample?: Resolver<Maybe<ResolversTypes['XfaResetTrackingVarianceSampleAggregates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingAverageAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingAverageAggregates'] = ResolversParentTypes['XfaResetTrackingAverageAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingConnection'] = ResolversParentTypes['XfaResetTrackingConnection']> = {
  aggregates?: Resolver<Maybe<ResolversTypes['XfaResetTrackingAggregates']>, ParentType, ContextType>;
  edges?: Resolver<Array<Maybe<ResolversTypes['XfaResetTrackingEdge']>>, ParentType, ContextType>;
  groupedAggregates?: Resolver<Maybe<Array<ResolversTypes['XfaResetTrackingAggregates']>>, ParentType, ContextType, RequireFields<XfaResetTrackingConnectionGroupedAggregatesArgs, 'groupBy'>>;
  nodes?: Resolver<Array<Maybe<ResolversTypes['XfaResetTracking']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingDistinctCountAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingDistinctCountAggregates'] = ResolversParentTypes['XfaResetTrackingDistinctCountAggregates']> = {
  activationScheduledAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  activationStatus?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  branchId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingEdge'] = ResolversParentTypes['XfaResetTrackingEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['XfaResetTracking']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingMaxAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingMaxAggregates'] = ResolversParentTypes['XfaResetTrackingMaxAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingMinAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingMinAggregates'] = ResolversParentTypes['XfaResetTrackingMinAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingStddevPopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingStddevPopulationAggregates'] = ResolversParentTypes['XfaResetTrackingStddevPopulationAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingStddevSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingStddevSampleAggregates'] = ResolversParentTypes['XfaResetTrackingStddevSampleAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingSumAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingSumAggregates'] = ResolversParentTypes['XfaResetTrackingSumAggregates']> = {
  parentAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  resetAccountId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingVariancePopulationAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingVariancePopulationAggregates'] = ResolversParentTypes['XfaResetTrackingVariancePopulationAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type XfaResetTrackingVarianceSampleAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['XfaResetTrackingVarianceSampleAggregates'] = ResolversParentTypes['XfaResetTrackingVarianceSampleAggregates']> = {
  parentAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  resetAccountId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  rowId?: Resolver<Maybe<ResolversTypes['BigFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Account?: AccountResolvers<ContextType>;
  AccountAdjustment?: AccountAdjustmentResolvers<ContextType>;
  AccountAggregates?: AccountAggregatesResolvers<ContextType>;
  AccountAudit?: AccountAuditResolvers<ContextType>;
  AccountAverageAggregates?: AccountAverageAggregatesResolvers<ContextType>;
  AccountCallUpDecision?: AccountCallUpDecisionResolvers<ContextType>;
  AccountCallUpDecisionAggregates?: AccountCallUpDecisionAggregatesResolvers<ContextType>;
  AccountCallUpDecisionAverageAggregates?: AccountCallUpDecisionAverageAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculation?: AccountCallUpDecisionCalculationResolvers<ContextType>;
  AccountCallUpDecisionCalculationAggregates?: AccountCallUpDecisionCalculationAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationAverageAggregates?: AccountCallUpDecisionCalculationAverageAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationConnection?: AccountCallUpDecisionCalculationConnectionResolvers<ContextType>;
  AccountCallUpDecisionCalculationDistinctCountAggregates?: AccountCallUpDecisionCalculationDistinctCountAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationEdge?: AccountCallUpDecisionCalculationEdgeResolvers<ContextType>;
  AccountCallUpDecisionCalculationMaxAggregates?: AccountCallUpDecisionCalculationMaxAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationMinAggregates?: AccountCallUpDecisionCalculationMinAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationStddevPopulationAggregates?: AccountCallUpDecisionCalculationStddevPopulationAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationStddevSampleAggregates?: AccountCallUpDecisionCalculationStddevSampleAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationSumAggregates?: AccountCallUpDecisionCalculationSumAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationVariancePopulationAggregates?: AccountCallUpDecisionCalculationVariancePopulationAggregatesResolvers<ContextType>;
  AccountCallUpDecisionCalculationVarianceSampleAggregates?: AccountCallUpDecisionCalculationVarianceSampleAggregatesResolvers<ContextType>;
  AccountCallUpDecisionConnection?: AccountCallUpDecisionConnectionResolvers<ContextType>;
  AccountCallUpDecisionDistinctCountAggregates?: AccountCallUpDecisionDistinctCountAggregatesResolvers<ContextType>;
  AccountCallUpDecisionEdge?: AccountCallUpDecisionEdgeResolvers<ContextType>;
  AccountCallUpDecisionMaxAggregates?: AccountCallUpDecisionMaxAggregatesResolvers<ContextType>;
  AccountCallUpDecisionMinAggregates?: AccountCallUpDecisionMinAggregatesResolvers<ContextType>;
  AccountCallUpDecisionStddevPopulationAggregates?: AccountCallUpDecisionStddevPopulationAggregatesResolvers<ContextType>;
  AccountCallUpDecisionStddevSampleAggregates?: AccountCallUpDecisionStddevSampleAggregatesResolvers<ContextType>;
  AccountCallUpDecisionSumAggregates?: AccountCallUpDecisionSumAggregatesResolvers<ContextType>;
  AccountCallUpDecisionVariancePopulationAggregates?: AccountCallUpDecisionVariancePopulationAggregatesResolvers<ContextType>;
  AccountCallUpDecisionVarianceSampleAggregates?: AccountCallUpDecisionVarianceSampleAggregatesResolvers<ContextType>;
  AccountCallUpPayoutOffer?: AccountCallUpPayoutOfferResolvers<ContextType>;
  AccountCapitalEntry?: AccountCapitalEntryResolvers<ContextType>;
  AccountCapitalEntryAggregates?: AccountCapitalEntryAggregatesResolvers<ContextType>;
  AccountCapitalEntryAverageAggregates?: AccountCapitalEntryAverageAggregatesResolvers<ContextType>;
  AccountCapitalEntryConnection?: AccountCapitalEntryConnectionResolvers<ContextType>;
  AccountCapitalEntryDistinctCountAggregates?: AccountCapitalEntryDistinctCountAggregatesResolvers<ContextType>;
  AccountCapitalEntryEdge?: AccountCapitalEntryEdgeResolvers<ContextType>;
  AccountCapitalEntryMaxAggregates?: AccountCapitalEntryMaxAggregatesResolvers<ContextType>;
  AccountCapitalEntryMinAggregates?: AccountCapitalEntryMinAggregatesResolvers<ContextType>;
  AccountCapitalEntryResult?: AccountCapitalEntryResultResolvers<ContextType>;
  AccountCapitalEntryStddevPopulationAggregates?: AccountCapitalEntryStddevPopulationAggregatesResolvers<ContextType>;
  AccountCapitalEntryStddevSampleAggregates?: AccountCapitalEntryStddevSampleAggregatesResolvers<ContextType>;
  AccountCapitalEntrySumAggregates?: AccountCapitalEntrySumAggregatesResolvers<ContextType>;
  AccountCapitalEntryVariancePopulationAggregates?: AccountCapitalEntryVariancePopulationAggregatesResolvers<ContextType>;
  AccountCapitalEntryVarianceSampleAggregates?: AccountCapitalEntryVarianceSampleAggregatesResolvers<ContextType>;
  AccountCapitalMutationPayload?: AccountCapitalMutationPayloadResolvers<ContextType>;
  AccountConnection?: AccountConnectionResolvers<ContextType>;
  AccountDistinctCountAggregates?: AccountDistinctCountAggregatesResolvers<ContextType>;
  AccountEdge?: AccountEdgeResolvers<ContextType>;
  AccountLiveCallUp?: AccountLiveCallUpResolvers<ContextType>;
  AccountMaxAggregates?: AccountMaxAggregatesResolvers<ContextType>;
  AccountMinAggregates?: AccountMinAggregatesResolvers<ContextType>;
  AccountNote?: AccountNoteResolvers<ContextType>;
  AccountPassedBinder?: AccountPassedBinderResolvers<ContextType>;
  AccountPassedBinderAggregates?: AccountPassedBinderAggregatesResolvers<ContextType>;
  AccountPassedBinderAverageAggregates?: AccountPassedBinderAverageAggregatesResolvers<ContextType>;
  AccountPassedBinderConnection?: AccountPassedBinderConnectionResolvers<ContextType>;
  AccountPassedBinderDistinctCountAggregates?: AccountPassedBinderDistinctCountAggregatesResolvers<ContextType>;
  AccountPassedBinderEdge?: AccountPassedBinderEdgeResolvers<ContextType>;
  AccountPassedBinderMaxAggregates?: AccountPassedBinderMaxAggregatesResolvers<ContextType>;
  AccountPassedBinderMinAggregates?: AccountPassedBinderMinAggregatesResolvers<ContextType>;
  AccountPassedBinderStddevPopulationAggregates?: AccountPassedBinderStddevPopulationAggregatesResolvers<ContextType>;
  AccountPassedBinderStddevSampleAggregates?: AccountPassedBinderStddevSampleAggregatesResolvers<ContextType>;
  AccountPassedBinderSumAggregates?: AccountPassedBinderSumAggregatesResolvers<ContextType>;
  AccountPassedBinderVariancePopulationAggregates?: AccountPassedBinderVariancePopulationAggregatesResolvers<ContextType>;
  AccountPassedBinderVarianceSampleAggregates?: AccountPassedBinderVarianceSampleAggregatesResolvers<ContextType>;
  AccountPlatformDatum?: AccountPlatformDatumResolvers<ContextType>;
  AccountResetLimit?: AccountResetLimitResolvers<ContextType>;
  AccountResetLimitAggregates?: AccountResetLimitAggregatesResolvers<ContextType>;
  AccountResetLimitAverageAggregates?: AccountResetLimitAverageAggregatesResolvers<ContextType>;
  AccountResetLimitConnection?: AccountResetLimitConnectionResolvers<ContextType>;
  AccountResetLimitDistinctCountAggregates?: AccountResetLimitDistinctCountAggregatesResolvers<ContextType>;
  AccountResetLimitEdge?: AccountResetLimitEdgeResolvers<ContextType>;
  AccountResetLimitMaxAggregates?: AccountResetLimitMaxAggregatesResolvers<ContextType>;
  AccountResetLimitMinAggregates?: AccountResetLimitMinAggregatesResolvers<ContextType>;
  AccountResetLimitStddevPopulationAggregates?: AccountResetLimitStddevPopulationAggregatesResolvers<ContextType>;
  AccountResetLimitStddevSampleAggregates?: AccountResetLimitStddevSampleAggregatesResolvers<ContextType>;
  AccountResetLimitSumAggregates?: AccountResetLimitSumAggregatesResolvers<ContextType>;
  AccountResetLimitVariancePopulationAggregates?: AccountResetLimitVariancePopulationAggregatesResolvers<ContextType>;
  AccountResetLimitVarianceSampleAggregates?: AccountResetLimitVarianceSampleAggregatesResolvers<ContextType>;
  AccountResetTracking?: AccountResetTrackingResolvers<ContextType>;
  AccountResetTrackingAggregates?: AccountResetTrackingAggregatesResolvers<ContextType>;
  AccountResetTrackingAverageAggregates?: AccountResetTrackingAverageAggregatesResolvers<ContextType>;
  AccountResetTrackingConnection?: AccountResetTrackingConnectionResolvers<ContextType>;
  AccountResetTrackingDistinctCountAggregates?: AccountResetTrackingDistinctCountAggregatesResolvers<ContextType>;
  AccountResetTrackingEdge?: AccountResetTrackingEdgeResolvers<ContextType>;
  AccountResetTrackingMaxAggregates?: AccountResetTrackingMaxAggregatesResolvers<ContextType>;
  AccountResetTrackingMinAggregates?: AccountResetTrackingMinAggregatesResolvers<ContextType>;
  AccountResetTrackingStddevPopulationAggregates?: AccountResetTrackingStddevPopulationAggregatesResolvers<ContextType>;
  AccountResetTrackingStddevSampleAggregates?: AccountResetTrackingStddevSampleAggregatesResolvers<ContextType>;
  AccountResetTrackingSumAggregates?: AccountResetTrackingSumAggregatesResolvers<ContextType>;
  AccountResetTrackingVariancePopulationAggregates?: AccountResetTrackingVariancePopulationAggregatesResolvers<ContextType>;
  AccountResetTrackingVarianceSampleAggregates?: AccountResetTrackingVarianceSampleAggregatesResolvers<ContextType>;
  AccountStat?: AccountStatResolvers<ContextType>;
  AccountStatAggregates?: AccountStatAggregatesResolvers<ContextType>;
  AccountStatAverageAggregates?: AccountStatAverageAggregatesResolvers<ContextType>;
  AccountStatConnection?: AccountStatConnectionResolvers<ContextType>;
  AccountStatDay?: AccountStatDayResolvers<ContextType>;
  AccountStatDistinctCountAggregates?: AccountStatDistinctCountAggregatesResolvers<ContextType>;
  AccountStatEdge?: AccountStatEdgeResolvers<ContextType>;
  AccountStatMaxAggregates?: AccountStatMaxAggregatesResolvers<ContextType>;
  AccountStatMinAggregates?: AccountStatMinAggregatesResolvers<ContextType>;
  AccountStatStddevPopulationAggregates?: AccountStatStddevPopulationAggregatesResolvers<ContextType>;
  AccountStatStddevSampleAggregates?: AccountStatStddevSampleAggregatesResolvers<ContextType>;
  AccountStatSumAggregates?: AccountStatSumAggregatesResolvers<ContextType>;
  AccountStatVariancePopulationAggregates?: AccountStatVariancePopulationAggregatesResolvers<ContextType>;
  AccountStatVarianceSampleAggregates?: AccountStatVarianceSampleAggregatesResolvers<ContextType>;
  AccountStddevPopulationAggregates?: AccountStddevPopulationAggregatesResolvers<ContextType>;
  AccountStddevSampleAggregates?: AccountStddevSampleAggregatesResolvers<ContextType>;
  AccountSumAggregates?: AccountSumAggregatesResolvers<ContextType>;
  AccountTemplate?: AccountTemplateResolvers<ContextType>;
  AccountTemplateAggregates?: AccountTemplateAggregatesResolvers<ContextType>;
  AccountTemplateAverageAggregates?: AccountTemplateAverageAggregatesResolvers<ContextType>;
  AccountTemplateConnection?: AccountTemplateConnectionResolvers<ContextType>;
  AccountTemplateDistinctCountAggregates?: AccountTemplateDistinctCountAggregatesResolvers<ContextType>;
  AccountTemplateEdge?: AccountTemplateEdgeResolvers<ContextType>;
  AccountTemplateMaxAggregates?: AccountTemplateMaxAggregatesResolvers<ContextType>;
  AccountTemplateMinAggregates?: AccountTemplateMinAggregatesResolvers<ContextType>;
  AccountTemplateStddevPopulationAggregates?: AccountTemplateStddevPopulationAggregatesResolvers<ContextType>;
  AccountTemplateStddevSampleAggregates?: AccountTemplateStddevSampleAggregatesResolvers<ContextType>;
  AccountTemplateSumAggregates?: AccountTemplateSumAggregatesResolvers<ContextType>;
  AccountTemplateVariancePopulationAggregates?: AccountTemplateVariancePopulationAggregatesResolvers<ContextType>;
  AccountTemplateVarianceSampleAggregates?: AccountTemplateVarianceSampleAggregatesResolvers<ContextType>;
  AccountTradeArchiveNewId?: AccountTradeArchiveNewIdResolvers<ContextType>;
  AccountTradeNat?: AccountTradeNatResolvers<ContextType>;
  AccountTradeStatByDay?: AccountTradeStatByDayResolvers<ContextType>;
  AccountTradeStatByDayAggregates?: AccountTradeStatByDayAggregatesResolvers<ContextType>;
  AccountTradeStatByDayAverageAggregates?: AccountTradeStatByDayAverageAggregatesResolvers<ContextType>;
  AccountTradeStatByDayConnection?: AccountTradeStatByDayConnectionResolvers<ContextType>;
  AccountTradeStatByDayDistinctCountAggregates?: AccountTradeStatByDayDistinctCountAggregatesResolvers<ContextType>;
  AccountTradeStatByDayEdge?: AccountTradeStatByDayEdgeResolvers<ContextType>;
  AccountTradeStatByDayMaxAggregates?: AccountTradeStatByDayMaxAggregatesResolvers<ContextType>;
  AccountTradeStatByDayMinAggregates?: AccountTradeStatByDayMinAggregatesResolvers<ContextType>;
  AccountTradeStatByDayNat?: AccountTradeStatByDayNatResolvers<ContextType>;
  AccountTradeStatByDayStddevPopulationAggregates?: AccountTradeStatByDayStddevPopulationAggregatesResolvers<ContextType>;
  AccountTradeStatByDayStddevSampleAggregates?: AccountTradeStatByDayStddevSampleAggregatesResolvers<ContextType>;
  AccountTradeStatByDaySumAggregates?: AccountTradeStatByDaySumAggregatesResolvers<ContextType>;
  AccountTradeStatByDayVariancePopulationAggregates?: AccountTradeStatByDayVariancePopulationAggregatesResolvers<ContextType>;
  AccountTradeStatByDayVarianceSampleAggregates?: AccountTradeStatByDayVarianceSampleAggregatesResolvers<ContextType>;
  AccountVariancePopulationAggregates?: AccountVariancePopulationAggregatesResolvers<ContextType>;
  AccountVarianceSampleAggregates?: AccountVarianceSampleAggregatesResolvers<ContextType>;
  Addon?: AddonResolvers<ContextType>;
  AdminAudit?: AdminAuditResolvers<ContextType>;
  AdminAuditAggregates?: AdminAuditAggregatesResolvers<ContextType>;
  AdminAuditAverageAggregates?: AdminAuditAverageAggregatesResolvers<ContextType>;
  AdminAuditConnection?: AdminAuditConnectionResolvers<ContextType>;
  AdminAuditDistinctCountAggregates?: AdminAuditDistinctCountAggregatesResolvers<ContextType>;
  AdminAuditEdge?: AdminAuditEdgeResolvers<ContextType>;
  AdminAuditMaxAggregates?: AdminAuditMaxAggregatesResolvers<ContextType>;
  AdminAuditMinAggregates?: AdminAuditMinAggregatesResolvers<ContextType>;
  AdminAuditStddevPopulationAggregates?: AdminAuditStddevPopulationAggregatesResolvers<ContextType>;
  AdminAuditStddevSampleAggregates?: AdminAuditStddevSampleAggregatesResolvers<ContextType>;
  AdminAuditSumAggregates?: AdminAuditSumAggregatesResolvers<ContextType>;
  AdminAuditVariancePopulationAggregates?: AdminAuditVariancePopulationAggregatesResolvers<ContextType>;
  AdminAuditVarianceSampleAggregates?: AdminAuditVarianceSampleAggregatesResolvers<ContextType>;
  AdminConfig?: AdminConfigResolvers<ContextType>;
  AdminConfigEdge?: AdminConfigEdgeResolvers<ContextType>;
  AdminRole?: AdminRoleResolvers<ContextType>;
  AdminRoleAggregates?: AdminRoleAggregatesResolvers<ContextType>;
  AdminRoleAverageAggregates?: AdminRoleAverageAggregatesResolvers<ContextType>;
  AdminRoleConnection?: AdminRoleConnectionResolvers<ContextType>;
  AdminRoleDistinctCountAggregates?: AdminRoleDistinctCountAggregatesResolvers<ContextType>;
  AdminRoleEdge?: AdminRoleEdgeResolvers<ContextType>;
  AdminRoleMaxAggregates?: AdminRoleMaxAggregatesResolvers<ContextType>;
  AdminRoleMinAggregates?: AdminRoleMinAggregatesResolvers<ContextType>;
  AdminRoleStddevPopulationAggregates?: AdminRoleStddevPopulationAggregatesResolvers<ContextType>;
  AdminRoleStddevSampleAggregates?: AdminRoleStddevSampleAggregatesResolvers<ContextType>;
  AdminRoleSumAggregates?: AdminRoleSumAggregatesResolvers<ContextType>;
  AdminRoleUsersUser?: AdminRoleUsersUserResolvers<ContextType>;
  AdminRoleUsersUserAggregates?: AdminRoleUsersUserAggregatesResolvers<ContextType>;
  AdminRoleUsersUserAverageAggregates?: AdminRoleUsersUserAverageAggregatesResolvers<ContextType>;
  AdminRoleUsersUserConnection?: AdminRoleUsersUserConnectionResolvers<ContextType>;
  AdminRoleUsersUserDistinctCountAggregates?: AdminRoleUsersUserDistinctCountAggregatesResolvers<ContextType>;
  AdminRoleUsersUserEdge?: AdminRoleUsersUserEdgeResolvers<ContextType>;
  AdminRoleUsersUserMaxAggregates?: AdminRoleUsersUserMaxAggregatesResolvers<ContextType>;
  AdminRoleUsersUserMinAggregates?: AdminRoleUsersUserMinAggregatesResolvers<ContextType>;
  AdminRoleUsersUserStddevPopulationAggregates?: AdminRoleUsersUserStddevPopulationAggregatesResolvers<ContextType>;
  AdminRoleUsersUserStddevSampleAggregates?: AdminRoleUsersUserStddevSampleAggregatesResolvers<ContextType>;
  AdminRoleUsersUserSumAggregates?: AdminRoleUsersUserSumAggregatesResolvers<ContextType>;
  AdminRoleUsersUserVariancePopulationAggregates?: AdminRoleUsersUserVariancePopulationAggregatesResolvers<ContextType>;
  AdminRoleUsersUserVarianceSampleAggregates?: AdminRoleUsersUserVarianceSampleAggregatesResolvers<ContextType>;
  AdminRoleVariancePopulationAggregates?: AdminRoleVariancePopulationAggregatesResolvers<ContextType>;
  AdminRoleVarianceSampleAggregates?: AdminRoleVarianceSampleAggregatesResolvers<ContextType>;
  Affiliate?: AffiliateResolvers<ContextType>;
  AffiliateAudit?: AffiliateAuditResolvers<ContextType>;
  AffiliateAuditAggregates?: AffiliateAuditAggregatesResolvers<ContextType>;
  AffiliateAuditAverageAggregates?: AffiliateAuditAverageAggregatesResolvers<ContextType>;
  AffiliateAuditConnection?: AffiliateAuditConnectionResolvers<ContextType>;
  AffiliateAuditDistinctCountAggregates?: AffiliateAuditDistinctCountAggregatesResolvers<ContextType>;
  AffiliateAuditEdge?: AffiliateAuditEdgeResolvers<ContextType>;
  AffiliateAuditMaxAggregates?: AffiliateAuditMaxAggregatesResolvers<ContextType>;
  AffiliateAuditMinAggregates?: AffiliateAuditMinAggregatesResolvers<ContextType>;
  AffiliateAuditStddevPopulationAggregates?: AffiliateAuditStddevPopulationAggregatesResolvers<ContextType>;
  AffiliateAuditStddevSampleAggregates?: AffiliateAuditStddevSampleAggregatesResolvers<ContextType>;
  AffiliateAuditSumAggregates?: AffiliateAuditSumAggregatesResolvers<ContextType>;
  AffiliateAuditVariancePopulationAggregates?: AffiliateAuditVariancePopulationAggregatesResolvers<ContextType>;
  AffiliateAuditVarianceSampleAggregates?: AffiliateAuditVarianceSampleAggregatesResolvers<ContextType>;
  AffiliateCommissionRate?: AffiliateCommissionRateResolvers<ContextType>;
  AffiliateCommissionRateAggregates?: AffiliateCommissionRateAggregatesResolvers<ContextType>;
  AffiliateCommissionRateAverageAggregates?: AffiliateCommissionRateAverageAggregatesResolvers<ContextType>;
  AffiliateCommissionRateConnection?: AffiliateCommissionRateConnectionResolvers<ContextType>;
  AffiliateCommissionRateDistinctCountAggregates?: AffiliateCommissionRateDistinctCountAggregatesResolvers<ContextType>;
  AffiliateCommissionRateEdge?: AffiliateCommissionRateEdgeResolvers<ContextType>;
  AffiliateCommissionRateMaxAggregates?: AffiliateCommissionRateMaxAggregatesResolvers<ContextType>;
  AffiliateCommissionRateMinAggregates?: AffiliateCommissionRateMinAggregatesResolvers<ContextType>;
  AffiliateCommissionRateStddevPopulationAggregates?: AffiliateCommissionRateStddevPopulationAggregatesResolvers<ContextType>;
  AffiliateCommissionRateStddevSampleAggregates?: AffiliateCommissionRateStddevSampleAggregatesResolvers<ContextType>;
  AffiliateCommissionRateSumAggregates?: AffiliateCommissionRateSumAggregatesResolvers<ContextType>;
  AffiliateCommissionRateVariancePopulationAggregates?: AffiliateCommissionRateVariancePopulationAggregatesResolvers<ContextType>;
  AffiliateCommissionRateVarianceSampleAggregates?: AffiliateCommissionRateVarianceSampleAggregatesResolvers<ContextType>;
  AffiliateLedger?: AffiliateLedgerResolvers<ContextType>;
  AffiliateLedgerAggregates?: AffiliateLedgerAggregatesResolvers<ContextType>;
  AffiliateLedgerAverageAggregates?: AffiliateLedgerAverageAggregatesResolvers<ContextType>;
  AffiliateLedgerConnection?: AffiliateLedgerConnectionResolvers<ContextType>;
  AffiliateLedgerDistinctCountAggregates?: AffiliateLedgerDistinctCountAggregatesResolvers<ContextType>;
  AffiliateLedgerEdge?: AffiliateLedgerEdgeResolvers<ContextType>;
  AffiliateLedgerMaxAggregates?: AffiliateLedgerMaxAggregatesResolvers<ContextType>;
  AffiliateLedgerMinAggregates?: AffiliateLedgerMinAggregatesResolvers<ContextType>;
  AffiliateLedgerStddevPopulationAggregates?: AffiliateLedgerStddevPopulationAggregatesResolvers<ContextType>;
  AffiliateLedgerStddevSampleAggregates?: AffiliateLedgerStddevSampleAggregatesResolvers<ContextType>;
  AffiliateLedgerSumAggregates?: AffiliateLedgerSumAggregatesResolvers<ContextType>;
  AffiliateLedgerVariancePopulationAggregates?: AffiliateLedgerVariancePopulationAggregatesResolvers<ContextType>;
  AffiliateLedgerVarianceSampleAggregates?: AffiliateLedgerVarianceSampleAggregatesResolvers<ContextType>;
  AffiliatePayment?: AffiliatePaymentResolvers<ContextType>;
  AffiliatePaymentAggregates?: AffiliatePaymentAggregatesResolvers<ContextType>;
  AffiliatePaymentAverageAggregates?: AffiliatePaymentAverageAggregatesResolvers<ContextType>;
  AffiliatePaymentConnection?: AffiliatePaymentConnectionResolvers<ContextType>;
  AffiliatePaymentDistinctCountAggregates?: AffiliatePaymentDistinctCountAggregatesResolvers<ContextType>;
  AffiliatePaymentEdge?: AffiliatePaymentEdgeResolvers<ContextType>;
  AffiliatePaymentMaxAggregates?: AffiliatePaymentMaxAggregatesResolvers<ContextType>;
  AffiliatePaymentMinAggregates?: AffiliatePaymentMinAggregatesResolvers<ContextType>;
  AffiliatePaymentStddevPopulationAggregates?: AffiliatePaymentStddevPopulationAggregatesResolvers<ContextType>;
  AffiliatePaymentStddevSampleAggregates?: AffiliatePaymentStddevSampleAggregatesResolvers<ContextType>;
  AffiliatePaymentSumAggregates?: AffiliatePaymentSumAggregatesResolvers<ContextType>;
  AffiliatePaymentVariancePopulationAggregates?: AffiliatePaymentVariancePopulationAggregatesResolvers<ContextType>;
  AffiliatePaymentVarianceSampleAggregates?: AffiliatePaymentVarianceSampleAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriod?: AffiliatePayoutPeriodResolvers<ContextType>;
  AffiliatePayoutPeriodAggregates?: AffiliatePayoutPeriodAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodAverageAggregates?: AffiliatePayoutPeriodAverageAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodConnection?: AffiliatePayoutPeriodConnectionResolvers<ContextType>;
  AffiliatePayoutPeriodDistinctCountAggregates?: AffiliatePayoutPeriodDistinctCountAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodEdge?: AffiliatePayoutPeriodEdgeResolvers<ContextType>;
  AffiliatePayoutPeriodMaxAggregates?: AffiliatePayoutPeriodMaxAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodMinAggregates?: AffiliatePayoutPeriodMinAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodStddevPopulationAggregates?: AffiliatePayoutPeriodStddevPopulationAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodStddevSampleAggregates?: AffiliatePayoutPeriodStddevSampleAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodSumAggregates?: AffiliatePayoutPeriodSumAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodVariancePopulationAggregates?: AffiliatePayoutPeriodVariancePopulationAggregatesResolvers<ContextType>;
  AffiliatePayoutPeriodVarianceSampleAggregates?: AffiliatePayoutPeriodVarianceSampleAggregatesResolvers<ContextType>;
  AggregateAccountTradeStatByDayConnection?: AggregateAccountTradeStatByDayConnectionResolvers<ContextType>;
  AggregateAccountTradeStatByDayEdge?: AggregateAccountTradeStatByDayEdgeResolvers<ContextType>;
  AggregateAccountTradeStatByDayRecord?: AggregateAccountTradeStatByDayRecordResolvers<ContextType>;
  AwsdmsChanges3728E4207De1F2E6?: AwsdmsChanges3728E4207De1F2E6Resolvers<ContextType>;
  AwsdmsDdlAudit?: AwsdmsDdlAuditResolvers<ContextType>;
  AwsdmsHeartbeat?: AwsdmsHeartbeatResolvers<ContextType>;
  BatchExecution?: BatchExecutionResolvers<ContextType>;
  BestTradingDay?: BestTradingDayResolvers<ContextType>;
  BigFloat?: GraphQLScalarType;
  BigInt?: GraphQLScalarType;
  BulkAction?: BulkActionResolvers<ContextType>;
  BulkCapitalUploadPayload?: BulkCapitalUploadPayloadResolvers<ContextType>;
  BulkCapitalUploadRowResult?: BulkCapitalUploadRowResultResolvers<ContextType>;
  BypassUserTaxFormValidationResult?: BypassUserTaxFormValidationResultResolvers<ContextType>;
  CardTransaction?: CardTransactionResolvers<ContextType>;
  CardTransactionAggregates?: CardTransactionAggregatesResolvers<ContextType>;
  CardTransactionAverageAggregates?: CardTransactionAverageAggregatesResolvers<ContextType>;
  CardTransactionConnection?: CardTransactionConnectionResolvers<ContextType>;
  CardTransactionDistinctCountAggregates?: CardTransactionDistinctCountAggregatesResolvers<ContextType>;
  CardTransactionEdge?: CardTransactionEdgeResolvers<ContextType>;
  CardTransactionMaxAggregates?: CardTransactionMaxAggregatesResolvers<ContextType>;
  CardTransactionMinAggregates?: CardTransactionMinAggregatesResolvers<ContextType>;
  CardTransactionStddevPopulationAggregates?: CardTransactionStddevPopulationAggregatesResolvers<ContextType>;
  CardTransactionStddevSampleAggregates?: CardTransactionStddevSampleAggregatesResolvers<ContextType>;
  CardTransactionSumAggregates?: CardTransactionSumAggregatesResolvers<ContextType>;
  CardTransactionVariancePopulationAggregates?: CardTransactionVariancePopulationAggregatesResolvers<ContextType>;
  CardTransactionVarianceSampleAggregates?: CardTransactionVarianceSampleAggregatesResolvers<ContextType>;
  CaseAssignableUser?: CaseAssignableUserResolvers<ContextType>;
  CaseBan?: CaseBanResolvers<ContextType>;
  CaseBanAggregates?: CaseBanAggregatesResolvers<ContextType>;
  CaseBanAverageAggregates?: CaseBanAverageAggregatesResolvers<ContextType>;
  CaseBanConnection?: CaseBanConnectionResolvers<ContextType>;
  CaseBanDistinctCountAggregates?: CaseBanDistinctCountAggregatesResolvers<ContextType>;
  CaseBanEdge?: CaseBanEdgeResolvers<ContextType>;
  CaseBanEventResult?: CaseBanEventResultResolvers<ContextType>;
  CaseBanMaxAggregates?: CaseBanMaxAggregatesResolvers<ContextType>;
  CaseBanMinAggregates?: CaseBanMinAggregatesResolvers<ContextType>;
  CaseBanReasonCode?: CaseBanReasonCodeResolvers<ContextType>;
  CaseBanReasonCodeAggregates?: CaseBanReasonCodeAggregatesResolvers<ContextType>;
  CaseBanReasonCodeAverageAggregates?: CaseBanReasonCodeAverageAggregatesResolvers<ContextType>;
  CaseBanReasonCodeConnection?: CaseBanReasonCodeConnectionResolvers<ContextType>;
  CaseBanReasonCodeDistinctCountAggregates?: CaseBanReasonCodeDistinctCountAggregatesResolvers<ContextType>;
  CaseBanReasonCodeEdge?: CaseBanReasonCodeEdgeResolvers<ContextType>;
  CaseBanReasonCodeMaxAggregates?: CaseBanReasonCodeMaxAggregatesResolvers<ContextType>;
  CaseBanReasonCodeMinAggregates?: CaseBanReasonCodeMinAggregatesResolvers<ContextType>;
  CaseBanReasonCodeStddevPopulationAggregates?: CaseBanReasonCodeStddevPopulationAggregatesResolvers<ContextType>;
  CaseBanReasonCodeStddevSampleAggregates?: CaseBanReasonCodeStddevSampleAggregatesResolvers<ContextType>;
  CaseBanReasonCodeSumAggregates?: CaseBanReasonCodeSumAggregatesResolvers<ContextType>;
  CaseBanReasonCodeVariancePopulationAggregates?: CaseBanReasonCodeVariancePopulationAggregatesResolvers<ContextType>;
  CaseBanReasonCodeVarianceSampleAggregates?: CaseBanReasonCodeVarianceSampleAggregatesResolvers<ContextType>;
  CaseBanResult?: CaseBanResultResolvers<ContextType>;
  CaseBanStddevPopulationAggregates?: CaseBanStddevPopulationAggregatesResolvers<ContextType>;
  CaseBanStddevSampleAggregates?: CaseBanStddevSampleAggregatesResolvers<ContextType>;
  CaseBanSumAggregates?: CaseBanSumAggregatesResolvers<ContextType>;
  CaseBanTrader?: CaseBanTraderResolvers<ContextType>;
  CaseBanTraderAggregates?: CaseBanTraderAggregatesResolvers<ContextType>;
  CaseBanTraderAverageAggregates?: CaseBanTraderAverageAggregatesResolvers<ContextType>;
  CaseBanTraderConnection?: CaseBanTraderConnectionResolvers<ContextType>;
  CaseBanTraderDistinctCountAggregates?: CaseBanTraderDistinctCountAggregatesResolvers<ContextType>;
  CaseBanTraderEdge?: CaseBanTraderEdgeResolvers<ContextType>;
  CaseBanTraderMaxAggregates?: CaseBanTraderMaxAggregatesResolvers<ContextType>;
  CaseBanTraderMinAggregates?: CaseBanTraderMinAggregatesResolvers<ContextType>;
  CaseBanTraderPendingDetailsResult?: CaseBanTraderPendingDetailsResultResolvers<ContextType>;
  CaseBanTraderResult?: CaseBanTraderResultResolvers<ContextType>;
  CaseBanTraderStddevPopulationAggregates?: CaseBanTraderStddevPopulationAggregatesResolvers<ContextType>;
  CaseBanTraderStddevSampleAggregates?: CaseBanTraderStddevSampleAggregatesResolvers<ContextType>;
  CaseBanTraderSumAggregates?: CaseBanTraderSumAggregatesResolvers<ContextType>;
  CaseBanTraderVariancePopulationAggregates?: CaseBanTraderVariancePopulationAggregatesResolvers<ContextType>;
  CaseBanTraderVarianceSampleAggregates?: CaseBanTraderVarianceSampleAggregatesResolvers<ContextType>;
  CaseBanTradersRemovedResult?: CaseBanTradersRemovedResultResolvers<ContextType>;
  CaseBanVariancePopulationAggregates?: CaseBanVariancePopulationAggregatesResolvers<ContextType>;
  CaseBanVarianceSampleAggregates?: CaseBanVarianceSampleAggregatesResolvers<ContextType>;
  CaseDepartment?: CaseDepartmentResolvers<ContextType>;
  CaseEvent?: CaseEventResolvers<ContextType>;
  CaseEventAggregates?: CaseEventAggregatesResolvers<ContextType>;
  CaseEventAverageAggregates?: CaseEventAverageAggregatesResolvers<ContextType>;
  CaseEventConnection?: CaseEventConnectionResolvers<ContextType>;
  CaseEventDistinctCountAggregates?: CaseEventDistinctCountAggregatesResolvers<ContextType>;
  CaseEventEdge?: CaseEventEdgeResolvers<ContextType>;
  CaseEventMaxAggregates?: CaseEventMaxAggregatesResolvers<ContextType>;
  CaseEventMinAggregates?: CaseEventMinAggregatesResolvers<ContextType>;
  CaseEventStddevPopulationAggregates?: CaseEventStddevPopulationAggregatesResolvers<ContextType>;
  CaseEventStddevSampleAggregates?: CaseEventStddevSampleAggregatesResolvers<ContextType>;
  CaseEventSumAggregates?: CaseEventSumAggregatesResolvers<ContextType>;
  CaseEventVariancePopulationAggregates?: CaseEventVariancePopulationAggregatesResolvers<ContextType>;
  CaseEventVarianceSampleAggregates?: CaseEventVarianceSampleAggregatesResolvers<ContextType>;
  CaseInvestigation?: CaseInvestigationResolvers<ContextType>;
  CaseInvestigationAggregates?: CaseInvestigationAggregatesResolvers<ContextType>;
  CaseInvestigationAverageAggregates?: CaseInvestigationAverageAggregatesResolvers<ContextType>;
  CaseInvestigationConnection?: CaseInvestigationConnectionResolvers<ContextType>;
  CaseInvestigationDistinctCountAggregates?: CaseInvestigationDistinctCountAggregatesResolvers<ContextType>;
  CaseInvestigationEdge?: CaseInvestigationEdgeResolvers<ContextType>;
  CaseInvestigationEventResult?: CaseInvestigationEventResultResolvers<ContextType>;
  CaseInvestigationMaxAggregates?: CaseInvestigationMaxAggregatesResolvers<ContextType>;
  CaseInvestigationMinAggregates?: CaseInvestigationMinAggregatesResolvers<ContextType>;
  CaseInvestigationResult?: CaseInvestigationResultResolvers<ContextType>;
  CaseInvestigationStddevPopulationAggregates?: CaseInvestigationStddevPopulationAggregatesResolvers<ContextType>;
  CaseInvestigationStddevSampleAggregates?: CaseInvestigationStddevSampleAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartment?: CaseInvestigationSubmittedDepartmentResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentAggregates?: CaseInvestigationSubmittedDepartmentAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentAverageAggregates?: CaseInvestigationSubmittedDepartmentAverageAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentConnection?: CaseInvestigationSubmittedDepartmentConnectionResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentDistinctCountAggregates?: CaseInvestigationSubmittedDepartmentDistinctCountAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentEdge?: CaseInvestigationSubmittedDepartmentEdgeResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentMaxAggregates?: CaseInvestigationSubmittedDepartmentMaxAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentMinAggregates?: CaseInvestigationSubmittedDepartmentMinAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentStddevPopulationAggregates?: CaseInvestigationSubmittedDepartmentStddevPopulationAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentStddevSampleAggregates?: CaseInvestigationSubmittedDepartmentStddevSampleAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentSumAggregates?: CaseInvestigationSubmittedDepartmentSumAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentVariancePopulationAggregates?: CaseInvestigationSubmittedDepartmentVariancePopulationAggregatesResolvers<ContextType>;
  CaseInvestigationSubmittedDepartmentVarianceSampleAggregates?: CaseInvestigationSubmittedDepartmentVarianceSampleAggregatesResolvers<ContextType>;
  CaseInvestigationSumAggregates?: CaseInvestigationSumAggregatesResolvers<ContextType>;
  CaseInvestigationTrader?: CaseInvestigationTraderResolvers<ContextType>;
  CaseInvestigationTraderAggregates?: CaseInvestigationTraderAggregatesResolvers<ContextType>;
  CaseInvestigationTraderAverageAggregates?: CaseInvestigationTraderAverageAggregatesResolvers<ContextType>;
  CaseInvestigationTraderConnection?: CaseInvestigationTraderConnectionResolvers<ContextType>;
  CaseInvestigationTraderDistinctCountAggregates?: CaseInvestigationTraderDistinctCountAggregatesResolvers<ContextType>;
  CaseInvestigationTraderEdge?: CaseInvestigationTraderEdgeResolvers<ContextType>;
  CaseInvestigationTraderMaxAggregates?: CaseInvestigationTraderMaxAggregatesResolvers<ContextType>;
  CaseInvestigationTraderMinAggregates?: CaseInvestigationTraderMinAggregatesResolvers<ContextType>;
  CaseInvestigationTraderPendingDetailsResult?: CaseInvestigationTraderPendingDetailsResultResolvers<ContextType>;
  CaseInvestigationTraderResult?: CaseInvestigationTraderResultResolvers<ContextType>;
  CaseInvestigationTraderStddevPopulationAggregates?: CaseInvestigationTraderStddevPopulationAggregatesResolvers<ContextType>;
  CaseInvestigationTraderStddevSampleAggregates?: CaseInvestigationTraderStddevSampleAggregatesResolvers<ContextType>;
  CaseInvestigationTraderSumAggregates?: CaseInvestigationTraderSumAggregatesResolvers<ContextType>;
  CaseInvestigationTraderVariancePopulationAggregates?: CaseInvestigationTraderVariancePopulationAggregatesResolvers<ContextType>;
  CaseInvestigationTraderVarianceSampleAggregates?: CaseInvestigationTraderVarianceSampleAggregatesResolvers<ContextType>;
  CaseInvestigationTradersRemovedResult?: CaseInvestigationTradersRemovedResultResolvers<ContextType>;
  CaseInvestigationVariancePopulationAggregates?: CaseInvestigationVariancePopulationAggregatesResolvers<ContextType>;
  CaseInvestigationVarianceSampleAggregates?: CaseInvestigationVarianceSampleAggregatesResolvers<ContextType>;
  CaseLabel?: CaseLabelResolvers<ContextType>;
  CaseLabelAggregates?: CaseLabelAggregatesResolvers<ContextType>;
  CaseLabelAssignment?: CaseLabelAssignmentResolvers<ContextType>;
  CaseLabelAssignmentAggregates?: CaseLabelAssignmentAggregatesResolvers<ContextType>;
  CaseLabelAssignmentAverageAggregates?: CaseLabelAssignmentAverageAggregatesResolvers<ContextType>;
  CaseLabelAssignmentConnection?: CaseLabelAssignmentConnectionResolvers<ContextType>;
  CaseLabelAssignmentDistinctCountAggregates?: CaseLabelAssignmentDistinctCountAggregatesResolvers<ContextType>;
  CaseLabelAssignmentEdge?: CaseLabelAssignmentEdgeResolvers<ContextType>;
  CaseLabelAssignmentMaxAggregates?: CaseLabelAssignmentMaxAggregatesResolvers<ContextType>;
  CaseLabelAssignmentMinAggregates?: CaseLabelAssignmentMinAggregatesResolvers<ContextType>;
  CaseLabelAssignmentStddevPopulationAggregates?: CaseLabelAssignmentStddevPopulationAggregatesResolvers<ContextType>;
  CaseLabelAssignmentStddevSampleAggregates?: CaseLabelAssignmentStddevSampleAggregatesResolvers<ContextType>;
  CaseLabelAssignmentSumAggregates?: CaseLabelAssignmentSumAggregatesResolvers<ContextType>;
  CaseLabelAssignmentVariancePopulationAggregates?: CaseLabelAssignmentVariancePopulationAggregatesResolvers<ContextType>;
  CaseLabelAssignmentVarianceSampleAggregates?: CaseLabelAssignmentVarianceSampleAggregatesResolvers<ContextType>;
  CaseLabelAverageAggregates?: CaseLabelAverageAggregatesResolvers<ContextType>;
  CaseLabelConnection?: CaseLabelConnectionResolvers<ContextType>;
  CaseLabelDistinctCountAggregates?: CaseLabelDistinctCountAggregatesResolvers<ContextType>;
  CaseLabelEdge?: CaseLabelEdgeResolvers<ContextType>;
  CaseLabelMaxAggregates?: CaseLabelMaxAggregatesResolvers<ContextType>;
  CaseLabelMinAggregates?: CaseLabelMinAggregatesResolvers<ContextType>;
  CaseLabelStddevPopulationAggregates?: CaseLabelStddevPopulationAggregatesResolvers<ContextType>;
  CaseLabelStddevSampleAggregates?: CaseLabelStddevSampleAggregatesResolvers<ContextType>;
  CaseLabelSumAggregates?: CaseLabelSumAggregatesResolvers<ContextType>;
  CaseLabelVariancePopulationAggregates?: CaseLabelVariancePopulationAggregatesResolvers<ContextType>;
  CaseLabelVarianceSampleAggregates?: CaseLabelVarianceSampleAggregatesResolvers<ContextType>;
  CaseType?: CaseTypeResolvers<ContextType>;
  CaseTypeAggregates?: CaseTypeAggregatesResolvers<ContextType>;
  CaseTypeAverageAggregates?: CaseTypeAverageAggregatesResolvers<ContextType>;
  CaseTypeConnection?: CaseTypeConnectionResolvers<ContextType>;
  CaseTypeDistinctCountAggregates?: CaseTypeDistinctCountAggregatesResolvers<ContextType>;
  CaseTypeEdge?: CaseTypeEdgeResolvers<ContextType>;
  CaseTypeMaxAggregates?: CaseTypeMaxAggregatesResolvers<ContextType>;
  CaseTypeMinAggregates?: CaseTypeMinAggregatesResolvers<ContextType>;
  CaseTypeStddevPopulationAggregates?: CaseTypeStddevPopulationAggregatesResolvers<ContextType>;
  CaseTypeStddevSampleAggregates?: CaseTypeStddevSampleAggregatesResolvers<ContextType>;
  CaseTypeSumAggregates?: CaseTypeSumAggregatesResolvers<ContextType>;
  CaseTypeVariancePopulationAggregates?: CaseTypeVariancePopulationAggregatesResolvers<ContextType>;
  CaseTypeVarianceSampleAggregates?: CaseTypeVarianceSampleAggregatesResolvers<ContextType>;
  Chargeback?: ChargebackResolvers<ContextType>;
  ChargebackAdminAction?: ChargebackAdminActionResolvers<ContextType>;
  ChargebackAggregates?: ChargebackAggregatesResolvers<ContextType>;
  ChargebackAverageAggregates?: ChargebackAverageAggregatesResolvers<ContextType>;
  ChargebackConnection?: ChargebackConnectionResolvers<ContextType>;
  ChargebackDistinctCountAggregates?: ChargebackDistinctCountAggregatesResolvers<ContextType>;
  ChargebackEdge?: ChargebackEdgeResolvers<ContextType>;
  ChargebackFeedRun?: ChargebackFeedRunResolvers<ContextType>;
  ChargebackFeedSource?: ChargebackFeedSourceResolvers<ContextType>;
  ChargebackFeedVersion?: ChargebackFeedVersionResolvers<ContextType>;
  ChargebackFeedVersionAggregates?: ChargebackFeedVersionAggregatesResolvers<ContextType>;
  ChargebackFeedVersionAverageAggregates?: ChargebackFeedVersionAverageAggregatesResolvers<ContextType>;
  ChargebackFeedVersionConnection?: ChargebackFeedVersionConnectionResolvers<ContextType>;
  ChargebackFeedVersionDistinctCountAggregates?: ChargebackFeedVersionDistinctCountAggregatesResolvers<ContextType>;
  ChargebackFeedVersionEdge?: ChargebackFeedVersionEdgeResolvers<ContextType>;
  ChargebackFeedVersionMaxAggregates?: ChargebackFeedVersionMaxAggregatesResolvers<ContextType>;
  ChargebackFeedVersionMinAggregates?: ChargebackFeedVersionMinAggregatesResolvers<ContextType>;
  ChargebackFeedVersionStddevPopulationAggregates?: ChargebackFeedVersionStddevPopulationAggregatesResolvers<ContextType>;
  ChargebackFeedVersionStddevSampleAggregates?: ChargebackFeedVersionStddevSampleAggregatesResolvers<ContextType>;
  ChargebackFeedVersionSumAggregates?: ChargebackFeedVersionSumAggregatesResolvers<ContextType>;
  ChargebackFeedVersionVariancePopulationAggregates?: ChargebackFeedVersionVariancePopulationAggregatesResolvers<ContextType>;
  ChargebackFeedVersionVarianceSampleAggregates?: ChargebackFeedVersionVarianceSampleAggregatesResolvers<ContextType>;
  ChargebackFlag?: ChargebackFlagResolvers<ContextType>;
  ChargebackIndicator?: ChargebackIndicatorResolvers<ContextType>;
  ChargebackIndicatorAggregates?: ChargebackIndicatorAggregatesResolvers<ContextType>;
  ChargebackIndicatorAverageAggregates?: ChargebackIndicatorAverageAggregatesResolvers<ContextType>;
  ChargebackIndicatorConnection?: ChargebackIndicatorConnectionResolvers<ContextType>;
  ChargebackIndicatorDistinctCountAggregates?: ChargebackIndicatorDistinctCountAggregatesResolvers<ContextType>;
  ChargebackIndicatorEdge?: ChargebackIndicatorEdgeResolvers<ContextType>;
  ChargebackIndicatorMaxAggregates?: ChargebackIndicatorMaxAggregatesResolvers<ContextType>;
  ChargebackIndicatorMinAggregates?: ChargebackIndicatorMinAggregatesResolvers<ContextType>;
  ChargebackIndicatorStddevPopulationAggregates?: ChargebackIndicatorStddevPopulationAggregatesResolvers<ContextType>;
  ChargebackIndicatorStddevSampleAggregates?: ChargebackIndicatorStddevSampleAggregatesResolvers<ContextType>;
  ChargebackIndicatorSumAggregates?: ChargebackIndicatorSumAggregatesResolvers<ContextType>;
  ChargebackIndicatorVariancePopulationAggregates?: ChargebackIndicatorVariancePopulationAggregatesResolvers<ContextType>;
  ChargebackIndicatorVarianceSampleAggregates?: ChargebackIndicatorVarianceSampleAggregatesResolvers<ContextType>;
  ChargebackMaxAggregates?: ChargebackMaxAggregatesResolvers<ContextType>;
  ChargebackMinAggregates?: ChargebackMinAggregatesResolvers<ContextType>;
  ChargebackResult?: ChargebackResultResolvers<ContextType>;
  ChargebackStddevPopulationAggregates?: ChargebackStddevPopulationAggregatesResolvers<ContextType>;
  ChargebackStddevSampleAggregates?: ChargebackStddevSampleAggregatesResolvers<ContextType>;
  ChargebackSumAggregates?: ChargebackSumAggregatesResolvers<ContextType>;
  ChargebackTotals?: ChargebackTotalsResolvers<ContextType>;
  ChargebackVariancePopulationAggregates?: ChargebackVariancePopulationAggregatesResolvers<ContextType>;
  ChargebackVarianceSampleAggregates?: ChargebackVarianceSampleAggregatesResolvers<ContextType>;
  CheckoutItem?: CheckoutItemResolvers<ContextType>;
  CheckoutItemAggregates?: CheckoutItemAggregatesResolvers<ContextType>;
  CheckoutItemAverageAggregates?: CheckoutItemAverageAggregatesResolvers<ContextType>;
  CheckoutItemConnection?: CheckoutItemConnectionResolvers<ContextType>;
  CheckoutItemDistinctCountAggregates?: CheckoutItemDistinctCountAggregatesResolvers<ContextType>;
  CheckoutItemEdge?: CheckoutItemEdgeResolvers<ContextType>;
  CheckoutItemMaxAggregates?: CheckoutItemMaxAggregatesResolvers<ContextType>;
  CheckoutItemMinAggregates?: CheckoutItemMinAggregatesResolvers<ContextType>;
  CheckoutItemStddevPopulationAggregates?: CheckoutItemStddevPopulationAggregatesResolvers<ContextType>;
  CheckoutItemStddevSampleAggregates?: CheckoutItemStddevSampleAggregatesResolvers<ContextType>;
  CheckoutItemSumAggregates?: CheckoutItemSumAggregatesResolvers<ContextType>;
  CheckoutItemVariancePopulationAggregates?: CheckoutItemVariancePopulationAggregatesResolvers<ContextType>;
  CheckoutItemVarianceSampleAggregates?: CheckoutItemVarianceSampleAggregatesResolvers<ContextType>;
  CheckoutSession?: CheckoutSessionResolvers<ContextType>;
  CheckoutSessionAggregates?: CheckoutSessionAggregatesResolvers<ContextType>;
  CheckoutSessionAverageAggregates?: CheckoutSessionAverageAggregatesResolvers<ContextType>;
  CheckoutSessionConnection?: CheckoutSessionConnectionResolvers<ContextType>;
  CheckoutSessionDistinctCountAggregates?: CheckoutSessionDistinctCountAggregatesResolvers<ContextType>;
  CheckoutSessionEdge?: CheckoutSessionEdgeResolvers<ContextType>;
  CheckoutSessionMaxAggregates?: CheckoutSessionMaxAggregatesResolvers<ContextType>;
  CheckoutSessionMinAggregates?: CheckoutSessionMinAggregatesResolvers<ContextType>;
  CheckoutSessionStddevPopulationAggregates?: CheckoutSessionStddevPopulationAggregatesResolvers<ContextType>;
  CheckoutSessionStddevSampleAggregates?: CheckoutSessionStddevSampleAggregatesResolvers<ContextType>;
  CheckoutSessionSumAggregates?: CheckoutSessionSumAggregatesResolvers<ContextType>;
  CheckoutSessionVariancePopulationAggregates?: CheckoutSessionVariancePopulationAggregatesResolvers<ContextType>;
  CheckoutSessionVarianceSampleAggregates?: CheckoutSessionVarianceSampleAggregatesResolvers<ContextType>;
  Coupon?: CouponResolvers<ContextType>;
  CouponAggregates?: CouponAggregatesResolvers<ContextType>;
  CouponAverageAggregates?: CouponAverageAggregatesResolvers<ContextType>;
  CouponConnection?: CouponConnectionResolvers<ContextType>;
  CouponDistinctCountAggregates?: CouponDistinctCountAggregatesResolvers<ContextType>;
  CouponEdge?: CouponEdgeResolvers<ContextType>;
  CouponMaxAggregates?: CouponMaxAggregatesResolvers<ContextType>;
  CouponMinAggregates?: CouponMinAggregatesResolvers<ContextType>;
  CouponPlatform?: CouponPlatformResolvers<ContextType>;
  CouponRedemption?: CouponRedemptionResolvers<ContextType>;
  CouponStddevPopulationAggregates?: CouponStddevPopulationAggregatesResolvers<ContextType>;
  CouponStddevSampleAggregates?: CouponStddevSampleAggregatesResolvers<ContextType>;
  CouponSumAggregates?: CouponSumAggregatesResolvers<ContextType>;
  CouponUser?: CouponUserResolvers<ContextType>;
  CouponUserAggregates?: CouponUserAggregatesResolvers<ContextType>;
  CouponUserAverageAggregates?: CouponUserAverageAggregatesResolvers<ContextType>;
  CouponUserConnection?: CouponUserConnectionResolvers<ContextType>;
  CouponUserDistinctCountAggregates?: CouponUserDistinctCountAggregatesResolvers<ContextType>;
  CouponUserEdge?: CouponUserEdgeResolvers<ContextType>;
  CouponUserMaxAggregates?: CouponUserMaxAggregatesResolvers<ContextType>;
  CouponUserMinAggregates?: CouponUserMinAggregatesResolvers<ContextType>;
  CouponUserStddevPopulationAggregates?: CouponUserStddevPopulationAggregatesResolvers<ContextType>;
  CouponUserStddevSampleAggregates?: CouponUserStddevSampleAggregatesResolvers<ContextType>;
  CouponUserSumAggregates?: CouponUserSumAggregatesResolvers<ContextType>;
  CouponUserVariancePopulationAggregates?: CouponUserVariancePopulationAggregatesResolvers<ContextType>;
  CouponUserVarianceSampleAggregates?: CouponUserVarianceSampleAggregatesResolvers<ContextType>;
  CouponVariancePopulationAggregates?: CouponVariancePopulationAggregatesResolvers<ContextType>;
  CouponVarianceSampleAggregates?: CouponVarianceSampleAggregatesResolvers<ContextType>;
  CreateImpactGroupAssignmentPayload?: CreateImpactGroupAssignmentPayloadResolvers<ContextType>;
  CreateImpactGroupTemplatePayload?: CreateImpactGroupTemplatePayloadResolvers<ContextType>;
  CreateKycPriorityLabelPayload?: CreateKycPriorityLabelPayloadResolvers<ContextType>;
  CreateKycPriorityReviewConfigPayload?: CreateKycPriorityReviewConfigPayloadResolvers<ContextType>;
  CreateTraderRiskIndicatorPayload?: CreateTraderRiskIndicatorPayloadResolvers<ContextType>;
  CreateTradingProductFeePayload?: CreateTradingProductFeePayloadResolvers<ContextType>;
  CreateUserAddressPayload?: CreateUserAddressPayloadResolvers<ContextType>;
  CreateUserTaxFormPayload?: CreateUserTaxFormPayloadResolvers<ContextType>;
  CreateXfaActivationCreditPayload?: CreateXfaActivationCreditPayloadResolvers<ContextType>;
  CurrentAdminRole?: CurrentAdminRoleResolvers<ContextType>;
  Cursor?: GraphQLScalarType;
  Date?: GraphQLScalarType;
  Datetime?: GraphQLScalarType;
  DeleteImpactGroupAssignmentPayload?: DeleteImpactGroupAssignmentPayloadResolvers<ContextType>;
  DeleteKycPriorityLabelPayload?: DeleteKycPriorityLabelPayloadResolvers<ContextType>;
  DeleteUserAddressPayload?: DeleteUserAddressPayloadResolvers<ContextType>;
  DeleteXfaActivationCreditPayload?: DeleteXfaActivationCreditPayloadResolvers<ContextType>;
  DiscordLinkUrlPayload?: DiscordLinkUrlPayloadResolvers<ContextType>;
  DllDailyMetrics?: DllDailyMetricsResolvers<ContextType>;
  DocuSignAuthResult?: DocuSignAuthResultResolvers<ContextType>;
  DocuSignEnvelopeStatusResult?: DocuSignEnvelopeStatusResultResolvers<ContextType>;
  Email?: EmailResolvers<ContextType>;
  EmailAction?: EmailActionResolvers<ContextType>;
  EmailActionAggregates?: EmailActionAggregatesResolvers<ContextType>;
  EmailActionAverageAggregates?: EmailActionAverageAggregatesResolvers<ContextType>;
  EmailActionConnection?: EmailActionConnectionResolvers<ContextType>;
  EmailActionDistinctCountAggregates?: EmailActionDistinctCountAggregatesResolvers<ContextType>;
  EmailActionEdge?: EmailActionEdgeResolvers<ContextType>;
  EmailActionMaxAggregates?: EmailActionMaxAggregatesResolvers<ContextType>;
  EmailActionMinAggregates?: EmailActionMinAggregatesResolvers<ContextType>;
  EmailActionStddevPopulationAggregates?: EmailActionStddevPopulationAggregatesResolvers<ContextType>;
  EmailActionStddevSampleAggregates?: EmailActionStddevSampleAggregatesResolvers<ContextType>;
  EmailActionSumAggregates?: EmailActionSumAggregatesResolvers<ContextType>;
  EmailActionVariancePopulationAggregates?: EmailActionVariancePopulationAggregatesResolvers<ContextType>;
  EmailActionVarianceSampleAggregates?: EmailActionVarianceSampleAggregatesResolvers<ContextType>;
  EmailAggregates?: EmailAggregatesResolvers<ContextType>;
  EmailAverageAggregates?: EmailAverageAggregatesResolvers<ContextType>;
  EmailConnection?: EmailConnectionResolvers<ContextType>;
  EmailDistinctCountAggregates?: EmailDistinctCountAggregatesResolvers<ContextType>;
  EmailEdge?: EmailEdgeResolvers<ContextType>;
  EmailMaxAggregates?: EmailMaxAggregatesResolvers<ContextType>;
  EmailMinAggregates?: EmailMinAggregatesResolvers<ContextType>;
  EmailStddevPopulationAggregates?: EmailStddevPopulationAggregatesResolvers<ContextType>;
  EmailStddevSampleAggregates?: EmailStddevSampleAggregatesResolvers<ContextType>;
  EmailSumAggregates?: EmailSumAggregatesResolvers<ContextType>;
  EmailVariancePopulationAggregates?: EmailVariancePopulationAggregatesResolvers<ContextType>;
  EmailVarianceSampleAggregates?: EmailVarianceSampleAggregatesResolvers<ContextType>;
  GetOrCreateUserTaxFormResult?: GetOrCreateUserTaxFormResultResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  GroupAdmin?: GroupAdminResolvers<ContextType>;
  GroupAdminAggregates?: GroupAdminAggregatesResolvers<ContextType>;
  GroupAdminAverageAggregates?: GroupAdminAverageAggregatesResolvers<ContextType>;
  GroupAdminConnection?: GroupAdminConnectionResolvers<ContextType>;
  GroupAdminDistinctCountAggregates?: GroupAdminDistinctCountAggregatesResolvers<ContextType>;
  GroupAdminEdge?: GroupAdminEdgeResolvers<ContextType>;
  GroupAdminMaxAggregates?: GroupAdminMaxAggregatesResolvers<ContextType>;
  GroupAdminMinAggregates?: GroupAdminMinAggregatesResolvers<ContextType>;
  GroupAdminStddevPopulationAggregates?: GroupAdminStddevPopulationAggregatesResolvers<ContextType>;
  GroupAdminStddevSampleAggregates?: GroupAdminStddevSampleAggregatesResolvers<ContextType>;
  GroupAdminSumAggregates?: GroupAdminSumAggregatesResolvers<ContextType>;
  GroupAdminVariancePopulationAggregates?: GroupAdminVariancePopulationAggregatesResolvers<ContextType>;
  GroupAdminVarianceSampleAggregates?: GroupAdminVarianceSampleAggregatesResolvers<ContextType>;
  GroupAggregates?: GroupAggregatesResolvers<ContextType>;
  GroupAverageAggregates?: GroupAverageAggregatesResolvers<ContextType>;
  GroupConnection?: GroupConnectionResolvers<ContextType>;
  GroupDistinctCountAggregates?: GroupDistinctCountAggregatesResolvers<ContextType>;
  GroupEdge?: GroupEdgeResolvers<ContextType>;
  GroupMaxAggregates?: GroupMaxAggregatesResolvers<ContextType>;
  GroupMinAggregates?: GroupMinAggregatesResolvers<ContextType>;
  GroupStddevPopulationAggregates?: GroupStddevPopulationAggregatesResolvers<ContextType>;
  GroupStddevSampleAggregates?: GroupStddevSampleAggregatesResolvers<ContextType>;
  GroupSumAggregates?: GroupSumAggregatesResolvers<ContextType>;
  GroupVariancePopulationAggregates?: GroupVariancePopulationAggregatesResolvers<ContextType>;
  GroupVarianceSampleAggregates?: GroupVarianceSampleAggregatesResolvers<ContextType>;
  ImpactGroupAssignment?: ImpactGroupAssignmentResolvers<ContextType>;
  ImpactGroupAssignmentAggregates?: ImpactGroupAssignmentAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentAverageAggregates?: ImpactGroupAssignmentAverageAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentConnection?: ImpactGroupAssignmentConnectionResolvers<ContextType>;
  ImpactGroupAssignmentDistinctCountAggregates?: ImpactGroupAssignmentDistinctCountAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentEdge?: ImpactGroupAssignmentEdgeResolvers<ContextType>;
  ImpactGroupAssignmentMaxAggregates?: ImpactGroupAssignmentMaxAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentMinAggregates?: ImpactGroupAssignmentMinAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentStddevPopulationAggregates?: ImpactGroupAssignmentStddevPopulationAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentStddevSampleAggregates?: ImpactGroupAssignmentStddevSampleAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentSumAggregates?: ImpactGroupAssignmentSumAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentVariancePopulationAggregates?: ImpactGroupAssignmentVariancePopulationAggregatesResolvers<ContextType>;
  ImpactGroupAssignmentVarianceSampleAggregates?: ImpactGroupAssignmentVarianceSampleAggregatesResolvers<ContextType>;
  ImpactGroupTemplate?: ImpactGroupTemplateResolvers<ContextType>;
  ImpactGroupTemplateAggregates?: ImpactGroupTemplateAggregatesResolvers<ContextType>;
  ImpactGroupTemplateAverageAggregates?: ImpactGroupTemplateAverageAggregatesResolvers<ContextType>;
  ImpactGroupTemplateConnection?: ImpactGroupTemplateConnectionResolvers<ContextType>;
  ImpactGroupTemplateDistinctCountAggregates?: ImpactGroupTemplateDistinctCountAggregatesResolvers<ContextType>;
  ImpactGroupTemplateEdge?: ImpactGroupTemplateEdgeResolvers<ContextType>;
  ImpactGroupTemplateMaxAggregates?: ImpactGroupTemplateMaxAggregatesResolvers<ContextType>;
  ImpactGroupTemplateMinAggregates?: ImpactGroupTemplateMinAggregatesResolvers<ContextType>;
  ImpactGroupTemplateStddevPopulationAggregates?: ImpactGroupTemplateStddevPopulationAggregatesResolvers<ContextType>;
  ImpactGroupTemplateStddevSampleAggregates?: ImpactGroupTemplateStddevSampleAggregatesResolvers<ContextType>;
  ImpactGroupTemplateSumAggregates?: ImpactGroupTemplateSumAggregatesResolvers<ContextType>;
  ImpactGroupTemplateVariancePopulationAggregates?: ImpactGroupTemplateVariancePopulationAggregatesResolvers<ContextType>;
  ImpactGroupTemplateVarianceSampleAggregates?: ImpactGroupTemplateVarianceSampleAggregatesResolvers<ContextType>;
  InitiateAdminPayoutRequestPayload?: InitiateAdminPayoutRequestPayloadResolvers<ContextType>;
  Interval?: IntervalResolvers<ContextType>;
  InvalidateUserTaxFormEventLogResult?: InvalidateUserTaxFormEventLogResultResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  KycPriorityLabel?: KycPriorityLabelResolvers<ContextType>;
  KycPriorityLabelAggregates?: KycPriorityLabelAggregatesResolvers<ContextType>;
  KycPriorityLabelAverageAggregates?: KycPriorityLabelAverageAggregatesResolvers<ContextType>;
  KycPriorityLabelConnection?: KycPriorityLabelConnectionResolvers<ContextType>;
  KycPriorityLabelDistinctCountAggregates?: KycPriorityLabelDistinctCountAggregatesResolvers<ContextType>;
  KycPriorityLabelEdge?: KycPriorityLabelEdgeResolvers<ContextType>;
  KycPriorityLabelMaxAggregates?: KycPriorityLabelMaxAggregatesResolvers<ContextType>;
  KycPriorityLabelMinAggregates?: KycPriorityLabelMinAggregatesResolvers<ContextType>;
  KycPriorityLabelStddevPopulationAggregates?: KycPriorityLabelStddevPopulationAggregatesResolvers<ContextType>;
  KycPriorityLabelStddevSampleAggregates?: KycPriorityLabelStddevSampleAggregatesResolvers<ContextType>;
  KycPriorityLabelSumAggregates?: KycPriorityLabelSumAggregatesResolvers<ContextType>;
  KycPriorityLabelVariancePopulationAggregates?: KycPriorityLabelVariancePopulationAggregatesResolvers<ContextType>;
  KycPriorityLabelVarianceSampleAggregates?: KycPriorityLabelVarianceSampleAggregatesResolvers<ContextType>;
  KycPriorityReviewConfig?: KycPriorityReviewConfigResolvers<ContextType>;
  KycPriorityReviewConfigAggregates?: KycPriorityReviewConfigAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigAverageAggregates?: KycPriorityReviewConfigAverageAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigConnection?: KycPriorityReviewConfigConnectionResolvers<ContextType>;
  KycPriorityReviewConfigDistinctCountAggregates?: KycPriorityReviewConfigDistinctCountAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigEdge?: KycPriorityReviewConfigEdgeResolvers<ContextType>;
  KycPriorityReviewConfigLabel?: KycPriorityReviewConfigLabelResolvers<ContextType>;
  KycPriorityReviewConfigLabelAggregates?: KycPriorityReviewConfigLabelAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelAverageAggregates?: KycPriorityReviewConfigLabelAverageAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelConnection?: KycPriorityReviewConfigLabelConnectionResolvers<ContextType>;
  KycPriorityReviewConfigLabelDistinctCountAggregates?: KycPriorityReviewConfigLabelDistinctCountAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelEdge?: KycPriorityReviewConfigLabelEdgeResolvers<ContextType>;
  KycPriorityReviewConfigLabelMaxAggregates?: KycPriorityReviewConfigLabelMaxAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelMinAggregates?: KycPriorityReviewConfigLabelMinAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelStddevPopulationAggregates?: KycPriorityReviewConfigLabelStddevPopulationAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelStddevSampleAggregates?: KycPriorityReviewConfigLabelStddevSampleAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelSumAggregates?: KycPriorityReviewConfigLabelSumAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelVariancePopulationAggregates?: KycPriorityReviewConfigLabelVariancePopulationAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigLabelVarianceSampleAggregates?: KycPriorityReviewConfigLabelVarianceSampleAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigMaxAggregates?: KycPriorityReviewConfigMaxAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigMinAggregates?: KycPriorityReviewConfigMinAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigStddevPopulationAggregates?: KycPriorityReviewConfigStddevPopulationAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigStddevSampleAggregates?: KycPriorityReviewConfigStddevSampleAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigSumAggregates?: KycPriorityReviewConfigSumAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigVariancePopulationAggregates?: KycPriorityReviewConfigVariancePopulationAggregatesResolvers<ContextType>;
  KycPriorityReviewConfigVarianceSampleAggregates?: KycPriorityReviewConfigVarianceSampleAggregatesResolvers<ContextType>;
  LfaSplashStatus?: LfaSplashStatusResolvers<ContextType>;
  LiteLlmBlockedTermCandidate?: LiteLlmBlockedTermCandidateResolvers<ContextType>;
  LiveStreamStatus?: LiveStreamStatusResolvers<ContextType>;
  LiveTradePairing?: LiveTradePairingResolvers<ContextType>;
  Migration?: MigrationResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MyMissingPopcards?: MyMissingPopcardsResolvers<ContextType>;
  MyPopcardCandidates?: MyPopcardCandidatesResolvers<ContextType>;
  MyTraderProfileAsset?: MyTraderProfileAssetResolvers<ContextType>;
  MyTraderPublicProfile?: MyTraderPublicProfileResolvers<ContextType>;
  MyTraderPublicProfileAllTimePayouts?: MyTraderPublicProfileAllTimePayoutsResolvers<ContextType>;
  MyTraderPublicProfileContent?: MyTraderPublicProfileContentResolvers<ContextType>;
  MyTraderPublicProfileHeader?: MyTraderPublicProfileHeaderResolvers<ContextType>;
  MyTraderPublicProfileNowTrading?: MyTraderPublicProfileNowTradingResolvers<ContextType>;
  MyTraderPublicProfileNowTradingAccount?: MyTraderPublicProfileNowTradingAccountResolvers<ContextType>;
  MyTraderPublicProfileNowTradingCalendarDay?: MyTraderPublicProfileNowTradingCalendarDayResolvers<ContextType>;
  MyTraderPublicProfileNowTradingCalendarWeek?: MyTraderPublicProfileNowTradingCalendarWeekResolvers<ContextType>;
  MyTraderPublicProfileNowTradingProfitCalendar?: MyTraderPublicProfileNowTradingProfitCalendarResolvers<ContextType>;
  MyTraderPublicProfileNowTradingSparklineDay?: MyTraderPublicProfileNowTradingSparklineDayResolvers<ContextType>;
  MyTraderPublicProfileNowTradingStats?: MyTraderPublicProfileNowTradingStatsResolvers<ContextType>;
  MyTraderPublicProfileProofOfPayoutCard?: MyTraderPublicProfileProofOfPayoutCardResolvers<ContextType>;
  MyTraderPublicProfileSocialConnections?: MyTraderPublicProfileSocialConnectionsResolvers<ContextType>;
  MyTraderPublicProfileTradingJourney?: MyTraderPublicProfileTradingJourneyResolvers<ContextType>;
  MyTraderPublicProfileTradingStyle?: MyTraderPublicProfileTradingStyleResolvers<ContextType>;
  NmiSubscription?: NmiSubscriptionResolvers<ContextType>;
  NmiSubscriptionAggregates?: NmiSubscriptionAggregatesResolvers<ContextType>;
  NmiSubscriptionAverageAggregates?: NmiSubscriptionAverageAggregatesResolvers<ContextType>;
  NmiSubscriptionConnection?: NmiSubscriptionConnectionResolvers<ContextType>;
  NmiSubscriptionDistinctCountAggregates?: NmiSubscriptionDistinctCountAggregatesResolvers<ContextType>;
  NmiSubscriptionEdge?: NmiSubscriptionEdgeResolvers<ContextType>;
  NmiSubscriptionMaxAggregates?: NmiSubscriptionMaxAggregatesResolvers<ContextType>;
  NmiSubscriptionMinAggregates?: NmiSubscriptionMinAggregatesResolvers<ContextType>;
  NmiSubscriptionStddevPopulationAggregates?: NmiSubscriptionStddevPopulationAggregatesResolvers<ContextType>;
  NmiSubscriptionStddevSampleAggregates?: NmiSubscriptionStddevSampleAggregatesResolvers<ContextType>;
  NmiSubscriptionSumAggregates?: NmiSubscriptionSumAggregatesResolvers<ContextType>;
  NmiSubscriptionVariancePopulationAggregates?: NmiSubscriptionVariancePopulationAggregatesResolvers<ContextType>;
  NmiSubscriptionVarianceSampleAggregates?: NmiSubscriptionVarianceSampleAggregatesResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  NormalizedPurchasesByUserConnection?: NormalizedPurchasesByUserConnectionResolvers<ContextType>;
  NormalizedPurchasesByUserEdge?: NormalizedPurchasesByUserEdgeResolvers<ContextType>;
  NormalizedPurchasesByUserRecord?: NormalizedPurchasesByUserRecordResolvers<ContextType>;
  NormalizedSavedCardsByUserConnection?: NormalizedSavedCardsByUserConnectionResolvers<ContextType>;
  NormalizedSavedCardsByUserEdge?: NormalizedSavedCardsByUserEdgeResolvers<ContextType>;
  NormalizedSavedCardsByUserRecord?: NormalizedSavedCardsByUserRecordResolvers<ContextType>;
  NormalizedSubsByUserConnection?: NormalizedSubsByUserConnectionResolvers<ContextType>;
  NormalizedSubsByUserEdge?: NormalizedSubsByUserEdgeResolvers<ContextType>;
  NormalizedSubsByUserRecord?: NormalizedSubsByUserRecordResolvers<ContextType>;
  NormalizedSubsDetailedByUserConnection?: NormalizedSubsDetailedByUserConnectionResolvers<ContextType>;
  NormalizedSubsDetailedByUserEdge?: NormalizedSubsDetailedByUserEdgeResolvers<ContextType>;
  NormalizedSubsDetailedByUserRecord?: NormalizedSubsDetailedByUserRecordResolvers<ContextType>;
  NuveiSavedCard?: NuveiSavedCardResolvers<ContextType>;
  NuveiSavedCardAggregates?: NuveiSavedCardAggregatesResolvers<ContextType>;
  NuveiSavedCardAverageAggregates?: NuveiSavedCardAverageAggregatesResolvers<ContextType>;
  NuveiSavedCardConnection?: NuveiSavedCardConnectionResolvers<ContextType>;
  NuveiSavedCardDistinctCountAggregates?: NuveiSavedCardDistinctCountAggregatesResolvers<ContextType>;
  NuveiSavedCardEdge?: NuveiSavedCardEdgeResolvers<ContextType>;
  NuveiSavedCardMaxAggregates?: NuveiSavedCardMaxAggregatesResolvers<ContextType>;
  NuveiSavedCardMinAggregates?: NuveiSavedCardMinAggregatesResolvers<ContextType>;
  NuveiSavedCardStddevPopulationAggregates?: NuveiSavedCardStddevPopulationAggregatesResolvers<ContextType>;
  NuveiSavedCardStddevSampleAggregates?: NuveiSavedCardStddevSampleAggregatesResolvers<ContextType>;
  NuveiSavedCardSumAggregates?: NuveiSavedCardSumAggregatesResolvers<ContextType>;
  NuveiSavedCardVariancePopulationAggregates?: NuveiSavedCardVariancePopulationAggregatesResolvers<ContextType>;
  NuveiSavedCardVarianceSampleAggregates?: NuveiSavedCardVarianceSampleAggregatesResolvers<ContextType>;
  NuveiSavedPaypalArchived?: NuveiSavedPaypalArchivedResolvers<ContextType>;
  NuveiWebhook?: NuveiWebhookResolvers<ContextType>;
  OfacsdnRecord?: OfacsdnRecordResolvers<ContextType>;
  OfacsdnRecordAggregates?: OfacsdnRecordAggregatesResolvers<ContextType>;
  OfacsdnRecordAverageAggregates?: OfacsdnRecordAverageAggregatesResolvers<ContextType>;
  OfacsdnRecordConnection?: OfacsdnRecordConnectionResolvers<ContextType>;
  OfacsdnRecordDistinctCountAggregates?: OfacsdnRecordDistinctCountAggregatesResolvers<ContextType>;
  OfacsdnRecordEdge?: OfacsdnRecordEdgeResolvers<ContextType>;
  OfacsdnRecordMaxAggregates?: OfacsdnRecordMaxAggregatesResolvers<ContextType>;
  OfacsdnRecordMinAggregates?: OfacsdnRecordMinAggregatesResolvers<ContextType>;
  OfacsdnRecordStddevPopulationAggregates?: OfacsdnRecordStddevPopulationAggregatesResolvers<ContextType>;
  OfacsdnRecordStddevSampleAggregates?: OfacsdnRecordStddevSampleAggregatesResolvers<ContextType>;
  OfacsdnRecordSumAggregates?: OfacsdnRecordSumAggregatesResolvers<ContextType>;
  OfacsdnRecordVariancePopulationAggregates?: OfacsdnRecordVariancePopulationAggregatesResolvers<ContextType>;
  OfacsdnRecordVarianceSampleAggregates?: OfacsdnRecordVarianceSampleAggregatesResolvers<ContextType>;
  OrderFulfillment?: OrderFulfillmentResolvers<ContextType>;
  OrderFulfillmentAggregates?: OrderFulfillmentAggregatesResolvers<ContextType>;
  OrderFulfillmentAverageAggregates?: OrderFulfillmentAverageAggregatesResolvers<ContextType>;
  OrderFulfillmentConnection?: OrderFulfillmentConnectionResolvers<ContextType>;
  OrderFulfillmentDistinctCountAggregates?: OrderFulfillmentDistinctCountAggregatesResolvers<ContextType>;
  OrderFulfillmentEdge?: OrderFulfillmentEdgeResolvers<ContextType>;
  OrderFulfillmentMaxAggregates?: OrderFulfillmentMaxAggregatesResolvers<ContextType>;
  OrderFulfillmentMinAggregates?: OrderFulfillmentMinAggregatesResolvers<ContextType>;
  OrderFulfillmentStddevPopulationAggregates?: OrderFulfillmentStddevPopulationAggregatesResolvers<ContextType>;
  OrderFulfillmentStddevSampleAggregates?: OrderFulfillmentStddevSampleAggregatesResolvers<ContextType>;
  OrderFulfillmentSumAggregates?: OrderFulfillmentSumAggregatesResolvers<ContextType>;
  OrderFulfillmentVariancePopulationAggregates?: OrderFulfillmentVariancePopulationAggregatesResolvers<ContextType>;
  OrderFulfillmentVarianceSampleAggregates?: OrderFulfillmentVarianceSampleAggregatesResolvers<ContextType>;
  Outbox?: OutboxResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Partner?: PartnerResolvers<ContextType>;
  PartnerTransaction?: PartnerTransactionResolvers<ContextType>;
  PasswordHistory?: PasswordHistoryResolvers<ContextType>;
  PasswordHistoryAggregates?: PasswordHistoryAggregatesResolvers<ContextType>;
  PasswordHistoryAverageAggregates?: PasswordHistoryAverageAggregatesResolvers<ContextType>;
  PasswordHistoryConnection?: PasswordHistoryConnectionResolvers<ContextType>;
  PasswordHistoryDistinctCountAggregates?: PasswordHistoryDistinctCountAggregatesResolvers<ContextType>;
  PasswordHistoryEdge?: PasswordHistoryEdgeResolvers<ContextType>;
  PasswordHistoryMaxAggregates?: PasswordHistoryMaxAggregatesResolvers<ContextType>;
  PasswordHistoryMinAggregates?: PasswordHistoryMinAggregatesResolvers<ContextType>;
  PasswordHistoryStddevPopulationAggregates?: PasswordHistoryStddevPopulationAggregatesResolvers<ContextType>;
  PasswordHistoryStddevSampleAggregates?: PasswordHistoryStddevSampleAggregatesResolvers<ContextType>;
  PasswordHistorySumAggregates?: PasswordHistorySumAggregatesResolvers<ContextType>;
  PasswordHistoryVariancePopulationAggregates?: PasswordHistoryVariancePopulationAggregatesResolvers<ContextType>;
  PasswordHistoryVarianceSampleAggregates?: PasswordHistoryVarianceSampleAggregatesResolvers<ContextType>;
  PathToFunding?: PathToFundingResolvers<ContextType>;
  PathToFundingObjective?: PathToFundingObjectiveResolvers<ContextType>;
  PathToFundingRule?: PathToFundingRuleResolvers<ContextType>;
  PaymentGateway?: PaymentGatewayResolvers<ContextType>;
  PayoutActivityActor?: PayoutActivityActorResolvers<ContextType>;
  PayoutActivityEvent?: PayoutActivityEventResolvers<ContextType>;
  PayoutActivityReturn?: PayoutActivityReturnResolvers<ContextType>;
  PayoutCycle?: PayoutCycleResolvers<ContextType>;
  PayoutDepartmentApproval?: PayoutDepartmentApprovalResolvers<ContextType>;
  PayoutDepartmentApprovalAggregates?: PayoutDepartmentApprovalAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalAverageAggregates?: PayoutDepartmentApprovalAverageAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalConnection?: PayoutDepartmentApprovalConnectionResolvers<ContextType>;
  PayoutDepartmentApprovalDistinctCountAggregates?: PayoutDepartmentApprovalDistinctCountAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalEdge?: PayoutDepartmentApprovalEdgeResolvers<ContextType>;
  PayoutDepartmentApprovalMaxAggregates?: PayoutDepartmentApprovalMaxAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalMinAggregates?: PayoutDepartmentApprovalMinAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalStddevPopulationAggregates?: PayoutDepartmentApprovalStddevPopulationAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalStddevSampleAggregates?: PayoutDepartmentApprovalStddevSampleAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalSumAggregates?: PayoutDepartmentApprovalSumAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalVariancePopulationAggregates?: PayoutDepartmentApprovalVariancePopulationAggregatesResolvers<ContextType>;
  PayoutDepartmentApprovalVarianceSampleAggregates?: PayoutDepartmentApprovalVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRequest?: PayoutRequestResolvers<ContextType>;
  PayoutRequestAggregates?: PayoutRequestAggregatesResolvers<ContextType>;
  PayoutRequestAsset?: PayoutRequestAssetResolvers<ContextType>;
  PayoutRequestAssetAggregates?: PayoutRequestAssetAggregatesResolvers<ContextType>;
  PayoutRequestAssetAverageAggregates?: PayoutRequestAssetAverageAggregatesResolvers<ContextType>;
  PayoutRequestAssetConnection?: PayoutRequestAssetConnectionResolvers<ContextType>;
  PayoutRequestAssetDistinctCountAggregates?: PayoutRequestAssetDistinctCountAggregatesResolvers<ContextType>;
  PayoutRequestAssetEdge?: PayoutRequestAssetEdgeResolvers<ContextType>;
  PayoutRequestAssetMaxAggregates?: PayoutRequestAssetMaxAggregatesResolvers<ContextType>;
  PayoutRequestAssetMinAggregates?: PayoutRequestAssetMinAggregatesResolvers<ContextType>;
  PayoutRequestAssetStddevPopulationAggregates?: PayoutRequestAssetStddevPopulationAggregatesResolvers<ContextType>;
  PayoutRequestAssetStddevSampleAggregates?: PayoutRequestAssetStddevSampleAggregatesResolvers<ContextType>;
  PayoutRequestAssetSumAggregates?: PayoutRequestAssetSumAggregatesResolvers<ContextType>;
  PayoutRequestAssetVariancePopulationAggregates?: PayoutRequestAssetVariancePopulationAggregatesResolvers<ContextType>;
  PayoutRequestAssetVarianceSampleAggregates?: PayoutRequestAssetVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRequestAverageAggregates?: PayoutRequestAverageAggregatesResolvers<ContextType>;
  PayoutRequestBatch?: PayoutRequestBatchResolvers<ContextType>;
  PayoutRequestBatchAggregates?: PayoutRequestBatchAggregatesResolvers<ContextType>;
  PayoutRequestBatchAverageAggregates?: PayoutRequestBatchAverageAggregatesResolvers<ContextType>;
  PayoutRequestBatchConnection?: PayoutRequestBatchConnectionResolvers<ContextType>;
  PayoutRequestBatchDistinctCountAggregates?: PayoutRequestBatchDistinctCountAggregatesResolvers<ContextType>;
  PayoutRequestBatchEdge?: PayoutRequestBatchEdgeResolvers<ContextType>;
  PayoutRequestBatchItem?: PayoutRequestBatchItemResolvers<ContextType>;
  PayoutRequestBatchItemAggregates?: PayoutRequestBatchItemAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemAverageAggregates?: PayoutRequestBatchItemAverageAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemConnection?: PayoutRequestBatchItemConnectionResolvers<ContextType>;
  PayoutRequestBatchItemDistinctCountAggregates?: PayoutRequestBatchItemDistinctCountAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemEdge?: PayoutRequestBatchItemEdgeResolvers<ContextType>;
  PayoutRequestBatchItemMaxAggregates?: PayoutRequestBatchItemMaxAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemMinAggregates?: PayoutRequestBatchItemMinAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemStddevPopulationAggregates?: PayoutRequestBatchItemStddevPopulationAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemStddevSampleAggregates?: PayoutRequestBatchItemStddevSampleAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemSumAggregates?: PayoutRequestBatchItemSumAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemVariancePopulationAggregates?: PayoutRequestBatchItemVariancePopulationAggregatesResolvers<ContextType>;
  PayoutRequestBatchItemVarianceSampleAggregates?: PayoutRequestBatchItemVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRequestBatchMaxAggregates?: PayoutRequestBatchMaxAggregatesResolvers<ContextType>;
  PayoutRequestBatchMinAggregates?: PayoutRequestBatchMinAggregatesResolvers<ContextType>;
  PayoutRequestBatchStddevPopulationAggregates?: PayoutRequestBatchStddevPopulationAggregatesResolvers<ContextType>;
  PayoutRequestBatchStddevSampleAggregates?: PayoutRequestBatchStddevSampleAggregatesResolvers<ContextType>;
  PayoutRequestBatchSumAggregates?: PayoutRequestBatchSumAggregatesResolvers<ContextType>;
  PayoutRequestBatchVariancePopulationAggregates?: PayoutRequestBatchVariancePopulationAggregatesResolvers<ContextType>;
  PayoutRequestBatchVarianceSampleAggregates?: PayoutRequestBatchVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRequestConnection?: PayoutRequestConnectionResolvers<ContextType>;
  PayoutRequestDistinctCountAggregates?: PayoutRequestDistinctCountAggregatesResolvers<ContextType>;
  PayoutRequestEdge?: PayoutRequestEdgeResolvers<ContextType>;
  PayoutRequestHistory?: PayoutRequestHistoryResolvers<ContextType>;
  PayoutRequestMaxAggregates?: PayoutRequestMaxAggregatesResolvers<ContextType>;
  PayoutRequestMinAggregates?: PayoutRequestMinAggregatesResolvers<ContextType>;
  PayoutRequestStddevPopulationAggregates?: PayoutRequestStddevPopulationAggregatesResolvers<ContextType>;
  PayoutRequestStddevSampleAggregates?: PayoutRequestStddevSampleAggregatesResolvers<ContextType>;
  PayoutRequestSubscriber?: PayoutRequestSubscriberResolvers<ContextType>;
  PayoutRequestSubscriberAggregates?: PayoutRequestSubscriberAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberAverageAggregates?: PayoutRequestSubscriberAverageAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberConnection?: PayoutRequestSubscriberConnectionResolvers<ContextType>;
  PayoutRequestSubscriberDistinctCountAggregates?: PayoutRequestSubscriberDistinctCountAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberEdge?: PayoutRequestSubscriberEdgeResolvers<ContextType>;
  PayoutRequestSubscriberMaxAggregates?: PayoutRequestSubscriberMaxAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberMinAggregates?: PayoutRequestSubscriberMinAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberStddevPopulationAggregates?: PayoutRequestSubscriberStddevPopulationAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberStddevSampleAggregates?: PayoutRequestSubscriberStddevSampleAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberSumAggregates?: PayoutRequestSubscriberSumAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberVariancePopulationAggregates?: PayoutRequestSubscriberVariancePopulationAggregatesResolvers<ContextType>;
  PayoutRequestSubscriberVarianceSampleAggregates?: PayoutRequestSubscriberVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRequestSumAggregates?: PayoutRequestSumAggregatesResolvers<ContextType>;
  PayoutRequestVariancePopulationAggregates?: PayoutRequestVariancePopulationAggregatesResolvers<ContextType>;
  PayoutRequestVarianceSampleAggregates?: PayoutRequestVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRequestsStatsConnection?: PayoutRequestsStatsConnectionResolvers<ContextType>;
  PayoutRequestsStatsEdge?: PayoutRequestsStatsEdgeResolvers<ContextType>;
  PayoutRequestsStatsRecord?: PayoutRequestsStatsRecordResolvers<ContextType>;
  PayoutReturn?: PayoutReturnResolvers<ContextType>;
  PayoutReturnAggregates?: PayoutReturnAggregatesResolvers<ContextType>;
  PayoutReturnAverageAggregates?: PayoutReturnAverageAggregatesResolvers<ContextType>;
  PayoutReturnConnection?: PayoutReturnConnectionResolvers<ContextType>;
  PayoutReturnDistinctCountAggregates?: PayoutReturnDistinctCountAggregatesResolvers<ContextType>;
  PayoutReturnEdge?: PayoutReturnEdgeResolvers<ContextType>;
  PayoutReturnMaxAggregates?: PayoutReturnMaxAggregatesResolvers<ContextType>;
  PayoutReturnMinAggregates?: PayoutReturnMinAggregatesResolvers<ContextType>;
  PayoutReturnReasonCode?: PayoutReturnReasonCodeResolvers<ContextType>;
  PayoutReturnReasonCodeAggregates?: PayoutReturnReasonCodeAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeAverageAggregates?: PayoutReturnReasonCodeAverageAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeConnection?: PayoutReturnReasonCodeConnectionResolvers<ContextType>;
  PayoutReturnReasonCodeDistinctCountAggregates?: PayoutReturnReasonCodeDistinctCountAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeEdge?: PayoutReturnReasonCodeEdgeResolvers<ContextType>;
  PayoutReturnReasonCodeMaxAggregates?: PayoutReturnReasonCodeMaxAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeMinAggregates?: PayoutReturnReasonCodeMinAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeStddevPopulationAggregates?: PayoutReturnReasonCodeStddevPopulationAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeStddevSampleAggregates?: PayoutReturnReasonCodeStddevSampleAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeSumAggregates?: PayoutReturnReasonCodeSumAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeVariancePopulationAggregates?: PayoutReturnReasonCodeVariancePopulationAggregatesResolvers<ContextType>;
  PayoutReturnReasonCodeVarianceSampleAggregates?: PayoutReturnReasonCodeVarianceSampleAggregatesResolvers<ContextType>;
  PayoutReturnStddevPopulationAggregates?: PayoutReturnStddevPopulationAggregatesResolvers<ContextType>;
  PayoutReturnStddevSampleAggregates?: PayoutReturnStddevSampleAggregatesResolvers<ContextType>;
  PayoutReturnSumAggregates?: PayoutReturnSumAggregatesResolvers<ContextType>;
  PayoutReturnVariancePopulationAggregates?: PayoutReturnVariancePopulationAggregatesResolvers<ContextType>;
  PayoutReturnVarianceSampleAggregates?: PayoutReturnVarianceSampleAggregatesResolvers<ContextType>;
  PayoutReview?: PayoutReviewResolvers<ContextType>;
  PayoutReviewAggregates?: PayoutReviewAggregatesResolvers<ContextType>;
  PayoutReviewAverageAggregates?: PayoutReviewAverageAggregatesResolvers<ContextType>;
  PayoutReviewConnection?: PayoutReviewConnectionResolvers<ContextType>;
  PayoutReviewDistinctCountAggregates?: PayoutReviewDistinctCountAggregatesResolvers<ContextType>;
  PayoutReviewEdge?: PayoutReviewEdgeResolvers<ContextType>;
  PayoutReviewMaxAggregates?: PayoutReviewMaxAggregatesResolvers<ContextType>;
  PayoutReviewMinAggregates?: PayoutReviewMinAggregatesResolvers<ContextType>;
  PayoutReviewStddevPopulationAggregates?: PayoutReviewStddevPopulationAggregatesResolvers<ContextType>;
  PayoutReviewStddevSampleAggregates?: PayoutReviewStddevSampleAggregatesResolvers<ContextType>;
  PayoutReviewSumAggregates?: PayoutReviewSumAggregatesResolvers<ContextType>;
  PayoutReviewVariancePopulationAggregates?: PayoutReviewVariancePopulationAggregatesResolvers<ContextType>;
  PayoutReviewVarianceSampleAggregates?: PayoutReviewVarianceSampleAggregatesResolvers<ContextType>;
  PayoutReviewer?: PayoutReviewerResolvers<ContextType>;
  PayoutReviewerAggregates?: PayoutReviewerAggregatesResolvers<ContextType>;
  PayoutReviewerAverageAggregates?: PayoutReviewerAverageAggregatesResolvers<ContextType>;
  PayoutReviewerConnection?: PayoutReviewerConnectionResolvers<ContextType>;
  PayoutReviewerDistinctCountAggregates?: PayoutReviewerDistinctCountAggregatesResolvers<ContextType>;
  PayoutReviewerEdge?: PayoutReviewerEdgeResolvers<ContextType>;
  PayoutReviewerMaxAggregates?: PayoutReviewerMaxAggregatesResolvers<ContextType>;
  PayoutReviewerMinAggregates?: PayoutReviewerMinAggregatesResolvers<ContextType>;
  PayoutReviewerStddevPopulationAggregates?: PayoutReviewerStddevPopulationAggregatesResolvers<ContextType>;
  PayoutReviewerStddevSampleAggregates?: PayoutReviewerStddevSampleAggregatesResolvers<ContextType>;
  PayoutReviewerSumAggregates?: PayoutReviewerSumAggregatesResolvers<ContextType>;
  PayoutReviewerVariancePopulationAggregates?: PayoutReviewerVariancePopulationAggregatesResolvers<ContextType>;
  PayoutReviewerVarianceSampleAggregates?: PayoutReviewerVarianceSampleAggregatesResolvers<ContextType>;
  PayoutRollupItem?: PayoutRollupItemResolvers<ContextType>;
  PayoutRollupResult?: PayoutRollupResultResolvers<ContextType>;
  PaypalTransaction?: PaypalTransactionResolvers<ContextType>;
  PersonaInquiryEvent?: PersonaInquiryEventResolvers<ContextType>;
  PersonaTransactionEvent?: PersonaTransactionEventResolvers<ContextType>;
  PersonaWebhookEvent?: PersonaWebhookEventResolvers<ContextType>;
  PersonaWebhookEventAggregates?: PersonaWebhookEventAggregatesResolvers<ContextType>;
  PersonaWebhookEventAverageAggregates?: PersonaWebhookEventAverageAggregatesResolvers<ContextType>;
  PersonaWebhookEventConnection?: PersonaWebhookEventConnectionResolvers<ContextType>;
  PersonaWebhookEventDistinctCountAggregates?: PersonaWebhookEventDistinctCountAggregatesResolvers<ContextType>;
  PersonaWebhookEventEdge?: PersonaWebhookEventEdgeResolvers<ContextType>;
  PersonaWebhookEventMaxAggregates?: PersonaWebhookEventMaxAggregatesResolvers<ContextType>;
  PersonaWebhookEventMinAggregates?: PersonaWebhookEventMinAggregatesResolvers<ContextType>;
  PersonaWebhookEventStddevPopulationAggregates?: PersonaWebhookEventStddevPopulationAggregatesResolvers<ContextType>;
  PersonaWebhookEventStddevSampleAggregates?: PersonaWebhookEventStddevSampleAggregatesResolvers<ContextType>;
  PersonaWebhookEventSumAggregates?: PersonaWebhookEventSumAggregatesResolvers<ContextType>;
  PersonaWebhookEventVariancePopulationAggregates?: PersonaWebhookEventVariancePopulationAggregatesResolvers<ContextType>;
  PersonaWebhookEventVarianceSampleAggregates?: PersonaWebhookEventVarianceSampleAggregatesResolvers<ContextType>;
  Platform?: PlatformResolvers<ContextType>;
  PopcardPayoutCandidate?: PopcardPayoutCandidateResolvers<ContextType>;
  PopcardRollupGroup?: PopcardRollupGroupResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductAggregates?: ProductAggregatesResolvers<ContextType>;
  ProductAverageAggregates?: ProductAverageAggregatesResolvers<ContextType>;
  ProductCategory?: ProductCategoryResolvers<ContextType>;
  ProductCategoryAggregates?: ProductCategoryAggregatesResolvers<ContextType>;
  ProductCategoryAverageAggregates?: ProductCategoryAverageAggregatesResolvers<ContextType>;
  ProductCategoryConnection?: ProductCategoryConnectionResolvers<ContextType>;
  ProductCategoryDistinctCountAggregates?: ProductCategoryDistinctCountAggregatesResolvers<ContextType>;
  ProductCategoryEdge?: ProductCategoryEdgeResolvers<ContextType>;
  ProductCategoryMaxAggregates?: ProductCategoryMaxAggregatesResolvers<ContextType>;
  ProductCategoryMinAggregates?: ProductCategoryMinAggregatesResolvers<ContextType>;
  ProductCategoryStddevPopulationAggregates?: ProductCategoryStddevPopulationAggregatesResolvers<ContextType>;
  ProductCategoryStddevSampleAggregates?: ProductCategoryStddevSampleAggregatesResolvers<ContextType>;
  ProductCategorySumAggregates?: ProductCategorySumAggregatesResolvers<ContextType>;
  ProductCategoryVariancePopulationAggregates?: ProductCategoryVariancePopulationAggregatesResolvers<ContextType>;
  ProductCategoryVarianceSampleAggregates?: ProductCategoryVarianceSampleAggregatesResolvers<ContextType>;
  ProductConnection?: ProductConnectionResolvers<ContextType>;
  ProductDistinctCountAggregates?: ProductDistinctCountAggregatesResolvers<ContextType>;
  ProductEdge?: ProductEdgeResolvers<ContextType>;
  ProductMaxAggregates?: ProductMaxAggregatesResolvers<ContextType>;
  ProductMinAggregates?: ProductMinAggregatesResolvers<ContextType>;
  ProductStddevPopulationAggregates?: ProductStddevPopulationAggregatesResolvers<ContextType>;
  ProductStddevSampleAggregates?: ProductStddevSampleAggregatesResolvers<ContextType>;
  ProductSumAggregates?: ProductSumAggregatesResolvers<ContextType>;
  ProductVariancePopulationAggregates?: ProductVariancePopulationAggregatesResolvers<ContextType>;
  ProductVarianceSampleAggregates?: ProductVarianceSampleAggregatesResolvers<ContextType>;
  ProfileReport?: ProfileReportResolvers<ContextType>;
  ProfileReportAggregates?: ProfileReportAggregatesResolvers<ContextType>;
  ProfileReportAverageAggregates?: ProfileReportAverageAggregatesResolvers<ContextType>;
  ProfileReportConnection?: ProfileReportConnectionResolvers<ContextType>;
  ProfileReportDistinctCountAggregates?: ProfileReportDistinctCountAggregatesResolvers<ContextType>;
  ProfileReportEdge?: ProfileReportEdgeResolvers<ContextType>;
  ProfileReportMaxAggregates?: ProfileReportMaxAggregatesResolvers<ContextType>;
  ProfileReportMinAggregates?: ProfileReportMinAggregatesResolvers<ContextType>;
  ProfileReportStddevPopulationAggregates?: ProfileReportStddevPopulationAggregatesResolvers<ContextType>;
  ProfileReportStddevSampleAggregates?: ProfileReportStddevSampleAggregatesResolvers<ContextType>;
  ProfileReportSumAggregates?: ProfileReportSumAggregatesResolvers<ContextType>;
  ProfileReportVariancePopulationAggregates?: ProfileReportVariancePopulationAggregatesResolvers<ContextType>;
  ProfileReportVarianceSampleAggregates?: ProfileReportVarianceSampleAggregatesResolvers<ContextType>;
  Purchase?: PurchaseResolvers<ContextType>;
  PurchaseAggregates?: PurchaseAggregatesResolvers<ContextType>;
  PurchaseAverageAggregates?: PurchaseAverageAggregatesResolvers<ContextType>;
  PurchaseConnection?: PurchaseConnectionResolvers<ContextType>;
  PurchaseDistinctCountAggregates?: PurchaseDistinctCountAggregatesResolvers<ContextType>;
  PurchaseEdge?: PurchaseEdgeResolvers<ContextType>;
  PurchaseItem?: PurchaseItemResolvers<ContextType>;
  PurchaseItemAggregates?: PurchaseItemAggregatesResolvers<ContextType>;
  PurchaseItemAverageAggregates?: PurchaseItemAverageAggregatesResolvers<ContextType>;
  PurchaseItemConnection?: PurchaseItemConnectionResolvers<ContextType>;
  PurchaseItemDistinctCountAggregates?: PurchaseItemDistinctCountAggregatesResolvers<ContextType>;
  PurchaseItemEdge?: PurchaseItemEdgeResolvers<ContextType>;
  PurchaseItemMaxAggregates?: PurchaseItemMaxAggregatesResolvers<ContextType>;
  PurchaseItemMinAggregates?: PurchaseItemMinAggregatesResolvers<ContextType>;
  PurchaseItemStddevPopulationAggregates?: PurchaseItemStddevPopulationAggregatesResolvers<ContextType>;
  PurchaseItemStddevSampleAggregates?: PurchaseItemStddevSampleAggregatesResolvers<ContextType>;
  PurchaseItemSumAggregates?: PurchaseItemSumAggregatesResolvers<ContextType>;
  PurchaseItemVariancePopulationAggregates?: PurchaseItemVariancePopulationAggregatesResolvers<ContextType>;
  PurchaseItemVarianceSampleAggregates?: PurchaseItemVarianceSampleAggregatesResolvers<ContextType>;
  PurchaseMaxAggregates?: PurchaseMaxAggregatesResolvers<ContextType>;
  PurchaseMinAggregates?: PurchaseMinAggregatesResolvers<ContextType>;
  PurchaseOrder?: PurchaseOrderResolvers<ContextType>;
  PurchaseOrderAggregates?: PurchaseOrderAggregatesResolvers<ContextType>;
  PurchaseOrderAverageAggregates?: PurchaseOrderAverageAggregatesResolvers<ContextType>;
  PurchaseOrderConnection?: PurchaseOrderConnectionResolvers<ContextType>;
  PurchaseOrderDistinctCountAggregates?: PurchaseOrderDistinctCountAggregatesResolvers<ContextType>;
  PurchaseOrderEdge?: PurchaseOrderEdgeResolvers<ContextType>;
  PurchaseOrderMaxAggregates?: PurchaseOrderMaxAggregatesResolvers<ContextType>;
  PurchaseOrderMinAggregates?: PurchaseOrderMinAggregatesResolvers<ContextType>;
  PurchaseOrderReceipt?: PurchaseOrderReceiptResolvers<ContextType>;
  PurchaseOrderStddevPopulationAggregates?: PurchaseOrderStddevPopulationAggregatesResolvers<ContextType>;
  PurchaseOrderStddevSampleAggregates?: PurchaseOrderStddevSampleAggregatesResolvers<ContextType>;
  PurchaseOrderSumAggregates?: PurchaseOrderSumAggregatesResolvers<ContextType>;
  PurchaseOrderVariancePopulationAggregates?: PurchaseOrderVariancePopulationAggregatesResolvers<ContextType>;
  PurchaseOrderVarianceSampleAggregates?: PurchaseOrderVarianceSampleAggregatesResolvers<ContextType>;
  PurchaseStddevPopulationAggregates?: PurchaseStddevPopulationAggregatesResolvers<ContextType>;
  PurchaseStddevSampleAggregates?: PurchaseStddevSampleAggregatesResolvers<ContextType>;
  PurchaseSumAggregates?: PurchaseSumAggregatesResolvers<ContextType>;
  PurchaseVariancePopulationAggregates?: PurchaseVariancePopulationAggregatesResolvers<ContextType>;
  PurchaseVarianceSampleAggregates?: PurchaseVarianceSampleAggregatesResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReasonCode?: ReasonCodeResolvers<ContextType>;
  ReasonCodeAggregates?: ReasonCodeAggregatesResolvers<ContextType>;
  ReasonCodeAverageAggregates?: ReasonCodeAverageAggregatesResolvers<ContextType>;
  ReasonCodeConnection?: ReasonCodeConnectionResolvers<ContextType>;
  ReasonCodeDistinctCountAggregates?: ReasonCodeDistinctCountAggregatesResolvers<ContextType>;
  ReasonCodeEdge?: ReasonCodeEdgeResolvers<ContextType>;
  ReasonCodeMaxAggregates?: ReasonCodeMaxAggregatesResolvers<ContextType>;
  ReasonCodeMinAggregates?: ReasonCodeMinAggregatesResolvers<ContextType>;
  ReasonCodeStddevPopulationAggregates?: ReasonCodeStddevPopulationAggregatesResolvers<ContextType>;
  ReasonCodeStddevSampleAggregates?: ReasonCodeStddevSampleAggregatesResolvers<ContextType>;
  ReasonCodeSumAggregates?: ReasonCodeSumAggregatesResolvers<ContextType>;
  ReasonCodeVariancePopulationAggregates?: ReasonCodeVariancePopulationAggregatesResolvers<ContextType>;
  ReasonCodeVarianceSampleAggregates?: ReasonCodeVarianceSampleAggregatesResolvers<ContextType>;
  RebillSession?: RebillSessionResolvers<ContextType>;
  RebillSessionAggregates?: RebillSessionAggregatesResolvers<ContextType>;
  RebillSessionAverageAggregates?: RebillSessionAverageAggregatesResolvers<ContextType>;
  RebillSessionConnection?: RebillSessionConnectionResolvers<ContextType>;
  RebillSessionDistinctCountAggregates?: RebillSessionDistinctCountAggregatesResolvers<ContextType>;
  RebillSessionEdge?: RebillSessionEdgeResolvers<ContextType>;
  RebillSessionMaxAggregates?: RebillSessionMaxAggregatesResolvers<ContextType>;
  RebillSessionMinAggregates?: RebillSessionMinAggregatesResolvers<ContextType>;
  RebillSessionStddevPopulationAggregates?: RebillSessionStddevPopulationAggregatesResolvers<ContextType>;
  RebillSessionStddevSampleAggregates?: RebillSessionStddevSampleAggregatesResolvers<ContextType>;
  RebillSessionSumAggregates?: RebillSessionSumAggregatesResolvers<ContextType>;
  RebillSessionVariancePopulationAggregates?: RebillSessionVariancePopulationAggregatesResolvers<ContextType>;
  RebillSessionVarianceSampleAggregates?: RebillSessionVarianceSampleAggregatesResolvers<ContextType>;
  RecordLfaSplashViewPayload?: RecordLfaSplashViewPayloadResolvers<ContextType>;
  RecordReflectionViewPayload?: RecordReflectionViewPayloadResolvers<ContextType>;
  ReferralPurchase?: ReferralPurchaseResolvers<ContextType>;
  ReferralReward?: ReferralRewardResolvers<ContextType>;
  Refund?: RefundResolvers<ContextType>;
  RefundAggregates?: RefundAggregatesResolvers<ContextType>;
  RefundAverageAggregates?: RefundAverageAggregatesResolvers<ContextType>;
  RefundConnection?: RefundConnectionResolvers<ContextType>;
  RefundDistinctCountAggregates?: RefundDistinctCountAggregatesResolvers<ContextType>;
  RefundEdge?: RefundEdgeResolvers<ContextType>;
  RefundMaxAggregates?: RefundMaxAggregatesResolvers<ContextType>;
  RefundMinAggregates?: RefundMinAggregatesResolvers<ContextType>;
  RefundStddevPopulationAggregates?: RefundStddevPopulationAggregatesResolvers<ContextType>;
  RefundStddevSampleAggregates?: RefundStddevSampleAggregatesResolvers<ContextType>;
  RefundSumAggregates?: RefundSumAggregatesResolvers<ContextType>;
  RefundVariancePopulationAggregates?: RefundVariancePopulationAggregatesResolvers<ContextType>;
  RefundVarianceSampleAggregates?: RefundVarianceSampleAggregatesResolvers<ContextType>;
  RegistrationRiskAssessment?: RegistrationRiskAssessmentResolvers<ContextType>;
  ResetCredit?: ResetCreditResolvers<ContextType>;
  ResetCreditAggregates?: ResetCreditAggregatesResolvers<ContextType>;
  ResetCreditAverageAggregates?: ResetCreditAverageAggregatesResolvers<ContextType>;
  ResetCreditConnection?: ResetCreditConnectionResolvers<ContextType>;
  ResetCreditDistinctCountAggregates?: ResetCreditDistinctCountAggregatesResolvers<ContextType>;
  ResetCreditEdge?: ResetCreditEdgeResolvers<ContextType>;
  ResetCreditGrant?: ResetCreditGrantResolvers<ContextType>;
  ResetCreditMaxAggregates?: ResetCreditMaxAggregatesResolvers<ContextType>;
  ResetCreditMinAggregates?: ResetCreditMinAggregatesResolvers<ContextType>;
  ResetCreditStddevPopulationAggregates?: ResetCreditStddevPopulationAggregatesResolvers<ContextType>;
  ResetCreditStddevSampleAggregates?: ResetCreditStddevSampleAggregatesResolvers<ContextType>;
  ResetCreditSumAggregates?: ResetCreditSumAggregatesResolvers<ContextType>;
  ResetCreditVariancePopulationAggregates?: ResetCreditVariancePopulationAggregatesResolvers<ContextType>;
  ResetCreditVarianceSampleAggregates?: ResetCreditVarianceSampleAggregatesResolvers<ContextType>;
  RevokeUserTaxFormValidationBypassResult?: RevokeUserTaxFormValidationBypassResultResolvers<ContextType>;
  RiskyProduct?: RiskyProductResolvers<ContextType>;
  RiskyProductAggregates?: RiskyProductAggregatesResolvers<ContextType>;
  RiskyProductAverageAggregates?: RiskyProductAverageAggregatesResolvers<ContextType>;
  RiskyProductConnection?: RiskyProductConnectionResolvers<ContextType>;
  RiskyProductDistinctCountAggregates?: RiskyProductDistinctCountAggregatesResolvers<ContextType>;
  RiskyProductEdge?: RiskyProductEdgeResolvers<ContextType>;
  RiskyProductMaxAggregates?: RiskyProductMaxAggregatesResolvers<ContextType>;
  RiskyProductMinAggregates?: RiskyProductMinAggregatesResolvers<ContextType>;
  RiskyProductStddevPopulationAggregates?: RiskyProductStddevPopulationAggregatesResolvers<ContextType>;
  RiskyProductStddevSampleAggregates?: RiskyProductStddevSampleAggregatesResolvers<ContextType>;
  RiskyProductSumAggregates?: RiskyProductSumAggregatesResolvers<ContextType>;
  RiskyProductVariancePopulationAggregates?: RiskyProductVariancePopulationAggregatesResolvers<ContextType>;
  RiskyProductVarianceSampleAggregates?: RiskyProductVarianceSampleAggregatesResolvers<ContextType>;
  SavedCard?: SavedCardResolvers<ContextType>;
  SavedCardAggregates?: SavedCardAggregatesResolvers<ContextType>;
  SavedCardAverageAggregates?: SavedCardAverageAggregatesResolvers<ContextType>;
  SavedCardConnection?: SavedCardConnectionResolvers<ContextType>;
  SavedCardDistinctCountAggregates?: SavedCardDistinctCountAggregatesResolvers<ContextType>;
  SavedCardEdge?: SavedCardEdgeResolvers<ContextType>;
  SavedCardMaxAggregates?: SavedCardMaxAggregatesResolvers<ContextType>;
  SavedCardMinAggregates?: SavedCardMinAggregatesResolvers<ContextType>;
  SavedCardStddevPopulationAggregates?: SavedCardStddevPopulationAggregatesResolvers<ContextType>;
  SavedCardStddevSampleAggregates?: SavedCardStddevSampleAggregatesResolvers<ContextType>;
  SavedCardSumAggregates?: SavedCardSumAggregatesResolvers<ContextType>;
  SavedCardVariancePopulationAggregates?: SavedCardVariancePopulationAggregatesResolvers<ContextType>;
  SavedCardVarianceSampleAggregates?: SavedCardVarianceSampleAggregatesResolvers<ContextType>;
  SkuAccountDetails?: SkuAccountDetailsResolvers<ContextType>;
  SkuAccountProvisioningClaim?: SkuAccountProvisioningClaimResolvers<ContextType>;
  SkuInventory?: SkuInventoryResolvers<ContextType>;
  SubscriptionDunning?: SubscriptionDunningResolvers<ContextType>;
  SyncDiscordRolesPayload?: SyncDiscordRolesPayloadResolvers<ContextType>;
  SyncState?: SyncStateResolvers<ContextType>;
  TaxFormDocumentResult?: TaxFormDocumentResultResolvers<ContextType>;
  TaxInfo?: TaxInfoResolvers<ContextType>;
  TaxInfoAggregates?: TaxInfoAggregatesResolvers<ContextType>;
  TaxInfoAverageAggregates?: TaxInfoAverageAggregatesResolvers<ContextType>;
  TaxInfoConnection?: TaxInfoConnectionResolvers<ContextType>;
  TaxInfoDistinctCountAggregates?: TaxInfoDistinctCountAggregatesResolvers<ContextType>;
  TaxInfoEdge?: TaxInfoEdgeResolvers<ContextType>;
  TaxInfoMaxAggregates?: TaxInfoMaxAggregatesResolvers<ContextType>;
  TaxInfoMinAggregates?: TaxInfoMinAggregatesResolvers<ContextType>;
  TaxInfoStddevPopulationAggregates?: TaxInfoStddevPopulationAggregatesResolvers<ContextType>;
  TaxInfoStddevSampleAggregates?: TaxInfoStddevSampleAggregatesResolvers<ContextType>;
  TaxInfoSumAggregates?: TaxInfoSumAggregatesResolvers<ContextType>;
  TaxInfoVariancePopulationAggregates?: TaxInfoVariancePopulationAggregatesResolvers<ContextType>;
  TaxInfoVarianceSampleAggregates?: TaxInfoVarianceSampleAggregatesResolvers<ContextType>;
  Trade?: TradeResolvers<ContextType>;
  TradedProductLots?: TradedProductLotsResolvers<ContextType>;
  TraderLockDetail?: TraderLockDetailResolvers<ContextType>;
  TraderOpenCase?: TraderOpenCaseResolvers<ContextType>;
  TraderPayoutNote?: TraderPayoutNoteResolvers<ContextType>;
  TraderProfileAsset?: TraderProfileAssetResolvers<ContextType>;
  TraderProfileModerationBlockedWord?: TraderProfileModerationBlockedWordResolvers<ContextType>;
  TraderProfileModerationCase?: TraderProfileModerationCaseResolvers<ContextType>;
  TraderProfileModerationCaseAggregates?: TraderProfileModerationCaseAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseAverageAggregates?: TraderProfileModerationCaseAverageAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseConnection?: TraderProfileModerationCaseConnectionResolvers<ContextType>;
  TraderProfileModerationCaseDistinctCountAggregates?: TraderProfileModerationCaseDistinctCountAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseEdge?: TraderProfileModerationCaseEdgeResolvers<ContextType>;
  TraderProfileModerationCaseHistory?: TraderProfileModerationCaseHistoryResolvers<ContextType>;
  TraderProfileModerationCaseHistoryAggregates?: TraderProfileModerationCaseHistoryAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryAverageAggregates?: TraderProfileModerationCaseHistoryAverageAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryConnection?: TraderProfileModerationCaseHistoryConnectionResolvers<ContextType>;
  TraderProfileModerationCaseHistoryDistinctCountAggregates?: TraderProfileModerationCaseHistoryDistinctCountAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryEdge?: TraderProfileModerationCaseHistoryEdgeResolvers<ContextType>;
  TraderProfileModerationCaseHistoryMaxAggregates?: TraderProfileModerationCaseHistoryMaxAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryMinAggregates?: TraderProfileModerationCaseHistoryMinAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryStddevPopulationAggregates?: TraderProfileModerationCaseHistoryStddevPopulationAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryStddevSampleAggregates?: TraderProfileModerationCaseHistoryStddevSampleAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistorySumAggregates?: TraderProfileModerationCaseHistorySumAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryVariancePopulationAggregates?: TraderProfileModerationCaseHistoryVariancePopulationAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseHistoryVarianceSampleAggregates?: TraderProfileModerationCaseHistoryVarianceSampleAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseMaxAggregates?: TraderProfileModerationCaseMaxAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseMinAggregates?: TraderProfileModerationCaseMinAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseStddevPopulationAggregates?: TraderProfileModerationCaseStddevPopulationAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseStddevSampleAggregates?: TraderProfileModerationCaseStddevSampleAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseSumAggregates?: TraderProfileModerationCaseSumAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseVariancePopulationAggregates?: TraderProfileModerationCaseVariancePopulationAggregatesResolvers<ContextType>;
  TraderProfileModerationCaseVarianceSampleAggregates?: TraderProfileModerationCaseVarianceSampleAggregatesResolvers<ContextType>;
  TraderPublicProfile?: TraderPublicProfileResolvers<ContextType>;
  TraderPublicProfileAggregates?: TraderPublicProfileAggregatesResolvers<ContextType>;
  TraderPublicProfileAverageAggregates?: TraderPublicProfileAverageAggregatesResolvers<ContextType>;
  TraderPublicProfileConnection?: TraderPublicProfileConnectionResolvers<ContextType>;
  TraderPublicProfileDistinctCountAggregates?: TraderPublicProfileDistinctCountAggregatesResolvers<ContextType>;
  TraderPublicProfileEdge?: TraderPublicProfileEdgeResolvers<ContextType>;
  TraderPublicProfileMaxAggregates?: TraderPublicProfileMaxAggregatesResolvers<ContextType>;
  TraderPublicProfileMinAggregates?: TraderPublicProfileMinAggregatesResolvers<ContextType>;
  TraderPublicProfileStddevPopulationAggregates?: TraderPublicProfileStddevPopulationAggregatesResolvers<ContextType>;
  TraderPublicProfileStddevSampleAggregates?: TraderPublicProfileStddevSampleAggregatesResolvers<ContextType>;
  TraderPublicProfileSumAggregates?: TraderPublicProfileSumAggregatesResolvers<ContextType>;
  TraderPublicProfileVariancePopulationAggregates?: TraderPublicProfileVariancePopulationAggregatesResolvers<ContextType>;
  TraderPublicProfileVarianceSampleAggregates?: TraderPublicProfileVarianceSampleAggregatesResolvers<ContextType>;
  TraderRiskIndicator?: TraderRiskIndicatorResolvers<ContextType>;
  TraderRiskIndicatorAggregates?: TraderRiskIndicatorAggregatesResolvers<ContextType>;
  TraderRiskIndicatorAverageAggregates?: TraderRiskIndicatorAverageAggregatesResolvers<ContextType>;
  TraderRiskIndicatorConnection?: TraderRiskIndicatorConnectionResolvers<ContextType>;
  TraderRiskIndicatorDistinctCountAggregates?: TraderRiskIndicatorDistinctCountAggregatesResolvers<ContextType>;
  TraderRiskIndicatorEdge?: TraderRiskIndicatorEdgeResolvers<ContextType>;
  TraderRiskIndicatorMaxAggregates?: TraderRiskIndicatorMaxAggregatesResolvers<ContextType>;
  TraderRiskIndicatorMinAggregates?: TraderRiskIndicatorMinAggregatesResolvers<ContextType>;
  TraderRiskIndicatorOwner?: TraderRiskIndicatorOwnerResolvers<ContextType>;
  TraderRiskIndicatorStddevPopulationAggregates?: TraderRiskIndicatorStddevPopulationAggregatesResolvers<ContextType>;
  TraderRiskIndicatorStddevSampleAggregates?: TraderRiskIndicatorStddevSampleAggregatesResolvers<ContextType>;
  TraderRiskIndicatorSumAggregates?: TraderRiskIndicatorSumAggregatesResolvers<ContextType>;
  TraderRiskIndicatorVariancePopulationAggregates?: TraderRiskIndicatorVariancePopulationAggregatesResolvers<ContextType>;
  TraderRiskIndicatorVarianceSampleAggregates?: TraderRiskIndicatorVarianceSampleAggregatesResolvers<ContextType>;
  TradingHabits?: TradingHabitsResolvers<ContextType>;
  TradingOverview?: TradingOverviewResolvers<ContextType>;
  TradingProduct?: TradingProductResolvers<ContextType>;
  TradingProductFee?: TradingProductFeeResolvers<ContextType>;
  TradingProductFeeAggregates?: TradingProductFeeAggregatesResolvers<ContextType>;
  TradingProductFeeAverageAggregates?: TradingProductFeeAverageAggregatesResolvers<ContextType>;
  TradingProductFeeConnection?: TradingProductFeeConnectionResolvers<ContextType>;
  TradingProductFeeDistinctCountAggregates?: TradingProductFeeDistinctCountAggregatesResolvers<ContextType>;
  TradingProductFeeEdge?: TradingProductFeeEdgeResolvers<ContextType>;
  TradingProductFeeMaxAggregates?: TradingProductFeeMaxAggregatesResolvers<ContextType>;
  TradingProductFeeMinAggregates?: TradingProductFeeMinAggregatesResolvers<ContextType>;
  TradingProductFeeStddevPopulationAggregates?: TradingProductFeeStddevPopulationAggregatesResolvers<ContextType>;
  TradingProductFeeStddevSampleAggregates?: TradingProductFeeStddevSampleAggregatesResolvers<ContextType>;
  TradingProductFeeSumAggregates?: TradingProductFeeSumAggregatesResolvers<ContextType>;
  TradingProductFeeVariancePopulationAggregates?: TradingProductFeeVariancePopulationAggregatesResolvers<ContextType>;
  TradingProductFeeVarianceSampleAggregates?: TradingProductFeeVarianceSampleAggregatesResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UnifiedSubscription?: UnifiedSubscriptionResolvers<ContextType>;
  UnlinkDiscordPayload?: UnlinkDiscordPayloadResolvers<ContextType>;
  UpdateAccountStatPayload?: UpdateAccountStatPayloadResolvers<ContextType>;
  UpdateAdminConfigPayload?: UpdateAdminConfigPayloadResolvers<ContextType>;
  UpdateImpactGroupAssignmentPayload?: UpdateImpactGroupAssignmentPayloadResolvers<ContextType>;
  UpdateImpactGroupTemplatePayload?: UpdateImpactGroupTemplatePayloadResolvers<ContextType>;
  UpdateKycPriorityLabelPayload?: UpdateKycPriorityLabelPayloadResolvers<ContextType>;
  UpdateMyTraderPublicProfilePayload?: UpdateMyTraderPublicProfilePayloadResolvers<ContextType>;
  UpdateTraderPublicProfilePayload?: UpdateTraderPublicProfilePayloadResolvers<ContextType>;
  UpdateTraderRiskIndicatorPayload?: UpdateTraderRiskIndicatorPayloadResolvers<ContextType>;
  UpdateTradingProductFeePayload?: UpdateTradingProductFeePayloadResolvers<ContextType>;
  UpdateUserAddressPayload?: UpdateUserAddressPayloadResolvers<ContextType>;
  UpdateUserTaxFormPayload?: UpdateUserTaxFormPayloadResolvers<ContextType>;
  UpdateXfaActivationCreditPayload?: UpdateXfaActivationCreditPayloadResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAddon?: UserAddonResolvers<ContextType>;
  UserAddress?: UserAddressResolvers<ContextType>;
  UserAddressAggregates?: UserAddressAggregatesResolvers<ContextType>;
  UserAddressAverageAggregates?: UserAddressAverageAggregatesResolvers<ContextType>;
  UserAddressConnection?: UserAddressConnectionResolvers<ContextType>;
  UserAddressDistinctCountAggregates?: UserAddressDistinctCountAggregatesResolvers<ContextType>;
  UserAddressEdge?: UserAddressEdgeResolvers<ContextType>;
  UserAddressMaxAggregates?: UserAddressMaxAggregatesResolvers<ContextType>;
  UserAddressMinAggregates?: UserAddressMinAggregatesResolvers<ContextType>;
  UserAddressStddevPopulationAggregates?: UserAddressStddevPopulationAggregatesResolvers<ContextType>;
  UserAddressStddevSampleAggregates?: UserAddressStddevSampleAggregatesResolvers<ContextType>;
  UserAddressSumAggregates?: UserAddressSumAggregatesResolvers<ContextType>;
  UserAddressVariancePopulationAggregates?: UserAddressVariancePopulationAggregatesResolvers<ContextType>;
  UserAddressVarianceSampleAggregates?: UserAddressVarianceSampleAggregatesResolvers<ContextType>;
  UserAdminRole?: UserAdminRoleResolvers<ContextType>;
  UserAdminRoleAggregates?: UserAdminRoleAggregatesResolvers<ContextType>;
  UserAdminRoleAverageAggregates?: UserAdminRoleAverageAggregatesResolvers<ContextType>;
  UserAdminRoleConnection?: UserAdminRoleConnectionResolvers<ContextType>;
  UserAdminRoleDistinctCountAggregates?: UserAdminRoleDistinctCountAggregatesResolvers<ContextType>;
  UserAdminRoleEdge?: UserAdminRoleEdgeResolvers<ContextType>;
  UserAdminRoleMaxAggregates?: UserAdminRoleMaxAggregatesResolvers<ContextType>;
  UserAdminRoleMinAggregates?: UserAdminRoleMinAggregatesResolvers<ContextType>;
  UserAdminRoleStddevPopulationAggregates?: UserAdminRoleStddevPopulationAggregatesResolvers<ContextType>;
  UserAdminRoleStddevSampleAggregates?: UserAdminRoleStddevSampleAggregatesResolvers<ContextType>;
  UserAdminRoleSumAggregates?: UserAdminRoleSumAggregatesResolvers<ContextType>;
  UserAdminRoleVariancePopulationAggregates?: UserAdminRoleVariancePopulationAggregatesResolvers<ContextType>;
  UserAdminRoleVarianceSampleAggregates?: UserAdminRoleVarianceSampleAggregatesResolvers<ContextType>;
  UserAggregates?: UserAggregatesResolvers<ContextType>;
  UserAgreement?: UserAgreementResolvers<ContextType>;
  UserAgreementAggregates?: UserAgreementAggregatesResolvers<ContextType>;
  UserAgreementAverageAggregates?: UserAgreementAverageAggregatesResolvers<ContextType>;
  UserAgreementConnection?: UserAgreementConnectionResolvers<ContextType>;
  UserAgreementDistinctCountAggregates?: UserAgreementDistinctCountAggregatesResolvers<ContextType>;
  UserAgreementEdge?: UserAgreementEdgeResolvers<ContextType>;
  UserAgreementMaxAggregates?: UserAgreementMaxAggregatesResolvers<ContextType>;
  UserAgreementMinAggregates?: UserAgreementMinAggregatesResolvers<ContextType>;
  UserAgreementStddevPopulationAggregates?: UserAgreementStddevPopulationAggregatesResolvers<ContextType>;
  UserAgreementStddevSampleAggregates?: UserAgreementStddevSampleAggregatesResolvers<ContextType>;
  UserAgreementSumAggregates?: UserAgreementSumAggregatesResolvers<ContextType>;
  UserAgreementVariancePopulationAggregates?: UserAgreementVariancePopulationAggregatesResolvers<ContextType>;
  UserAgreementVarianceSampleAggregates?: UserAgreementVarianceSampleAggregatesResolvers<ContextType>;
  UserAverageAggregates?: UserAverageAggregatesResolvers<ContextType>;
  UserBankingInfo?: UserBankingInfoResolvers<ContextType>;
  UserCertificate?: UserCertificateResolvers<ContextType>;
  UserCertificateAggregates?: UserCertificateAggregatesResolvers<ContextType>;
  UserCertificateAverageAggregates?: UserCertificateAverageAggregatesResolvers<ContextType>;
  UserCertificateConnection?: UserCertificateConnectionResolvers<ContextType>;
  UserCertificateDistinctCountAggregates?: UserCertificateDistinctCountAggregatesResolvers<ContextType>;
  UserCertificateEdge?: UserCertificateEdgeResolvers<ContextType>;
  UserCertificateMaxAggregates?: UserCertificateMaxAggregatesResolvers<ContextType>;
  UserCertificateMinAggregates?: UserCertificateMinAggregatesResolvers<ContextType>;
  UserCertificateStddevPopulationAggregates?: UserCertificateStddevPopulationAggregatesResolvers<ContextType>;
  UserCertificateStddevSampleAggregates?: UserCertificateStddevSampleAggregatesResolvers<ContextType>;
  UserCertificateSumAggregates?: UserCertificateSumAggregatesResolvers<ContextType>;
  UserCertificateVariancePopulationAggregates?: UserCertificateVariancePopulationAggregatesResolvers<ContextType>;
  UserCertificateVarianceSampleAggregates?: UserCertificateVarianceSampleAggregatesResolvers<ContextType>;
  UserConnection?: UserConnectionResolvers<ContextType>;
  UserContactInfo?: UserContactInfoResolvers<ContextType>;
  UserContactInfoAggregates?: UserContactInfoAggregatesResolvers<ContextType>;
  UserContactInfoAverageAggregates?: UserContactInfoAverageAggregatesResolvers<ContextType>;
  UserContactInfoConnection?: UserContactInfoConnectionResolvers<ContextType>;
  UserContactInfoDistinctCountAggregates?: UserContactInfoDistinctCountAggregatesResolvers<ContextType>;
  UserContactInfoEdge?: UserContactInfoEdgeResolvers<ContextType>;
  UserContactInfoMaxAggregates?: UserContactInfoMaxAggregatesResolvers<ContextType>;
  UserContactInfoMinAggregates?: UserContactInfoMinAggregatesResolvers<ContextType>;
  UserContactInfoStddevPopulationAggregates?: UserContactInfoStddevPopulationAggregatesResolvers<ContextType>;
  UserContactInfoStddevSampleAggregates?: UserContactInfoStddevSampleAggregatesResolvers<ContextType>;
  UserContactInfoSumAggregates?: UserContactInfoSumAggregatesResolvers<ContextType>;
  UserContactInfoVariancePopulationAggregates?: UserContactInfoVariancePopulationAggregatesResolvers<ContextType>;
  UserContactInfoVarianceSampleAggregates?: UserContactInfoVarianceSampleAggregatesResolvers<ContextType>;
  UserCooldown?: UserCooldownResolvers<ContextType>;
  UserCooldownAggregates?: UserCooldownAggregatesResolvers<ContextType>;
  UserCooldownAverageAggregates?: UserCooldownAverageAggregatesResolvers<ContextType>;
  UserCooldownConnection?: UserCooldownConnectionResolvers<ContextType>;
  UserCooldownDistinctCountAggregates?: UserCooldownDistinctCountAggregatesResolvers<ContextType>;
  UserCooldownEdge?: UserCooldownEdgeResolvers<ContextType>;
  UserCooldownMaxAggregates?: UserCooldownMaxAggregatesResolvers<ContextType>;
  UserCooldownMinAggregates?: UserCooldownMinAggregatesResolvers<ContextType>;
  UserCooldownStddevPopulationAggregates?: UserCooldownStddevPopulationAggregatesResolvers<ContextType>;
  UserCooldownStddevSampleAggregates?: UserCooldownStddevSampleAggregatesResolvers<ContextType>;
  UserCooldownSumAggregates?: UserCooldownSumAggregatesResolvers<ContextType>;
  UserCooldownVariancePopulationAggregates?: UserCooldownVariancePopulationAggregatesResolvers<ContextType>;
  UserCooldownVarianceSampleAggregates?: UserCooldownVarianceSampleAggregatesResolvers<ContextType>;
  UserDistinctCountAggregates?: UserDistinctCountAggregatesResolvers<ContextType>;
  UserEdge?: UserEdgeResolvers<ContextType>;
  UserIntegration?: UserIntegrationResolvers<ContextType>;
  UserMarketDatum?: UserMarketDatumResolvers<ContextType>;
  UserMaxAggregates?: UserMaxAggregatesResolvers<ContextType>;
  UserMeteredEvent?: UserMeteredEventResolvers<ContextType>;
  UserMeteredEventAggregates?: UserMeteredEventAggregatesResolvers<ContextType>;
  UserMeteredEventAverageAggregates?: UserMeteredEventAverageAggregatesResolvers<ContextType>;
  UserMeteredEventConnection?: UserMeteredEventConnectionResolvers<ContextType>;
  UserMeteredEventDistinctCountAggregates?: UserMeteredEventDistinctCountAggregatesResolvers<ContextType>;
  UserMeteredEventEdge?: UserMeteredEventEdgeResolvers<ContextType>;
  UserMeteredEventMaxAggregates?: UserMeteredEventMaxAggregatesResolvers<ContextType>;
  UserMeteredEventMinAggregates?: UserMeteredEventMinAggregatesResolvers<ContextType>;
  UserMeteredEventStddevPopulationAggregates?: UserMeteredEventStddevPopulationAggregatesResolvers<ContextType>;
  UserMeteredEventStddevSampleAggregates?: UserMeteredEventStddevSampleAggregatesResolvers<ContextType>;
  UserMeteredEventSumAggregates?: UserMeteredEventSumAggregatesResolvers<ContextType>;
  UserMeteredEventVariancePopulationAggregates?: UserMeteredEventVariancePopulationAggregatesResolvers<ContextType>;
  UserMeteredEventVarianceSampleAggregates?: UserMeteredEventVarianceSampleAggregatesResolvers<ContextType>;
  UserMinAggregates?: UserMinAggregatesResolvers<ContextType>;
  UserNote?: UserNoteResolvers<ContextType>;
  UserNoteAggregates?: UserNoteAggregatesResolvers<ContextType>;
  UserNoteAverageAggregates?: UserNoteAverageAggregatesResolvers<ContextType>;
  UserNoteConnection?: UserNoteConnectionResolvers<ContextType>;
  UserNoteDistinctCountAggregates?: UserNoteDistinctCountAggregatesResolvers<ContextType>;
  UserNoteEdge?: UserNoteEdgeResolvers<ContextType>;
  UserNoteMaxAggregates?: UserNoteMaxAggregatesResolvers<ContextType>;
  UserNoteMinAggregates?: UserNoteMinAggregatesResolvers<ContextType>;
  UserNoteStddevPopulationAggregates?: UserNoteStddevPopulationAggregatesResolvers<ContextType>;
  UserNoteStddevSampleAggregates?: UserNoteStddevSampleAggregatesResolvers<ContextType>;
  UserNoteSumAggregates?: UserNoteSumAggregatesResolvers<ContextType>;
  UserNoteVariancePopulationAggregates?: UserNoteVariancePopulationAggregatesResolvers<ContextType>;
  UserNoteVarianceSampleAggregates?: UserNoteVarianceSampleAggregatesResolvers<ContextType>;
  UserPlatformCredential?: UserPlatformCredentialResolvers<ContextType>;
  UserPlatformCredentialAggregates?: UserPlatformCredentialAggregatesResolvers<ContextType>;
  UserPlatformCredentialAverageAggregates?: UserPlatformCredentialAverageAggregatesResolvers<ContextType>;
  UserPlatformCredentialConnection?: UserPlatformCredentialConnectionResolvers<ContextType>;
  UserPlatformCredentialDistinctCountAggregates?: UserPlatformCredentialDistinctCountAggregatesResolvers<ContextType>;
  UserPlatformCredentialEdge?: UserPlatformCredentialEdgeResolvers<ContextType>;
  UserPlatformCredentialMaxAggregates?: UserPlatformCredentialMaxAggregatesResolvers<ContextType>;
  UserPlatformCredentialMinAggregates?: UserPlatformCredentialMinAggregatesResolvers<ContextType>;
  UserPlatformCredentialStddevPopulationAggregates?: UserPlatformCredentialStddevPopulationAggregatesResolvers<ContextType>;
  UserPlatformCredentialStddevSampleAggregates?: UserPlatformCredentialStddevSampleAggregatesResolvers<ContextType>;
  UserPlatformCredentialSumAggregates?: UserPlatformCredentialSumAggregatesResolvers<ContextType>;
  UserPlatformCredentialVariancePopulationAggregates?: UserPlatformCredentialVariancePopulationAggregatesResolvers<ContextType>;
  UserPlatformCredentialVarianceSampleAggregates?: UserPlatformCredentialVarianceSampleAggregatesResolvers<ContextType>;
  UserRolesAdminRole?: UserRolesAdminRoleResolvers<ContextType>;
  UserRolesAdminRoleAggregates?: UserRolesAdminRoleAggregatesResolvers<ContextType>;
  UserRolesAdminRoleAverageAggregates?: UserRolesAdminRoleAverageAggregatesResolvers<ContextType>;
  UserRolesAdminRoleConnection?: UserRolesAdminRoleConnectionResolvers<ContextType>;
  UserRolesAdminRoleDistinctCountAggregates?: UserRolesAdminRoleDistinctCountAggregatesResolvers<ContextType>;
  UserRolesAdminRoleEdge?: UserRolesAdminRoleEdgeResolvers<ContextType>;
  UserRolesAdminRoleMaxAggregates?: UserRolesAdminRoleMaxAggregatesResolvers<ContextType>;
  UserRolesAdminRoleMinAggregates?: UserRolesAdminRoleMinAggregatesResolvers<ContextType>;
  UserRolesAdminRoleStddevPopulationAggregates?: UserRolesAdminRoleStddevPopulationAggregatesResolvers<ContextType>;
  UserRolesAdminRoleStddevSampleAggregates?: UserRolesAdminRoleStddevSampleAggregatesResolvers<ContextType>;
  UserRolesAdminRoleSumAggregates?: UserRolesAdminRoleSumAggregatesResolvers<ContextType>;
  UserRolesAdminRoleVariancePopulationAggregates?: UserRolesAdminRoleVariancePopulationAggregatesResolvers<ContextType>;
  UserRolesAdminRoleVarianceSampleAggregates?: UserRolesAdminRoleVarianceSampleAggregatesResolvers<ContextType>;
  UserStddevPopulationAggregates?: UserStddevPopulationAggregatesResolvers<ContextType>;
  UserStddevSampleAggregates?: UserStddevSampleAggregatesResolvers<ContextType>;
  UserSubscription?: UserSubscriptionResolvers<ContextType>;
  UserSubscriptionAggregates?: UserSubscriptionAggregatesResolvers<ContextType>;
  UserSubscriptionAverageAggregates?: UserSubscriptionAverageAggregatesResolvers<ContextType>;
  UserSubscriptionConnection?: UserSubscriptionConnectionResolvers<ContextType>;
  UserSubscriptionDistinctCountAggregates?: UserSubscriptionDistinctCountAggregatesResolvers<ContextType>;
  UserSubscriptionEdge?: UserSubscriptionEdgeResolvers<ContextType>;
  UserSubscriptionMaxAggregates?: UserSubscriptionMaxAggregatesResolvers<ContextType>;
  UserSubscriptionMinAggregates?: UserSubscriptionMinAggregatesResolvers<ContextType>;
  UserSubscriptionStddevPopulationAggregates?: UserSubscriptionStddevPopulationAggregatesResolvers<ContextType>;
  UserSubscriptionStddevSampleAggregates?: UserSubscriptionStddevSampleAggregatesResolvers<ContextType>;
  UserSubscriptionSumAggregates?: UserSubscriptionSumAggregatesResolvers<ContextType>;
  UserSubscriptionVariancePopulationAggregates?: UserSubscriptionVariancePopulationAggregatesResolvers<ContextType>;
  UserSubscriptionVarianceSampleAggregates?: UserSubscriptionVarianceSampleAggregatesResolvers<ContextType>;
  UserSumAggregates?: UserSumAggregatesResolvers<ContextType>;
  UserTaxForm?: UserTaxFormResolvers<ContextType>;
  UserTaxFormAggregates?: UserTaxFormAggregatesResolvers<ContextType>;
  UserTaxFormAverageAggregates?: UserTaxFormAverageAggregatesResolvers<ContextType>;
  UserTaxFormConnection?: UserTaxFormConnectionResolvers<ContextType>;
  UserTaxFormDistinctCountAggregates?: UserTaxFormDistinctCountAggregatesResolvers<ContextType>;
  UserTaxFormEdge?: UserTaxFormEdgeResolvers<ContextType>;
  UserTaxFormMaxAggregates?: UserTaxFormMaxAggregatesResolvers<ContextType>;
  UserTaxFormMinAggregates?: UserTaxFormMinAggregatesResolvers<ContextType>;
  UserTaxFormStddevPopulationAggregates?: UserTaxFormStddevPopulationAggregatesResolvers<ContextType>;
  UserTaxFormStddevSampleAggregates?: UserTaxFormStddevSampleAggregatesResolvers<ContextType>;
  UserTaxFormSumAggregates?: UserTaxFormSumAggregatesResolvers<ContextType>;
  UserTaxFormVariancePopulationAggregates?: UserTaxFormVariancePopulationAggregatesResolvers<ContextType>;
  UserTaxFormVarianceSampleAggregates?: UserTaxFormVarianceSampleAggregatesResolvers<ContextType>;
  UserTcPurchaseLimit?: UserTcPurchaseLimitResolvers<ContextType>;
  UserTcPurchaseLimitAggregates?: UserTcPurchaseLimitAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitAverageAggregates?: UserTcPurchaseLimitAverageAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitConnection?: UserTcPurchaseLimitConnectionResolvers<ContextType>;
  UserTcPurchaseLimitDistinctCountAggregates?: UserTcPurchaseLimitDistinctCountAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitEdge?: UserTcPurchaseLimitEdgeResolvers<ContextType>;
  UserTcPurchaseLimitMaxAggregates?: UserTcPurchaseLimitMaxAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitMinAggregates?: UserTcPurchaseLimitMinAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitStddevPopulationAggregates?: UserTcPurchaseLimitStddevPopulationAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitStddevSampleAggregates?: UserTcPurchaseLimitStddevSampleAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitSumAggregates?: UserTcPurchaseLimitSumAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitVariancePopulationAggregates?: UserTcPurchaseLimitVariancePopulationAggregatesResolvers<ContextType>;
  UserTcPurchaseLimitVarianceSampleAggregates?: UserTcPurchaseLimitVarianceSampleAggregatesResolvers<ContextType>;
  UserVariancePopulationAggregates?: UserVariancePopulationAggregatesResolvers<ContextType>;
  UserVarianceSampleAggregates?: UserVarianceSampleAggregatesResolvers<ContextType>;
  UserXfaCooldown?: UserXfaCooldownResolvers<ContextType>;
  UserXfaCooldownAggregates?: UserXfaCooldownAggregatesResolvers<ContextType>;
  UserXfaCooldownAverageAggregates?: UserXfaCooldownAverageAggregatesResolvers<ContextType>;
  UserXfaCooldownConnection?: UserXfaCooldownConnectionResolvers<ContextType>;
  UserXfaCooldownDistinctCountAggregates?: UserXfaCooldownDistinctCountAggregatesResolvers<ContextType>;
  UserXfaCooldownEdge?: UserXfaCooldownEdgeResolvers<ContextType>;
  UserXfaCooldownMaxAggregates?: UserXfaCooldownMaxAggregatesResolvers<ContextType>;
  UserXfaCooldownMinAggregates?: UserXfaCooldownMinAggregatesResolvers<ContextType>;
  UserXfaCooldownStddevPopulationAggregates?: UserXfaCooldownStddevPopulationAggregatesResolvers<ContextType>;
  UserXfaCooldownStddevSampleAggregates?: UserXfaCooldownStddevSampleAggregatesResolvers<ContextType>;
  UserXfaCooldownSumAggregates?: UserXfaCooldownSumAggregatesResolvers<ContextType>;
  UserXfaCooldownVariancePopulationAggregates?: UserXfaCooldownVariancePopulationAggregatesResolvers<ContextType>;
  UserXfaCooldownVarianceSampleAggregates?: UserXfaCooldownVarianceSampleAggregatesResolvers<ContextType>;
  Verification?: VerificationResolvers<ContextType>;
  VerificationAggregates?: VerificationAggregatesResolvers<ContextType>;
  VerificationAverageAggregates?: VerificationAverageAggregatesResolvers<ContextType>;
  VerificationConnection?: VerificationConnectionResolvers<ContextType>;
  VerificationDistinctCountAggregates?: VerificationDistinctCountAggregatesResolvers<ContextType>;
  VerificationEdge?: VerificationEdgeResolvers<ContextType>;
  VerificationMaxAggregates?: VerificationMaxAggregatesResolvers<ContextType>;
  VerificationMinAggregates?: VerificationMinAggregatesResolvers<ContextType>;
  VerificationStddevPopulationAggregates?: VerificationStddevPopulationAggregatesResolvers<ContextType>;
  VerificationStddevSampleAggregates?: VerificationStddevSampleAggregatesResolvers<ContextType>;
  VerificationSumAggregates?: VerificationSumAggregatesResolvers<ContextType>;
  VerificationVariancePopulationAggregates?: VerificationVariancePopulationAggregatesResolvers<ContextType>;
  VerificationVarianceSampleAggregates?: VerificationVarianceSampleAggregatesResolvers<ContextType>;
  W8BENSigningResult?: W8BenSigningResultResolvers<ContextType>;
  W9SigningResult?: W9SigningResultResolvers<ContextType>;
  WorstTradingDay?: WorstTradingDayResolvers<ContextType>;
  XfaActivationCredit?: XfaActivationCreditResolvers<ContextType>;
  XfaActivationCreditAggregates?: XfaActivationCreditAggregatesResolvers<ContextType>;
  XfaActivationCreditAverageAggregates?: XfaActivationCreditAverageAggregatesResolvers<ContextType>;
  XfaActivationCreditConnection?: XfaActivationCreditConnectionResolvers<ContextType>;
  XfaActivationCreditDistinctCountAggregates?: XfaActivationCreditDistinctCountAggregatesResolvers<ContextType>;
  XfaActivationCreditEdge?: XfaActivationCreditEdgeResolvers<ContextType>;
  XfaActivationCreditMaxAggregates?: XfaActivationCreditMaxAggregatesResolvers<ContextType>;
  XfaActivationCreditMinAggregates?: XfaActivationCreditMinAggregatesResolvers<ContextType>;
  XfaActivationCreditStddevPopulationAggregates?: XfaActivationCreditStddevPopulationAggregatesResolvers<ContextType>;
  XfaActivationCreditStddevSampleAggregates?: XfaActivationCreditStddevSampleAggregatesResolvers<ContextType>;
  XfaActivationCreditSumAggregates?: XfaActivationCreditSumAggregatesResolvers<ContextType>;
  XfaActivationCreditVariancePopulationAggregates?: XfaActivationCreditVariancePopulationAggregatesResolvers<ContextType>;
  XfaActivationCreditVarianceSampleAggregates?: XfaActivationCreditVarianceSampleAggregatesResolvers<ContextType>;
  XfaConsistencyMetrics?: XfaConsistencyMetricsResolvers<ContextType>;
  XfaResetTracking?: XfaResetTrackingResolvers<ContextType>;
  XfaResetTrackingAggregates?: XfaResetTrackingAggregatesResolvers<ContextType>;
  XfaResetTrackingAverageAggregates?: XfaResetTrackingAverageAggregatesResolvers<ContextType>;
  XfaResetTrackingConnection?: XfaResetTrackingConnectionResolvers<ContextType>;
  XfaResetTrackingDistinctCountAggregates?: XfaResetTrackingDistinctCountAggregatesResolvers<ContextType>;
  XfaResetTrackingEdge?: XfaResetTrackingEdgeResolvers<ContextType>;
  XfaResetTrackingMaxAggregates?: XfaResetTrackingMaxAggregatesResolvers<ContextType>;
  XfaResetTrackingMinAggregates?: XfaResetTrackingMinAggregatesResolvers<ContextType>;
  XfaResetTrackingStddevPopulationAggregates?: XfaResetTrackingStddevPopulationAggregatesResolvers<ContextType>;
  XfaResetTrackingStddevSampleAggregates?: XfaResetTrackingStddevSampleAggregatesResolvers<ContextType>;
  XfaResetTrackingSumAggregates?: XfaResetTrackingSumAggregatesResolvers<ContextType>;
  XfaResetTrackingVariancePopulationAggregates?: XfaResetTrackingVariancePopulationAggregatesResolvers<ContextType>;
  XfaResetTrackingVarianceSampleAggregates?: XfaResetTrackingVarianceSampleAggregatesResolvers<ContextType>;
};

